import nt, { useRef as Xe, useContext as kt, useMemo as la, useDebugValue as j2, createElement as A5, useEffect as lt, useLayoutEffect as Bn, useState as Cn, createContext as Qo, memo as Hr, forwardRef as R5, useCallback as fs, lazy as RS, Suspense as OD, StrictMode as O5 } from "react";
import D5, { createPortal as I5 } from "react-dom";
var zo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function gy(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function OS(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      var i = !1;
      try {
        i = this instanceof r;
      } catch {
      }
      return i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var hp = { exports: {} }, Af = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V2;
function N5() {
  if (V2) return Af;
  V2 = 1;
  var t = nt, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, u) {
    var c, f = {}, d = null, h = null;
    u !== void 0 && (d = "" + u), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (c in l) r.call(l, c) && !o.hasOwnProperty(c) && (f[c] = l[c]);
    if (a && a.defaultProps) for (c in l = a.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: e, type: a, key: d, ref: h, props: f, _owner: i.current };
  }
  return Af.Fragment = n, Af.jsx = s, Af.jsxs = s, Af;
}
var Rf = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U2;
function P5() {
  return U2 || (U2 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = nt, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function m(G) {
      if (G === null || typeof G != "object")
        return null;
      var be = p && G[p] || G[g];
      return typeof be == "function" ? be : null;
    }
    var v = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(G) {
      {
        for (var be = arguments.length, xe = new Array(be > 1 ? be - 1 : 0), Me = 1; Me < be; Me++)
          xe[Me - 1] = arguments[Me];
        _("error", G, xe);
      }
    }
    function _(G, be, xe) {
      {
        var Me = v.ReactDebugCurrentFrame, et = Me.getStackAddendum();
        et !== "" && (be += "%s", xe = xe.concat([et]));
        var xt = xe.map(function(it) {
          return String(it);
        });
        xt.unshift("Warning: " + be), Function.prototype.apply.call(console[G], console, xt);
      }
    }
    var b = !1, y = !1, w = !1, E = !1, x = !1, k;
    k = Symbol.for("react.module.reference");
    function C(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === r || G === o || x || G === i || G === u || G === c || E || G === h || b || y || w || typeof G == "object" && G !== null && (G.$$typeof === d || G.$$typeof === f || G.$$typeof === s || G.$$typeof === a || G.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === k || G.getModuleId !== void 0));
    }
    function M(G, be, xe) {
      var Me = G.displayName;
      if (Me)
        return Me;
      var et = be.displayName || be.name || "";
      return et !== "" ? xe + "(" + et + ")" : xe;
    }
    function F(G) {
      return G.displayName || "Context";
    }
    function U(G) {
      if (G == null)
        return null;
      if (typeof G.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof G == "function")
        return G.displayName || G.name || null;
      if (typeof G == "string")
        return G;
      switch (G) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case a:
            var be = G;
            return F(be) + ".Consumer";
          case s:
            var xe = G;
            return F(xe._context) + ".Provider";
          case l:
            return M(G, G.render, "ForwardRef");
          case f:
            var Me = G.displayName || null;
            return Me !== null ? Me : U(G.type) || "Memo";
          case d: {
            var et = G, xt = et._payload, it = et._init;
            try {
              return U(it(xt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, N = 0, q, Q, ne, X, O, W, T;
    function $() {
    }
    $.__reactDisabledLog = !0;
    function P() {
      {
        if (N === 0) {
          q = console.log, Q = console.info, ne = console.warn, X = console.error, O = console.group, W = console.groupCollapsed, T = console.groupEnd;
          var G = {
            configurable: !0,
            enumerable: !0,
            value: $,
            writable: !0
          };
          Object.defineProperties(console, {
            info: G,
            log: G,
            warn: G,
            error: G,
            group: G,
            groupCollapsed: G,
            groupEnd: G
          });
        }
        N++;
      }
    }
    function H() {
      {
        if (N--, N === 0) {
          var G = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, G, {
              value: q
            }),
            info: B({}, G, {
              value: Q
            }),
            warn: B({}, G, {
              value: ne
            }),
            error: B({}, G, {
              value: X
            }),
            group: B({}, G, {
              value: O
            }),
            groupCollapsed: B({}, G, {
              value: W
            }),
            groupEnd: B({}, G, {
              value: T
            })
          });
        }
        N < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Z = v.ReactCurrentDispatcher, le;
    function J(G, be, xe) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (et) {
            var Me = et.stack.trim().match(/\n( *(at )?)/);
            le = Me && Me[1] || "";
          }
        return `
` + le + G;
      }
    }
    var ue = !1, he;
    {
      var me = typeof WeakMap == "function" ? WeakMap : Map;
      he = new me();
    }
    function oe(G, be) {
      if (!G || ue)
        return "";
      {
        var xe = he.get(G);
        if (xe !== void 0)
          return xe;
      }
      var Me;
      ue = !0;
      var et = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var xt;
      xt = Z.current, Z.current = null, P();
      try {
        if (be) {
          var it = function() {
            throw Error();
          };
          if (Object.defineProperty(it.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(it, []);
            } catch (Wt) {
              Me = Wt;
            }
            Reflect.construct(G, [], it);
          } else {
            try {
              it.call();
            } catch (Wt) {
              Me = Wt;
            }
            G.call(it.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Wt) {
            Me = Wt;
          }
          G();
        }
      } catch (Wt) {
        if (Wt && Me && typeof Wt.stack == "string") {
          for (var ht = Wt.stack.split(`
`), tn = Me.stack.split(`
`), Ct = ht.length - 1, At = tn.length - 1; Ct >= 1 && At >= 0 && ht[Ct] !== tn[At]; )
            At--;
          for (; Ct >= 1 && At >= 0; Ct--, At--)
            if (ht[Ct] !== tn[At]) {
              if (Ct !== 1 || At !== 1)
                do
                  if (Ct--, At--, At < 0 || ht[Ct] !== tn[At]) {
                    var Kt = `
` + ht[Ct].replace(" at new ", " at ");
                    return G.displayName && Kt.includes("<anonymous>") && (Kt = Kt.replace("<anonymous>", G.displayName)), typeof G == "function" && he.set(G, Kt), Kt;
                  }
                while (Ct >= 1 && At >= 0);
              break;
            }
        }
      } finally {
        ue = !1, Z.current = xt, H(), Error.prepareStackTrace = et;
      }
      var Gr = G ? G.displayName || G.name : "", Wr = Gr ? J(Gr) : "";
      return typeof G == "function" && he.set(G, Wr), Wr;
    }
    function re(G, be, xe) {
      return oe(G, !1);
    }
    function se(G) {
      var be = G.prototype;
      return !!(be && be.isReactComponent);
    }
    function ae(G, be, xe) {
      if (G == null)
        return "";
      if (typeof G == "function")
        return oe(G, se(G));
      if (typeof G == "string")
        return J(G);
      switch (G) {
        case u:
          return J("Suspense");
        case c:
          return J("SuspenseList");
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case l:
            return re(G.render);
          case f:
            return ae(G.type, be, xe);
          case d: {
            var Me = G, et = Me._payload, xt = Me._init;
            try {
              return ae(xt(et), be, xe);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Y = {}, Re = v.ReactDebugCurrentFrame;
    function ee(G) {
      if (G) {
        var be = G._owner, xe = ae(G.type, G._source, be ? be.type : null);
        Re.setExtraStackFrame(xe);
      } else
        Re.setExtraStackFrame(null);
    }
    function Ye(G, be, xe, Me, et) {
      {
        var xt = Function.call.bind(fe);
        for (var it in G)
          if (xt(G, it)) {
            var ht = void 0;
            try {
              if (typeof G[it] != "function") {
                var tn = Error((Me || "React class") + ": " + xe + " type `" + it + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof G[it] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw tn.name = "Invariant Violation", tn;
              }
              ht = G[it](be, it, Me, xe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ct) {
              ht = Ct;
            }
            ht && !(ht instanceof Error) && (ee(et), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Me || "React class", xe, it, typeof ht), ee(null)), ht instanceof Error && !(ht.message in Y) && (Y[ht.message] = !0, ee(et), S("Failed %s type: %s", xe, ht.message), ee(null));
          }
      }
    }
    var Te = Array.isArray;
    function ve(G) {
      return Te(G);
    }
    function Oe(G) {
      {
        var be = typeof Symbol == "function" && Symbol.toStringTag, xe = be && G[Symbol.toStringTag] || G.constructor.name || "Object";
        return xe;
      }
    }
    function Je(G) {
      try {
        return pt(G), !1;
      } catch {
        return !0;
      }
    }
    function pt(G) {
      return "" + G;
    }
    function Pt(G) {
      if (Je(G))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Oe(G)), pt(G);
    }
    var bt = v.ReactCurrentOwner, Ft = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, mt, ln;
    function jn(G) {
      if (fe.call(G, "ref")) {
        var be = Object.getOwnPropertyDescriptor(G, "ref").get;
        if (be && be.isReactWarning)
          return !1;
      }
      return G.ref !== void 0;
    }
    function $t(G) {
      if (fe.call(G, "key")) {
        var be = Object.getOwnPropertyDescriptor(G, "key").get;
        if (be && be.isReactWarning)
          return !1;
      }
      return G.key !== void 0;
    }
    function Tr(G, be) {
      typeof G.ref == "string" && bt.current;
    }
    function xr(G, be) {
      {
        var xe = function() {
          mt || (mt = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", be));
        };
        xe.isReactWarning = !0, Object.defineProperty(G, "key", {
          get: xe,
          configurable: !0
        });
      }
    }
    function ce(G, be) {
      {
        var xe = function() {
          ln || (ln = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", be));
        };
        xe.isReactWarning = !0, Object.defineProperty(G, "ref", {
          get: xe,
          configurable: !0
        });
      }
    }
    var ie = function(G, be, xe, Me, et, xt, it) {
      var ht = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: G,
        key: be,
        ref: xe,
        props: it,
        // Record the component responsible for creating this element.
        _owner: xt
      };
      return ht._store = {}, Object.defineProperty(ht._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ht, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Me
      }), Object.defineProperty(ht, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: et
      }), Object.freeze && (Object.freeze(ht.props), Object.freeze(ht)), ht;
    };
    function ke(G, be, xe, Me, et) {
      {
        var xt, it = {}, ht = null, tn = null;
        xe !== void 0 && (Pt(xe), ht = "" + xe), $t(be) && (Pt(be.key), ht = "" + be.key), jn(be) && (tn = be.ref, Tr(be, et));
        for (xt in be)
          fe.call(be, xt) && !Ft.hasOwnProperty(xt) && (it[xt] = be[xt]);
        if (G && G.defaultProps) {
          var Ct = G.defaultProps;
          for (xt in Ct)
            it[xt] === void 0 && (it[xt] = Ct[xt]);
        }
        if (ht || tn) {
          var At = typeof G == "function" ? G.displayName || G.name || "Unknown" : G;
          ht && xr(it, At), tn && ce(it, At);
        }
        return ie(G, ht, tn, et, Me, bt.current, it);
      }
    }
    var Ae = v.ReactCurrentOwner, we = v.ReactDebugCurrentFrame;
    function Ie(G) {
      if (G) {
        var be = G._owner, xe = ae(G.type, G._source, be ? be.type : null);
        we.setExtraStackFrame(xe);
      } else
        we.setExtraStackFrame(null);
    }
    var R;
    R = !1;
    function I(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function j() {
      {
        if (Ae.current) {
          var G = U(Ae.current.type);
          if (G)
            return `

Check the render method of \`` + G + "`.";
        }
        return "";
      }
    }
    function te(G) {
      return "";
    }
    var Ee = {};
    function Ue(G) {
      {
        var be = j();
        if (!be) {
          var xe = typeof G == "string" ? G : G.displayName || G.name;
          xe && (be = `

Check the top-level render call using <` + xe + ">.");
        }
        return be;
      }
    }
    function ut(G, be) {
      {
        if (!G._store || G._store.validated || G.key != null)
          return;
        G._store.validated = !0;
        var xe = Ue(be);
        if (Ee[xe])
          return;
        Ee[xe] = !0;
        var Me = "";
        G && G._owner && G._owner !== Ae.current && (Me = " It was passed a child from " + U(G._owner.type) + "."), Ie(G), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', xe, Me), Ie(null);
      }
    }
    function qe(G, be) {
      {
        if (typeof G != "object")
          return;
        if (ve(G))
          for (var xe = 0; xe < G.length; xe++) {
            var Me = G[xe];
            I(Me) && ut(Me, be);
          }
        else if (I(G))
          G._store && (G._store.validated = !0);
        else if (G) {
          var et = m(G);
          if (typeof et == "function" && et !== G.entries)
            for (var xt = et.call(G), it; !(it = xt.next()).done; )
              I(it.value) && ut(it.value, be);
        }
      }
    }
    function ze(G) {
      {
        var be = G.type;
        if (be == null || typeof be == "string")
          return;
        var xe;
        if (typeof be == "function")
          xe = be.propTypes;
        else if (typeof be == "object" && (be.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        be.$$typeof === f))
          xe = be.propTypes;
        else
          return;
        if (xe) {
          var Me = U(be);
          Ye(xe, G.props, "prop", Me, G);
        } else if (be.PropTypes !== void 0 && !R) {
          R = !0;
          var et = U(be);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", et || "Unknown");
        }
        typeof be.getDefaultProps == "function" && !be.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function dt(G) {
      {
        for (var be = Object.keys(G.props), xe = 0; xe < be.length; xe++) {
          var Me = be[xe];
          if (Me !== "children" && Me !== "key") {
            Ie(G), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Me), Ie(null);
            break;
          }
        }
        G.ref !== null && (Ie(G), S("Invalid attribute `ref` supplied to `React.Fragment`."), Ie(null));
      }
    }
    var Ce = {};
    function Ze(G, be, xe, Me, et, xt) {
      {
        var it = C(G);
        if (!it) {
          var ht = "";
          (G === void 0 || typeof G == "object" && G !== null && Object.keys(G).length === 0) && (ht += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var tn = te();
          tn ? ht += tn : ht += j();
          var Ct;
          G === null ? Ct = "null" : ve(G) ? Ct = "array" : G !== void 0 && G.$$typeof === e ? (Ct = "<" + (U(G.type) || "Unknown") + " />", ht = " Did you accidentally export a JSX literal instead of a component?") : Ct = typeof G, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ct, ht);
        }
        var At = ke(G, be, xe, et, xt);
        if (At == null)
          return At;
        if (it) {
          var Kt = be.children;
          if (Kt !== void 0)
            if (Me)
              if (ve(Kt)) {
                for (var Gr = 0; Gr < Kt.length; Gr++)
                  qe(Kt[Gr], G);
                Object.freeze && Object.freeze(Kt);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              qe(Kt, G);
        }
        if (fe.call(be, "key")) {
          var Wr = U(G), Wt = Object.keys(be).filter(function(El) {
            return El !== "key";
          }), Dn = Wt.length > 0 ? "{key: someKey, " + Wt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ce[Wr + Dn]) {
            var Si = Wt.length > 0 ? "{" + Wt.join(": ..., ") + ": ...}" : "{}";
            S(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Dn, Wr, Si, Wr), Ce[Wr + Dn] = !0;
          }
        }
        return G === r ? dt(At) : ze(At), At;
      }
    }
    function Ge(G, be, xe) {
      return Ze(G, be, xe, !0);
    }
    function ct(G, be, xe) {
      return Ze(G, be, xe, !1);
    }
    var Gt = ct, yt = Ge;
    Rf.Fragment = r, Rf.jsx = Gt, Rf.jsxs = yt;
  }()), Rf;
}
var q2;
function $5() {
  return q2 || (q2 = 1, process.env.NODE_ENV === "production" ? hp.exports = N5() : hp.exports = P5()), hp.exports;
}
var D = $5();
/*!
 * @rybbit/js v0.2.0
 * Rybbit Web SDK
 * (c) 2025 Rybbit
 * Released under the AGPL-3.0-only license.
 */
var M5 = Object.defineProperty, z2 = Object.getOwnPropertySymbols, F5 = Object.prototype.hasOwnProperty, L5 = Object.prototype.propertyIsEnumerable, w1 = (t, e, n) => e in t ? M5(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Hl = (t, e) => {
  for (var n in e || (e = {})) F5.call(e, n) && w1(t, n, e[n]);
  if (z2) for (var n of z2(e)) L5.call(e, n) && w1(t, n, e[n]);
  return t;
}, La = (t, e, n) => w1(t, typeof e != "symbol" ? e + "" : e, n);
function B5(t, e) {
  let n = null;
  return function(...r) {
    let i = this;
    n !== null && clearTimeout(n), n = setTimeout(() => {
      n = null, t.apply(i, r);
    }, e);
  };
}
function j5(t) {
  try {
    let e = window.location.hostname, n = new URL(t, window.location.href).hostname;
    return !!n && n !== e;
  } catch {
    return !1;
  }
}
function V5(t) {
  try {
    let e = "__DOUBLE_ASTERISK_TOKEN__", n = "__SINGLE_ASTERISK_TOKEN__", r = t.replace(/\*\*/g, e).replace(/\*/g, n).replace(/[.+?^${}()|[\]\\]/g, "\\$&");
    r = r.replace(/\//g, "\\/");
    let i = r.replace(new RegExp(e, "g"), ".*").replace(new RegExp(n, "g"), "[^/]+");
    return new RegExp("^" + i + "$");
  } catch (e) {
    return mn(`Invalid pattern: ${t}`, e), null;
  }
}
function H2(t, e = []) {
  if (!e || e.length === 0) return null;
  for (let n of e) {
    let r = V5(n);
    if (r && r.test(t)) return n;
  }
  return null;
}
function Tn(...t) {
  Vn.debug && console.log("[Rybbit]", ...t);
}
function mn(...t) {
  Vn.debug && console.error("[Rybbit Error]", ...t);
}
function G2() {
  let t = new URL(window.location.href), e = t.pathname;
  return Vn.trackHashRoutes && t.hash && (e += t.hash), e;
}
var Ui = { debounce: 500, autoTrackPageviews: !0, autoTrackSpaRoutes: !0, trackQuerystring: !0, trackOutboundLinks: !0, trackHashRoutes: !0, trackDataAttributes: !0, trackWebVitals: !0, webVitalsTimeout: 2e4, skipPatterns: [], maskPatterns: [], debug: !1 }, pm = null, Vn = new Proxy({}, { get: (t, e) => {
  var n;
  return pm ? pm[e] : (e !== "debug" && mn("Rybbit SDK accessed before initialization. Call rybbit.init() first."), (n = Ui[e]) != null ? n : void 0);
}, set: () => (mn("Rybbit config is read-only after initialization."), !1) });
function U5(t) {
  var e, n, r, i, o, s, a, l, u, c;
  if (pm) return mn("Rybbit SDK already initialized."), !1;
  if (typeof t != "object" || t === null) return mn("Invalid configuration provided to rybbit.init(). Expected an object."), !1;
  let f = t, d = f.analyticsHost;
  if (!d) return mn("`analyticsHost` is required in Rybbit config and must be a string."), !1;
  let h = d.replace(/\/$/, ""), p = f.siteId;
  if (p == null || String(p).trim() === "") return mn("`siteId` is required in Rybbit config and must be a non-empty string or number."), !1;
  let g = String(p), m = Array.isArray(f.skipPatterns) ? f.skipPatterns : Ui.skipPatterns, v = Array.isArray(f.maskPatterns) ? f.maskPatterns : Ui.maskPatterns;
  return pm = { analyticsHost: h, siteId: g, debounce: Math.max(0, (e = f.debounce) != null ? e : Ui.debounce), autoTrackPageviews: (n = f.autoTrackPageviews) != null ? n : Ui.autoTrackPageviews, autoTrackSpaRoutes: (r = f.autoTrackSpaRoutes) != null ? r : Ui.autoTrackSpaRoutes, trackQuerystring: (i = f.trackQuerystring) != null ? i : Ui.trackQuerystring, trackOutboundLinks: (o = f.trackOutboundLinks) != null ? o : Ui.trackOutboundLinks, trackHashRoutes: (s = f.trackHashRoutes) != null ? s : Ui.trackHashRoutes, trackDataAttributes: (a = f.trackDataAttributes) != null ? a : Ui.trackDataAttributes, trackWebVitals: (l = f.trackWebVitals) != null ? l : Ui.trackWebVitals, webVitalsTimeout: Math.max(1e3, (u = f.webVitalsTimeout) != null ? u : Ui.webVitalsTimeout), skipPatterns: m, maskPatterns: v, debug: (c = f.debug) != null ? c : Ui.debug }, !0;
}
var Ja = null, DS = !1;
try {
  let t = localStorage.getItem("rybbit-user-id");
  t && (Ja = t), localStorage.getItem("disable-rybbit") !== null && (DS = !0);
} catch {
  mn("localStorage unavailable");
}
typeof window < "u" && window.__RYBBIT_OPTOUT__ && (DS = !0);
function Za(t, e = {}) {
  if (DS) {
    Tn("Opted out of tracking.");
    return;
  }
  if (!Vn || !Vn.analyticsHost || !Vn.siteId) {
    mn("Rybbit config not available. Ensure rybbit.init() was called successfully.");
    return;
  }
  let { eventName: n, properties: r, pathOverride: i, webVitals: o } = e;
  if ((t === "custom_event" || t === "performance") && !n) {
    mn("Event name is required and must be a string for performance or custom events.");
    return;
  }
  try {
    let s = new URL(window.location.href), a, l = "";
    if (t === "pageview" && typeof i == "string" && i.trim()) {
      Tn(`Using path override: ${i}`);
      try {
        let h = new URL(i, "http://dummybase");
        a = h.pathname, l = h.search || "", Tn(`Parsed override path: ${a}, search: ${l}`);
      } catch {
        mn(`Invalid pathOverride format: ${i}. Using window location.`), a = G2(), l = Vn.trackQuerystring ? s.search : "";
      }
    } else a = G2(), l = Vn.trackQuerystring ? s.search : "";
    if (t !== "performance" && H2(a, Vn.skipPatterns)) {
      Tn(`Skipping track for path: ${a}`);
      return;
    }
    let u = H2(a, Vn.maskPatterns);
    u && t !== "performance" && (Tn(`Masking path ${a} as ${u}`), a = u, l = "");
    let c = Hl(Hl(Hl(Hl({ site_id: Vn.siteId, hostname: s.hostname, pathname: a, querystring: l, screenWidth: window.innerWidth, screenHeight: window.innerHeight, language: navigator.language, page_title: document.title, referrer: document.referrer || "direct", type: t }, (t === "custom_event" || t === "performance") && { event_name: n }), (t === "custom_event" || t === "outbound") && Object.keys(r ?? {}).length > 0 && { properties: JSON.stringify(r) }), t === "performance" && o && Hl({}, o)), Ja && { user_id: Ja });
    Tn("Sending track event:", c);
    let f = JSON.stringify(c), d = `${Vn.analyticsHost}/track`;
    navigator.sendBeacon ? navigator.sendBeacon(d, new Blob([f], { type: "application/json" })) || (mn("sendBeacon failed, falling back to fetch."), W2(d, f)) : W2(d, f);
  } catch (s) {
    mn("Error during tracking:", s);
  }
}
function W2(t, e) {
  fetch(t, { method: "POST", headers: { "Content-Type": "application/json" }, body: e, mode: "cors", keepalive: !0 }).catch((n) => {
    mn("Fetch request failed:", n);
  });
}
function q5(t) {
  if (t.trim() === "") {
    mn("User ID must be a non-empty string");
    return;
  }
  Ja = t.trim();
  try {
    localStorage.setItem("rybbit-user-id", Ja), Tn("User identified:", Ja);
  } catch {
    mn("Could not persist user ID to localStorage");
  }
}
function z5() {
  Ja = null;
  try {
    localStorage.removeItem("rybbit-user-id"), Tn("User ID cleared");
  } catch {
    mn("Could not remove user ID from localStorage");
  }
}
function H5() {
  return Ja;
}
var Ia, gm = !1;
function G5() {
  if (gm) {
    Tn("Automatic tracking already set up.");
    return;
  }
  if (!Vn.autoTrackPageviews) {
    Tn("Automatic pageview tracking is disabled.");
    return;
  }
  if (Tn("Setting up automatic tracking..."), Ia = Vn.debounce && Vn.debounce > 0 ? B5(() => Za("pageview"), Vn.debounce) : () => Za("pageview"), requestAnimationFrame(() => {
    Ia();
  }), Vn.autoTrackSpaRoutes) {
    Tn("Setting up SPA route change tracking.");
    let t = history.pushState, e = history.replaceState;
    history.pushState = function(...n) {
      t.apply(this, n), Ia();
    }, history.replaceState = function(...n) {
      e.apply(this, n), Ia();
    }, window.addEventListener("popstate", Ia);
  } else Tn("SPA route change tracking is disabled.");
  Vn.trackHashRoutes ? window.addEventListener("hashchange", Ia) : Tn("Hash route tracking is disabled."), gm = !0;
}
function W5() {
  if (!Vn.trackDataAttributes) {
    Tn("Data attribute tracking is disabled.");
    return;
  }
  Tn("Setting up data attribute and outbound link tracking."), document.addEventListener("click", DD, !0);
}
function DD(t) {
  if (!(t.target instanceof Element)) return;
  let e = t.target;
  for (; e; ) {
    if (e.hasAttribute("data-rybbit-event")) {
      let n = e.getAttribute("data-rybbit-event");
      if (n) {
        let r = {};
        for (let i of e.attributes) if (i.name.startsWith("data-rybbit-prop-")) {
          let o = i.name.replace("data-rybbit-prop-", "");
          r[o] = i.value;
        }
        Tn("Data attribute event triggered:", n, r), Za("custom_event", { eventName: n, properties: r });
      }
      break;
    }
    e = e.parentElement;
  }
  if (Vn.trackOutboundLinks && t.target instanceof Element) {
    let n = t.target.closest("a");
    if (n && n.href && j5(n.href)) {
      Tn("Outbound link clicked:", n.href);
      let r = { url: n.href, text: n.innerText || n.textContent || "", target: n.target || "_self" };
      Za("outbound", { properties: r });
    }
  }
}
function Y5() {
  gm && (Tn("Cleaning up automatic tracking listeners."), window.removeEventListener("popstate", Ia), window.removeEventListener("hashchange", Ia), document.removeEventListener("click", DD, !0), gm = !1);
}
var ID = -1, uf = (t) => {
  addEventListener("pageshow", (e) => {
    e.persisted && (ID = e.timeStamp, t(e));
  }, !0);
}, xs = (t, e, n, r) => {
  let i, o;
  return (s) => {
    e.value >= 0 && (s || r) && (o = e.value - (i ?? 0), (o || i === void 0) && (i = e.value, e.delta = o, e.rating = ((a, l) => a > l[1] ? "poor" : a > l[0] ? "needs-improvement" : "good")(e.value, n), t(e)));
  };
}, IS = (t) => {
  requestAnimationFrame(() => requestAnimationFrame(() => t()));
}, NS = () => {
  let t = performance.getEntriesByType("navigation")[0];
  if (t && t.responseStart > 0 && t.responseStart < performance.now()) return t;
}, Ih = () => {
  var t;
  let e = NS();
  return (t = e?.activationStart) != null ? t : 0;
}, Cs = (t, e = -1) => {
  let n = NS(), r = "navigate";
  return ID >= 0 ? r = "back-forward-cache" : n && (document.prerendering || Ih() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : n.type && (r = n.type.replace(/_/g, "-"))), { name: t, value: e, rating: "good", delta: 0, entries: [], id: `v5-${Date.now()}-${Math.floor(8999999999999 * Math.random()) + 1e12}`, navigationType: r };
}, A0 = /* @__PURE__ */ new WeakMap();
function PS(t, e) {
  return A0.get(t) || A0.set(t, new e()), A0.get(t);
}
var X5 = class {
  constructor() {
    La(this, "t"), La(this, "i", 0), La(this, "o", []);
  }
  h(e) {
    var n;
    if (e.hadRecentInput) return;
    let r = this.o[0], i = this.o.at(-1);
    this.i && r && i && e.startTime - i.startTime < 1e3 && e.startTime - r.startTime < 5e3 ? (this.i += e.value, this.o.push(e)) : (this.i = e.value, this.o = [e]), (n = this.t) == null || n.call(this, e);
  }
}, Nh = (t, e, n = {}) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      let r = new PerformanceObserver((i) => {
        Promise.resolve().then(() => {
          e(i.getEntries());
        });
      });
      return r.observe(Hl({ type: t, buffered: !0 }, n)), r;
    }
  } catch {
  }
}, $S = (t) => {
  let e = !1;
  return () => {
    e || (t(), e = !0);
  };
}, ec = -1, Y2 = () => document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0, mm = (t) => {
  document.visibilityState === "hidden" && ec > -1 && (ec = t.type === "visibilitychange" ? t.timeStamp : 0, K5());
}, X2 = () => {
  addEventListener("visibilitychange", mm, !0), addEventListener("prerenderingchange", mm, !0);
}, K5 = () => {
  removeEventListener("visibilitychange", mm, !0), removeEventListener("prerenderingchange", mm, !0);
}, ND = () => {
  var t;
  if (ec < 0) {
    let e = Ih(), n = document.prerendering || (t = globalThis.performance.getEntriesByType("visibility-state").filter((r) => r.name === "hidden" && r.startTime > e)[0]) == null ? void 0 : t.startTime;
    ec = n ?? Y2(), X2(), uf(() => {
      setTimeout(() => {
        ec = Y2(), X2();
      });
    });
  }
  return { get firstHiddenTime() {
    return ec;
  } };
}, my = (t) => {
  document.prerendering ? addEventListener("prerenderingchange", () => t(), !0) : t();
}, K2 = [1800, 3e3], PD = (t, e = {}) => {
  my(() => {
    let n = ND(), r, i = Cs("FCP"), o = Nh("paint", (s) => {
      for (let a of s) a.name === "first-contentful-paint" && (o.disconnect(), a.startTime < n.firstHiddenTime && (i.value = Math.max(a.startTime - Ih(), 0), i.entries.push(a), r(!0)));
    });
    o && (r = xs(t, i, K2, e.reportAllChanges), uf((s) => {
      i = Cs("FCP"), r = xs(t, i, K2, e.reportAllChanges), IS(() => {
        i.value = performance.now() - s.timeStamp, r(!0);
      });
    }));
  });
}, Q2 = [0.1, 0.25], Q5 = (t, e = {}) => {
  PD($S(() => {
    let n, r = Cs("CLS", 0), i = PS(e, X5), o = (a) => {
      for (let l of a) i.h(l);
      i.i > r.value && (r.value = i.i, r.entries = i.o, n());
    }, s = Nh("layout-shift", o);
    s && (n = xs(t, r, Q2, e.reportAllChanges), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && (o(s.takeRecords()), n(!0));
    }), uf(() => {
      i.i = 0, r = Cs("CLS", 0), n = xs(t, r, Q2, e.reportAllChanges), IS(() => n());
    }), setTimeout(n));
  }));
}, $D = 0, R0 = 1 / 0, pp = 0, J5 = (t) => {
  for (let e of t) e.interactionId && (R0 = Math.min(R0, e.interactionId), pp = Math.max(pp, e.interactionId), $D = pp ? (pp - R0) / 7 + 1 : 0);
}, S1, J2 = () => {
  var t;
  return S1 ? $D : (t = performance.interactionCount) != null ? t : 0;
}, Z5 = () => {
  "interactionCount" in performance || S1 || (S1 = Nh("event", J5, { type: "event", buffered: !0, durationThreshold: 0 }));
}, Z2 = 0, eB = class {
  constructor() {
    La(this, "u", []), La(this, "l", /* @__PURE__ */ new Map()), La(this, "m"), La(this, "v");
  }
  p() {
    Z2 = J2(), this.u.length = 0, this.l.clear();
  }
  P() {
    let e = Math.min(this.u.length - 1, Math.floor((J2() - Z2) / 50));
    return this.u[e];
  }
  h(e) {
    var n, r;
    if ((n = this.m) == null || n.call(this, e), !e.interactionId && e.entryType !== "first-input") return;
    let i = this.u.at(-1), o = this.l.get(e.interactionId);
    if (o || this.u.length < 10 || e.duration > i.T) {
      if (o ? e.duration > o.T ? (o.entries = [e], o.T = e.duration) : e.duration === o.T && e.startTime === o.entries[0].startTime && o.entries.push(e) : (o = { id: e.interactionId, entries: [e], T: e.duration }, this.l.set(o.id, o), this.u.push(o)), this.u.sort((s, a) => a.T - s.T), this.u.length > 10) {
        let s = this.u.splice(10);
        for (let a of s) this.l.delete(a.id);
      }
      (r = this.v) == null || r.call(this, o);
    }
  }
}, MD = (t) => {
  let e = globalThis.requestIdleCallback || setTimeout;
  document.visibilityState === "hidden" ? t() : (t = $S(t), document.addEventListener("visibilitychange", t, { once: !0 }), e(() => {
    t(), document.removeEventListener("visibilitychange", t);
  }));
}, ek = [200, 500], tB = (t, e = {}) => {
  globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype && my(() => {
    var n;
    Z5();
    let r, i = Cs("INP"), o = PS(e, eB), s = (l) => {
      MD(() => {
        for (let c of l) o.h(c);
        let u = o.P();
        u && u.T !== i.value && (i.value = u.T, i.entries = u.entries, r());
      });
    }, a = Nh("event", s, { durationThreshold: (n = e.durationThreshold) != null ? n : 40 });
    r = xs(t, i, ek, e.reportAllChanges), a && (a.observe({ type: "first-input", buffered: !0 }), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && (s(a.takeRecords()), r(!0));
    }), uf(() => {
      o.p(), i = Cs("INP"), r = xs(t, i, ek, e.reportAllChanges);
    }));
  });
}, nB = class {
  constructor() {
    La(this, "m");
  }
  h(e) {
    var n;
    (n = this.m) == null || n.call(this, e);
  }
}, tk = [2500, 4e3], rB = (t, e = {}) => {
  my(() => {
    let n = ND(), r, i = Cs("LCP"), o = PS(e, nB), s = (l) => {
      e.reportAllChanges || (l = l.slice(-1));
      for (let u of l) o.h(u), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - Ih(), 0), i.entries = [u], r());
    }, a = Nh("largest-contentful-paint", s);
    if (a) {
      r = xs(t, i, tk, e.reportAllChanges);
      let l = $S(() => {
        s(a.takeRecords()), a.disconnect(), r(!0);
      });
      for (let u of ["keydown", "click", "visibilitychange"]) addEventListener(u, () => MD(l), { capture: !0, once: !0 });
      uf((u) => {
        i = Cs("LCP"), r = xs(t, i, tk, e.reportAllChanges), IS(() => {
          i.value = performance.now() - u.timeStamp, r(!0);
        });
      });
    }
  });
}, nk = [800, 1800], _1 = (t) => {
  document.prerendering ? my(() => _1(t)) : document.readyState !== "complete" ? addEventListener("load", () => _1(t), !0) : setTimeout(t);
}, iB = (t, e = {}) => {
  let n = Cs("TTFB"), r = xs(t, n, nk, e.reportAllChanges);
  _1(() => {
    let i = NS();
    i && (n.value = Math.max(i.responseStart - Ih(), 0), n.entries = [i], r(!0), uf(() => {
      n = Cs("TTFB", 0), r = xs(t, n, nk, e.reportAllChanges), r(!0);
    }));
  });
}, ym = { lcp: null, cls: null, inp: null, fcp: null, ttfb: null }, Tc = !1, Pg = null;
function oB() {
  Tc || Object.values(ym).every((t) => t !== null) && E1();
}
function E1() {
  Tc || (Tc = !0, Pg && (clearTimeout(Pg), Pg = null), Tn("Sending web vitals data:", ym), Za("performance", { eventName: "web-vitals", webVitals: ym }));
}
function Of(t) {
  if (Tc) return;
  let e = t.name.toLowerCase();
  ym[e] = t.value, Tn(`Collected ${e}:`, t.value), oB();
}
function sB() {
  if (!Vn.trackWebVitals) {
    Tn("Web vitals tracking is disabled.");
    return;
  }
  Tn("Initializing web vitals tracking...");
  try {
    rB(Of), Q5(Of), tB(Of), PD(Of), iB(Of), Pg = setTimeout(() => {
      Tc || (Tn("Web vitals timeout reached, sending collected metrics."), E1());
    }, Vn.webVitalsTimeout || 2e4), window.addEventListener("beforeunload", () => {
      Tc || E1();
    }), Tn("Web vitals tracking initialized successfully.");
  } catch (t) {
    mn("Error setting up web vitals tracking:", t);
  }
}
var Aa = !1, aB = { init: (t) => {
  if (Aa) {
    mn("Rybbit SDK already initialized. Call init() only once.");
    return;
  }
  U5(t) && (Aa = !0, Tn("Config:", Hl({}, Vn)), G5(), W5(), sB());
}, pageview: (t) => {
  if (!Aa) {
    mn("Rybbit SDK not initialized. Call rybbit.init() first.");
    return;
  }
  Za("pageview", { pathOverride: t });
}, event: (t, e) => {
  if (!Aa) {
    mn("Rybbit SDK not initialized. Call rybbit.init() first.");
    return;
  }
  if (!t) {
    mn("Event name is required and must be a string.");
    return;
  }
  Za("custom_event", { eventName: t, properties: e });
}, outbound: (t, e = "", n = "_self") => {
  if (!Aa) {
    mn("Rybbit SDK not initialized. Call rybbit.init() first.");
    return;
  }
  if (!t) {
    mn("Outbound link URL is required and must be a string.");
    return;
  }
  Za("outbound", { properties: { url: t, text: e, target: n } });
}, identify: (t) => {
  if (!Aa) {
    mn("Rybbit SDK not initialized. Call rybbit.init() first.");
    return;
  }
  q5(t);
}, clearUserId: () => {
  if (!Aa) {
    mn("Rybbit SDK not initialized. Call rybbit.init() first.");
    return;
  }
  z5();
}, getUserId: () => Aa ? H5() : (mn("Rybbit SDK not initialized. Call rybbit.init() first."), null), cleanup: Y5 }, rk = aB;
function Ws(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function FD(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
/*!
 * GSAP 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var to = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, xc = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, MS, qr, Fn, So = 1e8, yn = 1 / So, k1 = Math.PI * 2, lB = k1 / 4, uB = 0, LD = Math.sqrt, cB = Math.cos, fB = Math.sin, Mr = function(e) {
  return typeof e == "string";
}, Yn = function(e) {
  return typeof e == "function";
}, ha = function(e) {
  return typeof e == "number";
}, FS = function(e) {
  return typeof e > "u";
}, As = function(e) {
  return typeof e == "object";
}, Ri = function(e) {
  return e !== !1;
}, LS = function() {
  return typeof window < "u";
}, gp = function(e) {
  return Yn(e) || Mr(e);
}, BD = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, ti = Array.isArray, T1 = /(?:-?\.?\d|\.)+/gi, jD = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, tc = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, O0 = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, VD = /[+-]=-?[.\d]+/, UD = /[^,'"\[\]\s]+/gi, dB = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, Un, ls, x1, BS, no = {}, vm = {}, qD, zD = function(e) {
  return (vm = Cc(e, no)) && Ni;
}, jS = function(e, n) {
  return console.warn("Invalid property", e, "set to", n, "Missing plugin? gsap.registerPlugin()");
}, Zd = function(e, n) {
  return !n && console.warn(e);
}, HD = function(e, n) {
  return e && (no[e] = n) && vm && (vm[e] = n) || no;
}, eh = function() {
  return 0;
}, hB = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, $g = {
  suppressEvents: !0,
  kill: !1
}, pB = {
  suppressEvents: !0
}, VS = {}, el = [], C1 = {}, GD, Yi = {}, D0 = {}, ik = 30, Mg = [], US = "", qS = function(e) {
  var n = e[0], r, i;
  if (As(n) || Yn(n) || (e = [e]), !(r = (n._gsap || {}).harness)) {
    for (i = Mg.length; i-- && !Mg[i].targetTest(n); )
      ;
    r = Mg[i];
  }
  for (i = e.length; i--; )
    e[i] && (e[i]._gsap || (e[i]._gsap = new mI(e[i], r))) || e.splice(i, 1);
  return e;
}, nu = function(e) {
  return e._gsap || qS(_o(e))[0]._gsap;
}, WD = function(e, n, r) {
  return (r = e[n]) && Yn(r) ? e[n]() : FS(r) && e.getAttribute && e.getAttribute(n) || r;
}, Oi = function(e, n) {
  return (e = e.split(",")).forEach(n) || e;
}, Qn = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, ur = function(e) {
  return Math.round(e * 1e7) / 1e7 || 0;
}, cc = function(e, n) {
  var r = n.charAt(0), i = parseFloat(n.substr(2));
  return e = parseFloat(e), r === "+" ? e + i : r === "-" ? e - i : r === "*" ? e * i : e / i;
}, gB = function(e, n) {
  for (var r = n.length, i = 0; e.indexOf(n[i]) < 0 && ++i < r; )
    ;
  return i < r;
}, bm = function() {
  var e = el.length, n = el.slice(0), r, i;
  for (C1 = {}, el.length = 0, r = 0; r < e; r++)
    i = n[r], i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
}, YD = function(e, n, r, i) {
  el.length && !qr && bm(), e.render(n, r, qr && n < 0 && (e._initted || e._startAt)), el.length && !qr && bm();
}, XD = function(e) {
  var n = parseFloat(e);
  return (n || n === 0) && (e + "").match(UD).length < 2 ? n : Mr(e) ? e.trim() : e;
}, KD = function(e) {
  return e;
}, ro = function(e, n) {
  for (var r in n)
    r in e || (e[r] = n[r]);
  return e;
}, mB = function(e) {
  return function(n, r) {
    for (var i in r)
      i in n || i === "duration" && e || i === "ease" || (n[i] = r[i]);
  };
}, Cc = function(e, n) {
  for (var r in n)
    e[r] = n[r];
  return e;
}, ok = function t(e, n) {
  for (var r in n)
    r !== "__proto__" && r !== "constructor" && r !== "prototype" && (e[r] = As(n[r]) ? t(e[r] || (e[r] = {}), n[r]) : n[r]);
  return e;
}, wm = function(e, n) {
  var r = {}, i;
  for (i in e)
    i in n || (r[i] = e[i]);
  return r;
}, Dd = function(e) {
  var n = e.parent || Un, r = e.keyframes ? mB(ti(e.keyframes)) : ro;
  if (Ri(e.inherit))
    for (; n; )
      r(e, n.vars.defaults), n = n.parent || n._dp;
  return e;
}, yB = function(e, n) {
  for (var r = e.length, i = r === n.length; i && r-- && e[r] === n[r]; )
    ;
  return r < 0;
}, QD = function(e, n, r, i, o) {
  var s = e[i], a;
  if (o)
    for (a = n[o]; s && s[o] > a; )
      s = s._prev;
  return s ? (n._next = s._next, s._next = n) : (n._next = e[r], e[r] = n), n._next ? n._next._prev = n : e[i] = n, n._prev = s, n.parent = n._dp = e, n;
}, yy = function(e, n, r, i) {
  r === void 0 && (r = "_first"), i === void 0 && (i = "_last");
  var o = n._prev, s = n._next;
  o ? o._next = s : e[r] === n && (e[r] = s), s ? s._prev = o : e[i] === n && (e[i] = o), n._next = n._prev = n.parent = null;
}, ol = function(e, n) {
  e.parent && (!n || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, ru = function(e, n) {
  if (e && (!n || n._end > e._dur || n._start < 0))
    for (var r = e; r; )
      r._dirty = 1, r = r.parent;
  return e;
}, vB = function(e) {
  for (var n = e.parent; n && n.parent; )
    n._dirty = 1, n.totalDuration(), n = n.parent;
  return e;
}, A1 = function(e, n, r, i) {
  return e._startAt && (qr ? e._startAt.revert($g) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(n, !0, i));
}, bB = function t(e) {
  return !e || e._ts && t(e.parent);
}, sk = function(e) {
  return e._repeat ? Ac(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, Ac = function(e, n) {
  var r = Math.floor(e = ur(e / n));
  return e && r === e ? r - 1 : r;
}, Sm = function(e, n) {
  return (e - n._start) * n._ts + (n._ts >= 0 ? 0 : n._dirty ? n.totalDuration() : n._tDur);
}, vy = function(e) {
  return e._end = ur(e._start + (e._tDur / Math.abs(e._ts || e._rts || yn) || 0));
}, by = function(e, n) {
  var r = e._dp;
  return r && r.smoothChildTiming && e._ts && (e._start = ur(r._time - (e._ts > 0 ? n / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - n) / -e._ts)), vy(e), r._dirty || ru(r, e)), e;
}, JD = function(e, n) {
  var r;
  if ((n._time || !n._dur && n._initted || n._start < e._time && (n._dur || !n.add)) && (r = Sm(e.rawTime(), n), (!n._dur || Ph(0, n.totalDuration(), r) - n._tTime > yn) && n.render(r, !0)), ru(e, n)._dp && e._initted && e._time >= e._dur && e._ts) {
    if (e._dur < e.duration())
      for (r = e; r._dp; )
        r.rawTime() >= 0 && r.totalTime(r._tTime), r = r._dp;
    e._zTime = -yn;
  }
}, ps = function(e, n, r, i) {
  return n.parent && ol(n), n._start = ur((ha(r) ? r : r || e !== Un ? po(e, r, n) : e._time) + n._delay), n._end = ur(n._start + (n.totalDuration() / Math.abs(n.timeScale()) || 0)), QD(e, n, "_first", "_last", e._sort ? "_start" : 0), R1(n) || (e._recent = n), i || JD(e, n), e._ts < 0 && by(e, e._tTime), e;
}, ZD = function(e, n) {
  return (no.ScrollTrigger || jS("scrollTrigger", n)) && no.ScrollTrigger.create(n, e);
}, eI = function(e, n, r, i, o) {
  if (HS(e, n, o), !e._initted)
    return 1;
  if (!r && e._pt && !qr && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && GD !== Qi.frame)
    return el.push(e), e._lazy = [o, i], 1;
}, wB = function t(e) {
  var n = e.parent;
  return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || t(n));
}, R1 = function(e) {
  var n = e.data;
  return n === "isFromStart" || n === "isStart";
}, SB = function(e, n, r, i) {
  var o = e.ratio, s = n < 0 || !n && (!e._start && wB(e) && !(!e._initted && R1(e)) || (e._ts < 0 || e._dp._ts < 0) && !R1(e)) ? 0 : 1, a = e._rDelay, l = 0, u, c, f;
  if (a && e._repeat && (l = Ph(0, e._tDur, n), c = Ac(l, a), e._yoyo && c & 1 && (s = 1 - s), c !== Ac(e._tTime, a) && (o = 1 - s, e.vars.repeatRefresh && e._initted && e.invalidate())), s !== o || qr || i || e._zTime === yn || !n && e._zTime) {
    if (!e._initted && eI(e, n, i, r, l))
      return;
    for (f = e._zTime, e._zTime = n || (r ? yn : 0), r || (r = n && !f), e.ratio = s, e._from && (s = 1 - s), e._time = 0, e._tTime = l, u = e._pt; u; )
      u.r(s, u.d), u = u._next;
    n < 0 && A1(e, n, r, !0), e._onUpdate && !r && eo(e, "onUpdate"), l && e._repeat && !r && e.parent && eo(e, "onRepeat"), (n >= e._tDur || n < 0) && e.ratio === s && (s && ol(e, 1), !r && !qr && (eo(e, s ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
  } else e._zTime || (e._zTime = n);
}, _B = function(e, n, r) {
  var i;
  if (r > n)
    for (i = e._first; i && i._start <= r; ) {
      if (i.data === "isPause" && i._start > n)
        return i;
      i = i._next;
    }
  else
    for (i = e._last; i && i._start >= r; ) {
      if (i.data === "isPause" && i._start < n)
        return i;
      i = i._prev;
    }
}, Rc = function(e, n, r, i) {
  var o = e._repeat, s = ur(n) || 0, a = e._tTime / e._tDur;
  return a && !i && (e._time *= s / e._dur), e._dur = s, e._tDur = o ? o < 0 ? 1e10 : ur(s * (o + 1) + e._rDelay * o) : s, a > 0 && !i && by(e, e._tTime = e._tDur * a), e.parent && vy(e), r || ru(e.parent, e), e;
}, ak = function(e) {
  return e instanceof fi ? ru(e) : Rc(e, e._dur);
}, EB = {
  _start: 0,
  endTime: eh,
  totalDuration: eh
}, po = function t(e, n, r) {
  var i = e.labels, o = e._recent || EB, s = e.duration() >= So ? o.endTime(!1) : e._dur, a, l, u;
  return Mr(n) && (isNaN(n) || n in i) ? (l = n.charAt(0), u = n.substr(-1) === "%", a = n.indexOf("="), l === "<" || l === ">" ? (a >= 0 && (n = n.replace(/=/, "")), (l === "<" ? o._start : o.endTime(o._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (u ? (a < 0 ? o : r).totalDuration() / 100 : 1)) : a < 0 ? (n in i || (i[n] = s), i[n]) : (l = parseFloat(n.charAt(a - 1) + n.substr(a + 1)), u && r && (l = l / 100 * (ti(r) ? r[0] : r).totalDuration()), a > 1 ? t(e, n.substr(0, a - 1), r) + l : s + l)) : n == null ? s : +n;
}, Id = function(e, n, r) {
  var i = ha(n[1]), o = (i ? 2 : 1) + (e < 2 ? 0 : 1), s = n[o], a, l;
  if (i && (s.duration = n[1]), s.parent = r, e) {
    for (a = s, l = r; l && !("immediateRender" in a); )
      a = l.vars.defaults || {}, l = Ri(l.vars.inherit) && l.parent;
    s.immediateRender = Ri(a.immediateRender), e < 2 ? s.runBackwards = 1 : s.startAt = n[o - 1];
  }
  return new lr(n[0], s, n[o + 1]);
}, gl = function(e, n) {
  return e || e === 0 ? n(e) : n;
}, Ph = function(e, n, r) {
  return r < e ? e : r > n ? n : r;
}, Qr = function(e, n) {
  return !Mr(e) || !(n = dB.exec(e)) ? "" : n[1];
}, kB = function(e, n, r) {
  return gl(r, function(i) {
    return Ph(e, n, i);
  });
}, O1 = [].slice, tI = function(e, n) {
  return e && As(e) && "length" in e && (!n && !e.length || e.length - 1 in e && As(e[0])) && !e.nodeType && e !== ls;
}, TB = function(e, n, r) {
  return r === void 0 && (r = []), e.forEach(function(i) {
    var o;
    return Mr(i) && !n || tI(i, 1) ? (o = r).push.apply(o, _o(i)) : r.push(i);
  }) || r;
}, _o = function(e, n, r) {
  return Fn && !n && Fn.selector ? Fn.selector(e) : Mr(e) && !r && (x1 || !Oc()) ? O1.call((n || BS).querySelectorAll(e), 0) : ti(e) ? TB(e, r) : tI(e) ? O1.call(e, 0) : e ? [e] : [];
}, D1 = function(e) {
  return e = _o(e)[0] || Zd("Invalid scope") || {}, function(n) {
    var r = e.current || e.nativeElement || e;
    return _o(n, r.querySelectorAll ? r : r === e ? Zd("Invalid scope") || BS.createElement("div") : e);
  };
}, nI = function(e) {
  return e.sort(function() {
    return 0.5 - Math.random();
  });
}, rI = function(e) {
  if (Yn(e))
    return e;
  var n = As(e) ? e : {
    each: e
  }, r = iu(n.ease), i = n.from || 0, o = parseFloat(n.base) || 0, s = {}, a = i > 0 && i < 1, l = isNaN(i) || a, u = n.axis, c = i, f = i;
  return Mr(i) ? c = f = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[i] || 0 : !a && l && (c = i[0], f = i[1]), function(d, h, p) {
    var g = (p || n).length, m = s[g], v, S, _, b, y, w, E, x, k;
    if (!m) {
      if (k = n.grid === "auto" ? 0 : (n.grid || [1, So])[1], !k) {
        for (E = -So; E < (E = p[k++].getBoundingClientRect().left) && k < g; )
          ;
        k < g && k--;
      }
      for (m = s[g] = [], v = l ? Math.min(k, g) * c - 0.5 : i % k, S = k === So ? 0 : l ? g * f / k - 0.5 : i / k | 0, E = 0, x = So, w = 0; w < g; w++)
        _ = w % k - v, b = S - (w / k | 0), m[w] = y = u ? Math.abs(u === "y" ? b : _) : LD(_ * _ + b * b), y > E && (E = y), y < x && (x = y);
      i === "random" && nI(m), m.max = E - x, m.min = x, m.v = g = (parseFloat(n.amount) || parseFloat(n.each) * (k > g ? g - 1 : u ? u === "y" ? g / k : k : Math.max(k, g / k)) || 0) * (i === "edges" ? -1 : 1), m.b = g < 0 ? o - g : o, m.u = Qr(n.amount || n.each) || 0, r = r && g < 0 ? hI(r) : r;
    }
    return g = (m[d] - m.min) / m.max || 0, ur(m.b + (r ? r(g) : g) * m.v) + m.u;
  };
}, I1 = function(e) {
  var n = Math.pow(10, ((e + "").split(".")[1] || "").length);
  return function(r) {
    var i = ur(Math.round(parseFloat(r) / e) * e * n);
    return (i - i % 1) / n + (ha(r) ? 0 : Qr(r));
  };
}, iI = function(e, n) {
  var r = ti(e), i, o;
  return !r && As(e) && (i = r = e.radius || So, e.values ? (e = _o(e.values), (o = !ha(e[0])) && (i *= i)) : e = I1(e.increment)), gl(n, r ? Yn(e) ? function(s) {
    return o = e(s), Math.abs(o - s) <= i ? o : s;
  } : function(s) {
    for (var a = parseFloat(o ? s.x : s), l = parseFloat(o ? s.y : 0), u = So, c = 0, f = e.length, d, h; f--; )
      o ? (d = e[f].x - a, h = e[f].y - l, d = d * d + h * h) : d = Math.abs(e[f] - a), d < u && (u = d, c = f);
    return c = !i || u <= i ? e[c] : s, o || c === s || ha(s) ? c : c + Qr(s);
  } : I1(e));
}, oI = function(e, n, r, i) {
  return gl(ti(e) ? !n : r === !0 ? !!(r = 0) : !i, function() {
    return ti(e) ? e[~~(Math.random() * e.length)] : (r = r || 1e-5) && (i = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) && Math.floor(Math.round((e - r / 2 + Math.random() * (n - e + r * 0.99)) / r) * r * i) / i;
  });
}, xB = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return function(i) {
    return n.reduce(function(o, s) {
      return s(o);
    }, i);
  };
}, CB = function(e, n) {
  return function(r) {
    return e(parseFloat(r)) + (n || Qr(r));
  };
}, AB = function(e, n, r) {
  return aI(e, n, 0, 1, r);
}, sI = function(e, n, r) {
  return gl(r, function(i) {
    return e[~~n(i)];
  });
}, RB = function t(e, n, r) {
  var i = n - e;
  return ti(e) ? sI(e, t(0, e.length), n) : gl(r, function(o) {
    return (i + (o - e) % i) % i + e;
  });
}, OB = function t(e, n, r) {
  var i = n - e, o = i * 2;
  return ti(e) ? sI(e, t(0, e.length - 1), n) : gl(r, function(s) {
    return s = (o + (s - e) % o) % o || 0, e + (s > i ? o - s : s);
  });
}, th = function(e) {
  for (var n = 0, r = "", i, o, s, a; ~(i = e.indexOf("random(", n)); )
    s = e.indexOf(")", i), a = e.charAt(i + 7) === "[", o = e.substr(i + 7, s - i - 7).match(a ? UD : T1), r += e.substr(n, i - n) + oI(a ? o : +o[0], a ? 0 : +o[1], +o[2] || 1e-5), n = s + 1;
  return r + e.substr(n, e.length - n);
}, aI = function(e, n, r, i, o) {
  var s = n - e, a = i - r;
  return gl(o, function(l) {
    return r + ((l - e) / s * a || 0);
  });
}, DB = function t(e, n, r, i) {
  var o = isNaN(e + n) ? 0 : function(h) {
    return (1 - h) * e + h * n;
  };
  if (!o) {
    var s = Mr(e), a = {}, l, u, c, f, d;
    if (r === !0 && (i = 1) && (r = null), s)
      e = {
        p: e
      }, n = {
        p: n
      };
    else if (ti(e) && !ti(n)) {
      for (c = [], f = e.length, d = f - 2, u = 1; u < f; u++)
        c.push(t(e[u - 1], e[u]));
      f--, o = function(p) {
        p *= f;
        var g = Math.min(d, ~~p);
        return c[g](p - g);
      }, r = n;
    } else i || (e = Cc(ti(e) ? [] : {}, e));
    if (!c) {
      for (l in n)
        zS.call(a, e, l, "get", n[l]);
      o = function(p) {
        return YS(p, a) || (s ? e.p : e);
      };
    }
  }
  return gl(r, o);
}, lk = function(e, n, r) {
  var i = e.labels, o = So, s, a, l;
  for (s in i)
    a = i[s] - n, a < 0 == !!r && a && o > (a = Math.abs(a)) && (l = s, o = a);
  return l;
}, eo = function(e, n, r) {
  var i = e.vars, o = i[n], s = Fn, a = e._ctx, l, u, c;
  if (o)
    return l = i[n + "Params"], u = i.callbackScope || e, r && el.length && bm(), a && (Fn = a), c = l ? o.apply(u, l) : o.call(u), Fn = s, c;
}, gd = function(e) {
  return ol(e), e.scrollTrigger && e.scrollTrigger.kill(!!qr), e.progress() < 1 && eo(e, "onInterrupt"), e;
}, nc, lI = [], uI = function(e) {
  if (e)
    if (e = !e.name && e.default || e, LS() || e.headless) {
      var n = e.name, r = Yn(e), i = n && !r && e.init ? function() {
        this._props = [];
      } : e, o = {
        init: eh,
        render: YS,
        add: zS,
        kill: WB,
        modifier: GB,
        rawVars: 0
      }, s = {
        targetTest: 0,
        get: 0,
        getSetter: WS,
        aliases: {},
        register: 0
      };
      if (Oc(), e !== i) {
        if (Yi[n])
          return;
        ro(i, ro(wm(e, o), s)), Cc(i.prototype, Cc(o, wm(e, s))), Yi[i.prop = n] = i, e.targetTest && (Mg.push(i), VS[n] = 1), n = (n === "css" ? "CSS" : n.charAt(0).toUpperCase() + n.substr(1)) + "Plugin";
      }
      HD(n, i), e.register && e.register(Ni, i, Di);
    } else
      lI.push(e);
}, gn = 255, md = {
  aqua: [0, gn, gn],
  lime: [0, gn, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, gn],
  navy: [0, 0, 128],
  white: [gn, gn, gn],
  olive: [128, 128, 0],
  yellow: [gn, gn, 0],
  orange: [gn, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [gn, 0, 0],
  pink: [gn, 192, 203],
  cyan: [0, gn, gn],
  transparent: [gn, gn, gn, 0]
}, I0 = function(e, n, r) {
  return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? n + (r - n) * e * 6 : e < 0.5 ? r : e * 3 < 2 ? n + (r - n) * (2 / 3 - e) * 6 : n) * gn + 0.5 | 0;
}, cI = function(e, n, r) {
  var i = e ? ha(e) ? [e >> 16, e >> 8 & gn, e & gn] : 0 : md.black, o, s, a, l, u, c, f, d, h, p;
  if (!i) {
    if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), md[e])
      i = md[e];
    else if (e.charAt(0) === "#") {
      if (e.length < 6 && (o = e.charAt(1), s = e.charAt(2), a = e.charAt(3), e = "#" + o + o + s + s + a + a + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9)
        return i = parseInt(e.substr(1, 6), 16), [i >> 16, i >> 8 & gn, i & gn, parseInt(e.substr(7), 16) / 255];
      e = parseInt(e.substr(1), 16), i = [e >> 16, e >> 8 & gn, e & gn];
    } else if (e.substr(0, 3) === "hsl") {
      if (i = p = e.match(T1), !n)
        l = +i[0] % 360 / 360, u = +i[1] / 100, c = +i[2] / 100, s = c <= 0.5 ? c * (u + 1) : c + u - c * u, o = c * 2 - s, i.length > 3 && (i[3] *= 1), i[0] = I0(l + 1 / 3, o, s), i[1] = I0(l, o, s), i[2] = I0(l - 1 / 3, o, s);
      else if (~e.indexOf("="))
        return i = e.match(jD), r && i.length < 4 && (i[3] = 1), i;
    } else
      i = e.match(T1) || md.transparent;
    i = i.map(Number);
  }
  return n && !p && (o = i[0] / gn, s = i[1] / gn, a = i[2] / gn, f = Math.max(o, s, a), d = Math.min(o, s, a), c = (f + d) / 2, f === d ? l = u = 0 : (h = f - d, u = c > 0.5 ? h / (2 - f - d) : h / (f + d), l = f === o ? (s - a) / h + (s < a ? 6 : 0) : f === s ? (a - o) / h + 2 : (o - s) / h + 4, l *= 60), i[0] = ~~(l + 0.5), i[1] = ~~(u * 100 + 0.5), i[2] = ~~(c * 100 + 0.5)), r && i.length < 4 && (i[3] = 1), i;
}, fI = function(e) {
  var n = [], r = [], i = -1;
  return e.split(tl).forEach(function(o) {
    var s = o.match(tc) || [];
    n.push.apply(n, s), r.push(i += s.length + 1);
  }), n.c = r, n;
}, uk = function(e, n, r) {
  var i = "", o = (e + i).match(tl), s = n ? "hsla(" : "rgba(", a = 0, l, u, c, f;
  if (!o)
    return e;
  if (o = o.map(function(d) {
    return (d = cI(d, n, 1)) && s + (n ? d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : d.join(",")) + ")";
  }), r && (c = fI(e), l = r.c, l.join(i) !== c.c.join(i)))
    for (u = e.replace(tl, "1").split(tc), f = u.length - 1; a < f; a++)
      i += u[a] + (~l.indexOf(a) ? o.shift() || s + "0,0,0,0)" : (c.length ? c : o.length ? o : r).shift());
  if (!u)
    for (u = e.split(tl), f = u.length - 1; a < f; a++)
      i += u[a] + o[a];
  return i + u[f];
}, tl = function() {
  var t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in md)
    t += "|" + e + "\\b";
  return new RegExp(t + ")", "gi");
}(), IB = /hsl[a]?\(/, dI = function(e) {
  var n = e.join(" "), r;
  if (tl.lastIndex = 0, tl.test(n))
    return r = IB.test(n), e[1] = uk(e[1], r), e[0] = uk(e[0], r, fI(e[1])), !0;
}, nh, Qi = function() {
  var t = Date.now, e = 500, n = 33, r = t(), i = r, o = 1e3 / 240, s = o, a = [], l, u, c, f, d, h, p = function g(m) {
    var v = t() - i, S = m === !0, _, b, y, w;
    if ((v > e || v < 0) && (r += v - n), i += v, y = i - r, _ = y - s, (_ > 0 || S) && (w = ++f.frame, d = y - f.time * 1e3, f.time = y = y / 1e3, s += _ + (_ >= o ? 4 : o - _), b = 1), S || (l = u(g)), b)
      for (h = 0; h < a.length; h++)
        a[h](y, d, w, m);
  };
  return f = {
    time: 0,
    frame: 0,
    tick: function() {
      p(!0);
    },
    deltaRatio: function(m) {
      return d / (1e3 / (m || 60));
    },
    wake: function() {
      qD && (!x1 && LS() && (ls = x1 = window, BS = ls.document || {}, no.gsap = Ni, (ls.gsapVersions || (ls.gsapVersions = [])).push(Ni.version), zD(vm || ls.GreenSockGlobals || !ls.gsap && ls || {}), lI.forEach(uI)), c = typeof requestAnimationFrame < "u" && requestAnimationFrame, l && f.sleep(), u = c || function(m) {
        return setTimeout(m, s - f.time * 1e3 + 1 | 0);
      }, nh = 1, p(2));
    },
    sleep: function() {
      (c ? cancelAnimationFrame : clearTimeout)(l), nh = 0, u = eh;
    },
    lagSmoothing: function(m, v) {
      e = m || 1 / 0, n = Math.min(v || 33, e);
    },
    fps: function(m) {
      o = 1e3 / (m || 240), s = f.time * 1e3 + o;
    },
    add: function(m, v, S) {
      var _ = v ? function(b, y, w, E) {
        m(b, y, w, E), f.remove(_);
      } : m;
      return f.remove(m), a[S ? "unshift" : "push"](_), Oc(), _;
    },
    remove: function(m, v) {
      ~(v = a.indexOf(m)) && a.splice(v, 1) && h >= v && h--;
    },
    _listeners: a
  }, f;
}(), Oc = function() {
  return !nh && Qi.wake();
}, zt = {}, NB = /^[\d.\-M][\d.\-,\s]/, PB = /["']/g, $B = function(e) {
  for (var n = {}, r = e.substr(1, e.length - 3).split(":"), i = r[0], o = 1, s = r.length, a, l, u; o < s; o++)
    l = r[o], a = o !== s - 1 ? l.lastIndexOf(",") : l.length, u = l.substr(0, a), n[i] = isNaN(u) ? u.replace(PB, "").trim() : +u, i = l.substr(a + 1).trim();
  return n;
}, MB = function(e) {
  var n = e.indexOf("(") + 1, r = e.indexOf(")"), i = e.indexOf("(", n);
  return e.substring(n, ~i && i < r ? e.indexOf(")", r + 1) : r);
}, FB = function(e) {
  var n = (e + "").split("("), r = zt[n[0]];
  return r && n.length > 1 && r.config ? r.config.apply(null, ~e.indexOf("{") ? [$B(n[1])] : MB(e).split(",").map(XD)) : zt._CE && NB.test(e) ? zt._CE("", e) : r;
}, hI = function(e) {
  return function(n) {
    return 1 - e(1 - n);
  };
}, pI = function t(e, n) {
  for (var r = e._first, i; r; )
    r instanceof fi ? t(r, n) : r.vars.yoyoEase && (!r._yoyo || !r._repeat) && r._yoyo !== n && (r.timeline ? t(r.timeline, n) : (i = r._ease, r._ease = r._yEase, r._yEase = i, r._yoyo = n)), r = r._next;
}, iu = function(e, n) {
  return e && (Yn(e) ? e : zt[e] || FB(e)) || n;
}, Ou = function(e, n, r, i) {
  r === void 0 && (r = function(l) {
    return 1 - n(1 - l);
  }), i === void 0 && (i = function(l) {
    return l < 0.5 ? n(l * 2) / 2 : 1 - n((1 - l) * 2) / 2;
  });
  var o = {
    easeIn: n,
    easeOut: r,
    easeInOut: i
  }, s;
  return Oi(e, function(a) {
    zt[a] = no[a] = o, zt[s = a.toLowerCase()] = r;
    for (var l in o)
      zt[s + (l === "easeIn" ? ".in" : l === "easeOut" ? ".out" : ".inOut")] = zt[a + "." + l] = o[l];
  }), o;
}, gI = function(e) {
  return function(n) {
    return n < 0.5 ? (1 - e(1 - n * 2)) / 2 : 0.5 + e((n - 0.5) * 2) / 2;
  };
}, N0 = function t(e, n, r) {
  var i = n >= 1 ? n : 1, o = (r || (e ? 0.3 : 0.45)) / (n < 1 ? n : 1), s = o / k1 * (Math.asin(1 / i) || 0), a = function(c) {
    return c === 1 ? 1 : i * Math.pow(2, -10 * c) * fB((c - s) * o) + 1;
  }, l = e === "out" ? a : e === "in" ? function(u) {
    return 1 - a(1 - u);
  } : gI(a);
  return o = k1 / o, l.config = function(u, c) {
    return t(e, u, c);
  }, l;
}, P0 = function t(e, n) {
  n === void 0 && (n = 1.70158);
  var r = function(s) {
    return s ? --s * s * ((n + 1) * s + n) + 1 : 0;
  }, i = e === "out" ? r : e === "in" ? function(o) {
    return 1 - r(1 - o);
  } : gI(r);
  return i.config = function(o) {
    return t(e, o);
  }, i;
};
Oi("Linear,Quad,Cubic,Quart,Quint,Strong", function(t, e) {
  var n = e < 5 ? e + 1 : e;
  Ou(t + ",Power" + (n - 1), e ? function(r) {
    return Math.pow(r, n);
  } : function(r) {
    return r;
  }, function(r) {
    return 1 - Math.pow(1 - r, n);
  }, function(r) {
    return r < 0.5 ? Math.pow(r * 2, n) / 2 : 1 - Math.pow((1 - r) * 2, n) / 2;
  });
});
zt.Linear.easeNone = zt.none = zt.Linear.easeIn;
Ou("Elastic", N0("in"), N0("out"), N0());
(function(t, e) {
  var n = 1 / e, r = 2 * n, i = 2.5 * n, o = function(a) {
    return a < n ? t * a * a : a < r ? t * Math.pow(a - 1.5 / e, 2) + 0.75 : a < i ? t * (a -= 2.25 / e) * a + 0.9375 : t * Math.pow(a - 2.625 / e, 2) + 0.984375;
  };
  Ou("Bounce", function(s) {
    return 1 - o(1 - s);
  }, o);
})(7.5625, 2.75);
Ou("Expo", function(t) {
  return Math.pow(2, 10 * (t - 1)) * t + t * t * t * t * t * t * (1 - t);
});
Ou("Circ", function(t) {
  return -(LD(1 - t * t) - 1);
});
Ou("Sine", function(t) {
  return t === 1 ? 1 : -cB(t * lB) + 1;
});
Ou("Back", P0("in"), P0("out"), P0());
zt.SteppedEase = zt.steps = no.SteppedEase = {
  config: function(e, n) {
    e === void 0 && (e = 1);
    var r = 1 / e, i = e + (n ? 0 : 1), o = n ? 1 : 0, s = 1 - yn;
    return function(a) {
      return ((i * Ph(0, s, a) | 0) + o) * r;
    };
  }
};
xc.ease = zt["quad.out"];
Oi("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t) {
  return US += t + "," + t + "Params,";
});
var mI = function(e, n) {
  this.id = uB++, e._gsap = this, this.target = e, this.harness = n, this.get = n ? n.get : WD, this.set = n ? n.getSetter : WS;
}, rh = /* @__PURE__ */ function() {
  function t(n) {
    this.vars = n, this._delay = +n.delay || 0, (this._repeat = n.repeat === 1 / 0 ? -2 : n.repeat || 0) && (this._rDelay = n.repeatDelay || 0, this._yoyo = !!n.yoyo || !!n.yoyoEase), this._ts = 1, Rc(this, +n.duration, 1, 1), this.data = n.data, Fn && (this._ctx = Fn, Fn.data.push(this)), nh || Qi.wake();
  }
  var e = t.prototype;
  return e.delay = function(r) {
    return r || r === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + r - this._delay), this._delay = r, this) : this._delay;
  }, e.duration = function(r) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? r + (r + this._rDelay) * this._repeat : r) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(r) {
    return arguments.length ? (this._dirty = 0, Rc(this, this._repeat < 0 ? r : (r - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(r, i) {
    if (Oc(), !arguments.length)
      return this._tTime;
    var o = this._dp;
    if (o && o.smoothChildTiming && this._ts) {
      for (by(this, r), !o._dp || o.parent || JD(o, this); o && o.parent; )
        o.parent._time !== o._start + (o._ts >= 0 ? o._tTime / o._ts : (o.totalDuration() - o._tTime) / -o._ts) && o.totalTime(o._tTime, !0), o = o.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && r < this._tDur || this._ts < 0 && r > 0 || !this._tDur && !r) && ps(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== r || !this._dur && !i || this._initted && Math.abs(this._zTime) === yn || !r && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = r), YD(this, r, i)), this;
  }, e.time = function(r, i) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), r + sk(this)) % (this._dur + this._rDelay) || (r ? this._dur : 0), i) : this._time;
  }, e.totalProgress = function(r, i) {
    return arguments.length ? this.totalTime(this.totalDuration() * r, i) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, e.progress = function(r, i) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - r : r) + sk(this), i) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(r, i) {
    var o = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (r - 1) * o, i) : this._repeat ? Ac(this._tTime, o) + 1 : 1;
  }, e.timeScale = function(r, i) {
    if (!arguments.length)
      return this._rts === -yn ? 0 : this._rts;
    if (this._rts === r)
      return this;
    var o = this.parent && this._ts ? Sm(this.parent._time, this) : this._tTime;
    return this._rts = +r || 0, this._ts = this._ps || r === -yn ? 0 : this._rts, this.totalTime(Ph(-Math.abs(this._delay), this._tDur, o), i !== !1), vy(this), vB(this);
  }, e.paused = function(r) {
    return arguments.length ? (this._ps !== r && (this._ps = r, r ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Oc(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== yn && (this._tTime -= yn)))), this) : this._ps;
  }, e.startTime = function(r) {
    if (arguments.length) {
      this._start = r;
      var i = this.parent || this._dp;
      return i && (i._sort || !this.parent) && ps(i, this, r - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(r) {
    return this._start + (Ri(r) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(r) {
    var i = this.parent || this._dp;
    return i ? r && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Sm(i.rawTime(r), this) : this._tTime : this._tTime;
  }, e.revert = function(r) {
    r === void 0 && (r = pB);
    var i = qr;
    return qr = r, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(r), this.totalTime(-0.01, r.suppressEvents)), this.data !== "nested" && r.kill !== !1 && this.kill(), qr = i, this;
  }, e.globalTime = function(r) {
    for (var i = this, o = arguments.length ? r : i.rawTime(); i; )
      o = i._start + o / (Math.abs(i._ts) || 1), i = i._dp;
    return !this.parent && this._sat ? this._sat.globalTime(r) : o;
  }, e.repeat = function(r) {
    return arguments.length ? (this._repeat = r === 1 / 0 ? -2 : r, ak(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(r) {
    if (arguments.length) {
      var i = this._time;
      return this._rDelay = r, ak(this), i ? this.time(i) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(r) {
    return arguments.length ? (this._yoyo = r, this) : this._yoyo;
  }, e.seek = function(r, i) {
    return this.totalTime(po(this, r), Ri(i));
  }, e.restart = function(r, i) {
    return this.play().totalTime(r ? -this._delay : 0, Ri(i)), this._dur || (this._zTime = -yn), this;
  }, e.play = function(r, i) {
    return r != null && this.seek(r, i), this.reversed(!1).paused(!1);
  }, e.reverse = function(r, i) {
    return r != null && this.seek(r || this.totalDuration(), i), this.reversed(!0).paused(!1);
  }, e.pause = function(r, i) {
    return r != null && this.seek(r, i), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(r) {
    return arguments.length ? (!!r !== this.reversed() && this.timeScale(-this._rts || (r ? -yn : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -yn, this;
  }, e.isActive = function() {
    var r = this.parent || this._dp, i = this._start, o;
    return !!(!r || this._ts && this._initted && r.isActive() && (o = r.rawTime(!0)) >= i && o < this.endTime(!0) - yn);
  }, e.eventCallback = function(r, i, o) {
    var s = this.vars;
    return arguments.length > 1 ? (i ? (s[r] = i, o && (s[r + "Params"] = o), r === "onUpdate" && (this._onUpdate = i)) : delete s[r], this) : s[r];
  }, e.then = function(r) {
    var i = this;
    return new Promise(function(o) {
      var s = Yn(r) ? r : KD, a = function() {
        var u = i.then;
        i.then = null, Yn(s) && (s = s(i)) && (s.then || s === i) && (i.then = u), o(s), i.then = u;
      };
      i._initted && i.totalProgress() === 1 && i._ts >= 0 || !i._tTime && i._ts < 0 ? a() : i._prom = a;
    });
  }, e.kill = function() {
    gd(this);
  }, t;
}();
ro(rh.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -yn,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var fi = /* @__PURE__ */ function(t) {
  FD(e, t);
  function e(r, i) {
    var o;
    return r === void 0 && (r = {}), o = t.call(this, r) || this, o.labels = {}, o.smoothChildTiming = !!r.smoothChildTiming, o.autoRemoveChildren = !!r.autoRemoveChildren, o._sort = Ri(r.sortChildren), Un && ps(r.parent || Un, Ws(o), i), r.reversed && o.reverse(), r.paused && o.paused(!0), r.scrollTrigger && ZD(Ws(o), r.scrollTrigger), o;
  }
  var n = e.prototype;
  return n.to = function(i, o, s) {
    return Id(0, arguments, this), this;
  }, n.from = function(i, o, s) {
    return Id(1, arguments, this), this;
  }, n.fromTo = function(i, o, s, a) {
    return Id(2, arguments, this), this;
  }, n.set = function(i, o, s) {
    return o.duration = 0, o.parent = this, Dd(o).repeatDelay || (o.repeat = 0), o.immediateRender = !!o.immediateRender, new lr(i, o, po(this, s), 1), this;
  }, n.call = function(i, o, s) {
    return ps(this, lr.delayedCall(0, i, o), s);
  }, n.staggerTo = function(i, o, s, a, l, u, c) {
    return s.duration = o, s.stagger = s.stagger || a, s.onComplete = u, s.onCompleteParams = c, s.parent = this, new lr(i, s, po(this, l)), this;
  }, n.staggerFrom = function(i, o, s, a, l, u, c) {
    return s.runBackwards = 1, Dd(s).immediateRender = Ri(s.immediateRender), this.staggerTo(i, o, s, a, l, u, c);
  }, n.staggerFromTo = function(i, o, s, a, l, u, c, f) {
    return a.startAt = s, Dd(a).immediateRender = Ri(a.immediateRender), this.staggerTo(i, o, a, l, u, c, f);
  }, n.render = function(i, o, s) {
    var a = this._time, l = this._dirty ? this.totalDuration() : this._tDur, u = this._dur, c = i <= 0 ? 0 : ur(i), f = this._zTime < 0 != i < 0 && (this._initted || !u), d, h, p, g, m, v, S, _, b, y, w, E;
    if (this !== Un && c > l && i >= 0 && (c = l), c !== this._tTime || s || f) {
      if (a !== this._time && u && (c += this._time - a, i += this._time - a), d = c, b = this._start, _ = this._ts, v = !_, f && (u || (a = this._zTime), (i || !o) && (this._zTime = i)), this._repeat) {
        if (w = this._yoyo, m = u + this._rDelay, this._repeat < -1 && i < 0)
          return this.totalTime(m * 100 + i, o, s);
        if (d = ur(c % m), c === l ? (g = this._repeat, d = u) : (y = ur(c / m), g = ~~y, g && g === y && (d = u, g--), d > u && (d = u)), y = Ac(this._tTime, m), !a && this._tTime && y !== g && this._tTime - y * m - this._dur <= 0 && (y = g), w && g & 1 && (d = u - d, E = 1), g !== y && !this._lock) {
          var x = w && y & 1, k = x === (w && g & 1);
          if (g < y && (x = !x), a = x ? 0 : c % u ? u : c, this._lock = 1, this.render(a || (E ? 0 : ur(g * m)), o, !u)._lock = 0, this._tTime = c, !o && this.parent && eo(this, "onRepeat"), this.vars.repeatRefresh && !E && (this.invalidate()._lock = 1), a && a !== this._time || v !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (u = this._dur, l = this._tDur, k && (this._lock = 2, a = x ? u : -1e-4, this.render(a, !0), this.vars.repeatRefresh && !E && this.invalidate()), this._lock = 0, !this._ts && !v)
            return this;
          pI(this, E);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (S = _B(this, ur(a), ur(d)), S && (c -= d - (d = S._start))), this._tTime = c, this._time = d, this._act = !_, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = i, a = 0), !a && d && !o && !g && (eo(this, "onStart"), this._tTime !== c))
        return this;
      if (d >= a && i >= 0)
        for (h = this._first; h; ) {
          if (p = h._next, (h._act || d >= h._start) && h._ts && S !== h) {
            if (h.parent !== this)
              return this.render(i, o, s);
            if (h.render(h._ts > 0 ? (d - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (d - h._start) * h._ts, o, s), d !== this._time || !this._ts && !v) {
              S = 0, p && (c += this._zTime = -yn);
              break;
            }
          }
          h = p;
        }
      else {
        h = this._last;
        for (var C = i < 0 ? i : d; h; ) {
          if (p = h._prev, (h._act || C <= h._end) && h._ts && S !== h) {
            if (h.parent !== this)
              return this.render(i, o, s);
            if (h.render(h._ts > 0 ? (C - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (C - h._start) * h._ts, o, s || qr && (h._initted || h._startAt)), d !== this._time || !this._ts && !v) {
              S = 0, p && (c += this._zTime = C ? -yn : yn);
              break;
            }
          }
          h = p;
        }
      }
      if (S && !o && (this.pause(), S.render(d >= a ? 0 : -yn)._zTime = d >= a ? 1 : -1, this._ts))
        return this._start = b, vy(this), this.render(i, o, s);
      this._onUpdate && !o && eo(this, "onUpdate", !0), (c === l && this._tTime >= this.totalDuration() || !c && a) && (b === this._start || Math.abs(_) !== Math.abs(this._ts)) && (this._lock || ((i || !u) && (c === l && this._ts > 0 || !c && this._ts < 0) && ol(this, 1), !o && !(i < 0 && !a) && (c || a || !l) && (eo(this, c === l && i >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(c < l && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, n.add = function(i, o) {
    var s = this;
    if (ha(o) || (o = po(this, o, i)), !(i instanceof rh)) {
      if (ti(i))
        return i.forEach(function(a) {
          return s.add(a, o);
        }), this;
      if (Mr(i))
        return this.addLabel(i, o);
      if (Yn(i))
        i = lr.delayedCall(0, i);
      else
        return this;
    }
    return this !== i ? ps(this, i, o) : this;
  }, n.getChildren = function(i, o, s, a) {
    i === void 0 && (i = !0), o === void 0 && (o = !0), s === void 0 && (s = !0), a === void 0 && (a = -So);
    for (var l = [], u = this._first; u; )
      u._start >= a && (u instanceof lr ? o && l.push(u) : (s && l.push(u), i && l.push.apply(l, u.getChildren(!0, o, s)))), u = u._next;
    return l;
  }, n.getById = function(i) {
    for (var o = this.getChildren(1, 1, 1), s = o.length; s--; )
      if (o[s].vars.id === i)
        return o[s];
  }, n.remove = function(i) {
    return Mr(i) ? this.removeLabel(i) : Yn(i) ? this.killTweensOf(i) : (i.parent === this && yy(this, i), i === this._recent && (this._recent = this._last), ru(this));
  }, n.totalTime = function(i, o) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = ur(Qi.time - (this._ts > 0 ? i / this._ts : (this.totalDuration() - i) / -this._ts))), t.prototype.totalTime.call(this, i, o), this._forcing = 0, this) : this._tTime;
  }, n.addLabel = function(i, o) {
    return this.labels[i] = po(this, o), this;
  }, n.removeLabel = function(i) {
    return delete this.labels[i], this;
  }, n.addPause = function(i, o, s) {
    var a = lr.delayedCall(0, o || eh, s);
    return a.data = "isPause", this._hasPause = 1, ps(this, a, po(this, i));
  }, n.removePause = function(i) {
    var o = this._first;
    for (i = po(this, i); o; )
      o._start === i && o.data === "isPause" && ol(o), o = o._next;
  }, n.killTweensOf = function(i, o, s) {
    for (var a = this.getTweensOf(i, s), l = a.length; l--; )
      Ba !== a[l] && a[l].kill(i, o);
    return this;
  }, n.getTweensOf = function(i, o) {
    for (var s = [], a = _o(i), l = this._first, u = ha(o), c; l; )
      l instanceof lr ? gB(l._targets, a) && (u ? (!Ba || l._initted && l._ts) && l.globalTime(0) <= o && l.globalTime(l.totalDuration()) > o : !o || l.isActive()) && s.push(l) : (c = l.getTweensOf(a, o)).length && s.push.apply(s, c), l = l._next;
    return s;
  }, n.tweenTo = function(i, o) {
    o = o || {};
    var s = this, a = po(s, i), l = o, u = l.startAt, c = l.onStart, f = l.onStartParams, d = l.immediateRender, h, p = lr.to(s, ro({
      ease: o.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: a,
      overwrite: "auto",
      duration: o.duration || Math.abs((a - (u && "time" in u ? u.time : s._time)) / s.timeScale()) || yn,
      onStart: function() {
        if (s.pause(), !h) {
          var m = o.duration || Math.abs((a - (u && "time" in u ? u.time : s._time)) / s.timeScale());
          p._dur !== m && Rc(p, m, 0, 1).render(p._time, !0, !0), h = 1;
        }
        c && c.apply(p, f || []);
      }
    }, o));
    return d ? p.render(0) : p;
  }, n.tweenFromTo = function(i, o, s) {
    return this.tweenTo(o, ro({
      startAt: {
        time: po(this, i)
      }
    }, s));
  }, n.recent = function() {
    return this._recent;
  }, n.nextLabel = function(i) {
    return i === void 0 && (i = this._time), lk(this, po(this, i));
  }, n.previousLabel = function(i) {
    return i === void 0 && (i = this._time), lk(this, po(this, i), 1);
  }, n.currentLabel = function(i) {
    return arguments.length ? this.seek(i, !0) : this.previousLabel(this._time + yn);
  }, n.shiftChildren = function(i, o, s) {
    s === void 0 && (s = 0);
    for (var a = this._first, l = this.labels, u; a; )
      a._start >= s && (a._start += i, a._end += i), a = a._next;
    if (o)
      for (u in l)
        l[u] >= s && (l[u] += i);
    return ru(this);
  }, n.invalidate = function(i) {
    var o = this._first;
    for (this._lock = 0; o; )
      o.invalidate(i), o = o._next;
    return t.prototype.invalidate.call(this, i);
  }, n.clear = function(i) {
    i === void 0 && (i = !0);
    for (var o = this._first, s; o; )
      s = o._next, this.remove(o), o = s;
    return this._dp && (this._time = this._tTime = this._pTime = 0), i && (this.labels = {}), ru(this);
  }, n.totalDuration = function(i) {
    var o = 0, s = this, a = s._last, l = So, u, c, f;
    if (arguments.length)
      return s.timeScale((s._repeat < 0 ? s.duration() : s.totalDuration()) / (s.reversed() ? -i : i));
    if (s._dirty) {
      for (f = s.parent; a; )
        u = a._prev, a._dirty && a.totalDuration(), c = a._start, c > l && s._sort && a._ts && !s._lock ? (s._lock = 1, ps(s, a, c - a._delay, 1)._lock = 0) : l = c, c < 0 && a._ts && (o -= c, (!f && !s._dp || f && f.smoothChildTiming) && (s._start += c / s._ts, s._time -= c, s._tTime -= c), s.shiftChildren(-c, !1, -1 / 0), l = 0), a._end > o && a._ts && (o = a._end), a = u;
      Rc(s, s === Un && s._time > o ? s._time : o, 1, 1), s._dirty = 0;
    }
    return s._tDur;
  }, e.updateRoot = function(i) {
    if (Un._ts && (YD(Un, Sm(i, Un)), GD = Qi.frame), Qi.frame >= ik) {
      ik += to.autoSleep || 120;
      var o = Un._first;
      if ((!o || !o._ts) && to.autoSleep && Qi._listeners.length < 2) {
        for (; o && !o._ts; )
          o = o._next;
        o || Qi.sleep();
      }
    }
  }, e;
}(rh);
ro(fi.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var LB = function(e, n, r, i, o, s, a) {
  var l = new Di(this._pt, e, n, 0, 1, _I, null, o), u = 0, c = 0, f, d, h, p, g, m, v, S;
  for (l.b = r, l.e = i, r += "", i += "", (v = ~i.indexOf("random(")) && (i = th(i)), s && (S = [r, i], s(S, e, n), r = S[0], i = S[1]), d = r.match(O0) || []; f = O0.exec(i); )
    p = f[0], g = i.substring(u, f.index), h ? h = (h + 1) % 5 : g.substr(-5) === "rgba(" && (h = 1), p !== d[c++] && (m = parseFloat(d[c - 1]) || 0, l._pt = {
      _next: l._pt,
      p: g || c === 1 ? g : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: m,
      c: p.charAt(1) === "=" ? cc(m, p) - m : parseFloat(p) - m,
      m: h && h < 4 ? Math.round : 0
    }, u = O0.lastIndex);
  return l.c = u < i.length ? i.substring(u, i.length) : "", l.fp = a, (VD.test(i) || v) && (l.e = 0), this._pt = l, l;
}, zS = function(e, n, r, i, o, s, a, l, u, c) {
  Yn(i) && (i = i(o || 0, e, s));
  var f = e[n], d = r !== "get" ? r : Yn(f) ? u ? e[n.indexOf("set") || !Yn(e["get" + n.substr(3)]) ? n : "get" + n.substr(3)](u) : e[n]() : f, h = Yn(f) ? u ? qB : wI : GS, p;
  if (Mr(i) && (~i.indexOf("random(") && (i = th(i)), i.charAt(1) === "=" && (p = cc(d, i) + (Qr(d) || 0), (p || p === 0) && (i = p))), !c || d !== i || N1)
    return !isNaN(d * i) && i !== "" ? (p = new Di(this._pt, e, n, +d || 0, i - (d || 0), typeof f == "boolean" ? HB : SI, 0, h), u && (p.fp = u), a && p.modifier(a, this, e), this._pt = p) : (!f && !(n in e) && jS(n, i), LB.call(this, e, n, d, i, h, l || to.stringFilter, u));
}, BB = function(e, n, r, i, o) {
  if (Yn(e) && (e = Nd(e, o, n, r, i)), !As(e) || e.style && e.nodeType || ti(e) || BD(e))
    return Mr(e) ? Nd(e, o, n, r, i) : e;
  var s = {}, a;
  for (a in e)
    s[a] = Nd(e[a], o, n, r, i);
  return s;
}, yI = function(e, n, r, i, o, s) {
  var a, l, u, c;
  if (Yi[e] && (a = new Yi[e]()).init(o, a.rawVars ? n[e] : BB(n[e], i, o, s, r), r, i, s) !== !1 && (r._pt = l = new Di(r._pt, o, e, 0, 1, a.render, a, 0, a.priority), r !== nc))
    for (u = r._ptLookup[r._targets.indexOf(o)], c = a._props.length; c--; )
      u[a._props[c]] = l;
  return a;
}, Ba, N1, HS = function t(e, n, r) {
  var i = e.vars, o = i.ease, s = i.startAt, a = i.immediateRender, l = i.lazy, u = i.onUpdate, c = i.runBackwards, f = i.yoyoEase, d = i.keyframes, h = i.autoRevert, p = e._dur, g = e._startAt, m = e._targets, v = e.parent, S = v && v.data === "nested" ? v.vars.targets : m, _ = e._overwrite === "auto" && !MS, b = e.timeline, y, w, E, x, k, C, M, F, U, B, N, q, Q;
  if (b && (!d || !o) && (o = "none"), e._ease = iu(o, xc.ease), e._yEase = f ? hI(iu(f === !0 ? o : f, xc.ease)) : 0, f && e._yoyo && !e._repeat && (f = e._yEase, e._yEase = e._ease, e._ease = f), e._from = !b && !!i.runBackwards, !b || d && !i.stagger) {
    if (F = m[0] ? nu(m[0]).harness : 0, q = F && i[F.prop], y = wm(i, VS), g && (g._zTime < 0 && g.progress(1), n < 0 && c && a && !h ? g.render(-1, !0) : g.revert(c && p ? $g : hB), g._lazy = 0), s) {
      if (ol(e._startAt = lr.set(m, ro({
        data: "isStart",
        overwrite: !1,
        parent: v,
        immediateRender: !0,
        lazy: !g && Ri(l),
        startAt: null,
        delay: 0,
        onUpdate: u && function() {
          return eo(e, "onUpdate");
        },
        stagger: 0
      }, s))), e._startAt._dp = 0, e._startAt._sat = e, n < 0 && (qr || !a && !h) && e._startAt.revert($g), a && p && n <= 0 && r <= 0) {
        n && (e._zTime = n);
        return;
      }
    } else if (c && p && !g) {
      if (n && (a = !1), E = ro({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: a && !g && Ri(l),
        immediateRender: a,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: v
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, y), q && (E[F.prop] = q), ol(e._startAt = lr.set(m, E)), e._startAt._dp = 0, e._startAt._sat = e, n < 0 && (qr ? e._startAt.revert($g) : e._startAt.render(-1, !0)), e._zTime = n, !a)
        t(e._startAt, yn, yn);
      else if (!n)
        return;
    }
    for (e._pt = e._ptCache = 0, l = p && Ri(l) || l && !p, w = 0; w < m.length; w++) {
      if (k = m[w], M = k._gsap || qS(m)[w]._gsap, e._ptLookup[w] = B = {}, C1[M.id] && el.length && bm(), N = S === m ? w : S.indexOf(k), F && (U = new F()).init(k, q || y, e, N, S) !== !1 && (e._pt = x = new Di(e._pt, k, U.name, 0, 1, U.render, U, 0, U.priority), U._props.forEach(function(ne) {
        B[ne] = x;
      }), U.priority && (C = 1)), !F || q)
        for (E in y)
          Yi[E] && (U = yI(E, y, e, N, k, S)) ? U.priority && (C = 1) : B[E] = x = zS.call(e, k, E, "get", y[E], N, S, 0, i.stringFilter);
      e._op && e._op[w] && e.kill(k, e._op[w]), _ && e._pt && (Ba = e, Un.killTweensOf(k, B, e.globalTime(n)), Q = !e.parent, Ba = 0), e._pt && l && (C1[M.id] = 1);
    }
    C && EI(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = u, e._initted = (!e._op || e._pt) && !Q, d && n <= 0 && b.render(So, !0, !0);
}, jB = function(e, n, r, i, o, s, a, l) {
  var u = (e._pt && e._ptCache || (e._ptCache = {}))[n], c, f, d, h;
  if (!u)
    for (u = e._ptCache[n] = [], d = e._ptLookup, h = e._targets.length; h--; ) {
      if (c = d[h][n], c && c.d && c.d._pt)
        for (c = c.d._pt; c && c.p !== n && c.fp !== n; )
          c = c._next;
      if (!c)
        return N1 = 1, e.vars[n] = "+=0", HS(e, a), N1 = 0, l ? Zd(n + " not eligible for reset") : 1;
      u.push(c);
    }
  for (h = u.length; h--; )
    f = u[h], c = f._pt || f, c.s = (i || i === 0) && !o ? i : c.s + (i || 0) + s * c.c, c.c = r - c.s, f.e && (f.e = Qn(r) + Qr(f.e)), f.b && (f.b = c.s + Qr(f.b));
}, VB = function(e, n) {
  var r = e[0] ? nu(e[0]).harness : 0, i = r && r.aliases, o, s, a, l;
  if (!i)
    return n;
  o = Cc({}, n);
  for (s in i)
    if (s in o)
      for (l = i[s].split(","), a = l.length; a--; )
        o[l[a]] = o[s];
  return o;
}, UB = function(e, n, r, i) {
  var o = n.ease || i || "power1.inOut", s, a;
  if (ti(n))
    a = r[e] || (r[e] = []), n.forEach(function(l, u) {
      return a.push({
        t: u / (n.length - 1) * 100,
        v: l,
        e: o
      });
    });
  else
    for (s in n)
      a = r[s] || (r[s] = []), s === "ease" || a.push({
        t: parseFloat(e),
        v: n[s],
        e: o
      });
}, Nd = function(e, n, r, i, o) {
  return Yn(e) ? e.call(n, r, i, o) : Mr(e) && ~e.indexOf("random(") ? th(e) : e;
}, vI = US + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", bI = {};
Oi(vI + ",id,stagger,delay,duration,paused,scrollTrigger", function(t) {
  return bI[t] = 1;
});
var lr = /* @__PURE__ */ function(t) {
  FD(e, t);
  function e(r, i, o, s) {
    var a;
    typeof i == "number" && (o.duration = i, i = o, o = null), a = t.call(this, s ? i : Dd(i)) || this;
    var l = a.vars, u = l.duration, c = l.delay, f = l.immediateRender, d = l.stagger, h = l.overwrite, p = l.keyframes, g = l.defaults, m = l.scrollTrigger, v = l.yoyoEase, S = i.parent || Un, _ = (ti(r) || BD(r) ? ha(r[0]) : "length" in i) ? [r] : _o(r), b, y, w, E, x, k, C, M;
    if (a._targets = _.length ? qS(_) : Zd("GSAP target " + r + " not found. https://gsap.com", !to.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = h, p || d || gp(u) || gp(c)) {
      if (i = a.vars, b = a.timeline = new fi({
        data: "nested",
        defaults: g || {},
        targets: S && S.data === "nested" ? S.vars.targets : _
      }), b.kill(), b.parent = b._dp = Ws(a), b._start = 0, d || gp(u) || gp(c)) {
        if (E = _.length, C = d && rI(d), As(d))
          for (x in d)
            ~vI.indexOf(x) && (M || (M = {}), M[x] = d[x]);
        for (y = 0; y < E; y++)
          w = wm(i, bI), w.stagger = 0, v && (w.yoyoEase = v), M && Cc(w, M), k = _[y], w.duration = +Nd(u, Ws(a), y, k, _), w.delay = (+Nd(c, Ws(a), y, k, _) || 0) - a._delay, !d && E === 1 && w.delay && (a._delay = c = w.delay, a._start += c, w.delay = 0), b.to(k, w, C ? C(y, k, _) : 0), b._ease = zt.none;
        b.duration() ? u = c = 0 : a.timeline = 0;
      } else if (p) {
        Dd(ro(b.vars.defaults, {
          ease: "none"
        })), b._ease = iu(p.ease || i.ease || "none");
        var F = 0, U, B, N;
        if (ti(p))
          p.forEach(function(q) {
            return b.to(_, q, ">");
          }), b.duration();
        else {
          w = {};
          for (x in p)
            x === "ease" || x === "easeEach" || UB(x, p[x], w, p.easeEach);
          for (x in w)
            for (U = w[x].sort(function(q, Q) {
              return q.t - Q.t;
            }), F = 0, y = 0; y < U.length; y++)
              B = U[y], N = {
                ease: B.e,
                duration: (B.t - (y ? U[y - 1].t : 0)) / 100 * u
              }, N[x] = B.v, b.to(_, N, F), F += N.duration;
          b.duration() < u && b.to({}, {
            duration: u - b.duration()
          });
        }
      }
      u || a.duration(u = b.duration());
    } else
      a.timeline = 0;
    return h === !0 && !MS && (Ba = Ws(a), Un.killTweensOf(_), Ba = 0), ps(S, Ws(a), o), i.reversed && a.reverse(), i.paused && a.paused(!0), (f || !u && !p && a._start === ur(S._time) && Ri(f) && bB(Ws(a)) && S.data !== "nested") && (a._tTime = -yn, a.render(Math.max(0, -c) || 0)), m && ZD(Ws(a), m), a;
  }
  var n = e.prototype;
  return n.render = function(i, o, s) {
    var a = this._time, l = this._tDur, u = this._dur, c = i < 0, f = i > l - yn && !c ? l : i < yn ? 0 : i, d, h, p, g, m, v, S, _, b;
    if (!u)
      SB(this, i, o, s);
    else if (f !== this._tTime || !i || s || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== c || this._lazy) {
      if (d = f, _ = this.timeline, this._repeat) {
        if (g = u + this._rDelay, this._repeat < -1 && c)
          return this.totalTime(g * 100 + i, o, s);
        if (d = ur(f % g), f === l ? (p = this._repeat, d = u) : (m = ur(f / g), p = ~~m, p && p === m ? (d = u, p--) : d > u && (d = u)), v = this._yoyo && p & 1, v && (b = this._yEase, d = u - d), m = Ac(this._tTime, g), d === a && !s && this._initted && p === m)
          return this._tTime = f, this;
        p !== m && (_ && this._yEase && pI(_, v), this.vars.repeatRefresh && !v && !this._lock && d !== g && this._initted && (this._lock = s = 1, this.render(ur(g * p), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (eI(this, c ? i : d, s, o, f))
          return this._tTime = 0, this;
        if (a !== this._time && !(s && this.vars.repeatRefresh && p !== m))
          return this;
        if (u !== this._dur)
          return this.render(i, o, s);
      }
      if (this._tTime = f, this._time = d, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = S = (b || this._ease)(d / u), this._from && (this.ratio = S = 1 - S), d && !a && !o && !p && (eo(this, "onStart"), this._tTime !== f))
        return this;
      for (h = this._pt; h; )
        h.r(S, h.d), h = h._next;
      _ && _.render(i < 0 ? i : _._dur * _._ease(d / this._dur), o, s) || this._startAt && (this._zTime = i), this._onUpdate && !o && (c && A1(this, i, o, s), eo(this, "onUpdate")), this._repeat && p !== m && this.vars.onRepeat && !o && this.parent && eo(this, "onRepeat"), (f === this._tDur || !f) && this._tTime === f && (c && !this._onUpdate && A1(this, i, !0, !0), (i || !u) && (f === this._tDur && this._ts > 0 || !f && this._ts < 0) && ol(this, 1), !o && !(c && !a) && (f || a || v) && (eo(this, f === l ? "onComplete" : "onReverseComplete", !0), this._prom && !(f < l && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, n.targets = function() {
    return this._targets;
  }, n.invalidate = function(i) {
    return (!i || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(i), t.prototype.invalidate.call(this, i);
  }, n.resetTo = function(i, o, s, a, l) {
    nh || Qi.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), c;
    return this._initted || HS(this, u), c = this._ease(u / this._dur), jB(this, i, o, s, a, c, u, l) ? this.resetTo(i, o, s, a, 1) : (by(this, 0), this.parent || QD(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, n.kill = function(i, o) {
    if (o === void 0 && (o = "all"), !i && (!o || o === "all"))
      return this._lazy = this._pt = 0, this.parent ? gd(this) : this.scrollTrigger && this.scrollTrigger.kill(!!qr), this;
    if (this.timeline) {
      var s = this.timeline.totalDuration();
      return this.timeline.killTweensOf(i, o, Ba && Ba.vars.overwrite !== !0)._first || gd(this), this.parent && s !== this.timeline.totalDuration() && Rc(this, this._dur * this.timeline._tDur / s, 0, 1), this;
    }
    var a = this._targets, l = i ? _o(i) : a, u = this._ptLookup, c = this._pt, f, d, h, p, g, m, v;
    if ((!o || o === "all") && yB(a, l))
      return o === "all" && (this._pt = 0), gd(this);
    for (f = this._op = this._op || [], o !== "all" && (Mr(o) && (g = {}, Oi(o, function(S) {
      return g[S] = 1;
    }), o = g), o = VB(a, o)), v = a.length; v--; )
      if (~l.indexOf(a[v])) {
        d = u[v], o === "all" ? (f[v] = o, p = d, h = {}) : (h = f[v] = f[v] || {}, p = o);
        for (g in p)
          m = d && d[g], m && ((!("kill" in m.d) || m.d.kill(g) === !0) && yy(this, m, "_pt"), delete d[g]), h !== "all" && (h[g] = 1);
      }
    return this._initted && !this._pt && c && gd(this), this;
  }, e.to = function(i, o) {
    return new e(i, o, arguments[2]);
  }, e.from = function(i, o) {
    return Id(1, arguments);
  }, e.delayedCall = function(i, o, s, a) {
    return new e(o, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: i,
      onComplete: o,
      onReverseComplete: o,
      onCompleteParams: s,
      onReverseCompleteParams: s,
      callbackScope: a
    });
  }, e.fromTo = function(i, o, s) {
    return Id(2, arguments);
  }, e.set = function(i, o) {
    return o.duration = 0, o.repeatDelay || (o.repeat = 0), new e(i, o);
  }, e.killTweensOf = function(i, o, s) {
    return Un.killTweensOf(i, o, s);
  }, e;
}(rh);
ro(lr.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Oi("staggerTo,staggerFrom,staggerFromTo", function(t) {
  lr[t] = function() {
    var e = new fi(), n = O1.call(arguments, 0);
    return n.splice(t === "staggerFromTo" ? 5 : 4, 0, 0), e[t].apply(e, n);
  };
});
var GS = function(e, n, r) {
  return e[n] = r;
}, wI = function(e, n, r) {
  return e[n](r);
}, qB = function(e, n, r, i) {
  return e[n](i.fp, r);
}, zB = function(e, n, r) {
  return e.setAttribute(n, r);
}, WS = function(e, n) {
  return Yn(e[n]) ? wI : FS(e[n]) && e.setAttribute ? zB : GS;
}, SI = function(e, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * e) * 1e6) / 1e6, n);
}, HB = function(e, n) {
  return n.set(n.t, n.p, !!(n.s + n.c * e), n);
}, _I = function(e, n) {
  var r = n._pt, i = "";
  if (!e && n.b)
    i = n.b;
  else if (e === 1 && n.e)
    i = n.e;
  else {
    for (; r; )
      i = r.p + (r.m ? r.m(r.s + r.c * e) : Math.round((r.s + r.c * e) * 1e4) / 1e4) + i, r = r._next;
    i += n.c;
  }
  n.set(n.t, n.p, i, n);
}, YS = function(e, n) {
  for (var r = n._pt; r; )
    r.r(e, r.d), r = r._next;
}, GB = function(e, n, r, i) {
  for (var o = this._pt, s; o; )
    s = o._next, o.p === i && o.modifier(e, n, r), o = s;
}, WB = function(e) {
  for (var n = this._pt, r, i; n; )
    i = n._next, n.p === e && !n.op || n.op === e ? yy(this, n, "_pt") : n.dep || (r = 1), n = i;
  return !r;
}, YB = function(e, n, r, i) {
  i.mSet(e, n, i.m.call(i.tween, r, i.mt), i);
}, EI = function(e) {
  for (var n = e._pt, r, i, o, s; n; ) {
    for (r = n._next, i = o; i && i.pr > n.pr; )
      i = i._next;
    (n._prev = i ? i._prev : s) ? n._prev._next = n : o = n, (n._next = i) ? i._prev = n : s = n, n = r;
  }
  e._pt = o;
}, Di = /* @__PURE__ */ function() {
  function t(n, r, i, o, s, a, l, u, c) {
    this.t = r, this.s = o, this.c = s, this.p = i, this.r = a || SI, this.d = l || this, this.set = u || GS, this.pr = c || 0, this._next = n, n && (n._prev = this);
  }
  var e = t.prototype;
  return e.modifier = function(r, i, o) {
    this.mSet = this.mSet || this.set, this.set = YB, this.m = r, this.mt = o, this.tween = i;
  }, t;
}();
Oi(US + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t) {
  return VS[t] = 1;
});
no.TweenMax = no.TweenLite = lr;
no.TimelineLite = no.TimelineMax = fi;
Un = new fi({
  sortChildren: !1,
  defaults: xc,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
to.stringFilter = dI;
var ou = [], Fg = {}, XB = [], ck = 0, KB = 0, $0 = function(e) {
  return (Fg[e] || XB).map(function(n) {
    return n();
  });
}, P1 = function() {
  var e = Date.now(), n = [];
  e - ck > 2 && ($0("matchMediaInit"), ou.forEach(function(r) {
    var i = r.queries, o = r.conditions, s, a, l, u;
    for (a in i)
      s = ls.matchMedia(i[a]).matches, s && (l = 1), s !== o[a] && (o[a] = s, u = 1);
    u && (r.revert(), l && n.push(r));
  }), $0("matchMediaRevert"), n.forEach(function(r) {
    return r.onMatch(r, function(i) {
      return r.add(null, i);
    });
  }), ck = e, $0("matchMedia"));
}, kI = /* @__PURE__ */ function() {
  function t(n, r) {
    this.selector = r && D1(r), this.data = [], this._r = [], this.isReverted = !1, this.id = KB++, n && this.add(n);
  }
  var e = t.prototype;
  return e.add = function(r, i, o) {
    Yn(r) && (o = i, i = r, r = Yn);
    var s = this, a = function() {
      var u = Fn, c = s.selector, f;
      return u && u !== s && u.data.push(s), o && (s.selector = D1(o)), Fn = s, f = i.apply(s, arguments), Yn(f) && s._r.push(f), Fn = u, s.selector = c, s.isReverted = !1, f;
    };
    return s.last = a, r === Yn ? a(s, function(l) {
      return s.add(null, l);
    }) : r ? s[r] = a : a;
  }, e.ignore = function(r) {
    var i = Fn;
    Fn = null, r(this), Fn = i;
  }, e.getTweens = function() {
    var r = [];
    return this.data.forEach(function(i) {
      return i instanceof t ? r.push.apply(r, i.getTweens()) : i instanceof lr && !(i.parent && i.parent.data === "nested") && r.push(i);
    }), r;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(r, i) {
    var o = this;
    if (r ? function() {
      for (var a = o.getTweens(), l = o.data.length, u; l--; )
        u = o.data[l], u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(c) {
          return a.splice(a.indexOf(c), 1);
        }));
      for (a.map(function(c) {
        return {
          g: c._dur || c._delay || c._sat && !c._sat.vars.immediateRender ? c.globalTime(0) : -1 / 0,
          t: c
        };
      }).sort(function(c, f) {
        return f.g - c.g || -1 / 0;
      }).forEach(function(c) {
        return c.t.revert(r);
      }), l = o.data.length; l--; )
        u = o.data[l], u instanceof fi ? u.data !== "nested" && (u.scrollTrigger && u.scrollTrigger.revert(), u.kill()) : !(u instanceof lr) && u.revert && u.revert(r);
      o._r.forEach(function(c) {
        return c(r, o);
      }), o.isReverted = !0;
    }() : this.data.forEach(function(a) {
      return a.kill && a.kill();
    }), this.clear(), i)
      for (var s = ou.length; s--; )
        ou[s].id === this.id && ou.splice(s, 1);
  }, e.revert = function(r) {
    this.kill(r || {});
  }, t;
}(), QB = /* @__PURE__ */ function() {
  function t(n) {
    this.contexts = [], this.scope = n, Fn && Fn.data.push(this);
  }
  var e = t.prototype;
  return e.add = function(r, i, o) {
    As(r) || (r = {
      matches: r
    });
    var s = new kI(0, o || this.scope), a = s.conditions = {}, l, u, c;
    Fn && !s.selector && (s.selector = Fn.selector), this.contexts.push(s), i = s.add("onMatch", i), s.queries = r;
    for (u in r)
      u === "all" ? c = 1 : (l = ls.matchMedia(r[u]), l && (ou.indexOf(s) < 0 && ou.push(s), (a[u] = l.matches) && (c = 1), l.addListener ? l.addListener(P1) : l.addEventListener("change", P1)));
    return c && i(s, function(f) {
      return s.add(null, f);
    }), this;
  }, e.revert = function(r) {
    this.kill(r || {});
  }, e.kill = function(r) {
    this.contexts.forEach(function(i) {
      return i.kill(r, !0);
    });
  }, t;
}(), _m = {
  registerPlugin: function() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    n.forEach(function(i) {
      return uI(i);
    });
  },
  timeline: function(e) {
    return new fi(e);
  },
  getTweensOf: function(e, n) {
    return Un.getTweensOf(e, n);
  },
  getProperty: function(e, n, r, i) {
    Mr(e) && (e = _o(e)[0]);
    var o = nu(e || {}).get, s = r ? KD : XD;
    return r === "native" && (r = ""), e && (n ? s((Yi[n] && Yi[n].get || o)(e, n, r, i)) : function(a, l, u) {
      return s((Yi[a] && Yi[a].get || o)(e, a, l, u));
    });
  },
  quickSetter: function(e, n, r) {
    if (e = _o(e), e.length > 1) {
      var i = e.map(function(c) {
        return Ni.quickSetter(c, n, r);
      }), o = i.length;
      return function(c) {
        for (var f = o; f--; )
          i[f](c);
      };
    }
    e = e[0] || {};
    var s = Yi[n], a = nu(e), l = a.harness && (a.harness.aliases || {})[n] || n, u = s ? function(c) {
      var f = new s();
      nc._pt = 0, f.init(e, r ? c + r : c, nc, 0, [e]), f.render(1, f), nc._pt && YS(1, nc);
    } : a.set(e, l);
    return s ? u : function(c) {
      return u(e, l, r ? c + r : c, a, 1);
    };
  },
  quickTo: function(e, n, r) {
    var i, o = Ni.to(e, ro((i = {}, i[n] = "+=0.1", i.paused = !0, i.stagger = 0, i), r || {})), s = function(l, u, c) {
      return o.resetTo(n, l, u, c);
    };
    return s.tween = o, s;
  },
  isTweening: function(e) {
    return Un.getTweensOf(e, !0).length > 0;
  },
  defaults: function(e) {
    return e && e.ease && (e.ease = iu(e.ease, xc.ease)), ok(xc, e || {});
  },
  config: function(e) {
    return ok(to, e || {});
  },
  registerEffect: function(e) {
    var n = e.name, r = e.effect, i = e.plugins, o = e.defaults, s = e.extendTimeline;
    (i || "").split(",").forEach(function(a) {
      return a && !Yi[a] && !no[a] && Zd(n + " effect requires " + a + " plugin.");
    }), D0[n] = function(a, l, u) {
      return r(_o(a), ro(l || {}, o), u);
    }, s && (fi.prototype[n] = function(a, l, u) {
      return this.add(D0[n](a, As(l) ? l : (u = l) && {}, this), u);
    });
  },
  registerEase: function(e, n) {
    zt[e] = iu(n);
  },
  parseEase: function(e, n) {
    return arguments.length ? iu(e, n) : zt;
  },
  getById: function(e) {
    return Un.getById(e);
  },
  exportRoot: function(e, n) {
    e === void 0 && (e = {});
    var r = new fi(e), i, o;
    for (r.smoothChildTiming = Ri(e.smoothChildTiming), Un.remove(r), r._dp = 0, r._time = r._tTime = Un._time, i = Un._first; i; )
      o = i._next, (n || !(!i._dur && i instanceof lr && i.vars.onComplete === i._targets[0])) && ps(r, i, i._start - i._delay), i = o;
    return ps(Un, r, 0), r;
  },
  context: function(e, n) {
    return e ? new kI(e, n) : Fn;
  },
  matchMedia: function(e) {
    return new QB(e);
  },
  matchMediaRefresh: function() {
    return ou.forEach(function(e) {
      var n = e.conditions, r, i;
      for (i in n)
        n[i] && (n[i] = !1, r = 1);
      r && e.revert();
    }) || P1();
  },
  addEventListener: function(e, n) {
    var r = Fg[e] || (Fg[e] = []);
    ~r.indexOf(n) || r.push(n);
  },
  removeEventListener: function(e, n) {
    var r = Fg[e], i = r && r.indexOf(n);
    i >= 0 && r.splice(i, 1);
  },
  utils: {
    wrap: RB,
    wrapYoyo: OB,
    distribute: rI,
    random: oI,
    snap: iI,
    normalize: AB,
    getUnit: Qr,
    clamp: kB,
    splitColor: cI,
    toArray: _o,
    selector: D1,
    mapRange: aI,
    pipe: xB,
    unitize: CB,
    interpolate: DB,
    shuffle: nI
  },
  install: zD,
  effects: D0,
  ticker: Qi,
  updateRoot: fi.updateRoot,
  plugins: Yi,
  globalTimeline: Un,
  core: {
    PropTween: Di,
    globals: HD,
    Tween: lr,
    Timeline: fi,
    Animation: rh,
    getCache: nu,
    _removeLinkedListItem: yy,
    reverting: function() {
      return qr;
    },
    context: function(e) {
      return e && Fn && (Fn.data.push(e), e._ctx = Fn), Fn;
    },
    suppressOverwrites: function(e) {
      return MS = e;
    }
  }
};
Oi("to,from,fromTo,delayedCall,set,killTweensOf", function(t) {
  return _m[t] = lr[t];
});
Qi.add(fi.updateRoot);
nc = _m.to({}, {
  duration: 0
});
var JB = function(e, n) {
  for (var r = e._pt; r && r.p !== n && r.op !== n && r.fp !== n; )
    r = r._next;
  return r;
}, ZB = function(e, n) {
  var r = e._targets, i, o, s;
  for (i in n)
    for (o = r.length; o--; )
      s = e._ptLookup[o][i], s && (s = s.d) && (s._pt && (s = JB(s, i)), s && s.modifier && s.modifier(n[i], e, r[o], i));
}, M0 = function(e, n) {
  return {
    name: e,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(i, o, s) {
      s._onInit = function(a) {
        var l, u;
        if (Mr(o) && (l = {}, Oi(o, function(c) {
          return l[c] = 1;
        }), o = l), n) {
          l = {};
          for (u in o)
            l[u] = n(o[u]);
          o = l;
        }
        ZB(a, o);
      };
    }
  };
}, Ni = _m.registerPlugin({
  name: "attr",
  init: function(e, n, r, i, o) {
    var s, a, l;
    this.tween = r;
    for (s in n)
      l = e.getAttribute(s) || "", a = this.add(e, "setAttribute", (l || 0) + "", n[s], i, o, 0, 0, s), a.op = s, a.b = l, this._props.push(s);
  },
  render: function(e, n) {
    for (var r = n._pt; r; )
      qr ? r.set(r.t, r.p, r.b, r) : r.r(e, r.d), r = r._next;
  }
}, {
  name: "endArray",
  init: function(e, n) {
    for (var r = n.length; r--; )
      this.add(e, r, e[r] || 0, n[r], 0, 0, 0, 0, 0, 1);
  }
}, M0("roundProps", I1), M0("modifiers"), M0("snap", iI)) || _m;
lr.version = fi.version = Ni.version = "3.12.7";
qD = 1;
LS() && Oc();
zt.Power0;
zt.Power1;
zt.Power2;
zt.Power3;
zt.Power4;
zt.Linear;
zt.Quad;
zt.Cubic;
zt.Quart;
zt.Quint;
zt.Strong;
zt.Elastic;
zt.Back;
zt.SteppedEase;
zt.Bounce;
zt.Sine;
zt.Expo;
zt.Circ;
/*!
 * CSSPlugin 3.12.7
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var fk, ja, fc, XS, Kl, dk, KS, e4 = function() {
  return typeof window < "u";
}, pa = {}, Ul = 180 / Math.PI, dc = Math.PI / 180, Lu = Math.atan2, hk = 1e8, QS = /([A-Z])/g, t4 = /(left|right|width|margin|padding|x)/i, n4 = /[\s,\(]\S/, ys = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, $1 = function(e, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u, n);
}, r4 = function(e, n) {
  return n.set(n.t, n.p, e === 1 ? n.e : Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u, n);
}, i4 = function(e, n) {
  return n.set(n.t, n.p, e ? Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u : n.b, n);
}, o4 = function(e, n) {
  var r = n.s + n.c * e;
  n.set(n.t, n.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + n.u, n);
}, TI = function(e, n) {
  return n.set(n.t, n.p, e ? n.e : n.b, n);
}, xI = function(e, n) {
  return n.set(n.t, n.p, e !== 1 ? n.b : n.e, n);
}, s4 = function(e, n, r) {
  return e.style[n] = r;
}, a4 = function(e, n, r) {
  return e.style.setProperty(n, r);
}, l4 = function(e, n, r) {
  return e._gsap[n] = r;
}, u4 = function(e, n, r) {
  return e._gsap.scaleX = e._gsap.scaleY = r;
}, c4 = function(e, n, r, i, o) {
  var s = e._gsap;
  s.scaleX = s.scaleY = r, s.renderTransform(o, s);
}, f4 = function(e, n, r, i, o) {
  var s = e._gsap;
  s[n] = r, s.renderTransform(o, s);
}, qn = "transform", Ii = qn + "Origin", d4 = function t(e, n) {
  var r = this, i = this.target, o = i.style, s = i._gsap;
  if (e in pa && o) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = ys[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(a) {
        return r.tfm[a] = Xs(i, a);
      }) : this.tfm[e] = s.x ? s[e] : Xs(i, e), e === Ii && (this.tfm.zOrigin = s.zOrigin);
    else
      return ys.transform.split(",").forEach(function(a) {
        return t.call(r, a, n);
      });
    if (this.props.indexOf(qn) >= 0)
      return;
    s.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(Ii, n, "")), e = qn;
  }
  (o || n) && this.props.push(e, n, o[e]);
}, CI = function(e) {
  e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, h4 = function() {
  var e = this.props, n = this.target, r = n.style, i = n._gsap, o, s;
  for (o = 0; o < e.length; o += 3)
    e[o + 1] ? e[o + 1] === 2 ? n[e[o]](e[o + 2]) : n[e[o]] = e[o + 2] : e[o + 2] ? r[e[o]] = e[o + 2] : r.removeProperty(e[o].substr(0, 2) === "--" ? e[o] : e[o].replace(QS, "-$1").toLowerCase());
  if (this.tfm) {
    for (s in this.tfm)
      i[s] = this.tfm[s];
    i.svg && (i.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), o = KS(), (!o || !o.isStart) && !r[qn] && (CI(r), i.zOrigin && r[Ii] && (r[Ii] += " " + i.zOrigin + "px", i.zOrigin = 0, i.renderTransform()), i.uncache = 1);
  }
}, AI = function(e, n) {
  var r = {
    target: e,
    props: [],
    revert: h4,
    save: d4
  };
  return e._gsap || Ni.core.getCache(e), n && e.style && e.nodeType && n.split(",").forEach(function(i) {
    return r.save(i);
  }), r;
}, RI, M1 = function(e, n) {
  var r = ja.createElementNS ? ja.createElementNS((n || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : ja.createElement(e);
  return r && r.style ? r : ja.createElement(e);
}, Ss = function t(e, n, r) {
  var i = getComputedStyle(e);
  return i[n] || i.getPropertyValue(n.replace(QS, "-$1").toLowerCase()) || i.getPropertyValue(n) || !r && t(e, Dc(n) || n, 1) || "";
}, pk = "O,Moz,ms,Ms,Webkit".split(","), Dc = function(e, n, r) {
  var i = n || Kl, o = i.style, s = 5;
  if (e in o && !r)
    return e;
  for (e = e.charAt(0).toUpperCase() + e.substr(1); s-- && !(pk[s] + e in o); )
    ;
  return s < 0 ? null : (s === 3 ? "ms" : s >= 0 ? pk[s] : "") + e;
}, F1 = function() {
  e4() && window.document && (fk = window, ja = fk.document, fc = ja.documentElement, Kl = M1("div") || {
    style: {}
  }, M1("div"), qn = Dc(qn), Ii = qn + "Origin", Kl.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", RI = !!Dc("perspective"), KS = Ni.core.reverting, XS = 1);
}, gk = function(e) {
  var n = e.ownerSVGElement, r = M1("svg", n && n.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), i = e.cloneNode(!0), o;
  i.style.display = "block", r.appendChild(i), fc.appendChild(r);
  try {
    o = i.getBBox();
  } catch {
  }
  return r.removeChild(i), fc.removeChild(r), o;
}, mk = function(e, n) {
  for (var r = n.length; r--; )
    if (e.hasAttribute(n[r]))
      return e.getAttribute(n[r]);
}, OI = function(e) {
  var n, r;
  try {
    n = e.getBBox();
  } catch {
    n = gk(e), r = 1;
  }
  return n && (n.width || n.height) || r || (n = gk(e)), n && !n.width && !n.x && !n.y ? {
    x: +mk(e, ["x", "cx", "x1"]) || 0,
    y: +mk(e, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : n;
}, DI = function(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && OI(e));
}, du = function(e, n) {
  if (n) {
    var r = e.style, i;
    n in pa && n !== Ii && (n = qn), r.removeProperty ? (i = n.substr(0, 2), (i === "ms" || n.substr(0, 6) === "webkit") && (n = "-" + n), r.removeProperty(i === "--" ? n : n.replace(QS, "-$1").toLowerCase())) : r.removeAttribute(n);
  }
}, Va = function(e, n, r, i, o, s) {
  var a = new Di(e._pt, n, r, 0, 1, s ? xI : TI);
  return e._pt = a, a.b = i, a.e = o, e._props.push(r), a;
}, yk = {
  deg: 1,
  rad: 1,
  turn: 1
}, p4 = {
  grid: 1,
  flex: 1
}, sl = function t(e, n, r, i) {
  var o = parseFloat(r) || 0, s = (r + "").trim().substr((o + "").length) || "px", a = Kl.style, l = t4.test(n), u = e.tagName.toLowerCase() === "svg", c = (u ? "client" : "offset") + (l ? "Width" : "Height"), f = 100, d = i === "px", h = i === "%", p, g, m, v;
  if (i === s || !o || yk[i] || yk[s])
    return o;
  if (s !== "px" && !d && (o = t(e, n, r, "px")), v = e.getCTM && DI(e), (h || s === "%") && (pa[n] || ~n.indexOf("adius")))
    return p = v ? e.getBBox()[l ? "width" : "height"] : e[c], Qn(h ? o / p * f : o / 100 * p);
  if (a[l ? "width" : "height"] = f + (d ? s : i), g = i !== "rem" && ~n.indexOf("adius") || i === "em" && e.appendChild && !u ? e : e.parentNode, v && (g = (e.ownerSVGElement || {}).parentNode), (!g || g === ja || !g.appendChild) && (g = ja.body), m = g._gsap, m && h && m.width && l && m.time === Qi.time && !m.uncache)
    return Qn(o / m.width * f);
  if (h && (n === "height" || n === "width")) {
    var S = e.style[n];
    e.style[n] = f + i, p = e[c], S ? e.style[n] = S : du(e, n);
  } else
    (h || s === "%") && !p4[Ss(g, "display")] && (a.position = Ss(e, "position")), g === e && (a.position = "static"), g.appendChild(Kl), p = Kl[c], g.removeChild(Kl), a.position = "absolute";
  return l && h && (m = nu(g), m.time = Qi.time, m.width = g[c]), Qn(d ? p * o / f : p && o ? f / p * o : 0);
}, Xs = function(e, n, r, i) {
  var o;
  return XS || F1(), n in ys && n !== "transform" && (n = ys[n], ~n.indexOf(",") && (n = n.split(",")[0])), pa[n] && n !== "transform" ? (o = oh(e, i), o = n !== "transformOrigin" ? o[n] : o.svg ? o.origin : km(Ss(e, Ii)) + " " + o.zOrigin + "px") : (o = e.style[n], (!o || o === "auto" || i || ~(o + "").indexOf("calc(")) && (o = Em[n] && Em[n](e, n, r) || Ss(e, n) || WD(e, n) || (n === "opacity" ? 1 : 0))), r && !~(o + "").trim().indexOf(" ") ? sl(e, n, o, r) + r : o;
}, g4 = function(e, n, r, i) {
  if (!r || r === "none") {
    var o = Dc(n, e, 1), s = o && Ss(e, o, 1);
    s && s !== r ? (n = o, r = s) : n === "borderColor" && (r = Ss(e, "borderTopColor"));
  }
  var a = new Di(this._pt, e.style, n, 0, 1, _I), l = 0, u = 0, c, f, d, h, p, g, m, v, S, _, b, y;
  if (a.b = r, a.e = i, r += "", i += "", i === "auto" && (g = e.style[n], e.style[n] = i, i = Ss(e, n) || i, g ? e.style[n] = g : du(e, n)), c = [r, i], dI(c), r = c[0], i = c[1], d = r.match(tc) || [], y = i.match(tc) || [], y.length) {
    for (; f = tc.exec(i); )
      m = f[0], S = i.substring(l, f.index), p ? p = (p + 1) % 5 : (S.substr(-5) === "rgba(" || S.substr(-5) === "hsla(") && (p = 1), m !== (g = d[u++] || "") && (h = parseFloat(g) || 0, b = g.substr((h + "").length), m.charAt(1) === "=" && (m = cc(h, m) + b), v = parseFloat(m), _ = m.substr((v + "").length), l = tc.lastIndex - _.length, _ || (_ = _ || to.units[n] || b, l === i.length && (i += _, a.e += _)), b !== _ && (h = sl(e, n, g, _) || 0), a._pt = {
        _next: a._pt,
        p: S || u === 1 ? S : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: h,
        c: v - h,
        m: p && p < 4 || n === "zIndex" ? Math.round : 0
      });
    a.c = l < i.length ? i.substring(l, i.length) : "";
  } else
    a.r = n === "display" && i === "none" ? xI : TI;
  return VD.test(i) && (a.e = 0), this._pt = a, a;
}, vk = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, m4 = function(e) {
  var n = e.split(" "), r = n[0], i = n[1] || "50%";
  return (r === "top" || r === "bottom" || i === "left" || i === "right") && (e = r, r = i, i = e), n[0] = vk[r] || r, n[1] = vk[i] || i, n.join(" ");
}, y4 = function(e, n) {
  if (n.tween && n.tween._time === n.tween._dur) {
    var r = n.t, i = r.style, o = n.u, s = r._gsap, a, l, u;
    if (o === "all" || o === !0)
      i.cssText = "", l = 1;
    else
      for (o = o.split(","), u = o.length; --u > -1; )
        a = o[u], pa[a] && (l = 1, a = a === "transformOrigin" ? Ii : qn), du(r, a);
    l && (du(r, qn), s && (s.svg && r.removeAttribute("transform"), i.scale = i.rotate = i.translate = "none", oh(r, 1), s.uncache = 1, CI(i)));
  }
}, Em = {
  clearProps: function(e, n, r, i, o) {
    if (o.data !== "isFromStart") {
      var s = e._pt = new Di(e._pt, n, r, 0, 0, y4);
      return s.u = i, s.pr = -10, s.tween = o, e._props.push(r), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, ih = [1, 0, 0, 1, 0, 0], II = {}, NI = function(e) {
  return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, bk = function(e) {
  var n = Ss(e, qn);
  return NI(n) ? ih : n.substr(7).match(jD).map(Qn);
}, JS = function(e, n) {
  var r = e._gsap || nu(e), i = e.style, o = bk(e), s, a, l, u;
  return r.svg && e.getAttribute("transform") ? (l = e.transform.baseVal.consolidate().matrix, o = [l.a, l.b, l.c, l.d, l.e, l.f], o.join(",") === "1,0,0,1,0,0" ? ih : o) : (o === ih && !e.offsetParent && e !== fc && !r.svg && (l = i.display, i.display = "block", s = e.parentNode, (!s || !e.offsetParent && !e.getBoundingClientRect().width) && (u = 1, a = e.nextElementSibling, fc.appendChild(e)), o = bk(e), l ? i.display = l : du(e, "display"), u && (a ? s.insertBefore(e, a) : s ? s.appendChild(e) : fc.removeChild(e))), n && o.length > 6 ? [o[0], o[1], o[4], o[5], o[12], o[13]] : o);
}, L1 = function(e, n, r, i, o, s) {
  var a = e._gsap, l = o || JS(e, !0), u = a.xOrigin || 0, c = a.yOrigin || 0, f = a.xOffset || 0, d = a.yOffset || 0, h = l[0], p = l[1], g = l[2], m = l[3], v = l[4], S = l[5], _ = n.split(" "), b = parseFloat(_[0]) || 0, y = parseFloat(_[1]) || 0, w, E, x, k;
  r ? l !== ih && (E = h * m - p * g) && (x = b * (m / E) + y * (-g / E) + (g * S - m * v) / E, k = b * (-p / E) + y * (h / E) - (h * S - p * v) / E, b = x, y = k) : (w = OI(e), b = w.x + (~_[0].indexOf("%") ? b / 100 * w.width : b), y = w.y + (~(_[1] || _[0]).indexOf("%") ? y / 100 * w.height : y)), i || i !== !1 && a.smooth ? (v = b - u, S = y - c, a.xOffset = f + (v * h + S * g) - v, a.yOffset = d + (v * p + S * m) - S) : a.xOffset = a.yOffset = 0, a.xOrigin = b, a.yOrigin = y, a.smooth = !!i, a.origin = n, a.originIsAbsolute = !!r, e.style[Ii] = "0px 0px", s && (Va(s, a, "xOrigin", u, b), Va(s, a, "yOrigin", c, y), Va(s, a, "xOffset", f, a.xOffset), Va(s, a, "yOffset", d, a.yOffset)), e.setAttribute("data-svg-origin", b + " " + y);
}, oh = function(e, n) {
  var r = e._gsap || new mI(e);
  if ("x" in r && !n && !r.uncache)
    return r;
  var i = e.style, o = r.scaleX < 0, s = "px", a = "deg", l = getComputedStyle(e), u = Ss(e, Ii) || "0", c, f, d, h, p, g, m, v, S, _, b, y, w, E, x, k, C, M, F, U, B, N, q, Q, ne, X, O, W, T, $, P, H;
  return c = f = d = g = m = v = S = _ = b = 0, h = p = 1, r.svg = !!(e.getCTM && DI(e)), l.translate && ((l.translate !== "none" || l.scale !== "none" || l.rotate !== "none") && (i[qn] = (l.translate !== "none" ? "translate3d(" + (l.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (l.rotate !== "none" ? "rotate(" + l.rotate + ") " : "") + (l.scale !== "none" ? "scale(" + l.scale.split(" ").join(",") + ") " : "") + (l[qn] !== "none" ? l[qn] : "")), i.scale = i.rotate = i.translate = "none"), E = JS(e, r.svg), r.svg && (r.uncache ? (ne = e.getBBox(), u = r.xOrigin - ne.x + "px " + (r.yOrigin - ne.y) + "px", Q = "") : Q = !n && e.getAttribute("data-svg-origin"), L1(e, Q || u, !!Q || r.originIsAbsolute, r.smooth !== !1, E)), y = r.xOrigin || 0, w = r.yOrigin || 0, E !== ih && (M = E[0], F = E[1], U = E[2], B = E[3], c = N = E[4], f = q = E[5], E.length === 6 ? (h = Math.sqrt(M * M + F * F), p = Math.sqrt(B * B + U * U), g = M || F ? Lu(F, M) * Ul : 0, S = U || B ? Lu(U, B) * Ul + g : 0, S && (p *= Math.abs(Math.cos(S * dc))), r.svg && (c -= y - (y * M + w * U), f -= w - (y * F + w * B))) : (H = E[6], $ = E[7], O = E[8], W = E[9], T = E[10], P = E[11], c = E[12], f = E[13], d = E[14], x = Lu(H, T), m = x * Ul, x && (k = Math.cos(-x), C = Math.sin(-x), Q = N * k + O * C, ne = q * k + W * C, X = H * k + T * C, O = N * -C + O * k, W = q * -C + W * k, T = H * -C + T * k, P = $ * -C + P * k, N = Q, q = ne, H = X), x = Lu(-U, T), v = x * Ul, x && (k = Math.cos(-x), C = Math.sin(-x), Q = M * k - O * C, ne = F * k - W * C, X = U * k - T * C, P = B * C + P * k, M = Q, F = ne, U = X), x = Lu(F, M), g = x * Ul, x && (k = Math.cos(x), C = Math.sin(x), Q = M * k + F * C, ne = N * k + q * C, F = F * k - M * C, q = q * k - N * C, M = Q, N = ne), m && Math.abs(m) + Math.abs(g) > 359.9 && (m = g = 0, v = 180 - v), h = Qn(Math.sqrt(M * M + F * F + U * U)), p = Qn(Math.sqrt(q * q + H * H)), x = Lu(N, q), S = Math.abs(x) > 2e-4 ? x * Ul : 0, b = P ? 1 / (P < 0 ? -P : P) : 0), r.svg && (Q = e.getAttribute("transform"), r.forceCSS = e.setAttribute("transform", "") || !NI(Ss(e, qn)), Q && e.setAttribute("transform", Q))), Math.abs(S) > 90 && Math.abs(S) < 270 && (o ? (h *= -1, S += g <= 0 ? 180 : -180, g += g <= 0 ? 180 : -180) : (p *= -1, S += S <= 0 ? 180 : -180)), n = n || r.uncache, r.x = c - ((r.xPercent = c && (!n && r.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-c) ? -50 : 0))) ? e.offsetWidth * r.xPercent / 100 : 0) + s, r.y = f - ((r.yPercent = f && (!n && r.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-f) ? -50 : 0))) ? e.offsetHeight * r.yPercent / 100 : 0) + s, r.z = d + s, r.scaleX = Qn(h), r.scaleY = Qn(p), r.rotation = Qn(g) + a, r.rotationX = Qn(m) + a, r.rotationY = Qn(v) + a, r.skewX = S + a, r.skewY = _ + a, r.transformPerspective = b + s, (r.zOrigin = parseFloat(u.split(" ")[2]) || !n && r.zOrigin || 0) && (i[Ii] = km(u)), r.xOffset = r.yOffset = 0, r.force3D = to.force3D, r.renderTransform = r.svg ? b4 : RI ? PI : v4, r.uncache = 0, r;
}, km = function(e) {
  return (e = e.split(" "))[0] + " " + e[1];
}, F0 = function(e, n, r) {
  var i = Qr(n);
  return Qn(parseFloat(n) + parseFloat(sl(e, "x", r + "px", i))) + i;
}, v4 = function(e, n) {
  n.z = "0px", n.rotationY = n.rotationX = "0deg", n.force3D = 0, PI(e, n);
}, Cl = "0deg", Df = "0px", Al = ") ", PI = function(e, n) {
  var r = n || this, i = r.xPercent, o = r.yPercent, s = r.x, a = r.y, l = r.z, u = r.rotation, c = r.rotationY, f = r.rotationX, d = r.skewX, h = r.skewY, p = r.scaleX, g = r.scaleY, m = r.transformPerspective, v = r.force3D, S = r.target, _ = r.zOrigin, b = "", y = v === "auto" && e && e !== 1 || v === !0;
  if (_ && (f !== Cl || c !== Cl)) {
    var w = parseFloat(c) * dc, E = Math.sin(w), x = Math.cos(w), k;
    w = parseFloat(f) * dc, k = Math.cos(w), s = F0(S, s, E * k * -_), a = F0(S, a, -Math.sin(w) * -_), l = F0(S, l, x * k * -_ + _);
  }
  m !== Df && (b += "perspective(" + m + Al), (i || o) && (b += "translate(" + i + "%, " + o + "%) "), (y || s !== Df || a !== Df || l !== Df) && (b += l !== Df || y ? "translate3d(" + s + ", " + a + ", " + l + ") " : "translate(" + s + ", " + a + Al), u !== Cl && (b += "rotate(" + u + Al), c !== Cl && (b += "rotateY(" + c + Al), f !== Cl && (b += "rotateX(" + f + Al), (d !== Cl || h !== Cl) && (b += "skew(" + d + ", " + h + Al), (p !== 1 || g !== 1) && (b += "scale(" + p + ", " + g + Al), S.style[qn] = b || "translate(0, 0)";
}, b4 = function(e, n) {
  var r = n || this, i = r.xPercent, o = r.yPercent, s = r.x, a = r.y, l = r.rotation, u = r.skewX, c = r.skewY, f = r.scaleX, d = r.scaleY, h = r.target, p = r.xOrigin, g = r.yOrigin, m = r.xOffset, v = r.yOffset, S = r.forceCSS, _ = parseFloat(s), b = parseFloat(a), y, w, E, x, k;
  l = parseFloat(l), u = parseFloat(u), c = parseFloat(c), c && (c = parseFloat(c), u += c, l += c), l || u ? (l *= dc, u *= dc, y = Math.cos(l) * f, w = Math.sin(l) * f, E = Math.sin(l - u) * -d, x = Math.cos(l - u) * d, u && (c *= dc, k = Math.tan(u - c), k = Math.sqrt(1 + k * k), E *= k, x *= k, c && (k = Math.tan(c), k = Math.sqrt(1 + k * k), y *= k, w *= k)), y = Qn(y), w = Qn(w), E = Qn(E), x = Qn(x)) : (y = f, x = d, w = E = 0), (_ && !~(s + "").indexOf("px") || b && !~(a + "").indexOf("px")) && (_ = sl(h, "x", s, "px"), b = sl(h, "y", a, "px")), (p || g || m || v) && (_ = Qn(_ + p - (p * y + g * E) + m), b = Qn(b + g - (p * w + g * x) + v)), (i || o) && (k = h.getBBox(), _ = Qn(_ + i / 100 * k.width), b = Qn(b + o / 100 * k.height)), k = "matrix(" + y + "," + w + "," + E + "," + x + "," + _ + "," + b + ")", h.setAttribute("transform", k), S && (h.style[qn] = k);
}, w4 = function(e, n, r, i, o) {
  var s = 360, a = Mr(o), l = parseFloat(o) * (a && ~o.indexOf("rad") ? Ul : 1), u = l - i, c = i + u + "deg", f, d;
  return a && (f = o.split("_")[1], f === "short" && (u %= s, u !== u % (s / 2) && (u += u < 0 ? s : -s)), f === "cw" && u < 0 ? u = (u + s * hk) % s - ~~(u / s) * s : f === "ccw" && u > 0 && (u = (u - s * hk) % s - ~~(u / s) * s)), e._pt = d = new Di(e._pt, n, r, i, u, r4), d.e = c, d.u = "deg", e._props.push(r), d;
}, wk = function(e, n) {
  for (var r in n)
    e[r] = n[r];
  return e;
}, S4 = function(e, n, r) {
  var i = wk({}, r._gsap), o = "perspective,force3D,transformOrigin,svgOrigin", s = r.style, a, l, u, c, f, d, h, p;
  i.svg ? (u = r.getAttribute("transform"), r.setAttribute("transform", ""), s[qn] = n, a = oh(r, 1), du(r, qn), r.setAttribute("transform", u)) : (u = getComputedStyle(r)[qn], s[qn] = n, a = oh(r, 1), s[qn] = u);
  for (l in pa)
    u = i[l], c = a[l], u !== c && o.indexOf(l) < 0 && (h = Qr(u), p = Qr(c), f = h !== p ? sl(r, l, u, p) : parseFloat(u), d = parseFloat(c), e._pt = new Di(e._pt, a, l, f, d - f, $1), e._pt.u = p || 0, e._props.push(l));
  wk(a, i);
};
Oi("padding,margin,Width,Radius", function(t, e) {
  var n = "Top", r = "Right", i = "Bottom", o = "Left", s = (e < 3 ? [n, r, i, o] : [n + o, n + r, i + r, i + o]).map(function(a) {
    return e < 2 ? t + a : "border" + a + t;
  });
  Em[e > 1 ? "border" + t : t] = function(a, l, u, c, f) {
    var d, h;
    if (arguments.length < 4)
      return d = s.map(function(p) {
        return Xs(a, p, u);
      }), h = d.join(" "), h.split(d[0]).length === 5 ? d[0] : h;
    d = (c + "").split(" "), h = {}, s.forEach(function(p, g) {
      return h[p] = d[g] = d[g] || d[(g - 1) / 2 | 0];
    }), a.init(l, h, f);
  };
});
var $I = {
  name: "css",
  register: F1,
  targetTest: function(e) {
    return e.style && e.nodeType;
  },
  init: function(e, n, r, i, o) {
    var s = this._props, a = e.style, l = r.vars.startAt, u, c, f, d, h, p, g, m, v, S, _, b, y, w, E, x;
    XS || F1(), this.styles = this.styles || AI(e), x = this.styles.props, this.tween = r;
    for (g in n)
      if (g !== "autoRound" && (c = n[g], !(Yi[g] && yI(g, n, r, i, e, o)))) {
        if (h = typeof c, p = Em[g], h === "function" && (c = c.call(r, i, e, o), h = typeof c), h === "string" && ~c.indexOf("random(") && (c = th(c)), p)
          p(this, e, g, c, r) && (E = 1);
        else if (g.substr(0, 2) === "--")
          u = (getComputedStyle(e).getPropertyValue(g) + "").trim(), c += "", tl.lastIndex = 0, tl.test(u) || (m = Qr(u), v = Qr(c)), v ? m !== v && (u = sl(e, g, u, v) + v) : m && (c += m), this.add(a, "setProperty", u, c, i, o, 0, 0, g), s.push(g), x.push(g, 0, a[g]);
        else if (h !== "undefined") {
          if (l && g in l ? (u = typeof l[g] == "function" ? l[g].call(r, i, e, o) : l[g], Mr(u) && ~u.indexOf("random(") && (u = th(u)), Qr(u + "") || u === "auto" || (u += to.units[g] || Qr(Xs(e, g)) || ""), (u + "").charAt(1) === "=" && (u = Xs(e, g))) : u = Xs(e, g), d = parseFloat(u), S = h === "string" && c.charAt(1) === "=" && c.substr(0, 2), S && (c = c.substr(2)), f = parseFloat(c), g in ys && (g === "autoAlpha" && (d === 1 && Xs(e, "visibility") === "hidden" && f && (d = 0), x.push("visibility", 0, a.visibility), Va(this, a, "visibility", d ? "inherit" : "hidden", f ? "inherit" : "hidden", !f)), g !== "scale" && g !== "transform" && (g = ys[g], ~g.indexOf(",") && (g = g.split(",")[0]))), _ = g in pa, _) {
            if (this.styles.save(g), b || (y = e._gsap, y.renderTransform && !n.parseTransform || oh(e, n.parseTransform), w = n.smoothOrigin !== !1 && y.smooth, b = this._pt = new Di(this._pt, a, qn, 0, 1, y.renderTransform, y, 0, -1), b.dep = 1), g === "scale")
              this._pt = new Di(this._pt, y, "scaleY", y.scaleY, (S ? cc(y.scaleY, S + f) : f) - y.scaleY || 0, $1), this._pt.u = 0, s.push("scaleY", g), g += "X";
            else if (g === "transformOrigin") {
              x.push(Ii, 0, a[Ii]), c = m4(c), y.svg ? L1(e, c, 0, w, 0, this) : (v = parseFloat(c.split(" ")[2]) || 0, v !== y.zOrigin && Va(this, y, "zOrigin", y.zOrigin, v), Va(this, a, g, km(u), km(c)));
              continue;
            } else if (g === "svgOrigin") {
              L1(e, c, 1, w, 0, this);
              continue;
            } else if (g in II) {
              w4(this, y, g, d, S ? cc(d, S + c) : c);
              continue;
            } else if (g === "smoothOrigin") {
              Va(this, y, "smooth", y.smooth, c);
              continue;
            } else if (g === "force3D") {
              y[g] = c;
              continue;
            } else if (g === "transform") {
              S4(this, c, e);
              continue;
            }
          } else g in a || (g = Dc(g) || g);
          if (_ || (f || f === 0) && (d || d === 0) && !n4.test(c) && g in a)
            m = (u + "").substr((d + "").length), f || (f = 0), v = Qr(c) || (g in to.units ? to.units[g] : m), m !== v && (d = sl(e, g, u, v)), this._pt = new Di(this._pt, _ ? y : a, g, d, (S ? cc(d, S + f) : f) - d, !_ && (v === "px" || g === "zIndex") && n.autoRound !== !1 ? o4 : $1), this._pt.u = v || 0, m !== v && v !== "%" && (this._pt.b = u, this._pt.r = i4);
          else if (g in a)
            g4.call(this, e, g, u, S ? S + c : c);
          else if (g in e)
            this.add(e, g, u || e[g], S ? S + c : c, i, o);
          else if (g !== "parseTransform") {
            jS(g, c);
            continue;
          }
          _ || (g in a ? x.push(g, 0, a[g]) : typeof e[g] == "function" ? x.push(g, 2, e[g]()) : x.push(g, 1, u || e[g])), s.push(g);
        }
      }
    E && EI(this);
  },
  render: function(e, n) {
    if (n.tween._time || !KS())
      for (var r = n._pt; r; )
        r.r(e, r.d), r = r._next;
    else
      n.styles.revert();
  },
  get: Xs,
  aliases: ys,
  getSetter: function(e, n, r) {
    var i = ys[n];
    return i && i.indexOf(",") < 0 && (n = i), n in pa && n !== Ii && (e._gsap.x || Xs(e, "x")) ? r && dk === r ? n === "scale" ? u4 : l4 : (dk = r || {}) && (n === "scale" ? c4 : f4) : e.style && !FS(e.style[n]) ? s4 : ~n.indexOf("-") ? a4 : WS(e, n);
  },
  core: {
    _removeProperty: du,
    _getMatrix: JS
  }
};
Ni.utils.checkPrefix = Dc;
Ni.core.getStyleSaver = AI;
(function(t, e, n, r) {
  var i = Oi(t + "," + e + "," + n, function(o) {
    pa[o] = 1;
  });
  Oi(e, function(o) {
    to.units[o] = "deg", II[o] = 1;
  }), ys[i[13]] = t + "," + e, Oi(r, function(o) {
    var s = o.split(":");
    ys[s[1]] = i[s[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Oi("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t) {
  to.units[t] = "px";
});
Ni.registerPlugin($I);
var Pe = Ni.registerPlugin($I) || Ni;
Pe.core.Tween;
function _4(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function E4(t, e, n) {
  return e && _4(t.prototype, e), t;
}
/*!
 * Observer 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var Vr, Lg, Ji, Ua, qa, hc, MI, ql, Pd, FI, ra, Vo, LI, BI = function() {
  return Vr || typeof window < "u" && (Vr = window.gsap) && Vr.registerPlugin && Vr;
}, jI = 1, rc = [], Bt = [], _s = [], $d = Date.now, B1 = function(e, n) {
  return n;
}, k4 = function() {
  var e = Pd.core, n = e.bridge || {}, r = e._scrollers, i = e._proxies;
  r.push.apply(r, Bt), i.push.apply(i, _s), Bt = r, _s = i, B1 = function(s, a) {
    return n[s](a);
  };
}, nl = function(e, n) {
  return ~_s.indexOf(e) && _s[_s.indexOf(e) + 1][n];
}, Md = function(e) {
  return !!~FI.indexOf(e);
}, si = function(e, n, r, i, o) {
  return e.addEventListener(n, r, {
    passive: i !== !1,
    capture: !!o
  });
}, ri = function(e, n, r, i) {
  return e.removeEventListener(n, r, !!i);
}, mp = "scrollLeft", yp = "scrollTop", j1 = function() {
  return ra && ra.isPressed || Bt.cache++;
}, Tm = function(e, n) {
  var r = function i(o) {
    if (o || o === 0) {
      jI && (Ji.history.scrollRestoration = "manual");
      var s = ra && ra.isPressed;
      o = i.v = Math.round(o) || (ra && ra.iOS ? 1 : 0), e(o), i.cacheID = Bt.cache, s && B1("ss", o);
    } else (n || Bt.cache !== i.cacheID || B1("ref")) && (i.cacheID = Bt.cache, i.v = e());
    return i.v + i.offset;
  };
  return r.offset = 0, e && r;
}, di = {
  s: mp,
  p: "left",
  p2: "Left",
  os: "right",
  os2: "Right",
  d: "width",
  d2: "Width",
  a: "x",
  sc: Tm(function(t) {
    return arguments.length ? Ji.scrollTo(t, br.sc()) : Ji.pageXOffset || Ua[mp] || qa[mp] || hc[mp] || 0;
  })
}, br = {
  s: yp,
  p: "top",
  p2: "Top",
  os: "bottom",
  os2: "Bottom",
  d: "height",
  d2: "Height",
  a: "y",
  op: di,
  sc: Tm(function(t) {
    return arguments.length ? Ji.scrollTo(di.sc(), t) : Ji.pageYOffset || Ua[yp] || qa[yp] || hc[yp] || 0;
  })
}, ki = function(e, n) {
  return (n && n._ctx && n._ctx.selector || Vr.utils.toArray)(e)[0] || (typeof e == "string" && Vr.config().nullTargetWarn !== !1 ? console.warn("Element not found:", e) : null);
}, al = function(e, n) {
  var r = n.s, i = n.sc;
  Md(e) && (e = Ua.scrollingElement || qa);
  var o = Bt.indexOf(e), s = i === br.sc ? 1 : 2;
  !~o && (o = Bt.push(e) - 1), Bt[o + s] || si(e, "scroll", j1);
  var a = Bt[o + s], l = a || (Bt[o + s] = Tm(nl(e, r), !0) || (Md(e) ? i : Tm(function(u) {
    return arguments.length ? e[r] = u : e[r];
  })));
  return l.target = e, a || (l.smooth = Vr.getProperty(e, "scrollBehavior") === "smooth"), l;
}, V1 = function(e, n, r) {
  var i = e, o = e, s = $d(), a = s, l = n || 50, u = Math.max(500, l * 3), c = function(p, g) {
    var m = $d();
    g || m - s > l ? (o = i, i = p, a = s, s = m) : r ? i += p : i = o + (p - o) / (m - a) * (s - a);
  }, f = function() {
    o = i = r ? 0 : i, a = s = 0;
  }, d = function(p) {
    var g = a, m = o, v = $d();
    return (p || p === 0) && p !== i && c(p), s === a || v - a > u ? 0 : (i + (r ? m : -m)) / ((r ? v : s) - g) * 1e3;
  };
  return {
    update: c,
    reset: f,
    getVelocity: d
  };
}, If = function(e, n) {
  return n && !e._gsapAllow && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e;
}, Sk = function(e) {
  var n = Math.max.apply(Math, e), r = Math.min.apply(Math, e);
  return Math.abs(n) >= Math.abs(r) ? n : r;
}, VI = function() {
  Pd = Vr.core.globals().ScrollTrigger, Pd && Pd.core && k4();
}, UI = function(e) {
  return Vr = e || BI(), !Lg && Vr && typeof document < "u" && document.body && (Ji = window, Ua = document, qa = Ua.documentElement, hc = Ua.body, FI = [Ji, Ua, qa, hc], Vr.utils.clamp, LI = Vr.core.context || function() {
  }, ql = "onpointerenter" in hc ? "pointer" : "mouse", MI = Jn.isTouch = Ji.matchMedia && Ji.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in Ji || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0, Vo = Jn.eventTypes = ("ontouchstart" in qa ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in qa ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout(function() {
    return jI = 0;
  }, 500), VI(), Lg = 1), Lg;
};
di.op = br;
Bt.cache = 0;
var Jn = /* @__PURE__ */ function() {
  function t(n) {
    this.init(n);
  }
  var e = t.prototype;
  return e.init = function(r) {
    Lg || UI(Vr) || console.warn("Please gsap.registerPlugin(Observer)"), Pd || VI();
    var i = r.tolerance, o = r.dragMinimum, s = r.type, a = r.target, l = r.lineHeight, u = r.debounce, c = r.preventDefault, f = r.onStop, d = r.onStopDelay, h = r.ignore, p = r.wheelSpeed, g = r.event, m = r.onDragStart, v = r.onDragEnd, S = r.onDrag, _ = r.onPress, b = r.onRelease, y = r.onRight, w = r.onLeft, E = r.onUp, x = r.onDown, k = r.onChangeX, C = r.onChangeY, M = r.onChange, F = r.onToggleX, U = r.onToggleY, B = r.onHover, N = r.onHoverEnd, q = r.onMove, Q = r.ignoreCheck, ne = r.isNormalizer, X = r.onGestureStart, O = r.onGestureEnd, W = r.onWheel, T = r.onEnable, $ = r.onDisable, P = r.onClick, H = r.scrollSpeed, Z = r.capture, le = r.allowClicks, J = r.lockAxis, ue = r.onLockAxis;
    this.target = a = ki(a) || qa, this.vars = r, h && (h = Vr.utils.toArray(h)), i = i || 1e-9, o = o || 0, p = p || 1, H = H || 1, s = s || "wheel,touch,pointer", u = u !== !1, l || (l = parseFloat(Ji.getComputedStyle(hc).lineHeight) || 22);
    var he, me, oe, re, se, ae, fe, Y = this, Re = 0, ee = 0, Ye = r.passive || !c && r.passive !== !1, Te = al(a, di), ve = al(a, br), Oe = Te(), Je = ve(), pt = ~s.indexOf("touch") && !~s.indexOf("pointer") && Vo[0] === "pointerdown", Pt = Md(a), bt = a.ownerDocument || Ua, Ft = [0, 0, 0], mt = [0, 0, 0], ln = 0, jn = function() {
      return ln = $d();
    }, $t = function(ze, dt) {
      return (Y.event = ze) && h && ~h.indexOf(ze.target) || dt && pt && ze.pointerType !== "touch" || Q && Q(ze, dt);
    }, Tr = function() {
      Y._vx.reset(), Y._vy.reset(), me.pause(), f && f(Y);
    }, xr = function() {
      var ze = Y.deltaX = Sk(Ft), dt = Y.deltaY = Sk(mt), Ce = Math.abs(ze) >= i, Ze = Math.abs(dt) >= i;
      M && (Ce || Ze) && M(Y, ze, dt, Ft, mt), Ce && (y && Y.deltaX > 0 && y(Y), w && Y.deltaX < 0 && w(Y), k && k(Y), F && Y.deltaX < 0 != Re < 0 && F(Y), Re = Y.deltaX, Ft[0] = Ft[1] = Ft[2] = 0), Ze && (x && Y.deltaY > 0 && x(Y), E && Y.deltaY < 0 && E(Y), C && C(Y), U && Y.deltaY < 0 != ee < 0 && U(Y), ee = Y.deltaY, mt[0] = mt[1] = mt[2] = 0), (re || oe) && (q && q(Y), oe && (m && oe === 1 && m(Y), S && S(Y), oe = 0), re = !1), ae && !(ae = !1) && ue && ue(Y), se && (W(Y), se = !1), he = 0;
    }, ce = function(ze, dt, Ce) {
      Ft[Ce] += ze, mt[Ce] += dt, Y._vx.update(ze), Y._vy.update(dt), u ? he || (he = requestAnimationFrame(xr)) : xr();
    }, ie = function(ze, dt) {
      J && !fe && (Y.axis = fe = Math.abs(ze) > Math.abs(dt) ? "x" : "y", ae = !0), fe !== "y" && (Ft[2] += ze, Y._vx.update(ze, !0)), fe !== "x" && (mt[2] += dt, Y._vy.update(dt, !0)), u ? he || (he = requestAnimationFrame(xr)) : xr();
    }, ke = function(ze) {
      if (!$t(ze, 1)) {
        ze = If(ze, c);
        var dt = ze.clientX, Ce = ze.clientY, Ze = dt - Y.x, Ge = Ce - Y.y, ct = Y.isDragging;
        Y.x = dt, Y.y = Ce, (ct || (Ze || Ge) && (Math.abs(Y.startX - dt) >= o || Math.abs(Y.startY - Ce) >= o)) && (oe = ct ? 2 : 1, ct || (Y.isDragging = !0), ie(Ze, Ge));
      }
    }, Ae = Y.onPress = function(qe) {
      $t(qe, 1) || qe && qe.button || (Y.axis = fe = null, me.pause(), Y.isPressed = !0, qe = If(qe), Re = ee = 0, Y.startX = Y.x = qe.clientX, Y.startY = Y.y = qe.clientY, Y._vx.reset(), Y._vy.reset(), si(ne ? a : bt, Vo[1], ke, Ye, !0), Y.deltaX = Y.deltaY = 0, _ && _(Y));
    }, we = Y.onRelease = function(qe) {
      if (!$t(qe, 1)) {
        ri(ne ? a : bt, Vo[1], ke, !0);
        var ze = !isNaN(Y.y - Y.startY), dt = Y.isDragging, Ce = dt && (Math.abs(Y.x - Y.startX) > 3 || Math.abs(Y.y - Y.startY) > 3), Ze = If(qe);
        !Ce && ze && (Y._vx.reset(), Y._vy.reset(), c && le && Vr.delayedCall(0.08, function() {
          if ($d() - ln > 300 && !qe.defaultPrevented) {
            if (qe.target.click)
              qe.target.click();
            else if (bt.createEvent) {
              var Ge = bt.createEvent("MouseEvents");
              Ge.initMouseEvent("click", !0, !0, Ji, 1, Ze.screenX, Ze.screenY, Ze.clientX, Ze.clientY, !1, !1, !1, !1, 0, null), qe.target.dispatchEvent(Ge);
            }
          }
        })), Y.isDragging = Y.isGesturing = Y.isPressed = !1, f && dt && !ne && me.restart(!0), oe && xr(), v && dt && v(Y), b && b(Y, Ce);
      }
    }, Ie = function(ze) {
      return ze.touches && ze.touches.length > 1 && (Y.isGesturing = !0) && X(ze, Y.isDragging);
    }, R = function() {
      return (Y.isGesturing = !1) || O(Y);
    }, I = function(ze) {
      if (!$t(ze)) {
        var dt = Te(), Ce = ve();
        ce((dt - Oe) * H, (Ce - Je) * H, 1), Oe = dt, Je = Ce, f && me.restart(!0);
      }
    }, j = function(ze) {
      if (!$t(ze)) {
        ze = If(ze, c), W && (se = !0);
        var dt = (ze.deltaMode === 1 ? l : ze.deltaMode === 2 ? Ji.innerHeight : 1) * p;
        ce(ze.deltaX * dt, ze.deltaY * dt, 0), f && !ne && me.restart(!0);
      }
    }, te = function(ze) {
      if (!$t(ze)) {
        var dt = ze.clientX, Ce = ze.clientY, Ze = dt - Y.x, Ge = Ce - Y.y;
        Y.x = dt, Y.y = Ce, re = !0, f && me.restart(!0), (Ze || Ge) && ie(Ze, Ge);
      }
    }, Ee = function(ze) {
      Y.event = ze, B(Y);
    }, Ue = function(ze) {
      Y.event = ze, N(Y);
    }, ut = function(ze) {
      return $t(ze) || If(ze, c) && P(Y);
    };
    me = Y._dc = Vr.delayedCall(d || 0.25, Tr).pause(), Y.deltaX = Y.deltaY = 0, Y._vx = V1(0, 50, !0), Y._vy = V1(0, 50, !0), Y.scrollX = Te, Y.scrollY = ve, Y.isDragging = Y.isGesturing = Y.isPressed = !1, LI(this), Y.enable = function(qe) {
      return Y.isEnabled || (si(Pt ? bt : a, "scroll", j1), s.indexOf("scroll") >= 0 && si(Pt ? bt : a, "scroll", I, Ye, Z), s.indexOf("wheel") >= 0 && si(a, "wheel", j, Ye, Z), (s.indexOf("touch") >= 0 && MI || s.indexOf("pointer") >= 0) && (si(a, Vo[0], Ae, Ye, Z), si(bt, Vo[2], we), si(bt, Vo[3], we), le && si(a, "click", jn, !0, !0), P && si(a, "click", ut), X && si(bt, "gesturestart", Ie), O && si(bt, "gestureend", R), B && si(a, ql + "enter", Ee), N && si(a, ql + "leave", Ue), q && si(a, ql + "move", te)), Y.isEnabled = !0, Y.isDragging = Y.isGesturing = Y.isPressed = re = oe = !1, Y._vx.reset(), Y._vy.reset(), Oe = Te(), Je = ve(), qe && qe.type && Ae(qe), T && T(Y)), Y;
    }, Y.disable = function() {
      Y.isEnabled && (rc.filter(function(qe) {
        return qe !== Y && Md(qe.target);
      }).length || ri(Pt ? bt : a, "scroll", j1), Y.isPressed && (Y._vx.reset(), Y._vy.reset(), ri(ne ? a : bt, Vo[1], ke, !0)), ri(Pt ? bt : a, "scroll", I, Z), ri(a, "wheel", j, Z), ri(a, Vo[0], Ae, Z), ri(bt, Vo[2], we), ri(bt, Vo[3], we), ri(a, "click", jn, !0), ri(a, "click", ut), ri(bt, "gesturestart", Ie), ri(bt, "gestureend", R), ri(a, ql + "enter", Ee), ri(a, ql + "leave", Ue), ri(a, ql + "move", te), Y.isEnabled = Y.isPressed = Y.isDragging = !1, $ && $(Y));
    }, Y.kill = Y.revert = function() {
      Y.disable();
      var qe = rc.indexOf(Y);
      qe >= 0 && rc.splice(qe, 1), ra === Y && (ra = 0);
    }, rc.push(Y), ne && Md(a) && (ra = Y), Y.enable(g);
  }, E4(t, [{
    key: "velocityX",
    get: function() {
      return this._vx.getVelocity();
    }
  }, {
    key: "velocityY",
    get: function() {
      return this._vy.getVelocity();
    }
  }]), t;
}();
Jn.version = "3.12.7";
Jn.create = function(t) {
  return new Jn(t);
};
Jn.register = UI;
Jn.getAll = function() {
  return rc.slice();
};
Jn.getById = function(t) {
  return rc.filter(function(e) {
    return e.vars.id === t;
  })[0];
};
BI() && Vr.registerPlugin(Jn);
/*!
 * ScrollTrigger 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var Ke, Qu, Lt, kn, Ki, sn, ZS, xm, sh, Fd, yd, vp, Yr, wy, U1, li, _k, Ek, Ju, qI, L0, zI, ai, q1, HI, GI, Ra, z1, e_, pc, t_, Cm, H1, B0, bp = 1, Xr = Date.now, j0 = Xr(), To = 0, vd = 0, kk = function(e, n, r) {
  var i = Gi(e) && (e.substr(0, 6) === "clamp(" || e.indexOf("max") > -1);
  return r["_" + n + "Clamp"] = i, i ? e.substr(6, e.length - 7) : e;
}, Tk = function(e, n) {
  return n && (!Gi(e) || e.substr(0, 6) !== "clamp(") ? "clamp(" + e + ")" : e;
}, T4 = function t() {
  return vd && requestAnimationFrame(t);
}, xk = function() {
  return wy = 1;
}, Ck = function() {
  return wy = 0;
}, us = function(e) {
  return e;
}, bd = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, WI = function() {
  return typeof window < "u";
}, YI = function() {
  return Ke || WI() && (Ke = window.gsap) && Ke.registerPlugin && Ke;
}, hu = function(e) {
  return !!~ZS.indexOf(e);
}, XI = function(e) {
  return (e === "Height" ? t_ : Lt["inner" + e]) || Ki["client" + e] || sn["client" + e];
}, KI = function(e) {
  return nl(e, "getBoundingClientRect") || (hu(e) ? function() {
    return qg.width = Lt.innerWidth, qg.height = t_, qg;
  } : function() {
    return Js(e);
  });
}, x4 = function(e, n, r) {
  var i = r.d, o = r.d2, s = r.a;
  return (s = nl(e, "getBoundingClientRect")) ? function() {
    return s()[i];
  } : function() {
    return (n ? XI(o) : e["client" + o]) || 0;
  };
}, C4 = function(e, n) {
  return !n || ~_s.indexOf(e) ? KI(e) : function() {
    return qg;
  };
}, vs = function(e, n) {
  var r = n.s, i = n.d2, o = n.d, s = n.a;
  return Math.max(0, (r = "scroll" + i) && (s = nl(e, r)) ? s() - KI(e)()[o] : hu(e) ? (Ki[r] || sn[r]) - XI(i) : e[r] - e["offset" + i]);
}, wp = function(e, n) {
  for (var r = 0; r < Ju.length; r += 3)
    (!n || ~n.indexOf(Ju[r + 1])) && e(Ju[r], Ju[r + 1], Ju[r + 2]);
}, Gi = function(e) {
  return typeof e == "string";
}, Jr = function(e) {
  return typeof e == "function";
}, wd = function(e) {
  return typeof e == "number";
}, zl = function(e) {
  return typeof e == "object";
}, Nf = function(e, n, r) {
  return e && e.progress(n ? 0 : 1) && r && e.pause();
}, V0 = function(e, n) {
  if (e.enabled) {
    var r = e._ctx ? e._ctx.add(function() {
      return n(e);
    }) : n(e);
    r && r.totalTime && (e.callbackAnimation = r);
  }
}, Bu = Math.abs, QI = "left", JI = "top", n_ = "right", r_ = "bottom", su = "width", au = "height", Ld = "Right", Bd = "Left", jd = "Top", Vd = "Bottom", sr = "padding", yo = "margin", Ic = "Width", i_ = "Height", vr = "px", vo = function(e) {
  return Lt.getComputedStyle(e);
}, A4 = function(e) {
  var n = vo(e).position;
  e.style.position = n === "absolute" || n === "fixed" ? n : "relative";
}, Ak = function(e, n) {
  for (var r in n)
    r in e || (e[r] = n[r]);
  return e;
}, Js = function(e, n) {
  var r = n && vo(e)[U1] !== "matrix(1, 0, 0, 1, 0, 0)" && Ke.to(e, {
    x: 0,
    y: 0,
    xPercent: 0,
    yPercent: 0,
    rotation: 0,
    rotationX: 0,
    rotationY: 0,
    scale: 1,
    skewX: 0,
    skewY: 0
  }).progress(1), i = e.getBoundingClientRect();
  return r && r.progress(0).kill(), i;
}, Am = function(e, n) {
  var r = n.d2;
  return e["offset" + r] || e["client" + r] || 0;
}, ZI = function(e) {
  var n = [], r = e.labels, i = e.duration(), o;
  for (o in r)
    n.push(r[o] / i);
  return n;
}, R4 = function(e) {
  return function(n) {
    return Ke.utils.snap(ZI(e), n);
  };
}, o_ = function(e) {
  var n = Ke.utils.snap(e), r = Array.isArray(e) && e.slice(0).sort(function(i, o) {
    return i - o;
  });
  return r ? function(i, o, s) {
    s === void 0 && (s = 1e-3);
    var a;
    if (!o)
      return n(i);
    if (o > 0) {
      for (i -= s, a = 0; a < r.length; a++)
        if (r[a] >= i)
          return r[a];
      return r[a - 1];
    } else
      for (a = r.length, i += s; a--; )
        if (r[a] <= i)
          return r[a];
    return r[0];
  } : function(i, o, s) {
    s === void 0 && (s = 1e-3);
    var a = n(i);
    return !o || Math.abs(a - i) < s || a - i < 0 == o < 0 ? a : n(o < 0 ? i - e : i + e);
  };
}, O4 = function(e) {
  return function(n, r) {
    return o_(ZI(e))(n, r.direction);
  };
}, Sp = function(e, n, r, i) {
  return r.split(",").forEach(function(o) {
    return e(n, o, i);
  });
}, Or = function(e, n, r, i, o) {
  return e.addEventListener(n, r, {
    passive: !i,
    capture: !!o
  });
}, Rr = function(e, n, r, i) {
  return e.removeEventListener(n, r, !!i);
}, _p = function(e, n, r) {
  r = r && r.wheelHandler, r && (e(n, "wheel", r), e(n, "touchmove", r));
}, Rk = {
  startColor: "green",
  endColor: "red",
  indent: 0,
  fontSize: "16px",
  fontWeight: "normal"
}, Ep = {
  toggleActions: "play",
  anticipatePin: 0
}, Rm = {
  top: 0,
  left: 0,
  center: 0.5,
  bottom: 1,
  right: 1
}, Bg = function(e, n) {
  if (Gi(e)) {
    var r = e.indexOf("="), i = ~r ? +(e.charAt(r - 1) + 1) * parseFloat(e.substr(r + 1)) : 0;
    ~r && (e.indexOf("%") > r && (i *= n / 100), e = e.substr(0, r - 1)), e = i + (e in Rm ? Rm[e] * n : ~e.indexOf("%") ? parseFloat(e) * n / 100 : parseFloat(e) || 0);
  }
  return e;
}, kp = function(e, n, r, i, o, s, a, l) {
  var u = o.startColor, c = o.endColor, f = o.fontSize, d = o.indent, h = o.fontWeight, p = kn.createElement("div"), g = hu(r) || nl(r, "pinType") === "fixed", m = e.indexOf("scroller") !== -1, v = g ? sn : r, S = e.indexOf("start") !== -1, _ = S ? u : c, b = "border-color:" + _ + ";font-size:" + f + ";color:" + _ + ";font-weight:" + h + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
  return b += "position:" + ((m || l) && g ? "fixed;" : "absolute;"), (m || l || !g) && (b += (i === br ? n_ : r_) + ":" + (s + parseFloat(d)) + "px;"), a && (b += "box-sizing:border-box;text-align:left;width:" + a.offsetWidth + "px;"), p._isStart = S, p.setAttribute("class", "gsap-marker-" + e + (n ? " marker-" + n : "")), p.style.cssText = b, p.innerText = n || n === 0 ? e + "-" + n : e, v.children[0] ? v.insertBefore(p, v.children[0]) : v.appendChild(p), p._offset = p["offset" + i.op.d2], jg(p, 0, i, S), p;
}, jg = function(e, n, r, i) {
  var o = {
    display: "block"
  }, s = r[i ? "os2" : "p2"], a = r[i ? "p2" : "os2"];
  e._isFlipped = i, o[r.a + "Percent"] = i ? -100 : 0, o[r.a] = i ? "1px" : 0, o["border" + s + Ic] = 1, o["border" + a + Ic] = 0, o[r.p] = n + "px", Ke.set(e, o);
}, Mt = [], G1 = {}, ah, Ok = function() {
  return Xr() - To > 34 && (ah || (ah = requestAnimationFrame(ua)));
}, ju = function() {
  (!ai || !ai.isPressed || ai.startX > sn.clientWidth) && (Bt.cache++, ai ? ah || (ah = requestAnimationFrame(ua)) : ua(), To || gu("scrollStart"), To = Xr());
}, U0 = function() {
  GI = Lt.innerWidth, HI = Lt.innerHeight;
}, Sd = function(e) {
  Bt.cache++, (e === !0 || !Yr && !zI && !kn.fullscreenElement && !kn.webkitFullscreenElement && (!q1 || GI !== Lt.innerWidth || Math.abs(Lt.innerHeight - HI) > Lt.innerHeight * 0.25)) && xm.restart(!0);
}, pu = {}, D4 = [], eN = function t() {
  return Rr(gt, "scrollEnd", t) || Ql(!0);
}, gu = function(e) {
  return pu[e] && pu[e].map(function(n) {
    return n();
  }) || D4;
}, zi = [], tN = function(e) {
  for (var n = 0; n < zi.length; n += 5)
    (!e || zi[n + 4] && zi[n + 4].query === e) && (zi[n].style.cssText = zi[n + 1], zi[n].getBBox && zi[n].setAttribute("transform", zi[n + 2] || ""), zi[n + 3].uncache = 1);
}, s_ = function(e, n) {
  var r;
  for (li = 0; li < Mt.length; li++)
    r = Mt[li], r && (!n || r._ctx === n) && (e ? r.kill(1) : r.revert(!0, !0));
  Cm = !0, n && tN(n), n || gu("revert");
}, nN = function(e, n) {
  Bt.cache++, (n || !ui) && Bt.forEach(function(r) {
    return Jr(r) && r.cacheID++ && (r.rec = 0);
  }), Gi(e) && (Lt.history.scrollRestoration = e_ = e);
}, ui, lu = 0, Dk, I4 = function() {
  if (Dk !== lu) {
    var e = Dk = lu;
    requestAnimationFrame(function() {
      return e === lu && Ql(!0);
    });
  }
}, rN = function() {
  sn.appendChild(pc), t_ = !ai && pc.offsetHeight || Lt.innerHeight, sn.removeChild(pc);
}, Ik = function(e) {
  return sh(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(n) {
    return n.style.display = e ? "none" : "block";
  });
}, Ql = function(e, n) {
  if (Ki = kn.documentElement, sn = kn.body, ZS = [Lt, kn, Ki, sn], To && !e && !Cm) {
    Or(gt, "scrollEnd", eN);
    return;
  }
  rN(), ui = gt.isRefreshing = !0, Bt.forEach(function(i) {
    return Jr(i) && ++i.cacheID && (i.rec = i());
  });
  var r = gu("refreshInit");
  qI && gt.sort(), n || s_(), Bt.forEach(function(i) {
    Jr(i) && (i.smooth && (i.target.style.scrollBehavior = "auto"), i(0));
  }), Mt.slice(0).forEach(function(i) {
    return i.refresh();
  }), Cm = !1, Mt.forEach(function(i) {
    if (i._subPinOffset && i.pin) {
      var o = i.vars.horizontal ? "offsetWidth" : "offsetHeight", s = i.pin[o];
      i.revert(!0, 1), i.adjustPinSpacing(i.pin[o] - s), i.refresh();
    }
  }), H1 = 1, Ik(!0), Mt.forEach(function(i) {
    var o = vs(i.scroller, i._dir), s = i.vars.end === "max" || i._endClamp && i.end > o, a = i._startClamp && i.start >= o;
    (s || a) && i.setPositions(a ? o - 1 : i.start, s ? Math.max(a ? o : i.start + 1, o) : i.end, !0);
  }), Ik(!1), H1 = 0, r.forEach(function(i) {
    return i && i.render && i.render(-1);
  }), Bt.forEach(function(i) {
    Jr(i) && (i.smooth && requestAnimationFrame(function() {
      return i.target.style.scrollBehavior = "smooth";
    }), i.rec && i(i.rec));
  }), nN(e_, 1), xm.pause(), lu++, ui = 2, ua(2), Mt.forEach(function(i) {
    return Jr(i.vars.onRefresh) && i.vars.onRefresh(i);
  }), ui = gt.isRefreshing = !1, gu("refresh");
}, W1 = 0, Vg = 1, Ud, ua = function(e) {
  if (e === 2 || !ui && !Cm) {
    gt.isUpdating = !0, Ud && Ud.update(0);
    var n = Mt.length, r = Xr(), i = r - j0 >= 50, o = n && Mt[0].scroll();
    if (Vg = W1 > o ? -1 : 1, ui || (W1 = o), i && (To && !wy && r - To > 200 && (To = 0, gu("scrollEnd")), yd = j0, j0 = r), Vg < 0) {
      for (li = n; li-- > 0; )
        Mt[li] && Mt[li].update(0, i);
      Vg = 1;
    } else
      for (li = 0; li < n; li++)
        Mt[li] && Mt[li].update(0, i);
    gt.isUpdating = !1;
  }
  ah = 0;
}, Y1 = [QI, JI, r_, n_, yo + Vd, yo + Ld, yo + jd, yo + Bd, "display", "flexShrink", "float", "zIndex", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "gridArea", "justifySelf", "alignSelf", "placeSelf", "order"], Ug = Y1.concat([su, au, "boxSizing", "max" + Ic, "max" + i_, "position", yo, sr, sr + jd, sr + Ld, sr + Vd, sr + Bd]), N4 = function(e, n, r) {
  gc(r);
  var i = e._gsap;
  if (i.spacerIsNative)
    gc(i.spacerState);
  else if (e._gsap.swappedIn) {
    var o = n.parentNode;
    o && (o.insertBefore(e, n), o.removeChild(n));
  }
  e._gsap.swappedIn = !1;
}, q0 = function(e, n, r, i) {
  if (!e._gsap.swappedIn) {
    for (var o = Y1.length, s = n.style, a = e.style, l; o--; )
      l = Y1[o], s[l] = r[l];
    s.position = r.position === "absolute" ? "absolute" : "relative", r.display === "inline" && (s.display = "inline-block"), a[r_] = a[n_] = "auto", s.flexBasis = r.flexBasis || "auto", s.overflow = "visible", s.boxSizing = "border-box", s[su] = Am(e, di) + vr, s[au] = Am(e, br) + vr, s[sr] = a[yo] = a[JI] = a[QI] = "0", gc(i), a[su] = a["max" + Ic] = r[su], a[au] = a["max" + i_] = r[au], a[sr] = r[sr], e.parentNode !== n && (e.parentNode.insertBefore(n, e), n.appendChild(e)), e._gsap.swappedIn = !0;
  }
}, P4 = /([A-Z])/g, gc = function(e) {
  if (e) {
    var n = e.t.style, r = e.length, i = 0, o, s;
    for ((e.t._gsap || Ke.core.getCache(e.t)).uncache = 1; i < r; i += 2)
      s = e[i + 1], o = e[i], s ? n[o] = s : n[o] && n.removeProperty(o.replace(P4, "-$1").toLowerCase());
  }
}, Tp = function(e) {
  for (var n = Ug.length, r = e.style, i = [], o = 0; o < n; o++)
    i.push(Ug[o], r[Ug[o]]);
  return i.t = e, i;
}, $4 = function(e, n, r) {
  for (var i = [], o = e.length, s = r ? 8 : 0, a; s < o; s += 2)
    a = e[s], i.push(a, a in n ? n[a] : e[s + 1]);
  return i.t = e.t, i;
}, qg = {
  left: 0,
  top: 0
}, Nk = function(e, n, r, i, o, s, a, l, u, c, f, d, h, p) {
  Jr(e) && (e = e(l)), Gi(e) && e.substr(0, 3) === "max" && (e = d + (e.charAt(4) === "=" ? Bg("0" + e.substr(3), r) : 0));
  var g = h ? h.time() : 0, m, v, S;
  if (h && h.seek(0), isNaN(e) || (e = +e), wd(e))
    h && (e = Ke.utils.mapRange(h.scrollTrigger.start, h.scrollTrigger.end, 0, d, e)), a && jg(a, r, i, !0);
  else {
    Jr(n) && (n = n(l));
    var _ = (e || "0").split(" "), b, y, w, E;
    S = ki(n, l) || sn, b = Js(S) || {}, (!b || !b.left && !b.top) && vo(S).display === "none" && (E = S.style.display, S.style.display = "block", b = Js(S), E ? S.style.display = E : S.style.removeProperty("display")), y = Bg(_[0], b[i.d]), w = Bg(_[1] || "0", r), e = b[i.p] - u[i.p] - c + y + o - w, a && jg(a, w, i, r - w < 20 || a._isStart && w > 20), r -= r - w;
  }
  if (p && (l[p] = e || -1e-3, e < 0 && (e = 0)), s) {
    var x = e + r, k = s._isStart;
    m = "scroll" + i.d2, jg(s, x, i, k && x > 20 || !k && (f ? Math.max(sn[m], Ki[m]) : s.parentNode[m]) <= x + 1), f && (u = Js(a), f && (s.style[i.op.p] = u[i.op.p] - i.op.m - s._offset + vr));
  }
  return h && S && (m = Js(S), h.seek(d), v = Js(S), h._caScrollDist = m[i.p] - v[i.p], e = e / h._caScrollDist * d), h && h.seek(g), h ? e : Math.round(e);
}, M4 = /(webkit|moz|length|cssText|inset)/i, Pk = function(e, n, r, i) {
  if (e.parentNode !== n) {
    var o = e.style, s, a;
    if (n === sn) {
      e._stOrig = o.cssText, a = vo(e);
      for (s in a)
        !+s && !M4.test(s) && a[s] && typeof o[s] == "string" && s !== "0" && (o[s] = a[s]);
      o.top = r, o.left = i;
    } else
      o.cssText = e._stOrig;
    Ke.core.getCache(e).uncache = 1, n.appendChild(e);
  }
}, iN = function(e, n, r) {
  var i = n, o = i;
  return function(s) {
    var a = Math.round(e());
    return a !== i && a !== o && Math.abs(a - i) > 3 && Math.abs(a - o) > 3 && (s = a, r && r()), o = i, i = Math.round(s), i;
  };
}, xp = function(e, n, r) {
  var i = {};
  i[n.p] = "+=" + r, Ke.set(e, i);
}, $k = function(e, n) {
  var r = al(e, n), i = "_scroll" + n.p2, o = function s(a, l, u, c, f) {
    var d = s.tween, h = l.onComplete, p = {};
    u = u || r();
    var g = iN(r, u, function() {
      d.kill(), s.tween = 0;
    });
    return f = c && f || 0, c = c || a - u, d && d.kill(), l[i] = a, l.inherit = !1, l.modifiers = p, p[i] = function() {
      return g(u + c * d.ratio + f * d.ratio * d.ratio);
    }, l.onUpdate = function() {
      Bt.cache++, s.tween && ua();
    }, l.onComplete = function() {
      s.tween = 0, h && h.call(d);
    }, d = s.tween = Ke.to(e, l), d;
  };
  return e[i] = r, r.wheelHandler = function() {
    return o.tween && o.tween.kill() && (o.tween = 0);
  }, Or(e, "wheel", r.wheelHandler), gt.isTouch && Or(e, "touchmove", r.wheelHandler), o;
}, gt = /* @__PURE__ */ function() {
  function t(n, r) {
    Qu || t.register(Ke) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), z1(this), this.init(n, r);
  }
  var e = t.prototype;
  return e.init = function(r, i) {
    if (this.progress = this.start = 0, this.vars && this.kill(!0, !0), !vd) {
      this.update = this.refresh = this.kill = us;
      return;
    }
    r = Ak(Gi(r) || wd(r) || r.nodeType ? {
      trigger: r
    } : r, Ep);
    var o = r, s = o.onUpdate, a = o.toggleClass, l = o.id, u = o.onToggle, c = o.onRefresh, f = o.scrub, d = o.trigger, h = o.pin, p = o.pinSpacing, g = o.invalidateOnRefresh, m = o.anticipatePin, v = o.onScrubComplete, S = o.onSnapComplete, _ = o.once, b = o.snap, y = o.pinReparent, w = o.pinSpacer, E = o.containerAnimation, x = o.fastScrollEnd, k = o.preventOverlaps, C = r.horizontal || r.containerAnimation && r.horizontal !== !1 ? di : br, M = !f && f !== 0, F = ki(r.scroller || Lt), U = Ke.core.getCache(F), B = hu(F), N = ("pinType" in r ? r.pinType : nl(F, "pinType") || B && "fixed") === "fixed", q = [r.onEnter, r.onLeave, r.onEnterBack, r.onLeaveBack], Q = M && r.toggleActions.split(" "), ne = "markers" in r ? r.markers : Ep.markers, X = B ? 0 : parseFloat(vo(F)["border" + C.p2 + Ic]) || 0, O = this, W = r.onRefreshInit && function() {
      return r.onRefreshInit(O);
    }, T = x4(F, B, C), $ = C4(F, B), P = 0, H = 0, Z = 0, le = al(F, C), J, ue, he, me, oe, re, se, ae, fe, Y, Re, ee, Ye, Te, ve, Oe, Je, pt, Pt, bt, Ft, mt, ln, jn, $t, Tr, xr, ce, ie, ke, Ae, we, Ie, R, I, j, te, Ee, Ue;
    if (O._startClamp = O._endClamp = !1, O._dir = C, m *= 45, O.scroller = F, O.scroll = E ? E.time.bind(E) : le, me = le(), O.vars = r, i = i || r.animation, "refreshPriority" in r && (qI = 1, r.refreshPriority === -9999 && (Ud = O)), U.tweenScroll = U.tweenScroll || {
      top: $k(F, br),
      left: $k(F, di)
    }, O.tweenTo = J = U.tweenScroll[C.p], O.scrubDuration = function(Ce) {
      Ie = wd(Ce) && Ce, Ie ? we ? we.duration(Ce) : we = Ke.to(i, {
        ease: "expo",
        totalProgress: "+=0",
        inherit: !1,
        duration: Ie,
        paused: !0,
        onComplete: function() {
          return v && v(O);
        }
      }) : (we && we.progress(1).kill(), we = 0);
    }, i && (i.vars.lazy = !1, i._initted && !O.isReverted || i.vars.immediateRender !== !1 && r.immediateRender !== !1 && i.duration() && i.render(0, !0, !0), O.animation = i.pause(), i.scrollTrigger = O, O.scrubDuration(f), ke = 0, l || (l = i.vars.id)), b && ((!zl(b) || b.push) && (b = {
      snapTo: b
    }), "scrollBehavior" in sn.style && Ke.set(B ? [sn, Ki] : F, {
      scrollBehavior: "auto"
    }), Bt.forEach(function(Ce) {
      return Jr(Ce) && Ce.target === (B ? kn.scrollingElement || Ki : F) && (Ce.smooth = !1);
    }), he = Jr(b.snapTo) ? b.snapTo : b.snapTo === "labels" ? R4(i) : b.snapTo === "labelsDirectional" ? O4(i) : b.directional !== !1 ? function(Ce, Ze) {
      return o_(b.snapTo)(Ce, Xr() - H < 500 ? 0 : Ze.direction);
    } : Ke.utils.snap(b.snapTo), R = b.duration || {
      min: 0.1,
      max: 2
    }, R = zl(R) ? Fd(R.min, R.max) : Fd(R, R), I = Ke.delayedCall(b.delay || Ie / 2 || 0.1, function() {
      var Ce = le(), Ze = Xr() - H < 500, Ge = J.tween;
      if ((Ze || Math.abs(O.getVelocity()) < 10) && !Ge && !wy && P !== Ce) {
        var ct = (Ce - re) / Te, Gt = i && !M ? i.totalProgress() : ct, yt = Ze ? 0 : (Gt - Ae) / (Xr() - yd) * 1e3 || 0, G = Ke.utils.clamp(-ct, 1 - ct, Bu(yt / 2) * yt / 0.185), be = ct + (b.inertia === !1 ? 0 : G), xe, Me, et = b, xt = et.onStart, it = et.onInterrupt, ht = et.onComplete;
        if (xe = he(be, O), wd(xe) || (xe = be), Me = Math.max(0, Math.round(re + xe * Te)), Ce <= se && Ce >= re && Me !== Ce) {
          if (Ge && !Ge._initted && Ge.data <= Bu(Me - Ce))
            return;
          b.inertia === !1 && (G = xe - ct), J(Me, {
            duration: R(Bu(Math.max(Bu(be - Gt), Bu(xe - Gt)) * 0.185 / yt / 0.05 || 0)),
            ease: b.ease || "power3",
            data: Bu(Me - Ce),
            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
            onInterrupt: function() {
              return I.restart(!0) && it && it(O);
            },
            onComplete: function() {
              O.update(), P = le(), i && !M && (we ? we.resetTo("totalProgress", xe, i._tTime / i._tDur) : i.progress(xe)), ke = Ae = i && !M ? i.totalProgress() : O.progress, S && S(O), ht && ht(O);
            }
          }, Ce, G * Te, Me - Ce - G * Te), xt && xt(O, J.tween);
        }
      } else O.isActive && P !== Ce && I.restart(!0);
    }).pause()), l && (G1[l] = O), d = O.trigger = ki(d || h !== !0 && h), Ue = d && d._gsap && d._gsap.stRevert, Ue && (Ue = Ue(O)), h = h === !0 ? d : ki(h), Gi(a) && (a = {
      targets: d,
      className: a
    }), h && (p === !1 || p === yo || (p = !p && h.parentNode && h.parentNode.style && vo(h.parentNode).display === "flex" ? !1 : sr), O.pin = h, ue = Ke.core.getCache(h), ue.spacer ? ve = ue.pinState : (w && (w = ki(w), w && !w.nodeType && (w = w.current || w.nativeElement), ue.spacerIsNative = !!w, w && (ue.spacerState = Tp(w))), ue.spacer = pt = w || kn.createElement("div"), pt.classList.add("pin-spacer"), l && pt.classList.add("pin-spacer-" + l), ue.pinState = ve = Tp(h)), r.force3D !== !1 && Ke.set(h, {
      force3D: !0
    }), O.spacer = pt = ue.spacer, ie = vo(h), jn = ie[p + C.os2], bt = Ke.getProperty(h), Ft = Ke.quickSetter(h, C.a, vr), q0(h, pt, ie), Je = Tp(h)), ne) {
      ee = zl(ne) ? Ak(ne, Rk) : Rk, Y = kp("scroller-start", l, F, C, ee, 0), Re = kp("scroller-end", l, F, C, ee, 0, Y), Pt = Y["offset" + C.op.d2];
      var ut = ki(nl(F, "content") || F);
      ae = this.markerStart = kp("start", l, ut, C, ee, Pt, 0, E), fe = this.markerEnd = kp("end", l, ut, C, ee, Pt, 0, E), E && (Ee = Ke.quickSetter([ae, fe], C.a, vr)), !N && !(_s.length && nl(F, "fixedMarkers") === !0) && (A4(B ? sn : F), Ke.set([Y, Re], {
        force3D: !0
      }), Tr = Ke.quickSetter(Y, C.a, vr), ce = Ke.quickSetter(Re, C.a, vr));
    }
    if (E) {
      var qe = E.vars.onUpdate, ze = E.vars.onUpdateParams;
      E.eventCallback("onUpdate", function() {
        O.update(0, 0, 1), qe && qe.apply(E, ze || []);
      });
    }
    if (O.previous = function() {
      return Mt[Mt.indexOf(O) - 1];
    }, O.next = function() {
      return Mt[Mt.indexOf(O) + 1];
    }, O.revert = function(Ce, Ze) {
      if (!Ze)
        return O.kill(!0);
      var Ge = Ce !== !1 || !O.enabled, ct = Yr;
      Ge !== O.isReverted && (Ge && (j = Math.max(le(), O.scroll.rec || 0), Z = O.progress, te = i && i.progress()), ae && [ae, fe, Y, Re].forEach(function(Gt) {
        return Gt.style.display = Ge ? "none" : "block";
      }), Ge && (Yr = O, O.update(Ge)), h && (!y || !O.isActive) && (Ge ? N4(h, pt, ve) : q0(h, pt, vo(h), $t)), Ge || O.update(Ge), Yr = ct, O.isReverted = Ge);
    }, O.refresh = function(Ce, Ze, Ge, ct) {
      if (!((Yr || !O.enabled) && !Ze)) {
        if (h && Ce && To) {
          Or(t, "scrollEnd", eN);
          return;
        }
        !ui && W && W(O), Yr = O, J.tween && !Ge && (J.tween.kill(), J.tween = 0), we && we.pause(), g && i && i.revert({
          kill: !1
        }).invalidate(), O.isReverted || O.revert(!0, !0), O._subPinOffset = !1;
        var Gt = T(), yt = $(), G = E ? E.duration() : vs(F, C), be = Te <= 0.01, xe = 0, Me = ct || 0, et = zl(Ge) ? Ge.end : r.end, xt = r.endTrigger || d, it = zl(Ge) ? Ge.start : r.start || (r.start === 0 || !d ? 0 : h ? "0 0" : "0 100%"), ht = O.pinnedContainer = r.pinnedContainer && ki(r.pinnedContainer, O), tn = d && Math.max(0, Mt.indexOf(O)) || 0, Ct = tn, At, Kt, Gr, Wr, Wt, Dn, Si, El, up, ns, _i, Ta, kl;
        for (ne && zl(Ge) && (Ta = Ke.getProperty(Y, C.p), kl = Ke.getProperty(Re, C.p)); Ct-- > 0; )
          Dn = Mt[Ct], Dn.end || Dn.refresh(0, 1) || (Yr = O), Si = Dn.pin, Si && (Si === d || Si === h || Si === ht) && !Dn.isReverted && (ns || (ns = []), ns.unshift(Dn), Dn.revert(!0, !0)), Dn !== Mt[Ct] && (tn--, Ct--);
        for (Jr(it) && (it = it(O)), it = kk(it, "start", O), re = Nk(it, d, Gt, C, le(), ae, Y, O, yt, X, N, G, E, O._startClamp && "_startClamp") || (h ? -1e-3 : 0), Jr(et) && (et = et(O)), Gi(et) && !et.indexOf("+=") && (~et.indexOf(" ") ? et = (Gi(it) ? it.split(" ")[0] : "") + et : (xe = Bg(et.substr(2), Gt), et = Gi(it) ? it : (E ? Ke.utils.mapRange(0, E.duration(), E.scrollTrigger.start, E.scrollTrigger.end, re) : re) + xe, xt = d)), et = kk(et, "end", O), se = Math.max(re, Nk(et || (xt ? "100% 0" : G), xt, Gt, C, le() + xe, fe, Re, O, yt, X, N, G, E, O._endClamp && "_endClamp")) || -1e-3, xe = 0, Ct = tn; Ct--; )
          Dn = Mt[Ct], Si = Dn.pin, Si && Dn.start - Dn._pinPush <= re && !E && Dn.end > 0 && (At = Dn.end - (O._startClamp ? Math.max(0, Dn.start) : Dn.start), (Si === d && Dn.start - Dn._pinPush < re || Si === ht) && isNaN(it) && (xe += At * (1 - Dn.progress)), Si === h && (Me += At));
        if (re += xe, se += xe, O._startClamp && (O._startClamp += xe), O._endClamp && !ui && (O._endClamp = se || -1e-3, se = Math.min(se, vs(F, C))), Te = se - re || (re -= 0.01) && 1e-3, be && (Z = Ke.utils.clamp(0, 1, Ke.utils.normalize(re, se, j))), O._pinPush = Me, ae && xe && (At = {}, At[C.a] = "+=" + xe, ht && (At[C.p] = "-=" + le()), Ke.set([ae, fe], At)), h && !(H1 && O.end >= vs(F, C)))
          At = vo(h), Wr = C === br, Gr = le(), mt = parseFloat(bt(C.a)) + Me, !G && se > 1 && (_i = (B ? kn.scrollingElement || Ki : F).style, _i = {
            style: _i,
            value: _i["overflow" + C.a.toUpperCase()]
          }, B && vo(sn)["overflow" + C.a.toUpperCase()] !== "scroll" && (_i.style["overflow" + C.a.toUpperCase()] = "scroll")), q0(h, pt, At), Je = Tp(h), Kt = Js(h, !0), El = N && al(F, Wr ? di : br)(), p ? ($t = [p + C.os2, Te + Me + vr], $t.t = pt, Ct = p === sr ? Am(h, C) + Te + Me : 0, Ct && ($t.push(C.d, Ct + vr), pt.style.flexBasis !== "auto" && (pt.style.flexBasis = Ct + vr)), gc($t), ht && Mt.forEach(function(Tl) {
            Tl.pin === ht && Tl.vars.pinSpacing !== !1 && (Tl._subPinOffset = !0);
          }), N && le(j)) : (Ct = Am(h, C), Ct && pt.style.flexBasis !== "auto" && (pt.style.flexBasis = Ct + vr)), N && (Wt = {
            top: Kt.top + (Wr ? Gr - re : El) + vr,
            left: Kt.left + (Wr ? El : Gr - re) + vr,
            boxSizing: "border-box",
            position: "fixed"
          }, Wt[su] = Wt["max" + Ic] = Math.ceil(Kt.width) + vr, Wt[au] = Wt["max" + i_] = Math.ceil(Kt.height) + vr, Wt[yo] = Wt[yo + jd] = Wt[yo + Ld] = Wt[yo + Vd] = Wt[yo + Bd] = "0", Wt[sr] = At[sr], Wt[sr + jd] = At[sr + jd], Wt[sr + Ld] = At[sr + Ld], Wt[sr + Vd] = At[sr + Vd], Wt[sr + Bd] = At[sr + Bd], Oe = $4(ve, Wt, y), ui && le(0)), i ? (up = i._initted, L0(1), i.render(i.duration(), !0, !0), ln = bt(C.a) - mt + Te + Me, xr = Math.abs(Te - ln) > 1, N && xr && Oe.splice(Oe.length - 2, 2), i.render(0, !0, !0), up || i.invalidate(!0), i.parent || i.totalTime(i.totalTime()), L0(0)) : ln = Te, _i && (_i.value ? _i.style["overflow" + C.a.toUpperCase()] = _i.value : _i.style.removeProperty("overflow-" + C.a));
        else if (d && le() && !E)
          for (Kt = d.parentNode; Kt && Kt !== sn; )
            Kt._pinOffset && (re -= Kt._pinOffset, se -= Kt._pinOffset), Kt = Kt.parentNode;
        ns && ns.forEach(function(Tl) {
          return Tl.revert(!1, !0);
        }), O.start = re, O.end = se, me = oe = ui ? j : le(), !E && !ui && (me < j && le(j), O.scroll.rec = 0), O.revert(!1, !0), H = Xr(), I && (P = -1, I.restart(!0)), Yr = 0, i && M && (i._initted || te) && i.progress() !== te && i.progress(te || 0, !0).render(i.time(), !0, !0), (be || Z !== O.progress || E || g || i && !i._initted) && (i && !M && i.totalProgress(E && re < -1e-3 && !Z ? Ke.utils.normalize(re, se, 0) : Z, !0), O.progress = be || (me - re) / Te === Z ? 0 : Z), h && p && (pt._pinOffset = Math.round(O.progress * ln)), we && we.invalidate(), isNaN(Ta) || (Ta -= Ke.getProperty(Y, C.p), kl -= Ke.getProperty(Re, C.p), xp(Y, C, Ta), xp(ae, C, Ta - (ct || 0)), xp(Re, C, kl), xp(fe, C, kl - (ct || 0))), be && !ui && O.update(), c && !ui && !Ye && (Ye = !0, c(O), Ye = !1);
      }
    }, O.getVelocity = function() {
      return (le() - oe) / (Xr() - yd) * 1e3 || 0;
    }, O.endAnimation = function() {
      Nf(O.callbackAnimation), i && (we ? we.progress(1) : i.paused() ? M || Nf(i, O.direction < 0, 1) : Nf(i, i.reversed()));
    }, O.labelToScroll = function(Ce) {
      return i && i.labels && (re || O.refresh() || re) + i.labels[Ce] / i.duration() * Te || 0;
    }, O.getTrailing = function(Ce) {
      var Ze = Mt.indexOf(O), Ge = O.direction > 0 ? Mt.slice(0, Ze).reverse() : Mt.slice(Ze + 1);
      return (Gi(Ce) ? Ge.filter(function(ct) {
        return ct.vars.preventOverlaps === Ce;
      }) : Ge).filter(function(ct) {
        return O.direction > 0 ? ct.end <= re : ct.start >= se;
      });
    }, O.update = function(Ce, Ze, Ge) {
      if (!(E && !Ge && !Ce)) {
        var ct = ui === !0 ? j : O.scroll(), Gt = Ce ? 0 : (ct - re) / Te, yt = Gt < 0 ? 0 : Gt > 1 ? 1 : Gt || 0, G = O.progress, be, xe, Me, et, xt, it, ht, tn;
        if (Ze && (oe = me, me = E ? le() : ct, b && (Ae = ke, ke = i && !M ? i.totalProgress() : yt)), m && h && !Yr && !bp && To && (!yt && re < ct + (ct - oe) / (Xr() - yd) * m ? yt = 1e-4 : yt === 1 && se > ct + (ct - oe) / (Xr() - yd) * m && (yt = 0.9999)), yt !== G && O.enabled) {
          if (be = O.isActive = !!yt && yt < 1, xe = !!G && G < 1, it = be !== xe, xt = it || !!yt != !!G, O.direction = yt > G ? 1 : -1, O.progress = yt, xt && !Yr && (Me = yt && !G ? 0 : yt === 1 ? 1 : G === 1 ? 2 : 3, M && (et = !it && Q[Me + 1] !== "none" && Q[Me + 1] || Q[Me], tn = i && (et === "complete" || et === "reset" || et in i))), k && (it || tn) && (tn || f || !i) && (Jr(k) ? k(O) : O.getTrailing(k).forEach(function(Gr) {
            return Gr.endAnimation();
          })), M || (we && !Yr && !bp ? (we._dp._time - we._start !== we._time && we.render(we._dp._time - we._start), we.resetTo ? we.resetTo("totalProgress", yt, i._tTime / i._tDur) : (we.vars.totalProgress = yt, we.invalidate().restart())) : i && i.totalProgress(yt, !!(Yr && (H || Ce)))), h) {
            if (Ce && p && (pt.style[p + C.os2] = jn), !N)
              Ft(bd(mt + ln * yt));
            else if (xt) {
              if (ht = !Ce && yt > G && se + 1 > ct && ct + 1 >= vs(F, C), y)
                if (!Ce && (be || ht)) {
                  var Ct = Js(h, !0), At = ct - re;
                  Pk(h, sn, Ct.top + (C === br ? At : 0) + vr, Ct.left + (C === br ? 0 : At) + vr);
                } else
                  Pk(h, pt);
              gc(be || ht ? Oe : Je), xr && yt < 1 && be || Ft(mt + (yt === 1 && !ht ? ln : 0));
            }
          }
          b && !J.tween && !Yr && !bp && I.restart(!0), a && (it || _ && yt && (yt < 1 || !B0)) && sh(a.targets).forEach(function(Gr) {
            return Gr.classList[be || _ ? "add" : "remove"](a.className);
          }), s && !M && !Ce && s(O), xt && !Yr ? (M && (tn && (et === "complete" ? i.pause().totalProgress(1) : et === "reset" ? i.restart(!0).pause() : et === "restart" ? i.restart(!0) : i[et]()), s && s(O)), (it || !B0) && (u && it && V0(O, u), q[Me] && V0(O, q[Me]), _ && (yt === 1 ? O.kill(!1, 1) : q[Me] = 0), it || (Me = yt === 1 ? 1 : 3, q[Me] && V0(O, q[Me]))), x && !be && Math.abs(O.getVelocity()) > (wd(x) ? x : 2500) && (Nf(O.callbackAnimation), we ? we.progress(1) : Nf(i, et === "reverse" ? 1 : !yt, 1))) : M && s && !Yr && s(O);
        }
        if (ce) {
          var Kt = E ? ct / E.duration() * (E._caScrollDist || 0) : ct;
          Tr(Kt + (Y._isFlipped ? 1 : 0)), ce(Kt);
        }
        Ee && Ee(-ct / E.duration() * (E._caScrollDist || 0));
      }
    }, O.enable = function(Ce, Ze) {
      O.enabled || (O.enabled = !0, Or(F, "resize", Sd), B || Or(F, "scroll", ju), W && Or(t, "refreshInit", W), Ce !== !1 && (O.progress = Z = 0, me = oe = P = le()), Ze !== !1 && O.refresh());
    }, O.getTween = function(Ce) {
      return Ce && J ? J.tween : we;
    }, O.setPositions = function(Ce, Ze, Ge, ct) {
      if (E) {
        var Gt = E.scrollTrigger, yt = E.duration(), G = Gt.end - Gt.start;
        Ce = Gt.start + G * Ce / yt, Ze = Gt.start + G * Ze / yt;
      }
      O.refresh(!1, !1, {
        start: Tk(Ce, Ge && !!O._startClamp),
        end: Tk(Ze, Ge && !!O._endClamp)
      }, ct), O.update();
    }, O.adjustPinSpacing = function(Ce) {
      if ($t && Ce) {
        var Ze = $t.indexOf(C.d) + 1;
        $t[Ze] = parseFloat($t[Ze]) + Ce + vr, $t[1] = parseFloat($t[1]) + Ce + vr, gc($t);
      }
    }, O.disable = function(Ce, Ze) {
      if (O.enabled && (Ce !== !1 && O.revert(!0, !0), O.enabled = O.isActive = !1, Ze || we && we.pause(), j = 0, ue && (ue.uncache = 1), W && Rr(t, "refreshInit", W), I && (I.pause(), J.tween && J.tween.kill() && (J.tween = 0)), !B)) {
        for (var Ge = Mt.length; Ge--; )
          if (Mt[Ge].scroller === F && Mt[Ge] !== O)
            return;
        Rr(F, "resize", Sd), B || Rr(F, "scroll", ju);
      }
    }, O.kill = function(Ce, Ze) {
      O.disable(Ce, Ze), we && !Ze && we.kill(), l && delete G1[l];
      var Ge = Mt.indexOf(O);
      Ge >= 0 && Mt.splice(Ge, 1), Ge === li && Vg > 0 && li--, Ge = 0, Mt.forEach(function(ct) {
        return ct.scroller === O.scroller && (Ge = 1);
      }), Ge || ui || (O.scroll.rec = 0), i && (i.scrollTrigger = null, Ce && i.revert({
        kill: !1
      }), Ze || i.kill()), ae && [ae, fe, Y, Re].forEach(function(ct) {
        return ct.parentNode && ct.parentNode.removeChild(ct);
      }), Ud === O && (Ud = 0), h && (ue && (ue.uncache = 1), Ge = 0, Mt.forEach(function(ct) {
        return ct.pin === h && Ge++;
      }), Ge || (ue.spacer = 0)), r.onKill && r.onKill(O);
    }, Mt.push(O), O.enable(!1, !1), Ue && Ue(O), i && i.add && !Te) {
      var dt = O.update;
      O.update = function() {
        O.update = dt, Bt.cache++, re || se || O.refresh();
      }, Ke.delayedCall(0.01, O.update), Te = 0.01, re = se = 0;
    } else
      O.refresh();
    h && I4();
  }, t.register = function(r) {
    return Qu || (Ke = r || YI(), WI() && window.document && t.enable(), Qu = vd), Qu;
  }, t.defaults = function(r) {
    if (r)
      for (var i in r)
        Ep[i] = r[i];
    return Ep;
  }, t.disable = function(r, i) {
    vd = 0, Mt.forEach(function(s) {
      return s[i ? "kill" : "disable"](r);
    }), Rr(Lt, "wheel", ju), Rr(kn, "scroll", ju), clearInterval(vp), Rr(kn, "touchcancel", us), Rr(sn, "touchstart", us), Sp(Rr, kn, "pointerdown,touchstart,mousedown", xk), Sp(Rr, kn, "pointerup,touchend,mouseup", Ck), xm.kill(), wp(Rr);
    for (var o = 0; o < Bt.length; o += 3)
      _p(Rr, Bt[o], Bt[o + 1]), _p(Rr, Bt[o], Bt[o + 2]);
  }, t.enable = function() {
    if (Lt = window, kn = document, Ki = kn.documentElement, sn = kn.body, Ke && (sh = Ke.utils.toArray, Fd = Ke.utils.clamp, z1 = Ke.core.context || us, L0 = Ke.core.suppressOverwrites || us, e_ = Lt.history.scrollRestoration || "auto", W1 = Lt.pageYOffset || 0, Ke.core.globals("ScrollTrigger", t), sn)) {
      vd = 1, pc = document.createElement("div"), pc.style.height = "100vh", pc.style.position = "absolute", rN(), T4(), Jn.register(Ke), t.isTouch = Jn.isTouch, Ra = Jn.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent), q1 = Jn.isTouch === 1, Or(Lt, "wheel", ju), ZS = [Lt, kn, Ki, sn], Ke.matchMedia ? (t.matchMedia = function(u) {
        var c = Ke.matchMedia(), f;
        for (f in u)
          c.add(f, u[f]);
        return c;
      }, Ke.addEventListener("matchMediaInit", function() {
        return s_();
      }), Ke.addEventListener("matchMediaRevert", function() {
        return tN();
      }), Ke.addEventListener("matchMedia", function() {
        Ql(0, 1), gu("matchMedia");
      }), Ke.matchMedia().add("(orientation: portrait)", function() {
        return U0(), U0;
      })) : console.warn("Requires GSAP 3.11.0 or later"), U0(), Or(kn, "scroll", ju);
      var r = sn.hasAttribute("style"), i = sn.style, o = i.borderTopStyle, s = Ke.core.Animation.prototype, a, l;
      for (s.revert || Object.defineProperty(s, "revert", {
        value: function() {
          return this.time(-0.01, !0);
        }
      }), i.borderTopStyle = "solid", a = Js(sn), br.m = Math.round(a.top + br.sc()) || 0, di.m = Math.round(a.left + di.sc()) || 0, o ? i.borderTopStyle = o : i.removeProperty("border-top-style"), r || (sn.setAttribute("style", ""), sn.removeAttribute("style")), vp = setInterval(Ok, 250), Ke.delayedCall(0.5, function() {
        return bp = 0;
      }), Or(kn, "touchcancel", us), Or(sn, "touchstart", us), Sp(Or, kn, "pointerdown,touchstart,mousedown", xk), Sp(Or, kn, "pointerup,touchend,mouseup", Ck), U1 = Ke.utils.checkPrefix("transform"), Ug.push(U1), Qu = Xr(), xm = Ke.delayedCall(0.2, Ql).pause(), Ju = [kn, "visibilitychange", function() {
        var u = Lt.innerWidth, c = Lt.innerHeight;
        kn.hidden ? (_k = u, Ek = c) : (_k !== u || Ek !== c) && Sd();
      }, kn, "DOMContentLoaded", Ql, Lt, "load", Ql, Lt, "resize", Sd], wp(Or), Mt.forEach(function(u) {
        return u.enable(0, 1);
      }), l = 0; l < Bt.length; l += 3)
        _p(Rr, Bt[l], Bt[l + 1]), _p(Rr, Bt[l], Bt[l + 2]);
    }
  }, t.config = function(r) {
    "limitCallbacks" in r && (B0 = !!r.limitCallbacks);
    var i = r.syncInterval;
    i && clearInterval(vp) || (vp = i) && setInterval(Ok, i), "ignoreMobileResize" in r && (q1 = t.isTouch === 1 && r.ignoreMobileResize), "autoRefreshEvents" in r && (wp(Rr) || wp(Or, r.autoRefreshEvents || "none"), zI = (r.autoRefreshEvents + "").indexOf("resize") === -1);
  }, t.scrollerProxy = function(r, i) {
    var o = ki(r), s = Bt.indexOf(o), a = hu(o);
    ~s && Bt.splice(s, a ? 6 : 2), i && (a ? _s.unshift(Lt, i, sn, i, Ki, i) : _s.unshift(o, i));
  }, t.clearMatchMedia = function(r) {
    Mt.forEach(function(i) {
      return i._ctx && i._ctx.query === r && i._ctx.kill(!0, !0);
    });
  }, t.isInViewport = function(r, i, o) {
    var s = (Gi(r) ? ki(r) : r).getBoundingClientRect(), a = s[o ? su : au] * i || 0;
    return o ? s.right - a > 0 && s.left + a < Lt.innerWidth : s.bottom - a > 0 && s.top + a < Lt.innerHeight;
  }, t.positionInViewport = function(r, i, o) {
    Gi(r) && (r = ki(r));
    var s = r.getBoundingClientRect(), a = s[o ? su : au], l = i == null ? a / 2 : i in Rm ? Rm[i] * a : ~i.indexOf("%") ? parseFloat(i) * a / 100 : parseFloat(i) || 0;
    return o ? (s.left + l) / Lt.innerWidth : (s.top + l) / Lt.innerHeight;
  }, t.killAll = function(r) {
    if (Mt.slice(0).forEach(function(o) {
      return o.vars.id !== "ScrollSmoother" && o.kill();
    }), r !== !0) {
      var i = pu.killAll || [];
      pu = {}, i.forEach(function(o) {
        return o();
      });
    }
  }, t;
}();
gt.version = "3.12.7";
gt.saveStyles = function(t) {
  return t ? sh(t).forEach(function(e) {
    if (e && e.style) {
      var n = zi.indexOf(e);
      n >= 0 && zi.splice(n, 5), zi.push(e, e.style.cssText, e.getBBox && e.getAttribute("transform"), Ke.core.getCache(e), z1());
    }
  }) : zi;
};
gt.revert = function(t, e) {
  return s_(!t, e);
};
gt.create = function(t, e) {
  return new gt(t, e);
};
gt.refresh = function(t) {
  return t ? Sd(!0) : (Qu || gt.register()) && Ql(!0);
};
gt.update = function(t) {
  return ++Bt.cache && ua(t === !0 ? 2 : 0);
};
gt.clearScrollMemory = nN;
gt.maxScroll = function(t, e) {
  return vs(t, e ? di : br);
};
gt.getScrollFunc = function(t, e) {
  return al(ki(t), e ? di : br);
};
gt.getById = function(t) {
  return G1[t];
};
gt.getAll = function() {
  return Mt.filter(function(t) {
    return t.vars.id !== "ScrollSmoother";
  });
};
gt.isScrolling = function() {
  return !!To;
};
gt.snapDirectional = o_;
gt.addEventListener = function(t, e) {
  var n = pu[t] || (pu[t] = []);
  ~n.indexOf(e) || n.push(e);
};
gt.removeEventListener = function(t, e) {
  var n = pu[t], r = n && n.indexOf(e);
  r >= 0 && n.splice(r, 1);
};
gt.batch = function(t, e) {
  var n = [], r = {}, i = e.interval || 0.016, o = e.batchMax || 1e9, s = function(u, c) {
    var f = [], d = [], h = Ke.delayedCall(i, function() {
      c(f, d), f = [], d = [];
    }).pause();
    return function(p) {
      f.length || h.restart(!0), f.push(p.trigger), d.push(p), o <= f.length && h.progress(1);
    };
  }, a;
  for (a in e)
    r[a] = a.substr(0, 2) === "on" && Jr(e[a]) && a !== "onRefreshInit" ? s(a, e[a]) : e[a];
  return Jr(o) && (o = o(), Or(gt, "refresh", function() {
    return o = e.batchMax();
  })), sh(t).forEach(function(l) {
    var u = {};
    for (a in r)
      u[a] = r[a];
    u.trigger = l, n.push(gt.create(u));
  }), n;
};
var Mk = function(e, n, r, i) {
  return n > i ? e(i) : n < 0 && e(0), r > i ? (i - n) / (r - n) : r < 0 ? n / (n - r) : 1;
}, z0 = function t(e, n) {
  n === !0 ? e.style.removeProperty("touch-action") : e.style.touchAction = n === !0 ? "auto" : n ? "pan-" + n + (Jn.isTouch ? " pinch-zoom" : "") : "none", e === Ki && t(sn, n);
}, Cp = {
  auto: 1,
  scroll: 1
}, F4 = function(e) {
  var n = e.event, r = e.target, i = e.axis, o = (n.changedTouches ? n.changedTouches[0] : n).target, s = o._gsap || Ke.core.getCache(o), a = Xr(), l;
  if (!s._isScrollT || a - s._isScrollT > 2e3) {
    for (; o && o !== sn && (o.scrollHeight <= o.clientHeight && o.scrollWidth <= o.clientWidth || !(Cp[(l = vo(o)).overflowY] || Cp[l.overflowX])); )
      o = o.parentNode;
    s._isScroll = o && o !== r && !hu(o) && (Cp[(l = vo(o)).overflowY] || Cp[l.overflowX]), s._isScrollT = a;
  }
  (s._isScroll || i === "x") && (n.stopPropagation(), n._gsapAllow = !0);
}, oN = function(e, n, r, i) {
  return Jn.create({
    target: e,
    capture: !0,
    debounce: !1,
    lockAxis: !0,
    type: n,
    onWheel: i = i && F4,
    onPress: i,
    onDrag: i,
    onScroll: i,
    onEnable: function() {
      return r && Or(kn, Jn.eventTypes[0], Lk, !1, !0);
    },
    onDisable: function() {
      return Rr(kn, Jn.eventTypes[0], Lk, !0);
    }
  });
}, L4 = /(input|label|select|textarea)/i, Fk, Lk = function(e) {
  var n = L4.test(e.target.tagName);
  (n || Fk) && (e._gsapAllow = !0, Fk = n);
}, B4 = function(e) {
  zl(e) || (e = {}), e.preventDefault = e.isNormalizer = e.allowClicks = !0, e.type || (e.type = "wheel,touch"), e.debounce = !!e.debounce, e.id = e.id || "normalizer";
  var n = e, r = n.normalizeScrollX, i = n.momentum, o = n.allowNestedScroll, s = n.onRelease, a, l, u = ki(e.target) || Ki, c = Ke.core.globals().ScrollSmoother, f = c && c.get(), d = Ra && (e.content && ki(e.content) || f && e.content !== !1 && !f.smooth() && f.content()), h = al(u, br), p = al(u, di), g = 1, m = (Jn.isTouch && Lt.visualViewport ? Lt.visualViewport.scale * Lt.visualViewport.width : Lt.outerWidth) / Lt.innerWidth, v = 0, S = Jr(i) ? function() {
    return i(a);
  } : function() {
    return i || 2.8;
  }, _, b, y = oN(u, e.type, !0, o), w = function() {
    return b = !1;
  }, E = us, x = us, k = function() {
    l = vs(u, br), x = Fd(Ra ? 1 : 0, l), r && (E = Fd(0, vs(u, di))), _ = lu;
  }, C = function() {
    d._gsap.y = bd(parseFloat(d._gsap.y) + h.offset) + "px", d.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(d._gsap.y) + ", 0, 1)", h.offset = h.cacheID = 0;
  }, M = function() {
    if (b) {
      requestAnimationFrame(w);
      var ne = bd(a.deltaY / 2), X = x(h.v - ne);
      if (d && X !== h.v + h.offset) {
        h.offset = X - h.v;
        var O = bd((parseFloat(d && d._gsap.y) || 0) - h.offset);
        d.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + O + ", 0, 1)", d._gsap.y = O + "px", h.cacheID = Bt.cache, ua();
      }
      return !0;
    }
    h.offset && C(), b = !0;
  }, F, U, B, N, q = function() {
    k(), F.isActive() && F.vars.scrollY > l && (h() > l ? F.progress(1) && h(l) : F.resetTo("scrollY", l));
  };
  return d && Ke.set(d, {
    y: "+=0"
  }), e.ignoreCheck = function(Q) {
    return Ra && Q.type === "touchmove" && M() || g > 1.05 && Q.type !== "touchstart" || a.isGesturing || Q.touches && Q.touches.length > 1;
  }, e.onPress = function() {
    b = !1;
    var Q = g;
    g = bd((Lt.visualViewport && Lt.visualViewport.scale || 1) / m), F.pause(), Q !== g && z0(u, g > 1.01 ? !0 : r ? !1 : "x"), U = p(), B = h(), k(), _ = lu;
  }, e.onRelease = e.onGestureStart = function(Q, ne) {
    if (h.offset && C(), !ne)
      N.restart(!0);
    else {
      Bt.cache++;
      var X = S(), O, W;
      r && (O = p(), W = O + X * 0.05 * -Q.velocityX / 0.227, X *= Mk(p, O, W, vs(u, di)), F.vars.scrollX = E(W)), O = h(), W = O + X * 0.05 * -Q.velocityY / 0.227, X *= Mk(h, O, W, vs(u, br)), F.vars.scrollY = x(W), F.invalidate().duration(X).play(0.01), (Ra && F.vars.scrollY >= l || O >= l - 1) && Ke.to({}, {
        onUpdate: q,
        duration: X
      });
    }
    s && s(Q);
  }, e.onWheel = function() {
    F._ts && F.pause(), Xr() - v > 1e3 && (_ = 0, v = Xr());
  }, e.onChange = function(Q, ne, X, O, W) {
    if (lu !== _ && k(), ne && r && p(E(O[2] === ne ? U + (Q.startX - Q.x) : p() + ne - O[1])), X) {
      h.offset && C();
      var T = W[2] === X, $ = T ? B + Q.startY - Q.y : h() + X - W[1], P = x($);
      T && $ !== P && (B += P - $), h(P);
    }
    (X || ne) && ua();
  }, e.onEnable = function() {
    z0(u, r ? !1 : "x"), gt.addEventListener("refresh", q), Or(Lt, "resize", q), h.smooth && (h.target.style.scrollBehavior = "auto", h.smooth = p.smooth = !1), y.enable();
  }, e.onDisable = function() {
    z0(u, !0), Rr(Lt, "resize", q), gt.removeEventListener("refresh", q), y.kill();
  }, e.lockAxis = e.lockAxis !== !1, a = new Jn(e), a.iOS = Ra, Ra && !h() && h(1), Ra && Ke.ticker.add(us), N = a._dc, F = Ke.to(a, {
    ease: "power4",
    paused: !0,
    inherit: !1,
    scrollX: r ? "+=0.1" : "+=0",
    scrollY: "+=0.1",
    modifiers: {
      scrollY: iN(h, h(), function() {
        return F.pause();
      })
    },
    onUpdate: ua,
    onComplete: N.vars.onComplete
  }), a;
};
gt.sort = function(t) {
  if (Jr(t))
    return Mt.sort(t);
  var e = Lt.pageYOffset || 0;
  return gt.getAll().forEach(function(n) {
    return n._sortY = n.trigger ? e + n.trigger.getBoundingClientRect().top : n.start + Lt.innerHeight;
  }), Mt.sort(t || function(n, r) {
    return (n.vars.refreshPriority || 0) * -1e6 + (n.vars.containerAnimation ? 1e6 : n._sortY) - ((r.vars.containerAnimation ? 1e6 : r._sortY) + (r.vars.refreshPriority || 0) * -1e6);
  });
};
gt.observe = function(t) {
  return new Jn(t);
};
gt.normalizeScroll = function(t) {
  if (typeof t > "u")
    return ai;
  if (t === !0 && ai)
    return ai.enable();
  if (t === !1) {
    ai && ai.kill(), ai = t;
    return;
  }
  var e = t instanceof Jn ? t : B4(t);
  return ai && ai.target === e.target && ai.kill(), hu(e.target) && (ai = e), e;
};
gt.core = {
  // smaller file size way to leverage in ScrollSmoother and Observer
  _getVelocityProp: V1,
  _inputObserver: oN,
  _scrollers: Bt,
  _proxies: _s,
  bridge: {
    // when normalizeScroll sets the scroll position (ss = setScroll)
    ss: function() {
      To || gu("scrollStart"), To = Xr();
    },
    // a way to get the _refreshing value in Observer
    ref: function() {
      return Yr;
    }
  }
};
YI() && Ke.registerPlugin(gt);
function j4(t) {
  const e = new Error(t);
  if (e.stack === void 0)
    try {
      throw e;
    } catch {
    }
  return e;
}
var V4 = j4, wt = V4;
function U4(t) {
  return !!t && typeof t.then == "function";
}
var bn = U4;
function q4(t, e) {
  if (t != null)
    return t;
  throw wt(e ?? "Got unexpected null or undefined");
}
var Ln = q4;
function Et(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
class Sy {
  getValue() {
    throw wt("BaseLoadable");
  }
  toPromise() {
    throw wt("BaseLoadable");
  }
  valueMaybe() {
    throw wt("BaseLoadable");
  }
  valueOrThrow() {
    throw wt(`Loadable expected value, but in "${this.state}" state`);
  }
  promiseMaybe() {
    throw wt("BaseLoadable");
  }
  promiseOrThrow() {
    throw wt(`Loadable expected promise, but in "${this.state}" state`);
  }
  errorMaybe() {
    throw wt("BaseLoadable");
  }
  errorOrThrow() {
    throw wt(`Loadable expected error, but in "${this.state}" state`);
  }
  is(e) {
    return e.state === this.state && e.contents === this.contents;
  }
  map(e) {
    throw wt("BaseLoadable");
  }
}
class z4 extends Sy {
  constructor(e) {
    super(), Et(this, "state", "hasValue"), Et(this, "contents", void 0), this.contents = e;
  }
  getValue() {
    return this.contents;
  }
  toPromise() {
    return Promise.resolve(this.contents);
  }
  valueMaybe() {
    return this.contents;
  }
  valueOrThrow() {
    return this.contents;
  }
  promiseMaybe() {
  }
  errorMaybe() {
  }
  map(e) {
    try {
      const n = e(this.contents);
      return bn(n) ? mu(n) : Nc(n) ? n : $h(n);
    } catch (n) {
      return bn(n) ? (
        // If we "suspended", then try again.
        // errors and subsequent retries will be handled in 'loading' case
        // $FlowFixMe[prop-missing]
        mu(n.next(() => this.map(e)))
      ) : _y(n);
    }
  }
}
class H4 extends Sy {
  constructor(e) {
    super(), Et(this, "state", "hasError"), Et(this, "contents", void 0), this.contents = e;
  }
  getValue() {
    throw this.contents;
  }
  toPromise() {
    return Promise.reject(this.contents);
  }
  valueMaybe() {
  }
  promiseMaybe() {
  }
  errorMaybe() {
    return this.contents;
  }
  errorOrThrow() {
    return this.contents;
  }
  map(e) {
    return this;
  }
}
class sN extends Sy {
  constructor(e) {
    super(), Et(this, "state", "loading"), Et(this, "contents", void 0), this.contents = e;
  }
  getValue() {
    throw this.contents;
  }
  toPromise() {
    return this.contents;
  }
  valueMaybe() {
  }
  promiseMaybe() {
    return this.contents;
  }
  promiseOrThrow() {
    return this.contents;
  }
  errorMaybe() {
  }
  map(e) {
    return mu(this.contents.then((n) => {
      const r = e(n);
      if (Nc(r)) {
        const i = r;
        switch (i.state) {
          case "hasValue":
            return i.contents;
          case "hasError":
            throw i.contents;
          case "loading":
            return i.contents;
        }
      }
      return r;
    }).catch((n) => {
      if (bn(n))
        return n.then(() => this.map(e).contents);
      throw n;
    }));
  }
}
function $h(t) {
  return Object.freeze(new z4(t));
}
function _y(t) {
  return Object.freeze(new H4(t));
}
function mu(t) {
  return Object.freeze(new sN(t));
}
function aN() {
  return Object.freeze(new sN(new Promise(() => {
  })));
}
function G4(t) {
  return t.every((e) => e.state === "hasValue") ? $h(t.map((e) => e.contents)) : t.some((e) => e.state === "hasError") ? _y(Ln(t.find((e) => e.state === "hasError"), "Invalid loadable passed to loadableAll").contents) : mu(Promise.all(t.map((e) => e.contents)));
}
function lN(t) {
  const n = (Array.isArray(t) ? t : Object.getOwnPropertyNames(t).map((i) => t[i])).map((i) => Nc(i) ? i : bn(i) ? mu(i) : $h(i)), r = G4(n);
  return Array.isArray(t) ? (
    // $FlowIssue[incompatible-return]
    r
  ) : (
    // Object.getOwnPropertyNames() has consistent key ordering with ES6
    // $FlowIssue[incompatible-call]
    r.map((i) => Object.getOwnPropertyNames(t).reduce(
      // $FlowFixMe[invalid-computed-prop]
      (o, s, a) => ({
        ...o,
        [s]: i[a]
      }),
      {}
    ))
  );
}
function Nc(t) {
  return t instanceof Sy;
}
const W4 = {
  of: (t) => bn(t) ? mu(t) : Nc(t) ? t : $h(t),
  error: (t) => _y(t),
  // $FlowIssue[incompatible-return]
  loading: () => aN(),
  // $FlowIssue[unclear-type]
  all: lN,
  isLoadable: Nc
};
var Du = {
  loadableWithValue: $h,
  loadableWithError: _y,
  loadableWithPromise: mu,
  loadableLoading: aN,
  loadableAll: lN,
  isLoadable: Nc,
  RecoilLoadable: W4
}, Y4 = Du.loadableWithValue, X4 = Du.loadableWithError, K4 = Du.loadableWithPromise, Q4 = Du.loadableLoading, J4 = Du.loadableAll, Z4 = Du.isLoadable, e8 = Du.RecoilLoadable, Mh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  loadableWithValue: Y4,
  loadableWithError: X4,
  loadableWithPromise: K4,
  loadableLoading: Q4,
  loadableAll: J4,
  isLoadable: Z4,
  RecoilLoadable: e8
});
const X1 = {
  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: !0,
  // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
  RECOIL_GKS_ENABLED: /* @__PURE__ */ new Set(["recoil_hamt_2020", "recoil_sync_external_store", "recoil_suppress_rerender_in_callback", "recoil_memory_managament_2020"])
};
function t8(t, e) {
  var n, r;
  const i = (n = process.env[t]) === null || n === void 0 || (r = n.toLowerCase()) === null || r === void 0 ? void 0 : r.trim();
  if (i == null || i === "")
    return;
  if (!["true", "false"].includes(i))
    throw wt(`process.env.${t} value must be 'true', 'false', or empty: ${i}`);
  e(i === "true");
}
function n8(t, e) {
  var n;
  const r = (n = process.env[t]) === null || n === void 0 ? void 0 : n.trim();
  r == null || r === "" || e(r.split(/\s*,\s*|\s+/));
}
function r8() {
  var t;
  typeof process > "u" || ((t = process) === null || t === void 0 ? void 0 : t.env) != null && (t8("RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED", (e) => {
    X1.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = e;
  }), n8("RECOIL_GKS_ENABLED", (e) => {
    e.forEach((n) => {
      X1.RECOIL_GKS_ENABLED.add(n);
    });
  }));
}
r8();
var cf = X1;
function Ey(t) {
  return cf.RECOIL_GKS_ENABLED.has(t);
}
Ey.setPass = (t) => {
  cf.RECOIL_GKS_ENABLED.add(t);
};
Ey.setFail = (t) => {
  cf.RECOIL_GKS_ENABLED.delete(t);
};
Ey.clear = () => {
  cf.RECOIL_GKS_ENABLED.clear();
};
var xn = Ey;
function i8(t, e, {
  error: n
} = {}) {
  return process.env.NODE_ENV !== "production" && console.error(t, n), null;
}
var o8 = i8, ni = o8, H0, G0, W0;
const s8 = (
  // flowlint-next-line unclear-type:off
  (H0 = nt.createMutableSource) !== null && H0 !== void 0 ? H0 : nt.unstable_createMutableSource
), uN = (
  // flowlint-next-line unclear-type:off
  (G0 = nt.useMutableSource) !== null && G0 !== void 0 ? G0 : nt.unstable_useMutableSource
), a_ = (
  // flowlint-next-line unclear-type:off
  (W0 = nt.useSyncExternalStore) !== null && W0 !== void 0 ? W0 : (
    // flowlint-next-line unclear-type:off
    nt.unstable_useSyncExternalStore
  )
);
let Bk = !1;
function a8() {
  var t;
  const {
    ReactCurrentDispatcher: e,
    ReactCurrentOwner: n
  } = (
    /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
     * to detect if the current renderer supports useSyncExternalStore()
     * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */
    nt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
  ), i = ((t = e?.current) !== null && t !== void 0 ? t : n.currentDispatcher).useSyncExternalStore != null;
  return a_ && !i && !Bk && (Bk = !0, ni("A React renderer without React 18+ API support is being used with React 18+.")), i;
}
function l8() {
  return xn("recoil_transition_support") ? {
    mode: "TRANSITION_SUPPORT",
    early: !0,
    concurrent: !0
  } : xn("recoil_sync_external_store") && a_ != null ? {
    mode: "SYNC_EXTERNAL_STORE",
    early: !0,
    concurrent: !1
  } : xn("recoil_mutable_source") && uN != null && typeof window < "u" && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE ? xn("recoil_suppress_rerender_in_callback") ? {
    mode: "MUTABLE_SOURCE",
    early: !0,
    concurrent: !0
  } : {
    mode: "MUTABLE_SOURCE",
    early: !1,
    concurrent: !1
  } : xn("recoil_suppress_rerender_in_callback") ? {
    mode: "LEGACY",
    early: !0,
    concurrent: !1
  } : {
    mode: "LEGACY",
    early: !1,
    concurrent: !1
  };
}
var l_ = {
  createMutableSource: s8,
  useMutableSource: uN,
  useSyncExternalStore: a_,
  currentRendererSupportsUseSyncExternalStore: a8,
  reactMode: l8
};
class u_ {
  constructor(e) {
    Et(this, "key", void 0), this.key = e;
  }
  toJSON() {
    return {
      key: this.key
    };
  }
}
class cN extends u_ {
}
class fN extends u_ {
}
function u8(t) {
  return t instanceof cN || t instanceof fN;
}
var ky = {
  AbstractRecoilValue: u_,
  RecoilState: cN,
  RecoilValueReadOnly: fN,
  isRecoilValue: u8
}, c8 = ky.AbstractRecoilValue, f8 = ky.RecoilState, d8 = ky.RecoilValueReadOnly, h8 = ky.isRecoilValue, yu = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AbstractRecoilValue: c8,
  RecoilState: f8,
  RecoilValueReadOnly: d8,
  isRecoilValue: h8
});
function p8(t, ...e) {
  let n = 0;
  return t.replace(/%s/g, () => String(e[n++]));
}
var g8 = p8;
function m8(t, ...e) {
  if (process.env.NODE_ENV !== "production") {
    const n = g8.call(null, t, ...e), r = new Error(n);
    r.name = "Expectation Violation", console.error(r);
  }
}
var y8 = m8, c_ = y8;
function v8(t, e) {
  return function* () {
    let n = 0;
    for (const r of t)
      yield e(r, n++);
  }();
}
var Ty = v8;
class dN {
}
const b8 = new dN(), Pc = /* @__PURE__ */ new Map(), f_ = /* @__PURE__ */ new Map();
function w8(t) {
  return Ty(t, (e) => Ln(f_.get(e)));
}
function S8(t) {
  if (Pc.has(t)) {
    const e = `Duplicate atom key "${t}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;
    process.env.NODE_ENV !== "production" ? c_(e, "recoil") : console.warn(e);
  }
}
function _8(t) {
  cf.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED && S8(t.key), Pc.set(t.key, t);
  const e = t.set == null ? new yu.RecoilValueReadOnly(t.key) : new yu.RecoilState(t.key);
  return f_.set(t.key, e), e;
}
class E8 extends Error {
}
function k8(t) {
  const e = Pc.get(t);
  if (e == null)
    throw new E8(`Missing definition for RecoilValue: "${t}""`);
  return e;
}
function T8(t) {
  return Pc.get(t);
}
const Om = /* @__PURE__ */ new Map();
function x8(t) {
  var e;
  if (!xn("recoil_memory_managament_2020"))
    return;
  const n = Pc.get(t);
  if (n != null && (e = n.shouldDeleteConfigOnRelease) !== null && e !== void 0 && e.call(n)) {
    var r;
    Pc.delete(t), (r = hN(t)) === null || r === void 0 || r(), Om.delete(t);
  }
}
function C8(t, e) {
  xn("recoil_memory_managament_2020") && (e === void 0 ? Om.delete(t) : Om.set(t, e));
}
function hN(t) {
  return Om.get(t);
}
var ao = {
  recoilValues: f_,
  registerNode: _8,
  getNode: k8,
  getNodeMaybe: T8,
  deleteNodeConfigIfPossible: x8,
  setConfigDeletionHandler: C8,
  getConfigDeletionHandler: hN,
  recoilValuesForKeys: w8,
  DefaultValue: dN,
  DEFAULT_VALUE: b8
};
function A8(t, e) {
  e();
}
var R8 = {
  enqueueExecution: A8
};
function O8(t, e) {
  return e = { exports: {} }, t(e, e.exports), e.exports;
}
var D8 = O8(function(t) {
  var e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ce) {
    return typeof ce;
  } : function(ce) {
    return ce && typeof Symbol == "function" && ce.constructor === Symbol && ce !== Symbol.prototype ? "symbol" : typeof ce;
  }, n = {}, r = 5, i = Math.pow(2, r), o = i - 1, s = i / 2, a = i / 4, l = {}, u = function(ie) {
    return function() {
      return ie;
    };
  }, c = n.hash = function(ce) {
    var ie = typeof ce > "u" ? "undefined" : e(ce);
    if (ie === "number") return ce;
    ie !== "string" && (ce += "");
    for (var ke = 0, Ae = 0, we = ce.length; Ae < we; ++Ae) {
      var Ie = ce.charCodeAt(Ae);
      ke = (ke << 5) - ke + Ie | 0;
    }
    return ke;
  }, f = function(ie) {
    return ie -= ie >> 1 & 1431655765, ie = (ie & 858993459) + (ie >> 2 & 858993459), ie = ie + (ie >> 4) & 252645135, ie += ie >> 8, ie += ie >> 16, ie & 127;
  }, d = function(ie, ke) {
    return ke >>> ie & o;
  }, h = function(ie) {
    return 1 << ie;
  }, p = function(ie, ke) {
    return f(ie & ke - 1);
  }, g = function(ie, ke, Ae, we) {
    var Ie = we;
    if (!ie) {
      var R = we.length;
      Ie = new Array(R);
      for (var I = 0; I < R; ++I)
        Ie[I] = we[I];
    }
    return Ie[ke] = Ae, Ie;
  }, m = function(ie, ke, Ae) {
    var we = Ae.length - 1, Ie = 0, R = 0, I = Ae;
    if (ie)
      Ie = R = ke;
    else
      for (I = new Array(we); Ie < ke; )
        I[R++] = Ae[Ie++];
    for (++Ie; Ie <= we; )
      I[R++] = Ae[Ie++];
    return ie && (I.length = we), I;
  }, v = function(ie, ke, Ae, we) {
    var Ie = we.length;
    if (ie) {
      for (var R = Ie; R >= ke; )
        we[R--] = we[R];
      return we[ke] = Ae, we;
    }
    for (var I = 0, j = 0, te = new Array(Ie + 1); I < ke; )
      te[j++] = we[I++];
    for (te[ke] = Ae; I < Ie; )
      te[++j] = we[I++];
    return te;
  }, S = 1, _ = 2, b = 3, y = 4, w = {
    __hamt_isEmpty: !0
  }, E = function(ie) {
    return ie === w || ie && ie.__hamt_isEmpty;
  }, x = function(ie, ke, Ae, we) {
    return {
      type: S,
      edit: ie,
      hash: ke,
      key: Ae,
      value: we,
      _modify: ne
    };
  }, k = function(ie, ke, Ae) {
    return {
      type: _,
      edit: ie,
      hash: ke,
      children: Ae,
      _modify: X
    };
  }, C = function(ie, ke, Ae) {
    return {
      type: b,
      edit: ie,
      mask: ke,
      children: Ae,
      _modify: O
    };
  }, M = function(ie, ke, Ae) {
    return {
      type: y,
      edit: ie,
      size: ke,
      children: Ae,
      _modify: W
    };
  }, F = function(ie) {
    return ie === w || ie.type === S || ie.type === _;
  }, U = function(ie, ke, Ae, we, Ie) {
    for (var R = [], I = we, j = 0, te = 0; I; ++te)
      I & 1 && (R[te] = Ie[j++]), I >>>= 1;
    return R[ke] = Ae, M(ie, j + 1, R);
  }, B = function(ie, ke, Ae, we) {
    for (var Ie = new Array(ke - 1), R = 0, I = 0, j = 0, te = we.length; j < te; ++j)
      if (j !== Ae) {
        var Ee = we[j];
        Ee && !E(Ee) && (Ie[R++] = Ee, I |= 1 << j);
      }
    return C(ie, I, Ie);
  }, N = function ce(ie, ke, Ae, we, Ie, R) {
    if (Ae === Ie) return k(ie, Ae, [R, we]);
    var I = d(ke, Ae), j = d(ke, Ie);
    return C(ie, h(I) | h(j), I === j ? [ce(ie, ke + r, Ae, we, Ie, R)] : I < j ? [we, R] : [R, we]);
  }, q = function(ie, ke, Ae, we, Ie, R, I, j) {
    for (var te = Ie.length, Ee = 0; Ee < te; ++Ee) {
      var Ue = Ie[Ee];
      if (Ae(I, Ue.key)) {
        var ut = Ue.value, qe = R(ut);
        return qe === ut ? Ie : qe === l ? (--j.value, m(ie, Ee, Ie)) : g(ie, Ee, x(ke, we, I, qe), Ie);
      }
    }
    var ze = R();
    return ze === l ? Ie : (++j.value, g(ie, te, x(ke, we, I, ze), Ie));
  }, Q = function(ie, ke) {
    return ie === ke.edit;
  }, ne = function(ie, ke, Ae, we, Ie, R, I) {
    if (ke(R, this.key)) {
      var j = we(this.value);
      return j === this.value ? this : j === l ? (--I.value, w) : Q(ie, this) ? (this.value = j, this) : x(ie, Ie, R, j);
    }
    var te = we();
    return te === l ? this : (++I.value, N(ie, Ae, this.hash, this, Ie, x(ie, Ie, R, te)));
  }, X = function(ie, ke, Ae, we, Ie, R, I) {
    if (Ie === this.hash) {
      var j = Q(ie, this), te = q(j, ie, ke, this.hash, this.children, we, R, I);
      return te === this.children ? this : te.length > 1 ? k(ie, this.hash, te) : te[0];
    }
    var Ee = we();
    return Ee === l ? this : (++I.value, N(ie, Ae, this.hash, this, Ie, x(ie, Ie, R, Ee)));
  }, O = function(ie, ke, Ae, we, Ie, R, I) {
    var j = this.mask, te = this.children, Ee = d(Ae, Ie), Ue = h(Ee), ut = p(j, Ue), qe = j & Ue, ze = qe ? te[ut] : w, dt = ze._modify(ie, ke, Ae + r, we, Ie, R, I);
    if (ze === dt) return this;
    var Ce = Q(ie, this), Ze = j, Ge = void 0;
    if (qe && E(dt)) {
      if (Ze &= ~Ue, !Ze) return w;
      if (te.length <= 2 && F(te[ut ^ 1])) return te[ut ^ 1];
      Ge = m(Ce, ut, te);
    } else if (!qe && !E(dt)) {
      if (te.length >= s) return U(ie, Ee, dt, j, te);
      Ze |= Ue, Ge = v(Ce, ut, dt, te);
    } else
      Ge = g(Ce, ut, dt, te);
    return Ce ? (this.mask = Ze, this.children = Ge, this) : C(ie, Ze, Ge);
  }, W = function(ie, ke, Ae, we, Ie, R, I) {
    var j = this.size, te = this.children, Ee = d(Ae, Ie), Ue = te[Ee], ut = (Ue || w)._modify(ie, ke, Ae + r, we, Ie, R, I);
    if (Ue === ut) return this;
    var qe = Q(ie, this), ze = void 0;
    if (E(Ue) && !E(ut))
      ++j, ze = g(qe, Ee, ut, te);
    else if (!E(Ue) && E(ut)) {
      if (--j, j <= a) return B(ie, j, Ee, te);
      ze = g(qe, Ee, w, te);
    } else
      ze = g(qe, Ee, ut, te);
    return qe ? (this.size = j, this.children = ze, this) : M(ie, j, ze);
  };
  w._modify = function(ce, ie, ke, Ae, we, Ie, R) {
    var I = Ae();
    return I === l ? w : (++R.value, x(ce, we, Ie, I));
  };
  function T(ce, ie, ke, Ae, we) {
    this._editable = ce, this._edit = ie, this._config = ke, this._root = Ae, this._size = we;
  }
  T.prototype.setTree = function(ce, ie) {
    return this._editable ? (this._root = ce, this._size = ie, this) : ce === this._root ? this : new T(this._editable, this._edit, this._config, ce, ie);
  };
  var $ = n.tryGetHash = function(ce, ie, ke, Ae) {
    for (var we = Ae._root, Ie = 0, R = Ae._config.keyEq; ; )
      switch (we.type) {
        case S:
          return R(ke, we.key) ? we.value : ce;
        case _: {
          if (ie === we.hash)
            for (var I = we.children, j = 0, te = I.length; j < te; ++j) {
              var Ee = I[j];
              if (R(ke, Ee.key)) return Ee.value;
            }
          return ce;
        }
        case b: {
          var Ue = d(Ie, ie), ut = h(Ue);
          if (we.mask & ut) {
            we = we.children[p(we.mask, ut)], Ie += r;
            break;
          }
          return ce;
        }
        case y: {
          if (we = we.children[d(Ie, ie)], we) {
            Ie += r;
            break;
          }
          return ce;
        }
        default:
          return ce;
      }
  };
  T.prototype.tryGetHash = function(ce, ie, ke) {
    return $(ce, ie, ke, this);
  };
  var P = n.tryGet = function(ce, ie, ke) {
    return $(ce, ke._config.hash(ie), ie, ke);
  };
  T.prototype.tryGet = function(ce, ie) {
    return P(ce, ie, this);
  };
  var H = n.getHash = function(ce, ie, ke) {
    return $(void 0, ce, ie, ke);
  };
  T.prototype.getHash = function(ce, ie) {
    return H(ce, ie, this);
  }, n.get = function(ce, ie) {
    return $(void 0, ie._config.hash(ce), ce, ie);
  }, T.prototype.get = function(ce, ie) {
    return P(ie, ce, this);
  };
  var Z = n.has = function(ce, ie, ke) {
    return $(l, ce, ie, ke) !== l;
  };
  T.prototype.hasHash = function(ce, ie) {
    return Z(ce, ie, this);
  };
  var le = n.has = function(ce, ie) {
    return Z(ie._config.hash(ce), ce, ie);
  };
  T.prototype.has = function(ce) {
    return le(ce, this);
  };
  var J = function(ie, ke) {
    return ie === ke;
  };
  n.make = function(ce) {
    return new T(0, 0, {
      keyEq: ce && ce.keyEq || J,
      hash: ce && ce.hash || c
    }, w, 0);
  }, n.empty = n.make();
  var ue = n.isEmpty = function(ce) {
    return ce && !!E(ce._root);
  };
  T.prototype.isEmpty = function() {
    return ue(this);
  };
  var he = n.modifyHash = function(ce, ie, ke, Ae) {
    var we = {
      value: Ae._size
    }, Ie = Ae._root._modify(Ae._editable ? Ae._edit : NaN, Ae._config.keyEq, 0, ce, ie, ke, we);
    return Ae.setTree(Ie, we.value);
  };
  T.prototype.modifyHash = function(ce, ie, ke) {
    return he(ke, ce, ie, this);
  };
  var me = n.modify = function(ce, ie, ke) {
    return he(ce, ke._config.hash(ie), ie, ke);
  };
  T.prototype.modify = function(ce, ie) {
    return me(ie, ce, this);
  };
  var oe = n.setHash = function(ce, ie, ke, Ae) {
    return he(u(ke), ce, ie, Ae);
  };
  T.prototype.setHash = function(ce, ie, ke) {
    return oe(ce, ie, ke, this);
  };
  var re = n.set = function(ce, ie, ke) {
    return oe(ke._config.hash(ce), ce, ie, ke);
  };
  T.prototype.set = function(ce, ie) {
    return re(ce, ie, this);
  };
  var se = u(l), ae = n.removeHash = function(ce, ie, ke) {
    return he(se, ce, ie, ke);
  };
  T.prototype.removeHash = T.prototype.deleteHash = function(ce, ie) {
    return ae(ce, ie, this);
  };
  var fe = n.remove = function(ce, ie) {
    return ae(ie._config.hash(ce), ce, ie);
  };
  T.prototype.remove = T.prototype.delete = function(ce) {
    return fe(ce, this);
  };
  var Y = n.beginMutation = function(ce) {
    return new T(ce._editable + 1, ce._edit + 1, ce._config, ce._root, ce._size);
  };
  T.prototype.beginMutation = function() {
    return Y(this);
  };
  var Re = n.endMutation = function(ce) {
    return ce._editable = ce._editable && ce._editable - 1, ce;
  };
  T.prototype.endMutation = function() {
    return Re(this);
  };
  var ee = n.mutate = function(ce, ie) {
    var ke = Y(ie);
    return ce(ke), Re(ke);
  };
  T.prototype.mutate = function(ce) {
    return ee(ce, this);
  };
  var Ye = function(ie) {
    return ie && Te(ie[0], ie[1], ie[2], ie[3], ie[4]);
  }, Te = function(ie, ke, Ae, we, Ie) {
    for (; Ae < ie; ) {
      var R = ke[Ae++];
      if (R && !E(R)) return ve(R, we, [ie, ke, Ae, we, Ie]);
    }
    return Ye(Ie);
  }, ve = function(ie, ke, Ae) {
    switch (ie.type) {
      case S:
        return {
          value: ke(ie),
          rest: Ae
        };
      case _:
      case y:
      case b:
        var we = ie.children;
        return Te(we.length, we, 0, ke, Ae);
      default:
        return Ye(Ae);
    }
  }, Oe = {
    done: !0
  };
  function Je(ce) {
    this.v = ce;
  }
  Je.prototype.next = function() {
    if (!this.v) return Oe;
    var ce = this.v;
    return this.v = Ye(ce.rest), ce;
  }, Je.prototype[Symbol.iterator] = function() {
    return this;
  };
  var pt = function(ie, ke) {
    return new Je(ve(ie._root, ke));
  }, Pt = function(ie) {
    return [ie.key, ie.value];
  }, bt = n.entries = function(ce) {
    return pt(ce, Pt);
  };
  T.prototype.entries = T.prototype[Symbol.iterator] = function() {
    return bt(this);
  };
  var Ft = function(ie) {
    return ie.key;
  }, mt = n.keys = function(ce) {
    return pt(ce, Ft);
  };
  T.prototype.keys = function() {
    return mt(this);
  };
  var ln = function(ie) {
    return ie.value;
  }, jn = n.values = T.prototype.values = function(ce) {
    return pt(ce, ln);
  };
  T.prototype.values = function() {
    return jn(this);
  };
  var $t = n.fold = function(ce, ie, ke) {
    var Ae = ke._root;
    if (Ae.type === S) return ce(ie, Ae.value, Ae.key);
    for (var we = [Ae.children], Ie = void 0; Ie = we.pop(); )
      for (var R = 0, I = Ie.length; R < I; ) {
        var j = Ie[R++];
        j && j.type && (j.type === S ? ie = ce(ie, j.value, j.key) : we.push(j.children));
      }
    return ie;
  };
  T.prototype.fold = function(ce, ie) {
    return $t(ce, ie, this);
  };
  var Tr = n.forEach = function(ce, ie) {
    return $t(function(ke, Ae, we) {
      return ce(Ae, we, ie);
    }, null, ie);
  };
  T.prototype.forEach = function(ce) {
    return Tr(ce, this);
  };
  var xr = n.count = function(ce) {
    return ce._size;
  };
  T.prototype.count = function() {
    return xr(this);
  }, Object.defineProperty(T.prototype, "size", {
    get: T.prototype.count
  }), t.exports ? t.exports = n : (void 0).hamt = n;
});
class I8 {
  constructor(e) {
    Et(this, "_map", void 0), this._map = new Map(e?.entries());
  }
  keys() {
    return this._map.keys();
  }
  entries() {
    return this._map.entries();
  }
  get(e) {
    return this._map.get(e);
  }
  has(e) {
    return this._map.has(e);
  }
  set(e, n) {
    return this._map.set(e, n), this;
  }
  delete(e) {
    return this._map.delete(e), this;
  }
  clone() {
    return h_(this);
  }
  toMap() {
    return new Map(this._map);
  }
}
class d_ {
  // Because hamt.empty is not a function there is no way to introduce type
  // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
  // $FlowIssue
  constructor(e) {
    if (Et(this, "_hamt", D8.empty.beginMutation()), e instanceof d_) {
      const n = e._hamt.endMutation();
      e._hamt = n.beginMutation(), this._hamt = n.beginMutation();
    } else if (e)
      for (const [n, r] of e.entries())
        this._hamt.set(n, r);
  }
  keys() {
    return this._hamt.keys();
  }
  entries() {
    return this._hamt.entries();
  }
  get(e) {
    return this._hamt.get(e);
  }
  has(e) {
    return this._hamt.has(e);
  }
  set(e, n) {
    return this._hamt.set(e, n), this;
  }
  delete(e) {
    return this._hamt.delete(e), this;
  }
  clone() {
    return h_(this);
  }
  toMap() {
    return new Map(this._hamt);
  }
}
function h_(t) {
  return xn("recoil_hamt_2020") ? new d_(t) : new I8(t);
}
var N8 = {
  persistentMap: h_
}, P8 = N8.persistentMap, $8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  persistentMap: P8
});
function M8(t, ...e) {
  const n = /* @__PURE__ */ new Set();
  e: for (const r of t) {
    for (const i of e)
      if (i.has(r))
        continue e;
    n.add(r);
  }
  return n;
}
var jk = M8;
function F8(t, e) {
  const n = /* @__PURE__ */ new Map();
  return t.forEach((r, i) => {
    n.set(i, e(r, i));
  }), n;
}
var Vk = F8;
function L8() {
  return {
    nodeDeps: /* @__PURE__ */ new Map(),
    nodeToNodeSubscriptions: /* @__PURE__ */ new Map()
  };
}
function B8(t) {
  return {
    nodeDeps: Vk(t.nodeDeps, (e) => new Set(e)),
    nodeToNodeSubscriptions: Vk(t.nodeToNodeSubscriptions, (e) => new Set(e))
  };
}
function Y0(t, e, n, r) {
  const {
    nodeDeps: i,
    nodeToNodeSubscriptions: o
  } = n, s = i.get(t);
  if (s && r && s !== r.nodeDeps.get(t))
    return;
  i.set(t, e);
  const a = s == null ? e : jk(e, s);
  for (const l of a)
    o.has(l) || o.set(l, /* @__PURE__ */ new Set()), Ln(o.get(l)).add(t);
  if (s) {
    const l = jk(s, e);
    for (const u of l) {
      if (!o.has(u))
        return;
      const c = Ln(o.get(u));
      c.delete(t), c.size === 0 && o.delete(u);
    }
  }
}
function j8(t, e, n, r) {
  var i, o, s, a;
  const l = n.getState();
  r === l.currentTree.version || r === ((i = l.nextTree) === null || i === void 0 ? void 0 : i.version) || r === ((o = l.previousTree) === null || o === void 0 ? void 0 : o.version) || ni("Tried to save dependencies to a discarded tree");
  const u = n.getGraph(r);
  if (Y0(t, e, u), r === ((s = l.previousTree) === null || s === void 0 ? void 0 : s.version)) {
    const f = n.getGraph(l.currentTree.version);
    Y0(t, e, f, u);
  }
  if (r === ((a = l.previousTree) === null || a === void 0 ? void 0 : a.version) || r === l.currentTree.version) {
    var c;
    const f = (c = l.nextTree) === null || c === void 0 ? void 0 : c.version;
    if (f !== void 0) {
      const d = n.getGraph(f);
      Y0(t, e, d, u);
    }
  }
}
var Fh = {
  cloneGraph: B8,
  graph: L8,
  saveDepsToStore: j8
};
let V8 = 0;
const U8 = () => V8++;
let q8 = 0;
const z8 = () => q8++;
let H8 = 0;
const G8 = () => H8++;
var xy = {
  getNextTreeStateVersion: U8,
  getNextStoreID: z8,
  getNextComponentID: G8
};
const {
  persistentMap: Uk
} = $8, {
  graph: W8
} = Fh, {
  getNextTreeStateVersion: pN
} = xy;
function Y8() {
  const t = pN();
  return {
    version: t,
    stateID: t,
    transactionMetadata: {},
    dirtyAtoms: /* @__PURE__ */ new Set(),
    atomValues: Uk(),
    nonvalidatedAtoms: Uk()
  };
}
function X8() {
  const t = Y8();
  return {
    currentTree: t,
    nextTree: null,
    previousTree: null,
    commitDepth: 0,
    knownAtoms: /* @__PURE__ */ new Set(),
    knownSelectors: /* @__PURE__ */ new Set(),
    transactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeTransactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeToComponentSubscriptions: /* @__PURE__ */ new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: /* @__PURE__ */ new Set(),
    graphsByVersion: (/* @__PURE__ */ new Map()).set(t.version, W8()),
    retention: {
      referenceCounts: /* @__PURE__ */ new Map(),
      nodesRetainedByZone: /* @__PURE__ */ new Map(),
      retainablesToCheckForRelease: /* @__PURE__ */ new Set()
    },
    nodeCleanupFunctions: /* @__PURE__ */ new Map()
  };
}
var gN = {
  makeEmptyStoreState: X8,
  getNextTreeStateVersion: pN
};
class K8 {
}
var p_ = {
  RetentionZone: K8
};
function Q8(t, e) {
  const n = new Set(t);
  return n.add(e), n;
}
var J8 = {
  setByAddingToSet: Q8
};
function* Z8(t, e) {
  let n = 0;
  for (const r of t)
    e(r, n++) && (yield r);
}
var g_ = Z8;
function ej(t, e) {
  return new Proxy(t, {
    // Compute and cache lazy property if not already done.
    get: (r, i) => (!(i in r) && i in e && (r[i] = e[i]()), r[i]),
    // This method allows user to iterate keys as normal
    ownKeys: (r) => Object.keys(r)
  });
}
var mN = ej;
const {
  getNode: Lh,
  getNodeMaybe: tj,
  recoilValuesForKeys: qk
} = ao, {
  RetentionZone: zk
} = p_, {
  setByAddingToSet: nj
} = J8, rj = Object.freeze(/* @__PURE__ */ new Set());
class ij extends Error {
}
function oj(t, e, n) {
  if (!xn("recoil_memory_managament_2020"))
    return () => {
    };
  const {
    nodesRetainedByZone: r
  } = t.getState().retention;
  function i(o) {
    let s = r.get(o);
    s || r.set(o, s = /* @__PURE__ */ new Set()), s.add(e);
  }
  if (n instanceof zk)
    i(n);
  else if (Array.isArray(n))
    for (const o of n)
      i(o);
  return () => {
    if (!xn("recoil_memory_managament_2020"))
      return;
    const {
      retention: o
    } = t.getState();
    function s(a) {
      const l = o.nodesRetainedByZone.get(a);
      l?.delete(e), l && l.size === 0 && o.nodesRetainedByZone.delete(a);
    }
    if (n instanceof zk)
      s(n);
    else if (Array.isArray(n))
      for (const a of n)
        s(a);
  };
}
function m_(t, e, n, r) {
  const i = t.getState();
  if (i.nodeCleanupFunctions.has(n))
    return;
  const o = Lh(n), s = oj(t, n, o.retainedBy), a = o.init(t, e, r);
  i.nodeCleanupFunctions.set(n, () => {
    a(), s();
  });
}
function sj(t, e, n) {
  m_(t, t.getState().currentTree, e, n);
}
function aj(t, e) {
  var n;
  const r = t.getState();
  (n = r.nodeCleanupFunctions.get(e)) === null || n === void 0 || n(), r.nodeCleanupFunctions.delete(e);
}
function lj(t, e, n) {
  return m_(t, e, n, "get"), Lh(n).get(t, e);
}
function yN(t, e, n) {
  return Lh(n).peek(t, e);
}
function uj(t, e, n) {
  var r;
  const i = tj(e);
  return i == null || (r = i.invalidate) === null || r === void 0 || r.call(i, t), {
    ...t,
    atomValues: t.atomValues.clone().delete(e),
    nonvalidatedAtoms: t.nonvalidatedAtoms.clone().set(e, n),
    dirtyAtoms: nj(t.dirtyAtoms, e)
  };
}
function cj(t, e, n, r) {
  const i = Lh(n);
  if (i.set == null)
    throw new ij(`Attempt to set read-only RecoilValue: ${n}`);
  const o = i.set;
  return m_(t, e, n, "set"), o(t, e, r);
}
function fj(t, e, n) {
  const r = t.getState(), i = t.getGraph(e.version), o = Lh(n).nodeType;
  return mN({
    type: o
  }, {
    // $FlowFixMe[underconstrained-implicit-instantiation]
    loadable: () => yN(t, e, n),
    isActive: () => r.knownAtoms.has(n) || r.knownSelectors.has(n),
    isSet: () => o === "selector" ? !1 : e.atomValues.has(n),
    isModified: () => e.dirtyAtoms.has(n),
    // Report current dependencies.  If the node hasn't been evaluated, then
    // dependencies may be missing based on the current state.
    deps: () => {
      var s;
      return qk((s = i.nodeDeps.get(n)) !== null && s !== void 0 ? s : []);
    },
    // Reports all "current" subscribers.  Evaluating other nodes or
    // previous in-progress async evaluations may introduce new subscribers.
    subscribers: () => {
      var s, a;
      return {
        nodes: qk(g_(vN(t, e, /* @__PURE__ */ new Set([n])), (l) => l !== n)),
        components: Ty((s = (a = r.nodeToComponentSubscriptions.get(n)) === null || a === void 0 ? void 0 : a.values()) !== null && s !== void 0 ? s : [], ([l]) => ({
          name: l
        }))
      };
    }
  });
}
function vN(t, e, n) {
  const r = /* @__PURE__ */ new Set(), i = Array.from(n), o = t.getGraph(e.version);
  for (let a = i.pop(); a; a = i.pop()) {
    var s;
    r.add(a);
    const l = (s = o.nodeToNodeSubscriptions.get(a)) !== null && s !== void 0 ? s : rj;
    for (const u of l)
      r.has(u) || i.push(u);
  }
  return r;
}
var Iu = {
  getNodeLoadable: lj,
  peekNodeLoadable: yN,
  setNodeValue: cj,
  initializeNode: sj,
  cleanUpNode: aj,
  setUnvalidatedAtomValue_DEPRECATED: uj,
  peekNodeInfo: fj,
  getDownstreamNodes: vN
};
let bN = null;
function dj(t) {
  bN = t;
}
function hj() {
  var t;
  (t = bN) === null || t === void 0 || t();
}
var wN = {
  setInvalidateMemoizedSnapshot: dj,
  invalidateMemoizedSnapshot: hj
};
const {
  getDownstreamNodes: pj,
  getNodeLoadable: SN,
  setNodeValue: gj
} = Iu, {
  getNextComponentID: mj
} = xy, {
  getNode: yj,
  getNodeMaybe: _N
} = ao, {
  DefaultValue: y_
} = ao, {
  reactMode: vj
} = l_, {
  AbstractRecoilValue: bj,
  RecoilState: $ae,
  RecoilValueReadOnly: Mae,
  isRecoilValue: Fae
} = yu, {
  invalidateMemoizedSnapshot: wj
} = wN;
function Sj(t, {
  key: e
}, n = t.getState().currentTree) {
  var r, i;
  const o = t.getState();
  n.version === o.currentTree.version || n.version === ((r = o.nextTree) === null || r === void 0 ? void 0 : r.version) || n.version === ((i = o.previousTree) === null || i === void 0 ? void 0 : i.version) || ni("Tried to read from a discarded tree");
  const s = SN(t, n, e);
  return s.state === "loading" && s.contents.catch(() => {
  }), s;
}
function _j(t, e) {
  const n = t.clone();
  return e.forEach((r, i) => {
    r.state === "hasValue" && r.contents instanceof y_ ? n.delete(i) : n.set(i, r);
  }), n;
}
function Ej(t, e, {
  key: n
}, r) {
  if (typeof r == "function") {
    const i = SN(t, e, n);
    if (i.state === "loading") {
      const o = `Tried to set atom or selector "${n}" using an updater function while the current state is pending, this is not currently supported.`;
      throw ni(o), wt(o);
    } else if (i.state === "hasError")
      throw i.contents;
    return r(i.contents);
  } else
    return r;
}
function kj(t, e, n) {
  if (n.type === "set") {
    const {
      recoilValue: i,
      valueOrUpdater: o
    } = n, s = Ej(t, e, i, o), a = gj(t, e, i.key, s);
    for (const [l, u] of a.entries())
      K1(e, l, u);
  } else if (n.type === "setLoadable") {
    const {
      recoilValue: {
        key: i
      },
      loadable: o
    } = n;
    K1(e, i, o);
  } else if (n.type === "markModified") {
    const {
      recoilValue: {
        key: i
      }
    } = n;
    e.dirtyAtoms.add(i);
  } else if (n.type === "setUnvalidated") {
    var r;
    const {
      recoilValue: {
        key: i
      },
      unvalidatedValue: o
    } = n, s = _N(i);
    s == null || (r = s.invalidate) === null || r === void 0 || r.call(s, e), e.atomValues.delete(i), e.nonvalidatedAtoms.set(i, o), e.dirtyAtoms.add(i);
  } else
    ni(`Unknown action ${n.type}`);
}
function K1(t, e, n) {
  n.state === "hasValue" && n.contents instanceof y_ ? t.atomValues.delete(e) : t.atomValues.set(e, n), t.dirtyAtoms.add(e), t.nonvalidatedAtoms.delete(e);
}
function EN(t, e) {
  t.replaceState((n) => {
    const r = kN(n);
    for (const i of e)
      kj(t, r, i);
    return TN(t, r), wj(), r;
  });
}
function Cy(t, e) {
  if (qd.length) {
    const n = qd[qd.length - 1];
    let r = n.get(t);
    r || n.set(t, r = []), r.push(e);
  } else
    EN(t, [e]);
}
const qd = [];
function Tj() {
  const t = /* @__PURE__ */ new Map();
  return qd.push(t), () => {
    for (const [n, r] of t)
      EN(n, r);
    qd.pop() !== t && ni("Incorrect order of batch popping");
  };
}
function kN(t) {
  return {
    ...t,
    atomValues: t.atomValues.clone(),
    nonvalidatedAtoms: t.nonvalidatedAtoms.clone(),
    dirtyAtoms: new Set(t.dirtyAtoms)
  };
}
function TN(t, e) {
  const n = pj(t, e, e.dirtyAtoms);
  for (const o of n) {
    var r, i;
    (r = _N(o)) === null || r === void 0 || (i = r.invalidate) === null || i === void 0 || i.call(r, e);
  }
}
function xN(t, e, n) {
  Cy(t, {
    type: "set",
    recoilValue: e,
    valueOrUpdater: n
  });
}
function xj(t, e, n) {
  if (n instanceof y_)
    return xN(t, e, n);
  Cy(t, {
    type: "setLoadable",
    recoilValue: e,
    loadable: n
  });
}
function Cj(t, e) {
  Cy(t, {
    type: "markModified",
    recoilValue: e
  });
}
function Aj(t, e, n) {
  Cy(t, {
    type: "setUnvalidated",
    recoilValue: e,
    unvalidatedValue: n
  });
}
function Rj(t, {
  key: e
}, n, r = null) {
  const i = mj(), o = t.getState();
  o.nodeToComponentSubscriptions.has(e) || o.nodeToComponentSubscriptions.set(e, /* @__PURE__ */ new Map()), Ln(o.nodeToComponentSubscriptions.get(e)).set(i, [r ?? "<not captured>", n]);
  const s = vj();
  if (s.early && (s.mode === "LEGACY" || s.mode === "MUTABLE_SOURCE")) {
    const a = t.getState().nextTree;
    a && a.dirtyAtoms.has(e) && n(a);
  }
  return {
    release: () => {
      const a = t.getState(), l = a.nodeToComponentSubscriptions.get(e);
      if (l === void 0 || !l.has(i)) {
        ni(`Subscription missing at release time for atom ${e}. This is a bug in Recoil.`);
        return;
      }
      l.delete(i), l.size === 0 && a.nodeToComponentSubscriptions.delete(e);
    }
  };
}
function Oj(t, e) {
  var n;
  const {
    currentTree: r
  } = t.getState(), i = yj(e.key);
  (n = i.clearCache) === null || n === void 0 || n.call(i, t, r);
}
var $s = {
  AbstractRecoilValue: bj,
  getRecoilValueAsLoadable: Sj,
  setRecoilValue: xN,
  setRecoilValueLoadable: xj,
  markRecoilValueModified: Cj,
  setUnvalidatedRecoilValue: Aj,
  subscribeToRecoilValue: Rj,
  applyAtomValueWrites: _j,
  // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
  batchStart: Tj,
  writeLoadableToTreeState: K1,
  invalidateDownstreams: TN,
  copyTreeState: kN,
  refreshRecoilValue: Oj
};
function Dj(t, e, n) {
  const r = t.entries();
  let i = r.next();
  for (; !i.done; ) {
    const o = i.value;
    if (e.call(n, o[1], o[0], t))
      return !0;
    i = r.next();
  }
  return !1;
}
var Ij = Dj;
const {
  cleanUpNode: Nj
} = Iu, {
  deleteNodeConfigIfPossible: Pj,
  getNode: CN
} = ao, {
  RetentionZone: AN
} = p_, $j = 12e4, RN = /* @__PURE__ */ new Set();
function ON(t, e) {
  const n = t.getState(), r = n.currentTree;
  if (n.nextTree) {
    ni("releaseNodesNowOnCurrentTree should only be called at the end of a batch");
    return;
  }
  const i = /* @__PURE__ */ new Set();
  for (const s of e)
    if (s instanceof AN)
      for (const a of Bj(n, s))
        i.add(a);
    else
      i.add(s);
  const o = Mj(t, i);
  for (const s of o)
    Lj(t, r, s);
}
function Mj(t, e) {
  const n = t.getState(), r = n.currentTree, i = t.getGraph(r.version), o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
  return a(e), o;
  function a(l) {
    const u = /* @__PURE__ */ new Set(), c = Fj(
      t,
      r,
      l,
      o,
      // don't descend into these
      s
      // don't descend into these
    );
    for (const p of c) {
      var f;
      if (CN(p).retainedBy === "recoilRoot") {
        s.add(p);
        continue;
      }
      if (((f = n.retention.referenceCounts.get(p)) !== null && f !== void 0 ? f : 0) > 0) {
        s.add(p);
        continue;
      }
      if (DN(p).some((m) => n.retention.referenceCounts.get(m))) {
        s.add(p);
        continue;
      }
      const g = i.nodeToNodeSubscriptions.get(p);
      if (g && Ij(g, (m) => s.has(m))) {
        s.add(p);
        continue;
      }
      o.add(p), u.add(p);
    }
    const d = /* @__PURE__ */ new Set();
    for (const p of u)
      for (const g of (h = i.nodeDeps.get(p)) !== null && h !== void 0 ? h : RN) {
        var h;
        o.has(g) || d.add(g);
      }
    d.size && a(d);
  }
}
function Fj(t, e, n, r, i) {
  const o = t.getGraph(e.version), s = [], a = /* @__PURE__ */ new Set();
  for (; n.size > 0; )
    l(Ln(n.values().next().value));
  return s;
  function l(u) {
    if (r.has(u) || i.has(u)) {
      n.delete(u);
      return;
    }
    if (a.has(u))
      return;
    const c = o.nodeToNodeSubscriptions.get(u);
    if (c)
      for (const f of c)
        l(f);
    a.add(u), n.delete(u), s.push(u);
  }
}
function Lj(t, e, n) {
  if (!xn("recoil_memory_managament_2020"))
    return;
  Nj(t, n);
  const r = t.getState();
  r.knownAtoms.delete(n), r.knownSelectors.delete(n), r.nodeTransactionSubscriptions.delete(n), r.retention.referenceCounts.delete(n);
  const i = DN(n);
  for (const l of i) {
    var o;
    (o = r.retention.nodesRetainedByZone.get(l)) === null || o === void 0 || o.delete(n);
  }
  e.atomValues.delete(n), e.dirtyAtoms.delete(n), e.nonvalidatedAtoms.delete(n);
  const s = r.graphsByVersion.get(e.version);
  if (s) {
    const l = s.nodeDeps.get(n);
    if (l !== void 0) {
      s.nodeDeps.delete(n);
      for (const u of l) {
        var a;
        (a = s.nodeToNodeSubscriptions.get(u)) === null || a === void 0 || a.delete(n);
      }
    }
    s.nodeToNodeSubscriptions.delete(n);
  }
  Pj(n);
}
function Bj(t, e) {
  var n;
  return (n = t.retention.nodesRetainedByZone.get(e)) !== null && n !== void 0 ? n : RN;
}
function DN(t) {
  const e = CN(t).retainedBy;
  return e === void 0 || e === "components" || e === "recoilRoot" ? [] : e instanceof AN ? [e] : e;
}
function jj(t, e) {
  const n = t.getState();
  n.nextTree ? n.retention.retainablesToCheckForRelease.add(e) : ON(t, /* @__PURE__ */ new Set([e]));
}
function Vj(t, e, n) {
  var r;
  if (!xn("recoil_memory_managament_2020"))
    return;
  const i = t.getState().retention.referenceCounts, o = ((r = i.get(e)) !== null && r !== void 0 ? r : 0) + n;
  o === 0 ? Uj(t, e) : i.set(e, o);
}
function Uj(t, e) {
  if (!xn("recoil_memory_managament_2020"))
    return;
  t.getState().retention.referenceCounts.delete(e), jj(t, e);
}
function qj(t) {
  if (!xn("recoil_memory_managament_2020"))
    return;
  const e = t.getState();
  ON(t, e.retention.retainablesToCheckForRelease), e.retention.retainablesToCheckForRelease.clear();
}
function zj(t) {
  return t === void 0 ? "recoilRoot" : t;
}
var ff = {
  SUSPENSE_TIMEOUT_MS: $j,
  updateRetainCount: Vj,
  releaseScheduledRetainablesNow: qj,
  retainedByOptionWithDefault: zj
};
const {
  unstable_batchedUpdates: Hj
} = D5;
var Gj = {
  unstable_batchedUpdates: Hj
};
const {
  unstable_batchedUpdates: Wj
} = Gj;
var Yj = {
  unstable_batchedUpdates: Wj
};
const {
  batchStart: Xj
} = $s, {
  unstable_batchedUpdates: Kj
} = Yj;
let Qj = Kj || ((t) => t());
const Jj = (t) => {
  Qj(() => {
    let e = () => {
    };
    try {
      e = Xj(), t();
    } finally {
      e();
    }
  });
};
var v_ = {
  batchUpdates: Jj
};
function* Zj(t) {
  for (const e of t)
    for (const n of e)
      yield n;
}
var IN = Zj;
const NN = (
  // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
  typeof Window > "u" || typeof window > "u"
), e9 = (t) => !NN && // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
(t === window || t instanceof Window), t9 = typeof navigator < "u" && navigator.product === "ReactNative";
var Ay = {
  isSSR: NN,
  isReactNative: t9,
  isWindow: e9
};
function n9(t, e) {
  let n, r;
  return [(...s) => {
    const a = e(...s);
    return n === a || (n = a, r = t(...s)), r;
  }, () => {
    n = null;
  }];
}
var r9 = {
  memoizeOneWithArgsHashAndInvalidation: n9
};
const {
  batchUpdates: Q1
} = v_, {
  initializeNode: i9,
  peekNodeInfo: o9
} = Iu, {
  graph: s9
} = Fh, {
  getNextStoreID: a9
} = xy, {
  DEFAULT_VALUE: l9,
  recoilValues: Hk,
  recoilValuesForKeys: Gk
} = ao, {
  AbstractRecoilValue: u9,
  getRecoilValueAsLoadable: c9,
  setRecoilValue: Wk,
  setUnvalidatedRecoilValue: f9
} = $s, {
  updateRetainCount: zg
} = ff, {
  setInvalidateMemoizedSnapshot: d9
} = wN, {
  getNextTreeStateVersion: h9,
  makeEmptyStoreState: p9
} = gN, {
  isSSR: g9
} = Ay, {
  memoizeOneWithArgsHashAndInvalidation: m9
} = r9, y9 = `
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`;
class Ry {
  // eslint-disable-next-line fb-www/no-uninitialized-properties
  constructor(e, n) {
    Et(this, "_store", void 0), Et(this, "_refCount", 1), Et(this, "getLoadable", (r) => (this.checkRefCount_INTERNAL(), c9(this._store, r))), Et(this, "getPromise", (r) => (this.checkRefCount_INTERNAL(), this.getLoadable(r).toPromise())), Et(this, "getNodes_UNSTABLE", (r) => {
      if (this.checkRefCount_INTERNAL(), r?.isModified === !0) {
        if (r?.isInitialized === !1)
          return [];
        const s = this._store.getState().currentTree;
        return Gk(s.dirtyAtoms);
      }
      const i = this._store.getState().knownAtoms, o = this._store.getState().knownSelectors;
      return r?.isInitialized == null ? Hk.values() : r.isInitialized === !0 ? Gk(IN([i, o])) : g_(Hk.values(), ({
        key: s
      }) => !i.has(s) && !o.has(s));
    }), Et(this, "getInfo_UNSTABLE", ({
      key: r
    }) => (this.checkRefCount_INTERNAL(), o9(this._store, this._store.getState().currentTree, r))), Et(this, "map", (r) => {
      this.checkRefCount_INTERNAL();
      const i = new J1(this, Q1);
      return r(i), i;
    }), Et(this, "asyncMap", async (r) => {
      this.checkRefCount_INTERNAL();
      const i = new J1(this, Q1);
      return i.retain(), await r(i), i.autoRelease_INTERNAL(), i;
    }), this._store = {
      storeID: a9(),
      parentStoreID: n,
      getState: () => e,
      replaceState: (r) => {
        e.currentTree = r(e.currentTree);
      },
      getGraph: (r) => {
        const i = e.graphsByVersion;
        if (i.has(r))
          return Ln(i.get(r));
        const o = s9();
        return i.set(r, o), o;
      },
      subscribeToTransactions: () => ({
        release: () => {
        }
      }),
      addTransactionMetadata: () => {
        throw wt("Cannot subscribe to Snapshots");
      }
    };
    for (const r of this._store.getState().knownAtoms)
      i9(this._store, r, "get"), zg(this._store, r, 1);
    this.autoRelease_INTERNAL();
  }
  retain() {
    if (this._refCount <= 0) {
      if (process.env.NODE_ENV !== "production")
        throw wt("Snapshot has already been released.");
      ni("Attempt to retain() Snapshot that was already released.");
    }
    this._refCount++;
    let e = !1;
    return () => {
      e || (e = !0, this._release());
    };
  }
  /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */
  autoRelease_INTERNAL() {
    g9 || window.setTimeout(() => this._release(), 10);
  }
  _release() {
    if (this._refCount--, this._refCount === 0) {
      if (this._store.getState().nodeCleanupFunctions.forEach((e) => e()), this._store.getState().nodeCleanupFunctions.clear(), !xn("recoil_memory_managament_2020"))
        return;
    } else this._refCount < 0 && process.env.NODE_ENV !== "production" && ni("Snapshot released an extra time.");
  }
  isRetained() {
    return this._refCount > 0;
  }
  checkRefCount_INTERNAL() {
    xn("recoil_memory_managament_2020") && this._refCount <= 0 && process.env.NODE_ENV !== "production" && ni(y9);
  }
  getStore_INTERNAL() {
    return this.checkRefCount_INTERNAL(), this._store;
  }
  getID() {
    return this.checkRefCount_INTERNAL(), this._store.getState().currentTree.stateID;
  }
  getStoreID() {
    return this.checkRefCount_INTERNAL(), this._store.storeID;
  }
  // We want to allow the methods to be destructured and used as accessors
  /* eslint-disable fb-www/extra-arrow-initializer */
  /* eslint-enable fb-www/extra-arrow-initializer */
}
function PN(t, e, n = !1) {
  const r = t.getState(), i = n ? h9() : e.version;
  return {
    // Always clone the TreeState to isolate stores from accidental mutations.
    // For example, reading a selector from a cloned snapshot shouldn't cache
    // in the original treestate which may cause the original to skip
    // initialization of upstream atoms.
    currentTree: {
      // TODO snapshots shouldn't really have versions because a new version number
      // is always assigned when the snapshot is gone to.
      version: n ? i : e.version,
      stateID: n ? i : e.stateID,
      transactionMetadata: {
        ...e.transactionMetadata
      },
      dirtyAtoms: new Set(e.dirtyAtoms),
      atomValues: e.atomValues.clone(),
      nonvalidatedAtoms: e.nonvalidatedAtoms.clone()
    },
    commitDepth: 0,
    nextTree: null,
    previousTree: null,
    knownAtoms: new Set(r.knownAtoms),
    // FIXME here's a copy
    knownSelectors: new Set(r.knownSelectors),
    // FIXME here's a copy
    transactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeTransactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeToComponentSubscriptions: /* @__PURE__ */ new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: /* @__PURE__ */ new Set(),
    graphsByVersion: (/* @__PURE__ */ new Map()).set(i, t.getGraph(e.version)),
    retention: {
      referenceCounts: /* @__PURE__ */ new Map(),
      nodesRetainedByZone: /* @__PURE__ */ new Map(),
      retainablesToCheckForRelease: /* @__PURE__ */ new Set()
    },
    // FIXME here's a copy
    // Create blank cleanup handlers for atoms so snapshots don't re-run
    // atom effects.
    nodeCleanupFunctions: new Map(Ty(r.nodeCleanupFunctions.entries(), ([o]) => [o, () => {
    }]))
  };
}
function v9(t) {
  const e = new Ry(p9());
  return t != null ? e.map(t) : e;
}
const [Yk, $N] = m9(
  // $FlowFixMe[missing-local-annot]
  (t, e) => {
    var n;
    const r = t.getState(), i = e === "latest" ? (n = r.nextTree) !== null && n !== void 0 ? n : r.currentTree : Ln(r.previousTree);
    return new Ry(PN(t, i), t.storeID);
  },
  (t, e) => {
    var n, r;
    return String(e) + String(t.storeID) + String((n = t.getState().nextTree) === null || n === void 0 ? void 0 : n.version) + String(t.getState().currentTree.version) + String((r = t.getState().previousTree) === null || r === void 0 ? void 0 : r.version);
  }
);
d9($N);
function b9(t, e = "latest") {
  const n = Yk(t, e);
  return n.isRetained() ? n : ($N(), Yk(t, e));
}
class J1 extends Ry {
  constructor(e, n) {
    super(PN(e.getStore_INTERNAL(), e.getStore_INTERNAL().getState().currentTree, !0), e.getStoreID()), Et(this, "_batch", void 0), Et(this, "set", (r, i) => {
      this.checkRefCount_INTERNAL();
      const o = this.getStore_INTERNAL();
      this._batch(() => {
        zg(o, r.key, 1), Wk(this.getStore_INTERNAL(), r, i);
      });
    }), Et(this, "reset", (r) => {
      this.checkRefCount_INTERNAL();
      const i = this.getStore_INTERNAL();
      this._batch(() => {
        zg(i, r.key, 1), Wk(this.getStore_INTERNAL(), r, l9);
      });
    }), Et(this, "setUnvalidatedAtomValues_DEPRECATED", (r) => {
      this.checkRefCount_INTERNAL();
      const i = this.getStore_INTERNAL();
      Q1(() => {
        for (const [o, s] of r.entries())
          zg(i, o, 1), f9(i, new u9(o), s);
      });
    }), this._batch = n;
  }
}
var Oy = {
  Snapshot: Ry,
  MutableSnapshot: J1,
  freshSnapshot: v9,
  cloneSnapshot: b9
}, w9 = Oy.Snapshot, S9 = Oy.MutableSnapshot, _9 = Oy.freshSnapshot, E9 = Oy.cloneSnapshot, Dy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Snapshot: w9,
  MutableSnapshot: S9,
  freshSnapshot: _9,
  cloneSnapshot: E9
});
function k9(...t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t)
    for (const r of n)
      e.add(r);
  return e;
}
var T9 = k9;
const {
  useRef: x9
} = nt;
function C9(t) {
  const e = x9(t);
  return e.current === t && typeof t == "function" && (e.current = t()), e;
}
var Xk = C9;
const {
  getNextTreeStateVersion: A9,
  makeEmptyStoreState: MN
} = gN, {
  cleanUpNode: R9,
  getDownstreamNodes: O9,
  initializeNode: D9,
  setNodeValue: I9,
  setUnvalidatedAtomValue_DEPRECATED: N9
} = Iu, {
  graph: P9
} = Fh, {
  cloneGraph: $9
} = Fh, {
  getNextStoreID: FN
} = xy, {
  createMutableSource: X0,
  reactMode: LN
} = l_, {
  applyAtomValueWrites: M9
} = $s, {
  releaseScheduledRetainablesNow: BN
} = ff, {
  freshSnapshot: F9
} = Dy, {
  useCallback: L9,
  useContext: jN,
  useEffect: Z1,
  useMemo: B9,
  useRef: j9,
  useState: V9
} = nt;
function Pf() {
  throw wt("This component must be used inside a <RecoilRoot> component.");
}
const VN = Object.freeze({
  storeID: FN(),
  getState: Pf,
  replaceState: Pf,
  getGraph: Pf,
  subscribeToTransactions: Pf,
  addTransactionMetadata: Pf
});
let ew = !1;
function Kk(t) {
  if (ew)
    throw wt("An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.");
  const e = t.getState();
  if (e.nextTree === null) {
    xn("recoil_memory_managament_2020") && xn("recoil_release_on_cascading_update_killswitch_2021") && e.commitDepth > 0 && BN(t);
    const n = e.currentTree.version, r = A9();
    e.nextTree = {
      ...e.currentTree,
      version: r,
      stateID: r,
      dirtyAtoms: /* @__PURE__ */ new Set(),
      transactionMetadata: {}
    }, e.graphsByVersion.set(r, $9(Ln(e.graphsByVersion.get(n))));
  }
}
const UN = nt.createContext({
  current: VN
}), b_ = () => jN(UN), qN = nt.createContext(null);
function U9() {
  const t = jN(qN);
  return t == null && c_("Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks."), t;
}
function zN(t, e, n) {
  const r = O9(t, n, n.dirtyAtoms);
  for (const i of r) {
    const o = e.nodeToComponentSubscriptions.get(i);
    if (o)
      for (const [s, [a, l]] of o)
        l(n);
  }
}
function q9(t) {
  const e = t.getState(), n = e.currentTree, r = n.dirtyAtoms;
  if (r.size) {
    for (const [i, o] of e.nodeTransactionSubscriptions)
      if (r.has(i))
        for (const [s, a] of o)
          a(t);
    for (const [i, o] of e.transactionSubscriptions)
      o(t);
    (!LN().early || e.suspendedComponentResolvers.size > 0) && (zN(t, e, n), e.suspendedComponentResolvers.forEach((i) => i()), e.suspendedComponentResolvers.clear());
  }
  e.queuedComponentCallbacks_DEPRECATED.forEach((i) => i(n)), e.queuedComponentCallbacks_DEPRECATED.splice(0, e.queuedComponentCallbacks_DEPRECATED.length);
}
function z9(t) {
  const e = t.getState();
  e.commitDepth++;
  try {
    const {
      nextTree: n
    } = e;
    if (n == null)
      return;
    e.previousTree = e.currentTree, e.currentTree = n, e.nextTree = null, q9(t), e.previousTree != null ? e.graphsByVersion.delete(e.previousTree.version) : ni("Ended batch with no previous state, which is unexpected", "recoil"), e.previousTree = null, xn("recoil_memory_managament_2020") && n == null && BN(t);
  } finally {
    e.commitDepth--;
  }
}
function H9({
  setNotifyBatcherOfChange: t
}) {
  const e = b_(), [, n] = V9([]);
  return t(() => n({})), Z1(() => (t(() => n({})), () => {
    t(() => {
    });
  }), [t]), Z1(() => {
    R8.enqueueExecution("Batcher", () => {
      z9(e.current);
    });
  }), null;
}
process.env.NODE_ENV !== "production" && typeof window < "u" && !window.$recoilDebugStates && (window.$recoilDebugStates = []);
function G9(t, e) {
  const n = MN();
  return e({
    set: (r, i) => {
      const o = n.currentTree, s = I9(t, o, r.key, i), a = new Set(s.keys()), l = o.nonvalidatedAtoms.clone();
      for (const u of a)
        l.delete(u);
      n.currentTree = {
        ...o,
        dirtyAtoms: T9(o.dirtyAtoms, a),
        atomValues: M9(o.atomValues, s),
        // NB: PLEASE un-export applyAtomValueWrites when deleting this code
        nonvalidatedAtoms: l
      };
    },
    setUnvalidatedAtomValues: (r) => {
      r.forEach((i, o) => {
        n.currentTree = N9(n.currentTree, o, i);
      });
    }
  }), n;
}
function W9(t) {
  const e = F9(t), n = e.getStore_INTERNAL().getState();
  return e.retain(), n.nodeCleanupFunctions.forEach((r) => r()), n.nodeCleanupFunctions.clear(), n;
}
let Qk = 0;
function Y9({
  initializeState_DEPRECATED: t,
  initializeState: e,
  store_INTERNAL: n,
  // For use with React "context bridging"
  children: r
}) {
  let i;
  const o = (h) => {
    const p = i.current.graphsByVersion;
    if (p.has(h))
      return Ln(p.get(h));
    const g = P9();
    return p.set(h, g), g;
  }, s = (h, p) => {
    if (p == null) {
      const {
        transactionSubscriptions: g
      } = f.current.getState(), m = Qk++;
      return g.set(m, h), {
        release: () => {
          g.delete(m);
        }
      };
    } else {
      const {
        nodeTransactionSubscriptions: g
      } = f.current.getState();
      g.has(p) || g.set(p, /* @__PURE__ */ new Map());
      const m = Qk++;
      return Ln(g.get(p)).set(m, h), {
        release: () => {
          const v = g.get(p);
          v && (v.delete(m), v.size === 0 && g.delete(p));
        }
      };
    }
  }, a = (h) => {
    Kk(f.current);
    for (const p of Object.keys(h))
      Ln(f.current.getState().nextTree).transactionMetadata[p] = h[p];
  }, l = (h) => {
    Kk(f.current);
    const p = Ln(i.current.nextTree);
    let g;
    try {
      ew = !0, g = h(p);
    } finally {
      ew = !1;
    }
    g !== p && (process.env.NODE_ENV !== "production" && typeof window < "u" && window.$recoilDebugStates.push(g), i.current.nextTree = g, LN().early && zN(f.current, i.current, g), Ln(u.current)());
  }, u = j9(null), c = L9((h) => {
    u.current = h;
  }, [u]), f = Xk(() => n ?? {
    storeID: FN(),
    getState: () => i.current,
    replaceState: l,
    getGraph: o,
    subscribeToTransactions: s,
    addTransactionMetadata: a
  });
  n != null && (f.current = n), i = Xk(() => t != null ? G9(f.current, t) : e != null ? W9(e) : MN());
  const d = B9(() => X0?.(i, () => i.current.currentTree.version), [i]);
  return Z1(() => {
    const h = f.current;
    for (const p of new Set(h.getState().knownAtoms))
      D9(h, p, "get");
    return () => {
      for (const p of h.getState().knownAtoms)
        R9(h, p);
    };
  }, [f]), /* @__PURE__ */ nt.createElement(UN.Provider, {
    value: f
  }, /* @__PURE__ */ nt.createElement(qN.Provider, {
    value: d
  }, /* @__PURE__ */ nt.createElement(H9, {
    setNotifyBatcherOfChange: c
  }), r));
}
function X9(t) {
  const {
    override: e,
    ...n
  } = t, r = b_();
  return e === !1 && r.current !== VN ? t.children : /* @__PURE__ */ nt.createElement(Y9, n);
}
var df = {
  RecoilRoot: X9,
  useStoreRef: b_,
  useRecoilMutableSource: U9
};
function K9(t, e) {
  if (t === e)
    return !0;
  if (t.length !== e.length)
    return !1;
  for (let n = 0, r = t.length; n < r; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
var Q9 = K9;
const {
  useEffect: J9,
  useRef: Z9
} = nt;
function e6(t) {
  const e = Z9();
  return J9(() => {
    e.current = t;
  }), e.current;
}
var t6 = e6;
const {
  useStoreRef: n6
} = df, {
  SUSPENSE_TIMEOUT_MS: r6
} = ff, {
  updateRetainCount: $f
} = ff, {
  RetentionZone: i6
} = p_, {
  useEffect: o6,
  useRef: s6
} = nt, {
  isSSR: Jk
} = Ay;
function a6(t) {
  if (xn("recoil_memory_managament_2020"))
    return l6(t);
}
function l6(t) {
  const n = (Array.isArray(t) ? t : [t]).map((s) => s instanceof i6 ? s : s.key), r = n6();
  o6(() => {
    if (!xn("recoil_memory_managament_2020"))
      return;
    const s = r.current;
    if (i.current && !Jk)
      window.clearTimeout(i.current), i.current = null;
    else
      for (const a of n)
        $f(s, a, 1);
    return () => {
      for (const a of n)
        $f(s, a, -1);
    };
  }, [r, ...n]);
  const i = s6(), o = t6(n);
  if (!Jk && (o === void 0 || !Q9(o, n))) {
    const s = r.current;
    for (const a of n)
      $f(s, a, 1);
    if (o)
      for (const a of o)
        $f(s, a, -1);
    i.current && window.clearTimeout(i.current), i.current = window.setTimeout(() => {
      i.current = null;
      for (const a of n)
        $f(s, a, -1);
    }, r6);
  }
}
var u6 = a6;
function c6() {
  return "<component name not available>";
}
var Iy = c6;
const {
  DEFAULT_VALUE: f6
} = ao, {
  currentRendererSupportsUseSyncExternalStore: d6,
  reactMode: Bh,
  useMutableSource: h6,
  useSyncExternalStore: p6
} = l_, {
  useRecoilMutableSource: g6,
  useStoreRef: Nu
} = df, {
  isRecoilValue: m6
} = yu, {
  getRecoilValueAsLoadable: Ny,
  setRecoilValue: HN,
  subscribeToRecoilValue: Py
} = $s, {
  useCallback: xo,
  useEffect: Dm,
  useMemo: y6,
  useRef: GN,
  useState: WN
} = nt, {
  isSSR: v6
} = Ay;
function b6(t, e, n) {
  if (t.state === "hasValue")
    return t.contents;
  throw t.state === "loading" ? new Promise((i) => {
    const o = n.current.getState().suspendedComponentResolvers;
    o.add(i), v6 && bn(t.contents) && t.contents.finally(() => {
      o.delete(i);
    });
  }) : t.state === "hasError" ? t.contents : wt(`Invalid value of loadable atom "${e.key}"`);
}
function jh(t, e) {
  if (!m6(t))
    throw wt(`Invalid argument to ${e}: expected an atom or selector but got ${String(t)}`);
}
function w6(t) {
  const e = Nu(), n = Iy(), r = xo(() => {
    var a;
    process.env.NODE_ENV;
    const l = e.current, u = l.getState(), c = Bh().early && (a = u.nextTree) !== null && a !== void 0 ? a : u.currentTree;
    return {
      loadable: Ny(l, t, c),
      key: t.key
    };
  }, [e, t]), i = xo((a) => {
    let l;
    return () => {
      var u, c;
      const f = a();
      return (u = l) !== null && u !== void 0 && u.loadable.is(f.loadable) && ((c = l) === null || c === void 0 ? void 0 : c.key) === f.key ? l : (l = f, f);
    };
  }, []), o = y6(() => i(r), [r, i]), s = xo((a) => {
    const l = e.current;
    return Py(l, t, a, n).release;
  }, [e, t, n]);
  return p6(
    s,
    o,
    // getSnapshot()
    o
    // getServerSnapshot() for SSR support
  ).loadable;
}
function S6(t) {
  const e = Nu(), n = xo(() => {
    var u;
    const c = e.current, f = c.getState(), d = Bh().early && (u = f.nextTree) !== null && u !== void 0 ? u : f.currentTree;
    return Ny(c, t, d);
  }, [e, t]), r = xo(() => (process.env.NODE_ENV, n()), [n]), i = Iy(), o = xo((u, c) => {
    const f = e.current;
    return Py(f, t, () => {
      if (!xn("recoil_suppress_rerender_in_callback"))
        return c();
      const h = n();
      l.current.is(h) || c(), l.current = h;
    }, i).release;
  }, [e, t, i, n]), s = g6();
  if (s == null)
    throw wt("Recoil hooks must be used in components contained within a <RecoilRoot> component.");
  const a = h6(s, r, o), l = GN(a);
  return Dm(() => {
    l.current = a;
  }), a;
}
function Zk(t) {
  const e = Nu(), n = Iy(), r = xo(() => {
    var l;
    process.env.NODE_ENV;
    const u = e.current, c = u.getState(), f = Bh().early && (l = c.nextTree) !== null && l !== void 0 ? l : c.currentTree;
    return Ny(u, t, f);
  }, [e, t]), i = xo(() => ({
    loadable: r(),
    key: t.key
  }), [r, t.key]), o = xo((l) => {
    const u = i();
    return l.loadable.is(u.loadable) && l.key === u.key ? l : u;
  }, [i]);
  Dm(() => {
    const l = Py(e.current, t, (u) => {
      a(o);
    }, n);
    return a(o), l.release;
  }, [n, t, e, o]);
  const [s, a] = WN(i);
  return s.key !== t.key ? i().loadable : s.loadable;
}
function _6(t) {
  const e = Nu(), [, n] = WN([]), r = Iy(), i = xo(() => {
    var a;
    process.env.NODE_ENV;
    const l = e.current, u = l.getState(), c = Bh().early && (a = u.nextTree) !== null && a !== void 0 ? a : u.currentTree;
    return Ny(l, t, c);
  }, [e, t]), o = i(), s = GN(o);
  return Dm(() => {
    s.current = o;
  }), Dm(() => {
    const a = e.current, l = a.getState(), u = Py(a, t, (f) => {
      var d;
      if (!xn("recoil_suppress_rerender_in_callback"))
        return n([]);
      const h = i();
      (d = s.current) !== null && d !== void 0 && d.is(h) || n(h), s.current = h;
    }, r);
    if (l.nextTree)
      a.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        s.current = null, n([]);
      });
    else {
      var c;
      if (!xn("recoil_suppress_rerender_in_callback"))
        return n([]);
      const f = i();
      (c = s.current) !== null && c !== void 0 && c.is(f) || n(f), s.current = f;
    }
    return u.release;
  }, [r, i, t, e]), o;
}
function YN(t) {
  return process.env.NODE_ENV !== "production" && jh(t, "useRecoilValueLoadable"), xn("recoil_memory_managament_2020") && u6(t), {
    TRANSITION_SUPPORT: Zk,
    // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
    // `reactMode()` before calling it.  However, sometimes the host React
    // environment supports it but uses additional React renderers (such as with
    // `react-three-fiber`) which do not.  While this is technically a user issue
    // by using a renderer with React 18+ that doesn't fully support React 18 we
    // don't want to break users if it can be avoided. As the current renderer can
    // change at runtime, we need to dynamically check and fallback if necessary.
    SYNC_EXTERNAL_STORE: d6() ? w6 : Zk,
    MUTABLE_SOURCE: S6,
    LEGACY: _6
  }[Bh().mode](t);
}
function XN(t) {
  process.env.NODE_ENV !== "production" && jh(t, "useRecoilValue");
  const e = Nu(), n = YN(t);
  return b6(n, t, e);
}
function KN(t) {
  process.env.NODE_ENV !== "production" && jh(t, "useSetRecoilState");
  const e = Nu();
  return xo((n) => {
    HN(e.current, t, n);
  }, [e, t]);
}
function E6(t) {
  process.env.NODE_ENV !== "production" && jh(t, "useResetRecoilState");
  const e = Nu();
  return xo(() => {
    HN(e.current, t, f6);
  }, [e, t]);
}
function k6(t) {
  return process.env.NODE_ENV !== "production" && jh(t, "useRecoilState"), [XN(t), KN(t)];
}
var T6 = {
  useRecoilState: k6,
  useRecoilValue: XN,
  useRecoilValueLoadable: YN,
  useResetRecoilState: E6,
  useSetRecoilState: KN
};
const {
  batchUpdates: x6
} = v_, {
  DEFAULT_VALUE: C6,
  getNode: A6
} = ao, {
  AbstractRecoilValue: R6,
  setRecoilValueLoadable: O6
} = $s, {
  cloneSnapshot: Lae
} = Dy, {
  useCallback: Bae,
  useEffect: jae,
  useRef: Vae,
  useState: Uae
} = nt;
function D6(t, e) {
  var n;
  const r = t.getState(), i = (n = r.nextTree) !== null && n !== void 0 ? n : r.currentTree, o = e.getStore_INTERNAL().getState().currentTree;
  x6(() => {
    const s = /* @__PURE__ */ new Set();
    for (const u of [i.atomValues.keys(), o.atomValues.keys()])
      for (const c of u) {
        var a, l;
        ((a = i.atomValues.get(c)) === null || a === void 0 ? void 0 : a.contents) !== ((l = o.atomValues.get(c)) === null || l === void 0 ? void 0 : l.contents) && A6(c).shouldRestoreFromSnapshots && s.add(c);
      }
    s.forEach((u) => {
      O6(t, new R6(u), o.atomValues.has(u) ? Ln(o.atomValues.get(u)) : C6);
    }), t.replaceState((u) => ({
      ...u,
      stateID: e.getID()
    }));
  });
}
var I6 = {
  gotoSnapshot: D6
};
const {
  useMemo: qae
} = nt, {
  loadableWithValue: N6
} = Mh, {
  initializeNode: P6
} = Iu, {
  DEFAULT_VALUE: $6,
  getNode: M6
} = ao, {
  copyTreeState: F6,
  getRecoilValueAsLoadable: L6,
  invalidateDownstreams: B6,
  writeLoadableToTreeState: j6
} = $s;
function eT(t) {
  return M6(t.key).nodeType === "atom";
}
class V6 {
  constructor(e, n) {
    Et(this, "_store", void 0), Et(this, "_treeState", void 0), Et(this, "_changes", void 0), Et(this, "get", (r) => {
      if (this._changes.has(r.key))
        return this._changes.get(r.key);
      if (!eT(r))
        throw wt("Reading selectors within atomicUpdate is not supported");
      const i = L6(this._store, r, this._treeState);
      if (i.state === "hasValue")
        return i.contents;
      throw i.state === "hasError" ? i.contents : wt(`Expected Recoil atom ${r.key} to have a value, but it is in a loading state.`);
    }), Et(this, "set", (r, i) => {
      if (!eT(r))
        throw wt("Setting selectors within atomicUpdate is not supported");
      if (typeof i == "function") {
        const o = this.get(r);
        this._changes.set(r.key, i(o));
      } else
        P6(this._store, r.key, "set"), this._changes.set(r.key, i);
    }), Et(this, "reset", (r) => {
      this.set(r, $6);
    }), this._store = e, this._treeState = n, this._changes = /* @__PURE__ */ new Map();
  }
  // Allow destructing
  // eslint-disable-next-line fb-www/extra-arrow-initializer
  newTreeState_INTERNAL() {
    if (this._changes.size === 0)
      return this._treeState;
    const e = F6(this._treeState);
    for (const [n, r] of this._changes)
      j6(e, n, N6(r));
    return B6(this._store, e), e;
  }
}
function U6(t) {
  return (e) => {
    t.replaceState((n) => {
      const r = new V6(t, n);
      return e(r), r.newTreeState_INTERNAL();
    });
  };
}
var q6 = {
  atomicUpdater: U6
}, z6 = q6.atomicUpdater, QN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  atomicUpdater: z6
});
function H6(t, e) {
  if (!t)
    throw new Error(e);
}
var G6 = H6, as = G6;
const {
  atomicUpdater: W6
} = QN, {
  batchUpdates: Y6
} = v_, {
  DEFAULT_VALUE: X6
} = ao, {
  useStoreRef: K6
} = df, {
  refreshRecoilValue: Q6,
  setRecoilValue: tT
} = $s, {
  cloneSnapshot: J6
} = Dy, {
  gotoSnapshot: Z6
} = I6, {
  useCallback: e7
} = nt;
class JN {
}
const t7 = new JN();
function ZN(t, e, n, r) {
  let i = t7, o;
  if (Y6(() => {
    const a = "useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.";
    if (typeof e != "function")
      throw wt(a);
    const l = mN({
      ...r ?? {},
      // flowlint-line unclear-type:off
      // $FlowFixMe[missing-local-annot]
      set: (c, f) => tT(t, c, f),
      // $FlowFixMe[missing-local-annot]
      reset: (c) => tT(t, c, X6),
      // $FlowFixMe[missing-local-annot]
      refresh: (c) => Q6(t, c),
      gotoSnapshot: (c) => Z6(t, c),
      transact_UNSTABLE: (c) => W6(t)(c)
    }, {
      snapshot: () => {
        const c = J6(t);
        return o = c.retain(), c;
      }
    }), u = e(l);
    if (typeof u != "function")
      throw wt(a);
    i = u(...n);
  }), i instanceof JN && (process.env.NODE_ENV !== "production" ? as(!1, "batchUpdates should return immediately") : as(!1)), bn(i))
    i = i.finally(() => {
      var a;
      (a = o) === null || a === void 0 || a();
    });
  else {
    var s;
    (s = o) === null || s === void 0 || s();
  }
  return i;
}
function n7(t, e) {
  const n = K6();
  return e7(
    // $FlowIssue[incompatible-call]
    (...r) => ZN(n.current, t, r),
    e != null ? [...e, n] : void 0
    // eslint-disable-line fb-www/react-hooks-deps
  );
}
var eP = {
  recoilCallback: ZN,
  useRecoilCallback: n7
};
const {
  useStoreRef: r7
} = df, {
  refreshRecoilValue: i7
} = $s, {
  useCallback: o7
} = nt;
function s7(t) {
  const e = r7();
  return o7(() => {
    const n = e.current;
    i7(n, t);
  }, [t, e]);
}
var a7 = s7;
const {
  atomicUpdater: l7
} = QN, {
  useStoreRef: u7
} = df, {
  useMemo: c7
} = nt;
function f7(t, e) {
  const n = u7();
  return c7(
    () => (...r) => {
      l7(n.current)((o) => {
        t(o)(...r);
      });
    },
    e != null ? [...e, n] : void 0
    // eslint-disable-line fb-www/react-hooks-deps
  );
}
var d7 = f7;
class h7 {
  constructor(e) {
    Et(this, "value", void 0), this.value = e;
  }
}
var p7 = {
  WrappedValue: h7
}, g7 = p7.WrappedValue, tP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WrappedValue: g7
});
class nT extends Error {
}
class m7 {
  // $FlowIssue[unclear-type]
  constructor(e) {
    var n, r, i;
    Et(this, "_name", void 0), Et(this, "_numLeafs", void 0), Et(this, "_root", void 0), Et(this, "_onHit", void 0), Et(this, "_onSet", void 0), Et(this, "_mapNodeValue", void 0), this._name = e?.name, this._numLeafs = 0, this._root = null, this._onHit = (n = e?.onHit) !== null && n !== void 0 ? n : () => {
    }, this._onSet = (r = e?.onSet) !== null && r !== void 0 ? r : () => {
    }, this._mapNodeValue = (i = e?.mapNodeValue) !== null && i !== void 0 ? i : (o) => o;
  }
  size() {
    return this._numLeafs;
  }
  // $FlowIssue[unclear-type]
  root() {
    return this._root;
  }
  get(e, n) {
    var r;
    return (r = this.getLeafNode(e, n)) === null || r === void 0 ? void 0 : r.value;
  }
  getLeafNode(e, n) {
    if (this._root == null)
      return;
    let r = this._root;
    for (; r; ) {
      if (n?.onNodeVisit(r), r.type === "leaf")
        return this._onHit(r), r;
      const i = this._mapNodeValue(e(r.nodeKey));
      r = r.branches.get(i);
    }
  }
  set(e, n, r) {
    const i = () => {
      var o, s, a, l;
      let u, c;
      for (const [m, v] of e) {
        var f, d, h;
        const S = this._root;
        if (S?.type === "leaf")
          throw this.invalidCacheError();
        const _ = u;
        if (u = _ ? _.branches.get(c) : S, u = (f = u) !== null && f !== void 0 ? f : {
          type: "branch",
          nodeKey: m,
          parent: _,
          branches: /* @__PURE__ */ new Map(),
          branchKey: c
        }, u.type !== "branch" || u.nodeKey !== m)
          throw this.invalidCacheError();
        _?.branches.set(c, u), r == null || (d = r.onNodeVisit) === null || d === void 0 || d.call(r, u), c = this._mapNodeValue(v), this._root = (h = this._root) !== null && h !== void 0 ? h : u;
      }
      const p = u ? (o = u) === null || o === void 0 ? void 0 : o.branches.get(c) : this._root;
      if (p != null && (p.type !== "leaf" || p.branchKey !== c))
        throw this.invalidCacheError();
      const g = {
        type: "leaf",
        value: n,
        parent: u,
        branchKey: c
      };
      (s = u) === null || s === void 0 || s.branches.set(c, g), this._root = (a = this._root) !== null && a !== void 0 ? a : g, this._numLeafs++, this._onSet(g), r == null || (l = r.onNodeVisit) === null || l === void 0 || l.call(r, g);
    };
    try {
      i();
    } catch (o) {
      if (o instanceof nT)
        this.clear(), i();
      else
        throw o;
    }
  }
  // Returns true if leaf was actually deleted from the tree
  delete(e) {
    const n = this.root();
    if (!n)
      return !1;
    if (e === n)
      return this._root = null, this._numLeafs = 0, !0;
    let r = e.parent, i = e.branchKey;
    for (; r; ) {
      var o;
      if (r.branches.delete(i), r === n)
        return r.branches.size === 0 ? (this._root = null, this._numLeafs = 0) : this._numLeafs--, !0;
      if (r.branches.size > 0)
        break;
      i = (o = r) === null || o === void 0 ? void 0 : o.branchKey, r = r.parent;
    }
    for (; r !== n; r = r.parent)
      if (r == null)
        return !1;
    return this._numLeafs--, !0;
  }
  clear() {
    this._numLeafs = 0, this._root = null;
  }
  invalidCacheError() {
    throw ni("Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache." + (this._name != null ? ` - ${this._name}` : "")), new nT();
  }
}
var y7 = {
  TreeCache: m7
}, v7 = y7.TreeCache, nP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  TreeCache: v7
});
class b7 {
  constructor(e) {
    var n;
    Et(this, "_maxSize", void 0), Et(this, "_size", void 0), Et(this, "_head", void 0), Et(this, "_tail", void 0), Et(this, "_map", void 0), Et(this, "_keyMapper", void 0), this._maxSize = e.maxSize, this._size = 0, this._head = null, this._tail = null, this._map = /* @__PURE__ */ new Map(), this._keyMapper = (n = e.mapKey) !== null && n !== void 0 ? n : (r) => r;
  }
  head() {
    return this._head;
  }
  tail() {
    return this._tail;
  }
  size() {
    return this._size;
  }
  maxSize() {
    return this._maxSize;
  }
  has(e) {
    return this._map.has(this._keyMapper(e));
  }
  get(e) {
    const n = this._keyMapper(e), r = this._map.get(n);
    if (r)
      return this.set(e, r.value), r.value;
  }
  set(e, n) {
    const r = this._keyMapper(e);
    this._map.get(r) && this.delete(e);
    const o = this.head(), s = {
      key: e,
      right: o,
      left: null,
      value: n
    };
    o ? o.left = s : this._tail = s, this._map.set(r, s), this._head = s, this._size++, this._maybeDeleteLRU();
  }
  _maybeDeleteLRU() {
    this.size() > this.maxSize() && this.deleteLru();
  }
  deleteLru() {
    const e = this.tail();
    e && this.delete(e.key);
  }
  delete(e) {
    const n = this._keyMapper(e);
    if (!this._size || !this._map.has(n))
      return;
    const r = Ln(this._map.get(n)), i = r.right, o = r.left;
    i && (i.left = r.left), o && (o.right = r.right), r === this.head() && (this._head = i), r === this.tail() && (this._tail = o), this._map.delete(n), this._size--;
  }
  clear() {
    this._size = 0, this._head = null, this._tail = null, this._map = /* @__PURE__ */ new Map();
  }
}
var w7 = {
  LRUCache: b7
}, S7 = w7.LRUCache, rP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  LRUCache: S7
});
const {
  LRUCache: _7
} = rP, {
  TreeCache: E7
} = nP;
function k7({
  name: t,
  maxSize: e,
  mapNodeValue: n = (r) => r
}) {
  const r = new _7({
    maxSize: e
  }), i = new E7({
    name: t,
    mapNodeValue: n,
    onHit: (o) => {
      r.set(o, !0);
    },
    onSet: (o) => {
      const s = r.tail();
      r.set(o, !0), s && i.size() > e && i.delete(s.key);
    }
  });
  return i;
}
var rT = k7;
const T7 = 15;
function go(t, e, n) {
  if (typeof t == "string" && !t.includes('"') && !t.includes("\\"))
    return `"${t}"`;
  switch (typeof t) {
    case "undefined":
      return "";
    // JSON.stringify(undefined) returns undefined, but we always want to return a string
    case "boolean":
      return t ? "true" : "false";
    case "number":
    case "symbol":
      return String(t);
    case "string":
      return JSON.stringify(t);
    case "function":
      if (e?.allowFunctions !== !0)
        throw wt("Attempt to serialize function in a Recoil cache key");
      return `__FUNCTION(${t.name})__`;
  }
  if (t === null)
    return "null";
  if (typeof t != "object") {
    var r;
    return (r = JSON.stringify(t)) !== null && r !== void 0 ? r : "";
  }
  if (bn(t))
    return "__PROMISE__";
  if (Array.isArray(t))
    return `[${t.map((i, o) => go(i, e, o.toString()))}]`;
  if (typeof t.toJSON == "function")
    return go(t.toJSON(n), e, n);
  if (t instanceof Map) {
    const i = {};
    for (const [o, s] of t)
      i[typeof o == "string" ? o : go(o, e)] = s;
    return go(i, e, n);
  }
  return t instanceof Set ? go(
    // $FlowFixMe[missing-local-annot]
    Array.from(t).sort((i, o) => go(i, e).localeCompare(go(o, e))),
    e,
    n
  ) : Symbol !== void 0 && t[Symbol.iterator] != null && typeof t[Symbol.iterator] == "function" ? go(Array.from(t), e, n) : `{${Object.keys(t).filter((i) => t[i] !== void 0).sort().map((i) => `${go(i, e)}:${go(t[i], e, i)}`).join(",")}}`;
}
function x7(t, e = {
  allowFunctions: !1
}) {
  if (process.env.NODE_ENV !== "production" && typeof window < "u") {
    const n = window.performance ? window.performance.now() : 0, r = go(t, e), i = window.performance ? window.performance.now() : 0;
    return i - n > T7 && (console.groupCollapsed(`Recoil: Spent ${i - n}ms computing a cache key`), console.warn(t, r), console.groupEnd()), r;
  }
  return go(t, e);
}
var $y = x7;
const {
  TreeCache: C7
} = nP, Ap = {
  equality: "reference",
  eviction: "keep-all",
  maxSize: 1 / 0
};
function A7({
  equality: t = Ap.equality,
  eviction: e = Ap.eviction,
  maxSize: n = Ap.maxSize
} = Ap, r) {
  const i = R7(t);
  return O7(e, n, i, r);
}
function R7(t) {
  switch (t) {
    case "reference":
      return (e) => e;
    case "value":
      return (e) => $y(e);
  }
  throw wt(`Unrecognized equality policy ${t}`);
}
function O7(t, e, n, r) {
  switch (t) {
    case "keep-all":
      return new C7({
        name: r,
        mapNodeValue: n
      });
    case "lru":
      return rT({
        name: r,
        maxSize: Ln(e),
        mapNodeValue: n
      });
    case "most-recent":
      return rT({
        name: r,
        maxSize: 1,
        mapNodeValue: n
      });
  }
  throw wt(`Unrecognized eviction policy ${t}`);
}
var D7 = A7;
function I7(t) {
  var e, n;
  if (typeof window > "u")
    return !1;
  const i = (n = (t != null ? (e = t.ownerDocument) !== null && e !== void 0 ? e : t : document).defaultView) !== null && n !== void 0 ? n : window;
  return t != null && (typeof i.Node == "function" ? t instanceof i.Node : typeof t == "object" && typeof t.nodeType == "number" && typeof t.nodeName == "string");
}
var N7 = I7;
const {
  isReactNative: P7,
  isWindow: $7
} = Ay;
function M7(t) {
  if (t === null || typeof t != "object")
    return !0;
  switch (typeof t.$$typeof) {
    case "symbol":
      return !0;
    case "number":
      return !0;
  }
  return !!(t["@@__IMMUTABLE_ITERABLE__@@"] != null || t["@@__IMMUTABLE_KEYED__@@"] != null || t["@@__IMMUTABLE_INDEXED__@@"] != null || t["@@__IMMUTABLE_ORDERED__@@"] != null || t["@@__IMMUTABLE_RECORD__@@"] != null || N7(t) || bn(t) || t instanceof Error || ArrayBuffer.isView(t) || !P7 && $7(t));
}
function iP(t) {
  if (!(typeof t != "object" || M7(t))) {
    Object.freeze(t);
    for (const e in t)
      if (Object.prototype.hasOwnProperty.call(t, e)) {
        const n = t[e];
        typeof n == "object" && n != null && !Object.isFrozen(n) && iP(n);
      }
    Object.seal(t);
  }
}
var tw = iP;
const {
  isLoadable: F7,
  loadableWithError: Rp,
  loadableWithPromise: L7,
  loadableWithValue: K0
} = Mh, {
  WrappedValue: oP
} = tP, {
  getNodeLoadable: Op,
  peekNodeLoadable: B7,
  setNodeValue: j7
} = Iu, {
  saveDepsToStore: V7
} = Fh, {
  DEFAULT_VALUE: U7,
  getConfigDeletionHandler: q7,
  getNode: z7,
  registerNode: iT
} = ao, {
  isRecoilValue: H7
} = yu, {
  markRecoilValueModified: oT
} = $s, {
  retainedByOptionWithDefault: G7
} = ff, {
  recoilCallback: W7
} = eP;
class sP {
}
const Mf = new sP(), Ff = [], Dp = /* @__PURE__ */ new Map(), Y7 = /* @__PURE__ */ (() => {
  let t = 0;
  return () => t++;
})();
function aP(t) {
  let e = null;
  const {
    key: n,
    get: r,
    cachePolicy_UNSTABLE: i
  } = t, o = t.set != null ? t.set : void 0;
  if (process.env.NODE_ENV !== "production") {
    if (typeof n != "string")
      throw wt("A key option with a unique string value must be provided when creating a selector.");
    if (typeof r != "function")
      throw wt("Selectors must specify a get callback option to get the selector value.");
  }
  const s = /* @__PURE__ */ new Set(), a = D7(i ?? {
    equality: "reference",
    eviction: "keep-all"
  }, n), l = G7(t.retainedBy_UNSTABLE), u = /* @__PURE__ */ new Map();
  let c = 0;
  function f() {
    return !xn("recoil_memory_managament_2020") || c > 0;
  }
  function d(T) {
    return T.getState().knownSelectors.add(n), c++, () => {
      c--;
    };
  }
  function h() {
    return q7(n) !== void 0 && !f();
  }
  function p(T, $, P, H, Z) {
    q($, H, Z), g(T, P);
  }
  function g(T, $) {
    B(T, $) && U(T), v($, !0);
  }
  function m(T, $) {
    B(T, $) && (Ln(C(T)).stateVersions.clear(), v($, !1));
  }
  function v(T, $) {
    const P = Dp.get(T);
    if (P != null) {
      for (const H of P)
        oT(H, Ln(e));
      $ && Dp.delete(T);
    }
  }
  function S(T, $) {
    let P = Dp.get($);
    P == null && Dp.set($, P = /* @__PURE__ */ new Set()), P.add(T);
  }
  function _(T, $, P, H, Z, le) {
    return $.then((J) => {
      if (!f())
        throw U(T), Mf;
      const ue = K0(J);
      return p(T, P, Z, ue, H), J;
    }).catch((J) => {
      if (!f())
        throw U(T), Mf;
      if (bn(J))
        return b(T, J, P, H, Z, le);
      const ue = Rp(J);
      throw p(T, P, Z, ue, H), J;
    });
  }
  function b(T, $, P, H, Z, le) {
    return $.then((J) => {
      if (!f())
        throw U(T), Mf;
      le.loadingDepKey != null && le.loadingDepPromise === $ ? P.atomValues.set(le.loadingDepKey, K0(J)) : T.getState().knownSelectors.forEach((oe) => {
        P.atomValues.delete(oe);
      });
      const ue = E(T, P);
      if (ue && ue.state !== "loading") {
        if ((B(T, Z) || C(T) == null) && g(T, Z), ue.state === "hasValue")
          return ue.contents;
        throw ue.contents;
      }
      if (!B(T, Z)) {
        const oe = k(T, P);
        if (oe != null)
          return oe.loadingLoadable.contents;
      }
      const [he, me] = w(T, P, Z);
      if (he.state !== "loading" && p(T, P, Z, he, me), he.state === "hasError")
        throw he.contents;
      return he.contents;
    }).catch((J) => {
      if (J instanceof sP)
        throw Mf;
      if (!f())
        throw U(T), Mf;
      const ue = Rp(J);
      throw p(T, P, Z, ue, H), J;
    });
  }
  function y(T, $, P, H) {
    var Z, le, J, ue;
    if (B(T, H) || $.version === ((Z = T.getState()) === null || Z === void 0 || (le = Z.currentTree) === null || le === void 0 ? void 0 : le.version) || $.version === ((J = T.getState()) === null || J === void 0 || (ue = J.nextTree) === null || ue === void 0 ? void 0 : ue.version)) {
      var he, me, oe;
      V7(n, P, T, (he = (me = T.getState()) === null || me === void 0 || (oe = me.nextTree) === null || oe === void 0 ? void 0 : oe.version) !== null && he !== void 0 ? he : T.getState().currentTree.version);
    }
    for (const re of P)
      s.add(re);
  }
  function w(T, $, P) {
    let H = !0, Z = !0;
    const le = () => {
      Z = !1;
    };
    let J, ue = !1, he;
    const me = {
      loadingDepKey: null,
      loadingDepPromise: null
    }, oe = /* @__PURE__ */ new Map();
    function re({
      key: ae
    }) {
      const fe = Op(T, $, ae);
      switch (oe.set(ae, fe), H || (y(T, $, new Set(oe.keys()), P), m(T, P)), fe.state) {
        case "hasValue":
          return fe.contents;
        case "hasError":
          throw fe.contents;
        case "loading":
          throw me.loadingDepKey = ae, me.loadingDepPromise = fe.contents, fe.contents;
      }
      throw wt("Invalid Loadable state");
    }
    const se = (ae) => (...fe) => {
      if (Z)
        throw wt("Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.");
      return e == null && (process.env.NODE_ENV !== "production" ? as(!1, "Recoil Value can never be null") : as(!1)), W7(
        T,
        ae,
        fe,
        {
          node: e
        }
        // flowlint-line unclear-type:off
      );
    };
    try {
      J = r({
        get: re,
        getCallback: se
      }), J = H7(J) ? re(J) : J, F7(J) && (J.state === "hasError" && (ue = !0), J = J.contents), bn(J) ? J = _(T, J, $, oe, P, me).finally(le) : le(), J = J instanceof oP ? J.value : J;
    } catch (ae) {
      J = ae, bn(J) ? J = b(T, J, $, oe, P, me).finally(le) : (ue = !0, le());
    }
    return ue ? he = Rp(J) : bn(J) ? he = L7(J) : he = K0(J), H = !1, F(T, P, oe), y(T, $, new Set(oe.keys()), P), [he, oe];
  }
  function E(T, $) {
    let P = $.atomValues.get(n);
    if (P != null)
      return P;
    const H = /* @__PURE__ */ new Set();
    try {
      P = a.get((le) => (typeof le != "string" && (process.env.NODE_ENV !== "production" ? as(!1, "Cache nodeKey is type string") : as(!1)), Op(T, $, le).contents), {
        onNodeVisit: (le) => {
          le.type === "branch" && le.nodeKey !== n && H.add(le.nodeKey);
        }
      });
    } catch (le) {
      throw wt(`Problem with cache lookup for selector "${n}": ${le.message}`);
    }
    if (P) {
      var Z;
      $.atomValues.set(n, P), y(T, $, H, (Z = C(T)) === null || Z === void 0 ? void 0 : Z.executionID);
    }
    return P;
  }
  function x(T, $) {
    const P = E(T, $);
    if (P != null)
      return U(T), P;
    const H = k(T, $);
    if (H != null) {
      var Z;
      return ((Z = H.loadingLoadable) === null || Z === void 0 ? void 0 : Z.state) === "loading" && S(T, H.executionID), H.loadingLoadable;
    }
    const le = Y7(), [J, ue] = w(T, $, le);
    return J.state === "loading" ? (M(T, le, J, ue, $), S(T, le)) : (U(T), q($, J, ue)), J;
  }
  function k(T, $) {
    const P = IN([u.has(T) ? [Ln(u.get(T))] : [], Ty(g_(u, ([Z]) => Z !== T), ([, Z]) => Z)]);
    function H(Z) {
      for (const [le, J] of Z)
        if (!Op(T, $, le).is(J))
          return !0;
      return !1;
    }
    for (const Z of P) {
      if (
        // If this execution was already checked to be valid with this version
        // of state, then let's use it!
        Z.stateVersions.get($.version) || // If the deps for the execution match our current state, then it's valid
        !H(Z.depValuesDiscoveredSoFarDuringAsyncWork)
      )
        return Z.stateVersions.set($.version, !0), Z;
      Z.stateVersions.set($.version, !1);
    }
  }
  function C(T) {
    return u.get(T);
  }
  function M(T, $, P, H, Z) {
    u.set(T, {
      depValuesDiscoveredSoFarDuringAsyncWork: H,
      executionID: $,
      loadingLoadable: P,
      stateVersions: /* @__PURE__ */ new Map([[Z.version, !0]])
    });
  }
  function F(T, $, P) {
    if (B(T, $)) {
      const H = C(T);
      H != null && (H.depValuesDiscoveredSoFarDuringAsyncWork = P);
    }
  }
  function U(T) {
    u.delete(T);
  }
  function B(T, $) {
    var P;
    return $ === ((P = C(T)) === null || P === void 0 ? void 0 : P.executionID);
  }
  function N(T) {
    return Array.from(T.entries()).map(([$, P]) => [$, P.contents]);
  }
  function q(T, $, P) {
    process.env.NODE_ENV !== "production" && $.state !== "loading" && !t.dangerouslyAllowMutability && tw($.contents), T.atomValues.set(n, $);
    try {
      a.set(N(P), $);
    } catch (H) {
      throw wt(`Problem with setting cache for selector "${n}": ${H.message}`);
    }
  }
  function Q(T) {
    if (Ff.includes(n)) {
      const $ = `Recoil selector has circular dependencies: ${Ff.slice(Ff.indexOf(n)).join(" → ")}`;
      return Rp(wt($));
    }
    Ff.push(n);
    try {
      return T();
    } finally {
      Ff.pop();
    }
  }
  function ne(T, $) {
    const P = $.atomValues.get(n);
    return P ?? a.get((H) => {
      var Z;
      return typeof H != "string" && (process.env.NODE_ENV !== "production" ? as(!1, "Cache nodeKey is type string") : as(!1)), (Z = B7(T, $, H)) === null || Z === void 0 ? void 0 : Z.contents;
    });
  }
  function X(T, $) {
    return Q(() => x(T, $));
  }
  function O(T) {
    T.atomValues.delete(n);
  }
  function W(T, $) {
    e == null && (process.env.NODE_ENV !== "production" ? as(!1, "Recoil Value can never be null") : as(!1));
    for (const H of s) {
      var P;
      const Z = z7(H);
      (P = Z.clearCache) === null || P === void 0 || P.call(Z, T, $);
    }
    s.clear(), O($), a.clear(), oT(T, e);
  }
  return o != null ? e = iT({
    key: n,
    nodeType: "selector",
    peek: ne,
    get: X,
    set: ($, P, H) => {
      let Z = !1;
      const le = /* @__PURE__ */ new Map();
      function J({
        key: oe
      }) {
        if (Z)
          throw wt("Recoil: Async selector sets are not currently supported.");
        const re = Op($, P, oe);
        if (re.state === "hasValue")
          return re.contents;
        if (re.state === "loading") {
          const se = `Getting value of asynchronous atom or selector "${oe}" in a pending state while setting selector "${n}" is not yet supported.`;
          throw ni(se), wt(se);
        } else
          throw re.contents;
      }
      function ue(oe, re) {
        if (Z) {
          const fe = "Recoil: Async selector sets are not currently supported.";
          throw ni(fe), wt(fe);
        }
        const se = typeof re == "function" ? (
          // cast to any because we can't restrict type S from being a function itself without losing support for opaque types
          // flowlint-next-line unclear-type:off
          re(J(oe))
        ) : re;
        j7($, P, oe.key, se).forEach((fe, Y) => le.set(Y, fe));
      }
      function he(oe) {
        ue(oe, U7);
      }
      const me = o({
        set: ue,
        get: J,
        reset: he
      }, H);
      if (me !== void 0)
        throw bn(me) ? wt("Recoil: Async selector sets are not currently supported.") : wt("Recoil: selector set should be a void function.");
      return Z = !0, le;
    },
    init: d,
    invalidate: O,
    clearCache: W,
    shouldDeleteConfigOnRelease: h,
    dangerouslyAllowMutability: t.dangerouslyAllowMutability,
    shouldRestoreFromSnapshots: !1,
    retainedBy: l
  }) : e = iT({
    key: n,
    nodeType: "selector",
    peek: ne,
    get: X,
    init: d,
    invalidate: O,
    clearCache: W,
    shouldDeleteConfigOnRelease: h,
    dangerouslyAllowMutability: t.dangerouslyAllowMutability,
    shouldRestoreFromSnapshots: !1,
    retainedBy: l
  });
}
aP.value = (t) => new oP(t);
var $c = aP;
const {
  isLoadable: X7,
  loadableWithError: Q0,
  loadableWithPromise: J0,
  loadableWithValue: Vu
} = Mh, {
  WrappedValue: lP
} = tP, {
  peekNodeInfo: K7
} = Iu, {
  DEFAULT_VALUE: Gl,
  DefaultValue: Na,
  getConfigDeletionHandler: uP,
  registerNode: Q7,
  setConfigDeletionHandler: J7
} = ao, {
  isRecoilValue: Z7
} = yu, {
  getRecoilValueAsLoadable: eV,
  markRecoilValueModified: tV,
  setRecoilValue: sT,
  setRecoilValueLoadable: nV
} = $s, {
  retainedByOptionWithDefault: rV
} = ff, Lf = (t) => t instanceof lP ? t.value : t;
function iV(t) {
  const {
    key: e,
    persistence_UNSTABLE: n
  } = t, r = rV(t.retainedBy_UNSTABLE);
  let i = 0;
  function o(S) {
    return J0(S.then((_) => (s = Vu(_), _)).catch((_) => {
      throw s = Q0(_), _;
    }));
  }
  let s = bn(t.default) ? o(t.default) : X7(t.default) ? t.default.state === "loading" ? o(t.default.contents) : t.default : (
    // $FlowFixMe[incompatible-call]
    Vu(Lf(t.default))
  );
  u(s.contents);
  let a;
  const l = /* @__PURE__ */ new Map();
  function u(S) {
    return process.env.NODE_ENV !== "production" && t.dangerouslyAllowMutability !== !0 ? bn(S) ? S.then((_) => (tw(_), _)) : (tw(S), S) : S;
  }
  function c(S, _) {
    const b = _.then((y) => {
      var w, E;
      return ((E = ((w = S.getState().nextTree) !== null && w !== void 0 ? w : S.getState().currentTree).atomValues.get(e)) === null || E === void 0 ? void 0 : E.contents) === b && sT(S, v, y), y;
    }).catch((y) => {
      var w, E;
      throw ((E = ((w = S.getState().nextTree) !== null && w !== void 0 ? w : S.getState().currentTree).atomValues.get(e)) === null || E === void 0 ? void 0 : E.contents) === b && nV(S, v, Q0(y)), y;
    });
    return b;
  }
  function f(S, _, b) {
    var y;
    i++;
    const w = () => {
      var C;
      i--, (C = l.get(S)) === null || C === void 0 || C.forEach((M) => M()), l.delete(S);
    };
    if (S.getState().knownAtoms.add(e), s.state === "loading") {
      const C = () => {
        var M;
        ((M = S.getState().nextTree) !== null && M !== void 0 ? M : S.getState().currentTree).atomValues.has(e) || tV(S, v);
      };
      s.contents.finally(C);
    }
    const E = (y = t.effects) !== null && y !== void 0 ? y : t.effects_UNSTABLE;
    if (E != null) {
      let B = function(O) {
        if (M && O.key === e) {
          const W = C;
          return W instanceof Na ? d(S, _) : bn(W) ? J0(W.then((T) => T instanceof Na ? (
            // Cast T to S
            s.toPromise()
          ) : T)) : (
            // $FlowFixMe[incompatible-call]
            Vu(W)
          );
        }
        return eV(S, O);
      }, N = function(O) {
        return B(O).toPromise();
      }, q = function(O) {
        var W;
        const T = K7(S, (W = S.getState().nextTree) !== null && W !== void 0 ? W : S.getState().currentTree, O.key);
        return M && O.key === e && !(C instanceof Na) ? {
          ...T,
          isSet: !0,
          loadable: B(O)
        } : T;
      }, C = Gl, M = !0, F = !1, U = null;
      const Q = (O) => (W) => {
        if (M) {
          const T = B(v), $ = T.state === "hasValue" ? T.contents : Gl;
          C = typeof W == "function" ? (
            // cast to any because we can't restrict T from being a function without losing support for opaque types
            W($)
          ) : W, bn(C) && (C = C.then((P) => (U = {
            effect: O,
            value: P
          }, P)));
        } else {
          if (bn(W))
            throw wt("Setting atoms to async values is not implemented.");
          typeof W != "function" && (U = {
            effect: O,
            value: Lf(W)
          }), sT(S, v, typeof W == "function" ? (T) => {
            const $ = Lf(
              // cast to any because we can't restrict T from being a function without losing support for opaque types
              W(T)
              // flowlint-line unclear-type:off
            );
            return U = {
              effect: O,
              value: $
            }, $;
          } : Lf(W));
        }
      }, ne = (O) => () => Q(O)(Gl), X = (O) => (W) => {
        var T;
        const {
          release: $
        } = S.subscribeToTransactions((P) => {
          var H;
          let {
            currentTree: Z,
            previousTree: le
          } = P.getState();
          le || (ni("Transaction subscribers notified without a next tree being present -- this is a bug in Recoil"), le = Z);
          const J = (H = Z.atomValues.get(e)) !== null && H !== void 0 ? H : s;
          if (J.state === "hasValue") {
            var ue, he, me, oe;
            const re = J.contents, se = (ue = le.atomValues.get(e)) !== null && ue !== void 0 ? ue : s, ae = se.state === "hasValue" ? se.contents : Gl;
            ((he = U) === null || he === void 0 ? void 0 : he.effect) !== O || ((me = U) === null || me === void 0 ? void 0 : me.value) !== re ? W(re, ae, !Z.atomValues.has(e)) : ((oe = U) === null || oe === void 0 ? void 0 : oe.effect) === O && (U = null);
          }
        }, e);
        l.set(S, [...(T = l.get(S)) !== null && T !== void 0 ? T : [], $]);
      };
      for (const O of E)
        try {
          const W = O({
            node: v,
            storeID: S.storeID,
            parentStoreID_UNSTABLE: S.parentStoreID,
            trigger: b,
            setSelf: Q(O),
            resetSelf: ne(O),
            onSet: X(O),
            getPromise: N,
            getLoadable: B,
            getInfo_UNSTABLE: q
          });
          if (W != null) {
            var x;
            l.set(S, [...(x = l.get(S)) !== null && x !== void 0 ? x : [], W]);
          }
        } catch (W) {
          C = W, F = !0;
        }
      if (M = !1, !(C instanceof Na)) {
        var k;
        const O = F ? Q0(C) : bn(C) ? J0(c(S, C)) : Vu(Lf(C));
        u(O.contents), _.atomValues.set(e, O), (k = S.getState().nextTree) === null || k === void 0 || k.atomValues.set(e, O);
      }
    }
    return w;
  }
  function d(S, _) {
    var b, y;
    return (b = (y = _.atomValues.get(e)) !== null && y !== void 0 ? y : a) !== null && b !== void 0 ? b : s;
  }
  function h(S, _) {
    if (_.atomValues.has(e))
      return Ln(_.atomValues.get(e));
    if (_.nonvalidatedAtoms.has(e)) {
      if (a != null)
        return a;
      if (n == null)
        return c_(`Tried to restore a persisted value for atom ${e} but it has no persistence settings.`), s;
      const b = _.nonvalidatedAtoms.get(e), y = n.validator(b, Gl);
      return a = y instanceof Na ? s : Vu(y), a;
    } else
      return s;
  }
  function p() {
    a = void 0;
  }
  function g(S, _, b) {
    if (_.atomValues.has(e)) {
      const y = Ln(_.atomValues.get(e));
      if (y.state === "hasValue" && b === y.contents)
        return /* @__PURE__ */ new Map();
    } else if (!_.nonvalidatedAtoms.has(e) && b instanceof Na)
      return /* @__PURE__ */ new Map();
    return u(b), a = void 0, (/* @__PURE__ */ new Map()).set(e, Vu(b));
  }
  function m() {
    return uP(e) !== void 0 && i <= 0;
  }
  const v = Q7({
    key: e,
    nodeType: "atom",
    peek: d,
    get: h,
    set: g,
    init: f,
    invalidate: p,
    shouldDeleteConfigOnRelease: m,
    dangerouslyAllowMutability: t.dangerouslyAllowMutability,
    persistence_UNSTABLE: t.persistence_UNSTABLE ? {
      type: t.persistence_UNSTABLE.type,
      backButton: t.persistence_UNSTABLE.backButton
    } : void 0,
    shouldRestoreFromSnapshots: !0,
    retainedBy: r
  });
  return v;
}
function w_(t) {
  if (process.env.NODE_ENV !== "production" && typeof t.key != "string")
    throw wt("A key option with a unique string value must be provided when creating an atom.");
  const {
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    ...e
  } = t, n = "default" in t ? (
    // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
    t.default
  ) : new Promise(() => {
  });
  return Z7(n) ? oV({
    ...e,
    default: n
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
  }) : iV({
    ...e,
    default: n
  });
}
function oV(t) {
  const e = w_({
    ...t,
    default: Gl,
    persistence_UNSTABLE: t.persistence_UNSTABLE === void 0 ? void 0 : {
      ...t.persistence_UNSTABLE,
      validator: (r) => r instanceof Na ? r : Ln(t.persistence_UNSTABLE).validator(r, Gl)
    },
    // TODO Hack for now.
    effects: t.effects,
    // flowlint-line unclear-type: off
    effects_UNSTABLE: t.effects_UNSTABLE
    // flowlint-line unclear-type: off
  }), n = $c({
    key: `${t.key}__withFallback`,
    get: ({
      get: r
    }) => {
      const i = r(e);
      return i instanceof Na ? t.default : i;
    },
    // $FlowFixMe[incompatible-call]
    set: ({
      set: r
    }, i) => r(e, i),
    // This selector does not need to cache as it is a wrapper selector
    // and the selector within the wrapper selector will have a cache
    // option by default
    cachePolicy_UNSTABLE: {
      eviction: "most-recent"
    },
    dangerouslyAllowMutability: t.dangerouslyAllowMutability
  });
  return J7(n.key, uP(t.key)), n;
}
w_.value = (t) => new lP(t);
var cP = w_;
let sV = class {
  constructor(e) {
    var n;
    Et(this, "_map", void 0), Et(this, "_keyMapper", void 0), this._map = /* @__PURE__ */ new Map(), this._keyMapper = (n = e?.mapKey) !== null && n !== void 0 ? n : (r) => r;
  }
  size() {
    return this._map.size;
  }
  has(e) {
    return this._map.has(this._keyMapper(e));
  }
  get(e) {
    return this._map.get(this._keyMapper(e));
  }
  set(e, n) {
    this._map.set(this._keyMapper(e), n);
  }
  delete(e) {
    this._map.delete(this._keyMapper(e));
  }
  clear() {
    this._map.clear();
  }
};
var aV = {
  MapCache: sV
}, lV = aV.MapCache, uV = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MapCache: lV
});
const {
  LRUCache: aT
} = rP, {
  MapCache: cV
} = uV, Ip = {
  equality: "reference",
  eviction: "none",
  maxSize: 1 / 0
};
function fV({
  equality: t = Ip.equality,
  eviction: e = Ip.eviction,
  maxSize: n = Ip.maxSize
} = Ip) {
  const r = dV(t);
  return hV(e, n, r);
}
function dV(t) {
  switch (t) {
    case "reference":
      return (e) => e;
    case "value":
      return (e) => $y(e);
  }
  throw wt(`Unrecognized equality policy ${t}`);
}
function hV(t, e, n) {
  switch (t) {
    case "keep-all":
      return new cV({
        mapKey: n
      });
    case "lru":
      return new aT({
        mapKey: n,
        maxSize: Ln(e)
      });
    case "most-recent":
      return new aT({
        mapKey: n,
        maxSize: 1
      });
  }
  throw wt(`Unrecognized eviction policy ${t}`);
}
var fP = fV;
const {
  setConfigDeletionHandler: pV
} = ao;
function gV(t) {
  var e, n;
  const r = fP({
    equality: (e = (n = t.cachePolicyForParams_UNSTABLE) === null || n === void 0 ? void 0 : n.equality) !== null && e !== void 0 ? e : "value",
    eviction: "keep-all"
  });
  return (i) => {
    var o, s;
    const a = r.get(i);
    if (a != null)
      return a;
    const {
      cachePolicyForParams_UNSTABLE: l,
      ...u
    } = t, c = "default" in t ? (
      // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
      t.default
    ) : new Promise(() => {
    }), f = cP({
      ...u,
      key: `${t.key}__${(o = $y(i)) !== null && o !== void 0 ? o : "void"}`,
      default: typeof c == "function" ? (
        // The default was parameterized
        // Flow doesn't know that T isn't a function, so we need to case to any
        // $FlowIssue[incompatible-use]
        c(i)
      ) : (
        // Default may be a static value, promise, or RecoilValue
        c
      ),
      retainedBy_UNSTABLE: typeof t.retainedBy_UNSTABLE == "function" ? t.retainedBy_UNSTABLE(i) : t.retainedBy_UNSTABLE,
      effects: typeof t.effects == "function" ? t.effects(i) : typeof t.effects_UNSTABLE == "function" ? t.effects_UNSTABLE(i) : (s = t.effects) !== null && s !== void 0 ? s : t.effects_UNSTABLE
      // prettier-ignore
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS: mapScopeRules(
      // @fb-only: options.scopeRules_APPEND_ONLY_READ_THE_DOCS,
      // @fb-only: params,
      // @fb-only: ),
    });
    return r.set(i, f), pV(f.key, () => {
      r.delete(i);
    }), f;
  };
}
var mV = gV;
const {
  setConfigDeletionHandler: yV
} = ao;
let vV = 0;
function bV(t) {
  var e, n;
  const r = fP({
    equality: (e = (n = t.cachePolicyForParams_UNSTABLE) === null || n === void 0 ? void 0 : n.equality) !== null && e !== void 0 ? e : "value",
    eviction: "keep-all"
  });
  return (i) => {
    var o;
    let s;
    try {
      s = r.get(i);
    } catch (d) {
      throw wt(`Problem with cache lookup for selector ${t.key}: ${d.message}`);
    }
    if (s != null)
      return s;
    const a = `${t.key}__selectorFamily/${(o = $y(i, {
      // It is possible to use functions in parameters if the user uses
      // a cache with reference equality thanks to the incrementing index.
      allowFunctions: !0
    })) !== null && o !== void 0 ? o : "void"}/${vV++}`, l = (d) => t.get(i)(d), u = t.cachePolicy_UNSTABLE, c = typeof t.retainedBy_UNSTABLE == "function" ? t.retainedBy_UNSTABLE(i) : t.retainedBy_UNSTABLE;
    let f;
    if (t.set != null) {
      const d = t.set;
      f = $c({
        key: a,
        get: l,
        set: (p, g) => d(i)(p, g),
        cachePolicy_UNSTABLE: u,
        dangerouslyAllowMutability: t.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: c
      });
    } else
      f = $c({
        key: a,
        get: l,
        cachePolicy_UNSTABLE: u,
        dangerouslyAllowMutability: t.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: c
      });
    return r.set(i, f), yV(f.key, () => {
      r.delete(i);
    }), f;
  };
}
var ml = bV;
ml({
  key: "__constant",
  get: (t) => () => t,
  cachePolicyForParams_UNSTABLE: {
    equality: "reference"
  }
});
ml({
  key: "__error",
  get: (t) => () => {
    throw wt(t);
  },
  // TODO Why?
  cachePolicyForParams_UNSTABLE: {
    equality: "reference"
  }
});
const {
  loadableWithError: dP,
  loadableWithPromise: hP,
  loadableWithValue: pP
} = Mh;
function My(t, e) {
  const n = Array(e.length).fill(void 0), r = Array(e.length).fill(void 0);
  for (const [i, o] of e.entries())
    try {
      n[i] = t(o);
    } catch (s) {
      r[i] = s;
    }
  return [n, r];
}
function wV(t) {
  return t != null && !bn(t);
}
function Fy(t) {
  return Array.isArray(t) ? t : Object.getOwnPropertyNames(t).map((e) => t[e]);
}
function nw(t, e) {
  return Array.isArray(t) ? e : (
    // Object.getOwnPropertyNames() has consistent key ordering with ES6
    Object.getOwnPropertyNames(t).reduce((n, r, i) => ({
      ...n,
      [r]: e[i]
    }), {})
  );
}
function mc(t, e, n) {
  const r = n.map((i, o) => i == null ? pP(e[o]) : bn(i) ? hP(i) : dP(i));
  return nw(t, r);
}
function SV(t, e) {
  return e.map((n, r) => (
    /**
     * it's important we use === undefined as opposed to == null, because the
     * resolved value of the async promise could be `null`, in which case we
     * don't want to use syncResults[idx], which would be undefined. If async
     * promise resolves to `undefined`, that's ok because `syncResults[idx]`
     * will also be `undefined`. That's a little hacky, but it works.
     */
    n === void 0 ? t[r] : n
  ));
}
ml({
  key: "__waitForNone",
  get: (t) => ({
    get: e
  }) => {
    const n = Fy(t), [r, i] = My(e, n);
    return mc(t, r, i);
  },
  dangerouslyAllowMutability: !0
});
ml({
  key: "__waitForAny",
  get: (t) => ({
    get: e
  }) => {
    const n = Fy(t), [r, i] = My(e, n);
    return i.some((o) => !bn(o)) ? mc(t, r, i) : new Promise((o) => {
      for (const [s, a] of i.entries())
        bn(a) && a.then((l) => {
          r[s] = l, i[s] = void 0, o(mc(t, r, i));
        }).catch((l) => {
          i[s] = l, o(mc(t, r, i));
        });
    });
  },
  dangerouslyAllowMutability: !0
});
const _V = ml({
  key: "__waitForAll",
  get: (t) => ({
    get: e
  }) => {
    const n = Fy(t), [r, i] = My(e, n);
    if (i.every((s) => s == null))
      return nw(t, r);
    const o = i.find(wV);
    if (o != null)
      throw o;
    return Promise.all(i).then((s) => nw(t, SV(r, s)));
  },
  dangerouslyAllowMutability: !0
});
ml({
  key: "__waitForAllSettled",
  get: (t) => ({
    get: e
  }) => {
    const n = Fy(t), [r, i] = My(e, n);
    return i.every((o) => !bn(o)) ? mc(t, r, i) : Promise.all(i.map((o, s) => bn(o) ? o.then((a) => {
      r[s] = a, i[s] = void 0;
    }).catch((a) => {
      r[s] = void 0, i[s] = a;
    }) : null)).then(() => mc(t, r, i));
  },
  dangerouslyAllowMutability: !0
});
ml({
  key: "__noWait",
  get: (t) => ({
    get: e
  }) => {
    try {
      return $c.value(pP(e(t)));
    } catch (n) {
      return $c.value(bn(n) ? hP(n) : dP(n));
    }
  },
  dangerouslyAllowMutability: !0
});
var EV = {
  waitForAll: _V
};
const {
  RecoilLoadable: Hae
} = Mh, {
  RecoilRoot: kV
} = df, {
  isRecoilValue: Gae
} = yu, {
  freshSnapshot: Wae
} = Dy, {
  useRecoilState: TV,
  useRecoilValue: xV,
  useRecoilValueLoadable: CV,
  useResetRecoilState: AV,
  useSetRecoilState: RV
} = T6, {
  useRecoilCallback: OV
} = eP, {
  waitForAll: DV
} = EV;
var yi = {
  // Global Recoil environment settiongs
  RecoilEnv: cf,
  // Recoil Root
  RecoilRoot: kV,
  // Atoms/Selectors
  atom: cP,
  selector: $c,
  // Convenience Atoms/Selectors
  atomFamily: mV,
  selectorFamily: ml,
  waitForAll: DV,
  // Hooks for Atoms/Selectors
  useRecoilValue: xV,
  useRecoilValueLoadable: CV,
  useRecoilState: TV,
  useSetRecoilState: RV,
  useResetRecoilState: AV,
  useRecoilRefresher_UNSTABLE: a7,
  // Hooks for complex operations
  useRecoilCallback: OV,
  useRecoilTransaction_UNSTABLE: d7
}, IV = yi.RecoilEnv, NV = yi.RecoilRoot, Tt = yi.atom, Qt = yi.selector, lo = yi.atomFamily, PV = yi.selectorFamily, $V = yi.waitForAll, L = yi.useRecoilValue, MV = yi.useRecoilValueLoadable, cs = yi.useRecoilState, un = yi.useSetRecoilState, gP = yi.useResetRecoilState, FV = yi.useRecoilRefresher_UNSTABLE, Es = yi.useRecoilCallback, LV = yi.useRecoilTransaction_UNSTABLE, Pr = function() {
  return Pr = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Pr.apply(this, arguments);
};
function ll(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, i = e.length, o; r < i; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function BV(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var jV = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, VV = /* @__PURE__ */ BV(
  function(t) {
    return jV.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), In = "-ms-", zd = "-moz-", on = "-webkit-", mP = "comm", Ly = "rule", S_ = "decl", UV = "@import", yP = "@keyframes", qV = "@layer", vP = Math.abs, __ = String.fromCharCode, rw = Object.assign;
function zV(t, e) {
  return Dr(t, 0) ^ 45 ? (((e << 2 ^ Dr(t, 0)) << 2 ^ Dr(t, 1)) << 2 ^ Dr(t, 2)) << 2 ^ Dr(t, 3) : 0;
}
function bP(t) {
  return t.trim();
}
function Ys(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function Dt(t, e, n) {
  return t.replace(e, n);
}
function Hg(t, e, n) {
  return t.indexOf(e, n);
}
function Dr(t, e) {
  return t.charCodeAt(e) | 0;
}
function Mc(t, e, n) {
  return t.slice(e, n);
}
function ds(t) {
  return t.length;
}
function wP(t) {
  return t.length;
}
function _d(t, e) {
  return e.push(t), t;
}
function HV(t, e) {
  return t.map(e).join("");
}
function lT(t, e) {
  return t.filter(function(n) {
    return !Ys(n, e);
  });
}
var By = 1, Fc = 1, SP = 0, Oo = 0, cr = 0, hf = "";
function jy(t, e, n, r, i, o, s, a) {
  return { value: t, root: e, parent: n, type: r, props: i, children: o, line: By, column: Fc, length: s, return: "", siblings: a };
}
function Oa(t, e) {
  return rw(jy("", null, null, "", null, null, 0, t.siblings), t, { length: -t.length }, e);
}
function Uu(t) {
  for (; t.root; )
    t = Oa(t.root, { children: [t] });
  _d(t, t.siblings);
}
function GV() {
  return cr;
}
function WV() {
  return cr = Oo > 0 ? Dr(hf, --Oo) : 0, Fc--, cr === 10 && (Fc = 1, By--), cr;
}
function Go() {
  return cr = Oo < SP ? Dr(hf, Oo++) : 0, Fc++, cr === 10 && (Fc = 1, By++), cr;
}
function uu() {
  return Dr(hf, Oo);
}
function Gg() {
  return Oo;
}
function Vy(t, e) {
  return Mc(hf, t, e);
}
function iw(t) {
  switch (t) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function YV(t) {
  return By = Fc = 1, SP = ds(hf = t), Oo = 0, [];
}
function XV(t) {
  return hf = "", t;
}
function Z0(t) {
  return bP(Vy(Oo - 1, ow(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function KV(t) {
  for (; (cr = uu()) && cr < 33; )
    Go();
  return iw(t) > 2 || iw(cr) > 3 ? "" : " ";
}
function QV(t, e) {
  for (; --e && Go() && !(cr < 48 || cr > 102 || cr > 57 && cr < 65 || cr > 70 && cr < 97); )
    ;
  return Vy(t, Gg() + (e < 6 && uu() == 32 && Go() == 32));
}
function ow(t) {
  for (; Go(); )
    switch (cr) {
      // ] ) " '
      case t:
        return Oo;
      // " '
      case 34:
      case 39:
        t !== 34 && t !== 39 && ow(cr);
        break;
      // (
      case 40:
        t === 41 && ow(t);
        break;
      // \
      case 92:
        Go();
        break;
    }
  return Oo;
}
function JV(t, e) {
  for (; Go() && t + cr !== 57; )
    if (t + cr === 84 && uu() === 47)
      break;
  return "/*" + Vy(e, Oo - 1) + "*" + __(t === 47 ? t : Go());
}
function ZV(t) {
  for (; !iw(uu()); )
    Go();
  return Vy(t, Oo);
}
function eU(t) {
  return XV(Wg("", null, null, null, [""], t = YV(t), 0, [0], t));
}
function Wg(t, e, n, r, i, o, s, a, l) {
  for (var u = 0, c = 0, f = s, d = 0, h = 0, p = 0, g = 1, m = 1, v = 1, S = 0, _ = "", b = i, y = o, w = r, E = _; m; )
    switch (p = S, S = Go()) {
      // (
      case 40:
        if (p != 108 && Dr(E, f - 1) == 58) {
          Hg(E += Dt(Z0(S), "&", "&\f"), "&\f", vP(u ? a[u - 1] : 0)) != -1 && (v = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        E += Z0(S);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        E += KV(p);
        break;
      // \
      case 92:
        E += QV(Gg() - 1, 7);
        continue;
      // /
      case 47:
        switch (uu()) {
          case 42:
          case 47:
            _d(tU(JV(Go(), Gg()), e, n, l), l);
            break;
          default:
            E += "/";
        }
        break;
      // {
      case 123 * g:
        a[u++] = ds(E) * v;
      // } ; \0
      case 125 * g:
      case 59:
      case 0:
        switch (S) {
          // \0 }
          case 0:
          case 125:
            m = 0;
          // ;
          case 59 + c:
            v == -1 && (E = Dt(E, /\f/g, "")), h > 0 && ds(E) - f && _d(h > 32 ? cT(E + ";", r, n, f - 1, l) : cT(Dt(E, " ", "") + ";", r, n, f - 2, l), l);
            break;
          // @ ;
          case 59:
            E += ";";
          // { rule/at-rule
          default:
            if (_d(w = uT(E, e, n, u, c, i, a, _, b = [], y = [], f, o), o), S === 123)
              if (c === 0)
                Wg(E, e, w, w, b, o, f, a, y);
              else
                switch (d === 99 && Dr(E, 3) === 110 ? 100 : d) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Wg(t, w, w, r && _d(uT(t, w, w, 0, 0, i, a, _, i, b = [], f, y), y), i, y, f, a, r ? b : y);
                    break;
                  default:
                    Wg(E, w, w, w, [""], y, 0, a, y);
                }
        }
        u = c = h = 0, g = v = 1, _ = E = "", f = s;
        break;
      // :
      case 58:
        f = 1 + ds(E), h = p;
      default:
        if (g < 1) {
          if (S == 123)
            --g;
          else if (S == 125 && g++ == 0 && WV() == 125)
            continue;
        }
        switch (E += __(S), S * g) {
          // &
          case 38:
            v = c > 0 ? 1 : (E += "\f", -1);
            break;
          // ,
          case 44:
            a[u++] = (ds(E) - 1) * v, v = 1;
            break;
          // @
          case 64:
            uu() === 45 && (E += Z0(Go())), d = uu(), c = f = ds(_ = E += ZV(Gg())), S++;
            break;
          // -
          case 45:
            p === 45 && ds(E) == 2 && (g = 0);
        }
    }
  return o;
}
function uT(t, e, n, r, i, o, s, a, l, u, c, f) {
  for (var d = i - 1, h = i === 0 ? o : [""], p = wP(h), g = 0, m = 0, v = 0; g < r; ++g)
    for (var S = 0, _ = Mc(t, d + 1, d = vP(m = s[g])), b = t; S < p; ++S)
      (b = bP(m > 0 ? h[S] + " " + _ : Dt(_, /&\f/g, h[S]))) && (l[v++] = b);
  return jy(t, e, n, i === 0 ? Ly : a, l, u, c, f);
}
function tU(t, e, n, r) {
  return jy(t, e, n, mP, __(GV()), Mc(t, 2, -2), 0, r);
}
function cT(t, e, n, r, i) {
  return jy(t, e, n, S_, Mc(t, 0, r), Mc(t, r + 1, -1), r, i);
}
function _P(t, e, n) {
  switch (zV(t, e)) {
    // color-adjust
    case 5103:
      return on + "print-" + t + t;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return on + t + t;
    // tab-size
    case 4789:
      return zd + t + t;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return on + t + zd + t + In + t + t;
    // writing-mode
    case 5936:
      switch (Dr(t, e + 11)) {
        // vertical-l(r)
        case 114:
          return on + t + In + Dt(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        // vertical-r(l)
        case 108:
          return on + t + In + Dt(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        // horizontal(-)tb
        case 45:
          return on + t + In + Dt(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return on + t + In + t + t;
    // order
    case 6165:
      return on + t + In + "flex-" + t + t;
    // align-items
    case 5187:
      return on + t + Dt(t, /(\w+).+(:[^]+)/, on + "box-$1$2" + In + "flex-$1$2") + t;
    // align-self
    case 5443:
      return on + t + In + "flex-item-" + Dt(t, /flex-|-self/g, "") + (Ys(t, /flex-|baseline/) ? "" : In + "grid-row-" + Dt(t, /flex-|-self/g, "")) + t;
    // align-content
    case 4675:
      return on + t + In + "flex-line-pack" + Dt(t, /align-content|flex-|-self/g, "") + t;
    // flex-shrink
    case 5548:
      return on + t + In + Dt(t, "shrink", "negative") + t;
    // flex-basis
    case 5292:
      return on + t + In + Dt(t, "basis", "preferred-size") + t;
    // flex-grow
    case 6060:
      return on + "box-" + Dt(t, "-grow", "") + on + t + In + Dt(t, "grow", "positive") + t;
    // transition
    case 4554:
      return on + Dt(t, /([^-])(transform)/g, "$1" + on + "$2") + t;
    // cursor
    case 6187:
      return Dt(Dt(Dt(t, /(zoom-|grab)/, on + "$1"), /(image-set)/, on + "$1"), t, "") + t;
    // background, background-image
    case 5495:
    case 3959:
      return Dt(t, /(image-set\([^]*)/, on + "$1$`$1");
    // justify-content
    case 4968:
      return Dt(Dt(t, /(.+:)(flex-)?(.*)/, on + "box-pack:$3" + In + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + on + t + t;
    // justify-self
    case 4200:
      if (!Ys(t, /flex-|baseline/)) return In + "grid-column-align" + Mc(t, e) + t;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return In + Dt(t, "template-", "") + t;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return n && n.some(function(r, i) {
        return e = i, Ys(r.props, /grid-\w+-end/);
      }) ? ~Hg(t + (n = n[e].value), "span", 0) ? t : In + Dt(t, "-start", "") + t + In + "grid-row-span:" + (~Hg(n, "span", 0) ? Ys(n, /\d+/) : +Ys(n, /\d+/) - +Ys(t, /\d+/)) + ";" : In + Dt(t, "-start", "") + t;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return n && n.some(function(r) {
        return Ys(r.props, /grid-\w+-start/);
      }) ? t : In + Dt(Dt(t, "-end", "-span"), "span ", "") + t;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Dt(t, /(.+)-inline(.+)/, on + "$1$2") + t;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ds(t) - 1 - e > 6)
        switch (Dr(t, e + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (Dr(t, e + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return Dt(t, /(.+:)(.+)-([^]+)/, "$1" + on + "$2-$3$1" + zd + (Dr(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          // (s)tretch
          case 115:
            return ~Hg(t, "stretch", 0) ? _P(Dt(t, "stretch", "fill-available"), e, n) + t : t;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return Dt(t, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, i, o, s, a, l, u) {
        return In + i + ":" + o + u + (s ? In + i + "-span:" + (a ? l : +l - +o) + u : "") + t;
      });
    // position: sticky
    case 4949:
      if (Dr(t, e + 6) === 121)
        return Dt(t, ":", ":" + on) + t;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (Dr(t, Dr(t, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return Dt(t, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + on + (Dr(t, 14) === 45 ? "inline-" : "") + "box$3$1" + on + "$2$3$1" + In + "$2box$3") + t;
        // (inline-)?gri(d)
        case 100:
          return Dt(t, ":", ":" + In) + t;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return Dt(t, "scroll-", "scroll-snap-") + t;
  }
  return t;
}
function Im(t, e) {
  for (var n = "", r = 0; r < t.length; r++)
    n += e(t[r], r, t, e) || "";
  return n;
}
function nU(t, e, n, r) {
  switch (t.type) {
    case qV:
      if (t.children.length) break;
    case UV:
    case S_:
      return t.return = t.return || t.value;
    case mP:
      return "";
    case yP:
      return t.return = t.value + "{" + Im(t.children, r) + "}";
    case Ly:
      if (!ds(t.value = t.props.join(","))) return "";
  }
  return ds(n = Im(t.children, r)) ? t.return = t.value + "{" + n + "}" : "";
}
function rU(t) {
  var e = wP(t);
  return function(n, r, i, o) {
    for (var s = "", a = 0; a < e; a++)
      s += t[a](n, r, i, o) || "";
    return s;
  };
}
function iU(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function oU(t, e, n, r) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case S_:
        t.return = _P(t.value, t.length, n);
        return;
      case yP:
        return Im([Oa(t, { value: Dt(t.value, "@", "@" + on) })], r);
      case Ly:
        if (t.length)
          return HV(n = t.props, function(i) {
            switch (Ys(i, r = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                Uu(Oa(t, { props: [Dt(i, /:(read-\w+)/, ":" + zd + "$1")] })), Uu(Oa(t, { props: [i] })), rw(t, { props: lT(n, r) });
                break;
              // :placeholder
              case "::placeholder":
                Uu(Oa(t, { props: [Dt(i, /:(plac\w+)/, ":" + on + "input-$1")] })), Uu(Oa(t, { props: [Dt(i, /:(plac\w+)/, ":" + zd + "$1")] })), Uu(Oa(t, { props: [Dt(i, /:(plac\w+)/, In + "input-$1")] })), Uu(Oa(t, { props: [i] })), rw(t, { props: lT(n, r) });
                break;
            }
            return "";
          });
    }
}
var sU = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, vu = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", EP = "active", kP = "data-styled-version", Uy = "6.1.15", E_ = `/*!sc*/
`, Nm = typeof window < "u" && "HTMLElement" in window, aU = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), lU = {}, fT = /invalid hook call/i, Np = /* @__PURE__ */ new Set(), TP = function(t, e) {
  if (process.env.NODE_ENV !== "production") {
    var n = e ? ' with the id of "'.concat(e, '"') : "", r = "The component ".concat(t).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, i = console.error;
    try {
      var o = !0;
      console.error = function(s) {
        for (var a = [], l = 1; l < arguments.length; l++) a[l - 1] = arguments[l];
        fT.test(s) ? (o = !1, Np.delete(r)) : i.apply(void 0, ll([s], a, !1));
      }, Xe(), o && !Np.has(r) && (console.warn(r), Np.add(r));
    } catch (s) {
      fT.test(s.message) && Np.delete(r);
    } finally {
      console.error = i;
    }
  }
}, qy = Object.freeze([]), Lc = Object.freeze({});
function xP(t, e, n) {
  return n === void 0 && (n = Lc), t.theme !== n.theme && t.theme || e || n.theme;
}
var sw = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), uU = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, cU = /(^-|-$)/g;
function dT(t) {
  return t.replace(uU, "-").replace(cU, "");
}
var fU = /(a)(d)/gi, Pp = 52, hT = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function aw(t) {
  var e, n = "";
  for (e = Math.abs(t); e > Pp; e = e / Pp | 0) n = hT(e % Pp) + n;
  return (hT(e % Pp) + n).replace(fU, "$1-$2");
}
var ev, CP = 5381, Wl = function(t, e) {
  for (var n = e.length; n; ) t = 33 * t ^ e.charCodeAt(--n);
  return t;
}, AP = function(t) {
  return Wl(CP, t);
};
function k_(t) {
  return aw(AP(t) >>> 0);
}
function RP(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function tv(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var OP = typeof Symbol == "function" && Symbol.for, DP = OP ? Symbol.for("react.memo") : 60115, dU = OP ? Symbol.for("react.forward_ref") : 60112, hU = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, pU = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, IP = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, gU = ((ev = {})[dU] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, ev[DP] = IP, ev);
function pT(t) {
  return ("type" in (e = t) && e.type.$$typeof) === DP ? IP : "$$typeof" in t ? gU[t.$$typeof] : hU;
  var e;
}
var mU = Object.defineProperty, yU = Object.getOwnPropertyNames, gT = Object.getOwnPropertySymbols, vU = Object.getOwnPropertyDescriptor, bU = Object.getPrototypeOf, mT = Object.prototype;
function NP(t, e, n) {
  if (typeof e != "string") {
    if (mT) {
      var r = bU(e);
      r && r !== mT && NP(t, r, n);
    }
    var i = yU(e);
    gT && (i = i.concat(gT(e)));
    for (var o = pT(t), s = pT(e), a = 0; a < i.length; ++a) {
      var l = i[a];
      if (!(l in pU || n && n[l] || s && l in s || o && l in o)) {
        var u = vU(e, l);
        try {
          mU(t, l, u);
        } catch {
        }
      }
    }
  }
  return t;
}
function bu(t) {
  return typeof t == "function";
}
function T_(t) {
  return typeof t == "object" && "styledComponentId" in t;
}
function Jl(t, e) {
  return t && e ? "".concat(t, " ").concat(e) : t || e || "";
}
function Pm(t, e) {
  if (t.length === 0) return "";
  for (var n = t[0], r = 1; r < t.length; r++) n += t[r];
  return n;
}
function Bc(t) {
  return t !== null && typeof t == "object" && t.constructor.name === Object.name && !("props" in t && t.$$typeof);
}
function lw(t, e, n) {
  if (n === void 0 && (n = !1), !n && !Bc(t) && !Array.isArray(t)) return e;
  if (Array.isArray(e)) for (var r = 0; r < e.length; r++) t[r] = lw(t[r], e[r]);
  else if (Bc(e)) for (var r in e) t[r] = lw(t[r], e[r]);
  return t;
}
function x_(t, e) {
  Object.defineProperty(t, "toString", { value: e });
}
var wU = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function SU() {
  for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
  for (var n = t[0], r = [], i = 1, o = t.length; i < o; i += 1) r.push(t[i]);
  return r.forEach(function(s) {
    n = n.replace(/%[a-z]/, s);
  }), n;
}
function ca(t) {
  for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(e.length > 0 ? " Args: ".concat(e.join(", ")) : "")) : new Error(SU.apply(void 0, ll([wU[t]], e, !1)).trim());
}
var _U = function() {
  function t(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
  }
  return t.prototype.indexOfGroup = function(e) {
    for (var n = 0, r = 0; r < e; r++) n += this.groupSizes[r];
    return n;
  }, t.prototype.insertRules = function(e, n) {
    if (e >= this.groupSizes.length) {
      for (var r = this.groupSizes, i = r.length, o = i; e >= o; ) if ((o <<= 1) < 0) throw ca(16, "".concat(e));
      this.groupSizes = new Uint32Array(o), this.groupSizes.set(r), this.length = o;
      for (var s = i; s < o; s++) this.groupSizes[s] = 0;
    }
    for (var a = this.indexOfGroup(e + 1), l = (s = 0, n.length); s < l; s++) this.tag.insertRule(a, n[s]) && (this.groupSizes[e]++, a++);
  }, t.prototype.clearGroup = function(e) {
    if (e < this.length) {
      var n = this.groupSizes[e], r = this.indexOfGroup(e), i = r + n;
      this.groupSizes[e] = 0;
      for (var o = r; o < i; o++) this.tag.deleteRule(r);
    }
  }, t.prototype.getGroup = function(e) {
    var n = "";
    if (e >= this.length || this.groupSizes[e] === 0) return n;
    for (var r = this.groupSizes[e], i = this.indexOfGroup(e), o = i + r, s = i; s < o; s++) n += "".concat(this.tag.getRule(s)).concat(E_);
    return n;
  }, t;
}(), EU = 1 << 30, Yg = /* @__PURE__ */ new Map(), $m = /* @__PURE__ */ new Map(), Xg = 1, $p = function(t) {
  if (Yg.has(t)) return Yg.get(t);
  for (; $m.has(Xg); ) Xg++;
  var e = Xg++;
  if (process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > EU)) throw ca(16, "".concat(e));
  return Yg.set(t, e), $m.set(e, t), e;
}, kU = function(t, e) {
  Xg = e + 1, Yg.set(t, e), $m.set(e, t);
}, TU = "style[".concat(vu, "][").concat(kP, '="').concat(Uy, '"]'), xU = new RegExp("^".concat(vu, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), CU = function(t, e, n) {
  for (var r, i = n.split(","), o = 0, s = i.length; o < s; o++) (r = i[o]) && t.registerName(e, r);
}, AU = function(t, e) {
  for (var n, r = ((n = e.textContent) !== null && n !== void 0 ? n : "").split(E_), i = [], o = 0, s = r.length; o < s; o++) {
    var a = r[o].trim();
    if (a) {
      var l = a.match(xU);
      if (l) {
        var u = 0 | parseInt(l[1], 10), c = l[2];
        u !== 0 && (kU(c, u), CU(t, c, l[3]), t.getTag().insertRules(u, i)), i.length = 0;
      } else i.push(a);
    }
  }
}, yT = function(t) {
  for (var e = document.querySelectorAll(TU), n = 0, r = e.length; n < r; n++) {
    var i = e[n];
    i && i.getAttribute(vu) !== EP && (AU(t, i), i.parentNode && i.parentNode.removeChild(i));
  }
};
function RU() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var PP = function(t) {
  var e = document.head, n = t || e, r = document.createElement("style"), i = function(a) {
    var l = Array.from(a.querySelectorAll("style[".concat(vu, "]")));
    return l[l.length - 1];
  }(n), o = i !== void 0 ? i.nextSibling : null;
  r.setAttribute(vu, EP), r.setAttribute(kP, Uy);
  var s = RU();
  return s && r.setAttribute("nonce", s), n.insertBefore(r, o), r;
}, OU = function() {
  function t(e) {
    this.element = PP(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet) return n.sheet;
      for (var r = document.styleSheets, i = 0, o = r.length; i < o; i++) {
        var s = r[i];
        if (s.ownerNode === n) return s;
      }
      throw ca(17);
    }(this.element), this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    try {
      return this.sheet.insertRule(n, e), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.prototype.deleteRule = function(e) {
    this.sheet.deleteRule(e), this.length--;
  }, t.prototype.getRule = function(e) {
    var n = this.sheet.cssRules[e];
    return n && n.cssText ? n.cssText : "";
  }, t;
}(), DU = function() {
  function t(e) {
    this.element = PP(e), this.nodes = this.element.childNodes, this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    if (e <= this.length && e >= 0) {
      var r = document.createTextNode(n);
      return this.element.insertBefore(r, this.nodes[e] || null), this.length++, !0;
    }
    return !1;
  }, t.prototype.deleteRule = function(e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }, t;
}(), IU = function() {
  function t(e) {
    this.rules = [], this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    return e <= this.length && (this.rules.splice(e, 0, n), this.length++, !0);
  }, t.prototype.deleteRule = function(e) {
    this.rules.splice(e, 1), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.rules[e] : "";
  }, t;
}(), vT = Nm, NU = { isServer: !Nm, useCSSOMInjection: !aU }, Mm = function() {
  function t(e, n, r) {
    e === void 0 && (e = Lc), n === void 0 && (n = {});
    var i = this;
    this.options = Pr(Pr({}, NU), e), this.gs = n, this.names = new Map(r), this.server = !!e.isServer, !this.server && Nm && vT && (vT = !1, yT(this)), x_(this, function() {
      return function(o) {
        for (var s = o.getTag(), a = s.length, l = "", u = function(f) {
          var d = function(v) {
            return $m.get(v);
          }(f);
          if (d === void 0) return "continue";
          var h = o.names.get(d), p = s.getGroup(f);
          if (h === void 0 || !h.size || p.length === 0) return "continue";
          var g = "".concat(vu, ".g").concat(f, '[id="').concat(d, '"]'), m = "";
          h !== void 0 && h.forEach(function(v) {
            v.length > 0 && (m += "".concat(v, ","));
          }), l += "".concat(p).concat(g, '{content:"').concat(m, '"}').concat(E_);
        }, c = 0; c < a; c++) u(c);
        return l;
      }(i);
    });
  }
  return t.registerId = function(e) {
    return $p(e);
  }, t.prototype.rehydrate = function() {
    !this.server && Nm && yT(this);
  }, t.prototype.reconstructWithOptions = function(e, n) {
    return n === void 0 && (n = !0), new t(Pr(Pr({}, this.options), e), this.gs, n && this.names || void 0);
  }, t.prototype.allocateGSInstance = function(e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }, t.prototype.getTag = function() {
    return this.tag || (this.tag = (e = function(n) {
      var r = n.useCSSOMInjection, i = n.target;
      return n.isServer ? new IU(i) : r ? new OU(i) : new DU(i);
    }(this.options), new _U(e)));
    var e;
  }, t.prototype.hasNameForId = function(e, n) {
    return this.names.has(e) && this.names.get(e).has(n);
  }, t.prototype.registerName = function(e, n) {
    if ($p(e), this.names.has(e)) this.names.get(e).add(n);
    else {
      var r = /* @__PURE__ */ new Set();
      r.add(n), this.names.set(e, r);
    }
  }, t.prototype.insertRules = function(e, n, r) {
    this.registerName(e, n), this.getTag().insertRules($p(e), r);
  }, t.prototype.clearNames = function(e) {
    this.names.has(e) && this.names.get(e).clear();
  }, t.prototype.clearRules = function(e) {
    this.getTag().clearGroup($p(e)), this.clearNames(e);
  }, t.prototype.clearTag = function() {
    this.tag = void 0;
  }, t;
}(), PU = /&/g, $U = /^\s*\/\/.*$/gm;
function $P(t, e) {
  return t.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(e, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(e, " ")), n.props = n.props.map(function(r) {
      return "".concat(e, " ").concat(r);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = $P(n.children, e)), n;
  });
}
function MU(t) {
  var e, n, r, i = Lc, o = i.options, s = o === void 0 ? Lc : o, a = i.plugins, l = a === void 0 ? qy : a, u = function(d, h, p) {
    return p.startsWith(n) && p.endsWith(n) && p.replaceAll(n, "").length > 0 ? ".".concat(e) : d;
  }, c = l.slice();
  c.push(function(d) {
    d.type === Ly && d.value.includes("&") && (d.props[0] = d.props[0].replace(PU, n).replace(r, u));
  }), s.prefix && c.push(oU), c.push(nU);
  var f = function(d, h, p, g) {
    h === void 0 && (h = ""), p === void 0 && (p = ""), g === void 0 && (g = "&"), e = g, n = h, r = new RegExp("\\".concat(n, "\\b"), "g");
    var m = d.replace($U, ""), v = eU(p || h ? "".concat(p, " ").concat(h, " { ").concat(m, " }") : m);
    s.namespace && (v = $P(v, s.namespace));
    var S = [];
    return Im(v, rU(c.concat(iU(function(_) {
      return S.push(_);
    })))), S;
  };
  return f.hash = l.length ? l.reduce(function(d, h) {
    return h.name || ca(15), Wl(d, h.name);
  }, CP).toString() : "", f;
}
var FU = new Mm(), uw = MU(), MP = nt.createContext({ shouldForwardProp: void 0, styleSheet: FU, stylis: uw });
MP.Consumer;
nt.createContext(void 0);
function cw() {
  return kt(MP);
}
var fw = function() {
  function t(e, n) {
    var r = this;
    this.inject = function(i, o) {
      o === void 0 && (o = uw);
      var s = r.name + o.hash;
      i.hasNameForId(r.id, s) || i.insertRules(r.id, s, o(r.rules, s, "@keyframes"));
    }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = n, x_(this, function() {
      throw ca(12, String(r.name));
    });
  }
  return t.prototype.getName = function(e) {
    return e === void 0 && (e = uw), this.name + e.hash;
  }, t;
}(), LU = function(t) {
  return t >= "A" && t <= "Z";
};
function bT(t) {
  for (var e = "", n = 0; n < t.length; n++) {
    var r = t[n];
    if (n === 1 && r === "-" && t[0] === "-") return t;
    LU(r) ? e += "-" + r.toLowerCase() : e += r;
  }
  return e.startsWith("ms-") ? "-" + e : e;
}
var FP = function(t) {
  return t == null || t === !1 || t === "";
}, LP = function(t) {
  var e, n, r = [];
  for (var i in t) {
    var o = t[i];
    t.hasOwnProperty(i) && !FP(o) && (Array.isArray(o) && o.isCss || bu(o) ? r.push("".concat(bT(i), ":"), o, ";") : Bc(o) ? r.push.apply(r, ll(ll(["".concat(i, " {")], LP(o), !1), ["}"], !1)) : r.push("".concat(bT(i), ": ").concat((e = i, (n = o) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || e in sU || e.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return r;
};
function rl(t, e, n, r) {
  if (FP(t)) return [];
  if (T_(t)) return [".".concat(t.styledComponentId)];
  if (bu(t)) {
    if (!bu(o = t) || o.prototype && o.prototype.isReactComponent || !e) return [t];
    var i = t(e);
    return process.env.NODE_ENV === "production" || typeof i != "object" || Array.isArray(i) || i instanceof fw || Bc(i) || i === null || console.error("".concat(RP(t), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), rl(i, e, n, r);
  }
  var o;
  return t instanceof fw ? n ? (t.inject(n, r), [t.getName(r)]) : [t] : Bc(t) ? LP(t) : Array.isArray(t) ? Array.prototype.concat.apply(qy, t.map(function(s) {
    return rl(s, e, n, r);
  })) : [t.toString()];
}
function BP(t) {
  for (var e = 0; e < t.length; e += 1) {
    var n = t[e];
    if (bu(n) && !T_(n)) return !1;
  }
  return !0;
}
var BU = AP(Uy), jU = function() {
  function t(e, n, r) {
    this.rules = e, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && BP(e), this.componentId = n, this.baseHash = Wl(BU, n), this.baseStyle = r, Mm.registerId(n);
  }
  return t.prototype.generateAndInjectStyles = function(e, n, r) {
    var i = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, n, r) : "";
    if (this.isStatic && !r.hash) if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId)) i = Jl(i, this.staticRulesId);
    else {
      var o = Pm(rl(this.rules, e, n, r)), s = aw(Wl(this.baseHash, o) >>> 0);
      if (!n.hasNameForId(this.componentId, s)) {
        var a = r(o, ".".concat(s), void 0, this.componentId);
        n.insertRules(this.componentId, s, a);
      }
      i = Jl(i, s), this.staticRulesId = s;
    }
    else {
      for (var l = Wl(this.baseHash, r.hash), u = "", c = 0; c < this.rules.length; c++) {
        var f = this.rules[c];
        if (typeof f == "string") u += f, process.env.NODE_ENV !== "production" && (l = Wl(l, f));
        else if (f) {
          var d = Pm(rl(f, e, n, r));
          l = Wl(l, d + c), u += d;
        }
      }
      if (u) {
        var h = aw(l >>> 0);
        n.hasNameForId(this.componentId, h) || n.insertRules(this.componentId, h, r(u, ".".concat(h), void 0, this.componentId)), i = Jl(i, h);
      }
    }
    return i;
  }, t;
}(), jc = nt.createContext(void 0);
jc.Consumer;
function Rn(t) {
  var e = nt.useContext(jc), n = la(function() {
    return function(r, i) {
      if (!r) throw ca(14);
      if (bu(r)) {
        var o = r(i);
        if (process.env.NODE_ENV !== "production" && (o === null || Array.isArray(o) || typeof o != "object")) throw ca(7);
        return o;
      }
      if (Array.isArray(r) || typeof r != "object") throw ca(8);
      return i ? Pr(Pr({}, i), r) : r;
    }(t.theme, e);
  }, [t.theme, e]);
  return t.children ? nt.createElement(jc.Provider, { value: n }, t.children) : null;
}
var nv = {}, wT = /* @__PURE__ */ new Set();
function VU(t, e, n) {
  var r = T_(t), i = t, o = !tv(t), s = e.attrs, a = s === void 0 ? qy : s, l = e.componentId, u = l === void 0 ? function(b, y) {
    var w = typeof b != "string" ? "sc" : dT(b);
    nv[w] = (nv[w] || 0) + 1;
    var E = "".concat(w, "-").concat(k_(Uy + w + nv[w]));
    return y ? "".concat(y, "-").concat(E) : E;
  }(e.displayName, e.parentComponentId) : l, c = e.displayName, f = c === void 0 ? function(b) {
    return tv(b) ? "styled.".concat(b) : "Styled(".concat(RP(b), ")");
  }(t) : c, d = e.displayName && e.componentId ? "".concat(dT(e.displayName), "-").concat(e.componentId) : e.componentId || u, h = r && i.attrs ? i.attrs.concat(a).filter(Boolean) : a, p = e.shouldForwardProp;
  if (r && i.shouldForwardProp) {
    var g = i.shouldForwardProp;
    if (e.shouldForwardProp) {
      var m = e.shouldForwardProp;
      p = function(b, y) {
        return g(b, y) && m(b, y);
      };
    } else p = g;
  }
  var v = new jU(n, d, r ? i.componentStyle : void 0);
  function S(b, y) {
    return function(w, E, x) {
      var k = w.attrs, C = w.componentStyle, M = w.defaultProps, F = w.foldedComponentIds, U = w.styledComponentId, B = w.target, N = nt.useContext(jc), q = cw(), Q = w.shouldForwardProp || q.shouldForwardProp;
      process.env.NODE_ENV !== "production" && j2(U);
      var ne = xP(E, N, M) || Lc, X = function(H, Z, le) {
        for (var J, ue = Pr(Pr({}, Z), { className: void 0, theme: le }), he = 0; he < H.length; he += 1) {
          var me = bu(J = H[he]) ? J(ue) : J;
          for (var oe in me) ue[oe] = oe === "className" ? Jl(ue[oe], me[oe]) : oe === "style" ? Pr(Pr({}, ue[oe]), me[oe]) : me[oe];
        }
        return Z.className && (ue.className = Jl(ue.className, Z.className)), ue;
      }(k, E, ne), O = X.as || B, W = {};
      for (var T in X) X[T] === void 0 || T[0] === "$" || T === "as" || T === "theme" && X.theme === ne || (T === "forwardedAs" ? W.as = X.forwardedAs : Q && !Q(T, O) || (W[T] = X[T], Q || process.env.NODE_ENV !== "development" || VV(T) || wT.has(T) || !sw.has(O) || (wT.add(T), console.warn('styled-components: it looks like an unknown prop "'.concat(T, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var $ = function(H, Z) {
        var le = cw(), J = H.generateAndInjectStyles(Z, le.styleSheet, le.stylis);
        return process.env.NODE_ENV !== "production" && j2(J), J;
      }(C, X);
      process.env.NODE_ENV !== "production" && w.warnTooManyClasses && w.warnTooManyClasses($);
      var P = Jl(F, U);
      return $ && (P += " " + $), X.className && (P += " " + X.className), W[tv(O) && !sw.has(O) ? "class" : "className"] = P, x && (W.ref = x), A5(O, W);
    }(_, b, y);
  }
  S.displayName = f;
  var _ = nt.forwardRef(S);
  return _.attrs = h, _.componentStyle = v, _.displayName = f, _.shouldForwardProp = p, _.foldedComponentIds = r ? Jl(i.foldedComponentIds, i.styledComponentId) : "", _.styledComponentId = d, _.target = r ? i.target : t, Object.defineProperty(_, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(b) {
    this._foldedDefaultProps = r ? function(y) {
      for (var w = [], E = 1; E < arguments.length; E++) w[E - 1] = arguments[E];
      for (var x = 0, k = w; x < k.length; x++) lw(y, k[x], !0);
      return y;
    }({}, i.defaultProps, b) : b;
  } }), process.env.NODE_ENV !== "production" && (TP(f, d), _.warnTooManyClasses = /* @__PURE__ */ function(b, y) {
    var w = {}, E = !1;
    return function(x) {
      if (!E && (w[x] = !0, Object.keys(w).length >= 200)) {
        var k = y ? ' with the id of "'.concat(y, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(b).concat(k, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), E = !0, w = {};
      }
    };
  }(f, d)), x_(_, function() {
    return ".".concat(_.styledComponentId);
  }), o && NP(_, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), _;
}
function ST(t, e) {
  for (var n = [t[0]], r = 0, i = e.length; r < i; r += 1) n.push(e[r], t[r + 1]);
  return n;
}
var _T = function(t) {
  return Object.assign(t, { isCss: !0 });
};
function C_(t) {
  for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  if (bu(t) || Bc(t)) return _T(rl(ST(qy, ll([t], e, !0))));
  var r = t;
  return e.length === 0 && r.length === 1 && typeof r[0] == "string" ? rl(r) : _T(rl(ST(r, e)));
}
function dw(t, e, n) {
  if (n === void 0 && (n = Lc), !e) throw ca(1, e);
  var r = function(i) {
    for (var o = [], s = 1; s < arguments.length; s++) o[s - 1] = arguments[s];
    return t(e, n, C_.apply(void 0, ll([i], o, !1)));
  };
  return r.attrs = function(i) {
    return dw(t, e, Pr(Pr({}, n), { attrs: Array.prototype.concat(n.attrs, i).filter(Boolean) }));
  }, r.withConfig = function(i) {
    return dw(t, e, Pr(Pr({}, n), i));
  }, r;
}
var jP = function(t) {
  return dw(VU, t);
}, rt = jP;
sw.forEach(function(t) {
  rt[t] = jP(t);
});
var UU = function() {
  function t(e, n) {
    this.rules = e, this.componentId = n, this.isStatic = BP(e), Mm.registerId(this.componentId + 1);
  }
  return t.prototype.createStyles = function(e, n, r, i) {
    var o = i(Pm(rl(this.rules, n, r, i)), ""), s = this.componentId + e;
    r.insertRules(s, s, o);
  }, t.prototype.removeStyles = function(e, n) {
    n.clearRules(this.componentId + e);
  }, t.prototype.renderStyles = function(e, n, r, i) {
    e > 2 && Mm.registerId(this.componentId + e), this.removeStyles(e, r), this.createStyles(e, n, r, i);
  }, t;
}();
function qU(t) {
  for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  var r = C_.apply(void 0, ll([t], e, !1)), i = "sc-global-".concat(k_(JSON.stringify(r))), o = new UU(r, i);
  process.env.NODE_ENV !== "production" && TP(i);
  var s = function(l) {
    var u = cw(), c = nt.useContext(jc), f = nt.useRef(u.styleSheet.allocateGSInstance(i)).current;
    return process.env.NODE_ENV !== "production" && nt.Children.count(l.children) && console.warn("The global style component ".concat(i, " was given child JSX. createGlobalStyle does not render children.")), process.env.NODE_ENV !== "production" && r.some(function(d) {
      return typeof d == "string" && d.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), u.styleSheet.server && a(f, l, u.styleSheet, c, u.stylis), nt.useLayoutEffect(function() {
      if (!u.styleSheet.server) return a(f, l, u.styleSheet, c, u.stylis), function() {
        return o.removeStyles(f, u.styleSheet);
      };
    }, [f, l, u.styleSheet, c, u.stylis]), null;
  };
  function a(l, u, c, f, d) {
    if (o.isStatic) o.renderStyles(l, lU, c, d);
    else {
      var h = Pr(Pr({}, u), { theme: xP(u, f, s.defaultProps) });
      o.renderStyles(l, h, c, d);
    }
  }
  return nt.memo(s);
}
function A_(t) {
  for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var r = Pm(C_.apply(void 0, ll([t], e, !1))), i = k_(r);
  return new fw(i, r);
}
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var Mp = "__sc-".concat(vu, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[Mp] || (window[Mp] = 0), window[Mp] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[Mp] += 1);
const ks = {
  topBar: {
    landscape: {
      icon: "3.4svh"
    }
  },
  dialogPanel: {
    landscape: {
      margin: "1.6svw",
      height: "60svh"
    },
    portrait: {
      margin: "4svw",
      height: "90svh"
    }
  },
  editor: {
    landscape: {
      height: "70svh",
      gutter: "2.7svw"
    }
  }
}, Ot = {
  black: "#000",
  editorBorderGrey: "#c8c8c8",
  lightGrey: "#f0f0f0",
  positionMarkerBlue: "#7fd1f6",
  red: "#FF6961",
  white: "#FFF",
  yellow: "#EBB822",
  alabaster: {
    active: "#007ACC",
    blue: "#325CC0",
    red: "#AA3731",
    magenta: "#7A3E9D"
  },
  brand: {
    white: "#ffffff",
    purple: "#8265FD",
    blue: "#BCE4E7",
    yellow: "#F4EC7A"
  },
  tufte: {
    white: "#fffff8",
    black: "#111111"
  }
}, Gs = {
  backgroundColor: Ot.white,
  borderColor: Ot.black,
  color: Ot.black,
  font: "Gill Sans",
  fontSize: 1,
  height: 2,
  hoverColor: Ot.brand.blue,
  minWidth: {
    landscape: "3rem",
    portrait: "5rem"
  },
  emphasize: Ot.brand.yellow,
  alert: Ot.red,
  borderBlockEnd: 0,
  borderInlineEnd: 0,
  borderInlineStart: 0,
  borderBlockStart: 0
}, zU = rt.button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-1s4znhs-0"
})`
  appearance: none;
  padding: 0; /* Adjust as needed */
  margin: 0; /* Adjust as needed */
  align-items:center;
  background-color: ${(t) => t.$emphasize ? t.theme.emphasize : t.theme.background};
  border-radius: 3px;
  border-color: ${(t) => t.theme.borderColor ? t.theme.borderColor : Gs.borderColor};
  border-inline-start: ${(t) => t.theme.borderInlineStart ? t.theme.borderInlineStart : Gs.borderInlineStart}px solid;
  border-inline-end: ${(t) => t.theme.borderInlineEnd ? t.theme.borderInlineEnd : Gs.borderInlineEnd}px solid;
  border-block-end: ${(t) => t.theme.borderBlockEnd ? t.theme.borderBlockEnd : Gs.borderBlockEnd}px solid;
  border-block-start: ${(t) => t.theme.borderBlockStart ? t.theme.borderBlockStart : Gs.borderBlockStart}px solid;
  color: ${(t) => t.theme.color};
  cursor: pointer;
  font-size: ${(t) => t.theme.fontSize + "rem"};
  font-family: Gill Sans;
  display: flex;
  height: ${(t) => t.theme.height + "rem"};
  width: ${(t) => t.theme.width};
  justify-content: center;
  margin: 1rem;
  padding: 1rem;
  text-align: center;
  visibility: ${(t) => t.hide ? "hidden" : "visible"};
  min-width: ${(t) => t.$portrait ? Gs.minWidth.portrait : Gs.minWidth.landscape};
  &:hover {
  background-color: ${(t) => t.theme.hoverColor ? t.theme.hoverColor : Gs.hoverColor};
  transition: background-color 0.3s ease-in-out;
}
`;
zU.defaultProps = {
  theme: Gs
};
rt.div.withConfig({
  displayName: "StyledDialogPanel",
  componentId: "sc-1xm48aw-0"
})`
    background-color: ${(t) => t.theme.backgroundColor};
    border-radius: 8px;
    box-shadow: 0 0 15px rgb(0 0 0 / 20%);
    display: flex;
    flex-direction: column;
    display: ${(t) => t.$show ? "block" : "none"};
    height: ${(t) => t.$isInPortrait ? ks.dialogPanel.portrait.height : ks.dialogPanel.landscape.height};
    position: absolute;
    width: ${(t) => t.$isInPortrait ? "100svw" : "80svw"};
    z-index:1000;
    .hr-text {
        line-height: 1em;
        position: relative;
        outline: 0;
        border: 0;
        color: ${(t) => t.theme.color ?? "unset"};
        text-align: center;
        height: 1em;
        opacity: 0.9;
       
}
`;
rt.div.withConfig({
  displayName: "StyledTitle",
  componentId: "sc-g7a4ij-0"
})`
    align-items: center;
    align-self: center;
    color: ${(t) => t.theme.active};
    display: flex;
    font-family: ${(t) => t.theme.font};
    height: 100%;
    width: 100%;
    justify-content: space-between;
    padding-inline: ${(t) => t.$isInPortrait ? ks.dialogPanel.portrait.margin : ks.dialogPanel.landscape.margin};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid ${(t) => t.theme.navigationFrame};

`;
rt.div.withConfig({
  displayName: "StyledToggle",
  componentId: "sc-u9rcuv-0"
})`
    cursor: pointer;
    svg {
        height: ${ks.topBar.landscape.icon};
    }
    svg:hover path {
      fill: ${(t) => t.theme.buttonHover}; /* Change the fill color on hover */
    }
    
    svg:hover rect {
      fill: ${(t) => t.theme.backgroundColor};
      stroke: ${(t) => t.theme.buttonHover};
      stroke-width: 2px;
 /* Change the fill color on hover */
    }
`;
rt.div.withConfig({
  displayName: "StyledToggle__StyledToggleBlack",
  componentId: "sc-u9rcuv-1"
})`
    cursor: pointer;
    svg {
        height: ${ks.topBar.landscape.icon};
    }
    svg:hover path {
      fill: ${(t) => t.theme.navigationText}; /* Change the fill color on hover */
    }

    svg:hover text {
      fill: ${(t) => t.theme.navigationText}; /* Change the fill color on hover */
    }
    
    svg:hover rect {
      fill: ${(t) => t.theme.backgroundColor};
      stroke: ${(t) => t.theme.navigationText};
 /* Change the fill color on hover */
    }
`;
rt.div.withConfig({
  displayName: "StyledToggle__StyledToggleRed",
  componentId: "sc-u9rcuv-2"
})`
    cursor: pointer;
    svg {
        height: ${ks.topBar.landscape.icon};
    }

    svg:hover text {
      fill: ${(t) => t.theme.white}; /* Change the fill color on hover */
    }

    svg:hover rect {
      fill: ${(t) => t.theme.red};
 /* Change the fill color on hover */
    }
`;
var Fm = function() {
  return Fm = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Fm.apply(this, arguments);
};
const HU = "16.11.0", GU = Object.freeze({
  major: 16,
  minor: 11,
  patch: 0,
  preReleaseTag: null
});
function Nt(t, e) {
  if (!!!t)
    throw new Error(e);
}
function io(t) {
  return typeof t?.then == "function";
}
function oo(t) {
  return typeof t == "object" && t !== null;
}
function Zn(t, e) {
  if (!!!t)
    throw new Error(
      e ?? "Unexpected invariant triggered."
    );
}
const WU = /\r\n|[\n\r]/g;
function Lm(t, e) {
  let n = 0, r = 1;
  for (const i of t.body.matchAll(WU)) {
    if (typeof i.index == "number" || Zn(!1), i.index >= e)
      break;
    n = i.index + i[0].length, r += 1;
  }
  return {
    line: r,
    column: e + 1 - n
  };
}
function VP(t) {
  return R_(
    t.source,
    Lm(t.source, t.start)
  );
}
function R_(t, e) {
  const n = t.locationOffset.column - 1, r = "".padStart(n) + t.body, i = e.line - 1, o = t.locationOffset.line - 1, s = e.line + o, a = e.line === 1 ? n : 0, l = e.column + a, u = `${t.name}:${s}:${l}
`, c = r.split(/\r\n|[\n\r]/g), f = c[i];
  if (f.length > 120) {
    const d = Math.floor(l / 80), h = l % 80, p = [];
    for (let g = 0; g < f.length; g += 80)
      p.push(f.slice(g, g + 80));
    return u + ET([
      [`${s} |`, p[0]],
      ...p.slice(1, d + 1).map((g) => ["|", g]),
      ["|", "^".padStart(h)],
      ["|", p[d + 1]]
    ]);
  }
  return u + ET([
    // Lines specified like this: ["prefix", "string"],
    [`${s - 1} |`, c[i - 1]],
    [`${s} |`, f],
    ["|", "^".padStart(l)],
    [`${s + 1} |`, c[i + 1]]
  ]);
}
function ET(t) {
  const e = t.filter(([r, i]) => i !== void 0), n = Math.max(...e.map(([r]) => r.length));
  return e.map(([r, i]) => r.padStart(n) + (i ? " " + i : "")).join(`
`);
}
function YU(t) {
  const e = t[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: t[1],
    positions: t[2],
    path: t[3],
    originalError: t[4],
    extensions: t[5]
  } : e;
}
class ye extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(e, ...n) {
    var r, i, o;
    const { nodes: s, source: a, positions: l, path: u, originalError: c, extensions: f } = YU(n);
    super(e), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = c ?? void 0, this.nodes = kT(
      Array.isArray(s) ? s : s ? [s] : void 0
    );
    const d = kT(
      (r = this.nodes) === null || r === void 0 ? void 0 : r.map((p) => p.loc).filter((p) => p != null)
    );
    this.source = a ?? (d == null || (i = d[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? d?.map((p) => p.start), this.locations = l && a ? l.map((p) => Lm(a, p)) : d?.map((p) => Lm(p.source, p.start));
    const h = oo(
      c?.extensions
    ) ? c?.extensions : void 0;
    this.extensions = (o = f ?? h) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? Object.defineProperty(this, "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, ye) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const n of this.nodes)
        n.loc && (e += `

` + VP(n.loc));
    else if (this.source && this.locations)
      for (const n of this.locations)
        e += `

` + R_(this.source, n);
    return e;
  }
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function kT(t) {
  return t === void 0 || t.length === 0 ? void 0 : t;
}
function XU(t) {
  return t.toString();
}
function KU(t) {
  return t.toJSON();
}
function wr(t, e, n) {
  return new ye(`Syntax Error: ${n}`, {
    source: t,
    positions: [e]
  });
}
class UP {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(e, n, r) {
    this.start = e.start, this.end = n.end, this.startToken = e, this.endToken = n, this.source = r;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class O_ {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(e, n, r, i, o, s) {
    this.kind = e, this.start = n, this.end = r, this.line = i, this.column = o, this.value = s, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const qP = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, QU = new Set(Object.keys(qP));
function hw(t) {
  const e = t?.kind;
  return typeof e == "string" && QU.has(e);
}
var Sr;
(function(t) {
  t.QUERY = "query", t.MUTATION = "mutation", t.SUBSCRIPTION = "subscription";
})(Sr || (Sr = {}));
var ft;
(function(t) {
  t.QUERY = "QUERY", t.MUTATION = "MUTATION", t.SUBSCRIPTION = "SUBSCRIPTION", t.FIELD = "FIELD", t.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", t.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", t.INLINE_FRAGMENT = "INLINE_FRAGMENT", t.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", t.SCHEMA = "SCHEMA", t.SCALAR = "SCALAR", t.OBJECT = "OBJECT", t.FIELD_DEFINITION = "FIELD_DEFINITION", t.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", t.INTERFACE = "INTERFACE", t.UNION = "UNION", t.ENUM = "ENUM", t.ENUM_VALUE = "ENUM_VALUE", t.INPUT_OBJECT = "INPUT_OBJECT", t.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(ft || (ft = {}));
var z;
(function(t) {
  t.NAME = "Name", t.DOCUMENT = "Document", t.OPERATION_DEFINITION = "OperationDefinition", t.VARIABLE_DEFINITION = "VariableDefinition", t.SELECTION_SET = "SelectionSet", t.FIELD = "Field", t.ARGUMENT = "Argument", t.FRAGMENT_SPREAD = "FragmentSpread", t.INLINE_FRAGMENT = "InlineFragment", t.FRAGMENT_DEFINITION = "FragmentDefinition", t.VARIABLE = "Variable", t.INT = "IntValue", t.FLOAT = "FloatValue", t.STRING = "StringValue", t.BOOLEAN = "BooleanValue", t.NULL = "NullValue", t.ENUM = "EnumValue", t.LIST = "ListValue", t.OBJECT = "ObjectValue", t.OBJECT_FIELD = "ObjectField", t.DIRECTIVE = "Directive", t.NAMED_TYPE = "NamedType", t.LIST_TYPE = "ListType", t.NON_NULL_TYPE = "NonNullType", t.SCHEMA_DEFINITION = "SchemaDefinition", t.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", t.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", t.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", t.FIELD_DEFINITION = "FieldDefinition", t.INPUT_VALUE_DEFINITION = "InputValueDefinition", t.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", t.UNION_TYPE_DEFINITION = "UnionTypeDefinition", t.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", t.ENUM_VALUE_DEFINITION = "EnumValueDefinition", t.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", t.DIRECTIVE_DEFINITION = "DirectiveDefinition", t.SCHEMA_EXTENSION = "SchemaExtension", t.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", t.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", t.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", t.UNION_TYPE_EXTENSION = "UnionTypeExtension", t.ENUM_TYPE_EXTENSION = "EnumTypeExtension", t.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(z || (z = {}));
function pw(t) {
  return t === 9 || t === 32;
}
function lh(t) {
  return t >= 48 && t <= 57;
}
function zP(t) {
  return t >= 97 && t <= 122 || // A-Z
  t >= 65 && t <= 90;
}
function D_(t) {
  return zP(t) || t === 95;
}
function HP(t) {
  return zP(t) || lh(t) || t === 95;
}
function JU(t) {
  var e;
  let n = Number.MAX_SAFE_INTEGER, r = null, i = -1;
  for (let s = 0; s < t.length; ++s) {
    var o;
    const a = t[s], l = ZU(a);
    l !== a.length && (r = (o = r) !== null && o !== void 0 ? o : s, i = s, s !== 0 && l < n && (n = l));
  }
  return t.map((s, a) => a === 0 ? s : s.slice(n)).slice(
    (e = r) !== null && e !== void 0 ? e : 0,
    i + 1
  );
}
function ZU(t) {
  let e = 0;
  for (; e < t.length && pw(t.charCodeAt(e)); )
    ++e;
  return e;
}
function eq(t) {
  if (t === "")
    return !0;
  let e = !0, n = !1, r = !0, i = !1;
  for (let o = 0; o < t.length; ++o)
    switch (t.codePointAt(o)) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 11:
      case 12:
      case 14:
      case 15:
        return !1;
      // Has non-printable characters
      case 13:
        return !1;
      // Has \r or \r\n which will be replaced as \n
      case 10:
        if (e && !i)
          return !1;
        i = !0, e = !0, n = !1;
        break;
      case 9:
      //   \t
      case 32:
        n || (n = e);
        break;
      default:
        r && (r = n), e = !1;
    }
  return !(e || r && i);
}
function GP(t, e) {
  const n = t.replace(/"""/g, '\\"""'), r = n.split(/\r\n|[\n\r]/g), i = r.length === 1, o = r.length > 1 && r.slice(1).every((h) => h.length === 0 || pw(h.charCodeAt(0))), s = n.endsWith('\\"""'), a = t.endsWith('"') && !s, l = t.endsWith("\\"), u = a || l, c = !(e != null && e.minimize) && // add leading and trailing new lines only if it improves readability
  (!i || t.length > 70 || u || o || s);
  let f = "";
  const d = i && pw(t.charCodeAt(0));
  return (c && !d || o) && (f += `
`), f += n, (c || u) && (f += `
`), '"""' + f + '"""';
}
var Se;
(function(t) {
  t.SOF = "<SOF>", t.EOF = "<EOF>", t.BANG = "!", t.DOLLAR = "$", t.AMP = "&", t.PAREN_L = "(", t.PAREN_R = ")", t.SPREAD = "...", t.COLON = ":", t.EQUALS = "=", t.AT = "@", t.BRACKET_L = "[", t.BRACKET_R = "]", t.BRACE_L = "{", t.PIPE = "|", t.BRACE_R = "}", t.NAME = "Name", t.INT = "Int", t.FLOAT = "Float", t.STRING = "String", t.BLOCK_STRING = "BlockString", t.COMMENT = "Comment";
})(Se || (Se = {}));
class I_ {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(e) {
    const n = new O_(Se.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== Se.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const n = tq(this, e.end);
          e.next = n, n.prev = e, e = n;
        }
      while (e.kind === Se.COMMENT);
    return e;
  }
}
function WP(t) {
  return t === Se.BANG || t === Se.DOLLAR || t === Se.AMP || t === Se.PAREN_L || t === Se.PAREN_R || t === Se.SPREAD || t === Se.COLON || t === Se.EQUALS || t === Se.AT || t === Se.BRACKET_L || t === Se.BRACKET_R || t === Se.BRACE_L || t === Se.PIPE || t === Se.BRACE_R;
}
function pf(t) {
  return t >= 0 && t <= 55295 || t >= 57344 && t <= 1114111;
}
function zy(t, e) {
  return YP(t.charCodeAt(e)) && XP(t.charCodeAt(e + 1));
}
function YP(t) {
  return t >= 55296 && t <= 56319;
}
function XP(t) {
  return t >= 56320 && t <= 57343;
}
function wu(t, e) {
  const n = t.source.body.codePointAt(e);
  if (n === void 0)
    return Se.EOF;
  if (n >= 32 && n <= 126) {
    const r = String.fromCodePoint(n);
    return r === '"' ? `'"'` : `"${r}"`;
  }
  return "U+" + n.toString(16).toUpperCase().padStart(4, "0");
}
function or(t, e, n, r, i) {
  const o = t.line, s = 1 + n - t.lineStart;
  return new O_(e, n, r, o, s, i);
}
function tq(t, e) {
  const n = t.source.body, r = n.length;
  let i = e;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    switch (o) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++i;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++i, ++t.line, t.lineStart = i;
        continue;
      case 13:
        n.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++t.line, t.lineStart = i;
        continue;
      // Comment
      case 35:
        return nq(t, i);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return or(t, Se.BANG, i, i + 1);
      case 36:
        return or(t, Se.DOLLAR, i, i + 1);
      case 38:
        return or(t, Se.AMP, i, i + 1);
      case 40:
        return or(t, Se.PAREN_L, i, i + 1);
      case 41:
        return or(t, Se.PAREN_R, i, i + 1);
      case 46:
        if (n.charCodeAt(i + 1) === 46 && n.charCodeAt(i + 2) === 46)
          return or(t, Se.SPREAD, i, i + 3);
        break;
      case 58:
        return or(t, Se.COLON, i, i + 1);
      case 61:
        return or(t, Se.EQUALS, i, i + 1);
      case 64:
        return or(t, Se.AT, i, i + 1);
      case 91:
        return or(t, Se.BRACKET_L, i, i + 1);
      case 93:
        return or(t, Se.BRACKET_R, i, i + 1);
      case 123:
        return or(t, Se.BRACE_L, i, i + 1);
      case 124:
        return or(t, Se.PIPE, i, i + 1);
      case 125:
        return or(t, Se.BRACE_R, i, i + 1);
      // StringValue
      case 34:
        return n.charCodeAt(i + 1) === 34 && n.charCodeAt(i + 2) === 34 ? lq(t, i) : iq(t, i);
    }
    if (lh(o) || o === 45)
      return rq(t, i, o);
    if (D_(o))
      return uq(t, i);
    throw wr(
      t.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : pf(o) || zy(n, i) ? `Unexpected character: ${wu(t, i)}.` : `Invalid character: ${wu(t, i)}.`
    );
  }
  return or(t, Se.EOF, r, r);
}
function nq(t, e) {
  const n = t.source.body, r = n.length;
  let i = e + 1;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (pf(o))
      ++i;
    else if (zy(n, i))
      i += 2;
    else
      break;
  }
  return or(
    t,
    Se.COMMENT,
    e,
    i,
    n.slice(e + 1, i)
  );
}
function rq(t, e, n) {
  const r = t.source.body;
  let i = e, o = n, s = !1;
  if (o === 45 && (o = r.charCodeAt(++i)), o === 48) {
    if (o = r.charCodeAt(++i), lh(o))
      throw wr(
        t.source,
        i,
        `Invalid number, unexpected digit after 0: ${wu(
          t,
          i
        )}.`
      );
  } else
    i = rv(t, i, o), o = r.charCodeAt(i);
  if (o === 46 && (s = !0, o = r.charCodeAt(++i), i = rv(t, i, o), o = r.charCodeAt(i)), (o === 69 || o === 101) && (s = !0, o = r.charCodeAt(++i), (o === 43 || o === 45) && (o = r.charCodeAt(++i)), i = rv(t, i, o), o = r.charCodeAt(i)), o === 46 || D_(o))
    throw wr(
      t.source,
      i,
      `Invalid number, expected digit but got: ${wu(
        t,
        i
      )}.`
    );
  return or(
    t,
    s ? Se.FLOAT : Se.INT,
    e,
    i,
    r.slice(e, i)
  );
}
function rv(t, e, n) {
  if (!lh(n))
    throw wr(
      t.source,
      e,
      `Invalid number, expected digit but got: ${wu(
        t,
        e
      )}.`
    );
  const r = t.source.body;
  let i = e + 1;
  for (; lh(r.charCodeAt(i)); )
    ++i;
  return i;
}
function iq(t, e) {
  const n = t.source.body, r = n.length;
  let i = e + 1, o = i, s = "";
  for (; i < r; ) {
    const a = n.charCodeAt(i);
    if (a === 34)
      return s += n.slice(o, i), or(t, Se.STRING, e, i + 1, s);
    if (a === 92) {
      s += n.slice(o, i);
      const l = n.charCodeAt(i + 1) === 117 ? n.charCodeAt(i + 2) === 123 ? oq(t, i) : sq(t, i) : aq(t, i);
      s += l.value, i += l.size, o = i;
      continue;
    }
    if (a === 10 || a === 13)
      break;
    if (pf(a))
      ++i;
    else if (zy(n, i))
      i += 2;
    else
      throw wr(
        t.source,
        i,
        `Invalid character within String: ${wu(
          t,
          i
        )}.`
      );
  }
  throw wr(t.source, i, "Unterminated string.");
}
function oq(t, e) {
  const n = t.source.body;
  let r = 0, i = 3;
  for (; i < 12; ) {
    const o = n.charCodeAt(e + i++);
    if (o === 125) {
      if (i < 5 || !pf(r))
        break;
      return {
        value: String.fromCodePoint(r),
        size: i
      };
    }
    if (r = r << 4 | Ed(o), r < 0)
      break;
  }
  throw wr(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${n.slice(
      e,
      e + i
    )}".`
  );
}
function sq(t, e) {
  const n = t.source.body, r = TT(n, e + 2);
  if (pf(r))
    return {
      value: String.fromCodePoint(r),
      size: 6
    };
  if (YP(r) && n.charCodeAt(e + 6) === 92 && n.charCodeAt(e + 7) === 117) {
    const i = TT(n, e + 8);
    if (XP(i))
      return {
        value: String.fromCodePoint(r, i),
        size: 12
      };
  }
  throw wr(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${n.slice(e, e + 6)}".`
  );
}
function TT(t, e) {
  return Ed(t.charCodeAt(e)) << 12 | Ed(t.charCodeAt(e + 1)) << 8 | Ed(t.charCodeAt(e + 2)) << 4 | Ed(t.charCodeAt(e + 3));
}
function Ed(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 65 && t <= 70 ? t - 55 : t >= 97 && t <= 102 ? t - 87 : -1;
}
function aq(t, e) {
  const n = t.source.body;
  switch (n.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw wr(
    t.source,
    e,
    `Invalid character escape sequence: "${n.slice(
      e,
      e + 2
    )}".`
  );
}
function lq(t, e) {
  const n = t.source.body, r = n.length;
  let i = t.lineStart, o = e + 3, s = o, a = "";
  const l = [];
  for (; o < r; ) {
    const u = n.charCodeAt(o);
    if (u === 34 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34) {
      a += n.slice(s, o), l.push(a);
      const c = or(
        t,
        Se.BLOCK_STRING,
        e,
        o + 3,
        // Return a string of the lines joined with U+000A.
        JU(l).join(`
`)
      );
      return t.line += l.length - 1, t.lineStart = i, c;
    }
    if (u === 92 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34 && n.charCodeAt(o + 3) === 34) {
      a += n.slice(s, o), s = o + 1, o += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      a += n.slice(s, o), l.push(a), u === 13 && n.charCodeAt(o + 1) === 10 ? o += 2 : ++o, a = "", s = o, i = o;
      continue;
    }
    if (pf(u))
      ++o;
    else if (zy(n, o))
      o += 2;
    else
      throw wr(
        t.source,
        o,
        `Invalid character within String: ${wu(
          t,
          o
        )}.`
      );
  }
  throw wr(t.source, o, "Unterminated string.");
}
function uq(t, e) {
  const n = t.source.body, r = n.length;
  let i = e + 1;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    if (HP(o))
      ++i;
    else
      break;
  }
  return or(
    t,
    Se.NAME,
    e,
    i,
    n.slice(e, i)
  );
}
const cq = 10, KP = 2;
function _e(t) {
  return Hy(t, []);
}
function Hy(t, e) {
  switch (typeof t) {
    case "string":
      return JSON.stringify(t);
    case "function":
      return t.name ? `[function ${t.name}]` : "[function]";
    case "object":
      return fq(t, e);
    default:
      return String(t);
  }
}
function fq(t, e) {
  if (t === null)
    return "null";
  if (e.includes(t))
    return "[Circular]";
  const n = [...e, t];
  if (dq(t)) {
    const r = t.toJSON();
    if (r !== t)
      return typeof r == "string" ? r : Hy(r, n);
  } else if (Array.isArray(t))
    return pq(t, n);
  return hq(t, n);
}
function dq(t) {
  return typeof t.toJSON == "function";
}
function hq(t, e) {
  const n = Object.entries(t);
  return n.length === 0 ? "{}" : e.length > KP ? "[" + gq(t) + "]" : "{ " + n.map(
    ([i, o]) => i + ": " + Hy(o, e)
  ).join(", ") + " }";
}
function pq(t, e) {
  if (t.length === 0)
    return "[]";
  if (e.length > KP)
    return "[Array]";
  const n = Math.min(cq, t.length), r = t.length - n, i = [];
  for (let o = 0; o < n; ++o)
    i.push(Hy(t[o], e));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push(`... ${r} more items`), "[" + i.join(", ") + "]";
}
function gq(t) {
  const e = Object.prototype.toString.call(t).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof t.constructor == "function") {
    const n = t.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return e;
}
const mq = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", Jo = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  mq ? function(e, n) {
    return e instanceof n;
  } : function(e, n) {
    if (e instanceof n)
      return !0;
    if (typeof e == "object" && e !== null) {
      var r;
      const i = n.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (r = e.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (i === o) {
        const s = _e(e);
        throw new Error(`Cannot use ${i} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class Gy {
  constructor(e, n = "GraphQL request", r = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || Nt(!1, `Body must be a string. Received: ${_e(e)}.`), this.body = e, this.name = n, this.locationOffset = r, this.locationOffset.line > 0 || Nt(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Nt(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function QP(t) {
  return Jo(t, Gy);
}
function gf(t, e) {
  const n = new Wy(t, e), r = n.parseDocument();
  return Object.defineProperty(r, "tokenCount", {
    enumerable: !1,
    value: n.tokenCount
  }), r;
}
function JP(t, e) {
  const n = new Wy(t, e);
  n.expectToken(Se.SOF);
  const r = n.parseValueLiteral(!1);
  return n.expectToken(Se.EOF), r;
}
function yq(t, e) {
  const n = new Wy(t, e);
  n.expectToken(Se.SOF);
  const r = n.parseConstValueLiteral();
  return n.expectToken(Se.EOF), r;
}
function vq(t, e) {
  const n = new Wy(t, e);
  n.expectToken(Se.SOF);
  const r = n.parseTypeReference();
  return n.expectToken(Se.EOF), r;
}
let Wy = class {
  constructor(e, n = {}) {
    const r = QP(e) ? e : new Gy(e);
    this._lexer = new I_(r), this._options = n, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const e = this.expectToken(Se.NAME);
    return this.node(e, {
      kind: z.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: z.DOCUMENT,
      definitions: this.many(
        Se.SOF,
        this.parseDefinition,
        Se.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(Se.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), n = e ? this._lexer.lookahead() : this._lexer.token;
    if (n.kind === Se.NAME) {
      switch (n.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (e)
        throw wr(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (n.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(n);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(Se.BRACE_L))
      return this.node(e, {
        kind: z.OPERATION_DEFINITION,
        operation: Sr.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const n = this.parseOperationType();
    let r;
    return this.peek(Se.NAME) && (r = this.parseName()), this.node(e, {
      kind: z.OPERATION_DEFINITION,
      operation: n,
      name: r,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const e = this.expectToken(Se.NAME);
    switch (e.value) {
      case "query":
        return Sr.QUERY;
      case "mutation":
        return Sr.MUTATION;
      case "subscription":
        return Sr.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      Se.PAREN_L,
      this.parseVariableDefinition,
      Se.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: z.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(Se.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(Se.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(Se.DOLLAR), this.node(e, {
      kind: z.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: z.SELECTION_SET,
      selections: this.many(
        Se.BRACE_L,
        this.parseSelection,
        Se.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(Se.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const e = this._lexer.token, n = this.parseName();
    let r, i;
    return this.expectOptionalToken(Se.COLON) ? (r = n, i = this.parseName()) : i = n, this.node(e, {
      kind: z.FIELD,
      alias: r,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(Se.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(e) {
    const n = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(Se.PAREN_L, n, Se.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(e = !1) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(Se.COLON), this.node(n, {
      kind: z.ARGUMENT,
      name: r,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(Se.SPREAD);
    const n = this.expectOptionalKeyword("on");
    return !n && this.peek(Se.NAME) ? this.node(e, {
      kind: z.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: z.INLINE_FRAGMENT,
      typeCondition: n ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const e = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: z.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: z.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(e) {
    const n = this._lexer.token;
    switch (n.kind) {
      case Se.BRACKET_L:
        return this.parseList(e);
      case Se.BRACE_L:
        return this.parseObject(e);
      case Se.INT:
        return this.advanceLexer(), this.node(n, {
          kind: z.INT,
          value: n.value
        });
      case Se.FLOAT:
        return this.advanceLexer(), this.node(n, {
          kind: z.FLOAT,
          value: n.value
        });
      case Se.STRING:
      case Se.BLOCK_STRING:
        return this.parseStringLiteral();
      case Se.NAME:
        switch (this.advanceLexer(), n.value) {
          case "true":
            return this.node(n, {
              kind: z.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(n, {
              kind: z.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(n, {
              kind: z.NULL
            });
          default:
            return this.node(n, {
              kind: z.ENUM,
              value: n.value
            });
        }
      case Se.DOLLAR:
        if (e)
          if (this.expectToken(Se.DOLLAR), this._lexer.token.kind === Se.NAME) {
            const r = this._lexer.token.value;
            throw wr(
              this._lexer.source,
              n.start,
              `Unexpected variable "$${r}" in constant value.`
            );
          } else
            throw this.unexpected(n);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: z.STRING,
      value: e.value,
      block: e.kind === Se.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(e) {
    const n = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: z.LIST,
      values: this.any(Se.BRACKET_L, n, Se.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(e) {
    const n = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: z.OBJECT,
      fields: this.any(Se.BRACE_L, n, Se.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(e) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(Se.COLON), this.node(n, {
      kind: z.OBJECT_FIELD,
      name: r,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(e) {
    const n = [];
    for (; this.peek(Se.AT); )
      n.push(this.parseDirective(e));
    return n;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(e) {
    const n = this._lexer.token;
    return this.expectToken(Se.AT), this.node(n, {
      kind: z.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let n;
    if (this.expectOptionalToken(Se.BRACKET_L)) {
      const r = this.parseTypeReference();
      this.expectToken(Se.BRACKET_R), n = this.node(e, {
        kind: z.LIST_TYPE,
        type: r
      });
    } else
      n = this.parseNamedType();
    return this.expectOptionalToken(Se.BANG) ? this.node(e, {
      kind: z.NON_NULL_TYPE,
      type: n
    }) : n;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: z.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(Se.STRING) || this.peek(Se.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("schema");
    const r = this.parseConstDirectives(), i = this.many(
      Se.BRACE_L,
      this.parseOperationTypeDefinition,
      Se.BRACE_R
    );
    return this.node(e, {
      kind: z.SCHEMA_DEFINITION,
      description: n,
      directives: r,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, n = this.parseOperationType();
    this.expectToken(Se.COLON);
    const r = this.parseNamedType();
    return this.node(e, {
      kind: z.OPERATION_TYPE_DEFINITION,
      operation: n,
      type: r
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("scalar");
    const r = this.parseName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: z.SCALAR_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("type");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(e, {
      kind: z.OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: i,
      directives: o,
      fields: s
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(Se.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      Se.BRACE_L,
      this.parseFieldDefinition,
      Se.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const e = this._lexer.token, n = this.parseDescription(), r = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(Se.COLON);
    const o = this.parseTypeReference(), s = this.parseConstDirectives();
    return this.node(e, {
      kind: z.FIELD_DEFINITION,
      description: n,
      name: r,
      arguments: i,
      type: o,
      directives: s
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      Se.PAREN_L,
      this.parseInputValueDef,
      Se.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const e = this._lexer.token, n = this.parseDescription(), r = this.parseName();
    this.expectToken(Se.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(Se.EQUALS) && (o = this.parseConstValueLiteral());
    const s = this.parseConstDirectives();
    return this.node(e, {
      kind: z.INPUT_VALUE_DEFINITION,
      description: n,
      name: r,
      type: i,
      defaultValue: o,
      directives: s
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("interface");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(e, {
      kind: z.INTERFACE_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: i,
      directives: o,
      fields: s
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("union");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: z.UNION_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(Se.EQUALS) ? this.delimitedMany(Se.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("enum");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: z.ENUM_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      Se.BRACE_L,
      this.parseEnumValueDefinition,
      Se.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, n = this.parseDescription(), r = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: z.ENUM_VALUE_DEFINITION,
      description: n,
      name: r,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw wr(
        this._lexer.source,
        this._lexer.token.start,
        `${Fp(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("input");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: z.INPUT_OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      Se.BRACE_L,
      this.parseInputValueDef,
      Se.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === Se.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const n = this.parseConstDirectives(), r = this.optionalMany(
      Se.BRACE_L,
      this.parseOperationTypeDefinition,
      Se.BRACE_R
    );
    if (n.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: z.SCHEMA_EXTENSION,
      directives: n,
      operationTypes: r
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const n = this.parseName(), r = this.parseConstDirectives();
    if (r.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: z.SCALAR_TYPE_EXTENSION,
      name: n,
      directives: r
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (r.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: z.OBJECT_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (r.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: z.INTERFACE_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: z.UNION_TYPE_EXTENSION,
      name: n,
      directives: r,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: z.ENUM_TYPE_EXTENSION,
      name: n,
      directives: r,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: z.INPUT_OBJECT_TYPE_EXTENSION,
      name: n,
      directives: r,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(Se.AT);
    const r = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const s = this.parseDirectiveLocations();
    return this.node(e, {
      kind: z.DIRECTIVE_DEFINITION,
      description: n,
      name: r,
      arguments: i,
      repeatable: o,
      locations: s
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(Se.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, n = this.parseName();
    if (Object.prototype.hasOwnProperty.call(ft, n.value))
      return n;
    throw this.unexpected(e);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(e, n) {
    return this._options.noLocation !== !0 && (n.loc = new UP(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), n;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(e) {
    const n = this._lexer.token;
    if (n.kind === e)
      return this.advanceLexer(), n;
    throw wr(
      this._lexer.source,
      n.start,
      `Expected ${ZP(e)}, found ${Fp(n)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(e) {
    const n = this._lexer.token;
    if (n.kind === Se.NAME && n.value === e)
      this.advanceLexer();
    else
      throw wr(
        this._lexer.source,
        n.start,
        `Expected "${e}", found ${Fp(n)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(e) {
    const n = this._lexer.token;
    return n.kind === Se.NAME && n.value === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(e) {
    const n = e ?? this._lexer.token;
    return wr(
      this._lexer.source,
      n.start,
      `Unexpected ${Fp(n)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(e, n, r) {
    this.expectToken(e);
    const i = [];
    for (; !this.expectOptionalToken(r); )
      i.push(n.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(e, n, r) {
    if (this.expectOptionalToken(e)) {
      const i = [];
      do
        i.push(n.call(this));
      while (!this.expectOptionalToken(r));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(e, n, r) {
    this.expectToken(e);
    const i = [];
    do
      i.push(n.call(this));
    while (!this.expectOptionalToken(r));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(e, n) {
    this.expectOptionalToken(e);
    const r = [];
    do
      r.push(n.call(this));
    while (this.expectOptionalToken(e));
    return r;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, n = this._lexer.advance();
    if (n.kind !== Se.EOF && (++this._tokenCounter, e !== void 0 && this._tokenCounter > e))
      throw wr(
        this._lexer.source,
        n.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
};
function Fp(t) {
  const e = t.value;
  return ZP(t.kind) + (e != null ? ` "${e}"` : "");
}
function ZP(t) {
  return WP(t) ? `"${t}"` : t;
}
const bq = 5;
function ga(t, e) {
  const [n, r] = e ? [t, e] : [void 0, t];
  let i = " Did you mean ";
  n && (i += n + " ");
  const o = r.map((l) => `"${l}"`);
  switch (o.length) {
    case 0:
      return "";
    case 1:
      return i + o[0] + "?";
    case 2:
      return i + o[0] + " or " + o[1] + "?";
  }
  const s = o.slice(0, bq), a = s.pop();
  return i + s.join(", ") + ", or " + a + "?";
}
function xT(t) {
  return t;
}
function ma(t, e) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const r of t)
    n[e(r)] = r;
  return n;
}
function za(t, e, n) {
  const r = /* @__PURE__ */ Object.create(null);
  for (const i of t)
    r[e(i)] = n(i);
  return r;
}
function Zs(t, e) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const r of Object.keys(t))
    n[r] = e(t[r], r);
  return n;
}
function Vh(t, e) {
  let n = 0, r = 0;
  for (; n < t.length && r < e.length; ) {
    let i = t.charCodeAt(n), o = e.charCodeAt(r);
    if (Lp(i) && Lp(o)) {
      let s = 0;
      do
        ++n, s = s * 10 + i - gw, i = t.charCodeAt(n);
      while (Lp(i) && s > 0);
      let a = 0;
      do
        ++r, a = a * 10 + o - gw, o = e.charCodeAt(r);
      while (Lp(o) && a > 0);
      if (s < a)
        return -1;
      if (s > a)
        return 1;
    } else {
      if (i < o)
        return -1;
      if (i > o)
        return 1;
      ++n, ++r;
    }
  }
  return t.length - e.length;
}
const gw = 48, wq = 57;
function Lp(t) {
  return !isNaN(t) && gw <= t && t <= wq;
}
function yl(t, e) {
  const n = /* @__PURE__ */ Object.create(null), r = new Sq(t), i = Math.floor(t.length * 0.4) + 1;
  for (const o of e) {
    const s = r.measure(o, i);
    s !== void 0 && (n[o] = s);
  }
  return Object.keys(n).sort((o, s) => {
    const a = n[o] - n[s];
    return a !== 0 ? a : Vh(o, s);
  });
}
class Sq {
  constructor(e) {
    this._input = e, this._inputLowerCase = e.toLowerCase(), this._inputArray = CT(this._inputLowerCase), this._rows = [
      new Array(e.length + 1).fill(0),
      new Array(e.length + 1).fill(0),
      new Array(e.length + 1).fill(0)
    ];
  }
  measure(e, n) {
    if (this._input === e)
      return 0;
    const r = e.toLowerCase();
    if (this._inputLowerCase === r)
      return 1;
    let i = CT(r), o = this._inputArray;
    if (i.length < o.length) {
      const c = i;
      i = o, o = c;
    }
    const s = i.length, a = o.length;
    if (s - a > n)
      return;
    const l = this._rows;
    for (let c = 0; c <= a; c++)
      l[0][c] = c;
    for (let c = 1; c <= s; c++) {
      const f = l[(c - 1) % 3], d = l[c % 3];
      let h = d[0] = c;
      for (let p = 1; p <= a; p++) {
        const g = i[c - 1] === o[p - 1] ? 0 : 1;
        let m = Math.min(
          f[p] + 1,
          // delete
          d[p - 1] + 1,
          // insert
          f[p - 1] + g
          // substitute
        );
        if (c > 1 && p > 1 && i[c - 1] === o[p - 2] && i[c - 2] === o[p - 1]) {
          const v = l[(c - 2) % 3][p - 2];
          m = Math.min(m, v + 1);
        }
        m < h && (h = m), d[p] = m;
      }
      if (h > n)
        return;
    }
    const u = l[s % 3][a];
    return u <= n ? u : void 0;
  }
}
function CT(t) {
  const e = t.length, n = new Array(e);
  for (let r = 0; r < e; ++r)
    n[r] = t.charCodeAt(r);
  return n;
}
function Mo(t) {
  if (t == null)
    return /* @__PURE__ */ Object.create(null);
  if (Object.getPrototypeOf(t) === null)
    return t;
  const e = /* @__PURE__ */ Object.create(null);
  for (const [n, r] of Object.entries(t))
    e[n] = r;
  return e;
}
function _q(t) {
  return `"${t.replace(Eq, kq)}"`;
}
const Eq = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function kq(t) {
  return Tq[t.charCodeAt(0)];
}
const Tq = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], ic = Object.freeze({});
function mf(t, e, n = qP) {
  const r = /* @__PURE__ */ new Map();
  for (const v of Object.values(z))
    r.set(v, Vc(e, v));
  let i, o = Array.isArray(t), s = [t], a = -1, l = [], u = t, c, f;
  const d = [], h = [];
  do {
    a++;
    const v = a === s.length, S = v && l.length !== 0;
    if (v) {
      if (c = h.length === 0 ? void 0 : d[d.length - 1], u = f, f = h.pop(), S)
        if (o) {
          u = u.slice();
          let b = 0;
          for (const [y, w] of l) {
            const E = y - b;
            w === null ? (u.splice(E, 1), b++) : u[E] = w;
          }
        } else {
          u = { ...u };
          for (const [b, y] of l)
            u[b] = y;
        }
      a = i.index, s = i.keys, l = i.edits, o = i.inArray, i = i.prev;
    } else if (f) {
      if (c = o ? a : s[a], u = f[c], u == null)
        continue;
      d.push(c);
    }
    let _;
    if (!Array.isArray(u)) {
      var p, g;
      hw(u) || Nt(!1, `Invalid AST Node: ${_e(u)}.`);
      const b = v ? (p = r.get(u.kind)) === null || p === void 0 ? void 0 : p.leave : (g = r.get(u.kind)) === null || g === void 0 ? void 0 : g.enter;
      if (_ = b?.call(e, u, c, f, d, h), _ === ic)
        break;
      if (_ === !1) {
        if (!v) {
          d.pop();
          continue;
        }
      } else if (_ !== void 0 && (l.push([c, _]), !v))
        if (hw(_))
          u = _;
        else {
          d.pop();
          continue;
        }
    }
    if (_ === void 0 && S && l.push([c, u]), v)
      d.pop();
    else {
      var m;
      i = {
        inArray: o,
        index: a,
        keys: s,
        edits: l,
        prev: i
      }, o = Array.isArray(u), s = o ? u : (m = n[u.kind]) !== null && m !== void 0 ? m : [], a = -1, l = [], f && h.push(f), f = u;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : t;
}
function N_(t) {
  const e = new Array(t.length).fill(null), n = /* @__PURE__ */ Object.create(null);
  for (const r of Object.values(z)) {
    let i = !1;
    const o = new Array(t.length).fill(void 0), s = new Array(t.length).fill(void 0);
    for (let l = 0; l < t.length; ++l) {
      const { enter: u, leave: c } = Vc(t[l], r);
      i || (i = u != null || c != null), o[l] = u, s[l] = c;
    }
    if (!i)
      continue;
    const a = {
      enter(...l) {
        const u = l[0];
        for (let f = 0; f < t.length; f++)
          if (e[f] === null) {
            var c;
            const d = (c = o[f]) === null || c === void 0 ? void 0 : c.apply(t[f], l);
            if (d === !1)
              e[f] = u;
            else if (d === ic)
              e[f] = ic;
            else if (d !== void 0)
              return d;
          }
      },
      leave(...l) {
        const u = l[0];
        for (let f = 0; f < t.length; f++)
          if (e[f] === null) {
            var c;
            const d = (c = s[f]) === null || c === void 0 ? void 0 : c.apply(t[f], l);
            if (d === ic)
              e[f] = ic;
            else if (d !== void 0 && d !== !1)
              return d;
          } else e[f] === u && (e[f] = null);
      }
    };
    n[r] = a;
  }
  return n;
}
function Vc(t, e) {
  const n = t[e];
  return typeof n == "object" ? n : typeof n == "function" ? {
    enter: n,
    leave: void 0
  } : {
    enter: t.enter,
    leave: t.leave
  };
}
function xq(t, e, n) {
  const { enter: r, leave: i } = Vc(t, e);
  return n ? i : r;
}
function An(t) {
  return mf(t, Aq);
}
const Cq = 80, Aq = {
  Name: {
    leave: (t) => t.value
  },
  Variable: {
    leave: (t) => "$" + t.name
  },
  // Document
  Document: {
    leave: (t) => tt(t.definitions, `

`)
  },
  OperationDefinition: {
    leave(t) {
      const e = Vt("(", tt(t.variableDefinitions, ", "), ")"), n = tt(
        [
          t.operation,
          tt([t.name, e]),
          tt(t.directives, " ")
        ],
        " "
      );
      return (n === "query" ? "" : n + " ") + t.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: t, type: e, defaultValue: n, directives: r }) => t + ": " + e + Vt(" = ", n) + Vt(" ", tt(r, " "))
  },
  SelectionSet: {
    leave: ({ selections: t }) => jo(t)
  },
  Field: {
    leave({ alias: t, name: e, arguments: n, directives: r, selectionSet: i }) {
      const o = Vt("", t, ": ") + e;
      let s = o + Vt("(", tt(n, ", "), ")");
      return s.length > Cq && (s = o + Vt(`(
`, Kg(tt(n, `
`)), `
)`)), tt([s, tt(r, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: t, value: e }) => t + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: t, directives: e }) => "..." + t + Vt(" ", tt(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: t, directives: e, selectionSet: n }) => tt(
      [
        "...",
        Vt("on ", t),
        tt(e, " "),
        n
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: t, typeCondition: e, variableDefinitions: n, directives: r, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${t}${Vt("(", tt(n, ", "), ")")} on ${e} ${Vt("", tt(r, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: t }) => t
  },
  FloatValue: {
    leave: ({ value: t }) => t
  },
  StringValue: {
    leave: ({ value: t, block: e }) => e ? GP(t) : _q(t)
  },
  BooleanValue: {
    leave: ({ value: t }) => t ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: t }) => t
  },
  ListValue: {
    leave: ({ values: t }) => "[" + tt(t, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: t }) => "{" + tt(t, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: t, value: e }) => t + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: t, arguments: e }) => "@" + t + Vt("(", tt(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: t }) => t
  },
  ListType: {
    leave: ({ type: t }) => "[" + t + "]"
  },
  NonNullType: {
    leave: ({ type: t }) => t + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: t, directives: e, operationTypes: n }) => Vt("", t, `
`) + tt(["schema", tt(e, " "), jo(n)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: t, type: e }) => t + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: t, name: e, directives: n }) => Vt("", t, `
`) + tt(["scalar", e, tt(n, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: t, name: e, interfaces: n, directives: r, fields: i }) => Vt("", t, `
`) + tt(
      [
        "type",
        e,
        Vt("implements ", tt(n, " & ")),
        tt(r, " "),
        jo(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: t, name: e, arguments: n, type: r, directives: i }) => Vt("", t, `
`) + e + (AT(n) ? Vt(`(
`, Kg(tt(n, `
`)), `
)`) : Vt("(", tt(n, ", "), ")")) + ": " + r + Vt(" ", tt(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: t, name: e, type: n, defaultValue: r, directives: i }) => Vt("", t, `
`) + tt(
      [e + ": " + n, Vt("= ", r), tt(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: t, name: e, interfaces: n, directives: r, fields: i }) => Vt("", t, `
`) + tt(
      [
        "interface",
        e,
        Vt("implements ", tt(n, " & ")),
        tt(r, " "),
        jo(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, types: r }) => Vt("", t, `
`) + tt(
      ["union", e, tt(n, " "), Vt("= ", tt(r, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, values: r }) => Vt("", t, `
`) + tt(["enum", e, tt(n, " "), jo(r)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: t, name: e, directives: n }) => Vt("", t, `
`) + tt([e, tt(n, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, fields: r }) => Vt("", t, `
`) + tt(["input", e, tt(n, " "), jo(r)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: t, name: e, arguments: n, repeatable: r, locations: i }) => Vt("", t, `
`) + "directive @" + e + (AT(n) ? Vt(`(
`, Kg(tt(n, `
`)), `
)`) : Vt("(", tt(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + tt(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: t, operationTypes: e }) => tt(
      ["extend schema", tt(t, " "), jo(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: t, directives: e }) => tt(["extend scalar", t, tt(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: t, interfaces: e, directives: n, fields: r }) => tt(
      [
        "extend type",
        t,
        Vt("implements ", tt(e, " & ")),
        tt(n, " "),
        jo(r)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: t, interfaces: e, directives: n, fields: r }) => tt(
      [
        "extend interface",
        t,
        Vt("implements ", tt(e, " & ")),
        tt(n, " "),
        jo(r)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: t, directives: e, types: n }) => tt(
      [
        "extend union",
        t,
        tt(e, " "),
        Vt("= ", tt(n, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: t, directives: e, values: n }) => tt(["extend enum", t, tt(e, " "), jo(n)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: t, directives: e, fields: n }) => tt(["extend input", t, tt(e, " "), jo(n)], " ")
  }
};
function tt(t, e = "") {
  var n;
  return (n = t?.filter((r) => r).join(e)) !== null && n !== void 0 ? n : "";
}
function jo(t) {
  return Vt(`{
`, Kg(tt(t, `
`)), `
}`);
}
function Vt(t, e, n = "") {
  return e != null && e !== "" ? t + e + n : "";
}
function Kg(t) {
  return Vt("  ", t.replace(/\n/g, `
  `));
}
function AT(t) {
  var e;
  return (e = t?.some((n) => n.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
function Bm(t, e) {
  switch (t.kind) {
    case z.NULL:
      return null;
    case z.INT:
      return parseInt(t.value, 10);
    case z.FLOAT:
      return parseFloat(t.value);
    case z.STRING:
    case z.ENUM:
    case z.BOOLEAN:
      return t.value;
    case z.LIST:
      return t.values.map(
        (n) => Bm(n, e)
      );
    case z.OBJECT:
      return za(
        t.fields,
        (n) => n.name.value,
        (n) => Bm(n.value, e)
      );
    case z.VARIABLE:
      return e?.[t.name.value];
  }
}
function uo(t) {
  if (t != null || Nt(!1, "Must provide name."), typeof t == "string" || Nt(!1, "Expected name to be a string."), t.length === 0)
    throw new ye("Expected name to be a non-empty string.");
  for (let e = 1; e < t.length; ++e)
    if (!HP(t.charCodeAt(e)))
      throw new ye(
        `Names must only contain [_a-zA-Z0-9] but "${t}" does not.`
      );
  if (!D_(t.charCodeAt(0)))
    throw new ye(
      `Names must start with [_a-zA-Z] but "${t}" does not.`
    );
  return t;
}
function e$(t) {
  if (t === "true" || t === "false" || t === "null")
    throw new ye(`Enum values cannot be named: ${t}`);
  return uo(t);
}
function Uh(t) {
  return co(t) || Yt(t) || an(t) || Er(t) || hr(t) || Sn(t) || Mn(t) || St(t);
}
function Rq(t) {
  if (!Uh(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL type.`);
  return t;
}
function co(t) {
  return Jo(t, Ds);
}
function Oq(t) {
  if (!co(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL Scalar type.`);
  return t;
}
function Yt(t) {
  return Jo(t, Do);
}
function t$(t) {
  if (!Yt(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL Object type.`);
  return t;
}
function an(t) {
  return Jo(t, Uc);
}
function n$(t) {
  if (!an(t))
    throw new Error(
      `Expected ${_e(t)} to be a GraphQL Interface type.`
    );
  return t;
}
function Er(t) {
  return Jo(t, qc);
}
function Dq(t) {
  if (!Er(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL Union type.`);
  return t;
}
function hr(t) {
  return Jo(t, ul);
}
function Iq(t) {
  if (!hr(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL Enum type.`);
  return t;
}
function Sn(t) {
  return Jo(t, zc);
}
function Nq(t) {
  if (!Sn(t))
    throw new Error(
      `Expected ${_e(t)} to be a GraphQL Input Object type.`
    );
  return t;
}
function Mn(t) {
  return Jo(t, jr);
}
function Pq(t) {
  if (!Mn(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL List type.`);
  return t;
}
function St(t) {
  return Jo(t, It);
}
function $q(t) {
  if (!St(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL Non-Null type.`);
  return t;
}
function Ci(t) {
  return co(t) || hr(t) || Sn(t) || qh(t) && Ci(t.ofType);
}
function Mq(t) {
  if (!Ci(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL input type.`);
  return t;
}
function il(t) {
  return co(t) || Yt(t) || an(t) || Er(t) || hr(t) || qh(t) && il(t.ofType);
}
function Fq(t) {
  if (!il(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL output type.`);
  return t;
}
function Rs(t) {
  return co(t) || hr(t);
}
function Lq(t) {
  if (!Rs(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL leaf type.`);
  return t;
}
function Os(t) {
  return Yt(t) || an(t) || Er(t);
}
function Bq(t) {
  if (!Os(t))
    throw new Error(
      `Expected ${_e(t)} to be a GraphQL composite type.`
    );
  return t;
}
function Ts(t) {
  return an(t) || Er(t);
}
function jq(t) {
  if (!Ts(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL abstract type.`);
  return t;
}
class jr {
  constructor(e) {
    Uh(e) || Nt(!1, `Expected ${_e(e)} to be a GraphQL type.`), this.ofType = e;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLList";
  }
  toString() {
    return "[" + String(this.ofType) + "]";
  }
  toJSON() {
    return this.toString();
  }
}
class It {
  constructor(e) {
    Yy(e) || Nt(
      !1,
      `Expected ${_e(e)} to be a GraphQL nullable type.`
    ), this.ofType = e;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLNonNull";
  }
  toString() {
    return String(this.ofType) + "!";
  }
  toJSON() {
    return this.toString();
  }
}
function qh(t) {
  return Mn(t) || St(t);
}
function Vq(t) {
  if (!qh(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL wrapping type.`);
  return t;
}
function Yy(t) {
  return Uh(t) && !St(t);
}
function r$(t) {
  if (!Yy(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL nullable type.`);
  return t;
}
function P_(t) {
  if (t)
    return St(t) ? t.ofType : t;
}
function zh(t) {
  return co(t) || Yt(t) || an(t) || Er(t) || hr(t) || Sn(t);
}
function Uq(t) {
  if (!zh(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL named type.`);
  return t;
}
function hi(t) {
  if (t) {
    let e = t;
    for (; qh(e); )
      e = e.ofType;
    return e;
  }
}
function $_(t) {
  return typeof t == "function" ? t() : t;
}
function M_(t) {
  return typeof t == "function" ? t() : t;
}
class Ds {
  constructor(e) {
    var n, r, i, o;
    const s = (n = e.parseValue) !== null && n !== void 0 ? n : xT;
    this.name = uo(e.name), this.description = e.description, this.specifiedByURL = e.specifiedByURL, this.serialize = (r = e.serialize) !== null && r !== void 0 ? r : xT, this.parseValue = s, this.parseLiteral = (i = e.parseLiteral) !== null && i !== void 0 ? i : (a, l) => s(Bm(a, l)), this.extensions = Mo(e.extensions), this.astNode = e.astNode, this.extensionASTNodes = (o = e.extensionASTNodes) !== null && o !== void 0 ? o : [], e.specifiedByURL == null || typeof e.specifiedByURL == "string" || Nt(
      !1,
      `${this.name} must provide "specifiedByURL" as a string, but got: ${_e(e.specifiedByURL)}.`
    ), e.serialize == null || typeof e.serialize == "function" || Nt(
      !1,
      `${this.name} must provide "serialize" function. If this custom Scalar is also used as an input type, ensure "parseValue" and "parseLiteral" functions are also provided.`
    ), e.parseLiteral && (typeof e.parseValue == "function" && typeof e.parseLiteral == "function" || Nt(
      !1,
      `${this.name} must provide both "parseValue" and "parseLiteral" functions.`
    ));
  }
  get [Symbol.toStringTag]() {
    return "GraphQLScalarType";
  }
  toConfig() {
    return {
      name: this.name,
      description: this.description,
      specifiedByURL: this.specifiedByURL,
      serialize: this.serialize,
      parseValue: this.parseValue,
      parseLiteral: this.parseLiteral,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes
    };
  }
  toString() {
    return this.name;
  }
  toJSON() {
    return this.toString();
  }
}
class Do {
  constructor(e) {
    var n;
    this.name = uo(e.name), this.description = e.description, this.isTypeOf = e.isTypeOf, this.extensions = Mo(e.extensions), this.astNode = e.astNode, this.extensionASTNodes = (n = e.extensionASTNodes) !== null && n !== void 0 ? n : [], this._fields = () => o$(e), this._interfaces = () => i$(e), e.isTypeOf == null || typeof e.isTypeOf == "function" || Nt(
      !1,
      `${this.name} must provide "isTypeOf" as a function, but got: ${_e(e.isTypeOf)}.`
    );
  }
  get [Symbol.toStringTag]() {
    return "GraphQLObjectType";
  }
  getFields() {
    return typeof this._fields == "function" && (this._fields = this._fields()), this._fields;
  }
  getInterfaces() {
    return typeof this._interfaces == "function" && (this._interfaces = this._interfaces()), this._interfaces;
  }
  toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: a$(this.getFields()),
      isTypeOf: this.isTypeOf,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes
    };
  }
  toString() {
    return this.name;
  }
  toJSON() {
    return this.toString();
  }
}
function i$(t) {
  var e;
  const n = $_(
    (e = t.interfaces) !== null && e !== void 0 ? e : []
  );
  return Array.isArray(n) || Nt(
    !1,
    `${t.name} interfaces must be an Array or a function which returns an Array.`
  ), n;
}
function o$(t) {
  const e = M_(t.fields);
  return yc(e) || Nt(
    !1,
    `${t.name} fields must be an object with field names as keys or a function which returns such an object.`
  ), Zs(e, (n, r) => {
    var i;
    yc(n) || Nt(
      !1,
      `${t.name}.${r} field config must be an object.`
    ), n.resolve == null || typeof n.resolve == "function" || Nt(
      !1,
      `${t.name}.${r} field resolver must be a function if provided, but got: ${_e(n.resolve)}.`
    );
    const o = (i = n.args) !== null && i !== void 0 ? i : {};
    return yc(o) || Nt(
      !1,
      `${t.name}.${r} args must be an object with argument names as keys.`
    ), {
      name: uo(r),
      description: n.description,
      type: n.type,
      args: s$(o),
      resolve: n.resolve,
      subscribe: n.subscribe,
      deprecationReason: n.deprecationReason,
      extensions: Mo(n.extensions),
      astNode: n.astNode
    };
  });
}
function s$(t) {
  return Object.entries(t).map(([e, n]) => ({
    name: uo(e),
    description: n.description,
    type: n.type,
    defaultValue: n.defaultValue,
    deprecationReason: n.deprecationReason,
    extensions: Mo(n.extensions),
    astNode: n.astNode
  }));
}
function yc(t) {
  return oo(t) && !Array.isArray(t);
}
function a$(t) {
  return Zs(t, (e) => ({
    description: e.description,
    type: e.type,
    args: l$(e.args),
    resolve: e.resolve,
    subscribe: e.subscribe,
    deprecationReason: e.deprecationReason,
    extensions: e.extensions,
    astNode: e.astNode
  }));
}
function l$(t) {
  return za(
    t,
    (e) => e.name,
    (e) => ({
      description: e.description,
      type: e.type,
      defaultValue: e.defaultValue,
      deprecationReason: e.deprecationReason,
      extensions: e.extensions,
      astNode: e.astNode
    })
  );
}
function vl(t) {
  return St(t.type) && t.defaultValue === void 0;
}
class Uc {
  constructor(e) {
    var n;
    this.name = uo(e.name), this.description = e.description, this.resolveType = e.resolveType, this.extensions = Mo(e.extensions), this.astNode = e.astNode, this.extensionASTNodes = (n = e.extensionASTNodes) !== null && n !== void 0 ? n : [], this._fields = o$.bind(void 0, e), this._interfaces = i$.bind(void 0, e), e.resolveType == null || typeof e.resolveType == "function" || Nt(
      !1,
      `${this.name} must provide "resolveType" as a function, but got: ${_e(e.resolveType)}.`
    );
  }
  get [Symbol.toStringTag]() {
    return "GraphQLInterfaceType";
  }
  getFields() {
    return typeof this._fields == "function" && (this._fields = this._fields()), this._fields;
  }
  getInterfaces() {
    return typeof this._interfaces == "function" && (this._interfaces = this._interfaces()), this._interfaces;
  }
  toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: a$(this.getFields()),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes
    };
  }
  toString() {
    return this.name;
  }
  toJSON() {
    return this.toString();
  }
}
class qc {
  constructor(e) {
    var n;
    this.name = uo(e.name), this.description = e.description, this.resolveType = e.resolveType, this.extensions = Mo(e.extensions), this.astNode = e.astNode, this.extensionASTNodes = (n = e.extensionASTNodes) !== null && n !== void 0 ? n : [], this._types = qq.bind(void 0, e), e.resolveType == null || typeof e.resolveType == "function" || Nt(
      !1,
      `${this.name} must provide "resolveType" as a function, but got: ${_e(e.resolveType)}.`
    );
  }
  get [Symbol.toStringTag]() {
    return "GraphQLUnionType";
  }
  getTypes() {
    return typeof this._types == "function" && (this._types = this._types()), this._types;
  }
  toConfig() {
    return {
      name: this.name,
      description: this.description,
      types: this.getTypes(),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes
    };
  }
  toString() {
    return this.name;
  }
  toJSON() {
    return this.toString();
  }
}
function qq(t) {
  const e = $_(t.types);
  return Array.isArray(e) || Nt(
    !1,
    `Must provide Array of types or a function which returns such an array for Union ${t.name}.`
  ), e;
}
class ul {
  /* <T> */
  constructor(e) {
    var n;
    this.name = uo(e.name), this.description = e.description, this.extensions = Mo(e.extensions), this.astNode = e.astNode, this.extensionASTNodes = (n = e.extensionASTNodes) !== null && n !== void 0 ? n : [], this._values = typeof e.values == "function" ? e.values : RT(this.name, e.values), this._valueLookup = null, this._nameLookup = null;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLEnumType";
  }
  getValues() {
    return typeof this._values == "function" && (this._values = RT(this.name, this._values())), this._values;
  }
  getValue(e) {
    return this._nameLookup === null && (this._nameLookup = ma(this.getValues(), (n) => n.name)), this._nameLookup[e];
  }
  serialize(e) {
    this._valueLookup === null && (this._valueLookup = new Map(
      this.getValues().map((r) => [r.value, r])
    ));
    const n = this._valueLookup.get(e);
    if (n === void 0)
      throw new ye(
        `Enum "${this.name}" cannot represent value: ${_e(e)}`
      );
    return n.name;
  }
  parseValue(e) {
    if (typeof e != "string") {
      const r = _e(e);
      throw new ye(
        `Enum "${this.name}" cannot represent non-string value: ${r}.` + Bp(this, r)
      );
    }
    const n = this.getValue(e);
    if (n == null)
      throw new ye(
        `Value "${e}" does not exist in "${this.name}" enum.` + Bp(this, e)
      );
    return n.value;
  }
  parseLiteral(e, n) {
    if (e.kind !== z.ENUM) {
      const i = An(e);
      throw new ye(
        `Enum "${this.name}" cannot represent non-enum value: ${i}.` + Bp(this, i),
        {
          nodes: e
        }
      );
    }
    const r = this.getValue(e.value);
    if (r == null) {
      const i = An(e);
      throw new ye(
        `Value "${i}" does not exist in "${this.name}" enum.` + Bp(this, i),
        {
          nodes: e
        }
      );
    }
    return r.value;
  }
  toConfig() {
    const e = za(
      this.getValues(),
      (n) => n.name,
      (n) => ({
        description: n.description,
        value: n.value,
        deprecationReason: n.deprecationReason,
        extensions: n.extensions,
        astNode: n.astNode
      })
    );
    return {
      name: this.name,
      description: this.description,
      values: e,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes
    };
  }
  toString() {
    return this.name;
  }
  toJSON() {
    return this.toString();
  }
}
function Bp(t, e) {
  const n = t.getValues().map((i) => i.name), r = yl(e, n);
  return ga("the enum value", r);
}
function RT(t, e) {
  return yc(e) || Nt(
    !1,
    `${t} values must be an object with value names as keys.`
  ), Object.entries(e).map(([n, r]) => (yc(r) || Nt(
    !1,
    `${t}.${n} must refer to an object with a "value" key representing an internal value but got: ${_e(r)}.`
  ), {
    name: e$(n),
    description: r.description,
    value: r.value !== void 0 ? r.value : n,
    deprecationReason: r.deprecationReason,
    extensions: Mo(r.extensions),
    astNode: r.astNode
  }));
}
class zc {
  constructor(e) {
    var n, r;
    this.name = uo(e.name), this.description = e.description, this.extensions = Mo(e.extensions), this.astNode = e.astNode, this.extensionASTNodes = (n = e.extensionASTNodes) !== null && n !== void 0 ? n : [], this.isOneOf = (r = e.isOneOf) !== null && r !== void 0 ? r : !1, this._fields = zq.bind(void 0, e);
  }
  get [Symbol.toStringTag]() {
    return "GraphQLInputObjectType";
  }
  getFields() {
    return typeof this._fields == "function" && (this._fields = this._fields()), this._fields;
  }
  toConfig() {
    const e = Zs(this.getFields(), (n) => ({
      description: n.description,
      type: n.type,
      defaultValue: n.defaultValue,
      deprecationReason: n.deprecationReason,
      extensions: n.extensions,
      astNode: n.astNode
    }));
    return {
      name: this.name,
      description: this.description,
      fields: e,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
      isOneOf: this.isOneOf
    };
  }
  toString() {
    return this.name;
  }
  toJSON() {
    return this.toString();
  }
}
function zq(t) {
  const e = M_(t.fields);
  return yc(e) || Nt(
    !1,
    `${t.name} fields must be an object with field names as keys or a function which returns such an object.`
  ), Zs(e, (n, r) => (!("resolve" in n) || Nt(
    !1,
    `${t.name}.${r} field has a resolve property, but Input Types cannot define resolvers.`
  ), {
    name: uo(r),
    description: n.description,
    type: n.type,
    defaultValue: n.defaultValue,
    deprecationReason: n.deprecationReason,
    extensions: Mo(n.extensions),
    astNode: n.astNode
  }));
}
function Xy(t) {
  return St(t.type) && t.defaultValue === void 0;
}
function jm(t, e) {
  return t === e ? !0 : St(t) && St(e) || Mn(t) && Mn(e) ? jm(t.ofType, e.ofType) : !1;
}
function cu(t, e, n) {
  return e === n ? !0 : St(n) ? St(e) ? cu(t, e.ofType, n.ofType) : !1 : St(e) ? cu(t, e.ofType, n) : Mn(n) ? Mn(e) ? cu(t, e.ofType, n.ofType) : !1 : Mn(e) ? !1 : Ts(n) && (an(e) || Yt(e)) && t.isSubType(n, e);
}
function mw(t, e, n) {
  return e === n ? !0 : Ts(e) ? Ts(n) ? t.getPossibleTypes(e).some((r) => t.isSubType(n, r)) : t.isSubType(e, n) : Ts(n) ? t.isSubType(n, e) : !1;
}
const Qg = 2147483647, Jg = -2147483648, u$ = new Ds({
  name: "Int",
  description: "The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.",
  serialize(t) {
    const e = Gh(t);
    if (typeof e == "boolean")
      return e ? 1 : 0;
    let n = e;
    if (typeof e == "string" && e !== "" && (n = Number(e)), typeof n != "number" || !Number.isInteger(n))
      throw new ye(
        `Int cannot represent non-integer value: ${_e(e)}`
      );
    if (n > Qg || n < Jg)
      throw new ye(
        "Int cannot represent non 32-bit signed integer value: " + _e(e)
      );
    return n;
  },
  parseValue(t) {
    if (typeof t != "number" || !Number.isInteger(t))
      throw new ye(
        `Int cannot represent non-integer value: ${_e(t)}`
      );
    if (t > Qg || t < Jg)
      throw new ye(
        `Int cannot represent non 32-bit signed integer value: ${t}`
      );
    return t;
  },
  parseLiteral(t) {
    if (t.kind !== z.INT)
      throw new ye(
        `Int cannot represent non-integer value: ${An(t)}`,
        {
          nodes: t
        }
      );
    const e = parseInt(t.value, 10);
    if (e > Qg || e < Jg)
      throw new ye(
        `Int cannot represent non 32-bit signed integer value: ${t.value}`,
        {
          nodes: t
        }
      );
    return e;
  }
}), c$ = new Ds({
  name: "Float",
  description: "The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).",
  serialize(t) {
    const e = Gh(t);
    if (typeof e == "boolean")
      return e ? 1 : 0;
    let n = e;
    if (typeof e == "string" && e !== "" && (n = Number(e)), typeof n != "number" || !Number.isFinite(n))
      throw new ye(
        `Float cannot represent non numeric value: ${_e(e)}`
      );
    return n;
  },
  parseValue(t) {
    if (typeof t != "number" || !Number.isFinite(t))
      throw new ye(
        `Float cannot represent non numeric value: ${_e(t)}`
      );
    return t;
  },
  parseLiteral(t) {
    if (t.kind !== z.FLOAT && t.kind !== z.INT)
      throw new ye(
        `Float cannot represent non numeric value: ${An(t)}`,
        t
      );
    return parseFloat(t.value);
  }
}), Xn = new Ds({
  name: "String",
  description: "The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.",
  serialize(t) {
    const e = Gh(t);
    if (typeof e == "string")
      return e;
    if (typeof e == "boolean")
      return e ? "true" : "false";
    if (typeof e == "number" && Number.isFinite(e))
      return e.toString();
    throw new ye(
      `String cannot represent value: ${_e(t)}`
    );
  },
  parseValue(t) {
    if (typeof t != "string")
      throw new ye(
        `String cannot represent a non string value: ${_e(t)}`
      );
    return t;
  },
  parseLiteral(t) {
    if (t.kind !== z.STRING)
      throw new ye(
        `String cannot represent a non string value: ${An(t)}`,
        {
          nodes: t
        }
      );
    return t.value;
  }
}), Ai = new Ds({
  name: "Boolean",
  description: "The `Boolean` scalar type represents `true` or `false`.",
  serialize(t) {
    const e = Gh(t);
    if (typeof e == "boolean")
      return e;
    if (Number.isFinite(e))
      return e !== 0;
    throw new ye(
      `Boolean cannot represent a non boolean value: ${_e(e)}`
    );
  },
  parseValue(t) {
    if (typeof t != "boolean")
      throw new ye(
        `Boolean cannot represent a non boolean value: ${_e(t)}`
      );
    return t;
  },
  parseLiteral(t) {
    if (t.kind !== z.BOOLEAN)
      throw new ye(
        `Boolean cannot represent a non boolean value: ${An(t)}`,
        {
          nodes: t
        }
      );
    return t.value;
  }
}), F_ = new Ds({
  name: "ID",
  description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
  serialize(t) {
    const e = Gh(t);
    if (typeof e == "string")
      return e;
    if (Number.isInteger(e))
      return String(e);
    throw new ye(
      `ID cannot represent value: ${_e(t)}`
    );
  },
  parseValue(t) {
    if (typeof t == "string")
      return t;
    if (typeof t == "number" && Number.isInteger(t))
      return t.toString();
    throw new ye(`ID cannot represent value: ${_e(t)}`);
  },
  parseLiteral(t) {
    if (t.kind !== z.STRING && t.kind !== z.INT)
      throw new ye(
        "ID cannot represent a non-string and non-integer value: " + An(t),
        {
          nodes: t
        }
      );
    return t.value;
  }
}), Hh = Object.freeze([
  Xn,
  u$,
  c$,
  Ai,
  F_
]);
function Ky(t) {
  return Hh.some(({ name: e }) => t.name === e);
}
function Gh(t) {
  if (oo(t)) {
    if (typeof t.valueOf == "function") {
      const e = t.valueOf();
      if (!oo(e))
        return e;
    }
    if (typeof t.toJSON == "function")
      return t.toJSON();
  }
  return t;
}
function Qy(t) {
  return Jo(t, Yo);
}
function Hq(t) {
  if (!Qy(t))
    throw new Error(
      `Expected ${_e(t)} to be a GraphQL directive.`
    );
  return t;
}
class Yo {
  constructor(e) {
    var n, r;
    this.name = uo(e.name), this.description = e.description, this.locations = e.locations, this.isRepeatable = (n = e.isRepeatable) !== null && n !== void 0 ? n : !1, this.extensions = Mo(e.extensions), this.astNode = e.astNode, Array.isArray(e.locations) || Nt(!1, `@${e.name} locations must be an Array.`);
    const i = (r = e.args) !== null && r !== void 0 ? r : {};
    oo(i) && !Array.isArray(i) || Nt(
      !1,
      `@${e.name} args must be an object with argument names as keys.`
    ), this.args = s$(i);
  }
  get [Symbol.toStringTag]() {
    return "GraphQLDirective";
  }
  toConfig() {
    return {
      name: this.name,
      description: this.description,
      locations: this.locations,
      args: l$(this.args),
      isRepeatable: this.isRepeatable,
      extensions: this.extensions,
      astNode: this.astNode
    };
  }
  toString() {
    return "@" + this.name;
  }
  toJSON() {
    return this.toString();
  }
}
const L_ = new Yo({
  name: "include",
  description: "Directs the executor to include this field or fragment only when the `if` argument is true.",
  locations: [
    ft.FIELD,
    ft.FRAGMENT_SPREAD,
    ft.INLINE_FRAGMENT
  ],
  args: {
    if: {
      type: new It(Ai),
      description: "Included when true."
    }
  }
}), B_ = new Yo({
  name: "skip",
  description: "Directs the executor to skip this field or fragment when the `if` argument is true.",
  locations: [
    ft.FIELD,
    ft.FRAGMENT_SPREAD,
    ft.INLINE_FRAGMENT
  ],
  args: {
    if: {
      type: new It(Ai),
      description: "Skipped when true."
    }
  }
}), j_ = "No longer supported", Jy = new Yo({
  name: "deprecated",
  description: "Marks an element of a GraphQL schema as no longer supported.",
  locations: [
    ft.FIELD_DEFINITION,
    ft.ARGUMENT_DEFINITION,
    ft.INPUT_FIELD_DEFINITION,
    ft.ENUM_VALUE
  ],
  args: {
    reason: {
      type: Xn,
      description: "Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).",
      defaultValue: j_
    }
  }
}), V_ = new Yo({
  name: "specifiedBy",
  description: "Exposes a URL that specifies the behavior of this scalar.",
  locations: [ft.SCALAR],
  args: {
    url: {
      type: new It(Xn),
      description: "The URL that specifies the behavior of this scalar."
    }
  }
}), U_ = new Yo({
  name: "oneOf",
  description: "Indicates exactly one field must be supplied and this field must not be `null`.",
  locations: [ft.INPUT_OBJECT],
  args: {}
}), bl = Object.freeze([
  L_,
  B_,
  Jy,
  V_,
  U_
]);
function q_(t) {
  return bl.some(({ name: e }) => e === t.name);
}
function z_(t) {
  return typeof t == "object" && typeof t?.[Symbol.iterator] == "function";
}
function Ha(t, e) {
  if (St(e)) {
    const n = Ha(t, e.ofType);
    return n?.kind === z.NULL ? null : n;
  }
  if (t === null)
    return {
      kind: z.NULL
    };
  if (t === void 0)
    return null;
  if (Mn(e)) {
    const n = e.ofType;
    if (z_(t)) {
      const r = [];
      for (const i of t) {
        const o = Ha(i, n);
        o != null && r.push(o);
      }
      return {
        kind: z.LIST,
        values: r
      };
    }
    return Ha(t, n);
  }
  if (Sn(e)) {
    if (!oo(t))
      return null;
    const n = [];
    for (const r of Object.values(e.getFields())) {
      const i = Ha(t[r.name], r.type);
      i && n.push({
        kind: z.OBJECT_FIELD,
        name: {
          kind: z.NAME,
          value: r.name
        },
        value: i
      });
    }
    return {
      kind: z.OBJECT,
      fields: n
    };
  }
  if (Rs(e)) {
    const n = e.serialize(t);
    if (n == null)
      return null;
    if (typeof n == "boolean")
      return {
        kind: z.BOOLEAN,
        value: n
      };
    if (typeof n == "number" && Number.isFinite(n)) {
      const r = String(n);
      return OT.test(r) ? {
        kind: z.INT,
        value: r
      } : {
        kind: z.FLOAT,
        value: r
      };
    }
    if (typeof n == "string")
      return hr(e) ? {
        kind: z.ENUM,
        value: n
      } : e === F_ && OT.test(n) ? {
        kind: z.INT,
        value: n
      } : {
        kind: z.STRING,
        value: n
      };
    throw new TypeError(`Cannot convert value to AST: ${_e(n)}.`);
  }
  Zn(!1, "Unexpected input type: " + _e(e));
}
const OT = /^-?(?:0|[1-9][0-9]*)$/, Zy = new Do({
  name: "__Schema",
  description: "A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.",
  fields: () => ({
    description: {
      type: Xn,
      resolve: (t) => t.description
    },
    types: {
      description: "A list of all types supported by this server.",
      type: new It(new jr(new It(Eo))),
      resolve(t) {
        return Object.values(t.getTypeMap());
      }
    },
    queryType: {
      description: "The type that query operations will be rooted at.",
      type: new It(Eo),
      resolve: (t) => t.getQueryType()
    },
    mutationType: {
      description: "If this server supports mutation, the type that mutation operations will be rooted at.",
      type: Eo,
      resolve: (t) => t.getMutationType()
    },
    subscriptionType: {
      description: "If this server support subscription, the type that subscription operations will be rooted at.",
      type: Eo,
      resolve: (t) => t.getSubscriptionType()
    },
    directives: {
      description: "A list of all directives supported by this server.",
      type: new It(
        new jr(new It(H_))
      ),
      resolve: (t) => t.getDirectives()
    }
  })
}), H_ = new Do({
  name: "__Directive",
  description: `A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.

In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.`,
  fields: () => ({
    name: {
      type: new It(Xn),
      resolve: (t) => t.name
    },
    description: {
      type: Xn,
      resolve: (t) => t.description
    },
    isRepeatable: {
      type: new It(Ai),
      resolve: (t) => t.isRepeatable
    },
    locations: {
      type: new It(
        new jr(new It(G_))
      ),
      resolve: (t) => t.locations
    },
    args: {
      type: new It(
        new jr(new It(Wh))
      ),
      args: {
        includeDeprecated: {
          type: Ai,
          defaultValue: !1
        }
      },
      resolve(t, { includeDeprecated: e }) {
        return e ? t.args : t.args.filter((n) => n.deprecationReason == null);
      }
    }
  })
}), G_ = new ul({
  name: "__DirectiveLocation",
  description: "A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.",
  values: {
    QUERY: {
      value: ft.QUERY,
      description: "Location adjacent to a query operation."
    },
    MUTATION: {
      value: ft.MUTATION,
      description: "Location adjacent to a mutation operation."
    },
    SUBSCRIPTION: {
      value: ft.SUBSCRIPTION,
      description: "Location adjacent to a subscription operation."
    },
    FIELD: {
      value: ft.FIELD,
      description: "Location adjacent to a field."
    },
    FRAGMENT_DEFINITION: {
      value: ft.FRAGMENT_DEFINITION,
      description: "Location adjacent to a fragment definition."
    },
    FRAGMENT_SPREAD: {
      value: ft.FRAGMENT_SPREAD,
      description: "Location adjacent to a fragment spread."
    },
    INLINE_FRAGMENT: {
      value: ft.INLINE_FRAGMENT,
      description: "Location adjacent to an inline fragment."
    },
    VARIABLE_DEFINITION: {
      value: ft.VARIABLE_DEFINITION,
      description: "Location adjacent to a variable definition."
    },
    SCHEMA: {
      value: ft.SCHEMA,
      description: "Location adjacent to a schema definition."
    },
    SCALAR: {
      value: ft.SCALAR,
      description: "Location adjacent to a scalar definition."
    },
    OBJECT: {
      value: ft.OBJECT,
      description: "Location adjacent to an object type definition."
    },
    FIELD_DEFINITION: {
      value: ft.FIELD_DEFINITION,
      description: "Location adjacent to a field definition."
    },
    ARGUMENT_DEFINITION: {
      value: ft.ARGUMENT_DEFINITION,
      description: "Location adjacent to an argument definition."
    },
    INTERFACE: {
      value: ft.INTERFACE,
      description: "Location adjacent to an interface definition."
    },
    UNION: {
      value: ft.UNION,
      description: "Location adjacent to a union definition."
    },
    ENUM: {
      value: ft.ENUM,
      description: "Location adjacent to an enum definition."
    },
    ENUM_VALUE: {
      value: ft.ENUM_VALUE,
      description: "Location adjacent to an enum value definition."
    },
    INPUT_OBJECT: {
      value: ft.INPUT_OBJECT,
      description: "Location adjacent to an input object type definition."
    },
    INPUT_FIELD_DEFINITION: {
      value: ft.INPUT_FIELD_DEFINITION,
      description: "Location adjacent to an input object field definition."
    }
  }
}), Eo = new Do({
  name: "__Type",
  description: "The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.",
  fields: () => ({
    kind: {
      type: new It(X_),
      resolve(t) {
        if (co(t))
          return pn.SCALAR;
        if (Yt(t))
          return pn.OBJECT;
        if (an(t))
          return pn.INTERFACE;
        if (Er(t))
          return pn.UNION;
        if (hr(t))
          return pn.ENUM;
        if (Sn(t))
          return pn.INPUT_OBJECT;
        if (Mn(t))
          return pn.LIST;
        if (St(t))
          return pn.NON_NULL;
        Zn(!1, `Unexpected type: "${_e(t)}".`);
      }
    },
    name: {
      type: Xn,
      resolve: (t) => "name" in t ? t.name : void 0
    },
    description: {
      type: Xn,
      resolve: (t) => (
        /* c8 ignore next */
        "description" in t ? t.description : void 0
      )
    },
    specifiedByURL: {
      type: Xn,
      resolve: (t) => "specifiedByURL" in t ? t.specifiedByURL : void 0
    },
    fields: {
      type: new jr(new It(W_)),
      args: {
        includeDeprecated: {
          type: Ai,
          defaultValue: !1
        }
      },
      resolve(t, { includeDeprecated: e }) {
        if (Yt(t) || an(t)) {
          const n = Object.values(t.getFields());
          return e ? n : n.filter((r) => r.deprecationReason == null);
        }
      }
    },
    interfaces: {
      type: new jr(new It(Eo)),
      resolve(t) {
        if (Yt(t) || an(t))
          return t.getInterfaces();
      }
    },
    possibleTypes: {
      type: new jr(new It(Eo)),
      resolve(t, e, n, { schema: r }) {
        if (Ts(t))
          return r.getPossibleTypes(t);
      }
    },
    enumValues: {
      type: new jr(new It(Y_)),
      args: {
        includeDeprecated: {
          type: Ai,
          defaultValue: !1
        }
      },
      resolve(t, { includeDeprecated: e }) {
        if (hr(t)) {
          const n = t.getValues();
          return e ? n : n.filter((r) => r.deprecationReason == null);
        }
      }
    },
    inputFields: {
      type: new jr(new It(Wh)),
      args: {
        includeDeprecated: {
          type: Ai,
          defaultValue: !1
        }
      },
      resolve(t, { includeDeprecated: e }) {
        if (Sn(t)) {
          const n = Object.values(t.getFields());
          return e ? n : n.filter((r) => r.deprecationReason == null);
        }
      }
    },
    ofType: {
      type: Eo,
      resolve: (t) => "ofType" in t ? t.ofType : void 0
    },
    isOneOf: {
      type: Ai,
      resolve: (t) => {
        if (Sn(t))
          return t.isOneOf;
      }
    }
  })
}), W_ = new Do({
  name: "__Field",
  description: "Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.",
  fields: () => ({
    name: {
      type: new It(Xn),
      resolve: (t) => t.name
    },
    description: {
      type: Xn,
      resolve: (t) => t.description
    },
    args: {
      type: new It(
        new jr(new It(Wh))
      ),
      args: {
        includeDeprecated: {
          type: Ai,
          defaultValue: !1
        }
      },
      resolve(t, { includeDeprecated: e }) {
        return e ? t.args : t.args.filter((n) => n.deprecationReason == null);
      }
    },
    type: {
      type: new It(Eo),
      resolve: (t) => t.type
    },
    isDeprecated: {
      type: new It(Ai),
      resolve: (t) => t.deprecationReason != null
    },
    deprecationReason: {
      type: Xn,
      resolve: (t) => t.deprecationReason
    }
  })
}), Wh = new Do({
  name: "__InputValue",
  description: "Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.",
  fields: () => ({
    name: {
      type: new It(Xn),
      resolve: (t) => t.name
    },
    description: {
      type: Xn,
      resolve: (t) => t.description
    },
    type: {
      type: new It(Eo),
      resolve: (t) => t.type
    },
    defaultValue: {
      type: Xn,
      description: "A GraphQL-formatted string representing the default value for this input value.",
      resolve(t) {
        const { type: e, defaultValue: n } = t, r = Ha(n, e);
        return r ? An(r) : null;
      }
    },
    isDeprecated: {
      type: new It(Ai),
      resolve: (t) => t.deprecationReason != null
    },
    deprecationReason: {
      type: Xn,
      resolve: (t) => t.deprecationReason
    }
  })
}), Y_ = new Do({
  name: "__EnumValue",
  description: "One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.",
  fields: () => ({
    name: {
      type: new It(Xn),
      resolve: (t) => t.name
    },
    description: {
      type: Xn,
      resolve: (t) => t.description
    },
    isDeprecated: {
      type: new It(Ai),
      resolve: (t) => t.deprecationReason != null
    },
    deprecationReason: {
      type: Xn,
      resolve: (t) => t.deprecationReason
    }
  })
});
var pn;
(function(t) {
  t.SCALAR = "SCALAR", t.OBJECT = "OBJECT", t.INTERFACE = "INTERFACE", t.UNION = "UNION", t.ENUM = "ENUM", t.INPUT_OBJECT = "INPUT_OBJECT", t.LIST = "LIST", t.NON_NULL = "NON_NULL";
})(pn || (pn = {}));
const X_ = new ul({
  name: "__TypeKind",
  description: "An enum describing what kind of type a given `__Type` is.",
  values: {
    SCALAR: {
      value: pn.SCALAR,
      description: "Indicates this type is a scalar."
    },
    OBJECT: {
      value: pn.OBJECT,
      description: "Indicates this type is an object. `fields` and `interfaces` are valid fields."
    },
    INTERFACE: {
      value: pn.INTERFACE,
      description: "Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields."
    },
    UNION: {
      value: pn.UNION,
      description: "Indicates this type is a union. `possibleTypes` is a valid field."
    },
    ENUM: {
      value: pn.ENUM,
      description: "Indicates this type is an enum. `enumValues` is a valid field."
    },
    INPUT_OBJECT: {
      value: pn.INPUT_OBJECT,
      description: "Indicates this type is an input object. `inputFields` is a valid field."
    },
    LIST: {
      value: pn.LIST,
      description: "Indicates this type is a list. `ofType` is a valid field."
    },
    NON_NULL: {
      value: pn.NON_NULL,
      description: "Indicates this type is a non-null. `ofType` is a valid field."
    }
  }
}), uh = {
  name: "__schema",
  type: new It(Zy),
  description: "Access the current type schema of this server.",
  args: [],
  resolve: (t, e, n, { schema: r }) => r,
  deprecationReason: void 0,
  extensions: /* @__PURE__ */ Object.create(null),
  astNode: void 0
}, ch = {
  name: "__type",
  type: Eo,
  description: "Request the type information of a single type.",
  args: [
    {
      name: "name",
      description: void 0,
      type: new It(Xn),
      defaultValue: void 0,
      deprecationReason: void 0,
      extensions: /* @__PURE__ */ Object.create(null),
      astNode: void 0
    }
  ],
  resolve: (t, { name: e }, n, { schema: r }) => r.getType(e),
  deprecationReason: void 0,
  extensions: /* @__PURE__ */ Object.create(null),
  astNode: void 0
}, fh = {
  name: "__typename",
  type: new It(Xn),
  description: "The name of the current Object type at runtime.",
  args: [],
  resolve: (t, e, n, { parentType: r }) => r.name,
  deprecationReason: void 0,
  extensions: /* @__PURE__ */ Object.create(null),
  astNode: void 0
}, Yh = Object.freeze([
  Zy,
  H_,
  G_,
  Eo,
  W_,
  Wh,
  Y_,
  X_
]);
function Pu(t) {
  return Yh.some(({ name: e }) => t.name === e);
}
function f$(t) {
  return Jo(t, yf);
}
function K_(t) {
  if (!f$(t))
    throw new Error(`Expected ${_e(t)} to be a GraphQL schema.`);
  return t;
}
class yf {
  // Used as a cache for validateSchema().
  constructor(e) {
    var n, r;
    this.__validationErrors = e.assumeValid === !0 ? [] : void 0, oo(e) || Nt(!1, "Must provide configuration object."), !e.types || Array.isArray(e.types) || Nt(
      !1,
      `"types" must be Array if provided but got: ${_e(e.types)}.`
    ), !e.directives || Array.isArray(e.directives) || Nt(
      !1,
      `"directives" must be Array if provided but got: ${_e(e.directives)}.`
    ), this.description = e.description, this.extensions = Mo(e.extensions), this.astNode = e.astNode, this.extensionASTNodes = (n = e.extensionASTNodes) !== null && n !== void 0 ? n : [], this._queryType = e.query, this._mutationType = e.mutation, this._subscriptionType = e.subscription, this._directives = (r = e.directives) !== null && r !== void 0 ? r : bl;
    const i = new Set(e.types);
    if (e.types != null)
      for (const o of e.types)
        i.delete(o), qo(o, i);
    this._queryType != null && qo(this._queryType, i), this._mutationType != null && qo(this._mutationType, i), this._subscriptionType != null && qo(this._subscriptionType, i);
    for (const o of this._directives)
      if (Qy(o))
        for (const s of o.args)
          qo(s.type, i);
    qo(Zy, i), this._typeMap = /* @__PURE__ */ Object.create(null), this._subTypeMap = /* @__PURE__ */ Object.create(null), this._implementationsMap = /* @__PURE__ */ Object.create(null);
    for (const o of i) {
      if (o == null)
        continue;
      const s = o.name;
      if (s || Nt(
        !1,
        "One of the provided types for building the Schema is missing a name."
      ), this._typeMap[s] !== void 0)
        throw new Error(
          `Schema must contain uniquely named types but contains multiple types named "${s}".`
        );
      if (this._typeMap[s] = o, an(o)) {
        for (const a of o.getInterfaces())
          if (an(a)) {
            let l = this._implementationsMap[a.name];
            l === void 0 && (l = this._implementationsMap[a.name] = {
              objects: [],
              interfaces: []
            }), l.interfaces.push(o);
          }
      } else if (Yt(o)) {
        for (const a of o.getInterfaces())
          if (an(a)) {
            let l = this._implementationsMap[a.name];
            l === void 0 && (l = this._implementationsMap[a.name] = {
              objects: [],
              interfaces: []
            }), l.objects.push(o);
          }
      }
    }
  }
  get [Symbol.toStringTag]() {
    return "GraphQLSchema";
  }
  getQueryType() {
    return this._queryType;
  }
  getMutationType() {
    return this._mutationType;
  }
  getSubscriptionType() {
    return this._subscriptionType;
  }
  getRootType(e) {
    switch (e) {
      case Sr.QUERY:
        return this.getQueryType();
      case Sr.MUTATION:
        return this.getMutationType();
      case Sr.SUBSCRIPTION:
        return this.getSubscriptionType();
    }
  }
  getTypeMap() {
    return this._typeMap;
  }
  getType(e) {
    return this.getTypeMap()[e];
  }
  getPossibleTypes(e) {
    return Er(e) ? e.getTypes() : this.getImplementations(e).objects;
  }
  getImplementations(e) {
    const n = this._implementationsMap[e.name];
    return n ?? {
      objects: [],
      interfaces: []
    };
  }
  isSubType(e, n) {
    let r = this._subTypeMap[e.name];
    if (r === void 0) {
      if (r = /* @__PURE__ */ Object.create(null), Er(e))
        for (const i of e.getTypes())
          r[i.name] = !0;
      else {
        const i = this.getImplementations(e);
        for (const o of i.objects)
          r[o.name] = !0;
        for (const o of i.interfaces)
          r[o.name] = !0;
      }
      this._subTypeMap[e.name] = r;
    }
    return r[n.name] !== void 0;
  }
  getDirectives() {
    return this._directives;
  }
  getDirective(e) {
    return this.getDirectives().find((n) => n.name === e);
  }
  toConfig() {
    return {
      description: this.description,
      query: this.getQueryType(),
      mutation: this.getMutationType(),
      subscription: this.getSubscriptionType(),
      types: Object.values(this.getTypeMap()),
      directives: this.getDirectives(),
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
      assumeValid: this.__validationErrors !== void 0
    };
  }
}
function qo(t, e) {
  const n = hi(t);
  if (!e.has(n)) {
    if (e.add(n), Er(n))
      for (const r of n.getTypes())
        qo(r, e);
    else if (Yt(n) || an(n)) {
      for (const r of n.getInterfaces())
        qo(r, e);
      for (const r of Object.values(n.getFields())) {
        qo(r.type, e);
        for (const i of r.args)
          qo(i.type, e);
      }
    } else if (Sn(n))
      for (const r of Object.values(n.getFields()))
        qo(r.type, e);
  }
  return e;
}
function Q_(t) {
  if (K_(t), t.__validationErrors)
    return t.__validationErrors;
  const e = new Gq(t);
  Wq(e), Yq(e), Xq(e);
  const n = e.getErrors();
  return t.__validationErrors = n, n;
}
function J_(t) {
  const e = Q_(t);
  if (e.length !== 0)
    throw new Error(e.map((n) => n.message).join(`

`));
}
class Gq {
  constructor(e) {
    this._errors = [], this.schema = e;
  }
  reportError(e, n) {
    const r = Array.isArray(n) ? n.filter(Boolean) : n;
    this._errors.push(
      new ye(e, {
        nodes: r
      })
    );
  }
  getErrors() {
    return this._errors;
  }
}
function Wq(t) {
  const e = t.schema, n = e.getQueryType();
  if (!n)
    t.reportError("Query root type must be provided.", e.astNode);
  else if (!Yt(n)) {
    var r;
    t.reportError(
      `Query root type must be Object type, it cannot be ${_e(
        n
      )}.`,
      (r = iv(
        e,
        Sr.QUERY
      )) !== null && r !== void 0 ? r : n.astNode
    );
  }
  const i = e.getMutationType();
  if (i && !Yt(i)) {
    var o;
    t.reportError(
      `Mutation root type must be Object type if provided, it cannot be ${_e(i)}.`,
      (o = iv(
        e,
        Sr.MUTATION
      )) !== null && o !== void 0 ? o : i.astNode
    );
  }
  const s = e.getSubscriptionType();
  if (s && !Yt(s)) {
    var a;
    t.reportError(
      `Subscription root type must be Object type if provided, it cannot be ${_e(s)}.`,
      (a = iv(
        e,
        Sr.SUBSCRIPTION
      )) !== null && a !== void 0 ? a : s.astNode
    );
  }
}
function iv(t, e) {
  var n;
  return (n = [t.astNode, ...t.extensionASTNodes].flatMap(
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    (r) => {
      var i;
      return (
        /* c8 ignore next */
        (i = r?.operationTypes) !== null && i !== void 0 ? i : []
      );
    }
  ).find((r) => r.operation === e)) === null || n === void 0 ? void 0 : n.type;
}
function Yq(t) {
  for (const n of t.schema.getDirectives()) {
    if (!Qy(n)) {
      t.reportError(
        `Expected directive but got: ${_e(n)}.`,
        n?.astNode
      );
      continue;
    }
    Su(t, n), n.locations.length === 0 && t.reportError(
      `Directive @${n.name} must include 1 or more locations.`,
      n.astNode
    );
    for (const r of n.args)
      if (Su(t, r), Ci(r.type) || t.reportError(
        `The type of @${n.name}(${r.name}:) must be Input Type but got: ${_e(r.type)}.`,
        r.astNode
      ), vl(r) && r.deprecationReason != null) {
        var e;
        t.reportError(
          `Required argument @${n.name}(${r.name}:) cannot be deprecated.`,
          [
            Z_(r.astNode),
            (e = r.astNode) === null || e === void 0 ? void 0 : e.type
          ]
        );
      }
  }
}
function Su(t, e) {
  e.name.startsWith("__") && t.reportError(
    `Name "${e.name}" must not begin with "__", which is reserved by GraphQL introspection.`,
    e.astNode
  );
}
function Xq(t) {
  const e = nz(t), n = t.schema.getTypeMap();
  for (const r of Object.values(n)) {
    if (!zh(r)) {
      t.reportError(
        `Expected GraphQL named type but got: ${_e(r)}.`,
        r.astNode
      );
      continue;
    }
    Pu(r) || Su(t, r), Yt(r) || an(r) ? (DT(t, r), IT(t, r)) : Er(r) ? Jq(t, r) : hr(r) ? Zq(t, r) : Sn(r) && (ez(t, r), e(r));
  }
}
function DT(t, e) {
  const n = Object.values(e.getFields());
  n.length === 0 && t.reportError(`Type ${e.name} must define one or more fields.`, [
    e.astNode,
    ...e.extensionASTNodes
  ]);
  for (const s of n) {
    if (Su(t, s), !il(s.type)) {
      var r;
      t.reportError(
        `The type of ${e.name}.${s.name} must be Output Type but got: ${_e(s.type)}.`,
        (r = s.astNode) === null || r === void 0 ? void 0 : r.type
      );
    }
    for (const a of s.args) {
      const l = a.name;
      if (Su(t, a), !Ci(a.type)) {
        var i;
        t.reportError(
          `The type of ${e.name}.${s.name}(${l}:) must be Input Type but got: ${_e(a.type)}.`,
          (i = a.astNode) === null || i === void 0 ? void 0 : i.type
        );
      }
      if (vl(a) && a.deprecationReason != null) {
        var o;
        t.reportError(
          `Required argument ${e.name}.${s.name}(${l}:) cannot be deprecated.`,
          [
            Z_(a.astNode),
            (o = a.astNode) === null || o === void 0 ? void 0 : o.type
          ]
        );
      }
    }
  }
}
function IT(t, e) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const r of e.getInterfaces()) {
    if (!an(r)) {
      t.reportError(
        `Type ${_e(e)} must only implement Interface types, it cannot implement ${_e(r)}.`,
        Hd(e, r)
      );
      continue;
    }
    if (e === r) {
      t.reportError(
        `Type ${e.name} cannot implement itself because it would create a circular reference.`,
        Hd(e, r)
      );
      continue;
    }
    if (n[r.name]) {
      t.reportError(
        `Type ${e.name} can only implement ${r.name} once.`,
        Hd(e, r)
      );
      continue;
    }
    n[r.name] = !0, Qq(t, e, r), Kq(t, e, r);
  }
}
function Kq(t, e, n) {
  const r = e.getFields();
  for (const l of Object.values(n.getFields())) {
    const u = l.name, c = r[u];
    if (!c) {
      t.reportError(
        `Interface field ${n.name}.${u} expected but ${e.name} does not provide it.`,
        [l.astNode, e.astNode, ...e.extensionASTNodes]
      );
      continue;
    }
    if (!cu(t.schema, c.type, l.type)) {
      var i, o;
      t.reportError(
        `Interface field ${n.name}.${u} expects type ${_e(l.type)} but ${e.name}.${u} is type ${_e(c.type)}.`,
        [
          (i = l.astNode) === null || i === void 0 ? void 0 : i.type,
          (o = c.astNode) === null || o === void 0 ? void 0 : o.type
        ]
      );
    }
    for (const f of l.args) {
      const d = f.name, h = c.args.find((p) => p.name === d);
      if (!h) {
        t.reportError(
          `Interface field argument ${n.name}.${u}(${d}:) expected but ${e.name}.${u} does not provide it.`,
          [f.astNode, c.astNode]
        );
        continue;
      }
      if (!jm(f.type, h.type)) {
        var s, a;
        t.reportError(
          `Interface field argument ${n.name}.${u}(${d}:) expects type ${_e(f.type)} but ${e.name}.${u}(${d}:) is type ${_e(h.type)}.`,
          [
            (s = f.astNode) === null || s === void 0 ? void 0 : s.type,
            (a = h.astNode) === null || a === void 0 ? void 0 : a.type
          ]
        );
      }
    }
    for (const f of c.args) {
      const d = f.name;
      !l.args.find((p) => p.name === d) && vl(f) && t.reportError(
        `Object field ${e.name}.${u} includes required argument ${d} that is missing from the Interface field ${n.name}.${u}.`,
        [f.astNode, l.astNode]
      );
    }
  }
}
function Qq(t, e, n) {
  const r = e.getInterfaces();
  for (const i of n.getInterfaces())
    r.includes(i) || t.reportError(
      i === e ? `Type ${e.name} cannot implement ${n.name} because it would create a circular reference.` : `Type ${e.name} must implement ${i.name} because it is implemented by ${n.name}.`,
      [
        ...Hd(n, i),
        ...Hd(e, n)
      ]
    );
}
function Jq(t, e) {
  const n = e.getTypes();
  n.length === 0 && t.reportError(
    `Union type ${e.name} must define one or more member types.`,
    [e.astNode, ...e.extensionASTNodes]
  );
  const r = /* @__PURE__ */ Object.create(null);
  for (const i of n) {
    if (r[i.name]) {
      t.reportError(
        `Union type ${e.name} can only include type ${i.name} once.`,
        NT(e, i.name)
      );
      continue;
    }
    r[i.name] = !0, Yt(i) || t.reportError(
      `Union type ${e.name} can only include Object types, it cannot include ${_e(i)}.`,
      NT(e, String(i))
    );
  }
}
function Zq(t, e) {
  const n = e.getValues();
  n.length === 0 && t.reportError(
    `Enum type ${e.name} must define one or more values.`,
    [e.astNode, ...e.extensionASTNodes]
  );
  for (const r of n)
    Su(t, r);
}
function ez(t, e) {
  const n = Object.values(e.getFields());
  n.length === 0 && t.reportError(
    `Input Object type ${e.name} must define one or more fields.`,
    [e.astNode, ...e.extensionASTNodes]
  );
  for (const o of n) {
    if (Su(t, o), !Ci(o.type)) {
      var r;
      t.reportError(
        `The type of ${e.name}.${o.name} must be Input Type but got: ${_e(o.type)}.`,
        (r = o.astNode) === null || r === void 0 ? void 0 : r.type
      );
    }
    if (Xy(o) && o.deprecationReason != null) {
      var i;
      t.reportError(
        `Required input field ${e.name}.${o.name} cannot be deprecated.`,
        [
          Z_(o.astNode),
          (i = o.astNode) === null || i === void 0 ? void 0 : i.type
        ]
      );
    }
    e.isOneOf && tz(e, o, t);
  }
}
function tz(t, e, n) {
  if (St(e.type)) {
    var r;
    n.reportError(
      `OneOf input field ${t.name}.${e.name} must be nullable.`,
      (r = e.astNode) === null || r === void 0 ? void 0 : r.type
    );
  }
  e.defaultValue !== void 0 && n.reportError(
    `OneOf input field ${t.name}.${e.name} cannot have a default value.`,
    e.astNode
  );
}
function nz(t) {
  const e = /* @__PURE__ */ Object.create(null), n = [], r = /* @__PURE__ */ Object.create(null);
  return i;
  function i(o) {
    if (e[o.name])
      return;
    e[o.name] = !0, r[o.name] = n.length;
    const s = Object.values(o.getFields());
    for (const a of s)
      if (St(a.type) && Sn(a.type.ofType)) {
        const l = a.type.ofType, u = r[l.name];
        if (n.push(a), u === void 0)
          i(l);
        else {
          const c = n.slice(u), f = c.map((d) => d.name).join(".");
          t.reportError(
            `Cannot reference Input Object "${l.name}" within itself through a series of non-null fields: "${f}".`,
            c.map((d) => d.astNode)
          );
        }
        n.pop();
      }
    r[o.name] = void 0;
  }
}
function Hd(t, e) {
  const { astNode: n, extensionASTNodes: r } = t;
  return (n != null ? [n, ...r] : r).flatMap((o) => {
    var s;
    return (
      /* c8 ignore next */
      (s = o.interfaces) !== null && s !== void 0 ? s : []
    );
  }).filter((o) => o.name.value === e.name);
}
function NT(t, e) {
  const { astNode: n, extensionASTNodes: r } = t;
  return (n != null ? [n, ...r] : r).flatMap((o) => {
    var s;
    return (
      /* c8 ignore next */
      (s = o.types) !== null && s !== void 0 ? s : []
    );
  }).filter((o) => o.name.value === e);
}
function Z_(t) {
  var e;
  return t == null || (e = t.directives) === null || e === void 0 ? void 0 : e.find(
    (n) => n.name.value === Jy.name
  );
}
function Pi(t, e) {
  switch (e.kind) {
    case z.LIST_TYPE: {
      const n = Pi(t, e.type);
      return n && new jr(n);
    }
    case z.NON_NULL_TYPE: {
      const n = Pi(t, e.type);
      return n && new It(n);
    }
    case z.NAMED_TYPE:
      return t.getType(e.name.value);
  }
}
class eE {
  constructor(e, n, r) {
    this._schema = e, this._typeStack = [], this._parentTypeStack = [], this._inputTypeStack = [], this._fieldDefStack = [], this._defaultValueStack = [], this._directive = null, this._argument = null, this._enumValue = null, this._getFieldDef = r ?? rz, n && (Ci(n) && this._inputTypeStack.push(n), Os(n) && this._parentTypeStack.push(n), il(n) && this._typeStack.push(n));
  }
  get [Symbol.toStringTag]() {
    return "TypeInfo";
  }
  getType() {
    if (this._typeStack.length > 0)
      return this._typeStack[this._typeStack.length - 1];
  }
  getParentType() {
    if (this._parentTypeStack.length > 0)
      return this._parentTypeStack[this._parentTypeStack.length - 1];
  }
  getInputType() {
    if (this._inputTypeStack.length > 0)
      return this._inputTypeStack[this._inputTypeStack.length - 1];
  }
  getParentInputType() {
    if (this._inputTypeStack.length > 1)
      return this._inputTypeStack[this._inputTypeStack.length - 2];
  }
  getFieldDef() {
    if (this._fieldDefStack.length > 0)
      return this._fieldDefStack[this._fieldDefStack.length - 1];
  }
  getDefaultValue() {
    if (this._defaultValueStack.length > 0)
      return this._defaultValueStack[this._defaultValueStack.length - 1];
  }
  getDirective() {
    return this._directive;
  }
  getArgument() {
    return this._argument;
  }
  getEnumValue() {
    return this._enumValue;
  }
  enter(e) {
    const n = this._schema;
    switch (e.kind) {
      case z.SELECTION_SET: {
        const i = hi(this.getType());
        this._parentTypeStack.push(
          Os(i) ? i : void 0
        );
        break;
      }
      case z.FIELD: {
        const i = this.getParentType();
        let o, s;
        i && (o = this._getFieldDef(n, i, e), o && (s = o.type)), this._fieldDefStack.push(o), this._typeStack.push(il(s) ? s : void 0);
        break;
      }
      case z.DIRECTIVE:
        this._directive = n.getDirective(e.name.value);
        break;
      case z.OPERATION_DEFINITION: {
        const i = n.getRootType(e.operation);
        this._typeStack.push(Yt(i) ? i : void 0);
        break;
      }
      case z.INLINE_FRAGMENT:
      case z.FRAGMENT_DEFINITION: {
        const i = e.typeCondition, o = i ? Pi(n, i) : hi(this.getType());
        this._typeStack.push(il(o) ? o : void 0);
        break;
      }
      case z.VARIABLE_DEFINITION: {
        const i = Pi(n, e.type);
        this._inputTypeStack.push(
          Ci(i) ? i : void 0
        );
        break;
      }
      case z.ARGUMENT: {
        var r;
        let i, o;
        const s = (r = this.getDirective()) !== null && r !== void 0 ? r : this.getFieldDef();
        s && (i = s.args.find(
          (a) => a.name === e.name.value
        ), i && (o = i.type)), this._argument = i, this._defaultValueStack.push(i ? i.defaultValue : void 0), this._inputTypeStack.push(Ci(o) ? o : void 0);
        break;
      }
      case z.LIST: {
        const i = P_(this.getInputType()), o = Mn(i) ? i.ofType : i;
        this._defaultValueStack.push(void 0), this._inputTypeStack.push(Ci(o) ? o : void 0);
        break;
      }
      case z.OBJECT_FIELD: {
        const i = hi(this.getInputType());
        let o, s;
        Sn(i) && (s = i.getFields()[e.name.value], s && (o = s.type)), this._defaultValueStack.push(
          s ? s.defaultValue : void 0
        ), this._inputTypeStack.push(
          Ci(o) ? o : void 0
        );
        break;
      }
      case z.ENUM: {
        const i = hi(this.getInputType());
        let o;
        hr(i) && (o = i.getValue(e.value)), this._enumValue = o;
        break;
      }
    }
  }
  leave(e) {
    switch (e.kind) {
      case z.SELECTION_SET:
        this._parentTypeStack.pop();
        break;
      case z.FIELD:
        this._fieldDefStack.pop(), this._typeStack.pop();
        break;
      case z.DIRECTIVE:
        this._directive = null;
        break;
      case z.OPERATION_DEFINITION:
      case z.INLINE_FRAGMENT:
      case z.FRAGMENT_DEFINITION:
        this._typeStack.pop();
        break;
      case z.VARIABLE_DEFINITION:
        this._inputTypeStack.pop();
        break;
      case z.ARGUMENT:
        this._argument = null, this._defaultValueStack.pop(), this._inputTypeStack.pop();
        break;
      case z.LIST:
      case z.OBJECT_FIELD:
        this._defaultValueStack.pop(), this._inputTypeStack.pop();
        break;
      case z.ENUM:
        this._enumValue = null;
        break;
    }
  }
}
function rz(t, e, n) {
  const r = n.name.value;
  if (r === uh.name && t.getQueryType() === e)
    return uh;
  if (r === ch.name && t.getQueryType() === e)
    return ch;
  if (r === fh.name && Os(e))
    return fh;
  if (Yt(e) || an(e))
    return e.getFields()[r];
}
function tE(t, e) {
  return {
    enter(...n) {
      const r = n[0];
      t.enter(r);
      const i = Vc(e, r.kind).enter;
      if (i) {
        const o = i.apply(e, n);
        return o !== void 0 && (t.leave(r), hw(o) && t.enter(o)), o;
      }
    },
    leave(...n) {
      const r = n[0], i = Vc(e, r.kind).leave;
      let o;
      return i && (o = i.apply(e, n)), t.leave(r), o;
    }
  };
}
function iz(t) {
  return nE(t) || rE(t) || iE(t);
}
function nE(t) {
  return t.kind === z.OPERATION_DEFINITION || t.kind === z.FRAGMENT_DEFINITION;
}
function oz(t) {
  return t.kind === z.FIELD || t.kind === z.FRAGMENT_SPREAD || t.kind === z.INLINE_FRAGMENT;
}
function d$(t) {
  return t.kind === z.VARIABLE || t.kind === z.INT || t.kind === z.FLOAT || t.kind === z.STRING || t.kind === z.BOOLEAN || t.kind === z.NULL || t.kind === z.ENUM || t.kind === z.LIST || t.kind === z.OBJECT;
}
function yw(t) {
  return d$(t) && (t.kind === z.LIST ? t.values.some(yw) : t.kind === z.OBJECT ? t.fields.some((e) => yw(e.value)) : t.kind !== z.VARIABLE);
}
function sz(t) {
  return t.kind === z.NAMED_TYPE || t.kind === z.LIST_TYPE || t.kind === z.NON_NULL_TYPE;
}
function rE(t) {
  return t.kind === z.SCHEMA_DEFINITION || vf(t) || t.kind === z.DIRECTIVE_DEFINITION;
}
function vf(t) {
  return t.kind === z.SCALAR_TYPE_DEFINITION || t.kind === z.OBJECT_TYPE_DEFINITION || t.kind === z.INTERFACE_TYPE_DEFINITION || t.kind === z.UNION_TYPE_DEFINITION || t.kind === z.ENUM_TYPE_DEFINITION || t.kind === z.INPUT_OBJECT_TYPE_DEFINITION;
}
function iE(t) {
  return t.kind === z.SCHEMA_EXTENSION || e0(t);
}
function e0(t) {
  return t.kind === z.SCALAR_TYPE_EXTENSION || t.kind === z.OBJECT_TYPE_EXTENSION || t.kind === z.INTERFACE_TYPE_EXTENSION || t.kind === z.UNION_TYPE_EXTENSION || t.kind === z.ENUM_TYPE_EXTENSION || t.kind === z.INPUT_OBJECT_TYPE_EXTENSION;
}
function h$(t) {
  return {
    Document(e) {
      for (const n of e.definitions)
        if (!nE(n)) {
          const r = n.kind === z.SCHEMA_DEFINITION || n.kind === z.SCHEMA_EXTENSION ? "schema" : '"' + n.name.value + '"';
          t.reportError(
            new ye(`The ${r} definition is not executable.`, {
              nodes: n
            })
          );
        }
      return !1;
    }
  };
}
function p$(t) {
  return {
    Field(e) {
      const n = t.getParentType();
      if (n && !t.getFieldDef()) {
        const i = t.getSchema(), o = e.name.value;
        let s = ga(
          "to use an inline fragment on",
          az(i, n, o)
        );
        s === "" && (s = ga(lz(n, o))), t.reportError(
          new ye(
            `Cannot query field "${o}" on type "${n.name}".` + s,
            {
              nodes: e
            }
          )
        );
      }
    }
  };
}
function az(t, e, n) {
  if (!Ts(e))
    return [];
  const r = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ Object.create(null);
  for (const s of t.getPossibleTypes(e))
    if (s.getFields()[n]) {
      r.add(s), i[s.name] = 1;
      for (const a of s.getInterfaces()) {
        var o;
        a.getFields()[n] && (r.add(a), i[a.name] = ((o = i[a.name]) !== null && o !== void 0 ? o : 0) + 1);
      }
    }
  return [...r].sort((s, a) => {
    const l = i[a.name] - i[s.name];
    return l !== 0 ? l : an(s) && t.isSubType(s, a) ? -1 : an(a) && t.isSubType(a, s) ? 1 : Vh(s.name, a.name);
  }).map((s) => s.name);
}
function lz(t, e) {
  if (Yt(t) || an(t)) {
    const n = Object.keys(t.getFields());
    return yl(e, n);
  }
  return [];
}
function g$(t) {
  return {
    InlineFragment(e) {
      const n = e.typeCondition;
      if (n) {
        const r = Pi(t.getSchema(), n);
        if (r && !Os(r)) {
          const i = An(n);
          t.reportError(
            new ye(
              `Fragment cannot condition on non composite type "${i}".`,
              {
                nodes: n
              }
            )
          );
        }
      }
    },
    FragmentDefinition(e) {
      const n = Pi(t.getSchema(), e.typeCondition);
      if (n && !Os(n)) {
        const r = An(e.typeCondition);
        t.reportError(
          new ye(
            `Fragment "${e.name.value}" cannot condition on non composite type "${r}".`,
            {
              nodes: e.typeCondition
            }
          )
        );
      }
    }
  };
}
function m$(t) {
  return {
    // eslint-disable-next-line new-cap
    ...y$(t),
    Argument(e) {
      const n = t.getArgument(), r = t.getFieldDef(), i = t.getParentType();
      if (!n && r && i) {
        const o = e.name.value, s = r.args.map((l) => l.name), a = yl(o, s);
        t.reportError(
          new ye(
            `Unknown argument "${o}" on field "${i.name}.${r.name}".` + ga(a),
            {
              nodes: e
            }
          )
        );
      }
    }
  };
}
function y$(t) {
  const e = /* @__PURE__ */ Object.create(null), n = t.getSchema(), r = n ? n.getDirectives() : bl;
  for (const s of r)
    e[s.name] = s.args.map((a) => a.name);
  const i = t.getDocument().definitions;
  for (const s of i)
    if (s.kind === z.DIRECTIVE_DEFINITION) {
      var o;
      const a = (o = s.arguments) !== null && o !== void 0 ? o : [];
      e[s.name.value] = a.map((l) => l.name.value);
    }
  return {
    Directive(s) {
      const a = s.name.value, l = e[a];
      if (s.arguments && l)
        for (const u of s.arguments) {
          const c = u.name.value;
          if (!l.includes(c)) {
            const f = yl(c, l);
            t.reportError(
              new ye(
                `Unknown argument "${c}" on directive "@${a}".` + ga(f),
                {
                  nodes: u
                }
              )
            );
          }
        }
      return !1;
    }
  };
}
function oE(t) {
  const e = /* @__PURE__ */ Object.create(null), n = t.getSchema(), r = n ? n.getDirectives() : bl;
  for (const o of r)
    e[o.name] = o.locations;
  const i = t.getDocument().definitions;
  for (const o of i)
    o.kind === z.DIRECTIVE_DEFINITION && (e[o.name.value] = o.locations.map((s) => s.value));
  return {
    Directive(o, s, a, l, u) {
      const c = o.name.value, f = e[c];
      if (!f) {
        t.reportError(
          new ye(`Unknown directive "@${c}".`, {
            nodes: o
          })
        );
        return;
      }
      const d = uz(u);
      d && !f.includes(d) && t.reportError(
        new ye(
          `Directive "@${c}" may not be used on ${d}.`,
          {
            nodes: o
          }
        )
      );
    }
  };
}
function uz(t) {
  const e = t[t.length - 1];
  switch ("kind" in e || Zn(!1), e.kind) {
    case z.OPERATION_DEFINITION:
      return cz(e.operation);
    case z.FIELD:
      return ft.FIELD;
    case z.FRAGMENT_SPREAD:
      return ft.FRAGMENT_SPREAD;
    case z.INLINE_FRAGMENT:
      return ft.INLINE_FRAGMENT;
    case z.FRAGMENT_DEFINITION:
      return ft.FRAGMENT_DEFINITION;
    case z.VARIABLE_DEFINITION:
      return ft.VARIABLE_DEFINITION;
    case z.SCHEMA_DEFINITION:
    case z.SCHEMA_EXTENSION:
      return ft.SCHEMA;
    case z.SCALAR_TYPE_DEFINITION:
    case z.SCALAR_TYPE_EXTENSION:
      return ft.SCALAR;
    case z.OBJECT_TYPE_DEFINITION:
    case z.OBJECT_TYPE_EXTENSION:
      return ft.OBJECT;
    case z.FIELD_DEFINITION:
      return ft.FIELD_DEFINITION;
    case z.INTERFACE_TYPE_DEFINITION:
    case z.INTERFACE_TYPE_EXTENSION:
      return ft.INTERFACE;
    case z.UNION_TYPE_DEFINITION:
    case z.UNION_TYPE_EXTENSION:
      return ft.UNION;
    case z.ENUM_TYPE_DEFINITION:
    case z.ENUM_TYPE_EXTENSION:
      return ft.ENUM;
    case z.ENUM_VALUE_DEFINITION:
      return ft.ENUM_VALUE;
    case z.INPUT_OBJECT_TYPE_DEFINITION:
    case z.INPUT_OBJECT_TYPE_EXTENSION:
      return ft.INPUT_OBJECT;
    case z.INPUT_VALUE_DEFINITION: {
      const n = t[t.length - 3];
      return "kind" in n || Zn(!1), n.kind === z.INPUT_OBJECT_TYPE_DEFINITION ? ft.INPUT_FIELD_DEFINITION : ft.ARGUMENT_DEFINITION;
    }
    // Not reachable, all possible types have been considered.
    /* c8 ignore next */
    default:
      Zn(!1, "Unexpected kind: " + _e(e.kind));
  }
}
function cz(t) {
  switch (t) {
    case Sr.QUERY:
      return ft.QUERY;
    case Sr.MUTATION:
      return ft.MUTATION;
    case Sr.SUBSCRIPTION:
      return ft.SUBSCRIPTION;
  }
}
function v$(t) {
  return {
    FragmentSpread(e) {
      const n = e.name.value;
      t.getFragment(n) || t.reportError(
        new ye(`Unknown fragment "${n}".`, {
          nodes: e.name
        })
      );
    }
  };
}
function sE(t) {
  const e = t.getSchema(), n = e ? e.getTypeMap() : /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  for (const o of t.getDocument().definitions)
    vf(o) && (r[o.name.value] = !0);
  const i = [
    ...Object.keys(n),
    ...Object.keys(r)
  ];
  return {
    NamedType(o, s, a, l, u) {
      const c = o.name.value;
      if (!n[c] && !r[c]) {
        var f;
        const d = (f = u[2]) !== null && f !== void 0 ? f : a, h = d != null && fz(d);
        if (h && PT.includes(c))
          return;
        const p = yl(
          c,
          h ? PT.concat(i) : i
        );
        t.reportError(
          new ye(
            `Unknown type "${c}".` + ga(p),
            {
              nodes: o
            }
          )
        );
      }
    }
  };
}
const PT = [...Hh, ...Yh].map(
  (t) => t.name
);
function fz(t) {
  return "kind" in t && (rE(t) || iE(t));
}
function b$(t) {
  let e = 0;
  return {
    Document(n) {
      e = n.definitions.filter(
        (r) => r.kind === z.OPERATION_DEFINITION
      ).length;
    },
    OperationDefinition(n) {
      !n.name && e > 1 && t.reportError(
        new ye(
          "This anonymous operation must be the only defined operation.",
          {
            nodes: n
          }
        )
      );
    }
  };
}
function w$(t) {
  var e, n, r;
  const i = t.getSchema(), o = (e = (n = (r = i?.astNode) !== null && r !== void 0 ? r : i?.getQueryType()) !== null && n !== void 0 ? n : i?.getMutationType()) !== null && e !== void 0 ? e : i?.getSubscriptionType();
  let s = 0;
  return {
    SchemaDefinition(a) {
      if (o) {
        t.reportError(
          new ye(
            "Cannot define a new schema within a schema extension.",
            {
              nodes: a
            }
          )
        );
        return;
      }
      s > 0 && t.reportError(
        new ye("Must provide only one schema definition.", {
          nodes: a
        })
      ), ++s;
    }
  };
}
const dz = 3;
function S$(t) {
  function e(n, r = /* @__PURE__ */ Object.create(null), i = 0) {
    if (n.kind === z.FRAGMENT_SPREAD) {
      const o = n.name.value;
      if (r[o] === !0)
        return !1;
      const s = t.getFragment(o);
      if (!s)
        return !1;
      try {
        return r[o] = !0, e(s, r, i);
      } finally {
        r[o] = void 0;
      }
    }
    if (n.kind === z.FIELD && // check all introspection lists
    (n.name.value === "fields" || n.name.value === "interfaces" || n.name.value === "possibleTypes" || n.name.value === "inputFields") && (i++, i >= dz))
      return !0;
    if ("selectionSet" in n && n.selectionSet) {
      for (const o of n.selectionSet.selections)
        if (e(o, r, i))
          return !0;
    }
    return !1;
  }
  return {
    Field(n) {
      if ((n.name.value === "__schema" || n.name.value === "__type") && e(n))
        return t.reportError(
          new ye("Maximum introspection depth exceeded", {
            nodes: [n]
          })
        ), !1;
    }
  };
}
function _$(t) {
  const e = /* @__PURE__ */ Object.create(null), n = [], r = /* @__PURE__ */ Object.create(null);
  return {
    OperationDefinition: () => !1,
    FragmentDefinition(o) {
      return i(o), !1;
    }
  };
  function i(o) {
    if (e[o.name.value])
      return;
    const s = o.name.value;
    e[s] = !0;
    const a = t.getFragmentSpreads(o.selectionSet);
    if (a.length !== 0) {
      r[s] = n.length;
      for (const l of a) {
        const u = l.name.value, c = r[u];
        if (n.push(l), c === void 0) {
          const f = t.getFragment(u);
          f && i(f);
        } else {
          const f = n.slice(c), d = f.slice(0, -1).map((h) => '"' + h.name.value + '"').join(", ");
          t.reportError(
            new ye(
              `Cannot spread fragment "${u}" within itself` + (d !== "" ? ` via ${d}.` : "."),
              {
                nodes: f
              }
            )
          );
        }
        n.pop();
      }
      r[s] = void 0;
    }
  }
}
function E$(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return {
    OperationDefinition: {
      enter() {
        e = /* @__PURE__ */ Object.create(null);
      },
      leave(n) {
        const r = t.getRecursiveVariableUsages(n);
        for (const { node: i } of r) {
          const o = i.name.value;
          e[o] !== !0 && t.reportError(
            new ye(
              n.name ? `Variable "$${o}" is not defined by operation "${n.name.value}".` : `Variable "$${o}" is not defined.`,
              {
                nodes: [i, n]
              }
            )
          );
        }
      }
    },
    VariableDefinition(n) {
      e[n.variable.name.value] = !0;
    }
  };
}
function k$(t) {
  const e = [], n = [];
  return {
    OperationDefinition(r) {
      return e.push(r), !1;
    },
    FragmentDefinition(r) {
      return n.push(r), !1;
    },
    Document: {
      leave() {
        const r = /* @__PURE__ */ Object.create(null);
        for (const i of e)
          for (const o of t.getRecursivelyReferencedFragments(
            i
          ))
            r[o.name.value] = !0;
        for (const i of n) {
          const o = i.name.value;
          r[o] !== !0 && t.reportError(
            new ye(`Fragment "${o}" is never used.`, {
              nodes: i
            })
          );
        }
      }
    }
  };
}
function T$(t) {
  let e = [];
  return {
    OperationDefinition: {
      enter() {
        e = [];
      },
      leave(n) {
        const r = /* @__PURE__ */ Object.create(null), i = t.getRecursiveVariableUsages(n);
        for (const { node: o } of i)
          r[o.name.value] = !0;
        for (const o of e) {
          const s = o.variable.name.value;
          r[s] !== !0 && t.reportError(
            new ye(
              n.name ? `Variable "$${s}" is never used in operation "${n.name.value}".` : `Variable "$${s}" is never used.`,
              {
                nodes: o
              }
            )
          );
        }
      }
    },
    VariableDefinition(n) {
      e.push(n);
    }
  };
}
function t0(t) {
  switch (t.kind) {
    case z.OBJECT:
      return { ...t, fields: hz(t.fields) };
    case z.LIST:
      return { ...t, values: t.values.map(t0) };
    case z.INT:
    case z.FLOAT:
    case z.STRING:
    case z.BOOLEAN:
    case z.NULL:
    case z.ENUM:
    case z.VARIABLE:
      return t;
  }
}
function hz(t) {
  return t.map((e) => ({
    ...e,
    value: t0(e.value)
  })).sort(
    (e, n) => Vh(e.name.value, n.name.value)
  );
}
function x$(t) {
  return Array.isArray(t) ? t.map(
    ([e, n]) => `subfields "${e}" conflict because ` + x$(n)
  ).join(" and ") : t;
}
function C$(t) {
  const e = new O$(), n = new bz(), r = /* @__PURE__ */ new Map();
  return {
    SelectionSet(i) {
      const o = pz(
        t,
        r,
        e,
        n,
        t.getParentType(),
        i
      );
      for (const [[s, a], l, u] of o) {
        const c = x$(a);
        t.reportError(
          new ye(
            `Fields "${s}" conflict because ${c}. Use different aliases on the fields to fetch both if this was intentional.`,
            {
              nodes: l.concat(u)
            }
          )
        );
      }
    }
  };
}
function pz(t, e, n, r, i, o) {
  const s = [], [a, l] = qm(
    t,
    e,
    i,
    o
  );
  if (mz(
    t,
    s,
    e,
    n,
    r,
    a
  ), l.length !== 0)
    for (let u = 0; u < l.length; u++) {
      Vm(
        t,
        s,
        e,
        n,
        r,
        !1,
        a,
        l[u]
      );
      for (let c = u + 1; c < l.length; c++)
        Um(
          t,
          s,
          e,
          n,
          r,
          !1,
          l[u],
          l[c]
        );
    }
  return s;
}
function Vm(t, e, n, r, i, o, s, a) {
  if (r.has(
    s,
    a,
    o
  ))
    return;
  r.add(
    s,
    a,
    o
  );
  const l = t.getFragment(a);
  if (!l)
    return;
  const [u, c] = bw(
    t,
    n,
    l
  );
  if (s !== u) {
    aE(
      t,
      e,
      n,
      r,
      i,
      o,
      s,
      u
    );
    for (const f of c)
      Vm(
        t,
        e,
        n,
        r,
        i,
        o,
        s,
        f
      );
  }
}
function Um(t, e, n, r, i, o, s, a) {
  if (s === a || i.has(
    s,
    a,
    o
  ))
    return;
  i.add(s, a, o);
  const l = t.getFragment(s), u = t.getFragment(a);
  if (!l || !u)
    return;
  const [c, f] = bw(
    t,
    n,
    l
  ), [d, h] = bw(
    t,
    n,
    u
  );
  aE(
    t,
    e,
    n,
    r,
    i,
    o,
    c,
    d
  );
  for (const p of h)
    Um(
      t,
      e,
      n,
      r,
      i,
      o,
      s,
      p
    );
  for (const p of f)
    Um(
      t,
      e,
      n,
      r,
      i,
      o,
      p,
      a
    );
}
function gz(t, e, n, r, i, o, s, a, l) {
  const u = [], [c, f] = qm(
    t,
    e,
    o,
    s
  ), [d, h] = qm(
    t,
    e,
    a,
    l
  );
  aE(
    t,
    u,
    e,
    n,
    r,
    i,
    c,
    d
  );
  for (const p of h)
    Vm(
      t,
      u,
      e,
      n,
      r,
      i,
      c,
      p
    );
  for (const p of f)
    Vm(
      t,
      u,
      e,
      n,
      r,
      i,
      d,
      p
    );
  for (const p of f)
    for (const g of h)
      Um(
        t,
        u,
        e,
        n,
        r,
        i,
        p,
        g
      );
  return u;
}
function mz(t, e, n, r, i, o) {
  for (const [s, a] of Object.entries(o))
    if (a.length > 1)
      for (let l = 0; l < a.length; l++)
        for (let u = l + 1; u < a.length; u++) {
          const c = A$(
            t,
            n,
            r,
            i,
            !1,
            // within one collection is never mutually exclusive
            s,
            a[l],
            a[u]
          );
          c && e.push(c);
        }
}
function aE(t, e, n, r, i, o, s, a) {
  for (const [l, u] of Object.entries(s)) {
    const c = a[l];
    if (c)
      for (const f of u)
        for (const d of c) {
          const h = A$(
            t,
            n,
            r,
            i,
            o,
            l,
            f,
            d
          );
          h && e.push(h);
        }
  }
}
function A$(t, e, n, r, i, o, s, a) {
  const [l, u, c] = s, [f, d, h] = a, p = i || l !== f && Yt(l) && Yt(f);
  if (!p) {
    const _ = u.name.value, b = d.name.value;
    if (_ !== b)
      return [
        [o, `"${_}" and "${b}" are different fields`],
        [u],
        [d]
      ];
    if (!yz(u, d))
      return [
        [o, "they have differing arguments"],
        [u],
        [d]
      ];
  }
  const g = c?.type, m = h?.type;
  if (g && m && vw(g, m))
    return [
      [
        o,
        `they return conflicting types "${_e(g)}" and "${_e(
          m
        )}"`
      ],
      [u],
      [d]
    ];
  const v = u.selectionSet, S = d.selectionSet;
  if (v && S) {
    const _ = gz(
      t,
      e,
      n,
      r,
      p,
      hi(g),
      v,
      hi(m),
      S
    );
    return vz(_, o, u, d);
  }
}
function yz(t, e) {
  const n = t.arguments, r = e.arguments;
  if (n === void 0 || n.length === 0)
    return r === void 0 || r.length === 0;
  if (r === void 0 || r.length === 0 || n.length !== r.length)
    return !1;
  const i = new Map(r.map(({ name: o, value: s }) => [o.value, s]));
  return n.every((o) => {
    const s = o.value, a = i.get(o.name.value);
    return a === void 0 ? !1 : $T(s) === $T(a);
  });
}
function $T(t) {
  return An(t0(t));
}
function vw(t, e) {
  return Mn(t) ? Mn(e) ? vw(t.ofType, e.ofType) : !0 : Mn(e) ? !0 : St(t) ? St(e) ? vw(t.ofType, e.ofType) : !0 : St(e) ? !0 : Rs(t) || Rs(e) ? t !== e : !1;
}
function qm(t, e, n, r) {
  const i = e.get(r);
  if (i)
    return i;
  const o = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  R$(
    t,
    n,
    r,
    o,
    s
  );
  const a = [o, Object.keys(s)];
  return e.set(r, a), a;
}
function bw(t, e, n) {
  const r = e.get(n.selectionSet);
  if (r)
    return r;
  const i = Pi(t.getSchema(), n.typeCondition);
  return qm(
    t,
    e,
    i,
    n.selectionSet
  );
}
function R$(t, e, n, r, i) {
  for (const o of n.selections)
    switch (o.kind) {
      case z.FIELD: {
        const s = o.name.value;
        let a;
        (Yt(e) || an(e)) && (a = e.getFields()[s]);
        const l = o.alias ? o.alias.value : s;
        r[l] || (r[l] = []), r[l].push([e, o, a]);
        break;
      }
      case z.FRAGMENT_SPREAD:
        i[o.name.value] = !0;
        break;
      case z.INLINE_FRAGMENT: {
        const s = o.typeCondition, a = s ? Pi(t.getSchema(), s) : e;
        R$(
          t,
          a,
          o.selectionSet,
          r,
          i
        );
        break;
      }
    }
}
function vz(t, e, n, r) {
  if (t.length > 0)
    return [
      [e, t.map(([i]) => i)],
      [n, ...t.map(([, i]) => i).flat()],
      [r, ...t.map(([, , i]) => i).flat()]
    ];
}
class O$ {
  constructor() {
    this._data = /* @__PURE__ */ new Map();
  }
  has(e, n, r) {
    var i;
    const o = (i = this._data.get(e)) === null || i === void 0 ? void 0 : i.get(n);
    return o === void 0 ? !1 : r ? !0 : r === o;
  }
  add(e, n, r) {
    const i = this._data.get(e);
    i === void 0 ? this._data.set(e, /* @__PURE__ */ new Map([[n, r]])) : i.set(n, r);
  }
}
class bz {
  constructor() {
    this._orderedPairSet = new O$();
  }
  has(e, n, r) {
    return e < n ? this._orderedPairSet.has(e, n, r) : this._orderedPairSet.has(n, e, r);
  }
  add(e, n, r) {
    e < n ? this._orderedPairSet.add(e, n, r) : this._orderedPairSet.add(n, e, r);
  }
}
function D$(t) {
  return {
    InlineFragment(e) {
      const n = t.getType(), r = t.getParentType();
      if (Os(n) && Os(r) && !mw(t.getSchema(), n, r)) {
        const i = _e(r), o = _e(n);
        t.reportError(
          new ye(
            `Fragment cannot be spread here as objects of type "${i}" can never be of type "${o}".`,
            {
              nodes: e
            }
          )
        );
      }
    },
    FragmentSpread(e) {
      const n = e.name.value, r = wz(t, n), i = t.getParentType();
      if (r && i && !mw(t.getSchema(), r, i)) {
        const o = _e(i), s = _e(r);
        t.reportError(
          new ye(
            `Fragment "${n}" cannot be spread here as objects of type "${o}" can never be of type "${s}".`,
            {
              nodes: e
            }
          )
        );
      }
    }
  };
}
function wz(t, e) {
  const n = t.getFragment(e);
  if (n) {
    const r = Pi(t.getSchema(), n.typeCondition);
    if (Os(r))
      return r;
  }
}
function I$(t) {
  const e = t.getSchema(), n = /* @__PURE__ */ Object.create(null);
  for (const i of t.getDocument().definitions)
    vf(i) && (n[i.name.value] = i);
  return {
    ScalarTypeExtension: r,
    ObjectTypeExtension: r,
    InterfaceTypeExtension: r,
    UnionTypeExtension: r,
    EnumTypeExtension: r,
    InputObjectTypeExtension: r
  };
  function r(i) {
    const o = i.name.value, s = n[o], a = e?.getType(o);
    let l;
    if (s ? l = Sz[s.kind] : a && (l = _z(a)), l) {
      if (l !== i.kind) {
        const u = Ez(i.kind);
        t.reportError(
          new ye(`Cannot extend non-${u} type "${o}".`, {
            nodes: s ? [s, i] : i
          })
        );
      }
    } else {
      const u = Object.keys({
        ...n,
        ...e?.getTypeMap()
      }), c = yl(o, u);
      t.reportError(
        new ye(
          `Cannot extend type "${o}" because it is not defined.` + ga(c),
          {
            nodes: i.name
          }
        )
      );
    }
  }
}
const Sz = {
  [z.SCALAR_TYPE_DEFINITION]: z.SCALAR_TYPE_EXTENSION,
  [z.OBJECT_TYPE_DEFINITION]: z.OBJECT_TYPE_EXTENSION,
  [z.INTERFACE_TYPE_DEFINITION]: z.INTERFACE_TYPE_EXTENSION,
  [z.UNION_TYPE_DEFINITION]: z.UNION_TYPE_EXTENSION,
  [z.ENUM_TYPE_DEFINITION]: z.ENUM_TYPE_EXTENSION,
  [z.INPUT_OBJECT_TYPE_DEFINITION]: z.INPUT_OBJECT_TYPE_EXTENSION
};
function _z(t) {
  if (co(t))
    return z.SCALAR_TYPE_EXTENSION;
  if (Yt(t))
    return z.OBJECT_TYPE_EXTENSION;
  if (an(t))
    return z.INTERFACE_TYPE_EXTENSION;
  if (Er(t))
    return z.UNION_TYPE_EXTENSION;
  if (hr(t))
    return z.ENUM_TYPE_EXTENSION;
  if (Sn(t))
    return z.INPUT_OBJECT_TYPE_EXTENSION;
  Zn(!1, "Unexpected type: " + _e(t));
}
function Ez(t) {
  switch (t) {
    case z.SCALAR_TYPE_EXTENSION:
      return "scalar";
    case z.OBJECT_TYPE_EXTENSION:
      return "object";
    case z.INTERFACE_TYPE_EXTENSION:
      return "interface";
    case z.UNION_TYPE_EXTENSION:
      return "union";
    case z.ENUM_TYPE_EXTENSION:
      return "enum";
    case z.INPUT_OBJECT_TYPE_EXTENSION:
      return "input object";
    // Not reachable. All possible types have been considered
    /* c8 ignore next */
    default:
      Zn(!1, "Unexpected kind: " + _e(t));
  }
}
function N$(t) {
  return {
    // eslint-disable-next-line new-cap
    ...P$(t),
    Field: {
      // Validate on leave to allow for deeper errors to appear first.
      leave(e) {
        var n;
        const r = t.getFieldDef();
        if (!r)
          return !1;
        const i = new Set(
          // FIXME: https://github.com/graphql/graphql-js/issues/2203
          /* c8 ignore next */
          (n = e.arguments) === null || n === void 0 ? void 0 : n.map((o) => o.name.value)
        );
        for (const o of r.args)
          if (!i.has(o.name) && vl(o)) {
            const s = _e(o.type);
            t.reportError(
              new ye(
                `Field "${r.name}" argument "${o.name}" of type "${s}" is required, but it was not provided.`,
                {
                  nodes: e
                }
              )
            );
          }
      }
    }
  };
}
function P$(t) {
  var e;
  const n = /* @__PURE__ */ Object.create(null), r = t.getSchema(), i = (e = r?.getDirectives()) !== null && e !== void 0 ? e : bl;
  for (const a of i)
    n[a.name] = ma(
      a.args.filter(vl),
      (l) => l.name
    );
  const o = t.getDocument().definitions;
  for (const a of o)
    if (a.kind === z.DIRECTIVE_DEFINITION) {
      var s;
      const l = (s = a.arguments) !== null && s !== void 0 ? s : [];
      n[a.name.value] = ma(
        l.filter(kz),
        (u) => u.name.value
      );
    }
  return {
    Directive: {
      // Validate on leave to allow for deeper errors to appear first.
      leave(a) {
        const l = a.name.value, u = n[l];
        if (u) {
          var c;
          const f = (c = a.arguments) !== null && c !== void 0 ? c : [], d = new Set(f.map((h) => h.name.value));
          for (const [h, p] of Object.entries(u))
            if (!d.has(h)) {
              const g = Uh(p.type) ? _e(p.type) : An(p.type);
              t.reportError(
                new ye(
                  `Directive "@${l}" argument "${h}" of type "${g}" is required, but it was not provided.`,
                  {
                    nodes: a
                  }
                )
              );
            }
        }
      }
    }
  };
}
function kz(t) {
  return t.type.kind === z.NON_NULL_TYPE && t.defaultValue == null;
}
function $$(t) {
  return {
    Field(e) {
      const n = t.getType(), r = e.selectionSet;
      if (n)
        if (Rs(hi(n))) {
          if (r) {
            const i = e.name.value, o = _e(n);
            t.reportError(
              new ye(
                `Field "${i}" must not have a selection since type "${o}" has no subfields.`,
                {
                  nodes: r
                }
              )
            );
          }
        } else if (r) {
          if (r.selections.length === 0) {
            const i = e.name.value, o = _e(n);
            t.reportError(
              new ye(
                `Field "${i}" of type "${o}" must have at least one field selected.`,
                {
                  nodes: e
                }
              )
            );
          }
        } else {
          const i = e.name.value, o = _e(n);
          t.reportError(
            new ye(
              `Field "${i}" of type "${o}" must have a selection of subfields. Did you mean "${i} { ... }"?`,
              {
                nodes: e
              }
            )
          );
        }
    }
  };
}
function M$(t) {
  return t.map(
    (e) => typeof e == "number" ? "[" + e.toString() + "]" : "." + e
  ).join("");
}
function Hc(t, e, n) {
  return {
    prev: t,
    key: e,
    typename: n
  };
}
function ci(t) {
  const e = [];
  let n = t;
  for (; n; )
    e.push(n.key), n = n.prev;
  return e.reverse();
}
function F$(t, e, n = Tz) {
  return kd(t, e, n, void 0);
}
function Tz(t, e, n) {
  let r = "Invalid value " + _e(e);
  throw t.length > 0 && (r += ` at "value${M$(t)}"`), n.message = r + ": " + n.message, n;
}
function kd(t, e, n, r) {
  if (St(e)) {
    if (t != null)
      return kd(t, e.ofType, n, r);
    n(
      ci(r),
      t,
      new ye(
        `Expected non-nullable type "${_e(e)}" not to be null.`
      )
    );
    return;
  }
  if (t == null)
    return null;
  if (Mn(e)) {
    const i = e.ofType;
    return z_(t) ? Array.from(t, (o, s) => {
      const a = Hc(r, s, void 0);
      return kd(o, i, n, a);
    }) : [kd(t, i, n, r)];
  }
  if (Sn(e)) {
    if (!oo(t) || Array.isArray(t)) {
      n(
        ci(r),
        t,
        new ye(`Expected type "${e.name}" to be an object.`)
      );
      return;
    }
    const i = {}, o = e.getFields();
    for (const s of Object.values(o)) {
      const a = t[s.name];
      if (a === void 0) {
        if (s.defaultValue !== void 0)
          i[s.name] = s.defaultValue;
        else if (St(s.type)) {
          const l = _e(s.type);
          n(
            ci(r),
            t,
            new ye(
              `Field "${s.name}" of required type "${l}" was not provided.`
            )
          );
        }
        continue;
      }
      i[s.name] = kd(
        a,
        s.type,
        n,
        Hc(r, s.name, e.name)
      );
    }
    for (const s of Object.keys(t))
      if (!o[s]) {
        const a = yl(
          s,
          Object.keys(e.getFields())
        );
        n(
          ci(r),
          t,
          new ye(
            `Field "${s}" is not defined by type "${e.name}".` + ga(a)
          )
        );
      }
    if (e.isOneOf) {
      const s = Object.keys(i);
      s.length !== 1 && n(
        ci(r),
        t,
        new ye(
          `Exactly one key must be specified for OneOf type "${e.name}".`
        )
      );
      const a = s[0], l = i[a];
      l === null && n(
        ci(r).concat(a),
        l,
        new ye(`Field "${a}" must be non-null.`)
      );
    }
    return i;
  }
  if (Rs(e)) {
    let i;
    try {
      i = e.parseValue(t);
    } catch (o) {
      o instanceof ye ? n(ci(r), t, o) : n(
        ci(r),
        t,
        new ye(`Expected type "${e.name}". ` + o.message, {
          originalError: o
        })
      );
      return;
    }
    return i === void 0 && n(
      ci(r),
      t,
      new ye(`Expected type "${e.name}".`)
    ), i;
  }
  Zn(!1, "Unexpected input type: " + _e(e));
}
function bs(t, e, n) {
  if (t) {
    if (t.kind === z.VARIABLE) {
      const r = t.name.value;
      if (n == null || n[r] === void 0)
        return;
      const i = n[r];
      return i === null && St(e) ? void 0 : i;
    }
    if (St(e))
      return t.kind === z.NULL ? void 0 : bs(t, e.ofType, n);
    if (t.kind === z.NULL)
      return null;
    if (Mn(e)) {
      const r = e.ofType;
      if (t.kind === z.LIST) {
        const o = [];
        for (const s of t.values)
          if (MT(s, n)) {
            if (St(r))
              return;
            o.push(null);
          } else {
            const a = bs(s, r, n);
            if (a === void 0)
              return;
            o.push(a);
          }
        return o;
      }
      const i = bs(t, r, n);
      return i === void 0 ? void 0 : [i];
    }
    if (Sn(e)) {
      if (t.kind !== z.OBJECT)
        return;
      const r = /* @__PURE__ */ Object.create(null), i = ma(t.fields, (o) => o.name.value);
      for (const o of Object.values(e.getFields())) {
        const s = i[o.name];
        if (!s || MT(s.value, n)) {
          if (o.defaultValue !== void 0)
            r[o.name] = o.defaultValue;
          else if (St(o.type))
            return;
          continue;
        }
        const a = bs(s.value, o.type, n);
        if (a === void 0)
          return;
        r[o.name] = a;
      }
      if (e.isOneOf) {
        const o = Object.keys(r);
        if (o.length !== 1 || r[o[0]] === null)
          return;
      }
      return r;
    }
    if (Rs(e)) {
      let r;
      try {
        r = e.parseLiteral(t, n);
      } catch {
        return;
      }
      return r === void 0 ? void 0 : r;
    }
    Zn(!1, "Unexpected input type: " + _e(e));
  }
}
function MT(t, e) {
  return t.kind === z.VARIABLE && (e == null || e[t.name.value] === void 0);
}
function L$(t, e, n, r) {
  const i = [], o = r?.maxErrors;
  try {
    const s = xz(
      t,
      e,
      n,
      (a) => {
        if (o != null && i.length >= o)
          throw new ye(
            "Too many errors processing variables, error limit reached. Execution aborted."
          );
        i.push(a);
      }
    );
    if (i.length === 0)
      return {
        coerced: s
      };
  } catch (s) {
    i.push(s);
  }
  return {
    errors: i
  };
}
function xz(t, e, n, r) {
  const i = {};
  for (const o of e) {
    const s = o.variable.name.value, a = Pi(t, o.type);
    if (!Ci(a)) {
      const u = An(o.type);
      r(
        new ye(
          `Variable "$${s}" expected value of type "${u}" which cannot be used as an input type.`,
          {
            nodes: o.type
          }
        )
      );
      continue;
    }
    if (!B$(n, s)) {
      if (o.defaultValue)
        i[s] = bs(o.defaultValue, a);
      else if (St(a)) {
        const u = _e(a);
        r(
          new ye(
            `Variable "$${s}" of required type "${u}" was not provided.`,
            {
              nodes: o
            }
          )
        );
      }
      continue;
    }
    const l = n[s];
    if (l === null && St(a)) {
      const u = _e(a);
      r(
        new ye(
          `Variable "$${s}" of non-null type "${u}" must not be null.`,
          {
            nodes: o
          }
        )
      );
      continue;
    }
    i[s] = F$(
      l,
      a,
      (u, c, f) => {
        let d = `Variable "$${s}" got invalid value ` + _e(c);
        u.length > 0 && (d += ` at "${s}${M$(u)}"`), r(
          new ye(d + "; " + f.message, {
            nodes: o,
            originalError: f
          })
        );
      }
    );
  }
  return i;
}
function n0(t, e, n) {
  var r;
  const i = {}, o = (r = e.arguments) !== null && r !== void 0 ? r : [], s = ma(o, (a) => a.name.value);
  for (const a of t.args) {
    const l = a.name, u = a.type, c = s[l];
    if (!c) {
      if (a.defaultValue !== void 0)
        i[l] = a.defaultValue;
      else if (St(u))
        throw new ye(
          `Argument "${l}" of required type "${_e(u)}" was not provided.`,
          {
            nodes: e
          }
        );
      continue;
    }
    const f = c.value;
    let d = f.kind === z.NULL;
    if (f.kind === z.VARIABLE) {
      const p = f.name.value;
      if (n == null || !B$(n, p)) {
        if (a.defaultValue !== void 0)
          i[l] = a.defaultValue;
        else if (St(u))
          throw new ye(
            `Argument "${l}" of required type "${_e(u)}" was provided the variable "$${p}" which was not provided a runtime value.`,
            {
              nodes: f
            }
          );
        continue;
      }
      d = n[p] == null;
    }
    if (d && St(u))
      throw new ye(
        `Argument "${l}" of non-null type "${_e(u)}" must not be null.`,
        {
          nodes: f
        }
      );
    const h = bs(f, u, n);
    if (h === void 0)
      throw new ye(
        `Argument "${l}" has invalid value ${An(f)}.`,
        {
          nodes: f
        }
      );
    i[l] = h;
  }
  return i;
}
function Gc(t, e, n) {
  var r;
  const i = (r = e.directives) === null || r === void 0 ? void 0 : r.find(
    (o) => o.name.value === t.name
  );
  if (i)
    return n0(t, i, n);
}
function B$(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function lE(t, e, n, r, i) {
  const o = /* @__PURE__ */ new Map();
  return zm(
    t,
    e,
    n,
    r,
    i,
    o,
    /* @__PURE__ */ new Set()
  ), o;
}
function Cz(t, e, n, r, i) {
  const o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set();
  for (const a of i)
    a.selectionSet && zm(
      t,
      e,
      n,
      r,
      a.selectionSet,
      o,
      s
    );
  return o;
}
function zm(t, e, n, r, i, o, s) {
  for (const a of i.selections)
    switch (a.kind) {
      case z.FIELD: {
        if (!ov(n, a))
          continue;
        const l = Az(a), u = o.get(l);
        u !== void 0 ? u.push(a) : o.set(l, [a]);
        break;
      }
      case z.INLINE_FRAGMENT: {
        if (!ov(n, a) || !FT(t, a, r))
          continue;
        zm(
          t,
          e,
          n,
          r,
          a.selectionSet,
          o,
          s
        );
        break;
      }
      case z.FRAGMENT_SPREAD: {
        const l = a.name.value;
        if (s.has(l) || !ov(n, a))
          continue;
        s.add(l);
        const u = e[l];
        if (!u || !FT(t, u, r))
          continue;
        zm(
          t,
          e,
          n,
          r,
          u.selectionSet,
          o,
          s
        );
        break;
      }
    }
}
function ov(t, e) {
  const n = Gc(B_, e, t);
  if (n?.if === !0)
    return !1;
  const r = Gc(
    L_,
    e,
    t
  );
  return r?.if !== !1;
}
function FT(t, e, n) {
  const r = e.typeCondition;
  if (!r)
    return !0;
  const i = Pi(t, r);
  return i === n ? !0 : Ts(i) ? t.isSubType(i, n) : !1;
}
function Az(t) {
  return t.alias ? t.alias.value : t.name.value;
}
function j$(t) {
  return {
    OperationDefinition(e) {
      if (e.operation === "subscription") {
        const n = t.getSchema(), r = n.getSubscriptionType();
        if (r) {
          const i = e.name ? e.name.value : null, o = /* @__PURE__ */ Object.create(null), s = t.getDocument(), a = /* @__PURE__ */ Object.create(null);
          for (const u of s.definitions)
            u.kind === z.FRAGMENT_DEFINITION && (a[u.name.value] = u);
          const l = lE(
            n,
            a,
            o,
            r,
            e.selectionSet
          );
          if (l.size > 1) {
            const f = [...l.values()].slice(1).flat();
            t.reportError(
              new ye(
                i != null ? `Subscription "${i}" must select only one top level field.` : "Anonymous Subscription must select only one top level field.",
                {
                  nodes: f
                }
              )
            );
          }
          for (const u of l.values())
            u[0].name.value.startsWith("__") && t.reportError(
              new ye(
                i != null ? `Subscription "${i}" must not select an introspection top level field.` : "Anonymous Subscription must not select an introspection top level field.",
                {
                  nodes: u
                }
              )
            );
        }
      }
    }
  };
}
function uE(t, e) {
  const n = /* @__PURE__ */ new Map();
  for (const r of t) {
    const i = e(r), o = n.get(i);
    o === void 0 ? n.set(i, [r]) : o.push(r);
  }
  return n;
}
function V$(t) {
  return {
    DirectiveDefinition(r) {
      var i;
      const o = (i = r.arguments) !== null && i !== void 0 ? i : [];
      return n(`@${r.name.value}`, o);
    },
    InterfaceTypeDefinition: e,
    InterfaceTypeExtension: e,
    ObjectTypeDefinition: e,
    ObjectTypeExtension: e
  };
  function e(r) {
    var i;
    const o = r.name.value, s = (i = r.fields) !== null && i !== void 0 ? i : [];
    for (const l of s) {
      var a;
      const u = l.name.value, c = (a = l.arguments) !== null && a !== void 0 ? a : [];
      n(`${o}.${u}`, c);
    }
    return !1;
  }
  function n(r, i) {
    const o = uE(i, (s) => s.name.value);
    for (const [s, a] of o)
      a.length > 1 && t.reportError(
        new ye(
          `Argument "${r}(${s}:)" can only be defined once.`,
          {
            nodes: a.map((l) => l.name)
          }
        )
      );
    return !1;
  }
}
function cE(t) {
  return {
    Field: e,
    Directive: e
  };
  function e(n) {
    var r;
    const i = (r = n.arguments) !== null && r !== void 0 ? r : [], o = uE(i, (s) => s.name.value);
    for (const [s, a] of o)
      a.length > 1 && t.reportError(
        new ye(
          `There can be only one argument named "${s}".`,
          {
            nodes: a.map((l) => l.name)
          }
        )
      );
  }
}
function U$(t) {
  const e = /* @__PURE__ */ Object.create(null), n = t.getSchema();
  return {
    DirectiveDefinition(r) {
      const i = r.name.value;
      if (n != null && n.getDirective(i)) {
        t.reportError(
          new ye(
            `Directive "@${i}" already exists in the schema. It cannot be redefined.`,
            {
              nodes: r.name
            }
          )
        );
        return;
      }
      return e[i] ? t.reportError(
        new ye(
          `There can be only one directive named "@${i}".`,
          {
            nodes: [e[i], r.name]
          }
        )
      ) : e[i] = r.name, !1;
    }
  };
}
function fE(t) {
  const e = /* @__PURE__ */ Object.create(null), n = t.getSchema(), r = n ? n.getDirectives() : bl;
  for (const a of r)
    e[a.name] = !a.isRepeatable;
  const i = t.getDocument().definitions;
  for (const a of i)
    a.kind === z.DIRECTIVE_DEFINITION && (e[a.name.value] = !a.repeatable);
  const o = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  return {
    // Many different AST nodes may contain directives. Rather than listing
    // them all, just listen for entering any node, and check to see if it
    // defines any directives.
    enter(a) {
      if (!("directives" in a) || !a.directives)
        return;
      let l;
      if (a.kind === z.SCHEMA_DEFINITION || a.kind === z.SCHEMA_EXTENSION)
        l = o;
      else if (vf(a) || e0(a)) {
        const u = a.name.value;
        l = s[u], l === void 0 && (s[u] = l = /* @__PURE__ */ Object.create(null));
      } else
        l = /* @__PURE__ */ Object.create(null);
      for (const u of a.directives) {
        const c = u.name.value;
        e[c] && (l[c] ? t.reportError(
          new ye(
            `The directive "@${c}" can only be used once at this location.`,
            {
              nodes: [l[c], u]
            }
          )
        ) : l[c] = u);
      }
    }
  };
}
function q$(t) {
  const e = t.getSchema(), n = e ? e.getTypeMap() : /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  return {
    EnumTypeDefinition: i,
    EnumTypeExtension: i
  };
  function i(o) {
    var s;
    const a = o.name.value;
    r[a] || (r[a] = /* @__PURE__ */ Object.create(null));
    const l = (s = o.values) !== null && s !== void 0 ? s : [], u = r[a];
    for (const c of l) {
      const f = c.name.value, d = n[a];
      hr(d) && d.getValue(f) ? t.reportError(
        new ye(
          `Enum value "${a}.${f}" already exists in the schema. It cannot also be defined in this type extension.`,
          {
            nodes: c.name
          }
        )
      ) : u[f] ? t.reportError(
        new ye(
          `Enum value "${a}.${f}" can only be defined once.`,
          {
            nodes: [u[f], c.name]
          }
        )
      ) : u[f] = c.name;
    }
    return !1;
  }
}
function z$(t) {
  const e = t.getSchema(), n = e ? e.getTypeMap() : /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  return {
    InputObjectTypeDefinition: i,
    InputObjectTypeExtension: i,
    InterfaceTypeDefinition: i,
    InterfaceTypeExtension: i,
    ObjectTypeDefinition: i,
    ObjectTypeExtension: i
  };
  function i(o) {
    var s;
    const a = o.name.value;
    r[a] || (r[a] = /* @__PURE__ */ Object.create(null));
    const l = (s = o.fields) !== null && s !== void 0 ? s : [], u = r[a];
    for (const c of l) {
      const f = c.name.value;
      Rz(n[a], f) ? t.reportError(
        new ye(
          `Field "${a}.${f}" already exists in the schema. It cannot also be defined in this type extension.`,
          {
            nodes: c.name
          }
        )
      ) : u[f] ? t.reportError(
        new ye(
          `Field "${a}.${f}" can only be defined once.`,
          {
            nodes: [u[f], c.name]
          }
        )
      ) : u[f] = c.name;
    }
    return !1;
  }
}
function Rz(t, e) {
  return Yt(t) || an(t) || Sn(t) ? t.getFields()[e] != null : !1;
}
function H$(t) {
  const e = /* @__PURE__ */ Object.create(null);
  return {
    OperationDefinition: () => !1,
    FragmentDefinition(n) {
      const r = n.name.value;
      return e[r] ? t.reportError(
        new ye(
          `There can be only one fragment named "${r}".`,
          {
            nodes: [e[r], n.name]
          }
        )
      ) : e[r] = n.name, !1;
    }
  };
}
function dE(t) {
  const e = [];
  let n = /* @__PURE__ */ Object.create(null);
  return {
    ObjectValue: {
      enter() {
        e.push(n), n = /* @__PURE__ */ Object.create(null);
      },
      leave() {
        const r = e.pop();
        r || Zn(!1), n = r;
      }
    },
    ObjectField(r) {
      const i = r.name.value;
      n[i] ? t.reportError(
        new ye(
          `There can be only one input field named "${i}".`,
          {
            nodes: [n[i], r.name]
          }
        )
      ) : n[i] = r.name;
    }
  };
}
function G$(t) {
  const e = /* @__PURE__ */ Object.create(null);
  return {
    OperationDefinition(n) {
      const r = n.name;
      return r && (e[r.value] ? t.reportError(
        new ye(
          `There can be only one operation named "${r.value}".`,
          {
            nodes: [
              e[r.value],
              r
            ]
          }
        )
      ) : e[r.value] = r), !1;
    },
    FragmentDefinition: () => !1
  };
}
function W$(t) {
  const e = t.getSchema(), n = /* @__PURE__ */ Object.create(null), r = e ? {
    query: e.getQueryType(),
    mutation: e.getMutationType(),
    subscription: e.getSubscriptionType()
  } : {};
  return {
    SchemaDefinition: i,
    SchemaExtension: i
  };
  function i(o) {
    var s;
    const a = (s = o.operationTypes) !== null && s !== void 0 ? s : [];
    for (const l of a) {
      const u = l.operation, c = n[u];
      r[u] ? t.reportError(
        new ye(
          `Type for ${u} already defined in the schema. It cannot be redefined.`,
          {
            nodes: l
          }
        )
      ) : c ? t.reportError(
        new ye(
          `There can be only one ${u} type in schema.`,
          {
            nodes: [c, l]
          }
        )
      ) : n[u] = l;
    }
    return !1;
  }
}
function Y$(t) {
  const e = /* @__PURE__ */ Object.create(null), n = t.getSchema();
  return {
    ScalarTypeDefinition: r,
    ObjectTypeDefinition: r,
    InterfaceTypeDefinition: r,
    UnionTypeDefinition: r,
    EnumTypeDefinition: r,
    InputObjectTypeDefinition: r
  };
  function r(i) {
    const o = i.name.value;
    if (n != null && n.getType(o)) {
      t.reportError(
        new ye(
          `Type "${o}" already exists in the schema. It cannot also be defined in this type definition.`,
          {
            nodes: i.name
          }
        )
      );
      return;
    }
    return e[o] ? t.reportError(
      new ye(`There can be only one type named "${o}".`, {
        nodes: [e[o], i.name]
      })
    ) : e[o] = i.name, !1;
  }
}
function X$(t) {
  return {
    OperationDefinition(e) {
      var n;
      const r = (n = e.variableDefinitions) !== null && n !== void 0 ? n : [], i = uE(
        r,
        (o) => o.variable.name.value
      );
      for (const [o, s] of i)
        s.length > 1 && t.reportError(
          new ye(
            `There can be only one variable named "$${o}".`,
            {
              nodes: s.map((a) => a.variable.name)
            }
          )
        );
    }
  };
}
function K$(t) {
  let e = {};
  return {
    OperationDefinition: {
      enter() {
        e = {};
      }
    },
    VariableDefinition(n) {
      e[n.variable.name.value] = n;
    },
    ListValue(n) {
      const r = P_(t.getParentInputType());
      if (!Mn(r))
        return Rl(t, n), !1;
    },
    ObjectValue(n) {
      const r = hi(t.getInputType());
      if (!Sn(r))
        return Rl(t, n), !1;
      const i = ma(n.fields, (o) => o.name.value);
      for (const o of Object.values(r.getFields()))
        if (!i[o.name] && Xy(o)) {
          const a = _e(o.type);
          t.reportError(
            new ye(
              `Field "${r.name}.${o.name}" of required type "${a}" was not provided.`,
              {
                nodes: n
              }
            )
          );
        }
      r.isOneOf && Oz(
        t,
        n,
        r,
        i,
        e
      );
    },
    ObjectField(n) {
      const r = hi(t.getParentInputType());
      if (!t.getInputType() && Sn(r)) {
        const o = yl(
          n.name.value,
          Object.keys(r.getFields())
        );
        t.reportError(
          new ye(
            `Field "${n.name.value}" is not defined by type "${r.name}".` + ga(o),
            {
              nodes: n
            }
          )
        );
      }
    },
    NullValue(n) {
      const r = t.getInputType();
      St(r) && t.reportError(
        new ye(
          `Expected value of type "${_e(r)}", found ${An(n)}.`,
          {
            nodes: n
          }
        )
      );
    },
    EnumValue: (n) => Rl(t, n),
    IntValue: (n) => Rl(t, n),
    FloatValue: (n) => Rl(t, n),
    StringValue: (n) => Rl(t, n),
    BooleanValue: (n) => Rl(t, n)
  };
}
function Rl(t, e) {
  const n = t.getInputType();
  if (!n)
    return;
  const r = hi(n);
  if (!Rs(r)) {
    const i = _e(n);
    t.reportError(
      new ye(
        `Expected value of type "${i}", found ${An(e)}.`,
        {
          nodes: e
        }
      )
    );
    return;
  }
  try {
    if (r.parseLiteral(
      e,
      void 0
      /* variables */
    ) === void 0) {
      const o = _e(n);
      t.reportError(
        new ye(
          `Expected value of type "${o}", found ${An(e)}.`,
          {
            nodes: e
          }
        )
      );
    }
  } catch (i) {
    const o = _e(n);
    i instanceof ye ? t.reportError(i) : t.reportError(
      new ye(
        `Expected value of type "${o}", found ${An(e)}; ` + i.message,
        {
          nodes: e,
          originalError: i
        }
      )
    );
  }
}
function Oz(t, e, n, r, i) {
  var o;
  const s = Object.keys(r);
  if (s.length !== 1) {
    t.reportError(
      new ye(
        `OneOf Input Object "${n.name}" must specify exactly one key.`,
        {
          nodes: [e]
        }
      )
    );
    return;
  }
  const l = (o = r[s[0]]) === null || o === void 0 ? void 0 : o.value, u = !l || l.kind === z.NULL, c = l?.kind === z.VARIABLE;
  if (u) {
    t.reportError(
      new ye(`Field "${n.name}.${s[0]}" must be non-null.`, {
        nodes: [e]
      })
    );
    return;
  }
  if (c) {
    const f = l.name.value;
    i[f].type.kind !== z.NON_NULL_TYPE && t.reportError(
      new ye(
        `Variable "${f}" must be non-nullable to be used for OneOf Input Object "${n.name}".`,
        {
          nodes: [e]
        }
      )
    );
  }
}
function Q$(t) {
  return {
    VariableDefinition(e) {
      const n = Pi(t.getSchema(), e.type);
      if (n !== void 0 && !Ci(n)) {
        const r = e.variable.name.value, i = An(e.type);
        t.reportError(
          new ye(
            `Variable "$${r}" cannot be non-input type "${i}".`,
            {
              nodes: e.type
            }
          )
        );
      }
    }
  };
}
function J$(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return {
    OperationDefinition: {
      enter() {
        e = /* @__PURE__ */ Object.create(null);
      },
      leave(n) {
        const r = t.getRecursiveVariableUsages(n);
        for (const { node: i, type: o, defaultValue: s, parentType: a } of r) {
          const l = i.name.value, u = e[l];
          if (u && o) {
            const c = t.getSchema(), f = Pi(c, u.type);
            if (f && !Dz(
              c,
              f,
              u.defaultValue,
              o,
              s
            )) {
              const d = _e(f), h = _e(o);
              t.reportError(
                new ye(
                  `Variable "$${l}" of type "${d}" used in position expecting type "${h}".`,
                  {
                    nodes: [u, i]
                  }
                )
              );
            }
            Sn(a) && a.isOneOf && Yy(f) && t.reportError(
              new ye(
                `Variable "$${l}" is of type "${f}" but must be non-nullable to be used for OneOf Input Object "${a}".`,
                {
                  nodes: [u, i]
                }
              )
            );
          }
        }
      }
    },
    VariableDefinition(n) {
      e[n.variable.name.value] = n;
    }
  };
}
function Dz(t, e, n, r, i) {
  if (St(r) && !St(e)) {
    if (!(n != null && n.kind !== z.NULL) && !(i !== void 0))
      return !1;
    const a = r.ofType;
    return cu(t, e, a);
  }
  return cu(t, e, r);
}
const Z$ = Object.freeze([S$]), eM = Object.freeze([
  h$,
  G$,
  b$,
  j$,
  sE,
  g$,
  Q$,
  $$,
  p$,
  H$,
  v$,
  k$,
  D$,
  _$,
  X$,
  E$,
  T$,
  oE,
  fE,
  m$,
  cE,
  K$,
  N$,
  J$,
  C$,
  dE,
  ...Z$
]), Iz = Object.freeze([
  w$,
  W$,
  Y$,
  q$,
  z$,
  V$,
  U$,
  sE,
  oE,
  fE,
  I$,
  y$,
  cE,
  dE,
  P$
]);
class tM {
  constructor(e, n) {
    this._ast = e, this._fragments = void 0, this._fragmentSpreads = /* @__PURE__ */ new Map(), this._recursivelyReferencedFragments = /* @__PURE__ */ new Map(), this._onError = n;
  }
  get [Symbol.toStringTag]() {
    return "ASTValidationContext";
  }
  reportError(e) {
    this._onError(e);
  }
  getDocument() {
    return this._ast;
  }
  getFragment(e) {
    let n;
    if (this._fragments)
      n = this._fragments;
    else {
      n = /* @__PURE__ */ Object.create(null);
      for (const r of this.getDocument().definitions)
        r.kind === z.FRAGMENT_DEFINITION && (n[r.name.value] = r);
      this._fragments = n;
    }
    return n[e];
  }
  getFragmentSpreads(e) {
    let n = this._fragmentSpreads.get(e);
    if (!n) {
      n = [];
      const r = [e];
      let i;
      for (; i = r.pop(); )
        for (const o of i.selections)
          o.kind === z.FRAGMENT_SPREAD ? n.push(o) : o.selectionSet && r.push(o.selectionSet);
      this._fragmentSpreads.set(e, n);
    }
    return n;
  }
  getRecursivelyReferencedFragments(e) {
    let n = this._recursivelyReferencedFragments.get(e);
    if (!n) {
      n = [];
      const r = /* @__PURE__ */ Object.create(null), i = [e.selectionSet];
      let o;
      for (; o = i.pop(); )
        for (const s of this.getFragmentSpreads(o)) {
          const a = s.name.value;
          if (r[a] !== !0) {
            r[a] = !0;
            const l = this.getFragment(a);
            l && (n.push(l), i.push(l.selectionSet));
          }
        }
      this._recursivelyReferencedFragments.set(e, n);
    }
    return n;
  }
}
class Nz extends tM {
  constructor(e, n, r) {
    super(e, r), this._schema = n;
  }
  get [Symbol.toStringTag]() {
    return "SDLValidationContext";
  }
  getSchema() {
    return this._schema;
  }
}
class nM extends tM {
  constructor(e, n, r, i) {
    super(n, i), this._schema = e, this._typeInfo = r, this._variableUsages = /* @__PURE__ */ new Map(), this._recursiveVariableUsages = /* @__PURE__ */ new Map();
  }
  get [Symbol.toStringTag]() {
    return "ValidationContext";
  }
  getSchema() {
    return this._schema;
  }
  getVariableUsages(e) {
    let n = this._variableUsages.get(e);
    if (!n) {
      const r = [], i = new eE(this._schema);
      mf(
        e,
        tE(i, {
          VariableDefinition: () => !1,
          Variable(o) {
            r.push({
              node: o,
              type: i.getInputType(),
              defaultValue: i.getDefaultValue(),
              parentType: i.getParentInputType()
            });
          }
        })
      ), n = r, this._variableUsages.set(e, n);
    }
    return n;
  }
  getRecursiveVariableUsages(e) {
    let n = this._recursiveVariableUsages.get(e);
    if (!n) {
      n = this.getVariableUsages(e);
      for (const r of this.getRecursivelyReferencedFragments(e))
        n = n.concat(this.getVariableUsages(r));
      this._recursiveVariableUsages.set(e, n);
    }
    return n;
  }
  getType() {
    return this._typeInfo.getType();
  }
  getParentType() {
    return this._typeInfo.getParentType();
  }
  getInputType() {
    return this._typeInfo.getInputType();
  }
  getParentInputType() {
    return this._typeInfo.getParentInputType();
  }
  getFieldDef() {
    return this._typeInfo.getFieldDef();
  }
  getDirective() {
    return this._typeInfo.getDirective();
  }
  getArgument() {
    return this._typeInfo.getArgument();
  }
  getEnumValue() {
    return this._typeInfo.getEnumValue();
  }
}
function rM(t, e, n = eM, r, i = new eE(t)) {
  var o;
  const s = (o = r?.maxErrors) !== null && o !== void 0 ? o : 100;
  e || Nt(!1, "Must provide document."), J_(t);
  const a = Object.freeze({}), l = [], u = new nM(
    t,
    e,
    i,
    (f) => {
      if (l.length >= s)
        throw l.push(
          new ye(
            "Too many validation errors, error limit reached. Validation aborted."
          )
        ), a;
      l.push(f);
    }
  ), c = N_(n.map((f) => f(u)));
  try {
    mf(e, tE(i, c));
  } catch (f) {
    if (f !== a)
      throw f;
  }
  return l;
}
function iM(t, e, n = Iz) {
  const r = [], i = new Nz(
    t,
    e,
    (s) => {
      r.push(s);
    }
  ), o = n.map((s) => s(i));
  return mf(t, N_(o)), r;
}
function Pz(t) {
  const e = iM(t);
  if (e.length !== 0)
    throw new Error(e.map((n) => n.message).join(`

`));
}
function $z(t, e) {
  const n = iM(t, e);
  if (n.length !== 0)
    throw new Error(n.map((r) => r.message).join(`

`));
}
function Mz(t) {
  let e;
  return function(r, i, o) {
    e === void 0 && (e = /* @__PURE__ */ new WeakMap());
    let s = e.get(r);
    s === void 0 && (s = /* @__PURE__ */ new WeakMap(), e.set(r, s));
    let a = s.get(i);
    a === void 0 && (a = /* @__PURE__ */ new WeakMap(), s.set(i, a));
    let l = a.get(o);
    return l === void 0 && (l = t(r, i, o), a.set(o, l)), l;
  };
}
function LT(t) {
  return Promise.all(Object.values(t)).then((e) => {
    const n = /* @__PURE__ */ Object.create(null);
    for (const [r, i] of Object.keys(t).entries())
      n[i] = e[r];
    return n;
  });
}
function Fz(t, e, n) {
  let r = n;
  for (const i of t)
    r = io(r) ? r.then((o) => e(o, i)) : e(r, i);
  return r;
}
function Lz(t) {
  return t instanceof Error ? t : new Bz(t);
}
class Bz extends Error {
  constructor(e) {
    super("Unexpected error value: " + _e(e)), this.name = "NonErrorThrown", this.thrownValue = e;
  }
}
function Wc(t, e, n) {
  var r;
  const i = Lz(t);
  return jz(i) ? i : new ye(i.message, {
    nodes: (r = i.nodes) !== null && r !== void 0 ? r : e,
    source: i.source,
    positions: i.positions,
    path: n,
    originalError: i
  });
}
function jz(t) {
  return Array.isArray(t.path);
}
const Vz = Mz(
  (t, e, n) => Cz(
    t.schema,
    t.fragments,
    t.variableValues,
    e,
    n
  )
);
function r0(t) {
  arguments.length < 2 || Nt(
    !1,
    "graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead."
  );
  const { schema: e, document: n, variableValues: r, rootValue: i } = t;
  sM(e, n, r);
  const o = aM(t);
  if (!("schema" in o))
    return {
      errors: o
    };
  try {
    const { operation: s } = o, a = Uz(o, s, i);
    return io(a) ? a.then(
      (l) => jp(l, o.errors),
      (l) => (o.errors.push(l), jp(null, o.errors))
    ) : jp(a, o.errors);
  } catch (s) {
    return o.errors.push(s), jp(null, o.errors);
  }
}
function oM(t) {
  const e = r0(t);
  if (io(e))
    throw new Error("GraphQL execution failed to complete synchronously.");
  return e;
}
function jp(t, e) {
  return e.length === 0 ? {
    data: t
  } : {
    errors: e,
    data: t
  };
}
function sM(t, e, n) {
  e || Nt(!1, "Must provide document."), J_(t), n == null || oo(n) || Nt(
    !1,
    "Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided."
  );
}
function aM(t) {
  var e, n, r;
  const {
    schema: i,
    document: o,
    rootValue: s,
    contextValue: a,
    variableValues: l,
    operationName: u,
    fieldResolver: c,
    typeResolver: f,
    subscribeFieldResolver: d,
    options: h
  } = t;
  let p;
  const g = /* @__PURE__ */ Object.create(null);
  for (const S of o.definitions)
    switch (S.kind) {
      case z.OPERATION_DEFINITION:
        if (u == null) {
          if (p !== void 0)
            return [
              new ye(
                "Must provide operation name if query contains multiple operations."
              )
            ];
          p = S;
        } else ((e = S.name) === null || e === void 0 ? void 0 : e.value) === u && (p = S);
        break;
      case z.FRAGMENT_DEFINITION:
        g[S.name.value] = S;
        break;
    }
  if (!p)
    return u != null ? [new ye(`Unknown operation named "${u}".`)] : [new ye("Must provide an operation.")];
  const m = (n = p.variableDefinitions) !== null && n !== void 0 ? n : [], v = L$(
    i,
    m,
    l ?? {},
    {
      maxErrors: (r = h?.maxCoercionErrors) !== null && r !== void 0 ? r : 50
    }
  );
  return v.errors ? v.errors : {
    schema: i,
    fragments: g,
    rootValue: s,
    contextValue: a,
    operation: p,
    variableValues: v.coerced,
    fieldResolver: c ?? Sw,
    typeResolver: f ?? cM,
    subscribeFieldResolver: d ?? Sw,
    errors: []
  };
}
function Uz(t, e, n) {
  const r = t.schema.getRootType(e.operation);
  if (r == null)
    throw new ye(
      `Schema is not configured to execute ${e.operation} operation.`,
      {
        nodes: e
      }
    );
  const i = lE(
    t.schema,
    t.fragments,
    t.variableValues,
    r,
    e.selectionSet
  ), o = void 0;
  switch (e.operation) {
    case Sr.QUERY:
      return Hm(t, r, n, o, i);
    case Sr.MUTATION:
      return qz(
        t,
        r,
        n,
        o,
        i
      );
    case Sr.SUBSCRIPTION:
      return Hm(t, r, n, o, i);
  }
}
function qz(t, e, n, r, i) {
  return Fz(
    i.entries(),
    (o, [s, a]) => {
      const l = Hc(r, s, e.name), u = lM(
        t,
        e,
        n,
        a,
        l
      );
      return u === void 0 ? o : io(u) ? u.then((c) => (o[s] = c, o)) : (o[s] = u, o);
    },
    /* @__PURE__ */ Object.create(null)
  );
}
function Hm(t, e, n, r, i) {
  const o = /* @__PURE__ */ Object.create(null);
  let s = !1;
  try {
    for (const [a, l] of i.entries()) {
      const u = Hc(r, a, e.name), c = lM(
        t,
        e,
        n,
        l,
        u
      );
      c !== void 0 && (o[a] = c, io(c) && (s = !0));
    }
  } catch (a) {
    if (s)
      return LT(o).finally(() => {
        throw a;
      });
    throw a;
  }
  return s ? LT(o) : o;
}
function lM(t, e, n, r, i) {
  var o;
  const s = fM(t.schema, e, r[0]);
  if (!s)
    return;
  const a = s.type, l = (o = s.resolve) !== null && o !== void 0 ? o : t.fieldResolver, u = uM(
    t,
    s,
    r,
    e,
    i
  );
  try {
    const c = n0(
      s,
      r[0],
      t.variableValues
    ), f = t.contextValue, d = l(n, c, f, u);
    let h;
    return io(d) ? h = d.then(
      (p) => dh(t, a, r, u, i, p)
    ) : h = dh(
      t,
      a,
      r,
      u,
      i,
      d
    ), io(h) ? h.then(void 0, (p) => {
      const g = Wc(p, r, ci(i));
      return Gm(g, a, t);
    }) : h;
  } catch (c) {
    const f = Wc(c, r, ci(i));
    return Gm(f, a, t);
  }
}
function uM(t, e, n, r, i) {
  return {
    fieldName: e.name,
    fieldNodes: n,
    returnType: e.type,
    parentType: r,
    path: i,
    schema: t.schema,
    fragments: t.fragments,
    rootValue: t.rootValue,
    operation: t.operation,
    variableValues: t.variableValues
  };
}
function Gm(t, e, n) {
  if (St(e))
    throw t;
  return n.errors.push(t), null;
}
function dh(t, e, n, r, i, o) {
  if (o instanceof Error)
    throw o;
  if (St(e)) {
    const s = dh(
      t,
      e.ofType,
      n,
      r,
      i,
      o
    );
    if (s === null)
      throw new Error(
        `Cannot return null for non-nullable field ${r.parentType.name}.${r.fieldName}.`
      );
    return s;
  }
  if (o == null)
    return null;
  if (Mn(e))
    return zz(
      t,
      e,
      n,
      r,
      i,
      o
    );
  if (Rs(e))
    return Hz(e, o);
  if (Ts(e))
    return Gz(
      t,
      e,
      n,
      r,
      i,
      o
    );
  if (Yt(e))
    return ww(
      t,
      e,
      n,
      r,
      i,
      o
    );
  Zn(
    !1,
    "Cannot complete value of unexpected output type: " + _e(e)
  );
}
function zz(t, e, n, r, i, o) {
  if (!z_(o))
    throw new ye(
      `Expected Iterable, but did not find one for field "${r.parentType.name}.${r.fieldName}".`
    );
  const s = e.ofType;
  let a = !1;
  const l = Array.from(o, (u, c) => {
    const f = Hc(i, c, void 0);
    try {
      let d;
      return io(u) ? d = u.then(
        (h) => dh(
          t,
          s,
          n,
          r,
          f,
          h
        )
      ) : d = dh(
        t,
        s,
        n,
        r,
        f,
        u
      ), io(d) ? (a = !0, d.then(void 0, (h) => {
        const p = Wc(
          h,
          n,
          ci(f)
        );
        return Gm(p, s, t);
      })) : d;
    } catch (d) {
      const h = Wc(d, n, ci(f));
      return Gm(h, s, t);
    }
  });
  return a ? Promise.all(l) : l;
}
function Hz(t, e) {
  const n = t.serialize(e);
  if (n == null)
    throw new Error(
      `Expected \`${_e(t)}.serialize(${_e(e)})\` to return non-nullable value, returned: ${_e(n)}`
    );
  return n;
}
function Gz(t, e, n, r, i, o) {
  var s;
  const a = (s = e.resolveType) !== null && s !== void 0 ? s : t.typeResolver, l = t.contextValue, u = a(o, l, r, e);
  return io(u) ? u.then(
    (c) => ww(
      t,
      BT(
        c,
        t,
        e,
        n,
        r,
        o
      ),
      n,
      r,
      i,
      o
    )
  ) : ww(
    t,
    BT(
      u,
      t,
      e,
      n,
      r,
      o
    ),
    n,
    r,
    i,
    o
  );
}
function BT(t, e, n, r, i, o) {
  if (t == null)
    throw new ye(
      `Abstract type "${n.name}" must resolve to an Object type at runtime for field "${i.parentType.name}.${i.fieldName}". Either the "${n.name}" type should provide a "resolveType" function or each possible type should provide an "isTypeOf" function.`,
      r
    );
  if (Yt(t))
    throw new ye(
      "Support for returning GraphQLObjectType from resolveType was removed in graphql-js@16.0.0 please return type name instead."
    );
  if (typeof t != "string")
    throw new ye(
      `Abstract type "${n.name}" must resolve to an Object type at runtime for field "${i.parentType.name}.${i.fieldName}" with value ${_e(o)}, received "${_e(t)}".`
    );
  const s = e.schema.getType(t);
  if (s == null)
    throw new ye(
      `Abstract type "${n.name}" was resolved to a type "${t}" that does not exist inside the schema.`,
      {
        nodes: r
      }
    );
  if (!Yt(s))
    throw new ye(
      `Abstract type "${n.name}" was resolved to a non-object type "${t}".`,
      {
        nodes: r
      }
    );
  if (!e.schema.isSubType(n, s))
    throw new ye(
      `Runtime Object type "${s.name}" is not a possible type for "${n.name}".`,
      {
        nodes: r
      }
    );
  return s;
}
function ww(t, e, n, r, i, o) {
  const s = Vz(t, e, n);
  if (e.isTypeOf) {
    const a = e.isTypeOf(o, t.contextValue, r);
    if (io(a))
      return a.then((l) => {
        if (!l)
          throw jT(e, o, n);
        return Hm(
          t,
          e,
          o,
          i,
          s
        );
      });
    if (!a)
      throw jT(e, o, n);
  }
  return Hm(t, e, o, i, s);
}
function jT(t, e, n) {
  return new ye(
    `Expected value of type "${t.name}" but got: ${_e(e)}.`,
    {
      nodes: n
    }
  );
}
const cM = function(t, e, n, r) {
  if (oo(t) && typeof t.__typename == "string")
    return t.__typename;
  const i = n.schema.getPossibleTypes(r), o = [];
  for (let s = 0; s < i.length; s++) {
    const a = i[s];
    if (a.isTypeOf) {
      const l = a.isTypeOf(t, e, n);
      if (io(l))
        o[s] = l;
      else if (l)
        return a.name;
    }
  }
  if (o.length)
    return Promise.all(o).then((s) => {
      for (let a = 0; a < s.length; a++)
        if (s[a])
          return i[a].name;
    });
}, Sw = function(t, e, n, r) {
  if (oo(t) || typeof t == "function") {
    const i = t[r.fieldName];
    return typeof i == "function" ? t[r.fieldName](e, n, r) : i;
  }
};
function fM(t, e, n) {
  const r = n.name.value;
  return r === uh.name && t.getQueryType() === e ? uh : r === ch.name && t.getQueryType() === e ? ch : r === fh.name ? fh : e.getFields()[r];
}
function Wz(t) {
  return new Promise((e) => e(dM(t)));
}
function Yz(t) {
  const e = dM(t);
  if (io(e))
    throw new Error("GraphQL execution failed to complete synchronously.");
  return e;
}
function dM(t) {
  arguments.length < 2 || Nt(
    !1,
    "graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead."
  );
  const {
    schema: e,
    source: n,
    rootValue: r,
    contextValue: i,
    variableValues: o,
    operationName: s,
    fieldResolver: a,
    typeResolver: l
  } = t, u = Q_(e);
  if (u.length > 0)
    return {
      errors: u
    };
  let c;
  try {
    c = gf(n);
  } catch (d) {
    return {
      errors: [d]
    };
  }
  const f = rM(e, c);
  return f.length > 0 ? {
    errors: f
  } : r0({
    schema: e,
    document: c,
    rootValue: r,
    contextValue: i,
    variableValues: o,
    operationName: s,
    fieldResolver: a,
    typeResolver: l
  });
}
function hM(t) {
  return typeof t?.[Symbol.asyncIterator] == "function";
}
function Xz(t, e) {
  const n = t[Symbol.asyncIterator]();
  async function r(i) {
    if (i.done)
      return i;
    try {
      return {
        value: await e(i.value),
        done: !1
      };
    } catch (o) {
      if (typeof n.return == "function")
        try {
          await n.return();
        } catch {
        }
      throw o;
    }
  }
  return {
    async next() {
      return r(await n.next());
    },
    async return() {
      return typeof n.return == "function" ? r(await n.return()) : {
        value: void 0,
        done: !0
      };
    },
    async throw(i) {
      if (typeof n.throw == "function")
        return r(await n.throw(i));
      throw i;
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
async function Kz(t) {
  arguments.length < 2 || Nt(
    !1,
    "graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead."
  );
  const e = await pM(t);
  return hM(e) ? Xz(e, (r) => r0({ ...t, rootValue: r })) : e;
}
function Qz(t) {
  const e = t[0];
  return e && "document" in e ? e : {
    schema: e,
    // FIXME: when underlying TS bug fixed, see https://github.com/microsoft/TypeScript/issues/31613
    document: t[1],
    rootValue: t[2],
    contextValue: t[3],
    variableValues: t[4],
    operationName: t[5],
    subscribeFieldResolver: t[6]
  };
}
async function pM(...t) {
  const e = Qz(t), { schema: n, document: r, variableValues: i } = e;
  sM(n, r, i);
  const o = aM(e);
  if (!("schema" in o))
    return {
      errors: o
    };
  try {
    const s = await Jz(o);
    if (!hM(s))
      throw new Error(
        `Subscription field must return Async Iterable. Received: ${_e(s)}.`
      );
    return s;
  } catch (s) {
    if (s instanceof ye)
      return {
        errors: [s]
      };
    throw s;
  }
}
async function Jz(t) {
  const { schema: e, fragments: n, operation: r, variableValues: i, rootValue: o } = t, s = e.getSubscriptionType();
  if (s == null)
    throw new ye(
      "Schema is not configured to execute subscription operation.",
      {
        nodes: r
      }
    );
  const a = lE(
    e,
    n,
    i,
    s,
    r.selectionSet
  ), [l, u] = [...a.entries()][0], c = fM(e, s, u[0]);
  if (!c) {
    const p = u[0].name.value;
    throw new ye(
      `The subscription field "${p}" is not defined.`,
      {
        nodes: u
      }
    );
  }
  const f = Hc(void 0, l, s.name), d = uM(
    t,
    c,
    u,
    s,
    f
  );
  try {
    var h;
    const p = n0(c, u[0], i), g = t.contextValue, v = await ((h = c.subscribe) !== null && h !== void 0 ? h : t.subscribeFieldResolver)(o, p, g, d);
    if (v instanceof Error)
      throw v;
    return v;
  } catch (p) {
    throw Wc(p, u, ci(f));
  }
}
function Zz(t) {
  return {
    Field(e) {
      const n = t.getFieldDef(), r = n?.deprecationReason;
      if (n && r != null) {
        const i = t.getParentType();
        i != null || Zn(!1), t.reportError(
          new ye(
            `The field ${i.name}.${n.name} is deprecated. ${r}`,
            {
              nodes: e
            }
          )
        );
      }
    },
    Argument(e) {
      const n = t.getArgument(), r = n?.deprecationReason;
      if (n && r != null) {
        const i = t.getDirective();
        if (i != null)
          t.reportError(
            new ye(
              `Directive "@${i.name}" argument "${n.name}" is deprecated. ${r}`,
              {
                nodes: e
              }
            )
          );
        else {
          const o = t.getParentType(), s = t.getFieldDef();
          o != null && s != null || Zn(!1), t.reportError(
            new ye(
              `Field "${o.name}.${s.name}" argument "${n.name}" is deprecated. ${r}`,
              {
                nodes: e
              }
            )
          );
        }
      }
    },
    ObjectField(e) {
      const n = hi(t.getParentInputType());
      if (Sn(n)) {
        const r = n.getFields()[e.name.value], i = r?.deprecationReason;
        i != null && t.reportError(
          new ye(
            `The input field ${n.name}.${r.name} is deprecated. ${i}`,
            {
              nodes: e
            }
          )
        );
      }
    },
    EnumValue(e) {
      const n = t.getEnumValue(), r = n?.deprecationReason;
      if (n && r != null) {
        const i = hi(t.getInputType());
        i != null || Zn(!1), t.reportError(
          new ye(
            `The enum value "${i.name}.${n.name}" is deprecated. ${r}`,
            {
              nodes: e
            }
          )
        );
      }
    }
  };
}
function eH(t) {
  return {
    Field(e) {
      const n = hi(t.getType());
      n && Pu(n) && t.reportError(
        new ye(
          `GraphQL introspection has been disabled, but the requested query contained the field "${e.name.value}".`,
          {
            nodes: e
          }
        )
      );
    }
  };
}
function gM(t) {
  const e = {
    descriptions: !0,
    specifiedByUrl: !1,
    directiveIsRepeatable: !1,
    schemaDescription: !1,
    inputValueDeprecation: !1,
    oneOf: !1,
    ...t
  }, n = e.descriptions ? "description" : "", r = e.specifiedByUrl ? "specifiedByURL" : "", i = e.directiveIsRepeatable ? "isRepeatable" : "", o = e.schemaDescription ? n : "";
  function s(l) {
    return e.inputValueDeprecation ? l : "";
  }
  const a = e.oneOf ? "isOneOf" : "";
  return `
    query IntrospectionQuery {
      __schema {
        ${o}
        queryType { name kind }
        mutationType { name kind }
        subscriptionType { name kind }
        types {
          ...FullType
        }
        directives {
          name
          ${n}
          ${i}
          locations
          args${s("(includeDeprecated: true)")} {
            ...InputValue
          }
        }
      }
    }

    fragment FullType on __Type {
      kind
      name
      ${n}
      ${r}
      ${a}
      fields(includeDeprecated: true) {
        name
        ${n}
        args${s("(includeDeprecated: true)")} {
          ...InputValue
        }
        type {
          ...TypeRef
        }
        isDeprecated
        deprecationReason
      }
      inputFields${s("(includeDeprecated: true)")} {
        ...InputValue
      }
      interfaces {
        ...TypeRef
      }
      enumValues(includeDeprecated: true) {
        name
        ${n}
        isDeprecated
        deprecationReason
      }
      possibleTypes {
        ...TypeRef
      }
    }

    fragment InputValue on __InputValue {
      name
      ${n}
      type { ...TypeRef }
      defaultValue
      ${s("isDeprecated")}
      ${s("deprecationReason")}
    }

    fragment TypeRef on __Type {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
              ofType {
                kind
                name
                ofType {
                  kind
                  name
                  ofType {
                    kind
                    name
                    ofType {
                      kind
                      name
                      ofType {
                        kind
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}
function tH(t, e) {
  let n = null;
  for (const i of t.definitions)
    if (i.kind === z.OPERATION_DEFINITION) {
      var r;
      if (e == null) {
        if (n)
          return null;
        n = i;
      } else if (((r = i.name) === null || r === void 0 ? void 0 : r.value) === e)
        return i;
    }
  return n;
}
function nH(t, e) {
  if (e.operation === "query") {
    const n = t.getQueryType();
    if (!n)
      throw new ye(
        "Schema does not define the required query root type.",
        {
          nodes: e
        }
      );
    return n;
  }
  if (e.operation === "mutation") {
    const n = t.getMutationType();
    if (!n)
      throw new ye("Schema is not configured for mutations.", {
        nodes: e
      });
    return n;
  }
  if (e.operation === "subscription") {
    const n = t.getSubscriptionType();
    if (!n)
      throw new ye("Schema is not configured for subscriptions.", {
        nodes: e
      });
    return n;
  }
  throw new ye(
    "Can only have query, mutation and subscription operations.",
    {
      nodes: e
    }
  );
}
function rH(t, e) {
  const n = {
    specifiedByUrl: !0,
    directiveIsRepeatable: !0,
    schemaDescription: !0,
    inputValueDeprecation: !0,
    oneOf: !0,
    ...e
  }, r = gf(gM(n)), i = oM({
    schema: t,
    document: r
  });
  return !i.errors && i.data || Zn(!1), i.data;
}
function iH(t, e) {
  oo(t) && oo(t.__schema) || Nt(
    !1,
    `Invalid or incomplete introspection result. Ensure that you are passing "data" property of introspection response and no "errors" was returned alongside: ${_e(
      t
    )}.`
  );
  const n = t.__schema, r = za(
    n.types,
    (k) => k.name,
    (k) => d(k)
  );
  for (const k of [...Hh, ...Yh])
    r[k.name] && (r[k.name] = k);
  const i = n.queryType ? c(n.queryType) : null, o = n.mutationType ? c(n.mutationType) : null, s = n.subscriptionType ? c(n.subscriptionType) : null, a = n.directives ? n.directives.map(x) : [];
  return new yf({
    description: n.description,
    query: i,
    mutation: o,
    subscription: s,
    types: Object.values(r),
    directives: a,
    assumeValid: e?.assumeValid
  });
  function l(k) {
    if (k.kind === pn.LIST) {
      const C = k.ofType;
      if (!C)
        throw new Error("Decorated type deeper than introspection query.");
      return new jr(l(C));
    }
    if (k.kind === pn.NON_NULL) {
      const C = k.ofType;
      if (!C)
        throw new Error("Decorated type deeper than introspection query.");
      const M = l(C);
      return new It(r$(M));
    }
    return u(k);
  }
  function u(k) {
    const C = k.name;
    if (!C)
      throw new Error(`Unknown type reference: ${_e(k)}.`);
    const M = r[C];
    if (!M)
      throw new Error(
        `Invalid or incomplete schema, unknown type: ${C}. Ensure that a full introspection query is used in order to build a client schema.`
      );
    return M;
  }
  function c(k) {
    return t$(u(k));
  }
  function f(k) {
    return n$(u(k));
  }
  function d(k) {
    if (k != null && k.name != null && k.kind != null)
      switch (k.kind) {
        case pn.SCALAR:
          return h(k);
        case pn.OBJECT:
          return g(k);
        case pn.INTERFACE:
          return m(k);
        case pn.UNION:
          return v(k);
        case pn.ENUM:
          return S(k);
        case pn.INPUT_OBJECT:
          return _(k);
      }
    const C = _e(k);
    throw new Error(
      `Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ${C}.`
    );
  }
  function h(k) {
    return new Ds({
      name: k.name,
      description: k.description,
      specifiedByURL: k.specifiedByURL
    });
  }
  function p(k) {
    if (k.interfaces === null && k.kind === pn.INTERFACE)
      return [];
    if (!k.interfaces) {
      const C = _e(k);
      throw new Error(
        `Introspection result missing interfaces: ${C}.`
      );
    }
    return k.interfaces.map(f);
  }
  function g(k) {
    return new Do({
      name: k.name,
      description: k.description,
      interfaces: () => p(k),
      fields: () => b(k)
    });
  }
  function m(k) {
    return new Uc({
      name: k.name,
      description: k.description,
      interfaces: () => p(k),
      fields: () => b(k)
    });
  }
  function v(k) {
    if (!k.possibleTypes) {
      const C = _e(k);
      throw new Error(
        `Introspection result missing possibleTypes: ${C}.`
      );
    }
    return new qc({
      name: k.name,
      description: k.description,
      types: () => k.possibleTypes.map(c)
    });
  }
  function S(k) {
    if (!k.enumValues) {
      const C = _e(k);
      throw new Error(
        `Introspection result missing enumValues: ${C}.`
      );
    }
    return new ul({
      name: k.name,
      description: k.description,
      values: za(
        k.enumValues,
        (C) => C.name,
        (C) => ({
          description: C.description,
          deprecationReason: C.deprecationReason
        })
      )
    });
  }
  function _(k) {
    if (!k.inputFields) {
      const C = _e(k);
      throw new Error(
        `Introspection result missing inputFields: ${C}.`
      );
    }
    return new zc({
      name: k.name,
      description: k.description,
      fields: () => w(k.inputFields),
      isOneOf: k.isOneOf
    });
  }
  function b(k) {
    if (!k.fields)
      throw new Error(
        `Introspection result missing fields: ${_e(k)}.`
      );
    return za(
      k.fields,
      (C) => C.name,
      y
    );
  }
  function y(k) {
    const C = l(k.type);
    if (!il(C)) {
      const M = _e(C);
      throw new Error(
        `Introspection must provide output type for fields, but received: ${M}.`
      );
    }
    if (!k.args) {
      const M = _e(k);
      throw new Error(
        `Introspection result missing field args: ${M}.`
      );
    }
    return {
      description: k.description,
      deprecationReason: k.deprecationReason,
      type: C,
      args: w(k.args)
    };
  }
  function w(k) {
    return za(
      k,
      (C) => C.name,
      E
    );
  }
  function E(k) {
    const C = l(k.type);
    if (!Ci(C)) {
      const F = _e(C);
      throw new Error(
        `Introspection must provide input type for arguments, but received: ${F}.`
      );
    }
    const M = k.defaultValue != null ? bs(JP(k.defaultValue), C) : void 0;
    return {
      description: k.description,
      type: C,
      defaultValue: M,
      deprecationReason: k.deprecationReason
    };
  }
  function x(k) {
    if (!k.args) {
      const C = _e(k);
      throw new Error(
        `Introspection result missing directive args: ${C}.`
      );
    }
    if (!k.locations) {
      const C = _e(k);
      throw new Error(
        `Introspection result missing directive locations: ${C}.`
      );
    }
    return new Yo({
      name: k.name,
      description: k.description,
      isRepeatable: k.isRepeatable,
      locations: k.locations.slice(),
      args: w(k.args)
    });
  }
}
function oH(t, e, n) {
  K_(t), e != null && e.kind === z.DOCUMENT || Nt(!1, "Must provide valid Document AST."), n?.assumeValid !== !0 && n?.assumeValidSDL !== !0 && $z(e, t);
  const r = t.toConfig(), i = mM(r, e, n);
  return r === i ? t : new yf(i);
}
function mM(t, e, n) {
  var r, i, o, s;
  const a = [], l = /* @__PURE__ */ Object.create(null), u = [];
  let c;
  const f = [];
  for (const T of e.definitions)
    if (T.kind === z.SCHEMA_DEFINITION)
      c = T;
    else if (T.kind === z.SCHEMA_EXTENSION)
      f.push(T);
    else if (vf(T))
      a.push(T);
    else if (e0(T)) {
      const $ = T.name.value, P = l[$];
      l[$] = P ? P.concat([T]) : [T];
    } else T.kind === z.DIRECTIVE_DEFINITION && u.push(T);
  if (Object.keys(l).length === 0 && a.length === 0 && u.length === 0 && f.length === 0 && c == null)
    return t;
  const d = /* @__PURE__ */ Object.create(null);
  for (const T of t.types)
    d[T.name] = S(T);
  for (const T of a) {
    var h;
    const $ = T.name.value;
    d[$] = (h = VT[$]) !== null && h !== void 0 ? h : W(T);
  }
  const p = {
    // Get the extended root operation types.
    query: t.query && m(t.query),
    mutation: t.mutation && m(t.mutation),
    subscription: t.subscription && m(t.subscription),
    // Then, incorporate schema definition and all schema extensions.
    ...c && M([c]),
    ...M(f)
  };
  return {
    description: (r = c) === null || r === void 0 || (i = r.description) === null || i === void 0 ? void 0 : i.value,
    ...p,
    types: Object.values(d),
    directives: [
      ...t.directives.map(v),
      ...u.map(B)
    ],
    extensions: /* @__PURE__ */ Object.create(null),
    astNode: (o = c) !== null && o !== void 0 ? o : t.astNode,
    extensionASTNodes: t.extensionASTNodes.concat(f),
    assumeValid: (s = n?.assumeValid) !== null && s !== void 0 ? s : !1
  };
  function g(T) {
    return Mn(T) ? new jr(g(T.ofType)) : St(T) ? new It(g(T.ofType)) : m(T);
  }
  function m(T) {
    return d[T.name];
  }
  function v(T) {
    const $ = T.toConfig();
    return new Yo({
      ...$,
      args: Zs($.args, C)
    });
  }
  function S(T) {
    if (Pu(T) || Ky(T))
      return T;
    if (co(T))
      return y(T);
    if (Yt(T))
      return w(T);
    if (an(T))
      return E(T);
    if (Er(T))
      return x(T);
    if (hr(T))
      return b(T);
    if (Sn(T))
      return _(T);
    Zn(!1, "Unexpected type: " + _e(T));
  }
  function _(T) {
    var $;
    const P = T.toConfig(), H = ($ = l[P.name]) !== null && $ !== void 0 ? $ : [];
    return new zc({
      ...P,
      fields: () => ({
        ...Zs(P.fields, (Z) => ({
          ...Z,
          type: g(Z.type)
        })),
        ...Q(H)
      }),
      extensionASTNodes: P.extensionASTNodes.concat(H)
    });
  }
  function b(T) {
    var $;
    const P = T.toConfig(), H = ($ = l[T.name]) !== null && $ !== void 0 ? $ : [];
    return new ul({
      ...P,
      values: { ...P.values, ...ne(H) },
      extensionASTNodes: P.extensionASTNodes.concat(H)
    });
  }
  function y(T) {
    var $;
    const P = T.toConfig(), H = ($ = l[P.name]) !== null && $ !== void 0 ? $ : [];
    let Z = P.specifiedByURL;
    for (const J of H) {
      var le;
      Z = (le = UT(J)) !== null && le !== void 0 ? le : Z;
    }
    return new Ds({
      ...P,
      specifiedByURL: Z,
      extensionASTNodes: P.extensionASTNodes.concat(H)
    });
  }
  function w(T) {
    var $;
    const P = T.toConfig(), H = ($ = l[P.name]) !== null && $ !== void 0 ? $ : [];
    return new Do({
      ...P,
      interfaces: () => [
        ...T.getInterfaces().map(m),
        ...X(H)
      ],
      fields: () => ({
        ...Zs(P.fields, k),
        ...N(H)
      }),
      extensionASTNodes: P.extensionASTNodes.concat(H)
    });
  }
  function E(T) {
    var $;
    const P = T.toConfig(), H = ($ = l[P.name]) !== null && $ !== void 0 ? $ : [];
    return new Uc({
      ...P,
      interfaces: () => [
        ...T.getInterfaces().map(m),
        ...X(H)
      ],
      fields: () => ({
        ...Zs(P.fields, k),
        ...N(H)
      }),
      extensionASTNodes: P.extensionASTNodes.concat(H)
    });
  }
  function x(T) {
    var $;
    const P = T.toConfig(), H = ($ = l[P.name]) !== null && $ !== void 0 ? $ : [];
    return new qc({
      ...P,
      types: () => [
        ...T.getTypes().map(m),
        ...O(H)
      ],
      extensionASTNodes: P.extensionASTNodes.concat(H)
    });
  }
  function k(T) {
    return {
      ...T,
      type: g(T.type),
      args: T.args && Zs(T.args, C)
    };
  }
  function C(T) {
    return { ...T, type: g(T.type) };
  }
  function M(T) {
    const $ = {};
    for (const H of T) {
      var P;
      const Z = (
        /* c8 ignore next */
        (P = H.operationTypes) !== null && P !== void 0 ? P : []
      );
      for (const le of Z)
        $[le.operation] = F(le.type);
    }
    return $;
  }
  function F(T) {
    var $;
    const P = T.name.value, H = ($ = VT[P]) !== null && $ !== void 0 ? $ : d[P];
    if (H === void 0)
      throw new Error(`Unknown type: "${P}".`);
    return H;
  }
  function U(T) {
    return T.kind === z.LIST_TYPE ? new jr(U(T.type)) : T.kind === z.NON_NULL_TYPE ? new It(U(T.type)) : F(T);
  }
  function B(T) {
    var $;
    return new Yo({
      name: T.name.value,
      description: ($ = T.description) === null || $ === void 0 ? void 0 : $.value,
      // @ts-expect-error
      locations: T.locations.map(({ value: P }) => P),
      isRepeatable: T.repeatable,
      args: q(T.arguments),
      astNode: T
    });
  }
  function N(T) {
    const $ = /* @__PURE__ */ Object.create(null);
    for (const Z of T) {
      var P;
      const le = (
        /* c8 ignore next */
        (P = Z.fields) !== null && P !== void 0 ? P : []
      );
      for (const J of le) {
        var H;
        $[J.name.value] = {
          // Note: While this could make assertions to get the correctly typed
          // value, that would throw immediately while type system validation
          // with validateSchema() will produce more actionable results.
          type: U(J.type),
          description: (H = J.description) === null || H === void 0 ? void 0 : H.value,
          args: q(J.arguments),
          deprecationReason: Vp(J),
          astNode: J
        };
      }
    }
    return $;
  }
  function q(T) {
    const $ = (
      /* c8 ignore next */
      T ?? []
    ), P = /* @__PURE__ */ Object.create(null);
    for (const Z of $) {
      var H;
      const le = U(Z.type);
      P[Z.name.value] = {
        type: le,
        description: (H = Z.description) === null || H === void 0 ? void 0 : H.value,
        defaultValue: bs(Z.defaultValue, le),
        deprecationReason: Vp(Z),
        astNode: Z
      };
    }
    return P;
  }
  function Q(T) {
    const $ = /* @__PURE__ */ Object.create(null);
    for (const Z of T) {
      var P;
      const le = (
        /* c8 ignore next */
        (P = Z.fields) !== null && P !== void 0 ? P : []
      );
      for (const J of le) {
        var H;
        const ue = U(J.type);
        $[J.name.value] = {
          type: ue,
          description: (H = J.description) === null || H === void 0 ? void 0 : H.value,
          defaultValue: bs(J.defaultValue, ue),
          deprecationReason: Vp(J),
          astNode: J
        };
      }
    }
    return $;
  }
  function ne(T) {
    const $ = /* @__PURE__ */ Object.create(null);
    for (const Z of T) {
      var P;
      const le = (
        /* c8 ignore next */
        (P = Z.values) !== null && P !== void 0 ? P : []
      );
      for (const J of le) {
        var H;
        $[J.name.value] = {
          description: (H = J.description) === null || H === void 0 ? void 0 : H.value,
          deprecationReason: Vp(J),
          astNode: J
        };
      }
    }
    return $;
  }
  function X(T) {
    return T.flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      ($) => {
        var P, H;
        return (
          /* c8 ignore next */
          (P = (H = $.interfaces) === null || H === void 0 ? void 0 : H.map(F)) !== null && P !== void 0 ? P : []
        );
      }
    );
  }
  function O(T) {
    return T.flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      ($) => {
        var P, H;
        return (
          /* c8 ignore next */
          (P = (H = $.types) === null || H === void 0 ? void 0 : H.map(F)) !== null && P !== void 0 ? P : []
        );
      }
    );
  }
  function W(T) {
    var $;
    const P = T.name.value, H = ($ = l[P]) !== null && $ !== void 0 ? $ : [];
    switch (T.kind) {
      case z.OBJECT_TYPE_DEFINITION: {
        var Z;
        const oe = [T, ...H];
        return new Do({
          name: P,
          description: (Z = T.description) === null || Z === void 0 ? void 0 : Z.value,
          interfaces: () => X(oe),
          fields: () => N(oe),
          astNode: T,
          extensionASTNodes: H
        });
      }
      case z.INTERFACE_TYPE_DEFINITION: {
        var le;
        const oe = [T, ...H];
        return new Uc({
          name: P,
          description: (le = T.description) === null || le === void 0 ? void 0 : le.value,
          interfaces: () => X(oe),
          fields: () => N(oe),
          astNode: T,
          extensionASTNodes: H
        });
      }
      case z.ENUM_TYPE_DEFINITION: {
        var J;
        const oe = [T, ...H];
        return new ul({
          name: P,
          description: (J = T.description) === null || J === void 0 ? void 0 : J.value,
          values: ne(oe),
          astNode: T,
          extensionASTNodes: H
        });
      }
      case z.UNION_TYPE_DEFINITION: {
        var ue;
        const oe = [T, ...H];
        return new qc({
          name: P,
          description: (ue = T.description) === null || ue === void 0 ? void 0 : ue.value,
          types: () => O(oe),
          astNode: T,
          extensionASTNodes: H
        });
      }
      case z.SCALAR_TYPE_DEFINITION: {
        var he;
        return new Ds({
          name: P,
          description: (he = T.description) === null || he === void 0 ? void 0 : he.value,
          specifiedByURL: UT(T),
          astNode: T,
          extensionASTNodes: H
        });
      }
      case z.INPUT_OBJECT_TYPE_DEFINITION: {
        var me;
        const oe = [T, ...H];
        return new zc({
          name: P,
          description: (me = T.description) === null || me === void 0 ? void 0 : me.value,
          fields: () => Q(oe),
          astNode: T,
          extensionASTNodes: H,
          isOneOf: sH(T)
        });
      }
    }
  }
}
const VT = ma(
  [...Hh, ...Yh],
  (t) => t.name
);
function Vp(t) {
  const e = Gc(Jy, t);
  return e?.reason;
}
function UT(t) {
  const e = Gc(V_, t);
  return e?.url;
}
function sH(t) {
  return !!Gc(U_, t);
}
function yM(t, e) {
  t != null && t.kind === z.DOCUMENT || Nt(!1, "Must provide valid Document AST."), e?.assumeValid !== !0 && e?.assumeValidSDL !== !0 && Pz(t);
  const r = mM({
    description: void 0,
    types: [],
    directives: [],
    extensions: /* @__PURE__ */ Object.create(null),
    extensionASTNodes: [],
    assumeValid: !1
  }, t, e);
  if (r.astNode == null)
    for (const o of r.types)
      switch (o.name) {
        // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        case "Query":
          r.query = o;
          break;
        case "Mutation":
          r.mutation = o;
          break;
        case "Subscription":
          r.subscription = o;
          break;
      }
  const i = [
    ...r.directives,
    // If specified directives were not explicitly declared, add them.
    ...bl.filter(
      (o) => r.directives.every(
        (s) => s.name !== o.name
      )
    )
  ];
  return new yf({ ...r, directives: i });
}
function aH(t, e) {
  const n = gf(t, {
    noLocation: e?.noLocation,
    allowLegacyFragmentVariables: e?.allowLegacyFragmentVariables
  });
  return yM(n, {
    assumeValidSDL: e?.assumeValidSDL,
    assumeValid: e?.assumeValid
  });
}
function lH(t) {
  const e = t.toConfig(), n = za(
    sv(e.types),
    (d) => d.name,
    f
  );
  return new yf({
    ...e,
    types: Object.values(n),
    directives: sv(e.directives).map(s),
    query: o(e.query),
    mutation: o(e.mutation),
    subscription: o(e.subscription)
  });
  function r(d) {
    return Mn(d) ? new jr(r(d.ofType)) : St(d) ? new It(r(d.ofType)) : i(d);
  }
  function i(d) {
    return n[d.name];
  }
  function o(d) {
    return d && i(d);
  }
  function s(d) {
    const h = d.toConfig();
    return new Yo({
      ...h,
      locations: vM(h.locations, (p) => p),
      args: a(h.args)
    });
  }
  function a(d) {
    return Up(d, (h) => ({ ...h, type: r(h.type) }));
  }
  function l(d) {
    return Up(d, (h) => ({
      ...h,
      type: r(h.type),
      args: h.args && a(h.args)
    }));
  }
  function u(d) {
    return Up(d, (h) => ({
      ...h,
      type: r(h.type)
    }));
  }
  function c(d) {
    return sv(d).map(i);
  }
  function f(d) {
    if (co(d) || Pu(d))
      return d;
    if (Yt(d)) {
      const h = d.toConfig();
      return new Do({
        ...h,
        interfaces: () => c(h.interfaces),
        fields: () => l(h.fields)
      });
    }
    if (an(d)) {
      const h = d.toConfig();
      return new Uc({
        ...h,
        interfaces: () => c(h.interfaces),
        fields: () => l(h.fields)
      });
    }
    if (Er(d)) {
      const h = d.toConfig();
      return new qc({
        ...h,
        types: () => c(h.types)
      });
    }
    if (hr(d)) {
      const h = d.toConfig();
      return new ul({
        ...h,
        values: Up(h.values, (p) => p)
      });
    }
    if (Sn(d)) {
      const h = d.toConfig();
      return new zc({
        ...h,
        fields: () => u(h.fields)
      });
    }
    Zn(!1, "Unexpected type: " + _e(d));
  }
}
function Up(t, e) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const r of Object.keys(t).sort(Vh))
    n[r] = e(t[r]);
  return n;
}
function sv(t) {
  return vM(t, (e) => e.name);
}
function vM(t, e) {
  return t.slice().sort((n, r) => {
    const i = e(n), o = e(r);
    return Vh(i, o);
  });
}
function uH(t) {
  return bM(
    t,
    (e) => !q_(e),
    fH
  );
}
function cH(t) {
  return bM(t, q_, Pu);
}
function fH(t) {
  return !Ky(t) && !Pu(t);
}
function bM(t, e, n) {
  const r = t.getDirectives().filter(e), i = Object.values(t.getTypeMap()).filter(n);
  return [
    dH(t),
    ...r.map((o) => wH(o)),
    ...i.map((o) => wM(o))
  ].filter(Boolean).join(`

`);
}
function dH(t) {
  if (t.description == null && hH(t))
    return;
  const e = [], n = t.getQueryType();
  n && e.push(`  query: ${n.name}`);
  const r = t.getMutationType();
  r && e.push(`  mutation: ${r.name}`);
  const i = t.getSubscriptionType();
  return i && e.push(`  subscription: ${i.name}`), Io(t) + `schema {
${e.join(`
`)}
}`;
}
function hH(t) {
  const e = t.getQueryType();
  if (e && e.name !== "Query")
    return !1;
  const n = t.getMutationType();
  if (n && n.name !== "Mutation")
    return !1;
  const r = t.getSubscriptionType();
  return !(r && r.name !== "Subscription");
}
function wM(t) {
  if (co(t))
    return pH(t);
  if (Yt(t))
    return gH(t);
  if (an(t))
    return mH(t);
  if (Er(t))
    return yH(t);
  if (hr(t))
    return vH(t);
  if (Sn(t))
    return bH(t);
  Zn(!1, "Unexpected type: " + _e(t));
}
function pH(t) {
  return Io(t) + `scalar ${t.name}` + SH(t);
}
function SM(t) {
  const e = t.getInterfaces();
  return e.length ? " implements " + e.map((n) => n.name).join(" & ") : "";
}
function gH(t) {
  return Io(t) + `type ${t.name}` + SM(t) + _M(t);
}
function mH(t) {
  return Io(t) + `interface ${t.name}` + SM(t) + _M(t);
}
function yH(t) {
  const e = t.getTypes(), n = e.length ? " = " + e.join(" | ") : "";
  return Io(t) + "union " + t.name + n;
}
function vH(t) {
  const e = t.getValues().map(
    (n, r) => Io(n, "  ", !r) + "  " + n.name + pE(n.deprecationReason)
  );
  return Io(t) + `enum ${t.name}` + hE(e);
}
function bH(t) {
  const e = Object.values(t.getFields()).map(
    (n, r) => Io(n, "  ", !r) + "  " + _w(n)
  );
  return Io(t) + `input ${t.name}` + (t.isOneOf ? " @oneOf" : "") + hE(e);
}
function _M(t) {
  const e = Object.values(t.getFields()).map(
    (n, r) => Io(n, "  ", !r) + "  " + n.name + EM(n.args, "  ") + ": " + String(n.type) + pE(n.deprecationReason)
  );
  return hE(e);
}
function hE(t) {
  return t.length !== 0 ? ` {
` + t.join(`
`) + `
}` : "";
}
function EM(t, e = "") {
  return t.length === 0 ? "" : t.every((n) => !n.description) ? "(" + t.map(_w).join(", ") + ")" : `(
` + t.map(
    (n, r) => Io(n, "  " + e, !r) + "  " + e + _w(n)
  ).join(`
`) + `
` + e + ")";
}
function _w(t) {
  const e = Ha(t.defaultValue, t.type);
  let n = t.name + ": " + String(t.type);
  return e && (n += ` = ${An(e)}`), n + pE(t.deprecationReason);
}
function wH(t) {
  return Io(t) + "directive @" + t.name + EM(t.args) + (t.isRepeatable ? " repeatable" : "") + " on " + t.locations.join(" | ");
}
function pE(t) {
  return t == null ? "" : t !== j_ ? ` @deprecated(reason: ${An({
    kind: z.STRING,
    value: t
  })})` : " @deprecated";
}
function SH(t) {
  return t.specifiedByURL == null ? "" : ` @specifiedBy(url: ${An({
    kind: z.STRING,
    value: t.specifiedByURL
  })})`;
}
function Io(t, e = "", n = !0) {
  const { description: r } = t;
  if (r == null)
    return "";
  const i = An({
    kind: z.STRING,
    value: r,
    block: eq(r)
  });
  return (e && !n ? `
` + e : e) + i.replace(/\n/g, `
` + e) + `
`;
}
function _H(t) {
  const e = [];
  for (const n of t)
    e.push(...n.definitions);
  return {
    kind: z.DOCUMENT,
    definitions: e
  };
}
function EH(t) {
  const e = [], n = /* @__PURE__ */ Object.create(null);
  for (const i of t.definitions)
    switch (i.kind) {
      case z.OPERATION_DEFINITION:
        e.push(i);
        break;
      case z.FRAGMENT_DEFINITION:
        n[i.name.value] = qT(
          i.selectionSet
        );
        break;
    }
  const r = /* @__PURE__ */ Object.create(null);
  for (const i of e) {
    const o = /* @__PURE__ */ new Set();
    for (const a of qT(i.selectionSet))
      kM(o, n, a);
    const s = i.name ? i.name.value : "";
    r[s] = {
      kind: z.DOCUMENT,
      definitions: t.definitions.filter(
        (a) => a === i || a.kind === z.FRAGMENT_DEFINITION && o.has(a.name.value)
      )
    };
  }
  return r;
}
function kM(t, e, n) {
  if (!t.has(n)) {
    t.add(n);
    const r = e[n];
    if (r !== void 0)
      for (const i of r)
        kM(t, e, i);
  }
}
function qT(t) {
  const e = [];
  return mf(t, {
    FragmentSpread(n) {
      e.push(n.name.value);
    }
  }), e;
}
function kH(t) {
  const e = QP(t) ? t : new Gy(t), n = e.body, r = new I_(e);
  let i = "", o = !1;
  for (; r.advance().kind !== Se.EOF; ) {
    const s = r.token, a = s.kind, l = !WP(s.kind);
    o && (l || s.kind === Se.SPREAD) && (i += " ");
    const u = n.slice(s.start, s.end);
    a === Se.BLOCK_STRING ? i += GP(s.value, {
      minimize: !0
    }) : i += u, o = l;
  }
  return i;
}
function TH(t) {
  const e = TM(t);
  if (e)
    throw e;
  return t;
}
function TM(t) {
  if (typeof t == "string" || Nt(!1, "Expected name to be a string."), t.startsWith("__"))
    return new ye(
      `Name "${t}" must not begin with "__", which is reserved by GraphQL introspection.`
    );
  try {
    uo(t);
  } catch (e) {
    return e;
  }
}
var Wn;
(function(t) {
  t.TYPE_REMOVED = "TYPE_REMOVED", t.TYPE_CHANGED_KIND = "TYPE_CHANGED_KIND", t.TYPE_REMOVED_FROM_UNION = "TYPE_REMOVED_FROM_UNION", t.VALUE_REMOVED_FROM_ENUM = "VALUE_REMOVED_FROM_ENUM", t.REQUIRED_INPUT_FIELD_ADDED = "REQUIRED_INPUT_FIELD_ADDED", t.IMPLEMENTED_INTERFACE_REMOVED = "IMPLEMENTED_INTERFACE_REMOVED", t.FIELD_REMOVED = "FIELD_REMOVED", t.FIELD_CHANGED_KIND = "FIELD_CHANGED_KIND", t.REQUIRED_ARG_ADDED = "REQUIRED_ARG_ADDED", t.ARG_REMOVED = "ARG_REMOVED", t.ARG_CHANGED_KIND = "ARG_CHANGED_KIND", t.DIRECTIVE_REMOVED = "DIRECTIVE_REMOVED", t.DIRECTIVE_ARG_REMOVED = "DIRECTIVE_ARG_REMOVED", t.REQUIRED_DIRECTIVE_ARG_ADDED = "REQUIRED_DIRECTIVE_ARG_ADDED", t.DIRECTIVE_REPEATABLE_REMOVED = "DIRECTIVE_REPEATABLE_REMOVED", t.DIRECTIVE_LOCATION_REMOVED = "DIRECTIVE_LOCATION_REMOVED";
})(Wn || (Wn = {}));
var Wo;
(function(t) {
  t.VALUE_ADDED_TO_ENUM = "VALUE_ADDED_TO_ENUM", t.TYPE_ADDED_TO_UNION = "TYPE_ADDED_TO_UNION", t.OPTIONAL_INPUT_FIELD_ADDED = "OPTIONAL_INPUT_FIELD_ADDED", t.OPTIONAL_ARG_ADDED = "OPTIONAL_ARG_ADDED", t.IMPLEMENTED_INTERFACE_ADDED = "IMPLEMENTED_INTERFACE_ADDED", t.ARG_DEFAULT_VALUE_CHANGE = "ARG_DEFAULT_VALUE_CHANGE";
})(Wo || (Wo = {}));
function xH(t, e) {
  return xM(t, e).filter(
    (n) => n.type in Wn
  );
}
function CH(t, e) {
  return xM(t, e).filter(
    (n) => n.type in Wo
  );
}
function xM(t, e) {
  return [
    ...RH(t, e),
    ...AH(t, e)
  ];
}
function AH(t, e) {
  const n = [], r = ya(
    t.getDirectives(),
    e.getDirectives()
  );
  for (const i of r.removed)
    n.push({
      type: Wn.DIRECTIVE_REMOVED,
      description: `${i.name} was removed.`
    });
  for (const [i, o] of r.persisted) {
    const s = ya(i.args, o.args);
    for (const a of s.added)
      vl(a) && n.push({
        type: Wn.REQUIRED_DIRECTIVE_ARG_ADDED,
        description: `A required arg ${a.name} on directive ${i.name} was added.`
      });
    for (const a of s.removed)
      n.push({
        type: Wn.DIRECTIVE_ARG_REMOVED,
        description: `${a.name} was removed from ${i.name}.`
      });
    i.isRepeatable && !o.isRepeatable && n.push({
      type: Wn.DIRECTIVE_REPEATABLE_REMOVED,
      description: `Repeatable flag was removed from ${i.name}.`
    });
    for (const a of i.locations)
      o.locations.includes(a) || n.push({
        type: Wn.DIRECTIVE_LOCATION_REMOVED,
        description: `${a} was removed from ${i.name}.`
      });
  }
  return n;
}
function RH(t, e) {
  const n = [], r = ya(
    Object.values(t.getTypeMap()),
    Object.values(e.getTypeMap())
  );
  for (const i of r.removed)
    n.push({
      type: Wn.TYPE_REMOVED,
      description: Ky(i) ? `Standard scalar ${i.name} was removed because it is not referenced anymore.` : `${i.name} was removed.`
    });
  for (const [i, o] of r.persisted)
    hr(i) && hr(o) ? n.push(...IH(i, o)) : Er(i) && Er(o) ? n.push(...DH(i, o)) : Sn(i) && Sn(o) ? n.push(...OH(i, o)) : Yt(i) && Yt(o) ? n.push(
      ...HT(i, o),
      ...zT(i, o)
    ) : an(i) && an(o) ? n.push(
      ...HT(i, o),
      ...zT(i, o)
    ) : i.constructor !== o.constructor && n.push({
      type: Wn.TYPE_CHANGED_KIND,
      description: `${i.name} changed from ${GT(i)} to ${GT(o)}.`
    });
  return n;
}
function OH(t, e) {
  const n = [], r = ya(
    Object.values(t.getFields()),
    Object.values(e.getFields())
  );
  for (const i of r.added)
    Xy(i) ? n.push({
      type: Wn.REQUIRED_INPUT_FIELD_ADDED,
      description: `A required field ${i.name} on input type ${t.name} was added.`
    }) : n.push({
      type: Wo.OPTIONAL_INPUT_FIELD_ADDED,
      description: `An optional field ${i.name} on input type ${t.name} was added.`
    });
  for (const i of r.removed)
    n.push({
      type: Wn.FIELD_REMOVED,
      description: `${t.name}.${i.name} was removed.`
    });
  for (const [i, o] of r.persisted)
    Gd(
      i.type,
      o.type
    ) || n.push({
      type: Wn.FIELD_CHANGED_KIND,
      description: `${t.name}.${i.name} changed type from ${String(i.type)} to ${String(o.type)}.`
    });
  return n;
}
function DH(t, e) {
  const n = [], r = ya(t.getTypes(), e.getTypes());
  for (const i of r.added)
    n.push({
      type: Wo.TYPE_ADDED_TO_UNION,
      description: `${i.name} was added to union type ${t.name}.`
    });
  for (const i of r.removed)
    n.push({
      type: Wn.TYPE_REMOVED_FROM_UNION,
      description: `${i.name} was removed from union type ${t.name}.`
    });
  return n;
}
function IH(t, e) {
  const n = [], r = ya(t.getValues(), e.getValues());
  for (const i of r.added)
    n.push({
      type: Wo.VALUE_ADDED_TO_ENUM,
      description: `${i.name} was added to enum type ${t.name}.`
    });
  for (const i of r.removed)
    n.push({
      type: Wn.VALUE_REMOVED_FROM_ENUM,
      description: `${i.name} was removed from enum type ${t.name}.`
    });
  return n;
}
function zT(t, e) {
  const n = [], r = ya(t.getInterfaces(), e.getInterfaces());
  for (const i of r.added)
    n.push({
      type: Wo.IMPLEMENTED_INTERFACE_ADDED,
      description: `${i.name} added to interfaces implemented by ${t.name}.`
    });
  for (const i of r.removed)
    n.push({
      type: Wn.IMPLEMENTED_INTERFACE_REMOVED,
      description: `${t.name} no longer implements interface ${i.name}.`
    });
  return n;
}
function HT(t, e) {
  const n = [], r = ya(
    Object.values(t.getFields()),
    Object.values(e.getFields())
  );
  for (const i of r.removed)
    n.push({
      type: Wn.FIELD_REMOVED,
      description: `${t.name}.${i.name} was removed.`
    });
  for (const [i, o] of r.persisted)
    n.push(...NH(t, i, o)), Td(
      i.type,
      o.type
    ) || n.push({
      type: Wn.FIELD_CHANGED_KIND,
      description: `${t.name}.${i.name} changed type from ${String(i.type)} to ${String(o.type)}.`
    });
  return n;
}
function NH(t, e, n) {
  const r = [], i = ya(e.args, n.args);
  for (const o of i.removed)
    r.push({
      type: Wn.ARG_REMOVED,
      description: `${t.name}.${e.name} arg ${o.name} was removed.`
    });
  for (const [o, s] of i.persisted)
    if (!Gd(
      o.type,
      s.type
    ))
      r.push({
        type: Wn.ARG_CHANGED_KIND,
        description: `${t.name}.${e.name} arg ${o.name} has changed type from ${String(o.type)} to ${String(s.type)}.`
      });
    else if (o.defaultValue !== void 0)
      if (s.defaultValue === void 0)
        r.push({
          type: Wo.ARG_DEFAULT_VALUE_CHANGE,
          description: `${t.name}.${e.name} arg ${o.name} defaultValue was removed.`
        });
      else {
        const l = WT(o.defaultValue, o.type), u = WT(s.defaultValue, s.type);
        l !== u && r.push({
          type: Wo.ARG_DEFAULT_VALUE_CHANGE,
          description: `${t.name}.${e.name} arg ${o.name} has changed defaultValue from ${l} to ${u}.`
        });
      }
  for (const o of i.added)
    vl(o) ? r.push({
      type: Wn.REQUIRED_ARG_ADDED,
      description: `A required arg ${o.name} on ${t.name}.${e.name} was added.`
    }) : r.push({
      type: Wo.OPTIONAL_ARG_ADDED,
      description: `An optional arg ${o.name} on ${t.name}.${e.name} was added.`
    });
  return r;
}
function Td(t, e) {
  return Mn(t) ? (
    // if they're both lists, make sure the underlying types are compatible
    Mn(e) && Td(
      t.ofType,
      e.ofType
    ) || // moving from nullable to non-null of the same underlying type is safe
    St(e) && Td(t, e.ofType)
  ) : St(t) ? St(e) && Td(t.ofType, e.ofType) : (
    // if they're both named types, see if their names are equivalent
    zh(e) && t.name === e.name || // moving from nullable to non-null of the same underlying type is safe
    St(e) && Td(t, e.ofType)
  );
}
function Gd(t, e) {
  return Mn(t) ? Mn(e) && Gd(t.ofType, e.ofType) : St(t) ? (
    // if they're both non-null, make sure the underlying types are
    // compatible
    St(e) && Gd(
      t.ofType,
      e.ofType
    ) || // moving from non-null to nullable of the same underlying type is safe
    !St(e) && Gd(t.ofType, e)
  ) : zh(e) && t.name === e.name;
}
function GT(t) {
  if (co(t))
    return "a Scalar type";
  if (Yt(t))
    return "an Object type";
  if (an(t))
    return "an Interface type";
  if (Er(t))
    return "a Union type";
  if (hr(t))
    return "an Enum type";
  if (Sn(t))
    return "an Input type";
  Zn(!1, "Unexpected type: " + _e(t));
}
function WT(t, e) {
  const n = Ha(t, e);
  return n != null || Zn(!1), An(t0(n));
}
function ya(t, e) {
  const n = [], r = [], i = [], o = ma(t, ({ name: a }) => a), s = ma(e, ({ name: a }) => a);
  for (const a of t) {
    const l = s[a.name];
    l === void 0 ? r.push(a) : i.push([a, l]);
  }
  for (const a of e)
    o[a.name] === void 0 && n.push(a);
  return {
    added: n,
    persisted: i,
    removed: r
  };
}
const PH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BREAK: ic,
  get BreakingChangeType() {
    return Wn;
  },
  DEFAULT_DEPRECATION_REASON: j_,
  get DangerousChangeType() {
    return Wo;
  },
  get DirectiveLocation() {
    return ft;
  },
  ExecutableDefinitionsRule: h$,
  FieldsOnCorrectTypeRule: p$,
  FragmentsOnCompositeTypesRule: g$,
  GRAPHQL_MAX_INT: Qg,
  GRAPHQL_MIN_INT: Jg,
  GraphQLBoolean: Ai,
  GraphQLDeprecatedDirective: Jy,
  GraphQLDirective: Yo,
  GraphQLEnumType: ul,
  GraphQLError: ye,
  GraphQLFloat: c$,
  GraphQLID: F_,
  GraphQLIncludeDirective: L_,
  GraphQLInputObjectType: zc,
  GraphQLInt: u$,
  GraphQLInterfaceType: Uc,
  GraphQLList: jr,
  GraphQLNonNull: It,
  GraphQLObjectType: Do,
  GraphQLOneOfDirective: U_,
  GraphQLScalarType: Ds,
  GraphQLSchema: yf,
  GraphQLSkipDirective: B_,
  GraphQLSpecifiedByDirective: V_,
  GraphQLString: Xn,
  GraphQLUnionType: qc,
  get Kind() {
    return z;
  },
  KnownArgumentNamesRule: m$,
  KnownDirectivesRule: oE,
  KnownFragmentNamesRule: v$,
  KnownTypeNamesRule: sE,
  Lexer: I_,
  Location: UP,
  LoneAnonymousOperationRule: b$,
  LoneSchemaDefinitionRule: w$,
  MaxIntrospectionDepthRule: S$,
  NoDeprecatedCustomRule: Zz,
  NoFragmentCyclesRule: _$,
  NoSchemaIntrospectionCustomRule: eH,
  NoUndefinedVariablesRule: E$,
  NoUnusedFragmentsRule: k$,
  NoUnusedVariablesRule: T$,
  get OperationTypeNode() {
    return Sr;
  },
  OverlappingFieldsCanBeMergedRule: C$,
  PossibleFragmentSpreadsRule: D$,
  PossibleTypeExtensionsRule: I$,
  ProvidedRequiredArgumentsRule: N$,
  ScalarLeafsRule: $$,
  SchemaMetaFieldDef: uh,
  SingleFieldSubscriptionsRule: j$,
  Source: Gy,
  Token: O_,
  get TokenKind() {
    return Se;
  },
  TypeInfo: eE,
  get TypeKind() {
    return pn;
  },
  TypeMetaFieldDef: ch,
  TypeNameMetaFieldDef: fh,
  UniqueArgumentDefinitionNamesRule: V$,
  UniqueArgumentNamesRule: cE,
  UniqueDirectiveNamesRule: U$,
  UniqueDirectivesPerLocationRule: fE,
  UniqueEnumValueNamesRule: q$,
  UniqueFieldDefinitionNamesRule: z$,
  UniqueFragmentNamesRule: H$,
  UniqueInputFieldNamesRule: dE,
  UniqueOperationNamesRule: G$,
  UniqueOperationTypesRule: W$,
  UniqueTypeNamesRule: Y$,
  UniqueVariableNamesRule: X$,
  ValidationContext: nM,
  ValuesOfCorrectTypeRule: K$,
  VariablesAreInputTypesRule: Q$,
  VariablesInAllowedPositionRule: J$,
  __Directive: H_,
  __DirectiveLocation: G_,
  __EnumValue: Y_,
  __Field: W_,
  __InputValue: Wh,
  __Schema: Zy,
  __Type: Eo,
  __TypeKind: X_,
  assertAbstractType: jq,
  assertCompositeType: Bq,
  assertDirective: Hq,
  assertEnumType: Iq,
  assertEnumValueName: e$,
  assertInputObjectType: Nq,
  assertInputType: Mq,
  assertInterfaceType: n$,
  assertLeafType: Lq,
  assertListType: Pq,
  assertName: uo,
  assertNamedType: Uq,
  assertNonNullType: $q,
  assertNullableType: r$,
  assertObjectType: t$,
  assertOutputType: Fq,
  assertScalarType: Oq,
  assertSchema: K_,
  assertType: Rq,
  assertUnionType: Dq,
  assertValidName: TH,
  assertValidSchema: J_,
  assertWrappingType: Vq,
  astFromValue: Ha,
  buildASTSchema: yM,
  buildClientSchema: iH,
  buildSchema: aH,
  coerceInputValue: F$,
  concatAST: _H,
  createSourceEventStream: pM,
  defaultFieldResolver: Sw,
  defaultTypeResolver: cM,
  doTypesOverlap: mw,
  execute: r0,
  executeSync: oM,
  extendSchema: oH,
  findBreakingChanges: xH,
  findDangerousChanges: CH,
  formatError: KU,
  getArgumentValues: n0,
  getDirectiveValues: Gc,
  getEnterLeaveForKind: Vc,
  getIntrospectionQuery: gM,
  getLocation: Lm,
  getNamedType: hi,
  getNullableType: P_,
  getOperationAST: tH,
  getOperationRootType: nH,
  getVariableValues: L$,
  getVisitFn: xq,
  graphql: Wz,
  graphqlSync: Yz,
  introspectionFromSchema: rH,
  introspectionTypes: Yh,
  isAbstractType: Ts,
  isCompositeType: Os,
  isConstValueNode: yw,
  isDefinitionNode: iz,
  isDirective: Qy,
  isEnumType: hr,
  isEqualType: jm,
  isExecutableDefinitionNode: nE,
  isInputObjectType: Sn,
  isInputType: Ci,
  isInterfaceType: an,
  isIntrospectionType: Pu,
  isLeafType: Rs,
  isListType: Mn,
  isNamedType: zh,
  isNonNullType: St,
  isNullableType: Yy,
  isObjectType: Yt,
  isOutputType: il,
  isRequiredArgument: vl,
  isRequiredInputField: Xy,
  isScalarType: co,
  isSchema: f$,
  isSelectionNode: oz,
  isSpecifiedDirective: q_,
  isSpecifiedScalarType: Ky,
  isType: Uh,
  isTypeDefinitionNode: vf,
  isTypeExtensionNode: e0,
  isTypeNode: sz,
  isTypeSubTypeOf: cu,
  isTypeSystemDefinitionNode: rE,
  isTypeSystemExtensionNode: iE,
  isUnionType: Er,
  isValidNameError: TM,
  isValueNode: d$,
  isWrappingType: qh,
  lexicographicSortSchema: lH,
  locatedError: Wc,
  parse: gf,
  parseConstValue: yq,
  parseType: vq,
  parseValue: JP,
  print: An,
  printError: XU,
  printIntrospectionSchema: cH,
  printLocation: VP,
  printSchema: uH,
  printSourceLocation: R_,
  printType: wM,
  recommendedRules: Z$,
  resolveObjMapThunk: M_,
  resolveReadonlyArrayThunk: $_,
  responsePathAsArray: ci,
  separateOperations: EH,
  specifiedDirectives: bl,
  specifiedRules: eM,
  specifiedScalarTypes: Hh,
  stripIgnoredCharacters: kH,
  subscribe: Kz,
  syntaxError: wr,
  typeFromAST: Pi,
  validate: rM,
  validateSchema: Q_,
  valueFromAST: bs,
  valueFromASTUntyped: Bm,
  version: HU,
  versionInfo: GU,
  visit: mf,
  visitInParallel: N_,
  visitWithTypeInfo: tE
}, Symbol.toStringTag, { value: "Module" }));
var Zg = /* @__PURE__ */ new Map(), Ew = /* @__PURE__ */ new Map(), CM = !0, Wm = !1;
function AM(t) {
  return t.replace(/[\s,]+/g, " ").trim();
}
function $H(t) {
  return AM(t.source.body.substring(t.start, t.end));
}
function MH(t) {
  var e = /* @__PURE__ */ new Set(), n = [];
  return t.definitions.forEach(function(r) {
    if (r.kind === "FragmentDefinition") {
      var i = r.name.value, o = $H(r.loc), s = Ew.get(i);
      s && !s.has(o) ? CM && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : s || Ew.set(i, s = /* @__PURE__ */ new Set()), s.add(o), e.has(o) || (e.add(o), n.push(r));
    } else
      n.push(r);
  }), Fm(Fm({}, t), { definitions: n });
}
function FH(t) {
  var e = new Set(t.definitions);
  e.forEach(function(r) {
    r.loc && delete r.loc, Object.keys(r).forEach(function(i) {
      var o = r[i];
      o && typeof o == "object" && e.add(o);
    });
  });
  var n = t.loc;
  return n && (delete n.startToken, delete n.endToken), t;
}
function LH(t) {
  var e = AM(t);
  if (!Zg.has(e)) {
    var n = gf(t, {
      experimentalFragmentVariables: Wm,
      allowLegacyFragmentVariables: Wm
    });
    if (!n || n.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Zg.set(e, FH(MH(n)));
  }
  return Zg.get(e);
}
function On(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  typeof t == "string" && (t = [t]);
  var r = t[0];
  return e.forEach(function(i, o) {
    i && i.kind === "Document" ? r += i.loc.source.body : r += i, r += t[o + 1];
  }), LH(r);
}
function BH() {
  Zg.clear(), Ew.clear();
}
function jH() {
  CM = !1;
}
function VH() {
  Wm = !0;
}
function UH() {
  Wm = !1;
}
var Bf = {
  gql: On,
  resetCaches: BH,
  disableFragmentWarnings: jH,
  enableExperimentalFragmentVariables: VH,
  disableExperimentalFragmentVariables: UH
};
(function(t) {
  t.gql = Bf.gql, t.resetCaches = Bf.resetCaches, t.disableFragmentWarnings = Bf.disableFragmentWarnings, t.enableExperimentalFragmentVariables = Bf.enableExperimentalFragmentVariables, t.disableExperimentalFragmentVariables = Bf.disableExperimentalFragmentVariables;
})(On || (On = {}));
On.default = On;
var dn;
(function(t) {
  t.Center = "center", t.End = "end", t.Justify = "justify", t.Start = "start", t.Unset = "unset";
})(dn || (dn = {}));
var st;
(function(t) {
  t.Eighth = "eighth", t.Fifth = "fifth", t.First = "first", t.Fourth = "fourth", t.Second = "second", t.Seventh = "seventh", t.Sixth = "sixth", t.Third = "third", t.Unset = "unset";
})(st || (st = {}));
var YT;
(function(t) {
  t.Column = "column", t.ColumnReverse = "columnReverse", t.Row = "row", t.RowReverse = "rowReverse", t.Unset = "unset";
})(YT || (YT = {}));
var Ar;
(function(t) {
  t.Eighth = "eighth", t.Fifth = "fifth", t.First = "first", t.Fourth = "fourth", t.Second = "second", t.Seventh = "seventh", t.Sixth = "sixth", t.Third = "third";
})(Ar || (Ar = {}));
var yr;
(function(t) {
  t.Eighth = "eighth", t.Fifth = "fifth", t.First = "first", t.Fourth = "fourth", t.Second = "second", t.Seventh = "seventh", t.Sixth = "sixth", t.Third = "third";
})(yr || (yr = {}));
var rr;
(function(t) {
  t.Italic = "italic", t.Normal = "normal", t.Unset = "unset";
})(rr || (rr = {}));
var Gn;
(function(t) {
  t.Bold = "bold", t.Bolder = "bolder", t.Lighter = "lighter", t.Normal = "normal", t.Unset = "unset";
})(Gn || (Gn = {}));
var mo;
(function(t) {
  t.BottomUp = "bottomUp", t.MiddleOut = "middleOut", t.TopDown = "topDown", t.Unset = "unset";
})(mo || (mo = {}));
var ir;
(function(t) {
  t.Overline = "overline", t.Strikethrough = "strikethrough", t.Underline = "underline", t.Unset = "unset";
})(ir || (ir = {}));
const qH = On`
    mutation GenerateAiImage($prompt: String!, $jwt: String!, $ownerName: String!, $stackId: String!, $useContext: Boolean, $code: String, $filter: String) {
  generateAiImage(
    prompt: $prompt
    jwt: $jwt
    ownerName: $ownerName
    stackId: $stackId
    useContext: $useContext
    code: $code
    filter: $filter
  ) {
    ... on QpFile {
      __typename
      id
      url
      userDefinedName
      altText
    }
    ... on FileErrorMessage {
      __typename
      success
      message
    }
  }
}
    `, zH = On`
    query GetFile($id: String!, $jwt: String!) {
  getFile(id: $id, jwt: $jwt) {
    ... on QpFile {
      __typename
      altText
      cloudFlareName
      fileName
      fileType
      id
      ownerName
      stackId
      tags
      uploadedOn
      url
      userDefinedName
    }
    ... on FileErrorMessage {
      __typename
      success
      message
    }
  }
}
    `, HH = On`
    query GetFiles($jwt: String!) {
  getFiles(jwt: $jwt) {
    files {
      altText
      cloudFlareName
      fileName
      fileType
      id
      ownerName
      stackId
      tags
      uploadedOn
      url
      userDefinedName
    }
  }
}
    `, GH = On`
    query GetFilterNames($jwt: String!) {
  getFilterNames(jwt: $jwt) {
    filterName
    ownerName
  }
}
    `, WH = On`
    query GetFilter($ownerName: String!, $filterName: String!) {
  getFilter(ownerName: $ownerName, filterName: $filterName) {
    align
    autospace
    background
    borderBlockEnd
    borderInlineEnd
    borderInlineStart
    borderBlockStart
    borderColor
    color
    cornerRadius
    decoration
    filterName
    font
    fontSize
    fontStyle
    lineHeightMultiplier
    marginBottomMultiplier
    marginTopMultiplier
    ownerName
    paddingBlockEnd
    paddingInlineStart
    paddingInlineEnd
    paddingBlockStart
    publish
    startingPoint
    weight
    audioPlayer {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    blank {
      fontSize
      leading
    }
    box {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    bullet {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      space
      markerColor
      weight
    }
    button {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    caption {
      align
      backdropOpacity
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    cell {
      align
      startingPoint
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
    }
    tableCell {
      align
      startingPoint
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
    }
    colors {
      first
      second
      third
      eighth
      fourth
      fifth
      sixth
      seventh
    }
    fonts {
      first
      second
      third
      eighth
      fourth
      fifth
      sixth
      seventh
    }
    fontSizes {
      first
      second
      third
      eighth
      fourth
      fifth
      sixth
      seventh
    }
    frame {
      paddingBlockEnd
      paddingBlockStart
      paddingInlineEnd
      paddingInlineStart
    }
    grid {
      align
      columnGap
      paddingBlockEnd
      paddingBlockStart
      paddingInlineEnd
      paddingInlineStart
      rowGap
      singleColumnInPortrait
      startingPoint
    }
    image {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      cornerRadius
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingBlockStart
      paddingInlineEnd
      paddingInlineStart
    }
    line {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    link {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      visited
      weight
    }
    list {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    paragraph {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    columnTitle {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    read {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    stickyFooter {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      cornerRadius
      marginTopMultiplier
      marginBottomMultiplier
      opacity
      startingPoint
    }
    stickyHeader {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      cornerRadius
      marginTopMultiplier
      marginBottomMultiplier
      opacity
      startingPoint
    }
    subtitle {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    supertitle {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    title {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    table {
      align
      columnGap
      paddingBlockEnd
      paddingBlockStart
      paddingInlineEnd
      paddingInlineStart
      rowGap
      singleColumnInPortrait
      startingPoint
      color
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      weight
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      cornerRadius
      marginTopMultiplier
      marginBottomMultiplier
      opacity
    }
  }
}
    `, YH = On`
    query GetFont($fontName: String!) {
  getFont(fontName: $fontName) {
    fontData
    fontName
  }
}
    `, XH = On`
    query GetStack($ownerName: String!, $stackCfKey: String!, $jwt: String!) {
  getStack(ownerName: $ownerName, stackCfKey: $stackCfKey, jwt: $jwt) {
    ... on Stack {
      __typename
      audioFiles {
        altText
        url
        userDefinedName
      }
      code
      created
      dataFiles {
        altText
        url
        userDefinedName
      }
      filters
      ownerName
      publish
      stackCfKey
      stackId
      updated
      images {
        altText
        url
        userDefinedName
      }
    }
    ... on StackErrorMessage {
      __typename
      success
      message
    }
  }
}
    `, KH = On`
    query GetStackCfKeys($ownerName: String!, $jwt: String!) {
  getStackCfKeys(ownerName: $ownerName, jwt: $jwt) {
    ... on StackCfKeys {
      __typename
      stackCfKeys {
        key
        created
        updated
      }
    }
    ... on StackErrorMessage {
      __typename
      success
      message
    }
  }
}
    `, QH = On`
    query GetStackIsPublished($ownerName: String!, $stackCfKey: String!, $jwt: String!) {
  getStackIsPublished(ownerName: $ownerName, stackCfKey: $stackCfKey, jwt: $jwt)
}
    `, JH = On`
    query SendMail($emailTo: String!, $emailStackCfKey: String!, $resendId: String!) {
  sendMail(
    emailTo: $emailTo
    emailStackCfKey: $emailStackCfKey
    resendId: $resendId
  ) {
    success
    message
  }
}
    `, ZH = On`
    mutation UpdateFile($altText: String!, $cloudFlareName: String!, $fileName: String!, $fileType: String!, $id: String!, $jwt: String!, $ownerName: String!, $stackId: String!, $tags: [String!]!, $uploadedOn: Float!, $url: String!, $userDefinedName: String!) {
  updateFile(
    altText: $altText
    cloudFlareName: $cloudFlareName
    fileName: $fileName
    fileType: $fileType
    id: $id
    jwt: $jwt
    ownerName: $ownerName
    stackId: $stackId
    tags: $tags
    uploadedOn: $uploadedOn
    url: $url
    userDefinedName: $userDefinedName
  ) {
    success
    message
  }
}
    `, eG = On`
    mutation DeleteFile($fileId: String!, $jwt: String!) {
  deleteFile(fileId: $fileId, jwt: $jwt) {
    success
    message
  }
}
    `, tG = On`
    mutation UpdateFilter($align: Align!, $autospace: Boolean!, $audioPlayer: AudioPlayerInput!, $background: String!, $borderBlockEnd: Float!, $borderInlineEnd: Float!, $borderInlineStart: Float!, $borderBlockStart: Float!, $borderColor: ColorChoice!, $blank: BlankInput!, $box: BoxInput!, $bullet: BulletInput!, $button: ButtonInput!, $caption: CaptionInput!, $cell: CellInput!, $tableCell: TableCellInput!, $color: String!, $colors: ColorsInput!, $cornerRadius: Float!, $decoration: TextDecoration!, $filterName: String!, $font: FontChoice!, $fonts: FontsInput!, $fontSize: FontSizeChoice!, $fontSizes: FontSizesInput!, $fontStyle: FontStyle!, $frame: FrameInput!, $grid: GridInput!, $image: ImageFilterInput!, $line: LineInput!, $lineHeightMultiplier: Float!, $link: LinkInput!, $list: ListInput!, $marginBottomMultiplier: Float!, $marginTopMultiplier: Float!, $ownerName: String!, $paddingBlockEnd: Float!, $paddingBlockStart: Float!, $paddingInlineEnd: Float!, $paddingInlineStart: Float!, $paragraph: ParagraphInput!, $publish: Boolean!, $read: ReadInput!, $stickyFooter: StickyFooterInput!, $stickyHeader: StickyHeaderInput!, $startingPoint: StartingPoint!, $subtitle: SubTitleInput!, $supertitle: SuperTitleInput!, $title: TitleInput!, $weight: FontWeight!, $columnTitle: ColumnTitleInput!, $table: TableInput!) {
  updateFilter(
    align: $align
    audioPlayer: $audioPlayer
    autospace: $autospace
    background: $background
    borderBlockEnd: $borderBlockEnd
    borderInlineEnd: $borderInlineEnd
    borderInlineStart: $borderInlineStart
    borderBlockStart: $borderBlockStart
    borderColor: $borderColor
    blank: $blank
    box: $box
    bullet: $bullet
    button: $button
    caption: $caption
    cell: $cell
    tableCell: $tableCell
    color: $color
    colors: $colors
    cornerRadius: $cornerRadius
    decoration: $decoration
    filterName: $filterName
    font: $font
    fonts: $fonts
    fontSize: $fontSize
    fontSizes: $fontSizes
    fontStyle: $fontStyle
    frame: $frame
    grid: $grid
    image: $image
    line: $line
    lineHeightMultiplier: $lineHeightMultiplier
    link: $link
    list: $list
    marginBottomMultiplier: $marginBottomMultiplier
    marginTopMultiplier: $marginTopMultiplier
    ownerName: $ownerName
    paddingBlockEnd: $paddingBlockEnd
    paddingBlockStart: $paddingBlockStart
    paddingInlineEnd: $paddingInlineEnd
    paddingInlineStart: $paddingInlineStart
    paragraph: $paragraph
    publish: $publish
    read: $read
    stickyFooter: $stickyFooter
    stickyHeader: $stickyHeader
    startingPoint: $startingPoint
    subtitle: $subtitle
    supertitle: $supertitle
    title: $title
    weight: $weight
    columnTitle: $columnTitle
    table: $table
  ) {
    success
    message
  }
}
    `, nG = On`
    mutation DeleteStack($jwt: String!, $ownerName: String!, $stackCfKey: String!) {
  deleteStack(ownerName: $ownerName, stackCfKey: $stackCfKey, jwt: $jwt) {
    success
    message
  }
}
    `, rG = On`
    mutation UpdateStack($audioFiles: [AudioFileInput!]!, $code: String, $created: Float!, $dataFiles: [DataFileInput!]!, $filters: [String!]!, $images: [ImageInput!]!, $jwt: String!, $navigationType: String!, $ownerName: String!, $publish: Boolean!, $stackCfKey: String!, $stackId: String!, $storyName: String, $updated: Float!) {
  updateStack(
    audioFiles: $audioFiles
    code: $code
    created: $created
    dataFiles: $dataFiles
    filters: $filters
    images: $images
    jwt: $jwt
    ownerName: $ownerName
    publish: $publish
    stackCfKey: $stackCfKey
    stackId: $stackId
    storyName: $storyName
    navigationType: $navigationType
    updated: $updated
  ) {
    success
    message
  }
}
    `, iG = On`
    mutation RenameStack($jwt: String!, $newStackCfKey: String!, $ownerName: String!, $stackCfKey: String!) {
  renameStack(
    jwt: $jwt
    newStackCfKey: $newStackCfKey
    ownerName: $ownerName
    stackCfKey: $stackCfKey
  ) {
    success
    message
  }
}
    `, oG = On`
    mutation PublishStack($jwt: String!, $stackCfKey: String!) {
  publishStack(stackCfKey: $stackCfKey, jwt: $jwt) {
    success
    message
  }
}
    `, sG = On`
    mutation UnPublishStack($jwt: String!, $stackCfKey: String!) {
  unPublishStack(stackCfKey: $stackCfKey, jwt: $jwt) {
    success
    message
  }
}
    `, aG = On`
    mutation WriteUserRecord($id: String!, $recordType: String!, $stack: String!, $stackId: String!, $value: String!, $created: Float!) {
  writeUserRecord(
    id: $id
    recordType: $recordType
    stack: $stack
    stackId: $stackId
    value: $value
    created: $created
  ) {
    success
    message
  }
}
    `, lG = On`
    query ViewFile($id: String!) {
  viewFile(id: $id) {
    altText
    url
    userDefinedName
  }
}
    `, uG = On`
    query ViewStack($stackCfKey: String!) {
  viewStack(stackCfKey: $stackCfKey) {
    code
    filters
    stackId
    audioFiles {
      userDefinedName
      url
      altText
    }
    dataFiles {
      userDefinedName
      url
      altText
    }
    images {
      userDefinedName
      url
      altText
    }
  }
}
    `, cG = (t, e, n, r) => t();
function gE(t, e = cG) {
  return {
    GenerateAiImage(n, r, i) {
      return e((o) => t.request({
        document: qH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GenerateAiImage", "mutation", n);
    },
    GetFile(n, r, i) {
      return e((o) => t.request({
        document: zH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GetFile", "query", n);
    },
    GetFiles(n, r, i) {
      return e((o) => t.request({
        document: HH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GetFiles", "query", n);
    },
    GetFilterNames(n, r, i) {
      return e((o) => t.request({
        document: GH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GetFilterNames", "query", n);
    },
    GetFilter(n, r, i) {
      return e((o) => t.request({
        document: WH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GetFilter", "query", n);
    },
    GetFont(n, r, i) {
      return e((o) => t.request({
        document: YH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GetFont", "query", n);
    },
    GetStack(n, r, i) {
      return e((o) => t.request({
        document: XH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GetStack", "query", n);
    },
    GetStackCfKeys(n, r, i) {
      return e((o) => t.request({
        document: KH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GetStackCfKeys", "query", n);
    },
    GetStackIsPublished(n, r, i) {
      return e((o) => t.request({
        document: QH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "GetStackIsPublished", "query", n);
    },
    SendMail(n, r, i) {
      return e((o) => t.request({
        document: JH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "SendMail", "query", n);
    },
    UpdateFile(n, r, i) {
      return e((o) => t.request({
        document: ZH,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "UpdateFile", "mutation", n);
    },
    DeleteFile(n, r, i) {
      return e((o) => t.request({
        document: eG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "DeleteFile", "mutation", n);
    },
    UpdateFilter(n, r, i) {
      return e((o) => t.request({
        document: tG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "UpdateFilter", "mutation", n);
    },
    DeleteStack(n, r, i) {
      return e((o) => t.request({
        document: nG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "DeleteStack", "mutation", n);
    },
    UpdateStack(n, r, i) {
      return e((o) => t.request({
        document: rG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "UpdateStack", "mutation", n);
    },
    RenameStack(n, r, i) {
      return e((o) => t.request({
        document: iG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "RenameStack", "mutation", n);
    },
    PublishStack(n, r, i) {
      return e((o) => t.request({
        document: oG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "PublishStack", "mutation", n);
    },
    UnPublishStack(n, r, i) {
      return e((o) => t.request({
        document: sG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "UnPublishStack", "mutation", n);
    },
    WriteUserRecord(n, r, i) {
      return e((o) => t.request({
        document: aG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "WriteUserRecord", "mutation", n);
    },
    ViewFile(n, r, i) {
      return e((o) => t.request({
        document: lG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "ViewFile", "query", n);
    },
    ViewStack(n, r, i) {
      return e((o) => t.request({
        document: uG,
        variables: n,
        requestHeaders: {
          ...r,
          ...o
        },
        signal: i
      }), "ViewStack", "query", n);
    }
  };
}
A_`
   0% { opacity:0; }
  100% { opacity:1; }
`;
A_`
  0% {
    box-shadow: 0 0 0 1px rgba(0, 255, 0, 1);
  }
  100% {
    box-shadow: 0 0 0 0px rgba(0, 255, 0, 1);
  }
`;
function RM(t) {
  if (!t) return t;
  const e = ["border", "cornerRadius", "fontSize", "gap", "height", "lineHeight", "lineHeightMultiplier", "opacity", "paddingBlockEnd", "paddingInlineStart", "paddingInlineEnd", "paddingBlockStart", "space"];
  for (const n of Object.keys(t))
    e.includes(n) && typeof t[n] != "number" && (t[n] = t[n] ? parseFloat(t[n]) : 0), typeof t[n] == "object" && RM(t[n]);
  return t;
}
let nr = !1, ho = "http://localhost:3000";
typeof window < "u" && (nr = process.env.NODE_ENV === "development" && window.location.host === "localhost:3000", ho = window.location.origin);
const Yc = {
  viewerUrl: () => {
    const t = {
      production: "https://author.quickpoint.me/viewer/index.html",
      staging: "https://stage-author.quickpoint.me/viewer/index.html",
      development: "/viewer/index.html",
      test: "/viewer/index.html"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  addowner: () => {
    const t = {
      production: "https://addowner-production.quickpointme.workers.dev",
      staging: "https://addowner-staging.quickpointme.workers.dev",
      development: "/addowner",
      test: "http://testing/addowner",
      honoTest: "http://0.0.0.0:9000"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  checkOwner: () => {
    const t = {
      production: "https://checkowner-production.quickpointme.workers.dev",
      staging: "https://checkowner-staging.quickpointme.workers.dev",
      development: "/checkowner",
      test: "http://testing/checkowner",
      honoTest: "http://0.0.0.0:9001"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  getOwner: () => {
    const t = {
      production: "https://getowner-production.quickpointme.workers.dev",
      staging: "https://getowner-staging.quickpointme.workers.dev",
      development: "/getowner",
      test: "http://testing/getowner",
      honoTest: "http://0.0.0.0:9002"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlGetFile: () => {
    const t = {
      production: "https://gql-get-file-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-get-file-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-get-file`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9003/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlGetFilter: () => {
    const t = {
      production: "https://gql-get-filter-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-get-filter-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-get-filter`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9004/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  getFont: () => {
    const t = {
      production: "https://get-font-production.quickpointme.workers.dev",
      staging: "https://get-font-staging.quickpointme.workers.dev",
      development: "/get-font",
      test: "http://testing/get-font-url",
      honoTest: "http://0.0.0.0:9005"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlGetStack: () => {
    const t = {
      production: "https://gql-get-stack-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-get-stack-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-get-stack`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9006/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlViewFile: () => {
    const t = {
      production: "https://gql-view-file-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-view-file-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-view-file`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9007/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlViewStack: () => {
    const t = {
      production: "https://gql-view-stack-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-view-stack-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-view-stack`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9008/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlWriteFile: () => {
    const t = {
      production: "https://gql-write-file-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-write-file-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-write-file`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9009/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlWriteFilter: () => {
    const t = {
      production: "https://gql-write-filter-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-write-filter-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-write-filter`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9010/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlWriteStack: () => {
    const t = {
      production: "https://gql-write-stack-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-write-stack-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-write-stack`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9011/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlWriteUserRecord: () => {
    const t = {
      production: "https://gql-write-user-record-production.quickpointme.workers.dev/graphql",
      staging: "https://gql-write-user-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-write-user-record`,
      test: "http://testing/gql",
      honoTest: "http://0.0.0.0:9012/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  gqlGenerateAiImage: () => {
    const t = {
      production: "https://ai-image-generator-production.quickpointme.workers.dev/graphql",
      staging: "https://ai-image-generator-staging.quickpointme.workers.dev/graphql",
      development: `${ho}/gql-ai-image`,
      test: "http://testing/gql-ai-image",
      honoTest: "http://0.0.0.0:9026/graphql"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  heatmapCollector: () => {
    const t = {
      production: "https://heatmap-collector.quickpointme.workers.dev",
      staging: "https://heatmap-collector-staging.quickpointme.workers.dev",
      development: "/heatmap-collector",
      test: "http://testing/heatmap-collector",
      honoTest: "http://0.0.0.0:9025/heatmap-collector"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  layoutAi: () => {
    const t = {
      production: "https://layout-ai.quickpointme.workers.dev",
      staging: "https://layout-ai-staging.quickpointme.workers.dev",
      development: `${ho}/layout-ai`,
      test: "http://testing",
      honoTest: "http://0.0.0.0:9023"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  uploadDatafileUrl: ({
    fileName: t,
    jwt: e,
    isPopOutInDev: n
  }) => {
    const r = {
      production: `https://upload-datafile-url-production.quickpointme.workers.dev/${t}/${e}`,
      staging: `https://upload-datafile-url-staging.quickpointme.workers.dev/${t}/${e}`,
      development: `/upload-datafile-url/${t}/${e}`,
      test: `http://testing/upload-datafile-url/${t}/${e}`,
      honoTest: `http://0.0.0.0:9022/${t}/${e}`
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return n ? r.development : r[process.env.NODE_ENV];
  },
  uploadImageUrl: (t, e) => {
    const n = {
      production: `https://upload-image-url-production.quickpointme.workers.dev/${t}`,
      staging: `https://upload-image-url-staging.quickpointme.workers.dev/${t}`,
      development: `/upload-image-url/${t}`,
      test: `http://testing/upload-image-url/${t}`,
      honoTest: `http://0.0.0.0:9013/${t}`
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return e ? n.development : n[process.env.NODE_ENV];
  },
  vespaTransfer: (t) => ({
    production: "https://transfer-to-vespa-production.quickpointme.workers.dev",
    staging: "https://transfer-to-vespa-staging.quickpointme.workers.dev",
    development: "http://0.0.0.0:9015"
  })[t],
  authorUrl: () => {
    const t = {
      production: "https://quickpoint.me/author",
      staging: "http://localhost:3000/author",
      development: "http://localhost:3000/author"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  },
  mobilePreviewUrl: () => {
    const t = {
      production: "/viewer/index.html",
      staging: "/viewer/index.html",
      development: "/viewer/index.html"
    };
    if (!process.env.NODE_ENV) throw new Error("Node env error");
    return nr ? t.development : t[process.env.NODE_ENV];
  }
}, OM = [
  "===",
  "---",
  "-->",
  "|",
  "[]",
  "^^^",
  "vvv"
  /// sticky footer
], Ym = "```", _t = {
  "===": {
    controlChar: "==="
  },
  "|": {
    controlChar: "|"
  },
  "---": {
    controlChar: "---"
  },
  "-->": {
    controlChar: "-->"
  },
  "[]": {
    controlChar: "[]"
  },
  "^^^": {
    controlChar: "^^^"
  },
  vvv: {
    controlChar: "vvv"
  }
};
function hh(t) {
  return !!OM.includes(t);
}
let kw = [], DM = [];
(() => {
  let t = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((e) => e ? parseInt(e, 36) : 1);
  for (let e = 0, n = 0; e < t.length; e++)
    (e % 2 ? DM : kw).push(n = n + t[e]);
})();
function fG(t) {
  if (t < 768) return !1;
  for (let e = 0, n = kw.length; ; ) {
    let r = e + n >> 1;
    if (t < kw[r]) n = r;
    else if (t >= DM[r]) e = r + 1;
    else return !0;
    if (e == n) return !1;
  }
}
function XT(t) {
  return t >= 127462 && t <= 127487;
}
const KT = 8205;
function dG(t, e, n = !0, r = !0) {
  return (n ? IM : hG)(t, e, r);
}
function IM(t, e, n) {
  if (e == t.length) return e;
  e && NM(t.charCodeAt(e)) && PM(t.charCodeAt(e - 1)) && e--;
  let r = av(t, e);
  for (e += QT(r); e < t.length; ) {
    let i = av(t, e);
    if (r == KT || i == KT || n && fG(i))
      e += QT(i), r = i;
    else if (XT(i)) {
      let o = 0, s = e - 2;
      for (; s >= 0 && XT(av(t, s)); )
        o++, s -= 2;
      if (o % 2 == 0) break;
      e += 2;
    } else
      break;
  }
  return e;
}
function hG(t, e, n) {
  for (; e > 0; ) {
    let r = IM(t, e - 2, n);
    if (r < e) return r;
    e--;
  }
  return 0;
}
function av(t, e) {
  let n = t.charCodeAt(e);
  if (!PM(n) || e + 1 == t.length) return n;
  let r = t.charCodeAt(e + 1);
  return NM(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function NM(t) {
  return t >= 56320 && t < 57344;
}
function PM(t) {
  return t >= 55296 && t < 56320;
}
function QT(t) {
  return t < 65536 ? 1 : 2;
}
class Zt {
  /**
  Get the line description around the given position.
  */
  lineAt(e) {
    if (e < 0 || e > this.length)
      throw new RangeError(`Invalid position ${e} in document of length ${this.length}`);
    return this.lineInner(e, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(e) {
    if (e < 1 || e > this.lines)
      throw new RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
    return this.lineInner(e, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(e, n, r) {
    [e, n] = Xc(this, e, n);
    let i = [];
    return this.decompose(
      0,
      e,
      i,
      2
      /* Open.To */
    ), r.length && r.decompose(
      0,
      r.length,
      i,
      3
      /* Open.To */
    ), this.decompose(
      n,
      this.length,
      i,
      1
      /* Open.From */
    ), gs.from(i, this.length - (n - e) + r.length);
  }
  /**
  Append another document to this one.
  */
  append(e) {
    return this.replace(this.length, this.length, e);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(e, n = this.length) {
    [e, n] = Xc(this, e, n);
    let r = [];
    return this.decompose(e, n, r, 0), gs.from(r, n - e);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(e) {
    if (e == this)
      return !0;
    if (e.length != this.length || e.lines != this.lines)
      return !1;
    let n = this.scanIdentical(e, 1), r = this.length - this.scanIdentical(e, -1), i = new Wd(this), o = new Wd(e);
    for (let s = n, a = n; ; ) {
      if (i.next(s), o.next(s), s = 0, i.lineBreak != o.lineBreak || i.done != o.done || i.value != o.value)
        return !1;
      if (a += i.value.length, i.done || a >= r)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(e = 1) {
    return new Wd(this, e);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(e, n = this.length) {
    return new $M(this, e, n);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(e, n) {
    let r;
    if (e == null)
      r = this.iter();
    else {
      n == null && (n = this.lines + 1);
      let i = this.line(e).from;
      r = this.iterRange(i, Math.max(i, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new MM(r);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let e = [];
    return this.flatten(e), e;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(e) {
    if (e.length == 0)
      throw new RangeError("A document must have at least one line");
    return e.length == 1 && !e[0] ? Zt.empty : e.length <= 32 ? new Kn(e) : gs.from(Kn.split(e, []));
  }
}
class Kn extends Zt {
  constructor(e, n = pG(e)) {
    super(), this.text = e, this.length = n;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e, n, r, i) {
    for (let o = 0; ; o++) {
      let s = this.text[o], a = i + s.length;
      if ((n ? r : a) >= e)
        return new gG(i, a, r, s);
      i = a + 1, r++;
    }
  }
  decompose(e, n, r, i) {
    let o = e <= 0 && n >= this.length ? this : new Kn(JT(this.text, e, n), Math.min(n, this.length) - Math.max(0, e));
    if (i & 1) {
      let s = r.pop(), a = em(o.text, s.text.slice(), 0, o.length);
      if (a.length <= 32)
        r.push(new Kn(a, s.length + o.length));
      else {
        let l = a.length >> 1;
        r.push(new Kn(a.slice(0, l)), new Kn(a.slice(l)));
      }
    } else
      r.push(o);
  }
  replace(e, n, r) {
    if (!(r instanceof Kn))
      return super.replace(e, n, r);
    [e, n] = Xc(this, e, n);
    let i = em(this.text, em(r.text, JT(this.text, 0, e)), n), o = this.length + r.length - (n - e);
    return i.length <= 32 ? new Kn(i, o) : gs.from(Kn.split(i, []), o);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = Xc(this, e, n);
    let i = "";
    for (let o = 0, s = 0; o <= n && s < this.text.length; s++) {
      let a = this.text[s], l = o + a.length;
      o > e && s && (i += r), e < l && n > o && (i += a.slice(Math.max(0, e - o), n - o)), o = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let n of this.text)
      e.push(n);
  }
  scanIdentical() {
    return 0;
  }
  static split(e, n) {
    let r = [], i = -1;
    for (let o of e)
      r.push(o), i += o.length + 1, r.length == 32 && (n.push(new Kn(r, i)), r = [], i = -1);
    return i > -1 && n.push(new Kn(r, i)), n;
  }
}
class gs extends Zt {
  constructor(e, n) {
    super(), this.children = e, this.length = n, this.lines = 0;
    for (let r of e)
      this.lines += r.lines;
  }
  lineInner(e, n, r, i) {
    for (let o = 0; ; o++) {
      let s = this.children[o], a = i + s.length, l = r + s.lines - 1;
      if ((n ? l : a) >= e)
        return s.lineInner(e, n, r, i);
      i = a + 1, r = l + 1;
    }
  }
  decompose(e, n, r, i) {
    for (let o = 0, s = 0; s <= n && o < this.children.length; o++) {
      let a = this.children[o], l = s + a.length;
      if (e <= l && n >= s) {
        let u = i & ((s <= e ? 1 : 0) | (l >= n ? 2 : 0));
        s >= e && l <= n && !u ? r.push(a) : a.decompose(e - s, n - s, r, u);
      }
      s = l + 1;
    }
  }
  replace(e, n, r) {
    if ([e, n] = Xc(this, e, n), r.lines < this.lines)
      for (let i = 0, o = 0; i < this.children.length; i++) {
        let s = this.children[i], a = o + s.length;
        if (e >= o && n <= a) {
          let l = s.replace(e - o, n - o, r), u = this.lines - s.lines + l.lines;
          if (l.lines < u >> 4 && l.lines > u >> 6) {
            let c = this.children.slice();
            return c[i] = l, new gs(c, this.length - (n - e) + r.length);
          }
          return super.replace(o, a, l);
        }
        o = a + 1;
      }
    return super.replace(e, n, r);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = Xc(this, e, n);
    let i = "";
    for (let o = 0, s = 0; o < this.children.length && s <= n; o++) {
      let a = this.children[o], l = s + a.length;
      s > e && o && (i += r), e < l && n > s && (i += a.sliceString(e - s, n - s, r)), s = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let n of this.children)
      n.flatten(e);
  }
  scanIdentical(e, n) {
    if (!(e instanceof gs))
      return 0;
    let r = 0, [i, o, s, a] = n > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1];
    for (; ; i += n, o += n) {
      if (i == s || o == a)
        return r;
      let l = this.children[i], u = e.children[o];
      if (l != u)
        return r + l.scanIdentical(u, n);
      r += l.length + 1;
    }
  }
  static from(e, n = e.reduce((r, i) => r + i.length + 1, -1)) {
    let r = 0;
    for (let h of e)
      r += h.lines;
    if (r < 32) {
      let h = [];
      for (let p of e)
        p.flatten(h);
      return new Kn(h, n);
    }
    let i = Math.max(
      32,
      r >> 5
      /* Tree.BranchShift */
    ), o = i << 1, s = i >> 1, a = [], l = 0, u = -1, c = [];
    function f(h) {
      let p;
      if (h.lines > o && h instanceof gs)
        for (let g of h.children)
          f(g);
      else h.lines > s && (l > s || !l) ? (d(), a.push(h)) : h instanceof Kn && l && (p = c[c.length - 1]) instanceof Kn && h.lines + p.lines <= 32 ? (l += h.lines, u += h.length + 1, c[c.length - 1] = new Kn(p.text.concat(h.text), p.length + 1 + h.length)) : (l + h.lines > i && d(), l += h.lines, u += h.length + 1, c.push(h));
    }
    function d() {
      l != 0 && (a.push(c.length == 1 ? c[0] : gs.from(c, u)), u = -1, l = c.length = 0);
    }
    for (let h of e)
      f(h);
    return d(), a.length == 1 ? a[0] : new gs(a, n);
  }
}
Zt.empty = /* @__PURE__ */ new Kn([""], 0);
function pG(t) {
  let e = -1;
  for (let n of t)
    e += n.length + 1;
  return e;
}
function em(t, e, n = 0, r = 1e9) {
  for (let i = 0, o = 0, s = !0; o < t.length && i <= r; o++) {
    let a = t[o], l = i + a.length;
    l >= n && (l > r && (a = a.slice(0, r - i)), i < n && (a = a.slice(n - i)), s ? (e[e.length - 1] += a, s = !1) : e.push(a)), i = l + 1;
  }
  return e;
}
function JT(t, e, n) {
  return em(t, [""], e, n);
}
class Wd {
  constructor(e, n = 1) {
    this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [n > 0 ? 1 : (e instanceof Kn ? e.text.length : e.children.length) << 1];
  }
  nextInner(e, n) {
    for (this.done = this.lineBreak = !1; ; ) {
      let r = this.nodes.length - 1, i = this.nodes[r], o = this.offsets[r], s = o >> 1, a = i instanceof Kn ? i.text.length : i.children.length;
      if (s == (n > 0 ? a : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((o & 1) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, e == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        e--;
      } else if (i instanceof Kn) {
        let l = i.text[s + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, l.length > Math.max(0, e))
          return this.value = e == 0 ? l : n > 0 ? l.slice(e) : l.slice(0, l.length - e), this;
        e -= l.length;
      } else {
        let l = i.children[s + (n < 0 ? -1 : 0)];
        e > l.length ? (e -= l.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(l), this.offsets.push(n > 0 ? 1 : (l instanceof Kn ? l.text.length : l.children.length) << 1));
      }
    }
  }
  next(e = 0) {
    return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
  }
}
class $M {
  constructor(e, n, r) {
    this.value = "", this.done = !1, this.cursor = new Wd(e, n > r ? -1 : 1), this.pos = n > r ? e.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  nextInner(e, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    e += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    let r = n < 0 ? this.pos - this.from : this.to - this.pos;
    e > r && (e = r), r -= e;
    let { value: i } = this.cursor.next(e);
    return this.pos += (i.length + e) * n, this.value = i.length <= r ? i : n < 0 ? i.slice(i.length - r) : i.slice(0, r), this.done = !this.value, this;
  }
  next(e = 0) {
    return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class MM {
  constructor(e) {
    this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(e = 0) {
    let { done: n, lineBreak: r, value: i } = this.inner.next(e);
    return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (Zt.prototype[Symbol.iterator] = function() {
  return this.iter();
}, Wd.prototype[Symbol.iterator] = $M.prototype[Symbol.iterator] = MM.prototype[Symbol.iterator] = function() {
  return this;
});
let gG = class {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.number = r, this.text = i;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
};
function Xc(t, e, n) {
  return e = Math.max(0, Math.min(t.length, e)), [e, Math.max(e, Math.min(t.length, n))];
}
function ia(t, e, n = !0, r = !0) {
  return dG(t, e, n, r);
}
const Tw = /\r\n?|\n/;
var Zi = /* @__PURE__ */ function(t) {
  return t[t.Simple = 0] = "Simple", t[t.TrackDel = 1] = "TrackDel", t[t.TrackBefore = 2] = "TrackBefore", t[t.TrackAfter = 3] = "TrackAfter", t;
}(Zi || (Zi = {}));
class fa {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(e) {
    this.sections = e;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2)
      e += this.sections[n];
    return e;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n + 1];
      e += r < 0 ? this.sections[n] : r;
    }
    return e;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(e) {
    for (let n = 0, r = 0, i = 0; n < this.sections.length; ) {
      let o = this.sections[n++], s = this.sections[n++];
      s < 0 ? (e(r, i, o), i += o) : i += s, r += o;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(e, n = !1) {
    xw(this, e, n);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let e = [];
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      i < 0 ? e.push(r, i) : e.push(i, r);
    }
    return new fa(e);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(e) {
    return this.empty ? e : e.empty ? this : FM(this, e);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `this` happened before the ones in `other`.
  */
  mapDesc(e, n = !1) {
    return e.empty ? this : Cw(this, e, n);
  }
  mapPos(e, n = -1, r = Zi.Simple) {
    let i = 0, o = 0;
    for (let s = 0; s < this.sections.length; ) {
      let a = this.sections[s++], l = this.sections[s++], u = i + a;
      if (l < 0) {
        if (u > e)
          return o + (e - i);
        o += a;
      } else {
        if (r != Zi.Simple && u >= e && (r == Zi.TrackDel && i < e && u > e || r == Zi.TrackBefore && i < e || r == Zi.TrackAfter && u > e))
          return null;
        if (u > e || u == e && n < 0 && !a)
          return e == i || n < 0 ? o : o + l;
        o += l;
      }
      i = u;
    }
    if (e > i)
      throw new RangeError(`Position ${e} is out of range for changeset of length ${i}`);
    return o;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(e, n = e) {
    for (let r = 0, i = 0; r < this.sections.length && i <= n; ) {
      let o = this.sections[r++], s = this.sections[r++], a = i + o;
      if (s >= 0 && i <= n && a >= e)
        return i < e && a > n ? "cover" : !0;
      i = a;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      e += (e ? " " : "") + r + (i >= 0 ? ":" + i : "");
    }
    return e;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2 || e.some((n) => typeof n != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new fa(e);
  }
  /**
  @internal
  */
  static create(e) {
    return new fa(e);
  }
}
class Ir extends fa {
  constructor(e, n) {
    super(e), this.inserted = n;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(e) {
    if (this.length != e.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return xw(this, (n, r, i, o, s) => e = e.replace(i, i + (r - n), s), !1), e;
  }
  mapDesc(e, n = !1) {
    return Cw(this, e, n, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(e) {
    let n = this.sections.slice(), r = [];
    for (let i = 0, o = 0; i < n.length; i += 2) {
      let s = n[i], a = n[i + 1];
      if (a >= 0) {
        n[i] = a, n[i + 1] = s;
        let l = i >> 1;
        for (; r.length < l; )
          r.push(Zt.empty);
        r.push(s ? e.slice(o, o + s) : Zt.empty);
      }
      o += s;
    }
    return new Ir(n, r);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(e) {
    return this.empty ? e : e.empty ? this : FM(this, e, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(e, n = !1) {
    return e.empty ? this : Cw(this, e, n, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(e, n = !1) {
    xw(this, e, n);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return fa.create(this.sections);
  }
  /**
  @internal
  */
  filter(e) {
    let n = [], r = [], i = [], o = new ph(this);
    e: for (let s = 0, a = 0; ; ) {
      let l = s == e.length ? 1e9 : e[s++];
      for (; a < l || a == l && o.len == 0; ) {
        if (o.done)
          break e;
        let c = Math.min(o.len, l - a);
        Kr(i, c, -1);
        let f = o.ins == -1 ? -1 : o.off == 0 ? o.ins : 0;
        Kr(n, c, f), f > 0 && Ga(r, n, o.text), o.forward(c), a += c;
      }
      let u = e[s++];
      for (; a < u; ) {
        if (o.done)
          break e;
        let c = Math.min(o.len, u - a);
        Kr(n, c, -1), Kr(i, c, o.ins == -1 ? -1 : o.off == 0 ? o.ins : 0), o.forward(c), a += c;
      }
    }
    return {
      changes: new Ir(n, r),
      filtered: fa.create(i)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let e = [];
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n], i = this.sections[n + 1];
      i < 0 ? e.push(r) : i == 0 ? e.push([r]) : e.push([r].concat(this.inserted[n >> 1].toJSON()));
    }
    return e;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(e, n, r) {
    let i = [], o = [], s = 0, a = null;
    function l(c = !1) {
      if (!c && !i.length)
        return;
      s < n && Kr(i, n - s, -1);
      let f = new Ir(i, o);
      a = a ? a.compose(f.map(a)) : f, i = [], o = [], s = 0;
    }
    function u(c) {
      if (Array.isArray(c))
        for (let f of c)
          u(f);
      else if (c instanceof Ir) {
        if (c.length != n)
          throw new RangeError(`Mismatched change set length (got ${c.length}, expected ${n})`);
        l(), a = a ? a.compose(c.map(a)) : c;
      } else {
        let { from: f, to: d = f, insert: h } = c;
        if (f > d || f < 0 || d > n)
          throw new RangeError(`Invalid change range ${f} to ${d} (in doc of length ${n})`);
        let p = h ? typeof h == "string" ? Zt.of(h.split(r || Tw)) : h : Zt.empty, g = p.length;
        if (f == d && g == 0)
          return;
        f < s && l(), f > s && Kr(i, f - s, -1), Kr(i, d - f, g), Ga(o, i, p), s = d;
      }
    }
    return u(e), l(!a), a;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(e) {
    return new Ir(e ? [e, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let n = [], r = [];
    for (let i = 0; i < e.length; i++) {
      let o = e[i];
      if (typeof o == "number")
        n.push(o, -1);
      else {
        if (!Array.isArray(o) || typeof o[0] != "number" || o.some((s, a) => a && typeof s != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (o.length == 1)
          n.push(o[0], 0);
        else {
          for (; r.length < i; )
            r.push(Zt.empty);
          r[i] = Zt.of(o.slice(1)), n.push(o[0], r[i].length);
        }
      }
    }
    return new Ir(n, r);
  }
  /**
  @internal
  */
  static createSet(e, n) {
    return new Ir(e, n);
  }
}
function Kr(t, e, n, r = !1) {
  if (e == 0 && n <= 0)
    return;
  let i = t.length - 2;
  i >= 0 && n <= 0 && n == t[i + 1] ? t[i] += e : i >= 0 && e == 0 && t[i] == 0 ? t[i + 1] += n : r ? (t[i] += e, t[i + 1] += n) : t.push(e, n);
}
function Ga(t, e, n) {
  if (n.length == 0)
    return;
  let r = e.length - 2 >> 1;
  if (r < t.length)
    t[t.length - 1] = t[t.length - 1].append(n);
  else {
    for (; t.length < r; )
      t.push(Zt.empty);
    t.push(n);
  }
}
function xw(t, e, n) {
  let r = t.inserted;
  for (let i = 0, o = 0, s = 0; s < t.sections.length; ) {
    let a = t.sections[s++], l = t.sections[s++];
    if (l < 0)
      i += a, o += a;
    else {
      let u = i, c = o, f = Zt.empty;
      for (; u += a, c += l, l && r && (f = f.append(r[s - 2 >> 1])), !(n || s == t.sections.length || t.sections[s + 1] < 0); )
        a = t.sections[s++], l = t.sections[s++];
      e(i, u, o, c, f), i = u, o = c;
    }
  }
}
function Cw(t, e, n, r = !1) {
  let i = [], o = r ? [] : null, s = new ph(t), a = new ph(e);
  for (let l = -1; ; ) {
    if (s.done && a.len || a.done && s.len)
      throw new Error("Mismatched change set lengths");
    if (s.ins == -1 && a.ins == -1) {
      let u = Math.min(s.len, a.len);
      Kr(i, u, -1), s.forward(u), a.forward(u);
    } else if (a.ins >= 0 && (s.ins < 0 || l == s.i || s.off == 0 && (a.len < s.len || a.len == s.len && !n))) {
      let u = a.len;
      for (Kr(i, a.ins, -1); u; ) {
        let c = Math.min(s.len, u);
        s.ins >= 0 && l < s.i && s.len <= c && (Kr(i, 0, s.ins), o && Ga(o, i, s.text), l = s.i), s.forward(c), u -= c;
      }
      a.next();
    } else if (s.ins >= 0) {
      let u = 0, c = s.len;
      for (; c; )
        if (a.ins == -1) {
          let f = Math.min(c, a.len);
          u += f, c -= f, a.forward(f);
        } else if (a.ins == 0 && a.len < c)
          c -= a.len, a.next();
        else
          break;
      Kr(i, u, l < s.i ? s.ins : 0), o && l < s.i && Ga(o, i, s.text), l = s.i, s.forward(s.len - c);
    } else {
      if (s.done && a.done)
        return o ? Ir.createSet(i, o) : fa.create(i);
      throw new Error("Mismatched change set lengths");
    }
  }
}
function FM(t, e, n = !1) {
  let r = [], i = n ? [] : null, o = new ph(t), s = new ph(e);
  for (let a = !1; ; ) {
    if (o.done && s.done)
      return i ? Ir.createSet(r, i) : fa.create(r);
    if (o.ins == 0)
      Kr(r, o.len, 0, a), o.next();
    else if (s.len == 0 && !s.done)
      Kr(r, 0, s.ins, a), i && Ga(i, r, s.text), s.next();
    else {
      if (o.done || s.done)
        throw new Error("Mismatched change set lengths");
      {
        let l = Math.min(o.len2, s.len), u = r.length;
        if (o.ins == -1) {
          let c = s.ins == -1 ? -1 : s.off ? 0 : s.ins;
          Kr(r, l, c, a), i && c && Ga(i, r, s.text);
        } else s.ins == -1 ? (Kr(r, o.off ? 0 : o.len, l, a), i && Ga(i, r, o.textBit(l))) : (Kr(r, o.off ? 0 : o.len, s.off ? 0 : s.ins, a), i && !s.off && Ga(i, r, s.text));
        a = (o.ins > l || s.ins >= 0 && s.len > l) && (a || r.length > u), o.forward2(l), s.forward(l);
      }
    }
  }
}
class ph {
  constructor(e) {
    this.set = e, this.i = 0, this.next();
  }
  next() {
    let { sections: e } = this.set;
    this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: e } = this.set, n = this.i - 2 >> 1;
    return n >= e.length ? Zt.empty : e[n];
  }
  textBit(e) {
    let { inserted: n } = this.set, r = this.i - 2 >> 1;
    return r >= n.length && !e ? Zt.empty : n[r].slice(this.off, e == null ? void 0 : this.off + e);
  }
  forward(e) {
    e == this.len ? this.next() : (this.len -= e, this.off += e);
  }
  forward2(e) {
    this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
  }
}
class Zl {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.flags = r;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let e = this.flags & 7;
    return e == 7 ? null : e;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let e = this.flags >> 6;
    return e == 16777215 ? void 0 : e;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(e, n = -1) {
    let r, i;
    return this.empty ? r = i = e.mapPos(this.from, n) : (r = e.mapPos(this.from, 1), i = e.mapPos(this.to, -1)), r == this.from && i == this.to ? this : new Zl(r, i, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(e, n = e) {
    if (e <= this.anchor && n >= this.anchor)
      return ot.range(e, n);
    let r = Math.abs(e - this.anchor) > Math.abs(n - this.anchor) ? e : n;
    return ot.range(this.anchor, r);
  }
  /**
  Compare this range to another range.
  */
  eq(e, n = !1) {
    return this.anchor == e.anchor && this.head == e.head && (!n || !this.empty || this.assoc == e.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(e) {
    if (!e || typeof e.anchor != "number" || typeof e.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return ot.range(e.anchor, e.head);
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new Zl(e, n, r);
  }
}
class ot {
  constructor(e, n) {
    this.ranges = e, this.mainIndex = n;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(e, n = -1) {
    return e.empty ? this : ot.create(this.ranges.map((r) => r.map(e, n)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(e, n = !1) {
    if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex)
      return !1;
    for (let r = 0; r < this.ranges.length; r++)
      if (!this.ranges[r].eq(e.ranges[r], n))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new ot([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(e, n = !0) {
    return ot.create([e].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(e, n = this.mainIndex) {
    let r = this.ranges.slice();
    return r[n] = e, ot.create(r, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((e) => e.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(e) {
    if (!e || !Array.isArray(e.ranges) || typeof e.main != "number" || e.main >= e.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new ot(e.ranges.map((n) => Zl.fromJSON(n)), e.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(e, n = e) {
    return new ot([ot.range(e, n)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(e, n = 0) {
    if (e.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let r = 0, i = 0; i < e.length; i++) {
      let o = e[i];
      if (o.empty ? o.from <= r : o.from < r)
        return ot.normalized(e.slice(), n);
      r = o.to;
    }
    return new ot(e, n);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(e, n = 0, r, i) {
    return Zl.create(e, e, (n == 0 ? 0 : n < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (i ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(e, n, r, i) {
    let o = (r ?? 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return n < e ? Zl.create(n, e, 48 | o) : Zl.create(e, n, (n > e ? 8 : 0) | o);
  }
  /**
  @internal
  */
  static normalized(e, n = 0) {
    let r = e[n];
    e.sort((i, o) => i.from - o.from), n = e.indexOf(r);
    for (let i = 1; i < e.length; i++) {
      let o = e[i], s = e[i - 1];
      if (o.empty ? o.from <= s.to : o.from < s.to) {
        let a = s.from, l = Math.max(o.to, s.to);
        i <= n && n--, e.splice(--i, 2, o.anchor > o.head ? ot.range(l, a) : ot.range(a, l));
      }
    }
    return new ot(e, n);
  }
}
function LM(t, e) {
  for (let n of t.ranges)
    if (n.to > e)
      throw new RangeError("Selection points outside of document");
}
let mE = 0;
class vt {
  constructor(e, n, r, i, o) {
    this.combine = e, this.compareInput = n, this.compare = r, this.isStatic = i, this.id = mE++, this.default = e([]), this.extensions = typeof o == "function" ? o(this) : o;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(e = {}) {
    return new vt(e.combine || ((n) => n), e.compareInput || ((n, r) => n === r), e.compare || (e.combine ? (n, r) => n === r : yE), !!e.static, e.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(e) {
    return new tm([], this, 0, e);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new tm(e, this, 1, n);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new tm(e, this, 2, n);
  }
  from(e, n) {
    return n || (n = (r) => r), this.compute([e], (r) => n(r.field(e)));
  }
}
function yE(t, e) {
  return t == e || t.length == e.length && t.every((n, r) => n === e[r]);
}
class tm {
  constructor(e, n, r, i) {
    this.dependencies = e, this.facet = n, this.type = r, this.value = i, this.id = mE++;
  }
  dynamicSlot(e) {
    var n;
    let r = this.value, i = this.facet.compareInput, o = this.id, s = e[o] >> 1, a = this.type == 2, l = !1, u = !1, c = [];
    for (let f of this.dependencies)
      f == "doc" ? l = !0 : f == "selection" ? u = !0 : (((n = e[f.id]) !== null && n !== void 0 ? n : 1) & 1) == 0 && c.push(e[f.id]);
    return {
      create(f) {
        return f.values[s] = r(f), 1;
      },
      update(f, d) {
        if (l && d.docChanged || u && (d.docChanged || d.selection) || Aw(f, c)) {
          let h = r(f);
          if (a ? !ZT(h, f.values[s], i) : !i(h, f.values[s]))
            return f.values[s] = h, 1;
        }
        return 0;
      },
      reconfigure: (f, d) => {
        let h, p = d.config.address[o];
        if (p != null) {
          let g = Km(d, p);
          if (this.dependencies.every((m) => m instanceof vt ? d.facet(m) === f.facet(m) : m instanceof Ms ? d.field(m, !1) == f.field(m, !1) : !0) || (a ? ZT(h = r(f), g, i) : i(h = r(f), g)))
            return f.values[s] = g, 0;
        } else
          h = r(f);
        return f.values[s] = h, 1;
      }
    };
  }
}
function ZT(t, e, n) {
  if (t.length != e.length)
    return !1;
  for (let r = 0; r < t.length; r++)
    if (!n(t[r], e[r]))
      return !1;
  return !0;
}
function Aw(t, e) {
  let n = !1;
  for (let r of e)
    Yd(t, r) & 1 && (n = !0);
  return n;
}
function mG(t, e, n) {
  let r = n.map((l) => t[l.id]), i = n.map((l) => l.type), o = r.filter((l) => !(l & 1)), s = t[e.id] >> 1;
  function a(l) {
    let u = [];
    for (let c = 0; c < r.length; c++) {
      let f = Km(l, r[c]);
      if (i[c] == 2)
        for (let d of f)
          u.push(d);
      else
        u.push(f);
    }
    return e.combine(u);
  }
  return {
    create(l) {
      for (let u of r)
        Yd(l, u);
      return l.values[s] = a(l), 1;
    },
    update(l, u) {
      if (!Aw(l, o))
        return 0;
      let c = a(l);
      return e.compare(c, l.values[s]) ? 0 : (l.values[s] = c, 1);
    },
    reconfigure(l, u) {
      let c = Aw(l, r), f = u.config.facets[e.id], d = u.facet(e);
      if (f && !c && yE(n, f))
        return l.values[s] = d, 0;
      let h = a(l);
      return e.compare(h, d) ? (l.values[s] = d, 0) : (l.values[s] = h, 1);
    }
  };
}
const qp = /* @__PURE__ */ vt.define({ static: !0 });
class Ms {
  constructor(e, n, r, i, o) {
    this.id = e, this.createF = n, this.updateF = r, this.compareF = i, this.spec = o, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(e) {
    let n = new Ms(mE++, e.create, e.update, e.compare || ((r, i) => r === i), e);
    return e.provide && (n.provides = e.provide(n)), n;
  }
  create(e) {
    let n = e.facet(qp).find((r) => r.field == this);
    return (n?.create || this.createF)(e);
  }
  /**
  @internal
  */
  slot(e) {
    let n = e[this.id] >> 1;
    return {
      create: (r) => (r.values[n] = this.create(r), 1),
      update: (r, i) => {
        let o = r.values[n], s = this.updateF(o, i);
        return this.compareF(o, s) ? 0 : (r.values[n] = s, 1);
      },
      reconfigure: (r, i) => {
        let o = r.facet(qp), s = i.facet(qp), a;
        return (a = o.find((l) => l.field == this)) && a != s.find((l) => l.field == this) ? (r.values[n] = a.create(r), 1) : i.config.address[this.id] != null ? (r.values[n] = i.field(this), 0) : (r.values[n] = this.create(r), 1);
      }
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(e) {
    return [this, qp.of({ field: this, create: e })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const Yl = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function jf(t) {
  return (e) => new jM(e, t);
}
const BM = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ jf(Yl.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ jf(Yl.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ jf(Yl.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ jf(Yl.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ jf(Yl.lowest)
};
class jM {
  constructor(e, n) {
    this.inner = e, this.prec = n;
  }
}
class i0 {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(e) {
    return new Rw(this, e);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(e) {
    return i0.reconfigure.of({ compartment: this, extension: e });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(e) {
    return e.config.compartments.get(this);
  }
}
class Rw {
  constructor(e, n) {
    this.compartment = e, this.inner = n;
  }
}
class Xm {
  constructor(e, n, r, i, o, s) {
    for (this.base = e, this.compartments = n, this.dynamicSlots = r, this.address = i, this.staticValues = o, this.facets = s, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(e) {
    let n = this.address[e.id];
    return n == null ? e.default : this.staticValues[n >> 1];
  }
  static resolve(e, n, r) {
    let i = [], o = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ new Map();
    for (let d of yG(e, n, s))
      d instanceof Ms ? i.push(d) : (o[d.facet.id] || (o[d.facet.id] = [])).push(d);
    let a = /* @__PURE__ */ Object.create(null), l = [], u = [];
    for (let d of i)
      a[d.id] = u.length << 1, u.push((h) => d.slot(h));
    let c = r?.config.facets;
    for (let d in o) {
      let h = o[d], p = h[0].facet, g = c && c[d] || [];
      if (h.every(
        (m) => m.type == 0
        /* Provider.Static */
      ))
        if (a[p.id] = l.length << 1 | 1, yE(g, h))
          l.push(r.facet(p));
        else {
          let m = p.combine(h.map((v) => v.value));
          l.push(r && p.compare(m, r.facet(p)) ? r.facet(p) : m);
        }
      else {
        for (let m of h)
          m.type == 0 ? (a[m.id] = l.length << 1 | 1, l.push(m.value)) : (a[m.id] = u.length << 1, u.push((v) => m.dynamicSlot(v)));
        a[p.id] = u.length << 1, u.push((m) => mG(m, p, h));
      }
    }
    let f = u.map((d) => d(a));
    return new Xm(e, s, f, a, l, o);
  }
}
function yG(t, e, n) {
  let r = [[], [], [], [], []], i = /* @__PURE__ */ new Map();
  function o(s, a) {
    let l = i.get(s);
    if (l != null) {
      if (l <= a)
        return;
      let u = r[l].indexOf(s);
      u > -1 && r[l].splice(u, 1), s instanceof Rw && n.delete(s.compartment);
    }
    if (i.set(s, a), Array.isArray(s))
      for (let u of s)
        o(u, a);
    else if (s instanceof Rw) {
      if (n.has(s.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let u = e.get(s.compartment) || s.inner;
      n.set(s.compartment, u), o(u, a);
    } else if (s instanceof jM)
      o(s.inner, s.prec);
    else if (s instanceof Ms)
      r[a].push(s), s.provides && o(s.provides, a);
    else if (s instanceof tm)
      r[a].push(s), s.facet.extensions && o(s.facet.extensions, Yl.default);
    else {
      let u = s.extension;
      if (!u)
        throw new Error(`Unrecognized extension value in extension set (${s}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      o(u, a);
    }
  }
  return o(t, Yl.default), r.reduce((s, a) => s.concat(a));
}
function Yd(t, e) {
  if (e & 1)
    return 2;
  let n = e >> 1, r = t.status[n];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (r & 2)
    return r;
  t.status[n] = 4;
  let i = t.computeSlot(t, t.config.dynamicSlots[n]);
  return t.status[n] = 2 | i;
}
function Km(t, e) {
  return e & 1 ? t.config.staticValues[e >> 1] : t.values[e >> 1];
}
const VM = /* @__PURE__ */ vt.define(), Ow = /* @__PURE__ */ vt.define({
  combine: (t) => t.some((e) => e),
  static: !0
}), UM = /* @__PURE__ */ vt.define({
  combine: (t) => t.length ? t[0] : void 0,
  static: !0
}), qM = /* @__PURE__ */ vt.define(), zM = /* @__PURE__ */ vt.define(), HM = /* @__PURE__ */ vt.define(), GM = /* @__PURE__ */ vt.define({
  combine: (t) => t.length ? t[0] : !1
});
class bf {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new vG();
  }
}
class vG {
  /**
  Create an instance of this annotation.
  */
  of(e) {
    return new bf(this, e);
  }
}
class bG {
  /**
  @internal
  */
  constructor(e) {
    this.map = e;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(e) {
    return new fr(this, e);
  }
}
class fr {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(e) {
    let n = this.type.map(this.value, e);
    return n === void 0 ? void 0 : n == this.value ? this : new fr(this.type, n);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(e) {
    return this.type == e;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(e = {}) {
    return new bG(e.map || ((n) => n));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(e, n) {
    if (!e.length)
      return e;
    let r = [];
    for (let i of e) {
      let o = i.map(n);
      o && r.push(o);
    }
    return r;
  }
}
fr.reconfigure = /* @__PURE__ */ fr.define();
fr.appendConfig = /* @__PURE__ */ fr.define();
class ei {
  constructor(e, n, r, i, o, s) {
    this.startState = e, this.changes = n, this.selection = r, this.effects = i, this.annotations = o, this.scrollIntoView = s, this._doc = null, this._state = null, r && LM(r, n.newLength), o.some((a) => a.type == ei.time) || (this.annotations = o.concat(ei.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(e, n, r, i, o, s) {
    return new ei(e, n, r, i, o, s);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(e) {
    for (let n of this.annotations)
      if (n.type == e)
        return n.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(e) {
    let n = this.annotation(ei.userEvent);
    return !!(n && (n == e || n.length > e.length && n.slice(0, e.length) == e && n[e.length] == "."));
  }
}
ei.time = /* @__PURE__ */ bf.define();
ei.userEvent = /* @__PURE__ */ bf.define();
ei.addToHistory = /* @__PURE__ */ bf.define();
ei.remote = /* @__PURE__ */ bf.define();
function wG(t, e) {
  let n = [];
  for (let r = 0, i = 0; ; ) {
    let o, s;
    if (r < t.length && (i == e.length || e[i] >= t[r]))
      o = t[r++], s = t[r++];
    else if (i < e.length)
      o = e[i++], s = e[i++];
    else
      return n;
    !n.length || n[n.length - 1] < o ? n.push(o, s) : n[n.length - 1] < s && (n[n.length - 1] = s);
  }
}
function WM(t, e, n) {
  var r;
  let i, o, s;
  return n ? (i = e.changes, o = Ir.empty(e.changes.length), s = t.changes.compose(e.changes)) : (i = e.changes.map(t.changes), o = t.changes.mapDesc(e.changes, !0), s = t.changes.compose(i)), {
    changes: s,
    selection: e.selection ? e.selection.map(o) : (r = t.selection) === null || r === void 0 ? void 0 : r.map(i),
    effects: fr.mapEffects(t.effects, i).concat(fr.mapEffects(e.effects, o)),
    annotations: t.annotations.length ? t.annotations.concat(e.annotations) : e.annotations,
    scrollIntoView: t.scrollIntoView || e.scrollIntoView
  };
}
function Dw(t, e, n) {
  let r = e.selection, i = vc(e.annotations);
  return e.userEvent && (i = i.concat(ei.userEvent.of(e.userEvent))), {
    changes: e.changes instanceof Ir ? e.changes : Ir.of(e.changes || [], n, t.facet(UM)),
    selection: r && (r instanceof ot ? r : ot.single(r.anchor, r.head)),
    effects: vc(e.effects),
    annotations: i,
    scrollIntoView: !!e.scrollIntoView
  };
}
function YM(t, e, n) {
  let r = Dw(t, e.length ? e[0] : {}, t.doc.length);
  e.length && e[0].filter === !1 && (n = !1);
  for (let o = 1; o < e.length; o++) {
    e[o].filter === !1 && (n = !1);
    let s = !!e[o].sequential;
    r = WM(r, Dw(t, e[o], s ? r.changes.newLength : t.doc.length), s);
  }
  let i = ei.create(t, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return _G(n ? SG(i) : i);
}
function SG(t) {
  let e = t.startState, n = !0;
  for (let i of e.facet(qM)) {
    let o = i(t);
    if (o === !1) {
      n = !1;
      break;
    }
    Array.isArray(o) && (n = n === !0 ? o : wG(n, o));
  }
  if (n !== !0) {
    let i, o;
    if (n === !1)
      o = t.changes.invertedDesc, i = Ir.empty(e.doc.length);
    else {
      let s = t.changes.filter(n);
      i = s.changes, o = s.filtered.mapDesc(s.changes).invertedDesc;
    }
    t = ei.create(e, i, t.selection && t.selection.map(o), fr.mapEffects(t.effects, o), t.annotations, t.scrollIntoView);
  }
  let r = e.facet(zM);
  for (let i = r.length - 1; i >= 0; i--) {
    let o = r[i](t);
    o instanceof ei ? t = o : Array.isArray(o) && o.length == 1 && o[0] instanceof ei ? t = o[0] : t = YM(e, vc(o), !1);
  }
  return t;
}
function _G(t) {
  let e = t.startState, n = e.facet(HM), r = t;
  for (let i = n.length - 1; i >= 0; i--) {
    let o = n[i](t);
    o && Object.keys(o).length && (r = WM(r, Dw(e, o, t.changes.newLength), !0));
  }
  return r == t ? t : ei.create(e, t.changes, t.selection, r.effects, r.annotations, r.scrollIntoView);
}
const EG = [];
function vc(t) {
  return t == null ? EG : Array.isArray(t) ? t : [t];
}
var oa = /* @__PURE__ */ function(t) {
  return t[t.Word = 0] = "Word", t[t.Space = 1] = "Space", t[t.Other = 2] = "Other", t;
}(oa || (oa = {}));
const kG = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let Iw;
try {
  Iw = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function TG(t) {
  if (Iw)
    return Iw.test(t);
  for (let e = 0; e < t.length; e++) {
    let n = t[e];
    if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || kG.test(n)))
      return !0;
  }
  return !1;
}
function xG(t) {
  return (e) => {
    if (!/\S/.test(e))
      return oa.Space;
    if (TG(e))
      return oa.Word;
    for (let n = 0; n < t.length; n++)
      if (e.indexOf(t[n]) > -1)
        return oa.Word;
    return oa.Other;
  };
}
class hn {
  constructor(e, n, r, i, o, s) {
    this.config = e, this.doc = n, this.selection = r, this.values = i, this.status = e.statusTemplate.slice(), this.computeSlot = o, s && (s._state = this);
    for (let a = 0; a < this.config.dynamicSlots.length; a++)
      Yd(this, a << 1);
    this.computeSlot = null;
  }
  field(e, n = !0) {
    let r = this.config.address[e.id];
    if (r == null) {
      if (n)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return Yd(this, r), Km(this, r);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...e) {
    return YM(this, e, !0);
  }
  /**
  @internal
  */
  applyTransaction(e) {
    let n = this.config, { base: r, compartments: i } = n;
    for (let a of e.effects)
      a.is(i0.reconfigure) ? (n && (i = /* @__PURE__ */ new Map(), n.compartments.forEach((l, u) => i.set(u, l)), n = null), i.set(a.value.compartment, a.value.extension)) : a.is(fr.reconfigure) ? (n = null, r = a.value) : a.is(fr.appendConfig) && (n = null, r = vc(r).concat(a.value));
    let o;
    n ? o = e.startState.values.slice() : (n = Xm.resolve(r, i, this), o = new hn(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (l, u) => u.reconfigure(l, this), null).values);
    let s = e.startState.facet(Ow) ? e.newSelection : e.newSelection.asSingle();
    new hn(n, e.newDoc, s, o, (a, l) => l.update(a, e), e);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(e) {
    return typeof e == "string" && (e = this.toText(e)), this.changeByRange((n) => ({
      changes: { from: n.from, to: n.to, insert: e },
      range: ot.cursor(n.from + e.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(e) {
    let n = this.selection, r = e(n.ranges[0]), i = this.changes(r.changes), o = [r.range], s = vc(r.effects);
    for (let a = 1; a < n.ranges.length; a++) {
      let l = e(n.ranges[a]), u = this.changes(l.changes), c = u.map(i);
      for (let d = 0; d < a; d++)
        o[d] = o[d].map(c);
      let f = i.mapDesc(u, !0);
      o.push(l.range.map(f)), i = i.compose(c), s = fr.mapEffects(s, c).concat(fr.mapEffects(vc(l.effects), f));
    }
    return {
      changes: i,
      selection: ot.create(o, n.mainIndex),
      effects: s
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(e = []) {
    return e instanceof Ir ? e : Ir.of(e, this.doc.length, this.facet(hn.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(e) {
    return Zt.of(e.split(this.facet(hn.lineSeparator) || Tw));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(e = 0, n = this.doc.length) {
    return this.doc.sliceString(e, n, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(e) {
    let n = this.config.address[e.id];
    return n == null ? e.default : (Yd(this, n), Km(this, n));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(e) {
    let n = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (e)
      for (let r in e) {
        let i = e[r];
        i instanceof Ms && this.config.address[i.id] != null && (n[r] = i.spec.toJSON(this.field(e[r]), this));
      }
    return n;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(e, n = {}, r) {
    if (!e || typeof e.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let i = [];
    if (r) {
      for (let o in r)
        if (Object.prototype.hasOwnProperty.call(e, o)) {
          let s = r[o], a = e[o];
          i.push(s.init((l) => s.spec.fromJSON(a, l)));
        }
    }
    return hn.create({
      doc: e.doc,
      selection: ot.fromJSON(e.selection),
      extensions: n.extensions ? i.concat([n.extensions]) : i
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(e = {}) {
    let n = Xm.resolve(e.extensions || [], /* @__PURE__ */ new Map()), r = e.doc instanceof Zt ? e.doc : Zt.of((e.doc || "").split(n.staticFacet(hn.lineSeparator) || Tw)), i = e.selection ? e.selection instanceof ot ? e.selection : ot.single(e.selection.anchor, e.selection.head) : ot.single(0);
    return LM(i, r.length), n.staticFacet(Ow) || (i = i.asSingle()), new hn(n, r, i, n.dynamicSlots.map(() => null), (o, s) => s.create(o), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(hn.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(hn.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(GM);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(e, ...n) {
    for (let r of this.facet(hn.phrases))
      if (Object.prototype.hasOwnProperty.call(r, e)) {
        e = r[e];
        break;
      }
    return n.length && (e = e.replace(/\$(\$|\d*)/g, (r, i) => {
      if (i == "$")
        return "$";
      let o = +(i || 1);
      return !o || o > n.length ? r : n[o - 1];
    })), e;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(e, n, r = -1) {
    let i = [];
    for (let o of this.facet(VM))
      for (let s of o(this, n, r))
        Object.prototype.hasOwnProperty.call(s, e) && i.push(s[e]);
    return i;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(e) {
    return xG(this.languageDataAt("wordChars", e).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(e) {
    let { text: n, from: r, length: i } = this.doc.lineAt(e), o = this.charCategorizer(e), s = e - r, a = e - r;
    for (; s > 0; ) {
      let l = ia(n, s, !1);
      if (o(n.slice(l, s)) != oa.Word)
        break;
      s = l;
    }
    for (; a < i; ) {
      let l = ia(n, a);
      if (o(n.slice(a, l)) != oa.Word)
        break;
      a = l;
    }
    return s == a ? null : ot.range(s + r, a + r);
  }
}
hn.allowMultipleSelections = Ow;
hn.tabSize = /* @__PURE__ */ vt.define({
  combine: (t) => t.length ? t[0] : 4
});
hn.lineSeparator = UM;
hn.readOnly = GM;
hn.phrases = /* @__PURE__ */ vt.define({
  compare(t, e) {
    let n = Object.keys(t), r = Object.keys(e);
    return n.length == r.length && n.every((i) => t[i] == e[i]);
  }
});
hn.languageData = VM;
hn.changeFilter = qM;
hn.transactionFilter = zM;
hn.transactionExtender = HM;
i0.reconfigure = /* @__PURE__ */ fr.define();
class Kc {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(e) {
    return this == e;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(e, n = e) {
    return Nw.create(e, n, this);
  }
}
Kc.prototype.startSide = Kc.prototype.endSide = 0;
Kc.prototype.point = !1;
Kc.prototype.mapMode = Zi.TrackDel;
let Nw = class XM {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.value = r;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new XM(e, n, r);
  }
};
function Pw(t, e) {
  return t.from - e.from || t.value.startSide - e.value.startSide;
}
class vE {
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.value = r, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(e, n, r, i = 0) {
    let o = r ? this.to : this.from;
    for (let s = i, a = o.length; ; ) {
      if (s == a)
        return s;
      let l = s + a >> 1, u = o[l] - e || (r ? this.value[l].endSide : this.value[l].startSide) - n;
      if (l == s)
        return u >= 0 ? s : a;
      u >= 0 ? a = l : s = l + 1;
    }
  }
  between(e, n, r, i) {
    for (let o = this.findIndex(n, -1e9, !0), s = this.findIndex(r, 1e9, !1, o); o < s; o++)
      if (i(this.from[o] + e, this.to[o] + e, this.value[o]) === !1)
        return !1;
  }
  map(e, n) {
    let r = [], i = [], o = [], s = -1, a = -1;
    for (let l = 0; l < this.value.length; l++) {
      let u = this.value[l], c = this.from[l] + e, f = this.to[l] + e, d, h;
      if (c == f) {
        let p = n.mapPos(c, u.startSide, u.mapMode);
        if (p == null || (d = h = p, u.startSide != u.endSide && (h = n.mapPos(c, u.endSide), h < d)))
          continue;
      } else if (d = n.mapPos(c, u.startSide), h = n.mapPos(f, u.endSide), d > h || d == h && u.startSide > 0 && u.endSide <= 0)
        continue;
      (h - d || u.endSide - u.startSide) < 0 || (s < 0 && (s = d), u.point && (a = Math.max(a, h - d)), r.push(u), i.push(d - s), o.push(h - s));
    }
    return { mapped: r.length ? new vE(i, o, r, a) : null, pos: s };
  }
}
class Jt {
  constructor(e, n, r, i) {
    this.chunkPos = e, this.chunk = n, this.nextLayer = r, this.maxPoint = i;
  }
  /**
  @internal
  */
  static create(e, n, r, i) {
    return new Jt(e, n, r, i);
  }
  /**
  @internal
  */
  get length() {
    let e = this.chunk.length - 1;
    return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let e = this.nextLayer.size;
    for (let n of this.chunk)
      e += n.value.length;
    return e;
  }
  /**
  @internal
  */
  chunkEnd(e) {
    return this.chunkPos[e] + this.chunk[e].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(e) {
    let { add: n = [], sort: r = !1, filterFrom: i = 0, filterTo: o = this.length } = e, s = e.filter;
    if (n.length == 0 && !s)
      return this;
    if (r && (n = n.slice().sort(Pw)), this.isEmpty)
      return n.length ? Jt.of(n) : this;
    let a = new KM(this, null, -1).goto(0), l = 0, u = [], c = new Is();
    for (; a.value || l < n.length; )
      if (l < n.length && (a.from - n[l].from || a.startSide - n[l].value.startSide) >= 0) {
        let f = n[l++];
        c.addInner(f.from, f.to, f.value) || u.push(f);
      } else a.rangeIndex == 1 && a.chunkIndex < this.chunk.length && (l == n.length || this.chunkEnd(a.chunkIndex) < n[l].from) && (!s || i > this.chunkEnd(a.chunkIndex) || o < this.chunkPos[a.chunkIndex]) && c.addChunk(this.chunkPos[a.chunkIndex], this.chunk[a.chunkIndex]) ? a.nextChunk() : ((!s || i > a.to || o < a.from || s(a.from, a.to, a.value)) && (c.addInner(a.from, a.to, a.value) || u.push(Nw.create(a.from, a.to, a.value))), a.next());
    return c.finishInner(this.nextLayer.isEmpty && !u.length ? Jt.empty : this.nextLayer.update({ add: u, filter: s, filterFrom: i, filterTo: o }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(e) {
    if (e.empty || this.isEmpty)
      return this;
    let n = [], r = [], i = -1;
    for (let s = 0; s < this.chunk.length; s++) {
      let a = this.chunkPos[s], l = this.chunk[s], u = e.touchesRange(a, a + l.length);
      if (u === !1)
        i = Math.max(i, l.maxPoint), n.push(l), r.push(e.mapPos(a));
      else if (u === !0) {
        let { mapped: c, pos: f } = l.map(a, e);
        c && (i = Math.max(i, c.maxPoint), n.push(c), r.push(f));
      }
    }
    let o = this.nextLayer.map(e);
    return n.length == 0 ? o : new Jt(r, n, o || Jt.empty, i);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(e, n, r) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let o = this.chunkPos[i], s = this.chunk[i];
        if (n >= o && e <= o + s.length && s.between(o, e - o, n - o, r) === !1)
          return;
      }
      this.nextLayer.between(e, n, r);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(e = 0) {
    return gh.from([this]).goto(e);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(e, n = 0) {
    return gh.from(e).goto(n);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(e, n, r, i, o = -1) {
    let s = e.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o), a = n.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o), l = ex(s, a, r), u = new Vf(s, l, o), c = new Vf(a, l, o);
    r.iterGaps((f, d, h) => tx(u, f, c, d, h, i)), r.empty && r.length == 0 && tx(u, 0, c, 0, 0, i);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(e, n, r = 0, i) {
    i == null && (i = 999999999);
    let o = e.filter((c) => !c.isEmpty && n.indexOf(c) < 0), s = n.filter((c) => !c.isEmpty && e.indexOf(c) < 0);
    if (o.length != s.length)
      return !1;
    if (!o.length)
      return !0;
    let a = ex(o, s), l = new Vf(o, a, 0).goto(r), u = new Vf(s, a, 0).goto(r);
    for (; ; ) {
      if (l.to != u.to || !$w(l.active, u.active) || l.point && (!u.point || !l.point.eq(u.point)))
        return !1;
      if (l.to > i)
        return !0;
      l.next(), u.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(e, n, r, i, o = -1) {
    let s = new Vf(e, null, o).goto(n), a = n, l = s.openStart;
    for (; ; ) {
      let u = Math.min(s.to, r);
      if (s.point) {
        let c = s.activeForPoint(s.to), f = s.pointFrom < n ? c.length + 1 : s.point.startSide < 0 ? c.length : Math.min(c.length, l);
        i.point(a, u, s.point, c, f, s.pointRank), l = Math.min(s.openEnd(u), c.length);
      } else u > a && (i.span(a, u, s.active, l), l = s.openEnd(u));
      if (s.to > r)
        return l + (s.point && s.to > r ? 1 : 0);
      a = s.to, s.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(e, n = !1) {
    let r = new Is();
    for (let i of e instanceof Nw ? [e] : n ? CG(e) : e)
      r.add(i.from, i.to, i.value);
    return r.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(e) {
    if (!e.length)
      return Jt.empty;
    let n = e[e.length - 1];
    for (let r = e.length - 2; r >= 0; r--)
      for (let i = e[r]; i != Jt.empty; i = i.nextLayer)
        n = new Jt(i.chunkPos, i.chunk, n, Math.max(i.maxPoint, n.maxPoint));
    return n;
  }
}
Jt.empty = /* @__PURE__ */ new Jt([], [], null, -1);
function CG(t) {
  if (t.length > 1)
    for (let e = t[0], n = 1; n < t.length; n++) {
      let r = t[n];
      if (Pw(e, r) > 0)
        return t.slice().sort(Pw);
      e = r;
    }
  return t;
}
Jt.empty.nextLayer = Jt.empty;
class Is {
  finishChunk(e) {
    this.chunks.push(new vE(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(e, n, r) {
    this.addInner(e, n, r) || (this.nextLayer || (this.nextLayer = new Is())).add(e, n, r);
  }
  /**
  @internal
  */
  addInner(e, n, r) {
    let i = e - this.lastTo || r.startSide - this.last.endSide;
    if (i <= 0 && (e - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return i < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = e, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - e)), !0);
  }
  /**
  @internal
  */
  addChunk(e, n) {
    if ((e - this.lastTo || n.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(e);
    let r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + e, this.lastTo = n.to[r] + e, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(Jt.empty);
  }
  /**
  @internal
  */
  finishInner(e) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return e;
    let n = Jt.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
    return this.from = null, n;
  }
}
function ex(t, e, n) {
  let r = /* @__PURE__ */ new Map();
  for (let o of t)
    for (let s = 0; s < o.chunk.length; s++)
      o.chunk[s].maxPoint <= 0 && r.set(o.chunk[s], o.chunkPos[s]);
  let i = /* @__PURE__ */ new Set();
  for (let o of e)
    for (let s = 0; s < o.chunk.length; s++) {
      let a = r.get(o.chunk[s]);
      a != null && (n ? n.mapPos(a) : a) == o.chunkPos[s] && !n?.touchesRange(a, a + o.chunk[s].length) && i.add(o.chunk[s]);
    }
  return i;
}
class KM {
  constructor(e, n, r, i = 0) {
    this.layer = e, this.skip = n, this.minPoint = r, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e, n = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, n, !1), this;
  }
  gotoInner(e, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < e || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(e, n) {
    (this.to - e || this.endSide - n) < 0 && this.gotoInner(e, n, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = e + n.from[this.rangeIndex];
        if (this.from = r, this.to = e + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(e) {
    if (e == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = e;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e) {
    return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
  }
}
class gh {
  constructor(e) {
    this.heap = e;
  }
  static from(e, n = null, r = -1) {
    let i = [];
    for (let o = 0; o < e.length; o++)
      for (let s = e[o]; !s.isEmpty; s = s.nextLayer)
        s.maxPoint >= r && i.push(new KM(s, n, r, o));
    return i.length == 1 ? i[0] : new gh(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e, n = -1e9) {
    for (let r of this.heap)
      r.goto(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      lv(this.heap, r);
    return this.next(), this;
  }
  forward(e, n) {
    for (let r of this.heap)
      r.forward(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      lv(this.heap, r);
    (this.to - e || this.value.endSide - n) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let e = this.heap[0];
      this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), lv(this.heap, 0);
    }
  }
}
function lv(t, e) {
  for (let n = t[e]; ; ) {
    let r = (e << 1) + 1;
    if (r >= t.length)
      break;
    let i = t[r];
    if (r + 1 < t.length && i.compare(t[r + 1]) >= 0 && (i = t[r + 1], r++), n.compare(i) < 0)
      break;
    t[r] = n, t[e] = i, e = r;
  }
}
class Vf {
  constructor(e, n, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = gh.from(e, n, r);
  }
  goto(e, n = -1e9) {
    return this.cursor.goto(e, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = n, this.openStart = -1, this.next(), this;
  }
  forward(e, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - n) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(e, n);
  }
  removeActive(e) {
    zp(this.active, e), zp(this.activeTo, e), zp(this.activeRank, e), this.minActive = nx(this.active, this.activeTo);
  }
  addActive(e) {
    let n = 0, { value: r, to: i, rank: o } = this.cursor;
    for (; n < this.activeRank.length && (o - this.activeRank[n] || i - this.activeTo[n]) > 0; )
      n++;
    Hp(this.active, n, r), Hp(this.activeTo, n, i), Hp(this.activeRank, n, o), e && Hp(e, n, this.cursor.from), this.minActive = nx(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let e = this.to, n = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > e) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), r && zp(r, i);
      } else if (this.cursor.value)
        if (this.cursor.from > e) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let o = this.cursor.value;
          if (!o.point)
            this.addActive(r), this.cursor.next();
          else if (n && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = o, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = o.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let i = r.length - 1; i >= 0 && r[i] < e; i--)
        this.openStart++;
    }
  }
  activeForPoint(e) {
    if (!this.active.length)
      return this.active;
    let n = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > e || this.activeTo[r] == e && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    return n.reverse();
  }
  openEnd(e) {
    let n = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > e; r--)
      n++;
    return n;
  }
}
function tx(t, e, n, r, i, o) {
  t.goto(e), n.goto(r);
  let s = r + i, a = r, l = r - e;
  for (; ; ) {
    let u = t.to + l - n.to, c = u || t.endSide - n.endSide, f = c < 0 ? t.to + l : n.to, d = Math.min(f, s);
    if (t.point || n.point ? t.point && n.point && (t.point == n.point || t.point.eq(n.point)) && $w(t.activeForPoint(t.to), n.activeForPoint(n.to)) || o.comparePoint(a, d, t.point, n.point) : d > a && !$w(t.active, n.active) && o.compareRange(a, d, t.active, n.active), f > s)
      break;
    (u || t.openEnd != n.openEnd) && o.boundChange && o.boundChange(f), a = f, c <= 0 && t.next(), c >= 0 && n.next();
  }
}
function $w(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] != e[n] && !t[n].eq(e[n]))
      return !1;
  return !0;
}
function zp(t, e) {
  for (let n = e, r = t.length - 1; n < r; n++)
    t[n] = t[n + 1];
  t.pop();
}
function Hp(t, e, n) {
  for (let r = t.length - 1; r >= e; r--)
    t[r + 1] = t[r];
  t[e] = n;
}
function nx(t, e) {
  let n = -1, r = 1e9;
  for (let i = 0; i < e.length; i++)
    (e[i] - r || t[i].endSide - t[n].endSide) < 0 && (n = i, r = e[i]);
  return n;
}
function AG(t, e, n, r) {
  for (let i = 0, o = 0; ; ) {
    if (o >= e)
      return i;
    if (i == t.length)
      break;
    o += t.charCodeAt(i) == 9 ? n - o % n : 1, i = ia(t, i);
  }
  return t.length;
}
const Mw = "ͼ", rx = typeof Symbol > "u" ? "__" + Mw : Symbol.for(Mw), Fw = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), ix = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class cl {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(e, n) {
    this.rules = [];
    let { finish: r } = n || {};
    function i(s) {
      return /^@/.test(s) ? [s] : s.split(/,\s*/);
    }
    function o(s, a, l, u) {
      let c = [], f = /^@(\w+)\b/.exec(s[0]), d = f && f[1] == "keyframes";
      if (f && a == null) return l.push(s[0] + ";");
      for (let h in a) {
        let p = a[h];
        if (/&/.test(h))
          o(
            h.split(/,\s*/).map((g) => s.map((m) => g.replace(/&/, m))).reduce((g, m) => g.concat(m)),
            p,
            l
          );
        else if (p && typeof p == "object") {
          if (!f) throw new RangeError("The value of a property (" + h + ") should be a primitive value.");
          o(i(h), p, c, d);
        } else p != null && c.push(h.replace(/_.*/, "").replace(/[A-Z]/g, (g) => "-" + g.toLowerCase()) + ": " + p + ";");
      }
      (c.length || d) && l.push((r && !f && !u ? s.map(r) : s).join(", ") + " {" + c.join(" ") + "}");
    }
    for (let s in e) o(i(s), e[s], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let e = ix[rx] || 1;
    return ix[rx] = e + 1, Mw + e.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(e, n, r) {
    let i = e[Fw], o = r && r.nonce;
    i ? o && i.setNonce(o) : i = new RG(e, o), i.mount(Array.isArray(n) ? n : [n], e);
  }
}
let ox = /* @__PURE__ */ new Map();
class RG {
  constructor(e, n) {
    let r = e.ownerDocument || e, i = r.defaultView;
    if (!e.head && e.adoptedStyleSheets && i.CSSStyleSheet) {
      let o = ox.get(r);
      if (o) return e[Fw] = o;
      this.sheet = new i.CSSStyleSheet(), ox.set(r, this);
    } else
      this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
    this.modules = [], e[Fw] = this;
  }
  mount(e, n) {
    let r = this.sheet, i = 0, o = 0;
    for (let s = 0; s < e.length; s++) {
      let a = e[s], l = this.modules.indexOf(a);
      if (l < o && l > -1 && (this.modules.splice(l, 1), o--, l = -1), l == -1) {
        if (this.modules.splice(o++, 0, a), r) for (let u = 0; u < a.rules.length; u++)
          r.insertRule(a.rules[u], i++);
      } else {
        for (; o < l; ) i += this.modules[o++].rules.length;
        i += a.rules.length, o++;
      }
    }
    if (r)
      n.adoptedStyleSheets.indexOf(this.sheet) < 0 && (n.adoptedStyleSheets = [this.sheet, ...n.adoptedStyleSheets]);
    else {
      let s = "";
      for (let l = 0; l < this.modules.length; l++)
        s += this.modules[l].getRules() + `
`;
      this.styleTag.textContent = s;
      let a = n.head || n;
      this.styleTag.parentNode != a && a.insertBefore(this.styleTag, a.firstChild);
    }
  }
  setNonce(e) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
  }
}
var Qc = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Lw = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
};
for (var Br = 0; Br < 10; Br++) Qc[48 + Br] = Qc[96 + Br] = String(Br);
for (var Br = 1; Br <= 24; Br++) Qc[Br + 111] = "F" + Br;
for (var Br = 65; Br <= 90; Br++)
  Qc[Br] = String.fromCharCode(Br + 32), Lw[Br] = String.fromCharCode(Br);
for (var uv in Qc) Lw.hasOwnProperty(uv) || (Lw[uv] = Qc[uv]);
function mh(t) {
  let e;
  return t.nodeType == 11 ? e = t.getSelection ? t : t.ownerDocument : e = t, e.getSelection();
}
function Bw(t, e) {
  return e ? t == e || t.contains(e.nodeType != 1 ? e.parentNode : e) : !1;
}
function nm(t, e) {
  if (!e.anchorNode)
    return !1;
  try {
    return Bw(t, e.anchorNode);
  } catch {
    return !1;
  }
}
function yh(t) {
  return t.nodeType == 3 ? Eu(t, 0, t.nodeValue.length).getClientRects() : t.nodeType == 1 ? t.getClientRects() : [];
}
function Xd(t, e, n, r) {
  return n ? sx(t, e, n, r, -1) || sx(t, e, n, r, 1) : !1;
}
function _u(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}
function Qm(t) {
  return t.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(t.nodeName);
}
function sx(t, e, n, r, i) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (i < 0 ? 0 : Ns(t))) {
      if (t.nodeName == "DIV")
        return !1;
      let o = t.parentNode;
      if (!o || o.nodeType != 1)
        return !1;
      e = _u(t) + (i < 0 ? 0 : 1), t = o;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (i < 0 ? -1 : 0)], t.nodeType == 1 && t.contentEditable == "false")
        return !1;
      e = i < 0 ? Ns(t) : 0;
    } else
      return !1;
  }
}
function Ns(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function o0(t, e) {
  let n = e ? t.left : t.right;
  return { left: n, right: n, top: t.top, bottom: t.bottom };
}
function OG(t) {
  let e = t.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.innerWidth,
    top: 0,
    bottom: t.innerHeight
  };
}
function QM(t, e) {
  let n = e.width / t.offsetWidth, r = e.height / t.offsetHeight;
  return (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(e.width - t.offsetWidth) < 1) && (n = 1), (r > 0.995 && r < 1.005 || !isFinite(r) || Math.abs(e.height - t.offsetHeight) < 1) && (r = 1), { scaleX: n, scaleY: r };
}
function DG(t, e, n, r, i, o, s, a) {
  let l = t.ownerDocument, u = l.defaultView || window;
  for (let c = t, f = !1; c && !f; )
    if (c.nodeType == 1) {
      let d, h = c == l.body, p = 1, g = 1;
      if (h)
        d = OG(u);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(c).position) && (f = !0), c.scrollHeight <= c.clientHeight && c.scrollWidth <= c.clientWidth) {
          c = c.assignedSlot || c.parentNode;
          continue;
        }
        let S = c.getBoundingClientRect();
        ({ scaleX: p, scaleY: g } = QM(c, S)), d = {
          left: S.left,
          right: S.left + c.clientWidth * p,
          top: S.top,
          bottom: S.top + c.clientHeight * g
        };
      }
      let m = 0, v = 0;
      if (i == "nearest")
        e.top < d.top ? (v = e.top - (d.top + s), n > 0 && e.bottom > d.bottom + v && (v = e.bottom - d.bottom + s)) : e.bottom > d.bottom && (v = e.bottom - d.bottom + s, n < 0 && e.top - v < d.top && (v = e.top - (d.top + s)));
      else {
        let S = e.bottom - e.top, _ = d.bottom - d.top;
        v = (i == "center" && S <= _ ? e.top + S / 2 - _ / 2 : i == "start" || i == "center" && n < 0 ? e.top - s : e.bottom - _ + s) - d.top;
      }
      if (r == "nearest" ? e.left < d.left ? (m = e.left - (d.left + o), n > 0 && e.right > d.right + m && (m = e.right - d.right + o)) : e.right > d.right && (m = e.right - d.right + o, n < 0 && e.left < d.left + m && (m = e.left - (d.left + o))) : m = (r == "center" ? e.left + (e.right - e.left) / 2 - (d.right - d.left) / 2 : r == "start" == a ? e.left - o : e.right - (d.right - d.left) + o) - d.left, m || v)
        if (h)
          u.scrollBy(m, v);
        else {
          let S = 0, _ = 0;
          if (v) {
            let b = c.scrollTop;
            c.scrollTop += v / g, _ = (c.scrollTop - b) * g;
          }
          if (m) {
            let b = c.scrollLeft;
            c.scrollLeft += m / p, S = (c.scrollLeft - b) * p;
          }
          e = {
            left: e.left - S,
            top: e.top - _,
            right: e.right - S,
            bottom: e.bottom - _
          }, S && Math.abs(S - m) < 1 && (r = "nearest"), _ && Math.abs(_ - v) < 1 && (i = "nearest");
        }
      if (h)
        break;
      (e.top < d.top || e.bottom > d.bottom || e.left < d.left || e.right > d.right) && (e = {
        left: Math.max(e.left, d.left),
        right: Math.min(e.right, d.right),
        top: Math.max(e.top, d.top),
        bottom: Math.min(e.bottom, d.bottom)
      }), c = c.assignedSlot || c.parentNode;
    } else if (c.nodeType == 11)
      c = c.host;
    else
      break;
}
function IG(t) {
  let e = t.ownerDocument, n, r;
  for (let i = t.parentNode; i && !(i == e.body || n && r); )
    if (i.nodeType == 1)
      !r && i.scrollHeight > i.clientHeight && (r = i), !n && i.scrollWidth > i.clientWidth && (n = i), i = i.assignedSlot || i.parentNode;
    else if (i.nodeType == 11)
      i = i.host;
    else
      break;
  return { x: n, y: r };
}
class NG {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(e) {
    return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
  }
  setRange(e) {
    let { anchorNode: n, focusNode: r } = e;
    this.set(n, Math.min(e.anchorOffset, n ? Ns(n) : 0), r, Math.min(e.focusOffset, r ? Ns(r) : 0));
  }
  set(e, n, r, i) {
    this.anchorNode = e, this.anchorOffset = n, this.focusNode = r, this.focusOffset = i;
  }
}
let qu = null;
function JM(t) {
  if (t.setActive)
    return t.setActive();
  if (qu)
    return t.focus(qu);
  let e = [];
  for (let n = t; n && (e.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode)
    ;
  if (t.focus(qu == null ? {
    get preventScroll() {
      return qu = { preventScroll: !0 }, !0;
    }
  } : void 0), !qu) {
    qu = !1;
    for (let n = 0; n < e.length; ) {
      let r = e[n++], i = e[n++], o = e[n++];
      r.scrollTop != i && (r.scrollTop = i), r.scrollLeft != o && (r.scrollLeft = o);
    }
  }
}
let ax;
function Eu(t, e, n = e) {
  let r = ax || (ax = document.createRange());
  return r.setEnd(t, n), r.setStart(t, e), r;
}
function bc(t, e, n, r) {
  let i = { key: e, code: e, keyCode: n, which: n, cancelable: !0 };
  r && ({ altKey: i.altKey, ctrlKey: i.ctrlKey, shiftKey: i.shiftKey, metaKey: i.metaKey } = r);
  let o = new KeyboardEvent("keydown", i);
  o.synthetic = !0, t.dispatchEvent(o);
  let s = new KeyboardEvent("keyup", i);
  return s.synthetic = !0, t.dispatchEvent(s), o.defaultPrevented || s.defaultPrevented;
}
function PG(t) {
  for (; t; ) {
    if (t && (t.nodeType == 9 || t.nodeType == 11 && t.host))
      return t;
    t = t.assignedSlot || t.parentNode;
  }
  return null;
}
function ZM(t) {
  for (; t.attributes.length; )
    t.removeAttributeNode(t.attributes[0]);
}
function $G(t, e) {
  let n = e.focusNode, r = e.focusOffset;
  if (!n || e.anchorNode != n || e.anchorOffset != r)
    return !1;
  for (r = Math.min(r, Ns(n)); ; )
    if (r) {
      if (n.nodeType != 1)
        return !1;
      let i = n.childNodes[r - 1];
      i.contentEditable == "false" ? r-- : (n = i, r = Ns(n));
    } else {
      if (n == t)
        return !0;
      r = _u(n), n = n.parentNode;
    }
}
function eF(t) {
  return t.scrollTop > Math.max(1, t.scrollHeight - t.clientHeight - 4);
}
function tF(t, e) {
  for (let n = t, r = e; ; ) {
    if (n.nodeType == 3 && r > 0)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r - 1], r = Ns(n);
    } else if (n.parentNode && !Qm(n))
      r = _u(n), n = n.parentNode;
    else
      return null;
  }
}
function nF(t, e) {
  for (let n = t, r = e; ; ) {
    if (n.nodeType == 3 && r < n.nodeValue.length)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r], r = 0;
    } else if (n.parentNode && !Qm(n))
      r = _u(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
class Zr {
  constructor(e, n, r = !0) {
    this.node = e, this.offset = n, this.precise = r;
  }
  static before(e, n) {
    return new Zr(e.parentNode, _u(e), n);
  }
  static after(e, n) {
    return new Zr(e.parentNode, _u(e) + 1, n);
  }
}
const bE = [];
class wn {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(e) {
    let n = this.posAtStart;
    for (let r of this.children) {
      if (r == e)
        return n;
      n += r.length + r.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(e) {
    return this.posBefore(e) + e.length;
  }
  sync(e, n) {
    if (this.flags & 2) {
      let r = this.dom, i = null, o;
      for (let s of this.children) {
        if (s.flags & 7) {
          if (!s.dom && (o = i ? i.nextSibling : r.firstChild)) {
            let a = wn.get(o);
            (!a || !a.parent && a.canReuseDOM(s)) && s.reuseDOM(o);
          }
          s.sync(e, n), s.flags &= -8;
        }
        if (o = i ? i.nextSibling : r.firstChild, n && !n.written && n.node == r && o != s.dom && (n.written = !0), s.dom.parentNode == r)
          for (; o && o != s.dom; )
            o = lx(o);
        else
          r.insertBefore(s.dom, o);
        i = s.dom;
      }
      for (o = i ? i.nextSibling : r.firstChild, o && n && n.node == r && (n.written = !0); o; )
        o = lx(o);
    } else if (this.flags & 1)
      for (let r of this.children)
        r.flags & 7 && (r.sync(e, n), r.flags &= -8);
  }
  reuseDOM(e) {
  }
  localPosFromDOM(e, n) {
    let r;
    if (e == this.dom)
      r = this.dom.childNodes[n];
    else {
      let i = Ns(e) == 0 ? 0 : n == 0 ? -1 : 1;
      for (; ; ) {
        let o = e.parentNode;
        if (o == this.dom)
          break;
        i == 0 && o.firstChild != o.lastChild && (e == o.firstChild ? i = -1 : i = 1), e = o;
      }
      i < 0 ? r = e : r = e.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !wn.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (let i = 0, o = 0; ; i++) {
      let s = this.children[i];
      if (s.dom == r)
        return o;
      o += s.length + s.breakAfter;
    }
  }
  domBoundsAround(e, n, r = 0) {
    let i = -1, o = -1, s = -1, a = -1;
    for (let l = 0, u = r, c = r; l < this.children.length; l++) {
      let f = this.children[l], d = u + f.length;
      if (u < e && d > n)
        return f.domBoundsAround(e, n, u);
      if (d >= e && i == -1 && (i = l, o = u), u > n && f.dom.parentNode == this.dom) {
        s = l, a = c;
        break;
      }
      c = d, u = d + f.breakAfter;
    }
    return {
      from: o,
      to: a < 0 ? r + this.length : a,
      startDOM: (i ? this.children[i - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: s < this.children.length && s >= 0 ? this.children[s].dom : null
    };
  }
  markDirty(e = !1) {
    this.flags |= 2, this.markParentsDirty(e);
  }
  markParentsDirty(e) {
    for (let n = this.parent; n; n = n.parent) {
      if (e && (n.flags |= 2), n.flags & 1)
        return;
      n.flags |= 1, e = !1;
    }
  }
  setParent(e) {
    this.parent != e && (this.parent = e, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(e) {
    this.dom != e && (this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this);
  }
  get rootView() {
    for (let e = this; ; ) {
      let n = e.parent;
      if (!n)
        return e;
      e = n;
    }
  }
  replaceChildren(e, n, r = bE) {
    this.markDirty();
    for (let i = e; i < n; i++) {
      let o = this.children[i];
      o.parent == this && r.indexOf(o) < 0 && o.destroy();
    }
    r.length < 250 ? this.children.splice(e, n - e, ...r) : this.children = [].concat(this.children.slice(0, e), r, this.children.slice(n));
    for (let i = 0; i < r.length; i++)
      r[i].setParent(this);
  }
  ignoreMutation(e) {
    return !1;
  }
  ignoreEvent(e) {
    return !1;
  }
  childCursor(e = this.length) {
    return new rF(this.children, e, this.children.length);
  }
  childPos(e, n = 1) {
    return this.childCursor().findPos(e, n);
  }
  toString() {
    let e = this.constructor.name.replace("View", "");
    return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (e == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(e) {
    return e.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(e, n, r, i, o, s) {
    return !1;
  }
  become(e) {
    return !1;
  }
  canReuseDOM(e) {
    return e.constructor == this.constructor && !((this.flags | e.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let e of this.children)
      e.parent == this && e.destroy();
    this.parent = null;
  }
}
wn.prototype.breakAfter = 0;
function lx(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class rF {
  constructor(e, n, r) {
    this.children = e, this.pos = n, this.i = r, this.off = 0;
  }
  findPos(e, n = 1) {
    for (; ; ) {
      if (e > this.pos || e == this.pos && (n > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = e - this.pos, this;
      let r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  }
}
function iF(t, e, n, r, i, o, s, a, l) {
  let { children: u } = t, c = u.length ? u[e] : null, f = o.length ? o[o.length - 1] : null, d = f ? f.breakAfter : s;
  if (!(e == r && c && !s && !d && o.length < 2 && c.merge(n, i, o.length ? f : null, n == 0, a, l))) {
    if (r < u.length) {
      let h = u[r];
      h && (i < h.length || h.breakAfter && f?.breakAfter) ? (e == r && (h = h.split(i), i = 0), !d && f && h.merge(0, i, f, !0, 0, l) ? o[o.length - 1] = h : ((i || h.children.length && !h.children[0].length) && h.merge(0, i, null, !1, 0, l), o.push(h))) : h?.breakAfter && (f ? f.breakAfter = 1 : s = 1), r++;
    }
    for (c && (c.breakAfter = s, n > 0 && (!s && o.length && c.merge(n, c.length, o[0], !1, a, 0) ? c.breakAfter = o.shift().breakAfter : (n < c.length || c.children.length && c.children[c.children.length - 1].length == 0) && c.merge(n, c.length, null, !1, a, 0), e++)); e < r && o.length; )
      if (u[r - 1].become(o[o.length - 1]))
        r--, o.pop(), l = o.length ? 0 : a;
      else if (u[e].become(o[0]))
        e++, o.shift(), a = o.length ? 0 : l;
      else
        break;
    !o.length && e && r < u.length && !u[e - 1].breakAfter && u[r].merge(0, 0, u[e - 1], !1, a, l) && e--, (e < r || o.length) && t.replaceChildren(e, r, o);
  }
}
function oF(t, e, n, r, i, o) {
  let s = t.childCursor(), { i: a, off: l } = s.findPos(n, 1), { i: u, off: c } = s.findPos(e, -1), f = e - n;
  for (let d of r)
    f += d.length;
  t.length += f, iF(t, u, c, a, l, r, 0, i, o);
}
let ko = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, jw = typeof document < "u" ? document : { documentElement: { style: {} } };
const Vw = /* @__PURE__ */ /Edge\/(\d+)/.exec(ko.userAgent), sF = /* @__PURE__ */ /MSIE \d/.test(ko.userAgent), Uw = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(ko.userAgent), s0 = !!(sF || Uw || Vw), ux = !s0 && /* @__PURE__ */ /gecko\/(\d+)/i.test(ko.userAgent), cv = !s0 && /* @__PURE__ */ /Chrome\/(\d+)/.exec(ko.userAgent), cx = "webkitFontSmoothing" in jw.documentElement.style, aF = !s0 && /* @__PURE__ */ /Apple Computer/.test(ko.vendor), fx = aF && (/* @__PURE__ */ /Mobile\/\w+/.test(ko.userAgent) || ko.maxTouchPoints > 2);
var Qe = {
  mac: fx || /* @__PURE__ */ /Mac/.test(ko.platform),
  ie: s0,
  ie_version: sF ? jw.documentMode || 6 : Uw ? +Uw[1] : Vw ? +Vw[1] : 0,
  gecko: ux,
  gecko_version: ux ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(ko.userAgent) || [0, 0])[1] : 0,
  chrome: !!cv,
  chrome_version: cv ? +cv[1] : 0,
  ios: fx,
  android: /* @__PURE__ */ /Android\b/.test(ko.userAgent),
  webkit: cx,
  safari: aF,
  webkit_version: cx ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(ko.userAgent) || [0, 0])[1] : 0,
  tabSize: jw.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const MG = 256;
class Xo extends wn {
  constructor(e) {
    super(), this.text = e;
  }
  get length() {
    return this.text.length;
  }
  createDOM(e) {
    this.setDOM(e || document.createTextNode(this.text));
  }
  sync(e, n) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (n && n.node == this.dom && (n.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(e) {
    e.nodeType == 3 && this.createDOM(e);
  }
  merge(e, n, r) {
    return this.flags & 8 || r && (!(r instanceof Xo) || this.length - (n - e) + r.length > MG || r.flags & 8) ? !1 : (this.text = this.text.slice(0, e) + (r ? r.text : "") + this.text.slice(n), this.markDirty(), !0);
  }
  split(e) {
    let n = new Xo(this.text.slice(e));
    return this.text = this.text.slice(0, e), this.markDirty(), n.flags |= this.flags & 8, n;
  }
  localPosFromDOM(e, n) {
    return e == this.dom ? n : n ? this.text.length : 0;
  }
  domAtPos(e) {
    return new Zr(this.dom, e);
  }
  domBoundsAround(e, n, r) {
    return { from: r, to: r + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(e, n) {
    return FG(this.dom, e, n);
  }
}
class va extends wn {
  constructor(e, n = [], r = 0) {
    super(), this.mark = e, this.children = n, this.length = r;
    for (let i of n)
      i.setParent(this);
  }
  setAttrs(e) {
    if (ZM(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs)
      for (let n in this.mark.attrs)
        e.setAttribute(n, this.mark.attrs[n]);
    return e;
  }
  canReuseDOM(e) {
    return super.canReuseDOM(e) && !((this.flags | e.flags) & 8);
  }
  reuseDOM(e) {
    e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(e, n);
  }
  merge(e, n, r, i, o, s) {
    return r && (!(r instanceof va && r.mark.eq(this.mark)) || e && o <= 0 || n < this.length && s <= 0) ? !1 : (oF(this, e, n, r ? r.children.slice() : [], o - 1, s - 1), this.markDirty(), !0);
  }
  split(e) {
    let n = [], r = 0, i = -1, o = 0;
    for (let a of this.children) {
      let l = r + a.length;
      l > e && n.push(r < e ? a.split(e - r) : a), i < 0 && r >= e && (i = o), r = l, o++;
    }
    let s = this.length - e;
    return this.length = e, i > -1 && (this.children.length = i, this.markDirty()), new va(this.mark, n, s);
  }
  domAtPos(e) {
    return lF(this, e);
  }
  coordsAt(e, n) {
    return cF(this, e, n);
  }
}
function FG(t, e, n) {
  let r = t.nodeValue.length;
  e > r && (e = r);
  let i = e, o = e, s = 0;
  e == 0 && n < 0 || e == r && n >= 0 ? Qe.chrome || Qe.gecko || (e ? (i--, s = 1) : o < r && (o++, s = -1)) : n < 0 ? i-- : o < r && o++;
  let a = Eu(t, i, o).getClientRects();
  if (!a.length)
    return null;
  let l = a[(s ? s < 0 : n >= 0) ? 0 : a.length - 1];
  return Qe.safari && !s && l.width == 0 && (l = Array.prototype.find.call(a, (u) => u.width) || l), s ? o0(l, s < 0) : l || null;
}
class eu extends wn {
  static create(e, n, r) {
    return new eu(e, n, r);
  }
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.side = r, this.prevWidget = null;
  }
  split(e) {
    let n = eu.create(this.widget, this.length - e, this.side);
    return this.length -= e, n;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(e, n, r, i, o, s) {
    return r && (!(r instanceof eu) || !this.widget.compare(r.widget) || e > 0 && o <= 0 || n < this.length && s <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  become(e) {
    return e instanceof eu && e.side == this.side && this.widget.constructor == e.widget.constructor ? (this.widget.compare(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return Zt.empty;
    let e = this;
    for (; e.parent; )
      e = e.parent;
    let { view: n } = e, r = n && n.state.doc, i = this.posAtStart;
    return r ? r.slice(i, i + this.length) : Zt.empty;
  }
  domAtPos(e) {
    return (this.length ? e == 0 : this.side > 0) ? Zr.before(this.dom) : Zr.after(this.dom, e == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e, n) {
    let r = this.widget.coordsAt(this.dom, e, n);
    if (r)
      return r;
    let i = this.dom.getClientRects(), o = null;
    if (!i.length)
      return null;
    let s = this.side ? this.side < 0 : e > 0;
    for (let a = s ? i.length - 1 : 0; o = i[a], !(e > 0 ? a == 0 : a == i.length - 1 || o.top < o.bottom); a += s ? -1 : 1)
      ;
    return o0(o, !s);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class Jc extends wn {
  constructor(e) {
    super(), this.side = e;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(e) {
    return e instanceof Jc && e.side == this.side;
  }
  split() {
    return new Jc(this.side);
  }
  sync() {
    if (!this.dom) {
      let e = document.createElement("img");
      e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(e) {
    return this.side > 0 ? Zr.before(this.dom) : Zr.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return Zt.empty;
  }
  get isHidden() {
    return !0;
  }
}
Xo.prototype.children = eu.prototype.children = Jc.prototype.children = bE;
function lF(t, e) {
  let n = t.dom, { children: r } = t, i = 0;
  for (let o = 0; i < r.length; i++) {
    let s = r[i], a = o + s.length;
    if (!(a == o && s.getSide() <= 0)) {
      if (e > o && e < a && s.dom.parentNode == n)
        return s.domAtPos(e - o);
      if (e <= o)
        break;
      o = a;
    }
  }
  for (let o = i; o > 0; o--) {
    let s = r[o - 1];
    if (s.dom.parentNode == n)
      return s.domAtPos(s.length);
  }
  for (let o = i; o < r.length; o++) {
    let s = r[o];
    if (s.dom.parentNode == n)
      return s.domAtPos(0);
  }
  return new Zr(n, 0);
}
function uF(t, e, n) {
  let r, { children: i } = t;
  n > 0 && e instanceof va && i.length && (r = i[i.length - 1]) instanceof va && r.mark.eq(e.mark) ? uF(r, e.children[0], n - 1) : (i.push(e), e.setParent(t)), t.length += e.length;
}
function cF(t, e, n) {
  let r = null, i = -1, o = null, s = -1;
  function a(u, c) {
    for (let f = 0, d = 0; f < u.children.length && d <= c; f++) {
      let h = u.children[f], p = d + h.length;
      p >= c && (h.children.length ? a(h, c - d) : (!o || o.isHidden && n > 0) && (p > c || d == p && h.getSide() > 0) ? (o = h, s = c - d) : (d < c || d == p && h.getSide() < 0 && !h.isHidden) && (r = h, i = c - d)), d = p;
    }
  }
  a(t, e);
  let l = (n < 0 ? r : o) || r || o;
  return l ? l.coordsAt(Math.max(0, l == r ? i : s), n) : LG(t);
}
function LG(t) {
  let e = t.dom.lastChild;
  if (!e)
    return t.dom.getBoundingClientRect();
  let n = yh(e);
  return n[n.length - 1] || null;
}
function qw(t, e) {
  for (let n in t)
    n == "class" && e.class ? e.class += " " + t.class : n == "style" && e.style ? e.style += ";" + t.style : e[n] = t[n];
  return e;
}
const dx = /* @__PURE__ */ Object.create(null);
function Jm(t, e, n) {
  if (t == e)
    return !0;
  t || (t = dx), e || (e = dx);
  let r = Object.keys(t), i = Object.keys(e);
  if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != i.length - (n && i.indexOf(n) > -1 ? 1 : 0))
    return !1;
  for (let o of r)
    if (o != n && (i.indexOf(o) == -1 || t[o] !== e[o]))
      return !1;
  return !0;
}
function zw(t, e, n) {
  let r = !1;
  if (e)
    for (let i in e)
      n && i in n || (r = !0, i == "style" ? t.style.cssText = "" : t.removeAttribute(i));
  if (n)
    for (let i in n)
      e && e[i] == n[i] || (r = !0, i == "style" ? t.style.cssText = n[i] : t.setAttribute(i, n[i]));
  return r;
}
function BG(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n = 0; n < t.attributes.length; n++) {
    let r = t.attributes[n];
    e[r.name] = r.value;
  }
  return e;
}
class wE {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(e) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(e, n) {
    return !1;
  }
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(e) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(e, n, r) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(e) {
  }
}
var Co = /* @__PURE__ */ function(t) {
  return t[t.Text = 0] = "Text", t[t.WidgetBefore = 1] = "WidgetBefore", t[t.WidgetAfter = 2] = "WidgetAfter", t[t.WidgetRange = 3] = "WidgetRange", t;
}(Co || (Co = {}));
class cn extends Kc {
  constructor(e, n, r, i) {
    super(), this.startSide = e, this.endSide = n, this.widget = r, this.spec = i;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(e) {
    return new Xh(e);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(e) {
    let n = Math.max(-1e4, Math.min(1e4, e.side || 0)), r = !!e.block;
    return n += r && !e.inlineOrder ? n > 0 ? 3e8 : -4e8 : n > 0 ? 1e8 : -1e8, new fl(e, n, n, r, e.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(e) {
    let n = !!e.block, r, i;
    if (e.isBlockGap)
      r = -5e8, i = 4e8;
    else {
      let { start: o, end: s } = fF(e, n);
      r = (o ? n ? -3e8 : -1 : 5e8) - 1, i = (s ? n ? 2e8 : 1 : -6e8) + 1;
    }
    return new fl(e, r, i, n, e.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(e) {
    return new Kh(e);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(e, n = !1) {
    return Jt.of(e, n);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
cn.none = Jt.empty;
class Xh extends cn {
  constructor(e) {
    let { start: n, end: r } = fF(e);
    super(n ? -1 : 5e8, r ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.class = e.class || "", this.attrs = e.attributes || null;
  }
  eq(e) {
    var n, r;
    return this == e || e instanceof Xh && this.tagName == e.tagName && (this.class || ((n = this.attrs) === null || n === void 0 ? void 0 : n.class)) == (e.class || ((r = e.attrs) === null || r === void 0 ? void 0 : r.class)) && Jm(this.attrs, e.attrs, "class");
  }
  range(e, n = e) {
    if (e >= n)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(e, n);
  }
}
Xh.prototype.point = !1;
class Kh extends cn {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(e) {
    return e instanceof Kh && this.spec.class == e.spec.class && Jm(this.spec.attributes, e.spec.attributes);
  }
  range(e, n = e) {
    if (n != e)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(e, n);
  }
}
Kh.prototype.mapMode = Zi.TrackBefore;
Kh.prototype.point = !0;
class fl extends cn {
  constructor(e, n, r, i, o, s) {
    super(n, r, o, e), this.block = i, this.isReplace = s, this.mapMode = i ? n <= 0 ? Zi.TrackBefore : Zi.TrackAfter : Zi.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? Co.WidgetRange : this.startSide <= 0 ? Co.WidgetBefore : Co.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(e) {
    return e instanceof fl && jG(this.widget, e.widget) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
  }
  range(e, n = e) {
    if (this.isReplace && (e > n || e == n && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && n != e)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(e, n);
  }
}
fl.prototype.point = !0;
function fF(t, e = !1) {
  let { inclusiveStart: n, inclusiveEnd: r } = t;
  return n == null && (n = t.inclusive), r == null && (r = t.inclusive), { start: n ?? e, end: r ?? e };
}
function jG(t, e) {
  return t == e || !!(t && e && t.compare(e));
}
function rm(t, e, n, r = 0) {
  let i = n.length - 1;
  i >= 0 && n[i] + r >= t ? n[i] = Math.max(n[i], e) : n.push(t, e);
}
class ar extends wn {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(e, n, r, i, o, s) {
    if (r) {
      if (!(r instanceof ar))
        return !1;
      this.dom || r.transferDOM(this);
    }
    return i && this.setDeco(r ? r.attrs : null), oF(this, e, n, r ? r.children.slice() : [], o, s), !0;
  }
  split(e) {
    let n = new ar();
    if (n.breakAfter = this.breakAfter, this.length == 0)
      return n;
    let { i: r, off: i } = this.childPos(e);
    i && (n.append(this.children[r].split(i), 0), this.children[r].merge(i, this.children[r].length, null, !1, 0, 0), r++);
    for (let o = r; o < this.children.length; o++)
      n.append(this.children[o], 0);
    for (; r > 0 && this.children[r - 1].length == 0; )
      this.children[--r].destroy();
    return this.children.length = r, this.markDirty(), this.length = e, n;
  }
  transferDOM(e) {
    this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(e) {
    Jm(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
  }
  append(e, n) {
    uF(this, e, n);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(e) {
    let n = e.spec.attributes, r = e.spec.class;
    n && (this.attrs = qw(n, this.attrs || {})), r && (this.attrs = qw({ class: r }, this.attrs || {}));
  }
  domAtPos(e) {
    return lF(this, e);
  }
  reuseDOM(e) {
    e.nodeName == "DIV" && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    var r;
    this.dom ? this.flags & 4 && (ZM(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (zw(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(e, n);
    let i = this.dom.lastChild;
    for (; i && wn.get(i) instanceof va; )
      i = i.lastChild;
    if (!i || !this.length || i.nodeName != "BR" && ((r = wn.get(i)) === null || r === void 0 ? void 0 : r.isEditable) == !1 && (!Qe.ios || !this.children.some((o) => o instanceof Xo))) {
      let o = document.createElement("BR");
      o.cmIgnore = !0, this.dom.appendChild(o);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let e = 0, n;
    for (let r of this.children) {
      if (!(r instanceof Xo) || /[^ -~]/.test(r.text))
        return null;
      let i = yh(r.dom);
      if (i.length != 1)
        return null;
      e += i[0].width, n = i[0].height;
    }
    return e ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: e / this.length,
      textHeight: n
    } : null;
  }
  coordsAt(e, n) {
    let r = cF(this, e, n);
    if (!this.children.length && r && this.parent) {
      let { heightOracle: i } = this.parent.view.viewState, o = r.bottom - r.top;
      if (Math.abs(o - i.lineHeight) < 2 && i.textHeight < o) {
        let s = (o - i.textHeight) / 2;
        return { top: r.top + s, bottom: r.bottom - s, left: r.left, right: r.left };
      }
    }
    return r;
  }
  become(e) {
    return e instanceof ar && this.children.length == 0 && e.children.length == 0 && Jm(this.attrs, e.attrs) && this.breakAfter == e.breakAfter;
  }
  covers() {
    return !0;
  }
  static find(e, n) {
    for (let r = 0, i = 0; r < e.children.length; r++) {
      let o = e.children[r], s = i + o.length;
      if (s >= n) {
        if (o instanceof ar)
          return o;
        if (s > n)
          break;
      }
      i = s + o.breakAfter;
    }
    return null;
  }
}
class da extends wn {
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.deco = r, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(e, n, r, i, o, s) {
    return r && (!(r instanceof da) || !this.widget.compare(r.widget) || e > 0 && o <= 0 || n < this.length && s <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  domAtPos(e) {
    return e == 0 ? Zr.before(this.dom) : Zr.after(this.dom, e == this.length);
  }
  split(e) {
    let n = this.length - e;
    this.length = e;
    let r = new da(this.widget, n, this.deco);
    return r.breakAfter = this.breakAfter, r;
  }
  get children() {
    return bE;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : Zt.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(e) {
    return e instanceof da && e.widget.constructor == this.widget.constructor ? (e.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.deco = e.deco, this.breakAfter = e.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(e, n) {
    let r = this.widget.coordsAt(this.dom, e, n);
    return r || (this.widget instanceof Hw ? null : o0(this.dom.getBoundingClientRect(), this.length ? e == 0 : n <= 0));
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(e) {
    let { startSide: n, endSide: r } = this.deco;
    return n == r ? !1 : e < 0 ? n < 0 : r > 0;
  }
}
class Hw extends wE {
  constructor(e) {
    super(), this.height = e;
  }
  toDOM() {
    let e = document.createElement("div");
    return e.className = "cm-gap", this.updateDOM(e), e;
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return e.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
}
class Kd {
  constructor(e, n, r, i) {
    this.doc = e, this.pos = n, this.end = r, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = e.iter(), this.skip = n;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let e = this.content[this.content.length - 1];
    return !(e.breakAfter || e instanceof da && e.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new ar()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(e = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(Gp(new Jc(-1), e), e.length), this.pendingBuffer = 0);
  }
  addBlockWidget(e) {
    this.flushBuffer(), this.curLine = null, this.content.push(e);
  }
  finish(e) {
    this.pendingBuffer && e <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(e && this.content.length && this.content[this.content.length - 1] instanceof da) && this.getLine();
  }
  buildText(e, n, r) {
    for (; e > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: o, lineBreak: s, done: a } = this.cursor.next(this.skip);
        if (this.skip = 0, a)
          throw new Error("Ran out of text content when drawing inline views");
        if (s) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, e--;
          continue;
        } else
          this.text = o, this.textOff = 0;
      }
      let i = Math.min(
        this.text.length - this.textOff,
        e,
        512
        /* T.Chunk */
      );
      this.flushBuffer(n.slice(n.length - r)), this.getLine().append(Gp(new Xo(this.text.slice(this.textOff, this.textOff + i)), n), r), this.atCursorPos = !0, this.textOff += i, e -= i, r = 0;
    }
  }
  span(e, n, r, i) {
    this.buildText(n - e, r, i), this.pos = n, this.openStart < 0 && (this.openStart = i);
  }
  point(e, n, r, i, o, s) {
    if (this.disallowBlockEffectsFor[s] && r instanceof fl) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (n > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let a = n - e;
    if (r instanceof fl)
      if (r.block)
        r.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new da(r.widget || Zc.block, a, r));
      else {
        let l = eu.create(r.widget || Zc.inline, a, a ? 0 : r.startSide), u = this.atCursorPos && !l.isEditable && o <= i.length && (e < n || r.startSide > 0), c = !l.isEditable && (e < n || o > i.length || r.startSide <= 0), f = this.getLine();
        this.pendingBuffer == 2 && !u && !l.isEditable && (this.pendingBuffer = 0), this.flushBuffer(i), u && (f.append(Gp(new Jc(1), i), o), o = i.length + Math.max(0, o - i.length)), f.append(Gp(l, i), o), this.atCursorPos = c, this.pendingBuffer = c ? e < n || o > i.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = i.slice());
      }
    else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = n), this.openStart < 0 && (this.openStart = o);
  }
  static build(e, n, r, i, o) {
    let s = new Kd(e, n, r, o);
    return s.openEnd = Jt.spans(i, n, r, s), s.openStart < 0 && (s.openStart = s.openEnd), s.finish(s.openEnd), s;
  }
}
function Gp(t, e) {
  for (let n of e)
    t = new va(n, [t], t.length);
  return t;
}
class Zc extends wE {
  constructor(e) {
    super(), this.tag = e;
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
Zc.inline = /* @__PURE__ */ new Zc("span");
Zc.block = /* @__PURE__ */ new Zc("div");
var $r = /* @__PURE__ */ function(t) {
  return t[t.LTR = 0] = "LTR", t[t.RTL = 1] = "RTL", t;
}($r || ($r = {}));
const ku = $r.LTR, SE = $r.RTL;
function dF(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    e.push(1 << +t[n]);
  return e;
}
const VG = /* @__PURE__ */ dF("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), UG = /* @__PURE__ */ dF("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), Gw = /* @__PURE__ */ Object.create(null), rs = [];
for (let t of ["()", "[]", "{}"]) {
  let e = /* @__PURE__ */ t.charCodeAt(0), n = /* @__PURE__ */ t.charCodeAt(1);
  Gw[e] = n, Gw[n] = -e;
}
function hF(t) {
  return t <= 247 ? VG[t] : 1424 <= t && t <= 1524 ? 2 : 1536 <= t && t <= 1785 ? UG[t - 1536] : 1774 <= t && t <= 2220 ? 4 : 8192 <= t && t <= 8204 ? 256 : 64336 <= t && t <= 65023 ? 4 : 1;
}
const qG = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class Wa {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? SE : ku;
  }
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.level = r;
  }
  /**
  @internal
  */
  side(e, n) {
    return this.dir == n == e ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(e, n) {
    return e == (this.dir == n);
  }
  /**
  @internal
  */
  static find(e, n, r, i) {
    let o = -1;
    for (let s = 0; s < e.length; s++) {
      let a = e[s];
      if (a.from <= n && a.to >= n) {
        if (a.level == r)
          return s;
        (o < 0 || (i != 0 ? i < 0 ? a.from < n : a.to > n : e[o].level > a.level)) && (o = s);
      }
    }
    if (o < 0)
      throw new RangeError("Index out of range");
    return o;
  }
}
function pF(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++) {
    let r = t[n], i = e[n];
    if (r.from != i.from || r.to != i.to || r.direction != i.direction || !pF(r.inner, i.inner))
      return !1;
  }
  return !0;
}
const vn = [];
function zG(t, e, n, r, i) {
  for (let o = 0; o <= r.length; o++) {
    let s = o ? r[o - 1].to : e, a = o < r.length ? r[o].from : n, l = o ? 256 : i;
    for (let u = s, c = l, f = l; u < a; u++) {
      let d = hF(t.charCodeAt(u));
      d == 512 ? d = c : d == 8 && f == 4 && (d = 16), vn[u] = d == 4 ? 2 : d, d & 7 && (f = d), c = d;
    }
    for (let u = s, c = l, f = l; u < a; u++) {
      let d = vn[u];
      if (d == 128)
        u < a - 1 && c == vn[u + 1] && c & 24 ? d = vn[u] = c : vn[u] = 256;
      else if (d == 64) {
        let h = u + 1;
        for (; h < a && vn[h] == 64; )
          h++;
        let p = u && c == 8 || h < n && vn[h] == 8 ? f == 1 ? 1 : 8 : 256;
        for (let g = u; g < h; g++)
          vn[g] = p;
        u = h - 1;
      } else d == 8 && f == 1 && (vn[u] = 1);
      c = d, d & 7 && (f = d);
    }
  }
}
function HG(t, e, n, r, i) {
  let o = i == 1 ? 2 : 1;
  for (let s = 0, a = 0, l = 0; s <= r.length; s++) {
    let u = s ? r[s - 1].to : e, c = s < r.length ? r[s].from : n;
    for (let f = u, d, h, p; f < c; f++)
      if (h = Gw[d = t.charCodeAt(f)])
        if (h < 0) {
          for (let g = a - 3; g >= 0; g -= 3)
            if (rs[g + 1] == -h) {
              let m = rs[g + 2], v = m & 2 ? i : m & 4 ? m & 1 ? o : i : 0;
              v && (vn[f] = vn[rs[g]] = v), a = g;
              break;
            }
        } else {
          if (rs.length == 189)
            break;
          rs[a++] = f, rs[a++] = d, rs[a++] = l;
        }
      else if ((p = vn[f]) == 2 || p == 1) {
        let g = p == i;
        l = g ? 0 : 1;
        for (let m = a - 3; m >= 0; m -= 3) {
          let v = rs[m + 2];
          if (v & 2)
            break;
          if (g)
            rs[m + 2] |= 2;
          else {
            if (v & 4)
              break;
            rs[m + 2] |= 4;
          }
        }
      }
  }
}
function GG(t, e, n, r) {
  for (let i = 0, o = r; i <= n.length; i++) {
    let s = i ? n[i - 1].to : t, a = i < n.length ? n[i].from : e;
    for (let l = s; l < a; ) {
      let u = vn[l];
      if (u == 256) {
        let c = l + 1;
        for (; ; )
          if (c == a) {
            if (i == n.length)
              break;
            c = n[i++].to, a = i < n.length ? n[i].from : e;
          } else if (vn[c] == 256)
            c++;
          else
            break;
        let f = o == 1, d = (c < e ? vn[c] : r) == 1, h = f == d ? f ? 1 : 2 : r;
        for (let p = c, g = i, m = g ? n[g - 1].to : t; p > l; )
          p == m && (p = n[--g].from, m = g ? n[g - 1].to : t), vn[--p] = h;
        l = c;
      } else
        o = u, l++;
    }
  }
}
function Ww(t, e, n, r, i, o, s) {
  let a = r % 2 ? 2 : 1;
  if (r % 2 == i % 2)
    for (let l = e, u = 0; l < n; ) {
      let c = !0, f = !1;
      if (u == o.length || l < o[u].from) {
        let g = vn[l];
        g != a && (c = !1, f = g == 16);
      }
      let d = !c && a == 1 ? [] : null, h = c ? r : r + 1, p = l;
      e: for (; ; )
        if (u < o.length && p == o[u].from) {
          if (f)
            break e;
          let g = o[u];
          if (!c)
            for (let m = g.to, v = u + 1; ; ) {
              if (m == n)
                break e;
              if (v < o.length && o[v].from == m)
                m = o[v++].to;
              else {
                if (vn[m] == a)
                  break e;
                break;
              }
            }
          if (u++, d)
            d.push(g);
          else {
            g.from > l && s.push(new Wa(l, g.from, h));
            let m = g.direction == ku != !(h % 2);
            Yw(t, m ? r + 1 : r, i, g.inner, g.from, g.to, s), l = g.to;
          }
          p = g.to;
        } else {
          if (p == n || (c ? vn[p] != a : vn[p] == a))
            break;
          p++;
        }
      d ? Ww(t, l, p, r + 1, i, d, s) : l < p && s.push(new Wa(l, p, h)), l = p;
    }
  else
    for (let l = n, u = o.length; l > e; ) {
      let c = !0, f = !1;
      if (!u || l > o[u - 1].to) {
        let g = vn[l - 1];
        g != a && (c = !1, f = g == 16);
      }
      let d = !c && a == 1 ? [] : null, h = c ? r : r + 1, p = l;
      e: for (; ; )
        if (u && p == o[u - 1].to) {
          if (f)
            break e;
          let g = o[--u];
          if (!c)
            for (let m = g.from, v = u; ; ) {
              if (m == e)
                break e;
              if (v && o[v - 1].to == m)
                m = o[--v].from;
              else {
                if (vn[m - 1] == a)
                  break e;
                break;
              }
            }
          if (d)
            d.push(g);
          else {
            g.to < l && s.push(new Wa(g.to, l, h));
            let m = g.direction == ku != !(h % 2);
            Yw(t, m ? r + 1 : r, i, g.inner, g.from, g.to, s), l = g.from;
          }
          p = g.from;
        } else {
          if (p == e || (c ? vn[p - 1] != a : vn[p - 1] == a))
            break;
          p--;
        }
      d ? Ww(t, p, l, r + 1, i, d, s) : p < l && s.push(new Wa(p, l, h)), l = p;
    }
}
function Yw(t, e, n, r, i, o, s) {
  let a = e % 2 ? 2 : 1;
  zG(t, i, o, r, a), HG(t, i, o, r, a), GG(i, o, r, a), Ww(t, i, o, e, n, r, s);
}
function WG(t, e, n) {
  if (!t)
    return [new Wa(0, 0, e == SE ? 1 : 0)];
  if (e == ku && !n.length && !qG.test(t))
    return gF(t.length);
  if (n.length)
    for (; t.length > vn.length; )
      vn[vn.length] = 256;
  let r = [], i = e == ku ? 0 : 1;
  return Yw(t, i, i, n, 0, t.length, r), r;
}
function gF(t) {
  return [new Wa(0, t, 0)];
}
let mF = "";
function YG(t, e, n, r, i) {
  var o;
  let s = r.head - t.from, a = Wa.find(e, s, (o = r.bidiLevel) !== null && o !== void 0 ? o : -1, r.assoc), l = e[a], u = l.side(i, n);
  if (s == u) {
    let d = a += i ? 1 : -1;
    if (d < 0 || d >= e.length)
      return null;
    l = e[a = d], s = l.side(!i, n), u = l.side(i, n);
  }
  let c = ia(t.text, s, l.forward(i, n));
  (c < l.from || c > l.to) && (c = u), mF = t.text.slice(Math.min(s, c), Math.max(s, c));
  let f = a == (i ? e.length - 1 : 0) ? null : e[a + (i ? 1 : -1)];
  return f && c == u && f.level + (i ? 0 : 1) < l.level ? ot.cursor(f.side(!i, n) + t.from, f.forward(i, n) ? 1 : -1, f.level) : ot.cursor(c + t.from, l.forward(i, n) ? -1 : 1, l.level);
}
function XG(t, e, n) {
  for (let r = e; r < n; r++) {
    let i = hF(t.charCodeAt(r));
    if (i == 1)
      return ku;
    if (i == 2 || i == 4)
      return SE;
  }
  return ku;
}
const yF = /* @__PURE__ */ vt.define(), vF = /* @__PURE__ */ vt.define(), bF = /* @__PURE__ */ vt.define(), wF = /* @__PURE__ */ vt.define(), Xw = /* @__PURE__ */ vt.define(), SF = /* @__PURE__ */ vt.define(), _F = /* @__PURE__ */ vt.define(), _E = /* @__PURE__ */ vt.define(), EE = /* @__PURE__ */ vt.define(), EF = /* @__PURE__ */ vt.define({
  combine: (t) => t.some((e) => e)
}), KG = /* @__PURE__ */ vt.define({
  combine: (t) => t.some((e) => e)
}), kF = /* @__PURE__ */ vt.define();
class wc {
  constructor(e, n = "nearest", r = "nearest", i = 5, o = 5, s = !1) {
    this.range = e, this.y = n, this.x = r, this.yMargin = i, this.xMargin = o, this.isSnapshot = s;
  }
  map(e) {
    return e.empty ? this : new wc(this.range.map(e), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(e) {
    return this.range.to <= e.doc.length ? this : new wc(ot.cursor(e.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const Wp = /* @__PURE__ */ fr.define({ map: (t, e) => t.map(e) }), TF = /* @__PURE__ */ fr.define();
function ws(t, e, n) {
  let r = t.facet(wF);
  r.length ? r[0](e) : window.onerror ? window.onerror(String(e), n, void 0, void 0, e) : n ? console.error(n + ":", e) : console.error(e);
}
const ea = /* @__PURE__ */ vt.define({ combine: (t) => t.length ? t[0] : !0 });
let QG = 0;
const xd = /* @__PURE__ */ vt.define();
class No {
  constructor(e, n, r, i, o) {
    this.id = e, this.create = n, this.domEventHandlers = r, this.domEventObservers = i, this.extension = o(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(e, n) {
    const { eventHandlers: r, eventObservers: i, provide: o, decorations: s } = n || {};
    return new No(QG++, e, r, i, (a) => {
      let l = [xd.of(a)];
      return s && l.push(vh.of((u) => {
        let c = u.plugin(a);
        return c ? s(c) : cn.none;
      })), o && l.push(o(a)), l;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(e, n) {
    return No.define((r) => new e(r), n);
  }
}
class fv {
  constructor(e) {
    this.spec = e, this.mustUpdate = null, this.value = null;
  }
  update(e) {
    if (this.value) {
      if (this.mustUpdate) {
        let n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(n);
          } catch (r) {
            if (ws(n.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(e);
      } catch (n) {
        ws(e.state, n, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(e) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        ws(e.state, r, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const xF = /* @__PURE__ */ vt.define(), kE = /* @__PURE__ */ vt.define(), vh = /* @__PURE__ */ vt.define(), CF = /* @__PURE__ */ vt.define(), TE = /* @__PURE__ */ vt.define(), AF = /* @__PURE__ */ vt.define();
function hx(t, e) {
  let n = t.state.facet(AF);
  if (!n.length)
    return n;
  let r = n.map((o) => o instanceof Function ? o(t) : o), i = [];
  return Jt.spans(r, e.from, e.to, {
    point() {
    },
    span(o, s, a, l) {
      let u = o - e.from, c = s - e.from, f = i;
      for (let d = a.length - 1; d >= 0; d--, l--) {
        let h = a[d].spec.bidiIsolate, p;
        if (h == null && (h = XG(e.text, u, c)), l > 0 && f.length && (p = f[f.length - 1]).to == u && p.direction == h)
          p.to = c, f = p.inner;
        else {
          let g = { from: u, to: c, direction: h, inner: [] };
          f.push(g), f = g.inner;
        }
      }
    }
  }), i;
}
const RF = /* @__PURE__ */ vt.define();
function OF(t) {
  let e = 0, n = 0, r = 0, i = 0;
  for (let o of t.state.facet(RF)) {
    let s = o(t);
    s && (s.left != null && (e = Math.max(e, s.left)), s.right != null && (n = Math.max(n, s.right)), s.top != null && (r = Math.max(r, s.top)), s.bottom != null && (i = Math.max(i, s.bottom)));
  }
  return { left: e, right: n, top: r, bottom: i };
}
const Cd = /* @__PURE__ */ vt.define();
class Ao {
  constructor(e, n, r, i) {
    this.fromA = e, this.toA = n, this.fromB = r, this.toB = i;
  }
  join(e) {
    return new Ao(Math.min(this.fromA, e.fromA), Math.max(this.toA, e.toA), Math.min(this.fromB, e.fromB), Math.max(this.toB, e.toB));
  }
  addToSet(e) {
    let n = e.length, r = this;
    for (; n > 0; n--) {
      let i = e[n - 1];
      if (!(i.fromA > r.toA)) {
        if (i.toA < r.fromA)
          break;
        r = r.join(i), e.splice(n - 1, 1);
      }
    }
    return e.splice(n, 0, r), e;
  }
  static extendWithRanges(e, n) {
    if (n.length == 0)
      return e;
    let r = [];
    for (let i = 0, o = 0, s = 0, a = 0; ; i++) {
      let l = i == e.length ? null : e[i], u = s - a, c = l ? l.fromB : 1e9;
      for (; o < n.length && n[o] < c; ) {
        let f = n[o], d = n[o + 1], h = Math.max(a, f), p = Math.min(c, d);
        if (h <= p && new Ao(h + u, p + u, h, p).addToSet(r), d > c)
          break;
        o += 2;
      }
      if (!l)
        return r;
      new Ao(l.fromA, l.toA, l.fromB, l.toB).addToSet(r), s = l.toA, a = l.toB;
    }
  }
}
class Zm {
  constructor(e, n, r) {
    this.view = e, this.state = n, this.transactions = r, this.flags = 0, this.startState = e.state, this.changes = Ir.empty(this.startState.doc.length);
    for (let o of r)
      this.changes = this.changes.compose(o.changes);
    let i = [];
    this.changes.iterChangedRanges((o, s, a, l) => i.push(new Ao(o, s, a, l))), this.changedRanges = i;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new Zm(e, n, r);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Returns true when
  [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
  and the viewport change is not just the result of mapping it in
  response to document changes.
  */
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 18) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((e) => e.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class px extends wn {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(e) {
    super(), this.view = e, this.decorations = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.editContextFormatting = cn.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(e.contentDOM), this.children = [new ar()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new Ao(0, 0, 0, e.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(e) {
    var n;
    let r = e.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({ fromA: u, toA: c }) => c < this.minWidthFrom || u > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(e);
    let i = -1;
    this.view.inputState.composing >= 0 && !this.view.observer.editContext && (!((n = this.domChanged) === null || n === void 0) && n.newSel ? i = this.domChanged.newSel.head : !iW(e.changes, this.hasComposition) && !e.selectionSet && (i = e.state.selection.main.head));
    let o = i > -1 ? ZG(this.view, e.changes, i) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: u, to: c } = this.hasComposition;
      r = new Ao(u, c, e.changes.mapPos(u, -1), e.changes.mapPos(c, 1)).addToSet(r.slice());
    }
    this.hasComposition = o ? { from: o.range.fromB, to: o.range.toB } : null, (Qe.ie || Qe.chrome) && !o && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
    let s = this.decorations, a = this.updateDeco(), l = nW(s, a, e.changes);
    return r = Ao.extendWithRanges(r, l), !(this.flags & 7) && r.length == 0 ? !1 : (this.updateInner(r, e.startState.doc.length, o), e.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(e, n, r) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, n, r);
    let { observer: i } = this.view;
    i.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let s = Qe.chrome || Qe.ios ? { node: i.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, s), this.flags &= -8, s && (s.written || i.selectionRange.focusNode != s.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (s) => s.flags &= -9
      /* ViewFlag.Composition */
    );
    let o = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let s of this.children)
        s instanceof da && s.widget instanceof Hw && o.push(s.dom);
    i.updateGaps(o);
  }
  updateChildren(e, n, r) {
    let i = r ? r.range.addToSet(e.slice()) : e, o = this.childCursor(n);
    for (let s = i.length - 1; ; s--) {
      let a = s >= 0 ? i[s] : null;
      if (!a)
        break;
      let { fromA: l, toA: u, fromB: c, toB: f } = a, d, h, p, g;
      if (r && r.range.fromB < f && r.range.toB > c) {
        let b = Kd.build(this.view.state.doc, c, r.range.fromB, this.decorations, this.dynamicDecorationMap), y = Kd.build(this.view.state.doc, r.range.toB, f, this.decorations, this.dynamicDecorationMap);
        h = b.breakAtStart, p = b.openStart, g = y.openEnd;
        let w = this.compositionView(r);
        y.breakAtStart ? w.breakAfter = 1 : y.content.length && w.merge(w.length, w.length, y.content[0], !1, y.openStart, 0) && (w.breakAfter = y.content[0].breakAfter, y.content.shift()), b.content.length && w.merge(0, 0, b.content[b.content.length - 1], !0, 0, b.openEnd) && b.content.pop(), d = b.content.concat(w).concat(y.content);
      } else
        ({ content: d, breakAtStart: h, openStart: p, openEnd: g } = Kd.build(this.view.state.doc, c, f, this.decorations, this.dynamicDecorationMap));
      let { i: m, off: v } = o.findPos(u, 1), { i: S, off: _ } = o.findPos(l, -1);
      iF(this, S, _, m, v, d, h, p, g);
    }
    r && this.fixCompositionDOM(r);
  }
  updateEditContextFormatting(e) {
    this.editContextFormatting = this.editContextFormatting.map(e.changes);
    for (let n of e.transactions)
      for (let r of n.effects)
        r.is(TF) && (this.editContextFormatting = r.value);
  }
  compositionView(e) {
    let n = new Xo(e.text.nodeValue);
    n.flags |= 8;
    for (let { deco: i } of e.marks)
      n = new va(i, [n], n.length);
    let r = new ar();
    return r.append(n, 0), r;
  }
  fixCompositionDOM(e) {
    let n = (o, s) => {
      s.flags |= 8 | (s.children.some(
        (l) => l.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(s);
      let a = wn.get(o);
      a && a != s && (a.dom = null), s.setDOM(o);
    }, r = this.childPos(e.range.fromB, 1), i = this.children[r.i];
    n(e.line, i);
    for (let o = e.marks.length - 1; o >= -1; o--)
      r = i.childPos(r.off, 1), i = i.children[r.i], n(o >= 0 ? e.marks[o].node : e.text, i);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(e = !1, n = !1) {
    (e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let r = this.view.root.activeElement, i = r == this.dom, o = !i && !(this.view.state.facet(ea) || this.dom.tabIndex > -1) && nm(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
    if (!(i || n || o))
      return;
    let s = this.forceSelection;
    this.forceSelection = !1;
    let a = this.view.state.selection.main, l = this.moveToLine(this.domAtPos(a.anchor)), u = a.empty ? l : this.moveToLine(this.domAtPos(a.head));
    if (Qe.gecko && a.empty && !this.hasComposition && JG(l)) {
      let f = document.createTextNode("");
      this.view.observer.ignore(() => l.node.insertBefore(f, l.node.childNodes[l.offset] || null)), l = u = new Zr(f, 0), s = !0;
    }
    let c = this.view.observer.selectionRange;
    (s || !c.focusNode || (!Xd(l.node, l.offset, c.anchorNode, c.anchorOffset) || !Xd(u.node, u.offset, c.focusNode, c.focusOffset)) && !this.suppressWidgetCursorChange(c, a)) && (this.view.observer.ignore(() => {
      Qe.android && Qe.chrome && this.dom.contains(c.focusNode) && rW(c.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let f = mh(this.view.root);
      if (f) if (a.empty) {
        if (Qe.gecko) {
          let d = eW(l.node, l.offset);
          if (d && d != 3) {
            let h = (d == 1 ? tF : nF)(l.node, l.offset);
            h && (l = new Zr(h.node, h.offset));
          }
        }
        f.collapse(l.node, l.offset), a.bidiLevel != null && f.caretBidiLevel !== void 0 && (f.caretBidiLevel = a.bidiLevel);
      } else if (f.extend) {
        f.collapse(l.node, l.offset);
        try {
          f.extend(u.node, u.offset);
        } catch {
        }
      } else {
        let d = document.createRange();
        a.anchor > a.head && ([l, u] = [u, l]), d.setEnd(u.node, u.offset), d.setStart(l.node, l.offset), f.removeAllRanges(), f.addRange(d);
      }
      o && this.view.root.activeElement == this.dom && (this.dom.blur(), r && r.focus());
    }), this.view.observer.setSelectionRange(l, u)), this.impreciseAnchor = l.precise ? null : new Zr(c.anchorNode, c.anchorOffset), this.impreciseHead = u.precise ? null : new Zr(c.focusNode, c.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(e, n) {
    return this.hasComposition && n.empty && Xd(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == n.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: e } = this, n = e.state.selection.main, r = mh(e.root), { anchorNode: i, anchorOffset: o } = e.observer.selectionRange;
    if (!r || !n.empty || !n.assoc || !r.modify)
      return;
    let s = ar.find(this, n.head);
    if (!s)
      return;
    let a = s.posAtStart;
    if (n.head == a || n.head == a + s.length)
      return;
    let l = this.coordsAt(n.head, -1), u = this.coordsAt(n.head, 1);
    if (!l || !u || l.bottom > u.top)
      return;
    let c = this.domAtPos(n.head + n.assoc);
    r.collapse(c.node, c.offset), r.modify("move", n.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
    let f = e.observer.selectionRange;
    e.docView.posFromDOM(f.anchorNode, f.anchorOffset) != n.from && r.collapse(i, o);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(e) {
    let n = this.dom, r;
    if (e.node != n)
      return e;
    for (let i = e.offset; !r && i < n.childNodes.length; i++) {
      let o = wn.get(n.childNodes[i]);
      o instanceof ar && (r = o.domAtPos(0));
    }
    for (let i = e.offset - 1; !r && i >= 0; i--) {
      let o = wn.get(n.childNodes[i]);
      o instanceof ar && (r = o.domAtPos(o.length));
    }
    return r ? new Zr(r.node, r.offset, !0) : e;
  }
  nearest(e) {
    for (let n = e; n; ) {
      let r = wn.get(n);
      if (r && r.rootView == this)
        return r;
      n = n.parentNode;
    }
    return null;
  }
  posFromDOM(e, n) {
    let r = this.nearest(e);
    if (!r)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return r.localPosFromDOM(e, n) + r.posAtStart;
  }
  domAtPos(e) {
    let { i: n, off: r } = this.childCursor().findPos(e, -1);
    for (; n < this.children.length - 1; ) {
      let i = this.children[n];
      if (r < i.length || i instanceof ar)
        break;
      n++, r = 0;
    }
    return this.children[n].domAtPos(r);
  }
  coordsAt(e, n) {
    let r = null, i = 0;
    for (let o = this.length, s = this.children.length - 1; s >= 0; s--) {
      let a = this.children[s], l = o - a.breakAfter, u = l - a.length;
      if (l < e)
        break;
      if (u <= e && (u < e || a.covers(-1)) && (l > e || a.covers(1)) && (!r || a instanceof ar && !(r instanceof ar && n >= 0)))
        r = a, i = u;
      else if (r && u == e && l == e && a instanceof da && Math.abs(n) < 2) {
        if (a.deco.startSide < 0)
          break;
        s && (r = null);
      }
      o = u;
    }
    return r ? r.coordsAt(e - i, n) : null;
  }
  coordsForChar(e) {
    let { i: n, off: r } = this.childPos(e, 1), i = this.children[n];
    if (!(i instanceof ar))
      return null;
    for (; i.children.length; ) {
      let { i: a, off: l } = i.childPos(r, 1);
      for (; ; a++) {
        if (a == i.children.length)
          return null;
        if ((i = i.children[a]).length)
          break;
      }
      r = l;
    }
    if (!(i instanceof Xo))
      return null;
    let o = ia(i.text, r);
    if (o == r)
      return null;
    let s = Eu(i.dom, r, o).getClientRects();
    for (let a = 0; a < s.length; a++) {
      let l = s[a];
      if (a == s.length - 1 || l.top < l.bottom && l.left < l.right)
        return l;
    }
    return null;
  }
  measureVisibleLineHeights(e) {
    let n = [], { from: r, to: i } = e, o = this.view.contentDOM.clientWidth, s = o > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, l = this.view.textDirection == $r.LTR;
    for (let u = 0, c = 0; c < this.children.length; c++) {
      let f = this.children[c], d = u + f.length;
      if (d > i)
        break;
      if (u >= r) {
        let h = f.dom.getBoundingClientRect();
        if (n.push(h.height), s) {
          let p = f.dom.lastChild, g = p ? yh(p) : [];
          if (g.length) {
            let m = g[g.length - 1], v = l ? m.right - h.left : h.right - m.left;
            v > a && (a = v, this.minWidth = o, this.minWidthFrom = u, this.minWidthTo = d);
          }
        }
      }
      u = d + f.breakAfter;
    }
    return n;
  }
  textDirectionAt(e) {
    let { i: n } = this.childPos(e, 1);
    return getComputedStyle(this.children[n].dom).direction == "rtl" ? $r.RTL : $r.LTR;
  }
  measureTextSize() {
    for (let o of this.children)
      if (o instanceof ar) {
        let s = o.measureTextSize();
        if (s)
          return s;
      }
    let e = document.createElement("div"), n, r, i;
    return e.className = "cm-line", e.style.width = "99999px", e.style.position = "absolute", e.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(e);
      let o = yh(e.firstChild)[0];
      n = e.getBoundingClientRect().height, r = o ? o.width / 27 : 7, i = o ? o.height : n, e.remove();
    }), { lineHeight: n, charWidth: r, textHeight: i };
  }
  childCursor(e = this.length) {
    let n = this.children.length;
    return n && (e -= this.children[--n].length), new rF(this.children, e, n);
  }
  computeBlockGapDeco() {
    let e = [], n = this.view.viewState;
    for (let r = 0, i = 0; ; i++) {
      let o = i == n.viewports.length ? null : n.viewports[i], s = o ? o.from - 1 : this.length;
      if (s > r) {
        let a = (n.lineBlockAt(s).bottom - n.lineBlockAt(r).top) / this.view.scaleY;
        e.push(cn.replace({
          widget: new Hw(a),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(r, s));
      }
      if (!o)
        break;
      r = o.to + 1;
    }
    return cn.set(e);
  }
  updateDeco() {
    let e = 1, n = this.view.state.facet(vh).map((o) => (this.dynamicDecorationMap[e++] = typeof o == "function") ? o(this.view) : o), r = !1, i = this.view.state.facet(CF).map((o, s) => {
      let a = typeof o == "function";
      return a && (r = !0), a ? o(this.view) : o;
    });
    for (i.length && (this.dynamicDecorationMap[e++] = r, n.push(Jt.join(i))), this.decorations = [
      this.editContextFormatting,
      ...n,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ]; e < this.decorations.length; )
      this.dynamicDecorationMap[e++] = !1;
    return this.decorations;
  }
  scrollIntoView(e) {
    if (e.isSnapshot) {
      let u = this.view.viewState.lineBlockAt(e.range.head);
      this.view.scrollDOM.scrollTop = u.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
      return;
    }
    for (let u of this.view.state.facet(kF))
      try {
        if (u(this.view, e.range, e))
          return !0;
      } catch (c) {
        ws(this.view.state, c, "scroll handler");
      }
    let { range: n } = e, r = this.coordsAt(n.head, n.empty ? n.assoc : n.head > n.anchor ? -1 : 1), i;
    if (!r)
      return;
    !n.empty && (i = this.coordsAt(n.anchor, n.anchor > n.head ? -1 : 1)) && (r = {
      left: Math.min(r.left, i.left),
      top: Math.min(r.top, i.top),
      right: Math.max(r.right, i.right),
      bottom: Math.max(r.bottom, i.bottom)
    });
    let o = OF(this.view), s = {
      left: r.left - o.left,
      top: r.top - o.top,
      right: r.right + o.right,
      bottom: r.bottom + o.bottom
    }, { offsetWidth: a, offsetHeight: l } = this.view.scrollDOM;
    DG(this.view.scrollDOM, s, n.head < n.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, a), -a), Math.max(Math.min(e.yMargin, l), -l), this.view.textDirection == $r.LTR);
  }
}
function JG(t) {
  return t.node.nodeType == 1 && t.node.firstChild && (t.offset == 0 || t.node.childNodes[t.offset - 1].contentEditable == "false") && (t.offset == t.node.childNodes.length || t.node.childNodes[t.offset].contentEditable == "false");
}
function DF(t, e) {
  let n = t.observer.selectionRange;
  if (!n.focusNode)
    return null;
  let r = tF(n.focusNode, n.focusOffset), i = nF(n.focusNode, n.focusOffset), o = r || i;
  if (i && r && i.node != r.node) {
    let a = wn.get(i.node);
    if (!a || a instanceof Xo && a.text != i.node.nodeValue)
      o = i;
    else if (t.docView.lastCompositionAfterCursor) {
      let l = wn.get(r.node);
      !l || l instanceof Xo && l.text != r.node.nodeValue || (o = i);
    }
  }
  if (t.docView.lastCompositionAfterCursor = o != r, !o)
    return null;
  let s = e - o.offset;
  return { from: s, to: s + o.node.nodeValue.length, node: o.node };
}
function ZG(t, e, n) {
  let r = DF(t, n);
  if (!r)
    return null;
  let { node: i, from: o, to: s } = r, a = i.nodeValue;
  if (/[\n\r]/.test(a) || t.state.doc.sliceString(r.from, r.to) != a)
    return null;
  let l = e.invertedDesc, u = new Ao(l.mapPos(o), l.mapPos(s), o, s), c = [];
  for (let f = i.parentNode; ; f = f.parentNode) {
    let d = wn.get(f);
    if (d instanceof va)
      c.push({ node: f, deco: d.mark });
    else {
      if (d instanceof ar || f.nodeName == "DIV" && f.parentNode == t.contentDOM)
        return { range: u, text: i, marks: c, line: f };
      if (f != t.contentDOM)
        c.push({ node: f, deco: new Xh({
          inclusive: !0,
          attributes: BG(f),
          tagName: f.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function eW(t, e) {
  return t.nodeType != 1 ? 0 : (e && t.childNodes[e - 1].contentEditable == "false" ? 1 : 0) | (e < t.childNodes.length && t.childNodes[e].contentEditable == "false" ? 2 : 0);
}
let tW = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, n) {
    rm(e, n, this.changes);
  }
  comparePoint(e, n) {
    rm(e, n, this.changes);
  }
  boundChange(e) {
    rm(e, e, this.changes);
  }
};
function nW(t, e, n) {
  let r = new tW();
  return Jt.compare(t, e, n, r), r.changes;
}
function rW(t, e) {
  for (let n = t; n && n != e; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == "false")
      return !0;
  return !1;
}
function iW(t, e) {
  let n = !1;
  return e && t.iterChangedRanges((r, i) => {
    r < e.to && i > e.from && (n = !0);
  }), n;
}
function oW(t, e, n = 1) {
  let r = t.charCategorizer(e), i = t.doc.lineAt(e), o = e - i.from;
  if (i.length == 0)
    return ot.cursor(e);
  o == 0 ? n = 1 : o == i.length && (n = -1);
  let s = o, a = o;
  n < 0 ? s = ia(i.text, o, !1) : a = ia(i.text, o);
  let l = r(i.text.slice(s, a));
  for (; s > 0; ) {
    let u = ia(i.text, s, !1);
    if (r(i.text.slice(u, s)) != l)
      break;
    s = u;
  }
  for (; a < i.length; ) {
    let u = ia(i.text, a);
    if (r(i.text.slice(a, u)) != l)
      break;
    a = u;
  }
  return ot.range(s + i.from, a + i.from);
}
function sW(t, e) {
  return e.left > t ? e.left - t : Math.max(0, t - e.right);
}
function aW(t, e) {
  return e.top > t ? e.top - t : Math.max(0, t - e.bottom);
}
function dv(t, e) {
  return t.top < e.bottom - 1 && t.bottom > e.top + 1;
}
function gx(t, e) {
  return e < t.top ? { top: e, left: t.left, right: t.right, bottom: t.bottom } : t;
}
function mx(t, e) {
  return e > t.bottom ? { top: t.top, left: t.left, right: t.right, bottom: e } : t;
}
function Kw(t, e, n) {
  let r, i, o, s, a = !1, l, u, c, f;
  for (let p = t.firstChild; p; p = p.nextSibling) {
    let g = yh(p);
    for (let m = 0; m < g.length; m++) {
      let v = g[m];
      i && dv(i, v) && (v = gx(mx(v, i.bottom), i.top));
      let S = sW(e, v), _ = aW(n, v);
      if (S == 0 && _ == 0)
        return p.nodeType == 3 ? yx(p, e, n) : Kw(p, e, n);
      if (!r || s > _ || s == _ && o > S) {
        r = p, i = v, o = S, s = _;
        let b = _ ? n < v.top ? -1 : 1 : S ? e < v.left ? -1 : 1 : 0;
        a = !b || (b > 0 ? m < g.length - 1 : m > 0);
      }
      S == 0 ? n > v.bottom && (!c || c.bottom < v.bottom) ? (l = p, c = v) : n < v.top && (!f || f.top > v.top) && (u = p, f = v) : c && dv(c, v) ? c = mx(c, v.bottom) : f && dv(f, v) && (f = gx(f, v.top));
    }
  }
  if (c && c.bottom >= n ? (r = l, i = c) : f && f.top <= n && (r = u, i = f), !r)
    return { node: t, offset: 0 };
  let d = Math.max(i.left, Math.min(i.right, e));
  if (r.nodeType == 3)
    return yx(r, d, n);
  if (a && r.contentEditable != "false")
    return Kw(r, d, n);
  let h = Array.prototype.indexOf.call(t.childNodes, r) + (e >= (i.left + i.right) / 2 ? 1 : 0);
  return { node: t, offset: h };
}
function yx(t, e, n) {
  let r = t.nodeValue.length, i = -1, o = 1e9, s = 0;
  for (let a = 0; a < r; a++) {
    let l = Eu(t, a, a + 1).getClientRects();
    for (let u = 0; u < l.length; u++) {
      let c = l[u];
      if (c.top == c.bottom)
        continue;
      s || (s = e - c.left);
      let f = (c.top > n ? c.top - n : n - c.bottom) - 1;
      if (c.left - 1 <= e && c.right + 1 >= e && f < o) {
        let d = e >= (c.left + c.right) / 2, h = d;
        if ((Qe.chrome || Qe.gecko) && Eu(t, a).getBoundingClientRect().left == c.right && (h = !d), f <= 0)
          return { node: t, offset: a + (h ? 1 : 0) };
        i = a + (h ? 1 : 0), o = f;
      }
    }
  }
  return { node: t, offset: i > -1 ? i : s > 0 ? t.nodeValue.length : 0 };
}
function IF(t, e, n, r = -1) {
  var i, o;
  let s = t.contentDOM.getBoundingClientRect(), a = s.top + t.viewState.paddingTop, l, { docHeight: u } = t.viewState, { x: c, y: f } = e, d = f - a;
  if (d < 0)
    return 0;
  if (d > u)
    return t.state.doc.length;
  for (let b = t.viewState.heightOracle.textHeight / 2, y = !1; l = t.elementAtHeight(d), l.type != Co.Text; )
    for (; d = r > 0 ? l.bottom + b : l.top - b, !(d >= 0 && d <= u); ) {
      if (y)
        return n ? null : 0;
      y = !0, r = -r;
    }
  f = a + d;
  let h = l.from;
  if (h < t.viewport.from)
    return t.viewport.from == 0 ? 0 : n ? null : vx(t, s, l, c, f);
  if (h > t.viewport.to)
    return t.viewport.to == t.state.doc.length ? t.state.doc.length : n ? null : vx(t, s, l, c, f);
  let p = t.dom.ownerDocument, g = t.root.elementFromPoint ? t.root : p, m = g.elementFromPoint(c, f);
  m && !t.contentDOM.contains(m) && (m = null), m || (c = Math.max(s.left + 1, Math.min(s.right - 1, c)), m = g.elementFromPoint(c, f), m && !t.contentDOM.contains(m) && (m = null));
  let v, S = -1;
  if (m && ((i = t.docView.nearest(m)) === null || i === void 0 ? void 0 : i.isEditable) != !1) {
    if (p.caretPositionFromPoint) {
      let b = p.caretPositionFromPoint(c, f);
      b && ({ offsetNode: v, offset: S } = b);
    } else if (p.caretRangeFromPoint) {
      let b = p.caretRangeFromPoint(c, f);
      b && ({ startContainer: v, startOffset: S } = b, (!t.contentDOM.contains(v) || Qe.safari && lW(v, S, c) || Qe.chrome && uW(v, S, c)) && (v = void 0));
    }
    v && (S = Math.min(Ns(v), S));
  }
  if (!v || !t.docView.dom.contains(v)) {
    let b = ar.find(t.docView, h);
    if (!b)
      return d > l.top + l.height / 2 ? l.to : l.from;
    ({ node: v, offset: S } = Kw(b.dom, c, f));
  }
  let _ = t.docView.nearest(v);
  if (!_)
    return null;
  if (_.isWidget && ((o = _.dom) === null || o === void 0 ? void 0 : o.nodeType) == 1) {
    let b = _.dom.getBoundingClientRect();
    return e.y < b.top || e.y <= b.bottom && e.x <= (b.left + b.right) / 2 ? _.posAtStart : _.posAtEnd;
  } else
    return _.localPosFromDOM(v, S) + _.posAtStart;
}
function vx(t, e, n, r, i) {
  let o = Math.round((r - e.left) * t.defaultCharacterWidth);
  if (t.lineWrapping && n.height > t.defaultLineHeight * 1.5) {
    let a = t.viewState.heightOracle.textHeight, l = Math.floor((i - n.top - (t.defaultLineHeight - a) * 0.5) / a);
    o += l * t.viewState.heightOracle.lineLength;
  }
  let s = t.state.sliceDoc(n.from, n.to);
  return n.from + AG(s, o, t.state.tabSize);
}
function lW(t, e, n) {
  let r;
  if (t.nodeType != 3 || e != (r = t.nodeValue.length))
    return !1;
  for (let i = t.nextSibling; i; i = i.nextSibling)
    if (i.nodeType != 1 || i.nodeName != "BR")
      return !1;
  return Eu(t, r - 1, r).getBoundingClientRect().left > n;
}
function uW(t, e, n) {
  if (e != 0)
    return !1;
  for (let i = t; ; ) {
    let o = i.parentNode;
    if (!o || o.nodeType != 1 || o.firstChild != i)
      return !1;
    if (o.classList.contains("cm-line"))
      break;
    i = o;
  }
  let r = t.nodeType == 1 ? t.getBoundingClientRect() : Eu(t, 0, Math.max(t.nodeValue.length, 1)).getBoundingClientRect();
  return n - r.left > 5;
}
function cW(t, e) {
  let n = t.lineBlockAt(e);
  if (Array.isArray(n.type)) {
    for (let r of n.type)
      if (r.to > e || r.to == e && (r.to == n.to || r.type == Co.Text))
        return r;
  }
  return n;
}
function fW(t, e, n, r) {
  let i = cW(t, e.head), o = !r || i.type != Co.Text || !(t.lineWrapping || i.widgetLineBreaks) ? null : t.coordsAtPos(e.assoc < 0 && e.head > i.from ? e.head - 1 : e.head);
  if (o) {
    let s = t.dom.getBoundingClientRect(), a = t.textDirectionAt(i.from), l = t.posAtCoords({
      x: n == (a == $r.LTR) ? s.right - 1 : s.left + 1,
      y: (o.top + o.bottom) / 2
    });
    if (l != null)
      return ot.cursor(l, n ? -1 : 1);
  }
  return ot.cursor(n ? i.to : i.from, n ? -1 : 1);
}
function bx(t, e, n, r) {
  let i = t.state.doc.lineAt(e.head), o = t.bidiSpans(i), s = t.textDirectionAt(i.from);
  for (let a = e, l = null; ; ) {
    let u = YG(i, o, s, a, n), c = mF;
    if (!u) {
      if (i.number == (n ? t.state.doc.lines : 1))
        return a;
      c = `
`, i = t.state.doc.line(i.number + (n ? 1 : -1)), o = t.bidiSpans(i), u = t.visualLineSide(i, !n);
    }
    if (l) {
      if (!l(c))
        return a;
    } else {
      if (!r)
        return u;
      l = r(c);
    }
    a = u;
  }
}
function dW(t, e, n) {
  let r = t.state.charCategorizer(e), i = r(n);
  return (o) => {
    let s = r(o);
    return i == oa.Space && (i = s), i == s;
  };
}
function hW(t, e, n, r) {
  let i = e.head, o = n ? 1 : -1;
  if (i == (n ? t.state.doc.length : 0))
    return ot.cursor(i, e.assoc);
  let s = e.goalColumn, a, l = t.contentDOM.getBoundingClientRect(), u = t.coordsAtPos(i, e.assoc || -1), c = t.documentTop;
  if (u)
    s == null && (s = u.left - l.left), a = o < 0 ? u.top : u.bottom;
  else {
    let h = t.viewState.lineBlockAt(i);
    s == null && (s = Math.min(l.right - l.left, t.defaultCharacterWidth * (i - h.from))), a = (o < 0 ? h.top : h.bottom) + c;
  }
  let f = l.left + s, d = r ?? t.viewState.heightOracle.textHeight >> 1;
  for (let h = 0; ; h += 10) {
    let p = a + (d + h) * o, g = IF(t, { x: f, y: p }, !1, o);
    if (p < l.top || p > l.bottom || (o < 0 ? g < i : g > i)) {
      let m = t.docView.coordsForChar(g), v = !m || p < m.top ? -1 : 1;
      return ot.cursor(g, v, void 0, s);
    }
  }
}
function im(t, e, n) {
  for (; ; ) {
    let r = 0;
    for (let i of t)
      i.between(e - 1, e + 1, (o, s, a) => {
        if (e > o && e < s) {
          let l = r || n || (e - o < s - e ? -1 : 1);
          e = l < 0 ? o : s, r = l;
        }
      });
    if (!r)
      return e;
  }
}
function hv(t, e, n) {
  let r = im(t.state.facet(TE).map((i) => i(t)), n.from, e.head > n.from ? -1 : 1);
  return r == n.from ? n : ot.cursor(r, r < n.from ? 1 : -1);
}
const Ad = "￿";
class pW {
  constructor(e, n) {
    this.points = e, this.text = "", this.lineSeparator = n.facet(hn.lineSeparator);
  }
  append(e) {
    this.text += e;
  }
  lineBreak() {
    this.text += Ad;
  }
  readRange(e, n) {
    if (!e)
      return this;
    let r = e.parentNode;
    for (let i = e; ; ) {
      this.findPointBefore(r, i);
      let o = this.text.length;
      this.readNode(i);
      let s = i.nextSibling;
      if (s == n)
        break;
      let a = wn.get(i), l = wn.get(s);
      (a && l ? a.breakAfter : (a ? a.breakAfter : Qm(i)) || Qm(s) && (i.nodeName != "BR" || i.cmIgnore) && this.text.length > o) && this.lineBreak(), i = s;
    }
    return this.findPointBefore(r, n), this;
  }
  readTextNode(e) {
    let n = e.nodeValue;
    for (let r of this.points)
      r.node == e && (r.pos = this.text.length + Math.min(r.offset, n.length));
    for (let r = 0, i = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let o = -1, s = 1, a;
      if (this.lineSeparator ? (o = n.indexOf(this.lineSeparator, r), s = this.lineSeparator.length) : (a = i.exec(n)) && (o = a.index, s = a[0].length), this.append(n.slice(r, o < 0 ? n.length : o)), o < 0)
        break;
      if (this.lineBreak(), s > 1)
        for (let l of this.points)
          l.node == e && l.pos > this.text.length && (l.pos -= s - 1);
      r = o + s;
    }
  }
  readNode(e) {
    if (e.cmIgnore)
      return;
    let n = wn.get(e), r = n && n.overrideDOMText;
    if (r != null) {
      this.findPointInside(e, r.length);
      for (let i = r.iter(); !i.next().done; )
        i.lineBreak ? this.lineBreak() : this.append(i.value);
    } else e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
  }
  findPointBefore(e, n) {
    for (let r of this.points)
      r.node == e && e.childNodes[r.offset] == n && (r.pos = this.text.length);
  }
  findPointInside(e, n) {
    for (let r of this.points)
      (e.nodeType == 3 ? r.node == e : e.contains(r.node)) && (r.pos = this.text.length + (gW(e, r.node, r.offset) ? n : 0));
  }
}
function gW(t, e, n) {
  for (; ; ) {
    if (!e || n < Ns(e))
      return !1;
    if (e == t)
      return !0;
    n = _u(e) + 1, e = e.parentNode;
  }
}
class wx {
  constructor(e, n) {
    this.node = e, this.offset = n, this.pos = -1;
  }
}
class mW {
  constructor(e, n, r, i) {
    this.typeOver = i, this.bounds = null, this.text = "", this.domChanged = n > -1;
    let { impreciseHead: o, impreciseAnchor: s } = e.docView;
    if (e.state.readOnly && n > -1)
      this.newSel = null;
    else if (n > -1 && (this.bounds = e.docView.domBoundsAround(n, r, 0))) {
      let a = o || s ? [] : bW(e), l = new pW(a, e.state);
      l.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = l.text, this.newSel = wW(a, this.bounds.from);
    } else {
      let a = e.observer.selectionRange, l = o && o.node == a.focusNode && o.offset == a.focusOffset || !Bw(e.contentDOM, a.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(a.focusNode, a.focusOffset), u = s && s.node == a.anchorNode && s.offset == a.anchorOffset || !Bw(e.contentDOM, a.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(a.anchorNode, a.anchorOffset), c = e.viewport;
      if ((Qe.ios || Qe.chrome) && e.state.selection.main.empty && l != u && (c.from > 0 || c.to < e.state.doc.length)) {
        let f = Math.min(l, u), d = Math.max(l, u), h = c.from - f, p = c.to - d;
        (h == 0 || h == 1 || f == 0) && (p == 0 || p == -1 || d == e.state.doc.length) && (l = 0, u = e.state.doc.length);
      }
      this.newSel = ot.single(u, l);
    }
  }
}
function NF(t, e) {
  let n, { newSel: r } = e, i = t.state.selection.main, o = t.inputState.lastKeyTime > Date.now() - 100 ? t.inputState.lastKeyCode : -1;
  if (e.bounds) {
    let { from: s, to: a } = e.bounds, l = i.from, u = null;
    (o === 8 || Qe.android && e.text.length < a - s) && (l = i.to, u = "end");
    let c = vW(t.state.doc.sliceString(s, a, Ad), e.text, l - s, u);
    c && (Qe.chrome && o == 13 && c.toB == c.from + 2 && e.text.slice(c.from, c.toB) == Ad + Ad && c.toB--, n = {
      from: s + c.from,
      to: s + c.toA,
      insert: Zt.of(e.text.slice(c.from, c.toB).split(Ad))
    });
  } else r && (!t.hasFocus && t.state.facet(ea) || r.main.eq(i)) && (r = null);
  if (!n && !r)
    return !1;
  if (!n && e.typeOver && !i.empty && r && r.main.empty ? n = { from: i.from, to: i.to, insert: t.state.doc.slice(i.from, i.to) } : (Qe.mac || Qe.android) && n && n.from == n.to && n.from == i.head - 1 && /^\. ?$/.test(n.insert.toString()) && t.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = ot.single(r.main.anchor - 1, r.main.head - 1)), n = { from: n.from, to: n.to, insert: Zt.of([n.insert.toString().replace(".", " ")]) }) : n && n.from >= i.from && n.to <= i.to && (n.from != i.from || n.to != i.to) && i.to - i.from - (n.to - n.from) <= 4 ? n = {
    from: i.from,
    to: i.to,
    insert: t.state.doc.slice(i.from, n.from).append(n.insert).append(t.state.doc.slice(n.to, i.to))
  } : Qe.chrome && n && n.from == n.to && n.from == i.head && n.insert.toString() == `
 ` && t.lineWrapping && (r && (r = ot.single(r.main.anchor - 1, r.main.head - 1)), n = { from: i.from, to: i.to, insert: Zt.of([" "]) }), n)
    return xE(t, n, r, o);
  if (r && !r.main.eq(i)) {
    let s = !1, a = "select";
    return t.inputState.lastSelectionTime > Date.now() - 50 && (t.inputState.lastSelectionOrigin == "select" && (s = !0), a = t.inputState.lastSelectionOrigin), t.dispatch({ selection: r, scrollIntoView: s, userEvent: a }), !0;
  } else
    return !1;
}
function xE(t, e, n, r = -1) {
  if (Qe.ios && t.inputState.flushIOSKey(e))
    return !0;
  let i = t.state.selection.main;
  if (Qe.android && (e.to == i.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (e.from == i.from || e.from == i.from - 1 && t.state.sliceDoc(e.from, i.from) == " ") && e.insert.length == 1 && e.insert.lines == 2 && bc(t.contentDOM, "Enter", 13) || (e.from == i.from - 1 && e.to == i.to && e.insert.length == 0 || r == 8 && e.insert.length < e.to - e.from && e.to > i.head) && bc(t.contentDOM, "Backspace", 8) || e.from == i.from && e.to == i.to + 1 && e.insert.length == 0 && bc(t.contentDOM, "Delete", 46)))
    return !0;
  let o = e.insert.toString();
  t.inputState.composing >= 0 && t.inputState.composing++;
  let s, a = () => s || (s = yW(t, e, n));
  return t.state.facet(SF).some((l) => l(t, e.from, e.to, o, a)) || t.dispatch(a()), !0;
}
function yW(t, e, n) {
  let r, i = t.state, o = i.selection.main;
  if (e.from >= o.from && e.to <= o.to && e.to - e.from >= (o.to - o.from) / 3 && (!n || n.main.empty && n.main.from == e.from + e.insert.length) && t.inputState.composing < 0) {
    let a = o.from < e.from ? i.sliceDoc(o.from, e.from) : "", l = o.to > e.to ? i.sliceDoc(e.to, o.to) : "";
    r = i.replaceSelection(t.state.toText(a + e.insert.sliceString(0, void 0, t.state.lineBreak) + l));
  } else {
    let a = i.changes(e), l = n && n.main.to <= a.newLength ? n.main : void 0;
    if (i.selection.ranges.length > 1 && t.inputState.composing >= 0 && e.to <= o.to && e.to >= o.to - 10) {
      let u = t.state.sliceDoc(e.from, e.to), c, f = n && DF(t, n.main.head);
      if (f) {
        let p = e.insert.length - (e.to - e.from);
        c = { from: f.from, to: f.to - p };
      } else
        c = t.state.doc.lineAt(o.head);
      let d = o.to - e.to, h = o.to - o.from;
      r = i.changeByRange((p) => {
        if (p.from == o.from && p.to == o.to)
          return { changes: a, range: l || p.map(a) };
        let g = p.to - d, m = g - u.length;
        if (p.to - p.from != h || t.state.sliceDoc(m, g) != u || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        p.to >= c.from && p.from <= c.to)
          return { range: p };
        let v = i.changes({ from: m, to: g, insert: e.insert }), S = p.to - o.to;
        return {
          changes: v,
          range: l ? ot.range(Math.max(0, l.anchor + S), Math.max(0, l.head + S)) : p.map(v)
        };
      });
    } else
      r = {
        changes: a,
        selection: l && i.selection.replaceRange(l)
      };
  }
  let s = "input.type";
  return (t.composing || t.inputState.compositionPendingChange && t.inputState.compositionEndedAt > Date.now() - 50) && (t.inputState.compositionPendingChange = !1, s += ".compose", t.inputState.compositionFirstChange && (s += ".start", t.inputState.compositionFirstChange = !1)), i.update(r, { userEvent: s, scrollIntoView: !0 });
}
function vW(t, e, n, r) {
  let i = Math.min(t.length, e.length), o = 0;
  for (; o < i && t.charCodeAt(o) == e.charCodeAt(o); )
    o++;
  if (o == i && t.length == e.length)
    return null;
  let s = t.length, a = e.length;
  for (; s > 0 && a > 0 && t.charCodeAt(s - 1) == e.charCodeAt(a - 1); )
    s--, a--;
  if (r == "end") {
    let l = Math.max(0, o - Math.min(s, a));
    n -= s + l - o;
  }
  if (s < o && t.length < e.length) {
    let l = n <= o && n >= s ? o - n : 0;
    o -= l, a = o + (a - s), s = o;
  } else if (a < o) {
    let l = n <= o && n >= a ? o - n : 0;
    o -= l, s = o + (s - a), a = o;
  }
  return { from: o, toA: s, toB: a };
}
function bW(t) {
  let e = [];
  if (t.root.activeElement != t.contentDOM)
    return e;
  let { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o } = t.observer.selectionRange;
  return n && (e.push(new wx(n, r)), (i != n || o != r) && e.push(new wx(i, o))), e;
}
function wW(t, e) {
  if (t.length == 0)
    return null;
  let n = t[0].pos, r = t.length == 2 ? t[1].pos : n;
  return n > -1 && r > -1 ? ot.single(n + e, r + e) : null;
}
class SW {
  setSelectionOrigin(e) {
    this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
  }
  constructor(e) {
    this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, Qe.safari && e.contentDOM.addEventListener("input", () => null), Qe.gecko && LW(e.contentDOM.ownerDocument);
  }
  handleEvent(e) {
    !OW(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || (this.view.updateState != 0 ? Promise.resolve().then(() => this.runHandlers(e.type, e)) : this.runHandlers(e.type, e));
  }
  runHandlers(e, n) {
    let r = this.handlers[e];
    if (r) {
      for (let i of r.observers)
        i(this.view, n);
      for (let i of r.handlers) {
        if (n.defaultPrevented)
          break;
        if (i(this.view, n)) {
          n.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let n = _W(e), r = this.handlers, i = this.view.contentDOM;
    for (let o in n)
      if (o != "scroll") {
        let s = !n[o].handlers.length, a = r[o];
        a && s != !a.handlers.length && (i.removeEventListener(o, this.handleEvent), a = null), a || i.addEventListener(o, this.handleEvent, { passive: s });
      }
    for (let o in r)
      o != "scroll" && !n[o] && i.removeEventListener(o, this.handleEvent);
    this.handlers = n;
  }
  keydown(e) {
    if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return !0;
    if (this.tabFocusMode > 0 && e.keyCode != 27 && kW.indexOf(e.keyCode) < 0 && (this.tabFocusMode = -1), Qe.android && Qe.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8))
      return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
    let n;
    return Qe.ios && !e.synthetic && !e.altKey && !e.metaKey && ((n = PF.find((r) => r.keyCode == e.keyCode)) && !e.ctrlKey || EW.indexOf(e.key) > -1 && e.ctrlKey && !e.shiftKey) ? (this.pendingIOSKey = n || e, setTimeout(() => this.flushIOSKey(), 250), !0) : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(e) {
    let n = this.pendingIOSKey;
    return !n || n.key == "Enter" && e && e.from < e.to && /^\S+$/.test(e.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, bc(this.view.contentDOM, n.key, n.keyCode, n instanceof KeyboardEvent ? n : void 0));
  }
  ignoreDuringComposition(e) {
    return /^key/.test(e.type) ? this.composing > 0 ? !0 : Qe.safari && !Qe.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(e) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
  }
  update(e) {
    this.view.observer.update(e), this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function Sx(t, e) {
  return (n, r) => {
    try {
      return e.call(t, r, n);
    } catch (i) {
      ws(n.state, i);
    }
  };
}
function _W(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    return e[r] || (e[r] = { observers: [], handlers: [] });
  }
  for (let r of t) {
    let i = r.spec;
    if (i && i.domEventHandlers)
      for (let o in i.domEventHandlers) {
        let s = i.domEventHandlers[o];
        s && n(o).handlers.push(Sx(r.value, s));
      }
    if (i && i.domEventObservers)
      for (let o in i.domEventObservers) {
        let s = i.domEventObservers[o];
        s && n(o).observers.push(Sx(r.value, s));
      }
  }
  for (let r in Ko)
    n(r).handlers.push(Ko[r]);
  for (let r in Po)
    n(r).observers.push(Po[r]);
  return e;
}
const PF = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], EW = "dthko", kW = [16, 17, 18, 20, 91, 92, 224, 225], Yp = 6;
function Xp(t) {
  return Math.max(0, t) * 0.7 + 8;
}
function TW(t, e) {
  return Math.max(Math.abs(t.clientX - e.clientX), Math.abs(t.clientY - e.clientY));
}
class xW {
  constructor(e, n, r, i) {
    this.view = e, this.startEvent = n, this.style = r, this.mustSelect = i, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = n, this.scrollParents = IG(e.contentDOM), this.atoms = e.state.facet(TE).map((s) => s(e));
    let o = e.contentDOM.ownerDocument;
    o.addEventListener("mousemove", this.move = this.move.bind(this)), o.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = e.state.facet(hn.allowMultipleSelections) && CW(e, n), this.dragging = RW(e, n) && FF(n) == 1 ? null : !1;
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    if (e.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && TW(this.startEvent, e) < 10)
      return;
    this.select(this.lastEvent = e);
    let n = 0, r = 0, i = 0, o = 0, s = this.view.win.innerWidth, a = this.view.win.innerHeight;
    this.scrollParents.x && ({ left: i, right: s } = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({ top: o, bottom: a } = this.scrollParents.y.getBoundingClientRect());
    let l = OF(this.view);
    e.clientX - l.left <= i + Yp ? n = -Xp(i - e.clientX) : e.clientX + l.right >= s - Yp && (n = Xp(e.clientX - s)), e.clientY - l.top <= o + Yp ? r = -Xp(o - e.clientY) : e.clientY + l.bottom >= a - Yp && (r = Xp(e.clientY - a)), this.setScrollSpeed(n, r);
  }
  up(e) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(e, n) {
    this.scrollSpeed = { x: e, y: n }, e || n ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    let { x: e, y: n } = this.scrollSpeed;
    e && this.scrollParents.x && (this.scrollParents.x.scrollLeft += e, e = 0), n && this.scrollParents.y && (this.scrollParents.y.scrollTop += n, n = 0), (e || n) && this.view.win.scrollBy(e, n), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(e) {
    let n = null;
    for (let r = 0; r < e.ranges.length; r++) {
      let i = e.ranges[r], o = null;
      if (i.empty) {
        let s = im(this.atoms, i.from, 0);
        s != i.from && (o = ot.cursor(s, -1));
      } else {
        let s = im(this.atoms, i.from, -1), a = im(this.atoms, i.to, 1);
        (s != i.from || a != i.to) && (o = ot.range(i.from == i.anchor ? s : a, i.from == i.head ? s : a));
      }
      o && (n || (n = e.ranges.slice()), n[r] = o);
    }
    return n ? ot.create(n, e.mainIndex) : e;
  }
  select(e) {
    let { view: n } = this, r = this.skipAtoms(this.style.get(e, this.extend, this.multiple));
    (this.mustSelect || !r.eq(n.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: r,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(e) {
    e.transactions.some((n) => n.isUserEvent("input.type")) ? this.destroy() : this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function CW(t, e) {
  let n = t.state.facet(yF);
  return n.length ? n[0](e) : Qe.mac ? e.metaKey : e.ctrlKey;
}
function AW(t, e) {
  let n = t.state.facet(vF);
  return n.length ? n[0](e) : Qe.mac ? !e.altKey : !e.ctrlKey;
}
function RW(t, e) {
  let { main: n } = t.state.selection;
  if (n.empty)
    return !1;
  let r = mh(t.root);
  if (!r || r.rangeCount == 0)
    return !0;
  let i = r.getRangeAt(0).getClientRects();
  for (let o = 0; o < i.length; o++) {
    let s = i[o];
    if (s.left <= e.clientX && s.right >= e.clientX && s.top <= e.clientY && s.bottom >= e.clientY)
      return !0;
  }
  return !1;
}
function OW(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target, r; n != t.contentDOM; n = n.parentNode)
    if (!n || n.nodeType == 11 || (r = wn.get(n)) && r.ignoreEvent(e))
      return !1;
  return !0;
}
const Ko = /* @__PURE__ */ Object.create(null), Po = /* @__PURE__ */ Object.create(null), $F = Qe.ie && Qe.ie_version < 15 || Qe.ios && Qe.webkit_version < 604;
function DW(t) {
  let e = t.dom.parentNode;
  if (!e)
    return;
  let n = e.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    t.focus(), n.remove(), MF(t, n.value);
  }, 50);
}
function a0(t, e, n) {
  for (let r of t.facet(e))
    n = r(n, t);
  return n;
}
function MF(t, e) {
  e = a0(t.state, _E, e);
  let { state: n } = t, r, i = 1, o = n.toText(e), s = o.lines == n.selection.ranges.length;
  if (Qw != null && n.selection.ranges.every((l) => l.empty) && Qw == o.toString()) {
    let l = -1;
    r = n.changeByRange((u) => {
      let c = n.doc.lineAt(u.from);
      if (c.from == l)
        return { range: u };
      l = c.from;
      let f = n.toText((s ? o.line(i++).text : e) + n.lineBreak);
      return {
        changes: { from: c.from, insert: f },
        range: ot.cursor(u.from + f.length)
      };
    });
  } else s ? r = n.changeByRange((l) => {
    let u = o.line(i++);
    return {
      changes: { from: l.from, to: l.to, insert: u.text },
      range: ot.cursor(l.from + u.length)
    };
  }) : r = n.replaceSelection(o);
  t.dispatch(r, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
Po.scroll = (t) => {
  t.inputState.lastScrollTop = t.scrollDOM.scrollTop, t.inputState.lastScrollLeft = t.scrollDOM.scrollLeft;
};
Ko.keydown = (t, e) => (t.inputState.setSelectionOrigin("select"), e.keyCode == 27 && t.inputState.tabFocusMode != 0 && (t.inputState.tabFocusMode = Date.now() + 2e3), !1);
Po.touchstart = (t, e) => {
  t.inputState.lastTouchTime = Date.now(), t.inputState.setSelectionOrigin("select.pointer");
};
Po.touchmove = (t) => {
  t.inputState.setSelectionOrigin("select.pointer");
};
Ko.mousedown = (t, e) => {
  if (t.observer.flush(), t.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let n = null;
  for (let r of t.state.facet(bF))
    if (n = r(t, e), n)
      break;
  if (!n && e.button == 0 && (n = PW(t, e)), n) {
    let r = !t.hasFocus;
    t.inputState.startMouseSelection(new xW(t, e, n, r)), r && t.observer.ignore(() => {
      JM(t.contentDOM);
      let o = t.root.activeElement;
      o && !o.contains(t.contentDOM) && o.blur();
    });
    let i = t.inputState.mouseSelection;
    if (i)
      return i.start(e), i.dragging === !1;
  }
  return !1;
};
function _x(t, e, n, r) {
  if (r == 1)
    return ot.cursor(e, n);
  if (r == 2)
    return oW(t.state, e, n);
  {
    let i = ar.find(t.docView, e), o = t.state.doc.lineAt(i ? i.posAtEnd : e), s = i ? i.posAtStart : o.from, a = i ? i.posAtEnd : o.to;
    return a < t.state.doc.length && a == o.to && a++, ot.range(s, a);
  }
}
let Ex = (t, e, n) => e >= n.top && e <= n.bottom && t >= n.left && t <= n.right;
function IW(t, e, n, r) {
  let i = ar.find(t.docView, e);
  if (!i)
    return 1;
  let o = e - i.posAtStart;
  if (o == 0)
    return 1;
  if (o == i.length)
    return -1;
  let s = i.coordsAt(o, -1);
  if (s && Ex(n, r, s))
    return -1;
  let a = i.coordsAt(o, 1);
  return a && Ex(n, r, a) ? 1 : s && s.bottom >= r ? -1 : 1;
}
function kx(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1);
  return { pos: n, bias: IW(t, n, e.clientX, e.clientY) };
}
const NW = Qe.ie && Qe.ie_version <= 11;
let Tx = null, xx = 0, Cx = 0;
function FF(t) {
  if (!NW)
    return t.detail;
  let e = Tx, n = Cx;
  return Tx = t, Cx = Date.now(), xx = !e || n > Date.now() - 400 && Math.abs(e.clientX - t.clientX) < 2 && Math.abs(e.clientY - t.clientY) < 2 ? (xx + 1) % 3 : 1;
}
function PW(t, e) {
  let n = kx(t, e), r = FF(e), i = t.state.selection;
  return {
    update(o) {
      o.docChanged && (n.pos = o.changes.mapPos(n.pos), i = i.map(o.changes));
    },
    get(o, s, a) {
      let l = kx(t, o), u, c = _x(t, l.pos, l.bias, r);
      if (n.pos != l.pos && !s) {
        let f = _x(t, n.pos, n.bias, r), d = Math.min(f.from, c.from), h = Math.max(f.to, c.to);
        c = d < c.from ? ot.range(d, h) : ot.range(h, d);
      }
      return s ? i.replaceRange(i.main.extend(c.from, c.to)) : a && r == 1 && i.ranges.length > 1 && (u = $W(i, l.pos)) ? u : a ? i.addRange(c) : ot.create([c]);
    }
  };
}
function $W(t, e) {
  for (let n = 0; n < t.ranges.length; n++) {
    let { from: r, to: i } = t.ranges[n];
    if (r <= e && i >= e)
      return ot.create(t.ranges.slice(0, n).concat(t.ranges.slice(n + 1)), t.mainIndex == n ? 0 : t.mainIndex - (t.mainIndex > n ? 1 : 0));
  }
  return null;
}
Ko.dragstart = (t, e) => {
  let { selection: { main: n } } = t.state;
  if (e.target.draggable) {
    let i = t.docView.nearest(e.target);
    if (i && i.isWidget) {
      let o = i.posAtStart, s = o + i.length;
      (o >= n.to || s <= n.from) && (n = ot.range(o, s));
    }
  }
  let { inputState: r } = t;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, e.dataTransfer && (e.dataTransfer.setData("Text", a0(t.state, EE, t.state.sliceDoc(n.from, n.to))), e.dataTransfer.effectAllowed = "copyMove"), !1;
};
Ko.dragend = (t) => (t.inputState.draggedContent = null, !1);
function Ax(t, e, n, r) {
  if (n = a0(t.state, _E, n), !n)
    return;
  let i = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), { draggedContent: o } = t.inputState, s = r && o && AW(t, e) ? { from: o.from, to: o.to } : null, a = { from: i, insert: n }, l = t.state.changes(s ? [s, a] : a);
  t.focus(), t.dispatch({
    changes: l,
    selection: { anchor: l.mapPos(i, -1), head: l.mapPos(i, 1) },
    userEvent: s ? "move.drop" : "input.drop"
  }), t.inputState.draggedContent = null;
}
Ko.drop = (t, e) => {
  if (!e.dataTransfer)
    return !1;
  if (t.state.readOnly)
    return !0;
  let n = e.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length), i = 0, o = () => {
      ++i == n.length && Ax(t, e, r.filter((s) => s != null).join(t.state.lineBreak), !1);
    };
    for (let s = 0; s < n.length; s++) {
      let a = new FileReader();
      a.onerror = o, a.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(a.result) || (r[s] = a.result), o();
      }, a.readAsText(n[s]);
    }
    return !0;
  } else {
    let r = e.dataTransfer.getData("Text");
    if (r)
      return Ax(t, e, r, !0), !0;
  }
  return !1;
};
Ko.paste = (t, e) => {
  if (t.state.readOnly)
    return !0;
  t.observer.flush();
  let n = $F ? null : e.clipboardData;
  return n ? (MF(t, n.getData("text/plain") || n.getData("text/uri-list")), !0) : (DW(t), !1);
};
function MW(t, e) {
  let n = t.dom.parentNode;
  if (!n)
    return;
  let r = n.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = e, r.focus(), r.selectionEnd = e.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), t.focus();
  }, 50);
}
function FW(t) {
  let e = [], n = [], r = !1;
  for (let i of t.selection.ranges)
    i.empty || (e.push(t.sliceDoc(i.from, i.to)), n.push(i));
  if (!e.length) {
    let i = -1;
    for (let { from: o } of t.selection.ranges) {
      let s = t.doc.lineAt(o);
      s.number > i && (e.push(s.text), n.push({ from: s.from, to: Math.min(t.doc.length, s.to + 1) })), i = s.number;
    }
    r = !0;
  }
  return { text: a0(t, EE, e.join(t.lineBreak)), ranges: n, linewise: r };
}
let Qw = null;
Ko.copy = Ko.cut = (t, e) => {
  let { text: n, ranges: r, linewise: i } = FW(t.state);
  if (!n && !i)
    return !1;
  Qw = i ? n : null, e.type == "cut" && !t.state.readOnly && t.dispatch({
    changes: r,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let o = $F ? null : e.clipboardData;
  return o ? (o.clearData(), o.setData("text/plain", n), !0) : (MW(t, n), !1);
};
const LF = /* @__PURE__ */ bf.define();
function BF(t, e) {
  let n = [];
  for (let r of t.facet(_F)) {
    let i = r(t, e);
    i && n.push(i);
  }
  return n ? t.update({ effects: n, annotations: LF.of(!0) }) : null;
}
function jF(t) {
  setTimeout(() => {
    let e = t.hasFocus;
    if (e != t.inputState.notifiedFocused) {
      let n = BF(t.state, e);
      n ? t.dispatch(n) : t.update([]);
    }
  }, 10);
}
Po.focus = (t) => {
  t.inputState.lastFocusTime = Date.now(), !t.scrollDOM.scrollTop && (t.inputState.lastScrollTop || t.inputState.lastScrollLeft) && (t.scrollDOM.scrollTop = t.inputState.lastScrollTop, t.scrollDOM.scrollLeft = t.inputState.lastScrollLeft), jF(t);
};
Po.blur = (t) => {
  t.observer.clearSelectionRange(), jF(t);
};
Po.compositionstart = Po.compositionupdate = (t) => {
  t.observer.editContext || (t.inputState.compositionFirstChange == null && (t.inputState.compositionFirstChange = !0), t.inputState.composing < 0 && (t.inputState.composing = 0));
};
Po.compositionend = (t) => {
  t.observer.editContext || (t.inputState.composing = -1, t.inputState.compositionEndedAt = Date.now(), t.inputState.compositionPendingKey = !0, t.inputState.compositionPendingChange = t.observer.pendingRecords().length > 0, t.inputState.compositionFirstChange = null, Qe.chrome && Qe.android ? t.observer.flushSoon() : t.inputState.compositionPendingChange ? Promise.resolve().then(() => t.observer.flush()) : setTimeout(() => {
    t.inputState.composing < 0 && t.docView.hasComposition && t.update([]);
  }, 50));
};
Po.contextmenu = (t) => {
  t.inputState.lastContextMenu = Date.now();
};
Ko.beforeinput = (t, e) => {
  var n, r;
  if (e.inputType == "insertReplacementText" && t.observer.editContext) {
    let o = (n = e.dataTransfer) === null || n === void 0 ? void 0 : n.getData("text/plain"), s = e.getTargetRanges();
    if (o && s.length) {
      let a = s[0], l = t.posAtDOM(a.startContainer, a.startOffset), u = t.posAtDOM(a.endContainer, a.endOffset);
      return xE(t, { from: l, to: u, insert: t.state.toText(o) }, null), !0;
    }
  }
  let i;
  if (Qe.chrome && Qe.android && (i = PF.find((o) => o.inputType == e.inputType)) && (t.observer.delayAndroidKey(i.key, i.keyCode), i.key == "Backspace" || i.key == "Delete")) {
    let o = ((r = window.visualViewport) === null || r === void 0 ? void 0 : r.height) || 0;
    setTimeout(() => {
      var s;
      (((s = window.visualViewport) === null || s === void 0 ? void 0 : s.height) || 0) > o + 10 && t.hasFocus && (t.contentDOM.blur(), t.focus());
    }, 100);
  }
  return Qe.ios && e.inputType == "deleteContentForward" && t.observer.flushSoon(), Qe.safari && e.inputType == "insertText" && t.inputState.composing >= 0 && setTimeout(() => Po.compositionend(t, e), 20), !1;
};
const Rx = /* @__PURE__ */ new Set();
function LW(t) {
  Rx.has(t) || (Rx.add(t), t.addEventListener("copy", () => {
  }), t.addEventListener("cut", () => {
  }));
}
const Ox = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let ef = !1;
function Dx() {
  ef = !1;
}
class BW {
  constructor(e) {
    this.lineWrapping = e, this.doc = Zt.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30;
  }
  heightForGap(e, n) {
    let r = this.doc.lineAt(n).number - this.doc.lineAt(e).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((n - e - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(e) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(e) {
    return this.doc = e, this;
  }
  mustRefreshForWrapping(e) {
    return Ox.indexOf(e) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(e) {
    let n = !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      i < 0 ? r++ : this.heightSamples[Math.floor(i * 10)] || (n = !0, this.heightSamples[Math.floor(i * 10)] = !0);
    }
    return n;
  }
  refresh(e, n, r, i, o, s) {
    let a = Ox.indexOf(e) > -1, l = Math.round(n) != Math.round(this.lineHeight) || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = n, this.charWidth = r, this.textHeight = i, this.lineLength = o, l) {
      this.heightSamples = {};
      for (let u = 0; u < s.length; u++) {
        let c = s[u];
        c < 0 ? u++ : this.heightSamples[Math.floor(c * 10)] = !0;
      }
    }
    return l;
  }
}
class jW {
  constructor(e, n) {
    this.from = e, this.heights = n, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class ms {
  /**
  @internal
  */
  constructor(e, n, r, i, o) {
    this.from = e, this.length = n, this.top = r, this.height = i, this._content = o;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? Co.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof fl ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(e) {
    let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(e._content) ? e._content : [e]);
    return new ms(this.from, this.length + e.length, this.top, this.height + e.height, n);
  }
}
var $n = /* @__PURE__ */ function(t) {
  return t[t.ByPos = 0] = "ByPos", t[t.ByHeight = 1] = "ByHeight", t[t.ByPosNoHeight = 2] = "ByPosNoHeight", t;
}($n || ($n = {}));
const om = 1e-3;
class pi {
  constructor(e, n, r = 2) {
    this.length = e, this.height = n, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(e) {
    this.flags = (e ? 2 : 0) | this.flags & -3;
  }
  setHeight(e) {
    this.height != e && (Math.abs(this.height - e) > om && (ef = !0), this.height = e);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(e, n, r) {
    return pi.of(r);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(e, n) {
    n.push(this);
  }
  decomposeRight(e, n) {
    n.push(this);
  }
  applyChanges(e, n, r, i) {
    let o = this, s = r.doc;
    for (let a = i.length - 1; a >= 0; a--) {
      let { fromA: l, toA: u, fromB: c, toB: f } = i[a], d = o.lineAt(l, $n.ByPosNoHeight, r.setDoc(n), 0, 0), h = d.to >= u ? d : o.lineAt(u, $n.ByPosNoHeight, r, 0, 0);
      for (f += h.to - u, u = h.to; a > 0 && d.from <= i[a - 1].toA; )
        l = i[a - 1].fromA, c = i[a - 1].fromB, a--, l < d.from && (d = o.lineAt(l, $n.ByPosNoHeight, r, 0, 0));
      c += d.from - l, l = d.from;
      let p = CE.build(r.setDoc(s), e, c, f);
      o = ey(o, o.replace(l, u, p));
    }
    return o.updateHeight(r, 0);
  }
  static empty() {
    return new Wi(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(e) {
    if (e.length == 1)
      return e[0];
    let n = 0, r = e.length, i = 0, o = 0;
    for (; ; )
      if (n == r)
        if (i > o * 2) {
          let a = e[n - 1];
          a.break ? e.splice(--n, 1, a.left, null, a.right) : e.splice(--n, 1, a.left, a.right), r += 1 + a.break, i -= a.size;
        } else if (o > i * 2) {
          let a = e[r];
          a.break ? e.splice(r, 1, a.left, null, a.right) : e.splice(r, 1, a.left, a.right), r += 2 + a.break, o -= a.size;
        } else
          break;
      else if (i < o) {
        let a = e[n++];
        a && (i += a.size);
      } else {
        let a = e[--r];
        a && (o += a.size);
      }
    let s = 0;
    return e[n - 1] == null ? (s = 1, n--) : e[n] == null && (s = 1, r++), new VW(pi.of(e.slice(0, n)), s, pi.of(e.slice(r)));
  }
}
function ey(t, e) {
  return t == e ? t : (t.constructor != e.constructor && (ef = !0), e);
}
pi.prototype.size = 1;
class VF extends pi {
  constructor(e, n, r) {
    super(e, n), this.deco = r;
  }
  blockAt(e, n, r, i) {
    return new ms(i, this.length, r, this.height, this.deco || 0);
  }
  lineAt(e, n, r, i, o) {
    return this.blockAt(0, r, i, o);
  }
  forEachLine(e, n, r, i, o, s) {
    e <= o + this.length && n >= o && s(this.blockAt(0, r, i, o));
  }
  updateHeight(e, n = 0, r = !1, i) {
    return i && i.from <= n && i.more && this.setHeight(i.heights[i.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class Wi extends VF {
  constructor(e, n) {
    super(e, n, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(e, n, r, i) {
    return new ms(i, this.length, r, this.height, this.breaks);
  }
  replace(e, n, r) {
    let i = r[0];
    return r.length == 1 && (i instanceof Wi || i instanceof Fr && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof Fr ? i = new Wi(i.length, this.height) : i.height = this.height, this.outdated || (i.outdated = !1), i) : pi.of(r);
  }
  updateHeight(e, n = 0, r = !1, i) {
    return i && i.from <= n && i.more ? this.setHeight(i.heights[i.index++]) : (r || this.outdated) && this.setHeight(Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class Fr extends pi {
  constructor(e) {
    super(e, 0);
  }
  heightMetrics(e, n) {
    let r = e.doc.lineAt(n).number, i = e.doc.lineAt(n + this.length).number, o = i - r + 1, s, a = 0;
    if (e.lineWrapping) {
      let l = Math.min(this.height, e.lineHeight * o);
      s = l / o, this.length > o + 1 && (a = (this.height - l) / (this.length - o - 1));
    } else
      s = this.height / o;
    return { firstLine: r, lastLine: i, perLine: s, perChar: a };
  }
  blockAt(e, n, r, i) {
    let { firstLine: o, lastLine: s, perLine: a, perChar: l } = this.heightMetrics(n, i);
    if (n.lineWrapping) {
      let u = i + (e < n.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (e - r) / this.height)) * this.length)), c = n.doc.lineAt(u), f = a + c.length * l, d = Math.max(r, e - f / 2);
      return new ms(c.from, c.length, d, f, 0);
    } else {
      let u = Math.max(0, Math.min(s - o, Math.floor((e - r) / a))), { from: c, length: f } = n.doc.line(o + u);
      return new ms(c, f, r + a * u, a, 0);
    }
  }
  lineAt(e, n, r, i, o) {
    if (n == $n.ByHeight)
      return this.blockAt(e, r, i, o);
    if (n == $n.ByPosNoHeight) {
      let { from: h, to: p } = r.doc.lineAt(e);
      return new ms(h, p - h, 0, 0, 0);
    }
    let { firstLine: s, perLine: a, perChar: l } = this.heightMetrics(r, o), u = r.doc.lineAt(e), c = a + u.length * l, f = u.number - s, d = i + a * f + l * (u.from - o - f);
    return new ms(u.from, u.length, Math.max(i, Math.min(d, i + this.height - c)), c, 0);
  }
  forEachLine(e, n, r, i, o, s) {
    e = Math.max(e, o), n = Math.min(n, o + this.length);
    let { firstLine: a, perLine: l, perChar: u } = this.heightMetrics(r, o);
    for (let c = e, f = i; c <= n; ) {
      let d = r.doc.lineAt(c);
      if (c == e) {
        let p = d.number - a;
        f += l * p + u * (e - o - p);
      }
      let h = l + u * d.length;
      s(new ms(d.from, d.length, f, h, 0)), f += h, c = d.to + 1;
    }
  }
  replace(e, n, r) {
    let i = this.length - n;
    if (i > 0) {
      let o = r[r.length - 1];
      o instanceof Fr ? r[r.length - 1] = new Fr(o.length + i) : r.push(null, new Fr(i - 1));
    }
    if (e > 0) {
      let o = r[0];
      o instanceof Fr ? r[0] = new Fr(e + o.length) : r.unshift(new Fr(e - 1), null);
    }
    return pi.of(r);
  }
  decomposeLeft(e, n) {
    n.push(new Fr(e - 1), null);
  }
  decomposeRight(e, n) {
    n.push(null, new Fr(this.length - e - 1));
  }
  updateHeight(e, n = 0, r = !1, i) {
    let o = n + this.length;
    if (i && i.from <= n + this.length && i.more) {
      let s = [], a = Math.max(n, i.from), l = -1;
      for (i.from > n && s.push(new Fr(i.from - n - 1).updateHeight(e, n)); a <= o && i.more; ) {
        let c = e.doc.lineAt(a).length;
        s.length && s.push(null);
        let f = i.heights[i.index++];
        l == -1 ? l = f : Math.abs(f - l) >= om && (l = -2);
        let d = new Wi(c, f);
        d.outdated = !1, s.push(d), a += c + 1;
      }
      a <= o && s.push(null, new Fr(o - a).updateHeight(e, a));
      let u = pi.of(s);
      return (l < 0 || Math.abs(u.height - this.height) >= om || Math.abs(l - this.heightMetrics(e, n).perLine) >= om) && (ef = !0), ey(this, u);
    } else (r || this.outdated) && (this.setHeight(e.heightForGap(n, n + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class VW extends pi {
  constructor(e, n, r) {
    super(e.length + n + r.length, e.height + r.height, n | (e.outdated || r.outdated ? 2 : 0)), this.left = e, this.right = r, this.size = e.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(e, n, r, i) {
    let o = r + this.left.height;
    return e < o ? this.left.blockAt(e, n, r, i) : this.right.blockAt(e, n, o, i + this.left.length + this.break);
  }
  lineAt(e, n, r, i, o) {
    let s = i + this.left.height, a = o + this.left.length + this.break, l = n == $n.ByHeight ? e < s : e < a, u = l ? this.left.lineAt(e, n, r, i, o) : this.right.lineAt(e, n, r, s, a);
    if (this.break || (l ? u.to < a : u.from > a))
      return u;
    let c = n == $n.ByPosNoHeight ? $n.ByPosNoHeight : $n.ByPos;
    return l ? u.join(this.right.lineAt(a, c, r, s, a)) : this.left.lineAt(a, c, r, i, o).join(u);
  }
  forEachLine(e, n, r, i, o, s) {
    let a = i + this.left.height, l = o + this.left.length + this.break;
    if (this.break)
      e < l && this.left.forEachLine(e, n, r, i, o, s), n >= l && this.right.forEachLine(e, n, r, a, l, s);
    else {
      let u = this.lineAt(l, $n.ByPos, r, i, o);
      e < u.from && this.left.forEachLine(e, u.from - 1, r, i, o, s), u.to >= e && u.from <= n && s(u), n > u.to && this.right.forEachLine(u.to + 1, n, r, a, l, s);
    }
  }
  replace(e, n, r) {
    let i = this.left.length + this.break;
    if (n < i)
      return this.balanced(this.left.replace(e, n, r), this.right);
    if (e > this.left.length)
      return this.balanced(this.left, this.right.replace(e - i, n - i, r));
    let o = [];
    e > 0 && this.decomposeLeft(e, o);
    let s = o.length;
    for (let a of r)
      o.push(a);
    if (e > 0 && Ix(o, s - 1), n < this.length) {
      let a = o.length;
      this.decomposeRight(n, o), Ix(o, a);
    }
    return pi.of(o);
  }
  decomposeLeft(e, n) {
    let r = this.left.length;
    if (e <= r)
      return this.left.decomposeLeft(e, n);
    n.push(this.left), this.break && (r++, e >= r && n.push(null)), e > r && this.right.decomposeLeft(e - r, n);
  }
  decomposeRight(e, n) {
    let r = this.left.length, i = r + this.break;
    if (e >= i)
      return this.right.decomposeRight(e - i, n);
    e < r && this.left.decomposeRight(e, n), this.break && e < i && n.push(null), n.push(this.right);
  }
  balanced(e, n) {
    return e.size > 2 * n.size || n.size > 2 * e.size ? pi.of(this.break ? [e, null, n] : [e, n]) : (this.left = ey(this.left, e), this.right = ey(this.right, n), this.setHeight(e.height + n.height), this.outdated = e.outdated || n.outdated, this.size = e.size + n.size, this.length = e.length + this.break + n.length, this);
  }
  updateHeight(e, n = 0, r = !1, i) {
    let { left: o, right: s } = this, a = n + o.length + this.break, l = null;
    return i && i.from <= n + o.length && i.more ? l = o = o.updateHeight(e, n, r, i) : o.updateHeight(e, n, r), i && i.from <= a + s.length && i.more ? l = s = s.updateHeight(e, a, r, i) : s.updateHeight(e, a, r), l ? this.balanced(o, s) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function Ix(t, e) {
  let n, r;
  t[e] == null && (n = t[e - 1]) instanceof Fr && (r = t[e + 1]) instanceof Fr && t.splice(e - 1, 3, new Fr(n.length + 1 + r.length));
}
const UW = 5;
class CE {
  constructor(e, n) {
    this.pos = e, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(e, n) {
    if (this.lineStart > -1) {
      let r = Math.min(n, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof Wi ? i.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new Wi(r - this.pos, -1)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  }
  point(e, n, r) {
    if (e < n || r.heightRelevant) {
      let i = r.widget ? r.widget.estimatedHeight : 0, o = r.widget ? r.widget.lineBreaks : 0;
      i < 0 && (i = this.oracle.lineHeight);
      let s = n - e;
      r.block ? this.addBlock(new VF(s, i, r)) : (s || o || i >= UW) && this.addLineDeco(i, o, s);
    } else n > e && this.span(e, n);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: e, to: n } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = e, this.lineEnd = n, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new Wi(this.pos - e, -1)), this.writtenTo = this.pos;
  }
  blankContent(e, n) {
    let r = new Fr(n - e);
    return this.oracle.doc.lineAt(e).to == n && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (e instanceof Wi)
      return e;
    let n = new Wi(0, -1);
    return this.nodes.push(n), n;
  }
  addBlock(e) {
    this.enterLine();
    let n = e.deco;
    n && n.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, n && n.endSide > 0 && (this.covering = e);
  }
  addLineDeco(e, n, r) {
    let i = this.ensureLine();
    i.length += r, i.collapsed += r, i.widgetHeight = Math.max(i.widgetHeight, e), i.breaks += n, this.writtenTo = this.pos = this.pos + r;
  }
  finish(e) {
    let n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(n instanceof Wi) && !this.isCovered ? this.nodes.push(new Wi(0, -1)) : (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = e;
    for (let i of this.nodes)
      i instanceof Wi && i.updateHeight(this.oracle, r), r += i ? i.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(e, n, r, i) {
    let o = new CE(r, e);
    return Jt.spans(n, r, i, o, 0), o.finish(r);
  }
}
function qW(t, e, n) {
  let r = new zW();
  return Jt.compare(t, e, n, r, 0), r.changes;
}
class zW {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(e, n, r, i) {
    (e < n || r && r.heightRelevant || i && i.heightRelevant) && rm(e, n, this.changes, 5);
  }
}
function HW(t, e) {
  let n = t.getBoundingClientRect(), r = t.ownerDocument, i = r.defaultView || window, o = Math.max(0, n.left), s = Math.min(i.innerWidth, n.right), a = Math.max(0, n.top), l = Math.min(i.innerHeight, n.bottom);
  for (let u = t.parentNode; u && u != r.body; )
    if (u.nodeType == 1) {
      let c = u, f = window.getComputedStyle(c);
      if ((c.scrollHeight > c.clientHeight || c.scrollWidth > c.clientWidth) && f.overflow != "visible") {
        let d = c.getBoundingClientRect();
        o = Math.max(o, d.left), s = Math.min(s, d.right), a = Math.max(a, d.top), l = Math.min(u == t.parentNode ? i.innerHeight : l, d.bottom);
      }
      u = f.position == "absolute" || f.position == "fixed" ? c.offsetParent : c.parentNode;
    } else if (u.nodeType == 11)
      u = u.host;
    else
      break;
  return {
    left: o - n.left,
    right: Math.max(o, s) - n.left,
    top: a - (n.top + e),
    bottom: Math.max(a, l) - (n.top + e)
  };
}
function GW(t) {
  let e = t.getBoundingClientRect(), n = t.ownerDocument.defaultView || window;
  return e.left < n.innerWidth && e.right > 0 && e.top < n.innerHeight && e.bottom > 0;
}
function WW(t, e) {
  let n = t.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: e,
    bottom: n.bottom - (n.top + e)
  };
}
class pv {
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.size = r, this.displaySize = i;
  }
  static same(e, n) {
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r], o = n[r];
      if (i.from != o.from || i.to != o.to || i.size != o.size)
        return !1;
    }
    return !0;
  }
  draw(e, n) {
    return cn.replace({
      widget: new YW(this.displaySize * (n ? e.scaleY : e.scaleX), n)
    }).range(this.from, this.to);
  }
}
class YW extends wE {
  constructor(e, n) {
    super(), this.size = e, this.vertical = n;
  }
  eq(e) {
    return e.size == this.size && e.vertical == this.vertical;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class Nx {
  constructor(e) {
    this.state = e, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !1, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = Px, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = $r.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let n = e.facet(kE).some((r) => typeof r != "function" && r.class == "cm-lineWrapping");
    this.heightOracle = new BW(n), this.stateDeco = e.facet(vh).filter((r) => typeof r != "function"), this.heightMap = pi.empty().applyChanges(this.stateDeco, Zt.empty, this.heightOracle.setDoc(e.doc), [new Ao(0, 0, 0, e.doc.length)]);
    for (let r = 0; r < 2 && (this.viewport = this.getViewport(0, null), !!this.updateForViewport()); r++)
      ;
    this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = cn.set(this.lineGaps.map((r) => r.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let e = [this.viewport], { main: n } = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let i = r ? n.head : n.anchor;
      if (!e.some(({ from: o, to: s }) => i >= o && i <= s)) {
        let { from: o, to: s } = this.lineBlockAt(i);
        e.push(new Kp(o, s));
      }
    }
    return this.viewports = e.sort((r, i) => r.from - i.from), this.updateScaler();
  }
  updateScaler() {
    let e = this.scaler;
    return this.scaler = this.heightMap.height <= 7e6 ? Px : new AE(this.heightOracle, this.heightMap, this.viewports), e.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (e) => {
      this.viewportLines.push(Rd(e, this.scaler));
    });
  }
  update(e, n = null) {
    this.state = e.state;
    let r = this.stateDeco;
    this.stateDeco = this.state.facet(vh).filter((c) => typeof c != "function");
    let i = e.changedRanges, o = Ao.extendWithRanges(i, qW(r, this.stateDeco, e ? e.changes : Ir.empty(this.state.doc.length))), s = this.heightMap.height, a = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    Dx(), this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), o), (this.heightMap.height != s || ef) && (e.flags |= 2), a ? (this.scrollAnchorPos = e.changes.mapPos(a.from, -1), this.scrollAnchorHeight = a.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let l = o.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
    (n && (n.range.head < l.from || n.range.head > l.to) || !this.viewportIsAppropriate(l)) && (l = this.getViewport(0, n));
    let u = l.from != this.viewport.from || l.to != this.viewport.to;
    this.viewport = l, e.flags |= this.updateForViewport(), (u || !e.changes.empty || e.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(e.changes), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet(KG) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(e) {
    let n = e.contentDOM, r = window.getComputedStyle(n), i = this.heightOracle, o = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? $r.RTL : $r.LTR;
    let s = this.heightOracle.mustRefreshForWrapping(o), a = n.getBoundingClientRect(), l = s || this.mustMeasureContent || this.contentDOMHeight != a.height;
    this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
    let u = 0, c = 0;
    if (a.width && a.height) {
      let { scaleX: b, scaleY: y } = QM(n, a);
      (b > 5e-3 && Math.abs(this.scaleX - b) > 5e-3 || y > 5e-3 && Math.abs(this.scaleY - y) > 5e-3) && (this.scaleX = b, this.scaleY = y, u |= 16, s = l = !0);
    }
    let f = (parseInt(r.paddingTop) || 0) * this.scaleY, d = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != f || this.paddingBottom != d) && (this.paddingTop = f, this.paddingBottom = d, u |= 18), this.editorWidth != e.scrollDOM.clientWidth && (i.lineWrapping && (l = !0), this.editorWidth = e.scrollDOM.clientWidth, u |= 16);
    let h = e.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != h && (this.scrollAnchorHeight = -1, this.scrollTop = h), this.scrolledToBottom = eF(e.scrollDOM);
    let p = (this.printing ? WW : HW)(n, this.paddingTop), g = p.top - this.pixelViewport.top, m = p.bottom - this.pixelViewport.bottom;
    this.pixelViewport = p;
    let v = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (v != this.inView && (this.inView = v, v && (l = !0)), !this.inView && !this.scrollTarget && !GW(e.dom))
      return 0;
    let S = a.width;
    if ((this.contentDOMWidth != S || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = a.width, this.editorHeight = e.scrollDOM.clientHeight, u |= 16), l) {
      let b = e.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(b) && (s = !0), s || i.lineWrapping && Math.abs(S - this.contentDOMWidth) > i.charWidth) {
        let { lineHeight: y, charWidth: w, textHeight: E } = e.docView.measureTextSize();
        s = y > 0 && i.refresh(o, y, w, E, S / w, b), s && (e.docView.minWidth = 0, u |= 16);
      }
      g > 0 && m > 0 ? c = Math.max(g, m) : g < 0 && m < 0 && (c = Math.min(g, m)), Dx();
      for (let y of this.viewports) {
        let w = y.from == this.viewport.from ? b : e.docView.measureVisibleLineHeights(y);
        this.heightMap = (s ? pi.empty().applyChanges(this.stateDeco, Zt.empty, this.heightOracle, [new Ao(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(i, 0, s, new jW(y.from, w));
      }
      ef && (u |= 2);
    }
    let _ = !this.viewportIsAppropriate(this.viewport, c) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return _ && (u & 2 && (u |= this.updateScaler()), this.viewport = this.getViewport(c, this.scrollTarget), u |= this.updateForViewport()), (u & 2 || _) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(s ? [] : this.lineGaps, e)), u |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), u;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(e, n) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)), i = this.heightMap, o = this.heightOracle, { visibleTop: s, visibleBottom: a } = this, l = new Kp(i.lineAt(s - r * 1e3, $n.ByHeight, o, 0, 0).from, i.lineAt(a + (1 - r) * 1e3, $n.ByHeight, o, 0, 0).to);
    if (n) {
      let { head: u } = n.range;
      if (u < l.from || u > l.to) {
        let c = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), f = i.lineAt(u, $n.ByPos, o, 0, 0), d;
        n.y == "center" ? d = (f.top + f.bottom) / 2 - c / 2 : n.y == "start" || n.y == "nearest" && u < l.from ? d = f.top : d = f.bottom - c, l = new Kp(i.lineAt(d - 1e3 / 2, $n.ByHeight, o, 0, 0).from, i.lineAt(d + c + 1e3 / 2, $n.ByHeight, o, 0, 0).to);
      }
    }
    return l;
  }
  mapViewport(e, n) {
    let r = n.mapPos(e.from, -1), i = n.mapPos(e.to, 1);
    return new Kp(this.heightMap.lineAt(r, $n.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(i, $n.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: e, to: n }, r = 0) {
    if (!this.inView)
      return !0;
    let { top: i } = this.heightMap.lineAt(e, $n.ByPos, this.heightOracle, 0, 0), { bottom: o } = this.heightMap.lineAt(n, $n.ByPos, this.heightOracle, 0, 0), { visibleTop: s, visibleBottom: a } = this;
    return (e == 0 || i <= s - Math.max(10, Math.min(
      -r,
      250
      /* VP.MaxCoverMargin */
    ))) && (n == this.state.doc.length || o >= a + Math.max(10, Math.min(
      r,
      250
      /* VP.MaxCoverMargin */
    ))) && i > s - 2 * 1e3 && o < a + 2 * 1e3;
  }
  mapLineGaps(e, n) {
    if (!e.length || n.empty)
      return e;
    let r = [];
    for (let i of e)
      n.touchesRange(i.from, i.to) || r.push(new pv(n.mapPos(i.from), n.mapPos(i.to), i.size, i.displaySize));
    return r;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(e, n) {
    let r = this.heightOracle.lineWrapping, i = r ? 1e4 : 2e3, o = i >> 1, s = i << 1;
    if (this.defaultTextDirection != $r.LTR && !r)
      return [];
    let a = [], l = (c, f, d, h) => {
      if (f - c < o)
        return;
      let p = this.state.selection.main, g = [p.from];
      p.empty || g.push(p.to);
      for (let v of g)
        if (v > c && v < f) {
          l(c, v - 10, d, h), l(v + 10, f, d, h);
          return;
        }
      let m = KW(e, (v) => v.from >= d.from && v.to <= d.to && Math.abs(v.from - c) < o && Math.abs(v.to - f) < o && !g.some((S) => v.from < S && v.to > S));
      if (!m) {
        if (f < d.to && n && r && n.visibleRanges.some((_) => _.from <= f && _.to >= f)) {
          let _ = n.moveToLineBoundary(ot.cursor(f), !1, !0).head;
          _ > c && (f = _);
        }
        let v = this.gapSize(d, c, f, h), S = r || v < 2e6 ? v : 2e6;
        m = new pv(c, f, v, S);
      }
      a.push(m);
    }, u = (c) => {
      if (c.length < s || c.type != Co.Text)
        return;
      let f = XW(c.from, c.to, this.stateDeco);
      if (f.total < s)
        return;
      let d = this.scrollTarget ? this.scrollTarget.range.head : null, h, p;
      if (r) {
        let g = i / this.heightOracle.lineLength * this.heightOracle.lineHeight, m, v;
        if (d != null) {
          let S = Jp(f, d), _ = ((this.visibleBottom - this.visibleTop) / 2 + g) / c.height;
          m = S - _, v = S + _;
        } else
          m = (this.visibleTop - c.top - g) / c.height, v = (this.visibleBottom - c.top + g) / c.height;
        h = Qp(f, m), p = Qp(f, v);
      } else {
        let g = f.total * this.heightOracle.charWidth, m = i * this.heightOracle.charWidth, v = 0;
        if (g > 2e6)
          for (let w of e)
            w.from >= c.from && w.from < c.to && w.size != w.displaySize && w.from * this.heightOracle.charWidth + v < this.pixelViewport.left && (v = w.size - w.displaySize);
        let S = this.pixelViewport.left + v, _ = this.pixelViewport.right + v, b, y;
        if (d != null) {
          let w = Jp(f, d), E = ((_ - S) / 2 + m) / g;
          b = w - E, y = w + E;
        } else
          b = (S - m) / g, y = (_ + m) / g;
        h = Qp(f, b), p = Qp(f, y);
      }
      h > c.from && l(c.from, h, c, f), p < c.to && l(p, c.to, c, f);
    };
    for (let c of this.viewportLines)
      Array.isArray(c.type) ? c.type.forEach(u) : u(c);
    return a;
  }
  gapSize(e, n, r, i) {
    let o = Jp(i, r) - Jp(i, n);
    return this.heightOracle.lineWrapping ? e.height * o : i.total * this.heightOracle.charWidth * o;
  }
  updateLineGaps(e) {
    pv.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = cn.set(e.map((n) => n.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges(e) {
    let n = this.stateDeco;
    this.lineGaps.length && (n = n.concat(this.lineGapDeco));
    let r = [];
    Jt.spans(n, this.viewport.from, this.viewport.to, {
      span(o, s) {
        r.push({ from: o, to: s });
      },
      point() {
      }
    }, 20);
    let i = 0;
    if (r.length != this.visibleRanges.length)
      i = 12;
    else
      for (let o = 0; o < r.length && !(i & 8); o++) {
        let s = this.visibleRanges[o], a = r[o];
        (s.from != a.from || s.to != a.to) && (i |= 4, e && e.mapPos(s.from, -1) == a.from && e.mapPos(s.to, 1) == a.to || (i |= 8));
      }
    return this.visibleRanges = r, i;
  }
  lineBlockAt(e) {
    return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find((n) => n.from <= e && n.to >= e) || Rd(this.heightMap.lineAt(e, $n.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(e) {
    return e >= this.viewportLines[0].top && e <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((n) => n.top <= e && n.bottom >= e) || Rd(this.heightMap.lineAt(this.scaler.fromDOM(e), $n.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(e) {
    let n = this.lineBlockAtHeight(e + 8);
    return n.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? n : this.viewportLines[0];
  }
  elementAtHeight(e) {
    return Rd(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class Kp {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
function XW(t, e, n) {
  let r = [], i = t, o = 0;
  return Jt.spans(n, t, e, {
    span() {
    },
    point(s, a) {
      s > i && (r.push({ from: i, to: s }), o += s - i), i = a;
    }
  }, 20), i < e && (r.push({ from: i, to: e }), o += e - i), { total: o, ranges: r };
}
function Qp({ total: t, ranges: e }, n) {
  if (n <= 0)
    return e[0].from;
  if (n >= 1)
    return e[e.length - 1].to;
  let r = Math.floor(t * n);
  for (let i = 0; ; i++) {
    let { from: o, to: s } = e[i], a = s - o;
    if (r <= a)
      return o + r;
    r -= a;
  }
}
function Jp(t, e) {
  let n = 0;
  for (let { from: r, to: i } of t.ranges) {
    if (e <= i) {
      n += e - r;
      break;
    }
    n += i - r;
  }
  return n / t.total;
}
function KW(t, e) {
  for (let n of t)
    if (e(n))
      return n;
}
const Px = {
  toDOM(t) {
    return t;
  },
  fromDOM(t) {
    return t;
  },
  scale: 1,
  eq(t) {
    return t == this;
  }
};
class AE {
  constructor(e, n, r) {
    let i = 0, o = 0, s = 0;
    this.viewports = r.map(({ from: a, to: l }) => {
      let u = n.lineAt(a, $n.ByPos, e, 0, 0).top, c = n.lineAt(l, $n.ByPos, e, 0, 0).bottom;
      return i += c - u, { from: a, to: l, top: u, bottom: c, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - i) / (n.height - i);
    for (let a of this.viewports)
      a.domTop = s + (a.top - o) * this.scale, s = a.domBottom = a.domTop + (a.bottom - a.top), o = a.bottom;
  }
  toDOM(e) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || e < o.top)
        return i + (e - r) * this.scale;
      if (e <= o.bottom)
        return o.domTop + (e - o.top);
      r = o.bottom, i = o.domBottom;
    }
  }
  fromDOM(e) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || e < o.domTop)
        return r + (e - i) / this.scale;
      if (e <= o.domBottom)
        return o.top + (e - o.domTop);
      r = o.bottom, i = o.domBottom;
    }
  }
  eq(e) {
    return e instanceof AE ? this.scale == e.scale && this.viewports.length == e.viewports.length && this.viewports.every((n, r) => n.from == e.viewports[r].from && n.to == e.viewports[r].to) : !1;
  }
}
function Rd(t, e) {
  if (e.scale == 1)
    return t;
  let n = e.toDOM(t.top), r = e.toDOM(t.bottom);
  return new ms(t.from, t.length, n, r - n, Array.isArray(t._content) ? t._content.map((i) => Rd(i, e)) : t._content);
}
const Zp = /* @__PURE__ */ vt.define({ combine: (t) => t.join(" ") }), Jw = /* @__PURE__ */ vt.define({ combine: (t) => t.indexOf(!0) > -1 }), Zw = /* @__PURE__ */ cl.newName(), UF = /* @__PURE__ */ cl.newName(), qF = /* @__PURE__ */ cl.newName(), zF = { "&light": "." + UF, "&dark": "." + qF };
function eS(t, e, n) {
  return new cl(e, {
    finish(r) {
      return /&/.test(r) ? r.replace(/&\w*/, (i) => {
        if (i == "&")
          return t;
        if (!n || !n[i])
          throw new RangeError(`Unsupported selector: ${i}`);
        return n[i];
      }) : t + " " + r;
    }
  });
}
const QW = /* @__PURE__ */ eS("." + Zw, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0,
    overflowAnchor: "none"
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#ddd"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: 300
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace": {
    backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
    backgroundPosition: "center"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, zF), JW = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, gv = Qe.ie && Qe.ie_version <= 11;
class ZW {
  constructor(e) {
    this.view = e, this.active = !1, this.editContext = null, this.selectionRange = new NG(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = e.contentDOM, this.observer = new MutationObserver((n) => {
      for (let r of n)
        this.queue.push(r);
      (Qe.ie && Qe.ie_version <= 11 || Qe.ios && e.composing) && n.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), window.EditContext && e.constructor.EDIT_CONTEXT !== !1 && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(Qe.chrome && Qe.chrome_version < 126) && (this.editContext = new tY(e), e.state.facet(ea) && (e.contentDOM.editContext = this.editContext.editContext)), gv && (this.onCharData = (n) => {
      this.queue.push({
        target: n.target,
        type: "characterData",
        oldValue: n.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var n;
      ((n = this.view.docView) === null || n === void 0 ? void 0 : n.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((n) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), n.length > 0 && n[n.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((n) => {
      n.length > 0 && n[n.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(e) {
    this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
  }
  onScroll(e) {
    this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(e);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(e) {
    (e.type == "change" || !e.type) && !e.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(e) {
    if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((n, r) => n != e[r]))) {
      this.gapIntersection.disconnect();
      for (let n of e)
        this.gapIntersection.observe(n);
      this.gaps = e;
    }
  }
  onSelectionChange(e) {
    let n = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: r } = this, i = this.selectionRange;
    if (r.state.facet(ea) ? r.root.activeElement != this.dom : !nm(this.dom, i))
      return;
    let o = i.anchorNode && r.docView.nearest(i.anchorNode);
    if (o && o.ignoreEvent(e)) {
      n || (this.selectionChanged = !1);
      return;
    }
    (Qe.ie && Qe.ie_version <= 11 || Qe.android && Qe.chrome) && !r.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    i.focusNode && Xd(i.focusNode, i.focusOffset, i.anchorNode, i.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: e } = this, n = mh(e.root);
    if (!n)
      return !1;
    let r = Qe.safari && e.root.nodeType == 11 && e.root.activeElement == this.dom && eY(this.view, n) || n;
    if (!r || this.selectionRange.eq(r))
      return !1;
    let i = nm(this.dom, r);
    return i && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && $G(this.dom, r) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(r), i && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(e, n) {
    this.selectionRange.set(e.node, e.offset, n.node, n.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let e = 0, n = null;
    for (let r = this.dom; r; )
      if (r.nodeType == 1)
        !n && e < this.scrollTargets.length && this.scrollTargets[e] == r ? e++ : n || (n = this.scrollTargets.slice(0, e)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      else if (r.nodeType == 11)
        r = r.host;
      else
        break;
    if (e < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, e)), n) {
      for (let r of this.scrollTargets)
        r.removeEventListener("scroll", this.onScroll);
      for (let r of this.scrollTargets = n)
        r.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(e) {
    if (!this.active)
      return e();
    try {
      return this.stop(), e();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, JW), gv && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), gv && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(e, n) {
    var r;
    if (!this.delayedAndroidKey) {
      let i = () => {
        let o = this.delayedAndroidKey;
        o && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = o.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && o.force && bc(this.dom, o.key, o.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(i);
    }
    (!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {
      key: e,
      keyCode: n,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let e of this.observer.takeRecords())
      this.queue.push(e);
    return this.queue;
  }
  processRecords() {
    let e = this.pendingRecords();
    e.length && (this.queue = []);
    let n = -1, r = -1, i = !1;
    for (let o of e) {
      let s = this.readMutation(o);
      s && (s.typeOver && (i = !0), n == -1 ? { from: n, to: r } = s : (n = Math.min(s.from, n), r = Math.max(s.to, r)));
    }
    return { from: n, to: r, typeOver: i };
  }
  readChange() {
    let { from: e, to: n, typeOver: r } = this.processRecords(), i = this.selectionChanged && nm(this.dom, this.selectionRange);
    if (e < 0 && !i)
      return null;
    e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let o = new mW(this.view, e, n, r);
    return this.view.docView.domChanged = { newSel: o.newSel ? o.newSel.main : null }, o;
  }
  // Apply pending changes, if any
  flush(e = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    e && this.readSelectionRange();
    let n = this.readChange();
    if (!n)
      return this.view.requestMeasure(), !1;
    let r = this.view.state, i = NF(this.view, n);
    return this.view.state == r && (n.domChanged || n.newSel && !n.newSel.main.eq(this.view.state.selection.main)) && this.view.update([]), i;
  }
  readMutation(e) {
    let n = this.view.docView.nearest(e.target);
    if (!n || n.ignoreMutation(e))
      return null;
    if (n.markDirty(e.type == "attributes"), e.type == "attributes" && (n.flags |= 4), e.type == "childList") {
      let r = $x(n, e.previousSibling || e.target.previousSibling, -1), i = $x(n, e.nextSibling || e.target.nextSibling, 1);
      return {
        from: r ? n.posAfter(r) : n.posAtStart,
        to: i ? n.posBefore(i) : n.posAtEnd,
        typeOver: !1
      };
    } else return e.type == "characterData" ? { from: n.posAtStart, to: n.posAtEnd, typeOver: e.target.nodeValue == e.oldValue } : null;
  }
  setWindow(e) {
    e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
  }
  addWindowListeners(e) {
    e.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener ? this.printQuery.addEventListener("change", this.onPrint) : this.printQuery.addListener(this.onPrint) : e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(e) {
    e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener ? this.printQuery.removeEventListener("change", this.onPrint) : this.printQuery.removeListener(this.onPrint) : e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(e) {
    this.editContext && (this.editContext.update(e), e.startState.facet(ea) != e.state.facet(ea) && (e.view.contentDOM.editContext = e.state.facet(ea) ? this.editContext.editContext : null));
  }
  destroy() {
    var e, n, r;
    this.stop(), (e = this.intersection) === null || e === void 0 || e.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let i of this.scrollTargets)
      i.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
  }
}
function $x(t, e, n) {
  for (; e; ) {
    let r = wn.get(e);
    if (r && r.parent == t)
      return r;
    let i = e.parentNode;
    e = i != t.dom ? i : n > 0 ? e.nextSibling : e.previousSibling;
  }
  return null;
}
function Mx(t, e) {
  let n = e.startContainer, r = e.startOffset, i = e.endContainer, o = e.endOffset, s = t.docView.domAtPos(t.state.selection.main.anchor);
  return Xd(s.node, s.offset, i, o) && ([n, r, i, o] = [i, o, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o };
}
function eY(t, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(t.root)[0];
    if (i)
      return Mx(t, i);
  }
  let n = null;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return t.contentDOM.addEventListener("beforeinput", r, !0), t.dom.ownerDocument.execCommand("indent"), t.contentDOM.removeEventListener("beforeinput", r, !0), n ? Mx(t, n) : null;
}
class tY {
  constructor(e) {
    this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = /* @__PURE__ */ Object.create(null), this.composing = null, this.resetRange(e.state);
    let n = this.editContext = new window.EditContext({
      text: e.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, e.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(e.state.selection.main.head)
    });
    this.handlers.textupdate = (r) => {
      let i = e.state.selection.main, { anchor: o, head: s } = i, a = this.toEditorPos(r.updateRangeStart), l = this.toEditorPos(r.updateRangeEnd);
      e.inputState.composing >= 0 && !this.composing && (this.composing = { contextBase: r.updateRangeStart, editorBase: a, drifted: !1 });
      let u = { from: a, to: l, insert: Zt.of(r.text.split(`
`)) };
      if (u.from == this.from && o < this.from ? u.from = o : u.to == this.to && o > this.to && (u.to = o), u.from == u.to && !u.insert.length) {
        let c = ot.single(this.toEditorPos(r.selectionStart), this.toEditorPos(r.selectionEnd));
        c.main.eq(i) || e.dispatch({ selection: c, userEvent: "select" });
        return;
      }
      if ((Qe.mac || Qe.android) && u.from == s - 1 && /^\. ?$/.test(r.text) && e.contentDOM.getAttribute("autocorrect") == "off" && (u = { from: a, to: l, insert: Zt.of([r.text.replace(".", " ")]) }), this.pendingContextChange = u, !e.state.readOnly) {
        let c = this.to - this.from + (u.to - u.from + u.insert.length);
        xE(e, u, ot.single(this.toEditorPos(r.selectionStart, c), this.toEditorPos(r.selectionEnd, c)));
      }
      this.pendingContextChange && (this.revertPending(e.state), this.setSelection(e.state));
    }, this.handlers.characterboundsupdate = (r) => {
      let i = [], o = null;
      for (let s = this.toEditorPos(r.rangeStart), a = this.toEditorPos(r.rangeEnd); s < a; s++) {
        let l = e.coordsForChar(s);
        o = l && new DOMRect(l.left, l.top, l.right - l.left, l.bottom - l.top) || o || new DOMRect(), i.push(o);
      }
      n.updateCharacterBounds(r.rangeStart, i);
    }, this.handlers.textformatupdate = (r) => {
      let i = [];
      for (let o of r.getTextFormats()) {
        let s = o.underlineStyle, a = o.underlineThickness;
        if (s != "None" && a != "None") {
          let l = this.toEditorPos(o.rangeStart), u = this.toEditorPos(o.rangeEnd);
          if (l < u) {
            let c = `text-decoration: underline ${s == "Dashed" ? "dashed " : s == "Squiggle" ? "wavy " : ""}${a == "Thin" ? 1 : 2}px`;
            i.push(cn.mark({ attributes: { style: c } }).range(l, u));
          }
        }
      }
      e.dispatch({ effects: TF.of(cn.set(i)) });
    }, this.handlers.compositionstart = () => {
      e.inputState.composing < 0 && (e.inputState.composing = 0, e.inputState.compositionFirstChange = !0);
    }, this.handlers.compositionend = () => {
      if (e.inputState.composing = -1, e.inputState.compositionFirstChange = null, this.composing) {
        let { drifted: r } = this.composing;
        this.composing = null, r && this.reset(e.state);
      }
    };
    for (let r in this.handlers)
      n.addEventListener(r, this.handlers[r]);
    this.measureReq = { read: (r) => {
      this.editContext.updateControlBounds(r.contentDOM.getBoundingClientRect());
      let i = mh(r.root);
      i && i.rangeCount && this.editContext.updateSelectionBounds(i.getRangeAt(0).getBoundingClientRect());
    } };
  }
  applyEdits(e) {
    let n = 0, r = !1, i = this.pendingContextChange;
    return e.changes.iterChanges((o, s, a, l, u) => {
      if (r)
        return;
      let c = u.length - (s - o);
      if (i && s >= i.to)
        if (i.from == o && i.to == s && i.insert.eq(u)) {
          i = this.pendingContextChange = null, n += c, this.to += c;
          return;
        } else
          i = null, this.revertPending(e.state);
      if (o += n, s += n, s <= this.from)
        this.from += c, this.to += c;
      else if (o < this.to) {
        if (o < this.from || s > this.to || this.to - this.from + u.length > 3e4) {
          r = !0;
          return;
        }
        this.editContext.updateText(this.toContextPos(o), this.toContextPos(s), u.toString()), this.to += c;
      }
      n += c;
    }), i && !r && this.revertPending(e.state), !r;
  }
  update(e) {
    let n = this.pendingContextChange, r = e.startState.selection.main;
    this.composing && (this.composing.drifted || !e.changes.touchesRange(r.from, r.to) && e.transactions.some((i) => !i.isUserEvent("input.type") && i.changes.touchesRange(this.from, this.to))) ? (this.composing.drifted = !0, this.composing.editorBase = e.changes.mapPos(this.composing.editorBase)) : !this.applyEdits(e) || !this.rangeIsValid(e.state) ? (this.pendingContextChange = null, this.reset(e.state)) : (e.docChanged || e.selectionSet || n) && this.setSelection(e.state), (e.geometryChanged || e.docChanged || e.selectionSet) && e.view.requestMeasure(this.measureReq);
  }
  resetRange(e) {
    let { head: n } = e.selection.main;
    this.from = Math.max(
      0,
      n - 1e4
      /* CxVp.Margin */
    ), this.to = Math.min(
      e.doc.length,
      n + 1e4
      /* CxVp.Margin */
    );
  }
  reset(e) {
    this.resetRange(e), this.editContext.updateText(0, this.editContext.text.length, e.doc.sliceString(this.from, this.to)), this.setSelection(e);
  }
  revertPending(e) {
    let n = this.pendingContextChange;
    this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(n.from), this.toContextPos(n.from + n.insert.length), e.doc.sliceString(n.from, n.to));
  }
  setSelection(e) {
    let { main: n } = e.selection, r = this.toContextPos(Math.max(this.from, Math.min(this.to, n.anchor))), i = this.toContextPos(n.head);
    (this.editContext.selectionStart != r || this.editContext.selectionEnd != i) && this.editContext.updateSelection(r, i);
  }
  rangeIsValid(e) {
    let { head: n } = e.selection.main;
    return !(this.from > 0 && n - this.from < 500 || this.to < e.doc.length && this.to - n < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(e, n = this.to - this.from) {
    e = Math.min(e, n);
    let r = this.composing;
    return r && r.drifted ? r.editorBase + (e - r.contextBase) : e + this.from;
  }
  toContextPos(e) {
    let n = this.composing;
    return n && n.drifted ? n.contextBase + (e - n.editorBase) : e - this.from;
  }
  destroy() {
    for (let e in this.handlers)
      this.editContext.removeEventListener(e, this.handlers[e]);
  }
}
class Ht {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(e = {}) {
    var n;
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), e.parent && e.parent.appendChild(this.dom);
    let { dispatch: r } = e;
    this.dispatchTransactions = e.dispatchTransactions || r && ((i) => i.forEach((o) => r(o, this))) || ((i) => this.update(i)), this.dispatch = this.dispatch.bind(this), this._root = e.root || PG(e.parent) || document, this.viewState = new Nx(e.state || hn.create(e)), e.scrollTo && e.scrollTo.is(Wp) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(xd).map((i) => new fv(i));
    for (let i of this.plugins)
      i.update(this);
    this.observer = new ZW(this), this.inputState = new SW(this), this.inputState.ensureHandlers(this.plugins), this.docView = new px(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), !((n = document.fonts) === null || n === void 0) && n.ready && document.fonts.ready.then(() => this.requestMeasure());
  }
  dispatch(...e) {
    let n = e.length == 1 && e[0] instanceof ei ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
    this.dispatchTransactions(n, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let n = !1, r = !1, i, o = this.state;
    for (let d of e) {
      if (d.startState != o)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      o = d.state;
    }
    if (this.destroyed) {
      this.viewState.state = o;
      return;
    }
    let s = this.hasFocus, a = 0, l = null;
    e.some((d) => d.annotation(LF)) ? (this.inputState.notifiedFocused = s, a = 1) : s != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = s, l = BF(o, s), l || (a = 1));
    let u = this.observer.delayedAndroidKey, c = null;
    if (u ? (this.observer.clearDelayedAndroidKey(), c = this.observer.readChange(), (c && !this.state.doc.eq(o.doc) || !this.state.selection.eq(o.selection)) && (c = null)) : this.observer.clear(), o.facet(hn.phrases) != this.state.facet(hn.phrases))
      return this.setState(o);
    i = Zm.create(this, o, e), i.flags |= a;
    let f = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let d of e) {
        if (f && (f = f.map(d.changes)), d.scrollIntoView) {
          let { main: h } = d.state.selection;
          f = new wc(h.empty ? h : ot.cursor(h.head, h.head > h.anchor ? -1 : 1));
        }
        for (let h of d.effects)
          h.is(Wp) && (f = h.value.clip(this.state));
      }
      this.viewState.update(i, f), this.bidiCache = ty.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), n = this.docView.update(i), this.state.facet(Cd) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(n, e.some((d) => d.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (i.startState.facet(Zp) != i.state.facet(Zp) && (this.viewState.mustMeasureContent = !0), (n || r || f || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), n && this.docViewUpdate(), !i.empty)
      for (let d of this.state.facet(Xw))
        try {
          d(i);
        } catch (h) {
          ws(this.state, h, "update listener");
        }
    (l || c) && Promise.resolve().then(() => {
      l && this.state == l.startState && this.dispatch(l), c && !NF(this, c) && u.force && bc(this.contentDOM, u.key, u.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = e;
      return;
    }
    this.updateState = 2;
    let n = this.hasFocus;
    try {
      for (let r of this.plugins)
        r.destroy(this);
      this.viewState = new Nx(e), this.plugins = e.facet(xd).map((r) => new fv(r)), this.pluginMap.clear();
      for (let r of this.plugins)
        r.update(this);
      this.docView.destroy(), this.docView = new px(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    n && this.focus(), this.requestMeasure();
  }
  updatePlugins(e) {
    let n = e.startState.facet(xd), r = e.state.facet(xd);
    if (n != r) {
      let i = [];
      for (let o of r) {
        let s = n.indexOf(o);
        if (s < 0)
          i.push(new fv(o));
        else {
          let a = this.plugins[s];
          a.mustUpdate = e, i.push(a);
        }
      }
      for (let o of this.plugins)
        o.mustUpdate != e && o.destroy(this);
      this.plugins = i, this.pluginMap.clear();
    } else
      for (let i of this.plugins)
        i.mustUpdate = e;
    for (let i = 0; i < this.plugins.length; i++)
      this.plugins[i].update(this);
    n != r && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let e of this.plugins) {
      let n = e.value;
      if (n && n.docViewUpdate)
        try {
          n.docViewUpdate(this);
        } catch (r) {
          ws(this.state, r, "doc view update listener");
        }
    }
  }
  /**
  @internal
  */
  measure(e = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, e && this.observer.forceFlush();
    let n = null, r = this.scrollDOM, i = r.scrollTop * this.scaleY, { scrollAnchorPos: o, scrollAnchorHeight: s } = this.viewState;
    Math.abs(i - this.viewState.scrollTop) > 1 && (s = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let a = 0; ; a++) {
        if (s < 0)
          if (eF(r))
            o = -1, s = this.viewState.heightMap.height;
          else {
            let h = this.viewState.scrollAnchorAt(i);
            o = h.from, s = h.top;
          }
        this.updateState = 1;
        let l = this.viewState.measure(this);
        if (!l && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (a > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let u = [];
        l & 4 || ([this.measureRequests, u] = [u, this.measureRequests]);
        let c = u.map((h) => {
          try {
            return h.read(this);
          } catch (p) {
            return ws(this.state, p), Fx;
          }
        }), f = Zm.create(this, this.state, []), d = !1;
        f.flags |= l, n ? n.flags |= l : n = f, this.updateState = 2, f.empty || (this.updatePlugins(f), this.inputState.update(f), this.updateAttrs(), d = this.docView.update(f), d && this.docViewUpdate());
        for (let h = 0; h < u.length; h++)
          if (c[h] != Fx)
            try {
              let p = u[h];
              p.write && p.write(c[h], this);
            } catch (p) {
              ws(this.state, p);
            }
        if (d && this.docView.updateSelection(!0), !f.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, s = -1;
              continue;
            } else {
              let p = (o < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(o).top) - s;
              if (p > 1 || p < -1) {
                i = i + p, r.scrollTop = i / this.scaleY, s = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (n && !n.empty)
      for (let a of this.state.facet(Xw))
        a(n);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return Zw + " " + (this.state.facet(Jw) ? qF : UF) + " " + this.state.facet(Zp);
  }
  updateAttrs() {
    let e = Lx(this, xF, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), n = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      writingsuggestions: "false",
      translate: "no",
      contenteditable: this.state.facet(ea) ? "true" : "false",
      class: "cm-content",
      style: `${Qe.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (n["aria-readonly"] = "true"), Lx(this, kE, n);
    let r = this.observer.ignore(() => {
      let i = zw(this.contentDOM, this.contentAttrs, n), o = zw(this.dom, this.editorAttrs, e);
      return i || o;
    });
    return this.editorAttrs = e, this.contentAttrs = n, r;
  }
  showAnnouncements(e) {
    let n = !0;
    for (let r of e)
      for (let i of r.effects)
        if (i.is(Ht.announce)) {
          n && (this.announceDOM.textContent = ""), n = !1;
          let o = this.announceDOM.appendChild(document.createElement("div"));
          o.textContent = i.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(Cd);
    let e = this.state.facet(Ht.cspNonce);
    cl.mount(this.root, this.styleModules.concat(QW).reverse(), e ? { nonce: e } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(e) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
      if (this.measureRequests.indexOf(e) > -1)
        return;
      if (e.key != null) {
        for (let n = 0; n < this.measureRequests.length; n++)
          if (this.measureRequests[n].key === e.key) {
            this.measureRequests[n] = e;
            return;
          }
      }
      this.measureRequests.push(e);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(e) {
    let n = this.pluginMap.get(e);
    return (n === void 0 || n && n.spec != e) && this.pluginMap.set(e, n = this.plugins.find((r) => r.spec == e) || null), n && n.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(e) {
    return this.readMeasured(), this.viewState.elementAtHeight(e);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(e) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(e) {
    return this.viewState.lineBlockAt(e);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(e, n, r) {
    return hv(this, e, bx(this, e, n, r));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(e, n) {
    return hv(this, e, bx(this, e, n, (r) => dW(this, e.head, r)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(e, n) {
    let r = this.bidiSpans(e), i = this.textDirectionAt(e.from), o = r[n ? r.length - 1 : 0];
    return ot.cursor(o.side(n, i) + e.from, o.forward(!n, i) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(e, n, r = !0) {
    return fW(this, e, n, r);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(e, n, r) {
    return hv(this, e, hW(this, e, n, r));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(e) {
    return this.docView.domAtPos(e);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(e, n = 0) {
    return this.docView.posFromDOM(e, n);
  }
  posAtCoords(e, n = !0) {
    return this.readMeasured(), IF(this, e, n);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(e, n = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(e, n);
    if (!r || r.left == r.right)
      return r;
    let i = this.state.doc.lineAt(e), o = this.bidiSpans(i), s = o[Wa.find(o, e - i.from, -1, n)];
    return o0(r, s.dir == $r.LTR == n > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(e) {
    return this.readMeasured(), this.docView.coordsForChar(e);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(e) {
    return !this.state.facet(EF) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(e) {
    if (e.length > nY)
      return gF(e.length);
    let n = this.textDirectionAt(e.from), r;
    for (let o of this.bidiCache)
      if (o.from == e.from && o.dir == n && (o.fresh || pF(o.isolates, r = hx(this, e))))
        return o.order;
    r || (r = hx(this, e));
    let i = WG(e.text, n, r);
    return this.bidiCache.push(new ty(e.from, e.to, n, r, !0, i)), i;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var e;
    return (this.dom.ownerDocument.hasFocus() || Qe.safari && ((e = this.inputState) === null || e === void 0 ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      JM(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(e) {
    this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    this.root.activeElement == this.contentDOM && this.contentDOM.blur();
    for (let e of this.plugins)
      e.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(e, n = {}) {
    return Wp.of(new wc(typeof e == "number" ? ot.cursor(e) : e, n.y, n.x, n.yMargin, n.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: e, scrollLeft: n } = this.scrollDOM, r = this.viewState.scrollAnchorAt(e);
    return Wp.of(new wc(ot.cursor(r.from), "start", "start", r.top - e, n, !0));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(e) {
    e == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof e == "boolean" ? this.inputState.tabFocusMode = e ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + e);
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(e) {
    return No.define(() => ({}), { eventHandlers: e });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(e) {
    return No.define(() => ({}), { eventObservers: e });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(e, n) {
    let r = cl.newName(), i = [Zp.of(r), Cd.of(eS(`.${r}`, e))];
    return n && n.dark && i.push(Jw.of(!0)), i;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(e) {
    return BM.lowest(Cd.of(eS("." + Zw, e, zF)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(e) {
    var n;
    let r = e.querySelector(".cm-content"), i = r && wn.get(r) || wn.get(e);
    return ((n = i?.rootView) === null || n === void 0 ? void 0 : n.view) || null;
  }
}
Ht.styleModule = Cd;
Ht.inputHandler = SF;
Ht.clipboardInputFilter = _E;
Ht.clipboardOutputFilter = EE;
Ht.scrollHandler = kF;
Ht.focusChangeEffect = _F;
Ht.perLineTextDirection = EF;
Ht.exceptionSink = wF;
Ht.updateListener = Xw;
Ht.editable = ea;
Ht.mouseSelectionStyle = bF;
Ht.dragMovesSelection = vF;
Ht.clickAddsSelectionRange = yF;
Ht.decorations = vh;
Ht.outerDecorations = CF;
Ht.atomicRanges = TE;
Ht.bidiIsolatedRanges = AF;
Ht.scrollMargins = RF;
Ht.darkTheme = Jw;
Ht.cspNonce = /* @__PURE__ */ vt.define({ combine: (t) => t.length ? t[0] : "" });
Ht.contentAttributes = kE;
Ht.editorAttributes = xF;
Ht.lineWrapping = /* @__PURE__ */ Ht.contentAttributes.of({ class: "cm-lineWrapping" });
Ht.announce = /* @__PURE__ */ fr.define();
const nY = 4096, Fx = {};
class ty {
  constructor(e, n, r, i, o, s) {
    this.from = e, this.to = n, this.dir = r, this.isolates = i, this.fresh = o, this.order = s;
  }
  static update(e, n) {
    if (n.empty && !e.some((o) => o.fresh))
      return e;
    let r = [], i = e.length ? e[e.length - 1].dir : $r.LTR;
    for (let o = Math.max(0, e.length - 10); o < e.length; o++) {
      let s = e[o];
      s.dir == i && !n.touchesRange(s.from, s.to) && r.push(new ty(n.mapPos(s.from, 1), n.mapPos(s.to, -1), s.dir, s.isolates, !1, s.order));
    }
    return r;
  }
}
function Lx(t, e, n) {
  for (let r = t.state.facet(e), i = r.length - 1; i >= 0; i--) {
    let o = r[i], s = typeof o == "function" ? o(t) : o;
    s && qw(s, n);
  }
  return n;
}
const rY = !(Qe.ios && Qe.webkit && Qe.webkit_version < 534), Bx = {
  ".cm-line": {},
  ".cm-content": {}
};
rY && (Bx[".cm-line"].caretColor = Bx[".cm-content"].caretColor = "transparent !important");
class $o extends Kc {
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(e) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(e) {
  }
}
$o.prototype.elementClass = "";
$o.prototype.toDOM = void 0;
$o.prototype.mapMode = Zi.TrackBefore;
$o.prototype.startSide = $o.prototype.endSide = -1;
$o.prototype.point = !0;
const mv = /* @__PURE__ */ vt.define(), iY = /* @__PURE__ */ vt.define(), oY = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => Jt.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, sm = /* @__PURE__ */ vt.define();
function RE(t) {
  return [sY(), sm.of(Object.assign(Object.assign({}, oY), t))];
}
const jx = /* @__PURE__ */ vt.define({
  combine: (t) => t.some((e) => e)
});
function sY(t) {
  return [
    aY
  ];
}
const aY = /* @__PURE__ */ No.fromClass(class {
  constructor(t) {
    this.view = t, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = t.state.facet(sm).map((e) => new Ux(t, e));
    for (let e of this.gutters)
      this.dom.appendChild(e.dom);
    this.fixed = !t.state.facet(jx), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
  }
  update(t) {
    if (this.updateGutters(t)) {
      let e = this.prevViewport, n = t.view.viewport, r = Math.min(e.to, n.to) - Math.max(e.from, n.from);
      this.syncGutters(r < (n.to - n.from) * 0.8);
    }
    t.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px"), this.view.state.facet(jx) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = t.view.viewport;
  }
  syncGutters(t) {
    let e = this.dom.nextSibling;
    t && this.dom.remove();
    let n = Jt.iter(this.view.state.facet(mv), this.view.viewport.from), r = [], i = this.gutters.map((o) => new lY(o, this.view.viewport, -this.view.documentPadding.top));
    for (let o of this.view.viewportLineBlocks)
      if (r.length && (r = []), Array.isArray(o.type)) {
        let s = !0;
        for (let a of o.type)
          if (a.type == Co.Text && s) {
            tS(n, r, a.from);
            for (let l of i)
              l.line(this.view, a, r);
            s = !1;
          } else if (a.widget)
            for (let l of i)
              l.widget(this.view, a);
      } else if (o.type == Co.Text) {
        tS(n, r, o.from);
        for (let s of i)
          s.line(this.view, o, r);
      } else if (o.widget)
        for (let s of i)
          s.widget(this.view, o);
    for (let o of i)
      o.finish();
    t && this.view.scrollDOM.insertBefore(this.dom, e);
  }
  updateGutters(t) {
    let e = t.startState.facet(sm), n = t.state.facet(sm), r = t.docChanged || t.heightChanged || t.viewportChanged || !Jt.eq(t.startState.facet(mv), t.state.facet(mv), t.view.viewport.from, t.view.viewport.to);
    if (e == n)
      for (let i of this.gutters)
        i.update(t) && (r = !0);
    else {
      r = !0;
      let i = [];
      for (let o of n) {
        let s = e.indexOf(o);
        s < 0 ? i.push(new Ux(this.view, o)) : (this.gutters[s].update(t), i.push(this.gutters[s]));
      }
      for (let o of this.gutters)
        o.dom.remove(), i.indexOf(o) < 0 && o.destroy();
      for (let o of i)
        this.dom.appendChild(o.dom);
      this.gutters = i;
    }
    return r;
  }
  destroy() {
    for (let t of this.gutters)
      t.destroy();
    this.dom.remove();
  }
}, {
  provide: (t) => Ht.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return !n || n.gutters.length == 0 || !n.fixed ? null : e.textDirection == $r.LTR ? { left: n.dom.offsetWidth * e.scaleX } : { right: n.dom.offsetWidth * e.scaleX };
  })
});
function Vx(t) {
  return Array.isArray(t) ? t : [t];
}
function tS(t, e, n) {
  for (; t.value && t.from <= n; )
    t.from == n && e.push(t.value), t.next();
}
class lY {
  constructor(e, n, r) {
    this.gutter = e, this.height = r, this.i = 0, this.cursor = Jt.iter(e.markers, n.from);
  }
  addElement(e, n, r) {
    let { gutter: i } = this, o = (n.top - this.height) / e.scaleY, s = n.height / e.scaleY;
    if (this.i == i.elements.length) {
      let a = new HF(e, s, o, r);
      i.elements.push(a), i.dom.appendChild(a.dom);
    } else
      i.elements[this.i].update(e, s, o, r);
    this.height = n.bottom, this.i++;
  }
  line(e, n, r) {
    let i = [];
    tS(this.cursor, i, n.from), r.length && (i = i.concat(r));
    let o = this.gutter.config.lineMarker(e, n, i);
    o && i.unshift(o);
    let s = this.gutter;
    i.length == 0 && !s.config.renderEmptyElements || this.addElement(e, n, i);
  }
  widget(e, n) {
    let r = this.gutter.config.widgetMarker(e, n.widget, n), i = r ? [r] : null;
    for (let o of e.state.facet(iY)) {
      let s = o(e, n.widget, n);
      s && (i || (i = [])).push(s);
    }
    i && this.addElement(e, n, i);
  }
  finish() {
    let e = this.gutter;
    for (; e.elements.length > this.i; ) {
      let n = e.elements.pop();
      e.dom.removeChild(n.dom), n.destroy();
    }
  }
}
class Ux {
  constructor(e, n) {
    this.view = e, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in n.domEventHandlers)
      this.dom.addEventListener(r, (i) => {
        let o = i.target, s;
        if (o != this.dom && this.dom.contains(o)) {
          for (; o.parentNode != this.dom; )
            o = o.parentNode;
          let l = o.getBoundingClientRect();
          s = (l.top + l.bottom) / 2;
        } else
          s = i.clientY;
        let a = e.lineBlockAtHeight(s - e.documentTop);
        n.domEventHandlers[r](e, a, i) && i.preventDefault();
      });
    this.markers = Vx(n.markers(e)), n.initialSpacer && (this.spacer = new HF(e, 0, 0, [n.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(e) {
    let n = this.markers;
    if (this.markers = Vx(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
      let i = this.config.updateSpacer(this.spacer.markers[0], e);
      i != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [i]);
    }
    let r = e.view.viewport;
    return !Jt.eq(this.markers, n, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
  }
  destroy() {
    for (let e of this.elements)
      e.destroy();
  }
}
class HF {
  constructor(e, n, r, i) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, n, r, i);
  }
  update(e, n, r, i) {
    this.height != n && (this.height = n, this.dom.style.height = n + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), uY(this.markers, i) || this.setMarkers(e, i);
  }
  setMarkers(e, n) {
    let r = "cm-gutterElement", i = this.dom.firstChild;
    for (let o = 0, s = 0; ; ) {
      let a = s, l = o < n.length ? n[o++] : null, u = !1;
      if (l) {
        let c = l.elementClass;
        c && (r += " " + c);
        for (let f = s; f < this.markers.length; f++)
          if (this.markers[f].compare(l)) {
            a = f, u = !0;
            break;
          }
      } else
        a = this.markers.length;
      for (; s < a; ) {
        let c = this.markers[s++];
        if (c.toDOM) {
          c.destroy(i);
          let f = i.nextSibling;
          i.remove(), i = f;
        }
      }
      if (!l)
        break;
      l.toDOM && (u ? i = i.nextSibling : this.dom.insertBefore(l.toDOM(e), i)), u && s++;
    }
    this.dom.className = r, this.markers = n;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function uY(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].compare(e[n]))
      return !1;
  return !0;
}
const cY = ["color:", "font:", "size:", "weight:", "line-height:", "shadow:", "decoration:", "opacity:"], OE = ["across:", "align:", "anchor:", "down:"], DE = ["animate:", "animateStart:", "delay:"], GF = ["backlink:", "toPage:", "url:", "mailto:"], WF = ["border-color:", "border-thickness:", "corner-radius:", "padding-bottom:", "padding-left:", "padding-right:", "padding-top:", "padding:"], bh = [...cY, ...OE, ...DE, "background:", "columns:", "hideOn:"], Uf = [...bh, ...GF], eg = [...bh], qx = [...OE, ...DE, ...WF, "hideOn:", "height:", "width:", "opacity:"], zx = [...bh, ...WF, "blur:"], l0 = ["##:", "#:", "**:", "*:", "audio:", "autoplay:", "autospace:", "background:", "button:", "blank:", "box:", "chart:", "columnTitle:", "filter:", "form:", "image:", "line:", "moveBy:", "map:", "paragraph:", "pause:", "read:", "storyName:", "subtitle:", "supertitle:", "title:", "video:"], Qh = ["autoplay:", "filter:", "moveBy:", "pause:", "read:", "storyName:"], Hx = [...Qh, "background:", "blank:"], Tu = {
  "*:": {
    allowNdr: !0,
    keyword: "*:",
    help: "Make a bullet point.",
    expandedHelp: "Just type `*:` followed by your text to make a bullet point. Like this: `*: Add your text here`",
    hide: !1,
    type: "bullet",
    modifiers: eg
  },
  "**:": {
    allowNdr: !0,
    keyword: "**:",
    type: "bullet",
    help: "Indent a bullet point.",
    expandedHelp: "To indent a bullet point, just use `**:`. It's perfect for making sub-lists. Like this: `**: This is an indented bullet`",
    hide: !1,
    modifiers: eg
  },
  "#:": {
    allowNdr: !0,
    keyword: "#:",
    type: "bullet",
    help: "Make a numbered list.",
    expandedHelp: "Use `#: ` to start a numbered list. QuickPoint handles the numbering for you. For example: `#: First item`",
    hide: !1,
    modifiers: eg
  },
  "##:": {
    allowNdr: !0,
    keyword: "##:",
    type: "bullet",
    help: "Indent a numbered list item.",
    expandedHelp: "For sub-items in a numbered list, just use `##:`. Like this: `##: Sub-item 1.1`",
    hide: !1,
    modifiers: eg
  },
  "audio:": {
    allowNdr: !1,
    keyword: "audio:",
    type: "media",
    help: "Add an audio file.",
    expandedHelp: "Got an MP3 or OGG file? Just type `audio:` and then pick the audio file you want to add from your list of uploaded files.",
    hide: !1,
    modifiers: [],
    autoComplete: ["audio"]
  },
  "autoplay:": {
    allowNdr: !1,
    keyword: "autoplay:",
    type: "uncategorized",
    help: "Have your story play automatically.",
    expandedHelp: "Want your story to move to the next slide on its own? Just type `autoplay:` and a number of seconds. For example, `autoplay: 5` will move things along after 5 seconds. You can even make it loop with the `loop:` modifier.",
    hide: !0,
    modifiers: ["loop:"],
    autoComplete: ["loop"]
  },
  "autospace:": {
    allowNdr: !1,
    keyword: "autospace:",
    type: "uncategorized",
    help: "Toggles automatic vertical spacing between elements.",
    expandedHelp: "Use `autospace: off` to manually control the vertical space between elements using the `blank:` keyword. By default, autospacing is on.",
    hide: !1,
    modifiers: [],
    autoComplete: ["toggle"]
  },
  "background:": {
    allowNdr: !1,
    keyword: "background:",
    type: "media",
    help: "Change the background to a color or an image.",
    expandedHelp: "You can set a background for your slide with a color or an image. Just type `background:` and then a color name (like `blue`) or pick an image you've uploaded.",
    hide: !1,
    modifiers: ["opacity:", "animate:", "animateStart:"],
    autoComplete: ["colors", "images"]
  },
  "blank:": {
    allowNdr: !1,
    keyword: "blank:",
    type: "media",
    help: "Add some empty space.",
    expandedHelp: "Use `blank:` to add a standard amount of space. Want more? Just add a number. `blank:2` gives you double the space, and `blank:3` gives you triple. It's an easy way to get your spacing just right.",
    hide: !1,
    modifiers: ["height:"]
  },
  "box:": {
    allowNdr: !0,
    keyword: "box:",
    type: "divider",
    help: "Highlight text in a stylish box.",
    expandedHelp: "Perfect for pulling out a quote or making a key point stand out. You can even give the box its own background color to make it pop.",
    hide: !1,
    modifiers: zx
  },
  "button:": {
    allowNdr: !0,
    keyword: "button:",
    type: "text",
    help: "Make a clickable button.",
    expandedHelp: "Use this to create a button that links to another page in your story (with `toPage:`) or to a different website (with `url:`).",
    hide: !1,
    modifiers: Uf
  },
  "chart:": {
    allowNdr: !1,
    keyword: "chart:",
    type: "media",
    help: "Create a chart from your data.",
    expandedHelp: "Turn your data into a chart. Just upload a CSV or JSON file, type `chart:`, and then pick your file.",
    hide: !0,
    modifiers: ["animate:", "animateStart:"],
    autoComplete: ["charts"]
  },
  "columnTitle:": {
    allowNdr: !0,
    keyword: "columnTitle:",
    type: "text",
    help: "Defines a title for a grid column, enabling responsive behavior on mobile.",
    expandedHelp: "Use `columnTitle:` in the first row of a grid to label each column. Grids with column titles will automatically collapse into a stacked layout on mobile screens for better readability.",
    hide: !1,
    modifiers: bh
  },
  "filter:": {
    allowNdr: !1,
    keyword: "filter:",
    type: "uncategorized",
    help: "Apply a complete visual style to your page.",
    expandedHelp: "A filter takes care of all the visual elements for you, providing a pre-chosen color palette and style that applies to everything on the page.",
    hide: !1,
    modifiers: [],
    autoComplete: ["filters"]
  },
  "form:": {
    allowNdr: !0,
    keyword: "form:",
    type: "uncategorized",
    help: "Ask your audience a question.",
    expandedHelp: "Use this to create a form and gather information from your readers.",
    hide: !0,
    modifiers: zx
  },
  "image:": {
    allowNdr: !1,
    keyword: "image:",
    type: "loadable",
    help: "Add an image from your files.",
    expandedHelp: "Just type `image:` and pick the image you want to add. You can also add a `caption:` or make the image a link with `url:` or `toPage:`.",
    hide: !1,
    autoComplete: ["images"],
    modifiers: [...qx, ...GF, "background:", "blur:", "caption:"]
  },
  "line:": {
    allowNdr: !1,
    keyword: "line:",
    type: "divider",
    help: "Add a decorative line to break up your page.",
    expandedHelp: "Add a line to separate your content. Make it thicker by adding a number (e.g., `line:2`). Or, add some text to create a more decorative divider (e.g., `line: Chapter 2`).",
    hide: !1,
    modifiers: ["animate:", "animateStart:", "color:", "font:", "line-height:", "opacity:", "size:", "weight:"]
  },
  "map:": {
    allowNdr: !1,
    keyword: "map:",
    type: "media",
    help: "Add a Google Map.",
    expandedHelp: "To add a map, go to Google Maps and find your location. Click the 'Share' button, copy the link, and then paste it right after `map:`.",
    hide: !0,
    modifiers: qx
  },
  "moveBy:": {
    allowNdr: !1,
    keyword: "moveBy:",
    type: "uncategorized",
    help: "Choose how to move through your story.",
    expandedHelp: "Do you want your audience to tap or scroll? Use `moveBy: tap` to have them click through, or `moveBy: scroll` to let them scroll.",
    hide: !1,
    modifiers: [],
    autoComplete: ["moveBy"]
  },
  "paragraph:": {
    allowNdr: !0,
    keyword: "paragraph:",
    type: "text",
    help: "Add a paragraph of text.",
    expandedHelp: "This is the best way to add regular text to your page. You can change how it looks with modifiers like `color:`, `size:`, and `font:`.",
    hide: !1,
    modifiers: Uf
  },
  "read:": {
    allowNdr: !0,
    keyword: "read:",
    type: "text",
    help: "Add text for 'Read mode'.",
    expandedHelp: "This text won't show up on your page, but it will be available in 'Read mode'. This is a great place for speaker notes or extra information for your audience.",
    hide: !1,
    modifiers: bh
  },
  // "shadertoy:": {
  //   allowNdr: false,
  //   keyword: "shadertoy:",
  //   type: "media",
  //   help: "Adds a 3D background from shadertoy.com",
  //   expandedHelp: "",
  //   hide: false,
  //   modifiers: [],
  // },
  "storyName:": {
    allowNdr: !1,
    keyword: "storyName:",
    type: "uncategorized",
    help: "Give your story a name.",
    expandedHelp: "The name you choose will show up in the browser tab. It's also what people will see when you share your story. For example: `storyName: My Story's Title`",
    hide: !1,
    modifiers: []
  },
  "subtitle:": {
    allowNdr: !0,
    keyword: "subtitle:",
    type: "text",
    help: "Add a subtitle.",
    expandedHelp: "Perfect for adding a bit more information right under your main title.",
    hide: !1,
    modifiers: Uf
  },
  "supertitle:": {
    allowNdr: !0,
    keyword: "supertitle:",
    type: "text",
    help: "Add a big, bold title.",
    expandedHelp: "This creates text that's even bigger than a normal title. It's great for making a big statement or introducing a new section.",
    hide: !1,
    modifiers: Uf
  },
  "pause:": {
    allowNdr: !1,
    keyword: "pause:",
    type: "uncategorized",
    help: "Pause the story.",
    expandedHelp: "Everything after a `pause:` will be hidden until your reader clicks or taps. It's a great way to reveal your points one by one.",
    hide: !1,
    modifiers: []
  },
  "title:": {
    allowNdr: !0,
    keyword: "title:",
    type: "text",
    help: "Add a title.",
    expandedHelp: "Use this to add a main title to your page.",
    hide: !1,
    modifiers: Uf
  },
  "video:": {
    allowNdr: !1,
    keyword: "video:",
    type: "media",
    help: "Add a video from YouTube or Vimeo.",
    expandedHelp: "To add a video, go to its page on YouTube or Vimeo and get the shareable link. Then, just paste that link right after `video:`.",
    hide: !1,
    modifiers: [...OE, ...DE, "hideOn:", "caption:", "url:", "mute:"]
  }
};
function nS(t) {
  return !!l0.includes(t);
}
const fY = ["border-color:", "border-thickness:", "corner-radius:", "padding-bottom:", "padding-left:", "padding-right:", "padding-top:", "padding:"], dY = ["delay:", "loop:", "effect:", "caption:"], IE = ["scroll", "tap", "scrollCards", "scrollContinuous"], YF = 1, Gx = ["desktop", "mobile"], hY = ["normal", "over-image"], pY = ["blur:", "hideOn:"], XF = ["backlink:", "url:", "toPage:", "mailto:"], gY = ["across:", "animate:", "down:", "align:", "anchor:", "animateStart:"], ba = {
  underline: "__",
  bold: "**",
  italic: "''",
  shadow: "§",
  strikeThrough: "~~"
}, Lr = {
  animate: ">>>",
  endAnimate: "<<<"
}, Od = {
  link: "{{",
  endLink: "}}"
}, mY = ["columns:", "decoration:", "line-height:", "shadow:", "weight:"], yY = ["mute:", "widescreen:"], vY = ["height:", "width:"], bY = ["background:", "color:", "font:", "opacity:", "size:"], NE = [...fY, ...dY, ...pY, ...XF, ...gY, ...vY, ...mY, ...bY, ...yY], Ya = {
  "backlink:": {
    keyword: "backlink:"
  },
  "border-thickness:": {
    keyword: "border-thickness:"
  },
  "toPage:": {
    keyword: "toPage:"
  },
  "mailto:": {
    keyword: "mailto:"
  },
  "url:": {
    keyword: "url:"
  }
};
function wY(t) {
  let e = "", n;
  return t.forEach((r, i) => {
    switch (r) {
      case "*:":
        n = "\\*:";
        break;
      case "**:":
        n = "\\*\\*:";
        break;
      default:
        n = r;
    }
    const o = `(${n})`;
    i === t.length - 1 ? e = e.concat(o) : e = e.concat(o, "|");
  }), e;
}
const SY = new RegExp(`^\\s*((${NE.join(")|(")}))(.*)$`), _Y = `${wY(l0)}|(${NE.join(")|(")})`, EY = new RegExp(
  // match indentation at start.
  `^(\\s\\s)?(${_Y})(.*)`,
  "i"
), kY = new RegExp(`^${Tu["read:"].keyword}(.*)$`), TY = new RegExp(`${Ym}(.*)`), xY = cn.line({
  attributes: {
    class: "qp-modifier"
  }
});
function Wx(t) {
  const e = new Is();
  for (const {
    from: n,
    to: r
  } of t.visibleRanges)
    for (let i = n; i <= r; ) {
      const o = t.state.doc.lineAt(i);
      SY.test(o.text) && e.add(o.from, o.from, xY), i = o.to + 1;
    }
  return e.finish();
}
const CY = No.fromClass(class {
  decorations;
  constructor(t) {
    this.decorations = Wx(t);
  }
  update(t) {
    (t.docChanged || t.viewportChanged) && (this.decorations = Wx(t.view));
  }
}, {
  decorations: (t) => t.decorations
});
function Qae() {
  return [CY];
}
const AY = cn.line({
  attributes: {
    class: "qp-read-text"
  }
});
function Yx(t) {
  const e = new Is();
  for (const {
    from: n,
    to: r
  } of t.visibleRanges)
    for (let i = n; i <= r; ) {
      const o = t.state.doc.lineAt(i);
      kY.test(o.text) && e.add(o.from, o.from, AY), i = o.to + 1;
    }
  return e.finish();
}
const RY = No.fromClass(class {
  decorations;
  constructor(t) {
    this.decorations = Yx(t);
  }
  update(t) {
    (t.docChanged || t.viewportChanged) && (this.decorations = Yx(t.view));
  }
}, {
  decorations: (t) => t.decorations
});
function Jae() {
  return [RY];
}
const OY = Ht.baseTheme({
  // "&light .cm-page-line": {
  //   color: "#c5c4c4",
  //   height: "4rem",
  //   lineHeight: "4",
  //   "background-color": colors.offWhite;,
  //   "background-image":
  //     "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23d4d4d4' fill-opacity='0.27' fill-rule='nonzero'%3E%3Cpath d='M29 58.58l7.38-7.39A30.95 30.95 0 0 1 29 37.84a30.95 30.95 0 0 1-7.38 13.36l7.37 7.38zm1.4 1.41l.01.01h-2.84l-7.37-7.38A30.95 30.95 0 0 1 6.84 60H0v-1.02a28.9 28.9 0 0 0 18.79-7.78L0 32.41v-4.84L18.78 8.79A28.9 28.9 0 0 0 0 1.02V0h6.84a30.95 30.95 0 0 1 13.35 7.38L27.57 0h2.84l7.39 7.38A30.95 30.95 0 0 1 51.16 0H60v27.58-.01V60h-8.84a30.95 30.95 0 0 1-13.37-7.4L30.4 60zM29 1.41l-7.4 7.38A30.95 30.95 0 0 1 29 22.16 30.95 30.95 0 0 1 36.38 8.8L29 1.4zM58 1A28.9 28.9 0 0 0 39.2 8.8L58 27.58V1.02zm-20.2 9.2A28.9 28.9 0 0 0 30.02 29h26.56L37.8 10.21zM30.02 31a28.9 28.9 0 0 0 7.77 18.79l18.79-18.79H30.02zm9.18 20.2A28.9 28.9 0 0 0 58 59V32.4L39.2 51.19zm-19-1.4a28.9 28.9 0 0 0 7.78-18.8H1.41l18.8 18.8zm7.78-20.8A28.9 28.9 0 0 0 20.2 10.2L1.41 29h26.57z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")",
  // },
  // "&dark .cm-page-line": { backgroundColor: "#b327a0" },
}), DY = cn.line({
  attributes: {
    class: "cm-end-grid-line"
  }
}), IY = cn.line({
  attributes: {
    class: "cm-page-line"
  }
}), NY = cn.line({
  attributes: {
    class: "cm-row-line"
  }
}), PY = cn.line({
  attributes: {
    class: "cm-split-page-line"
  }
}), $Y = cn.line({
  attributes: {
    class: "cm-sticky-menu-line"
  }
}), MY = cn.line({
  attributes: {
    class: "cm-placeholder-line"
  }
}), FY = No.fromClass(class {
  decorations;
  constructor(t) {
    this.decorations = Xx(t);
  }
  update(t) {
    (t.docChanged || t.viewportChanged) && (this.decorations = Xx(t.view));
  }
}, {
  decorations: (t) => t.decorations
});
function Xx(t) {
  const e = new Is();
  for (const {
    from: n,
    to: r
  } of t.visibleRanges)
    for (let i = n; i <= r; ) {
      const o = t.state.doc.lineAt(i);
      o.text === _t["==="].controlChar && e.add(o.from, o.from, IY), o.text === _t["---"].controlChar && e.add(o.from, o.from, NY), o.text === _t["-->"].controlChar && e.add(o.from, o.from, DY), o.text === _t["|"].controlChar && e.add(o.from, o.from, PY), o.text === _t["[]"].controlChar && e.add(o.from, o.from, MY), o.text === _t["^^^"].controlChar && e.add(o.from, o.from, $Y), i = o.to + 1;
    }
  return e.finish();
}
function Zae() {
  return [OY, [], FY];
}
function Kx(t) {
  const e = t.iterLines();
  let n = 1, r = 1;
  const i = [{
    line: t.line(1),
    pageIdx: n
  }];
  for (const o of e)
    o === _t["==="].controlChar && (n++, i.push({
      line: t.line(r),
      pageIdx: n,
      type: "page"
    })), o === _t["---"].controlChar && i.push({
      line: t.line(r),
      pageIdx: n,
      type: "row"
    }), r++;
  return i;
}
const KF = Ms.define({
  create(t) {
    return Kx(t.doc);
  },
  update(t, e) {
    return Kx(e.newDoc);
  }
});
class LY extends $o {
  constructor(e) {
    super(), this.pageIdx = e, this.elementClass = "qp-gutter-pageNumber";
  }
  pageIdx;
  toDOM() {
    const e = document.createElement("div"), n = document.createTextNode(this.pageIdx.toString());
    return e.appendChild(n);
  }
}
const rS = Ms.define({
  create() {
    return Jt.empty;
  },
  update(t, e) {
    const n = e.state.field(KF), r = new Is();
    return Array.isArray(n) && n.forEach(({
      line: i,
      pageIdx: o,
      type: s
    }) => {
      let a;
      s === "page" && (a = new LY(o)), a && r.add(i.from, i.from, a);
    }), r.finish();
  }
}), ele = [
  [rS, KF],
  RE({
    class: "cm-page-numbers-gutter-gutter",
    renderEmptyElements: !0,
    markers: (t) => t.state.field(rS)
  })
  // EditorView.baseTheme({
  //     ".cm-qp-pageNumber": {
  //         width: "1rem",
  //         cursor: "default",
  //         "text-align": "center",
  //         border: "1px solid #d5d5d5",
  //     },
  //     ".cm-qp-pageNumber .cm-activeLineGutter": {
  //         "background-color": "red",
  //     },
  // }),
], Qx = new class extends $o {
  toDOM() {
    return document.createTextNode("");
  }
  elementClass = "qp-active-line-gutter";
}(), BY = new class extends $o {
  toDOM() {
    return document.createTextNode("");
  }
  elementClass = "qp-row-marker-gutter";
}(), jY = new class extends $o {
  toDOM() {
    return document.createTextNode("");
  }
  elementClass = "qp-end-grid-marker-gutter";
}(), VY = new class extends $o {
  toDOM() {
    return document.createTextNode("");
  }
  elementClass = "qp-split-page-marker-gutter";
}(), tle = RE({
  lineMarker(t, {
    from: e
  }) {
    const r = t.state.doc.lineAt(t.state.selection.main.from).number, i = t.state.doc.lineAt(e).number;
    return t.state.doc.lineAt(e).text.trim() === _t["---"].controlChar ? BY : t.state.doc.lineAt(e).text.trim() === _t["-->"].controlChar ? jY : t.state.doc.lineAt(e).text.trim() === _t["|"].controlChar ? VY : i == r ? Qx : null;
  },
  renderEmptyElements: !0,
  initialSpacer: () => Qx
}), UY = /* @__PURE__ */ fr.define(), qY = Ms.define({
  create: () => [],
  update(t, e) {
    const n = e.effects.find((i) => i.is(UY));
    if (n)
      return n.value;
    let r = t;
    if (e.changes.length) {
      let i = [];
      for (let o of t) {
        let s = e.changes.mapPos(o.from, -1), a = e.changes.mapPos(o.to, 1);
        s < a && i.push({
          ...o,
          from: s,
          to: a
        });
      }
      r = i;
    }
    return r;
  }
});
class yv extends $o {
  pageIdx;
  lintSeverity;
  constructor(e, n) {
    super(), this.pageIdx = e, this.lintSeverity = n;
  }
  toDOM() {
    const e = document.createElement("div");
    if (this.pageIdx !== null)
      e.className = "qp-gutter-pageNumber", e.textContent = this.pageIdx.toString();
    else if (this.lintSeverity) {
      e.className = "qp-lint-marker-container";
      const n = document.createElement("div");
      n.className = `cm-lint-marker cm-lint-marker-${this.lintSeverity}`, e.appendChild(n);
    }
    return e;
  }
}
RE({
  class: "cm-page-numbers-gutter-gutter",
  markers(t) {
    const e = t.state.field(rS), n = t.state.field(qY), r = new Is();
    e.between(0, t.state.doc.length, (i, o, s) => {
      const a = s;
      a.pageIdx && r.add(i, o, new yv(a.pageIdx, null));
    });
    for (const i of n)
      if (i.from !== -1) {
        const o = t.state.doc.lineAt(i.from), s = i.severity === "hint" ? "info" : i.severity;
        r.add(o.from, o.from, new yv(null, s));
      }
    return r.finish();
  },
  initialSpacer: () => new yv(null, null)
});
const zY = {
  [Lr.animate]: cn.mark({
    class: "cm-text-modifier-animate"
  }),
  [Lr.endAnimate]: cn.mark({
    class: "cm-text-modifier-end-animate"
  })
};
function HY(t, e, n) {
  const r = [];
  let i = e.indexOf(Lr[t]);
  for (; i !== -1; )
    r.push(i), i = e.indexOf(Lr[t], i + 1);
  return r.map((o) => o + n);
}
const nle = No.fromClass(class {
  decorations;
  constructor() {
    this.decorations = cn.none;
  }
  update(t) {
    const e = [];
    for (const n of t.view.viewportLineBlocks) {
      const r = t.state.doc.lineAt(n.from), i = {}, o = Object.keys(Lr);
      for (const a of o)
        i[a] = HY(a, r.text, r.from);
      const s = Object.keys(i);
      for (const a of s) {
        const l = i[a];
        if (l?.length)
          for (const u of l) {
            const c = zY[Lr[a]], f = u + Lr[a].length;
            f > u && e.push(c.range(u, f));
          }
      }
      this.decorations = cn.set(e, !0);
    }
  }
}, {
  decorations: (t) => t.decorations
}), Uo = {
  backgroundColor: Ot.brand.white,
  font: "Avantt-Regular,sans-serif"
}, Jx = {
  "background-color": Ot.lightGrey,
  "padding-block-start": "1rem",
  "padding-block-end": "1rem",
  "border-block-start": "1rem solid ",
  "border-block-end": "1rem solid",
  "border-block-start-color": Uo.backgroundColor,
  "border-block-end-color": Uo.backgroundColor
}, rle = Ht.theme({
  ".cm-activeLine.cm-page-line": Jx,
  ".cm-activeLine.cm-line": {
    background: "none"
  },
  ".cm-activeLineGutter": {
    background: "none"
  },
  ".cm-column-line": {
    color: "#C5C4C4",
    fontSize: ".8rem"
  },
  ".cm-content": {
    "font-family": Uo.font,
    "font-weight": 400,
    "font-size": "16px",
    "background-color": Uo.backgroundColor
  },
  ".cm-control-panel-nav": {
    display: "flex",
    "align-items": "center"
  },
  ".cm-end-grid-line": {
    color: "#C5C4C4"
  },
  "&.cm-focused": {
    "outline-style": "none"
  },
  ".cm-gutters": {
    width: ks.editor.landscape.gutter,
    "background-color": Uo.backgroundColor
  },
  ".cm-line": {
    // "padding-inline-start": "2rem",
    // "padding-inline-end": "2rem",
  },
  ".cm-row-line": {
    color: "#C5C4C4"
  },
  ".cm-navigation-panel": {
    display: "flex",
    "align-items": "center",
    "justify-content": "center"
  },
  ".cm-page-line": Jx,
  ".cm-page-numbers-gutter-gutter": {
    width: `${ks.editor.landscape.gutter}`
  },
  ".cm-placeholder-line": {
    color: "#C5C4C4",
    "letter-spacing": ".3rem"
  },
  ".cm-scroller": {
    height: ks.editor.landscape.height,
    overflow: "auto"
  },
  ".cm-split-page-line": {
    color: "#C5C4C4"
  },
  ".cm-sticky-menu-line": {
    color: Ot.alabaster.magenta
  },
  ".cm-panel-lint": {
    backgroundColor: Ot.lightGrey,
    color: Ot.tufte.black,
    borderTop: `1px solid ${Ot.editorBorderGrey}`
  },
  // Tooltip container for lint diagnostics (popover)
  // Keep outer container neutral; allow inner UL to render the card/shadow
  ".cm-tooltip:has(.cm-tooltip-lint)": {
    overflow: "visible",
    padding: 0,
    boxShadow: "none",
    border: "none",
    backgroundColor: "transparent"
  },
  // Fallback: also style the inner lint list in case container styles are overridden
  ".cm-tooltip .cm-tooltip-lint.cm-tooltip-section": {
    backgroundColor: Uo.backgroundColor,
    borderRadius: "10px",
    border: `1px solid ${Ot.editorBorderGrey}`,
    boxShadow: "0 2px 6px rgba(0,0,0,0.12), 0 12px 24px rgba(0,0,0,0.12)",
    position: "relative",
    listStyle: "none",
    margin: "6px",
    padding: "6px 0",
    display: "block",
    maxWidth: "min(520px, 92vw)"
  },
  ".cm-tooltip-hover": {
    backgroundColor: "transparent !important",
    border: "none !important"
  },
  ".cm-tooltip-lint .cm-diagnostic": {
    fontFamily: Uo.font,
    fontSize: ".8rem",
    maxWidth: "480px",
    padding: "10px 14px",
    display: "flex",
    alignItems: "flex-start",
    gap: "8px"
  },
  ".cm-tooltip-lint .cm-diagnostic + .cm-diagnostic": {
    borderTop: `1px solid ${Ot.editorBorderGrey}`
  },
  ".cm-tooltip-lint .cm-diagnostic-error": {
    backgroundColor: Uo.backgroundColor,
    color: Ot.tufte.black
  },
  ".cm-tooltip-lint .cm-diagnostic-warning": {
    backgroundColor: Uo.backgroundColor,
    color: Ot.tufte.black
  },
  ".cm-tooltip-lint .cm-diagnostic-info": {
    backgroundColor: Uo.backgroundColor,
    color: Ot.tufte.black
  },
  ".cm-tooltip-lint .cm-diagnosticText": {
    lineHeight: 1.3
  },
  ".cm-tooltip-lint .cm-diagnosticSource": {
    opacity: 0.7,
    fontSize: "0.75rem",
    marginTop: "2px"
  },
  // Group and style action buttons (e.g., "Remove")
  ".cm-tooltip-lint .cm-diagnosticActions": {
    marginTop: "8px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "6px"
  },
  ".cm-tooltip-lint .cm-diagnosticAction": {
    fontSize: ".75rem",
    lineHeight: 1.2,
    padding: "4px 8px",
    borderRadius: "6px",
    border: `1px solid ${Ot.editorBorderGrey}`,
    backgroundColor: Ot.lightGrey,
    color: Ot.tufte.black,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    whiteSpace: "nowrap",
    marginLeft: "6px"
  },
  ".cm-tooltip-lint .cm-diagnosticAction:first-of-type": {
    marginLeft: "auto"
  },
  // Highlight entire line when it contains a lint error range
  ".cm-line:has(.cm-lintRange.cm-lintRange-error)": {
    backgroundColor: "rgba(255, 0, 0, 0.08)"
  },
  ".cm-activeLine.cm-line:has(.cm-lintRange.cm-lintRange-error)": {
    backgroundColor: "rgba(255, 0, 0, 0.08)"
  },
  // (No arrow overrides for lint; card styling is on the inner UL only)
  ".cm-panel-lint ul": {
    padding: "0 10px",
    listStyle: "none"
  },
  ".cm-panel-lint .cm-diagnostic": {
    padding: "5px 0",
    borderBottom: `1px solid ${Ot.editorBorderGrey}`
  },
  ".qp-lint-marker-container": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%"
  },
  ".cm-lint-marker": {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    cursor: "pointer"
  },
  ".cm-lint-marker-error": {
    backgroundColor: Ot.alabaster.red
  },
  ".cm-lint-marker-warning": {
    backgroundColor: Ot.brand.yellow
  },
  ".cm-text-modifier-animate": {
    color: Ot.alabaster.active,
    "font-size": "0.8rem"
  },
  ".cm-text-modifier-end-animate": {
    color: Ot.alabaster.active
  },
  ".cm-text-modifier-bold": {
    "font-weight": "bold"
  },
  ".cm-text-modifier-italic": {
    "font-style": "italic"
  },
  ".cm-text-modifier-underline": {
    "text-decoration": "underline",
    "text-decoration-thickness": "2px"
  },
  ".cm-control-panel": {
    display: "flex",
    "align-items": "center",
    "justify-content": "center"
  },
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: Uo.font,
      fontSize: ".8rem",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "13em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li > .image-preview": {
        "vertical-align": "middle",
        "background-position": "center"
      },
      "& > li > .color-block": {
        "vertical-align": "middle"
      },
      "& > li, & > completion-section": {
        padding: "3px 3px",
        lineHeight: 1
      },
      textOverflow: "ellipsis",
      cursor: "pointer"
    },
    "& > li": {
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  // non stantard classes
  ".qp-row-marker-gutter": {
    background: Ot.brand.yellow,
    width: "1px",
    "align-self": "end"
  },
  ".qp-end-grid-marker-gutter": {
    background: Ot.brand.yellow,
    width: "1px",
    "align-self": "end"
  },
  ".qp-split-page-marker-gutter": {
    background: Ot.alabaster.magenta,
    width: "1px",
    "align-self": "end"
  },
  ".qp-active-line-gutter": {
    background: Ot.positionMarkerBlue,
    width: "1px",
    "align-self": "end"
  },
  ".qp-gutter-pageNumber": {
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
    height: "100%"
  },
  ".qp-keyword-color": {
    "font-size": "0.8rem",
    "font-style": "italic",
    color: Ot.alabaster.blue,
    "margin-inline-end": "0.24rem"
  },
  ".qp-keyword-no-text-color": {
    "font-size": "0.8rem",
    "font-style": "italic",
    color: Ot.alabaster.blue
  },
  ".qp-modifier": {
    // "padding-block-start": "0rem !important", 
    // "margin-block-start": "-0.75rem", 
    "font-size": "0.8rem",
    "font-style": "italic",
    color: Ot.alabaster.blue
  },
  ".qp-modifier-color": {
    "margin-inline-end": "0.24rem",
    color: Ot.alabaster.red
  },
  ".qp-read-text": {
    "font-style": "italic",
    "color:": Ot.tufte.black
  },
  ".qp-stack-modifier-color": {
    "font-size": "0.8rem",
    color: Ot.alabaster.active
  }
}), QF = 1024;
let GY = 0;
class vv {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
class en {
  /**
  Create a new node prop type.
  */
  constructor(e = {}) {
    this.id = GY++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(e) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = $i.match(e)), (n) => {
      let r = e(n);
      return r === void 0 ? null : [this, r];
    };
  }
}
en.closedBy = new en({ deserialize: (t) => t.split(" ") });
en.openedBy = new en({ deserialize: (t) => t.split(" ") });
en.group = new en({ deserialize: (t) => t.split(" ") });
en.isolate = new en({ deserialize: (t) => {
  if (t && t != "rtl" && t != "ltr" && t != "auto")
    throw new RangeError("Invalid value for isolate: " + t);
  return t || "auto";
} });
en.contextHash = new en({ perNode: !0 });
en.lookAhead = new en({ perNode: !0 });
en.mounted = new en({ perNode: !0 });
class ny {
  constructor(e, n, r) {
    this.tree = e, this.overlay = n, this.parser = r;
  }
  /**
  @internal
  */
  static get(e) {
    return e && e.props && e.props[en.mounted.id];
  }
}
const WY = /* @__PURE__ */ Object.create(null);
class $i {
  /**
  @internal
  */
  constructor(e, n, r, i = 0) {
    this.name = e, this.props = n, this.id = r, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(e) {
    let n = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : WY, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), i = new $i(e.name || "", n, e.id, r);
    if (e.props) {
      for (let o of e.props)
        if (Array.isArray(o) || (o = o(i)), o) {
          if (o[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          n[o[0].id] = o[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(e) {
    return this.props[e.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      let n = this.prop(en.group);
      return n ? n.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in e)
      for (let i of r.split(" "))
        n[i] = e[r];
    return (r) => {
      for (let i = r.prop(en.group), o = -1; o < (i ? i.length : 0); o++) {
        let s = n[o < 0 ? r.name : i[o]];
        if (s)
          return s;
      }
    };
  }
}
$i.none = new $i(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class PE {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(e) {
    this.types = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].id != n)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...e) {
    let n = [];
    for (let r of this.types) {
      let i = null;
      for (let o of e) {
        let s = o(r);
        s && (i || (i = Object.assign({}, r.props)), i[s[0].id] = s[1]);
      }
      n.push(i ? new $i(r.name, i, r.id, r.flags) : r);
    }
    return new PE(n);
  }
}
const tg = /* @__PURE__ */ new WeakMap(), Zx = /* @__PURE__ */ new WeakMap();
var Nr;
(function(t) {
  t[t.ExcludeBuffers = 1] = "ExcludeBuffers", t[t.IncludeAnonymous = 2] = "IncludeAnonymous", t[t.IgnoreMounts = 4] = "IgnoreMounts", t[t.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Nr || (Nr = {}));
class dr {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(e, n, r, i, o) {
    if (this.type = e, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [s, a] of o)
        this.props[typeof s == "number" ? s : s.id] = a;
    }
  }
  /**
  @internal
  */
  toString() {
    let e = ny.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    let n = "";
    for (let r of this.children) {
      let i = r.toString();
      i && (n && (n += ","), n += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(e = 0) {
    return new oS(this.topNode, e);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(e, n = 0, r = 0) {
    let i = tg.get(this) || this.topNode, o = new oS(i);
    return o.moveTo(e, n), tg.set(this, o._tree), o;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new Ro(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(e, n = 0) {
    let r = wh(tg.get(this) || this.topNode, e, n, !1);
    return tg.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(e, n = 0) {
    let r = wh(Zx.get(this) || this.topNode, e, n, !0);
    return Zx.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(e, n = 0) {
    return KY(this, e, n);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(e) {
    let { enter: n, leave: r, from: i = 0, to: o = this.length } = e, s = e.mode || 0, a = (s & Nr.IncludeAnonymous) > 0;
    for (let l = this.cursor(s | Nr.IncludeAnonymous); ; ) {
      let u = !1;
      if (l.from <= o && l.to >= i && (!a && l.type.isAnonymous || n(l) !== !1)) {
        if (l.firstChild())
          continue;
        u = !0;
      }
      for (; u && r && (a || !l.type.isAnonymous) && r(l), !l.nextSibling(); ) {
        if (!l.parent())
          return;
        u = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let e = [];
    if (this.props)
      for (let n in this.props)
        e.push([+n, this.props[n]]);
    return e;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(e = {}) {
    return this.children.length <= 8 ? this : FE($i.none, this.children, this.positions, 0, this.children.length, 0, this.length, (n, r, i) => new dr(this.type, n, r, i, this.propValues), e.makeTree || ((n, r, i) => new dr($i.none, n, r, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(e) {
    return QY(e);
  }
}
dr.empty = new dr($i.none, [], [], 0);
class $E {
  constructor(e, n) {
    this.buffer = e, this.index = n;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new $E(this.buffer, this.index);
  }
}
class dl {
  /**
  Create a tree buffer.
  */
  constructor(e, n, r) {
    this.buffer = e, this.length = n, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return $i.none;
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    for (let n = 0; n < this.buffer.length; )
      e.push(this.childString(n)), n = this.buffer[n + 3];
    return e.join(",");
  }
  /**
  @internal
  */
  childString(e) {
    let n = this.buffer[e], r = this.buffer[e + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), e += 4, r == e)
      return o;
    let s = [];
    for (; e < r; )
      s.push(this.childString(e)), e = this.buffer[e + 3];
    return o + "(" + s.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(e, n, r, i, o) {
    let { buffer: s } = this, a = -1;
    for (let l = e; l != n && !(JF(o, i, s[l + 1], s[l + 2]) && (a = l, r > 0)); l = s[l + 3])
      ;
    return a;
  }
  /**
  @internal
  */
  slice(e, n, r) {
    let i = this.buffer, o = new Uint16Array(n - e), s = 0;
    for (let a = e, l = 0; a < n; ) {
      o[l++] = i[a++], o[l++] = i[a++] - r;
      let u = o[l++] = i[a++] - r;
      o[l++] = i[a++] - e, s = Math.max(s, u);
    }
    return new dl(o, s, this.set);
  }
}
function JF(t, e, n, r) {
  switch (t) {
    case -2:
      return n < e;
    case -1:
      return r >= e && n < e;
    case 0:
      return n < e && r > e;
    case 1:
      return n <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function wh(t, e, n, r) {
  for (var i; t.from == t.to || (n < 1 ? t.from >= e : t.from > e) || (n > -1 ? t.to <= e : t.to < e); ) {
    let s = !r && t instanceof Ro && t.index < 0 ? null : t.parent;
    if (!s)
      return t;
    t = s;
  }
  let o = r ? 0 : Nr.IgnoreOverlays;
  if (r)
    for (let s = t, a = s.parent; a; s = a, a = s.parent)
      s instanceof Ro && s.index < 0 && ((i = a.enter(e, n, o)) === null || i === void 0 ? void 0 : i.from) != s.from && (t = a);
  for (; ; ) {
    let s = t.enter(e, n, o);
    if (!s)
      return t;
    t = s;
  }
}
class ZF {
  cursor(e = 0) {
    return new oS(this, e);
  }
  getChild(e, n = null, r = null) {
    let i = eC(this, e, n, r);
    return i.length ? i[0] : null;
  }
  getChildren(e, n = null, r = null) {
    return eC(this, e, n, r);
  }
  resolve(e, n = 0) {
    return wh(this, e, n, !1);
  }
  resolveInner(e, n = 0) {
    return wh(this, e, n, !0);
  }
  matchContext(e) {
    return iS(this.parent, e);
  }
  enterUnfinishedNodesBefore(e) {
    let n = this.childBefore(e), r = this;
    for (; n; ) {
      let i = n.lastChild;
      if (!i || i.to != n.to)
        break;
      i.type.isError && i.from == i.to ? (r = n, n = i.prevSibling) : n = i;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class Ro extends ZF {
  constructor(e, n, r, i) {
    super(), this._tree = e, this.from = n, this.index = r, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, n, r, i, o = 0) {
    for (let s = this; ; ) {
      for (let { children: a, positions: l } = s._tree, u = n > 0 ? a.length : -1; e != u; e += n) {
        let c = a[e], f = l[e] + s.from;
        if (JF(i, r, f, f + c.length)) {
          if (c instanceof dl) {
            if (o & Nr.ExcludeBuffers)
              continue;
            let d = c.findChild(0, c.buffer.length, n, r - f, i);
            if (d > -1)
              return new Xa(new YY(s, c, e, f), null, d);
          } else if (o & Nr.IncludeAnonymous || !c.type.isAnonymous || ME(c)) {
            let d;
            if (!(o & Nr.IgnoreMounts) && (d = ny.get(c)) && !d.overlay)
              return new Ro(d.tree, f, e, s);
            let h = new Ro(c, f, e, s);
            return o & Nr.IncludeAnonymous || !h.type.isAnonymous ? h : h.nextChild(n < 0 ? c.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (o & Nr.IncludeAnonymous || !s.type.isAnonymous || (s.index >= 0 ? e = s.index + n : e = n < 0 ? -1 : s._parent._tree.children.length, s = s._parent, !s))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.nextChild(
      0,
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    let i;
    if (!(r & Nr.IgnoreOverlays) && (i = ny.get(this._tree)) && i.overlay) {
      let o = e - this.from;
      for (let { from: s, to: a } of i.overlay)
        if ((n > 0 ? s <= o : s < o) && (n < 0 ? a >= o : a > o))
          return new Ro(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e, n, r);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent; )
      e = e._parent;
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function eC(t, e, n, r) {
  let i = t.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (let s = !1; !s; )
      if (s = i.type.is(n), !i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(e) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function iS(t, e, n = e.length - 1) {
  for (let r = t; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (e[n] && e[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
class YY {
  constructor(e, n, r, i) {
    this.parent = e, this.buffer = n, this.index = r, this.start = i;
  }
}
class Xa extends ZF {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, n, r) {
    super(), this.context = e, this._parent = n, this.index = r, this.type = e.buffer.set.types[e.buffer.buffer[r]];
  }
  child(e, n, r) {
    let { buffer: i } = this.context, o = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.context.start, r);
    return o < 0 ? null : new Xa(this.context, this, o);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.child(
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.child(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    if (r & Nr.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, e - this.context.start, n);
    return o < 0 ? null : new Xa(this.context, this, o);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + e,
      e,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: e } = this.context, n = e.buffer[this.index + 3];
    return n < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new Xa(this.context, this._parent, n) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e } = this.context, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new Xa(this.context, this._parent, e.findChild(
      n,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], n = [], { buffer: r } = this.context, i = this.index + 4, o = r.buffer[this.index + 3];
    if (o > i) {
      let s = r.buffer[this.index + 1];
      e.push(r.slice(i, o, s)), n.push(0);
    }
    return new dr(this.type, e, n, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function eL(t) {
  if (!t.length)
    return null;
  let e = 0, n = t[0];
  for (let o = 1; o < t.length; o++) {
    let s = t[o];
    (s.from > n.from || s.to < n.to) && (n = s, e = o);
  }
  let r = n instanceof Ro && n.index < 0 ? null : n.parent, i = t.slice();
  return r ? i[e] = r : i.splice(e, 1), new XY(i, n);
}
class XY {
  constructor(e, n) {
    this.heads = e, this.node = n;
  }
  get next() {
    return eL(this.heads);
  }
}
function KY(t, e, n) {
  let r = t.resolveInner(e, n), i = null;
  for (let o = r instanceof Ro ? r : r.context.parent; o; o = o.parent)
    if (o.index < 0) {
      let s = o.parent;
      (i || (i = [r])).push(s.resolve(e, n)), o = s;
    } else {
      let s = ny.get(o.tree);
      if (s && s.overlay && s.overlay[0].from <= e && s.overlay[s.overlay.length - 1].to >= e) {
        let a = new Ro(s.tree, s.overlay[0].from + o.from, -1, o);
        (i || (i = [r])).push(wh(a, e, n, !1));
      }
    }
  return i ? eL(i) : r;
}
class oS {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(e, n = 0) {
    if (this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof Ro)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let r = e._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, n) {
    this.index = e;
    let { start: r, buffer: i } = this.buffer;
    return this.type = n || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
  }
  /**
  @internal
  */
  yield(e) {
    return e ? e instanceof Ro ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(e, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, n, r, this.mode));
    let { buffer: i } = this.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.buffer.start, r);
    return o < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(o));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(e) {
    return this.enterChild(
      1,
      e,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(e) {
    return this.enterChild(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(e, n, r = this.mode) {
    return this.buffer ? r & Nr.ExcludeBuffers ? !1 : this.enterChild(1, e, n) : this.yield(this._tree.enter(e, n, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Nr.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e = this.mode & Nr.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  /**
  @internal
  */
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    let { buffer: n } = this.buffer, r = this.stack.length - 1;
    if (e < 0) {
      let i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = n.buffer[this.index + 3];
      if (i < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(i);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let n, r, { buffer: i } = this;
    if (i) {
      if (e > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      ({ index: n, parent: r } = i);
    } else
      ({ index: n, _parent: r } = this._tree);
    for (; r; { index: n, _parent: r } = r)
      if (n > -1)
        for (let o = n + e, s = e < 0 ? -1 : r._tree.children.length; o != s; o += e) {
          let a = r._tree.children[o];
          if (this.mode & Nr.IncludeAnonymous || a instanceof dl || !a.type.isAnonymous || ME(a))
            return !1;
        }
    return !0;
  }
  move(e, n) {
    if (n && this.enterChild(
      e,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(e = !0) {
    return this.move(1, e);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(e = !0) {
    return this.move(-1, e);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(e, n = 0) {
    for (; (this.from == this.to || (n < 1 ? this.from >= e : this.from > e) || (n > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, n); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let e = this.bufferNode, n = null, r = 0;
    if (e && e.context == this.buffer)
      e: for (let i = this.index, o = this.stack.length; o >= 0; ) {
        for (let s = e; s; s = s._parent)
          if (s.index == i) {
            if (i == this.index)
              return s;
            n = s, r = o + 1;
            break e;
          }
        i = this.stack[--o];
      }
    for (let i = r; i < this.stack.length; i++)
      n = new Xa(this.buffer, n, this.stack[i]);
    return this.bufferNode = new Xa(this.buffer, n, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(e, n) {
    for (let r = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; ; ) {
        if (i && n && n(this), i = this.type.isAnonymous, !r)
          return;
        if (this.nextSibling())
          break;
        this.parent(), r--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(e) {
    if (!this.buffer)
      return iS(this.node.parent, e);
    let { buffer: n } = this.buffer, { types: r } = n.set;
    for (let i = e.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return iS(this._tree, e, i);
      let s = r[n.buffer[this.stack[o]]];
      if (!s.isAnonymous) {
        if (e[i] && e[i] != s.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function ME(t) {
  return t.children.some((e) => e instanceof dl || !e.type.isAnonymous || ME(e));
}
function QY(t) {
  var e;
  let { buffer: n, nodeSet: r, maxBufferLength: i = QF, reused: o = [], minRepeatType: s = r.types.length } = t, a = Array.isArray(n) ? new $E(n, n.length) : n, l = r.types, u = 0, c = 0;
  function f(y, w, E, x, k, C) {
    let { id: M, start: F, end: U, size: B } = a, N = c, q = u;
    for (; B < 0; )
      if (a.next(), B == -1) {
        let W = o[M];
        E.push(W), x.push(F - y);
        return;
      } else if (B == -3) {
        u = M;
        return;
      } else if (B == -4) {
        c = M;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${B}`);
    let Q = l[M], ne, X, O = F - y;
    if (U - F <= i && (X = m(a.pos - w, k))) {
      let W = new Uint16Array(X.size - X.skip), T = a.pos - X.size, $ = W.length;
      for (; a.pos > T; )
        $ = v(X.start, W, $);
      ne = new dl(W, U - X.start, r), O = X.start - y;
    } else {
      let W = a.pos - B;
      a.next();
      let T = [], $ = [], P = M >= s ? M : -1, H = 0, Z = U;
      for (; a.pos > W; )
        P >= 0 && a.id == P && a.size >= 0 ? (a.end <= Z - i && (p(T, $, F, H, a.end, Z, P, N, q), H = T.length, Z = a.end), a.next()) : C > 2500 ? d(F, W, T, $) : f(F, W, T, $, P, C + 1);
      if (P >= 0 && H > 0 && H < T.length && p(T, $, F, H, F, Z, P, N, q), T.reverse(), $.reverse(), P > -1 && H > 0) {
        let le = h(Q, q);
        ne = FE(Q, T, $, 0, T.length, 0, U - F, le, le);
      } else
        ne = g(Q, T, $, U - F, N - U, q);
    }
    E.push(ne), x.push(O);
  }
  function d(y, w, E, x) {
    let k = [], C = 0, M = -1;
    for (; a.pos > w; ) {
      let { id: F, start: U, end: B, size: N } = a;
      if (N > 4)
        a.next();
      else {
        if (M > -1 && U < M)
          break;
        M < 0 && (M = B - i), k.push(F, U, B), C++, a.next();
      }
    }
    if (C) {
      let F = new Uint16Array(C * 4), U = k[k.length - 2];
      for (let B = k.length - 3, N = 0; B >= 0; B -= 3)
        F[N++] = k[B], F[N++] = k[B + 1] - U, F[N++] = k[B + 2] - U, F[N++] = N;
      E.push(new dl(F, k[2] - U, r)), x.push(U - y);
    }
  }
  function h(y, w) {
    return (E, x, k) => {
      let C = 0, M = E.length - 1, F, U;
      if (M >= 0 && (F = E[M]) instanceof dr) {
        if (!M && F.type == y && F.length == k)
          return F;
        (U = F.prop(en.lookAhead)) && (C = x[M] + F.length + U);
      }
      return g(y, E, x, k, C, w);
    };
  }
  function p(y, w, E, x, k, C, M, F, U) {
    let B = [], N = [];
    for (; y.length > x; )
      B.push(y.pop()), N.push(w.pop() + E - k);
    y.push(g(r.types[M], B, N, C - k, F - C, U)), w.push(k - E);
  }
  function g(y, w, E, x, k, C, M) {
    if (C) {
      let F = [en.contextHash, C];
      M = M ? [F].concat(M) : [F];
    }
    if (k > 25) {
      let F = [en.lookAhead, k];
      M = M ? [F].concat(M) : [F];
    }
    return new dr(y, w, E, x, M);
  }
  function m(y, w) {
    let E = a.fork(), x = 0, k = 0, C = 0, M = E.end - i, F = { size: 0, start: 0, skip: 0 };
    e: for (let U = E.pos - y; E.pos > U; ) {
      let B = E.size;
      if (E.id == w && B >= 0) {
        F.size = x, F.start = k, F.skip = C, C += 4, x += 4, E.next();
        continue;
      }
      let N = E.pos - B;
      if (B < 0 || N < U || E.start < M)
        break;
      let q = E.id >= s ? 4 : 0, Q = E.start;
      for (E.next(); E.pos > N; ) {
        if (E.size < 0)
          if (E.size == -3)
            q += 4;
          else
            break e;
        else E.id >= s && (q += 4);
        E.next();
      }
      k = Q, x += B, C += q;
    }
    return (w < 0 || x == y) && (F.size = x, F.start = k, F.skip = C), F.size > 4 ? F : void 0;
  }
  function v(y, w, E) {
    let { id: x, start: k, end: C, size: M } = a;
    if (a.next(), M >= 0 && x < s) {
      let F = E;
      if (M > 4) {
        let U = a.pos - (M - 4);
        for (; a.pos > U; )
          E = v(y, w, E);
      }
      w[--E] = F, w[--E] = C - y, w[--E] = k - y, w[--E] = x;
    } else M == -3 ? u = x : M == -4 && (c = x);
    return E;
  }
  let S = [], _ = [];
  for (; a.pos > 0; )
    f(t.start || 0, t.bufferStart || 0, S, _, -1, 0);
  let b = (e = t.length) !== null && e !== void 0 ? e : S.length ? _[0] + S[0].length : 0;
  return new dr(l[t.topID], S.reverse(), _.reverse(), b);
}
const tC = /* @__PURE__ */ new WeakMap();
function am(t, e) {
  if (!t.isAnonymous || e instanceof dl || e.type != t)
    return 1;
  let n = tC.get(e);
  if (n == null) {
    n = 1;
    for (let r of e.children) {
      if (r.type != t || !(r instanceof dr)) {
        n = 1;
        break;
      }
      n += am(t, r);
    }
    tC.set(e, n);
  }
  return n;
}
function FE(t, e, n, r, i, o, s, a, l) {
  let u = 0;
  for (let p = r; p < i; p++)
    u += am(t, e[p]);
  let c = Math.ceil(
    u * 1.5 / 8
    /* Balance.BranchFactor */
  ), f = [], d = [];
  function h(p, g, m, v, S) {
    for (let _ = m; _ < v; ) {
      let b = _, y = g[_], w = am(t, p[_]);
      for (_++; _ < v; _++) {
        let E = am(t, p[_]);
        if (w + E >= c)
          break;
        w += E;
      }
      if (_ == b + 1) {
        if (w > c) {
          let E = p[b];
          h(E.children, E.positions, 0, E.children.length, g[b] + S);
          continue;
        }
        f.push(p[b]);
      } else {
        let E = g[_ - 1] + p[_ - 1].length - y;
        f.push(FE(t, p, g, b, _, y, E, null, l));
      }
      d.push(y + S - o);
    }
  }
  return h(e, n, r, i, 0), (a || l)(f, d, s);
}
class fu {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(e, n, r, i, o = !1, s = !1) {
    this.from = e, this.to = n, this.tree = r, this.offset = i, this.open = (o ? 1 : 0) | (s ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(e, n = [], r = !1) {
    let i = [new fu(0, e.length, e, 0, !1, r)];
    for (let o of n)
      o.to > e.length && i.push(o);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(e, n, r = 128) {
    if (!n.length)
      return e;
    let i = [], o = 1, s = e.length ? e[0] : null;
    for (let a = 0, l = 0, u = 0; ; a++) {
      let c = a < n.length ? n[a] : null, f = c ? c.fromA : 1e9;
      if (f - l >= r)
        for (; s && s.from < f; ) {
          let d = s;
          if (l >= d.from || f <= d.to || u) {
            let h = Math.max(d.from, l) - u, p = Math.min(d.to, f) - u;
            d = h >= p ? null : new fu(h, p, d.tree, d.offset + u, a > 0, !!c);
          }
          if (d && i.push(d), s.to > f)
            break;
          s = o < e.length ? e[o++] : null;
        }
      if (!c)
        break;
      l = c.toA, u = c.toA - c.toB;
    }
    return i;
  }
}
class tL {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(e, n, r) {
    return typeof e == "string" && (e = new JY(e)), r = r ? r.length ? r.map((i) => new vv(i.from, i.to)) : [new vv(0, 0)] : [new vv(0, e.length)], this.createParse(e, n || [], r);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(e, n, r) {
    let i = this.startParse(e, n, r);
    for (; ; ) {
      let o = i.advance();
      if (o)
        return o;
    }
  }
}
class JY {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, n) {
    return this.string.slice(e, n);
  }
}
new en({ perNode: !0 });
let ZY = 0;
class bo {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    this.name = e, this.set = n, this.base = r, this.modified = i, this.id = ZY++;
  }
  toString() {
    let { name: e } = this;
    for (let n of this.modified)
      n.name && (e = `${n.name}(${e})`);
    return e;
  }
  static define(e, n) {
    let r = typeof e == "string" ? e : "?";
    if (e instanceof bo && (n = e), n?.base)
      throw new Error("Can not derive from a modified tag");
    let i = new bo(r, [], null, []);
    if (i.set.push(i), n)
      for (let o of n.set)
        i.set.push(o);
    return i;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier(e) {
    let n = new ry(e);
    return (r) => r.modified.indexOf(n) > -1 ? r : ry.get(r.base || r, r.modified.concat(n).sort((i, o) => i.id - o.id));
  }
}
let eX = 0;
class ry {
  constructor(e) {
    this.name = e, this.instances = [], this.id = eX++;
  }
  static get(e, n) {
    if (!n.length)
      return e;
    let r = n[0].instances.find((a) => a.base == e && tX(n, a.modified));
    if (r)
      return r;
    let i = [], o = new bo(e.name, i, e, n);
    for (let a of n)
      a.instances.push(o);
    let s = nX(n);
    for (let a of e.set)
      if (!a.modified.length)
        for (let l of s)
          i.push(ry.get(a, l));
    return o;
  }
}
function tX(t, e) {
  return t.length == e.length && t.every((n, r) => n == e[r]);
}
function nX(t) {
  let e = [[]];
  for (let n = 0; n < t.length; n++)
    for (let r = 0, i = e.length; r < i; r++)
      e.push(e[r].concat(t[n]));
  return e.sort((n, r) => r.length - n.length);
}
function nL(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    Array.isArray(r) || (r = [r]);
    for (let i of n.split(" "))
      if (i) {
        let o = [], s = 2, a = i;
        for (let f = 0; ; ) {
          if (a == "..." && f > 0 && f + 3 == i.length) {
            s = 1;
            break;
          }
          let d = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!d)
            throw new RangeError("Invalid path: " + i);
          if (o.push(d[0] == "*" ? "" : d[0][0] == '"' ? JSON.parse(d[0]) : d[0]), f += d[0].length, f == i.length)
            break;
          let h = i[f++];
          if (f == i.length && h == "!") {
            s = 0;
            break;
          }
          if (h != "/")
            throw new RangeError("Invalid path: " + i);
          a = i.slice(f);
        }
        let l = o.length - 1, u = o[l];
        if (!u)
          throw new RangeError("Invalid path: " + i);
        let c = new iy(r, s, l > 0 ? o.slice(0, l) : null);
        e[u] = c.sort(e[u]);
      }
  }
  return rL.add(e);
}
const rL = new en();
class iy {
  constructor(e, n, r, i) {
    this.tags = e, this.mode = n, this.context = r, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(e) {
    return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
iy.empty = new iy([], 2, null);
function iL(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let o of t)
    if (!Array.isArray(o.tag))
      n[o.tag.id] = o.class;
    else
      for (let s of o.tag)
        n[s.id] = o.class;
  let { scope: r, all: i = null } = e || {};
  return {
    style: (o) => {
      let s = i;
      for (let a of o)
        for (let l of a.set) {
          let u = n[l.id];
          if (u) {
            s = s ? s + " " + u : u;
            break;
          }
        }
      return s;
    },
    scope: r
  };
}
function rX(t, e) {
  let n = null;
  for (let r of t) {
    let i = r.style(e);
    i && (n = n ? n + " " + i : i);
  }
  return n;
}
function iX(t, e, n, r = 0, i = t.length) {
  let o = new oX(r, Array.isArray(e) ? e : [e], n);
  o.highlightRange(t.cursor(), r, i, "", o.highlighters), o.flush(i);
}
class oX {
  constructor(e, n, r) {
    this.at = e, this.highlighters = n, this.span = r, this.class = "";
  }
  startSpan(e, n) {
    n != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = n);
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, n, r, i, o) {
    let { type: s, from: a, to: l } = e;
    if (a >= r || l <= n)
      return;
    s.isTop && (o = this.highlighters.filter((h) => !h.scope || h.scope(s)));
    let u = i, c = sX(e) || iy.empty, f = rX(o, c.tags);
    if (f && (u && (u += " "), u += f, c.mode == 1 && (i += (i ? " " : "") + f)), this.startSpan(Math.max(n, a), u), c.opaque)
      return;
    let d = e.tree && e.tree.prop(en.mounted);
    if (d && d.overlay) {
      let h = e.node.enter(d.overlay[0].from + a, 1), p = this.highlighters.filter((m) => !m.scope || m.scope(d.tree.type)), g = e.firstChild();
      for (let m = 0, v = a; ; m++) {
        let S = m < d.overlay.length ? d.overlay[m] : null, _ = S ? S.from + a : l, b = Math.max(n, v), y = Math.min(r, _);
        if (b < y && g)
          for (; e.from < y && (this.highlightRange(e, b, y, i, o), this.startSpan(Math.min(y, e.to), u), !(e.to >= _ || !e.nextSibling())); )
            ;
        if (!S || _ > r)
          break;
        v = S.to + a, v > n && (this.highlightRange(h.cursor(), Math.max(n, S.from + a), Math.min(r, v), "", p), this.startSpan(Math.min(r, v), u));
      }
      g && e.parent();
    } else if (e.firstChild()) {
      d && (i = "");
      do
        if (!(e.to <= n)) {
          if (e.from >= r)
            break;
          this.highlightRange(e, n, r, i, o), this.startSpan(Math.min(r, e.to), u);
        }
      while (e.nextSibling());
      e.parent();
    }
  }
}
function sX(t) {
  let e = t.type.prop(rL);
  for (; e && e.context && !t.matchContext(e.context); )
    e = e.next;
  return e || null;
}
const je = bo.define, ng = je(), Pa = je(), nC = je(Pa), rC = je(Pa), $a = je(), rg = je($a), bv = je($a), ss = je(), Ol = je(ss), is = je(), os = je(), sS = je(), qf = je(sS), ig = je(), Ne = {
  /**
  A comment.
  */
  comment: ng,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: je(ng),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: je(ng),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: je(ng),
  /**
  Any kind of identifier.
  */
  name: Pa,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: je(Pa),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: nC,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: je(nC),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: rC,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: je(rC),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: je(Pa),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: je(Pa),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: je(Pa),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: je(Pa),
  /**
  A literal value.
  */
  literal: $a,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: rg,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: je(rg),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: je(rg),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: je(rg),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: bv,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: je(bv),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: je(bv),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: je($a),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: je($a),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: je($a),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: je($a),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: je($a),
  /**
  A language keyword.
  */
  keyword: is,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: je(is),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: je(is),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: je(is),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: je(is),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: je(is),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: je(is),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: je(is),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: je(is),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: je(is),
  /**
  An operator.
  */
  operator: os,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: je(os),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: je(os),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: je(os),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: je(os),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: je(os),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: je(os),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: je(os),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: je(os),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: je(os),
  /**
  Program or markup punctuation.
  */
  punctuation: sS,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: je(sS),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: qf,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: je(qf),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: je(qf),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: je(qf),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: je(qf),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: ss,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: Ol,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: je(Ol),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: je(Ol),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: je(Ol),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: je(Ol),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: je(Ol),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: je(Ol),
  /**
  A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
  */
  contentSeparator: je(ss),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: je(ss),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: je(ss),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: je(ss),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: je(ss),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: je(ss),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: je(ss),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: je(ss),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: je(),
  /**
  Deleted text.
  */
  deleted: je(),
  /**
  Changed text.
  */
  changed: je(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: je(),
  /**
  Metadata or meta-instruction.
  */
  meta: ig,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: je(ig),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: je(ig),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: je(ig),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: bo.defineModifier("definition"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: bo.defineModifier("constant"),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: bo.defineModifier("function"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: bo.defineModifier("standard"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: bo.defineModifier("local"),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: bo.defineModifier("special")
};
for (let t in Ne) {
  let e = Ne[t];
  e instanceof bo && (e.name = t);
}
iL([
  { tag: Ne.link, class: "tok-link" },
  { tag: Ne.heading, class: "tok-heading" },
  { tag: Ne.emphasis, class: "tok-emphasis" },
  { tag: Ne.strong, class: "tok-strong" },
  { tag: Ne.keyword, class: "tok-keyword" },
  { tag: Ne.atom, class: "tok-atom" },
  { tag: Ne.bool, class: "tok-bool" },
  { tag: Ne.url, class: "tok-url" },
  { tag: Ne.labelName, class: "tok-labelName" },
  { tag: Ne.inserted, class: "tok-inserted" },
  { tag: Ne.deleted, class: "tok-deleted" },
  { tag: Ne.literal, class: "tok-literal" },
  { tag: Ne.string, class: "tok-string" },
  { tag: Ne.number, class: "tok-number" },
  { tag: [Ne.regexp, Ne.escape, Ne.special(Ne.string)], class: "tok-string2" },
  { tag: Ne.variableName, class: "tok-variableName" },
  { tag: Ne.local(Ne.variableName), class: "tok-variableName tok-local" },
  { tag: Ne.definition(Ne.variableName), class: "tok-variableName tok-definition" },
  { tag: Ne.special(Ne.variableName), class: "tok-variableName2" },
  { tag: Ne.definition(Ne.propertyName), class: "tok-propertyName tok-definition" },
  { tag: Ne.typeName, class: "tok-typeName" },
  { tag: Ne.namespace, class: "tok-namespace" },
  { tag: Ne.className, class: "tok-className" },
  { tag: Ne.macroName, class: "tok-macroName" },
  { tag: Ne.propertyName, class: "tok-propertyName" },
  { tag: Ne.operator, class: "tok-operator" },
  { tag: Ne.comment, class: "tok-comment" },
  { tag: Ne.meta, class: "tok-meta" },
  { tag: Ne.invalid, class: "tok-invalid" },
  { tag: Ne.punctuation, class: "tok-punctuation" }
]);
var wv;
const oc = /* @__PURE__ */ new en();
function aX(t) {
  return vt.define({
    combine: t ? (e) => e.concat(t) : void 0
  });
}
const lX = /* @__PURE__ */ new en();
class Ho {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(e, n, r = [], i = "") {
    this.data = e, this.name = i, hn.prototype.hasOwnProperty("tree") || Object.defineProperty(hn.prototype, "tree", { get() {
      return Sh(this);
    } }), this.parser = n, this.extension = [
      nf.of(this),
      hn.languageData.of((o, s, a) => {
        let l = iC(o, s, a), u = l.type.prop(oc);
        if (!u)
          return [];
        let c = o.facet(u), f = l.type.prop(lX);
        if (f) {
          let d = l.resolve(s - l.from, a);
          for (let h of f)
            if (h.test(d, o)) {
              let p = o.facet(h.facet);
              return h.type == "replace" ? p : p.concat(c);
            }
        }
        return c;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(e, n, r = -1) {
    return iC(e, n, r).type.prop(oc) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(e) {
    let n = e.facet(nf);
    if (n?.data == this.data)
      return [{ from: 0, to: e.doc.length }];
    if (!n || !n.allowsNesting)
      return [];
    let r = [], i = (o, s) => {
      if (o.prop(oc) == this.data) {
        r.push({ from: s, to: s + o.length });
        return;
      }
      let a = o.prop(en.mounted);
      if (a) {
        if (a.tree.prop(oc) == this.data) {
          if (a.overlay)
            for (let l of a.overlay)
              r.push({ from: l.from + s, to: l.to + s });
          else
            r.push({ from: s, to: s + o.length });
          return;
        } else if (a.overlay) {
          let l = r.length;
          if (i(a.tree, a.overlay[0].from + s), r.length > l)
            return;
        }
      }
      for (let l = 0; l < o.children.length; l++) {
        let u = o.children[l];
        u instanceof dr && i(u, o.positions[l] + s);
      }
    };
    return i(Sh(e), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
Ho.setState = /* @__PURE__ */ fr.define();
function iC(t, e, n) {
  let r = t.facet(nf), i = Sh(t).topNode;
  if (!r || r.allowsNesting)
    for (let o = i; o; o = o.enter(e, n, Nr.ExcludeBuffers))
      o.type.isTop && (i = o);
  return i;
}
class oy extends Ho {
  constructor(e, n, r) {
    super(e, n, [], r), this.parser = n;
  }
  /**
  Define a language from a parser.
  */
  static define(e) {
    let n = aX(e.languageData);
    return new oy(n, e.parser.configure({
      props: [oc.add((r) => r.isTop ? n : void 0)]
    }), e.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(e, n) {
    return new oy(this.data, this.parser.configure(e), n || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function Sh(t) {
  let e = t.field(Ho.state, !1);
  return e ? e.tree : dr.empty;
}
class uX {
  /**
  Create an input object for the given document.
  */
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, n) {
    let r = this.cursorPos - this.string.length;
    return e < r || n >= this.cursorPos ? this.doc.sliceString(e, n) : this.string.slice(e - r, n - r);
  }
}
let zf = null;
class sy {
  constructor(e, n, r = [], i, o, s, a, l) {
    this.parser = e, this.state = n, this.fragments = r, this.tree = i, this.treeLen = o, this.viewport = s, this.skipped = a, this.scheduleOn = l, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new sy(e, n, [], dr.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new uX(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(e, n) {
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != dr.empty && this.isDone(n ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof e == "number") {
        let i = Date.now() + e;
        e = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), n != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > n) && n < this.state.doc.length && this.parse.stopAt(n); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(fu.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (n ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (e())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let e, n;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(n = this.parse.advance()); )
        ;
    }), this.treeLen = e, this.tree = n, this.fragments = this.withoutTempSkipped(fu.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let n = zf;
    zf = this;
    try {
      return e();
    } finally {
      zf = n;
    }
  }
  withoutTempSkipped(e) {
    for (let n; n = this.tempSkipped.pop(); )
      e = oC(e, n.from, n.to);
    return e;
  }
  /**
  @internal
  */
  changes(e, n) {
    let { fragments: r, tree: i, treeLen: o, viewport: s, skipped: a } = this;
    if (this.takeTree(), !e.empty) {
      let l = [];
      if (e.iterChangedRanges((u, c, f, d) => l.push({ fromA: u, toA: c, fromB: f, toB: d })), r = fu.applyChanges(r, l), i = dr.empty, o = 0, s = { from: e.mapPos(s.from, -1), to: e.mapPos(s.to, 1) }, this.skipped.length) {
        a = [];
        for (let u of this.skipped) {
          let c = e.mapPos(u.from, 1), f = e.mapPos(u.to, -1);
          c < f && a.push({ from: c, to: f });
        }
      }
    }
    return new sy(this.parser, n, r, i, o, s, a, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to)
      return !1;
    this.viewport = e;
    let n = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: i, to: o } = this.skipped[r];
      i < e.to && o > e.from && (this.fragments = oC(this.fragments, i, o), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= n ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(e, n) {
    this.skipped.push({ from: e, to: n });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(e) {
    return new class extends tL {
      createParse(n, r, i) {
        let o = i[0].from, s = i[i.length - 1].to;
        return {
          parsedPos: o,
          advance() {
            let l = zf;
            if (l) {
              for (let u of i)
                l.tempSkipped.push(u);
              e && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, e]) : e);
            }
            return this.parsedPos = s, new dr($i.none, [], [], s - o);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let n = this.fragments;
    return this.treeLen >= e && n.length && n[0].from == 0 && n[0].to >= e;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return zf;
  }
}
function oC(t, e, n) {
  return fu.applyChanges(t, [{ fromA: e, toA: n, fromB: e, toB: n }]);
}
class tf {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree)
      return this;
    let n = this.context.changes(e.changes, e.state), r = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new tf(n);
  }
  static init(e) {
    let n = Math.min(3e3, e.doc.length), r = sy.create(e.facet(nf).parser, e, { from: 0, to: n });
    return r.work(20, n) || r.takeTree(), new tf(r);
  }
}
Ho.state = /* @__PURE__ */ Ms.define({
  create: tf.init,
  update(t, e) {
    for (let n of e.effects)
      if (n.is(Ho.setState))
        return n.value;
    return e.startState.facet(nf) != e.state.facet(nf) ? tf.init(e.state) : t.apply(e);
  }
});
let oL = (t) => {
  let e = setTimeout(
    () => t(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(e);
};
typeof requestIdleCallback < "u" && (oL = (t) => {
  let e = -1, n = setTimeout(
    () => {
      e = requestIdleCallback(t, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => e < 0 ? clearTimeout(n) : cancelIdleCallback(e);
});
const Sv = typeof navigator < "u" && (!((wv = navigator.scheduling) === null || wv === void 0) && wv.isInputPending) ? () => navigator.scheduling.isInputPending() : null, cX = /* @__PURE__ */ No.fromClass(class {
  constructor(e) {
    this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e) {
    let n = this.view.state.field(Ho.state).context;
    (n.updateViewport(e.view.viewport) || this.view.viewport.to > n.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(n);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: e } = this.view, n = e.field(Ho.state);
    (n.tree != n.context.tree || !n.context.isDone(e.doc.length)) && (this.working = oL(this.work));
  }
  work(e) {
    this.working = null;
    let n = Date.now();
    if (this.chunkEnd < n && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = n + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r, viewport: { to: i } } = this.view, o = r.field(Ho.state);
    if (o.tree == o.context.tree && o.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let s = Date.now() + Math.min(this.chunkBudget, 100, e && !Sv ? Math.max(25, e.timeRemaining() - 5) : 1e9), a = o.context.treeLen < i && r.doc.length > i + 1e3, l = o.context.work(() => Sv && Sv() || Date.now() > s, i + (a ? 0 : 1e5));
    this.chunkBudget -= Date.now() - n, (l || this.chunkBudget <= 0) && (o.context.takeTree(), this.view.dispatch({ effects: Ho.setState.of(new tf(o.context)) })), this.chunkBudget > 0 && !(l && !a) && this.scheduleWork(), this.checkAsyncSchedule(o.context);
  }
  checkAsyncSchedule(e) {
    e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch((n) => ws(this.view.state, n)).then(() => this.workScheduled--), e.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), nf = /* @__PURE__ */ vt.define({
  combine(t) {
    return t.length ? t[0] : null;
  },
  enables: (t) => [
    Ho.state,
    cX,
    Ht.contentAttributes.compute([t], (e) => {
      let n = e.facet(t);
      return n && n.name ? { "data-language": n.name } : {};
    })
  ]
});
class fX {
  /**
  Create a language support object.
  */
  constructor(e, n = []) {
    this.language = e, this.support = n, this.extension = [e, n];
  }
}
const ole = /* @__PURE__ */ new en();
function sle({ except: t, units: e = 1 } = {}) {
  return (n) => {
    let r = t && t.test(n.textAfter);
    return n.baseIndent + (r ? 0 : e * n.unit);
  };
}
const ale = /* @__PURE__ */ new en();
function lle(t) {
  let e = t.firstChild, n = t.lastChild;
  return e && e.to < n.from ? { from: e.to, to: n.type.isError ? t.to : n.from } : null;
}
class Jh {
  constructor(e, n) {
    this.specs = e;
    let r;
    function i(a) {
      let l = cl.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + l] = a, l;
    }
    const o = typeof n.all == "string" ? n.all : n.all ? i(n.all) : void 0, s = n.scope;
    this.scope = s instanceof Ho ? (a) => a.prop(oc) == s.data : s ? (a) => a == s : void 0, this.style = iL(e.map((a) => ({
      tag: a.tag,
      class: a.class || i(Object.assign({}, a, { tag: null }))
    })), {
      all: o
    }).style, this.module = r ? new cl(r) : null, this.themeType = n.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(e, n) {
    return new Jh(e, n || {});
  }
}
const aS = /* @__PURE__ */ vt.define(), sL = /* @__PURE__ */ vt.define({
  combine(t) {
    return t.length ? [t[0]] : null;
  }
});
function _v(t) {
  let e = t.facet(aS);
  return e.length ? e : t.facet(sL);
}
function ule(t, e) {
  let n = [hX], r;
  return t instanceof Jh && (t.module && n.push(Ht.styleModule.of(t.module)), r = t.themeType), e?.fallback ? n.push(sL.of(t)) : r ? n.push(aS.computeN([Ht.darkTheme], (i) => i.facet(Ht.darkTheme) == (r == "dark") ? [t] : [])) : n.push(aS.of(t)), n;
}
class dX {
  constructor(e) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = Sh(e.state), this.decorations = this.buildDeco(e, _v(e.state)), this.decoratedTo = e.viewport.to;
  }
  update(e) {
    let n = Sh(e.state), r = _v(e.state), i = r != _v(e.startState), { viewport: o } = e.view, s = e.changes.mapPos(this.decoratedTo, 1);
    n.length < o.to && !i && n.type == this.tree.type && s >= o.to ? (this.decorations = this.decorations.map(e.changes), this.decoratedTo = s) : (n != this.tree || e.viewportChanged || i) && (this.tree = n, this.decorations = this.buildDeco(e.view, r), this.decoratedTo = o.to);
  }
  buildDeco(e, n) {
    if (!n || !this.tree.length)
      return cn.none;
    let r = new Is();
    for (let { from: i, to: o } of e.visibleRanges)
      iX(this.tree, n, (s, a, l) => {
        r.add(s, a, this.markCache[l] || (this.markCache[l] = cn.mark({ class: l })));
      }, i, o);
    return r.finish();
  }
}
const hX = /* @__PURE__ */ BM.high(/* @__PURE__ */ No.fromClass(dX, {
  decorations: (t) => t.decorations
})), cle = /* @__PURE__ */ Jh.define([
  {
    tag: Ne.meta,
    color: "#404740"
  },
  {
    tag: Ne.link,
    textDecoration: "underline"
  },
  {
    tag: Ne.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: Ne.emphasis,
    fontStyle: "italic"
  },
  {
    tag: Ne.strong,
    fontWeight: "bold"
  },
  {
    tag: Ne.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: Ne.keyword,
    color: "#708"
  },
  {
    tag: [Ne.atom, Ne.bool, Ne.url, Ne.contentSeparator, Ne.labelName],
    color: "#219"
  },
  {
    tag: [Ne.literal, Ne.inserted],
    color: "#164"
  },
  {
    tag: [Ne.string, Ne.deleted],
    color: "#a11"
  },
  {
    tag: [Ne.regexp, Ne.escape, /* @__PURE__ */ Ne.special(Ne.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ Ne.definition(Ne.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ Ne.local(Ne.variableName),
    color: "#30a"
  },
  {
    tag: [Ne.typeName, Ne.namespace],
    color: "#085"
  },
  {
    tag: Ne.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ Ne.special(Ne.variableName), Ne.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ Ne.definition(Ne.propertyName),
    color: "#00c"
  },
  {
    tag: Ne.comment,
    color: "#940"
  },
  {
    tag: Ne.invalid,
    color: "#f00"
  }
]), pX = /* @__PURE__ */ Object.create(null), sC = [$i.none], aC = [], lC = /* @__PURE__ */ Object.create(null), gX = /* @__PURE__ */ Object.create(null);
for (let [t, e] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  gX[t] = /* @__PURE__ */ mX(pX, e);
function Ev(t, e) {
  aC.indexOf(t) > -1 || (aC.push(t), console.warn(e));
}
function mX(t, e) {
  let n = [];
  for (let a of e.split(" ")) {
    let l = [];
    for (let u of a.split(".")) {
      let c = t[u] || Ne[u];
      c ? typeof c == "function" ? l.length ? l = l.map(c) : Ev(u, `Modifier ${u} used at start of tag`) : l.length ? Ev(u, `Tag ${u} used as modifier`) : l = Array.isArray(c) ? c : [c] : Ev(u, `Unknown highlighting tag ${u}`);
    }
    for (let u of l)
      n.push(u);
  }
  if (!n.length)
    return 0;
  let r = e.replace(/ /g, "_"), i = r + " " + n.map((a) => a.id), o = lC[i];
  if (o)
    return o.id;
  let s = lC[i] = $i.define({
    id: sC.length,
    name: r,
    props: [nL({ [r]: n })]
  });
  return sC.push(s), s.id;
}
$r.RTL, $r.LTR;
let yX = class lS {
  /**
  @internal
  */
  constructor(e, n, r, i, o, s, a, l, u, c = 0, f) {
    this.p = e, this.stack = n, this.state = r, this.reducePos = i, this.pos = o, this.score = s, this.buffer = a, this.bufferBase = l, this.curContext = u, this.lookAhead = c, this.parent = f;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((e, n) => n % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(e, n, r = 0) {
    let i = e.parser.context;
    return new lS(e, [], n, r, r, 0, [], 0, i ? new uC(i, i.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(e, n) {
    this.stack.push(this.state, n, this.bufferBase + this.buffer.length), this.state = e;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(e) {
    var n;
    let r = e >> 19, i = e & 65535, { parser: o } = this.p, s = this.reducePos < this.pos - 25;
    s && this.setLookAhead(this.pos);
    let a = o.dynamicPrecedence(i);
    if (a && (this.score += a), r == 0) {
      this.pushState(o.getGoto(this.state, i, !0), this.reducePos), i < o.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, s ? 8 : 4, !0), this.reduceContext(i, this.reducePos);
      return;
    }
    let l = this.stack.length - (r - 1) * 3 - (e & 262144 ? 6 : 0), u = l ? this.stack[l - 2] : this.p.ranges[0].from, c = this.reducePos - u;
    c >= 2e3 && !(!((n = this.p.parser.nodeSet.types[i]) === null || n === void 0) && n.isAnonymous) && (u == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = c) : this.p.lastBigReductionSize < c && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = u, this.p.lastBigReductionSize = c));
    let f = l ? this.stack[l - 1] : 0, d = this.bufferBase + this.buffer.length - f;
    if (i < o.minRepeatTerm || e & 131072) {
      let h = o.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(i, u, h, d + 4, !0);
    }
    if (e & 262144)
      this.state = this.stack[l];
    else {
      let h = this.stack[l - 3];
      this.state = o.getGoto(h, i, !0);
    }
    for (; this.stack.length > l; )
      this.stack.pop();
    this.reduceContext(i, u);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(e, n, r, i = 4, o = !1) {
    if (e == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let s = this, a = this.buffer.length;
      if (a == 0 && s.parent && (a = s.bufferBase - s.parent.bufferBase, s = s.parent), a > 0 && s.buffer[a - 4] == 0 && s.buffer[a - 1] > -1) {
        if (n == r)
          return;
        if (s.buffer[a - 2] >= n) {
          s.buffer[a - 2] = r;
          return;
        }
      }
    }
    if (!o || this.pos == r)
      this.buffer.push(e, n, r, i);
    else {
      let s = this.buffer.length;
      if (s > 0 && this.buffer[s - 4] != 0) {
        let a = !1;
        for (let l = s; l > 0 && this.buffer[l - 2] > r; l -= 4)
          if (this.buffer[l - 1] >= 0) {
            a = !0;
            break;
          }
        if (a)
          for (; s > 0 && this.buffer[s - 2] > r; )
            this.buffer[s] = this.buffer[s - 4], this.buffer[s + 1] = this.buffer[s - 3], this.buffer[s + 2] = this.buffer[s - 2], this.buffer[s + 3] = this.buffer[s - 1], s -= 4, i > 4 && (i -= 4);
      }
      this.buffer[s] = e, this.buffer[s + 1] = n, this.buffer[s + 2] = r, this.buffer[s + 3] = i;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(e, n, r, i) {
    if (e & 131072)
      this.pushState(e & 65535, this.pos);
    else if ((e & 262144) == 0) {
      let o = e, { parser: s } = this.p;
      (i > this.pos || n <= s.maxNode) && (this.pos = i, s.stateFlag(
        o,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = i)), this.pushState(o, r), this.shiftContext(n, r), n <= s.maxNode && this.buffer.push(n, r, i, 4);
    } else
      this.pos = i, this.shiftContext(n, r), n <= this.p.parser.maxNode && this.buffer.push(n, r, i, 4);
  }
  // Apply an action
  /**
  @internal
  */
  apply(e, n, r, i) {
    e & 65536 ? this.reduce(e) : this.shift(e, n, r, i);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(e, n) {
    let r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != e) && (this.p.reused.push(e), r++);
    let i = this.pos;
    this.reducePos = this.pos = i + e.length, this.pushState(n, i), this.buffer.push(
      r,
      i,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let e = this, n = e.buffer.length;
    for (; n > 0 && e.buffer[n - 2] > e.reducePos; )
      n -= 4;
    let r = e.buffer.slice(n), i = e.bufferBase + n;
    for (; e && i == e.bufferBase; )
      e = e.parent;
    return new lS(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, e);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(e, n) {
    let r = e <= this.p.parser.maxNode;
    r && this.storeNode(e, this.pos, n, 4), this.storeNode(0, this.pos, n, r ? 8 : 4), this.pos = this.reducePos = n, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(e) {
    for (let n = new vX(this); ; ) {
      let r = this.p.parser.stateSlot(
        n.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(n.state, e);
      if (r == 0)
        return !1;
      if ((r & 65536) == 0)
        return !0;
      n.reduce(r);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(e) {
    if (this.stack.length >= 300)
      return [];
    let n = this.p.parser.nextStates(this.state);
    if (n.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let o = 0, s; o < n.length; o += 2)
        (s = n[o + 1]) != this.state && this.p.parser.hasAction(s, e) && i.push(n[o], s);
      if (this.stack.length < 120)
        for (let o = 0; i.length < 8 && o < n.length; o += 2) {
          let s = n[o + 1];
          i.some((a, l) => l & 1 && a == s) || i.push(n[o], s);
        }
      n = i;
    }
    let r = [];
    for (let i = 0; i < n.length && r.length < 4; i += 2) {
      let o = n[i + 1];
      if (o == this.state)
        continue;
      let s = this.split();
      s.pushState(o, this.pos), s.storeNode(0, s.pos, s.pos, 4, !0), s.shiftContext(n[i], this.pos), s.reducePos = this.pos, s.score -= 200, r.push(s);
    }
    return r;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: e } = this.p, n = e.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((n & 65536) == 0)
      return !1;
    if (!e.validAction(this.state, n)) {
      let r = n >> 19, i = n & 65535, o = this.stack.length - r * 3;
      if (o < 0 || e.getGoto(this.stack[o], i, !1) < 0) {
        let s = this.findForcedReduction();
        if (s == null)
          return !1;
        n = s;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(n), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: e } = this.p, n = [], r = (i, o) => {
      if (!n.includes(i))
        return n.push(i), e.allActions(i, (s) => {
          if (!(s & 393216)) if (s & 65536) {
            let a = (s >> 19) - o;
            if (a > 1) {
              let l = s & 65535, u = this.stack.length - a * 3;
              if (u >= 0 && e.getGoto(this.stack[u], l, !1) >= 0)
                return a << 19 | 65536 | l;
            }
          } else {
            let a = r(s, o + 1);
            if (a != null)
              return a;
          }
        });
    };
    return r(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: e } = this.p;
    return e.data[e.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !e.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(e) {
    if (this.state != e.state || this.stack.length != e.stack.length)
      return !1;
    for (let n = 0; n < this.stack.length; n += 3)
      if (this.stack[n] != e.stack[n])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(e) {
    return this.p.parser.dialect.flags[e];
  }
  shiftContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  reduceContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  /**
  @internal
  */
  emitContext() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(e) {
    if (e != this.curContext.context) {
      let n = new uC(this.curContext.tracker, e);
      n.hash != this.curContext.hash && this.emitContext(), this.curContext = n;
    }
  }
  /**
  @internal
  */
  setLookAhead(e) {
    e > this.lookAhead && (this.emitLookAhead(), this.lookAhead = e);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
};
class uC {
  constructor(e, n) {
    this.tracker = e, this.context = n, this.hash = e.strict ? e.hash(n) : 0;
  }
}
class vX {
  constructor(e) {
    this.start = e, this.state = e.state, this.stack = e.stack, this.base = this.stack.length;
  }
  reduce(e) {
    let n = e & 65535, r = e >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (r - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], n, !0);
    this.state = i;
  }
}
class ay {
  constructor(e, n, r) {
    this.stack = e, this.pos = n, this.index = r, this.buffer = e.buffer, this.index == 0 && this.maybeNext();
  }
  static create(e, n = e.bufferBase + e.buffer.length) {
    return new ay(e, n, n - e.bufferBase);
  }
  maybeNext() {
    let e = this.stack.parent;
    e != null && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new ay(this.stack, this.pos, this.index);
  }
}
function og(t, e = Uint16Array) {
  if (typeof t != "string")
    return t;
  let n = null;
  for (let r = 0, i = 0; r < t.length; ) {
    let o = 0;
    for (; ; ) {
      let s = t.charCodeAt(r++), a = !1;
      if (s == 126) {
        o = 65535;
        break;
      }
      s >= 92 && s--, s >= 34 && s--;
      let l = s - 32;
      if (l >= 46 && (l -= 46, a = !0), o += l, a)
        break;
      o *= 46;
    }
    n ? n[i++] = o : n = new e(o);
  }
  return n;
}
class lm {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const cC = new lm();
class bX {
  /**
  @internal
  */
  constructor(e, n) {
    this.input = e, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = cC, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(e, n) {
    let r = this.range, i = this.rangeIndex, o = this.pos + e;
    for (; o < r.from; ) {
      if (!i)
        return null;
      let s = this.ranges[--i];
      o -= r.from - s.to, r = s;
    }
    for (; n < 0 ? o > r.to : o >= r.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      let s = this.ranges[++i];
      o += s.from - r.to, r = s;
    }
    return o;
  }
  /**
  @internal
  */
  clipPos(e) {
    if (e >= this.range.from && e < this.range.to)
      return e;
    for (let n of this.ranges)
      if (n.to > e)
        return Math.max(e, n.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(e) {
    let n = this.chunkOff + e, r, i;
    if (n >= 0 && n < this.chunk.length)
      r = this.pos + e, i = this.chunk.charCodeAt(n);
    else {
      let o = this.resolveOffset(e, 1);
      if (o == null)
        return -1;
      if (r = o, r >= this.chunk2Pos && r < this.chunk2Pos + this.chunk2.length)
        i = this.chunk2.charCodeAt(r - this.chunk2Pos);
      else {
        let s = this.rangeIndex, a = this.range;
        for (; a.to <= r; )
          a = this.ranges[++s];
        this.chunk2 = this.input.chunk(this.chunk2Pos = r), r + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - r)), i = this.chunk2.charCodeAt(0);
      }
    }
    return r >= this.token.lookAhead && (this.token.lookAhead = r + 1), i;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(e, n = 0) {
    let r = n ? this.resolveOffset(n, -1) : this.pos;
    if (r == null || r < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = e, this.token.end = r;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(e, n) {
    this.token.value = e, this.token.end = n;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: e, chunkPos: n } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = n, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let e = this.input.chunk(this.pos), n = this.pos + e.length;
      this.chunk = n > this.range.to ? e.slice(0, this.range.to - this.pos) : e, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(e = 1) {
    for (this.chunkOff += e; this.pos + e >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(e, n) {
    if (n ? (this.token = n, n.start = e, n.lookAhead = e + 1, n.value = n.extended = -1) : this.token = cC, this.pos != e) {
      if (this.pos = e, e == this.end)
        return this.setDone(), this;
      for (; e < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; e >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(e, n) {
    if (e >= this.chunkPos && n <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(e - this.chunkPos, n - this.chunkPos);
    if (e >= this.chunk2Pos && n <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(e - this.chunk2Pos, n - this.chunk2Pos);
    if (e >= this.range.from && n <= this.range.to)
      return this.input.read(e, n);
    let r = "";
    for (let i of this.ranges) {
      if (i.from >= n)
        break;
      i.to > e && (r += this.input.read(Math.max(i.from, e), Math.min(i.to, n)));
    }
    return r;
  }
}
class Sc {
  constructor(e, n) {
    this.data = e, this.id = n;
  }
  token(e, n) {
    let { parser: r } = n.p;
    SX(this.data, e, n, this.id, r.data, r.tokenPrecTable);
  }
}
Sc.prototype.contextual = Sc.prototype.fallback = Sc.prototype.extend = !1;
Sc.prototype.fallback = Sc.prototype.extend = !1;
class wX {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(e, n = {}) {
    this.token = e, this.contextual = !!n.contextual, this.fallback = !!n.fallback, this.extend = !!n.extend;
  }
}
function SX(t, e, n, r, i, o) {
  let s = 0, a = 1 << r, { dialect: l } = n.p.parser;
  e: for (; (a & t[s]) != 0; ) {
    let u = t[s + 1];
    for (let h = s + 3; h < u; h += 2)
      if ((t[h + 1] & a) > 0) {
        let p = t[h];
        if (l.allows(p) && (e.token.value == -1 || e.token.value == p || _X(p, e.token.value, i, o))) {
          e.acceptToken(p);
          break;
        }
      }
    let c = e.next, f = 0, d = t[s + 2];
    if (e.next < 0 && d > f && t[u + d * 3 - 3] == 65535) {
      s = t[u + d * 3 - 1];
      continue e;
    }
    for (; f < d; ) {
      let h = f + d >> 1, p = u + h + (h << 1), g = t[p], m = t[p + 1] || 65536;
      if (c < g)
        d = h;
      else if (c >= m)
        f = h + 1;
      else {
        s = t[p + 2], e.advance();
        continue e;
      }
    }
    break;
  }
}
function fC(t, e, n) {
  for (let r = e, i; (i = t[r]) != 65535; r++)
    if (i == n)
      return r - e;
  return -1;
}
function _X(t, e, n, r) {
  let i = fC(n, r, e);
  return i < 0 || fC(n, r, t) < i;
}
const Bi = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let kv = null;
function dC(t, e, n) {
  let r = t.cursor(Nr.IncludeAnonymous);
  for (r.moveTo(e); ; )
    if (!(n < 0 ? r.childBefore(e) : r.childAfter(e)))
      for (; ; ) {
        if ((n < 0 ? r.to < e : r.from > e) && !r.type.isError)
          return n < 0 ? Math.max(0, Math.min(
            r.to - 1,
            e - 25
            /* Lookahead.Margin */
          )) : Math.min(t.length, Math.max(
            r.from + 1,
            e + 25
            /* Lookahead.Margin */
          ));
        if (n < 0 ? r.prevSibling() : r.nextSibling())
          break;
        if (!r.parent())
          return n < 0 ? 0 : t.length;
      }
}
class EX {
  constructor(e, n) {
    this.fragments = e, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (e) {
      for (this.safeFrom = e.openStart ? dC(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? dC(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(e) {
    if (e < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= e; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let n = this.trees.length - 1;
      if (n < 0)
        return this.nextFragment(), null;
      let r = this.trees[n], i = this.index[n];
      if (i == r.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let o = r.children[i], s = this.start[n] + r.positions[i];
      if (s > e)
        return this.nextStart = s, null;
      if (o instanceof dr) {
        if (s == e) {
          if (s < this.safeFrom)
            return null;
          let a = s + o.length;
          if (a <= this.safeTo) {
            let l = o.prop(en.lookAhead);
            if (!l || a + l < this.fragment.to)
              return o;
          }
        }
        this.index[n]++, s + o.length >= Math.max(this.safeFrom, e) && (this.trees.push(o), this.start.push(s), this.index.push(0));
      } else
        this.index[n]++, this.nextStart = s + o.length;
    }
  }
}
class kX {
  constructor(e, n) {
    this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = e.tokenizers.map((r) => new lm());
  }
  getActions(e) {
    let n = 0, r = null, { parser: i } = e.p, { tokenizers: o } = i, s = i.stateSlot(
      e.state,
      3
      /* ParseState.TokenizerMask */
    ), a = e.curContext ? e.curContext.hash : 0, l = 0;
    for (let u = 0; u < o.length; u++) {
      if ((1 << u & s) == 0)
        continue;
      let c = o[u], f = this.tokens[u];
      if (!(r && !c.fallback) && ((c.contextual || f.start != e.pos || f.mask != s || f.context != a) && (this.updateCachedToken(f, c, e), f.mask = s, f.context = a), f.lookAhead > f.end + 25 && (l = Math.max(f.lookAhead, l)), f.value != 0)) {
        let d = n;
        if (f.extended > -1 && (n = this.addActions(e, f.extended, f.end, n)), n = this.addActions(e, f.value, f.end, n), !c.extend && (r = f, n > d))
          break;
      }
    }
    for (; this.actions.length > n; )
      this.actions.pop();
    return l && e.setLookAhead(l), !r && e.pos == this.stream.end && (r = new lm(), r.value = e.p.parser.eofTerm, r.start = r.end = e.pos, n = this.addActions(e, r.value, r.end, n)), this.mainToken = r, this.actions;
  }
  getMainToken(e) {
    if (this.mainToken)
      return this.mainToken;
    let n = new lm(), { pos: r, p: i } = e;
    return n.start = r, n.end = Math.min(r + 1, i.stream.end), n.value = r == i.stream.end ? i.parser.eofTerm : 0, n;
  }
  updateCachedToken(e, n, r) {
    let i = this.stream.clipPos(r.pos);
    if (n.token(this.stream.reset(i, e), r), e.value > -1) {
      let { parser: o } = r.p;
      for (let s = 0; s < o.specialized.length; s++)
        if (o.specialized[s] == e.value) {
          let a = o.specializers[s](this.stream.read(e.start, e.end), r);
          if (a >= 0 && r.p.parser.dialect.allows(a >> 1)) {
            (a & 1) == 0 ? e.value = a >> 1 : e.extended = a >> 1;
            break;
          }
        }
    } else
      e.value = 0, e.end = this.stream.clipPos(i + 1);
  }
  putAction(e, n, r, i) {
    for (let o = 0; o < i; o += 3)
      if (this.actions[o] == e)
        return i;
    return this.actions[i++] = e, this.actions[i++] = n, this.actions[i++] = r, i;
  }
  addActions(e, n, r, i) {
    let { state: o } = e, { parser: s } = e.p, { data: a } = s;
    for (let l = 0; l < 2; l++)
      for (let u = s.stateSlot(
        o,
        l ? 2 : 1
        /* ParseState.Actions */
      ); ; u += 3) {
        if (a[u] == 65535)
          if (a[u + 1] == 1)
            u = Ks(a, u + 2);
          else {
            i == 0 && a[u + 1] == 2 && (i = this.putAction(Ks(a, u + 2), n, r, i));
            break;
          }
        a[u] == n && (i = this.putAction(Ks(a, u + 1), n, r, i));
      }
    return i;
  }
}
class TX {
  constructor(e, n, r, i) {
    this.parser = e, this.input = n, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new bX(n, i), this.tokens = new kX(e, this.stream), this.topTerm = e.top[1];
    let { from: o } = i[0];
    this.stacks = [yX.start(this, e.top[0], o)], this.fragments = r.length && this.stream.end - o > e.bufferLength * 4 ? new EX(r, e.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let e = this.stacks, n = this.minStackPos, r = this.stacks = [], i, o;
    if (this.bigReductionCount > 300 && e.length == 1) {
      let [s] = e;
      for (; s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let s = 0; s < e.length; s++) {
      let a = e[s];
      for (; ; ) {
        if (this.tokens.mainToken = null, a.pos > n)
          r.push(a);
        else {
          if (this.advanceStack(a, r, e))
            continue;
          {
            i || (i = [], o = []), i.push(a);
            let l = this.tokens.getMainToken(a);
            o.push(l.value, l.end);
          }
        }
        break;
      }
    }
    if (!r.length) {
      let s = i && CX(i);
      if (s)
        return Bi && console.log("Finish with " + this.stackID(s)), this.stackToTree(s);
      if (this.parser.strict)
        throw Bi && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + n);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let s = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, o, r);
      if (s)
        return Bi && console.log("Force-finish " + this.stackID(s)), this.stackToTree(s.forceAll());
    }
    if (this.recovering) {
      let s = this.recovering == 1 ? 1 : this.recovering * 3;
      if (r.length > s)
        for (r.sort((a, l) => l.score - a.score); r.length > s; )
          r.pop();
      r.some((a) => a.reducePos > n) && this.recovering--;
    } else if (r.length > 1) {
      e: for (let s = 0; s < r.length - 1; s++) {
        let a = r[s];
        for (let l = s + 1; l < r.length; l++) {
          let u = r[l];
          if (a.sameState(u) || a.buffer.length > 500 && u.buffer.length > 500)
            if ((a.score - u.score || a.buffer.length - u.buffer.length) > 0)
              r.splice(l--, 1);
            else {
              r.splice(s--, 1);
              continue e;
            }
        }
      }
      r.length > 12 && r.splice(
        12,
        r.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = r[0].pos;
    for (let s = 1; s < r.length; s++)
      r[s].pos < this.minStackPos && (this.minStackPos = r[s].pos);
    return null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = e;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(e, n, r) {
    let i = e.pos, { parser: o } = this, s = Bi ? this.stackID(e) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return e.forceReduce() ? e : null;
    if (this.fragments) {
      let u = e.curContext && e.curContext.tracker.strict, c = u ? e.curContext.hash : 0;
      for (let f = this.fragments.nodeAt(i); f; ) {
        let d = this.parser.nodeSet.types[f.type.id] == f.type ? o.getGoto(e.state, f.type.id) : -1;
        if (d > -1 && f.length && (!u || (f.prop(en.contextHash) || 0) == c))
          return e.useNode(f, d), Bi && console.log(s + this.stackID(e) + ` (via reuse of ${o.getName(f.type.id)})`), !0;
        if (!(f instanceof dr) || f.children.length == 0 || f.positions[0] > 0)
          break;
        let h = f.children[0];
        if (h instanceof dr && f.positions[0] == 0)
          f = h;
        else
          break;
      }
    }
    let a = o.stateSlot(
      e.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (a > 0)
      return e.reduce(a), Bi && console.log(s + this.stackID(e) + ` (via always-reduce ${o.getName(
        a & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (e.stack.length >= 8400)
      for (; e.stack.length > 6e3 && e.forceReduce(); )
        ;
    let l = this.tokens.getActions(e);
    for (let u = 0; u < l.length; ) {
      let c = l[u++], f = l[u++], d = l[u++], h = u == l.length || !r, p = h ? e : e.split(), g = this.tokens.mainToken;
      if (p.apply(c, f, g ? g.start : p.pos, d), Bi && console.log(s + this.stackID(p) + ` (via ${(c & 65536) == 0 ? "shift" : `reduce of ${o.getName(
        c & 65535
        /* Action.ValueMask */
      )}`} for ${o.getName(f)} @ ${i}${p == e ? "" : ", split"})`), h)
        return !0;
      p.pos > i ? n.push(p) : r.push(p);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(e, n) {
    let r = e.pos;
    for (; ; ) {
      if (!this.advanceStack(e, null, null))
        return !1;
      if (e.pos > r)
        return hC(e, n), !0;
    }
  }
  runRecovery(e, n, r) {
    let i = null, o = !1;
    for (let s = 0; s < e.length; s++) {
      let a = e[s], l = n[s << 1], u = n[(s << 1) + 1], c = Bi ? this.stackID(a) + " -> " : "";
      if (a.deadEnd && (o || (o = !0, a.restart(), Bi && console.log(c + this.stackID(a) + " (restarted)"), this.advanceFully(a, r))))
        continue;
      let f = a.split(), d = c;
      for (let h = 0; f.forceReduce() && h < 10 && (Bi && console.log(d + this.stackID(f) + " (via force-reduce)"), !this.advanceFully(f, r)); h++)
        Bi && (d = this.stackID(f) + " -> ");
      for (let h of a.recoverByInsert(l))
        Bi && console.log(c + this.stackID(h) + " (via recover-insert)"), this.advanceFully(h, r);
      this.stream.end > a.pos ? (u == a.pos && (u++, l = 0), a.recoverByDelete(l, u), Bi && console.log(c + this.stackID(a) + ` (via recover-delete ${this.parser.getName(l)})`), hC(a, r)) : (!i || i.score < a.score) && (i = a);
    }
    return i;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(e) {
    return e.close(), dr.build({
      buffer: ay.create(e),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: e.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(e) {
    let n = (kv || (kv = /* @__PURE__ */ new WeakMap())).get(e);
    return n || kv.set(e, n = String.fromCodePoint(this.nextStackID++)), n + e;
  }
}
function hC(t, e) {
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    if (r.pos == t.pos && r.sameState(t)) {
      e[n].score < t.score && (e[n] = t);
      return;
    }
  }
  e.push(t);
}
class xX {
  constructor(e, n, r) {
    this.source = e, this.flags = n, this.disabled = r;
  }
  allows(e) {
    return !this.disabled || this.disabled[e] == 0;
  }
}
class ly extends tL {
  /**
  @internal
  */
  constructor(e) {
    if (super(), this.wrappers = [], e.version != 14)
      throw new RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
    let n = e.nodeNames.split(" ");
    this.minRepeatTerm = n.length;
    for (let a = 0; a < e.repeatNodeCount; a++)
      n.push("");
    let r = Object.keys(e.topRules).map((a) => e.topRules[a][1]), i = [];
    for (let a = 0; a < n.length; a++)
      i.push([]);
    function o(a, l, u) {
      i[a].push([l, l.deserialize(String(u))]);
    }
    if (e.nodeProps)
      for (let a of e.nodeProps) {
        let l = a[0];
        typeof l == "string" && (l = en[l]);
        for (let u = 1; u < a.length; ) {
          let c = a[u++];
          if (c >= 0)
            o(c, l, a[u++]);
          else {
            let f = a[u + -c];
            for (let d = -c; d > 0; d--)
              o(a[u++], l, f);
            u++;
          }
        }
      }
    this.nodeSet = new PE(n.map((a, l) => $i.define({
      name: l >= this.minRepeatTerm ? void 0 : a,
      id: l,
      props: i[l],
      top: r.indexOf(l) > -1,
      error: l == 0,
      skipped: e.skippedNodes && e.skippedNodes.indexOf(l) > -1
    }))), e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)), this.strict = !1, this.bufferLength = QF;
    let s = og(e.tokenData);
    this.context = e.context, this.specializerSpecs = e.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let a = 0; a < this.specializerSpecs.length; a++)
      this.specialized[a] = this.specializerSpecs[a].term;
    this.specializers = this.specializerSpecs.map(pC), this.states = og(e.states, Uint32Array), this.data = og(e.stateData), this.goto = og(e.goto), this.maxTerm = e.maxTerm, this.tokenizers = e.tokenizers.map((a) => typeof a == "number" ? new Sc(s, a) : a), this.topRules = e.topRules, this.dialects = e.dialects || {}, this.dynamicPrecedences = e.dynamicPrecedences || null, this.tokenPrecTable = e.tokenPrec, this.termNames = e.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(e, n, r) {
    let i = new TX(this, e, n, r);
    for (let o of this.wrappers)
      i = o(i, e, n, r);
    return i;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(e, n, r = !1) {
    let i = this.goto;
    if (n >= i[0])
      return -1;
    for (let o = i[n + 1]; ; ) {
      let s = i[o++], a = s & 1, l = i[o++];
      if (a && r)
        return l;
      for (let u = o + (s >> 1); o < u; o++)
        if (i[o] == e)
          return l;
      if (a)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(e, n) {
    let r = this.data;
    for (let i = 0; i < 2; i++)
      for (let o = this.stateSlot(
        e,
        i ? 2 : 1
        /* ParseState.Actions */
      ), s; ; o += 3) {
        if ((s = r[o]) == 65535)
          if (r[o + 1] == 1)
            s = r[o = Ks(r, o + 2)];
          else {
            if (r[o + 1] == 2)
              return Ks(r, o + 2);
            break;
          }
        if (s == n || s == 0)
          return Ks(r, o + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(e, n) {
    return this.states[e * 6 + n];
  }
  /**
  @internal
  */
  stateFlag(e, n) {
    return (this.stateSlot(
      e,
      0
      /* ParseState.Flags */
    ) & n) > 0;
  }
  /**
  @internal
  */
  validAction(e, n) {
    return !!this.allActions(e, (r) => r == n ? !0 : null);
  }
  /**
  @internal
  */
  allActions(e, n) {
    let r = this.stateSlot(
      e,
      4
      /* ParseState.DefaultReduce */
    ), i = r ? n(r) : void 0;
    for (let o = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); i == null; o += 3) {
      if (this.data[o] == 65535)
        if (this.data[o + 1] == 1)
          o = Ks(this.data, o + 2);
        else
          break;
      i = n(Ks(this.data, o + 1));
    }
    return i;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(e) {
    let n = [];
    for (let r = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); ; r += 3) {
      if (this.data[r] == 65535)
        if (this.data[r + 1] == 1)
          r = Ks(this.data, r + 2);
        else
          break;
      if ((this.data[r + 2] & 1) == 0) {
        let i = this.data[r + 1];
        n.some((o, s) => s & 1 && o == i) || n.push(this.data[r], i);
      }
    }
    return n;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(e) {
    let n = Object.assign(Object.create(ly.prototype), this);
    if (e.props && (n.nodeSet = this.nodeSet.extend(...e.props)), e.top) {
      let r = this.topRules[e.top];
      if (!r)
        throw new RangeError(`Invalid top rule name ${e.top}`);
      n.top = r;
    }
    return e.tokenizers && (n.tokenizers = this.tokenizers.map((r) => {
      let i = e.tokenizers.find((o) => o.from == r);
      return i ? i.to : r;
    })), e.specializers && (n.specializers = this.specializers.slice(), n.specializerSpecs = this.specializerSpecs.map((r, i) => {
      let o = e.specializers.find((a) => a.from == r.external);
      if (!o)
        return r;
      let s = Object.assign(Object.assign({}, r), { external: o.to });
      return n.specializers[i] = pC(s), s;
    })), e.contextTracker && (n.context = e.contextTracker), e.dialect && (n.dialect = this.parseDialect(e.dialect)), e.strict != null && (n.strict = e.strict), e.wrap && (n.wrappers = n.wrappers.concat(e.wrap)), e.bufferLength != null && (n.bufferLength = e.bufferLength), n;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(e) {
    return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(e) {
    let n = this.dynamicPrecedences;
    return n == null ? 0 : n[e] || 0;
  }
  /**
  @internal
  */
  parseDialect(e) {
    let n = Object.keys(this.dialects), r = n.map(() => !1);
    if (e)
      for (let o of e.split(" ")) {
        let s = n.indexOf(o);
        s >= 0 && (r[s] = !0);
      }
    let i = null;
    for (let o = 0; o < n.length; o++)
      if (!r[o])
        for (let s = this.dialects[n[o]], a; (a = this.data[s++]) != 65535; )
          (i || (i = new Uint8Array(this.maxTerm + 1)))[a] = 1;
    return new xX(e, r, i);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(e) {
    return new ly(e);
  }
}
function Ks(t, e) {
  return t[e] | t[e + 1] << 16;
}
function CX(t) {
  let e = null;
  for (let n of t) {
    let r = n.p.stoppedAt;
    (n.pos == n.p.stream.end || r != null && n.pos > r) && n.p.parser.stateFlag(
      n.state,
      2
      /* StateFlag.Accepting */
    ) && (!e || e.score < n.score) && (e = n);
  }
  return e;
}
function pC(t) {
  if (t.external) {
    let e = t.extend ? 1 : 0;
    return (n, r) => t.external(n, r) << 1 | e;
  }
  return t.get;
}
const AX = ly.deserialize({
  version: 14,
  states: "nQVQPOOOOQO'#Cf'#CfOOQO'#Cb'#CbQVQPOOOOQO-E6`-E6`",
  stateData: "e~OXOS~OQPORPOSPOTPO~O",
  goto: "fZPPPPPP[PPPbQRORSRTQOR",
  nodeNames: "⚠ Stack Modifier StackModifier Keyword NotText",
  maxTerm: 10,
  skippedNodes: [0],
  repeatNodeCount: 1,
  tokenData: "Ch~RiXY!pYZ!p]^!ppq!pst#Rz{#g#T#U#p#U#V)|#V#W/m#W#X2m#X#Y3u#Y#Z4_#[#]5a#]#^6`#`#a6x#a#b8T#c#d9l#d#e:[#f#g=[#g#h=}#h#iAs#i#jBc#j#kBi#k#lB{#r#s$i~!uSX~XY!pYZ!p]^!ppq!p~#UQst#[![!]#b~#_P![!]#b~#gOS~~#jQz{#[![!]#b~#sS#V#W$P#`#a$t#b#c%W#i#j'O~$SP#f#g$V~$YP#c#d$]~$`P#g#h$c~$fP#g#h$i~$lP![!]$o~$tOQ~~$wP#]#^$z~$}P#Z#[%Q~%TP#b#c$i~%ZQ#V#W%a#]#^%s~%dP#[#]%g~%jP#c#d%m~%pP#f#g$i~%vP#a#b%y~%|P#T#U&P~&SP#h#i&V~&YP#X#Y&]~&`Q![!]$o!u!v&f~&iP#h#i&l~&oP#T#U&r~&uP#f#g&x~&{P#h#i$i~'RQ#W#X'X#h#i(S~'[P#]#^'_~'bP#c#d'e~'hP![!]'k~'pST~OY'kZ;'S'k;'S;=`'|<%lO'k~(PP;=`<%l'k~(VP#c#d(Y~(]Q#d#e(c#g#h)d~(fP#`#a(i~(lP#T#U(o~(rP#m#n(u~(xP![!]({~)QSR~OY({Z;'S({;'S;=`)^<%lO({~)aP;=`<%l({~)gP#d#e)j~)mP#T#U)p~)sP#V#W)v~)yP#X#Y(u~*PS#T#U*]#`#a+t#c#d,Z#i#j/T~*`P#V#W*c~*fP#_#`*i~*lQ#Z#[*r#`#a+b~*uP#f#g*x~*{P#c#d+O~+RP#i#j+U~+XP#b#c+[~+_P#W#X'e~+eP#]#^+h~+kP#b#c+n~+qP#_#`$i~+wQ#T#U+}#i#j%m~,QP#b#c,T~,WP#_#`'e~,^Q#f#g,d#l#m.X~,gP#W#X,j~,mP#X#Y,p~,sP#f#g,v~,yP}!O,|~-PQ#V#W-V#h#i-c~-YP#c#d-]~-`P#`#a%g~-fP#[#]-i~-lP#]#^-o~-rP#V#W-u~-xP#_#`-{~.OP#b#c.R~.UP#X#Y$]~.[Q}!O.b![!]#b~.eP#V#W.h~.kP#c#d.n~.qQ#`#a%g#f#g.w~.zP#b#c.}~/QP#X#Y%m~/WP#h#i/Z~/^P#h#i/a~/dP#c#d/g~/jP#b#c'e~/pR#T#U/y#[#]0c#c#d0u~/|P#d#e0P~0SP#h#i0V~0YP#]#^0]~0`P#c#d%Q~0fP#T#U0i~0lP#f#g0o~0rP#h#i'e~0xQ#`#a1O#f#g1e~1RQ#c#d%m#i#j1X~1[P#a#b1_~1bP#b#c$c~1hP#b#c1k~1nP#X#Y1q~1tP#f#g1w~1zP}!O1}~2QP#f#g2T~2WP#T#U2Z~2^P#W#X2a~2dP#]#^2g~2jP#i#j$c~2pQ#X#Y2v#c#d3o~2yQ#V#W3P#`#a3c~3SP#c#d3V~3YP#f#g3]~3`P#T#U0P~3fP#T#U3i~3lP#m#n$i~3rP#k#l%Q~3xP#Y#Z3{~4OP#Y#Z4R~4UP#X#Y4X~4[P#V#W&x~4bQ#]#^4h#c#d5Q~4kP#`#a4n~4qP#h#i4t~4wP#X#Y4z~4}P#f#g(u~5TQ#b#c&x#f#g5Z~5^P#a#b#[~5dQ#X#Y5j#]#^5|~5mP#]#^5p~5sP#Z#[5v~5yP#[#]&x~6PP#W#X6S~6VP#X#Y6Y~6]P!q!r%Q~6cP#a#b6f~6iP#T#U6l~6oP#Z#[6r~6uP#X#Y'e~6{Q#]#^7R#c#d7w~7UP#b#c7X~7[Q#X#Y7b#_#`#[~7eQ}!O7k![!]#b~7nP#[#]7q~7tP#X#Y5j~7zP#c#d7}~8QP#d#e'e~8WR#T#U8a#c#d8|#i#j9`~8dQ#]#^8j#d#e'e~8mP#`#a8p~8sP#h#i8v~8yP#c#d$i~9PP#j#k9S~9VP#X#Y9Y~9]P!d!e(o~9cP#h#i9f~9iP#X#Y$i~9oP#d#e9r~9uP#T#U9x~9{P#V#W:O~:RP#]#^:U~:XP#h#i3i~:_Q#T#U:e#c#d=O~:hQ#W#X:n#i#j<x~:qP#W#X:t~:wP#]#^:z~:}P#b#c;Q~;TP#Z#[;W~;ZQ}!O;a![!]$o~;dS#U#V;p#`#a<`#f#g5j#h#i<l~;sP#c#d;v~;yP#h#i;|~<PP#h#i<S~<VP#c#d<Y~<]P#a#b$i~<cP#X#Y<f~<iP#Y#Z&x~<oP#c#d<r~<uP#d#e$i~<{P#g#h6r~=RP#g#h=U~=XP#]#^0P~=_P#X#Y=b~=eQ#T#U=k#d#e=q~=nP#W#X#[~=tP#X#Y=w~=zP#T#U&x~>QT#V#W>a#[#]>y#]#^?c#h#i?i#i#j@n~>dP#f#g>g~>jP#c#d>m~>pP#`#a>s~>vP#`#a$i~>|P#T#U?P~?SP#W#X?V~?YP#c#d?]~?`P#k#l$i~?fP#n#o9f~?lQ#c#d?r#m#n@h~?uP#f#g?x~?{P#m#n@O~@RP!p!q@U~@XP#T#U@[~@_P#a#b@b~@eP#X#Y({~@kP#`#a9f~@qQ#U#V@w#d#eAg~@zP#h#i@}~AQP#]#^AT~AWP#h#iAZ~A^P#`#aAa~AdP#X#Y#[~AjP#X#YAm~ApP#f#g@w~AvR#T#U<r#]#^AT#c#dBP~BSP!r!sBV~BYP#T#UB]~B`P#Z#[9f~BfP#f#g>s~BlP#]#^Bo~BrP#W#XBu~BxP#X#Y'_~COQ#X#Y5j#]#^CU~CXP#W#XC[~C_P#h#iCb~CeP#[#]$i",
  tokenizers: [0],
  topRules: {
    Stack: [0, 1]
  },
  tokenPrec: 0
}), RX = 1, Tv = "  background:", OX = new wX((t) => {
  const e = t.peek(-1);
  if (e === 10 || e === -1) {
    let n = !0;
    for (let r = 0; r < Tv.length; r++)
      if (t.peek(r) !== Tv.charCodeAt(r)) {
        n = !1;
        break;
      }
    n && (t.advance(Tv.length), t.acceptToken(RX));
  }
}), fle = Jh.define([{
  tag: Ne.keyword,
  class: "qp-keyword-color"
}, {
  tag: Ne.controlKeyword,
  class: "qp-keyword-no-text-color"
}, {
  tag: Ne.comment,
  class: "qp-modifier-color"
}, {
  tag: Ne.documentMeta,
  class: "qp-stack-modifier-color"
}]), DX = AX.configure({
  name: "rYaml",
  props: [nL({
    Keyword: Ne.keyword,
    NotText: Ne.controlKeyword,
    BackgroundKeyword: Ne.controlKeyword,
    Modifier: Ne.comment,
    BackgroundModifier: Ne.comment,
    StackModifier: Ne.documentMeta
  })],
  externalTokenizer: OX
}), IX = oy.define({
  parser: DX
});
function dle(t) {
  return new fX(IX);
}
const NX = /* @__PURE__ */ new Set(["inkReveal"]), pe = {
  broadcastChannel: {
    allAuthors: "allAuthors",
    author: "quickpoint_channel_author",
    fileComponent: "quickpoint_file_component",
    fromUploader: "quickpoint_from_uploader",
    general: "general",
    preview: "quickpoint_channel_preview",
    toUploader: "quickpoint_to_uploader",
    viewer: "quickpoint_channel_viewer"
  },
  common: {
    unauthorized: "unauthorized",
    landing: {
      qp: "quickpoint/landing",
      m23: "mrkt23/landing",
      tkn: "tkns/landing"
    }
  },
  demo: {
    cfKey: "demo/story",
    ownerName: "demo"
  },
  controlsPortalId: {
    files: "files-control-button-portal",
    logout: "logout-control-button-portal",
    mobilePreview: "mobile-preview-button-portal",
    newStack: "new-stack-control-button-portal",
    preview: "preview-control-button-portal",
    publish: "publish-control-button-portal",
    qr: "qr-control-button-portal",
    read: "read-control-button-portal",
    save: "save-control-button-portal",
    stacks: "stacks-control-button-portal"
  },
  controlsPortalText: {
    ai: "Use AI",
    close: "Exit",
    discuss: "Discuss",
    file: "File",
    files: "Files",
    folder: "Folder",
    logout: "Logout",
    mobilePreview: "Preview",
    newStack: "New",
    preview: "Preview",
    present: "Present",
    publish: "Publish",
    qr: "qr",
    read: "Read",
    rename: "Rename story",
    save: "Save",
    saved: "Saved",
    saving: "Saving",
    share: "Share",
    stacks: "Stories",
    tour: "Tour",
    trash: "Trash",
    trashImage: "Trash image",
    unpreview: "Un-preview",
    unpublish: "Un-Pub",
    unread: "Un-read"
  },
  context: {
    files: "files",
    filter: "filter",
    hints: "hints",
    init: "init",
    stacks: "stacks",
    topLevel: "topLevel"
  },
  css: {
    authorUserInterface: "author-user-interface",
    authorUserInterfaceClass: "author-user-interface",
    displayGrid: "quickpoint-display-grid",
    displayGridClass: ".quickpoint-display-grid",
    dynamicResize: "dynamic-resize",
    dynamicResizeClass: ".dynamic-resize",
    fileDropZone: "file-drop-zone",
    grid: "quickpoint-grid",
    gridClass: ".quickpoint-grid",
    image: "image",
    imageClass: ".image",
    landscapePreviewGeneratorID: "landscape-preview-generator",
    landscapeViewerID: "landscape-viewer",
    pageElement: "page-element",
    pageElementClass: ".page-element",
    portraitPreviewGeneratorID: "portrait-preview-generator",
    portraitViewerID: "portrait-viewer",
    preventDragDropDefault: "prevent-drag-drop-default",
    previewGenerator: "preview-generator",
    previewPane: "preview-pane",
    previewPaneClass: ".preview-pane",
    safariWrapper: "safari-wrapper",
    splitPage: "split-page",
    stack: "stack",
    stickyHeader: "sticky-menu",
    styledGridCell: "styled-grid-cell",
    styledGridCellClass: ".styled-grid-cell",
    viewerContainer: "viewer-container",
    viewerContainerClass: ".viewer-container"
  },
  defaultFilter: "quickpoint::default",
  errors: {
    emailLinkExpired: "Verify email link expired",
    invalidCredentials: "Invalid credentials",
    noStack: "A new story.",
    notFound: "No stories live at this address. Sorry"
  },
  events: {
    clearCode: "clearCode",
    fold: "foldCode",
    insertCharacter: "insertCharacter",
    insertWord: "insertWord",
    openAutoComplete: "openAutoComplete",
    moveCursorToPageIndex: "moveCursorToPageIndex",
    undo: "undo",
    updateAppVars: "updateAppVars",
    updateAudioFiles: "updateAudioFiles",
    updateBacklinks: "updateBacklinks",
    updateCode: "updateCode",
    updateDataFiles: "updateDataFiles",
    updateFilterColors: "updateFilterColors",
    updateFilterNames: "updateFilterNames",
    updateImageFiles: "updateImageFiles",
    updateLoadedFilterFonts: "updateLoadedFilterFonts",
    updateStackCfKeys: "updateStackCfKeys",
    wrapSelection: "wrapSelection"
  },
  localStorage: {
    ownerName: "ownerName",
    authObject: "authObject",
    ownerId: "ownerId",
    QpHistoryLocalStorage: "QpHistoryLocalStorage",
    QpHistorySessionStorage: "QpHistorySessionStorage"
  },
  messages: {
    allFiles: "allFiles",
    applicationError: "applicationError",
    authorIsReady: "authorIsReady",
    deleteImage: "deleteImage",
    deleteImageFailed: "deleteImageFailed",
    deleteStack: "deleteStack",
    edit: "edit",
    exitPresentationMode: "exitPresentationMode",
    enterReadMode: "enterReadMode",
    exitReadMode: "exitReadMode",
    error: "error",
    fileUpload: "fileUpload",
    filtersAreLoaded: "filtersAreLoaded",
    goToPage: "goToPage",
    init: "init",
    injectFilter: "injectFilter",
    invalidEmail: "invalidEmail",
    linkClicked: "linkClicked",
    orgNameRequired: "orgNameRequired",
    page: "page",
    parsedStack: "parsedStack",
    ping: "ping",
    pong: "pong",
    preview: "preview",
    presentationMode: "presentationMode",
    ready: "ready",
    restartPreview: "restartPreview",
    requestAllFiles: "requestAllFiles",
    requestFilterNames: "requestFilterNames",
    requestPreviewSnap: "requestPreviewSnap",
    requestStack: "requestStack",
    saveStack: "saveStack",
    setFilterColors: "setFilterColors",
    setFilterFonts: "setFilterFonts",
    setFilterNames: "setFilterNames",
    setNavigationType: "setNavigationType",
    setStoryNames: "setStoryNames",
    toggleStoriesDuringDemoMode: "toggleStoriesDuringDemoMode",
    test: "test",
    toggleFilesPanel: "toggleFilesPanel",
    toggleSharePanel: "toggleSharePanel",
    toggleStacksPanel: "toggleStacksPanel",
    unPreview: "unPreview",
    updateFiles: "updateFiles",
    weakPassword: "weakPassword",
    getCodeAndFilter: "getCodeAndFilter",
    codeAndFilter: "codeAndFilter",
    code: "code"
  },
  modifier: "modifier",
  navigation: {
    idStoryBackgroundLeft: "#story-background-left",
    idStoryBackgroundRight: "#story-background-right",
    idStoryBackgroundTop: "#story-background-top",
    idStoryBackgroundBottom: "#story-background-bottom",
    storyBackgroundLeft: "story-background-left",
    storyBackgroundRight: "story-background-right",
    storyBackgroundTop: "story-background-top",
    storyBackgroundBottom: "story-background-bottom"
  },
  preview: {
    inMobile: "previewInMobile",
    inDesktop: "previewInDesktop",
    inExternalMobile: "previewInExternalMobile"
  },
  reservedWordsArray: ["READ", "PAGE"],
  reservedWords: {
    read: "READ",
    page: "PAGE",
    debug: "DEBUG"
  },
  signUpMethods: {
    google: "google",
    github: "github",
    email: "email"
  },
  startOfLine: "startOfLine",
  startOfLinePlusTab: "startOfLinePlusTab",
  textControlsPortalId: {
    bold: "bold-text-control-button-portal",
    col: "col-text-control-button-portal",
    page: "page-text-control-button-portal",
    fold: "fold-text-control-button-portal",
    italic: "italic-text-control-button-portal",
    row: "row-text-control-button-portal",
    underline: "underline-text-control-button-portal"
  },
  textControlsPortalText: {
    bold: "bold",
    codeBlock: "new code or math",
    col: "new col",
    endGrid: "finish the grid",
    insertFilter: "insert a filter",
    fold: "fold code",
    italic: "italic",
    page: "new page",
    row: "new row",
    underline: "underline",
    undo: "undo",
    mdToJadle: "markdown to jadle"
  },
  tests: {
    failMail: "fail@fail.com",
    gitHub: "github@test.com",
    gmail: "google@test.com",
    jwt: "testJwt",
    integrationTestImage: "integrationTestImage",
    integrationTestImageURL: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/6907ee2e-9318-4ca5-6737-281f2237ee00/public",
    noNameMail: "noname@test.com",
    testMail: "greg@test.test",
    testPassword: "testing",
    url: "/testOwner/testStack"
  },
  ui: {
    portrait: "portrait",
    landscape: "landscape"
  },
  unset: "unset",
  url: {
    helpUrl: "help/",
    page: "PAGE",
    read: "READ",
    showLogin: "login",
    showSignUp: "signup",
    userRequestsGitHubSignUp: "github-signup",
    userRequestsGoogleSignUp: "google-signup",
    userRequestsLoginWithEmail: "email-login",
    userRequestsSignUpWithEmail: "email-signup"
  },
  utility: {
    alreadyAuth: "alreadyAuth",
    author: "author",
    badUrl: "badUrl",
    contentUrl: "internal-content-link",
    defaultFilter: "quickpoint::default",
    emailLinkExpired: "emailLinkExpired",
    inAuthor: "inAuthor",
    invalidCredentials: "invalidCredentials",
    loginError: "loginError",
    networkError: "networkError",
    postLogin: "postLogin",
    signedUp: "signedUp",
    signUpTime: "signUpTime",
    sourceCode: "sourceCode",
    unverifiedEmail: "unverifiedEmail",
    viewerati: "viewerati",
    loading: "loading",
    noOwnerNameAssociatedWithEmail: "noOwnerNameAssociatedWithEmail",
    noRecordFound: "noVespaRecordFound"
  },
  // Centralized messages and actions for the editor linter
  lint: {
    actions: {
      remove: "Remove"
    },
    messages: {
      closeGridWithoutOpen: "You tried to end a grid with '-->', but never started one. Start one with '---' first.",
      unclosedGridBeforePage: "This grid wasn't finished before the page ended. Add '-->' where you want it to end.",
      unclosedCodeBeforePage: "This code block wasn't finished before the page ended. Add '```' where you want it to end.",
      unclosedStickyHeaderBeforePage: "This sticky header wasn't finished before the page ended. Add another '^^^' where you want it to end.",
      unclosedStickyFooterBeforePage: "This sticky footer wasn't finished before the page ended. Add another 'vvv' where you want it to end.",
      unclosedGridAtDocEnd: "The document ends while this grid is still open. Add '-->' to close it where you want it to end.",
      unclosedCodeAtDocEnd: "The document ends while this code block is still open. Add '```' to close it where you want it to end.",
      unclosedStickyHeaderAtDocEnd: "The document ends while this sticky header is still open. Add another '^^^' to close it.",
      unclosedStickyFooterAtDocEnd: "The document ends while this sticky footer is still open. Add another 'vvv' to close it.",
      multiInstructionOnLine: "Only use one keyword per line. Move extra keywords or modifiers to their own lines.",
      modifierNeedsKeyword: "This modifier needs a keyword above it (like title: or image:). Indent it under the text you want to change.",
      missingValue: (t) => {
        const e = t;
        return l0.includes(e) ? e === "image:" ? `"${e}" needs an image. Pick one from your files.` : e === "background:" ? `"${e}" needs a color name or an image. Add it on the same line.` : e === "video:" ? `"${e}" needs a video link (YouTube or Vimeo). Paste the link after it.` : e === "audio:" ? `"${e}" needs an audio file. Pick one from your files.` : e === "map:" ? `"${e}" needs a Google Maps share link. Paste it after the keyword.` : e === "chart:" ? `"${e}" needs a data file (CSV or JSON). Pick one from your files.` : e === "filter:" ? `"${e}" needs a filter name. Choose one from your filters.` : e === "moveBy:" ? `"${e}" needs a choice: "tap" or "scroll".` : e === "autoplay:" ? `"${e}" needs a number of seconds. Example: autoplay: 5` : `"${e}" needs text. Type it on the same line.` : `"${e}" needs a value. Add it on the same line.`;
      },
      modifierNotAllowed: (t, e) => `The modifier "${t}" can't be used with "${e}".`,
      incorrectIndentation: "Incorrect indentation. Please use exactly two spaces."
    }
  },
  workers: {
    datafilesR2: "datafiles",
    missingFields: "missing fields",
    ownerExists: "owner exists",
    reserved: "reserved",
    turnStileError: "turnstile error",
    userExists: "user exists"
  }
}, Zh = {
  align: dn.Center,
  autospace: !0,
  background: st.Second,
  borderBlockEnd: 0,
  borderBlockStart: 0,
  borderColor: st.Unset,
  borderInlineEnd: 0,
  borderInlineStart: 0,
  color: st.First,
  cornerRadius: 0,
  decoration: ir.Unset,
  filterName: pe.defaultFilter,
  font: Ar.First,
  fontSize: yr.First,
  fontStyle: rr.Unset,
  lineHeightMultiplier: 1,
  marginBottomMultiplier: 1,
  marginTopMultiplier: 1,
  ownerName: "quickpoint",
  paddingBlockEnd: 8,
  paddingInlineStart: 8,
  paddingInlineEnd: 8,
  paddingBlockStart: 8,
  publish: !0,
  startingPoint: mo.MiddleOut,
  weight: Gn.Normal,
  audioPlayer: {
    align: dn.Unset,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.Second,
    fontStyle: rr.Unset,
    lineHeight: 1.42,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  blank: {
    fontSize: yr.Second,
    leading: 0.42
  },
  box: {
    align: dn.Unset,
    background: st.Seventh,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.Unset,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.Second,
    fontStyle: rr.Unset,
    lineHeight: 0,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  bullet: {
    align: dn.Unset,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.Second,
    fontSize: yr.Second,
    fontStyle: rr.Unset,
    lineHeight: 0,
    markerColor: st.Unset,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    space: 0,
    weight: Gn.Unset
  },
  button: {
    align: dn.Unset,
    background: st.Second,
    borderBlockEnd: 0.1,
    borderInlineEnd: 0.1,
    borderInlineStart: 0.1,
    borderBlockStart: 0.1,
    borderColor: st.First,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.Second,
    fontSize: yr.First,
    fontStyle: rr.Unset,
    lineHeight: 1,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 1,
    paddingInlineStart: 1,
    paddingInlineEnd: 1,
    paddingBlockStart: 1,
    weight: Gn.Unset
  },
  caption: {
    align: dn.End,
    backdropOpacity: 50,
    background: st.Second,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.First,
    fontStyle: rr.Unset,
    lineHeight: 0,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 2,
    paddingInlineStart: 2,
    paddingInlineEnd: 2,
    paddingBlockStart: 2,
    weight: Gn.Unset
  },
  cell: {
    align: dn.Start,
    startingPoint: mo.MiddleOut,
    paddingBlockEnd: 2,
    paddingBlockStart: 2,
    paddingInlineEnd: 2,
    paddingInlineStart: 2
  },
  colors: {
    first: "#111111",
    second: "#fffff8",
    third: "#dc2828",
    fourth: "#fdf4fc"
    // Unused/Extra
  },
  columnTitle: {
    align: dn.Center,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.Second,
    fontStyle: rr.Unset,
    lineHeight: 1.3,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  fonts: {
    first: "et-book-roman-line-figures.woff",
    second: "et-book-display-italic-old-style-figures.woff",
    third: "et-book-bold-line-figures.woff",
    fourth: "et-book-roman-old-style-figures.woff"
  },
  fontSizes: {
    first: 3.14,
    second: 4,
    third: 4.86,
    fourth: 6.29,
    fifth: 9.14,
    sixth: 2.86
    // Code 1.0rem
  },
  frame: {
    paddingBlockEnd: 2,
    paddingBlockStart: 2,
    paddingInlineEnd: 2,
    paddingInlineStart: 2
  },
  grid: {
    align: dn.Start,
    columnGap: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    rowGap: 1,
    singleColumnInPortrait: !0,
    startingPoint: mo.MiddleOut
  },
  image: {
    align: dn.Unset,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    cornerRadius: 0,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    paddingBlockEnd: 0,
    opacity: 100,
    paddingBlockStart: 0,
    paddingInlineEnd: 0,
    paddingInlineStart: 0
  },
  line: {
    align: dn.Unset,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.Second,
    fontStyle: rr.Unset,
    lineHeight: 0,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  link: {
    align: dn.Unset,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Underline,
    font: Ar.First,
    fontSize: yr.Second,
    fontStyle: rr.Unset,
    lineHeight: 0,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    visited: st.First,
    weight: Gn.Unset
  },
  list: {
    align: dn.Unset,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.Second,
    fontStyle: rr.Unset,
    lineHeight: 1.43,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  paragraph: {
    align: dn.Center,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.Second,
    fontStyle: rr.Unset,
    lineHeight: 1.43,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  read: {
    align: dn.Unset,
    background: st.Second,
    borderBlockEnd: 0.2,
    borderInlineEnd: 0.2,
    borderInlineStart: 0.2,
    borderBlockStart: 0.2,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 2,
    decoration: ir.Unset,
    font: Ar.First,
    fontStyle: rr.Unset,
    fontSize: yr.First,
    lineHeight: 1.43,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  stickyFooter: {
    align: dn.Unset,
    background: st.Second,
    borderBlockEnd: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    cornerRadius: 0,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    startingPoint: mo.MiddleOut
  },
  stickyHeader: {
    align: dn.Unset,
    background: st.Second,
    borderBlockEnd: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    cornerRadius: 0,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1,
    opacity: 100,
    startingPoint: mo.MiddleOut
  },
  subtitle: {
    align: dn.Center,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.Second,
    fontSize: yr.Third,
    fontStyle: rr.Italic,
    lineHeight: 1,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1.4,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  supertitle: {
    align: dn.Center,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.Fifth,
    fontStyle: rr.Unset,
    lineHeight: 1,
    marginBottomMultiplier: 1.1,
    marginTopMultiplier: 2.8,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  tableCell: {
    align: dn.Start,
    startingPoint: mo.MiddleOut,
    paddingBlockEnd: 2,
    paddingBlockStart: 2,
    paddingInlineEnd: 2,
    paddingInlineStart: 2
  },
  title: {
    align: dn.Center,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    color: st.First,
    cornerRadius: 0,
    decoration: ir.Unset,
    font: Ar.Second,
    fontSize: yr.Fourth,
    fontStyle: rr.Italic,
    lineHeight: 1,
    marginBottomMultiplier: 1,
    marginTopMultiplier: 1.5,
    opacity: 100,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    paddingBlockStart: 0,
    weight: Gn.Unset
  },
  table: {
    align: dn.Start,
    columnGap: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    rowGap: 1,
    singleColumnInPortrait: !0,
    startingPoint: mo.TopDown,
    background: st.Unset,
    borderBlockEnd: 0,
    borderInlineEnd: 0,
    borderInlineStart: 0,
    borderBlockStart: 0,
    borderColor: st.Unset,
    cornerRadius: 0,
    marginTopMultiplier: 1,
    marginBottomMultiplier: 1,
    opacity: 100,
    color: st.First,
    decoration: ir.Unset,
    font: Ar.First,
    fontSize: yr.First,
    fontStyle: rr.Unset,
    lineHeight: 1.42,
    weight: Gn.Unset
  }
}, PX = ["Arial Black", "Arial", "Baskerville", "Courier", "Garamond", "Georgia", "Gill Sans", "Helvetica", "Impact", "Monaco", "Palatino", "Tahoma", "Times New Roman", "Trebuchet MS", "Verdana"], gC = [pe.common.unauthorized, pe.unset, pe.utility.alreadyAuth, pe.utility.badUrl, pe.utility.emailLinkExpired, pe.utility.loginError, pe.utility.networkError, pe.utility.noOwnerNameAssociatedWithEmail, pe.utility.postLogin, pe.utility.signedUp, pe.utility.signUpTime, pe.utility.unverifiedEmail];
function $X(t) {
  if (!t) return !1;
  const e = t.split("/");
  return !(e.length < 2 || e[0] === "" || e[1] === "" || gC.find((n) => n === e[0]) || gC.find((n) => n === e[1]));
}
function aL(t) {
  let e = t;
  const n = {}, r = t.indexOf("?");
  if (r !== -1) {
    e = t.substring(0, r);
    const h = t.substring(r + 1);
    for (const p of h.split("&")) {
      const [g, m] = p.split("=");
      g && (n[decodeURIComponent(g)] = m ? decodeURIComponent(m) : "");
    }
  }
  e.endsWith("/") && e.slice(0, -1);
  const i = e.split("/"), o = i[1], s = i.indexOf(pe.reservedWords.page), a = i.indexOf(pe.reservedWords.read);
  let l = 2;
  const u = a > -1, c = s > -1 ? Number.parseInt(i[s + 1]) : !1;
  c || u ? (c && (l = s - 1), u && (l = a - 1)) : l = i.length - 1;
  const f = i.slice(1, l + 1), d = f.length === 1 ? "" : f.join("/").replace(/\/+$/, "");
  return {
    ownerName: o,
    page: c,
    read: u,
    stackCfKey: d,
    validStackCfKey: $X(d),
    stackFileName: i[l],
    queryParams: n
  };
}
const MX = qU`
 /*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
*/
    *, *::before, *::after {
    box-sizing: border-box;
    }
    * {
    margin: 0;
    padding: 0; 
    }
    body {
    -webkit-font-smoothing: antialiased;
    }
    img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
    }
    input, button, textarea, select {
    font: inherit;
    }
    p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
    }
    #root, #__next {
    isolation: isolate;
    }
`, FX = ["backdrop:", "link:"], xv = {
  "backdrop:": "background:",
  "link:": "{{"
}, LX = new RegExp(`^((${FX.join(")|(")}))(.*)$`);
function mC(t) {
  const e = t.split(`
`);
  return e.forEach((r, i) => {
    const o = LX.exec(r);
    o && (o[1] === "link:" ? (r += "}}", e[i] = r.replace(o[1] + " ", xv[o[1]]), e[i] = r.replace(o[1], xv[o[1]])) : (e[i] = r.replace(o[1], xv[o[1]]), o[1] === "link:" && (r += "}}")));
  }), e.join(`
`);
}
var sg = { exports: {} }, yC;
function BX() {
  return yC || (yC = 1, function(t, e) {
    var n = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof zo < "u" && zo, r = function() {
      function o() {
        this.fetch = !1, this.DOMException = n.DOMException;
      }
      return o.prototype = n, new o();
    }();
    (function(o) {
      (function(s) {
        var a = typeof o < "u" && o || typeof self < "u" && self || // eslint-disable-next-line no-undef
        typeof zo < "u" && zo || {}, l = {
          searchParams: "URLSearchParams" in a,
          iterable: "Symbol" in a && "iterator" in Symbol,
          blob: "FileReader" in a && "Blob" in a && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in a,
          arrayBuffer: "ArrayBuffer" in a
        };
        function u(N) {
          return N && DataView.prototype.isPrototypeOf(N);
        }
        if (l.arrayBuffer)
          var c = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], f = ArrayBuffer.isView || function(N) {
            return N && c.indexOf(Object.prototype.toString.call(N)) > -1;
          };
        function d(N) {
          if (typeof N != "string" && (N = String(N)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(N) || N === "")
            throw new TypeError('Invalid character in header field name: "' + N + '"');
          return N.toLowerCase();
        }
        function h(N) {
          return typeof N != "string" && (N = String(N)), N;
        }
        function p(N) {
          var q = {
            next: function() {
              var Q = N.shift();
              return { done: Q === void 0, value: Q };
            }
          };
          return l.iterable && (q[Symbol.iterator] = function() {
            return q;
          }), q;
        }
        function g(N) {
          this.map = {}, N instanceof g ? N.forEach(function(q, Q) {
            this.append(Q, q);
          }, this) : Array.isArray(N) ? N.forEach(function(q) {
            if (q.length != 2)
              throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + q.length);
            this.append(q[0], q[1]);
          }, this) : N && Object.getOwnPropertyNames(N).forEach(function(q) {
            this.append(q, N[q]);
          }, this);
        }
        g.prototype.append = function(N, q) {
          N = d(N), q = h(q);
          var Q = this.map[N];
          this.map[N] = Q ? Q + ", " + q : q;
        }, g.prototype.delete = function(N) {
          delete this.map[d(N)];
        }, g.prototype.get = function(N) {
          return N = d(N), this.has(N) ? this.map[N] : null;
        }, g.prototype.has = function(N) {
          return this.map.hasOwnProperty(d(N));
        }, g.prototype.set = function(N, q) {
          this.map[d(N)] = h(q);
        }, g.prototype.forEach = function(N, q) {
          for (var Q in this.map)
            this.map.hasOwnProperty(Q) && N.call(q, this.map[Q], Q, this);
        }, g.prototype.keys = function() {
          var N = [];
          return this.forEach(function(q, Q) {
            N.push(Q);
          }), p(N);
        }, g.prototype.values = function() {
          var N = [];
          return this.forEach(function(q) {
            N.push(q);
          }), p(N);
        }, g.prototype.entries = function() {
          var N = [];
          return this.forEach(function(q, Q) {
            N.push([Q, q]);
          }), p(N);
        }, l.iterable && (g.prototype[Symbol.iterator] = g.prototype.entries);
        function m(N) {
          if (!N._noBody) {
            if (N.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            N.bodyUsed = !0;
          }
        }
        function v(N) {
          return new Promise(function(q, Q) {
            N.onload = function() {
              q(N.result);
            }, N.onerror = function() {
              Q(N.error);
            };
          });
        }
        function S(N) {
          var q = new FileReader(), Q = v(q);
          return q.readAsArrayBuffer(N), Q;
        }
        function _(N) {
          var q = new FileReader(), Q = v(q), ne = /charset=([A-Za-z0-9_-]+)/.exec(N.type), X = ne ? ne[1] : "utf-8";
          return q.readAsText(N, X), Q;
        }
        function b(N) {
          for (var q = new Uint8Array(N), Q = new Array(q.length), ne = 0; ne < q.length; ne++)
            Q[ne] = String.fromCharCode(q[ne]);
          return Q.join("");
        }
        function y(N) {
          if (N.slice)
            return N.slice(0);
          var q = new Uint8Array(N.byteLength);
          return q.set(new Uint8Array(N)), q.buffer;
        }
        function w() {
          return this.bodyUsed = !1, this._initBody = function(N) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = N, N ? typeof N == "string" ? this._bodyText = N : l.blob && Blob.prototype.isPrototypeOf(N) ? this._bodyBlob = N : l.formData && FormData.prototype.isPrototypeOf(N) ? this._bodyFormData = N : l.searchParams && URLSearchParams.prototype.isPrototypeOf(N) ? this._bodyText = N.toString() : l.arrayBuffer && l.blob && u(N) ? (this._bodyArrayBuffer = y(N.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : l.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(N) || f(N)) ? this._bodyArrayBuffer = y(N) : this._bodyText = N = Object.prototype.toString.call(N) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof N == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : l.searchParams && URLSearchParams.prototype.isPrototypeOf(N) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, l.blob && (this.blob = function() {
            var N = m(this);
            if (N)
              return N;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var N = m(this);
              return N || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else {
              if (l.blob)
                return this.blob().then(S);
              throw new Error("could not read as ArrayBuffer");
            }
          }, this.text = function() {
            var N = m(this);
            if (N)
              return N;
            if (this._bodyBlob)
              return _(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(b(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, l.formData && (this.formData = function() {
            return this.text().then(C);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var E = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
        function x(N) {
          var q = N.toUpperCase();
          return E.indexOf(q) > -1 ? q : N;
        }
        function k(N, q) {
          if (!(this instanceof k))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          q = q || {};
          var Q = q.body;
          if (N instanceof k) {
            if (N.bodyUsed)
              throw new TypeError("Already read");
            this.url = N.url, this.credentials = N.credentials, q.headers || (this.headers = new g(N.headers)), this.method = N.method, this.mode = N.mode, this.signal = N.signal, !Q && N._bodyInit != null && (Q = N._bodyInit, N.bodyUsed = !0);
          } else
            this.url = String(N);
          if (this.credentials = q.credentials || this.credentials || "same-origin", (q.headers || !this.headers) && (this.headers = new g(q.headers)), this.method = x(q.method || this.method || "GET"), this.mode = q.mode || this.mode || null, this.signal = q.signal || this.signal || function() {
            if ("AbortController" in a) {
              var O = new AbortController();
              return O.signal;
            }
          }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && Q)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(Q), (this.method === "GET" || this.method === "HEAD") && (q.cache === "no-store" || q.cache === "no-cache")) {
            var ne = /([?&])_=[^&]*/;
            if (ne.test(this.url))
              this.url = this.url.replace(ne, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var X = /\?/;
              this.url += (X.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        k.prototype.clone = function() {
          return new k(this, { body: this._bodyInit });
        };
        function C(N) {
          var q = new FormData();
          return N.trim().split("&").forEach(function(Q) {
            if (Q) {
              var ne = Q.split("="), X = ne.shift().replace(/\+/g, " "), O = ne.join("=").replace(/\+/g, " ");
              q.append(decodeURIComponent(X), decodeURIComponent(O));
            }
          }), q;
        }
        function M(N) {
          var q = new g(), Q = N.replace(/\r?\n[\t ]+/g, " ");
          return Q.split("\r").map(function(ne) {
            return ne.indexOf(`
`) === 0 ? ne.substr(1, ne.length) : ne;
          }).forEach(function(ne) {
            var X = ne.split(":"), O = X.shift().trim();
            if (O) {
              var W = X.join(":").trim();
              try {
                q.append(O, W);
              } catch (T) {
                console.warn("Response " + T.message);
              }
            }
          }), q;
        }
        w.call(k.prototype);
        function F(N, q) {
          if (!(this instanceof F))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          if (q || (q = {}), this.type = "default", this.status = q.status === void 0 ? 200 : q.status, this.status < 200 || this.status > 599)
            throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
          this.ok = this.status >= 200 && this.status < 300, this.statusText = q.statusText === void 0 ? "" : "" + q.statusText, this.headers = new g(q.headers), this.url = q.url || "", this._initBody(N);
        }
        w.call(F.prototype), F.prototype.clone = function() {
          return new F(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new g(this.headers),
            url: this.url
          });
        }, F.error = function() {
          var N = new F(null, { status: 200, statusText: "" });
          return N.ok = !1, N.status = 0, N.type = "error", N;
        };
        var U = [301, 302, 303, 307, 308];
        F.redirect = function(N, q) {
          if (U.indexOf(q) === -1)
            throw new RangeError("Invalid status code");
          return new F(null, { status: q, headers: { location: N } });
        }, s.DOMException = a.DOMException;
        try {
          new s.DOMException();
        } catch {
          s.DOMException = function(q, Q) {
            this.message = q, this.name = Q;
            var ne = Error(q);
            this.stack = ne.stack;
          }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
        }
        function B(N, q) {
          return new Promise(function(Q, ne) {
            var X = new k(N, q);
            if (X.signal && X.signal.aborted)
              return ne(new s.DOMException("Aborted", "AbortError"));
            var O = new XMLHttpRequest();
            function W() {
              O.abort();
            }
            O.onload = function() {
              var P = {
                statusText: O.statusText,
                headers: M(O.getAllResponseHeaders() || "")
              };
              X.url.indexOf("file://") === 0 && (O.status < 200 || O.status > 599) ? P.status = 200 : P.status = O.status, P.url = "responseURL" in O ? O.responseURL : P.headers.get("X-Request-URL");
              var H = "response" in O ? O.response : O.responseText;
              setTimeout(function() {
                Q(new F(H, P));
              }, 0);
            }, O.onerror = function() {
              setTimeout(function() {
                ne(new TypeError("Network request failed"));
              }, 0);
            }, O.ontimeout = function() {
              setTimeout(function() {
                ne(new TypeError("Network request timed out"));
              }, 0);
            }, O.onabort = function() {
              setTimeout(function() {
                ne(new s.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function T(P) {
              try {
                return P === "" && a.location.href ? a.location.href : P;
              } catch {
                return P;
              }
            }
            if (O.open(X.method, T(X.url), !0), X.credentials === "include" ? O.withCredentials = !0 : X.credentials === "omit" && (O.withCredentials = !1), "responseType" in O && (l.blob ? O.responseType = "blob" : l.arrayBuffer && (O.responseType = "arraybuffer")), q && typeof q.headers == "object" && !(q.headers instanceof g || a.Headers && q.headers instanceof a.Headers)) {
              var $ = [];
              Object.getOwnPropertyNames(q.headers).forEach(function(P) {
                $.push(d(P)), O.setRequestHeader(P, h(q.headers[P]));
              }), X.headers.forEach(function(P, H) {
                $.indexOf(H) === -1 && O.setRequestHeader(H, P);
              });
            } else
              X.headers.forEach(function(P, H) {
                O.setRequestHeader(H, P);
              });
            X.signal && (X.signal.addEventListener("abort", W), O.onreadystatechange = function() {
              O.readyState === 4 && X.signal.removeEventListener("abort", W);
            }), O.send(typeof X._bodyInit > "u" ? null : X._bodyInit);
          });
        }
        return B.polyfill = !0, a.fetch || (a.fetch = B, a.Headers = g, a.Request = k, a.Response = F), s.Headers = g, s.Request = k, s.Response = F, s.fetch = B, Object.defineProperty(s, "__esModule", { value: !0 }), s;
      })({});
    })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
    var i = n.fetch ? n : r;
    e = i.fetch, e.default = i.fetch, e.fetch = i.fetch, e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response, t.exports = e;
  }(sg, sg.exports)), sg.exports;
}
BX();
const lL = `
FRAME-1
title:000000
  color: blue
Testing 1.. 2.. 3.. 
test
===
FRAME-2
title: 2
won't you come into my room
image: image-1
test
===
FRAME-3
title: 3
hello
  color: blue
world
How are you? 
test
===
FRAME-4
title: 4
backgrounds
pause:
backdrop: image-2
pause:
backdrop: blue
pause:
backdrop: image-3
===
FRAME-5
backdrop: image-4
title: 5
box: Hello I'm a box
  background: image-5
  corner-radius: 2
  opacity: 20
  color: sixth
  blur: 50
test
===
FRAME-6
title: 6
Not in the Grid
---
image: image-1
title: 2
image: image-2
---
image: nyancat
title: 4
image: image-3
--->
Not in the Grid 
test
===
FRAME-7
title: 7
pause:
backdrop: linear-gradient(to right, #2C5364, #203A43, #0F2027);
---
pause:
backdrop: linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)
title: 1 1
...
pause:
backdrop: linear-gradient(180deg, #52ACFF 25%, #FFE32C 100%)
title: 1 2
---
pause:
title: 2 1
backdrop: linear-gradient(45deg, #FBDA61 0%, #FF5ACD 100%)
...
pause:
backdrop: linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)
blank:
---
pause:
title: 3 1
backdrop: linear-gradient(to right, #fdeff9, #ec38bc, #7303c0, #03001e)
...
pause:
title: 3 2
backdrop: linear-gradient(147deg, #FFE53B 0%, #FF2525 74%)
---
test
===
FRAME-8
title: 8
backdrop: image-4
  opacity: 50
---
title: left
backdrop: fish
  opacity: 60
...
title: middle
---
title: hello
...
title: right
backdrop: image-5
image: image-1 
---
title: test
backdrop: image-2
  opacity: 80
...
title: yes
---
test
===
FRAME-9
title: 9
read: Read Mode Engaged!
Read Mode Engaged?test
===
FRAME-10
---
title: 10
Just columns
...
image: image-3
two
test
===
FRAME-11
title: 11
Bullets
pause:
*: bullet shmullet shmullet shmullet shmullet shmullet
pause:
**: indented bullet
pause:
*: shmullet shmullet shmullet shmullet shmullet shmullet shmullet
pause:
*: potaato
#: number 1
#: number 2
test
===
FRAME-12
title: 12
---
1 1
1 2
---
2 1
2 2
---
===
FRAME-13
title: 13
test
===
FRAME-14
title: 14
test
===
FRAME-15
title: 15
test
===
FRAME-16
title: 16
test
===
FRAME-17
title: 17
test
===
FRAME-18
title: 18
test
===
FRAME-19
title: 19
test
===
FRAME-20
title: 20
test
===
FRAME-21
title: 21
`, jX = {
  getStackCfKeys: {
    __typename: "StackCfKeys",
    stackCfKeys: [{
      key: "testOwner/stack-1",
      created: 1,
      updated: 2
    }, {
      key: "testOwner/stack-2",
      created: 3,
      updated: 4
    }, {
      key: "testOwner/stack-3",
      created: 5,
      updated: 6
    }, {
      key: "testOwner/testFolder/stack-4",
      created: 7,
      updated: 8
    }]
  }
}, uS = {
  files: [{
    userDefinedName: "image-1",
    uploadedOn: 1657819952423,
    url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/a4eff37b-c89c-4b07-970a-b18d4512c900/public",
    id: "a4eff37b-c89c-4b07-970a-b18d4512c900",
    altText: "keep",
    fileType: "image/jpeg",
    ownerName: "testOwnerName",
    stackId: "testStackId",
    cloudFlareName: "testCfName",
    tags: ["ab"],
    fileName: "testFileName"
  }, {
    userDefinedName: "image-2",
    uploadedOn: 1657819902185,
    url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/97c68f64-adc4-43ad-9891-3b6e62c9ef00/public",
    id: "97c68f64-adc4-43ad-9891-3b6e62c9ef00",
    altText: "1234556",
    fileType: "image/jpeg",
    ownerName: "testOwnerName",
    stackId: "testStackId",
    cloudFlareName: "testCfName",
    tags: ["ab"],
    fileName: "testFileName"
  }, {
    userDefinedName: "image-3",
    uploadedOn: 1657820375847,
    url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/30ee173c-e355-488a-751a-d7823b4bfc00/public",
    id: "30ee173c-e355-488a-751a-d7823b4bfc00",
    altText: "keep",
    fileType: "image/jpeg",
    ownerName: "testOwnerName",
    stackId: "testStackId",
    cloudFlareName: "testCfName",
    tags: ["ab"],
    fileName: "testFileName"
  }, {
    userDefinedName: "image-4",
    uploadedOn: 1657820053391,
    url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/ec6c9f05-7727-4ea9-d18c-21c273dc1300/public",
    id: "ec6c9f05-7727-4ea9-d18c-21c273dc1300",
    altText: "words",
    fileType: "image/jpeg",
    ownerName: "testOwnerName",
    stackId: "testStackId",
    cloudFlareName: "testCfName",
    tags: ["ab"],
    fileName: "testFileName"
  }, {
    userDefinedName: "image-5",
    uploadedOn: 1657820445592,
    url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/47704b44-313d-4e03-9d27-ca42e90d3f00/public",
    id: "47704b44-313d-4e03-9d27-ca42e90d3f00",
    altText: "BBC TestCard F",
    fileType: "image/jpeg",
    ownerName: "testOwnerName",
    stackId: "testStackId",
    cloudFlareName: "testCfName",
    tags: ["ab"],
    fileName: "testFileName"
  }]
}, VX = [{
  userDefinedName: "image-1",
  url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/a4eff37b-c89c-4b07-970a-b18d4512c900/public",
  altText: "keep"
}, {
  userDefinedName: "image-2",
  url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/97c68f64-adc4-43ad-9891-3b6e62c9ef00/public",
  altText: "1234556"
}, {
  userDefinedName: "image-3",
  url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/30ee173c-e355-488a-751a-d7823b4bfc00/public",
  altText: "keep"
}, {
  userDefinedName: "image-4",
  url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/ec6c9f05-7727-4ea9-d18c-21c273dc1300/public",
  altText: "words"
}, {
  userDefinedName: "image-5",
  url: "https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/47704b44-313d-4e03-9d27-ca42e90d3f00/public",
  altText: "BBC TestCard F"
}], UX = (() => {
  const t = structuredClone(uS);
  return t.files.forEach((n) => {
    delete n.fileType, delete n.uploadedOn, delete n.id;
  }), t.files;
})(), qX = {
  audioFiles: [],
  code: lL,
  filters: ["quickpoint::default"],
  images: UX,
  dataFiles: [],
  stackId: "testStackId",
  ownerName: "test",
  stackCfKey: "test/testStack"
}, zX = {
  getStack: {
    __typename: "Stack",
    audioFiles: [],
    code: lL,
    created: 79371604,
    filters: ["quickpoint::default"],
    dataFiles: [],
    images: VX,
    ownerName: "testOwnerName",
    publish: !0,
    stackCfKey: "testOwnerName/test",
    stackId: "testStackId",
    updated: 79371604
  }
}, HX = {
  altText: "test view file",
  url: "test view file",
  userDefinedName: "test view file"
}, GX = {
  getFilterNames: [{
    filterName: "default",
    ownerName: "tkn"
  }, {
    filterName: "filter-1",
    ownerName: "tkn"
  }, {
    filterName: "filter-2",
    ownerName: "quickpoint"
  }]
};
var Cv, vC;
function Hi() {
  if (vC) return Cv;
  vC = 1;
  function t(re, se) {
    (se == null || se > re.length) && (se = re.length);
    for (var ae = 0, fe = new Array(se); ae < se; ae++) fe[ae] = re[ae];
    return fe;
  }
  function e(re) {
    if (Array.isArray(re)) return re;
  }
  function n(re, se) {
    if (!(re instanceof se))
      throw new TypeError("Cannot call a class as a function");
  }
  function r(re, se) {
    for (var ae = 0; ae < se.length; ae++) {
      var fe = se[ae];
      fe.enumerable = fe.enumerable || !1, fe.configurable = !0, "value" in fe && (fe.writable = !0), Object.defineProperty(re, fe.key, fe);
    }
  }
  function i(re, se, ae) {
    return se && r(re.prototype, se), re;
  }
  function o(re, se) {
    return se != null && typeof Symbol < "u" && se[Symbol.hasInstance] ? !!se[Symbol.hasInstance](re) : re instanceof se;
  }
  function s(re, se) {
    var ae = re == null ? null : typeof Symbol < "u" && re[Symbol.iterator] || re["@@iterator"];
    if (ae != null) {
      var fe = [], Y = !0, Re = !1, ee, Ye;
      try {
        for (ae = ae.call(re); !(Y = (ee = ae.next()).done) && (fe.push(ee.value), !(se && fe.length === se)); Y = !0)
          ;
      } catch (Te) {
        Re = !0, Ye = Te;
      } finally {
        try {
          !Y && ae.return != null && ae.return();
        } finally {
          if (Re) throw Ye;
        }
      }
      return fe;
    }
  }
  function a() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function l(re, se) {
    return e(re) || s(re, se) || u(re, se) || a();
  }
  function u(re, se) {
    if (re) {
      if (typeof re == "string") return t(re, se);
      var ae = Object.prototype.toString.call(re).slice(8, -1);
      if (ae === "Object" && re.constructor && (ae = re.constructor.name), ae === "Map" || ae === "Set") return Array.from(ae);
      if (ae === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ae)) return t(re, se);
    }
  }
  function c(re, se) {
    var ae, fe, Y, Re, ee = {
      label: 0,
      sent: function() {
        if (Y[0] & 1) throw Y[1];
        return Y[1];
      },
      trys: [],
      ops: []
    };
    return Re = {
      next: Ye(0),
      throw: Ye(1),
      return: Ye(2)
    }, typeof Symbol == "function" && (Re[Symbol.iterator] = function() {
      return this;
    }), Re;
    function Ye(ve) {
      return function(Oe) {
        return Te([
          ve,
          Oe
        ]);
      };
    }
    function Te(ve) {
      if (ae) throw new TypeError("Generator is already executing.");
      for (; ee; ) try {
        if (ae = 1, fe && (Y = ve[0] & 2 ? fe.return : ve[0] ? fe.throw || ((Y = fe.return) && Y.call(fe), 0) : fe.next) && !(Y = Y.call(fe, ve[1])).done) return Y;
        switch (fe = 0, Y && (ve = [
          ve[0] & 2,
          Y.value
        ]), ve[0]) {
          case 0:
          case 1:
            Y = ve;
            break;
          case 4:
            return ee.label++, {
              value: ve[1],
              done: !1
            };
          case 5:
            ee.label++, fe = ve[1], ve = [
              0
            ];
            continue;
          case 7:
            ve = ee.ops.pop(), ee.trys.pop();
            continue;
          default:
            if (Y = ee.trys, !(Y = Y.length > 0 && Y[Y.length - 1]) && (ve[0] === 6 || ve[0] === 2)) {
              ee = 0;
              continue;
            }
            if (ve[0] === 3 && (!Y || ve[1] > Y[0] && ve[1] < Y[3])) {
              ee.label = ve[1];
              break;
            }
            if (ve[0] === 6 && ee.label < Y[1]) {
              ee.label = Y[1], Y = ve;
              break;
            }
            if (Y && ee.label < Y[2]) {
              ee.label = Y[2], ee.ops.push(ve);
              break;
            }
            Y[2] && ee.ops.pop(), ee.trys.pop();
            continue;
        }
        ve = se.call(re, ee);
      } catch (Oe) {
        ve = [
          6,
          Oe
        ], fe = 0;
      } finally {
        ae = Y = 0;
      }
      if (ve[0] & 5) throw ve[1];
      return {
        value: ve[0] ? ve[1] : void 0,
        done: !0
      };
    }
  }
  var f = Object.create, d = Object.defineProperty, h = Object.getOwnPropertyDescriptor, p = Object.getOwnPropertyNames, g = Object.getPrototypeOf, m = Object.prototype.hasOwnProperty, v = function(re, se) {
    return function() {
      return se || (0, re[p(re)[0]])((se = {
        exports: {}
      }).exports, se), se.exports;
    };
  }, S = function(re, se) {
    for (var ae in se) d(re, ae, {
      get: se[ae],
      enumerable: !0
    });
  }, _ = function(re, se, ae, fe) {
    if (se && typeof se == "object" || typeof se == "function") {
      var Y = !0, Re = !1, ee = void 0;
      try {
        for (var Ye = function() {
          var Oe = ve.value;
          !m.call(re, Oe) && Oe !== ae && d(re, Oe, {
            get: function() {
              return se[Oe];
            },
            enumerable: !(fe = h(se, Oe)) || fe.enumerable
          });
        }, Te = p(se)[Symbol.iterator](), ve; !(Y = (ve = Te.next()).done); Y = !0) Ye();
      } catch (Oe) {
        Re = !0, ee = Oe;
      } finally {
        try {
          !Y && Te.return != null && Te.return();
        } finally {
          if (Re)
            throw ee;
        }
      }
    }
    return re;
  }, b = function(re, se, ae) {
    return ae = re != null ? f(g(re)) : {}, _(!re || !re.__esModule ? d(ae, "default", {
      value: re,
      enumerable: !0
    }) : ae, re);
  }, y = function(re) {
    return _(d({}, "__esModule", {
      value: !0
    }), re);
  }, w = v({
    "node_modules/set-cookie-parser/lib/set-cookie.js": function(re, se) {
      var ae = function(ve) {
        return typeof ve == "string" && !!ve.trim();
      }, fe = function(ve, Oe) {
        var Je = ve.split(";").filter(ae), pt = Je.shift(), Pt = Y(pt), bt = Pt.name, Ft = Pt.value;
        Oe = Oe ? Object.assign({}, Ye, Oe) : Ye;
        try {
          Ft = Oe.decodeValues ? decodeURIComponent(Ft) : Ft;
        } catch (ln) {
          console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + Ft + "'. Set options.decodeValues to false to disable this feature.", ln);
        }
        var mt = {
          name: bt,
          value: Ft
        };
        return Je.forEach(function(ln) {
          var jn = ln.split("="), $t = jn.shift().trimLeft().toLowerCase(), Tr = jn.join("=");
          $t === "expires" ? mt.expires = new Date(Tr) : $t === "max-age" ? mt.maxAge = parseInt(Tr, 10) : $t === "secure" ? mt.secure = !0 : $t === "httponly" ? mt.httpOnly = !0 : $t === "samesite" ? mt.sameSite = Tr : mt[$t] = Tr;
        }), mt;
      }, Y = function(ve) {
        var Oe = "", Je = "", pt = ve.split("=");
        return pt.length > 1 ? (Oe = pt.shift(), Je = pt.join("=")) : Je = ve, {
          name: Oe,
          value: Je
        };
      }, Re = function(ve, Oe) {
        if (Oe = Oe ? Object.assign({}, Ye, Oe) : Ye, !ve)
          return Oe.map ? {} : [];
        if (ve.headers)
          if (typeof ve.headers.getSetCookie == "function")
            ve = ve.headers.getSetCookie();
          else if (ve.headers["set-cookie"])
            ve = ve.headers["set-cookie"];
          else {
            var Je = ve.headers[Object.keys(ve.headers).find(function(Pt) {
              return Pt.toLowerCase() === "set-cookie";
            })];
            !Je && ve.headers.cookie && !Oe.silent && console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."), ve = Je;
          }
        if (Array.isArray(ve) || (ve = [
          ve
        ]), Oe = Oe ? Object.assign({}, Ye, Oe) : Ye, Oe.map) {
          var pt = {};
          return ve.filter(ae).reduce(function(Pt, bt) {
            var Ft = fe(bt, Oe);
            return Pt[Ft.name] = Ft, Pt;
          }, pt);
        } else
          return ve.filter(ae).map(function(Pt) {
            return fe(Pt, Oe);
          });
      }, ee = function(ve) {
        if (Array.isArray(ve))
          return ve;
        if (typeof ve != "string")
          return [];
        var Oe = [], Je = 0, pt, Pt, bt, Ft, mt;
        function ln() {
          for (; Je < ve.length && /\s/.test(ve.charAt(Je)); )
            Je += 1;
          return Je < ve.length;
        }
        function jn() {
          return Pt = ve.charAt(Je), Pt !== "=" && Pt !== ";" && Pt !== ",";
        }
        for (; Je < ve.length; ) {
          for (pt = Je, mt = !1; ln(); )
            if (Pt = ve.charAt(Je), Pt === ",") {
              for (bt = Je, Je += 1, ln(), Ft = Je; Je < ve.length && jn(); )
                Je += 1;
              Je < ve.length && ve.charAt(Je) === "=" ? (mt = !0, Je = Ft, Oe.push(ve.substring(pt, bt)), pt = Je) : Je = bt + 1;
            } else
              Je += 1;
          (!mt || Je >= ve.length) && Oe.push(ve.substring(pt, ve.length));
        }
        return Oe;
      }, Ye = {
        decodeValues: !0,
        map: !1,
        silent: !1
      };
      se.exports = Re, se.exports.parse = Re, se.exports.parseString = fe, se.exports.splitCookiesString = ee;
    }
  }), E = {};
  S(E, {
    Headers: function() {
      return T;
    },
    flattenHeadersList: function() {
      return me;
    },
    flattenHeadersObject: function() {
      return oe;
    },
    headersToList: function() {
      return $;
    },
    headersToObject: function() {
      return Z;
    },
    headersToString: function() {
      return P;
    },
    listToHeaders: function() {
      return J;
    },
    objectToHeaders: function() {
      return he;
    },
    reduceHeadersObject: function() {
      return ue;
    },
    stringToHeaders: function() {
      return le;
    }
  }), Cv = y(E);
  var x = b(w()), k = /[^a-z0-9\-#$%&'*+.^_`|~]/i;
  function C(re) {
    if (k.test(re) || re.trim() === "")
      throw new TypeError("Invalid character in header field name");
    return re.trim().toLowerCase();
  }
  var M = [
    `
`,
    "\r",
    "	",
    " "
  ], F = new RegExp("(^[".concat(M.join(""), "]|$[").concat(M.join(""), "])"), "g");
  function U(re) {
    var se = re.replace(F, "");
    return se;
  }
  function B(re) {
    if (typeof re != "string" || re.length === 0)
      return !1;
    for (var se = 0; se < re.length; se++) {
      var ae = re.charCodeAt(se);
      if (ae > 127 || !N(ae))
        return !1;
    }
    return !0;
  }
  function N(re) {
    return ![
      127,
      32,
      "(",
      ")",
      "<",
      ">",
      "@",
      ",",
      ";",
      ":",
      "\\",
      '"',
      "/",
      "[",
      "]",
      "?",
      "=",
      "{",
      "}"
    ].includes(re);
  }
  function q(re) {
    if (typeof re != "string" || re.trim() !== re)
      return !1;
    for (var se = 0; se < re.length; se++) {
      var ae = re.charCodeAt(se);
      if (ae === 0 || ae === 10 || ae === 13)
        return !1;
    }
    return !0;
  }
  var Q = Symbol("normalizedHeaders"), ne = Symbol("rawHeaderNames"), X = ", ", O, W, T = /* @__PURE__ */ function() {
    function re(se) {
      var ae = this;
      n(this, re);
      var fe;
      if (this[O] = {}, this[W] = /* @__PURE__ */ new Map(), [
        "Headers",
        "HeadersPolyfill"
      ].includes((fe = se) === null || fe === void 0 ? void 0 : fe.constructor.name) || o(se, T)) {
        var Y = se;
        Y.forEach(function(Re, ee) {
          ae.append(ee, Re);
        }, this);
      } else Array.isArray(se) ? se.forEach(function(Re) {
        var ee = l(Re, 2), Ye = ee[0], Te = ee[1];
        ae.append(Ye, Array.isArray(Te) ? Te.join(X) : Te);
      }) : se && Object.getOwnPropertyNames(se).forEach(function(Re) {
        var ee = se[Re];
        ae.append(Re, Array.isArray(ee) ? ee.join(X) : ee);
      });
    }
    return i(re, [
      {
        key: (O = Q, W = ne, Symbol.iterator),
        value: function() {
          return this.entries();
        }
      },
      {
        key: "keys",
        value: function() {
          var ae, fe, Y, Re, ee, Ye, Te, ve;
          return c(this, function(Oe) {
            switch (Oe.label) {
              case 0:
                ae = !0, fe = !1, Y = void 0, Oe.label = 1;
              case 1:
                Oe.trys.push([
                  1,
                  6,
                  7,
                  8
                ]), Re = this.entries()[Symbol.iterator](), Oe.label = 2;
              case 2:
                return (ae = (ee = Re.next()).done) ? [
                  3,
                  5
                ] : (Ye = l(ee.value, 1), Te = Ye[0], [
                  4,
                  Te
                ]);
              case 3:
                Oe.sent(), Oe.label = 4;
              case 4:
                return ae = !0, [
                  3,
                  2
                ];
              case 5:
                return [
                  3,
                  8
                ];
              case 6:
                return ve = Oe.sent(), fe = !0, Y = ve, [
                  3,
                  8
                ];
              case 7:
                try {
                  !ae && Re.return != null && Re.return();
                } finally {
                  if (fe)
                    throw Y;
                }
                return [
                  7
                ];
              case 8:
                return [
                  2
                ];
            }
          });
        }
      },
      {
        key: "values",
        value: function() {
          var ae, fe, Y, Re, ee, Ye, Te, ve;
          return c(this, function(Oe) {
            switch (Oe.label) {
              case 0:
                ae = !0, fe = !1, Y = void 0, Oe.label = 1;
              case 1:
                Oe.trys.push([
                  1,
                  6,
                  7,
                  8
                ]), Re = this.entries()[Symbol.iterator](), Oe.label = 2;
              case 2:
                return (ae = (ee = Re.next()).done) ? [
                  3,
                  5
                ] : (Ye = l(ee.value, 2), Te = Ye[1], [
                  4,
                  Te
                ]);
              case 3:
                Oe.sent(), Oe.label = 4;
              case 4:
                return ae = !0, [
                  3,
                  2
                ];
              case 5:
                return [
                  3,
                  8
                ];
              case 6:
                return ve = Oe.sent(), fe = !0, Y = ve, [
                  3,
                  8
                ];
              case 7:
                try {
                  !ae && Re.return != null && Re.return();
                } finally {
                  if (fe)
                    throw Y;
                }
                return [
                  7
                ];
              case 8:
                return [
                  2
                ];
            }
          });
        }
      },
      {
        key: "entries",
        value: function() {
          var ae, fe, Y, Re, ee, Ye, Te, ve, Oe, Je, pt, Pt, bt, Ft, Ft;
          return c(this, function(mt) {
            switch (mt.label) {
              case 0:
                ae = Object.keys(this[Q]).sort(function(ln, jn) {
                  return ln.localeCompare(jn);
                }), fe = !0, Y = !1, Re = void 0, mt.label = 1;
              case 1:
                mt.trys.push([
                  1,
                  15,
                  16,
                  17
                ]), ee = ae[Symbol.iterator](), mt.label = 2;
              case 2:
                if (fe = (Ye = ee.next()).done) return [
                  3,
                  14
                ];
                if (Te = Ye.value, Te !== "set-cookie") return [
                  3,
                  11
                ];
                ve = !0, Oe = !1, Je = void 0, mt.label = 3;
              case 3:
                mt.trys.push([
                  3,
                  8,
                  9,
                  10
                ]), pt = this.getSetCookie()[Symbol.iterator](), mt.label = 4;
              case 4:
                return (ve = (Pt = pt.next()).done) ? [
                  3,
                  7
                ] : (bt = Pt.value, [
                  4,
                  [
                    Te,
                    bt
                  ]
                ]);
              case 5:
                mt.sent(), mt.label = 6;
              case 6:
                return ve = !0, [
                  3,
                  4
                ];
              case 7:
                return [
                  3,
                  10
                ];
              case 8:
                return Ft = mt.sent(), Oe = !0, Je = Ft, [
                  3,
                  10
                ];
              case 9:
                try {
                  !ve && pt.return != null && pt.return();
                } finally {
                  if (Oe)
                    throw Je;
                }
                return [
                  7
                ];
              case 10:
                return [
                  3,
                  13
                ];
              case 11:
                return [
                  4,
                  [
                    Te,
                    this.get(Te)
                  ]
                ];
              case 12:
                mt.sent(), mt.label = 13;
              case 13:
                return fe = !0, [
                  3,
                  2
                ];
              case 14:
                return [
                  3,
                  17
                ];
              case 15:
                return Ft = mt.sent(), Y = !0, Re = Ft, [
                  3,
                  17
                ];
              case 16:
                try {
                  !fe && ee.return != null && ee.return();
                } finally {
                  if (Y)
                    throw Re;
                }
                return [
                  7
                ];
              case 17:
                return [
                  2
                ];
            }
          });
        }
      },
      {
        key: "has",
        value: function(ae) {
          if (!B(ae))
            throw new TypeError('Invalid header name "'.concat(ae, '"'));
          return this[Q].hasOwnProperty(C(ae));
        }
      },
      {
        key: "get",
        value: function(ae) {
          if (!B(ae))
            throw TypeError('Invalid header name "'.concat(ae, '"'));
          var fe;
          return (fe = this[Q][C(ae)]) !== null && fe !== void 0 ? fe : null;
        }
      },
      {
        key: "set",
        value: function(ae, fe) {
          if (!(!B(ae) || !q(fe))) {
            var Y = C(ae), Re = U(fe);
            this[Q][Y] = U(Re), this[ne].set(Y, ae);
          }
        }
      },
      {
        key: "append",
        value: function(ae, fe) {
          if (!(!B(ae) || !q(fe))) {
            var Y = C(ae), Re = U(fe), ee = this.has(Y) ? "".concat(this.get(Y), ", ").concat(Re) : Re;
            this.set(ae, ee);
          }
        }
      },
      {
        key: "delete",
        value: function(ae) {
          if (B(ae) && this.has(ae)) {
            var fe = C(ae);
            delete this[Q][fe], this[ne].delete(fe);
          }
        }
      },
      {
        key: "all",
        value: function() {
          return this[Q];
        }
      },
      {
        key: "raw",
        value: function() {
          var ae = {}, fe = !0, Y = !1, Re = void 0;
          try {
            for (var ee = this.entries()[Symbol.iterator](), Ye; !(fe = (Ye = ee.next()).done); fe = !0) {
              var Te = l(Ye.value, 2), ve = Te[0], Oe = Te[1];
              ae[this[ne].get(ve)] = Oe;
            }
          } catch (Je) {
            Y = !0, Re = Je;
          } finally {
            try {
              !fe && ee.return != null && ee.return();
            } finally {
              if (Y)
                throw Re;
            }
          }
          return ae;
        }
      },
      {
        key: "forEach",
        value: function(ae, fe) {
          var Y = !0, Re = !1, ee = void 0;
          try {
            for (var Ye = this.entries()[Symbol.iterator](), Te; !(Y = (Te = Ye.next()).done); Y = !0) {
              var ve = l(Te.value, 2), Oe = ve[0], Je = ve[1];
              ae.call(fe, Je, Oe, this);
            }
          } catch (pt) {
            Re = !0, ee = pt;
          } finally {
            try {
              !Y && Ye.return != null && Ye.return();
            } finally {
              if (Re)
                throw ee;
            }
          }
        }
      },
      {
        key: "getSetCookie",
        value: function() {
          var ae = this.get("set-cookie");
          return ae === null ? [] : ae === "" ? [
            ""
          ] : (0, x.splitCookiesString)(ae);
        }
      }
    ]), re;
  }();
  function $(re) {
    var se = [];
    return re.forEach(function(ae, fe) {
      var Y = ae.includes(",") ? ae.split(",").map(function(Re) {
        return Re.trim();
      }) : ae;
      se.push([
        fe,
        Y
      ]);
    }), se;
  }
  function P(re) {
    var se = $(re), ae = se.map(function(fe) {
      var Y = l(fe, 2), Re = Y[0], ee = Y[1], Ye = [].concat(ee);
      return "".concat(Re, ": ").concat(Ye.join(", "));
    });
    return ae.join(`\r
`);
  }
  var H = [
    "user-agent"
  ];
  function Z(re) {
    var se = {};
    return re.forEach(function(ae, fe) {
      var Y = !H.includes(fe.toLowerCase()) && ae.includes(",");
      se[fe] = Y ? ae.split(",").map(function(Re) {
        return Re.trim();
      }) : ae;
    }), se;
  }
  function le(re) {
    var se = re.trim().split(/[\r\n]+/);
    return se.reduce(function(ae, fe) {
      if (fe.trim() === "")
        return ae;
      var Y = fe.split(": "), Re = Y.shift(), ee = Y.join(": ");
      return ae.append(Re, ee), ae;
    }, new T());
  }
  function J(re) {
    var se = new T();
    return re.forEach(function(ae) {
      var fe = l(ae, 2), Y = fe[0], Re = fe[1], ee = [].concat(Re);
      ee.forEach(function(Ye) {
        se.append(Y, Ye);
      });
    }), se;
  }
  function ue(re, se, ae) {
    return Object.keys(re).reduce(function(fe, Y) {
      return se(fe, Y, re[Y]);
    }, ae);
  }
  function he(re) {
    return ue(re, function(se, ae, fe) {
      var Y = [].concat(fe).filter(Boolean);
      return Y.forEach(function(Re) {
        se.append(ae, Re);
      }), se;
    }, new T());
  }
  function me(re) {
    return re.map(function(se) {
      var ae = l(se, 2), fe = ae[0], Y = ae[1];
      return [
        fe,
        [].concat(Y).join(", ")
      ];
    });
  }
  function oe(re) {
    return ue(re, function(se, ae, fe) {
      return se[ae] = [].concat(fe).join(", "), se;
    }, {});
  }
  return Cv;
}
var ag = {};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var bC;
function Av() {
  if (bC) return ag;
  bC = 1, ag.parse = r, ag.serialize = i;
  var t = decodeURIComponent, e = encodeURIComponent, n = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
  function r(s, a) {
    if (typeof s != "string")
      throw new TypeError("argument str must be a string");
    for (var l = {}, u = a || {}, c = s.split(";"), f = u.decode || t, d = 0; d < c.length; d++) {
      var h = c[d], p = h.indexOf("=");
      if (!(p < 0)) {
        var g = h.substring(0, p).trim();
        if (l[g] == null) {
          var m = h.substring(p + 1, h.length).trim();
          m[0] === '"' && (m = m.slice(1, -1)), l[g] = o(m, f);
        }
      }
    }
    return l;
  }
  function i(s, a, l) {
    var u = l || {}, c = u.encode || e;
    if (typeof c != "function")
      throw new TypeError("option encode is invalid");
    if (!n.test(s))
      throw new TypeError("argument name is invalid");
    var f = c(a);
    if (f && !n.test(f))
      throw new TypeError("argument val is invalid");
    var d = s + "=" + f;
    if (u.maxAge != null) {
      var h = u.maxAge - 0;
      if (isNaN(h) || !isFinite(h))
        throw new TypeError("option maxAge is invalid");
      d += "; Max-Age=" + Math.floor(h);
    }
    if (u.domain) {
      if (!n.test(u.domain))
        throw new TypeError("option domain is invalid");
      d += "; Domain=" + u.domain;
    }
    if (u.path) {
      if (!n.test(u.path))
        throw new TypeError("option path is invalid");
      d += "; Path=" + u.path;
    }
    if (u.expires) {
      if (typeof u.expires.toUTCString != "function")
        throw new TypeError("option expires is invalid");
      d += "; Expires=" + u.expires.toUTCString();
    }
    if (u.httpOnly && (d += "; HttpOnly"), u.secure && (d += "; Secure"), u.sameSite) {
      var p = typeof u.sameSite == "string" ? u.sameSite.toLowerCase() : u.sameSite;
      switch (p) {
        case !0:
          d += "; SameSite=Strict";
          break;
        case "lax":
          d += "; SameSite=Lax";
          break;
        case "strict":
          d += "; SameSite=Strict";
          break;
        case "none":
          d += "; SameSite=None";
          break;
        default:
          throw new TypeError("option sameSite is invalid");
      }
    }
    return d;
  }
  function o(s, a) {
    try {
      return a(s);
    } catch {
      return s;
    }
  }
  return ag;
}
var Rv, wC;
function Ov() {
  if (wC) return Rv;
  wC = 1;
  var t = Object.defineProperty, e = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, r = Object.prototype.hasOwnProperty, i = (u, c) => {
    for (var f in c)
      t(u, f, { get: c[f], enumerable: !0 });
  }, o = (u, c, f, d) => {
    if (c && typeof c == "object" || typeof c == "function")
      for (let h of n(c))
        !r.call(u, h) && h !== f && t(u, h, { get: () => c[h], enumerable: !(d = e(c, h)) || d.enumerable });
    return u;
  }, s = (u) => o(t({}, "__esModule", { value: !0 }), u), a = {};
  i(a, {
    isNodeProcess: () => l
  }), Rv = s(a);
  function l() {
    if (typeof navigator < "u" && navigator.product === "ReactNative")
      return !0;
    if (typeof process < "u") {
      const u = process.type;
      return u === "renderer" || u === "worker" ? !1 : !!(process.versions && process.versions.node);
    }
    return !1;
  }
  return Rv;
}
var lg = { exports: {} }, SC;
function WX() {
  return SC || (SC = 1, function(t, e) {
    var n = function() {
      if (typeof self < "u")
        return self;
      if (typeof window < "u")
        return window;
      if (typeof zo < "u")
        return zo;
      throw new Error("unable to locate global object");
    }, r = n();
    t.exports = e = r.fetch, r.fetch && (e.default = r.fetch.bind(r)), e.Headers = r.Headers, e.Request = r.Request, e.Response = r.Response;
  }(lg, lg.exports)), lg.exports;
}
var Dv, _C;
function ta() {
  if (_C) return Dv;
  _C = 1;
  var t = Object.defineProperty, e = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, r = Object.prototype.hasOwnProperty, i = (g, m) => {
    for (var v in m)
      t(g, v, { get: m[v], enumerable: !0 });
  }, o = (g, m, v, S) => {
    if (m && typeof m == "object" || typeof m == "function")
      for (let _ of n(m))
        !r.call(g, _) && _ !== v && t(g, _, { get: () => m[_], enumerable: !(S = e(m, _)) || S.enumerable });
    return g;
  }, s = (g) => o(t({}, "__esModule", { value: !0 }), g), a = {};
  i(a, {
    InvariantError: () => h,
    format: () => c,
    invariant: () => p
  }), Dv = s(a);
  var l = /(%?)(%([sdijo]))/g;
  function u(g, m) {
    switch (m) {
      case "s":
        return g;
      case "d":
      case "i":
        return Number(g);
      case "j":
        return JSON.stringify(g);
      case "o": {
        if (typeof g == "string")
          return g;
        const v = JSON.stringify(g);
        return v === "{}" || v === "[]" || /^\[object .+?\]$/.test(v) ? g : v;
      }
    }
  }
  function c(g, ...m) {
    if (m.length === 0)
      return g;
    let v = 0, S = g.replace(
      l,
      (_, b, y, w) => {
        const E = m[v], x = u(E, w);
        return b ? _ : (v++, x);
      }
    );
    return v < m.length && (S += ` ${m.slice(v).join(" ")}`), S = S.replace(/%{2,2}/g, "%"), S;
  }
  var f = 2;
  function d(g) {
    if (!g.stack)
      return;
    const m = g.stack.split(`
`);
    m.splice(1, f), g.stack = m.join(`
`);
  }
  var h = class extends Error {
    constructor(g, ...m) {
      super(g), this.message = g, this.name = "Invariant Violation", this.message = c(g, ...m), d(this);
    }
  }, p = (g, m, ...v) => {
    if (!g)
      throw new h(m, ...v);
  };
  return p.as = (g, m, v, ...S) => {
    if (!m) {
      const _ = S.length === 0 ? v : c(v, ...S);
      let b;
      try {
        b = Reflect.construct(g, [
          _
        ]);
      } catch {
        b = g(_);
      }
      throw b;
    }
  }, Dv;
}
var ug = {}, cg = {}, EC;
function YX() {
  return EC || (EC = 1, Object.defineProperty(cg, "__esModule", { value: !0 }), cg.until = async (t) => {
    try {
      return [null, await t().catch((n) => {
        throw n;
      })];
    } catch (e) {
      return [e, null];
    }
  }), cg;
}
var kC;
function sc() {
  if (kC) return ug;
  kC = 1, Object.defineProperty(ug, "__esModule", { value: !0 });
  var t = YX();
  return ug.until = t.until, ug;
}
var Dl = {}, Hf = {}, TC;
function LE() {
  return TC || (TC = 1, Object.defineProperty(Hf, "__esModule", { value: !0 }), Hf.IS_PATCHED_MODULE = void 0, Hf.IS_PATCHED_MODULE = Symbol("isPatchedModule")), Hf;
}
var Gf = {}, fg = { exports: {} }, Iv, xC;
function XX() {
  if (xC) return Iv;
  xC = 1;
  var t = 1e3, e = t * 60, n = e * 60, r = n * 24, i = r * 7, o = r * 365.25;
  Iv = function(c, f) {
    f = f || {};
    var d = typeof c;
    if (d === "string" && c.length > 0)
      return s(c);
    if (d === "number" && isFinite(c))
      return f.long ? l(c) : a(c);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(c)
    );
  };
  function s(c) {
    if (c = String(c), !(c.length > 100)) {
      var f = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        c
      );
      if (f) {
        var d = parseFloat(f[1]), h = (f[2] || "ms").toLowerCase();
        switch (h) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return d * o;
          case "weeks":
          case "week":
          case "w":
            return d * i;
          case "days":
          case "day":
          case "d":
            return d * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return d * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return d * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return d * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return d;
          default:
            return;
        }
      }
    }
  }
  function a(c) {
    var f = Math.abs(c);
    return f >= r ? Math.round(c / r) + "d" : f >= n ? Math.round(c / n) + "h" : f >= e ? Math.round(c / e) + "m" : f >= t ? Math.round(c / t) + "s" : c + "ms";
  }
  function l(c) {
    var f = Math.abs(c);
    return f >= r ? u(c, f, r, "day") : f >= n ? u(c, f, n, "hour") : f >= e ? u(c, f, e, "minute") : f >= t ? u(c, f, t, "second") : c + " ms";
  }
  function u(c, f, d, h) {
    var p = f >= d * 1.5;
    return Math.round(c / d) + " " + h + (p ? "s" : "");
  }
  return Iv;
}
var Nv, CC;
function KX() {
  if (CC) return Nv;
  CC = 1;
  function t(e) {
    r.debug = r, r.default = r, r.coerce = u, r.disable = a, r.enable = o, r.enabled = l, r.humanize = XX(), r.destroy = c, Object.keys(e).forEach((f) => {
      r[f] = e[f];
    }), r.names = [], r.skips = [], r.formatters = {};
    function n(f) {
      let d = 0;
      for (let h = 0; h < f.length; h++)
        d = (d << 5) - d + f.charCodeAt(h), d |= 0;
      return r.colors[Math.abs(d) % r.colors.length];
    }
    r.selectColor = n;
    function r(f) {
      let d, h = null, p, g;
      function m(...v) {
        if (!m.enabled)
          return;
        const S = m, _ = Number(/* @__PURE__ */ new Date()), b = _ - (d || _);
        S.diff = b, S.prev = d, S.curr = _, d = _, v[0] = r.coerce(v[0]), typeof v[0] != "string" && v.unshift("%O");
        let y = 0;
        v[0] = v[0].replace(/%([a-zA-Z%])/g, (E, x) => {
          if (E === "%%")
            return "%";
          y++;
          const k = r.formatters[x];
          if (typeof k == "function") {
            const C = v[y];
            E = k.call(S, C), v.splice(y, 1), y--;
          }
          return E;
        }), r.formatArgs.call(S, v), (S.log || r.log).apply(S, v);
      }
      return m.namespace = f, m.useColors = r.useColors(), m.color = r.selectColor(f), m.extend = i, m.destroy = r.destroy, Object.defineProperty(m, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: () => h !== null ? h : (p !== r.namespaces && (p = r.namespaces, g = r.enabled(f)), g),
        set: (v) => {
          h = v;
        }
      }), typeof r.init == "function" && r.init(m), m;
    }
    function i(f, d) {
      const h = r(this.namespace + (typeof d > "u" ? ":" : d) + f);
      return h.log = this.log, h;
    }
    function o(f) {
      r.save(f), r.namespaces = f, r.names = [], r.skips = [];
      const d = (typeof f == "string" ? f : "").trim().replace(" ", ",").split(",").filter(Boolean);
      for (const h of d)
        h[0] === "-" ? r.skips.push(h.slice(1)) : r.names.push(h);
    }
    function s(f, d) {
      let h = 0, p = 0, g = -1, m = 0;
      for (; h < f.length; )
        if (p < d.length && (d[p] === f[h] || d[p] === "*"))
          d[p] === "*" ? (g = p, m = h, p++) : (h++, p++);
        else if (g !== -1)
          p = g + 1, m++, h = m;
        else
          return !1;
      for (; p < d.length && d[p] === "*"; )
        p++;
      return p === d.length;
    }
    function a() {
      const f = [
        ...r.names,
        ...r.skips.map((d) => "-" + d)
      ].join(",");
      return r.enable(""), f;
    }
    function l(f) {
      for (const d of r.skips)
        if (s(f, d))
          return !1;
      for (const d of r.names)
        if (s(f, d))
          return !0;
      return !1;
    }
    function u(f) {
      return f instanceof Error ? f.stack || f.message : f;
    }
    function c() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    return r.enable(r.load()), r;
  }
  return Nv = t, Nv;
}
var AC;
function uL() {
  return AC || (AC = 1, function(t, e) {
    e.formatArgs = r, e.save = i, e.load = o, e.useColors = n, e.storage = s(), e.destroy = /* @__PURE__ */ (() => {
      let l = !1;
      return () => {
        l || (l = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      };
    })(), e.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs))
        return !0;
      if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))
        return !1;
      let l;
      return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && (l = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(l[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function r(l) {
      if (l[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + l[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors)
        return;
      const u = "color: " + this.color;
      l.splice(1, 0, u, "color: inherit");
      let c = 0, f = 0;
      l[0].replace(/%[a-zA-Z%]/g, (d) => {
        d !== "%%" && (c++, d === "%c" && (f = c));
      }), l.splice(f, 0, u);
    }
    e.log = console.debug || console.log || (() => {
    });
    function i(l) {
      try {
        l ? e.storage.setItem("debug", l) : e.storage.removeItem("debug");
      } catch {
      }
    }
    function o() {
      let l;
      try {
        l = e.storage.getItem("debug");
      } catch {
      }
      return !l && typeof process < "u" && "env" in process && (l = process.env.DEBUG), l;
    }
    function s() {
      try {
        return localStorage;
      } catch {
      }
    }
    t.exports = KX()(e);
    const { formatters: a } = t.exports;
    a.j = function(l) {
      try {
        return JSON.stringify(l);
      } catch (u) {
        return "[UnexpectedJSONParseError]: " + u.message;
      }
    };
  }(fg, fg.exports)), fg.exports;
}
var ji = {}, Il = {}, js = {}, dg = { exports: {} }, RC;
function QX() {
  if (RC) return dg.exports;
  RC = 1;
  var t = typeof Reflect == "object" ? Reflect : null, e = t && typeof t.apply == "function" ? t.apply : function(y, w, E) {
    return Function.prototype.apply.call(y, w, E);
  }, n;
  t && typeof t.ownKeys == "function" ? n = t.ownKeys : Object.getOwnPropertySymbols ? n = function(y) {
    return Object.getOwnPropertyNames(y).concat(Object.getOwnPropertySymbols(y));
  } : n = function(y) {
    return Object.getOwnPropertyNames(y);
  };
  function r(b) {
    console && console.warn && console.warn(b);
  }
  var i = Number.isNaN || function(y) {
    return y !== y;
  };
  function o() {
    o.init.call(this);
  }
  dg.exports = o, dg.exports.once = v, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function a(b) {
    if (typeof b != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof b);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(b) {
      if (typeof b != "number" || b < 0 || i(b))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + b + ".");
      s = b;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(y) {
    if (typeof y != "number" || y < 0 || i(y))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + y + ".");
    return this._maxListeners = y, this;
  };
  function l(b) {
    return b._maxListeners === void 0 ? o.defaultMaxListeners : b._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return l(this);
  }, o.prototype.emit = function(y) {
    for (var w = [], E = 1; E < arguments.length; E++) w.push(arguments[E]);
    var x = y === "error", k = this._events;
    if (k !== void 0)
      x = x && k.error === void 0;
    else if (!x)
      return !1;
    if (x) {
      var C;
      if (w.length > 0 && (C = w[0]), C instanceof Error)
        throw C;
      var M = new Error("Unhandled error." + (C ? " (" + C.message + ")" : ""));
      throw M.context = C, M;
    }
    var F = k[y];
    if (F === void 0)
      return !1;
    if (typeof F == "function")
      e(F, this, w);
    else
      for (var U = F.length, B = p(F, U), E = 0; E < U; ++E)
        e(B[E], this, w);
    return !0;
  };
  function u(b, y, w, E) {
    var x, k, C;
    if (a(w), k = b._events, k === void 0 ? (k = b._events = /* @__PURE__ */ Object.create(null), b._eventsCount = 0) : (k.newListener !== void 0 && (b.emit(
      "newListener",
      y,
      w.listener ? w.listener : w
    ), k = b._events), C = k[y]), C === void 0)
      C = k[y] = w, ++b._eventsCount;
    else if (typeof C == "function" ? C = k[y] = E ? [w, C] : [C, w] : E ? C.unshift(w) : C.push(w), x = l(b), x > 0 && C.length > x && !C.warned) {
      C.warned = !0;
      var M = new Error("Possible EventEmitter memory leak detected. " + C.length + " " + String(y) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      M.name = "MaxListenersExceededWarning", M.emitter = b, M.type = y, M.count = C.length, r(M);
    }
    return b;
  }
  o.prototype.addListener = function(y, w) {
    return u(this, y, w, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(y, w) {
    return u(this, y, w, !0);
  };
  function c() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(b, y, w) {
    var E = { fired: !1, wrapFn: void 0, target: b, type: y, listener: w }, x = c.bind(E);
    return x.listener = w, E.wrapFn = x, x;
  }
  o.prototype.once = function(y, w) {
    return a(w), this.on(y, f(this, y, w)), this;
  }, o.prototype.prependOnceListener = function(y, w) {
    return a(w), this.prependListener(y, f(this, y, w)), this;
  }, o.prototype.removeListener = function(y, w) {
    var E, x, k, C, M;
    if (a(w), x = this._events, x === void 0)
      return this;
    if (E = x[y], E === void 0)
      return this;
    if (E === w || E.listener === w)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete x[y], x.removeListener && this.emit("removeListener", y, E.listener || w));
    else if (typeof E != "function") {
      for (k = -1, C = E.length - 1; C >= 0; C--)
        if (E[C] === w || E[C].listener === w) {
          M = E[C].listener, k = C;
          break;
        }
      if (k < 0)
        return this;
      k === 0 ? E.shift() : g(E, k), E.length === 1 && (x[y] = E[0]), x.removeListener !== void 0 && this.emit("removeListener", y, M || w);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(y) {
    var w, E, x;
    if (E = this._events, E === void 0)
      return this;
    if (E.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : E[y] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete E[y]), this;
    if (arguments.length === 0) {
      var k = Object.keys(E), C;
      for (x = 0; x < k.length; ++x)
        C = k[x], C !== "removeListener" && this.removeAllListeners(C);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (w = E[y], typeof w == "function")
      this.removeListener(y, w);
    else if (w !== void 0)
      for (x = w.length - 1; x >= 0; x--)
        this.removeListener(y, w[x]);
    return this;
  };
  function d(b, y, w) {
    var E = b._events;
    if (E === void 0)
      return [];
    var x = E[y];
    return x === void 0 ? [] : typeof x == "function" ? w ? [x.listener || x] : [x] : w ? m(x) : p(x, x.length);
  }
  o.prototype.listeners = function(y) {
    return d(this, y, !0);
  }, o.prototype.rawListeners = function(y) {
    return d(this, y, !1);
  }, o.listenerCount = function(b, y) {
    return typeof b.listenerCount == "function" ? b.listenerCount(y) : h.call(b, y);
  }, o.prototype.listenerCount = h;
  function h(b) {
    var y = this._events;
    if (y !== void 0) {
      var w = y[b];
      if (typeof w == "function")
        return 1;
      if (w !== void 0)
        return w.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function p(b, y) {
    for (var w = new Array(y), E = 0; E < y; ++E)
      w[E] = b[E];
    return w;
  }
  function g(b, y) {
    for (; y + 1 < b.length; y++)
      b[y] = b[y + 1];
    b.pop();
  }
  function m(b) {
    for (var y = new Array(b.length), w = 0; w < y.length; ++w)
      y[w] = b[w].listener || b[w];
    return y;
  }
  function v(b, y) {
    return new Promise(function(w, E) {
      function x(C) {
        b.removeListener(y, k), E(C);
      }
      function k() {
        typeof b.removeListener == "function" && b.removeListener("error", x), w([].slice.call(arguments));
      }
      _(b, y, k, { once: !0 }), y !== "error" && S(b, x, { once: !0 });
    });
  }
  function S(b, y, w) {
    typeof b.on == "function" && _(b, "error", y, w);
  }
  function _(b, y, w, E) {
    if (typeof b.on == "function")
      E.once ? b.once(y, w) : b.on(y, w);
    else if (typeof b.addEventListener == "function")
      b.addEventListener(y, function x(k) {
        E.once && b.removeEventListener(y, x), w(k);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof b);
  }
  return dg.exports;
}
var OC;
function JX() {
  if (OC) return js;
  OC = 1;
  var t = js && js.__extends || /* @__PURE__ */ function() {
    var i = function(o, s) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, l) {
        a.__proto__ = l;
      } || function(a, l) {
        for (var u in l) Object.prototype.hasOwnProperty.call(l, u) && (a[u] = l[u]);
      }, i(o, s);
    };
    return function(o, s) {
      i(o, s);
      function a() {
        this.constructor = o;
      }
      o.prototype = s === null ? Object.create(s) : (a.prototype = s.prototype, new a());
    };
  }(), e = js && js.__spreadArrays || function() {
    for (var i = 0, o = 0, s = arguments.length; o < s; o++) i += arguments[o].length;
    for (var a = Array(i), l = 0, o = 0; o < s; o++)
      for (var u = arguments[o], c = 0, f = u.length; c < f; c++, l++)
        a[l] = u[c];
    return a;
  };
  js.__esModule = !0, js.StrictEventEmitter = void 0;
  var n = QX(), r = (
    /** @class */
    function(i) {
      t(o, i);
      function o() {
        return i.call(this) || this;
      }
      return o.prototype.on = function(s, a) {
        return i.prototype.on.call(this, s.toString(), a);
      }, o.prototype.once = function(s, a) {
        return i.prototype.once.call(this, s.toString(), a);
      }, o.prototype.off = function(s, a) {
        return i.prototype.off.call(this, s.toString(), a);
      }, o.prototype.emit = function(s) {
        for (var a = [], l = 1; l < arguments.length; l++)
          a[l - 1] = arguments[l];
        return i.prototype.emit.apply(this, e([s.toString()], a));
      }, o.prototype.addListener = function(s, a) {
        return i.prototype.addListener.call(this, s.toString(), a);
      }, o.prototype.prependListener = function(s, a) {
        return i.prototype.prependListener.call(this, s.toString(), a);
      }, o.prototype.prependOnceListener = function(s, a) {
        return i.prototype.prependOnceListener.call(this, s.toString(), a);
      }, o.prototype.removeListener = function(s, a) {
        return i.prototype.removeListener.call(this, s.toString(), a);
      }, o.prototype.removeAllListeners = function(s) {
        return s ? i.prototype.removeAllListeners.call(this, s.toString()) : i.prototype.removeAllListeners.call(this);
      }, o.prototype.eventNames = function() {
        return i.prototype.eventNames.call(this);
      }, o.prototype.listeners = function(s) {
        return i.prototype.listeners.call(this, s.toString());
      }, o.prototype.rawListeners = function(s) {
        return i.prototype.rawListeners.call(this, s.toString());
      }, o.prototype.listenerCount = function(s) {
        return i.prototype.listenerCount.call(this, s.toString());
      }, o;
    }(n.EventEmitter)
  );
  return js.StrictEventEmitter = r, js;
}
var DC;
function ZX() {
  return DC || (DC = 1, function(t) {
    var e = Il && Il.__createBinding || (Object.create ? function(r, i, o, s) {
      s === void 0 && (s = o), Object.defineProperty(r, s, { enumerable: !0, get: function() {
        return i[o];
      } });
    } : function(r, i, o, s) {
      s === void 0 && (s = o), r[s] = i[o];
    }), n = Il && Il.__exportStar || function(r, i) {
      for (var o in r) o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, r, o);
    };
    t.__esModule = !0, n(JX(), t);
  }(Il)), Il;
}
var Nl = {}, IC;
function cL() {
  if (IC) return Nl;
  IC = 1, Object.defineProperty(Nl, "__esModule", { value: !0 }), Nl.nextTickAsync = Nl.nextTick = void 0;
  function t(n) {
    setTimeout(n, 0);
  }
  Nl.nextTick = t;
  function e(n) {
    return new Promise(function(r) {
      setTimeout(function() {
        r(n());
      }, 0);
    });
  }
  return Nl.nextTickAsync = e, Nl;
}
var NC;
function eK() {
  return NC || (NC = 1, function(t) {
    var e = ji && ji.__extends || /* @__PURE__ */ function() {
      var f = function(d, h) {
        return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, g) {
          p.__proto__ = g;
        } || function(p, g) {
          for (var m in g) Object.prototype.hasOwnProperty.call(g, m) && (p[m] = g[m]);
        }, f(d, h);
      };
      return function(d, h) {
        if (typeof h != "function" && h !== null)
          throw new TypeError("Class extends value " + String(h) + " is not a constructor or null");
        f(d, h);
        function p() {
          this.constructor = d;
        }
        d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      };
    }(), n = ji && ji.__awaiter || function(f, d, h, p) {
      function g(m) {
        return m instanceof h ? m : new h(function(v) {
          v(m);
        });
      }
      return new (h || (h = Promise))(function(m, v) {
        function S(y) {
          try {
            b(p.next(y));
          } catch (w) {
            v(w);
          }
        }
        function _(y) {
          try {
            b(p.throw(y));
          } catch (w) {
            v(w);
          }
        }
        function b(y) {
          y.done ? m(y.value) : g(y.value).then(S, _);
        }
        b((p = p.apply(f, d || [])).next());
      });
    }, r = ji && ji.__generator || function(f, d) {
      var h = { label: 0, sent: function() {
        if (m[0] & 1) throw m[1];
        return m[1];
      }, trys: [], ops: [] }, p, g, m, v;
      return v = { next: S(0), throw: S(1), return: S(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
        return this;
      }), v;
      function S(b) {
        return function(y) {
          return _([b, y]);
        };
      }
      function _(b) {
        if (p) throw new TypeError("Generator is already executing.");
        for (; h; ) try {
          if (p = 1, g && (m = b[0] & 2 ? g.return : b[0] ? g.throw || ((m = g.return) && m.call(g), 0) : g.next) && !(m = m.call(g, b[1])).done) return m;
          switch (g = 0, m && (b = [b[0] & 2, m.value]), b[0]) {
            case 0:
            case 1:
              m = b;
              break;
            case 4:
              return h.label++, { value: b[1], done: !1 };
            case 5:
              h.label++, g = b[1], b = [0];
              continue;
            case 7:
              b = h.ops.pop(), h.trys.pop();
              continue;
            default:
              if (m = h.trys, !(m = m.length > 0 && m[m.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                h = 0;
                continue;
              }
              if (b[0] === 3 && (!m || b[1] > m[0] && b[1] < m[3])) {
                h.label = b[1];
                break;
              }
              if (b[0] === 6 && h.label < m[1]) {
                h.label = m[1], m = b;
                break;
              }
              if (m && h.label < m[2]) {
                h.label = m[2], h.ops.push(b);
                break;
              }
              m[2] && h.ops.pop(), h.trys.pop();
              continue;
          }
          b = d.call(f, h);
        } catch (y) {
          b = [6, y], g = 0;
        } finally {
          p = m = 0;
        }
        if (b[0] & 5) throw b[1];
        return { value: b[0] ? b[1] : void 0, done: !0 };
      }
    }, i = ji && ji.__read || function(f, d) {
      var h = typeof Symbol == "function" && f[Symbol.iterator];
      if (!h) return f;
      var p = h.call(f), g, m = [], v;
      try {
        for (; (d === void 0 || d-- > 0) && !(g = p.next()).done; ) m.push(g.value);
      } catch (S) {
        v = { error: S };
      } finally {
        try {
          g && !g.done && (h = p.return) && h.call(p);
        } finally {
          if (v) throw v.error;
        }
      }
      return m;
    }, o = ji && ji.__spreadArray || function(f, d) {
      for (var h = 0, p = d.length, g = f.length; h < p; h++, g++)
        f[g] = d[h];
      return f;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.AsyncEventEmitter = t.AsyncEventEmitterReadyState = void 0;
    var s = uL(), a = ZX(), l = cL(), u;
    (function(f) {
      f.ACTIVE = "ACTIVE", f.DEACTIVATED = "DEACTIVATED";
    })(u = t.AsyncEventEmitterReadyState || (t.AsyncEventEmitterReadyState = {}));
    var c = (
      /** @class */
      function(f) {
        e(d, f);
        function d() {
          var h = f.call(this) || this;
          return h.log = s.debug("async-event-emitter"), h.queue = /* @__PURE__ */ new Map(), h.readyState = u.ACTIVE, h;
        }
        return d.prototype.on = function(h, p) {
          var g = this, m = this.log.extend("on");
          return m('adding "%s" listener...', h), this.readyState === u.DEACTIVATED ? (m("the emitter is destroyed, skipping!"), this) : f.prototype.on.call(this, h, function() {
            for (var v = [], S = 0; S < arguments.length; S++)
              v[S] = arguments[S];
            return n(g, void 0, void 0, function() {
              var _, b = this;
              return r(this, function(y) {
                return _ = this.openListenerQueue(h), m('awaiting the "%s" listener...', h), _.push({
                  args: v,
                  done: new Promise(function(w, E) {
                    return n(b, void 0, void 0, function() {
                      var x;
                      return r(this, function(k) {
                        switch (k.label) {
                          case 0:
                            return k.trys.push([0, 2, , 3]), [4, p.apply(void 0, o([], i(v)))];
                          case 1:
                            return k.sent(), w(), m('"%s" listener has resolved!', h), [3, 3];
                          case 2:
                            return x = k.sent(), m('"%s" listener has rejected!', x), E(x), [3, 3];
                          case 3:
                            return [
                              2
                              /*return*/
                            ];
                        }
                      });
                    });
                  })
                }), [
                  2
                  /*return*/
                ];
              });
            });
          });
        }, d.prototype.emit = function(h) {
          for (var p = this, g = [], m = 1; m < arguments.length; m++)
            g[m - 1] = arguments[m];
          var v = this.log.extend("emit");
          return v('emitting "%s" event...', h), this.readyState === u.DEACTIVATED ? (v("the emitter is destroyed, skipping!"), !1) : (this.openListenerQueue(h), v('appending a one-time cleanup "%s" listener...', h), this.once(h, function() {
            l.nextTick(function() {
              p.queue.delete(h), v('cleaned up "%s" listeners queue!', h);
            });
          }), f.prototype.emit.apply(this, o([h], i(g))));
        }, d.prototype.untilIdle = function(h, p) {
          return p === void 0 && (p = function() {
            return !0;
          }), n(this, void 0, void 0, function() {
            var g, m = this;
            return r(this, function(v) {
              switch (v.label) {
                case 0:
                  return g = this.queue.get(h) || [], [4, Promise.all(g.filter(p).map(function(S) {
                    var _ = S.done;
                    return _;
                  })).finally(function() {
                    m.queue.delete(h);
                  })];
                case 1:
                  return v.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, d.prototype.openListenerQueue = function(h) {
          var p = this.log.extend("openListenerQueue");
          p('opening "%s" listeners queue...', h);
          var g = this.queue.get(h);
          return g ? (p("returning an exising queue:", g), g) : (p("no queue found, creating one..."), this.queue.set(h, []), []);
        }, d.prototype.removeAllListeners = function(h) {
          var p = this.log.extend("removeAllListeners");
          return p("event:", h), h ? (this.queue.delete(h), p('cleared the "%s" listeners queue!', h, this.queue.get(h))) : (this.queue.clear(), p("cleared the listeners queue!", this.queue)), f.prototype.removeAllListeners.call(this, h);
        }, d.prototype.activate = function() {
          var h = this.log.extend("activate");
          this.readyState = u.ACTIVE, h("set state to:", this.readyState);
        }, d.prototype.deactivate = function() {
          var h = this.log.extend("deactivate");
          h("removing all listeners..."), this.removeAllListeners(), this.readyState = u.DEACTIVATED, h("set state to:", this.readyState);
        }, d;
      }(a.StrictEventEmitter)
    );
    t.AsyncEventEmitter = c;
  }(ji)), ji;
}
var PC;
function u0() {
  return PC || (PC = 1, function(t) {
    var e = Gf && Gf.__values || function(c) {
      var f = typeof Symbol == "function" && Symbol.iterator, d = f && c[f], h = 0;
      if (d) return d.call(c);
      if (c && typeof c.length == "number") return {
        next: function() {
          return c && h >= c.length && (c = void 0), { value: c && c[h++], done: !c };
        }
      };
      throw new TypeError(f ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Interceptor = t.InterceptorReadyState = t.deleteGlobalSymbol = t.getGlobalSymbol = void 0;
    var n = uL(), r = eK(), i = cL();
    function o(c) {
      return (
        // @ts-ignore https://github.com/Microsoft/TypeScript/issues/24587
        globalThis[c] || void 0
      );
    }
    t.getGlobalSymbol = o;
    function s(c, f) {
      globalThis[c] = f;
    }
    function a(c) {
      delete globalThis[c];
    }
    t.deleteGlobalSymbol = a;
    var l;
    (function(c) {
      c.IDLE = "IDLE", c.APPLYING = "APPLYING", c.APPLIED = "APPLIED", c.DISPOSING = "DISPOSING", c.DISPOSED = "DISPOSED";
    })(l = t.InterceptorReadyState || (t.InterceptorReadyState = {}));
    var u = (
      /** @class */
      function() {
        function c(f) {
          this.symbol = f, this.readyState = l.IDLE, this.emitter = new r.AsyncEventEmitter(), this.subscriptions = [], this.log = n.debug(f.description), this.emitter.setMaxListeners(0), this.log("constructing the interceptor...");
        }
        return c.prototype.checkEnvironment = function() {
          return !0;
        }, c.prototype.apply = function() {
          var f = this, d = this.log.extend("apply");
          if (d("applying the interceptor..."), this.readyState === l.APPLIED) {
            d("intercepted already applied!");
            return;
          }
          var h = this.checkEnvironment();
          if (!h) {
            d("the interceptor cannot be applied in this environment!");
            return;
          }
          this.readyState = l.APPLYING, this.emitter.activate(), d("activated the emiter!", this.emitter.readyState);
          var p = this.getInstance();
          if (p) {
            d("found a running instance, reusing..."), this.on = function(g, m) {
              d('proxying the "%s" listener', g), p.emitter.addListener(g, m), f.subscriptions.push(function() {
                p.emitter.removeListener(g, m), d('removed proxied "%s" listener!', g);
              });
            }, i.nextTick(function() {
              f.readyState = l.APPLIED;
            });
            return;
          }
          d("no running instance found, setting up a new instance..."), this.setup(), this.setInstance(), i.nextTick(function() {
            f.readyState = l.APPLIED;
          });
        }, c.prototype.setup = function() {
        }, c.prototype.on = function(f, d) {
          var h = this.log.extend("on");
          if (this.readyState === l.DISPOSING || this.readyState === l.DISPOSED) {
            h("cannot listen to events, already disposed!");
            return;
          }
          h('adding "%s" event listener:', f, d.name), this.emitter.on(f, d);
        }, c.prototype.dispose = function() {
          var f, d, h = this, p = this.log.extend("dispose");
          if (this.readyState === l.DISPOSED) {
            p("cannot dispose, already disposed!");
            return;
          }
          if (p("disposing the interceptor..."), this.readyState = l.DISPOSING, !this.getInstance()) {
            p("no interceptors running, skipping dispose...");
            return;
          }
          if (this.clearInstance(), p("global symbol deleted:", o(this.symbol)), this.subscriptions.length > 0) {
            p("disposing of %d subscriptions...", this.subscriptions.length);
            try {
              for (var g = e(this.subscriptions), m = g.next(); !m.done; m = g.next()) {
                var v = m.value;
                v();
              }
            } catch (S) {
              f = { error: S };
            } finally {
              try {
                m && !m.done && (d = g.return) && d.call(g);
              } finally {
                if (f) throw f.error;
              }
            }
            this.subscriptions = [], p("disposed of all subscriptions!", this.subscriptions.length);
          }
          this.emitter.deactivate(), p("destroyed the listener!"), i.nextTick(function() {
            h.readyState = l.DISPOSED;
          });
        }, c.prototype.getInstance = function() {
          var f, d = o(this.symbol);
          return this.log("retrieved global instance:", (f = d?.constructor) === null || f === void 0 ? void 0 : f.name), d;
        }, c.prototype.setInstance = function() {
          s(this.symbol, this), this.log("set global instance!", this.symbol.description);
        }, c.prototype.clearInstance = function() {
          a(this.symbol), this.log("cleared global instance!", this.symbol.description);
        }, c;
      }()
    );
    t.Interceptor = u;
  }(Gf)), Gf;
}
var Vs = {}, $C;
function tK() {
  if ($C) return Vs;
  $C = 1;
  var t = Vs && Vs.__extends || /* @__PURE__ */ function() {
    var i = function(o, s) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, l) {
        a.__proto__ = l;
      } || function(a, l) {
        for (var u in l) Object.prototype.hasOwnProperty.call(l, u) && (a[u] = l[u]);
      }, i(o, s);
    };
    return function(o, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      i(o, s);
      function a() {
        this.constructor = o;
      }
      o.prototype = s === null ? Object.create(s) : (a.prototype = s.prototype, new a());
    };
  }(), e = Vs && Vs.__values || function(i) {
    var o = typeof Symbol == "function" && Symbol.iterator, s = o && i[o], a = 0;
    if (s) return s.call(i);
    if (i && typeof i.length == "number") return {
      next: function() {
        return i && a >= i.length && (i = void 0), { value: i && i[a++], done: !i };
      }
    };
    throw new TypeError(o ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(Vs, "__esModule", { value: !0 }), Vs.BatchInterceptor = void 0;
  var n = u0(), r = (
    /** @class */
    function(i) {
      t(o, i);
      function o(s) {
        var a = this;
        return o.symbol = Symbol(s.name), a = i.call(this, o.symbol) || this, a.interceptors = s.interceptors, a;
      }
      return o.prototype.setup = function() {
        var s, a, l = this.log.extend("setup");
        l("applying all %d interceptors...", this.interceptors.length);
        var u = function(p) {
          l('applying "%s" interceptor...', p.constructor.name), p.apply(), l("adding interceptor dispose subscription"), c.subscriptions.push(function() {
            return p.dispose();
          });
        }, c = this;
        try {
          for (var f = e(this.interceptors), d = f.next(); !d.done; d = f.next()) {
            var h = d.value;
            u(h);
          }
        } catch (p) {
          s = { error: p };
        } finally {
          try {
            d && !d.done && (a = f.return) && a.call(f);
          } finally {
            if (s) throw s.error;
          }
        }
      }, o.prototype.on = function(s, a) {
        this.interceptors.forEach(function(l) {
          l.on(s, a);
        });
      }, o;
    }(n.Interceptor)
  );
  return Vs.BatchInterceptor = r, Vs;
}
var Us = {}, qs = {}, hg = {}, Pv = {}, $v = {}, Mv, MC;
function fL() {
  return MC || (MC = 1, Mv = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, n = Symbol("test"), r = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var i = 42;
    e[n] = i;
    for (var o in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var s = Object.getOwnPropertySymbols(e);
    if (s.length !== 1 || s[0] !== n || !Object.prototype.propertyIsEnumerable.call(e, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var a = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, n)
      );
      if (a.value !== i || a.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Mv;
}
var Fv, FC;
function c0() {
  if (FC) return Fv;
  FC = 1;
  var t = fL();
  return Fv = function() {
    return t() && !!Symbol.toStringTag;
  }, Fv;
}
var Lv, LC;
function dL() {
  return LC || (LC = 1, Lv = Object), Lv;
}
var Bv, BC;
function nK() {
  return BC || (BC = 1, Bv = Error), Bv;
}
var jv, jC;
function rK() {
  return jC || (jC = 1, jv = EvalError), jv;
}
var Vv, VC;
function iK() {
  return VC || (VC = 1, Vv = RangeError), Vv;
}
var Uv, UC;
function oK() {
  return UC || (UC = 1, Uv = ReferenceError), Uv;
}
var qv, qC;
function hL() {
  return qC || (qC = 1, qv = SyntaxError), qv;
}
var zv, zC;
function ep() {
  return zC || (zC = 1, zv = TypeError), zv;
}
var Hv, HC;
function sK() {
  return HC || (HC = 1, Hv = URIError), Hv;
}
var Gv, GC;
function aK() {
  return GC || (GC = 1, Gv = Math.abs), Gv;
}
var Wv, WC;
function lK() {
  return WC || (WC = 1, Wv = Math.floor), Wv;
}
var Yv, YC;
function uK() {
  return YC || (YC = 1, Yv = Math.max), Yv;
}
var Xv, XC;
function cK() {
  return XC || (XC = 1, Xv = Math.min), Xv;
}
var Kv, KC;
function fK() {
  return KC || (KC = 1, Kv = Math.pow), Kv;
}
var Qv, QC;
function dK() {
  return QC || (QC = 1, Qv = Math.round), Qv;
}
var Jv, JC;
function hK() {
  return JC || (JC = 1, Jv = Number.isNaN || function(e) {
    return e !== e;
  }), Jv;
}
var Zv, ZC;
function pK() {
  if (ZC) return Zv;
  ZC = 1;
  var t = /* @__PURE__ */ hK();
  return Zv = function(n) {
    return t(n) || n === 0 ? n : n < 0 ? -1 : 1;
  }, Zv;
}
var eb, eA;
function gK() {
  return eA || (eA = 1, eb = Object.getOwnPropertyDescriptor), eb;
}
var tb, tA;
function wf() {
  if (tA) return tb;
  tA = 1;
  var t = /* @__PURE__ */ gK();
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return tb = t, tb;
}
var nb, nA;
function f0() {
  if (nA) return nb;
  nA = 1;
  var t = Object.defineProperty || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return nb = t, nb;
}
var rb, rA;
function mK() {
  if (rA) return rb;
  rA = 1;
  var t = typeof Symbol < "u" && Symbol, e = fL();
  return rb = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, rb;
}
var ib, iA;
function pL() {
  return iA || (iA = 1, ib = typeof Reflect < "u" && Reflect.getPrototypeOf || null), ib;
}
var ob, oA;
function gL() {
  if (oA) return ob;
  oA = 1;
  var t = /* @__PURE__ */ dL();
  return ob = t.getPrototypeOf || null, ob;
}
var sb, sA;
function yK() {
  if (sA) return sb;
  sA = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, n = Math.max, r = "[object Function]", i = function(l, u) {
    for (var c = [], f = 0; f < l.length; f += 1)
      c[f] = l[f];
    for (var d = 0; d < u.length; d += 1)
      c[d + l.length] = u[d];
    return c;
  }, o = function(l, u) {
    for (var c = [], f = u, d = 0; f < l.length; f += 1, d += 1)
      c[d] = l[f];
    return c;
  }, s = function(a, l) {
    for (var u = "", c = 0; c < a.length; c += 1)
      u += a[c], c + 1 < a.length && (u += l);
    return u;
  };
  return sb = function(l) {
    var u = this;
    if (typeof u != "function" || e.apply(u) !== r)
      throw new TypeError(t + u);
    for (var c = o(arguments, 1), f, d = function() {
      if (this instanceof f) {
        var v = u.apply(
          this,
          i(c, arguments)
        );
        return Object(v) === v ? v : this;
      }
      return u.apply(
        l,
        i(c, arguments)
      );
    }, h = n(0, u.length - c.length), p = [], g = 0; g < h; g++)
      p[g] = "$" + g;
    if (f = Function("binder", "return function (" + s(p, ",") + "){ return binder.apply(this,arguments); }")(d), u.prototype) {
      var m = function() {
      };
      m.prototype = u.prototype, f.prototype = new m(), m.prototype = null;
    }
    return f;
  }, sb;
}
var ab, aA;
function tp() {
  if (aA) return ab;
  aA = 1;
  var t = yK();
  return ab = Function.prototype.bind || t, ab;
}
var lb, lA;
function BE() {
  return lA || (lA = 1, lb = Function.prototype.call), lb;
}
var ub, uA;
function jE() {
  return uA || (uA = 1, ub = Function.prototype.apply), ub;
}
var cb, cA;
function vK() {
  return cA || (cA = 1, cb = typeof Reflect < "u" && Reflect && Reflect.apply), cb;
}
var fb, fA;
function mL() {
  if (fA) return fb;
  fA = 1;
  var t = tp(), e = jE(), n = BE(), r = vK();
  return fb = r || t.call(n, e), fb;
}
var db, dA;
function VE() {
  if (dA) return db;
  dA = 1;
  var t = tp(), e = /* @__PURE__ */ ep(), n = BE(), r = mL();
  return db = function(o) {
    if (o.length < 1 || typeof o[0] != "function")
      throw new e("a function is required");
    return r(t, n, o);
  }, db;
}
var hb, hA;
function bK() {
  if (hA) return hb;
  hA = 1;
  var t = VE(), e = /* @__PURE__ */ wf(), n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (s) {
    if (!s || typeof s != "object" || !("code" in s) || s.code !== "ERR_PROTO_ACCESS")
      throw s;
  }
  var r = !!n && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), i = Object, o = i.getPrototypeOf;
  return hb = r && typeof r.get == "function" ? t([r.get]) : typeof o == "function" ? (
    /** @type {import('./get')} */
    function(a) {
      return o(a == null ? a : i(a));
    }
  ) : !1, hb;
}
var pb, pA;
function UE() {
  if (pA) return pb;
  pA = 1;
  var t = pL(), e = gL(), n = /* @__PURE__ */ bK();
  return pb = t ? function(i) {
    return t(i);
  } : e ? function(i) {
    if (!i || typeof i != "object" && typeof i != "function")
      throw new TypeError("getProto: not an object");
    return e(i);
  } : n ? function(i) {
    return n(i);
  } : null, pb;
}
var gb, gA;
function yL() {
  if (gA) return gb;
  gA = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, n = tp();
  return gb = n.call(t, e), gb;
}
var mb, mA;
function vL() {
  if (mA) return mb;
  mA = 1;
  var t, e = /* @__PURE__ */ dL(), n = /* @__PURE__ */ nK(), r = /* @__PURE__ */ rK(), i = /* @__PURE__ */ iK(), o = /* @__PURE__ */ oK(), s = /* @__PURE__ */ hL(), a = /* @__PURE__ */ ep(), l = /* @__PURE__ */ sK(), u = /* @__PURE__ */ aK(), c = /* @__PURE__ */ lK(), f = /* @__PURE__ */ uK(), d = /* @__PURE__ */ cK(), h = /* @__PURE__ */ fK(), p = /* @__PURE__ */ dK(), g = /* @__PURE__ */ pK(), m = Function, v = function(ue) {
    try {
      return m('"use strict"; return (' + ue + ").constructor;")();
    } catch {
    }
  }, S = /* @__PURE__ */ wf(), _ = /* @__PURE__ */ f0(), b = function() {
    throw new a();
  }, y = S ? function() {
    try {
      return arguments.callee, b;
    } catch {
      try {
        return S(arguments, "callee").get;
      } catch {
        return b;
      }
    }
  }() : b, w = mK()(), E = UE(), x = gL(), k = pL(), C = jE(), M = BE(), F = {}, U = typeof Uint8Array > "u" || !E ? t : E(Uint8Array), B = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": w && E ? E([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": F,
    "%AsyncGenerator%": F,
    "%AsyncGeneratorFunction%": F,
    "%AsyncIteratorPrototype%": F,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": n,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float16Array%": typeof Float16Array > "u" ? t : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": m,
    "%GeneratorFunction%": F,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": w && E ? E(E([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !w || !E ? t : E((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": S,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": i,
    "%ReferenceError%": o,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !w || !E ? t : E((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": w && E ? E(""[Symbol.iterator]()) : t,
    "%Symbol%": w ? Symbol : t,
    "%SyntaxError%": s,
    "%ThrowTypeError%": y,
    "%TypedArray%": U,
    "%TypeError%": a,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet,
    "%Function.prototype.call%": M,
    "%Function.prototype.apply%": C,
    "%Object.defineProperty%": _,
    "%Object.getPrototypeOf%": x,
    "%Math.abs%": u,
    "%Math.floor%": c,
    "%Math.max%": f,
    "%Math.min%": d,
    "%Math.pow%": h,
    "%Math.round%": p,
    "%Math.sign%": g,
    "%Reflect.getPrototypeOf%": k
  };
  if (E)
    try {
      null.error;
    } catch (ue) {
      var N = E(E(ue));
      B["%Error.prototype%"] = N;
    }
  var q = function ue(he) {
    var me;
    if (he === "%AsyncFunction%")
      me = v("async function () {}");
    else if (he === "%GeneratorFunction%")
      me = v("function* () {}");
    else if (he === "%AsyncGeneratorFunction%")
      me = v("async function* () {}");
    else if (he === "%AsyncGenerator%") {
      var oe = ue("%AsyncGeneratorFunction%");
      oe && (me = oe.prototype);
    } else if (he === "%AsyncIteratorPrototype%") {
      var re = ue("%AsyncGenerator%");
      re && E && (me = E(re.prototype));
    }
    return B[he] = me, me;
  }, Q = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, ne = tp(), X = /* @__PURE__ */ yL(), O = ne.call(M, Array.prototype.concat), W = ne.call(C, Array.prototype.splice), T = ne.call(M, String.prototype.replace), $ = ne.call(M, String.prototype.slice), P = ne.call(M, RegExp.prototype.exec), H = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Z = /\\(\\)?/g, le = function(he) {
    var me = $(he, 0, 1), oe = $(he, -1);
    if (me === "%" && oe !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (oe === "%" && me !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var re = [];
    return T(he, H, function(se, ae, fe, Y) {
      re[re.length] = fe ? T(Y, Z, "$1") : ae || se;
    }), re;
  }, J = function(he, me) {
    var oe = he, re;
    if (X(Q, oe) && (re = Q[oe], oe = "%" + re[0] + "%"), X(B, oe)) {
      var se = B[oe];
      if (se === F && (se = q(oe)), typeof se > "u" && !me)
        throw new a("intrinsic " + he + " exists, but is not available. Please file an issue!");
      return {
        alias: re,
        name: oe,
        value: se
      };
    }
    throw new s("intrinsic " + he + " does not exist!");
  };
  return mb = function(he, me) {
    if (typeof he != "string" || he.length === 0)
      throw new a("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof me != "boolean")
      throw new a('"allowMissing" argument must be a boolean');
    if (P(/^%?[^%]*%?$/, he) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var oe = le(he), re = oe.length > 0 ? oe[0] : "", se = J("%" + re + "%", me), ae = se.name, fe = se.value, Y = !1, Re = se.alias;
    Re && (re = Re[0], W(oe, O([0, 1], Re)));
    for (var ee = 1, Ye = !0; ee < oe.length; ee += 1) {
      var Te = oe[ee], ve = $(Te, 0, 1), Oe = $(Te, -1);
      if ((ve === '"' || ve === "'" || ve === "`" || Oe === '"' || Oe === "'" || Oe === "`") && ve !== Oe)
        throw new s("property names with quotes must have matching quotes");
      if ((Te === "constructor" || !Ye) && (Y = !0), re += "." + Te, ae = "%" + re + "%", X(B, ae))
        fe = B[ae];
      else if (fe != null) {
        if (!(Te in fe)) {
          if (!me)
            throw new a("base intrinsic for " + he + " exists, but the property is not available.");
          return;
        }
        if (S && ee + 1 >= oe.length) {
          var Je = S(fe, Te);
          Ye = !!Je, Ye && "get" in Je && !("originalValue" in Je.get) ? fe = Je.get : fe = fe[Te];
        } else
          Ye = X(fe, Te), fe = fe[Te];
        Ye && !Y && (B[ae] = fe);
      }
    }
    return fe;
  }, mb;
}
var yb, yA;
function np() {
  if (yA) return yb;
  yA = 1;
  var t = /* @__PURE__ */ vL(), e = VE(), n = e([t("%String.prototype.indexOf%")]);
  return yb = function(i, o) {
    var s = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      t(i, !!o)
    );
    return typeof s == "function" && n(i, ".prototype.") > -1 ? e(
      /** @type {const} */
      [s]
    ) : s;
  }, yb;
}
var vb, vA;
function wK() {
  if (vA) return vb;
  vA = 1;
  var t = c0()(), e = /* @__PURE__ */ np(), n = e("Object.prototype.toString"), r = function(a) {
    return t && a && typeof a == "object" && Symbol.toStringTag in a ? !1 : n(a) === "[object Arguments]";
  }, i = function(a) {
    return r(a) ? !0 : a !== null && typeof a == "object" && "length" in a && typeof a.length == "number" && a.length >= 0 && n(a) !== "[object Array]" && "callee" in a && n(a.callee) === "[object Function]";
  }, o = function() {
    return r(arguments);
  }();
  return r.isLegacyArguments = i, vb = o ? r : i, vb;
}
var bb, bA;
function SK() {
  if (bA) return bb;
  bA = 1;
  var t = /* @__PURE__ */ np(), e = c0()(), n = /* @__PURE__ */ yL(), r = /* @__PURE__ */ wf(), i;
  if (e) {
    var o = t("RegExp.prototype.exec"), s = {}, a = function() {
      throw s;
    }, l = {
      toString: a,
      valueOf: a
    };
    typeof Symbol.toPrimitive == "symbol" && (l[Symbol.toPrimitive] = a), i = function(d) {
      if (!d || typeof d != "object")
        return !1;
      var h = (
        /** @type {NonNullable<typeof gOPD>} */
        r(
          /** @type {{ lastIndex?: unknown }} */
          d,
          "lastIndex"
        )
      ), p = h && n(h, "value");
      if (!p)
        return !1;
      try {
        o(
          d,
          /** @type {string} */
          /** @type {unknown} */
          l
        );
      } catch (g) {
        return g === s;
      }
    };
  } else {
    var u = t("Object.prototype.toString"), c = "[object RegExp]";
    i = function(d) {
      return !d || typeof d != "object" && typeof d != "function" ? !1 : u(d) === c;
    };
  }
  return bb = i, bb;
}
var wb, wA;
function _K() {
  if (wA) return wb;
  wA = 1;
  var t = /* @__PURE__ */ np(), e = SK(), n = t("RegExp.prototype.exec"), r = /* @__PURE__ */ ep();
  return wb = function(o) {
    if (!e(o))
      throw new r("`regex` must be a RegExp");
    return function(a) {
      return n(o, a) !== null;
    };
  }, wb;
}
var Sb, SA;
function EK() {
  if (SA) return Sb;
  SA = 1;
  var t = /* @__PURE__ */ np(), e = /* @__PURE__ */ _K(), n = e(/^\s*(?:function)?\*/), r = c0()(), i = UE(), o = t("Object.prototype.toString"), s = t("Function.prototype.toString"), a = function() {
    if (!r)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, l;
  return Sb = function(c) {
    if (typeof c != "function")
      return !1;
    if (n(s(c)))
      return !0;
    if (!r) {
      var f = o(c);
      return f === "[object GeneratorFunction]";
    }
    if (!i)
      return !1;
    if (typeof l > "u") {
      var d = a();
      l = d ? (
        /** @type {GeneratorFunctionConstructor} */
        i(d)
      ) : !1;
    }
    return i(c) === l;
  }, Sb;
}
var _b, _A;
function kK() {
  if (_A) return _b;
  _A = 1;
  var t = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, n, r;
  if (typeof e == "function" && typeof Object.defineProperty == "function")
    try {
      n = Object.defineProperty({}, "length", {
        get: function() {
          throw r;
        }
      }), r = {}, e(function() {
        throw 42;
      }, null, n);
    } catch (S) {
      S !== r && (e = null);
    }
  else
    e = null;
  var i = /^\s*class\b/, o = function(_) {
    try {
      var b = t.call(_);
      return i.test(b);
    } catch {
      return !1;
    }
  }, s = function(_) {
    try {
      return o(_) ? !1 : (t.call(_), !0);
    } catch {
      return !1;
    }
  }, a = Object.prototype.toString, l = "[object Object]", u = "[object Function]", c = "[object GeneratorFunction]", f = "[object HTMLAllCollection]", d = "[object HTML document.all class]", h = "[object HTMLCollection]", p = typeof Symbol == "function" && !!Symbol.toStringTag, g = !(0 in [,]), m = function() {
    return !1;
  };
  if (typeof document == "object") {
    var v = document.all;
    a.call(v) === a.call(document.all) && (m = function(_) {
      if ((g || !_) && (typeof _ > "u" || typeof _ == "object"))
        try {
          var b = a.call(_);
          return (b === f || b === d || b === h || b === l) && _("") == null;
        } catch {
        }
      return !1;
    });
  }
  return _b = e ? function(_) {
    if (m(_))
      return !0;
    if (!_ || typeof _ != "function" && typeof _ != "object")
      return !1;
    try {
      e(_, null, n);
    } catch (b) {
      if (b !== r)
        return !1;
    }
    return !o(_) && s(_);
  } : function(_) {
    if (m(_))
      return !0;
    if (!_ || typeof _ != "function" && typeof _ != "object")
      return !1;
    if (p)
      return s(_);
    if (o(_))
      return !1;
    var b = a.call(_);
    return b !== u && b !== c && !/^\[object HTML/.test(b) ? !1 : s(_);
  }, _b;
}
var Eb, EA;
function TK() {
  if (EA) return Eb;
  EA = 1;
  var t = kK(), e = Object.prototype.toString, n = Object.prototype.hasOwnProperty, r = function(l, u, c) {
    for (var f = 0, d = l.length; f < d; f++)
      n.call(l, f) && (c == null ? u(l[f], f, l) : u.call(c, l[f], f, l));
  }, i = function(l, u, c) {
    for (var f = 0, d = l.length; f < d; f++)
      c == null ? u(l.charAt(f), f, l) : u.call(c, l.charAt(f), f, l);
  }, o = function(l, u, c) {
    for (var f in l)
      n.call(l, f) && (c == null ? u(l[f], f, l) : u.call(c, l[f], f, l));
  };
  function s(a) {
    return e.call(a) === "[object Array]";
  }
  return Eb = function(l, u, c) {
    if (!t(u))
      throw new TypeError("iterator must be a function");
    var f;
    arguments.length >= 3 && (f = c), s(l) ? r(l, u, f) : typeof l == "string" ? i(l, u, f) : o(l, u, f);
  }, Eb;
}
var kb, kA;
function xK() {
  return kA || (kA = 1, kb = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), kb;
}
var Tb, TA;
function CK() {
  if (TA) return Tb;
  TA = 1;
  var t = /* @__PURE__ */ xK(), e = typeof globalThis > "u" ? zo : globalThis;
  return Tb = function() {
    for (var r = [], i = 0; i < t.length; i++)
      typeof e[t[i]] == "function" && (r[r.length] = t[i]);
    return r;
  }, Tb;
}
var xb = { exports: {} }, Cb, xA;
function AK() {
  if (xA) return Cb;
  xA = 1;
  var t = /* @__PURE__ */ f0(), e = /* @__PURE__ */ hL(), n = /* @__PURE__ */ ep(), r = /* @__PURE__ */ wf();
  return Cb = function(o, s, a) {
    if (!o || typeof o != "object" && typeof o != "function")
      throw new n("`obj` must be an object or a function`");
    if (typeof s != "string" && typeof s != "symbol")
      throw new n("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new n("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new n("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new n("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new n("`loose`, if provided, must be a boolean");
    var l = arguments.length > 3 ? arguments[3] : null, u = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, f = arguments.length > 6 ? arguments[6] : !1, d = !!r && r(o, s);
    if (t)
      t(o, s, {
        configurable: c === null && d ? d.configurable : !c,
        enumerable: l === null && d ? d.enumerable : !l,
        value: a,
        writable: u === null && d ? d.writable : !u
      });
    else if (f || !l && !u && !c)
      o[s] = a;
    else
      throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, Cb;
}
var Ab, CA;
function RK() {
  if (CA) return Ab;
  CA = 1;
  var t = /* @__PURE__ */ f0(), e = function() {
    return !!t;
  };
  return e.hasArrayLengthDefineBug = function() {
    if (!t)
      return null;
    try {
      return t([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, Ab = e, Ab;
}
var Rb, AA;
function OK() {
  if (AA) return Rb;
  AA = 1;
  var t = /* @__PURE__ */ vL(), e = /* @__PURE__ */ AK(), n = /* @__PURE__ */ RK()(), r = /* @__PURE__ */ wf(), i = /* @__PURE__ */ ep(), o = t("%Math.floor%");
  return Rb = function(a, l) {
    if (typeof a != "function")
      throw new i("`fn` is not a function");
    if (typeof l != "number" || l < 0 || l > 4294967295 || o(l) !== l)
      throw new i("`length` must be a positive 32-bit integer");
    var u = arguments.length > 2 && !!arguments[2], c = !0, f = !0;
    if ("length" in a && r) {
      var d = r(a, "length");
      d && !d.configurable && (c = !1), d && !d.writable && (f = !1);
    }
    return (c || f || !u) && (n ? e(
      /** @type {Parameters<define>[0]} */
      a,
      "length",
      l,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      a,
      "length",
      l
    )), a;
  }, Rb;
}
var Ob, RA;
function DK() {
  if (RA) return Ob;
  RA = 1;
  var t = tp(), e = jE(), n = mL();
  return Ob = function() {
    return n(t, e, arguments);
  }, Ob;
}
var OA;
function IK() {
  return OA || (OA = 1, function(t) {
    var e = /* @__PURE__ */ OK(), n = /* @__PURE__ */ f0(), r = VE(), i = DK();
    t.exports = function(s) {
      var a = r(arguments), l = s.length - (arguments.length - 1);
      return e(
        a,
        1 + (l > 0 ? l : 0),
        !0
      );
    }, n ? n(t.exports, "apply", { value: i }) : t.exports.apply = i;
  }(xb)), xb.exports;
}
var Db, DA;
function bL() {
  if (DA) return Db;
  DA = 1;
  var t = TK(), e = /* @__PURE__ */ CK(), n = IK(), r = /* @__PURE__ */ np(), i = /* @__PURE__ */ wf(), o = UE(), s = r("Object.prototype.toString"), a = c0()(), l = typeof globalThis > "u" ? zo : globalThis, u = e(), c = r("String.prototype.slice"), f = r("Array.prototype.indexOf", !0) || function(m, v) {
    for (var S = 0; S < m.length; S += 1)
      if (m[S] === v)
        return S;
    return -1;
  }, d = { __proto__: null };
  a && i && o ? t(u, function(g) {
    var m = new l[g]();
    if (Symbol.toStringTag in m && o) {
      var v = o(m), S = i(v, Symbol.toStringTag);
      if (!S && v) {
        var _ = o(v);
        S = i(_, Symbol.toStringTag);
      }
      d["$" + g] = n(S.get);
    }
  }) : t(u, function(g) {
    var m = new l[g](), v = m.slice || m.set;
    v && (d[
      /** @type {`$${import('.').TypedArrayName}`} */
      "$" + g
    ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
    // @ts-expect-error TODO FIXME
    n(v));
  });
  var h = function(m) {
    var v = !1;
    return t(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      d,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(S, _) {
        if (!v)
          try {
            "$" + S(m) === _ && (v = /** @type {import('.').TypedArrayName} */
            c(_, 1));
          } catch {
          }
      }
    ), v;
  }, p = function(m) {
    var v = !1;
    return t(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      d,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(S, _) {
        if (!v)
          try {
            S(m), v = /** @type {import('.').TypedArrayName} */
            c(_, 1);
          } catch {
          }
      }
    ), v;
  };
  return Db = function(m) {
    if (!m || typeof m != "object")
      return !1;
    if (!a) {
      var v = c(s(m), 8, -1);
      return f(u, v) > -1 ? v : v !== "Object" ? !1 : p(m);
    }
    return i ? h(m) : null;
  }, Db;
}
var Ib, IA;
function NK() {
  if (IA) return Ib;
  IA = 1;
  var t = /* @__PURE__ */ bL();
  return Ib = function(n) {
    return !!t(n);
  }, Ib;
}
var NA;
function PK() {
  return NA || (NA = 1, function(t) {
    var e = /* @__PURE__ */ wK(), n = EK(), r = /* @__PURE__ */ bL(), i = /* @__PURE__ */ NK();
    function o(ee) {
      return ee.call.bind(ee);
    }
    var s = typeof BigInt < "u", a = typeof Symbol < "u", l = o(Object.prototype.toString), u = o(Number.prototype.valueOf), c = o(String.prototype.valueOf), f = o(Boolean.prototype.valueOf);
    if (s)
      var d = o(BigInt.prototype.valueOf);
    if (a)
      var h = o(Symbol.prototype.valueOf);
    function p(ee, Ye) {
      if (typeof ee != "object")
        return !1;
      try {
        return Ye(ee), !0;
      } catch {
        return !1;
      }
    }
    t.isArgumentsObject = e, t.isGeneratorFunction = n, t.isTypedArray = i;
    function g(ee) {
      return typeof Promise < "u" && ee instanceof Promise || ee !== null && typeof ee == "object" && typeof ee.then == "function" && typeof ee.catch == "function";
    }
    t.isPromise = g;
    function m(ee) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(ee) : i(ee) || $(ee);
    }
    t.isArrayBufferView = m;
    function v(ee) {
      return r(ee) === "Uint8Array";
    }
    t.isUint8Array = v;
    function S(ee) {
      return r(ee) === "Uint8ClampedArray";
    }
    t.isUint8ClampedArray = S;
    function _(ee) {
      return r(ee) === "Uint16Array";
    }
    t.isUint16Array = _;
    function b(ee) {
      return r(ee) === "Uint32Array";
    }
    t.isUint32Array = b;
    function y(ee) {
      return r(ee) === "Int8Array";
    }
    t.isInt8Array = y;
    function w(ee) {
      return r(ee) === "Int16Array";
    }
    t.isInt16Array = w;
    function E(ee) {
      return r(ee) === "Int32Array";
    }
    t.isInt32Array = E;
    function x(ee) {
      return r(ee) === "Float32Array";
    }
    t.isFloat32Array = x;
    function k(ee) {
      return r(ee) === "Float64Array";
    }
    t.isFloat64Array = k;
    function C(ee) {
      return r(ee) === "BigInt64Array";
    }
    t.isBigInt64Array = C;
    function M(ee) {
      return r(ee) === "BigUint64Array";
    }
    t.isBigUint64Array = M;
    function F(ee) {
      return l(ee) === "[object Map]";
    }
    F.working = typeof Map < "u" && F(/* @__PURE__ */ new Map());
    function U(ee) {
      return typeof Map > "u" ? !1 : F.working ? F(ee) : ee instanceof Map;
    }
    t.isMap = U;
    function B(ee) {
      return l(ee) === "[object Set]";
    }
    B.working = typeof Set < "u" && B(/* @__PURE__ */ new Set());
    function N(ee) {
      return typeof Set > "u" ? !1 : B.working ? B(ee) : ee instanceof Set;
    }
    t.isSet = N;
    function q(ee) {
      return l(ee) === "[object WeakMap]";
    }
    q.working = typeof WeakMap < "u" && q(/* @__PURE__ */ new WeakMap());
    function Q(ee) {
      return typeof WeakMap > "u" ? !1 : q.working ? q(ee) : ee instanceof WeakMap;
    }
    t.isWeakMap = Q;
    function ne(ee) {
      return l(ee) === "[object WeakSet]";
    }
    ne.working = typeof WeakSet < "u" && ne(/* @__PURE__ */ new WeakSet());
    function X(ee) {
      return ne(ee);
    }
    t.isWeakSet = X;
    function O(ee) {
      return l(ee) === "[object ArrayBuffer]";
    }
    O.working = typeof ArrayBuffer < "u" && O(new ArrayBuffer());
    function W(ee) {
      return typeof ArrayBuffer > "u" ? !1 : O.working ? O(ee) : ee instanceof ArrayBuffer;
    }
    t.isArrayBuffer = W;
    function T(ee) {
      return l(ee) === "[object DataView]";
    }
    T.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && T(new DataView(new ArrayBuffer(1), 0, 1));
    function $(ee) {
      return typeof DataView > "u" ? !1 : T.working ? T(ee) : ee instanceof DataView;
    }
    t.isDataView = $;
    var P = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function H(ee) {
      return l(ee) === "[object SharedArrayBuffer]";
    }
    function Z(ee) {
      return typeof P > "u" ? !1 : (typeof H.working > "u" && (H.working = H(new P())), H.working ? H(ee) : ee instanceof P);
    }
    t.isSharedArrayBuffer = Z;
    function le(ee) {
      return l(ee) === "[object AsyncFunction]";
    }
    t.isAsyncFunction = le;
    function J(ee) {
      return l(ee) === "[object Map Iterator]";
    }
    t.isMapIterator = J;
    function ue(ee) {
      return l(ee) === "[object Set Iterator]";
    }
    t.isSetIterator = ue;
    function he(ee) {
      return l(ee) === "[object Generator]";
    }
    t.isGeneratorObject = he;
    function me(ee) {
      return l(ee) === "[object WebAssembly.Module]";
    }
    t.isWebAssemblyCompiledModule = me;
    function oe(ee) {
      return p(ee, u);
    }
    t.isNumberObject = oe;
    function re(ee) {
      return p(ee, c);
    }
    t.isStringObject = re;
    function se(ee) {
      return p(ee, f);
    }
    t.isBooleanObject = se;
    function ae(ee) {
      return s && p(ee, d);
    }
    t.isBigIntObject = ae;
    function fe(ee) {
      return a && p(ee, h);
    }
    t.isSymbolObject = fe;
    function Y(ee) {
      return oe(ee) || re(ee) || se(ee) || ae(ee) || fe(ee);
    }
    t.isBoxedPrimitive = Y;
    function Re(ee) {
      return typeof Uint8Array < "u" && (W(ee) || Z(ee));
    }
    t.isAnyArrayBuffer = Re, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(ee) {
      Object.defineProperty(t, ee, {
        enumerable: !1,
        value: function() {
          throw new Error(ee + " is not supported in userland");
        }
      });
    });
  }($v)), $v;
}
var Nb, PA;
function $K() {
  return PA || (PA = 1, Nb = function(e) {
    return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
  }), Nb;
}
var pg = { exports: {} }, $A;
function MK() {
  return $A || ($A = 1, typeof Object.create == "function" ? pg.exports = function(e, n) {
    n && (e.super_ = n, e.prototype = Object.create(n.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : pg.exports = function(e, n) {
    if (n) {
      e.super_ = n;
      var r = function() {
      };
      r.prototype = n.prototype, e.prototype = new r(), e.prototype.constructor = e;
    }
  }), pg.exports;
}
var MA;
function FA() {
  return MA || (MA = 1, function(t) {
    var e = Object.getOwnPropertyDescriptors || function($) {
      for (var P = Object.keys($), H = {}, Z = 0; Z < P.length; Z++)
        H[P[Z]] = Object.getOwnPropertyDescriptor($, P[Z]);
      return H;
    }, n = /%[sdj%]/g;
    t.format = function(T) {
      if (!y(T)) {
        for (var $ = [], P = 0; P < arguments.length; P++)
          $.push(s(arguments[P]));
        return $.join(" ");
      }
      for (var P = 1, H = arguments, Z = H.length, le = String(T).replace(n, function(ue) {
        if (ue === "%%") return "%";
        if (P >= Z) return ue;
        switch (ue) {
          case "%s":
            return String(H[P++]);
          case "%d":
            return Number(H[P++]);
          case "%j":
            try {
              return JSON.stringify(H[P++]);
            } catch {
              return "[Circular]";
            }
          default:
            return ue;
        }
      }), J = H[P]; P < Z; J = H[++P])
        S(J) || !k(J) ? le += " " + J : le += " " + s(J);
      return le;
    }, t.deprecate = function(T, $) {
      if (typeof process < "u" && process.noDeprecation === !0)
        return T;
      if (typeof process > "u")
        return function() {
          return t.deprecate(T, $).apply(this, arguments);
        };
      var P = !1;
      function H() {
        if (!P) {
          if (process.throwDeprecation)
            throw new Error($);
          process.traceDeprecation ? console.trace($) : console.error($), P = !0;
        }
        return T.apply(this, arguments);
      }
      return H;
    };
    var r = {}, i = /^$/;
    if (process.env.NODE_DEBUG) {
      var o = process.env.NODE_DEBUG;
      o = o.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = new RegExp("^" + o + "$", "i");
    }
    t.debuglog = function(T) {
      if (T = T.toUpperCase(), !r[T])
        if (i.test(T)) {
          var $ = process.pid;
          r[T] = function() {
            var P = t.format.apply(t, arguments);
            console.error("%s %d: %s", T, $, P);
          };
        } else
          r[T] = function() {
          };
      return r[T];
    };
    function s(T, $) {
      var P = {
        seen: [],
        stylize: l
      };
      return arguments.length >= 3 && (P.depth = arguments[2]), arguments.length >= 4 && (P.colors = arguments[3]), v($) ? P.showHidden = $ : $ && t._extend(P, $), E(P.showHidden) && (P.showHidden = !1), E(P.depth) && (P.depth = 2), E(P.colors) && (P.colors = !1), E(P.customInspect) && (P.customInspect = !0), P.colors && (P.stylize = a), c(P, T, P.depth);
    }
    t.inspect = s, s.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, s.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function a(T, $) {
      var P = s.styles[$];
      return P ? "\x1B[" + s.colors[P][0] + "m" + T + "\x1B[" + s.colors[P][1] + "m" : T;
    }
    function l(T, $) {
      return T;
    }
    function u(T) {
      var $ = {};
      return T.forEach(function(P, H) {
        $[P] = !0;
      }), $;
    }
    function c(T, $, P) {
      if (T.customInspect && $ && F($.inspect) && // Filter out the util module, it's inspect function is special
      $.inspect !== t.inspect && // Also filter out any prototype objects using the circular check.
      !($.constructor && $.constructor.prototype === $)) {
        var H = $.inspect(P, T);
        return y(H) || (H = c(T, H, P)), H;
      }
      var Z = f(T, $);
      if (Z)
        return Z;
      var le = Object.keys($), J = u(le);
      if (T.showHidden && (le = Object.getOwnPropertyNames($)), M($) && (le.indexOf("message") >= 0 || le.indexOf("description") >= 0))
        return d($);
      if (le.length === 0) {
        if (F($)) {
          var ue = $.name ? ": " + $.name : "";
          return T.stylize("[Function" + ue + "]", "special");
        }
        if (x($))
          return T.stylize(RegExp.prototype.toString.call($), "regexp");
        if (C($))
          return T.stylize(Date.prototype.toString.call($), "date");
        if (M($))
          return d($);
      }
      var he = "", me = !1, oe = ["{", "}"];
      if (m($) && (me = !0, oe = ["[", "]"]), F($)) {
        var re = $.name ? ": " + $.name : "";
        he = " [Function" + re + "]";
      }
      if (x($) && (he = " " + RegExp.prototype.toString.call($)), C($) && (he = " " + Date.prototype.toUTCString.call($)), M($) && (he = " " + d($)), le.length === 0 && (!me || $.length == 0))
        return oe[0] + he + oe[1];
      if (P < 0)
        return x($) ? T.stylize(RegExp.prototype.toString.call($), "regexp") : T.stylize("[Object]", "special");
      T.seen.push($);
      var se;
      return me ? se = h(T, $, P, J, le) : se = le.map(function(ae) {
        return p(T, $, P, J, ae, me);
      }), T.seen.pop(), g(se, he, oe);
    }
    function f(T, $) {
      if (E($))
        return T.stylize("undefined", "undefined");
      if (y($)) {
        var P = "'" + JSON.stringify($).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return T.stylize(P, "string");
      }
      if (b($))
        return T.stylize("" + $, "number");
      if (v($))
        return T.stylize("" + $, "boolean");
      if (S($))
        return T.stylize("null", "null");
    }
    function d(T) {
      return "[" + Error.prototype.toString.call(T) + "]";
    }
    function h(T, $, P, H, Z) {
      for (var le = [], J = 0, ue = $.length; J < ue; ++J)
        ne($, String(J)) ? le.push(p(
          T,
          $,
          P,
          H,
          String(J),
          !0
        )) : le.push("");
      return Z.forEach(function(he) {
        he.match(/^\d+$/) || le.push(p(
          T,
          $,
          P,
          H,
          he,
          !0
        ));
      }), le;
    }
    function p(T, $, P, H, Z, le) {
      var J, ue, he;
      if (he = Object.getOwnPropertyDescriptor($, Z) || { value: $[Z] }, he.get ? he.set ? ue = T.stylize("[Getter/Setter]", "special") : ue = T.stylize("[Getter]", "special") : he.set && (ue = T.stylize("[Setter]", "special")), ne(H, Z) || (J = "[" + Z + "]"), ue || (T.seen.indexOf(he.value) < 0 ? (S(P) ? ue = c(T, he.value, null) : ue = c(T, he.value, P - 1), ue.indexOf(`
`) > -1 && (le ? ue = ue.split(`
`).map(function(me) {
        return "  " + me;
      }).join(`
`).slice(2) : ue = `
` + ue.split(`
`).map(function(me) {
        return "   " + me;
      }).join(`
`))) : ue = T.stylize("[Circular]", "special")), E(J)) {
        if (le && Z.match(/^\d+$/))
          return ue;
        J = JSON.stringify("" + Z), J.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (J = J.slice(1, -1), J = T.stylize(J, "name")) : (J = J.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), J = T.stylize(J, "string"));
      }
      return J + ": " + ue;
    }
    function g(T, $, P) {
      var H = T.reduce(function(Z, le) {
        return le.indexOf(`
`) >= 0, Z + le.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return H > 60 ? P[0] + ($ === "" ? "" : $ + `
 `) + " " + T.join(`,
  `) + " " + P[1] : P[0] + $ + " " + T.join(", ") + " " + P[1];
    }
    t.types = PK();
    function m(T) {
      return Array.isArray(T);
    }
    t.isArray = m;
    function v(T) {
      return typeof T == "boolean";
    }
    t.isBoolean = v;
    function S(T) {
      return T === null;
    }
    t.isNull = S;
    function _(T) {
      return T == null;
    }
    t.isNullOrUndefined = _;
    function b(T) {
      return typeof T == "number";
    }
    t.isNumber = b;
    function y(T) {
      return typeof T == "string";
    }
    t.isString = y;
    function w(T) {
      return typeof T == "symbol";
    }
    t.isSymbol = w;
    function E(T) {
      return T === void 0;
    }
    t.isUndefined = E;
    function x(T) {
      return k(T) && B(T) === "[object RegExp]";
    }
    t.isRegExp = x, t.types.isRegExp = x;
    function k(T) {
      return typeof T == "object" && T !== null;
    }
    t.isObject = k;
    function C(T) {
      return k(T) && B(T) === "[object Date]";
    }
    t.isDate = C, t.types.isDate = C;
    function M(T) {
      return k(T) && (B(T) === "[object Error]" || T instanceof Error);
    }
    t.isError = M, t.types.isNativeError = M;
    function F(T) {
      return typeof T == "function";
    }
    t.isFunction = F;
    function U(T) {
      return T === null || typeof T == "boolean" || typeof T == "number" || typeof T == "string" || typeof T == "symbol" || // ES6 symbol
      typeof T > "u";
    }
    t.isPrimitive = U, t.isBuffer = $K();
    function B(T) {
      return Object.prototype.toString.call(T);
    }
    function N(T) {
      return T < 10 ? "0" + T.toString(10) : T.toString(10);
    }
    var q = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function Q() {
      var T = /* @__PURE__ */ new Date(), $ = [
        N(T.getHours()),
        N(T.getMinutes()),
        N(T.getSeconds())
      ].join(":");
      return [T.getDate(), q[T.getMonth()], $].join(" ");
    }
    t.log = function() {
      console.log("%s - %s", Q(), t.format.apply(t, arguments));
    }, t.inherits = MK(), t._extend = function(T, $) {
      if (!$ || !k($)) return T;
      for (var P = Object.keys($), H = P.length; H--; )
        T[P[H]] = $[P[H]];
      return T;
    };
    function ne(T, $) {
      return Object.prototype.hasOwnProperty.call(T, $);
    }
    var X = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    t.promisify = function($) {
      if (typeof $ != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (X && $[X]) {
        var P = $[X];
        if (typeof P != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(P, X, {
          value: P,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), P;
      }
      function P() {
        for (var H, Z, le = new Promise(function(he, me) {
          H = he, Z = me;
        }), J = [], ue = 0; ue < arguments.length; ue++)
          J.push(arguments[ue]);
        J.push(function(he, me) {
          he ? Z(he) : H(me);
        });
        try {
          $.apply(this, J);
        } catch (he) {
          Z(he);
        }
        return le;
      }
      return Object.setPrototypeOf(P, Object.getPrototypeOf($)), X && Object.defineProperty(P, X, {
        value: P,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        P,
        e($)
      );
    }, t.promisify.custom = X;
    function O(T, $) {
      if (!T) {
        var P = new Error("Promise was rejected with a falsy value");
        P.reason = T, T = P;
      }
      return $(T);
    }
    function W(T) {
      if (typeof T != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function $() {
        for (var P = [], H = 0; H < arguments.length; H++)
          P.push(arguments[H]);
        var Z = P.pop();
        if (typeof Z != "function")
          throw new TypeError("The last argument must be of type Function");
        var le = this, J = function() {
          return Z.apply(le, arguments);
        };
        T.apply(this, P).then(
          function(ue) {
            process.nextTick(J.bind(null, null, ue));
          },
          function(ue) {
            process.nextTick(O.bind(null, ue, J));
          }
        );
      }
      return Object.setPrototypeOf($, Object.getPrototypeOf(T)), Object.defineProperties(
        $,
        e(T)
      ), $;
    }
    t.callbackify = W;
  }(Pv)), Pv;
}
var LA;
function FK() {
  return LA || (LA = 1, hg.TextEncoder = typeof TextEncoder < "u" ? TextEncoder : FA().TextEncoder, hg.TextDecoder = typeof TextDecoder < "u" ? TextDecoder : FA().TextDecoder), hg;
}
var BA;
function d0() {
  if (BA) return qs;
  BA = 1, Object.defineProperty(qs, "__esModule", { value: !0 }), qs.getArrayBuffer = qs.decodeBuffer = qs.encodeBuffer = void 0;
  var t = FK();
  function e(i) {
    var o = new t.TextEncoder(), s = o.encode(i);
    return r(s);
  }
  qs.encodeBuffer = e;
  function n(i, o) {
    var s = new t.TextDecoder(o);
    return s.decode(i);
  }
  qs.decodeBuffer = n;
  function r(i) {
    return i.buffer.slice(i.byteOffset, i.byteOffset + i.byteLength);
  }
  return qs.getArrayBuffer = r, qs;
}
var Wf = {}, jA;
function LK() {
  if (jA) return Wf;
  jA = 1, Object.defineProperty(Wf, "__esModule", { value: !0 }), Wf.uuidv4 = void 0;
  function t() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
      var n = Math.random() * 16 | 0, r = e == "x" ? n : n & 3 | 8;
      return r.toString(16);
    });
  }
  return Wf.uuidv4 = t, Wf;
}
var VA;
function h0() {
  if (VA) return Us;
  VA = 1;
  var t = Us && Us.__awaiter || function(a, l, u, c) {
    function f(d) {
      return d instanceof u ? d : new u(function(h) {
        h(d);
      });
    }
    return new (u || (u = Promise))(function(d, h) {
      function p(v) {
        try {
          m(c.next(v));
        } catch (S) {
          h(S);
        }
      }
      function g(v) {
        try {
          m(c.throw(v));
        } catch (S) {
          h(S);
        }
      }
      function m(v) {
        v.done ? d(v.value) : f(v.value).then(p, g);
      }
      m((c = c.apply(a, l || [])).next());
    });
  }, e = Us && Us.__generator || function(a, l) {
    var u = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, c, f, d, h;
    return h = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
      return this;
    }), h;
    function p(m) {
      return function(v) {
        return g([m, v]);
      };
    }
    function g(m) {
      if (c) throw new TypeError("Generator is already executing.");
      for (; u; ) try {
        if (c = 1, f && (d = m[0] & 2 ? f.return : m[0] ? f.throw || ((d = f.return) && d.call(f), 0) : f.next) && !(d = d.call(f, m[1])).done) return d;
        switch (f = 0, d && (m = [m[0] & 2, d.value]), m[0]) {
          case 0:
          case 1:
            d = m;
            break;
          case 4:
            return u.label++, { value: m[1], done: !1 };
          case 5:
            u.label++, f = m[1], m = [0];
            continue;
          case 7:
            m = u.ops.pop(), u.trys.pop();
            continue;
          default:
            if (d = u.trys, !(d = d.length > 0 && d[d.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              u = 0;
              continue;
            }
            if (m[0] === 3 && (!d || m[1] > d[0] && m[1] < d[3])) {
              u.label = m[1];
              break;
            }
            if (m[0] === 6 && u.label < d[1]) {
              u.label = d[1], d = m;
              break;
            }
            if (d && u.label < d[2]) {
              u.label = d[2], u.ops.push(m);
              break;
            }
            d[2] && u.ops.pop(), u.trys.pop();
            continue;
        }
        m = l.call(a, u);
      } catch (v) {
        m = [6, v], f = 0;
      } finally {
        c = d = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Us, "__esModule", { value: !0 }), Us.IsomorphicRequest = void 0;
  var n = Hi(), r = ta(), i = d0(), o = LK(), s = (
    /** @class */
    function() {
      function a(l, u) {
        u === void 0 && (u = {});
        var c = new ArrayBuffer(0);
        if (this._bodyUsed = !1, l instanceof a) {
          this.id = l.id, this.url = l.url, this.method = l.method, this.headers = l.headers, this.credentials = l.credentials, this._body = l._body || c;
          return;
        }
        this.id = o.uuidv4(), this.url = l, this.method = u.method || "GET", this.headers = new n.Headers(u.headers), this.credentials = u.credentials || "same-origin", this._body = u.body || c;
      }
      return Object.defineProperty(a.prototype, "bodyUsed", {
        get: function() {
          return this._bodyUsed;
        },
        enumerable: !1,
        configurable: !0
      }), a.prototype.text = function() {
        return t(this, void 0, void 0, function() {
          return e(this, function(l) {
            return r.invariant(!this.bodyUsed, 'Failed to execute "text" on "IsomorphicRequest": body buffer already read'), this._bodyUsed = !0, [2, i.decodeBuffer(this._body)];
          });
        });
      }, a.prototype.json = function() {
        return t(this, void 0, void 0, function() {
          var l;
          return e(this, function(u) {
            return r.invariant(!this.bodyUsed, 'Failed to execute "json" on "IsomorphicRequest": body buffer already read'), this._bodyUsed = !0, l = i.decodeBuffer(this._body), [2, JSON.parse(l)];
          });
        });
      }, a.prototype.arrayBuffer = function() {
        return t(this, void 0, void 0, function() {
          return e(this, function(l) {
            return r.invariant(!this.bodyUsed, 'Failed to execute "arrayBuffer" on "IsomorphicRequest": body buffer already read'), this._bodyUsed = !0, [2, this._body];
          });
        });
      }, a.prototype.clone = function() {
        return new a(this);
      }, a;
    }()
  );
  return Us.IsomorphicRequest = s, Us;
}
var Pl = {}, zs = {}, UA;
function BK() {
  if (UA) return zs;
  UA = 1;
  var t = zs && zs.__awaiter || function(r, i, o, s) {
    function a(l) {
      return l instanceof o ? l : new o(function(u) {
        u(l);
      });
    }
    return new (o || (o = Promise))(function(l, u) {
      function c(h) {
        try {
          d(s.next(h));
        } catch (p) {
          u(p);
        }
      }
      function f(h) {
        try {
          d(s.throw(h));
        } catch (p) {
          u(p);
        }
      }
      function d(h) {
        h.done ? l(h.value) : a(h.value).then(c, f);
      }
      d((s = s.apply(r, i || [])).next());
    });
  }, e = zs && zs.__generator || function(r, i) {
    var o = { label: 0, sent: function() {
      if (l[0] & 1) throw l[1];
      return l[1];
    }, trys: [], ops: [] }, s, a, l, u;
    return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
      return this;
    }), u;
    function c(d) {
      return function(h) {
        return f([d, h]);
      };
    }
    function f(d) {
      if (s) throw new TypeError("Generator is already executing.");
      for (; o; ) try {
        if (s = 1, a && (l = d[0] & 2 ? a.return : d[0] ? a.throw || ((l = a.return) && l.call(a), 0) : a.next) && !(l = l.call(a, d[1])).done) return l;
        switch (a = 0, l && (d = [d[0] & 2, l.value]), d[0]) {
          case 0:
          case 1:
            l = d;
            break;
          case 4:
            return o.label++, { value: d[1], done: !1 };
          case 5:
            o.label++, a = d[1], d = [0];
            continue;
          case 7:
            d = o.ops.pop(), o.trys.pop();
            continue;
          default:
            if (l = o.trys, !(l = l.length > 0 && l[l.length - 1]) && (d[0] === 6 || d[0] === 2)) {
              o = 0;
              continue;
            }
            if (d[0] === 3 && (!l || d[1] > l[0] && d[1] < l[3])) {
              o.label = d[1];
              break;
            }
            if (d[0] === 6 && o.label < l[1]) {
              o.label = l[1], l = d;
              break;
            }
            if (l && o.label < l[2]) {
              o.label = l[2], o.ops.push(d);
              break;
            }
            l[2] && o.ops.pop(), o.trys.pop();
            continue;
        }
        d = i.call(r, o);
      } catch (h) {
        d = [6, h], a = 0;
      } finally {
        s = l = 0;
      }
      if (d[0] & 5) throw d[1];
      return { value: d[0] ? d[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(zs, "__esModule", { value: !0 }), zs.createLazyCallback = void 0;
  function n(r) {
    var i = this;
    r === void 0 && (r = {});
    var o = 0, s, a, l = new Promise(function(c) {
      a = c;
    }).finally(function() {
      clearTimeout(s);
    }), u = function() {
      for (var c, f = [], d = 0; d < arguments.length; d++)
        f[d] = arguments[d];
      r.maxCalls && o >= r.maxCalls && ((c = r.maxCallsCallback) === null || c === void 0 || c.call(r)), a(f), o++;
    };
    return u.invoked = function() {
      return t(i, void 0, void 0, function() {
        return e(this, function(c) {
          return s = setTimeout(function() {
            a([]);
          }, 0), [2, l];
        });
      });
    }, u;
  }
  return zs.createLazyCallback = n, zs;
}
var qA;
function qE() {
  if (qA) return Pl;
  qA = 1;
  var t = Pl && Pl.__extends || /* @__PURE__ */ function() {
    var o = function(s, a) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, u) {
        l.__proto__ = u;
      } || function(l, u) {
        for (var c in u) Object.prototype.hasOwnProperty.call(u, c) && (l[c] = u[c]);
      }, o(s, a);
    };
    return function(s, a) {
      if (typeof a != "function" && a !== null)
        throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
      o(s, a);
      function l() {
        this.constructor = s;
      }
      s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
    };
  }();
  Object.defineProperty(Pl, "__esModule", { value: !0 }), Pl.InteractiveIsomorphicRequest = void 0;
  var e = ta(), n = h0(), r = BK(), i = (
    /** @class */
    function(o) {
      t(s, o);
      function s(a) {
        var l = o.call(this, a) || this;
        return l.respondWith = r.createLazyCallback({
          maxCalls: 1,
          maxCallsCallback: function() {
            e.invariant(!1, 'Failed to respond to "%s %s" request: the "request" event has already been responded to.', l.method, l.url.href);
          }
        }), l;
      }
      return s;
    }(n.IsomorphicRequest)
  );
  return Pl.InteractiveIsomorphicRequest = i, Pl;
}
var Yf = {}, zA;
function wL() {
  if (zA) return Yf;
  zA = 1, Object.defineProperty(Yf, "__esModule", { value: !0 }), Yf.getCleanUrl = void 0;
  function t(e, n) {
    return n === void 0 && (n = !0), [n && e.origin, e.pathname].filter(Boolean).join("");
  }
  return Yf.getCleanUrl = t, Yf;
}
var HA;
function Pb() {
  return HA || (HA = 1, function(t) {
    var e = Dl && Dl.__createBinding || (Object.create ? function(o, s, a, l) {
      l === void 0 && (l = a), Object.defineProperty(o, l, { enumerable: !0, get: function() {
        return s[a];
      } });
    } : function(o, s, a, l) {
      l === void 0 && (l = a), o[l] = s[a];
    }), n = Dl && Dl.__exportStar || function(o, s) {
      for (var a in o) a !== "default" && !Object.prototype.hasOwnProperty.call(s, a) && e(s, o, a);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeBuffer = t.encodeBuffer = t.getCleanUrl = void 0, n(LE(), t), n(u0(), t), n(tK(), t), n(h0(), t), n(qE(), t);
    var r = wL();
    Object.defineProperty(t, "getCleanUrl", { enumerable: !0, get: function() {
      return r.getCleanUrl;
    } });
    var i = d0();
    Object.defineProperty(t, "encodeBuffer", { enumerable: !0, get: function() {
      return i.encodeBuffer;
    } }), Object.defineProperty(t, "decodeBuffer", { enumerable: !0, get: function() {
      return i.decodeBuffer;
    } });
  }(Dl)), Dl;
}
var $l = {}, Xf = {}, zu = { exports: {} }, GA;
function jK() {
  if (GA) return zu.exports;
  GA = 1;
  var t = {
    decodeValues: !0,
    map: !1,
    silent: !1
  };
  function e(s) {
    return typeof s == "string" && !!s.trim();
  }
  function n(s, a) {
    var l = s.split(";").filter(e), u = l.shift(), c = r(u), f = c.name, d = c.value;
    a = a ? Object.assign({}, t, a) : t;
    try {
      d = a.decodeValues ? decodeURIComponent(d) : d;
    } catch (p) {
      console.error(
        "set-cookie-parser encountered an error while decoding a cookie with value '" + d + "'. Set options.decodeValues to false to disable this feature.",
        p
      );
    }
    var h = {
      name: f,
      value: d
    };
    return l.forEach(function(p) {
      var g = p.split("="), m = g.shift().trimLeft().toLowerCase(), v = g.join("=");
      m === "expires" ? h.expires = new Date(v) : m === "max-age" ? h.maxAge = parseInt(v, 10) : m === "secure" ? h.secure = !0 : m === "httponly" ? h.httpOnly = !0 : m === "samesite" ? h.sameSite = v : m === "partitioned" ? h.partitioned = !0 : h[m] = v;
    }), h;
  }
  function r(s) {
    var a = "", l = "", u = s.split("=");
    return u.length > 1 ? (a = u.shift(), l = u.join("=")) : l = s, { name: a, value: l };
  }
  function i(s, a) {
    if (a = a ? Object.assign({}, t, a) : t, !s)
      return a.map ? {} : [];
    if (s.headers)
      if (typeof s.headers.getSetCookie == "function")
        s = s.headers.getSetCookie();
      else if (s.headers["set-cookie"])
        s = s.headers["set-cookie"];
      else {
        var l = s.headers[Object.keys(s.headers).find(function(c) {
          return c.toLowerCase() === "set-cookie";
        })];
        !l && s.headers.cookie && !a.silent && console.warn(
          "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
        ), s = l;
      }
    if (Array.isArray(s) || (s = [s]), a.map) {
      var u = {};
      return s.filter(e).reduce(function(c, f) {
        var d = n(f, a);
        return c[d.name] = d, c;
      }, u);
    } else
      return s.filter(e).map(function(c) {
        return n(c, a);
      });
  }
  function o(s) {
    if (Array.isArray(s))
      return s;
    if (typeof s != "string")
      return [];
    var a = [], l = 0, u, c, f, d, h;
    function p() {
      for (; l < s.length && /\s/.test(s.charAt(l)); )
        l += 1;
      return l < s.length;
    }
    function g() {
      return c = s.charAt(l), c !== "=" && c !== ";" && c !== ",";
    }
    for (; l < s.length; ) {
      for (u = l, h = !1; p(); )
        if (c = s.charAt(l), c === ",") {
          for (f = l, l += 1, p(), d = l; l < s.length && g(); )
            l += 1;
          l < s.length && s.charAt(l) === "=" ? (h = !0, l = d, a.push(s.substring(u, f)), u = l) : l = f + 1;
        } else
          l += 1;
      (!h || l >= s.length) && a.push(s.substring(u, s.length));
    }
    return a;
  }
  return zu.exports = i, zu.exports.parse = i, zu.exports.parseString = n, zu.exports.splitCookiesString = o, zu.exports;
}
var WA;
function VK() {
  return WA || (WA = 1, function(t) {
    var e = Xf && Xf.__rest || function(o, s) {
      var a = {};
      for (var l in o) Object.prototype.hasOwnProperty.call(o, l) && s.indexOf(l) < 0 && (a[l] = o[l]);
      if (o != null && typeof Object.getOwnPropertySymbols == "function")
        for (var u = 0, l = Object.getOwnPropertySymbols(o); u < l.length; u++)
          s.indexOf(l[u]) < 0 && Object.prototype.propertyIsEnumerable.call(o, l[u]) && (a[l[u]] = o[l[u]]);
      return a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.store = t.PERSISTENCY_KEY = void 0;
    const n = /* @__PURE__ */ jK();
    t.PERSISTENCY_KEY = "MSW_COOKIE_STORE";
    function r() {
      try {
        if (localStorage == null)
          return !1;
        const o = t.PERSISTENCY_KEY + "_test";
        return localStorage.setItem(o, "test"), localStorage.getItem(o), localStorage.removeItem(o), !0;
      } catch {
        return !1;
      }
    }
    class i {
      constructor() {
        this.store = /* @__PURE__ */ new Map();
      }
      /**
       * Sets the given request cookies into the store.
       * Respects the `request.credentials` policy.
       */
      add(s, a) {
        if (s.credentials === "omit")
          return;
        const l = new URL(s.url), u = a.headers.get("set-cookie");
        if (!u)
          return;
        const c = Date.now(), f = n.parse(u).map((h) => {
          var { maxAge: p } = h, g = e(h, ["maxAge"]);
          return Object.assign(Object.assign({}, g), { expires: p === void 0 ? g.expires : new Date(c + p * 1e3), maxAge: p });
        }), d = this.store.get(l.origin) || /* @__PURE__ */ new Map();
        f.forEach((h) => {
          this.store.set(l.origin, d.set(h.name, h));
        });
      }
      /**
       * Returns cookies relevant to the given request
       * and its `request.credentials` policy.
       */
      get(s) {
        this.deleteExpiredCookies();
        const a = new URL(s.url), l = this.store.get(a.origin) || /* @__PURE__ */ new Map();
        switch (s.credentials) {
          case "include":
            return typeof document > "u" || n.parse(document.cookie).forEach((c) => {
              l.set(c.name, c);
            }), l;
          case "same-origin":
            return l;
          default:
            return /* @__PURE__ */ new Map();
        }
      }
      /**
       * Returns a collection of all stored cookies.
       */
      getAll() {
        return this.deleteExpiredCookies(), this.store;
      }
      /**
       * Deletes all cookies associated with the given request.
       */
      deleteAll(s) {
        const a = new URL(s.url);
        this.store.delete(a.origin);
      }
      /**
       * Clears the entire cookie store.
       */
      clear() {
        this.store.clear();
      }
      /**
       * Hydrates the virtual cookie store from the `localStorage` if defined.
       */
      hydrate() {
        if (!r())
          return;
        const s = localStorage.getItem(t.PERSISTENCY_KEY);
        if (s)
          try {
            JSON.parse(s).forEach(([l, u]) => {
              this.store.set(l, new Map(u.map((c) => {
                var [f, d] = c, { expires: h } = d, p = e(d, ["expires"]);
                return [
                  f,
                  h === void 0 ? p : Object.assign(Object.assign({}, p), { expires: new Date(h) })
                ];
              })));
            });
          } catch (a) {
            console.warn(`
[virtual-cookie] Failed to parse a stored cookie from the localStorage (key "${t.PERSISTENCY_KEY}").

Stored value:
${localStorage.getItem(t.PERSISTENCY_KEY)}

Thrown exception:
${a}

Invalid value has been removed from localStorage to prevent subsequent failed parsing attempts.`), localStorage.removeItem(t.PERSISTENCY_KEY);
          }
      }
      /**
       * Persists the current virtual cookies into the `localStorage` if defined,
       * so they are available on the next page load.
       */
      persist() {
        if (!r())
          return;
        const s = Array.from(this.store.entries()).map(([a, l]) => [a, Array.from(l.entries())]);
        localStorage.setItem(t.PERSISTENCY_KEY, JSON.stringify(s));
      }
      deleteExpiredCookies() {
        const s = Date.now();
        this.store.forEach((a, l) => {
          a.forEach(({ expires: u, name: c }) => {
            u !== void 0 && u.getTime() <= s && a.delete(c);
          }), a.size === 0 && this.store.delete(l);
        });
      }
    }
    t.store = new i();
  }(Xf)), Xf;
}
var YA;
function XA() {
  return YA || (YA = 1, function(t) {
    var e = $l && $l.__createBinding || (Object.create ? function(r, i, o, s) {
      s === void 0 && (s = o), Object.defineProperty(r, s, { enumerable: !0, get: function() {
        return i[o];
      } });
    } : function(r, i, o, s) {
      s === void 0 && (s = o), r[s] = i[o];
    }), n = $l && $l.__exportStar || function(r, i) {
      for (var o in r) o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, r, o);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), n(VK(), t);
  }($l)), $l;
}
var $b, KA;
function UK() {
  return KA || (KA = 1, $b = /* @__PURE__ */ function() {
    function t(e, n, r, i, o) {
      return e < n || r < n ? e > r ? r + 1 : e + 1 : i === o ? n : n + 1;
    }
    return function(e, n) {
      if (e === n)
        return 0;
      if (e.length > n.length) {
        var r = e;
        e = n, n = r;
      }
      for (var i = e.length, o = n.length; i > 0 && e.charCodeAt(i - 1) === n.charCodeAt(o - 1); )
        i--, o--;
      for (var s = 0; s < i && e.charCodeAt(s) === n.charCodeAt(s); )
        s++;
      if (i -= s, o -= s, i === 0 || o < 3)
        return o;
      var a = 0, l, u, c, f, d, h, p, g, m, v, S, _, b = [];
      for (l = 0; l < i; l++)
        b.push(l + 1), b.push(e.charCodeAt(s + l));
      for (var y = b.length - 1; a < o - 3; )
        for (m = n.charCodeAt(s + (u = a)), v = n.charCodeAt(s + (c = a + 1)), S = n.charCodeAt(s + (f = a + 2)), _ = n.charCodeAt(s + (d = a + 3)), h = a += 4, l = 0; l < y; l += 2)
          p = b[l], g = b[l + 1], u = t(p, u, c, m, g), c = t(u, c, f, v, g), f = t(c, f, d, S, g), h = t(f, d, h, _, g), b[l] = h, d = f, f = c, c = u, u = p;
      for (; a < o; )
        for (m = n.charCodeAt(s + (u = a)), h = ++a, l = 0; l < y; l += 2)
          p = b[l], b[l] = h = t(p, u, h, m, b[l + 1]), u = p;
      return h;
    };
  }()), $b;
}
const qK = /* @__PURE__ */ OS(PH);
function zK(t) {
  for (var e = [], n = 0; n < t.length; ) {
    var r = t[n];
    if (r === "*" || r === "+" || r === "?") {
      e.push({ type: "MODIFIER", index: n, value: t[n++] });
      continue;
    }
    if (r === "\\") {
      e.push({ type: "ESCAPED_CHAR", index: n++, value: t[n++] });
      continue;
    }
    if (r === "{") {
      e.push({ type: "OPEN", index: n, value: t[n++] });
      continue;
    }
    if (r === "}") {
      e.push({ type: "CLOSE", index: n, value: t[n++] });
      continue;
    }
    if (r === ":") {
      for (var i = "", o = n + 1; o < t.length; ) {
        var s = t.charCodeAt(o);
        if (
          // `0-9`
          s >= 48 && s <= 57 || // `A-Z`
          s >= 65 && s <= 90 || // `a-z`
          s >= 97 && s <= 122 || // `_`
          s === 95
        ) {
          i += t[o++];
          continue;
        }
        break;
      }
      if (!i)
        throw new TypeError("Missing parameter name at ".concat(n));
      e.push({ type: "NAME", index: n, value: i }), n = o;
      continue;
    }
    if (r === "(") {
      var a = 1, l = "", o = n + 1;
      if (t[o] === "?")
        throw new TypeError('Pattern cannot start with "?" at '.concat(o));
      for (; o < t.length; ) {
        if (t[o] === "\\") {
          l += t[o++] + t[o++];
          continue;
        }
        if (t[o] === ")") {
          if (a--, a === 0) {
            o++;
            break;
          }
        } else if (t[o] === "(" && (a++, t[o + 1] !== "?"))
          throw new TypeError("Capturing groups are not allowed at ".concat(o));
        l += t[o++];
      }
      if (a)
        throw new TypeError("Unbalanced pattern at ".concat(n));
      if (!l)
        throw new TypeError("Missing pattern at ".concat(n));
      e.push({ type: "PATTERN", index: n, value: l }), n = o;
      continue;
    }
    e.push({ type: "CHAR", index: n, value: t[n++] });
  }
  return e.push({ type: "END", index: n, value: "" }), e;
}
function zE(t, e) {
  e === void 0 && (e = {});
  for (var n = zK(t), r = e.prefixes, i = r === void 0 ? "./" : r, o = e.delimiter, s = o === void 0 ? "/#?" : o, a = [], l = 0, u = 0, c = "", f = function(k) {
    if (u < n.length && n[u].type === k)
      return n[u++].value;
  }, d = function(k) {
    var C = f(k);
    if (C !== void 0)
      return C;
    var M = n[u], F = M.type, U = M.index;
    throw new TypeError("Unexpected ".concat(F, " at ").concat(U, ", expected ").concat(k));
  }, h = function() {
    for (var k = "", C; C = f("CHAR") || f("ESCAPED_CHAR"); )
      k += C;
    return k;
  }, p = function(k) {
    for (var C = 0, M = s; C < M.length; C++) {
      var F = M[C];
      if (k.indexOf(F) > -1)
        return !0;
    }
    return !1;
  }, g = function(k) {
    var C = a[a.length - 1], M = k || (C && typeof C == "string" ? C : "");
    if (C && !M)
      throw new TypeError('Must have text between two parameters, missing text after "'.concat(C.name, '"'));
    return !M || p(M) ? "[^".concat(Ma(s), "]+?") : "(?:(?!".concat(Ma(M), ")[^").concat(Ma(s), "])+?");
  }; u < n.length; ) {
    var m = f("CHAR"), v = f("NAME"), S = f("PATTERN");
    if (v || S) {
      var _ = m || "";
      i.indexOf(_) === -1 && (c += _, _ = ""), c && (a.push(c), c = ""), a.push({
        name: v || l++,
        prefix: _,
        suffix: "",
        pattern: S || g(_),
        modifier: f("MODIFIER") || ""
      });
      continue;
    }
    var b = m || f("ESCAPED_CHAR");
    if (b) {
      c += b;
      continue;
    }
    c && (a.push(c), c = "");
    var y = f("OPEN");
    if (y) {
      var _ = h(), w = f("NAME") || "", E = f("PATTERN") || "", x = h();
      d("CLOSE"), a.push({
        name: w || (E ? l++ : ""),
        pattern: w && !E ? g(_) : E,
        prefix: _,
        suffix: x,
        modifier: f("MODIFIER") || ""
      });
      continue;
    }
    d("END");
  }
  return a;
}
function HK(t, e) {
  return SL(zE(t, e), e);
}
function SL(t, e) {
  e === void 0 && (e = {});
  var n = HE(e), r = e.encode, i = r === void 0 ? function(l) {
    return l;
  } : r, o = e.validate, s = o === void 0 ? !0 : o, a = t.map(function(l) {
    if (typeof l == "object")
      return new RegExp("^(?:".concat(l.pattern, ")$"), n);
  });
  return function(l) {
    for (var u = "", c = 0; c < t.length; c++) {
      var f = t[c];
      if (typeof f == "string") {
        u += f;
        continue;
      }
      var d = l ? l[f.name] : void 0, h = f.modifier === "?" || f.modifier === "*", p = f.modifier === "*" || f.modifier === "+";
      if (Array.isArray(d)) {
        if (!p)
          throw new TypeError('Expected "'.concat(f.name, '" to not repeat, but got an array'));
        if (d.length === 0) {
          if (h)
            continue;
          throw new TypeError('Expected "'.concat(f.name, '" to not be empty'));
        }
        for (var g = 0; g < d.length; g++) {
          var m = i(d[g], f);
          if (s && !a[c].test(m))
            throw new TypeError('Expected all "'.concat(f.name, '" to match "').concat(f.pattern, '", but got "').concat(m, '"'));
          u += f.prefix + m + f.suffix;
        }
        continue;
      }
      if (typeof d == "string" || typeof d == "number") {
        var m = i(String(d), f);
        if (s && !a[c].test(m))
          throw new TypeError('Expected "'.concat(f.name, '" to match "').concat(f.pattern, '", but got "').concat(m, '"'));
        u += f.prefix + m + f.suffix;
        continue;
      }
      if (!h) {
        var v = p ? "an array" : "a string";
        throw new TypeError('Expected "'.concat(f.name, '" to be ').concat(v));
      }
    }
    return u;
  };
}
function GK(t, e) {
  var n = [], r = GE(t, n, e);
  return _L(r, n, e);
}
function _L(t, e, n) {
  n === void 0 && (n = {});
  var r = n.decode, i = r === void 0 ? function(o) {
    return o;
  } : r;
  return function(o) {
    var s = t.exec(o);
    if (!s)
      return !1;
    for (var a = s[0], l = s.index, u = /* @__PURE__ */ Object.create(null), c = function(d) {
      if (s[d] === void 0)
        return "continue";
      var h = e[d - 1];
      h.modifier === "*" || h.modifier === "+" ? u[h.name] = s[d].split(h.prefix + h.suffix).map(function(p) {
        return i(p, h);
      }) : u[h.name] = i(s[d], h);
    }, f = 1; f < s.length; f++)
      c(f);
    return { path: a, index: l, params: u };
  };
}
function Ma(t) {
  return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function HE(t) {
  return t && t.sensitive ? "" : "i";
}
function WK(t, e) {
  if (!e)
    return t;
  for (var n = /\((?:\?<(.*?)>)?(?!\?)/g, r = 0, i = n.exec(t.source); i; )
    e.push({
      // Use parenthesized substring match if available, index otherwise
      name: i[1] || r++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    }), i = n.exec(t.source);
  return t;
}
function YK(t, e, n) {
  var r = t.map(function(i) {
    return GE(i, e, n).source;
  });
  return new RegExp("(?:".concat(r.join("|"), ")"), HE(n));
}
function XK(t, e, n) {
  return EL(zE(t, n), e, n);
}
function EL(t, e, n) {
  n === void 0 && (n = {});
  for (var r = n.strict, i = r === void 0 ? !1 : r, o = n.start, s = o === void 0 ? !0 : o, a = n.end, l = a === void 0 ? !0 : a, u = n.encode, c = u === void 0 ? function(C) {
    return C;
  } : u, f = n.delimiter, d = f === void 0 ? "/#?" : f, h = n.endsWith, p = h === void 0 ? "" : h, g = "[".concat(Ma(p), "]|$"), m = "[".concat(Ma(d), "]"), v = s ? "^" : "", S = 0, _ = t; S < _.length; S++) {
    var b = _[S];
    if (typeof b == "string")
      v += Ma(c(b));
    else {
      var y = Ma(c(b.prefix)), w = Ma(c(b.suffix));
      if (b.pattern)
        if (e && e.push(b), y || w)
          if (b.modifier === "+" || b.modifier === "*") {
            var E = b.modifier === "*" ? "?" : "";
            v += "(?:".concat(y, "((?:").concat(b.pattern, ")(?:").concat(w).concat(y, "(?:").concat(b.pattern, "))*)").concat(w, ")").concat(E);
          } else
            v += "(?:".concat(y, "(").concat(b.pattern, ")").concat(w, ")").concat(b.modifier);
        else {
          if (b.modifier === "+" || b.modifier === "*")
            throw new TypeError('Can not repeat "'.concat(b.name, '" without a prefix and suffix'));
          v += "(".concat(b.pattern, ")").concat(b.modifier);
        }
      else
        v += "(?:".concat(y).concat(w, ")").concat(b.modifier);
    }
  }
  if (l)
    i || (v += "".concat(m, "?")), v += n.endsWith ? "(?=".concat(g, ")") : "$";
  else {
    var x = t[t.length - 1], k = typeof x == "string" ? m.indexOf(x[x.length - 1]) > -1 : x === void 0;
    i || (v += "(?:".concat(m, "(?=").concat(g, "))?")), k || (v += "(?=".concat(m, "|").concat(g, ")"));
  }
  return new RegExp(v, HE(n));
}
function GE(t, e, n) {
  return t instanceof RegExp ? WK(t, e) : Array.isArray(t) ? YK(t, e, n) : XK(t, e, n);
}
const KK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compile: HK,
  match: GK,
  parse: zE,
  pathToRegexp: GE,
  regexpToFunction: _L,
  tokensToFunction: SL,
  tokensToRegexp: EL
}, Symbol.toStringTag, { value: "Module" })), QK = /* @__PURE__ */ OS(KK);
var ii = {}, Kf = {}, QA;
function kL() {
  if (QA) return Kf;
  QA = 1, Object.defineProperty(Kf, "__esModule", { value: !0 }), Kf.toIsoResponse = void 0;
  var t = Hi();
  function e(n) {
    var r;
    return {
      status: (r = n.status) !== null && r !== void 0 ? r : 200,
      statusText: n.statusText || "OK",
      headers: t.objectToHeaders(n.headers || {}),
      body: n.body
    };
  }
  return Kf.toIsoResponse = e, Kf;
}
var JA;
function JK() {
  if (JA) return ii;
  JA = 1;
  var t = ii && ii.__extends || /* @__PURE__ */ function() {
    var g = function(m, v) {
      return g = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(S, _) {
        S.__proto__ = _;
      } || function(S, _) {
        for (var b in _) Object.prototype.hasOwnProperty.call(_, b) && (S[b] = _[b]);
      }, g(m, v);
    };
    return function(m, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Class extends value " + String(v) + " is not a constructor or null");
      g(m, v);
      function S() {
        this.constructor = m;
      }
      m.prototype = v === null ? Object.create(v) : (S.prototype = v.prototype, new S());
    };
  }(), e = ii && ii.__assign || function() {
    return e = Object.assign || function(g) {
      for (var m, v = 1, S = arguments.length; v < S; v++) {
        m = arguments[v];
        for (var _ in m) Object.prototype.hasOwnProperty.call(m, _) && (g[_] = m[_]);
      }
      return g;
    }, e.apply(this, arguments);
  }, n = ii && ii.__awaiter || function(g, m, v, S) {
    function _(b) {
      return b instanceof v ? b : new v(function(y) {
        y(b);
      });
    }
    return new (v || (v = Promise))(function(b, y) {
      function w(k) {
        try {
          x(S.next(k));
        } catch (C) {
          y(C);
        }
      }
      function E(k) {
        try {
          x(S.throw(k));
        } catch (C) {
          y(C);
        }
      }
      function x(k) {
        k.done ? b(k.value) : _(k.value).then(w, E);
      }
      x((S = S.apply(g, m || [])).next());
    });
  }, r = ii && ii.__generator || function(g, m) {
    var v = { label: 0, sent: function() {
      if (b[0] & 1) throw b[1];
      return b[1];
    }, trys: [], ops: [] }, S, _, b, y;
    return y = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
      return this;
    }), y;
    function w(x) {
      return function(k) {
        return E([x, k]);
      };
    }
    function E(x) {
      if (S) throw new TypeError("Generator is already executing.");
      for (; v; ) try {
        if (S = 1, _ && (b = x[0] & 2 ? _.return : x[0] ? _.throw || ((b = _.return) && b.call(_), 0) : _.next) && !(b = b.call(_, x[1])).done) return b;
        switch (_ = 0, b && (x = [x[0] & 2, b.value]), x[0]) {
          case 0:
          case 1:
            b = x;
            break;
          case 4:
            return v.label++, { value: x[1], done: !1 };
          case 5:
            v.label++, _ = x[1], x = [0];
            continue;
          case 7:
            x = v.ops.pop(), v.trys.pop();
            continue;
          default:
            if (b = v.trys, !(b = b.length > 0 && b[b.length - 1]) && (x[0] === 6 || x[0] === 2)) {
              v = 0;
              continue;
            }
            if (x[0] === 3 && (!b || x[1] > b[0] && x[1] < b[3])) {
              v.label = x[1];
              break;
            }
            if (x[0] === 6 && v.label < b[1]) {
              v.label = b[1], b = x;
              break;
            }
            if (b && v.label < b[2]) {
              v.label = b[2], v.ops.push(x);
              break;
            }
            b[2] && v.ops.pop(), v.trys.pop();
            continue;
        }
        x = m.call(g, v);
      } catch (k) {
        x = [6, k], _ = 0;
      } finally {
        S = b = 0;
      }
      if (x[0] & 5) throw x[1];
      return { value: x[0] ? x[1] : void 0, done: !0 };
    }
  }, i = ii && ii.__read || function(g, m) {
    var v = typeof Symbol == "function" && g[Symbol.iterator];
    if (!v) return g;
    var S = v.call(g), _, b = [], y;
    try {
      for (; (m === void 0 || m-- > 0) && !(_ = S.next()).done; ) b.push(_.value);
    } catch (w) {
      y = { error: w };
    } finally {
      try {
        _ && !_.done && (v = S.return) && v.call(S);
      } finally {
        if (y) throw y.error;
      }
    }
    return b;
  };
  Object.defineProperty(ii, "__esModule", { value: !0 }), ii.FetchInterceptor = void 0;
  var o = Hi(), s = ta(), a = sc(), l = h0(), u = LE(), c = u0(), f = kL(), d = qE(), h = (
    /** @class */
    function(g) {
      t(m, g);
      function m() {
        return g.call(this, m.symbol) || this;
      }
      return m.prototype.checkEnvironment = function() {
        return typeof globalThis < "u" && typeof globalThis.fetch < "u";
      }, m.prototype.setup = function() {
        var v = this, S = globalThis.fetch;
        s.invariant(!S[u.IS_PATCHED_MODULE], 'Failed to patch the "fetch" module: already patched.'), globalThis.fetch = function(_, b) {
          return n(v, void 0, void 0, function() {
            var y, w, E, x, k, C, M, F, U, B, N, q, Q, ne = this;
            return r(this, function(X) {
              switch (X.label) {
                case 0:
                  return y = new Request(_, b), w = typeof _ == "string" ? _ : _.url, E = y.method, this.log("[%s] %s", E, w), [4, y.clone().arrayBuffer()];
                case 1:
                  return x = X.sent(), k = new URL(w, typeof location < "u" ? location.origin : void 0), C = new l.IsomorphicRequest(k, {
                    body: x,
                    method: E,
                    headers: new o.Headers(y.headers),
                    credentials: y.credentials
                  }), M = new d.InteractiveIsomorphicRequest(C), this.log("isomorphic request", M), this.log('emitting the "request" event for %d listener(s)...', this.emitter.listenerCount("request")), this.emitter.emit("request", M), this.log("awaiting for the mocked response..."), [4, a.until(function() {
                    return n(ne, void 0, void 0, function() {
                      var O, W;
                      return r(this, function(T) {
                        switch (T.label) {
                          case 0:
                            return [4, this.emitter.untilIdle("request", function($) {
                              var P = i($.args, 1), H = P[0];
                              return H.id === M.id;
                            })];
                          case 1:
                            return T.sent(), this.log("all request listeners have been resolved!"), [4, M.respondWith.invoked()];
                          case 2:
                            return O = i.apply(void 0, [T.sent(), 1]), W = O[0], this.log("event.respondWith called with:", W), [2, W];
                        }
                      });
                    });
                  })];
                case 2:
                  return F = i.apply(void 0, [X.sent(), 2]), U = F[0], B = F[1], U ? (console.error(y.method + " " + y.url + " net::ERR_FAILED"), N = Object.assign(new TypeError("Failed to fetch"), {
                    cause: U
                  }), [2, Promise.reject(N)]) : B ? (this.log("received mocked response:", B), q = f.toIsoResponse(B), this.log("derived isomorphic response:", q), this.emitter.emit("response", M, q), Q = new Response(B.body, e(e({}, q), {
                    // `Response.headers` cannot be instantiated with the `Headers` polyfill.
                    // Apparently, it halts if the `Headers` class contains unknown properties
                    // (i.e. the internal `Headers.map`).
                    headers: o.flattenHeadersObject(B.headers || {})
                  })), Object.defineProperty(Q, "url", {
                    writable: !1,
                    enumerable: !0,
                    configurable: !1,
                    value: M.url.href
                  }), [2, Q]) : (this.log("no mocked response received!"), [2, S(y).then(function(O) {
                    return n(ne, void 0, void 0, function() {
                      var W, T, $, P;
                      return r(this, function(H) {
                        switch (H.label) {
                          case 0:
                            return W = O.clone(), this.log("original fetch performed", W), $ = (T = this.emitter).emit, P = [
                              "response",
                              M
                            ], [4, p(W)];
                          case 1:
                            return $.apply(T, P.concat([H.sent()])), [2, O];
                        }
                      });
                    });
                  })]);
              }
            });
          });
        }, Object.defineProperty(globalThis.fetch, u.IS_PATCHED_MODULE, {
          enumerable: !0,
          configurable: !0,
          value: !0
        }), this.subscriptions.push(function() {
          Object.defineProperty(globalThis.fetch, u.IS_PATCHED_MODULE, {
            value: void 0
          }), globalThis.fetch = S, v.log('restored native "globalThis.fetch"!', globalThis.fetch.name);
        });
      }, m.symbol = Symbol("fetch"), m;
    }(c.Interceptor)
  );
  ii.FetchInterceptor = h;
  function p(g) {
    return n(this, void 0, void 0, function() {
      var m;
      return r(this, function(v) {
        switch (v.label) {
          case 0:
            return m = {
              status: g.status,
              statusText: g.statusText,
              headers: o.objectToHeaders(o.headersToObject(g.headers))
            }, [4, g.text()];
          case 1:
            return [2, (m.body = v.sent(), m)];
        }
      });
    });
  }
  return ii;
}
var Ml = {}, Vi = {}, Qf = {}, Hs = {}, Fl = {}, ZA;
function p0() {
  if (ZA) return Fl;
  ZA = 1;
  function t(o, s, a) {
    if (a === void 0 && (a = Array.prototype), o && typeof a.find == "function")
      return a.find.call(o, s);
    for (var l = 0; l < o.length; l++)
      if (Object.prototype.hasOwnProperty.call(o, l)) {
        var u = o[l];
        if (s.call(void 0, u, l, o))
          return u;
      }
  }
  function e(o, s) {
    return s === void 0 && (s = Object), s && typeof s.freeze == "function" ? s.freeze(o) : o;
  }
  function n(o, s) {
    if (o === null || typeof o != "object")
      throw new TypeError("target is not an object");
    for (var a in s)
      Object.prototype.hasOwnProperty.call(s, a) && (o[a] = s[a]);
    return o;
  }
  var r = e({
    /**
     * `text/html`, the only mime type that triggers treating an XML document as HTML.
     *
     * @see DOMParser.SupportedType.isHTML
     * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/HTML Wikipedia
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
     * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
     */
    HTML: "text/html",
    /**
     * Helper method to check a mime type if it indicates an HTML document
     *
     * @param {string} [value]
     * @returns {boolean}
     *
     * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/HTML Wikipedia
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
     * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
    isHTML: function(o) {
      return o === r.HTML;
    },
    /**
     * `application/xml`, the standard mime type for XML documents.
     *
     * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
     * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
     * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
     */
    XML_APPLICATION: "application/xml",
    /**
     * `text/html`, an alias for `application/xml`.
     *
     * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
     * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
     */
    XML_TEXT: "text/xml",
    /**
     * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
     * but is parsed as an XML document.
     *
     * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
     * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
     */
    XML_XHTML_APPLICATION: "application/xhtml+xml",
    /**
     * `image/svg+xml`,
     *
     * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
     * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
     * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
     */
    XML_SVG_IMAGE: "image/svg+xml"
  }), i = e({
    /**
     * The XHTML namespace.
     *
     * @see http://www.w3.org/1999/xhtml
     */
    HTML: "http://www.w3.org/1999/xhtml",
    /**
     * Checks if `uri` equals `NAMESPACE.HTML`.
     *
     * @param {string} [uri]
     *
     * @see NAMESPACE.HTML
     */
    isHTML: function(o) {
      return o === i.HTML;
    },
    /**
     * The SVG namespace.
     *
     * @see http://www.w3.org/2000/svg
     */
    SVG: "http://www.w3.org/2000/svg",
    /**
     * The `xml:` namespace.
     *
     * @see http://www.w3.org/XML/1998/namespace
     */
    XML: "http://www.w3.org/XML/1998/namespace",
    /**
     * The `xmlns:` namespace
     *
     * @see https://www.w3.org/2000/xmlns/
     */
    XMLNS: "http://www.w3.org/2000/xmlns/"
  });
  return Fl.assign = n, Fl.find = t, Fl.freeze = e, Fl.MIME_TYPE = r, Fl.NAMESPACE = i, Fl;
}
var eR;
function TL() {
  if (eR) return Hs;
  eR = 1;
  var t = p0(), e = t.find, n = t.NAMESPACE;
  function r(R) {
    return R !== "";
  }
  function i(R) {
    return R ? R.split(/[\t\n\f\r ]+/).filter(r) : [];
  }
  function o(R, I) {
    return R.hasOwnProperty(I) || (R[I] = !0), R;
  }
  function s(R) {
    if (!R) return [];
    var I = i(R);
    return Object.keys(I.reduce(o, {}));
  }
  function a(R) {
    return function(I) {
      return R && R.indexOf(I) !== -1;
    };
  }
  function l(R, I) {
    for (var j in R)
      Object.prototype.hasOwnProperty.call(R, j) && (I[j] = R[j]);
  }
  function u(R, I) {
    var j = R.prototype;
    if (!(j instanceof I)) {
      let te = function() {
      };
      te.prototype = I.prototype, te = new te(), l(j, te), R.prototype = j = te;
    }
    j.constructor != R && (typeof R != "function" && console.error("unknown Class:" + R), j.constructor = R);
  }
  var c = {}, f = c.ELEMENT_NODE = 1, d = c.ATTRIBUTE_NODE = 2, h = c.TEXT_NODE = 3, p = c.CDATA_SECTION_NODE = 4, g = c.ENTITY_REFERENCE_NODE = 5, m = c.ENTITY_NODE = 6, v = c.PROCESSING_INSTRUCTION_NODE = 7, S = c.COMMENT_NODE = 8, _ = c.DOCUMENT_NODE = 9, b = c.DOCUMENT_TYPE_NODE = 10, y = c.DOCUMENT_FRAGMENT_NODE = 11, w = c.NOTATION_NODE = 12, E = {}, x = {};
  E.INDEX_SIZE_ERR = (x[1] = "Index size error", 1), E.DOMSTRING_SIZE_ERR = (x[2] = "DOMString size error", 2);
  var k = E.HIERARCHY_REQUEST_ERR = (x[3] = "Hierarchy request error", 3);
  E.WRONG_DOCUMENT_ERR = (x[4] = "Wrong document", 4), E.INVALID_CHARACTER_ERR = (x[5] = "Invalid character", 5), E.NO_DATA_ALLOWED_ERR = (x[6] = "No data allowed", 6), E.NO_MODIFICATION_ALLOWED_ERR = (x[7] = "No modification allowed", 7);
  var C = E.NOT_FOUND_ERR = (x[8] = "Not found", 8);
  E.NOT_SUPPORTED_ERR = (x[9] = "Not supported", 9);
  var M = E.INUSE_ATTRIBUTE_ERR = (x[10] = "Attribute in use", 10);
  E.INVALID_STATE_ERR = (x[11] = "Invalid state", 11), E.SYNTAX_ERR = (x[12] = "Syntax error", 12), E.INVALID_MODIFICATION_ERR = (x[13] = "Invalid modification", 13), E.NAMESPACE_ERR = (x[14] = "Invalid namespace", 14), E.INVALID_ACCESS_ERR = (x[15] = "Invalid access", 15);
  function F(R, I) {
    if (I instanceof Error)
      var j = I;
    else
      j = this, Error.call(this, x[R]), this.message = x[R], Error.captureStackTrace && Error.captureStackTrace(this, F);
    return j.code = R, I && (this.message = this.message + ": " + I), j;
  }
  F.prototype = Error.prototype, l(E, F);
  function U() {
  }
  U.prototype = {
    /**
     * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
     * @standard level1
     */
    length: 0,
    /**
     * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
     * @standard level1
     * @param index  unsigned long
     *   Index into the collection.
     * @return Node
     * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
     */
    item: function(R) {
      return R >= 0 && R < this.length ? this[R] : null;
    },
    toString: function(R, I) {
      for (var j = [], te = 0; te < this.length; te++)
        ke(this[te], j, R, I);
      return j.join("");
    },
    /**
     * @private
     * @param {function (Node):boolean} predicate
     * @returns {Node[]}
     */
    filter: function(R) {
      return Array.prototype.filter.call(this, R);
    },
    /**
     * @private
     * @param {Node} item
     * @returns {number}
     */
    indexOf: function(R) {
      return Array.prototype.indexOf.call(this, R);
    }
  };
  function B(R, I) {
    this._node = R, this._refresh = I, N(this);
  }
  function N(R) {
    var I = R._node._inc || R._node.ownerDocument._inc;
    if (R._inc !== I) {
      var j = R._refresh(R._node);
      if (Ie(R, "length", j.length), !R.$$length || j.length < R.$$length)
        for (var te = j.length; te in R; te++)
          Object.prototype.hasOwnProperty.call(R, te) && delete R[te];
      l(j, R), R._inc = I;
    }
  }
  B.prototype.item = function(R) {
    return N(this), this[R] || null;
  }, u(B, U);
  function q() {
  }
  function Q(R, I) {
    for (var j = R.length; j--; )
      if (R[j] === I)
        return j;
  }
  function ne(R, I, j, te) {
    if (te ? I[Q(I, te)] = j : I[I.length++] = j, R) {
      j.ownerElement = R;
      var Ee = R.ownerDocument;
      Ee && (te && Z(Ee, R, te), H(Ee, R, j));
    }
  }
  function X(R, I, j) {
    var te = Q(I, j);
    if (te >= 0) {
      for (var Ee = I.length - 1; te < Ee; )
        I[te] = I[++te];
      if (I.length = Ee, R) {
        var Ue = R.ownerDocument;
        Ue && (Z(Ue, R, j), j.ownerElement = null);
      }
    } else
      throw new F(C, new Error(R.tagName + "@" + j));
  }
  q.prototype = {
    length: 0,
    item: U.prototype.item,
    getNamedItem: function(R) {
      for (var I = this.length; I--; ) {
        var j = this[I];
        if (j.nodeName == R)
          return j;
      }
    },
    setNamedItem: function(R) {
      var I = R.ownerElement;
      if (I && I != this._ownerElement)
        throw new F(M);
      var j = this.getNamedItem(R.nodeName);
      return ne(this._ownerElement, this, R, j), j;
    },
    /* returns Node */
    setNamedItemNS: function(R) {
      var I = R.ownerElement, j;
      if (I && I != this._ownerElement)
        throw new F(M);
      return j = this.getNamedItemNS(R.namespaceURI, R.localName), ne(this._ownerElement, this, R, j), j;
    },
    /* returns Node */
    removeNamedItem: function(R) {
      var I = this.getNamedItem(R);
      return X(this._ownerElement, this, I), I;
    },
    // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
    //for level2
    removeNamedItemNS: function(R, I) {
      var j = this.getNamedItemNS(R, I);
      return X(this._ownerElement, this, j), j;
    },
    getNamedItemNS: function(R, I) {
      for (var j = this.length; j--; ) {
        var te = this[j];
        if (te.localName == I && te.namespaceURI == R)
          return te;
      }
      return null;
    }
  };
  function O() {
  }
  O.prototype = {
    /**
     * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
     * The different implementations fairly diverged in what kind of features were reported.
     * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
     *
     * @deprecated It is deprecated and modern browsers return true in all cases.
     *
     * @param {string} feature
     * @param {string} [version]
     * @returns {boolean} always true
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
     * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
     */
    hasFeature: function(R, I) {
      return !0;
    },
    /**
     * Creates an XML Document object of the specified type with its document element.
     *
     * __It behaves slightly different from the description in the living standard__:
     * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
     * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
     * - this implementation is not validating names or qualified names
     *   (when parsing XML strings, the SAX parser takes care of that)
     *
     * @param {string|null} namespaceURI
     * @param {string} qualifiedName
     * @param {DocumentType=null} doctype
     * @returns {Document}
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
     * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
     *
     * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
     * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
     * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
     */
    createDocument: function(R, I, j) {
      var te = new P();
      if (te.implementation = this, te.childNodes = new U(), te.doctype = j || null, j && te.appendChild(j), I) {
        var Ee = te.createElementNS(R, I);
        te.appendChild(Ee);
      }
      return te;
    },
    /**
     * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
     *
     * __This behavior is slightly different from the in the specs__:
     * - this implementation is not validating names or qualified names
     *   (when parsing XML strings, the SAX parser takes care of that)
     *
     * @param {string} qualifiedName
     * @param {string} [publicId]
     * @param {string} [systemId]
     * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
     * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
     * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
     *
     * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
     * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
     * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
     */
    createDocumentType: function(R, I, j) {
      var te = new bt();
      return te.name = R, te.nodeName = R, te.publicId = I || "", te.systemId = j || "", te;
    }
  };
  function W() {
  }
  W.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(R, I) {
      return ee(this, R, I);
    },
    replaceChild: function(R, I) {
      ee(this, R, I, Re), I && this.removeChild(I);
    },
    removeChild: function(R) {
      return J(this, R);
    },
    appendChild: function(R) {
      return this.insertBefore(R, null);
    },
    hasChildNodes: function() {
      return this.firstChild != null;
    },
    cloneNode: function(R) {
      return we(this.ownerDocument || this, this, R);
    },
    // Modified in DOM Level 2:
    normalize: function() {
      for (var R = this.firstChild; R; ) {
        var I = R.nextSibling;
        I && I.nodeType == h && R.nodeType == h ? (this.removeChild(I), R.appendData(I.data)) : (R.normalize(), R = I);
      }
    },
    // Introduced in DOM Level 2:
    isSupported: function(R, I) {
      return this.ownerDocument.implementation.hasFeature(R, I);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
      return this.attributes.length > 0;
    },
    /**
     * Look up the prefix associated to the given namespace URI, starting from this node.
     * **The default namespace declarations are ignored by this method.**
     * See Namespace Prefix Lookup for details on the algorithm used by this method.
     *
     * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
     *
     * @param {string | null} namespaceURI
     * @returns {string | null}
     * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
     * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
     * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
     * @see https://github.com/xmldom/xmldom/issues/322
     */
    lookupPrefix: function(R) {
      for (var I = this; I; ) {
        var j = I._nsMap;
        if (j) {
          for (var te in j)
            if (Object.prototype.hasOwnProperty.call(j, te) && j[te] === R)
              return te;
        }
        I = I.nodeType == d ? I.ownerDocument : I.parentNode;
      }
      return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(R) {
      for (var I = this; I; ) {
        var j = I._nsMap;
        if (j && Object.prototype.hasOwnProperty.call(j, R))
          return j[R];
        I = I.nodeType == d ? I.ownerDocument : I.parentNode;
      }
      return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(R) {
      var I = this.lookupPrefix(R);
      return I == null;
    }
  };
  function T(R) {
    return R == "<" && "&lt;" || R == ">" && "&gt;" || R == "&" && "&amp;" || R == '"' && "&quot;" || "&#" + R.charCodeAt() + ";";
  }
  l(c, W), l(c, W.prototype);
  function $(R, I) {
    if (I(R))
      return !0;
    if (R = R.firstChild)
      do
        if ($(R, I))
          return !0;
      while (R = R.nextSibling);
  }
  function P() {
    this.ownerDocument = this;
  }
  function H(R, I, j) {
    R && R._inc++;
    var te = j.namespaceURI;
    te === n.XMLNS && (I._nsMap[j.prefix ? j.localName : ""] = j.value);
  }
  function Z(R, I, j, te) {
    R && R._inc++;
    var Ee = j.namespaceURI;
    Ee === n.XMLNS && delete I._nsMap[j.prefix ? j.localName : ""];
  }
  function le(R, I, j) {
    if (R && R._inc) {
      R._inc++;
      var te = I.childNodes;
      if (j)
        te[te.length++] = j;
      else {
        for (var Ee = I.firstChild, Ue = 0; Ee; )
          te[Ue++] = Ee, Ee = Ee.nextSibling;
        te.length = Ue, delete te[te.length];
      }
    }
  }
  function J(R, I) {
    var j = I.previousSibling, te = I.nextSibling;
    return j ? j.nextSibling = te : R.firstChild = te, te ? te.previousSibling = j : R.lastChild = j, I.parentNode = null, I.previousSibling = null, I.nextSibling = null, le(R.ownerDocument, R), I;
  }
  function ue(R) {
    return R && (R.nodeType === W.DOCUMENT_NODE || R.nodeType === W.DOCUMENT_FRAGMENT_NODE || R.nodeType === W.ELEMENT_NODE);
  }
  function he(R) {
    return R && (oe(R) || re(R) || me(R) || R.nodeType === W.DOCUMENT_FRAGMENT_NODE || R.nodeType === W.COMMENT_NODE || R.nodeType === W.PROCESSING_INSTRUCTION_NODE);
  }
  function me(R) {
    return R && R.nodeType === W.DOCUMENT_TYPE_NODE;
  }
  function oe(R) {
    return R && R.nodeType === W.ELEMENT_NODE;
  }
  function re(R) {
    return R && R.nodeType === W.TEXT_NODE;
  }
  function se(R, I) {
    var j = R.childNodes || [];
    if (e(j, oe) || me(I))
      return !1;
    var te = e(j, me);
    return !(I && te && j.indexOf(te) > j.indexOf(I));
  }
  function ae(R, I) {
    var j = R.childNodes || [];
    function te(Ue) {
      return oe(Ue) && Ue !== I;
    }
    if (e(j, te))
      return !1;
    var Ee = e(j, me);
    return !(I && Ee && j.indexOf(Ee) > j.indexOf(I));
  }
  function fe(R, I, j) {
    if (!ue(R))
      throw new F(k, "Unexpected parent node type " + R.nodeType);
    if (j && j.parentNode !== R)
      throw new F(C, "child not in parent");
    if (
      // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
      !he(I) || // 5. If either `node` is a Text node and `parent` is a document,
      // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
      // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
      // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
      me(I) && R.nodeType !== W.DOCUMENT_NODE
    )
      throw new F(
        k,
        "Unexpected node type " + I.nodeType + " for parent node type " + R.nodeType
      );
  }
  function Y(R, I, j) {
    var te = R.childNodes || [], Ee = I.childNodes || [];
    if (I.nodeType === W.DOCUMENT_FRAGMENT_NODE) {
      var Ue = Ee.filter(oe);
      if (Ue.length > 1 || e(Ee, re))
        throw new F(k, "More than one element or text in fragment");
      if (Ue.length === 1 && !se(R, j))
        throw new F(k, "Element in fragment can not be inserted before doctype");
    }
    if (oe(I) && !se(R, j))
      throw new F(k, "Only one element can be added and only after doctype");
    if (me(I)) {
      if (e(te, me))
        throw new F(k, "Only one doctype is allowed");
      var ut = e(te, oe);
      if (j && te.indexOf(ut) < te.indexOf(j))
        throw new F(k, "Doctype can only be inserted before an element");
      if (!j && ut)
        throw new F(k, "Doctype can not be appended since element is present");
    }
  }
  function Re(R, I, j) {
    var te = R.childNodes || [], Ee = I.childNodes || [];
    if (I.nodeType === W.DOCUMENT_FRAGMENT_NODE) {
      var Ue = Ee.filter(oe);
      if (Ue.length > 1 || e(Ee, re))
        throw new F(k, "More than one element or text in fragment");
      if (Ue.length === 1 && !ae(R, j))
        throw new F(k, "Element in fragment can not be inserted before doctype");
    }
    if (oe(I) && !ae(R, j))
      throw new F(k, "Only one element can be added and only after doctype");
    if (me(I)) {
      if (e(te, function(ze) {
        return me(ze) && ze !== j;
      }))
        throw new F(k, "Only one doctype is allowed");
      var ut = e(te, oe);
      if (j && te.indexOf(ut) < te.indexOf(j))
        throw new F(k, "Doctype can only be inserted before an element");
    }
  }
  function ee(R, I, j, te) {
    fe(R, I, j), R.nodeType === W.DOCUMENT_NODE && (te || Y)(R, I, j);
    var Ee = I.parentNode;
    if (Ee && Ee.removeChild(I), I.nodeType === y) {
      var Ue = I.firstChild;
      if (Ue == null)
        return I;
      var ut = I.lastChild;
    } else
      Ue = ut = I;
    var qe = j ? j.previousSibling : R.lastChild;
    Ue.previousSibling = qe, ut.nextSibling = j, qe ? qe.nextSibling = Ue : R.firstChild = Ue, j == null ? R.lastChild = ut : j.previousSibling = ut;
    do
      Ue.parentNode = R;
    while (Ue !== ut && (Ue = Ue.nextSibling));
    return le(R.ownerDocument || R, R), I.nodeType == y && (I.firstChild = I.lastChild = null), I;
  }
  function Ye(R, I) {
    return I.parentNode && I.parentNode.removeChild(I), I.parentNode = R, I.previousSibling = R.lastChild, I.nextSibling = null, I.previousSibling ? I.previousSibling.nextSibling = I : R.firstChild = I, R.lastChild = I, le(R.ownerDocument, R, I), I;
  }
  P.prototype = {
    //implementation : null,
    nodeName: "#document",
    nodeType: _,
    /**
     * The DocumentType node of the document.
     *
     * @readonly
     * @type DocumentType
     */
    doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(R, I) {
      if (R.nodeType == y) {
        for (var j = R.firstChild; j; ) {
          var te = j.nextSibling;
          this.insertBefore(j, I), j = te;
        }
        return R;
      }
      return ee(this, R, I), R.ownerDocument = this, this.documentElement === null && R.nodeType === f && (this.documentElement = R), R;
    },
    removeChild: function(R) {
      return this.documentElement == R && (this.documentElement = null), J(this, R);
    },
    replaceChild: function(R, I) {
      ee(this, R, I, Re), R.ownerDocument = this, I && this.removeChild(I), oe(R) && (this.documentElement = R);
    },
    // Introduced in DOM Level 2:
    importNode: function(R, I) {
      return Ae(this, R, I);
    },
    // Introduced in DOM Level 2:
    getElementById: function(R) {
      var I = null;
      return $(this.documentElement, function(j) {
        if (j.nodeType == f && j.getAttribute("id") == R)
          return I = j, !0;
      }), I;
    },
    /**
     * The `getElementsByClassName` method of `Document` interface returns an array-like object
     * of all child elements which have **all** of the given class name(s).
     *
     * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
     *
     *
     * Warning: This is a live LiveNodeList.
     * Changes in the DOM will reflect in the array as the changes occur.
     * If an element selected by this array no longer qualifies for the selector,
     * it will automatically be removed. Be aware of this for iteration purposes.
     *
     * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
     * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
     */
    getElementsByClassName: function(R) {
      var I = s(R);
      return new B(this, function(j) {
        var te = [];
        return I.length > 0 && $(j.documentElement, function(Ee) {
          if (Ee !== j && Ee.nodeType === f) {
            var Ue = Ee.getAttribute("class");
            if (Ue) {
              var ut = R === Ue;
              if (!ut) {
                var qe = s(Ue);
                ut = I.every(a(qe));
              }
              ut && te.push(Ee);
            }
          }
        }), te;
      });
    },
    //document factory method:
    createElement: function(R) {
      var I = new Te();
      I.ownerDocument = this, I.nodeName = R, I.tagName = R, I.localName = R, I.childNodes = new U();
      var j = I.attributes = new q();
      return j._ownerElement = I, I;
    },
    createDocumentFragment: function() {
      var R = new jn();
      return R.ownerDocument = this, R.childNodes = new U(), R;
    },
    createTextNode: function(R) {
      var I = new Je();
      return I.ownerDocument = this, I.appendData(R), I;
    },
    createComment: function(R) {
      var I = new pt();
      return I.ownerDocument = this, I.appendData(R), I;
    },
    createCDATASection: function(R) {
      var I = new Pt();
      return I.ownerDocument = this, I.appendData(R), I;
    },
    createProcessingInstruction: function(R, I) {
      var j = new $t();
      return j.ownerDocument = this, j.tagName = j.nodeName = j.target = R, j.nodeValue = j.data = I, j;
    },
    createAttribute: function(R) {
      var I = new ve();
      return I.ownerDocument = this, I.name = R, I.nodeName = R, I.localName = R, I.specified = !0, I;
    },
    createEntityReference: function(R) {
      var I = new ln();
      return I.ownerDocument = this, I.nodeName = R, I;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(R, I) {
      var j = new Te(), te = I.split(":"), Ee = j.attributes = new q();
      return j.childNodes = new U(), j.ownerDocument = this, j.nodeName = I, j.tagName = I, j.namespaceURI = R, te.length == 2 ? (j.prefix = te[0], j.localName = te[1]) : j.localName = I, Ee._ownerElement = j, j;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(R, I) {
      var j = new ve(), te = I.split(":");
      return j.ownerDocument = this, j.nodeName = I, j.name = I, j.namespaceURI = R, j.specified = !0, te.length == 2 ? (j.prefix = te[0], j.localName = te[1]) : j.localName = I, j;
    }
  }, u(P, W);
  function Te() {
    this._nsMap = {};
  }
  Te.prototype = {
    nodeType: f,
    hasAttribute: function(R) {
      return this.getAttributeNode(R) != null;
    },
    getAttribute: function(R) {
      var I = this.getAttributeNode(R);
      return I && I.value || "";
    },
    getAttributeNode: function(R) {
      return this.attributes.getNamedItem(R);
    },
    setAttribute: function(R, I) {
      var j = this.ownerDocument.createAttribute(R);
      j.value = j.nodeValue = "" + I, this.setAttributeNode(j);
    },
    removeAttribute: function(R) {
      var I = this.getAttributeNode(R);
      I && this.removeAttributeNode(I);
    },
    //four real opeartion method
    appendChild: function(R) {
      return R.nodeType === y ? this.insertBefore(R, null) : Ye(this, R);
    },
    setAttributeNode: function(R) {
      return this.attributes.setNamedItem(R);
    },
    setAttributeNodeNS: function(R) {
      return this.attributes.setNamedItemNS(R);
    },
    removeAttributeNode: function(R) {
      return this.attributes.removeNamedItem(R.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(R, I) {
      var j = this.getAttributeNodeNS(R, I);
      j && this.removeAttributeNode(j);
    },
    hasAttributeNS: function(R, I) {
      return this.getAttributeNodeNS(R, I) != null;
    },
    getAttributeNS: function(R, I) {
      var j = this.getAttributeNodeNS(R, I);
      return j && j.value || "";
    },
    setAttributeNS: function(R, I, j) {
      var te = this.ownerDocument.createAttributeNS(R, I);
      te.value = te.nodeValue = "" + j, this.setAttributeNode(te);
    },
    getAttributeNodeNS: function(R, I) {
      return this.attributes.getNamedItemNS(R, I);
    },
    getElementsByTagName: function(R) {
      return new B(this, function(I) {
        var j = [];
        return $(I, function(te) {
          te !== I && te.nodeType == f && (R === "*" || te.tagName == R) && j.push(te);
        }), j;
      });
    },
    getElementsByTagNameNS: function(R, I) {
      return new B(this, function(j) {
        var te = [];
        return $(j, function(Ee) {
          Ee !== j && Ee.nodeType === f && (R === "*" || Ee.namespaceURI === R) && (I === "*" || Ee.localName == I) && te.push(Ee);
        }), te;
      });
    }
  }, P.prototype.getElementsByTagName = Te.prototype.getElementsByTagName, P.prototype.getElementsByTagNameNS = Te.prototype.getElementsByTagNameNS, u(Te, W);
  function ve() {
  }
  ve.prototype.nodeType = d, u(ve, W);
  function Oe() {
  }
  Oe.prototype = {
    data: "",
    substringData: function(R, I) {
      return this.data.substring(R, R + I);
    },
    appendData: function(R) {
      R = this.data + R, this.nodeValue = this.data = R, this.length = R.length;
    },
    insertData: function(R, I) {
      this.replaceData(R, 0, I);
    },
    appendChild: function(R) {
      throw new Error(x[k]);
    },
    deleteData: function(R, I) {
      this.replaceData(R, I, "");
    },
    replaceData: function(R, I, j) {
      var te = this.data.substring(0, R), Ee = this.data.substring(R + I);
      j = te + j + Ee, this.nodeValue = this.data = j, this.length = j.length;
    }
  }, u(Oe, W);
  function Je() {
  }
  Je.prototype = {
    nodeName: "#text",
    nodeType: h,
    splitText: function(R) {
      var I = this.data, j = I.substring(R);
      I = I.substring(0, R), this.data = this.nodeValue = I, this.length = I.length;
      var te = this.ownerDocument.createTextNode(j);
      return this.parentNode && this.parentNode.insertBefore(te, this.nextSibling), te;
    }
  }, u(Je, Oe);
  function pt() {
  }
  pt.prototype = {
    nodeName: "#comment",
    nodeType: S
  }, u(pt, Oe);
  function Pt() {
  }
  Pt.prototype = {
    nodeName: "#cdata-section",
    nodeType: p
  }, u(Pt, Oe);
  function bt() {
  }
  bt.prototype.nodeType = b, u(bt, W);
  function Ft() {
  }
  Ft.prototype.nodeType = w, u(Ft, W);
  function mt() {
  }
  mt.prototype.nodeType = m, u(mt, W);
  function ln() {
  }
  ln.prototype.nodeType = g, u(ln, W);
  function jn() {
  }
  jn.prototype.nodeName = "#document-fragment", jn.prototype.nodeType = y, u(jn, W);
  function $t() {
  }
  $t.prototype.nodeType = v, u($t, W);
  function Tr() {
  }
  Tr.prototype.serializeToString = function(R, I, j) {
    return xr.call(R, I, j);
  }, W.prototype.toString = xr;
  function xr(R, I) {
    var j = [], te = this.nodeType == 9 && this.documentElement || this, Ee = te.prefix, Ue = te.namespaceURI;
    if (Ue && Ee == null) {
      var Ee = te.lookupPrefix(Ue);
      if (Ee == null)
        var ut = [
          { namespace: Ue, prefix: null }
          //{namespace:uri,prefix:''}
        ];
    }
    return ke(this, j, R, I, ut), j.join("");
  }
  function ce(R, I, j) {
    var te = R.prefix || "", Ee = R.namespaceURI;
    if (!Ee || te === "xml" && Ee === n.XML || Ee === n.XMLNS)
      return !1;
    for (var Ue = j.length; Ue--; ) {
      var ut = j[Ue];
      if (ut.prefix === te)
        return ut.namespace !== Ee;
    }
    return !0;
  }
  function ie(R, I, j) {
    R.push(" ", I, '="', j.replace(/[<>&"\t\n\r]/g, T), '"');
  }
  function ke(R, I, j, te, Ee) {
    if (Ee || (Ee = []), te)
      if (R = te(R), R) {
        if (typeof R == "string") {
          I.push(R);
          return;
        }
      } else
        return;
    switch (R.nodeType) {
      case f:
        var Ue = R.attributes, ut = Ue.length, be = R.firstChild, qe = R.tagName;
        j = n.isHTML(R.namespaceURI) || j;
        var ze = qe;
        if (!j && !R.prefix && R.namespaceURI) {
          for (var dt, Ce = 0; Ce < Ue.length; Ce++)
            if (Ue.item(Ce).name === "xmlns") {
              dt = Ue.item(Ce).value;
              break;
            }
          if (!dt)
            for (var Ze = Ee.length - 1; Ze >= 0; Ze--) {
              var Ge = Ee[Ze];
              if (Ge.prefix === "" && Ge.namespace === R.namespaceURI) {
                dt = Ge.namespace;
                break;
              }
            }
          if (dt !== R.namespaceURI)
            for (var Ze = Ee.length - 1; Ze >= 0; Ze--) {
              var Ge = Ee[Ze];
              if (Ge.namespace === R.namespaceURI) {
                Ge.prefix && (ze = Ge.prefix + ":" + qe);
                break;
              }
            }
        }
        I.push("<", ze);
        for (var ct = 0; ct < ut; ct++) {
          var Gt = Ue.item(ct);
          Gt.prefix == "xmlns" ? Ee.push({ prefix: Gt.localName, namespace: Gt.value }) : Gt.nodeName == "xmlns" && Ee.push({ prefix: "", namespace: Gt.value });
        }
        for (var ct = 0; ct < ut; ct++) {
          var Gt = Ue.item(ct);
          if (ce(Gt, j, Ee)) {
            var yt = Gt.prefix || "", G = Gt.namespaceURI;
            ie(I, yt ? "xmlns:" + yt : "xmlns", G), Ee.push({ prefix: yt, namespace: G });
          }
          ke(Gt, I, j, te, Ee);
        }
        if (qe === ze && ce(R, j, Ee)) {
          var yt = R.prefix || "", G = R.namespaceURI;
          ie(I, yt ? "xmlns:" + yt : "xmlns", G), Ee.push({ prefix: yt, namespace: G });
        }
        if (be || j && !/^(?:meta|link|img|br|hr|input)$/i.test(qe)) {
          if (I.push(">"), j && /^script$/i.test(qe))
            for (; be; )
              be.data ? I.push(be.data) : ke(be, I, j, te, Ee.slice()), be = be.nextSibling;
          else
            for (; be; )
              ke(be, I, j, te, Ee.slice()), be = be.nextSibling;
          I.push("</", ze, ">");
        } else
          I.push("/>");
        return;
      case _:
      case y:
        for (var be = R.firstChild; be; )
          ke(be, I, j, te, Ee.slice()), be = be.nextSibling;
        return;
      case d:
        return ie(I, R.name, R.value);
      case h:
        return I.push(
          R.data.replace(/[<&>]/g, T)
        );
      case p:
        return I.push("<![CDATA[", R.data, "]]>");
      case S:
        return I.push("<!--", R.data, "-->");
      case b:
        var xe = R.publicId, Me = R.systemId;
        if (I.push("<!DOCTYPE ", R.name), xe)
          I.push(" PUBLIC ", xe), Me && Me != "." && I.push(" ", Me), I.push(">");
        else if (Me && Me != ".")
          I.push(" SYSTEM ", Me, ">");
        else {
          var et = R.internalSubset;
          et && I.push(" [", et, "]"), I.push(">");
        }
        return;
      case v:
        return I.push("<?", R.target, " ", R.data, "?>");
      case g:
        return I.push("&", R.nodeName, ";");
      //case ENTITY_NODE:
      //case NOTATION_NODE:
      default:
        I.push("??", R.nodeName);
    }
  }
  function Ae(R, I, j) {
    var te;
    switch (I.nodeType) {
      case f:
        te = I.cloneNode(!1), te.ownerDocument = R;
      //var attrs = node2.attributes;
      //var len = attrs.length;
      //for(var i=0;i<len;i++){
      //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
      //}
      case y:
        break;
      case d:
        j = !0;
        break;
    }
    if (te || (te = I.cloneNode(!1)), te.ownerDocument = R, te.parentNode = null, j)
      for (var Ee = I.firstChild; Ee; )
        te.appendChild(Ae(R, Ee, j)), Ee = Ee.nextSibling;
    return te;
  }
  function we(R, I, j) {
    var te = new I.constructor();
    for (var Ee in I)
      if (Object.prototype.hasOwnProperty.call(I, Ee)) {
        var Ue = I[Ee];
        typeof Ue != "object" && Ue != te[Ee] && (te[Ee] = Ue);
      }
    switch (I.childNodes && (te.childNodes = new U()), te.ownerDocument = R, te.nodeType) {
      case f:
        var ut = I.attributes, qe = te.attributes = new q(), ze = ut.length;
        qe._ownerElement = te;
        for (var dt = 0; dt < ze; dt++)
          te.setAttributeNode(we(R, ut.item(dt), !0));
        break;
      case d:
        j = !0;
    }
    if (j)
      for (var Ce = I.firstChild; Ce; )
        te.appendChild(we(R, Ce, j)), Ce = Ce.nextSibling;
    return te;
  }
  function Ie(R, I, j) {
    R[I] = j;
  }
  try {
    if (Object.defineProperty) {
      let R = function(I) {
        switch (I.nodeType) {
          case f:
          case y:
            var j = [];
            for (I = I.firstChild; I; )
              I.nodeType !== 7 && I.nodeType !== 8 && j.push(R(I)), I = I.nextSibling;
            return j.join("");
          default:
            return I.nodeValue;
        }
      };
      Object.defineProperty(B.prototype, "length", {
        get: function() {
          return N(this), this.$$length;
        }
      }), Object.defineProperty(W.prototype, "textContent", {
        get: function() {
          return R(this);
        },
        set: function(I) {
          switch (this.nodeType) {
            case f:
            case y:
              for (; this.firstChild; )
                this.removeChild(this.firstChild);
              (I || String(I)) && this.appendChild(this.ownerDocument.createTextNode(I));
              break;
            default:
              this.data = I, this.value = I, this.nodeValue = I;
          }
        }
      }), Ie = function(I, j, te) {
        I["$$" + j] = te;
      };
    }
  } catch {
  }
  return Hs.DocumentType = bt, Hs.DOMException = F, Hs.DOMImplementation = O, Hs.Element = Te, Hs.Node = W, Hs.NodeList = U, Hs.XMLSerializer = Tr, Hs;
}
var Jf = {}, Mb = {}, tR;
function ZK() {
  return tR || (tR = 1, function(t) {
    var e = p0().freeze;
    t.XML_ENTITIES = e({
      amp: "&",
      apos: "'",
      gt: ">",
      lt: "<",
      quot: '"'
    }), t.HTML_ENTITIES = e({
      Aacute: "Á",
      aacute: "á",
      Abreve: "Ă",
      abreve: "ă",
      ac: "∾",
      acd: "∿",
      acE: "∾̳",
      Acirc: "Â",
      acirc: "â",
      acute: "´",
      Acy: "А",
      acy: "а",
      AElig: "Æ",
      aelig: "æ",
      af: "⁡",
      Afr: "𝔄",
      afr: "𝔞",
      Agrave: "À",
      agrave: "à",
      alefsym: "ℵ",
      aleph: "ℵ",
      Alpha: "Α",
      alpha: "α",
      Amacr: "Ā",
      amacr: "ā",
      amalg: "⨿",
      AMP: "&",
      amp: "&",
      And: "⩓",
      and: "∧",
      andand: "⩕",
      andd: "⩜",
      andslope: "⩘",
      andv: "⩚",
      ang: "∠",
      ange: "⦤",
      angle: "∠",
      angmsd: "∡",
      angmsdaa: "⦨",
      angmsdab: "⦩",
      angmsdac: "⦪",
      angmsdad: "⦫",
      angmsdae: "⦬",
      angmsdaf: "⦭",
      angmsdag: "⦮",
      angmsdah: "⦯",
      angrt: "∟",
      angrtvb: "⊾",
      angrtvbd: "⦝",
      angsph: "∢",
      angst: "Å",
      angzarr: "⍼",
      Aogon: "Ą",
      aogon: "ą",
      Aopf: "𝔸",
      aopf: "𝕒",
      ap: "≈",
      apacir: "⩯",
      apE: "⩰",
      ape: "≊",
      apid: "≋",
      apos: "'",
      ApplyFunction: "⁡",
      approx: "≈",
      approxeq: "≊",
      Aring: "Å",
      aring: "å",
      Ascr: "𝒜",
      ascr: "𝒶",
      Assign: "≔",
      ast: "*",
      asymp: "≈",
      asympeq: "≍",
      Atilde: "Ã",
      atilde: "ã",
      Auml: "Ä",
      auml: "ä",
      awconint: "∳",
      awint: "⨑",
      backcong: "≌",
      backepsilon: "϶",
      backprime: "‵",
      backsim: "∽",
      backsimeq: "⋍",
      Backslash: "∖",
      Barv: "⫧",
      barvee: "⊽",
      Barwed: "⌆",
      barwed: "⌅",
      barwedge: "⌅",
      bbrk: "⎵",
      bbrktbrk: "⎶",
      bcong: "≌",
      Bcy: "Б",
      bcy: "б",
      bdquo: "„",
      becaus: "∵",
      Because: "∵",
      because: "∵",
      bemptyv: "⦰",
      bepsi: "϶",
      bernou: "ℬ",
      Bernoullis: "ℬ",
      Beta: "Β",
      beta: "β",
      beth: "ℶ",
      between: "≬",
      Bfr: "𝔅",
      bfr: "𝔟",
      bigcap: "⋂",
      bigcirc: "◯",
      bigcup: "⋃",
      bigodot: "⨀",
      bigoplus: "⨁",
      bigotimes: "⨂",
      bigsqcup: "⨆",
      bigstar: "★",
      bigtriangledown: "▽",
      bigtriangleup: "△",
      biguplus: "⨄",
      bigvee: "⋁",
      bigwedge: "⋀",
      bkarow: "⤍",
      blacklozenge: "⧫",
      blacksquare: "▪",
      blacktriangle: "▴",
      blacktriangledown: "▾",
      blacktriangleleft: "◂",
      blacktriangleright: "▸",
      blank: "␣",
      blk12: "▒",
      blk14: "░",
      blk34: "▓",
      block: "█",
      bne: "=⃥",
      bnequiv: "≡⃥",
      bNot: "⫭",
      bnot: "⌐",
      Bopf: "𝔹",
      bopf: "𝕓",
      bot: "⊥",
      bottom: "⊥",
      bowtie: "⋈",
      boxbox: "⧉",
      boxDL: "╗",
      boxDl: "╖",
      boxdL: "╕",
      boxdl: "┐",
      boxDR: "╔",
      boxDr: "╓",
      boxdR: "╒",
      boxdr: "┌",
      boxH: "═",
      boxh: "─",
      boxHD: "╦",
      boxHd: "╤",
      boxhD: "╥",
      boxhd: "┬",
      boxHU: "╩",
      boxHu: "╧",
      boxhU: "╨",
      boxhu: "┴",
      boxminus: "⊟",
      boxplus: "⊞",
      boxtimes: "⊠",
      boxUL: "╝",
      boxUl: "╜",
      boxuL: "╛",
      boxul: "┘",
      boxUR: "╚",
      boxUr: "╙",
      boxuR: "╘",
      boxur: "└",
      boxV: "║",
      boxv: "│",
      boxVH: "╬",
      boxVh: "╫",
      boxvH: "╪",
      boxvh: "┼",
      boxVL: "╣",
      boxVl: "╢",
      boxvL: "╡",
      boxvl: "┤",
      boxVR: "╠",
      boxVr: "╟",
      boxvR: "╞",
      boxvr: "├",
      bprime: "‵",
      Breve: "˘",
      breve: "˘",
      brvbar: "¦",
      Bscr: "ℬ",
      bscr: "𝒷",
      bsemi: "⁏",
      bsim: "∽",
      bsime: "⋍",
      bsol: "\\",
      bsolb: "⧅",
      bsolhsub: "⟈",
      bull: "•",
      bullet: "•",
      bump: "≎",
      bumpE: "⪮",
      bumpe: "≏",
      Bumpeq: "≎",
      bumpeq: "≏",
      Cacute: "Ć",
      cacute: "ć",
      Cap: "⋒",
      cap: "∩",
      capand: "⩄",
      capbrcup: "⩉",
      capcap: "⩋",
      capcup: "⩇",
      capdot: "⩀",
      CapitalDifferentialD: "ⅅ",
      caps: "∩︀",
      caret: "⁁",
      caron: "ˇ",
      Cayleys: "ℭ",
      ccaps: "⩍",
      Ccaron: "Č",
      ccaron: "č",
      Ccedil: "Ç",
      ccedil: "ç",
      Ccirc: "Ĉ",
      ccirc: "ĉ",
      Cconint: "∰",
      ccups: "⩌",
      ccupssm: "⩐",
      Cdot: "Ċ",
      cdot: "ċ",
      cedil: "¸",
      Cedilla: "¸",
      cemptyv: "⦲",
      cent: "¢",
      CenterDot: "·",
      centerdot: "·",
      Cfr: "ℭ",
      cfr: "𝔠",
      CHcy: "Ч",
      chcy: "ч",
      check: "✓",
      checkmark: "✓",
      Chi: "Χ",
      chi: "χ",
      cir: "○",
      circ: "ˆ",
      circeq: "≗",
      circlearrowleft: "↺",
      circlearrowright: "↻",
      circledast: "⊛",
      circledcirc: "⊚",
      circleddash: "⊝",
      CircleDot: "⊙",
      circledR: "®",
      circledS: "Ⓢ",
      CircleMinus: "⊖",
      CirclePlus: "⊕",
      CircleTimes: "⊗",
      cirE: "⧃",
      cire: "≗",
      cirfnint: "⨐",
      cirmid: "⫯",
      cirscir: "⧂",
      ClockwiseContourIntegral: "∲",
      CloseCurlyDoubleQuote: "”",
      CloseCurlyQuote: "’",
      clubs: "♣",
      clubsuit: "♣",
      Colon: "∷",
      colon: ":",
      Colone: "⩴",
      colone: "≔",
      coloneq: "≔",
      comma: ",",
      commat: "@",
      comp: "∁",
      compfn: "∘",
      complement: "∁",
      complexes: "ℂ",
      cong: "≅",
      congdot: "⩭",
      Congruent: "≡",
      Conint: "∯",
      conint: "∮",
      ContourIntegral: "∮",
      Copf: "ℂ",
      copf: "𝕔",
      coprod: "∐",
      Coproduct: "∐",
      COPY: "©",
      copy: "©",
      copysr: "℗",
      CounterClockwiseContourIntegral: "∳",
      crarr: "↵",
      Cross: "⨯",
      cross: "✗",
      Cscr: "𝒞",
      cscr: "𝒸",
      csub: "⫏",
      csube: "⫑",
      csup: "⫐",
      csupe: "⫒",
      ctdot: "⋯",
      cudarrl: "⤸",
      cudarrr: "⤵",
      cuepr: "⋞",
      cuesc: "⋟",
      cularr: "↶",
      cularrp: "⤽",
      Cup: "⋓",
      cup: "∪",
      cupbrcap: "⩈",
      CupCap: "≍",
      cupcap: "⩆",
      cupcup: "⩊",
      cupdot: "⊍",
      cupor: "⩅",
      cups: "∪︀",
      curarr: "↷",
      curarrm: "⤼",
      curlyeqprec: "⋞",
      curlyeqsucc: "⋟",
      curlyvee: "⋎",
      curlywedge: "⋏",
      curren: "¤",
      curvearrowleft: "↶",
      curvearrowright: "↷",
      cuvee: "⋎",
      cuwed: "⋏",
      cwconint: "∲",
      cwint: "∱",
      cylcty: "⌭",
      Dagger: "‡",
      dagger: "†",
      daleth: "ℸ",
      Darr: "↡",
      dArr: "⇓",
      darr: "↓",
      dash: "‐",
      Dashv: "⫤",
      dashv: "⊣",
      dbkarow: "⤏",
      dblac: "˝",
      Dcaron: "Ď",
      dcaron: "ď",
      Dcy: "Д",
      dcy: "д",
      DD: "ⅅ",
      dd: "ⅆ",
      ddagger: "‡",
      ddarr: "⇊",
      DDotrahd: "⤑",
      ddotseq: "⩷",
      deg: "°",
      Del: "∇",
      Delta: "Δ",
      delta: "δ",
      demptyv: "⦱",
      dfisht: "⥿",
      Dfr: "𝔇",
      dfr: "𝔡",
      dHar: "⥥",
      dharl: "⇃",
      dharr: "⇂",
      DiacriticalAcute: "´",
      DiacriticalDot: "˙",
      DiacriticalDoubleAcute: "˝",
      DiacriticalGrave: "`",
      DiacriticalTilde: "˜",
      diam: "⋄",
      Diamond: "⋄",
      diamond: "⋄",
      diamondsuit: "♦",
      diams: "♦",
      die: "¨",
      DifferentialD: "ⅆ",
      digamma: "ϝ",
      disin: "⋲",
      div: "÷",
      divide: "÷",
      divideontimes: "⋇",
      divonx: "⋇",
      DJcy: "Ђ",
      djcy: "ђ",
      dlcorn: "⌞",
      dlcrop: "⌍",
      dollar: "$",
      Dopf: "𝔻",
      dopf: "𝕕",
      Dot: "¨",
      dot: "˙",
      DotDot: "⃜",
      doteq: "≐",
      doteqdot: "≑",
      DotEqual: "≐",
      dotminus: "∸",
      dotplus: "∔",
      dotsquare: "⊡",
      doublebarwedge: "⌆",
      DoubleContourIntegral: "∯",
      DoubleDot: "¨",
      DoubleDownArrow: "⇓",
      DoubleLeftArrow: "⇐",
      DoubleLeftRightArrow: "⇔",
      DoubleLeftTee: "⫤",
      DoubleLongLeftArrow: "⟸",
      DoubleLongLeftRightArrow: "⟺",
      DoubleLongRightArrow: "⟹",
      DoubleRightArrow: "⇒",
      DoubleRightTee: "⊨",
      DoubleUpArrow: "⇑",
      DoubleUpDownArrow: "⇕",
      DoubleVerticalBar: "∥",
      DownArrow: "↓",
      Downarrow: "⇓",
      downarrow: "↓",
      DownArrowBar: "⤓",
      DownArrowUpArrow: "⇵",
      DownBreve: "̑",
      downdownarrows: "⇊",
      downharpoonleft: "⇃",
      downharpoonright: "⇂",
      DownLeftRightVector: "⥐",
      DownLeftTeeVector: "⥞",
      DownLeftVector: "↽",
      DownLeftVectorBar: "⥖",
      DownRightTeeVector: "⥟",
      DownRightVector: "⇁",
      DownRightVectorBar: "⥗",
      DownTee: "⊤",
      DownTeeArrow: "↧",
      drbkarow: "⤐",
      drcorn: "⌟",
      drcrop: "⌌",
      Dscr: "𝒟",
      dscr: "𝒹",
      DScy: "Ѕ",
      dscy: "ѕ",
      dsol: "⧶",
      Dstrok: "Đ",
      dstrok: "đ",
      dtdot: "⋱",
      dtri: "▿",
      dtrif: "▾",
      duarr: "⇵",
      duhar: "⥯",
      dwangle: "⦦",
      DZcy: "Џ",
      dzcy: "џ",
      dzigrarr: "⟿",
      Eacute: "É",
      eacute: "é",
      easter: "⩮",
      Ecaron: "Ě",
      ecaron: "ě",
      ecir: "≖",
      Ecirc: "Ê",
      ecirc: "ê",
      ecolon: "≕",
      Ecy: "Э",
      ecy: "э",
      eDDot: "⩷",
      Edot: "Ė",
      eDot: "≑",
      edot: "ė",
      ee: "ⅇ",
      efDot: "≒",
      Efr: "𝔈",
      efr: "𝔢",
      eg: "⪚",
      Egrave: "È",
      egrave: "è",
      egs: "⪖",
      egsdot: "⪘",
      el: "⪙",
      Element: "∈",
      elinters: "⏧",
      ell: "ℓ",
      els: "⪕",
      elsdot: "⪗",
      Emacr: "Ē",
      emacr: "ē",
      empty: "∅",
      emptyset: "∅",
      EmptySmallSquare: "◻",
      emptyv: "∅",
      EmptyVerySmallSquare: "▫",
      emsp: " ",
      emsp13: " ",
      emsp14: " ",
      ENG: "Ŋ",
      eng: "ŋ",
      ensp: " ",
      Eogon: "Ę",
      eogon: "ę",
      Eopf: "𝔼",
      eopf: "𝕖",
      epar: "⋕",
      eparsl: "⧣",
      eplus: "⩱",
      epsi: "ε",
      Epsilon: "Ε",
      epsilon: "ε",
      epsiv: "ϵ",
      eqcirc: "≖",
      eqcolon: "≕",
      eqsim: "≂",
      eqslantgtr: "⪖",
      eqslantless: "⪕",
      Equal: "⩵",
      equals: "=",
      EqualTilde: "≂",
      equest: "≟",
      Equilibrium: "⇌",
      equiv: "≡",
      equivDD: "⩸",
      eqvparsl: "⧥",
      erarr: "⥱",
      erDot: "≓",
      Escr: "ℰ",
      escr: "ℯ",
      esdot: "≐",
      Esim: "⩳",
      esim: "≂",
      Eta: "Η",
      eta: "η",
      ETH: "Ð",
      eth: "ð",
      Euml: "Ë",
      euml: "ë",
      euro: "€",
      excl: "!",
      exist: "∃",
      Exists: "∃",
      expectation: "ℰ",
      ExponentialE: "ⅇ",
      exponentiale: "ⅇ",
      fallingdotseq: "≒",
      Fcy: "Ф",
      fcy: "ф",
      female: "♀",
      ffilig: "ﬃ",
      fflig: "ﬀ",
      ffllig: "ﬄ",
      Ffr: "𝔉",
      ffr: "𝔣",
      filig: "ﬁ",
      FilledSmallSquare: "◼",
      FilledVerySmallSquare: "▪",
      fjlig: "fj",
      flat: "♭",
      fllig: "ﬂ",
      fltns: "▱",
      fnof: "ƒ",
      Fopf: "𝔽",
      fopf: "𝕗",
      ForAll: "∀",
      forall: "∀",
      fork: "⋔",
      forkv: "⫙",
      Fouriertrf: "ℱ",
      fpartint: "⨍",
      frac12: "½",
      frac13: "⅓",
      frac14: "¼",
      frac15: "⅕",
      frac16: "⅙",
      frac18: "⅛",
      frac23: "⅔",
      frac25: "⅖",
      frac34: "¾",
      frac35: "⅗",
      frac38: "⅜",
      frac45: "⅘",
      frac56: "⅚",
      frac58: "⅝",
      frac78: "⅞",
      frasl: "⁄",
      frown: "⌢",
      Fscr: "ℱ",
      fscr: "𝒻",
      gacute: "ǵ",
      Gamma: "Γ",
      gamma: "γ",
      Gammad: "Ϝ",
      gammad: "ϝ",
      gap: "⪆",
      Gbreve: "Ğ",
      gbreve: "ğ",
      Gcedil: "Ģ",
      Gcirc: "Ĝ",
      gcirc: "ĝ",
      Gcy: "Г",
      gcy: "г",
      Gdot: "Ġ",
      gdot: "ġ",
      gE: "≧",
      ge: "≥",
      gEl: "⪌",
      gel: "⋛",
      geq: "≥",
      geqq: "≧",
      geqslant: "⩾",
      ges: "⩾",
      gescc: "⪩",
      gesdot: "⪀",
      gesdoto: "⪂",
      gesdotol: "⪄",
      gesl: "⋛︀",
      gesles: "⪔",
      Gfr: "𝔊",
      gfr: "𝔤",
      Gg: "⋙",
      gg: "≫",
      ggg: "⋙",
      gimel: "ℷ",
      GJcy: "Ѓ",
      gjcy: "ѓ",
      gl: "≷",
      gla: "⪥",
      glE: "⪒",
      glj: "⪤",
      gnap: "⪊",
      gnapprox: "⪊",
      gnE: "≩",
      gne: "⪈",
      gneq: "⪈",
      gneqq: "≩",
      gnsim: "⋧",
      Gopf: "𝔾",
      gopf: "𝕘",
      grave: "`",
      GreaterEqual: "≥",
      GreaterEqualLess: "⋛",
      GreaterFullEqual: "≧",
      GreaterGreater: "⪢",
      GreaterLess: "≷",
      GreaterSlantEqual: "⩾",
      GreaterTilde: "≳",
      Gscr: "𝒢",
      gscr: "ℊ",
      gsim: "≳",
      gsime: "⪎",
      gsiml: "⪐",
      Gt: "≫",
      GT: ">",
      gt: ">",
      gtcc: "⪧",
      gtcir: "⩺",
      gtdot: "⋗",
      gtlPar: "⦕",
      gtquest: "⩼",
      gtrapprox: "⪆",
      gtrarr: "⥸",
      gtrdot: "⋗",
      gtreqless: "⋛",
      gtreqqless: "⪌",
      gtrless: "≷",
      gtrsim: "≳",
      gvertneqq: "≩︀",
      gvnE: "≩︀",
      Hacek: "ˇ",
      hairsp: " ",
      half: "½",
      hamilt: "ℋ",
      HARDcy: "Ъ",
      hardcy: "ъ",
      hArr: "⇔",
      harr: "↔",
      harrcir: "⥈",
      harrw: "↭",
      Hat: "^",
      hbar: "ℏ",
      Hcirc: "Ĥ",
      hcirc: "ĥ",
      hearts: "♥",
      heartsuit: "♥",
      hellip: "…",
      hercon: "⊹",
      Hfr: "ℌ",
      hfr: "𝔥",
      HilbertSpace: "ℋ",
      hksearow: "⤥",
      hkswarow: "⤦",
      hoarr: "⇿",
      homtht: "∻",
      hookleftarrow: "↩",
      hookrightarrow: "↪",
      Hopf: "ℍ",
      hopf: "𝕙",
      horbar: "―",
      HorizontalLine: "─",
      Hscr: "ℋ",
      hscr: "𝒽",
      hslash: "ℏ",
      Hstrok: "Ħ",
      hstrok: "ħ",
      HumpDownHump: "≎",
      HumpEqual: "≏",
      hybull: "⁃",
      hyphen: "‐",
      Iacute: "Í",
      iacute: "í",
      ic: "⁣",
      Icirc: "Î",
      icirc: "î",
      Icy: "И",
      icy: "и",
      Idot: "İ",
      IEcy: "Е",
      iecy: "е",
      iexcl: "¡",
      iff: "⇔",
      Ifr: "ℑ",
      ifr: "𝔦",
      Igrave: "Ì",
      igrave: "ì",
      ii: "ⅈ",
      iiiint: "⨌",
      iiint: "∭",
      iinfin: "⧜",
      iiota: "℩",
      IJlig: "Ĳ",
      ijlig: "ĳ",
      Im: "ℑ",
      Imacr: "Ī",
      imacr: "ī",
      image: "ℑ",
      ImaginaryI: "ⅈ",
      imagline: "ℐ",
      imagpart: "ℑ",
      imath: "ı",
      imof: "⊷",
      imped: "Ƶ",
      Implies: "⇒",
      in: "∈",
      incare: "℅",
      infin: "∞",
      infintie: "⧝",
      inodot: "ı",
      Int: "∬",
      int: "∫",
      intcal: "⊺",
      integers: "ℤ",
      Integral: "∫",
      intercal: "⊺",
      Intersection: "⋂",
      intlarhk: "⨗",
      intprod: "⨼",
      InvisibleComma: "⁣",
      InvisibleTimes: "⁢",
      IOcy: "Ё",
      iocy: "ё",
      Iogon: "Į",
      iogon: "į",
      Iopf: "𝕀",
      iopf: "𝕚",
      Iota: "Ι",
      iota: "ι",
      iprod: "⨼",
      iquest: "¿",
      Iscr: "ℐ",
      iscr: "𝒾",
      isin: "∈",
      isindot: "⋵",
      isinE: "⋹",
      isins: "⋴",
      isinsv: "⋳",
      isinv: "∈",
      it: "⁢",
      Itilde: "Ĩ",
      itilde: "ĩ",
      Iukcy: "І",
      iukcy: "і",
      Iuml: "Ï",
      iuml: "ï",
      Jcirc: "Ĵ",
      jcirc: "ĵ",
      Jcy: "Й",
      jcy: "й",
      Jfr: "𝔍",
      jfr: "𝔧",
      jmath: "ȷ",
      Jopf: "𝕁",
      jopf: "𝕛",
      Jscr: "𝒥",
      jscr: "𝒿",
      Jsercy: "Ј",
      jsercy: "ј",
      Jukcy: "Є",
      jukcy: "є",
      Kappa: "Κ",
      kappa: "κ",
      kappav: "ϰ",
      Kcedil: "Ķ",
      kcedil: "ķ",
      Kcy: "К",
      kcy: "к",
      Kfr: "𝔎",
      kfr: "𝔨",
      kgreen: "ĸ",
      KHcy: "Х",
      khcy: "х",
      KJcy: "Ќ",
      kjcy: "ќ",
      Kopf: "𝕂",
      kopf: "𝕜",
      Kscr: "𝒦",
      kscr: "𝓀",
      lAarr: "⇚",
      Lacute: "Ĺ",
      lacute: "ĺ",
      laemptyv: "⦴",
      lagran: "ℒ",
      Lambda: "Λ",
      lambda: "λ",
      Lang: "⟪",
      lang: "⟨",
      langd: "⦑",
      langle: "⟨",
      lap: "⪅",
      Laplacetrf: "ℒ",
      laquo: "«",
      Larr: "↞",
      lArr: "⇐",
      larr: "←",
      larrb: "⇤",
      larrbfs: "⤟",
      larrfs: "⤝",
      larrhk: "↩",
      larrlp: "↫",
      larrpl: "⤹",
      larrsim: "⥳",
      larrtl: "↢",
      lat: "⪫",
      lAtail: "⤛",
      latail: "⤙",
      late: "⪭",
      lates: "⪭︀",
      lBarr: "⤎",
      lbarr: "⤌",
      lbbrk: "❲",
      lbrace: "{",
      lbrack: "[",
      lbrke: "⦋",
      lbrksld: "⦏",
      lbrkslu: "⦍",
      Lcaron: "Ľ",
      lcaron: "ľ",
      Lcedil: "Ļ",
      lcedil: "ļ",
      lceil: "⌈",
      lcub: "{",
      Lcy: "Л",
      lcy: "л",
      ldca: "⤶",
      ldquo: "“",
      ldquor: "„",
      ldrdhar: "⥧",
      ldrushar: "⥋",
      ldsh: "↲",
      lE: "≦",
      le: "≤",
      LeftAngleBracket: "⟨",
      LeftArrow: "←",
      Leftarrow: "⇐",
      leftarrow: "←",
      LeftArrowBar: "⇤",
      LeftArrowRightArrow: "⇆",
      leftarrowtail: "↢",
      LeftCeiling: "⌈",
      LeftDoubleBracket: "⟦",
      LeftDownTeeVector: "⥡",
      LeftDownVector: "⇃",
      LeftDownVectorBar: "⥙",
      LeftFloor: "⌊",
      leftharpoondown: "↽",
      leftharpoonup: "↼",
      leftleftarrows: "⇇",
      LeftRightArrow: "↔",
      Leftrightarrow: "⇔",
      leftrightarrow: "↔",
      leftrightarrows: "⇆",
      leftrightharpoons: "⇋",
      leftrightsquigarrow: "↭",
      LeftRightVector: "⥎",
      LeftTee: "⊣",
      LeftTeeArrow: "↤",
      LeftTeeVector: "⥚",
      leftthreetimes: "⋋",
      LeftTriangle: "⊲",
      LeftTriangleBar: "⧏",
      LeftTriangleEqual: "⊴",
      LeftUpDownVector: "⥑",
      LeftUpTeeVector: "⥠",
      LeftUpVector: "↿",
      LeftUpVectorBar: "⥘",
      LeftVector: "↼",
      LeftVectorBar: "⥒",
      lEg: "⪋",
      leg: "⋚",
      leq: "≤",
      leqq: "≦",
      leqslant: "⩽",
      les: "⩽",
      lescc: "⪨",
      lesdot: "⩿",
      lesdoto: "⪁",
      lesdotor: "⪃",
      lesg: "⋚︀",
      lesges: "⪓",
      lessapprox: "⪅",
      lessdot: "⋖",
      lesseqgtr: "⋚",
      lesseqqgtr: "⪋",
      LessEqualGreater: "⋚",
      LessFullEqual: "≦",
      LessGreater: "≶",
      lessgtr: "≶",
      LessLess: "⪡",
      lesssim: "≲",
      LessSlantEqual: "⩽",
      LessTilde: "≲",
      lfisht: "⥼",
      lfloor: "⌊",
      Lfr: "𝔏",
      lfr: "𝔩",
      lg: "≶",
      lgE: "⪑",
      lHar: "⥢",
      lhard: "↽",
      lharu: "↼",
      lharul: "⥪",
      lhblk: "▄",
      LJcy: "Љ",
      ljcy: "љ",
      Ll: "⋘",
      ll: "≪",
      llarr: "⇇",
      llcorner: "⌞",
      Lleftarrow: "⇚",
      llhard: "⥫",
      lltri: "◺",
      Lmidot: "Ŀ",
      lmidot: "ŀ",
      lmoust: "⎰",
      lmoustache: "⎰",
      lnap: "⪉",
      lnapprox: "⪉",
      lnE: "≨",
      lne: "⪇",
      lneq: "⪇",
      lneqq: "≨",
      lnsim: "⋦",
      loang: "⟬",
      loarr: "⇽",
      lobrk: "⟦",
      LongLeftArrow: "⟵",
      Longleftarrow: "⟸",
      longleftarrow: "⟵",
      LongLeftRightArrow: "⟷",
      Longleftrightarrow: "⟺",
      longleftrightarrow: "⟷",
      longmapsto: "⟼",
      LongRightArrow: "⟶",
      Longrightarrow: "⟹",
      longrightarrow: "⟶",
      looparrowleft: "↫",
      looparrowright: "↬",
      lopar: "⦅",
      Lopf: "𝕃",
      lopf: "𝕝",
      loplus: "⨭",
      lotimes: "⨴",
      lowast: "∗",
      lowbar: "_",
      LowerLeftArrow: "↙",
      LowerRightArrow: "↘",
      loz: "◊",
      lozenge: "◊",
      lozf: "⧫",
      lpar: "(",
      lparlt: "⦓",
      lrarr: "⇆",
      lrcorner: "⌟",
      lrhar: "⇋",
      lrhard: "⥭",
      lrm: "‎",
      lrtri: "⊿",
      lsaquo: "‹",
      Lscr: "ℒ",
      lscr: "𝓁",
      Lsh: "↰",
      lsh: "↰",
      lsim: "≲",
      lsime: "⪍",
      lsimg: "⪏",
      lsqb: "[",
      lsquo: "‘",
      lsquor: "‚",
      Lstrok: "Ł",
      lstrok: "ł",
      Lt: "≪",
      LT: "<",
      lt: "<",
      ltcc: "⪦",
      ltcir: "⩹",
      ltdot: "⋖",
      lthree: "⋋",
      ltimes: "⋉",
      ltlarr: "⥶",
      ltquest: "⩻",
      ltri: "◃",
      ltrie: "⊴",
      ltrif: "◂",
      ltrPar: "⦖",
      lurdshar: "⥊",
      luruhar: "⥦",
      lvertneqq: "≨︀",
      lvnE: "≨︀",
      macr: "¯",
      male: "♂",
      malt: "✠",
      maltese: "✠",
      Map: "⤅",
      map: "↦",
      mapsto: "↦",
      mapstodown: "↧",
      mapstoleft: "↤",
      mapstoup: "↥",
      marker: "▮",
      mcomma: "⨩",
      Mcy: "М",
      mcy: "м",
      mdash: "—",
      mDDot: "∺",
      measuredangle: "∡",
      MediumSpace: " ",
      Mellintrf: "ℳ",
      Mfr: "𝔐",
      mfr: "𝔪",
      mho: "℧",
      micro: "µ",
      mid: "∣",
      midast: "*",
      midcir: "⫰",
      middot: "·",
      minus: "−",
      minusb: "⊟",
      minusd: "∸",
      minusdu: "⨪",
      MinusPlus: "∓",
      mlcp: "⫛",
      mldr: "…",
      mnplus: "∓",
      models: "⊧",
      Mopf: "𝕄",
      mopf: "𝕞",
      mp: "∓",
      Mscr: "ℳ",
      mscr: "𝓂",
      mstpos: "∾",
      Mu: "Μ",
      mu: "μ",
      multimap: "⊸",
      mumap: "⊸",
      nabla: "∇",
      Nacute: "Ń",
      nacute: "ń",
      nang: "∠⃒",
      nap: "≉",
      napE: "⩰̸",
      napid: "≋̸",
      napos: "ŉ",
      napprox: "≉",
      natur: "♮",
      natural: "♮",
      naturals: "ℕ",
      nbsp: " ",
      nbump: "≎̸",
      nbumpe: "≏̸",
      ncap: "⩃",
      Ncaron: "Ň",
      ncaron: "ň",
      Ncedil: "Ņ",
      ncedil: "ņ",
      ncong: "≇",
      ncongdot: "⩭̸",
      ncup: "⩂",
      Ncy: "Н",
      ncy: "н",
      ndash: "–",
      ne: "≠",
      nearhk: "⤤",
      neArr: "⇗",
      nearr: "↗",
      nearrow: "↗",
      nedot: "≐̸",
      NegativeMediumSpace: "​",
      NegativeThickSpace: "​",
      NegativeThinSpace: "​",
      NegativeVeryThinSpace: "​",
      nequiv: "≢",
      nesear: "⤨",
      nesim: "≂̸",
      NestedGreaterGreater: "≫",
      NestedLessLess: "≪",
      NewLine: `
`,
      nexist: "∄",
      nexists: "∄",
      Nfr: "𝔑",
      nfr: "𝔫",
      ngE: "≧̸",
      nge: "≱",
      ngeq: "≱",
      ngeqq: "≧̸",
      ngeqslant: "⩾̸",
      nges: "⩾̸",
      nGg: "⋙̸",
      ngsim: "≵",
      nGt: "≫⃒",
      ngt: "≯",
      ngtr: "≯",
      nGtv: "≫̸",
      nhArr: "⇎",
      nharr: "↮",
      nhpar: "⫲",
      ni: "∋",
      nis: "⋼",
      nisd: "⋺",
      niv: "∋",
      NJcy: "Њ",
      njcy: "њ",
      nlArr: "⇍",
      nlarr: "↚",
      nldr: "‥",
      nlE: "≦̸",
      nle: "≰",
      nLeftarrow: "⇍",
      nleftarrow: "↚",
      nLeftrightarrow: "⇎",
      nleftrightarrow: "↮",
      nleq: "≰",
      nleqq: "≦̸",
      nleqslant: "⩽̸",
      nles: "⩽̸",
      nless: "≮",
      nLl: "⋘̸",
      nlsim: "≴",
      nLt: "≪⃒",
      nlt: "≮",
      nltri: "⋪",
      nltrie: "⋬",
      nLtv: "≪̸",
      nmid: "∤",
      NoBreak: "⁠",
      NonBreakingSpace: " ",
      Nopf: "ℕ",
      nopf: "𝕟",
      Not: "⫬",
      not: "¬",
      NotCongruent: "≢",
      NotCupCap: "≭",
      NotDoubleVerticalBar: "∦",
      NotElement: "∉",
      NotEqual: "≠",
      NotEqualTilde: "≂̸",
      NotExists: "∄",
      NotGreater: "≯",
      NotGreaterEqual: "≱",
      NotGreaterFullEqual: "≧̸",
      NotGreaterGreater: "≫̸",
      NotGreaterLess: "≹",
      NotGreaterSlantEqual: "⩾̸",
      NotGreaterTilde: "≵",
      NotHumpDownHump: "≎̸",
      NotHumpEqual: "≏̸",
      notin: "∉",
      notindot: "⋵̸",
      notinE: "⋹̸",
      notinva: "∉",
      notinvb: "⋷",
      notinvc: "⋶",
      NotLeftTriangle: "⋪",
      NotLeftTriangleBar: "⧏̸",
      NotLeftTriangleEqual: "⋬",
      NotLess: "≮",
      NotLessEqual: "≰",
      NotLessGreater: "≸",
      NotLessLess: "≪̸",
      NotLessSlantEqual: "⩽̸",
      NotLessTilde: "≴",
      NotNestedGreaterGreater: "⪢̸",
      NotNestedLessLess: "⪡̸",
      notni: "∌",
      notniva: "∌",
      notnivb: "⋾",
      notnivc: "⋽",
      NotPrecedes: "⊀",
      NotPrecedesEqual: "⪯̸",
      NotPrecedesSlantEqual: "⋠",
      NotReverseElement: "∌",
      NotRightTriangle: "⋫",
      NotRightTriangleBar: "⧐̸",
      NotRightTriangleEqual: "⋭",
      NotSquareSubset: "⊏̸",
      NotSquareSubsetEqual: "⋢",
      NotSquareSuperset: "⊐̸",
      NotSquareSupersetEqual: "⋣",
      NotSubset: "⊂⃒",
      NotSubsetEqual: "⊈",
      NotSucceeds: "⊁",
      NotSucceedsEqual: "⪰̸",
      NotSucceedsSlantEqual: "⋡",
      NotSucceedsTilde: "≿̸",
      NotSuperset: "⊃⃒",
      NotSupersetEqual: "⊉",
      NotTilde: "≁",
      NotTildeEqual: "≄",
      NotTildeFullEqual: "≇",
      NotTildeTilde: "≉",
      NotVerticalBar: "∤",
      npar: "∦",
      nparallel: "∦",
      nparsl: "⫽⃥",
      npart: "∂̸",
      npolint: "⨔",
      npr: "⊀",
      nprcue: "⋠",
      npre: "⪯̸",
      nprec: "⊀",
      npreceq: "⪯̸",
      nrArr: "⇏",
      nrarr: "↛",
      nrarrc: "⤳̸",
      nrarrw: "↝̸",
      nRightarrow: "⇏",
      nrightarrow: "↛",
      nrtri: "⋫",
      nrtrie: "⋭",
      nsc: "⊁",
      nsccue: "⋡",
      nsce: "⪰̸",
      Nscr: "𝒩",
      nscr: "𝓃",
      nshortmid: "∤",
      nshortparallel: "∦",
      nsim: "≁",
      nsime: "≄",
      nsimeq: "≄",
      nsmid: "∤",
      nspar: "∦",
      nsqsube: "⋢",
      nsqsupe: "⋣",
      nsub: "⊄",
      nsubE: "⫅̸",
      nsube: "⊈",
      nsubset: "⊂⃒",
      nsubseteq: "⊈",
      nsubseteqq: "⫅̸",
      nsucc: "⊁",
      nsucceq: "⪰̸",
      nsup: "⊅",
      nsupE: "⫆̸",
      nsupe: "⊉",
      nsupset: "⊃⃒",
      nsupseteq: "⊉",
      nsupseteqq: "⫆̸",
      ntgl: "≹",
      Ntilde: "Ñ",
      ntilde: "ñ",
      ntlg: "≸",
      ntriangleleft: "⋪",
      ntrianglelefteq: "⋬",
      ntriangleright: "⋫",
      ntrianglerighteq: "⋭",
      Nu: "Ν",
      nu: "ν",
      num: "#",
      numero: "№",
      numsp: " ",
      nvap: "≍⃒",
      nVDash: "⊯",
      nVdash: "⊮",
      nvDash: "⊭",
      nvdash: "⊬",
      nvge: "≥⃒",
      nvgt: ">⃒",
      nvHarr: "⤄",
      nvinfin: "⧞",
      nvlArr: "⤂",
      nvle: "≤⃒",
      nvlt: "<⃒",
      nvltrie: "⊴⃒",
      nvrArr: "⤃",
      nvrtrie: "⊵⃒",
      nvsim: "∼⃒",
      nwarhk: "⤣",
      nwArr: "⇖",
      nwarr: "↖",
      nwarrow: "↖",
      nwnear: "⤧",
      Oacute: "Ó",
      oacute: "ó",
      oast: "⊛",
      ocir: "⊚",
      Ocirc: "Ô",
      ocirc: "ô",
      Ocy: "О",
      ocy: "о",
      odash: "⊝",
      Odblac: "Ő",
      odblac: "ő",
      odiv: "⨸",
      odot: "⊙",
      odsold: "⦼",
      OElig: "Œ",
      oelig: "œ",
      ofcir: "⦿",
      Ofr: "𝔒",
      ofr: "𝔬",
      ogon: "˛",
      Ograve: "Ò",
      ograve: "ò",
      ogt: "⧁",
      ohbar: "⦵",
      ohm: "Ω",
      oint: "∮",
      olarr: "↺",
      olcir: "⦾",
      olcross: "⦻",
      oline: "‾",
      olt: "⧀",
      Omacr: "Ō",
      omacr: "ō",
      Omega: "Ω",
      omega: "ω",
      Omicron: "Ο",
      omicron: "ο",
      omid: "⦶",
      ominus: "⊖",
      Oopf: "𝕆",
      oopf: "𝕠",
      opar: "⦷",
      OpenCurlyDoubleQuote: "“",
      OpenCurlyQuote: "‘",
      operp: "⦹",
      oplus: "⊕",
      Or: "⩔",
      or: "∨",
      orarr: "↻",
      ord: "⩝",
      order: "ℴ",
      orderof: "ℴ",
      ordf: "ª",
      ordm: "º",
      origof: "⊶",
      oror: "⩖",
      orslope: "⩗",
      orv: "⩛",
      oS: "Ⓢ",
      Oscr: "𝒪",
      oscr: "ℴ",
      Oslash: "Ø",
      oslash: "ø",
      osol: "⊘",
      Otilde: "Õ",
      otilde: "õ",
      Otimes: "⨷",
      otimes: "⊗",
      otimesas: "⨶",
      Ouml: "Ö",
      ouml: "ö",
      ovbar: "⌽",
      OverBar: "‾",
      OverBrace: "⏞",
      OverBracket: "⎴",
      OverParenthesis: "⏜",
      par: "∥",
      para: "¶",
      parallel: "∥",
      parsim: "⫳",
      parsl: "⫽",
      part: "∂",
      PartialD: "∂",
      Pcy: "П",
      pcy: "п",
      percnt: "%",
      period: ".",
      permil: "‰",
      perp: "⊥",
      pertenk: "‱",
      Pfr: "𝔓",
      pfr: "𝔭",
      Phi: "Φ",
      phi: "φ",
      phiv: "ϕ",
      phmmat: "ℳ",
      phone: "☎",
      Pi: "Π",
      pi: "π",
      pitchfork: "⋔",
      piv: "ϖ",
      planck: "ℏ",
      planckh: "ℎ",
      plankv: "ℏ",
      plus: "+",
      plusacir: "⨣",
      plusb: "⊞",
      pluscir: "⨢",
      plusdo: "∔",
      plusdu: "⨥",
      pluse: "⩲",
      PlusMinus: "±",
      plusmn: "±",
      plussim: "⨦",
      plustwo: "⨧",
      pm: "±",
      Poincareplane: "ℌ",
      pointint: "⨕",
      Popf: "ℙ",
      popf: "𝕡",
      pound: "£",
      Pr: "⪻",
      pr: "≺",
      prap: "⪷",
      prcue: "≼",
      prE: "⪳",
      pre: "⪯",
      prec: "≺",
      precapprox: "⪷",
      preccurlyeq: "≼",
      Precedes: "≺",
      PrecedesEqual: "⪯",
      PrecedesSlantEqual: "≼",
      PrecedesTilde: "≾",
      preceq: "⪯",
      precnapprox: "⪹",
      precneqq: "⪵",
      precnsim: "⋨",
      precsim: "≾",
      Prime: "″",
      prime: "′",
      primes: "ℙ",
      prnap: "⪹",
      prnE: "⪵",
      prnsim: "⋨",
      prod: "∏",
      Product: "∏",
      profalar: "⌮",
      profline: "⌒",
      profsurf: "⌓",
      prop: "∝",
      Proportion: "∷",
      Proportional: "∝",
      propto: "∝",
      prsim: "≾",
      prurel: "⊰",
      Pscr: "𝒫",
      pscr: "𝓅",
      Psi: "Ψ",
      psi: "ψ",
      puncsp: " ",
      Qfr: "𝔔",
      qfr: "𝔮",
      qint: "⨌",
      Qopf: "ℚ",
      qopf: "𝕢",
      qprime: "⁗",
      Qscr: "𝒬",
      qscr: "𝓆",
      quaternions: "ℍ",
      quatint: "⨖",
      quest: "?",
      questeq: "≟",
      QUOT: '"',
      quot: '"',
      rAarr: "⇛",
      race: "∽̱",
      Racute: "Ŕ",
      racute: "ŕ",
      radic: "√",
      raemptyv: "⦳",
      Rang: "⟫",
      rang: "⟩",
      rangd: "⦒",
      range: "⦥",
      rangle: "⟩",
      raquo: "»",
      Rarr: "↠",
      rArr: "⇒",
      rarr: "→",
      rarrap: "⥵",
      rarrb: "⇥",
      rarrbfs: "⤠",
      rarrc: "⤳",
      rarrfs: "⤞",
      rarrhk: "↪",
      rarrlp: "↬",
      rarrpl: "⥅",
      rarrsim: "⥴",
      Rarrtl: "⤖",
      rarrtl: "↣",
      rarrw: "↝",
      rAtail: "⤜",
      ratail: "⤚",
      ratio: "∶",
      rationals: "ℚ",
      RBarr: "⤐",
      rBarr: "⤏",
      rbarr: "⤍",
      rbbrk: "❳",
      rbrace: "}",
      rbrack: "]",
      rbrke: "⦌",
      rbrksld: "⦎",
      rbrkslu: "⦐",
      Rcaron: "Ř",
      rcaron: "ř",
      Rcedil: "Ŗ",
      rcedil: "ŗ",
      rceil: "⌉",
      rcub: "}",
      Rcy: "Р",
      rcy: "р",
      rdca: "⤷",
      rdldhar: "⥩",
      rdquo: "”",
      rdquor: "”",
      rdsh: "↳",
      Re: "ℜ",
      real: "ℜ",
      realine: "ℛ",
      realpart: "ℜ",
      reals: "ℝ",
      rect: "▭",
      REG: "®",
      reg: "®",
      ReverseElement: "∋",
      ReverseEquilibrium: "⇋",
      ReverseUpEquilibrium: "⥯",
      rfisht: "⥽",
      rfloor: "⌋",
      Rfr: "ℜ",
      rfr: "𝔯",
      rHar: "⥤",
      rhard: "⇁",
      rharu: "⇀",
      rharul: "⥬",
      Rho: "Ρ",
      rho: "ρ",
      rhov: "ϱ",
      RightAngleBracket: "⟩",
      RightArrow: "→",
      Rightarrow: "⇒",
      rightarrow: "→",
      RightArrowBar: "⇥",
      RightArrowLeftArrow: "⇄",
      rightarrowtail: "↣",
      RightCeiling: "⌉",
      RightDoubleBracket: "⟧",
      RightDownTeeVector: "⥝",
      RightDownVector: "⇂",
      RightDownVectorBar: "⥕",
      RightFloor: "⌋",
      rightharpoondown: "⇁",
      rightharpoonup: "⇀",
      rightleftarrows: "⇄",
      rightleftharpoons: "⇌",
      rightrightarrows: "⇉",
      rightsquigarrow: "↝",
      RightTee: "⊢",
      RightTeeArrow: "↦",
      RightTeeVector: "⥛",
      rightthreetimes: "⋌",
      RightTriangle: "⊳",
      RightTriangleBar: "⧐",
      RightTriangleEqual: "⊵",
      RightUpDownVector: "⥏",
      RightUpTeeVector: "⥜",
      RightUpVector: "↾",
      RightUpVectorBar: "⥔",
      RightVector: "⇀",
      RightVectorBar: "⥓",
      ring: "˚",
      risingdotseq: "≓",
      rlarr: "⇄",
      rlhar: "⇌",
      rlm: "‏",
      rmoust: "⎱",
      rmoustache: "⎱",
      rnmid: "⫮",
      roang: "⟭",
      roarr: "⇾",
      robrk: "⟧",
      ropar: "⦆",
      Ropf: "ℝ",
      ropf: "𝕣",
      roplus: "⨮",
      rotimes: "⨵",
      RoundImplies: "⥰",
      rpar: ")",
      rpargt: "⦔",
      rppolint: "⨒",
      rrarr: "⇉",
      Rrightarrow: "⇛",
      rsaquo: "›",
      Rscr: "ℛ",
      rscr: "𝓇",
      Rsh: "↱",
      rsh: "↱",
      rsqb: "]",
      rsquo: "’",
      rsquor: "’",
      rthree: "⋌",
      rtimes: "⋊",
      rtri: "▹",
      rtrie: "⊵",
      rtrif: "▸",
      rtriltri: "⧎",
      RuleDelayed: "⧴",
      ruluhar: "⥨",
      rx: "℞",
      Sacute: "Ś",
      sacute: "ś",
      sbquo: "‚",
      Sc: "⪼",
      sc: "≻",
      scap: "⪸",
      Scaron: "Š",
      scaron: "š",
      sccue: "≽",
      scE: "⪴",
      sce: "⪰",
      Scedil: "Ş",
      scedil: "ş",
      Scirc: "Ŝ",
      scirc: "ŝ",
      scnap: "⪺",
      scnE: "⪶",
      scnsim: "⋩",
      scpolint: "⨓",
      scsim: "≿",
      Scy: "С",
      scy: "с",
      sdot: "⋅",
      sdotb: "⊡",
      sdote: "⩦",
      searhk: "⤥",
      seArr: "⇘",
      searr: "↘",
      searrow: "↘",
      sect: "§",
      semi: ";",
      seswar: "⤩",
      setminus: "∖",
      setmn: "∖",
      sext: "✶",
      Sfr: "𝔖",
      sfr: "𝔰",
      sfrown: "⌢",
      sharp: "♯",
      SHCHcy: "Щ",
      shchcy: "щ",
      SHcy: "Ш",
      shcy: "ш",
      ShortDownArrow: "↓",
      ShortLeftArrow: "←",
      shortmid: "∣",
      shortparallel: "∥",
      ShortRightArrow: "→",
      ShortUpArrow: "↑",
      shy: "­",
      Sigma: "Σ",
      sigma: "σ",
      sigmaf: "ς",
      sigmav: "ς",
      sim: "∼",
      simdot: "⩪",
      sime: "≃",
      simeq: "≃",
      simg: "⪞",
      simgE: "⪠",
      siml: "⪝",
      simlE: "⪟",
      simne: "≆",
      simplus: "⨤",
      simrarr: "⥲",
      slarr: "←",
      SmallCircle: "∘",
      smallsetminus: "∖",
      smashp: "⨳",
      smeparsl: "⧤",
      smid: "∣",
      smile: "⌣",
      smt: "⪪",
      smte: "⪬",
      smtes: "⪬︀",
      SOFTcy: "Ь",
      softcy: "ь",
      sol: "/",
      solb: "⧄",
      solbar: "⌿",
      Sopf: "𝕊",
      sopf: "𝕤",
      spades: "♠",
      spadesuit: "♠",
      spar: "∥",
      sqcap: "⊓",
      sqcaps: "⊓︀",
      sqcup: "⊔",
      sqcups: "⊔︀",
      Sqrt: "√",
      sqsub: "⊏",
      sqsube: "⊑",
      sqsubset: "⊏",
      sqsubseteq: "⊑",
      sqsup: "⊐",
      sqsupe: "⊒",
      sqsupset: "⊐",
      sqsupseteq: "⊒",
      squ: "□",
      Square: "□",
      square: "□",
      SquareIntersection: "⊓",
      SquareSubset: "⊏",
      SquareSubsetEqual: "⊑",
      SquareSuperset: "⊐",
      SquareSupersetEqual: "⊒",
      SquareUnion: "⊔",
      squarf: "▪",
      squf: "▪",
      srarr: "→",
      Sscr: "𝒮",
      sscr: "𝓈",
      ssetmn: "∖",
      ssmile: "⌣",
      sstarf: "⋆",
      Star: "⋆",
      star: "☆",
      starf: "★",
      straightepsilon: "ϵ",
      straightphi: "ϕ",
      strns: "¯",
      Sub: "⋐",
      sub: "⊂",
      subdot: "⪽",
      subE: "⫅",
      sube: "⊆",
      subedot: "⫃",
      submult: "⫁",
      subnE: "⫋",
      subne: "⊊",
      subplus: "⪿",
      subrarr: "⥹",
      Subset: "⋐",
      subset: "⊂",
      subseteq: "⊆",
      subseteqq: "⫅",
      SubsetEqual: "⊆",
      subsetneq: "⊊",
      subsetneqq: "⫋",
      subsim: "⫇",
      subsub: "⫕",
      subsup: "⫓",
      succ: "≻",
      succapprox: "⪸",
      succcurlyeq: "≽",
      Succeeds: "≻",
      SucceedsEqual: "⪰",
      SucceedsSlantEqual: "≽",
      SucceedsTilde: "≿",
      succeq: "⪰",
      succnapprox: "⪺",
      succneqq: "⪶",
      succnsim: "⋩",
      succsim: "≿",
      SuchThat: "∋",
      Sum: "∑",
      sum: "∑",
      sung: "♪",
      Sup: "⋑",
      sup: "⊃",
      sup1: "¹",
      sup2: "²",
      sup3: "³",
      supdot: "⪾",
      supdsub: "⫘",
      supE: "⫆",
      supe: "⊇",
      supedot: "⫄",
      Superset: "⊃",
      SupersetEqual: "⊇",
      suphsol: "⟉",
      suphsub: "⫗",
      suplarr: "⥻",
      supmult: "⫂",
      supnE: "⫌",
      supne: "⊋",
      supplus: "⫀",
      Supset: "⋑",
      supset: "⊃",
      supseteq: "⊇",
      supseteqq: "⫆",
      supsetneq: "⊋",
      supsetneqq: "⫌",
      supsim: "⫈",
      supsub: "⫔",
      supsup: "⫖",
      swarhk: "⤦",
      swArr: "⇙",
      swarr: "↙",
      swarrow: "↙",
      swnwar: "⤪",
      szlig: "ß",
      Tab: "	",
      target: "⌖",
      Tau: "Τ",
      tau: "τ",
      tbrk: "⎴",
      Tcaron: "Ť",
      tcaron: "ť",
      Tcedil: "Ţ",
      tcedil: "ţ",
      Tcy: "Т",
      tcy: "т",
      tdot: "⃛",
      telrec: "⌕",
      Tfr: "𝔗",
      tfr: "𝔱",
      there4: "∴",
      Therefore: "∴",
      therefore: "∴",
      Theta: "Θ",
      theta: "θ",
      thetasym: "ϑ",
      thetav: "ϑ",
      thickapprox: "≈",
      thicksim: "∼",
      ThickSpace: "  ",
      thinsp: " ",
      ThinSpace: " ",
      thkap: "≈",
      thksim: "∼",
      THORN: "Þ",
      thorn: "þ",
      Tilde: "∼",
      tilde: "˜",
      TildeEqual: "≃",
      TildeFullEqual: "≅",
      TildeTilde: "≈",
      times: "×",
      timesb: "⊠",
      timesbar: "⨱",
      timesd: "⨰",
      tint: "∭",
      toea: "⤨",
      top: "⊤",
      topbot: "⌶",
      topcir: "⫱",
      Topf: "𝕋",
      topf: "𝕥",
      topfork: "⫚",
      tosa: "⤩",
      tprime: "‴",
      TRADE: "™",
      trade: "™",
      triangle: "▵",
      triangledown: "▿",
      triangleleft: "◃",
      trianglelefteq: "⊴",
      triangleq: "≜",
      triangleright: "▹",
      trianglerighteq: "⊵",
      tridot: "◬",
      trie: "≜",
      triminus: "⨺",
      TripleDot: "⃛",
      triplus: "⨹",
      trisb: "⧍",
      tritime: "⨻",
      trpezium: "⏢",
      Tscr: "𝒯",
      tscr: "𝓉",
      TScy: "Ц",
      tscy: "ц",
      TSHcy: "Ћ",
      tshcy: "ћ",
      Tstrok: "Ŧ",
      tstrok: "ŧ",
      twixt: "≬",
      twoheadleftarrow: "↞",
      twoheadrightarrow: "↠",
      Uacute: "Ú",
      uacute: "ú",
      Uarr: "↟",
      uArr: "⇑",
      uarr: "↑",
      Uarrocir: "⥉",
      Ubrcy: "Ў",
      ubrcy: "ў",
      Ubreve: "Ŭ",
      ubreve: "ŭ",
      Ucirc: "Û",
      ucirc: "û",
      Ucy: "У",
      ucy: "у",
      udarr: "⇅",
      Udblac: "Ű",
      udblac: "ű",
      udhar: "⥮",
      ufisht: "⥾",
      Ufr: "𝔘",
      ufr: "𝔲",
      Ugrave: "Ù",
      ugrave: "ù",
      uHar: "⥣",
      uharl: "↿",
      uharr: "↾",
      uhblk: "▀",
      ulcorn: "⌜",
      ulcorner: "⌜",
      ulcrop: "⌏",
      ultri: "◸",
      Umacr: "Ū",
      umacr: "ū",
      uml: "¨",
      UnderBar: "_",
      UnderBrace: "⏟",
      UnderBracket: "⎵",
      UnderParenthesis: "⏝",
      Union: "⋃",
      UnionPlus: "⊎",
      Uogon: "Ų",
      uogon: "ų",
      Uopf: "𝕌",
      uopf: "𝕦",
      UpArrow: "↑",
      Uparrow: "⇑",
      uparrow: "↑",
      UpArrowBar: "⤒",
      UpArrowDownArrow: "⇅",
      UpDownArrow: "↕",
      Updownarrow: "⇕",
      updownarrow: "↕",
      UpEquilibrium: "⥮",
      upharpoonleft: "↿",
      upharpoonright: "↾",
      uplus: "⊎",
      UpperLeftArrow: "↖",
      UpperRightArrow: "↗",
      Upsi: "ϒ",
      upsi: "υ",
      upsih: "ϒ",
      Upsilon: "Υ",
      upsilon: "υ",
      UpTee: "⊥",
      UpTeeArrow: "↥",
      upuparrows: "⇈",
      urcorn: "⌝",
      urcorner: "⌝",
      urcrop: "⌎",
      Uring: "Ů",
      uring: "ů",
      urtri: "◹",
      Uscr: "𝒰",
      uscr: "𝓊",
      utdot: "⋰",
      Utilde: "Ũ",
      utilde: "ũ",
      utri: "▵",
      utrif: "▴",
      uuarr: "⇈",
      Uuml: "Ü",
      uuml: "ü",
      uwangle: "⦧",
      vangrt: "⦜",
      varepsilon: "ϵ",
      varkappa: "ϰ",
      varnothing: "∅",
      varphi: "ϕ",
      varpi: "ϖ",
      varpropto: "∝",
      vArr: "⇕",
      varr: "↕",
      varrho: "ϱ",
      varsigma: "ς",
      varsubsetneq: "⊊︀",
      varsubsetneqq: "⫋︀",
      varsupsetneq: "⊋︀",
      varsupsetneqq: "⫌︀",
      vartheta: "ϑ",
      vartriangleleft: "⊲",
      vartriangleright: "⊳",
      Vbar: "⫫",
      vBar: "⫨",
      vBarv: "⫩",
      Vcy: "В",
      vcy: "в",
      VDash: "⊫",
      Vdash: "⊩",
      vDash: "⊨",
      vdash: "⊢",
      Vdashl: "⫦",
      Vee: "⋁",
      vee: "∨",
      veebar: "⊻",
      veeeq: "≚",
      vellip: "⋮",
      Verbar: "‖",
      verbar: "|",
      Vert: "‖",
      vert: "|",
      VerticalBar: "∣",
      VerticalLine: "|",
      VerticalSeparator: "❘",
      VerticalTilde: "≀",
      VeryThinSpace: " ",
      Vfr: "𝔙",
      vfr: "𝔳",
      vltri: "⊲",
      vnsub: "⊂⃒",
      vnsup: "⊃⃒",
      Vopf: "𝕍",
      vopf: "𝕧",
      vprop: "∝",
      vrtri: "⊳",
      Vscr: "𝒱",
      vscr: "𝓋",
      vsubnE: "⫋︀",
      vsubne: "⊊︀",
      vsupnE: "⫌︀",
      vsupne: "⊋︀",
      Vvdash: "⊪",
      vzigzag: "⦚",
      Wcirc: "Ŵ",
      wcirc: "ŵ",
      wedbar: "⩟",
      Wedge: "⋀",
      wedge: "∧",
      wedgeq: "≙",
      weierp: "℘",
      Wfr: "𝔚",
      wfr: "𝔴",
      Wopf: "𝕎",
      wopf: "𝕨",
      wp: "℘",
      wr: "≀",
      wreath: "≀",
      Wscr: "𝒲",
      wscr: "𝓌",
      xcap: "⋂",
      xcirc: "◯",
      xcup: "⋃",
      xdtri: "▽",
      Xfr: "𝔛",
      xfr: "𝔵",
      xhArr: "⟺",
      xharr: "⟷",
      Xi: "Ξ",
      xi: "ξ",
      xlArr: "⟸",
      xlarr: "⟵",
      xmap: "⟼",
      xnis: "⋻",
      xodot: "⨀",
      Xopf: "𝕏",
      xopf: "𝕩",
      xoplus: "⨁",
      xotime: "⨂",
      xrArr: "⟹",
      xrarr: "⟶",
      Xscr: "𝒳",
      xscr: "𝓍",
      xsqcup: "⨆",
      xuplus: "⨄",
      xutri: "△",
      xvee: "⋁",
      xwedge: "⋀",
      Yacute: "Ý",
      yacute: "ý",
      YAcy: "Я",
      yacy: "я",
      Ycirc: "Ŷ",
      ycirc: "ŷ",
      Ycy: "Ы",
      ycy: "ы",
      yen: "¥",
      Yfr: "𝔜",
      yfr: "𝔶",
      YIcy: "Ї",
      yicy: "ї",
      Yopf: "𝕐",
      yopf: "𝕪",
      Yscr: "𝒴",
      yscr: "𝓎",
      YUcy: "Ю",
      yucy: "ю",
      Yuml: "Ÿ",
      yuml: "ÿ",
      Zacute: "Ź",
      zacute: "ź",
      Zcaron: "Ž",
      zcaron: "ž",
      Zcy: "З",
      zcy: "з",
      Zdot: "Ż",
      zdot: "ż",
      zeetrf: "ℨ",
      ZeroWidthSpace: "​",
      Zeta: "Ζ",
      zeta: "ζ",
      Zfr: "ℨ",
      zfr: "𝔷",
      ZHcy: "Ж",
      zhcy: "ж",
      zigrarr: "⇝",
      Zopf: "ℤ",
      zopf: "𝕫",
      Zscr: "𝒵",
      zscr: "𝓏",
      zwj: "‍",
      zwnj: "‌"
    }), t.entityMap = t.HTML_ENTITIES;
  }(Mb)), Mb;
}
var gg = {}, nR;
function eQ() {
  if (nR) return gg;
  nR = 1;
  var t = p0().NAMESPACE, e = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, n = new RegExp("[\\-\\.0-9" + e.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), r = new RegExp("^" + e.source + n.source + "*(?::" + e.source + n.source + "*)?$"), i = 0, o = 1, s = 2, a = 3, l = 4, u = 5, c = 6, f = 7;
  function d(k, C) {
    this.message = k, this.locator = C, Error.captureStackTrace && Error.captureStackTrace(this, d);
  }
  d.prototype = new Error(), d.prototype.name = d.name;
  function h() {
  }
  h.prototype = {
    parse: function(k, C, M) {
      var F = this.domBuilder;
      F.startDocument(), b(C, C = {}), p(
        k,
        C,
        M,
        F,
        this.errorHandler
      ), F.endDocument();
    }
  };
  function p(k, C, M, F, U) {
    function B(Te) {
      if (Te > 65535) {
        Te -= 65536;
        var ve = 55296 + (Te >> 10), Oe = 56320 + (Te & 1023);
        return String.fromCharCode(ve, Oe);
      } else
        return String.fromCharCode(Te);
    }
    function N(Te) {
      var ve = Te.slice(1, -1);
      return Object.hasOwnProperty.call(M, ve) ? M[ve] : ve.charAt(0) === "#" ? B(parseInt(ve.substr(1).replace("x", "0x"))) : (U.error("entity not found:" + Te), Te);
    }
    function q(Te) {
      if (Te > P) {
        var ve = k.substring(P, Te).replace(/&#?\w+;/g, N);
        W && Q(P), F.characters(ve, 0, Te - P), P = Te;
      }
    }
    function Q(Te, ve) {
      for (; Te >= X && (ve = O.exec(k)); )
        ne = ve.index, X = ne + ve[0].length, W.lineNumber++;
      W.columnNumber = Te - ne + 1;
    }
    for (var ne = 0, X = 0, O = /.*(?:\r\n?|\n)|.*$/g, W = F.locator, T = [{ currentNSMap: C }], $ = {}, P = 0; ; ) {
      try {
        var H = k.indexOf("<", P);
        if (H < 0) {
          if (!k.substr(P).match(/^\s*$/)) {
            var Z = F.doc, le = Z.createTextNode(k.substr(P));
            Z.appendChild(le), F.currentElement = le;
          }
          return;
        }
        switch (H > P && q(H), k.charAt(H + 1)) {
          case "/":
            var fe = k.indexOf(">", H + 3), J = k.substring(H + 2, fe).replace(/[ \t\n\r]+$/g, ""), ue = T.pop();
            fe < 0 ? (J = k.substring(H + 2).replace(/[\s<].*/, ""), U.error("end tag name: " + J + " is not complete:" + ue.tagName), fe = H + 1 + J.length) : J.match(/\s</) && (J = J.replace(/[\s<].*/, ""), U.error("end tag name: " + J + " maybe not complete"), fe = H + 1 + J.length);
            var he = ue.localNSMap, me = ue.tagName == J, oe = me || ue.tagName && ue.tagName.toLowerCase() == J.toLowerCase();
            if (oe) {
              if (F.endElement(ue.uri, ue.localName, J), he)
                for (var re in he)
                  Object.prototype.hasOwnProperty.call(he, re) && F.endPrefixMapping(re);
              me || U.fatalError("end tag name: " + J + " is not match the current start tagName:" + ue.tagName);
            } else
              T.push(ue);
            fe++;
            break;
          // end elment
          case "?":
            W && Q(H), fe = w(k, H, F);
            break;
          case "!":
            W && Q(H), fe = y(k, H, F, U);
            break;
          default:
            W && Q(H);
            var se = new E(), ae = T[T.length - 1].currentNSMap, fe = m(k, H, se, ae, N, U), Y = se.length;
            if (!se.closed && _(k, fe, se.tagName, $) && (se.closed = !0, M.nbsp || U.warning("unclosed xml attribute")), W && Y) {
              for (var Re = g(W, {}), ee = 0; ee < Y; ee++) {
                var Ye = se[ee];
                Q(Ye.offset), Ye.locator = g(W, {});
              }
              F.locator = Re, v(se, F, ae) && T.push(se), F.locator = W;
            } else
              v(se, F, ae) && T.push(se);
            t.isHTML(se.uri) && !se.closed ? fe = S(k, fe, se.tagName, N, F) : fe++;
        }
      } catch (Te) {
        if (Te instanceof d)
          throw Te;
        U.error("element parse error: " + Te), fe = -1;
      }
      fe > P ? P = fe : q(Math.max(H, P) + 1);
    }
  }
  function g(k, C) {
    return C.lineNumber = k.lineNumber, C.columnNumber = k.columnNumber, C;
  }
  function m(k, C, M, F, U, B) {
    function N(W, T, $) {
      M.attributeNames.hasOwnProperty(W) && B.fatalError("Attribute " + W + " redefined"), M.addValue(
        W,
        // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        T.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, U),
        $
      );
    }
    for (var q, Q, ne = ++C, X = i; ; ) {
      var O = k.charAt(ne);
      switch (O) {
        case "=":
          if (X === o)
            q = k.slice(C, ne), X = a;
          else if (X === s)
            X = a;
          else
            throw new Error("attribute equal must after attrName");
          break;
        case "'":
        case '"':
          if (X === a || X === o)
            if (X === o && (B.warning('attribute value must after "="'), q = k.slice(C, ne)), C = ne + 1, ne = k.indexOf(O, C), ne > 0)
              Q = k.slice(C, ne), N(q, Q, C - 1), X = u;
            else
              throw new Error("attribute value no end '" + O + "' match");
          else if (X == l)
            Q = k.slice(C, ne), N(q, Q, C), B.warning('attribute "' + q + '" missed start quot(' + O + ")!!"), C = ne + 1, X = u;
          else
            throw new Error('attribute value must after "="');
          break;
        case "/":
          switch (X) {
            case i:
              M.setTagName(k.slice(C, ne));
            case u:
            case c:
            case f:
              X = f, M.closed = !0;
            case l:
            case o:
              break;
            case s:
              M.closed = !0;
              break;
            //case S_EQ:
            default:
              throw new Error("attribute invalid close char('/')");
          }
          break;
        case "":
          return B.error("unexpected end of input"), X == i && M.setTagName(k.slice(C, ne)), ne;
        case ">":
          switch (X) {
            case i:
              M.setTagName(k.slice(C, ne));
            case u:
            case c:
            case f:
              break;
            //normal
            case l:
            //Compatible state
            case o:
              Q = k.slice(C, ne), Q.slice(-1) === "/" && (M.closed = !0, Q = Q.slice(0, -1));
            case s:
              X === s && (Q = q), X == l ? (B.warning('attribute "' + Q + '" missed quot(")!'), N(q, Q, C)) : ((!t.isHTML(F[""]) || !Q.match(/^(?:disabled|checked|selected)$/i)) && B.warning('attribute "' + Q + '" missed value!! "' + Q + '" instead!!'), N(Q, Q, C));
              break;
            case a:
              throw new Error("attribute value missed!!");
          }
          return ne;
        /*xml space '\x20' | #x9 | #xD | #xA; */
        case "":
          O = " ";
        default:
          if (O <= " ")
            switch (X) {
              case i:
                M.setTagName(k.slice(C, ne)), X = c;
                break;
              case o:
                q = k.slice(C, ne), X = s;
                break;
              case l:
                var Q = k.slice(C, ne);
                B.warning('attribute "' + Q + '" missed quot(")!!'), N(q, Q, C);
              case u:
                X = c;
                break;
            }
          else
            switch (X) {
              //case S_TAG:void();break;
              //case S_ATTR:void();break;
              //case S_ATTR_NOQUOT_VALUE:void();break;
              case s:
                M.tagName, (!t.isHTML(F[""]) || !q.match(/^(?:disabled|checked|selected)$/i)) && B.warning('attribute "' + q + '" missed value!! "' + q + '" instead2!!'), N(q, q, C), C = ne, X = o;
                break;
              case u:
                B.warning('attribute space is required"' + q + '"!!');
              case c:
                X = o, C = ne;
                break;
              case a:
                X = l, C = ne;
                break;
              case f:
                throw new Error("elements closed character '/' and '>' must be connected to");
            }
      }
      ne++;
    }
  }
  function v(k, C, M) {
    for (var F = k.tagName, U = null, O = k.length; O--; ) {
      var B = k[O], N = B.qName, q = B.value, W = N.indexOf(":");
      if (W > 0)
        var Q = B.prefix = N.slice(0, W), ne = N.slice(W + 1), X = Q === "xmlns" && ne;
      else
        ne = N, Q = null, X = N === "xmlns" && "";
      B.localName = ne, X !== !1 && (U == null && (U = {}, b(M, M = {})), M[X] = U[X] = q, B.uri = t.XMLNS, C.startPrefixMapping(X, q));
    }
    for (var O = k.length; O--; ) {
      B = k[O];
      var Q = B.prefix;
      Q && (Q === "xml" && (B.uri = t.XML), Q !== "xmlns" && (B.uri = M[Q || ""]));
    }
    var W = F.indexOf(":");
    W > 0 ? (Q = k.prefix = F.slice(0, W), ne = k.localName = F.slice(W + 1)) : (Q = null, ne = k.localName = F);
    var T = k.uri = M[Q || ""];
    if (C.startElement(T, ne, F, k), k.closed) {
      if (C.endElement(T, ne, F), U)
        for (Q in U)
          Object.prototype.hasOwnProperty.call(U, Q) && C.endPrefixMapping(Q);
    } else
      return k.currentNSMap = M, k.localNSMap = U, !0;
  }
  function S(k, C, M, F, U) {
    if (/^(?:script|textarea)$/i.test(M)) {
      var B = k.indexOf("</" + M + ">", C), N = k.substring(C + 1, B);
      if (/[&<]/.test(N))
        return /^script$/i.test(M) ? (U.characters(N, 0, N.length), B) : (N = N.replace(/&#?\w+;/g, F), U.characters(N, 0, N.length), B);
    }
    return C + 1;
  }
  function _(k, C, M, F) {
    var U = F[M];
    return U == null && (U = k.lastIndexOf("</" + M + ">"), U < C && (U = k.lastIndexOf("</" + M)), F[M] = U), U < C;
  }
  function b(k, C) {
    for (var M in k)
      Object.prototype.hasOwnProperty.call(k, M) && (C[M] = k[M]);
  }
  function y(k, C, M, F) {
    var U = k.charAt(C + 2);
    switch (U) {
      case "-":
        if (k.charAt(C + 3) === "-") {
          var B = k.indexOf("-->", C + 4);
          return B > C ? (M.comment(k, C + 4, B - C - 4), B + 3) : (F.error("Unclosed comment"), -1);
        } else
          return -1;
      default:
        if (k.substr(C + 3, 6) == "CDATA[") {
          var B = k.indexOf("]]>", C + 9);
          return M.startCDATA(), M.characters(k, C + 9, B - C - 9), M.endCDATA(), B + 3;
        }
        var N = x(k, C), q = N.length;
        if (q > 1 && /!doctype/i.test(N[0][0])) {
          var Q = N[1][0], ne = !1, X = !1;
          q > 3 && (/^public$/i.test(N[2][0]) ? (ne = N[3][0], X = q > 4 && N[4][0]) : /^system$/i.test(N[2][0]) && (X = N[3][0]));
          var O = N[q - 1];
          return M.startDTD(Q, ne, X), M.endDTD(), O.index + O[0].length;
        }
    }
    return -1;
  }
  function w(k, C, M) {
    var F = k.indexOf("?>", C);
    if (F) {
      var U = k.substring(C, F).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
      return U ? (U[0].length, M.processingInstruction(U[1], U[2]), F + 2) : -1;
    }
    return -1;
  }
  function E() {
    this.attributeNames = {};
  }
  E.prototype = {
    setTagName: function(k) {
      if (!r.test(k))
        throw new Error("invalid tagName:" + k);
      this.tagName = k;
    },
    addValue: function(k, C, M) {
      if (!r.test(k))
        throw new Error("invalid attribute:" + k);
      this.attributeNames[k] = this.length, this[this.length++] = { qName: k, value: C, offset: M };
    },
    length: 0,
    getLocalName: function(k) {
      return this[k].localName;
    },
    getLocator: function(k) {
      return this[k].locator;
    },
    getQName: function(k) {
      return this[k].qName;
    },
    getURI: function(k) {
      return this[k].uri;
    },
    getValue: function(k) {
      return this[k].value;
    }
    //	,getIndex:function(uri, localName)){
    //		if(localName){
    //
    //		}else{
    //			var qName = uri
    //		}
    //	},
    //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
    //	getType:function(uri,localName){}
    //	getType:function(i){},
  };
  function x(k, C) {
    var M, F = [], U = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    for (U.lastIndex = C, U.exec(k); M = U.exec(k); )
      if (F.push(M), M[1]) return F;
  }
  return gg.XMLReader = h, gg.ParseError = d, gg;
}
var rR;
function tQ() {
  if (rR) return Jf;
  rR = 1;
  var t = p0(), e = TL(), n = ZK(), r = eQ(), i = e.DOMImplementation, o = t.NAMESPACE, s = r.ParseError, a = r.XMLReader;
  function l(m) {
    return m.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
  }
  function u(m) {
    this.options = m || { locator: {} };
  }
  u.prototype.parseFromString = function(m, v) {
    var S = this.options, _ = new a(), b = S.domBuilder || new f(), y = S.errorHandler, w = S.locator, E = S.xmlns || {}, x = /\/x?html?$/.test(v), k = x ? n.HTML_ENTITIES : n.XML_ENTITIES;
    w && b.setDocumentLocator(w), _.errorHandler = c(y, b, w), _.domBuilder = S.domBuilder || b, x && (E[""] = o.HTML), E.xml = E.xml || o.XML;
    var C = S.normalizeLineEndings || l;
    return m && typeof m == "string" ? _.parse(
      C(m),
      E,
      k
    ) : _.errorHandler.error("invalid doc source"), b.doc;
  };
  function c(m, v, S) {
    if (!m) {
      if (v instanceof f)
        return v;
      m = v;
    }
    var _ = {}, b = m instanceof Function;
    S = S || {};
    function y(w) {
      var E = m[w];
      !E && b && (E = m.length == 2 ? function(x) {
        m(w, x);
      } : m), _[w] = E && function(x) {
        E("[xmldom " + w + "]	" + x + h(S));
      } || function() {
      };
    }
    return y("warning"), y("error"), y("fatalError"), _;
  }
  function f() {
    this.cdata = !1;
  }
  function d(m, v) {
    v.lineNumber = m.lineNumber, v.columnNumber = m.columnNumber;
  }
  f.prototype = {
    startDocument: function() {
      this.doc = new i().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
    },
    startElement: function(m, v, S, _) {
      var b = this.doc, y = b.createElementNS(m, S || v), w = _.length;
      g(this, y), this.currentElement = y, this.locator && d(this.locator, y);
      for (var E = 0; E < w; E++) {
        var m = _.getURI(E), x = _.getValue(E), S = _.getQName(E), k = b.createAttributeNS(m, S);
        this.locator && d(_.getLocator(E), k), k.value = k.nodeValue = x, y.setAttributeNode(k);
      }
    },
    endElement: function(m, v, S) {
      var _ = this.currentElement;
      _.tagName, this.currentElement = _.parentNode;
    },
    startPrefixMapping: function(m, v) {
    },
    endPrefixMapping: function(m) {
    },
    processingInstruction: function(m, v) {
      var S = this.doc.createProcessingInstruction(m, v);
      this.locator && d(this.locator, S), g(this, S);
    },
    ignorableWhitespace: function(m, v, S) {
    },
    characters: function(m, v, S) {
      if (m = p.apply(this, arguments), m) {
        if (this.cdata)
          var _ = this.doc.createCDATASection(m);
        else
          var _ = this.doc.createTextNode(m);
        this.currentElement ? this.currentElement.appendChild(_) : /^\s*$/.test(m) && this.doc.appendChild(_), this.locator && d(this.locator, _);
      }
    },
    skippedEntity: function(m) {
    },
    endDocument: function() {
      this.doc.normalize();
    },
    setDocumentLocator: function(m) {
      (this.locator = m) && (m.lineNumber = 0);
    },
    //LexicalHandler
    comment: function(m, v, S) {
      m = p.apply(this, arguments);
      var _ = this.doc.createComment(m);
      this.locator && d(this.locator, _), g(this, _);
    },
    startCDATA: function() {
      this.cdata = !0;
    },
    endCDATA: function() {
      this.cdata = !1;
    },
    startDTD: function(m, v, S) {
      var _ = this.doc.implementation;
      if (_ && _.createDocumentType) {
        var b = _.createDocumentType(m, v, S);
        this.locator && d(this.locator, b), g(this, b), this.doc.doctype = b;
      }
    },
    /**
     * @see org.xml.sax.ErrorHandler
     * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
     */
    warning: function(m) {
      console.warn("[xmldom warning]	" + m, h(this.locator));
    },
    error: function(m) {
      console.error("[xmldom error]	" + m, h(this.locator));
    },
    fatalError: function(m) {
      throw new s(m, this.locator);
    }
  };
  function h(m) {
    if (m)
      return `
@` + (m.systemId || "") + "#[line:" + m.lineNumber + ",col:" + m.columnNumber + "]";
  }
  function p(m, v, S) {
    return typeof m == "string" ? m.substr(v, S) : m.length >= v + S || v ? new java.lang.String(m, v, S) + "" : m;
  }
  "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(m) {
    f.prototype[m] = function() {
      return null;
    };
  });
  function g(m, v) {
    m.currentElement ? m.currentElement.appendChild(v) : m.doc.appendChild(v);
  }
  return Jf.__DOMHandler = f, Jf.normalizeLineEndings = l, Jf.DOMParser = u, Jf;
}
var iR;
function nQ() {
  if (iR) return Qf;
  iR = 1;
  var t = TL();
  return Qf.DOMImplementation = t.DOMImplementation, Qf.XMLSerializer = t.XMLSerializer, Qf.DOMParser = tQ().DOMParser, Qf;
}
var Zf = {}, oR;
function rQ() {
  if (oR) return Zf;
  oR = 1, Object.defineProperty(Zf, "__esModule", { value: !0 }), Zf.parseJson = void 0;
  function t(e) {
    try {
      var n = JSON.parse(e);
      return n;
    } catch {
      return null;
    }
  }
  return Zf.parseJson = t, Zf;
}
var ed = {}, sR;
function iQ() {
  if (sR) return ed;
  sR = 1, Object.defineProperty(ed, "__esModule", { value: !0 }), ed.bufferFrom = void 0;
  function t(e) {
    var n = encodeURIComponent(e), r = n.replace(/%([0-9A-F]{2})/g, function(o, s) {
      return String.fromCharCode("0x" + s);
    }), i = new Uint8Array(r.length);
    return Array.prototype.forEach.call(r, function(o, s) {
      i[s] = o.charCodeAt(0);
    }), i;
  }
  return ed.bufferFrom = t, ed;
}
var td = {}, nd = {}, aR;
function xL() {
  if (aR) return nd;
  aR = 1, Object.defineProperty(nd, "__esModule", { value: !0 }), nd.EventPolyfill = void 0;
  var t = (
    /** @class */
    function() {
      function e(n, r) {
        this.AT_TARGET = 0, this.BUBBLING_PHASE = 0, this.CAPTURING_PHASE = 0, this.NONE = 0, this.type = "", this.srcElement = null, this.currentTarget = null, this.eventPhase = 0, this.isTrusted = !0, this.composed = !1, this.cancelable = !0, this.defaultPrevented = !1, this.bubbles = !0, this.lengthComputable = !0, this.loaded = 0, this.total = 0, this.cancelBubble = !1, this.returnValue = !0, this.type = n, this.target = r?.target || null, this.currentTarget = r?.currentTarget || null, this.timeStamp = Date.now();
      }
      return e.prototype.composedPath = function() {
        return [];
      }, e.prototype.initEvent = function(n, r, i) {
        this.type = n, this.bubbles = !!r, this.cancelable = !!i;
      }, e.prototype.preventDefault = function() {
        this.defaultPrevented = !0;
      }, e.prototype.stopPropagation = function() {
      }, e.prototype.stopImmediatePropagation = function() {
      }, e;
    }()
  );
  return nd.EventPolyfill = t, nd;
}
var Ll = {}, lR;
function oQ() {
  if (lR) return Ll;
  lR = 1;
  var t = Ll && Ll.__extends || /* @__PURE__ */ function() {
    var r = function(i, o) {
      return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, a) {
        s.__proto__ = a;
      } || function(s, a) {
        for (var l in a) Object.prototype.hasOwnProperty.call(a, l) && (s[l] = a[l]);
      }, r(i, o);
    };
    return function(i, o) {
      if (typeof o != "function" && o !== null)
        throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
      r(i, o);
      function s() {
        this.constructor = i;
      }
      i.prototype = o === null ? Object.create(o) : (s.prototype = o.prototype, new s());
    };
  }();
  Object.defineProperty(Ll, "__esModule", { value: !0 }), Ll.ProgressEventPolyfill = void 0;
  var e = xL(), n = (
    /** @class */
    function(r) {
      t(i, r);
      function i(o, s) {
        var a = r.call(this, o) || this;
        return a.lengthComputable = s?.lengthComputable || !1, a.composed = s?.composed || !1, a.loaded = s?.loaded || 0, a.total = s?.total || 0, a;
      }
      return i;
    }(e.EventPolyfill)
  );
  return Ll.ProgressEventPolyfill = n, Ll;
}
var uR;
function sQ() {
  if (uR) return td;
  uR = 1, Object.defineProperty(td, "__esModule", { value: !0 }), td.createEvent = void 0;
  var t = xL(), e = oQ(), n = typeof ProgressEvent < "u";
  function r(i, o, s) {
    var a = [
      "error",
      "progress",
      "loadstart",
      "loadend",
      "load",
      "timeout",
      "abort"
    ], l = n ? ProgressEvent : e.ProgressEventPolyfill, u = a.includes(o) ? new l(o, {
      lengthComputable: !0,
      loaded: s?.loaded || 0,
      total: s?.total || 0
    }) : new t.EventPolyfill(o, {
      target: i,
      currentTarget: i
    });
    return u;
  }
  return td.createEvent = r, td;
}
var cR;
function aQ() {
  if (cR) return Vi;
  cR = 1;
  var t = Vi && Vi.__awaiter || function(g, m, v, S) {
    function _(b) {
      return b instanceof v ? b : new v(function(y) {
        y(b);
      });
    }
    return new (v || (v = Promise))(function(b, y) {
      function w(k) {
        try {
          x(S.next(k));
        } catch (C) {
          y(C);
        }
      }
      function E(k) {
        try {
          x(S.throw(k));
        } catch (C) {
          y(C);
        }
      }
      function x(k) {
        k.done ? b(k.value) : _(k.value).then(w, E);
      }
      x((S = S.apply(g, m || [])).next());
    });
  }, e = Vi && Vi.__generator || function(g, m) {
    var v = { label: 0, sent: function() {
      if (b[0] & 1) throw b[1];
      return b[1];
    }, trys: [], ops: [] }, S, _, b, y;
    return y = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
      return this;
    }), y;
    function w(x) {
      return function(k) {
        return E([x, k]);
      };
    }
    function E(x) {
      if (S) throw new TypeError("Generator is already executing.");
      for (; v; ) try {
        if (S = 1, _ && (b = x[0] & 2 ? _.return : x[0] ? _.throw || ((b = _.return) && b.call(_), 0) : _.next) && !(b = b.call(_, x[1])).done) return b;
        switch (_ = 0, b && (x = [x[0] & 2, b.value]), x[0]) {
          case 0:
          case 1:
            b = x;
            break;
          case 4:
            return v.label++, { value: x[1], done: !1 };
          case 5:
            v.label++, _ = x[1], x = [0];
            continue;
          case 7:
            x = v.ops.pop(), v.trys.pop();
            continue;
          default:
            if (b = v.trys, !(b = b.length > 0 && b[b.length - 1]) && (x[0] === 6 || x[0] === 2)) {
              v = 0;
              continue;
            }
            if (x[0] === 3 && (!b || x[1] > b[0] && x[1] < b[3])) {
              v.label = x[1];
              break;
            }
            if (x[0] === 6 && v.label < b[1]) {
              v.label = b[1], b = x;
              break;
            }
            if (b && v.label < b[2]) {
              v.label = b[2], v.ops.push(x);
              break;
            }
            b[2] && v.ops.pop(), v.trys.pop();
            continue;
        }
        x = m.call(g, v);
      } catch (k) {
        x = [6, k], _ = 0;
      } finally {
        S = b = 0;
      }
      if (x[0] & 5) throw x[1];
      return { value: x[0] ? x[1] : void 0, done: !0 };
    }
  }, n = Vi && Vi.__values || function(g) {
    var m = typeof Symbol == "function" && Symbol.iterator, v = m && g[m], S = 0;
    if (v) return v.call(g);
    if (g && typeof g.length == "number") return {
      next: function() {
        return g && S >= g.length && (g = void 0), { value: g && g[S++], done: !g };
      }
    };
    throw new TypeError(m ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, r = Vi && Vi.__read || function(g, m) {
    var v = typeof Symbol == "function" && g[Symbol.iterator];
    if (!v) return g;
    var S = v.call(g), _, b = [], y;
    try {
      for (; (m === void 0 || m-- > 0) && !(_ = S.next()).done; ) b.push(_.value);
    } catch (w) {
      y = { error: w };
    } finally {
      try {
        _ && !_.done && (v = S.return) && v.call(S);
      } finally {
        if (y) throw y.error;
      }
    }
    return b;
  };
  Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.createXMLHttpRequestOverride = void 0;
  var i = sc(), o = Hi(), s = nQ(), a = rQ(), l = kL(), u = iQ(), c = sQ(), f = h0(), d = d0(), h = qE(), p = function(g) {
    var m, v = g.XMLHttpRequest, S = g.emitter, _ = g.log;
    return m = /** @class */
    function() {
      function b() {
        this._events = [], this.log = _, this.UNSENT = 0, this.OPENED = 1, this.HEADERS_RECEIVED = 2, this.LOADING = 3, this.DONE = 4, this.onreadystatechange = null, this.onabort = null, this.onerror = null, this.onload = null, this.onloadend = null, this.onloadstart = null, this.onprogress = null, this.ontimeout = null, this.url = "", this.method = "GET", this.readyState = this.UNSENT, this.withCredentials = !1, this.status = 200, this.statusText = "OK", this.response = "", this.responseType = "text", this.responseText = "", this.responseXML = null, this.responseURL = "", this.upload = {}, this.timeout = 0, this._requestHeaders = new o.Headers(), this._responseHeaders = new o.Headers();
      }
      return b.prototype.setReadyState = function(y) {
        y !== this.readyState && (this.log("readyState change %d -> %d", this.readyState, y), this.readyState = y, y !== this.UNSENT && (this.log("triggering readystate change..."), this.trigger("readystatechange")));
      }, b.prototype.trigger = function(y, w) {
        var E, x;
        this.log('trigger "%s" (%d)', y, this.readyState), this.log('resolve listener for event "%s"', y);
        var k = this["on" + y];
        k?.call(this, c.createEvent(this, y, w));
        try {
          for (var C = n(this._events), M = C.next(); !M.done; M = C.next()) {
            var F = M.value;
            F.name === y && (_('calling mock event listener "%s" (%d)', y, this.readyState), F.listener.call(this, c.createEvent(this, y, w)));
          }
        } catch (U) {
          E = { error: U };
        } finally {
          try {
            M && !M.done && (x = C.return) && x.call(C);
          } finally {
            if (E) throw E.error;
          }
        }
        return this;
      }, b.prototype.reset = function() {
        this.log("reset"), this.setReadyState(this.UNSENT), this.status = 200, this.statusText = "OK", this.response = null, this.responseText = null, this.responseXML = null, this._requestHeaders = new o.Headers(), this._responseHeaders = new o.Headers();
      }, b.prototype.open = function(y, w, E, x, k) {
        return E === void 0 && (E = !0), t(this, void 0, void 0, function() {
          return e(this, function(C) {
            return this.log = this.log.extend("request " + y + " " + w), this.log("open", { method: y, url: w, async: E, user: x, password: k }), this.reset(), this.setReadyState(this.OPENED), typeof w > "u" ? (this.url = y, this.method = "GET") : (this.url = w, this.method = y, this.async = E, this.user = x, this.password = k), [
              2
              /*return*/
            ];
          });
        });
      }, b.prototype.send = function(y) {
        var w = this;
        this.log("send %s %s", this.method, this.url);
        var E;
        typeof y == "string" ? E = d.encodeBuffer(y) : E = y || new ArrayBuffer(0);
        var x;
        try {
          x = new URL(this.url);
        } catch {
          x = new URL(this.url, window.location.href);
        }
        this.log("request headers", this._requestHeaders);
        var k = new f.IsomorphicRequest(x, {
          body: E,
          method: this.method,
          headers: this._requestHeaders,
          credentials: this.withCredentials ? "include" : "omit"
        }), C = new h.InteractiveIsomorphicRequest(k);
        this.log('emitting the "request" event for %d listener(s)...', S.listenerCount("request")), S.emit("request", C), this.log("awaiting mocked response..."), Promise.resolve(i.until(function() {
          return t(w, void 0, void 0, function() {
            var M, F;
            return e(this, function(U) {
              switch (U.label) {
                case 0:
                  return [4, S.untilIdle("request", function(B) {
                    var N = r(B.args, 1), q = N[0];
                    return q.id === C.id;
                  })];
                case 1:
                  return U.sent(), this.log("all request listeners have been resolved!"), [4, C.respondWith.invoked()];
                case 2:
                  return M = r.apply(void 0, [U.sent(), 1]), F = M[0], this.log("event.respondWith called with:", F), [2, F];
              }
            });
          });
        })).then(function(M) {
          var F, U, B = r(M, 2), N = B[0], q = B[1];
          if (N) {
            w.log("middleware function threw an exception!", N), w.trigger("error"), w.abort();
            return;
          }
          if (q) {
            if (w.log("received mocked response", q), w.trigger("loadstart"), w.status = (F = q.status) !== null && F !== void 0 ? F : 200, w.statusText = q.statusText || "OK", w._responseHeaders = q.headers ? o.objectToHeaders(q.headers) : new o.Headers(), w.log("set response status", w.status, w.statusText), w.log("set response headers", w._responseHeaders), w.setReadyState(w.HEADERS_RECEIVED), w.log("response type", w.responseType), w.response = w.getResponseBody(q.body), w.responseURL = w.url, w.responseText = q.body || "", w.responseXML = w.getResponseXML(), w.log("set response body", w.response), q.body && w.response) {
              w.setReadyState(w.LOADING);
              var Q = u.bufferFrom(q.body);
              w.trigger("progress", {
                loaded: Q.length,
                total: Q.length
              });
            }
            w.setReadyState(w.DONE), w.trigger("load"), w.trigger("loadend"), S.emit("response", k, l.toIsoResponse(q));
          } else {
            w.log("no mocked response received!");
            var ne = new v();
            w.log("opening an original request %s %s", w.method, w.url), ne.open(w.method, w.url, (U = w.async) !== null && U !== void 0 ? U : !0, w.user, w.password), ne.addEventListener("load", function() {
              w.log('original "onload"'), w.status = ne.status, w.statusText = ne.statusText, w.responseURL = ne.responseURL, w.responseType = ne.responseType, w.response = ne.response, w.responseText = ne.responseText, w.responseXML = ne.responseXML, w.log("set mock request readyState to DONE"), w.setReadyState(w.DONE), w.log("received original response", w.status, w.statusText), w.log("original response body:", w.response);
              var X = ne.getAllResponseHeaders();
              w.log(`original response headers:
`, X), w._responseHeaders = o.stringToHeaders(X), w.log("original response headers (normalized)", w._responseHeaders), w.log("original response finished"), S.emit("response", k, {
                status: ne.status,
                statusText: ne.statusText,
                headers: w._responseHeaders,
                body: ne.response
              });
            }), w.propagateCallbacks(ne), w.propagateListeners(ne), w.propagateHeaders(ne, w._requestHeaders), w.async && (ne.timeout = w.timeout), w.log("send", y), ne.send(y);
          }
        });
      }, b.prototype.abort = function() {
        this.log("abort"), this.readyState > this.UNSENT && this.readyState < this.DONE && (this.setReadyState(this.UNSENT), this.trigger("abort"));
      }, b.prototype.dispatchEvent = function() {
        return !1;
      }, b.prototype.setRequestHeader = function(y, w) {
        this.log('set request header "%s" to "%s"', y, w), this._requestHeaders.append(y, w);
      }, b.prototype.getResponseHeader = function(y) {
        if (this.log('get response header "%s"', y), this.readyState < this.HEADERS_RECEIVED)
          return this.log("cannot return a header: headers not received (state: %s)", this.readyState), null;
        var w = this._responseHeaders.get(y);
        return this.log('resolved response header "%s" to "%s"', y, w, this._responseHeaders), w;
      }, b.prototype.getAllResponseHeaders = function() {
        return this.log("get all response headers"), this.readyState < this.HEADERS_RECEIVED ? (this.log("cannot return headers: headers not received (state: %s)", this.readyState), "") : o.headersToString(this._responseHeaders);
      }, b.prototype.addEventListener = function(y, w) {
        this.log("addEventListener", y, w), this._events.push({
          name: y,
          listener: w
        });
      }, b.prototype.removeEventListener = function(y, w) {
        this.log("removeEventListener", y, w), this._events = this._events.filter(function(E) {
          return E.name !== y && E.listener !== w;
        });
      }, b.prototype.overrideMimeType = function() {
      }, b.prototype.getResponseBody = function(y) {
        var w = y ?? "";
        switch (this.log("coerced response body to", w), this.responseType) {
          case "json":
            return this.log("resolving response body as JSON"), a.parseJson(w);
          case "blob": {
            var E = this.getResponseHeader("content-type") || "text/plain";
            return this.log("resolving response body as Blob", { type: E }), new Blob([w], {
              type: E
            });
          }
          case "arraybuffer": {
            this.log("resolving response body as ArrayBuffer");
            var x = u.bufferFrom(w);
            return x;
          }
          default:
            return w;
        }
      }, b.prototype.getResponseXML = function() {
        var y = this.getResponseHeader("Content-Type");
        return y === "application/xml" || y === "text/xml" ? new s.DOMParser().parseFromString(this.responseText, y) : null;
      }, b.prototype.propagateCallbacks = function(y) {
        var w, E;
        this.log("propagating request callbacks to the original request");
        var x = [
          "abort",
          "onerror",
          "ontimeout",
          "onload",
          "onloadstart",
          "onloadend",
          "onprogress",
          "onreadystatechange"
        ];
        try {
          for (var k = n(x), C = k.next(); !C.done; C = k.next()) {
            var M = C.value, F = this[M];
            F && (y[M] = this[M], this.log('propagated the "%s" callback', M, F));
          }
        } catch (U) {
          w = { error: U };
        } finally {
          try {
            C && !C.done && (E = k.return) && E.call(k);
          } finally {
            if (w) throw w.error;
          }
        }
        y.onabort = this.abort, y.onerror = this.onerror, y.ontimeout = this.ontimeout, y.onload = this.onload, y.onloadstart = this.onloadstart, y.onloadend = this.onloadend, y.onprogress = this.onprogress, y.onreadystatechange = this.onreadystatechange;
      }, b.prototype.propagateListeners = function(y) {
        this.log("propagating request listeners (%d) to the original request", this._events.length, this._events), this._events.forEach(function(w) {
          var E = w.name, x = w.listener;
          y.addEventListener(E, x);
        });
      }, b.prototype.propagateHeaders = function(y, w) {
        var E = this;
        this.log("propagating request headers to the original request", w), Object.entries(w.raw()).forEach(function(x) {
          var k = r(x, 2), C = k[0], M = k[1];
          E.log('setting "%s" (%s) header on the original request', C, M), y.setRequestHeader(C, M);
        });
      }, b;
    }(), /* Request state */
    m.UNSENT = 0, m.OPENED = 1, m.HEADERS_RECEIVED = 2, m.LOADING = 3, m.DONE = 4, m;
  };
  return Vi.createXMLHttpRequestOverride = p, Vi;
}
var fR;
function lQ() {
  if (fR) return Ml;
  fR = 1;
  var t = Ml && Ml.__extends || /* @__PURE__ */ function() {
    var s = function(a, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, c) {
        u.__proto__ = c;
      } || function(u, c) {
        for (var f in c) Object.prototype.hasOwnProperty.call(c, f) && (u[f] = c[f]);
      }, s(a, l);
    };
    return function(a, l) {
      if (typeof l != "function" && l !== null)
        throw new TypeError("Class extends value " + String(l) + " is not a constructor or null");
      s(a, l);
      function u() {
        this.constructor = a;
      }
      a.prototype = l === null ? Object.create(l) : (u.prototype = l.prototype, new u());
    };
  }();
  Object.defineProperty(Ml, "__esModule", { value: !0 }), Ml.XMLHttpRequestInterceptor = void 0;
  var e = ta(), n = LE(), r = u0(), i = aQ(), o = (
    /** @class */
    function(s) {
      t(a, s);
      function a() {
        return s.call(this, a.symbol) || this;
      }
      return a.prototype.checkEnvironment = function() {
        return typeof window < "u" && typeof window.XMLHttpRequest < "u";
      }, a.prototype.setup = function() {
        var l = this.log.extend("setup");
        l('patching "XMLHttpRequest" module...');
        var u = window.XMLHttpRequest;
        e.invariant(!u[n.IS_PATCHED_MODULE], 'Failed to patch the "XMLHttpRequest" module: already patched.'), window.XMLHttpRequest = i.createXMLHttpRequestOverride({
          XMLHttpRequest: u,
          emitter: this.emitter,
          log: this.log
        }), l('native "XMLHttpRequest" module patched!', window.XMLHttpRequest.name), Object.defineProperty(window.XMLHttpRequest, n.IS_PATCHED_MODULE, {
          enumerable: !0,
          configurable: !0,
          value: !0
        }), this.subscriptions.push(function() {
          Object.defineProperty(window.XMLHttpRequest, n.IS_PATCHED_MODULE, {
            value: void 0
          }), window.XMLHttpRequest = u, l('native "XMLHttpRequest" module restored!', window.XMLHttpRequest.name);
        });
      }, a.symbol = Symbol("xhr"), a;
    }(r.Interceptor)
  );
  return Ml.XMLHttpRequestInterceptor = o, Ml;
}
var Bl = {}, rd = {}, id = {}, dR;
function CL() {
  if (dR) return id;
  dR = 1, Object.defineProperty(id, "__esModule", { value: !0 }), id.MemoryLeakError = void 0;
  let t = class extends Error {
    constructor(n, r, i) {
      super(`Possible EventEmitter memory leak detected. ${i} ${r.toString()} listeners added. Use emitter.setMaxListeners() to increase limit`), this.emitter = n, this.type = r, this.count = i, this.name = "MaxListenersExceededWarning";
    }
  };
  return id.MemoryLeakError = t, id;
}
var hR;
function uQ() {
  if (hR) return rd;
  hR = 1, Object.defineProperty(rd, "__esModule", { value: !0 }), rd.Emitter = void 0;
  const t = CL();
  let e = class AL {
    constructor() {
      this.events = /* @__PURE__ */ new Map(), this.maxListeners = AL.defaultMaxListeners, this.hasWarnedAboutPotentialMemoryLeak = !1;
    }
    static listenerCount(r, i) {
      return r.listenerCount(i);
    }
    _emitInternalEvent(r, i, o) {
      this.emit(
        r,
        i,
        o
      );
    }
    _getListeners(r) {
      return this.events.get(r) || [];
    }
    _removeListener(r, i) {
      const o = r.indexOf(i);
      return o > -1 && r.splice(o, 1), [];
    }
    _wrapOnceListener(r, i) {
      const o = (...s) => {
        this.removeListener(r, o), i.apply(this, s);
      };
      return o;
    }
    setMaxListeners(r) {
      return this.maxListeners = r, this;
    }
    /**
     * Returns the current max listener value for the `Emitter` which is
     * either set by `emitter.setMaxListeners(n)` or defaults to
     * `Emitter.defaultMaxListeners`.
     */
    getMaxListeners() {
      return this.maxListeners;
    }
    /**
     * Returns an array listing the events for which the emitter has registered listeners.
     * The values in the array will be strings or Symbols.
     */
    eventNames() {
      return Array.from(this.events.keys());
    }
    /**
     * Synchronously calls each of the listeners registered for the event named `eventName`,
     * in the order they were registered, passing the supplied arguments to each.
     * Returns `true` if the event has listeners, `false` otherwise.
     *
     * @example
     * const emitter = new Emitter<{ hello: [string] }>()
     * emitter.emit('hello', 'John')
     */
    emit(r, ...i) {
      const o = this._getListeners(r);
      return o.forEach((s) => {
        s.apply(this, i);
      }), o.length > 0;
    }
    addListener(r, i) {
      this._emitInternalEvent("newListener", r, i);
      const o = this._getListeners(r).concat(i);
      if (this.events.set(r, o), this.maxListeners > 0 && this.listenerCount(r) > this.maxListeners && !this.hasWarnedAboutPotentialMemoryLeak) {
        this.hasWarnedAboutPotentialMemoryLeak = !0;
        const s = new t.MemoryLeakError(this, r, this.listenerCount(r));
        console.warn(s);
      }
      return this;
    }
    on(r, i) {
      return this.addListener(r, i);
    }
    once(r, i) {
      return this.addListener(r, this._wrapOnceListener(r, i));
    }
    prependListener(r, i) {
      const o = this._getListeners(r);
      if (o.length > 0) {
        const s = [i].concat(o);
        this.events.set(r, s);
      } else
        this.events.set(r, o.concat(i));
      return this;
    }
    prependOnceListener(r, i) {
      return this.prependListener(r, this._wrapOnceListener(r, i));
    }
    removeListener(r, i) {
      const o = this._getListeners(r);
      return o.length > 0 && (this._removeListener(o, i), this.events.set(r, o), this._emitInternalEvent("removeListener", r, i)), this;
    }
    /**
     * Alias for `emitter.removeListener()`.
     *
     * @example
     * emitter.off('hello', listener)
     */
    off(r, i) {
      return this.removeListener(r, i);
    }
    removeAllListeners(r) {
      return r ? this.events.delete(r) : this.events.clear(), this;
    }
    /**
     * Returns a copy of the array of listeners for the event named `eventName`.
     */
    listeners(r) {
      return Array.from(this._getListeners(r));
    }
    /**
     * Returns the number of listeners listening to the event named `eventName`.
     */
    listenerCount(r) {
      return this._getListeners(r).length;
    }
    rawListeners(r) {
      return this.listeners(r);
    }
  };
  return rd.Emitter = e, e.defaultMaxListeners = 10, rd;
}
var pR;
function cQ() {
  return pR || (pR = 1, function(t) {
    var e = Bl && Bl.__createBinding || (Object.create ? function(r, i, o, s) {
      s === void 0 && (s = o);
      var a = Object.getOwnPropertyDescriptor(i, o);
      (!a || ("get" in a ? !i.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
        return i[o];
      } }), Object.defineProperty(r, s, a);
    } : function(r, i, o, s) {
      s === void 0 && (s = o), r[s] = i[o];
    }), n = Bl && Bl.__exportStar || function(r, i) {
      for (var o in r) o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, r, o);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), n(uQ(), t), n(CL(), t);
  }(Bl)), Bl;
}
var Fb, gR;
function fQ() {
  if (gR) return Fb;
  gR = 1;
  var t = Object.create, e = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, o = Object.prototype.hasOwnProperty, s = (A, V) => {
    for (var K in V)
      e(A, K, { get: V[K], enumerable: !0 });
  }, a = (A, V, K, de) => {
    if (V && typeof V == "object" || typeof V == "function")
      for (let ge of r(V))
        !o.call(A, ge) && ge !== K && e(A, ge, { get: () => V[ge], enumerable: !(de = n(V, ge)) || de.enumerable });
    return A;
  }, l = (A, V, K) => (K = A != null ? t(i(A)) : {}, a(
    !A || !A.__esModule ? e(K, "default", { value: A, enumerable: !0 }) : K,
    A
  )), u = (A) => a(e({}, "__esModule", { value: !0 }), A), c = {};
  s(c, {
    GraphQLHandler: () => fp,
    MockedRequest: () => we,
    RESTMethods: () => Ta,
    RequestHandler: () => _i,
    RestHandler: () => x0,
    SetupApi: () => F2,
    SetupWorkerApi: () => L2,
    cleanUrl: () => Me,
    compose: () => At,
    context: () => f,
    createResponseComposition: () => Wr,
    defaultContext: () => ns,
    defaultResponse: () => Kt,
    graphql: () => C5,
    graphqlContext: () => A2,
    handleRequest: () => C0,
    matchRequestUrl: () => tn,
    response: () => Wt,
    rest: () => k5,
    restContext: () => kl,
    setupWorker: () => E5
  }), Fb = u(c);
  var f = {};
  s(f, {
    body: () => S,
    cookie: () => v,
    data: () => E,
    delay: () => N,
    errors: () => q,
    extensions: () => x,
    fetch: () => T,
    json: () => w,
    set: () => g,
    status: () => h,
    text: () => $,
    xml: () => P
  });
  var d = {
    100: "Continue",
    101: "Switching Protocols",
    102: "Processing",
    103: "Early Hints",
    200: "OK",
    201: "Created",
    202: "Accepted",
    203: "Non-Authoritative Information",
    204: "No Content",
    205: "Reset Content",
    206: "Partial Content",
    207: "Multi-Status",
    208: "Already Reported",
    226: "IM Used",
    300: "Multiple Choices",
    301: "Moved Permanently",
    302: "Found",
    303: "See Other",
    304: "Not Modified",
    305: "Use Proxy",
    307: "Temporary Redirect",
    308: "Permanent Redirect",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Failed",
    413: "Payload Too Large",
    414: "URI Too Long",
    415: "Unsupported Media Type",
    416: "Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a Teapot",
    421: "Misdirected Request",
    422: "Unprocessable Entity",
    423: "Locked",
    424: "Failed Dependency",
    425: "Too Early",
    426: "Upgrade Required",
    428: "Precondition Required",
    429: "Too Many Requests",
    431: "Request Header Fields Too Large",
    451: "Unavailable For Legal Reasons",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported",
    506: "Variant Also Negotiates",
    507: "Insufficient Storage",
    508: "Loop Detected",
    509: "Bandwidth Limit Exceeded",
    510: "Not Extended",
    511: "Network Authentication Required"
  }, h = (A, V) => (K) => (K.status = A, K.statusText = V || d[String(A)], K), p = Hi();
  function g(...A) {
    return (V) => {
      const [K, de] = A;
      return typeof K == "string" ? V.headers.append(K, de) : (0, p.objectToHeaders)(K).forEach(($e, Ve) => {
        V.headers.append(Ve, $e);
      }), V;
    };
  }
  var m = l(Av()), v = (A, V, K) => (de) => {
    const ge = m.serialize(A, V, K);
    return de.headers.append("Set-Cookie", ge), typeof document < "u" && (document.cookie = ge), de;
  }, S = (A) => (V) => (V.body = A, V);
  function _(A) {
    try {
      return JSON.parse(A);
    } catch {
      return;
    }
  }
  function b(A) {
    return A != null && typeof A == "object" && !Array.isArray(A);
  }
  function y(A, V) {
    return Object.entries(V).reduce((K, [de, ge]) => {
      const $e = K[de];
      return Array.isArray($e) && Array.isArray(ge) ? (K[de] = $e.concat(ge), K) : b($e) && b(ge) ? (K[de] = y($e, ge), K) : (K[de] = ge, K);
    }, Object.assign({}, A));
  }
  var w = (A) => (V) => (V.headers.set("Content-Type", "application/json"), V.body = JSON.stringify(A), V), E = (A) => (V) => {
    const K = _(V.body) || {}, de = y(K, { data: A });
    return w(de)(V);
  }, x = (A) => (V) => {
    const K = _(V.body) || {}, de = y(K, { extensions: A });
    return w(de)(V);
  }, k = Ov(), C = 2147483647, M = 100, F = 400, U = 5, B = () => (0, k.isNodeProcess)() ? U : Math.floor(
    Math.random() * (F - M) + M
  ), N = (A) => (V) => {
    let K;
    if (typeof A == "string")
      switch (A) {
        case "infinite": {
          K = C;
          break;
        }
        case "real": {
          K = B();
          break;
        }
        default:
          throw new Error(
            `Failed to delay a response: unknown delay mode "${A}". Please make sure you provide one of the supported modes ("real", "infinite") or a number to "ctx.delay".`
          );
      }
    else if (typeof A > "u")
      K = B();
    else {
      if (A > C)
        throw new Error(
          `Failed to delay a response: provided delay duration (${A}) exceeds the maximum allowed duration for "setTimeout" (${C}). This will cause the response to be returned immediately. Please use a number within the allowed range to delay the response by exact duration, or consider the "infinite" delay mode to delay the response indefinitely.`
        );
      K = A;
    }
    return V.delay = K, V;
  }, q = (A) => (V) => {
    if (A == null)
      return V;
    const K = _(V.body) || {}, de = y(K, { errors: A });
    return w(de)(V);
  }, Q = Ov(), ne = Hi(), X = (0, Q.isNodeProcess)() ? (A, V) => Promise.resolve().then(() => l(WX())).then(
    ({ default: K }) => K(A, V)
  ) : globalThis.fetch, O = (A) => {
    const V = new ne.Headers(A.headers);
    return V.set("x-msw-bypass", "true"), {
      ...A,
      headers: V.all()
    };
  }, W = (A) => {
    const { body: V, method: K } = A, de = {
      ...A,
      body: void 0
    };
    return ["GET", "HEAD"].includes(K) || (typeof V == "object" || typeof V == "number" || typeof V == "boolean" ? de.body = JSON.stringify(V) : de.body = V), de;
  }, T = (A, V = {}) => {
    if (typeof A == "string")
      return X(A, O(V));
    const K = W(A), de = O(K);
    return X(A.url.href, de);
  }, $ = (A) => (V) => (V.headers.set("Content-Type", "text/plain"), V.body = A, V), P = (A) => (V) => (V.headers.set("Content-Type", "text/xml"), V.body = A, V), H = ta(), Z = ta(), le = "[MSW]";
  function J(A, ...V) {
    const K = (0, Z.format)(A, ...V);
    return `${le} ${K}`;
  }
  function ue(A, ...V) {
    console.warn(J(A, ...V));
  }
  function he(A, ...V) {
    console.error(J(A, ...V));
  }
  var me = {
    formatMessage: J,
    warn: ue,
    error: he
  };
  function oe() {
    (0, H.invariant)(
      typeof URL < "u",
      me.formatMessage(
        `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
      )
    );
  }
  var re = ta(), se = Ov(), ae = sc(), fe = sc();
  function Y(A, V, K) {
    return [
      A.active,
      A.installing,
      A.waiting
    ].filter((Ve) => Ve != null).find((Ve) => K(Ve.scriptURL, V)) || null;
  }
  function Re(A) {
    return new URL(A, location.href).href;
  }
  var ee = async (A, V = {}, K) => {
    const de = Re(A), ge = await navigator.serviceWorker.getRegistrations().then(
      (at) => at.filter(
        (_n) => Y(_n, de, K)
      )
    );
    !navigator.serviceWorker.controller && ge.length > 0 && location.reload();
    const [$e] = ge;
    if ($e)
      return $e.update().then(() => [
        Y(
          $e,
          de,
          K
        ),
        $e
      ]);
    const [Ve, He] = await (0, fe.until)(
      async () => {
        const at = await navigator.serviceWorker.register(A, V);
        return [
          Y(at, de, K),
          at
        ];
      }
    );
    if (Ve) {
      if (Ve.message.includes("(404)")) {
        const _n = new URL(V?.scope || "/", location.href);
        throw new Error(
          me.formatMessage(`Failed to register a Service Worker for scope ('${_n.href}') with script ('${de}'): Service Worker script does not exist at the given path.

Did you forget to run "npx msw init <PUBLIC_DIR>"?

Learn more about creating the Service Worker script: https://mswjs.io/docs/cli/init`)
        );
      }
      throw new Error(
        me.formatMessage(
          `Failed to register the Service Worker:

%s`,
          Ve.message
        )
      );
    }
    return He;
  };
  function Ye(A = {}) {
    if (A.quiet)
      return;
    const V = A.message || "Mocking enabled.";
    console.groupCollapsed(
      `%c${me.formatMessage(V)}`,
      "color:orangered;font-weight:bold;"
    ), console.log(
      "%cDocumentation: %chttps://mswjs.io/docs",
      "font-weight:bold",
      "font-weight:normal"
    ), console.log("Found an issue? https://github.com/mswjs/msw/issues"), A.workerUrl && console.log("Worker script URL:", A.workerUrl), A.workerScope && console.log("Worker scope:", A.workerScope), console.groupEnd();
  }
  async function Te(A, V) {
    var K, de;
    if (A.workerChannel.send("MOCK_ACTIVATE"), await A.events.once("MOCKING_ENABLED"), A.isMockingEnabled) {
      me.warn(
        'Found a redundant "worker.start()" call. Note that starting the worker while mocking is already enabled will have no effect. Consider removing this "worker.start()" call.'
      );
      return;
    }
    A.isMockingEnabled = !0, Ye({
      quiet: V.quiet,
      workerScope: (K = A.registration) == null ? void 0 : K.scope,
      workerUrl: (de = A.worker) == null ? void 0 : de.scriptURL
    });
  }
  var ve = class {
    constructor(A) {
      this.port = A;
    }
    postMessage(A, ...V) {
      const [K, de] = V;
      this.port.postMessage({ type: A, data: K }, { transfer: de });
    }
  }, Oe = class extends Error {
    constructor(A) {
      super(A), this.name = "NetworkError";
    }
  }, Je = Pb(), pt = Hi(), Pt = l(Av()), bt = XA(), Ft = Pb(), mt = d0(), ln = Hi(), jn = l(Av());
  function $t() {
    return jn.parse(document.cookie);
  }
  function Tr(A) {
    if (typeof document > "u" || typeof location > "u")
      return {};
    switch (A.credentials) {
      case "same-origin":
        return location.origin === A.url.origin ? $t() : {};
      case "include":
        return $t();
      default:
        return {};
    }
  }
  var xr = Hi();
  function ce(A) {
    var V, K;
    const de = (0, xr.stringToHeaders)(A), ge = de.get("content-type") || "text/plain", $e = de.get("content-disposition");
    if (!$e)
      throw new Error('"Content-Disposition" header is required.');
    const Ve = $e.split(";").reduce((_n, Cr) => {
      const [Ei, ...Ca] = Cr.trim().split("=");
      return _n[Ei] = Ca.join("="), _n;
    }, {}), He = (V = Ve.name) == null ? void 0 : V.slice(1, -1), at = (K = Ve.filename) == null ? void 0 : K.slice(1, -1);
    return {
      name: He,
      filename: at,
      contentType: ge
    };
  }
  function ie(A, V) {
    const K = V?.get("content-type");
    if (!K)
      return;
    const [, ...de] = K.split(/; */), ge = de.filter((at) => at.startsWith("boundary=")).map((at) => at.replace(/^boundary=/, ""))[0];
    if (!ge)
      return;
    const $e = new RegExp(`--+${ge}`), Ve = A.split($e).filter((at) => at.startsWith(`\r
`) && at.endsWith(`\r
`)).map((at) => at.trimStart().replace(/\r\n$/, ""));
    if (!Ve.length)
      return;
    const He = {};
    try {
      for (const at of Ve) {
        const [_n, ...Cr] = at.split(`\r
\r
`), Ei = Cr.join(`\r
\r
`), { contentType: Ca, filename: Bs, name: Li } = ce(_n), Cf = Bs === void 0 ? Ei : new File([Ei], Bs, { type: Ca }), xl = He[Li];
        xl === void 0 ? He[Li] = Cf : Array.isArray(xl) ? He[Li] = [...xl, Cf] : He[Li] = [xl, Cf];
      }
      return He;
    } catch {
      return;
    }
  }
  function ke(A, V) {
    var K;
    if (!A)
      return A;
    const de = ((K = V?.get("content-type")) == null ? void 0 : K.toLowerCase()) || "";
    return de.startsWith("multipart/form-data") && typeof A != "object" ? ie(A.toString(), V) || A : de.includes("json") && typeof A != "object" && _(A.toString()) || A;
  }
  function Ae(A, V) {
    return A.toLowerCase() === V.toLowerCase();
  }
  var we = class extends Ft.IsomorphicRequest {
    constructor(A, V = {}) {
      super(A, V), V.id && (this.id = V.id), this.cache = V.cache || "default", this.destination = V.destination || "", this.integrity = V.integrity || "", this.keepalive = V.keepalive || !1, this.mode = V.mode || "cors", this.priority = V.priority || "auto", this.redirect = V.redirect || "follow", this.referrer = V.referrer || "", this.referrerPolicy = V.referrerPolicy || "no-referrer", this.cookies = V.cookies || this.getCookies();
    }
    get body() {
      const A = (0, mt.decodeBuffer)(this._body), V = ke(A, this.headers);
      if (!(Ae(this.method, "GET") && V === ""))
        return V;
    }
    passthrough() {
      return {
        status: 101,
        statusText: "Continue",
        headers: new ln.Headers(),
        body: null,
        passthrough: !0,
        once: !1
      };
    }
    getCookies() {
      var A;
      const V = this.headers.get("cookie"), K = V ? Pt.parse(V) : {};
      bt.store.hydrate();
      const de = Array.from(
        (A = bt.store.get({ ...this, url: this.url.href })) == null ? void 0 : A.entries()
      ).reduce((Ve, [He, { value: at }]) => Object.assign(Ve, { [He.trim()]: at }), {}), $e = {
        ...Tr(this),
        ...de
      };
      for (const [Ve, He] of Object.entries($e))
        this.headers.append("cookie", `${Ve}=${He}`);
      return {
        ...$e,
        ...K
      };
    }
  };
  function Ie(A) {
    const V = new URL(A.url), K = new pt.Headers(A.headers);
    return new we(V, {
      ...A,
      body: (0, Je.encodeBuffer)(A.body || ""),
      headers: K
    });
  }
  var R = sc(), I = async (A, V, K) => {
    const de = V.filter(($e) => $e.test(A, K));
    if (de.length === 0)
      return {
        handler: void 0,
        response: void 0
      };
    const ge = await de.reduce(async ($e, Ve) => {
      const He = await $e;
      if (He?.response)
        return $e;
      const at = await Ve.run(A, K);
      return at === null || at.handler.shouldSkip ? null : at.response ? (at.response.once && Ve.markAsSkipped(!0), at) : {
        request: at.request,
        handler: at.handler,
        response: void 0,
        parsedResult: at.parsedResult
      };
    }, Promise.resolve(null));
    return ge ? {
      handler: ge.handler,
      publicRequest: ge.request,
      parsedRequest: ge.parsedResult,
      response: ge.response
    } : {
      handler: void 0,
      response: void 0
    };
  }, j = l(UK()), te = qK, Ee = (A) => A.referrer.startsWith(A.url.origin) ? A.url.pathname : new URL(
    A.url.pathname,
    `${A.url.protocol}//${A.url.host}`
  ).href;
  function Ue(A) {
    var V;
    const K = A.definitions.find((de) => de.kind === "OperationDefinition");
    return {
      operationType: K?.operation,
      operationName: (V = K?.name) == null ? void 0 : V.value
    };
  }
  function ut(A) {
    try {
      const V = (0, te.parse)(A);
      return Ue(V);
    } catch (V) {
      return V;
    }
  }
  function qe(A, V, K) {
    const de = { variables: A };
    for (const [ge, $e] of Object.entries(V)) {
      if (!(ge in K))
        throw new Error(`Given files do not have a key '${ge}' .`);
      for (const Ve of $e) {
        const [He, ...at] = Ve.split(".").reverse(), _n = at.reverse();
        let Cr = de;
        for (const Ei of _n) {
          if (!(Ei in Cr))
            throw new Error(`Property '${_n}' is not in operations.`);
          Cr = Cr[Ei];
        }
        Cr[He] = K[ge];
      }
    }
    return de.variables;
  }
  function ze(A) {
    var V, K;
    switch (A.method) {
      case "GET": {
        const de = A.url.searchParams.get("query"), ge = A.url.searchParams.get("variables") || "";
        return {
          query: de,
          variables: _(ge)
        };
      }
      case "POST": {
        if ((V = A.body) != null && V.query) {
          const { query: de, variables: ge } = A.body;
          return {
            query: de,
            variables: ge
          };
        }
        if ((K = A.body) != null && K.operations) {
          const { operations: de, map: ge, ...$e } = A.body, Ve = _(
            de
          ) || {};
          if (!Ve.query)
            return null;
          const He = _(ge || "") || {}, at = Ve.variables ? qe(
            Ve.variables,
            He,
            $e
          ) : {};
          return {
            query: Ve.query,
            variables: at
          };
        }
      }
      default:
        return null;
    }
  }
  function dt(A) {
    const V = ze(A);
    if (!V || !V.query)
      return;
    const { query: K, variables: de } = V, ge = ut(K);
    if (ge instanceof Error) {
      const $e = Ee(A);
      throw new Error(
        me.formatMessage(
          `Failed to intercept a GraphQL request to "%s %s": cannot parse query. See the error message from the parser below.

%s`,
          A.method,
          $e,
          ge.message
        )
      );
    }
    return {
      operationType: ge.operationType,
      operationName: ge.operationName,
      variables: de
    };
  }
  function Ce(A) {
    return A < 300 ? "#69AB32" : A < 400 ? "#F0BB4B" : "#E95F5D";
  }
  function Ze() {
    const A = /* @__PURE__ */ new Date();
    return [A.getHours(), A.getMinutes(), A.getSeconds()].map(String).map((V) => V.slice(0, 2)).map((V) => V.padStart(2, "0")).join(":");
  }
  function Ge(A) {
    return {
      ...A,
      body: A.body,
      headers: A.headers.all()
    };
  }
  var ct = Hi();
  function Gt(A) {
    const V = (0, ct.objectToHeaders)(A.headers), K = ke(A.body, V);
    return {
      ...A,
      body: K
    };
  }
  var yt = QK, G = wL(), be = /[\?|#].*$/g;
  function xe(A) {
    return new URL(`/${A}`, "http://localhost").searchParams;
  }
  function Me(A) {
    return A.replace(be, "");
  }
  function et(A) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(A);
  }
  function xt(A, V) {
    if (et(A) || A.startsWith("*"))
      return A;
    const K = V || typeof document < "u" && document.baseURI;
    return K ? decodeURI(new URL(encodeURI(A), K).href) : A;
  }
  function it(A, V) {
    if (A instanceof RegExp)
      return A;
    const K = xt(A, V);
    return Me(K);
  }
  function ht(A) {
    return A.replace(
      /([:a-zA-Z_-]*)(\*{1,2})+/g,
      (V, K, de) => {
        const ge = "(.*)";
        return K ? K.startsWith(":") ? `${K}${de}` : `${K}${ge}` : ge;
      }
    ).replace(/([^\/])(:)(?=\d+)/, "$1\\$2").replace(/^([^\/]+)(:)(?=\/\/)/, "$1\\$2");
  }
  function tn(A, V, K) {
    const de = it(V, K), ge = typeof de == "string" ? ht(de) : de, $e = (0, G.getCleanUrl)(A), Ve = (0, yt.match)(ge, { decode: decodeURIComponent })($e), He = Ve && Ve.params || {};
    return {
      matches: Ve !== !1,
      params: He
    };
  }
  Hi();
  var Ct = Hi();
  function At(...A) {
    return (...V) => A.reduceRight((K, de) => K instanceof Promise ? Promise.resolve(K).then(de) : de(K), V[0]);
  }
  var Kt = {
    status: 200,
    statusText: "OK",
    body: null,
    delay: 0,
    once: !1,
    passthrough: !1
  }, Gr = [];
  function Wr(A, V = Gr) {
    return async (...K) => {
      const de = Object.assign(
        {},
        Kt,
        {
          headers: new Ct.Headers({
            "x-powered-by": "msw"
          })
        },
        A
      ), ge = [
        ...V,
        ...K
      ].filter(Boolean);
      return ge.length > 0 ? At(...ge)(de) : de;
    };
  }
  var Wt = Object.assign(Wr(), {
    once: Wr({ once: !0 }),
    networkError(A) {
      throw new Oe(A);
    }
  }), Dn = /[\/\\]msw[\/\\]src[\/\\](.+)/, Si = /(node_modules)?[\/\\]lib[\/\\](umd|esm|iief|cjs)[\/\\]|^[^\/\\]*$/;
  function El(A) {
    const V = A.stack;
    if (!V)
      return;
    const de = V.split(`
`).slice(1).find(($e) => !(Dn.test($e) || Si.test($e)));
    return de ? de.replace(/\s*at [^()]*\(([^)]+)\)/, "$1").replace(/^@/, "") : void 0;
  }
  function up(A) {
    return A ? typeof A[Symbol.iterator] == "function" : !1;
  }
  var ns = {
    status: h,
    set: g,
    delay: N,
    fetch: T
  }, _i = class {
    constructor(A) {
      this.shouldSkip = !1, this.ctx = A.ctx || ns, this.resolver = A.resolver;
      const V = El(new Error());
      this.info = {
        ...A.info,
        callFrame: V
      };
    }
    parse(A, V) {
      return null;
    }
    test(A, V) {
      return this.predicate(
        A,
        this.parse(A, V),
        V
      );
    }
    getPublicRequest(A, V) {
      return A;
    }
    markAsSkipped(A = !0) {
      this.shouldSkip = A;
    }
    async run(A, V) {
      if (this.shouldSkip)
        return null;
      const K = this.parse(A, V);
      if (!this.predicate(
        A,
        K,
        V
      ))
        return null;
      const ge = this.getPublicRequest(A, K), Ve = await this.wrapResolver(this.resolver)(
        ge,
        Wt,
        this.ctx
      );
      return this.createExecutionResult(
        K,
        ge,
        Ve
      );
    }
    wrapResolver(A) {
      return async (V, K, de) => {
        const ge = this.resolverGenerator || await A(V, K, de);
        if (up(ge)) {
          const { value: $e, done: Ve } = ge[Symbol.iterator]().next(), He = await $e;
          return !He && Ve ? this.resolverGeneratorResult : (this.resolverGenerator || (this.resolverGenerator = ge), this.resolverGeneratorResult = He, He);
        }
        return ge;
      };
    }
    createExecutionResult(A, V, K) {
      return {
        handler: this,
        parsedResult: A || null,
        request: V,
        response: K || null
      };
    }
  }, Ta = /* @__PURE__ */ ((A) => (A.HEAD = "HEAD", A.GET = "GET", A.POST = "POST", A.PUT = "PUT", A.PATCH = "PATCH", A.OPTIONS = "OPTIONS", A.DELETE = "DELETE", A))(Ta || {}), kl = {
    ...ns,
    cookie: v,
    body: S,
    text: $,
    json: w,
    xml: P
  }, Tl = class extends we {
    constructor(A, V) {
      super(A.url, {
        ...A,
        body: A._body
      }), this.params = V, this.id = A.id;
    }
  }, x0 = class extends _i {
    constructor(A, V, K) {
      super({
        info: {
          header: `${A} ${V}`,
          path: V,
          method: A
        },
        ctx: kl,
        resolver: K
      }), this.checkRedundantQueryParameters();
    }
    checkRedundantQueryParameters() {
      const { method: A, path: V } = this.info;
      if (V instanceof RegExp || Me(V) === V)
        return;
      xe(V).forEach((ge, $e) => {
      }), me.warn(
        `Found a redundant usage of query parameters in the request handler URL for "${A} ${V}". Please match against a path instead and access query parameters in the response resolver function using "req.url.searchParams".`
      );
    }
    parse(A, V) {
      return tn(
        A.url,
        this.info.path,
        V?.baseUrl
      );
    }
    getPublicRequest(A, V) {
      return new Tl(A, V.params || {});
    }
    predicate(A, V) {
      return (this.info.method instanceof RegExp ? this.info.method.test(A.method) : Ae(this.info.method, A.method)) && V.matches;
    }
    log(A, V) {
      const K = Ee(A), de = Ge(A), ge = Gt(V), $e = Ce(V.status);
      console.groupCollapsed(
        me.formatMessage("%s %s %s (%c%s%c)"),
        Ze(),
        A.method,
        K,
        `color:${$e}`,
        `${V.status} ${V.statusText}`,
        "color:inherit"
      ), console.log("Request", de), console.log("Handler:", this), console.log("Response", ge), console.groupEnd();
    }
  }, cp = ta(), G3 = (A, V) => (K) => {
    W3(A);
    const de = _(K.body) || {}, ge = y(de, { [A]: V });
    return w(ge)(K);
  };
  function W3(A) {
    (0, cp.invariant)(
      A.trim() !== "",
      me.formatMessage(
        "Failed to set a custom field on a GraphQL response: field name cannot be empty."
      )
    ), (0, cp.invariant)(
      A !== "data",
      me.formatMessage(
        'Failed to set a custom "%s" field on a mocked GraphQL response: forbidden field name. Did you mean to call "ctx.data()" instead?',
        A
      )
    ), (0, cp.invariant)(
      A !== "errors",
      me.formatMessage(
        'Failed to set a custom "%s" field on a mocked GraphQL response: forbidden field name. Did you mean to call "ctx.errors()" instead?',
        A
      )
    ), (0, cp.invariant)(
      A !== "extensions",
      me.formatMessage(
        'Failed to set a custom "%s" field on a mocked GraphQL response: forbidden field name. Did you mean to call "ctx.extensions()" instead?',
        A
      )
    );
  }
  function C2(A, V) {
    try {
      return A();
    } catch (K) {
      V?.(K);
    }
  }
  var A2 = {
    ...ns,
    data: E,
    extensions: x,
    errors: q,
    cookie: v,
    field: G3
  };
  function Y3(A) {
    return A == null ? !1 : typeof A == "object" && "kind" in A && "definitions" in A;
  }
  var X3 = class extends we {
    constructor(A, V, K) {
      super(A.url, {
        ...A,
        body: A._body
      }), this.variables = V, this.operationName = K;
    }
  }, fp = class extends _i {
    constructor(A, V, K, de) {
      let ge = V;
      if (Y3(V)) {
        const Ve = Ue(V);
        if (Ve.operationType !== A)
          throw new Error(
            `Failed to create a GraphQL handler: provided a DocumentNode with a mismatched operation type (expected "${A}", but got "${Ve.operationType}").`
          );
        if (!Ve.operationName)
          throw new Error(
            "Failed to create a GraphQL handler: provided a DocumentNode with no operation name."
          );
        ge = Ve.operationName;
      }
      const $e = A === "all" ? `${A} (origin: ${K.toString()})` : `${A} ${ge} (origin: ${K.toString()})`;
      super({
        info: {
          header: $e,
          operationType: A,
          operationName: ge
        },
        ctx: A2,
        resolver: de
      }), this.endpoint = K;
    }
    parse(A) {
      return C2(
        () => dt(A),
        (V) => console.error(V.message)
      );
    }
    getPublicRequest(A, V) {
      var K, de;
      return new X3(
        A,
        (K = V?.variables) != null ? K : {},
        (de = V?.operationName) != null ? de : ""
      );
    }
    predicate(A, V) {
      if (!V)
        return !1;
      if (!V.operationName && this.info.operationType !== "all") {
        const $e = Ee(A);
        return me.warn(`Failed to intercept a GraphQL request at "${A.method} ${$e}": anonymous GraphQL operations are not supported.

Consider naming this operation or using "graphql.operation()" request handler to intercept GraphQL requests regardless of their operation name/type. Read more: https://mswjs.io/docs/api/graphql/operation      `), !1;
      }
      const K = tn(A.url, this.endpoint), de = this.info.operationType === "all" || V.operationType === this.info.operationType, ge = this.info.operationName instanceof RegExp ? this.info.operationName.test(V.operationName || "") : V.operationName === this.info.operationName;
      return K.matches && de && ge;
    }
    log(A, V, K) {
      const de = Ge(A), ge = Gt(V), $e = Ce(V.status), Ve = K?.operationName ? `${K?.operationType} ${K?.operationName}` : `anonymous ${K?.operationType}`;
      console.groupCollapsed(
        me.formatMessage("%s %s (%c%s%c)"),
        Ze(),
        `${Ve}`,
        `color:${$e}`,
        `${V.status} ${V.statusText}`,
        "color:inherit"
      ), console.log("Request:", de), console.log("Handler:", this), console.log("Response:", ge), console.groupEnd();
    }
  }, K3 = 3, Q3 = 4, R2 = 0.5;
  function J3(A) {
    return A.reduce(
      (V, K) => (K instanceof x0 && V.rest.push(K), K instanceof fp && V.graphql.push(K), V),
      {
        rest: [],
        graphql: []
      }
    );
  }
  function Z3() {
    return (A, V) => {
      const { path: K, method: de } = V.info;
      if (K instanceof RegExp || de instanceof RegExp)
        return 1 / 0;
      const $e = Ae(A.method, de) ? R2 : 0, Ve = Ee(A);
      return (0, j.default)(Ve, K) - $e;
    };
  }
  function e5(A) {
    return (V, K) => {
      if (typeof A.operationName > "u")
        return 1 / 0;
      const { operationType: de, operationName: ge } = K.info;
      if (typeof ge != "string")
        return 1 / 0;
      const Ve = A.operationType === de ? R2 : 0;
      return (0, j.default)(A.operationName, ge) - Ve;
    };
  }
  function t5(A, V, K) {
    return V.reduce((ge, $e) => {
      const Ve = K(A, $e);
      return ge.concat([[Ve, $e]]);
    }, []).sort(([ge], [$e]) => ge - $e).filter(([ge]) => ge <= K3).slice(0, Q3).map(([, ge]) => ge);
  }
  function n5(A) {
    return A.length > 1 ? `Did you mean to request one of the following resources instead?

${A.map((V) => `  • ${V.info.header}`).join(`
`)}` : `Did you mean to request "${A[0].info.header}" instead?`;
  }
  function r5(A, V, K = "warn") {
    const de = C2(() => dt(A));
    function ge() {
      const He = J3(V), at = de ? He.graphql : He.rest, _n = t5(
        A,
        at,
        de ? e5(de) : Z3()
      );
      return _n.length > 0 ? n5(_n) : "";
    }
    function $e() {
      const He = Ee(A), at = de ? `${de.operationType} ${de.operationName} (${A.method} ${He})` : `${A.method} ${He}`, _n = ge();
      return [
        "captured a request without a matching request handler:",
        `  • ${at}`,
        _n,
        `If you still wish to intercept this unhandled request, please create a request handler for it.
Read more: https://mswjs.io/docs/getting-started/mocks`
      ].filter(Boolean).join(`

`);
    }
    function Ve(He) {
      const at = $e();
      switch (He) {
        case "error":
          throw me.error("Error: %s", at), new Error(
            me.formatMessage(
              'Cannot bypass a request when using the "error" strategy for the "onUnhandledRequest" option.'
            )
          );
        case "warn": {
          me.warn("Warning: %s", at);
          break;
        }
        case "bypass":
          break;
        default:
          throw new Error(
            me.formatMessage(
              'Failed to react to an unhandled request: unknown strategy "%s". Please provide one of the supported strategies ("bypass", "warn", "error") or a custom callback function as the value of the "onUnhandledRequest" option.',
              He
            )
          );
      }
    }
    if (typeof K == "function") {
      K(A, {
        warning: Ve.bind(null, "warn"),
        error: Ve.bind(null, "error")
      });
      return;
    }
    Ve(K);
  }
  var O2 = XA();
  function i5(A, V) {
    O2.store.add({ ...A, url: A.url.toString() }, V), O2.store.persist();
  }
  async function C0(A, V, K, de, ge) {
    var $e, Ve, He, at, _n, Cr;
    if (de.emit("request:start", A), A.headers.get("x-msw-bypass") === "true") {
      de.emit("request:end", A), ($e = ge?.onPassthroughResponse) == null || $e.call(ge, A);
      return;
    }
    const [Ei, Ca] = await (0, R.until)(() => I(
      A,
      V,
      ge?.resolutionContext
    ));
    if (Ei)
      throw de.emit("unhandledException", Ei, A), Ei;
    const { handler: Bs, response: Li } = Ca;
    if (!Bs) {
      r5(A, V, K.onUnhandledRequest), de.emit("request:unhandled", A), de.emit("request:end", A), (Ve = ge?.onPassthroughResponse) == null || Ve.call(ge, A);
      return;
    }
    if (!Li) {
      me.warn(
        `Expected response resolver to return a mocked response Object, but got %s. The original response is going to be used instead.

  • %s
    %s`,
        Li,
        Bs.info.header,
        Bs.info.callFrame
      ), de.emit("request:end", A), (He = ge?.onPassthroughResponse) == null || He.call(ge, A);
      return;
    }
    if (Li.passthrough) {
      de.emit("request:end", A), (at = ge?.onPassthroughResponse) == null || at.call(ge, A);
      return;
    }
    i5(A, Li), de.emit("request:match", A);
    const Cf = Ca, xl = ((_n = ge?.transformResponse) == null ? void 0 : _n.call(ge, Li)) || Li;
    return (Cr = ge?.onMockedResponse) == null || Cr.call(
      ge,
      xl,
      Cf
    ), de.emit("request:end", A), xl;
  }
  var D2 = Hi();
  async function I2(A) {
    return {
      status: A.status,
      statusText: A.statusText,
      headers: (0, D2.flattenHeadersObject)((0, D2.headersToObject)(A.headers)),
      body: await A.clone().text()
    };
  }
  var o5 = (A, V) => async (K, de) => {
    var ge;
    const $e = new ve(K.ports[0]), Ve = Ie(de.payload);
    try {
      await C0(
        Ve,
        A.requestHandlers,
        V,
        A.emitter,
        {
          transformResponse: s5,
          onPassthroughResponse() {
            $e.postMessage("NOT_FOUND");
          },
          async onMockedResponse(He, { handler: at, publicRequest: _n, parsedRequest: Cr }) {
            if (He.body instanceof ReadableStream)
              throw new Error(
                me.formatMessage(
                  'Failed to construct a mocked response with a "ReadableStream" body: mocked streams are not supported. Follow https://github.com/mswjs/msw/issues/1336 for more details.'
                )
              );
            const Ei = new Response(He.body, He), Ca = Ei.clone(), Bs = await Ei.arrayBuffer(), Li = He.body == null ? null : Bs;
            $e.postMessage(
              "MOCK_RESPONSE",
              {
                ...He,
                body: Li
              },
              [Bs]
            ), V.quiet || A.emitter.once("response:mocked", async () => {
              at.log(
                _n,
                await I2(Ca),
                Cr
              );
            });
          }
        }
      );
    } catch (He) {
      if (He instanceof Oe) {
        $e.postMessage("NETWORK_ERROR", {
          name: He.name,
          message: He.message
        });
        return;
      }
      He instanceof Error && (me.error(
        `Uncaught exception in the request handler for "%s %s":

%s

This exception has been gracefully handled as a 500 response, however, it's strongly recommended to resolve this error, as it indicates a mistake in your code. If you wish to mock an error response, please see this guide: https://mswjs.io/docs/recipes/mocking-error-responses`,
        Ve.method,
        Ve.url,
        (ge = He.stack) != null ? ge : He
      ), $e.postMessage("MOCK_RESPONSE", {
        status: 500,
        statusText: "Request Handler Error",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: He.name,
          message: He.message,
          stack: He.stack
        })
      }));
    }
  };
  function s5(A) {
    return {
      status: A.status,
      statusText: A.statusText,
      headers: A.headers.all(),
      body: A.body,
      delay: A.delay
    };
  }
  async function a5(A, V) {
    A.workerChannel.send("INTEGRITY_CHECK_REQUEST");
    const { payload: K } = await A.events.once(
      "INTEGRITY_CHECK_RESPONSE"
    );
    if (K !== "3d6b9f06410d179a7f7404d4bf4c3c70")
      throw new Error(
        `Currently active Service Worker (${K}) is behind the latest published one (3d6b9f06410d179a7f7404d4bf4c3c70).`
      );
    return V;
  }
  var N2 = sc();
  function l5(A) {
    const V = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.send = function(...de) {
      (0, N2.until)(() => A).then(() => {
        window.XMLHttpRequest.prototype.send = V, this.send(...de);
      });
    };
    const K = window.fetch;
    window.fetch = async (...de) => (await (0, N2.until)(() => A), window.fetch = K, window.fetch(...de));
  }
  function u5(A) {
    return (V, K) => {
      var de;
      const { payload: ge } = K;
      if ((de = ge.type) != null && de.includes("opaque"))
        return;
      const $e = new Response(ge.body || null, ge);
      $e.headers.get("x-powered-by") === "msw" ? A.emitter.emit("response:mocked", $e, ge.requestId) : A.emitter.emit("response:bypass", $e, ge.requestId);
    };
  }
  function c5(A, V) {
    !V?.quiet && !location.href.startsWith(A.scope) && me.warn(
      `Cannot intercept requests on this page because it's outside of the worker's scope ("${A.scope}"). If you wish to mock API requests on this page, you must resolve this scope issue.

- (Recommended) Register the worker at the root level ("/") of your application.
- Set the "Service-Worker-Allowed" response header to allow out-of-scope workers.`
    );
  }
  var f5 = (A) => function(K, de) {
    const $e = (async () => {
      A.events.removeAllListeners(), A.workerChannel.on(
        "REQUEST",
        o5(A, K)
      ), A.workerChannel.on("RESPONSE", u5(A));
      const Ve = await ee(
        K.serviceWorker.url,
        K.serviceWorker.options,
        K.findWorker
      ), [He, at] = Ve;
      if (!He) {
        const Cr = de?.findWorker ? me.formatMessage(
          `Failed to locate the Service Worker registration using a custom "findWorker" predicate.

Please ensure that the custom predicate properly locates the Service Worker registration at "%s".
More details: https://mswjs.io/docs/api/setup-worker/start#findworker
`,
          K.serviceWorker.url
        ) : me.formatMessage(
          `Failed to locate the Service Worker registration.

This most likely means that the worker script URL "%s" cannot resolve against the actual public hostname (%s). This may happen if your application runs behind a proxy, or has a dynamic hostname.

Please consider using a custom "serviceWorker.url" option to point to the actual worker script location, or a custom "findWorker" option to resolve the Service Worker registration manually. More details: https://mswjs.io/docs/api/setup-worker/start`,
          K.serviceWorker.url,
          location.host
        );
        throw new Error(Cr);
      }
      A.worker = He, A.registration = at, A.events.addListener(window, "beforeunload", () => {
        He.state !== "redundant" && A.workerChannel.send("CLIENT_CLOSED"), window.clearInterval(A.keepAliveInterval);
      });
      const [_n] = await (0, ae.until)(
        () => a5(A, He)
      );
      return _n && me.error(`Detected outdated Service Worker: ${_n.message}

The mocking is still enabled, but it's highly recommended that you update your Service Worker by running:

$ npx msw init <PUBLIC_DIR>

This is necessary to ensure that the Service Worker is in sync with the library to guarantee its stability.
If this message still persists after updating, please report an issue: https://github.com/open-draft/msw/issues      `), A.keepAliveInterval = window.setInterval(
        () => A.workerChannel.send("KEEPALIVE_REQUEST"),
        5e3
      ), c5(at, A.startOptions), at;
    })().then(
      async (Ve) => {
        const He = Ve.installing || Ve.waiting;
        return He && await new Promise((at) => {
          He.addEventListener("statechange", () => {
            if (He.state === "activated")
              return at();
          });
        }), await Te(A, K).catch((at) => {
          throw new Error(`Failed to enable mocking: ${at?.message}`);
        }), Ve;
      }
    );
    return K.waitUntilReady && l5($e), $e;
  };
  function P2(A = {}) {
    A.quiet || console.log(
      `%c${me.formatMessage("Mocking disabled.")}`,
      "color:orangered;font-weight:bold;"
    );
  }
  var d5 = (A) => function() {
    var K;
    if (!A.isMockingEnabled) {
      me.warn(
        'Found a redundant "worker.stop()" call. Note that stopping the worker while mocking already stopped has no effect. Consider removing this "worker.stop()" call.'
      );
      return;
    }
    A.workerChannel.send("MOCK_DEACTIVATE"), A.isMockingEnabled = !1, window.clearInterval(A.keepAliveInterval), P2({ quiet: (K = A.startOptions) == null ? void 0 : K.quiet });
  }, h5 = {
    serviceWorker: {
      url: "/mockServiceWorker.js",
      options: null
    },
    quiet: !1,
    waitUntilReady: !0,
    onUnhandledRequest: "warn",
    findWorker(A, V) {
      return A === V;
    }
  }, p5 = Pb(), g5 = JK(), m5 = lQ();
  function y5(A) {
    return new Response(A.body, {
      status: A.status,
      statusText: A.statusText,
      headers: A.headers
    });
  }
  function v5(A, V) {
    const K = new p5.BatchInterceptor({
      name: "fallback",
      interceptors: [new g5.FetchInterceptor(), new m5.XMLHttpRequestInterceptor()]
    });
    return K.on("request", async (de) => {
      const ge = new we(de.url, {
        ...de,
        body: await de.arrayBuffer()
      }), $e = await C0(
        ge,
        A.requestHandlers,
        V,
        A.emitter,
        {
          transformResponse(Ve) {
            return {
              status: Ve.status,
              statusText: Ve.statusText,
              headers: Ve.headers.all(),
              body: Ve.body,
              delay: Ve.delay
            };
          },
          onMockedResponse(Ve, { handler: He, publicRequest: at, parsedRequest: _n }) {
            V.quiet || A.emitter.once("response:mocked", async (Cr) => {
              He.log(
                at,
                await I2(Cr),
                _n
              );
            });
          }
        }
      );
      $e && de.respondWith($e);
    }), K.on("response", (de, ge) => {
      if (!de.id)
        return;
      const $e = y5(ge);
      ge.headers.get("x-powered-by") === "msw" ? A.emitter.emit("response:mocked", $e, de.id) : A.emitter.emit("response:bypass", $e, de.id);
    }), K.apply(), K;
  }
  function b5(A) {
    return async function(K) {
      A.fallbackInterceptor = v5(
        A,
        K
      ), Ye({
        message: "Mocking enabled (fallback mode).",
        quiet: K.quiet
      });
    };
  }
  function w5(A) {
    return function() {
      var K, de;
      (K = A.fallbackInterceptor) == null || K.dispose(), P2({ quiet: (de = A.startOptions) == null ? void 0 : de.quiet });
    };
  }
  var S5 = ta(), $2 = cQ();
  function _5(A, V) {
    const K = A.emit;
    K._isPiped || (A.emit = function(de, ...ge) {
      return V.emit(de, ...ge), K.call(this, de, ...ge);
    }, A.emit._isPiped = !0);
  }
  function M2(A) {
    const V = [...A];
    return Object.freeze(V), V;
  }
  var F2 = class {
    constructor(...A) {
      this.validateHandlers(...A), this.initialHandlers = M2(A), this.currentHandlers = [...A], this.emitter = new $2.Emitter(), this.publicEmitter = new $2.Emitter(), _5(this.emitter, this.publicEmitter), this.events = this.createLifeCycleEvents();
    }
    validateHandlers(...A) {
      for (const V of A)
        (0, S5.invariant)(
          !Array.isArray(V),
          me.formatMessage(
            'Failed to construct "%s" given an Array of request handlers. Make sure you spread the request handlers when calling the respective setup function.'
          ),
          this.constructor.name
        );
    }
    dispose() {
      this.emitter.removeAllListeners(), this.publicEmitter.removeAllListeners();
    }
    use(...A) {
      this.currentHandlers.unshift(...A);
    }
    restoreHandlers() {
      this.currentHandlers.forEach((A) => {
        A.markAsSkipped(!1);
      });
    }
    resetHandlers(...A) {
      this.currentHandlers = A.length > 0 ? [...A] : [...this.initialHandlers];
    }
    listHandlers() {
      return M2(this.currentHandlers);
    }
    createLifeCycleEvents() {
      return {
        on: (...A) => this.publicEmitter.on(...A),
        removeListener: (...A) => this.publicEmitter.removeListener(...A),
        removeAllListeners: (...A) => this.publicEmitter.removeAllListeners(...A)
      };
    }
  }, L2 = class extends F2 {
    constructor(...A) {
      super(...A), this.startHandler = null, this.stopHandler = null, (0, re.invariant)(
        !(0, se.isNodeProcess)(),
        me.formatMessage(
          "Failed to execute `setupWorker` in a non-browser environment. Consider using `setupServer` for Node.js environment instead."
        )
      ), this.listeners = [], this.context = this.createWorkerContext();
    }
    createWorkerContext() {
      const A = {
        isMockingEnabled: !1,
        startOptions: null,
        worker: null,
        registration: null,
        requestHandlers: this.currentHandlers,
        emitter: this.emitter,
        workerChannel: {
          on: (V, K) => {
            this.context.events.addListener(
              navigator.serviceWorker,
              "message",
              (de) => {
                if (de.source !== this.context.worker)
                  return;
                const ge = de.data;
                ge && ge.type === V && K(de, ge);
              }
            );
          },
          send: (V) => {
            var K;
            (K = this.context.worker) == null || K.postMessage(V);
          }
        },
        events: {
          addListener: (V, K, de) => (V.addEventListener(K, de), this.listeners.push({ eventType: K, target: V, callback: de }), () => {
            V.removeEventListener(K, de);
          }),
          removeAllListeners: () => {
            for (const { target: V, eventType: K, callback: de } of this.listeners)
              V.removeEventListener(K, de);
            this.listeners = [];
          },
          once: (V) => {
            const K = [];
            return new Promise((de, ge) => {
              const $e = (Ve) => {
                try {
                  const He = Ve.data;
                  He.type === V && de(He);
                } catch (He) {
                  ge(He);
                }
              };
              K.push(
                this.context.events.addListener(
                  navigator.serviceWorker,
                  "message",
                  $e
                ),
                this.context.events.addListener(
                  navigator.serviceWorker,
                  "messageerror",
                  ge
                )
              );
            }).finally(() => {
              K.forEach((de) => de());
            });
          }
        },
        useFallbackMode: !("serviceWorker" in navigator) || location.protocol === "file:"
      };
      return Object.defineProperties(A, {
        requestHandlers: {
          get: () => this.currentHandlers
        }
      }), this.startHandler = A.useFallbackMode ? b5(A) : f5(A), this.stopHandler = A.useFallbackMode ? w5(A) : d5(A), A;
    }
    async start(A = {}) {
      return this.context.startOptions = y(
        h5,
        A
      ), await this.startHandler(this.context.startOptions, A);
    }
    printHandlers() {
      this.listHandlers().forEach((V) => {
        const { header: K, callFrame: de } = V.info, ge = V.info.hasOwnProperty("operationType") ? "[graphql]" : "[rest]";
        console.groupCollapsed(`${ge} ${K}`), de && console.log(`Declaration: ${de}`), console.log("Handler:", V), console.groupEnd();
      });
    }
    stop() {
      super.dispose(), this.context.events.removeAllListeners(), this.context.emitter.removeAllListeners(), this.stopHandler();
    }
  };
  function E5(...A) {
    return new L2(...A);
  }
  function xa(A) {
    return (V, K) => new x0(A, V, K);
  }
  var k5 = {
    all: xa(/.+/),
    head: xa(
      "HEAD"
      /* HEAD */
    ),
    get: xa(
      "GET"
      /* GET */
    ),
    post: xa(
      "POST"
      /* POST */
    ),
    put: xa(
      "PUT"
      /* PUT */
    ),
    delete: xa(
      "DELETE"
      /* DELETE */
    ),
    patch: xa(
      "PATCH"
      /* PATCH */
    ),
    options: xa(
      "OPTIONS"
      /* OPTIONS */
    )
  };
  function dp(A, V) {
    return (K, de) => new fp(
      A,
      K,
      V,
      de
    );
  }
  function B2(A) {
    return (V) => new fp(
      "all",
      new RegExp(".*"),
      A,
      V
    );
  }
  var T5 = {
    operation: B2("*"),
    query: dp("query", "*"),
    mutation: dp("mutation", "*")
  };
  function x5(A) {
    return {
      operation: B2(A),
      query: dp("query", A),
      mutation: dp("mutation", A)
    };
  }
  var C5 = {
    ...T5,
    link: x5
  };
  return oe(), Fb;
}
var Nn = /* @__PURE__ */ fQ();
typeof process < "u" && process.env.STAGING;
Nn.graphql.query("GetFile", (t, e, n) => {
  const r = {
    getFile: {
      ...uS.files[0],
      __typename: "QpFile"
    }
  };
  return e(n.data(r));
}), Nn.graphql.query("GetFiles", (t, e, n) => {
  const r = {
    getFiles: {
      files: uS.files
    }
  };
  return e(n.data(r));
}), Nn.graphql.query("GetFilter", (t, e, n) => {
  const r = {
    getFilter: Zh
  };
  return e(n.data(r));
}), Nn.graphql.query("GetFont", (t, e, n) => {
  const r = {
    getFont: {
      fontData: "font",
      fontName: "testFont"
    }
  };
  return e(n.data(r));
}), Nn.graphql.query("GetStack", (t, e, n) => {
  const r = zX;
  return e(n.data(r));
}), Nn.graphql.query("GetStackCfKeys", (t, e, n) => {
  const r = jX;
  return e(n.data(r));
}), Nn.graphql.query("GetStackIsPublished", (t, e, n) => {
  const r = {
    getStackIsPublished: !0
  };
  return e(n.data(r));
}), Nn.graphql.mutation("PublishStack", async (t, e, n) => {
  const r = {
    publishStack: {
      success: !0
    }
  };
  return e(n.data(r));
}), Nn.graphql.mutation("RenameStack", (t, e, n) => {
  const r = {
    renameStack: {
      success: !0
    }
  };
  return e(n.data(r));
}), Nn.graphql.mutation("UpdateStack", (t, e, n) => {
  const r = {
    updateStack: {
      success: !0
    }
  };
  return e(n.data(r));
}), Nn.graphql.query("ViewFile", (t, e, n) => {
  const r = {
    viewFile: HX
  };
  return e(n.data(r));
}), Nn.graphql.mutation("UnPublishStack", (t, e, n) => {
  const r = {
    unPublishStack: {
      success: !0
    }
  };
  return e(n.data(r));
}), Nn.graphql.mutation("UpdateFile", (t, e, n) => {
  const r = {
    success: !0
  };
  return e(n.data(r));
}), Nn.graphql.mutation("WriteFilter", (t, e, n) => {
  const r = {
    success: !0
  };
  return e(n.data(r));
}), Nn.graphql.mutation("WriteUserRecord", (t, e, n) => {
  const r = {
    writeUserRecord: {
      success: !0
    }
  };
  return e(n.data(r));
}), Nn.graphql.query("GetFilterNames", (t, e, n) => {
  const r = GX;
  return e(n.data(r));
}), Nn.graphql.query("ViewStack", (t, e, n) => e(n.data(qX)));
// rest.get("http://testing/gql", (_req, res, ctx) => {
//   console.log("MSW: CatchAll");
//   return res(
//     // Respond with a 200 status code
//     ctx.status(200),
//   );
// }),
Nn.rest.get("https://imagedelivery.net/*", (t, e, n) => e(
  // Respond with a 200 status code
  n.status(200)
)), Nn.rest.get("http://testing/upload-image-url", (t, e, n) => e(n.body("http://cloudflare-test-upload-image-url"))), Nn.rest.post("http://cloudflare-test-upload-image-url/", (t, e, n) => {
  const r = {
    result: {
      filename: "test-cloudflareImage-url"
    }
  };
  return e(n.json(r));
}), Nn.rest.all("http://localhost:9099/*", (t) => t.passthrough()), Nn.rest.all("http://testing/get-font-url", (t, e, n) => e(n.text("font"))), Nn.rest.post("http://testing/getowner", async (t, e, n) => {
  const r = await t.json(), i = {
    success: !0,
    owners: ["testOwner"]
  };
  return r.jwt === pe.tests.jwt && (i.owners = [r.jwt]), e(n.json(i));
}), Nn.rest.post("http://testing/checkowner", async (t, e, n) => {
  const r = await t.json(), i = {
    success: !0,
    reservation: "testReservation"
  };
  return r.owner === pe.tests.jwt && (i.reservation = r.owner), e(n.json(i));
}), Nn.rest.post("http://testing/addowner", async (t, e, n) => {
  const r = await t.json(), i = {
    success: !0
  };
  return r.jwt === pe.tests.jwt && (i.data = {
    owner: r.owner,
    uid: r.jwt,
    reservation: r.reservation
  }), e(n.json(i), n.set("Content-Type", "application/json"));
});
class _c extends Error {
  response;
  request;
  constructor(e, n) {
    const r = `${_c.extractMessage(e)}: ${JSON.stringify({
      response: e,
      request: n
    })}`;
    super(r), Object.setPrototypeOf(this, _c.prototype), this.response = e, this.request = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, _c);
  }
  static extractMessage(e) {
    return e.errors?.[0]?.message ?? `GraphQL Error (Code: ${String(e.status)})`;
  }
}
const mR = (t) => t.toUpperCase(), Lb = (t) => typeof t == "function" ? t() : t, RL = (t, e) => t.map((n, r) => [n, e[r]]), Hu = (t) => {
  let e = {};
  return t instanceof Headers ? e = dQ(t) : Array.isArray(t) ? t.forEach(([n, r]) => {
    n && r !== void 0 && (e[n] = r);
  }) : t && (e = t), e;
}, dQ = (t) => {
  const e = {};
  return t.forEach((n, r) => {
    e[r] = n;
  }), e;
}, hQ = (t) => {
  try {
    const e = t();
    return pQ(e) ? e.catch((n) => yR(n)) : e;
  } catch (e) {
    return yR(e);
  }
}, yR = (t) => t instanceof Error ? t : new Error(String(t)), pQ = (t) => typeof t == "object" && t !== null && "then" in t && typeof t.then == "function" && "catch" in t && typeof t.catch == "function" && "finally" in t && typeof t.finally == "function", WE = (t) => {
  throw new Error(`Unhandled case: ${String(t)}`);
}, um = (t) => typeof t == "object" && t !== null && !Array.isArray(t), gQ = (t, e) => t.documents ? t : {
  documents: t,
  requestHeaders: e,
  signal: void 0
}, mQ = (t, e, n) => t.query ? t : {
  query: t,
  variables: e,
  requestHeaders: n,
  signal: void 0
}, vR = "Accept", cS = "Content-Type", fS = "application/json", OL = "application/graphql-response+json", bR = (t) => t.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), yQ = (t) => {
  const e = t.toLowerCase();
  return e.includes(OL) || e.includes(fS);
}, wR = (t) => {
  try {
    if (Array.isArray(t))
      return {
        _tag: "Batch",
        executionResults: t.map(SR)
      };
    if (um(t))
      return {
        _tag: "Single",
        executionResult: SR(t)
      };
    throw new Error(`Invalid execution result: result is not object or array. 
Got:
${String(t)}`);
  } catch (e) {
    return e;
  }
}, SR = (t) => {
  if (typeof t != "object" || t === null)
    throw new Error("Invalid execution result: result is not object");
  let e, n, r;
  if ("errors" in t) {
    if (!um(t.errors) && !Array.isArray(t.errors))
      throw new Error("Invalid execution result: errors is not plain object OR array");
    e = t.errors;
  }
  if ("data" in t) {
    if (!um(t.data) && t.data !== null)
      throw new Error("Invalid execution result: data is not plain object");
    n = t.data;
  }
  if ("extensions" in t) {
    if (!um(t.extensions))
      throw new Error("Invalid execution result: extensions is not plain object");
    r = t.extensions;
  }
  return {
    data: n,
    errors: e,
    extensions: r
  };
}, vQ = (t) => t._tag === "Batch" ? t.executionResults.some(_R) : _R(t.executionResult), _R = (t) => Array.isArray(t.errors) ? t.errors.length > 0 : !!t.errors, DL = (t) => typeof t == "object" && t !== null && "kind" in t && t.kind === z.OPERATION_DEFINITION, bQ = (t) => {
  let e;
  const n = t.definitions.filter(DL);
  return n.length === 1 && (e = n[0].name?.value), e;
}, wQ = (t) => {
  let e = !1;
  const n = t.definitions.filter(DL);
  return n.length === 1 && (e = n[0].operation === "mutation"), e;
}, Bb = (t, e) => {
  const n = typeof t == "string" ? t : An(t);
  let r = !1, i;
  if (e)
    return { expression: n, isMutation: r, operationName: i };
  const o = hQ(() => typeof t == "string" ? gf(t) : t);
  return o instanceof Error ? { expression: n, isMutation: r, operationName: i } : (i = bQ(o), r = wQ(o), { expression: n, operationName: i, isMutation: r });
}, YE = JSON, jb = async (t) => {
  const e = {
    ...t,
    method: t.request._tag === "Single" ? t.request.document.isMutation ? "POST" : mR(t.method ?? "post") : t.request.hasMutations ? "POST" : mR(t.method ?? "post"),
    fetchOptions: {
      ...t.fetchOptions,
      errorPolicy: t.fetchOptions.errorPolicy ?? "none"
    }
  }, r = await _Q(e.method)(e);
  if (!r.ok)
    return new _c({ status: r.status, headers: r.headers }, {
      query: t.request._tag === "Single" ? t.request.document.expression : t.request.query,
      variables: t.request.variables
    });
  const i = await SQ(r, t.fetchOptions.jsonSerializer ?? YE);
  if (i instanceof Error)
    throw i;
  const o = {
    status: r.status,
    headers: r.headers
  };
  if (vQ(i) && e.fetchOptions.errorPolicy === "none") {
    const s = i._tag === "Batch" ? { ...i.executionResults, ...o } : {
      ...i.executionResult,
      ...o
    };
    return new _c(s, {
      query: t.request._tag === "Single" ? t.request.document.expression : t.request.query,
      variables: t.request.variables
    });
  }
  switch (i._tag) {
    case "Single":
      return {
        ...o,
        ...ER(e)(i.executionResult)
      };
    case "Batch":
      return {
        ...o,
        data: i.executionResults.map(ER(e))
      };
    default:
      WE(i);
  }
}, ER = (t) => (e) => ({
  extensions: e.extensions,
  data: e.data,
  errors: t.fetchOptions.errorPolicy === "all" ? e.errors : void 0
}), SQ = async (t, e) => {
  const n = t.headers.get(cS), r = await t.text();
  return n && yQ(n) ? wR(e.parse(r)) : wR(r);
}, _Q = (t) => async (e) => {
  const n = new Headers(e.headers);
  let r = null, i;
  n.has(vR) || n.set(vR, [OL, fS].join(", ")), t === "POST" ? (i = (e.fetchOptions.jsonSerializer ?? YE).stringify(EQ(e)), typeof i == "string" && !n.has(cS) && n.set(cS, fS)) : r = kQ(e);
  const o = { method: t, headers: n, body: i, ...e.fetchOptions };
  let s = new URL(e.url), a = o;
  if (e.middleware) {
    const u = await Promise.resolve(e.middleware({
      ...o,
      url: e.url,
      operationName: e.request._tag === "Single" ? e.request.document.operationName : void 0,
      variables: e.request.variables
    })), { url: c, ...f } = u;
    s = new URL(c), a = f;
  }
  return r && r.forEach((u, c) => {
    s.searchParams.append(c, u);
  }), await (e.fetch ?? fetch)(s, a);
}, EQ = (t) => {
  switch (t.request._tag) {
    case "Single":
      return {
        query: t.request.document.expression,
        variables: t.request.variables,
        operationName: t.request.document.operationName
      };
    case "Batch":
      return RL(t.request.query, t.request.variables ?? []).map(([e, n]) => ({
        query: e,
        variables: n
      }));
    default:
      throw WE(t.request);
  }
}, kQ = (t) => {
  const e = t.fetchOptions.jsonSerializer ?? YE, n = new URLSearchParams();
  switch (t.request._tag) {
    case "Single":
      return n.append("query", bR(t.request.document.expression)), t.request.variables && n.append("variables", e.stringify(t.request.variables)), t.request.document.operationName && n.append("operationName", t.request.document.operationName), n;
    case "Batch": {
      const r = t.request.variables?.map((s) => e.stringify(s)) ?? [], i = t.request.query.map(bR), o = RL(i, r).map(([s, a]) => ({
        query: s,
        variables: a
      }));
      return n.append("query", e.stringify(o)), n;
    }
    default:
      throw WE(t.request);
  }
};
class XE {
  url;
  requestConfig;
  constructor(e, n = {}) {
    this.url = e, this.requestConfig = n;
  }
  /**
   * Send a GraphQL query to the server.
   */
  rawRequest = async (...e) => {
    const [n, r, i] = e, o = mQ(n, r, i), { headers: s, fetch: a = globalThis.fetch, method: l = "POST", requestMiddleware: u, responseMiddleware: c, excludeOperationName: f, ...d } = this.requestConfig, { url: h } = this;
    o.signal !== void 0 && (d.signal = o.signal);
    const p = Bb(o.query, f), g = await jb({
      url: h,
      request: {
        _tag: "Single",
        document: p,
        variables: o.variables
      },
      headers: {
        ...Hu(Lb(s)),
        ...Hu(o.requestHeaders)
      },
      fetch: a,
      method: l,
      fetchOptions: d,
      middleware: u
    });
    if (c && await c(g, {
      operationName: p.operationName,
      variables: r,
      url: this.url
    }), g instanceof Error)
      throw g;
    return g;
  };
  async request(e, ...n) {
    const [r, i] = n, o = TQ(e, r, i), { headers: s, fetch: a = globalThis.fetch, method: l = "POST", requestMiddleware: u, responseMiddleware: c, excludeOperationName: f, ...d } = this.requestConfig, { url: h } = this;
    o.signal !== void 0 && (d.signal = o.signal);
    const p = Bb(o.document, f), g = await jb({
      url: h,
      request: {
        _tag: "Single",
        document: p,
        variables: o.variables
      },
      headers: {
        ...Hu(Lb(s)),
        ...Hu(o.requestHeaders)
      },
      fetch: a,
      method: l,
      fetchOptions: d,
      middleware: u
    });
    if (c && await c(g, {
      operationName: p.operationName,
      variables: o.variables,
      url: this.url
    }), g instanceof Error)
      throw g;
    return g.data;
  }
  async batchRequests(e, n) {
    const r = gQ(e, n), { headers: i, excludeOperationName: o, ...s } = this.requestConfig;
    r.signal !== void 0 && (s.signal = r.signal);
    const a = r.documents.map(({ document: d }) => Bb(d, o)), l = a.map(({ expression: d }) => d), u = a.some(({ isMutation: d }) => d), c = r.documents.map(({ variables: d }) => d), f = await jb({
      url: this.url,
      request: {
        _tag: "Batch",
        operationName: void 0,
        query: l,
        hasMutations: u,
        variables: c
      },
      headers: {
        ...Hu(Lb(i)),
        ...Hu(r.requestHeaders)
      },
      fetch: this.requestConfig.fetch ?? globalThis.fetch,
      method: this.requestConfig.method || "POST",
      fetchOptions: s,
      middleware: this.requestConfig.requestMiddleware
    });
    if (this.requestConfig.responseMiddleware && await this.requestConfig.responseMiddleware(f, {
      operationName: void 0,
      variables: c,
      url: this.url
    }), f instanceof Error)
      throw f;
    return f.data;
  }
  setHeaders(e) {
    return this.requestConfig.headers = e, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(e, n) {
    const { headers: r } = this.requestConfig;
    return r ? r[e] = n : this.requestConfig.headers = { [e]: n }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(e) {
    return this.url = e, this;
  }
}
const TQ = (t, e, n) => t.document ? t : {
  document: t,
  variables: e,
  requestHeaders: n,
  signal: void 0
};
function xQ(t) {
  return IE.includes(t);
}
function CQ(t) {
  return t = t.trim(), !!OM.some((e) => e === t);
}
function AQ(t) {
  return !!TY.exec(t);
}
function RQ(t, e, n, r) {
  if (t[e].modifier || (t[e].modifier = {
    links: []
  }), XF.find((o) => o === n)) {
    const s = {
      type: n,
      link: r.trim()
    };
    t[e].modifier.links.push(s);
  }
  const i = n;
  return t[e].modifier[i] = r, t;
}
const OQ = (t) => {
  if (!t)
    return [];
  const e = [], n = t.split(`
`);
  let r, i = IE[YF], o = [];
  const s = [];
  let a = 0, l = !1;
  return n.forEach((u, c) => {
    const f = u.match(EY), d = CQ(u);
    let h = !1;
    if (AQ(u) && (l = !l, l && (r = "", o[a] = {
      type: Ym,
      content: r,
      modifier: {},
      lineNumber: c
    })), l && (r = `${r + u}
`, c < n.length - 1))
      return;
    let p;
    if (f?.[2] && (f[1] && (h = !0), p = f[2], r = f[3 + l0.length + NE.length], r = r.replace(p, ""), r = r.trim()), d && (p = u, r = ""), !h && !nS(p) && !hh(p) && !l && u !== Ym) {
      if (u.trim() === "") {
        o[a] = {
          type: "blank:",
          content: "",
          lineNumber: c,
          modifier: {
            links: []
          }
        }, a++;
        return;
      }
      r = u, p = "paragraph:";
    }
    if (p === "===") {
      a = 0, s.push(Array.from(o)), o.length = 0;
      return;
    }
    p === "storyName:" && e.push(r), p === "moveBy:" && xQ(r) && (i = r), (nS(p) || hh(p)) && (o[a] = {
      type: p,
      content: "",
      lineNumber: c
    });
    const g = a - 1 < 0 ? 0 : a - 1;
    if (h) {
      o[g] && p && (p = p.trim(), r = r.trim(), o = RQ(o, g, p, r));
      return;
    }
    o[a].content = r, a++;
  }), s.push(Array.from(o)), oJ("QP", e), sJ("QP", i), iJ("QP", s), s;
}, rp = (t) => ({
  setSelf: e,
  onSet: n
}) => {
  const r = localStorage.getItem(t);
  r != null && e(JSON.parse(r)), n((i, o, s) => {
    s ? localStorage.removeItem(t) : localStorage.setItem(t, JSON.stringify(i));
  });
}, DQ = Tt({
  key: "zoomFactor",
  default: 1
}), KE = Tt({
  key: "VS_ NeuroDivergentColorChoice",
  default: {
    text: "#a97878",
    background: "#EDEB73"
  },
  effects: [rp("ndrcc")]
}), IL = Tt({
  key: "VS_NeuroDivergentFontMultiplier",
  default: 1,
  effects: [rp("ndrFontMultiplier")]
}), g0 = Tt({
  key: "VS_UseNDRColors",
  default: !1,
  effects: [rp("useNdrcc")]
}), IQ = Tt({
  key: "MarkdownNDRToggleState",
  default: !1
}), m0 = Tt({
  key: "VS_NeueroDivergentReader",
  default: !1,
  effects: [rp("ndr")]
}), NQ = Tt({
  key: "VS_PresetColorChoices",
  default: [{
    name: "Catherine's",
    value: {
      text: "#a97878",
      background: "#EDEB73"
    }
  }, {
    name: "Matherine",
    value: {
      text: "#ffffff",
      background: "#78bcf6"
    }
  }, {
    name: "Deep Seek A",
    value: {
      text: "#3D3D3D",
      background: "#FFFFE0"
    }
  }, {
    name: "Deep Seek B",
    value: {
      text: "#000080",
      background: "#FAF8ED"
    }
  }]
});
function QE(t) {
  return t != null;
}
const PQ = Qt({
  key: "VS_AllIDsInPageElementsFamily",
  get: ({
    get: t
  }) => {
    const e = t(Ut);
    return t(wl(e)).map((i) => i.props.atomId);
  }
}), Sa = Qt({
  key: "VS_AllLoaded",
  get: ({
    get: t
  }) => {
    const e = t(PQ), n = t(Ut), r = [];
    for (const i of e) {
      const o = t(tu(Xt(n, i)));
      o !== void 0 && r.push(o);
    }
    return r.length === 0 ? !1 : !r.includes(!1);
  }
}), JE = Qt({
  key: "VS_AudioFileMaps",
  get: ({
    get: t
  }) => {
    const e = t(Lo), n = t(_l(e));
    return n?.audioFiles ? n.audioFiles.filter(QE) : [];
  }
}), ip = Qt({
  key: "VS_ImageMaps",
  get: ({
    get: t
  }) => {
    const e = t(Lo), n = t(_l(e));
    return n?.images ? n.images.filter(QE) : [];
  }
}), ZE = Qt({
  key: "VS_DataFileMaps",
  get: ({
    get: t
  }) => {
    const e = t(Lo), n = t(_l(e));
    return n?.dataFiles ? n.dataFiles.filter(QE) : [];
  }
});
function $Q(t, e) {
  for (const n of t)
    for (const r of n)
      r.type === "background:" && (r.content = e.background), r.modifier && (r.modifier["color:"] && (r.modifier["color:"] = e.text), r.modifier["background:"] && (r.modifier["background:"] = e.background));
}
const Zo = Qt({
  key: "VS_ParsedCodeSelector",
  get: ({
    get: t
  }) => {
    const e = t(Lo), n = t(_l(e)), r = t(g0), i = t(KE);
    if (n?.code) {
      const o = OQ(n.code);
      return r && $Q(o, i), o;
    }
    return [];
  }
});
Qt({
  key: "VS_StackName",
  get: ({
    get: t
  }) => t(er) ? pe.utility.inAuthor : window.location.pathname.split("/")[2]
});
const $u = Qt({
  key: "VS_NumberOfPages",
  get: ({
    get: t
  }) => t(Zo).length
}), Fs = Qt({
  key: "VS_OwnerName",
  get: ({
    get: t
  }) => t(er) ? pe.utility.inAuthor : window.location.pathname.split("/")[1]
}), MQ = Qt({
  key: "VS_StackId",
  get: ({
    get: t
  }) => {
    const e = t(Lo);
    return t(_l(e)).stackId;
  }
});
function FQ({
  entry: t,
  goingTo: e
}) {
  let n = BQ();
  n ? (n.crumbs.push(e), kR(n)) : (n = {
    entry: t,
    crumbs: [e]
  }, kR(n)), LQ(n);
}
function LQ(t) {
  const e = NL();
  if (e)
    e[t.entry] = t, localStorage.setItem(pe.localStorage.QpHistoryLocalStorage, JSON.stringify(e));
  else {
    const n = {};
    n[t.entry] = t, localStorage.setItem(pe.localStorage.QpHistoryLocalStorage, JSON.stringify(n));
  }
}
function NL() {
  const t = localStorage.getItem(pe.localStorage.QpHistoryLocalStorage);
  return t ? JSON.parse(t) : !1;
}
function kR(t) {
  sessionStorage.setItem(pe.localStorage.QpHistorySessionStorage, JSON.stringify(t));
}
function BQ() {
  const t = sessionStorage.getItem(pe.localStorage.QpHistorySessionStorage);
  return t ? JSON.parse(t) : !1;
}
function jQ(t) {
  const e = localStorage.getItem(t);
  return e ? parseInt(e) : !1;
}
function VQ(t, e) {
  localStorage.setItem(t, e.toString());
}
function uy() {
  return uy = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, uy.apply(null, arguments);
}
var ac, e2 = ac || (ac = {});
e2.Pop = "POP";
e2.Push = "PUSH";
e2.Replace = "REPLACE";
var TR = process.env.NODE_ENV !== "production" ? function(t) {
  return Object.freeze(t);
} : function(t) {
  return t;
};
function UQ(t, e) {
  {
    typeof console < "u" && console.warn(e);
    try {
      throw Error(e);
    } catch {
    }
  }
}
function xR(t) {
  t.preventDefault(), t.returnValue = "";
}
function CR() {
  var t = [];
  return { get length() {
    return t.length;
  }, push: function(e) {
    return t.push(e), function() {
      t = t.filter(function(n) {
        return n !== e;
      });
    };
  }, call: function(e) {
    t.forEach(function(n) {
      return n && n(e);
    });
  } };
}
function qQ() {
  return Math.random().toString(36).substr(2, 8);
}
function zQ(t) {
  var e = t.pathname, n = t.search;
  return t = t.hash, (e === void 0 ? "/" : e) + (n === void 0 ? "" : n) + (t === void 0 ? "" : t);
}
function HQ(t) {
  var e = {};
  if (t) {
    var n = t.indexOf("#");
    0 <= n && (e.hash = t.substr(n), t = t.substr(0, n)), n = t.indexOf("?"), 0 <= n && (e.search = t.substr(n), t = t.substr(0, n)), t && (e.pathname = t);
  }
  return e;
}
function GQ(t) {
  function e() {
    var m = l.location, v = u.state || {};
    return [v.idx, TR({ pathname: m.pathname, search: m.search, hash: m.hash, state: v.usr || null, key: v.key || "default" })];
  }
  function n(m) {
    return typeof m == "string" ? m : zQ(m);
  }
  function r(m, v) {
    return v === void 0 && (v = null), TR(uy({}, h, {}, typeof m == "string" ? HQ(m) : m, { state: v, key: qQ() }));
  }
  function i(m) {
    f = m, m = e(), d = m[0], h = m[1], p.call({ action: f, location: h });
  }
  function o(m, v) {
    function S() {
      o(m, v);
    }
    var _ = ac.Push, b = r(m, v);
    if (!g.length || (g.call({
      action: _,
      location: b,
      retry: S
    }), !1)) {
      var y = [{ usr: b.state, key: b.key, idx: d + 1 }, n(b)];
      b = y[0], y = y[1];
      try {
        u.pushState(b, "", y);
      } catch {
        l.location.assign(y);
      }
      i(_);
    }
  }
  function s(m, v) {
    function S() {
      s(m, v);
    }
    var _ = ac.Replace, b = r(m, v);
    g.length && (g.call({ action: _, location: b, retry: S }), 1) || (b = [{ usr: b.state, key: b.key, idx: d }, n(b)], u.replaceState(b[0], "", b[1]), i(_));
  }
  function a(m) {
    u.go(m);
  }
  t === void 0 && (t = {}), t = t.window;
  var l = t === void 0 ? document.defaultView : t, u = l.history, c = null;
  l.addEventListener("popstate", function() {
    if (c) g.call(c), c = null;
    else {
      var m = ac.Pop, v = e(), S = v[0];
      if (v = v[1], g.length) if (S != null) {
        var _ = d - S;
        _ && (c = { action: m, location: v, retry: function() {
          a(-1 * _);
        } }, a(_));
      } else process.env.NODE_ENV !== "production" && UQ(!1, "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
      else i(m);
    }
  });
  var f = ac.Pop;
  t = e();
  var d = t[0], h = t[1], p = CR(), g = CR();
  return d == null && (d = 0, u.replaceState(uy({}, u.state, { idx: d }), "")), { get action() {
    return f;
  }, get location() {
    return h;
  }, createHref: n, push: o, replace: s, go: a, back: function() {
    a(-1);
  }, forward: function() {
    a(1);
  }, listen: function(m) {
    return p.push(m);
  }, block: function(m) {
    var v = g.push(m);
    return g.length === 1 && l.addEventListener("beforeunload", xR), function() {
      v(), g.length || l.removeEventListener("beforeunload", xR);
    };
  } };
}
const WQ = GQ();
function YQ() {
  const t = L(Ut), e = L(Lo), n = L(er), r = L(dy);
  if (!n)
    return lt(() => {
      Da(e, t, r);
    }, [e, t, r]), lt(() => {
      VQ(e, t);
    }, [t, e]), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
function Da(t, e, n) {
  if (!t) return;
  const r = n ? `/${t}/READ/PAGE/${e}` : `/${t}/PAGE/${e}`;
  WQ.replace({
    pathname: r,
    search: ""
  });
}
const XQ = Qt({
  key: "VS_GetPageNumberFromUrl",
  get: ({
    get: t
  }) => {
    if (t(er)) return 1;
    const e = t(Zo);
    for (const [a, l] of e.entries())
      for (const u of l)
        if (u.type === Tu["moveBy:"].keyword && u.content !== "tap") return 1;
    const n = t($u);
    if (n === 1) return 1;
    const r = aL(window.location.pathname);
    let i = r.page ? r.page : 1;
    const o = jQ(r.stackCfKey);
    if (!r.validStackCfKey && r.ownerName)
      return Da(r.ownerName, 1, !1), 1;
    const s = NL();
    if (s && typeof s == "object" && r.stackCfKey in s) {
      const a = s[r.stackCfKey].crumbs, l = a[a.length - 1];
      if (`/${r.stackCfKey}` !== l) {
        if (confirm(`The last time you opened this story you ended up at ${l}. Do you want to go there?`))
          return window.open(l, "_self"), 1;
        delete s[r.stackCfKey], localStorage.setItem(pe.localStorage.QpHistoryLocalStorage, JSON.stringify(s));
      }
    }
    return o === i ? (i > n && (i = n), Da(r.stackCfKey, i, r.read), i) : o ? confirm("Do you want to go to the last page you were reading?") ? (Da(r.stackCfKey, o, r.read), o) : (i > n && (i = n), Da(r.stackCfKey, i, r.read), i) : !o && i && i > 1 ? confirm("Go to the start of the story?") ? (Da(r.stackCfKey, 1, r.read), 1) : (i > n && (i = n), Da(r.stackCfKey, i, r.read), i) : (Da(r.stackCfKey, 1, r.read), 1);
  }
}), t2 = lo({
  key: "pageHasWidescreen",
  default: !1
});
lo({
  key: "VS_ContentIsOverflowingForPage",
  default: !1
});
const Xt = (t, e) => `${t}::${e}`, Sf = Qt({
  key: "VS_IsInPlayWrightTest",
  get: () => !1
}), n2 = Tt({
  key: "VS_StickyHeaderHeight",
  default: 0
}), KQ = Tt({
  key: "VS_StickyFooterHeight",
  default: 0
}), r2 = Tt({
  key: "VS_PageColumns",
  default: 1
}), fn = lo({
  key: "VS_PageElements",
  default: {
    pageIndex: 0,
    atomId: 0,
    key: "0",
    data: {
      background: "unset",
      content: "",
      firstElement: !1,
      id: -1,
      lastElement: !1,
      tapped: !1,
      type: "blank:"
    }
  }
}), tu = lo({
  key: "VS_PageElementIsLoadedFamily",
  default: !1
}), Ut = Tt({
  key: "VS_PageIndex",
  default: XQ
}), QQ = Tt({
  key: "VS_PageScrollPercentage",
  default: 0
}), i2 = Tt({
  key: "VS_PageRows",
  default: 1
}), jt = Tt({
  key: "VS_PageSize",
  default: {
    onePercentHeight: 0,
    onePercentWidth: 0,
    baseFontSize: 10,
    containerX: 0,
    containerY: 0,
    documentHeight: 0,
    documentWidth: 0,
    gridXWidth: 0,
    gridYHeight: 0,
    height: 0,
    landscape: !0,
    width: 0,
    x0: 0,
    y0: 0
  }
}), op = Qt({
  key: "VS_PageSizeWithPaddingSelector",
  get: ({
    get: t
  }) => {
    const e = t(jt), n = t(vi), r = t(bi), i = t(Fo(r)), o = i.paddingBlockStart ? i.paddingBlockStart * e.baseFontSize : 0, s = i.paddingBlockEnd ? i.paddingBlockEnd * e.baseFontSize : 0, a = i.paddingInlineStart ? i.paddingInlineStart * e.baseFontSize : 0, l = i.paddingInlineEnd ? i.paddingInlineEnd * e.baseFontSize : 0;
    let u = e.height - (o + s) / (e.landscape ? 1 : 1.681), c = e.width - (a + l) / (e.landscape ? 1 : 1.681);
    u = u < 0 ? 0 : Math.trunc(u), c = c < 0 ? 0 : Math.trunc(c);
    const f = {
      onePercentHeight: u / 100,
      onePercentWidth: c / 100,
      baseFontSize: e.landscape ? u / 100 : Math.trunc(u / 128),
      containerX: e.containerX,
      containerY: e.containerY,
      gridXWidth: c / 100,
      gridYHeight: u / 100,
      documentHeight: e.documentHeight,
      documentWidth: e.documentWidth,
      height: u,
      landscape: e.landscape,
      width: c,
      x0: e.x0 + a,
      y0: e.y0 + o
    };
    return e.landscape || !e.landscape && n === "scrollCards" ? f : e;
  }
});
Tt({
  key: "VS_PreviousPageIndex",
  default: -1
});
lo({
  key: "VS_PreviouslyRenderedPages",
  default: !1
});
const wl = lo({
  key: "VS_RenderedPageElementsToDisplay ",
  default: []
});
lo({
  key: "VS_StickyHeaderElements",
  default: {
    background: "unset",
    content: "",
    id: -1,
    tapped: !1,
    type: "blank:",
    firstElement: !1,
    lastElement: !1
  }
});
const cy = Tt({
  key: "VS_StickyHeaderElementsToDisplay",
  default: []
}), dS = Tt({
  key: "VS_StickyFooterElementsToDisplay",
  default: []
}), _h = lo({
  key: "VS_TapIdContainers",
  default: [{
    containerTapped: !0,
    ids: []
  }]
});
Qt({
  key: "VS_BottomIndexElements",
  get: ({
    get: t
  }) => {
    const e = t(JQ);
    return wl(e);
  }
});
const JQ = Qt({
  key: "VS_BottomPageIndex",
  get: ({
    get: t
  }) => {
    const e = t(Ut) + 1, n = t($u);
    return e > n ? n : e;
  }
});
Qt({
  key: "VS_TopElements",
  get: ({
    get: t
  }) => {
    const e = t(eJ);
    return wl(e);
  }
});
const ZQ = window.__SSR_DATA?.navigationType ? window.__SSR_DATA.navigationType : IE[YF], vi = Tt({
  key: "VS_NavigationType",
  //@ts-expect-error
  default: ZQ
}), eJ = Qt({
  key: "VS_TopPageIndex",
  get: ({
    get: t
  }) => t(Ut)
}), tJ = Qt({
  key: "VS_RightIndexElements",
  get: ({
    get: t
  }) => {
    const e = t(PL);
    return wl(e);
  }
}), PL = Qt({
  key: "VS_RightPageIndex",
  get: ({
    get: t
  }) => {
    const e = t(Ut), n = t($u), r = t(gi), o = e + (r === "forward" || r === "init" ? 0 : 1);
    return o > n ? n : o;
  }
}), nJ = Qt({
  key: "VS_LeftElements",
  get: ({
    get: t
  }) => {
    const e = t($L);
    return wl(e);
  }
}), $L = Qt({
  key: "VS_LeftPageIndex",
  get: ({
    get: t
  }) => {
    const e = t(gi), n = e === "forward" || e === "init" ? -1 : 0, r = t(Ut) + n;
    return r < 1 ? 1 : r;
  }
}), AR = (() => {
  try {
    return new BroadcastChannel(pe.broadcastChannel.author);
  } catch {
    return !1;
  }
})();
function hl({
  type: t,
  action: e,
  payload: n,
  hostId: r
}) {
  if (AR) {
    const i = {
      hostId: r,
      type: t,
      action: e,
      payload: n || void 0
    };
    AR.postMessage(i);
  }
}
function rJ(t, e) {
  hl({
    hostId: "all",
    type: t,
    action: pe.messages.setFilterColors,
    payload: e
  });
}
function iJ(t, e) {
  hl({
    hostId: pe.broadcastChannel.allAuthors,
    type: t,
    action: pe.messages.parsedStack,
    // @ts-ignore
    payload: e
  });
}
function oJ(t, e) {
  hl({
    hostId: pe.broadcastChannel.allAuthors,
    type: t,
    action: pe.messages.setStoryNames,
    payload: e
  });
}
function sJ(t, e) {
  hl({
    hostId: pe.broadcastChannel.allAuthors,
    type: t,
    action: pe.messages.setNavigationType,
    payload: e
  });
}
function aJ(t) {
  hl({
    hostId: pe.broadcastChannel.allAuthors,
    type: t,
    action: pe.messages.requestFilterNames
  });
}
function lJ(t) {
  hl({
    hostId: pe.broadcastChannel.allAuthors,
    type: t,
    action: pe.messages.filtersAreLoaded
  });
}
function uJ() {
  const t = un(cne), e = L(Lo), n = un(_l(e)), r = un(Ea), i = un(Ut), o = un(ap), s = un(dy), a = L(zn), l = un(t3), u = L(Fi), c = L(vi);
  lt(() => {
    const f = new BroadcastChannel(pe.broadcastChannel.viewer);
    f.onmessage = (h) => {
      d(h);
    };
    const d = (h) => {
      const p = h.data;
      if (p.hostId === u) {
        if (p.action && p.action === pe.messages.edit && typeof p.payload != "number") {
          r(!0);
          const g = p.payload;
          n(g);
        }
        if (p.action && p.action === pe.messages.exitPresentationMode && o(!1), p.action && p.action === pe.messages.injectFilter && p.payload && typeof p.payload != "number") {
          const g = p.payload;
          t(g);
        }
        if (p.action && p.action === pe.messages.preview && r(!1), p.action && p.action === pe.messages.presentationMode && (a || (console.log(p), r(!1), o(!0))), p.action && p.action === pe.messages.unPreview && r(!0), p.action && p.action === pe.messages.enterReadMode && s(!0), p.action && p.action === pe.messages.exitReadMode && s(!1), p.action && p.action === pe.messages.setFilterNames && Array.isArray(p.payload)) {
          const g = p.payload;
          l(g);
        }
        p.type === "preview" && a && p.action && p.action === pe.messages.goToPage && (r(!0), i((g) => p.payload && typeof p.payload == "number" ? p.payload : g)), p.type === "QP" && !a && p.action && p.action === pe.messages.goToPage && (c !== "tap" && document.getElementById(`scroll-trigger-page-${p.payload}`)?.scrollIntoView({
          behavior: "instant",
          block: "start"
        }), i((g) => p.payload && typeof p.payload == "number" ? p.payload : g));
      }
    };
    return () => {
      f.close();
    };
  });
  try {
    BroadcastChannel;
  } catch {
    return console.error("No BroadcastChannel"), /* @__PURE__ */ D.jsx(D.Fragment, {});
  }
  return /* @__PURE__ */ D.jsx(D.Fragment, {});
}
var ML = typeof global == "object" && global && global.Object === Object && global, cJ = typeof self == "object" && self && self.Object === Object && self, es = ML || cJ || Function("return this")(), rf = es.Symbol, FL = Object.prototype, fJ = FL.hasOwnProperty, dJ = FL.toString, od = rf ? rf.toStringTag : void 0;
function hJ(t) {
  var e = fJ.call(t, od), n = t[od];
  try {
    t[od] = void 0;
    var r = !0;
  } catch {
  }
  var i = dJ.call(t);
  return r && (e ? t[od] = n : delete t[od]), i;
}
var pJ = Object.prototype, gJ = pJ.toString;
function mJ(t) {
  return gJ.call(t);
}
var yJ = "[object Null]", vJ = "[object Undefined]", RR = rf ? rf.toStringTag : void 0;
function _f(t) {
  return t == null ? t === void 0 ? vJ : yJ : RR && RR in Object(t) ? hJ(t) : mJ(t);
}
function Ef(t) {
  return t != null && typeof t == "object";
}
var bJ = "[object Symbol]";
function wJ(t) {
  return typeof t == "symbol" || Ef(t) && _f(t) == bJ;
}
var o2 = Array.isArray, SJ = /\s/;
function _J(t) {
  for (var e = t.length; e-- && SJ.test(t.charAt(e)); )
    ;
  return e;
}
var EJ = /^\s+/;
function kJ(t) {
  return t && t.slice(0, _J(t) + 1).replace(EJ, "");
}
function pl(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var OR = NaN, TJ = /^[-+]0x[0-9a-f]+$/i, xJ = /^0b[01]+$/i, CJ = /^0o[0-7]+$/i, AJ = parseInt;
function DR(t) {
  if (typeof t == "number")
    return t;
  if (wJ(t))
    return OR;
  if (pl(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = pl(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = kJ(t);
  var n = xJ.test(t);
  return n || CJ.test(t) ? AJ(t.slice(2), n ? 2 : 8) : TJ.test(t) ? OR : +t;
}
var RJ = "[object AsyncFunction]", OJ = "[object Function]", DJ = "[object GeneratorFunction]", IJ = "[object Proxy]";
function LL(t) {
  if (!pl(t))
    return !1;
  var e = _f(t);
  return e == OJ || e == DJ || e == RJ || e == IJ;
}
var Vb = es["__core-js_shared__"], IR = function() {
  var t = /[^.]+$/.exec(Vb && Vb.keys && Vb.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function NJ(t) {
  return !!IR && IR in t;
}
var PJ = Function.prototype, $J = PJ.toString;
function Mu(t) {
  if (t != null) {
    try {
      return $J.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var MJ = /[\\^$.*+?()[\]{}|]/g, FJ = /^\[object .+?Constructor\]$/, LJ = Function.prototype, BJ = Object.prototype, jJ = LJ.toString, VJ = BJ.hasOwnProperty, UJ = RegExp(
  "^" + jJ.call(VJ).replace(MJ, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function qJ(t) {
  if (!pl(t) || NJ(t))
    return !1;
  var e = LL(t) ? UJ : FJ;
  return e.test(Mu(t));
}
function zJ(t, e) {
  return t?.[e];
}
function Fu(t, e) {
  var n = zJ(t, e);
  return qJ(n) ? n : void 0;
}
var hS = Fu(es, "WeakMap"), NR = Object.create, HJ = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!pl(e))
      return {};
    if (NR)
      return NR(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), PR = function() {
  try {
    var t = Fu(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
function GJ(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var WJ = 9007199254740991, YJ = /^(?:0|[1-9]\d*)$/;
function XJ(t, e) {
  var n = typeof t;
  return e = e ?? WJ, !!e && (n == "number" || n != "symbol" && YJ.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function KJ(t, e, n) {
  e == "__proto__" && PR ? PR(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
function BL(t, e) {
  return t === e || t !== t && e !== e;
}
var QJ = Object.prototype, JJ = QJ.hasOwnProperty;
function ZJ(t, e, n) {
  var r = t[e];
  (!(JJ.call(t, e) && BL(r, n)) || n === void 0 && !(e in t)) && KJ(t, e, n);
}
var eZ = 9007199254740991;
function jL(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= eZ;
}
function tZ(t) {
  return t != null && jL(t.length) && !LL(t);
}
var nZ = Object.prototype;
function VL(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || nZ;
  return t === n;
}
function rZ(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var iZ = "[object Arguments]";
function $R(t) {
  return Ef(t) && _f(t) == iZ;
}
var UL = Object.prototype, oZ = UL.hasOwnProperty, sZ = UL.propertyIsEnumerable, aZ = $R(/* @__PURE__ */ function() {
  return arguments;
}()) ? $R : function(t) {
  return Ef(t) && oZ.call(t, "callee") && !sZ.call(t, "callee");
};
function lZ() {
  return !1;
}
var qL = typeof exports == "object" && exports && !exports.nodeType && exports, MR = qL && typeof module == "object" && module && !module.nodeType && module, uZ = MR && MR.exports === qL, FR = uZ ? es.Buffer : void 0, cZ = FR ? FR.isBuffer : void 0, zL = cZ || lZ, fZ = "[object Arguments]", dZ = "[object Array]", hZ = "[object Boolean]", pZ = "[object Date]", gZ = "[object Error]", mZ = "[object Function]", yZ = "[object Map]", vZ = "[object Number]", bZ = "[object Object]", wZ = "[object RegExp]", SZ = "[object Set]", _Z = "[object String]", EZ = "[object WeakMap]", kZ = "[object ArrayBuffer]", TZ = "[object DataView]", xZ = "[object Float32Array]", CZ = "[object Float64Array]", AZ = "[object Int8Array]", RZ = "[object Int16Array]", OZ = "[object Int32Array]", DZ = "[object Uint8Array]", IZ = "[object Uint8ClampedArray]", NZ = "[object Uint16Array]", PZ = "[object Uint32Array]", Pn = {};
Pn[xZ] = Pn[CZ] = Pn[AZ] = Pn[RZ] = Pn[OZ] = Pn[DZ] = Pn[IZ] = Pn[NZ] = Pn[PZ] = !0;
Pn[fZ] = Pn[dZ] = Pn[kZ] = Pn[hZ] = Pn[TZ] = Pn[pZ] = Pn[gZ] = Pn[mZ] = Pn[yZ] = Pn[vZ] = Pn[bZ] = Pn[wZ] = Pn[SZ] = Pn[_Z] = Pn[EZ] = !1;
function $Z(t) {
  return Ef(t) && jL(t.length) && !!Pn[_f(t)];
}
function s2(t) {
  return function(e) {
    return t(e);
  };
}
var HL = typeof exports == "object" && exports && !exports.nodeType && exports, Qd = HL && typeof module == "object" && module && !module.nodeType && module, MZ = Qd && Qd.exports === HL, Ub = MZ && ML.process, of = function() {
  try {
    var t = Qd && Qd.require && Qd.require("util").types;
    return t || Ub && Ub.binding && Ub.binding("util");
  } catch {
  }
}(), LR = of && of.isTypedArray, FZ = LR ? s2(LR) : $Z, LZ = Object.prototype, BZ = LZ.hasOwnProperty;
function jZ(t, e) {
  var n = o2(t), r = !n && aZ(t), i = !n && !r && zL(t), o = !n && !r && !i && FZ(t), s = n || r || i || o, a = s ? rZ(t.length, String) : [], l = a.length;
  for (var u in t)
    BZ.call(t, u) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    XJ(u, l))) && a.push(u);
  return a;
}
function GL(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var VZ = GL(Object.keys, Object), UZ = Object.prototype, qZ = UZ.hasOwnProperty;
function zZ(t) {
  if (!VL(t))
    return VZ(t);
  var e = [];
  for (var n in Object(t))
    qZ.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function HZ(t) {
  return tZ(t) ? jZ(t) : zZ(t);
}
var Eh = Fu(Object, "create");
function GZ() {
  this.__data__ = Eh ? Eh(null) : {}, this.size = 0;
}
function WZ(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var YZ = "__lodash_hash_undefined__", XZ = Object.prototype, KZ = XZ.hasOwnProperty;
function QZ(t) {
  var e = this.__data__;
  if (Eh) {
    var n = e[t];
    return n === YZ ? void 0 : n;
  }
  return KZ.call(e, t) ? e[t] : void 0;
}
var JZ = Object.prototype, ZZ = JZ.hasOwnProperty;
function eee(t) {
  var e = this.__data__;
  return Eh ? e[t] !== void 0 : ZZ.call(e, t);
}
var tee = "__lodash_hash_undefined__";
function nee(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = Eh && e === void 0 ? tee : e, this;
}
function xu(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
xu.prototype.clear = GZ;
xu.prototype.delete = WZ;
xu.prototype.get = QZ;
xu.prototype.has = eee;
xu.prototype.set = nee;
function ree() {
  this.__data__ = [], this.size = 0;
}
function y0(t, e) {
  for (var n = t.length; n--; )
    if (BL(t[n][0], e))
      return n;
  return -1;
}
var iee = Array.prototype, oee = iee.splice;
function see(t) {
  var e = this.__data__, n = y0(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : oee.call(e, n, 1), --this.size, !0;
}
function aee(t) {
  var e = this.__data__, n = y0(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function lee(t) {
  return y0(this.__data__, t) > -1;
}
function uee(t, e) {
  var n = this.__data__, r = y0(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function _a(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
_a.prototype.clear = ree;
_a.prototype.delete = see;
_a.prototype.get = aee;
_a.prototype.has = lee;
_a.prototype.set = uee;
var kh = Fu(es, "Map");
function cee() {
  this.size = 0, this.__data__ = {
    hash: new xu(),
    map: new (kh || _a)(),
    string: new xu()
  };
}
function fee(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function v0(t, e) {
  var n = t.__data__;
  return fee(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function dee(t) {
  var e = v0(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function hee(t) {
  return v0(this, t).get(t);
}
function pee(t) {
  return v0(this, t).has(t);
}
function gee(t, e) {
  var n = v0(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function kf(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
kf.prototype.clear = cee;
kf.prototype.delete = dee;
kf.prototype.get = hee;
kf.prototype.has = pee;
kf.prototype.set = gee;
function mee(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var yee = GL(Object.getPrototypeOf, Object);
function vee() {
  this.__data__ = new _a(), this.size = 0;
}
function bee(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function wee(t) {
  return this.__data__.get(t);
}
function See(t) {
  return this.__data__.has(t);
}
var _ee = 200;
function Eee(t, e) {
  var n = this.__data__;
  if (n instanceof _a) {
    var r = n.__data__;
    if (!kh || r.length < _ee - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new kf(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function Tf(t) {
  var e = this.__data__ = new _a(t);
  this.size = e.size;
}
Tf.prototype.clear = vee;
Tf.prototype.delete = bee;
Tf.prototype.get = wee;
Tf.prototype.has = See;
Tf.prototype.set = Eee;
var WL = typeof exports == "object" && exports && !exports.nodeType && exports, BR = WL && typeof module == "object" && module && !module.nodeType && module, kee = BR && BR.exports === WL, jR = kee ? es.Buffer : void 0;
jR && jR.allocUnsafe;
function Tee(t, e) {
  return t.slice();
}
function xee(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var s = t[n];
    e(s, n, t) && (o[i++] = s);
  }
  return o;
}
function Cee() {
  return [];
}
var Aee = Object.prototype, Ree = Aee.propertyIsEnumerable, VR = Object.getOwnPropertySymbols, Oee = VR ? function(t) {
  return t == null ? [] : (t = Object(t), xee(VR(t), function(e) {
    return Ree.call(t, e);
  }));
} : Cee;
function Dee(t, e, n) {
  var r = e(t);
  return o2(t) ? r : mee(r, n(t));
}
function Iee(t) {
  return Dee(t, HZ, Oee);
}
var pS = Fu(es, "DataView"), gS = Fu(es, "Promise"), mS = Fu(es, "Set"), UR = "[object Map]", Nee = "[object Object]", qR = "[object Promise]", zR = "[object Set]", HR = "[object WeakMap]", GR = "[object DataView]", Pee = Mu(pS), $ee = Mu(kh), Mee = Mu(gS), Fee = Mu(mS), Lee = Mu(hS), Qs = _f;
(pS && Qs(new pS(new ArrayBuffer(1))) != GR || kh && Qs(new kh()) != UR || gS && Qs(gS.resolve()) != qR || mS && Qs(new mS()) != zR || hS && Qs(new hS()) != HR) && (Qs = function(t) {
  var e = _f(t), n = e == Nee ? t.constructor : void 0, r = n ? Mu(n) : "";
  if (r)
    switch (r) {
      case Pee:
        return GR;
      case $ee:
        return UR;
      case Mee:
        return qR;
      case Fee:
        return zR;
      case Lee:
        return HR;
    }
  return e;
});
var Bee = Object.prototype, jee = Bee.hasOwnProperty;
function Vee(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && jee.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var WR = es.Uint8Array;
function a2(t) {
  var e = new t.constructor(t.byteLength);
  return new WR(e).set(new WR(t)), e;
}
function Uee(t, e) {
  var n = a2(t.buffer);
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var qee = /\w*$/;
function zee(t) {
  var e = new t.constructor(t.source, qee.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var YR = rf ? rf.prototype : void 0, XR = YR ? YR.valueOf : void 0;
function Hee(t) {
  return XR ? Object(XR.call(t)) : {};
}
function Gee(t, e) {
  var n = a2(t.buffer);
  return new t.constructor(n, t.byteOffset, t.length);
}
var Wee = "[object Boolean]", Yee = "[object Date]", Xee = "[object Map]", Kee = "[object Number]", Qee = "[object RegExp]", Jee = "[object Set]", Zee = "[object String]", ete = "[object Symbol]", tte = "[object ArrayBuffer]", nte = "[object DataView]", rte = "[object Float32Array]", ite = "[object Float64Array]", ote = "[object Int8Array]", ste = "[object Int16Array]", ate = "[object Int32Array]", lte = "[object Uint8Array]", ute = "[object Uint8ClampedArray]", cte = "[object Uint16Array]", fte = "[object Uint32Array]";
function dte(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case tte:
      return a2(t);
    case Wee:
    case Yee:
      return new r(+t);
    case nte:
      return Uee(t);
    case rte:
    case ite:
    case ote:
    case ste:
    case ate:
    case lte:
    case ute:
    case cte:
    case fte:
      return Gee(t);
    case Xee:
      return new r();
    case Kee:
    case Zee:
      return new r(t);
    case Qee:
      return zee(t);
    case Jee:
      return new r();
    case ete:
      return Hee(t);
  }
}
function hte(t) {
  return typeof t.constructor == "function" && !VL(t) ? HJ(yee(t)) : {};
}
var pte = "[object Map]";
function gte(t) {
  return Ef(t) && Qs(t) == pte;
}
var KR = of && of.isMap, mte = KR ? s2(KR) : gte, yte = "[object Set]";
function vte(t) {
  return Ef(t) && Qs(t) == yte;
}
var QR = of && of.isSet, bte = QR ? s2(QR) : vte, YL = "[object Arguments]", wte = "[object Array]", Ste = "[object Boolean]", _te = "[object Date]", Ete = "[object Error]", XL = "[object Function]", kte = "[object GeneratorFunction]", Tte = "[object Map]", xte = "[object Number]", KL = "[object Object]", Cte = "[object RegExp]", Ate = "[object Set]", Rte = "[object String]", Ote = "[object Symbol]", Dte = "[object WeakMap]", Ite = "[object ArrayBuffer]", Nte = "[object DataView]", Pte = "[object Float32Array]", $te = "[object Float64Array]", Mte = "[object Int8Array]", Fte = "[object Int16Array]", Lte = "[object Int32Array]", Bte = "[object Uint8Array]", jte = "[object Uint8ClampedArray]", Vte = "[object Uint16Array]", Ute = "[object Uint32Array]", En = {};
En[YL] = En[wte] = En[Ite] = En[Nte] = En[Ste] = En[_te] = En[Pte] = En[$te] = En[Mte] = En[Fte] = En[Lte] = En[Tte] = En[xte] = En[KL] = En[Cte] = En[Ate] = En[Rte] = En[Ote] = En[Bte] = En[jte] = En[Vte] = En[Ute] = !0;
En[Ete] = En[XL] = En[Dte] = !1;
function cm(t, e, n, r, i, o) {
  var s;
  if (s !== void 0)
    return s;
  if (!pl(t))
    return t;
  var a = o2(t);
  if (a)
    s = Vee(t);
  else {
    var l = Qs(t), u = l == XL || l == kte;
    if (zL(t))
      return Tee(t);
    if (l == KL || l == YL || u && !i)
      s = u ? {} : hte(t);
    else {
      if (!En[l])
        return i ? t : {};
      s = dte(t, l);
    }
  }
  o || (o = new Tf());
  var c = o.get(t);
  if (c)
    return c;
  o.set(t, s), bte(t) ? t.forEach(function(h) {
    s.add(cm(h, e, n, h, t, o));
  }) : mte(t) && t.forEach(function(h, p) {
    s.set(p, cm(h, e, n, p, t, o));
  });
  var f = Iee, d = a ? void 0 : f(t);
  return GJ(d || t, function(h, p) {
    d && (p = h, h = t[p]), ZJ(s, p, cm(h, e, n, p, t, o));
  }), s;
}
var qte = 1, zte = 4;
function Cu(t) {
  return cm(t, qte | zte);
}
var qb = function() {
  return es.Date.now();
}, Hte = "Expected a function", Gte = Math.max, Wte = Math.min;
function Yte(t, e, n) {
  var r, i, o, s, a, l, u = 0, c = !1, f = !1, d = !0;
  if (typeof t != "function")
    throw new TypeError(Hte);
  e = DR(e) || 0, pl(n) && (c = !!n.leading, f = "maxWait" in n, o = f ? Gte(DR(n.maxWait) || 0, e) : o, d = "trailing" in n ? !!n.trailing : d);
  function h(w) {
    var E = r, x = i;
    return r = i = void 0, u = w, s = t.apply(x, E), s;
  }
  function p(w) {
    return u = w, a = setTimeout(v, e), c ? h(w) : s;
  }
  function g(w) {
    var E = w - l, x = w - u, k = e - E;
    return f ? Wte(k, o - x) : k;
  }
  function m(w) {
    var E = w - l, x = w - u;
    return l === void 0 || E >= e || E < 0 || f && x >= o;
  }
  function v() {
    var w = qb();
    if (m(w))
      return S(w);
    a = setTimeout(v, g(w));
  }
  function S(w) {
    return a = void 0, d && r ? h(w) : (r = i = void 0, s);
  }
  function _() {
    a !== void 0 && clearTimeout(a), u = 0, r = l = i = a = void 0;
  }
  function b() {
    return a === void 0 ? s : S(qb());
  }
  function y() {
    var w = qb(), E = m(w);
    if (r = arguments, i = this, l = w, E) {
      if (a === void 0)
        return p(l);
      if (f)
        return clearTimeout(a), a = setTimeout(v, e), h(l);
    }
    return a === void 0 && (a = setTimeout(v, e)), s;
  }
  return y.cancel = _, y.flush = b, y;
}
function Xte(t) {
  return t === null;
}
var Kte = "Expected a function";
function fm(t, e, n) {
  var r = !0, i = !0;
  if (typeof t != "function")
    throw new TypeError(Kte);
  return pl(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Yte(t, e, {
    leading: r,
    maxWait: e,
    trailing: i
  });
}
var Qte = "2.0.0-beta.2", sf = "", JR = "?", yS = "function", Ka = "undefined", af = "object", vS = "string", Th = "major", Le = "model", De = "name", Be = "type", We = "vendor", Fe = "version", Ti = "architecture", lc = "console", qt = "mobile", Hn = "tablet", qi = "smarttv", Zu = "wearable", bS = "embedded", ZR = "user-agent", wS = 500, l2 = "brands", Xl = "formFactor", u2 = "fullVersionList", Ec = "platform", c2 = "platformVersion", b0 = "bitness", Sl = "sec-ch-ua", Jte = Sl + "-full-version-list", Zte = Sl + "-arch", ene = Sl + "-" + b0, tne = Sl + "-form-factor", nne = Sl + "-" + qt, rne = Sl + "-" + Le, QL = Sl + "-" + Ec, ine = QL + "-version", JL = [l2, u2, qt, Le, Ec, c2, Ti, Xl, b0], Xi = "browser", na = "cpu", hs = "device", sa = "engine", wo = "os", kc = "result", mg = "Amazon", sd = "Apple", eO = "ASUS", tO = "BlackBerry", yg = "Google", nO = "Huawei", rO = "Lenovo", zb = "LG", dm = "Microsoft", iO = "Motorola", vg = "Samsung", oO = "Sharp", bg = "Sony", Hb = "Xiaomi", Gb = "Zebra", Gu = "Mobile ", Wu = " Browser", wg = "Chrome", one = "Edge", ad = "Firefox", ld = "Opera", sO = "Facebook", aO = "Sogou", SS = "Windows", sne = typeof window !== Ka, xi = sne && window.navigator ? window.navigator : void 0, Fa = xi && xi.userAgentData ? xi.userAgentData : void 0, ane = function(t, e) {
  var n = {};
  for (var r in t)
    n[r] = e[r] && e[r].length % 2 === 0 ? e[r].concat(t[r]) : t[r];
  return n;
}, w0 = function(t) {
  for (var e = {}, n = 0; n < t.length; n++)
    e[t[n].toUpperCase()] = t[n];
  return e;
}, _S = function(t, e) {
  if (typeof t === af && t.length > 0) {
    for (var n in t)
      if (Qa(t[n]) == Qa(e)) return !0;
    return !1;
  }
  return xf(t) ? Qa(e).indexOf(Qa(t)) !== -1 : !1;
}, lO = function(t) {
  for (var e in t)
    return /^(browser|cpu|device|engine|os)$/.test(e);
}, xf = function(t) {
  return typeof t === vS;
}, Wb = function(t) {
  if (t) {
    for (var e = [], n = Au(/\\?\"/g, t).split(","), r = 0; r < n.length; r++)
      if (n[r].indexOf(";") > -1) {
        var i = xh(n[r]).split(";v=");
        e[r] = { brand: i[0], version: i[1] };
      } else
        e[r] = xh(n[r]);
    return e;
  }
}, Qa = function(t) {
  return xf(t) ? t.toLowerCase() : t;
}, Yb = function(t) {
  return xf(t) ? Au(/[^\d\.]/g, t).split(".")[0] : void 0;
}, aa = function(t) {
  for (var e in t) {
    var n = t[e];
    typeof n == af && n.length == 2 ? this[n[0]] = n[1] : this[n] = void 0;
  }
  return this;
}, Au = function(t, e) {
  return xf(e) ? e.replace(t, sf) : e;
}, ud = function(t) {
  return Au(/\\?\"/g, t);
}, xh = function(t, e) {
  if (xf(t))
    return t = Au(/^\s\s*/, t), typeof e === Ka ? t : t.substring(0, wS);
}, uO = function(t, e) {
  if (!(!t || !e))
    for (var n = 0, r, i, o, s, a, l; n < e.length && !a; ) {
      var u = e[n], c = e[n + 1];
      for (r = i = 0; r < u.length && !a && u[r]; )
        if (a = u[r++].exec(t), a)
          for (o = 0; o < c.length; o++)
            l = a[++i], s = c[o], typeof s === af && s.length > 0 ? s.length === 2 ? typeof s[1] == yS ? this[s[0]] = s[1].call(this, l) : this[s[0]] = s[1] : s.length === 3 ? typeof s[1] === yS && !(s[1].exec && s[1].test) ? this[s[0]] = l ? s[1].call(this, l, s[2]) : void 0 : this[s[0]] = l ? l.replace(s[1], s[2]) : void 0 : s.length === 4 && (this[s[0]] = l ? s[3].call(this, l.replace(s[1], s[2])) : void 0) : this[s] = l || void 0;
      n += 2;
    }
}, fy = function(t, e) {
  for (var n in e)
    if (typeof e[n] === af && e[n].length > 0) {
      for (var r = 0; r < e[n].length; r++)
        if (_S(e[n][r], t))
          return n === JR ? void 0 : n;
    } else if (_S(e[n], t))
      return n === JR ? void 0 : n;
  return e.hasOwnProperty("*") ? e["*"] : t;
}, cO = {
  ME: "4.90",
  "NT 3.11": "NT3.51",
  "NT 4.0": "NT4.0",
  2e3: "NT 5.0",
  XP: ["NT 5.1", "NT 5.2"],
  Vista: "NT 6.0",
  7: "NT 6.1",
  8: "NT 6.2",
  "8.1": "NT 6.3",
  10: ["NT 6.4", "NT 10.0"],
  RT: "ARM"
}, fO = {
  embedded: "Automotive",
  mobile: "Mobile",
  tablet: ["Tablet", "EInk"],
  smarttv: "TV",
  wearable: ["VR", "XR", "Watch"],
  "?": ["Desktop", "Unknown"],
  "*": void 0
}, dO = {
  browser: [
    [
      // Most common regardless engine
      /\b(?:crmo|crios)\/([\w\.]+)/i
      // Chrome for Android/iOS
    ],
    [Fe, [De, Gu + "Chrome"]],
    [
      /edg(?:e|ios|a)?\/([\w\.]+)/i
      // Microsoft Edge
    ],
    [Fe, [De, "Edge"]],
    [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
      // Opera
    ],
    [De, Fe],
    [
      /opios[\/ ]+([\w\.]+)/i
      // Opera mini on iphone >= 8.0
    ],
    [Fe, [De, ld + " Mini"]],
    [
      /\bop(?:rg)?x\/([\w\.]+)/i
      // Opera GX
    ],
    [Fe, [De, ld + " GX"]],
    [
      /\bopr\/([\w\.]+)/i
      // Opera Webkit
    ],
    [Fe, [De, ld]],
    [
      // Mixed
      /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
      // Baidu
    ],
    [Fe, [De, "Baidu"]],
    [
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
      // Avant/IEMobile/SlimBrowser
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer
      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo
      /(heytap|ovi)browser\/([\d\.]+)/i,
      // HeyTap/Ovi
      /(weibo)__([\d\.]+)/i
      // Weibo
    ],
    [De, Fe],
    [
      /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
      // UCBrowser
    ],
    [Fe, [De, "UCBrowser"]],
    [
      /microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i,
      /micromessenger\/([\w\.]+)/i
      // WeChat
    ],
    [Fe, [De, "WeChat"]],
    [
      /konqueror\/([\w\.]+)/i
      // Konqueror
    ],
    [Fe, [De, "Konqueror"]],
    [
      /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
      // IE11
    ],
    [Fe, [De, "IE"]],
    [
      /ya(?:search)?browser\/([\w\.]+)/i
      // Yandex
    ],
    [Fe, [De, "Yandex"]],
    [
      /slbrowser\/([\w\.]+)/i
      // Smart Lenovo Browser
    ],
    [Fe, [De, "Smart " + rO + Wu]],
    [
      /(avast|avg)\/([\w\.]+)/i
      // Avast/AVG Secure Browser
    ],
    [[De, /(.+)/, "$1 Secure" + Wu], Fe],
    [
      /\bfocus\/([\w\.]+)/i
      // Firefox Focus
    ],
    [Fe, [De, ad + " Focus"]],
    [
      /\bopt\/([\w\.]+)/i
      // Opera Touch
    ],
    [Fe, [De, ld + " Touch"]],
    [
      /coc_coc\w+\/([\w\.]+)/i
      // Coc Coc Browser
    ],
    [Fe, [De, "Coc Coc"]],
    [
      /dolfin\/([\w\.]+)/i
      // Dolphin
    ],
    [Fe, [De, "Dolphin"]],
    [
      /coast\/([\w\.]+)/i
      // Opera Coast
    ],
    [Fe, [De, ld + " Coast"]],
    [
      /miuibrowser\/([\w\.]+)/i
      // MIUI Browser
    ],
    [Fe, [De, "MIUI" + Wu]],
    [
      /fxios\/([\w\.-]+)/i
      // Firefox for iOS
    ],
    [Fe, [De, Gu + ad]],
    [
      /\bqihu|(qi?ho?o?|360)browser/i
      // 360
    ],
    [[De, "360" + Wu]],
    [
      /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
    ],
    [[De, /(.+)/, "$1" + Wu], Fe],
    [
      // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
      /samsungbrowser\/([\w\.]+)/i
      // Samsung Internet
    ],
    [Fe, [De, vg + " Internet"]],
    [
      /(comodo_dragon)\/([\w\.]+)/i
      // Comodo Dragon
    ],
    [[De, /_/g, " "], Fe],
    [
      /metasr[\/ ]?([\d\.]+)/i
      // Sogou Explorer
    ],
    [Fe, [De, aO + " Explorer"]],
    [
      /(sogou)mo\w+\/([\d\.]+)/i
      // Sogou Mobile
    ],
    [[De, aO + " Mobile"], Fe],
    [
      /(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
      // QQBrowser/2345 Browser
    ],
    [De, Fe],
    [
      /(lbbrowser)/i,
      // LieBao Browser
      /\[(linkedin)app\]/i
      // LinkedIn App for iOS & Android
    ],
    [De],
    [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
      // Facebook App for iOS & Android
    ],
    [[De, sO], Fe],
    [
      /(Klarna)\/([\w\.]+)/i,
      // Klarna Shopping Browser for iOS & Android
      /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
      // Kakao App
      /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
      // Naver InApp
      /safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(alipay)client\/([\w\.]+)/i,
      // Alipay
      /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
      // Chromium/Instagram/Snapchat
    ],
    [De, Fe],
    [
      /\bgsa\/([\w\.]+) .*safari\//i
      // Google Search Appliance on iOS
    ],
    [Fe, [De, "GSA"]],
    [
      /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
      // TikTok
    ],
    [Fe, [De, "TikTok"]],
    [
      /headlesschrome(?:\/([\w\.]+)| )/i
      // Chrome Headless
    ],
    [Fe, [De, wg + " Headless"]],
    [
      / wv\).+(chrome)\/([\w\.]+)/i
      // Chrome WebView
    ],
    [[De, wg + " WebView"], Fe],
    [
      /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
      // Android Browser
    ],
    [Fe, [De, "Android" + Wu]],
    [
      /chrome\/([\w\.]+) mobile/i
      // Chrome Mobile
    ],
    [Fe, [De, Gu + "Chrome"]],
    [
      /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
      // Chrome/OmniWeb/Arora/Tizen/Nokia
    ],
    [De, Fe],
    [
      /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
      // Safari Mobile
    ],
    [Fe, [De, Gu + "Safari"]],
    [
      /iphone .*mobile(?:\/\w+ | ?)safari/i
    ],
    [[De, Gu + "Safari"]],
    [
      /version\/([\w\.\,]+) .*(safari)/i
      // Safari
    ],
    [Fe, De],
    [
      /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
      // Safari < 3.0
    ],
    [De, [Fe, "1"]],
    [
      /(webkit|khtml)\/([\w\.]+)/i
    ],
    [De, Fe],
    [
      // Gecko based
      /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
      // Firefox Mobile
    ],
    [[De, Gu + ad], Fe],
    [
      /(navigator|netscape\d?)\/([-\w\.]+)/i
      // Netscape
    ],
    [[De, "Netscape"], Fe],
    [
      /mobile vr; rv:([\w\.]+)\).+firefox/i
      // Firefox Reality
    ],
    [Fe, [De, ad + " Reality"]],
    [
      /ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla
      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
      /(links) \(([\w\.]+)/i,
      // Links
      /panasonic;(viera)/i
      // Panasonic Viera
    ],
    [De, Fe],
    [
      /(cobalt)\/([\w\.]+)/i
      // Cobalt
    ],
    [De, [Fe, /[^\d\.]+./, sf]]
  ],
  cpu: [
    [
      /\b(?:(amd|x|x86[-_]?|wow|win)64)\b/i
      // AMD64 (x64)
    ],
    [[Ti, "amd64"]],
    [
      /(ia32(?=;))/i,
      // IA32 (quicktime)
      /((?:i[346]|x)86)[;\)]/i
      // IA32 (x86)
    ],
    [[Ti, "ia32"]],
    [
      /\b(aarch64|arm(v?8e?l?|_?64))\b/i
      // ARM64
    ],
    [[Ti, "arm64"]],
    [
      /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
      // ARMHF
    ],
    [[Ti, "armhf"]],
    [
      // PocketPC mistakenly identified as PowerPC
      /windows (ce|mobile); ppc;/i
    ],
    [[Ti, "arm"]],
    [
      /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
      // PowerPC
    ],
    [[Ti, /ower/, sf, Qa]],
    [
      /(sun4\w)[;\)]/i
      // SPARC
    ],
    [[Ti, "sparc"]],
    [
      /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    ],
    [[Ti, Qa]]
  ],
  device: [
    [
      //////////////////////////
      // MOBILES & TABLETS
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
    ],
    [Le, [We, vg], [Be, Hn]],
    [
      /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
      /samsung[- ]([-\w]+)/i,
      /sec-(sgh\w+)/i
    ],
    [Le, [We, vg], [Be, qt]],
    [
      // Apple
      /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
      // iPod/iPhone
    ],
    [Le, [We, sd], [Be, qt]],
    [
      /\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i,
      /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
    ],
    [Le, [We, sd], [Be, Hn]],
    [
      /(macintosh);/i
    ],
    [Le, [We, sd]],
    [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
    ],
    [Le, [We, oO], [Be, qt]],
    [
      // Huawei
      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
    ],
    [Le, [We, nO], [Be, Hn]],
    [
      /(?:huawei|honor)([-\w ]+)[;\)]/i,
      /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
    ],
    [Le, [We, nO], [Be, qt]],
    [
      // Xiaomi
      /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
      // Xiaomi Redmi 'numeric' models
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
      // Xiaomi Mi
    ],
    [[Le, /_/g, " "], [We, Hb], [Be, qt]],
    [
      /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
      // Redmi Pad
      /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
      // Mi Pad tablets
    ],
    [[Le, /_/g, " "], [We, Hb], [Be, Hn]],
    [
      // OPPO
      /; (\w+) bui.+ oppo/i,
      /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
    ],
    [Le, [We, "OPPO"], [Be, qt]],
    [
      // Vivo
      /vivo (\w+)(?: bui|\))/i,
      /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
    ],
    [Le, [We, "Vivo"], [Be, qt]],
    [
      // Realme
      /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
    ],
    [Le, [We, "Realme"], [Be, qt]],
    [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
      /\bmot(?:orola)?[- ](\w*)/i,
      /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
    ],
    [Le, [We, iO], [Be, qt]],
    [
      /\b(mz60\d|xoom[2 ]{0,2}) build\//i
    ],
    [Le, [We, iO], [Be, Hn]],
    [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
    ],
    [Le, [We, zb], [Be, Hn]],
    [
      /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
      /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
      /\blg-?([\d\w]+) bui/i
    ],
    [Le, [We, zb], [Be, qt]],
    [
      // Lenovo
      /(ideatab[-\w ]+)/i,
      /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
    ],
    [Le, [We, rO], [Be, Hn]],
    [
      // Nokia
      /(?:maemo|nokia).*(n900|lumia \d+)/i,
      /nokia[-_ ]?([-\w\.]*)/i
    ],
    [[Le, /_/g, " "], [We, "Nokia"], [Be, qt]],
    [
      // Google
      /(pixel c)\b/i
      // Google Pixel C
    ],
    [Le, [We, yg], [Be, Hn]],
    [
      /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
      // Google Pixel
    ],
    [Le, [We, yg], [Be, qt]],
    [
      // Sony
      /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
    ],
    [Le, [We, bg], [Be, qt]],
    [
      /sony tablet [ps]/i,
      /\b(?:sony)?sgp\w+(?: bui|\))/i
    ],
    [[Le, "Xperia Tablet"], [We, bg], [Be, Hn]],
    [
      // OnePlus
      / (kb2005|in20[12]5|be20[12][59])\b/i,
      /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
    ],
    [Le, [We, "OnePlus"], [Be, qt]],
    [
      // Amazon
      /(alexa)webm/i,
      /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
      // Kindle Fire without Silk / Echo Show
      /(kf[a-z]+)( bui|\)).+silk\//i
      // Kindle Fire HD
    ],
    [Le, [We, mg], [Be, Hn]],
    [
      /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
      // Fire Phone
    ],
    [[Le, /(.+)/g, "Fire Phone $1"], [We, mg], [Be, qt]],
    [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i
      // BlackBerry PlayBook
    ],
    [Le, We, [Be, Hn]],
    [
      /\b((?:bb[a-f]|st[hv])100-\d)/i,
      /\(bb10; (\w+)/i
      // BlackBerry 10
    ],
    [Le, [We, tO], [Be, qt]],
    [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
    ],
    [Le, [We, eO], [Be, Hn]],
    [
      / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
    ],
    [Le, [We, eO], [Be, qt]],
    [
      // HTC
      /(nexus 9)/i
      // HTC Nexus 9
    ],
    [Le, [We, "HTC"], [Be, Hn]],
    [
      /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC
      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
      /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
      // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ],
    [We, [Le, /_/g, " "], [Be, qt]],
    [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
    ],
    [Le, [We, "Acer"], [Be, Hn]],
    [
      // Meizu
      /droid.+; (m[1-5] note) bui/i,
      /\bmz-([-\w]{2,})/i
    ],
    [Le, [We, "Meizu"], [Be, qt]],
    [
      // Ulefone
      /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
    ],
    [Le, [We, "Ulefone"], [Be, qt]],
    [
      // MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(asus)-?(\w+)/i,
      // Asus
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(lenovo)[-_ ]?([-\w]+)/i,
      // Lenovo
      /(jolla)/i,
      // Jolla
      /(oppo) ?([\w ]+) bui/i
      // OPPO
    ],
    [We, Le, [Be, qt]],
    [
      /(kobo)\s(ereader|touch)/i,
      // Kobo
      /(archos) (gamepad2?)/i,
      // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i
      // Kindle
    ],
    [We, Le, [Be, Hn]],
    [
      /(surface duo)/i
      // Surface Duo
    ],
    [Le, [We, dm], [Be, Hn]],
    [
      /droid [\d\.]+; (fp\du?)(?: b|\))/i
      // Fairphone
    ],
    [Le, [We, "Fairphone"], [Be, qt]],
    [
      /(shield[\w ]+) b/i
      // Nvidia Shield Tablets
    ],
    [Le, [We, "Nvidia"], [Be, Hn]],
    [
      /(sprint) (\w+)/i
      // Sprint Phones
    ],
    [We, Le, [Be, qt]],
    [
      /(kin\.[onetw]{3})/i
      // Microsoft Kin
    ],
    [[Le, /\./g, " "], [We, dm], [Be, qt]],
    [
      /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
      // Zebra
    ],
    [Le, [We, Gb], [Be, Hn]],
    [
      /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
    ],
    [Le, [We, Gb], [Be, qt]],
    [
      ///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i
      // Samsung
    ],
    [We, [Be, qi]],
    [
      /hbbtv.+maple;(\d+)/i
    ],
    [[Le, /^/, "SmartTV"], [We, vg], [Be, qi]],
    [
      /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
      // LG SmartTV
    ],
    [[We, zb], [Be, qi]],
    [
      /(apple) ?tv/i
      // Apple TV
    ],
    [We, [Le, sd + " TV"], [Be, qi]],
    [
      /crkey/i
      // Google Chromecast
    ],
    [[Le, wg + "cast"], [We, yg], [Be, qi]],
    [
      /droid.+aft(\w+)( bui|\))/i
      // Fire TV
    ],
    [Le, [We, mg], [Be, qi]],
    [
      /\(dtv[\);].+(aquos)/i,
      /(aquos-tv[\w ]+)\)/i
      // Sharp
    ],
    [Le, [We, oO], [Be, qi]],
    [
      /(bravia[\w ]+)( bui|\))/i
      // Sony
    ],
    [Le, [We, bg], [Be, qi]],
    [
      /(mitv-\w{5}) bui/i
      // Xiaomi
    ],
    [Le, [We, Hb], [Be, qi]],
    [
      /Hbbtv.*(technisat) (.*);/i
      // TechniSAT
    ],
    [We, Le, [Be, qi]],
    [
      /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
      // HbbTV devices
    ],
    [[We, xh], [Le, xh], [Be, qi]],
    [
      /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
      // SmartTV from Unidentified Vendors
    ],
    [[Be, qi]],
    [
      ///////////////////
      // CONSOLES
      ///////////////////
      /(ouya)/i,
      // Ouya
      /(nintendo) (\w+)/i
      // Nintendo
    ],
    [We, Le, [Be, lc]],
    [
      /droid.+; (shield) bui/i
      // Nvidia
    ],
    [Le, [We, "Nvidia"], [Be, lc]],
    [
      /(playstation \w+)/i
      // Playstation
    ],
    [Le, [We, bg], [Be, lc]],
    [
      /\b(xbox(?: one)?(?!; xbox))[\); ]/i
      // Microsoft Xbox
    ],
    [Le, [We, dm], [Be, lc]],
    [
      ///////////////////
      // WEARABLES
      ///////////////////
      /((pebble))app/i
      // Pebble
    ],
    [We, Le, [Be, Zu]],
    [
      /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
      // Apple Watch
    ],
    [Le, [We, sd], [Be, Zu]],
    [
      /droid.+; (glass) \d/i
      // Google Glass
    ],
    [Le, [We, yg], [Be, Zu]],
    [
      /droid.+; (wt63?0{2,3})\)/i
    ],
    [Le, [We, Gb], [Be, Zu]],
    [
      /(quest( 2| pro)?)/i
      // Oculus Quest
    ],
    [Le, [We, sO], [Be, Zu]],
    [
      ///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
      // Tesla
    ],
    [We, [Be, bS]],
    [
      /(aeobc)\b/i
      // Echo Dot
    ],
    [Le, [We, mg], [Be, bS]],
    [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
      // Android Phones from Unidentified Vendors
    ],
    [Le, [Be, qt]],
    [
      /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
      // Android Tablets from Unidentified Vendors
    ],
    [Le, [Be, Hn]],
    [
      /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
      // Unidentifiable Tablet
    ],
    [[Be, Hn]],
    [
      /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
      // Unidentifiable Mobile
    ],
    [[Be, qt]],
    [
      /(android[-\w\. ]{0,9});.+buil/i
      // Generic Android Device
    ],
    [Le, [We, "Generic"]]
  ],
  engine: [
    [
      /windows.+ edge\/([\w\.]+)/i
      // EdgeHTML
    ],
    [Fe, [De, one + "HTML"]],
    [
      /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
      // Blink
    ],
    [Fe, [De, "Blink"]],
    [
      /(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i,
      // iCab
      /\b(libweb)/i
    ],
    [De, Fe],
    [
      /rv\:([\w\.]{1,9})\b.+(gecko)/i
      // Gecko
    ],
    [Fe, De]
  ],
  os: [
    [
      // Windows
      /microsoft (windows) (vista|xp)/i
      // Windows (iTunes)
    ],
    [De, Fe],
    [
      /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
      // Windows Phone
    ],
    [De, [Fe, fy, cO]],
    [
      /windows nt 6\.2; (arm)/i,
      // Windows RT
      /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
      /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
    ],
    [[Fe, fy, cO], [De, SS]],
    [
      // iOS/macOS
      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
      /cfnetwork\/.+darwin/i
    ],
    [[Fe, /_/g, "."], [De, "iOS"]],
    [
      /(mac os x) ?([\w\. ]*)/i,
      /(macintosh|mac_powerpc\b)(?!.+haiku)/i
      // Mac OS
    ],
    [[De, "macOS"], [Fe, /_/g, "."]],
    [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
      // Android-x86/HarmonyOS
    ],
    [Fe, De],
    [
      // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
      /(blackberry)\w*\/([\w\.]*)/i,
      // Blackberry
      /(tizen|kaios)[\/ ]([\w\.]+)/i,
      // Tizen/KaiOS
      /\((series40);/i
      // Series 40
    ],
    [De, Fe],
    [
      /\(bb(10);/i
      // BlackBerry 10
    ],
    [Fe, [De, tO]],
    [
      /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
      // Symbian
    ],
    [Fe, [De, "Symbian"]],
    [
      /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
      // Firefox OS
    ],
    [Fe, [De, ad + " OS"]],
    [
      /web0s;.+rt(tv)/i,
      /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
      // WebOS
    ],
    [Fe, [De, "webOS"]],
    [
      /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
      // watchOS
    ],
    [Fe, [De, "watchOS"]],
    [
      // Google Chromecast
      /crkey\/([\d\.]+)/i
      // Google Chromecast
    ],
    [Fe, [De, wg + "cast"]],
    [
      /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
      // Chromium OS
    ],
    [[De, "Chrome OS"], Fe],
    [
      // Smart TVs
      /panasonic;(viera)/i,
      // Panasonic Viera
      /(netrange)mmh/i,
      // Netrange
      /(nettv)\/(\d+\.[\w\.]+)/i,
      // NetTV
      // Console
      /(nintendo|playstation) (\w+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)
      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /(mint)[\/\(\) ]?(\w*)/i,
      // Mint
      /(mageia|vectorlinux)[; ]/i,
      // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux) ?([\w\.]*)/i,
      // Hurd/Linux
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i
      // Haiku
    ],
    [De, Fe],
    [
      /(sunos) ?([\w\.\d]*)/i
      // Solaris
    ],
    [[De, "Solaris"], Fe],
    [
      /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
      // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
      // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
      /(unix) ?([\w\.]*)/i
      // UNIX
    ],
    [De, Fe]
  ]
}, Sg = function() {
  var t = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} };
  return aa.call(t.init, [
    [Xi, [De, Fe, Th]],
    [na, [Ti]],
    [hs, [Be, Le, We]],
    [sa, [De, Fe]],
    [wo, [De, Fe]]
  ]), aa.call(t.isIgnore, [
    [Xi, [Fe, Th]],
    [sa, [Fe]],
    [wo, [Fe]]
  ]), aa.call(t.isIgnoreRgx, [
    [Xi, / ?browser$/i],
    [wo, / ?os$/i]
  ]), aa.call(t.toString, [
    [Xi, [De, Fe]],
    [na, [Ti]],
    [hs, [We, Le]],
    [sa, [De, Fe]],
    [wo, [De, Fe]]
  ]), t;
}(), lne = function(t, e) {
  var n = Sg.init[e], r = Sg.isIgnore[e] || 0, i = Sg.isIgnoreRgx[e] || 0, o = Sg.toString[e] || 0;
  function s() {
    aa.call(this, n);
  }
  return s.prototype.getItem = function() {
    return t;
  }, s.prototype.withClientHints = function() {
    return Fa ? Fa.getHighEntropyValues(JL).then(function(a) {
      return t.setCH(new ZL(a, !1)).parseCH().get();
    }) : t.parseCH().get();
  }, s.prototype.withFeatureCheck = function() {
    return t.detectFeature().get();
  }, e != kc && (s.prototype.is = function(a) {
    var l = !1;
    for (var u in this)
      if (this.hasOwnProperty(u) && !_S(r, u) && Qa(i ? Au(i, this[u]) : this[u]) == Qa(i ? Au(i, a) : a)) {
        if (l = !0, a != Ka) break;
      } else if (a == Ka && l) {
        l = !l;
        break;
      }
    return l;
  }, s.prototype.toString = function() {
    var a = sf;
    for (var l in o)
      typeof this[o[l]] !== Ka && (a += (a ? " " : sf) + this[o[l]]);
    return a || Ka;
  }), Fa || (s.prototype.then = function(a) {
    var l = this, u = function() {
      for (var f in l)
        l.hasOwnProperty(f) && (this[f] = l[f]);
    };
    u.prototype = {
      is: s.prototype.is,
      toString: s.prototype.toString
    };
    var c = new u();
    return a(c), c;
  }), new s();
};
function ZL(t, e) {
  if (t = t || {}, aa.call(this, JL), e)
    aa.call(this, [
      [l2, Wb(t[Sl])],
      [u2, Wb(t[Jte])],
      [qt, /\?1/.test(t[nne])],
      [Le, ud(t[rne])],
      [Ec, ud(t[QL])],
      [c2, ud(t[ine])],
      [Ti, ud(t[Zte])],
      [Xl, Wb(t[tne])],
      [b0, ud(t[ene])]
    ]);
  else
    for (var n in t)
      this.hasOwnProperty(n) && typeof t[n] !== Ka && (this[n] = t[n]);
}
function hO(t, e, n, r) {
  return this.get = function(i) {
    return i ? this.data.hasOwnProperty(i) ? this.data[i] : void 0 : this.data;
  }, this.set = function(i, o) {
    return this.data[i] = o, this;
  }, this.setCH = function(i) {
    return this.uaCH = i, this;
  }, this.detectFeature = function() {
    if (xi && xi.userAgent == this.ua)
      switch (this.itemType) {
        case Xi:
          xi.brave && typeof xi.brave.isBrave == yS && this.set(De, "Brave");
          break;
        case hs:
          !this.get(Be) && Fa && Fa[qt] && this.set(Be, qt), this.get(Le) == "Macintosh" && xi && typeof xi.standalone !== Ka && xi.maxTouchPoints && xi.maxTouchPoints > 2 && this.set(Le, "iPad").set(Be, Hn);
          break;
        case wo:
          !this.get(De) && Fa && Fa[Ec] && this.set(De, Fa[Ec]);
          break;
        case kc:
          var i = this.data, o = function(s) {
            return i[s].getItem().detectFeature().get();
          };
          this.set(Xi, o(Xi)).set(na, o(na)).set(hs, o(hs)).set(sa, o(sa)).set(wo, o(wo));
      }
    return this;
  }, this.parseUA = function() {
    return this.itemType != kc && uO.call(this.data, this.ua, this.rgxMap), this.itemType == Xi && this.set(Th, Yb(this.get(Fe))), this;
  }, this.parseCH = function() {
    var i = this.uaCH, o = this.rgxMap;
    switch (this.itemType) {
      case Xi:
        var s = i[u2] || i[l2], a;
        if (s)
          for (var l in s) {
            var u = Au(/(Google|Microsoft) /, s[l].brand || s[l]), c = s[l].version;
            !/not.a.brand/i.test(u) && (!a || /chrom/i.test(a) && !/chromi/i.test(u)) && (this.set(De, u).set(Fe, c).set(Th, Yb(c)), a = u);
          }
        break;
      case na:
        var f = i[Ti];
        f && (f && i[b0] == "64" && (f += "64"), uO.call(this.data, f + ";", o));
        break;
      case hs:
        if (i[qt] && this.set(Be, qt), i[Le] && this.set(Le, i[Le]), i[Le] == "Xbox" && this.set(Be, lc).set(We, dm), i[Xl]) {
          var d;
          if (typeof i[Xl] != "string")
            for (var h = 0; !d && h < i[Xl].length; )
              d = fy(i[Xl][h++], fO);
          else
            d = fy(i[Xl], fO);
          this.set(Be, d);
        }
        break;
      case wo:
        var p = i[Ec];
        if (p) {
          var g = i[c2];
          p == SS && (g = parseInt(Yb(g), 10) >= 13 ? "11" : "10"), this.set(De, p).set(Fe, g);
        }
        this.get(De) == SS && i[Le] == "Xbox" && this.set(De, "Xbox").set(Fe, void 0);
        break;
      case kc:
        var m = this.data, v = function(S) {
          return m[S].getItem().setCH(i).parseCH().get();
        };
        this.set(Xi, v(Xi)).set(na, v(na)).set(hs, v(hs)).set(sa, v(sa)).set(wo, v(wo));
    }
    return this;
  }, aa.call(this, [
    ["itemType", t],
    ["ua", e],
    ["uaCH", r],
    ["rgxMap", n],
    ["data", lne(this, t)]
  ]), this;
}
function Ps(t, e, n) {
  if (typeof t === af ? (lO(t) ? (typeof e === af && (n = e), e = t) : (n = t, e = void 0), t = void 0) : typeof t === vS && !lO(e) && (n = e, e = void 0), !(this instanceof Ps))
    return new Ps(t, e, n).getResult();
  var r = typeof t === vS ? t : (
    // Passed user-agent string
    xi && xi.userAgent ? xi.userAgent : (
      // navigator.userAgent
      n && n[ZR] ? n[ZR] : (
        // User-Agent from passed headers
        sf
      )
    )
  ), i = new ZL(n, !0), o = e ? ane(dO, e) : dO, s = function(a) {
    return a == kc ? function() {
      return new hO(a, r, o, i).set("ua", r).set(Xi, this.getBrowser()).set(na, this.getCPU()).set(hs, this.getDevice()).set(sa, this.getEngine()).set(wo, this.getOS()).get();
    } : function() {
      return new hO(a, r, o[a], i).parseUA().get();
    };
  };
  return aa.call(this, [
    ["getBrowser", s(Xi)],
    ["getCPU", s(na)],
    ["getDevice", s(hs)],
    ["getEngine", s(sa)],
    ["getOS", s(wo)],
    ["getResult", s(kc)],
    ["getUA", function() {
      return r;
    }],
    ["setUA", function(a) {
      return xf(a) && (r = a.length > wS ? xh(a, wS) : a), this;
    }]
  ]).setUA(r), this;
}
Ps.VERSION = Qte;
Ps.BROWSER = w0([De, Fe, Th]);
Ps.CPU = w0([Ti]);
Ps.DEVICE = w0([Le, We, Be, lc, qt, qi, Hn, Zu, bS]);
Ps.ENGINE = Ps.OS = w0([De, Fe]);
let Xb;
function Ch(t) {
  if (!t) return t;
  t.colors && (Xb = t.colors);
  const e = ["background", "backgroundColor", "borderColor", "color", "markerColor"];
  for (const [n, r] of Object.entries(t)) {
    const i = r, o = n;
    e.includes(o) && Xb[i] && (t[o] = Xb[i]), t[o] && typeof t[o] == "object" && Ch(t[o]);
  }
  return t;
}
let Kb;
function S0(t) {
  if (!t) return t;
  t.fontSizes && (Kb = t.fontSizes);
  for (const [e, n] of Object.entries(t))
    e === "fontSize" && Kb[n] && (t[e] = Kb[n]), typeof t[e] == "object" && S0(t[e]);
  return t;
}
let pO;
function e3(t) {
  if (!t) return t;
  t.fonts && (pO = t.fonts);
  for (const [e, n] of Object.entries(t)) {
    const r = n, i = e;
    i === "font" && (t[i] = pO[r]);
  }
  return t;
}
function ES({
  filter: t,
  background: e,
  text: n
}) {
  if (!t) return t;
  const r = ["background", "backgroundColor"], i = ["color", "markerColor"];
  for (const [o] of Object.entries(t)) {
    const s = o;
    i.includes(s) && (t[s] = n), r.includes(s) && (t[s] = e), t[s] && typeof t[s] == "object" && ES({
      filter: t[s],
      background: e,
      text: n
    });
  }
  return t;
}
function une(t) {
  const e = atob(t), n = e.length, r = new ArrayBuffer(n), i = new Uint8Array(r);
  for (let o = 0; o < n; o++)
    i[o] = e.charCodeAt(o);
  return r;
}
const gO = new Ps(), Mi = Qt({
  key: "VS_CurrentFilter",
  get: ({
    get: t
  }) => {
    const e = t(bi);
    return t(Fo(e));
  }
}), cne = Tt({
  key: "VS_InjectedFilter",
  default: null
}), t3 = Tt({
  key: "VS_FilterNames",
  default: []
}), bi = Qt({
  key: "VS_FilterName",
  get: ({
    get: t
  }) => {
    const e = t(Ut), n = t(Zo), r = [];
    for (let i = 0; i < e; i++) {
      const o = n[i];
      if (!o) return pe.defaultFilter;
      const s = o.find((a) => a && a.type === "filter:");
      s && r.push(s.content);
    }
    return r.length > 0 ? r[r.length - 1] : pe.defaultFilter;
  },
  cachePolicy_UNSTABLE: {
    // Only store the most recent set of dependencies and their values
    eviction: "most-recent"
  }
});
function mO(t, e) {
  const n = gO.getEngine().name, r = gO.getBrowser(), i = n === "Gecko", o = e === "preview", s = r.name === "Mobile Safari" && r.major && Number.parseInt(r.major) >= 26;
  return i || o || s ? `"${t}"` : t;
}
async function f2(t, e) {
  const n = [], r = Object.keys(t), i = window.__SSR_FONT_DATA;
  console.log("ssrFonts:", i?.length);
  for (const o of r) {
    const s = t[o];
    if (!s) continue;
    const a = async () => {
      if (PX.includes(s))
        return s;
      if (i && i.length > 0) {
        const d = i.find((h) => h?.fontName === s);
        if (d) {
          const h = mO(s, e), p = une(d.fontData), g = new FontFace(h, p);
          return await g.load(), document.fonts.add(g), s;
        }
      }
      const l = `${Yc.getFont()}/${s}`, u = await fetch(l).then((d) => d.arrayBuffer()), c = mO(s, e), f = new FontFace(c, u);
      return await f.load(), document.fonts.add(f), s;
    };
    try {
      const l = await a();
      n.push(l);
    } catch {
    }
  }
  return n;
}
const fne = new XE(Yc.gqlGetFilter()), yO = gE(fne), dne = (t) => ({
  trigger: e,
  setSelf: n
}) => {
  const {
    ownerName: r,
    filterName: i
  } = JSON.parse(t), o = "QP";
  let s;
  const a = window.__SSR_DATA?.filterData;
  e === "get" && (async () => {
    try {
      if (a) {
        const c = `${r}::${i}`, f = a.find((d) => d?.filterName === c);
        f ? s = {
          getFilter: JSON.parse(f.filter)
        } : s = await yO.GetFilter({
          ownerName: r,
          filterName: i
        });
      } else
        s = await yO.GetFilter({
          ownerName: r,
          filterName: i
        });
      if (s.getFilter === null) throw new TypeError("Filter is null");
      let u = s.getFilter;
      u = Ch(u), u = S0(u), u = e3(u), RM(u);
      try {
        console.log("Loading fonts for filter:", u.filterName, u.fonts), await f2(u.fonts, o);
      } catch (c) {
      }
      n(u), lJ(o);
    } catch (u) {
      console.error(u);
      const c = Cu(Zh);
      n(Ch(c));
    }
  })();
}, hne = lo({
  key: "VS_Filter",
  default: () => {
    console.log("Loading default fonts for filter:");
    let t = Cu(Zh);
    return t = Ch(t), t = S0(t), console.log("Loading default fonts for filter:", t.fonts), f2(t.fonts, "QP"), t;
  },
  effects: (t) => [dne(t)]
}), Fo = PV({
  key: "VS_Filter",
  get: () => async ({
    get: t
  }) => {
    const e = t(bi), n = t(t3), r = t(er), i = t(sp), o = t(zn) ? "preview" : "QP", [s, a] = e.split("::"), l = t(g0), u = t(KE);
    let c = Cu(Zh);
    if (c = Ch(c), c = S0(c), c = e3(c), console.log("Loading default fonts for filter:", c.fonts), f2(c.fonts, "QP"), l && (c = ES({
      filter: c,
      background: u.background,
      text: u.text
    })), e === pe.defaultFilter || !i && r && !n.includes(e)) return c;
    const f = JSON.stringify({
      filterName: a,
      ownerName: s,
      type: o
    });
    let d = t(hne(f));
    return l && (d = ES({
      filter: Cu(d),
      background: u.background,
      text: u.text
    })), d;
  }
}), pr = Qt({
  key: "VS_FilterColors",
  get: ({
    get: t
  }) => {
    const e = t(Mi);
    return rJ("QP", e.colors), e.colors;
  }
}), gr = Qt({
  key: "VS_FilterFonts",
  get: ({
    get: t
  }) => t(Mi).fonts
}), n3 = Qt({
  key: "VS_FontsAreLoaded",
  get: ({
    get: t
  }) => {
    const e = t(bi), n = t(Fo(e));
    return n.filterName === pe.defaultFilter || n.filterName !== pe.defaultFilter;
  }
}), Fi = Tt({
  key: "VS_HostId",
  default: ""
}), sp = Tt({
  key: "VS_AllowEmbeddedDataFetch",
  default: !1
}), Ah = Tt({
  key: "VS_AutoPlayAtom",
  default: {
    autoPlay: -1,
    loop: "once"
  }
}), r3 = Tt({
  key: "VS_AutoSpaceAtom",
  default: !0
}), pne = Qt({
  key: "VS_AutoSpaceFilterSetting",
  get: ({
    get: t
  }) => {
    const e = t(bi);
    return t(Fo(e)).autospace;
  }
}), wi = Qt({
  key: "VS_ConstrainDimensionsSelector",
  get: ({
    get: t
  }) => {
    const e = t(sp), n = t(er);
    return e || n;
  }
}), d2 = Tt({
  key: "VS_ContainerSelector"
}), gne = Tt({
  key: "VS_CurrentGridClass",
  default: pe.unset
}), mne = ({
  setSelf: t
}) => {
  const n = window.location.pathname.split("/").indexOf(pe.reservedWords.debug) > -1;
  t(n);
}, i3 = Tt({
  key: "VS_DebugMode",
  default: !1,
  effects: [mne]
}), Ea = Tt({
  key: "VS_EditMode",
  default: !1
}), er = Tt({
  key: "VS_IsEmbedded",
  default: !1
});
Tt({
  key: "VS_IsOverflowing",
  default: !1
});
const zn = Tt({
  key: "VS_IsPreviewGenerator",
  default: !1
}), _0 = Tt({
  key: "VS_IsInPopOut",
  default: !1
}), yne = Tt({
  key: "VS_IsInPopOutInDev",
  default: !1
}), ap = Tt({
  key: "VS_IsInPresentationMode",
  default: !1
}), o3 = Qt({
  key: "VS_SingleColumnInPortrait",
  get: ({
    get: t
  }) => {
    const e = t(bi);
    return t(Fo(e)).grid.singleColumnInPortrait;
  }
}), Rh = Qt({
  key: "VS_TapEvent",
  get: ({
    get: t
  }) => t(gi),
  set: ({
    get: t,
    set: e
  }, n) => {
    const r = t(er), i = t(Ea);
    if (!t(ap) && r && i) return;
    const s = t(Ut), a = t(_h(s)), u = t(Zo).length;
    if (s > u && e(Ut, u), s < 1 && e(Ut, 1), n === "back" && s > 1 && (e(Oh(s), !0), e(Ut, (c) => c - 1)), n === "forward") {
      e(Oh(s), !1);
      const c = a.find((f) => f.containerTapped === !1);
      if (c) {
        for (const f of c.ids) {
          const d = Xt(s, f);
          e(fn(d), (h) => {
            const p = {
              ...h
            };
            return p.data.tapped = !0, p;
          });
        }
        e(_h(s), (f) => {
          const d = a.findIndex((p) => p === c), h = f.map((p) => ({
            ...p
          }));
          return h[d].containerTapped = !0, h;
        });
      }
      if (s + 1 > u) return;
      c || (s < u && e(Ut, (f) => f + 1), s === u && e(Ut, s));
    }
  }
}), vne = ({
  setSelf: t
}) => {
  const n = window.location.pathname.split("/").indexOf(pe.reservedWords.read) > -1;
  t(n);
}, dy = Tt({
  key: "VS_ReadMode",
  default: !1,
  effects: [vne]
}), gi = Tt({
  key: "VS_TapDirection",
  default: "init"
}), Oh = lo({
  key: "VS_ShowAllTapElements",
  default: !1
}), s3 = Tt({
  key: "VS_ShowInfoBarAtom",
  default: !1,
  effects: [rp("show_info_bar")]
}), h2 = Tt({
  key: "VS_ShowSettings",
  default: !1
}), bne = Tt({
  key: "VS_ShowSourceCode",
  default: !1
}), a3 = Tt({
  key: "VS_InjectedStackCfKey",
  default: null
}), Lo = Qt({
  key: "VS_StackCfKey",
  get: ({
    get: t
  }) => {
    const e = t(a3);
    if (e) return e;
    const n = t(er), r = t(sp);
    if (n && !r) return pe.utility.inAuthor;
    const i = aL(window.location.pathname), o = window.location.hostname.toLowerCase(), s = o === "mrkt23.com" || o === "www.mrkt23.com", a = o === "tkn.exchange" || o === "www.tkn.exchange";
    return i.ownerName ? i.ownerName && !i.stackCfKey ? i.ownerName : i.stackCfKey : a ? pe.common.landing.tkn : s ? pe.common.landing.m23 : pe.common.landing.qp;
  }
}), wne = (t) => ({
  setSelf: e
}) => {
  if (t === pe.utility.inAuthor) {
    e({
      code: "",
      stackId: "",
      audioFiles: [],
      filters: [],
      images: [],
      dataFiles: []
    });
    return;
  }
  const n = window.__SSR_DATA;
  if (n) {
    const o = {
      code: n.code ? mC(n.code) : n.code,
      filters: n.filters,
      stackId: n.stackId,
      images: n.images,
      audioFiles: n.audioFiles,
      dataFiles: n.dataFiles
    };
    e(o);
    return;
  }
  const r = new XE(Yc.gqlViewStack());
  gE(r).ViewStack({
    stackCfKey: t
  }).then((o) => {
    o.viewStack.images || (o.viewStack.images = []), o.viewStack.code ? (o.viewStack.code = o.viewStack.code ? mC(o.viewStack.code) : o.viewStack.code, e(o.viewStack)) : e({
      code: "There is no stack at this address.",
      stackId: "",
      audioFiles: [],
      filters: [],
      images: [],
      dataFiles: []
    });
  }).catch((o) => {
    console.error(o), e({
      code: pe.messages.error,
      stackId: "",
      audioFiles: [],
      filters: [],
      images: [],
      dataFiles: []
    });
  });
}, _l = lo({
  key: "VS_RawCode",
  effects: (t) => [wne(t)]
});
Tt({
  key: "VS_StoryBackGroundContent",
  default: null
});
function l3(t) {
  switch (t) {
    case void 0:
      return pe.unset;
    case rr.Italic:
      return "italic";
    case rr.Normal:
      return "normal";
  }
  return pe.unset;
}
function u3(t) {
  switch (t) {
    case void 0:
      return pe.unset;
    case Gn.Bold:
      return "bold";
    case Gn.Bolder:
      return "bolder";
    case Gn.Lighter:
      return "lighter";
    case Gn.Normal:
      return "normal";
  }
  return pe.unset;
}
const wa = (t, e, n = 1) => t.fontSize ? `${t.fontSize * e * n}px` : pe.unset, p2 = (t, e) => {
  if (!e) return pe.unset;
  const n = e[t.font];
  return n ? `"${n}"` : pe.unset;
};
function ts(t, e) {
  return t ? e ? `align-self: ${t}` : `justify-self: ${t}` : "";
}
function Ru(t, e, n) {
  switch (t) {
    case mo.BottomUp:
      return "end";
    case mo.MiddleOut:
      return e ? "start" : "center";
    case mo.TopDown:
      return "start";
  }
  return pe.unset;
}
function c3(t) {
  switch (t) {
    case ir.Strikethrough:
      return "line-through";
    case ir.Underline:
      return "underline";
  }
  return pe.unset;
}
function _r(t, e) {
  if (!e) return 1;
  typeof e == "string" && (e = Number.parseInt(e));
  const n = e ? e / 100 : 1;
  return t ? n : 0;
}
function mr(t) {
  function e(r, ...i) {
    return r.reduce((s, a, l) => `${s} ${i[l - 1](t.theme)} ${r[l]}`);
  }
  return e`
    ${(r) => ts(r.align, r.isInCell)};
    align-items: ${(r) => r.align};
    background: ${(r) => r.background ? r.background : "unset"};
    border-radius: ${(r) => r.cornerRadius ? `${r.cornerRadius * t.baseFontSize}px` : "unset"};
    border-block-end: ${(r) => r.borderBlockEnd ? `${r.borderBlockEnd * t.baseFontSize}px solid` : "unset"};
    border-block-start: ${(r) => r.borderBlockStart ? `${r.borderBlockStart * t.baseFontSize}px solid` : "unset"};
    border-inline-start: ${(r) => r.borderInlineStart ? `${r.borderInlineStart * t.baseFontSize}px solid` : "unset"};
    border-inline-end: ${(r) => r.borderInlineEnd ? `${r.borderInlineEnd * t.baseFontSize}px solid` : "unset"};
    border-color: ${(r) => r.borderColor ? r.borderColor : "unset"};
    color: ${(r) => r.color ? r.color : "unset"};
    font-family: ${(r) => p2(r, t.fonts)};
    font-size:  ${(r) => wa(r, t.baseFontSize)};
    font-style: ${(r) => l3(r.fontStyle)};
    font-weight: ${(r) => u3(r.weight)};
    line-height: ${(r) => r.lineHeight ? r.lineHeight : "unset"};
    padding-block-end: ${(r) => r.paddingBlockEnd ? `${r.paddingBlockEnd * t.baseFontSize}px` : "unset"};
    padding-block-start: ${(r) => r.paddingBlockStart ? `${r.paddingBlockStart * t.baseFontSize}px` : "unset"};
    padding-inline-start: ${(r) => r.paddingInlineStart ? `${r.paddingInlineStart * t.baseFontSize}px` : "unset"};
    padding-inline-end: ${(r) => r.paddingInlineEnd ? `${r.paddingInlineEnd * t.baseFontSize}px` : "unset"};
    text-decoration: ${(r) => c3(r.decoration)};
    white-space: pre-wrap;
`;
}
function f3(t) {
  function e(r, ...i) {
    return r.reduce((s, a, l) => `${s} ${i[l - 1](t.theme)} ${r[l]}`);
  }
  return e`
    align-items: ${(r) => r.align};
    border-radius: ${(r) => r.cornerRadius ? `${r.cornerRadius * t.baseFontSize}px` : "unset"};
    border-block-end: ${(r) => r.borderBlockEnd ? `${r.borderBlockEnd * t.baseFontSize}px solid ${r.borderColor}` : "unset"}  ;
    border-block-start: ${(r) => r.borderBlockStart ? `${r.borderBlockStart * t.baseFontSize}px solid${r.borderColor}` : "unset"};
    border-inline-start: ${(r) => r.borderInlineStart ? `${r.borderInlineStart * t.baseFontSize}px solid${r.borderColor}` : "unset"};
    border-inline-end: ${(r) => r.borderInlineEnd ? `${r.borderInlineEnd * t.baseFontSize}px solid${r.borderColor}` : "unset"};
    color: ${(r) => r.color ? r.color : "unset"};
    font-family: ${(r) => p2(r, t.fonts)};
    font-size:  ${(r) => wa(r, t.baseFontSize)};
    font-style: ${(r) => l3(r.fontStyle)};
    font-weight: ${(r) => u3(r.weight)};
    justify-content: ${(r) => Ru(r.startingPoint, t.isOverflowing, t.isInLandscape)};
    line-height: ${(r) => r.lineHeight ? r.lineHeight : "unset"};
    padding-block-end: ${(r) => r.paddingBlockEnd && t.isInLandscape ? `${r.paddingBlockEnd * t.baseFontSize}px` : "unset"};
    padding-block-start: ${(r) => r.paddingBlockEnd && t.isInLandscape ? `${r.paddingBlockStart * t.baseFontSize + +t.stickyHeaderHeight}px` : "unset"};
    padding-inline-start: ${(r) => r.paddingBlockEnd ? `${r.paddingInlineStart * t.baseFontSize}px` : "unset"};
    padding-inline-end: ${(r) => r.paddingBlockEnd ? `${r.paddingInlineEnd * t.baseFontSize}px` : "unset"};
    text-decoration: ${(r) => c3(r.decoration)};
    white-space: pre-wrap;
        `;
}
const d3 = () => `

    --light-pos-x: 1; /* left: -1, center: 0, right: 1 */
    --light-pos-y: -1; /* top: -1, center: 0, bottom: 1 */
    --rim-size: .02ch;
    --shadow-offset: .2ch;
    --shadow-blur: .1ch;
    text-shadow: 
      calc(max(var(--rim-size), 1px) * var(--light-pos-x)) calc(max(var(--rim-size), 1px) * var(--light-pos-y)) hsl(0 0% 100%),
      calc(max(var(--rim-size), 1px) * var(--light-pos-x) * -1) calc(max(var(--rim-size), 1px) * var(--light-pos-y) * -1) hsl(0 0% 60%),
      calc(var(--shadow-offset) * var(--light-pos-x) * -1) calc(var(--shadow-offset) * var(--light-pos-y) * -1) var(--shadow-blur) hsl(0 0% 50% / .75) 

`, Sne = () => "text-shadow: 0px 0px 4px rgba(51,51,51,.8),0px 0px 8px #333333; color: #fff", _ne = `
  .paragraph {
    text-wrap: pretty;
  }

  .shadow { ${d3()} }
  align-items: center;
  display: grid;
  justify-items:  center;
 

  .inkReveal {
    mask-image: url(/fx/ink_lv2.gif);
    mask-size: cover;
    mask-position: center;
  }

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }

  .animate  { animation: fadeIn 5s; }

  .disable-select {
    user-select: none;
    /* supported by Chrome and Opera */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-user-select: none;
    /* Safari */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -khtml-user-select: none;
    /* Konqueror HTML */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -moz-user-select: none;
    /* Firefox */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
  }




  /*for screen readers*/
  .sr-only {
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  .text-modifier.__{
    text-decoration: underline;
  }

  .neuro-divergent-sentence {
    display: flex;
    flex-wrap: wrap;
  }

  .neuro-divergent-letter-bold {
    font-weight: bold;
  }   `, Ene = ({
  isInLandscape: t,
  navigationType: e
}) => e === "scroll" ? !0 : !(e === "scrollCards" || e === "scrollContinuous" || t), kne = rt.div.withConfig({
  displayName: "StyledDisplay",
  componentId: "sc-12zmjcq-0"
})`
${_ne};
position: ${(t) => t.$constrainDimensions ? "relative" : "fixed"};
width: 100%;
overflow-x: hidden;
overflow-y: ${(t) => Ene({
  navigationType: t.$navigationType,
  isInLandscape: t.$isInLandscape
}) ? "auto" : "hidden"};
height: ${(t) => t.$constrainDimensions ? "100%" : (t.$navigationType === "tap", "100svh")};
.inline-link {
cursor: pointer;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme.link
})}`}
font-size: inherit;
font-family: inherit;

}
`;
/*!
 * @gsap/react 2.1.2
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
let vO = typeof document < "u" ? Bn : lt, bO = (t) => t && !Array.isArray(t) && typeof t == "object", _g = [], Tne = {}, h3 = Pe;
const so = (t, e = _g) => {
  let n = Tne;
  bO(t) ? (n = t, t = null, e = "dependencies" in n ? n.dependencies : _g) : bO(e) && (n = e, e = "dependencies" in n ? n.dependencies : _g), t && typeof t != "function" && console.warn("First parameter must be a function or config object");
  const { scope: r, revertOnUpdate: i } = n, o = Xe(!1), s = Xe(h3.context(() => {
  }, r)), a = Xe((u) => s.current.add(null, u)), l = e && e.length && !i;
  return l && vO(() => (o.current = !0, () => s.current.revert()), _g), vO(() => {
    if (t && s.current.add(t, r), !l || !o.current)
      return () => s.current.revert();
  }, e), { context: s.current, contextSafe: a.current };
};
so.register = (t) => {
  h3 = t;
};
so.headless = !0;
var hm = { exports: {} }, xne = hm.exports, wO;
function Cne() {
  return wO || (wO = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(xne, function() {
      return function(n) {
        function r(o) {
          if (i[o]) return i[o].exports;
          var s = i[o] = { i: o, l: !1, exports: {} };
          return n[o].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
        }
        var i = {};
        return r.m = n, r.c = i, r.d = function(o, s, a) {
          r.o(o, s) || Object.defineProperty(o, s, { configurable: !1, enumerable: !0, get: a });
        }, r.n = function(o) {
          var s = o && o.__esModule ? function() {
            return o.default;
          } : function() {
            return o;
          };
          return r.d(s, "a", s), s;
        }, r.o = function(o, s) {
          return Object.prototype.hasOwnProperty.call(o, s);
        }, r.p = "", r(r.s = 3);
      }([function(n, r, i) {
        var o = i(1);
        n.exports = function(s, a) {
          return a = a || {}, o.forEach(function(l) {
            var u = typeof l[1] == "function" ? l[1](a.retainLength) : l[1];
            s = s.replace(l[0], u);
          }), s;
        };
      }, function(n) {
        n.exports = [[/'''/g, function(r) {
          return "‴" + (r ? "⁣⁣" : "");
        }], [/(\W|^)"(\w)/g, "$1“$2"], [/(\u201c[^"]*)"([^"]*$|[^\u201c"]*\u201c)/g, "$1”$2"], [/([^0-9])"/g, "$1”"], [/''/g, function(r) {
          return "″" + (r ? "⁣" : "");
        }], [/(\W|^)'(\S)/g, "$1‘$2"], [/([a-z0-9])'([a-z])/ig, "$1’$2"], [/(\u2018)([0-9]{2}[^\u2019]*)(\u2018([^0-9]|$)|$|\u2019[a-z])/ig, "’$2$3"], [/((\u2018[^']*)|[a-z])'([^0-9]|$)/ig, "$1’$3"], [/(\B|^)\u2018(?=([^\u2018\u2019]*\u2019\b)*([^\u2018\u2019]*\B\W[\u2018\u2019]\b|[^\u2018\u2019]*$))/ig, "$1’"], [/"/g, "″"], [/'/g, "′"]];
      }, function(n, r, i) {
        function o(u) {
          if (["CODE", "PRE", "SCRIPT", "STYLE", "NOSCRIPT"].indexOf(u.nodeName.toUpperCase()) === -1) {
            var c, f, d, h = "", p = u.childNodes, g = [];
            for (c = 0; c < p.length; c++) f = p[c], f.nodeType === l || f.nodeName === "#text" ? (g.push([f, h.length]), h += f.nodeValue || f.value) : f.childNodes && f.childNodes.length && (h += o(f));
            for (c in h = a(h, { retainLength: !0 }), g) d = g[c], d[0].nodeValue ? d[0].nodeValue = s(h, d[0].nodeValue, d[1]) : d[0].value && (d[0].value = s(h, d[0].value, d[1]));
            return h;
          }
        }
        function s(u, c, f) {
          return u.substr(f, c.length).replace("⁣", "");
        }
        var a = i(0), l = typeof Element < "u" && Element.TEXT_NODE || 3;
        n.exports = function(u) {
          return o(u), u;
        };
      }, function(n, r, i) {
        function o(c) {
          return typeof document < "u" && typeof c > "u" ? (l.runOnReady(function() {
            return a(document.body);
          }), o) : typeof c == "string" ? u(c) : a(c);
        }
        var s = i(1), a = i(2), l = i(4), u = i(0);
        n.exports = o, n.exports.string = u, n.exports.element = a, n.exports.replacements = s, n.exports.listen = l;
      }, function(n, r, i) {
        function o(a) {
          var l = new MutationObserver(function(u) {
            u.forEach(function(c) {
              var f, d = !0, h = !1;
              try {
                for (var p, g, m = c.addedNodes[Symbol.iterator](); !(d = (p = m.next()).done); d = !0) g = p.value, s(g);
              } catch (v) {
                h = !0, f = v;
              } finally {
                try {
                  !d && m.return && m.return();
                } finally {
                  if (h) throw f;
                }
              }
            });
          });
          return o.runOnReady(function() {
            l.observe(a || document.body, { childList: !0, subtree: !0 });
          }), l;
        }
        var s = i(2);
        i(0), o.runOnReady = function(a) {
          if (document.readyState !== "loading") a();
          else if (document.addEventListener) document.addEventListener("DOMContentLoaded", a, !1);
          else var l = setInterval(function() {
            document.readyState !== "loading" && (clearInterval(l), a());
          }, 10);
        }, n.exports = o;
      }]);
    });
  }(hm)), hm.exports;
}
var Ane = Cne();
const E0 = /* @__PURE__ */ gy(Ane);
Pe.registerPlugin(gt);
function Rne({
  elRef: t,
  pageIndex: e,
  isInAuthor: n,
  isPreviewer: r,
  isInPlayWrightTest: i,
  navigationType: o,
  scrollerRef: s
}) {
  const a = kt(k2), [l, u] = Cn();
  return so(() => {
    if (o !== "scroll" && o !== "scrollCards" && o !== "scrollContinuous" || !t.current || !s?.current) return;
    const c = Pe.timeline();
    a && a.add(c, 0), gt.create({
      trigger: t.current,
      scroller: s.current,
      start: "top bottom",
      end: "bottom top",
      animation: c,
      scrub: !0,
      onUpdate: () => {
      }
    }), u(c);
  }, {
    scope: t,
    dependencies: [e, a, o, r, i, n, s]
  }), l;
}
lo({
  key: "VS_VideoUrl",
  default: void 0
});
const One = Tt({
  key: "VS_ScrollTriggerPosition",
  default: 0
});
function p3(t, e, n) {
  return t.some((i) => i.props.type === "columnTitle:") ? Dne(t, e) : e || !n ? Ine(t) : Nne(t);
}
function Dne(t, e) {
  const n = [], r = [], i = [], o = t.findIndex((f) => f.props.type === _t["---"].controlChar);
  if (o === -1) return [];
  const s = t.findIndex((f, d) => d > o && f.props.type === _t["---"].controlChar);
  if (s === -1) return [];
  const a = t.slice(o + 1, s), l = t.slice(s + 1);
  for (const f of a)
    f.props.type === "columnTitle:" && r.push(f);
  for (const f of l)
    f.props.type !== _t["---"].controlChar && f.props.type !== _t["-->"].controlChar && !Qh.includes(f.props.type) && !f.props.isAutospaceElement && i.push(f);
  const u = r.length;
  if (u === 0) return [];
  const c = [];
  for (let f = 0; f < i.length; f += u)
    c.push(i.slice(f, f + u));
  if (e)
    r.forEach((f, d) => {
      n.push({
        col: d + 1,
        row: 1,
        elArray: [f],
        isResponsiveTable: !0,
        maxCols: u,
        maxRows: c.length + 1,
        lastColInRow: d === u - 1,
        lastRowInGrid: c.length === 0,
        isSplitCell: !1
      });
    }), c.forEach((f, d) => {
      f.forEach((h, p) => {
        n.push({
          col: p + 1,
          row: d + 2,
          elArray: [h],
          isResponsiveTable: !0,
          maxCols: u,
          maxRows: c.length + 1,
          lastColInRow: p === f.length - 1,
          lastRowInGrid: d === c.length - 1,
          isSplitCell: !1
        });
      });
    });
  else {
    let f = 1;
    const d = 2, h = i.length;
    for (const p of c) {
      for (const [g, m] of p.entries())
        if (g < r.length) {
          const v = r[g];
          n.push({
            col: 1,
            row: f,
            elArray: [v],
            isResponsiveTable: !0,
            maxCols: d,
            maxRows: h,
            lastColInRow: !1,
            lastRowInGrid: !1,
            isSplitCell: !1
          }), n.push({
            col: 2,
            row: f,
            elArray: [m],
            isResponsiveTable: !0,
            maxCols: d,
            maxRows: h,
            lastColInRow: !0,
            lastRowInGrid: !1,
            isSplitCell: !1
          }), f++;
        }
      c.indexOf(p) < c.length - 1 && (n.push({
        col: 1,
        row: f,
        elArray: [],
        // Empty cell for spacing
        isResponsiveTable: !0,
        isSpacer: !0,
        maxCols: 1,
        maxRows: h,
        lastColInRow: !0,
        lastRowInGrid: !1,
        isSplitCell: !0
      }), f++);
    }
    n.length > 0 && (n[n.length - 1].lastRowInGrid = !0);
  }
  return n;
}
function Ine(t) {
  const e = [], n = [];
  t.forEach((h, p) => {
    h.props.type === _t["|"].controlChar && n.push(p);
  });
  const r = [];
  t.forEach((h, p) => {
    h.props.type === _t["---"].controlChar && r.push(p);
  });
  const i = [];
  t.forEach((h, p) => {
    h.props.type === _t["-->"].controlChar && i.push(p);
  });
  const o = r.concat(i);
  let s, a = 1, l = 1, u = !1;
  t.every((h, p) => {
    if (h.props.type === _t["-->"].controlChar || h.props.isAutospaceElement || Qh.includes(h.props.type)) return !0;
    let g = !1;
    p === 0 && (h.props.type === _t["---"].controlChar || h.props.type === _t["^^^"].controlChar) && (s = 0, l = 1, a = 1, g = !0), p !== 0 && (h.props.type === _t["---"].controlChar || h.props.type === _t["^^^"].controlChar) && (s++, l++, a = 1, u = !1, g = !0);
    const m = o[s], v = o[s + 1];
    if (n.find((b) => b > m && b < v) !== void 0 && (u = !0), h.props.type === _t["|"].controlChar && (a++, g = !0), h.props.type === "background:")
      return e[e.length - 1] && e[e.length - 1].elArray.push(h), !0;
    const _ = {
      col: a,
      row: l,
      elArray: [h],
      lastColInRow: !1,
      lastRowInGrid: !1,
      isSplitCell: u,
      maxCols: 0,
      maxRows: 0
    };
    return !g && !u && e.push(_), g && u && (_.elArray = [], e.push(_)), !g && u && e[e.length - 1].elArray.push(h), !g && !u && a++, !0;
  });
  const c = e.reduce((h, p) => p.col > h ? p.col : h, 0), f = e.reduce((h, p) => p.row > h ? p.row : h, 0);
  function d(h) {
    const p = h.findIndex((m) => m.props.type === "background:");
    if (p === -1) return h;
    const g = h.splice(p, 1)[0];
    return h.unshift(g), h;
  }
  return e.forEach((h, p) => {
    h.elArray = d(h.elArray), h.maxCols = c, h.maxRows = f, e[p + 1] && h.row !== e[p + 1].row && (h.lastColInRow = !0), e[p + 1] || (h.lastColInRow = !0, h.lastRowInGrid = !0);
  }), e;
}
function Nne(t) {
  let e = 1, n = 1;
  const r = [];
  t.every((s) => s.props.type === _t["-->"].controlChar ? !1 : s.props.type === _t["|"].controlChar || Qh.includes(s.props.type) || s.props.isAutospaceElement || s.props.type === _t["^^^"].controlChar ? !0 : s.props.type === _t["---"].controlChar ? (e = 1, !0) : s.props.type === "background:" ? (r[r.length - 1] && r[r.length - 1].elArray.push(s), !0) : (r.push({
    col: e,
    elArray: [s],
    lastColInRow: !1,
    lastRowInGrid: !1,
    maxCols: 0,
    isSplitCell: !1,
    maxRows: 0,
    row: n
  }), n++, !0));
  const i = r.reduce((s, a) => a.col > s ? a.col : s, 0), o = r.reduce((s, a) => a.row > s ? a.row : s, 0);
  return r.forEach((s, a) => {
    s.maxCols = i, s.maxRows = o, r[a + 1] && s.row !== r[a + 1].row && (s.lastColInRow = !0), r[a + 1] || (s.lastColInRow = !0, s.lastRowInGrid = !0);
  }), r;
}
function Pne({
  elRef: t,
  isEmpty: e
}) {
  const n = Xe(!e);
  so(() => {
    const r = !e;
    n.current && !r ? Pe.to(t.current, {
      autoAlpha: 0,
      duration: 0.3,
      ease: "power1.out"
    }) : !n.current && r ? Pe.fromTo(t.current, {
      autoAlpha: 0
    }, {
      autoAlpha: 1,
      duration: 0.3,
      ease: "power1.in"
    }) : r || Pe.set(t.current, {
      autoAlpha: 0
    }), n.current = r;
  }, {
    scope: t,
    dependencies: [e]
  });
}
function uc(t) {
  const e = document.querySelector('meta[name="theme-color"]');
  if (e)
    e.content = t;
  else {
    const n = document.createElement("meta");
    n.name = "theme-color", n.content = t, document.head.appendChild(n);
  }
}
const tr = Qo(!1);
function $ne({
  currentCol: t,
  isInLandscape: e,
  isLastColInRow: n,
  maxCols: r
}) {
  return n && r > t && e ? `${t}  /  ${r + 1}` : t;
}
const Mne = rt.div.withConfig({
  displayName: "Cell__StyledCell",
  componentId: "sc-1vga57f-0"
})`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: ${(t) => Ru(t.theme.startingPoint)} ;
  position: relative;
  min-height: 0;
  max-height: 100%;
  grid-column: ${(t) => {
  const e = {
    currentCol: t.$column,
    isInLandscape: t.$isInLandscape,
    isLastColInRow: t.$lastColInRow,
    maxCols: t.$maxCols
  };
  return $ne(e);
}};
  grid-row: ${(t) => t.$row};
  height: ${(t) => t.$isSpacer ? "1em" : "auto"};
  width: ${(t) => t.$isSplitPageChildCell && t.$isInLandscape ? "90%" : "100%"};
  --cell-background: "unset";
  --cell-background-repeat: no-repeat;
  --cell-background-position: center;
  --cell-background-size: cover;
  --cell-opacity: 1;
  --cell-blur: 0;
  &::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    visibility: visible;
    background: var(--cell-background);
    background-repeat: var(--cell-background-repeat);
    background-position: var(--cell-background-position);
    background-size: var(--cell-background-size);
    filter: blur(var(--cell-blur)) opacity(var(--cell-opacity));
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    max-width: 100%;
    max-height: 100%;
  }
  ${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.$filter
})}`};
  ${(t) => t.$isSplitPageChildCell ? "padding: 0;" : ""}
  ${(t) => t.$isSplitPageChildCell ? "justify-self: center;" : ""}
  ${(t) => t.$isInLandscape ? "" : "padding-inline: 0;"}
`, Fne = Qo(!0);
function g3({
  gridObject: t,
  idx: e,
  inEditMode: n,
  isPreviewer: r,
  alignCellAsColumn: i,
  isSplitPageChildCell: o
}) {
  const s = L(bi), a = L(Fo(s)), l = L(gr), u = L(jt), c = L(wi), f = u.landscape, d = u.baseFontSize, h = L(Ut);
  return /* @__PURE__ */ D.jsx(tr.Provider, { value: !0, children: /* @__PURE__ */ D.jsx(Fne.Provider, { value: !0, children: /* @__PURE__ */ D.jsx(Mne, { $alignCellAsColumn: i, $baseFontSize: d, $column: t.col, $filter: a.cell, $fonts: l, $inEditMode: n, $constrainDimensions: c, $isInLandscape: f, $isPreviewer: r, $isSplitPageChildCell: o, $isSplitCell: t.isSplitCell, $lastColInRow: t.lastColInRow, $lastRowInGrid: t.lastRowInGrid, $maxCols: t.maxCols, $maxRows: t.maxRows, $row: t.row, $isSpacer: t.isSpacer, className: `${pe.css.styledGridCell} `, id: `grid-cell${e}-col-${t.col}-row-${t.row}`, role: "none", children: t.elArray }, `grid-cell${e}-col-${t.col}-row-${t.row}-${h}`) }) });
}
const Lne = Qo(!1);
function Bne({
  currentCol: t,
  isInLandscape: e,
  isLastColInRow: n,
  maxCols: r
}) {
  return n && r > t && e ? `${t}  /  ${r + 1}` : t;
}
const jne = rt.div.withConfig({
  displayName: "TableCell__StyledCell",
  componentId: "sc-n0d4rr-0"
})`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: ${(t) => Ru(t.theme.startingPoint)} ;
  position: relative;
  min-height: 0;
  max-height: 100%;
  grid-column: ${(t) => {
  if (t.$isSplitCell) return "1 / -1";
  const e = {
    currentCol: t.$column,
    isInLandscape: t.$isInLandscape,
    isLastColInRow: t.$lastColInRow,
    maxCols: t.$maxCols
  };
  return Bne(e);
}};
  grid-row: ${(t) => t.$row};
  height: ${(t) => t.$isSpacer ? "1em" : "auto"};
  width: ${(t) => t.$isSplitPageChildCell && t.$isInLandscape ? "90%" : "100%"};
  --cell-background: "unset";
  --cell-background-repeat: no-repeat;
  --cell-background-position: center;
  --cell-background-size: cover;
  --cell-opacity: 1;
  --cell-blur: 0;
  &::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    visibility: visible;
    background: var(--cell-background);
    background-repeat: var(--cell-background-repeat);
    background-position: var(--cell-background-position);
    background-size: var(--cell-background-size);
    filter: blur(var(--cell-blur)) opacity(var(--cell-opacity));
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    max-width: 100%;
    max-height: 100%;
  }
  ${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.$filter
})}`};
  ${(t) => t.$isSplitPageChildCell ? "padding: 0;" : ""}
  ${(t) => t.$isSplitPageChildCell ? "justify-self: center;" : ""}
  ${(t) => t.$isInLandscape ? "" : "padding-inline: 0;"}
 
`, Vne = Qo(!0);
function Une({
  gridObject: t,
  idx: e,
  inEditMode: n,
  isPreviewer: r,
  alignCellAsColumn: i,
  isSplitPageChildCell: o
}) {
  const s = L(bi), a = L(Fo(s)), l = L(gr), u = L(jt), c = L(wi), f = u.landscape, d = u.baseFontSize, h = L(Ut), p = t.columnTitleAtomId;
  let g;
  const m = (v) => ({
    ...v,
    paragraph: v.table
  });
  if (p !== void 0) {
    const v = L(fn(Xt(h, p)));
    typeof v?.data?.content == "string" && (g = v.data.content);
  }
  return /* @__PURE__ */ D.jsx(Rn, { theme: m, children: /* @__PURE__ */ D.jsx(Lne.Provider, { value: !0, children: /* @__PURE__ */ D.jsx(Vne.Provider, { value: !0, children: /* @__PURE__ */ D.jsx(
    jne,
    {
      $alignCellAsColumn: i,
      $baseFontSize: d,
      $column: t.col,
      $filter: a.tableCell,
      $fonts: l,
      $inEditMode: n,
      $constrainDimensions: c,
      $isInLandscape: f,
      $isPreviewer: r,
      $isSplitPageChildCell: o,
      $isSplitCell: t.isSplitCell,
      $lastColInRow: t.lastColInRow,
      $lastRowInGrid: t.lastRowInGrid,
      $maxCols: t.maxCols,
      $maxRows: t.maxRows,
      $row: t.row,
      $isSpacer: t.isSpacer,
      className: `${pe.css.styledGridCell} `,
      id: `grid-cell${e}-col-${t.col}-row-${t.row}`,
      role: "cell",
      "data-label": g,
      children: t.elArray
    },
    `grid-cell${e}-col-${t.col}-row-${t.row}-${h}`
  ) }) }) });
}
const qne = new Ps();
function m3(t) {
  switch (t) {
    case "middleOut":
      return "center";
    case "topDown":
      return "start";
    case "bottomUp":
      return "end";
    default:
      return "center";
  }
}
const y3 = rt.div.withConfig({
  displayName: "RenderGrid__StyledGrid",
  componentId: "sc-yz4c0g-0"
})`
  display: grid;
  align-items: ${(t) => m3(t.theme.grid.startingPoint)};
  justify-items: ${(t) => t.theme.grid.align};
  grid-template-rows: ${(t) => t.$isSplitPageChild && !t.$isInLandscape ? `repeat(${t.$maxRows}, 1fr)` : "auto"};;
  grid-template-columns: ${(t) => t.$isInLandscape ? `repeat(${t.$maxCols}, 1fr)` : t.$isResponsiveTable ? "auto" : "1fr"};
  column-gap: ${(t) => t.theme.grid.columnGap ? `${t.theme.grid.columnGap * t.$baseFontSize}px` : "unset"};
  row-gap: ${(t) => t.theme.grid.rowGap && t.$isInLandscape ? `${t.theme.grid.rowGap * t.$baseFontSize}px` : "unset"};;
  // after days of messing a decision. The user must fill the grid. No adding height on mobile
  // min-height: 100% is nice on mobile but it messes the layouts..
  ${(t) => t.$isInLandscape ? "max-height: 100%;" : "height: 100%;"} 
  position: relative;
  z-index: 0;
  ${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  theme: t.theme.grid
})}`}
  max-width: 100%;
  max-height: ${(t) => t.$isInLandscape ? "100%" : "unset"};
  height: ${(t) => t.$isInLandscape ? "100%" : "auto"}; 
  width: 100%;
  ${(t) => t.$isInLandscape ? "min-height: 0" : ""};
  .overlay {
    position: absolute;
    display: grid;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    grid-gap: inherit;
    pointer-events: none;
  }
  .overlay>* {
    background-size: cover;
    opacity: 0.1;
    border:  ${(t) => t.$inEditMode ? `2px solid ${Ot.yellow}` : "unset"};
  }
   ${(t) => t.$isInLandscape ? "" : "padding-inline: 0;"}
 `;
function v3({
  gridArray: t,
  alignCellsAsColumn: e,
  setGridHasRenderedCallback: n,
  isSplitPageChild: r
}) {
  const i = L(jt), o = L(Ea), s = L(wi), a = L(er), l = L(zn), u = i.baseFontSize, c = L(Ut), f = L(Mi), d = L(gr), h = t.length > 0 && t[0].isResponsiveTable, p = `${pe.css.grid} ${r ? pe.css.splitPage : ""} ${h ? "responsive-table-grid" : ""}`, g = L(Sa), m = t.some((w) => w.elArray.some((E) => E.props.type === "image:")), v = qne.getEngine().name === "WebKit", S = t.map((w, E) => {
    const x = h ? Une : g3;
    return /* @__PURE__ */ D.jsx(x, { gridObject: w, idx: E, isPreviewer: l, inEditMode: o, isSplitPageChildCell: r, alignCellAsColumn: e }, `cell-${E}-${c}`);
  }), _ = Xe(null);
  let b = L(jt).landscape;
  return b = f.grid.singleColumnInPortrait ? b : !0, Bn(() => {
    const w = document.createElement("div");
    return !l && a && (() => {
      if (!_.current) return;
      const x = _.current;
      w.className = "overlay", w.style.gridTemplateRows = window.getComputedStyle(x, null).getPropertyValue("grid-template-rows"), w.style.gridTemplateColumns = window.getComputedStyle(x, null).getPropertyValue("grid-template-columns"), x.appendChild(w);
      const k = w.style.gridTemplateColumns.split(" ").length, C = w.style.gridTemplateRows.split(" ").length;
      for (let M = 0; M < k * C; M++) {
        const F = document.createElement("div");
        w.appendChild(F);
      }
      w.style.gridTemplateRows = window.getComputedStyle(x, null).getPropertyValue("grid-template-rows"), w.style.gridTemplateColumns = window.getComputedStyle(x, null).getPropertyValue("grid-template-columns");
    })(), () => {
      w.remove();
    };
  }, [t, a, l]), Bn(() => {
    n && n(!0);
  }, [t, n, g]), t.length === 0 ? /* @__PURE__ */ D.jsx(D.Fragment, {}) : /* @__PURE__ */ D.jsx(y3, { role: h ? "table" : "grid", $alignCellsAsColumn: !1, $baseFontSize: u, $fonts: d, $gridContainsImages: m, $inEditMode: o, $constrainDimensions: s, $isInLandscape: b, $isPreviewer: l, $isSplitPageChild: r, $isWebkit: v, $isResponsiveTable: h, $maxCols: t[0].maxCols, $maxRows: t[0].maxRows, className: p, ref: _, children: /* @__PURE__ */ D.jsx(E2.Provider, { value: !0, children: S }) }, `styledGrid-${c}`);
}
const zne = rt.header.withConfig({
  displayName: "RenderSticky__StyledStickyOuter",
  componentId: "sc-ts62re-0"
})`
	visibility: hidden; /* Initially hidden, GSAP will manage visibility */
	width: ${(t) => t.$constrainDimensions ? "100%" : "100vw"};
	width: ${(t) => t.$constrainDimensions ? "100%" : "100svw"};
	${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.$position === "top" ? t.theme.stickyHeader : t.theme.stickyFooter
})}`};
`, Hne = rt.div.withConfig({
  displayName: "RenderSticky__StyledSticky",
  componentId: "sc-ts62re-1"
})`
	align-items: ${(t) => m3(t.theme.startingPoint)};
	display: grid;
	grid-template-columns: ${(t) => `repeat(${t.$maxCols || 1}, 1fr)`};
	position: relative;
	margin: auto;
	width: ${(t) => t.width}px;
	pointer-events: auto;
`;
function Gne({
  gridArray: t,
  position: e
}) {
  const n = L(jt), r = L(Ea), i = L(zn), o = n.baseFontSize, s = L(wi), a = L(gr), l = t.length === 0, u = L(Mi), c = Xe(null);
  Pne({
    elRef: c,
    isEmpty: l
  }), lt(() => {
    const g = c.current;
    return () => {
      g && Pe.killTweensOf(g);
    };
  }, []);
  const f = l ? u.background : e === "top" ? u.stickyHeader.background : u.stickyFooter.background;
  lt(() => {
    s || uc(f);
  }, [s, f]);
  const d = t.map((g, m) => /* @__PURE__ */ D.jsx(g3, { gridObject: g, idx: m, isPreviewer: i, inEditMode: r, alignCellAsColumn: !0 }, `cell-${g.row}-${g.col}`)), h = Xe(null), p = t.reduce((g, m) => m.col > g ? m.col : g, 0);
  return /* @__PURE__ */ D.jsx(Rn, { theme: u, children: /* @__PURE__ */ D.jsx(zne, { ref: c, as: e === "bottom" ? "footer" : "header", $isEmpty: l, $baseFontSize: o, $constrainDimensions: s, $fonts: a, $isPreviewer: i, $position: e, "data-sticky-position": e, children: /* @__PURE__ */ D.jsx(Hne, { ref: h, className: `${pe.css.stickyHeader} `, $maxCols: p, width: n.width, children: /* @__PURE__ */ D.jsx(E2.Provider, { value: !0, children: d }) }) }) });
}
const g2 = Qo(!1);
function Wne({
  position: t
}) {
  const e = un(r2), n = un(i2), r = L(cy), i = L(dS), o = t === "top" ? r : i, s = la(() => p3(o, !0, !0), [o]);
  return lt(() => {
    const a = s.reduce((l, u) => u.col > l ? u.col : l, 1);
    return e(a), () => e(0);
  }, [s, e]), lt(() => {
    const a = s.reduce((l, u) => u.row > l ? u.row : l, 1);
    return n(a), () => n(1);
  }, [s, n]), /* @__PURE__ */ D.jsx(g2.Provider, { value: !0, children: /* @__PURE__ */ D.jsx(Gne, { gridArray: s, position: t }) });
}
function Yne({
  elRef: t,
  direction: e,
  pageIndex: n,
  numberOfPages: r,
  isInAuthor: i,
  isPreviewer: o,
  navigationType: s,
  position: a,
  isInPlayWrightTest: l
}) {
  const u = a === "left", c = a === "right", f = e === "forward", d = e === "back", h = L(Ut), p = kt(g2), g = un(One);
  lt(() => {
    if (r === 1 || o || l || i || p || s !== "tap") return;
    let m;
    const v = Pe.timeline({
      onComplete: () => {
        (f && c || // Navigating forward, this is the incoming page
        d && u) && document.getElementById(`display-elements-children-${n}`)?.focus({
          preventScroll: !0
        });
      }
    });
    return v.eventCallback("onUpdate", () => {
      g(v.progress());
    }), t.current && (m = Pe.context(() => {
      if (f) {
        if (n === 1 && h === 1) {
          u && v.set(t.current, {
            x: "-200%",
            autoAlpha: 0,
            ease: "sine.in"
          });
          return;
        }
        u && v.fromTo(t.current, {
          x: 0,
          autoAlpha: 1
        }, {
          x: "-200%",
          autoAlpha: 0,
          ease: "sine.in"
        }), c && (v.call(() => {
          t.current?.removeAttribute("aria-hidden");
        }, [], "<"), v.from(t.current, {
          x: "200%",
          autoAlpha: 0,
          ease: "sine.in"
        }, "<"));
      }
      d && (u && (v.call(() => {
        t.current?.removeAttribute("aria-hidden");
      }), v.fromTo(t.current, {
        x: "-200%",
        autoAlpha: 0
      }, {
        x: 0,
        autoAlpha: 1,
        ease: "sine.in"
      })), c && v.to(t.current, {
        x: "200%",
        autoAlpha: 0,
        ease: "sine.in"
      }));
    })), () => {
      m && m.revert();
    };
  }, [t, s, r, i, n, o, l, p, h, f, d, u, c, g]);
}
function b3({
  direction: t,
  elRef: e,
  filter: n,
  isInAuthor: r,
  isInLandscape: i,
  isInPlayWrightTest: o,
  isOverflowing: s,
  isPreviewer: a,
  navigationType: l,
  numberOfPages: u,
  onePercent: c,
  pageIndex: f,
  position: d,
  tapIdContainers: h,
  scrollerRef: p
}) {
  const g = Rne({
    elRef: e,
    isInAuthor: r,
    isInPlayWrightTest: o,
    isPreviewer: a,
    navigationType: l,
    pageIndex: f,
    scrollerRef: p
  });
  return Yne({
    direction: t,
    elRef: e,
    isInAuthor: r,
    isInPlayWrightTest: o,
    isPreviewer: a,
    navigationType: l,
    numberOfPages: u,
    pageIndex: f,
    position: d
  }), g;
}
function Xne({
  rowsIndices: t,
  endOfGridIndices: e,
  splitIndices: n,
  numberOfLines: r,
  getPageSplits: i
}) {
  let o = !1;
  const s = [];
  for (let a = 0; a <= r; a++)
    t.find((l) => l === a) !== void 0 && (o = !0), e.find((l) => l === a) !== void 0 && (o = !1), n.find((l) => l == a) !== void 0 && o && s.push(a);
  return n.length === 0 ? n : n.filter((a) => !s.includes(a));
}
function Kne({
  elements: t
}) {
  const e = y3.styledComponentId, n = L(jt).landscape, r = un(gne), i = un(r2), o = un(i2), s = L(o3), a = p3(t, n, s);
  return lt(() => {
    const l = a.reduce((u, c) => c.col > u ? c.col : u, 1);
    return i(l), () => i(0);
  }), lt(() => {
    r(e);
  }), lt(() => {
    const l = a.reduce((u, c) => c.row > u ? c.row : u, 1);
    return o(l), () => o(1);
  }), /* @__PURE__ */ D.jsx(v3, { gridArray: a, alignCellsAsColumn: !1 });
}
const SO = rt.div.withConfig({
  displayName: "DisplayGrid__StyledGridElements",
  componentId: "sc-10j7e7e-0"
})`
  align-items: ${(t) => t.theme.align};
  display: grid;
  grid-template-columns : 1fr;
  grid-template-rows : auto;
  align-items: ${(t) => Ru(t.theme.cell.startingPoint, !1, t.$isInLandscape)};
  justify-items: ${(t) => t.theme.cell.align};
  height: ${(t) => t.$isInFlexBox ? "unset" : "100%"};
  justify-content: ${(t) => Ru(t.theme.startingPoint, t.$isOverflowing, t.$isInLandscape)}; 
  width: 100%;
  min-height: 0;
  min-width: 0;
  ${(t) => t.$position === "top" && !t.$isInLandscape ? `
        overflow-y: scroll;
        z-index:1;
        &::-webkit-scrollbar {
        display: none;
        }` : ""}
`;
function w3({
  pageElementsToDisplay: t
}) {
  const e = L(bi), n = L(Fo(e)), r = L(wi), i = L(zn), o = L(op), s = t.filter((w) => w.props.type === _t["---"].controlChar), a = t.filter((w) => w.props.type === _t["-->"].controlChar)[0], l = L(Ut), u = L(Sa), c = Xe(null), [f, d] = Cn(!1), h = kt(tr), p = kt(mi), g = o.baseFontSize;
  lt(() => {
    const w = document.getElementsByClassName(SO.styledComponentId);
    for (const E of Array.from(w))
      E0(E);
  });
  const m = s[0], v = t.indexOf(m), S = t.indexOf(a) === -1 ? t.length - 1 : t.indexOf(a), _ = t.slice(0, v), b = t.slice(S + 1), y = t.slice(v, S + 1);
  return Bn(() => {
    if (c.current) {
      const w = c.current.scrollHeight, E = c.current.clientHeight, x = w > E;
      d(x);
    }
  }, [o, t, l, u]), /* @__PURE__ */ D.jsx(Rn, { theme: n, children: /* @__PURE__ */ D.jsx(E2.Provider, { value: !0, children: /* @__PURE__ */ D.jsxs(SO, { $baseFontSize: g, "data-testid": "DisplayGrid", className: pe.css.displayGrid, $isOverflowing: f, $isPreviewer: i, $constrainDimensions: r, $isInFlexBox: h, $isInLandscape: o.landscape, $position: p, ref: c, children: [
    _,
    /* @__PURE__ */ D.jsx(Kne, { elements: y }),
    b
  ] }, `grid-${l}`) }) });
}
const m2 = Qo(!1);
function Qne({
  pageSections: t,
  setGridHasRenderedCallback: e
}) {
  const [n, r] = Cn([]), i = L(jt).landscape, o = L(Ut);
  return Bn(() => {
    const s = [];
    t.forEach((a, l) => {
      const u = a.filter((f) => f.props.type === _t["---"].controlChar);
      let c = a;
      u.length > 0 && (c = [/* @__PURE__ */ D.jsx(w3, { pageElementsToDisplay: a }, `styledGrid-${o}`)]), s.push({
        col: i ? l + 1 : 1,
        row: i ? 1 : l + 1,
        maxCols: t.length,
        maxRows: 1,
        isSplitCell: !1,
        lastRowInGrid: !0,
        elArray: c,
        lastColInRow: l + 1 === t.length
      }), r(s);
    });
  }, [t, i, o]), /* @__PURE__ */ D.jsx(m2.Provider, { value: !0, children: /* @__PURE__ */ D.jsx(v3, { gridArray: n, alignCellsAsColumn: !0, setGridHasRenderedCallback: e, isSplitPageChild: !0 }) });
}
const Jne = rt.section.withConfig({
  displayName: "SafariWrapper__StyledSafariWrapper",
  componentId: "sc-1rinsrh-0"
})`
  display: grid;
  align-items: center;
  justify-items: center;
  position: ${(t) => t.$navigationType === "scroll" ? "relative" : "absolute"};
  height: ${(t) => t.$navigationType === "scroll" && !t.$isInLandscape ? "auto" : `${t.$height}px`};
  width: ${(t) => t.$hasWidescreen ? "100%" : `${t.$width}px`};
`, S3 = ({
  variant: t,
  "aria-hidden": e,
  children: n,
  $hasWidescreen: r
}) => {
  const i = L(op), o = L(vi), s = L(zn), a = kt(mi), l = `${t === "elements" ? "display-elements-safari-wrapper" : "display-split-page-safari-wrapper"} ${a} ${s ? "previewer" : ""}`;
  return /* @__PURE__ */ D.jsx(Jne, { $height: i.height, $width: i.width, $navigationType: o, id: pe.css.safariWrapper, className: l, "aria-hidden": e, $hasWidescreen: r, $isInLandscape: i.landscape, children: n });
}, _O = rt.section.withConfig({
  displayName: "DisplaySplitPage__StyledSplitPageElements",
  componentId: "sc-2paxgc-0"
})`
  display: flex;
  flex-direction: column;
  height: ${(t) => t.$navigationType === "scroll" ? "auto" : "100%"};
  justify-self: center;
  overflow-y: ${(t) => t.$isInLandscape || t.$navigationType === "scroll" ? "hidden" : "visible"};
  width: ${(t) => t.$width}px;
  padding: 0;
  ${(t) => `${f3({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme,
  isOverflowing: t.$isOverflowing ? t.$isOverflowing : !1,
  isInLandscape: t.$isInLandscape ? t.$isInLandscape : !1,
  stickyHeaderHeight: t.$stickyHeaderHeight
})}`};
   
   ${(t) => t.$navigationType === "scroll" || t.$isPreviewer || t.$isInPlayWrightTest ? "" : "position: absolute;"} 
  ${(t) => t.$hasWidescreen && "padding: 0;"}
`;
function Zne(t, e) {
  const n = [];
  let r = 0;
  for (const i of e)
    n.push(t.slice(r, i)), r = i;
  return n.push(t.slice(r)), n;
}
function ere({
  pageElementsToDisplay: t,
  pageIndex: e,
  pageSplits: n,
  scrollerRef: r
}) {
  const i = L(op), o = i.baseFontSize, s = L(gi), a = L(bi), l = L(Fo(a)), u = L(wi), c = i.landscape, f = L(Sf), d = L(zn), h = L(vi), p = L($u), g = Xe(null), m = Zne(t, n), [v, S] = Cn(!1), _ = kt(mi), b = L(Sa), [y, w] = Cn(!1), E = L(n2), x = L(er), k = L(_h(e)), C = b3({
    direction: s,
    elRef: g,
    filter: l,
    isInAuthor: x,
    isInLandscape: i.landscape,
    isInPlayWrightTest: f,
    isOverflowing: v,
    isPreviewer: d,
    navigationType: h,
    numberOfPages: p,
    onePercent: {
      width: i.onePercentWidth,
      height: i.onePercentHeight
    },
    pageIndex: e,
    position: _,
    tapIdContainers: k,
    scrollerRef: r
  }), M = L(t2(e));
  return lt(() => {
    const F = document.getElementsByClassName(_O.styledComponentId);
    for (const U of Array.from(F))
      E0(U);
  }), Bn(() => {
    if (g.current) {
      const F = g.current.scrollHeight, U = g.current.clientHeight, B = F > U;
      S(B);
    }
  }, [i, t, e, b, y]), /* @__PURE__ */ D.jsx(S3, { variant: "split-page", $hasWidescreen: M, children: /* @__PURE__ */ D.jsx(T2.Provider, { value: C, children: /* @__PURE__ */ D.jsx(Rn, { theme: l, children: /* @__PURE__ */ D.jsx(_O, { tabIndex: -1, $isPreviewer: d, $isOverflowing: v, $baseFontSize: o, $height: i.height, $constrainDimensions: u, $isInLandscape: c, $isInPlayWrightTest: f, $navigationType: h, $width: i.width, className: `display-split-page ${_} ${d ? "previewer" : ""}`, "data-testid": "DisplaySplitPage", ref: g, $stickyHeaderHeight: E, id: `display-elements-children-${e}`, $hasWidescreen: M, children: /* @__PURE__ */ D.jsx(Qne, { pageSections: m, setGridHasRenderedCallback: w }) }, `splitPage-${e}}`) }) }) });
}
const EO = rt.div.withConfig({
  displayName: "DisplayElementsChildren__StyledDisplayElements",
  componentId: "sc-1adf241-0"
})`
  display: grid;
  position: ${(t) => t.$navigationType === "scroll" ? "relative" : "absolute"};
	height: ${(t) => t.$navigationType === "scroll" && !t.$isInLandscape ? "100%" : `${t.$height}px`};
  width:100%;
  grid-auto-columns: 1fr; 
  ${(t) => `${f3({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme,
  isOverflowing: t.$isOverflowing ? t.$isOverflowing : !1,
  isInLandscape: t.$isInLandscape ? t.$isInLandscape : !1,
  stickyHeaderHeight: t.$stickyHeaderHeight
})}`};
  align-content: ${(t) => Ru(t.theme.startingPoint, t.$isOverflowing, t.$isInLandscape)};
  padding-top: ${(t) => t.$stickyHeaderHeight}px;
  ${(t) => t.$hasWidescreen && "padding: 0;"}
`, hy = Hr(({
  pageElementsToDisplay: t,
  pageIndex: e,
  "aria-hidden": n,
  scrollerRef: r
}) => {
  const i = L(op), o = i.baseFontSize, {
    contextSafe: s
  } = so(), a = L(gi), l = s(Pe.timeline), u = L(bi), c = L(Fo(u)), f = L(gr), d = L(wi), h = L(zn), p = L(Sf), g = L(er), m = L(vi), v = L($u), S = Xe(null), _ = kt(mi), b = t.filter((Q) => Q.props.type === _t["---"].controlChar), [y, w] = Cn(!1), E = L(Sa), x = L(_h(e)), k = L(i3), C = L(n2), M = L(t2(e)), F = b3({
    direction: a,
    elRef: S,
    filter: c,
    isInAuthor: g,
    isInLandscape: i.landscape,
    isInPlayWrightTest: p,
    isOverflowing: y,
    isPreviewer: h,
    navigationType: m,
    numberOfPages: v,
    onePercent: {
      width: i.onePercentWidth,
      height: i.onePercentHeight
    },
    pageIndex: e,
    position: _,
    tapIdContainers: x,
    scrollerRef: r
  });
  lt(() => {
    const Q = document.getElementsByClassName(EO.styledComponentId);
    for (const ne of Array.from(Q))
      E0(ne);
  }), Bn(() => {
    if (S.current) {
      const Q = S.current.scrollHeight, ne = S.current.clientHeight, X = Q > ne;
      i.landscape || w(X);
    }
  }, [i, t, e, E]);
  const U = [];
  t.forEach((Q, ne) => {
    Q.props.type === _t["|"].controlChar && U.push(ne);
  });
  const B = [];
  t.forEach((Q, ne) => {
    Q.props.type === _t["---"].controlChar && B.push(ne);
  });
  const N = [];
  t.forEach((Q, ne) => {
    Q.props.type === _t["-->"].controlChar && N.push(ne);
  });
  const q = Xne({
    rowsIndices: B,
    splitIndices: U,
    endOfGridIndices: N,
    numberOfLines: t.length,
    getPageSplits: !0
  });
  return q.length > 0 ? /* @__PURE__ */ D.jsx(ere, { pageElementsToDisplay: t, pageIndex: e, pageSplits: q, scrollerRef: r }) : /* @__PURE__ */ D.jsx(S3, { variant: "elements", "aria-hidden": n, $hasWidescreen: M, children: /* @__PURE__ */ D.jsx(T2.Provider, { value: F, children: /* @__PURE__ */ D.jsx(Rn, { theme: c, children: /* @__PURE__ */ D.jsxs(q3.Provider, { value: l(), children: [
    k && /* @__PURE__ */ D.jsxs("div", { style: {
      background: "white",
      color: "black",
      zIndex: 1e3
    }, children: [
      _,
      /* @__PURE__ */ D.jsx("br", {}),
      a
    ] }),
    /* @__PURE__ */ D.jsx(EO, { role: "none", tabIndex: -1, ref: S, $baseFontSize: o, $fonts: f, $height: i.height, $constrainDimensions: d, $isInLandscape: i.landscape, $isOverflowing: y, $isPreviewer: h, $stickyHeaderHeight: C, $width: i.width, $navigationType: m, className: `display-elements-children ${_} ${h ? "previewer" : ""}`, id: `display-elements-children-${e}`, "data-testid": "DisplayElementsChildren", $hasWidescreen: M, children: b.length > 0 ? /* @__PURE__ */ D.jsx(w3, { pageElementsToDisplay: t }) : t }, `DisplayElements-${e}-${_}`)
  ] }) }) }) });
});
function tre() {
  const t = L(Ut), e = L(wl(t));
  return /* @__PURE__ */ D.jsx(D.Fragment, { children: /* @__PURE__ */ D.jsx(mi.Provider, { value: "top", children: /* @__PURE__ */ D.jsx(hy, { pageElementsToDisplay: e, pageIndex: t }, `preview-${t}`) }) });
}
Pe.registerPlugin(gt);
function nre() {
  const t = un(Ut), e = un(QQ), r = L(Zo).length;
  return Bn(() => {
    const i = document.querySelector("#scroll-elements-container");
    if (!i)
      return;
    const o = Pe.context(() => {
      t(1), e(0);
      for (let a = 1; a <= r; a++) {
        const l = document.querySelector(`#scroll-page-${a}`);
        l && gt.create({
          trigger: l,
          scroller: i,
          start: "top center",
          end: "bottom center",
          scrub: !0,
          onToggle: (u) => {
            u.isActive && t(a);
          },
          onUpdate: (u) => {
            u.isActive && e(u.progress);
          }
        });
      }
      const s = setTimeout(() => {
        gt.refresh();
      }, 100);
      return () => clearTimeout(s);
    });
    return () => o.revert();
  }, [r, t, e]), null;
}
let y2 = (t = 21) => {
  let e = "", n = crypto.getRandomValues(new Uint8Array(t));
  for (; t--; ) {
    let r = n[t] & 63;
    r < 36 ? e += r.toString(36) : r < 62 ? e += (r - 26).toString(36).toUpperCase() : r < 63 ? e += "_" : e += "-";
  }
  return e;
};
function rre({
  text: t
}) {
  const n = t.split(" ").map((r) => {
    const i = r.slice(0, r.length / 2), o = r.slice(r.length / 2);
    return /* @__PURE__ */ D.jsxs("span", { children: [
      /* @__PURE__ */ D.jsx("span", { className: "neuro-divergent-letter-bold", children: i }),
      /* @__PURE__ */ D.jsx("span", { children: o }),
      " "
    ] }, y2());
  });
  return /* @__PURE__ */ D.jsx("div", { className: "neuro-divergent-sentence", children: n });
}
const ire = function({
  atomId: t,
  pageIndex: e
}) {
  const n = Xt(e, t), r = L(fn(n)).data, i = un(Ah);
  return lt(() => {
    if (r.type !== "autoplay:") return;
    const o = r.content && typeof r.content == "string" ? parseFloat(r.content) : !1, s = r?.modifier && r.modifier["loop:"] === "forever" ? r.modifier["loop:"] : "once";
    i({
      autoPlay: o,
      loop: s
    });
  }), /* @__PURE__ */ D.jsx(D.Fragment, {});
}, ore = function({
  atomId: t,
  pageIndex: e
}) {
  const n = Xt(e, t), r = L(fn(n)).data, i = un(r3);
  return lt(() => {
    if (r.type !== "autospace:") return;
    const o = r.content && typeof r.content == "string" ? r.content : "on";
    i(o !== "off");
  }), /* @__PURE__ */ D.jsx(D.Fragment, {});
};
function sre({
  target: t,
  pageIndex: e,
  position: n,
  atomId: r
}) {
  const i = n === "left", o = n === "right", s = kt(g2), a = kt(T2), l = L(gi), u = L(er), c = L(zn), f = L(Sf), d = L(vi), h = Xt(e, r), p = L(fn(h))?.data, g = p?.modifier?.["opacity:"] ? p.modifier["opacity:"] : "1";
  lt(() => {
    const m = typeof t == "string" ? t : t.current;
    (f || u) && m && Pe.set(m, {
      autoAlpha: 1
    });
  }), Bn(() => {
    if (d !== "tap" || s || c || f) return;
    let m;
    const v = Pe.timeline(), S = typeof t == "string" ? t : t.current;
    return S && (m = Pe.context(() => {
      l === "init" && (i && Pe.set(S, {
        autoAlpha: 1
      }), o && Pe.set(S, {
        autoAlpha: 0
      })), l === "back" && (o && (v.set(S, {
        autoAlpha: 1
      }), v.to(S, {
        autoAlpha: 0
      })), i && (v.set(S, {
        autoAlpha: 0
      }), v.to(S, {
        autoAlpha: g || 1
      }))), l === "forward" && (i && v.set(S, {
        autoAlpha: 0
      }), o && (v.set(S, {
        autoAlpha: 0
      }), v.to(S, {
        autoAlpha: g || 1
      })));
    }), f && Pe.set(S, {
      autoAlpha: 1
    })), () => {
      m && m.revert();
    };
  }, [l, t, c, f, d, s, g, i, o]), Bn(() => {
    const m = pe.navigation.idStoryBackgroundTop, v = pe.navigation.idStoryBackgroundBottom;
    if (s || c || f || u || d !== "scroll" && d !== "scrollCards" && d !== "scrollContinuous" || n !== "top" || !a) return;
    const S = Pe.context(() => {
      Pe.killTweensOf([m, v]), Pe.set(m, {
        autoAlpha: 1
      }), Pe.set(v, {
        autoAlpha: 0
      }), a.to(m, {
        autoAlpha: 0,
        duration: 0.49
      }, 0.5), a.to(v, {
        autoAlpha: 1,
        duration: 0.49
      }, 0.5);
    });
    return () => S.revert();
  }, [a, n, s, c, f, u, d]);
}
const are = {
  thin: "100",
  "extra light": "200",
  light: "300",
  normal: "400",
  medium: "500",
  "semi bold": "600",
  bold: "700",
  "extra bold": "800",
  heavy: "900",
  "ultra heavy": "950"
}, oi = (t, e) => {
  const n = Number.parseFloat(t);
  return Number.isNaN(n) ? t : `${n * e}px`;
}, Qb = (t, e) => e[t] || t, lre = {
  "across:": ({
    keyword: t,
    value: e,
    onePercentWidth: n
  }) => {
    if (!n) return "";
    let r = `position: absolute; left: ${oi(e, n)};`;
    return t === "image:" && (r += "height: unset;"), r;
  },
  "align:": ({
    keyword: t,
    value: e
  }) => {
    const r = {
      across: "unset",
      bottom: "end",
      center: "center",
      down: "unset",
      left: "start",
      right: "end",
      top: "start"
    }[e] || e;
    return t === "image:" ? `justify-self: ${r}; align-items: ${r};` : `text-align: ${e}; justify-self: ${r}; justify-content: ${r}; align-self: ${r};`;
  },
  "anchor:": ({
    keyword: t,
    value: e,
    isInFlexBox: n
  }) => {
    const i = {
      across: "unset",
      bottom: "end",
      center: "center",
      down: "unset",
      left: "flex-start",
      right: "flex-end",
      top: "start"
    }[e] || e;
    return t === "image:" ? `justify-content: ${i};` : n ? `align-self: ${i};` : `align-self: ${i};`;
  },
  "animate:": () => "",
  "animateStart:": () => "",
  "background:": ({
    value: t,
    filterColors: e
  }) => `background-color: ${Qb(t, e)};`,
  "border-color:": ({
    value: t,
    filterColors: e
  }) => `border-style: solid; border-color: ${Qb(t, e)};`,
  "border-thickness:": ({
    value: t,
    baseFontSize: e
  }) => `border-style: solid; border-width: ${oi(t, e)};`,
  "blur:": ({
    keyword: t,
    value: e
  }) => {
    if (!e) return "filter: none;";
    const n = Number.parseInt(e) / 20;
    return t === "box:" ? `backdrop-filter: blur(${n}rem);` : `filter: blur(${n}rem);`;
  },
  "color:": ({
    keyword: t,
    value: e,
    filterColors: n
  }) => {
    const r = Qb(e, n);
    return t === "line:" ? `
        .hr-text {
          &:before {
            background: linear-gradient(to right, transparent, ${r}, transparent);
          }
          &:after {
            color: ${r};
          }
        }
      ` : `color: ${r};`;
  },
  "columns:": ({
    value: t,
    isInPortrait: e
  }) => `column-count: ${e ? 1 : t};`,
  "corner-radius:": ({
    value: t,
    baseFontSize: e
  }) => `border-radius: ${oi(t, e)};`,
  "decoration:": ({
    value: t
  }) => `text-decoration-line: ${t};`,
  "down:": ({
    keyword: t,
    value: e,
    onePercentHeight: n
  }) => {
    if (!n) return "";
    let r = `position: absolute; top:  ${oi(e, n)};`;
    return t === "image:" && (r += "height: unset;"), r;
  },
  "font:": ({
    value: t
  }) => `font-family: ${t};`,
  "height:": ({
    value: t,
    onePercentHeight: e
  }) => `height:  ${oi(t, e)};max-height:  ${oi(t, e)};`,
  "hideOn:": ({
    value: t,
    pageSize: e
  }) => t === Gx[0] && e.landscape || t === Gx[1] && !e.landscape ? "display: none;" : "",
  "line-height:": ({
    value: t,
    baseFontSize: e
  }) => `line-height: ${oi(t, e)};`,
  "opacity:": ({
    keyword: t,
    value: e
  }) => {
    if (!e) return "opacity: unset;";
    const n = Number.parseInt(e) / 100;
    return t === "box:" ? "" : `opacity: ${n};`;
  },
  "padding:": ({
    value: t,
    baseFontSize: e
  }) => `padding: ${oi(t, e)};`,
  "padding-bottom:": ({
    value: t,
    baseFontSize: e
  }) => `padding-block-end: ${oi(t, e)};`,
  "padding-left:": ({
    value: t,
    baseFontSize: e
  }) => `padding-inline-start: ${oi(t, e)};`,
  "padding-right:": ({
    value: t,
    baseFontSize: e
  }) => `padding-inline-end: ${oi(t, e)};`,
  "padding-top:": ({
    value: t,
    baseFontSize: e
  }) => `padding-block-start: ${oi(t, e)};`,
  "shadow:": ({
    value: t
  }) => t === hY[1] ? Sne() : d3(),
  "size:": ({
    keyword: t,
    value: e,
    baseFontSize: n
  }) => `${{
    "*:": "font-size",
    "background:": "background-size",
    "box:": "font-size",
    "paragraph:": "font-size",
    "subtitle:": "font-size",
    "supertitle:": "font-size",
    "title:": "font-size"
  }[t] || "font-size"}: ${oi(e, n)};`,
  "weight:": ({
    value: t
  }) => `font-weight: ${are[t] || "400"};`,
  "width:": ({
    value: t,
    onePercentWidth: e
  }) => `width:${oi(t, e)};max-width:${oi(t, e)};`
}, ure = ({
  keyword: t,
  modifier: e,
  baseFontSize: n,
  filterColors: r,
  pageSize: i,
  onePercentHeight: o,
  onePercentWidth: s,
  isInFlexBox: a,
  isInPortrait: l
}) => {
  if (!e) return "";
  let u = "";
  for (const [c, f] of Object.entries(e)) {
    if (typeof f != "string") continue;
    const d = lre[c];
    d && (u += d({
      keyword: t,
      value: f,
      baseFontSize: n,
      filterColors: r,
      pageSize: i,
      onePercentHeight: o,
      onePercentWidth: s,
      isInFlexBox: a,
      isInPortrait: l
    }));
  }
  return u;
}, zr = (t, {
  $modifier: e,
  $baseFontSize: n,
  $filterColors: r,
  $pageSize: i,
  $onePercentHeight: o,
  $onePercentWidth: s,
  $isInFlexBox: a,
  $isInPortrait: l
}) => ure({
  keyword: t,
  modifier: e,
  baseFontSize: n,
  filterColors: r,
  pageSize: i,
  onePercentHeight: o,
  onePercentWidth: s,
  isInFlexBox: a,
  isInPortrait: l
}), cre = ({
  pageIndex: t,
  atomId: e,
  isInAuthor: n
}) => {
  if (n) return "";
  const r = Xt(t, e), i = L(fn(r)).data.modifier;
  return i?.["effect:"] && NX.has(i["effect:"]) ? i["effect:"] : "";
};
function kS(t) {
  const e = t.url;
  return e || pe.messages.error;
}
const fre = rt.div.withConfig({
  displayName: "BackgroundGridCell__StyledCell",
  componentId: "sc-b49lxw-0"
})`
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  display: flex;
  --cell-opacity: ${(t) => t.$opacity ? t.$opacity : 1};
  --cell-blur: ${(t) => t.$blur ? t.$blur : 0};
  background: ${(t) => t.$isInGridCell ? "unset" : t.$background};
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  filter: blur(var(--cell-blur)) opacity(var(--cell-opacity));
  ${(t) => t.$hideOn === "desktop" && t.$pageSize.landscape || t.$hideOn === "mobile" && !t.$pageSize.landscape ? "display: none;" : ""};
`, dre = ({
  atomId: t,
  content: e,
  pageIndex: n,
  position: r,
  tapped: i,
  modifier: o,
  isInGridCell: s
}) => {
  e = e.trim();
  const a = L(jt), l = L(er), u = Xe(null), c = a.baseFontSize, f = L(gi), d = L(pr), h = cre({
    pageIndex: n,
    atomId: t,
    isInAuthor: l
  }), p = L(ip), g = L(_0), m = L(Sf), v = kt(m2), S = L(cy), _ = p.find((E) => E.userDefinedName === e);
  let b = "unset";
  !_ && typeof e == "string" && (d[e] ? b = d[e] : b = e), _ && (b = `url(${kS(_)})`);
  const y = _r(i, o?.["opacity:"]).toString(), w = o?.["blur:"] ? `${o["blur:"]}px` : "0";
  return Bn(() => {
    if (u.current && s) {
      const E = u.current?.closest(pe.css.styledGridCellClass);
      E && (E.style.setProperty("--cell-background", b), o?.["opacity:"] && E.style.setProperty("--cell-opacity", y), o?.["blur:"] && E.style.setProperty("--cell-blur", w));
    }
  }), Bn(() => {
    if (!(v || S.length > 0)) {
      if (_) {
        uc("#000");
        return;
      }
      f === "init" && r === "left" && setTimeout(() => uc(b), 10), f === "back" && r === "left" && uc(b), f === "forward" && r === "right" && uc(b);
    }
  }, [b, v, S.length, r, f, _]), /* @__PURE__ */ D.jsx(
    fre,
    {
      $background: b,
      $elementIndex: 0,
      $filterColors: d,
      $isInFlexBox: !0,
      $isInGridCell: s,
      $isInPLaywrightTest: m,
      $isInPopOut: g,
      $blur: w,
      $opacity: y,
      className: h,
      $hideOn: o?.["hideOn:"],
      $pageSize: a,
      $isInPortrait: !a.landscape,
      $tapped: i,
      $modifier: o,
      "data-testid": "background-grid-cell",
      ref: u,
      $baseFontSize: c
    }
  );
};
function hre(t, e, n) {
  return n && t && !e ? t ? "absolute" : "fixed" : t && !e ? "unset" : t ? "absolute" : "fixed";
}
function pre(t, e, n) {
  return n && t && !e ? "grid" : t && !e ? "none" : "grid";
}
const gre = rt.div.withConfig({
  displayName: "Background__StyledBackground",
  componentId: "sc-j1o9qu-0"
})`
  display:  ${(t) => pre(t.$constrainDimensions, t.$isInPopOut, t.$isInCell)};
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  grid-auto-flow: ${(t) => t.$pageSize.landscape ? "column" : "row"};
  min-width: 100%;
  min-height: 100vh;
  position: ${(t) => hre(t.$constrainDimensions, t.$isInPopOut, t.$isInCell)};
  top: 0;
  left: 0;
  ${(t) => `${zr("background:", t)}`}
  margin-block-start: 0 !important;
  pointer-events: none;
`;
function mre(t, e) {
  return e === "tap" ? t === "left" ? pe.navigation.idStoryBackgroundLeft : pe.navigation.idStoryBackgroundRight : t === "top" ? pe.navigation.idStoryBackgroundTop : pe.navigation.idStoryBackgroundBottom;
}
const yre = ({
  atomId: t,
  pageIndex: e
}) => {
  const n = L(Ut), r = L(vi), i = Xe(null), o = L(jt), [s, a] = Cn(!1), l = o.baseFontSize, u = Xt(e, t), c = L(fn(u)).data, f = L(_0), d = L(wi), h = L(pr), [p, g] = Cn();
  let m = la(() => [], []);
  const v = kt(mi), S = kt(m2), _ = kt(tr);
  let b = v;
  (r === "scroll" || r === "scrollCards" || r === "scrollContinuous") && (e === n ? b = "top" : e === n + 1 && (b = "bottom"));
  const y = mre(b, r);
  sre({
    target: s ? i : y,
    pageIndex: e,
    position: b,
    atomId: t
  }), Bn(() => {
    const k = r === "scroll", C = e === n || e === n + 1;
    if (k && !C || !c.tapped || !i.current)
      return;
    a(!1), g(void 0);
    const M = i.current, F = M.closest(pe.css.styledGridCellClass);
    if (F && !S) {
      a(!0), g(F);
      return;
    }
    const U = M.closest(".viewer-container");
    if (U) {
      const B = U.querySelector(y);
      B && g(B);
    }
  }, [c.tapped, S, y, n, e, r]), c.content && typeof c.content == "string" && (m = c.content.split(_t["|"].controlChar));
  const E = c.tapped, x = m.map((k, C) => /* @__PURE__ */ D.jsx(dre, { atomId: t, position: b, pageIndex: e, content: k, tapped: E, isInGridCell: s, modifier: c.modifier }, `split-background-${// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
  C}`));
  return r === "scroll" && e !== n && e !== n + 1 ? null : /* @__PURE__ */ D.jsxs(gre, { $background: "", $baseFontSize: l, $elementIndex: t, $filterColors: h, $constrainDimensions: d, $isInCell: s, $isInFlexBox: _, $isInPopOut: f, $modifier: c.modifier, $onePercentHeight: o.onePercentHeight, $onePercentWidth: o.onePercentWidth, $pageSize: o, $isInPortrait: !o.landscape, $tapped: E, "aria-hidden": !0, "aria-label": c.altText, className: `${pe.css.pageElement}  background`, ref: i, role: "img", children: [
    p && !s && I5(x, p),
    s && x
  ] });
}, vre = rt.div.withConfig({
  displayName: "Blank__StyledBlank",
  componentId: "sc-12lb21q-0"
})`
  min-height: ${(t) => t.$leading};
  height: ${(t) => t.$leading};
`, bre = (t) => t.blank, wre = ({
  atomId: t,
  pageIndex: e,
  isAutospaceElement: n
}) => {
  const i = L(jt).baseFontSize, o = L(r3), s = L(pne), a = Xt(e, t), l = L(fn(a)).data, u = L(bi), c = L(Fo(u)), f = kt(tr), d = Xt(e, t > 0 ? t - 1 : 0), h = L(fn(d)).data;
  let p = 0;
  if (n) {
    if (t === 0) return /* @__PURE__ */ D.jsx(D.Fragment, {});
    if (f) return /* @__PURE__ */ D.jsx(D.Fragment, {});
    if (!o) return /* @__PURE__ */ D.jsx(D.Fragment, {});
    if (!s) return /* @__PURE__ */ D.jsx(D.Fragment, {});
    if (h.lastElement) return /* @__PURE__ */ D.jsx(D.Fragment, {});
    const g = h.type.slice(0, -1), m = c[g];
    m ? p = wa(m, c.blank.leading) : p = `${i}px`;
  } else if (l.type === "blank:") {
    let g = 1;
    if (l.content && typeof l.content == "string") {
      const m = Number.parseInt(l.content, 10);
      Number.isNaN(m) || (g = m);
    }
    p = wa(c.blank, i, g);
  }
  return p ? /* @__PURE__ */ D.jsx(Rn, { theme: bre, children: /* @__PURE__ */ D.jsx(
    vre,
    {
      $leading: p,
      "aria-hidden": !0,
      className: `${pe.css.pageElement}  blank ${n ? "autospace" : ""}`
    }
  ) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, v2 = Hr(wre);
Pe.registerPlugin(so);
function Ls({
  elRef: t,
  modifier: e
}) {
  const n = L(jt);
  so(() => {
    if (t.current) {
      const r = e?.["across:"], i = e?.["down:"], o = t.current.offsetLeft, s = t.current.offsetTop;
      if (r && i && n.onePercentHeight && n.onePercentWidth) {
        const a = Number.parseInt(r) * n.onePercentWidth, l = Number.parseInt(i) * n.onePercentHeight;
        Pe.set(t.current, {
          position: "absolute",
          left: o,
          top: s
        }), Pe.to(t.current, {
          left: a,
          top: l,
          duration: 0.35,
          ease: "power1.out"
        });
      }
    }
  }, {
    dependencies: [e],
    revertOnUpdate: !1
  });
}
function Bo({
  elRef: t,
  tapped: e,
  atomId: n
}) {
  const [r] = Cn(e), i = L(vi), o = kt(k2), s = kt(mi), a = Xe(null), l = Xe(!1);
  lt(() => {
    if (!(!t.current || l.current)) {
      if (!r && i === "scroll" && s === "top") {
        Pe.set(t.current, {
          autoAlpha: 0,
          x: "200%"
        });
        const u = Pe.to(t.current, {
          x: 0,
          autoAlpha: 1,
          duration: 40,
          stagger: n,
          paused: !0
          // Start paused
        });
        a.current = u, o?.add(u, n * 3), l.current = !0;
      }
      return () => {
        a.current && (a.current.kill(), a.current = null);
      };
    }
  }, [i, s]), lt(() => {
    !t.current || r || i === "tap" && (Pe.set(t.current, {
      autoAlpha: 0
    }), e && Pe.to(t.current, {
      autoAlpha: 1
    }));
  }, [e, i]);
}
var cd = {}, Yu = {}, Eg = {}, jl = {}, Vl = {}, Jb = {}, kO;
function _3() {
  return kO || (kO = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0;
    var e;
    (function(r) {
      r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
    })(e = t.ElementType || (t.ElementType = {}));
    function n(r) {
      return r.type === e.Tag || r.type === e.Script || r.type === e.Style;
    }
    t.isTag = n, t.Root = e.Root, t.Text = e.Text, t.Directive = e.Directive, t.Comment = e.Comment, t.Script = e.Script, t.Style = e.Style, t.Tag = e.Tag, t.CDATA = e.CDATA, t.Doctype = e.Doctype;
  }(Jb)), Jb;
}
var Rt = {}, TO;
function xO() {
  if (TO) return Rt;
  TO = 1;
  var t = Rt && Rt.__extends || /* @__PURE__ */ function() {
    var y = function(w, E) {
      return y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(x, k) {
        x.__proto__ = k;
      } || function(x, k) {
        for (var C in k) Object.prototype.hasOwnProperty.call(k, C) && (x[C] = k[C]);
      }, y(w, E);
    };
    return function(w, E) {
      if (typeof E != "function" && E !== null)
        throw new TypeError("Class extends value " + String(E) + " is not a constructor or null");
      y(w, E);
      function x() {
        this.constructor = w;
      }
      w.prototype = E === null ? Object.create(E) : (x.prototype = E.prototype, new x());
    };
  }(), e = Rt && Rt.__assign || function() {
    return e = Object.assign || function(y) {
      for (var w, E = 1, x = arguments.length; E < x; E++) {
        w = arguments[E];
        for (var k in w) Object.prototype.hasOwnProperty.call(w, k) && (y[k] = w[k]);
      }
      return y;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(Rt, "__esModule", { value: !0 }), Rt.cloneNode = Rt.hasChildren = Rt.isDocument = Rt.isDirective = Rt.isComment = Rt.isText = Rt.isCDATA = Rt.isTag = Rt.Element = Rt.Document = Rt.CDATA = Rt.NodeWithChildren = Rt.ProcessingInstruction = Rt.Comment = Rt.Text = Rt.DataNode = Rt.Node = void 0;
  var n = /* @__PURE__ */ _3(), r = (
    /** @class */
    function() {
      function y() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(y.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(w) {
          this.parent = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(y.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(w) {
          this.prev = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(y.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(w) {
          this.next = w;
        },
        enumerable: !1,
        configurable: !0
      }), y.prototype.cloneNode = function(w) {
        return w === void 0 && (w = !1), _(this, w);
      }, y;
    }()
  );
  Rt.Node = r;
  var i = (
    /** @class */
    function(y) {
      t(w, y);
      function w(E) {
        var x = y.call(this) || this;
        return x.data = E, x;
      }
      return Object.defineProperty(w.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(E) {
          this.data = E;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(r)
  );
  Rt.DataNode = i;
  var o = (
    /** @class */
    function(y) {
      t(w, y);
      function w() {
        var E = y !== null && y.apply(this, arguments) || this;
        return E.type = n.ElementType.Text, E;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(i)
  );
  Rt.Text = o;
  var s = (
    /** @class */
    function(y) {
      t(w, y);
      function w() {
        var E = y !== null && y.apply(this, arguments) || this;
        return E.type = n.ElementType.Comment, E;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(i)
  );
  Rt.Comment = s;
  var a = (
    /** @class */
    function(y) {
      t(w, y);
      function w(E, x) {
        var k = y.call(this, x) || this;
        return k.name = E, k.type = n.ElementType.Directive, k;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(i)
  );
  Rt.ProcessingInstruction = a;
  var l = (
    /** @class */
    function(y) {
      t(w, y);
      function w(E) {
        var x = y.call(this) || this;
        return x.children = E, x;
      }
      return Object.defineProperty(w.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var E;
          return (E = this.children[0]) !== null && E !== void 0 ? E : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(E) {
          this.children = E;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(r)
  );
  Rt.NodeWithChildren = l;
  var u = (
    /** @class */
    function(y) {
      t(w, y);
      function w() {
        var E = y !== null && y.apply(this, arguments) || this;
        return E.type = n.ElementType.CDATA, E;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(l)
  );
  Rt.CDATA = u;
  var c = (
    /** @class */
    function(y) {
      t(w, y);
      function w() {
        var E = y !== null && y.apply(this, arguments) || this;
        return E.type = n.ElementType.Root, E;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(l)
  );
  Rt.Document = c;
  var f = (
    /** @class */
    function(y) {
      t(w, y);
      function w(E, x, k, C) {
        k === void 0 && (k = []), C === void 0 && (C = E === "script" ? n.ElementType.Script : E === "style" ? n.ElementType.Style : n.ElementType.Tag);
        var M = y.call(this, k) || this;
        return M.name = E, M.attribs = x, M.type = C, M;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(E) {
          this.name = E;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "attributes", {
        get: function() {
          var E = this;
          return Object.keys(this.attribs).map(function(x) {
            var k, C;
            return {
              name: x,
              value: E.attribs[x],
              namespace: (k = E["x-attribsNamespace"]) === null || k === void 0 ? void 0 : k[x],
              prefix: (C = E["x-attribsPrefix"]) === null || C === void 0 ? void 0 : C[x]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(l)
  );
  Rt.Element = f;
  function d(y) {
    return (0, n.isTag)(y);
  }
  Rt.isTag = d;
  function h(y) {
    return y.type === n.ElementType.CDATA;
  }
  Rt.isCDATA = h;
  function p(y) {
    return y.type === n.ElementType.Text;
  }
  Rt.isText = p;
  function g(y) {
    return y.type === n.ElementType.Comment;
  }
  Rt.isComment = g;
  function m(y) {
    return y.type === n.ElementType.Directive;
  }
  Rt.isDirective = m;
  function v(y) {
    return y.type === n.ElementType.Root;
  }
  Rt.isDocument = v;
  function S(y) {
    return Object.prototype.hasOwnProperty.call(y, "children");
  }
  Rt.hasChildren = S;
  function _(y, w) {
    w === void 0 && (w = !1);
    var E;
    if (p(y))
      E = new o(y.data);
    else if (g(y))
      E = new s(y.data);
    else if (d(y)) {
      var x = w ? b(y.children) : [], k = new f(y.name, e({}, y.attribs), x);
      x.forEach(function(U) {
        return U.parent = k;
      }), y.namespace != null && (k.namespace = y.namespace), y["x-attribsNamespace"] && (k["x-attribsNamespace"] = e({}, y["x-attribsNamespace"])), y["x-attribsPrefix"] && (k["x-attribsPrefix"] = e({}, y["x-attribsPrefix"])), E = k;
    } else if (h(y)) {
      var x = w ? b(y.children) : [], C = new u(x);
      x.forEach(function(B) {
        return B.parent = C;
      }), E = C;
    } else if (v(y)) {
      var x = w ? b(y.children) : [], M = new c(x);
      x.forEach(function(B) {
        return B.parent = M;
      }), y["x-mode"] && (M["x-mode"] = y["x-mode"]), E = M;
    } else if (m(y)) {
      var F = new a(y.name, y.data);
      y["x-name"] != null && (F["x-name"] = y["x-name"], F["x-publicId"] = y["x-publicId"], F["x-systemId"] = y["x-systemId"]), E = F;
    } else
      throw new Error("Not implemented yet: ".concat(y.type));
    return E.startIndex = y.startIndex, E.endIndex = y.endIndex, y.sourceCodeLocation != null && (E.sourceCodeLocation = y.sourceCodeLocation), E;
  }
  Rt.cloneNode = _;
  function b(y) {
    for (var w = y.map(function(x) {
      return _(x, !0);
    }), E = 1; E < w.length; E++)
      w[E].prev = w[E - 1], w[E - 1].next = w[E];
    return w;
  }
  return Rt;
}
var CO;
function E3() {
  return CO || (CO = 1, function(t) {
    var e = Vl && Vl.__createBinding || (Object.create ? function(a, l, u, c) {
      c === void 0 && (c = u);
      var f = Object.getOwnPropertyDescriptor(l, u);
      (!f || ("get" in f ? !l.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
        return l[u];
      } }), Object.defineProperty(a, c, f);
    } : function(a, l, u, c) {
      c === void 0 && (c = u), a[c] = l[u];
    }), n = Vl && Vl.__exportStar || function(a, l) {
      for (var u in a) u !== "default" && !Object.prototype.hasOwnProperty.call(l, u) && e(l, a, u);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.DomHandler = void 0;
    var r = /* @__PURE__ */ _3(), i = /* @__PURE__ */ xO();
    n(/* @__PURE__ */ xO(), t);
    var o = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, s = (
      /** @class */
      function() {
        function a(l, u, c) {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof u == "function" && (c = u, u = o), typeof l == "object" && (u = l, l = void 0), this.callback = l ?? null, this.options = u ?? o, this.elementCB = c ?? null;
        }
        return a.prototype.onparserinit = function(l) {
          this.parser = l;
        }, a.prototype.onreset = function() {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, a.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, a.prototype.onerror = function(l) {
          this.handleCallback(l);
        }, a.prototype.onclosetag = function() {
          this.lastNode = null;
          var l = this.tagStack.pop();
          this.options.withEndIndices && (l.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(l);
        }, a.prototype.onopentag = function(l, u) {
          var c = this.options.xmlMode ? r.ElementType.Tag : void 0, f = new i.Element(l, u, void 0, c);
          this.addNode(f), this.tagStack.push(f);
        }, a.prototype.ontext = function(l) {
          var u = this.lastNode;
          if (u && u.type === r.ElementType.Text)
            u.data += l, this.options.withEndIndices && (u.endIndex = this.parser.endIndex);
          else {
            var c = new i.Text(l);
            this.addNode(c), this.lastNode = c;
          }
        }, a.prototype.oncomment = function(l) {
          if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
            this.lastNode.data += l;
            return;
          }
          var u = new i.Comment(l);
          this.addNode(u), this.lastNode = u;
        }, a.prototype.oncommentend = function() {
          this.lastNode = null;
        }, a.prototype.oncdatastart = function() {
          var l = new i.Text(""), u = new i.CDATA([l]);
          this.addNode(u), l.parent = u, this.lastNode = l;
        }, a.prototype.oncdataend = function() {
          this.lastNode = null;
        }, a.prototype.onprocessinginstruction = function(l, u) {
          var c = new i.ProcessingInstruction(l, u);
          this.addNode(c);
        }, a.prototype.handleCallback = function(l) {
          if (typeof this.callback == "function")
            this.callback(l, this.dom);
          else if (l)
            throw l;
        }, a.prototype.addNode = function(l) {
          var u = this.tagStack[this.tagStack.length - 1], c = u.children[u.children.length - 1];
          this.options.withStartIndices && (l.startIndex = this.parser.startIndex), this.options.withEndIndices && (l.endIndex = this.parser.endIndex), u.children.push(l), c && (l.prev = c, c.next = l), l.parent = u, this.lastNode = null;
        }, a;
      }()
    );
    t.DomHandler = s, t.default = s;
  }(Vl)), Vl;
}
var Zb = {}, AO;
function Sre() {
  return AO || (AO = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.CARRIAGE_RETURN_PLACEHOLDER_REGEX = t.CARRIAGE_RETURN_PLACEHOLDER = t.CARRIAGE_RETURN_REGEX = t.CARRIAGE_RETURN = t.CASE_SENSITIVE_TAG_NAMES_MAP = t.CASE_SENSITIVE_TAG_NAMES = void 0, t.CASE_SENSITIVE_TAG_NAMES = [
      "animateMotion",
      "animateTransform",
      "clipPath",
      "feBlend",
      "feColorMatrix",
      "feComponentTransfer",
      "feComposite",
      "feConvolveMatrix",
      "feDiffuseLighting",
      "feDisplacementMap",
      "feDropShadow",
      "feFlood",
      "feFuncA",
      "feFuncB",
      "feFuncG",
      "feFuncR",
      "feGaussianBlur",
      "feImage",
      "feMerge",
      "feMergeNode",
      "feMorphology",
      "feOffset",
      "fePointLight",
      "feSpecularLighting",
      "feSpotLight",
      "feTile",
      "feTurbulence",
      "foreignObject",
      "linearGradient",
      "radialGradient",
      "textPath"
    ], t.CASE_SENSITIVE_TAG_NAMES_MAP = t.CASE_SENSITIVE_TAG_NAMES.reduce(function(e, n) {
      return e[n.toLowerCase()] = n, e;
    }, {}), t.CARRIAGE_RETURN = "\r", t.CARRIAGE_RETURN_REGEX = new RegExp(t.CARRIAGE_RETURN, "g"), t.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now(), "__"), t.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(t.CARRIAGE_RETURN_PLACEHOLDER, "g");
  }(Zb)), Zb;
}
var RO;
function k3() {
  if (RO) return jl;
  RO = 1, Object.defineProperty(jl, "__esModule", { value: !0 }), jl.formatAttributes = r, jl.escapeSpecialCharacters = o, jl.revertEscapedCharacters = s, jl.formatDOM = a;
  var t = /* @__PURE__ */ E3(), e = Sre();
  function n(l) {
    return e.CASE_SENSITIVE_TAG_NAMES_MAP[l];
  }
  function r(l) {
    for (var u = {}, c = 0, f = l.length; c < f; c++) {
      var d = l[c];
      u[d.name] = d.value;
    }
    return u;
  }
  function i(l) {
    l = l.toLowerCase();
    var u = n(l);
    return u || l;
  }
  function o(l) {
    return l.replace(e.CARRIAGE_RETURN_REGEX, e.CARRIAGE_RETURN_PLACEHOLDER);
  }
  function s(l) {
    return l.replace(e.CARRIAGE_RETURN_PLACEHOLDER_REGEX, e.CARRIAGE_RETURN);
  }
  function a(l, u, c) {
    u === void 0 && (u = null);
    for (var f = [], d, h = 0, p = l.length; h < p; h++) {
      var g = l[h];
      switch (g.nodeType) {
        case 1: {
          var m = i(g.nodeName);
          d = new t.Element(m, r(g.attributes)), d.children = a(
            // template children are on content
            m === "template" ? g.content.childNodes : g.childNodes,
            d
          );
          break;
        }
        case 3:
          d = new t.Text(s(g.nodeValue));
          break;
        case 8:
          d = new t.Comment(g.nodeValue);
          break;
        default:
          continue;
      }
      var v = f[h - 1] || null;
      v && (v.next = d), d.parent = u, d.prev = v, d.next = null, f.push(d);
    }
    return c && (d = new t.ProcessingInstruction(c.substring(0, c.indexOf(" ")).toLowerCase(), c), d.next = f[0] || null, d.parent = u, f.unshift(d), f[1] && (f[1].prev = f[0])), f;
  }
  return jl;
}
var OO;
function _re() {
  if (OO) return Eg;
  OO = 1, Object.defineProperty(Eg, "__esModule", { value: !0 }), Eg.default = g;
  var t = k3(), e = "html", n = "head", r = "body", i = /<([a-zA-Z]+[0-9]?)/, o = /<head[^]*>/i, s = /<body[^]*>/i, a = function(m, v) {
    throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
  }, l = function(m, v) {
    throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
  }, u = typeof window == "object" && window.DOMParser;
  if (typeof u == "function") {
    var c = new u(), f = "text/html";
    l = function(m, v) {
      return v && (m = "<".concat(v, ">").concat(m, "</").concat(v, ">")), c.parseFromString(m, f);
    }, a = l;
  }
  if (typeof document == "object" && document.implementation) {
    var d = document.implementation.createHTMLDocument();
    a = function(m, v) {
      if (v) {
        var S = d.documentElement.querySelector(v);
        return S && (S.innerHTML = m), d;
      }
      return d.documentElement.innerHTML = m, d;
    };
  }
  var h = typeof document == "object" && document.createElement("template"), p;
  h && h.content && (p = function(m) {
    return h.innerHTML = m, h.content.childNodes;
  });
  function g(m) {
    var v, S;
    m = (0, t.escapeSpecialCharacters)(m);
    var _ = m.match(i), b = _ && _[1] ? _[1].toLowerCase() : "";
    switch (b) {
      case e: {
        var y = l(m);
        if (!o.test(m)) {
          var w = y.querySelector(n);
          (v = w?.parentNode) === null || v === void 0 || v.removeChild(w);
        }
        if (!s.test(m)) {
          var w = y.querySelector(r);
          (S = w?.parentNode) === null || S === void 0 || S.removeChild(w);
        }
        return y.querySelectorAll(e);
      }
      case n:
      case r: {
        var E = a(m).querySelectorAll(b);
        return s.test(m) && o.test(m) ? E[0].parentNode.childNodes : E;
      }
      // low-level tag or text
      default: {
        if (p)
          return p(m);
        var w = a(m, r).querySelector(r);
        return w.childNodes;
      }
    }
  }
  return Eg;
}
var DO;
function Ere() {
  if (DO) return Yu;
  DO = 1;
  var t = Yu && Yu.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(Yu, "__esModule", { value: !0 }), Yu.default = i;
  var e = t(_re()), n = k3(), r = /<(![a-zA-Z\s]+)>/;
  function i(o) {
    if (typeof o != "string")
      throw new TypeError("First argument must be a string");
    if (!o)
      return [];
    var s = o.match(r), a = s ? s[1] : void 0;
    return (0, n.formatDOM)((0, e.default)(o), null, a);
  }
  return Yu;
}
var kg = {}, fo = {}, fd = {}, IO;
function kre() {
  if (IO) return fd;
  IO = 1;
  var t = 0;
  fd.SAME = t;
  var e = 1;
  return fd.CAMELCASE = e, fd.possibleStandardNames = {
    accept: 0,
    acceptCharset: 1,
    "accept-charset": "acceptCharset",
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: "className",
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: "htmlFor",
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    "http-equiv": "httpEquiv",
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    "accent-height": "accentHeight",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    "alignment-baseline": "alignmentBaseline",
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    "arabic-form": "arabicForm",
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    "baseline-shift": "baselineShift",
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    "cap-height": "capHeight",
    clip: 0,
    clipPath: 1,
    "clip-path": "clipPath",
    clipPathUnits: 1,
    clipRule: 1,
    "clip-rule": "clipRule",
    color: 0,
    colorInterpolation: 1,
    "color-interpolation": "colorInterpolation",
    colorInterpolationFilters: 1,
    "color-interpolation-filters": "colorInterpolationFilters",
    colorProfile: 1,
    "color-profile": "colorProfile",
    colorRendering: 1,
    "color-rendering": "colorRendering",
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    "dominant-baseline": "dominantBaseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    "enable-background": "enableBackground",
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    "fill-opacity": "fillOpacity",
    fillRule: 1,
    "fill-rule": "fillRule",
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    "flood-opacity": "floodOpacity",
    floodColor: 1,
    "flood-color": "floodColor",
    focusable: 0,
    fontFamily: 1,
    "font-family": "fontFamily",
    fontSize: 1,
    "font-size": "fontSize",
    fontSizeAdjust: 1,
    "font-size-adjust": "fontSizeAdjust",
    fontStretch: 1,
    "font-stretch": "fontStretch",
    fontStyle: 1,
    "font-style": "fontStyle",
    fontVariant: 1,
    "font-variant": "fontVariant",
    fontWeight: 1,
    "font-weight": "fontWeight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    "glyph-name": "glyphName",
    glyphOrientationHorizontal: 1,
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphOrientationVertical: 1,
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    "horiz-adv-x": "horizAdvX",
    horizOriginX: 1,
    "horiz-origin-x": "horizOriginX",
    ideographic: 0,
    imageRendering: 1,
    "image-rendering": "imageRendering",
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    "letter-spacing": "letterSpacing",
    lightingColor: 1,
    "lighting-color": "lightingColor",
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    "marker-end": "markerEnd",
    markerHeight: 1,
    markerMid: 1,
    "marker-mid": "markerMid",
    markerStart: 1,
    "marker-start": "markerStart",
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    "overline-position": "overlinePosition",
    overlineThickness: 1,
    "overline-thickness": "overlineThickness",
    paintOrder: 1,
    "paint-order": "paintOrder",
    panose1: 0,
    "panose-1": "panose1",
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    "pointer-events": "pointerEvents",
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    "rendering-intent": "renderingIntent",
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    "shape-rendering": "shapeRendering",
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    "stop-color": "stopColor",
    stopOpacity: 1,
    "stop-opacity": "stopOpacity",
    strikethroughPosition: 1,
    "strikethrough-position": "strikethroughPosition",
    strikethroughThickness: 1,
    "strikethrough-thickness": "strikethroughThickness",
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    "stroke-dasharray": "strokeDasharray",
    strokeDashoffset: 1,
    "stroke-dashoffset": "strokeDashoffset",
    strokeLinecap: 1,
    "stroke-linecap": "strokeLinecap",
    strokeLinejoin: 1,
    "stroke-linejoin": "strokeLinejoin",
    strokeMiterlimit: 1,
    "stroke-miterlimit": "strokeMiterlimit",
    strokeWidth: 1,
    "stroke-width": "strokeWidth",
    strokeOpacity: 1,
    "stroke-opacity": "strokeOpacity",
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    "text-anchor": "textAnchor",
    textDecoration: 1,
    "text-decoration": "textDecoration",
    textLength: 1,
    textRendering: 1,
    "text-rendering": "textRendering",
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    "underline-position": "underlinePosition",
    underlineThickness: 1,
    "underline-thickness": "underlineThickness",
    unicode: 0,
    unicodeBidi: 1,
    "unicode-bidi": "unicodeBidi",
    unicodeRange: 1,
    "unicode-range": "unicodeRange",
    unitsPerEm: 1,
    "units-per-em": "unitsPerEm",
    unselectable: 0,
    vAlphabetic: 1,
    "v-alphabetic": "vAlphabetic",
    values: 0,
    vectorEffect: 1,
    "vector-effect": "vectorEffect",
    version: 0,
    vertAdvY: 1,
    "vert-adv-y": "vertAdvY",
    vertOriginX: 1,
    "vert-origin-x": "vertOriginX",
    vertOriginY: 1,
    "vert-origin-y": "vertOriginY",
    vHanging: 1,
    "v-hanging": "vHanging",
    vIdeographic: 1,
    "v-ideographic": "vIdeographic",
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    "v-mathematical": "vMathematical",
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    "word-spacing": "wordSpacing",
    writingMode: 1,
    "writing-mode": "writingMode",
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    "x-height": "xHeight",
    xlinkActuate: 1,
    "xlink:actuate": "xlinkActuate",
    xlinkArcrole: 1,
    "xlink:arcrole": "xlinkArcrole",
    xlinkHref: 1,
    "xlink:href": "xlinkHref",
    xlinkRole: 1,
    "xlink:role": "xlinkRole",
    xlinkShow: 1,
    "xlink:show": "xlinkShow",
    xlinkTitle: 1,
    "xlink:title": "xlinkTitle",
    xlinkType: 1,
    "xlink:type": "xlinkType",
    xmlBase: 1,
    "xml:base": "xmlBase",
    xmlLang: 1,
    "xml:lang": "xmlLang",
    xmlns: 0,
    "xml:space": "xmlSpace",
    xmlnsXlink: 1,
    "xmlns:xlink": "xmlnsXlink",
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
  }, fd;
}
var NO;
function Tre() {
  if (NO) return fo;
  NO = 1;
  const t = 0, e = 1, n = 2, r = 3, i = 4, o = 5, s = 6;
  function a(y) {
    return u.hasOwnProperty(y) ? u[y] : null;
  }
  function l(y, w, E, x, k, C, M) {
    this.acceptsBooleans = w === n || w === r || w === i, this.attributeName = x, this.attributeNamespace = k, this.mustUseProperty = E, this.propertyName = y, this.type = w, this.sanitizeURL = C, this.removeEmptyString = M;
  }
  const u = {};
  [
    "children",
    "dangerouslySetInnerHTML",
    // TODO: This prevents the assignment of defaultValue to regular
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
  ].forEach((y) => {
    u[y] = new l(
      y,
      t,
      !1,
      // mustUseProperty
      y,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    ["acceptCharset", "accept-charset"],
    ["className", "class"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"]
  ].forEach(([y, w]) => {
    u[y] = new l(
      y,
      e,
      !1,
      // mustUseProperty
      w,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach((y) => {
    u[y] = new l(
      y,
      n,
      !1,
      // mustUseProperty
      y.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
  ].forEach((y) => {
    u[y] = new l(
      y,
      n,
      !1,
      // mustUseProperty
      y,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "allowFullScreen",
    "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    // Microdata
    "itemScope"
  ].forEach((y) => {
    u[y] = new l(
      y,
      r,
      !1,
      // mustUseProperty
      y.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((y) => {
    u[y] = new l(
      y,
      r,
      !0,
      // mustUseProperty
      y,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "capture",
    "download"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((y) => {
    u[y] = new l(
      y,
      i,
      !1,
      // mustUseProperty
      y,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "cols",
    "rows",
    "size",
    "span"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((y) => {
    u[y] = new l(
      y,
      s,
      !1,
      // mustUseProperty
      y,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), ["rowSpan", "start"].forEach((y) => {
    u[y] = new l(
      y,
      o,
      !1,
      // mustUseProperty
      y.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  });
  const f = /[\-\:]([a-z])/g, d = (y) => y[1].toUpperCase();
  [
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((y) => {
    const w = y.replace(f, d);
    u[w] = new l(
      w,
      e,
      !1,
      // mustUseProperty
      y,
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((y) => {
    const w = y.replace(f, d);
    u[w] = new l(
      w,
      e,
      !1,
      // mustUseProperty
      y,
      "http://www.w3.org/1999/xlink",
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "xml:base",
    "xml:lang",
    "xml:space"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((y) => {
    const w = y.replace(f, d);
    u[w] = new l(
      w,
      e,
      !1,
      // mustUseProperty
      y,
      "http://www.w3.org/XML/1998/namespace",
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), ["tabIndex", "crossOrigin"].forEach((y) => {
    u[y] = new l(
      y,
      e,
      !1,
      // mustUseProperty
      y.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  });
  const h = "xlinkHref";
  u[h] = new l(
    "xlinkHref",
    e,
    !1,
    // mustUseProperty
    "xlink:href",
    "http://www.w3.org/1999/xlink",
    !0,
    // sanitizeURL
    !1
    // removeEmptyString
  ), ["src", "href", "action", "formAction"].forEach((y) => {
    u[y] = new l(
      y,
      e,
      !1,
      // mustUseProperty
      y.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !0,
      // sanitizeURL
      !0
      // removeEmptyString
    );
  });
  const {
    CAMELCASE: p,
    SAME: g,
    possibleStandardNames: m
  } = kre(), S = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD" + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", _ = RegExp.prototype.test.bind(
    // eslint-disable-next-line no-misleading-character-class
    new RegExp("^(data|aria)-[" + S + "]*$")
  ), b = Object.keys(
    m
  ).reduce((y, w) => {
    const E = m[w];
    return E === g ? y[w] = w : E === p ? y[w.toLowerCase()] = w : y[w] = E, y;
  }, {});
  return fo.BOOLEAN = r, fo.BOOLEANISH_STRING = n, fo.NUMERIC = o, fo.OVERLOADED_BOOLEAN = i, fo.POSITIVE_NUMERIC = s, fo.RESERVED = t, fo.STRING = e, fo.getPropertyInfo = a, fo.isCustomAttribute = _, fo.possibleStandardNames = b, fo;
}
var dd = {}, Xu = {}, e1, PO;
function xre() {
  if (PO) return e1;
  PO = 1;
  var t = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, e = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, i = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, a = /^\s+|\s+$/g, l = `
`, u = "/", c = "*", f = "", d = "comment", h = "declaration";
  e1 = function(g, m) {
    if (typeof g != "string")
      throw new TypeError("First argument must be a string");
    if (!g) return [];
    m = m || {};
    var v = 1, S = 1;
    function _(U) {
      var B = U.match(e);
      B && (v += B.length);
      var N = U.lastIndexOf(l);
      S = ~N ? U.length - N : S + U.length;
    }
    function b() {
      var U = { line: v, column: S };
      return function(B) {
        return B.position = new y(U), x(), B;
      };
    }
    function y(U) {
      this.start = U, this.end = { line: v, column: S }, this.source = m.source;
    }
    y.prototype.content = g;
    function w(U) {
      var B = new Error(
        m.source + ":" + v + ":" + S + ": " + U
      );
      if (B.reason = U, B.filename = m.source, B.line = v, B.column = S, B.source = g, !m.silent) throw B;
    }
    function E(U) {
      var B = U.exec(g);
      if (B) {
        var N = B[0];
        return _(N), g = g.slice(N.length), B;
      }
    }
    function x() {
      E(n);
    }
    function k(U) {
      var B;
      for (U = U || []; B = C(); )
        B !== !1 && U.push(B);
      return U;
    }
    function C() {
      var U = b();
      if (!(u != g.charAt(0) || c != g.charAt(1))) {
        for (var B = 2; f != g.charAt(B) && (c != g.charAt(B) || u != g.charAt(B + 1)); )
          ++B;
        if (B += 2, f === g.charAt(B - 1))
          return w("End of comment missing");
        var N = g.slice(2, B - 2);
        return S += 2, _(N), g = g.slice(B), S += 2, U({
          type: d,
          comment: N
        });
      }
    }
    function M() {
      var U = b(), B = E(r);
      if (B) {
        if (C(), !E(i)) return w("property missing ':'");
        var N = E(o), q = U({
          type: h,
          property: p(B[0].replace(t, f)),
          value: N ? p(N[0].replace(t, f)) : f
        });
        return E(s), q;
      }
    }
    function F() {
      var U = [];
      k(U);
      for (var B; B = M(); )
        B !== !1 && (U.push(B), k(U));
      return U;
    }
    return x(), F();
  };
  function p(g) {
    return g ? g.replace(a, f) : f;
  }
  return e1;
}
var $O;
function Cre() {
  if ($O) return Xu;
  $O = 1;
  var t = Xu && Xu.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Xu, "__esModule", { value: !0 }), Xu.default = n;
  var e = t(xre());
  function n(r, i) {
    var o = null;
    if (!r || typeof r != "string")
      return o;
    var s = (0, e.default)(r), a = typeof i == "function";
    return s.forEach(function(l) {
      if (l.type === "declaration") {
        var u = l.property, c = l.value;
        a ? i(u, c, l) : c && (o = o || {}, o[u] = c);
      }
    }), o;
  }
  return Xu;
}
var hd = {}, MO;
function Are() {
  if (MO) return hd;
  MO = 1, Object.defineProperty(hd, "__esModule", { value: !0 }), hd.camelCase = void 0;
  var t = /^--[a-zA-Z0-9_-]+$/, e = /-([a-z])/g, n = /^[^-]+$/, r = /^-(webkit|moz|ms|o|khtml)-/, i = /^-(ms)-/, o = function(u) {
    return !u || n.test(u) || t.test(u);
  }, s = function(u, c) {
    return c.toUpperCase();
  }, a = function(u, c) {
    return "".concat(c, "-");
  }, l = function(u, c) {
    return c === void 0 && (c = {}), o(u) ? u : (u = u.toLowerCase(), c.reactCompat ? u = u.replace(i, a) : u = u.replace(r, a), u.replace(e, s));
  };
  return hd.camelCase = l, hd;
}
var pd, FO;
function Rre() {
  if (FO) return pd;
  FO = 1;
  var t = pd && pd.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  }, e = t(Cre()), n = Are();
  function r(i, o) {
    var s = {};
    return !i || typeof i != "string" || (0, e.default)(i, function(a, l) {
      a && l && (s[(0, n.camelCase)(a, o)] = l);
    }), s;
  }
  return r.default = r, pd = r, pd;
}
var LO;
function T3() {
  return LO || (LO = 1, function(t) {
    var e = dd && dd.__importDefault || function(c) {
      return c && c.__esModule ? c : { default: c };
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.returnFirstArg = t.canTextBeChildOfNode = t.ELEMENTS_WITH_NO_TEXT_CHILDREN = t.PRESERVE_CUSTOM_ATTRIBUTES = void 0, t.isCustomComponent = o, t.setStyleProp = a;
    var n = nt, r = e(Rre()), i = /* @__PURE__ */ new Set([
      "annotation-xml",
      "color-profile",
      "font-face",
      "font-face-src",
      "font-face-uri",
      "font-face-format",
      "font-face-name",
      "missing-glyph"
    ]);
    function o(c, f) {
      return c.includes("-") ? !i.has(c) : !!(f && typeof f.is == "string");
    }
    var s = {
      reactCompat: !0
    };
    function a(c, f) {
      if (typeof c == "string") {
        if (!c.trim()) {
          f.style = {};
          return;
        }
        try {
          f.style = (0, r.default)(c, s);
        } catch {
          f.style = {};
        }
      }
    }
    t.PRESERVE_CUSTOM_ATTRIBUTES = Number(n.version.split(".")[0]) >= 16, t.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
      "tr",
      "tbody",
      "thead",
      "tfoot",
      "colgroup",
      "table",
      "head",
      "html",
      "frameset"
    ]);
    var l = function(c) {
      return !t.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(c.name);
    };
    t.canTextBeChildOfNode = l;
    var u = function(c) {
      return c;
    };
    t.returnFirstArg = u;
  }(dd)), dd;
}
var BO;
function x3() {
  if (BO) return kg;
  BO = 1, Object.defineProperty(kg, "__esModule", { value: !0 }), kg.default = o;
  var t = Tre(), e = T3(), n = ["checked", "value"], r = ["input", "select", "textarea"], i = {
    reset: !0,
    submit: !0
  };
  function o(a, l) {
    a === void 0 && (a = {});
    var u = {}, c = !!(a.type && i[a.type]);
    for (var f in a) {
      var d = a[f];
      if ((0, t.isCustomAttribute)(f)) {
        u[f] = d;
        continue;
      }
      var h = f.toLowerCase(), p = s(h);
      if (p) {
        var g = (0, t.getPropertyInfo)(p);
        switch (n.includes(p) && r.includes(l) && !c && (p = s("default" + h)), u[p] = d, g && g.type) {
          case t.BOOLEAN:
            u[p] = !0;
            break;
          case t.OVERLOADED_BOOLEAN:
            d === "" && (u[p] = !0);
            break;
        }
        continue;
      }
      e.PRESERVE_CUSTOM_ATTRIBUTES && (u[f] = d);
    }
    return (0, e.setStyleProp)(a.style, u), u;
  }
  function s(a) {
    return t.possibleStandardNames[a];
  }
  return kg;
}
var Ku = {}, jO;
function Ore() {
  if (jO) return Ku;
  jO = 1;
  var t = Ku && Ku.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(Ku, "__esModule", { value: !0 }), Ku.default = o;
  var e = nt, n = t(x3()), r = T3(), i = {
    cloneElement: e.cloneElement,
    createElement: e.createElement,
    isValidElement: e.isValidElement
  };
  function o(a, l) {
    l === void 0 && (l = {});
    for (var u = [], c = typeof l.replace == "function", f = l.transform || r.returnFirstArg, d = l.library || i, h = d.cloneElement, p = d.createElement, g = d.isValidElement, m = a.length, v = 0; v < m; v++) {
      var S = a[v];
      if (c) {
        var _ = l.replace(S, v);
        if (g(_)) {
          m > 1 && (_ = h(_, {
            key: _.key || v
          })), u.push(f(_, S, v));
          continue;
        }
      }
      if (S.type === "text") {
        var b = !S.data.trim().length;
        if (b && S.parent && !(0, r.canTextBeChildOfNode)(S.parent) || l.trim && b)
          continue;
        u.push(f(S.data, S, v));
        continue;
      }
      var y = S, w = {};
      s(y) ? ((0, r.setStyleProp)(y.attribs.style, y.attribs), w = y.attribs) : y.attribs && (w = (0, n.default)(y.attribs, y.name));
      var E = void 0;
      switch (S.type) {
        case "script":
        case "style":
          S.children[0] && (w.dangerouslySetInnerHTML = {
            __html: S.children[0].data
          });
          break;
        case "tag":
          S.name === "textarea" && S.children[0] ? w.defaultValue = S.children[0].data : S.children && S.children.length && (E = o(S.children, l));
          break;
        // skip all other cases (e.g., comment)
        default:
          continue;
      }
      m > 1 && (w.key = v), u.push(f(p(S.name, w, E), S, v));
    }
    return u.length === 1 ? u[0] : u;
  }
  function s(a) {
    return r.PRESERVE_CUSTOM_ATTRIBUTES && a.type === "tag" && (0, r.isCustomComponent)(a.name, a.attribs);
  }
  return Ku;
}
var VO;
function Dre() {
  return VO || (VO = 1, function(t) {
    var e = cd && cd.__importDefault || function(l) {
      return l && l.__esModule ? l : { default: l };
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.htmlToDOM = t.domToReact = t.attributesToProps = t.Text = t.ProcessingInstruction = t.Element = t.Comment = void 0, t.default = a;
    var n = e(Ere());
    t.htmlToDOM = n.default;
    var r = e(x3());
    t.attributesToProps = r.default;
    var i = e(Ore());
    t.domToReact = i.default;
    var o = /* @__PURE__ */ E3();
    Object.defineProperty(t, "Comment", { enumerable: !0, get: function() {
      return o.Comment;
    } }), Object.defineProperty(t, "Element", { enumerable: !0, get: function() {
      return o.Element;
    } }), Object.defineProperty(t, "ProcessingInstruction", { enumerable: !0, get: function() {
      return o.ProcessingInstruction;
    } }), Object.defineProperty(t, "Text", { enumerable: !0, get: function() {
      return o.Text;
    } });
    var s = { lowerCaseAttributeNames: !1 };
    function a(l, u) {
      if (typeof l != "string")
        throw new TypeError("First argument must be a string");
      return l ? (0, i.default)((0, n.default)(l, u?.htmlparser2 || s), u) : [];
    }
  }(cd)), cd;
}
var C3 = Dre();
const UO = /* @__PURE__ */ gy(C3), A3 = UO.default || UO, Ire = rt.div.withConfig({
  displayName: "AnimatedWords__StyledText",
  componentId: "sc-yfe131-0"
})`
  text-align: start;
  will-change: transform;
  display: inline-block;
`, Nre = ({
  words: t,
  tapped: e
}) => {
  const n = Xe(null), r = L(wi), i = L(ap), o = L(zn), [s, a] = Cn(0), l = t.map((c) => A3(c)), u = L(d2);
  return lt(() => {
    a(0);
  }, []), lt(() => {
    if (o || r && u === pe.css.portraitViewerID || r && !i || !e) return;
    const c = Pe.timeline({
      onComplete: () => {
        if (s < t.length - 1) {
          if (r && !i) return;
          a(s + 1);
        }
      }
    });
    let f = 0;
    typeof l[s] == "string" && (f = l[s].length), Array.isArray(l[s]) && (f = 2), typeof l[s] == "object" && (f = l[s].props.children.length);
    const d = Math.max(0.8, f * 0.1);
    if (s === 0) {
      c.set(n.current, {
        opacity: 1,
        scale: 1,
        delay: d
      }), c.to(n.current, {
        opacity: 0,
        scale: 1.1,
        ease: "slow(0.25, 0.9, true)"
      });
      return;
    }
    c.set(n.current, {
      opacity: 0,
      scale: 0.1
    }), c.to(n.current, {
      opacity: 1,
      scale: 1,
      ease: "slow(0.25, 0.9)",
      duration: d
    }), s < t.length - 1 && c.to(n.current, {
      delay: 0.5,
      opacity: 0,
      scale: 1.1,
      ease: "slow(0.25, 0.9, true)"
    });
  }, [s, e, i, r, u, o, l, t.length]), /* @__PURE__ */ D.jsx(Ire, { ref: n, className: "animated-word", children: l[s] });
}, Pre = rt.button.withConfig({
  displayName: "NDRToggle__StyledNDRButton",
  componentId: "sc-347cgm-0"
})`
	background: ${(t) => t.$colors.third};
	color: ${(t) => t.$colors.first};
	border: 1px solid ${(t) => t.$colors.first};
	border-radius: 4px;
	padding: 2px 10px;
	margin-inline-start: .6rem;
	cursor: pointer;
	z-index: 10;
	pointer-events: auto;
`;
function $re() {
  const [t, e] = cs(IQ), n = un(g0), r = L(pr), i = L(Mi), o = (s) => {
    s.stopPropagation();
    const a = !t;
    e(a), n(a);
  };
  return /* @__PURE__ */ D.jsx(Rn, { theme: i.button, children: /* @__PURE__ */ D.jsx(Pre, { type: "button", onClick: o, $isChecked: t, $colors: r, children: t ? "On" : "Off" }) });
}
const lp = /* @__PURE__ */ new Map();
lp.set(ba.underline, {
  open: `<span class="text-modifier ${ba.underline}">`,
  close: "</span>"
});
lp.set(ba.shadow, {
  open: `<span class='text-modifier shadow ${ba.shadow}'>`,
  close: "</span>"
});
lp.set(ba.bold, {
  open: `<strong class="text-modifier ${ba.bold}">`,
  close: "</strong>"
});
lp.set(ba.italic, {
  open: `<i class="text-modifier ${ba.italic}">`,
  close: "</i>"
});
function py(t, e, n = !1) {
  const r = [];
  let i = 0, o = t.indexOf(e, i);
  for (; o !== -1; )
    r.push(o + (n ? e.length : 0)), i = o + e.length, o = t.indexOf(e, i);
  return r;
}
function R3(t, e) {
  let n = t;
  const r = Object.entries(e).sort((i, o) => o[1].start - i[1].start);
  for (const [i, {
    start: o,
    end: s,
    replacement: a
  }] of r) {
    const l = o, u = s;
    n = n.substring(0, l) + a + n.substring(u);
  }
  return n;
}
function Mre(t) {
  let e = py(t, Lr.animate);
  const n = py(t, Lr.endAnimate, !0), r = [];
  if (n.forEach((i) => {
    const o = e[0], a = t.slice(o, i).split(Lr.animate);
    a.shift();
    const l = `<span data-words='${JSON.stringify(a)}' id="${Lr.animate}" ></span>`;
    r.push({
      start: o,
      end: i,
      replacement: l.replace(Lr.endAnimate, "")
    }), e = e.filter((u) => u > i);
  }), e.length > 0 && n.length === 0) {
    const i = e[0], s = t.slice(i, t.length).split(Lr.animate);
    s.shift();
    const a = `<span data-words='${JSON.stringify(s)}' id="${Lr.animate}" ></span>`;
    r.push({
      start: i,
      end: t.length,
      replacement: a.replace(Lr.endAnimate, "")
    });
  }
  return R3(t, r);
}
function Fre(t, e) {
  const n = py(t, Od.link), r = py(t, Od.endLink), i = e.links, o = [];
  return n.forEach((s, a) => {
    if (!i || !i[a]) return;
    const l = s, u = r[a], c = t.slice(l + Od.link.length, u), f = `<a  data-testid="link-${a}" data-link="${i[a].link}" data-type="${i[a].type}" target="_blank">${c}</a>`;
    o.push({
      start: l,
      end: u + Od.endLink.length,
      replacement: f
    });
  }), R3(t, o);
}
function Lre(t, e, n) {
  let r = e;
  e === "**" && (r = "\\*\\*");
  const i = new RegExp(r, "g");
  let o = 1, s = !1;
  return {
    parsed: t.replaceAll(i, () => {
      const l = o % 2 === 0 ? n.close : n.open;
      return o++, s = !0, l;
    }),
    tag: s
  };
}
function Bre(t) {
  return Object.values(ba).some((n) => t.includes(n));
}
function jre(t) {
  return Object.values(Od).some((n) => t.includes(n));
}
function Vre(t) {
  return Object.values(Lr).some((n) => t.includes(n));
}
function Ure(t) {
  return t.includes("NDRColorsToggle");
}
const qre = new BroadcastChannel(pe.broadcastChannel.viewer);
function zre(t) {
  return t.replace(/NDRColorsToggle/g, '<span id="ndr-toggle"></span>');
}
function ka({
  text: t,
  ownerName: e,
  modifier: n,
  hostId: r,
  tapped: i
}) {
  const o = L(Ut), s = un(gi), a = {
    replace(c) {
      if (c instanceof C3.Element && c.attribs) {
        if (c.attribs.id === "ndr-toggle")
          return /* @__PURE__ */ D.jsx("span", { style: {
            position: "relative",
            zIndex: 2
          }, children: /* @__PURE__ */ D.jsx($re, {}) });
        if (c.attribs.id === Lr.animate)
          return /* @__PURE__ */ D.jsx(Nre, { words: JSON.parse(c.attribs["data-words"]), tapped: i });
        if (c.name === "a") {
          const f = c.children?.[0] && c.children[0].type === "text" ? c.children[0].data : "", d = (h) => {
            h.stopPropagation(), h.preventDefault();
            const p = c.attribs["data-type"], g = c.attribs["data-link"];
            if (p === Ya["mailto:"].keyword && (window.location.href = `mailto:${c.attribs["data-link"]}`), p === Ya["url:"].keyword) {
              let m = c.attribs["data-link"];
              m.startsWith("http") || (m = `https://${m}`);
              try {
                const v = new URL(m);
                if (v.hostname === "author.quickpoint.me") {
                  const S = sessionStorage.getItem("qpSearchParams");
                  if (S) {
                    const _ = JSON.parse(S);
                    for (const b in _)
                      Object.prototype.hasOwnProperty.call(_, b) && v.searchParams.set(b, _[b]);
                    m = v.toString();
                  }
                }
              } catch (v) {
                console.error("Error processing URL:", v);
              }
              window.location.href = m;
            }
            if (p === Ya["backlink:"].keyword && (window.location.href = `/${e}/${c.attribs["data-link"]}`), p === Ya["toPage:"].keyword && r) {
              if (Number.parseInt(g) === o) return;
              const m = Number.parseInt(g) > o ? "forward" : "back";
              s(m);
              const v = {
                hostId: r,
                type: "QP",
                action: pe.messages.goToPage,
                payload: Number.parseInt(g)
              };
              qre.postMessage(v);
            }
          };
          return (
            // biome-ignore lint/a11y/useValidAnchor: <explanation>
            /* @__PURE__ */ D.jsx("a", { href: "#", "data-testid": c.attribs["data-testid"], className: "inline-link", onClick: d, style: {
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              textDecoration: "underline",
              color: "inherit"
            }, children: f })
          );
        }
      }
      return null;
    }
  };
  if (!Bre(t) && !jre(t) && !Vre(t) && !Ure(t)) return t;
  let l = t;
  return lp.forEach((c, f) => {
    l = Lre(l, f, c).parsed;
  }), n && (l = Fre(l, n)), l = Mre(l), l = zre(l), A3(l, a);
}
function Hre(t) {
  const e = t / 100;
  if (e < 0 || e > 1)
    throw new Error("Opacity must be between 0 and 1");
  return Math.round(e * 255).toString(16).padStart(2, "0").toUpperCase();
}
const O3 = rt.figcaption.withConfig({
  displayName: "Caption__StyledCaption",
  componentId: "sc-ivcu4v-0"
})`
  bottom: 0;
  display: grid;
  height: auto;
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};

  width: ${(t) => t.$width ? `${t.$width}px` : "100%"};
  position: ${(t) => t.$absolutePosition ? "absolute" : "relative"}; // fix for captions on images in cells
  ${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.theme.fonts,
  theme: t.theme
})}`}
    background:${(t) => t.$absolutePosition ? t.theme.caption.background + Hre(t.theme.caption.backdropOpacity) : "unset"};
    align-self: center;
  justify-items: ${(t) => t.theme.caption.align};
  font-size: ${(t) => {
  const e = (
    //@ts-ignore
    t.theme.fontSize / //@ts-ignore
    t.$parentFontSizeMultiplier ** 2
  );
  return wa(t.theme, e);
}};
`, Gre = rt.figure.withConfig({
  displayName: "Box__StyledBox",
  componentId: "sc-1f6a6wl-0"
})`
  --box-opacity: ${(t) => t.$boxOpacity};
  --box-blur: ${(t) => t.$boxBlur};
  display: flex;
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  flex-wrap: wrap;
  text-wrap: balance;
  text-wrap: pretty;
  filter: blur(var(--box-blur)) opacity(var(--box-opacity));
   /* keep this here otherwise the text will become transparent */
  ${(t) => _r(t.$tapped, t.theme.opacity)}
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`}
  /* opacity: ${(t) => _r(t.$tapped, t.theme.opacity)}; */
  position:relative;
  width: fit-content;
  ${(t) => `${zr("box:", t)}`}
  background-color: transparent !important;
  /* this is required to prevent the backdrop from breaking out of the box */
  /*any modifiers will override it.*/
  backdrop-filter: opacity(0);
  background-size: cover;
  background-position: center;
  &::before {
    position: absolute;
    opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
    filter: blur(var(--box-blur));
    content: "";
    background: ${(t) => t.theme?.background ? t.theme.background : "unset"};
    background: ${(t) => t.$background};
    background-size: cover;
    background-position: center;
    ${(t) => `${zr("background:", t)}`}
    border: none; /* overwrite any border properties added by modifierStyled*/
    border-radius:  ${(t) => `${t.theme.cornerRadius * t.$baseFontSize}px`};
    border-color: transparent;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width:100%;
    height:100%;
  }
  .content {
    text-align: start; 
    opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
    position: relative;
    padding-block-start: ${(t) => `${t.theme.paddingBlockStart * t.$baseFontSize}px`};
    padding-block-end: ${(t) => `${t.theme.paddingBlockEnd * t.$baseFontSize}px`};
    padding-inline-start: ${(t) => `${t.theme.paddingInlineStart * t.$baseFontSize}px`};
    padding-inline-end: ${(t) => `${t.theme.paddingInlineEnd * t.$baseFontSize}px`};
  }
`, Wre = ({
  atomId: t,
  pageIndex: e
}) => {
  const n = Xt(e, t), r = L(fn(n)).data, i = kt(tr), o = L(pr), s = L(jt), a = s.baseFontSize, l = r.tapped, u = L(gr), c = L(Fs), f = L(Fi), d = r.modifier?.["blur:"] ? r.modifier?.["blur:"] : "unset", h = r.modifier?.["opacity:"] ? r.modifier?.["opacity:"] : "unset", p = r.modifier ? r.modifier["caption:"] : void 0, g = L(Mi), m = Xe(null);
  Bo({
    elRef: m,
    tapped: l,
    atomId: t
  }), Ls({
    elRef: m,
    modifier: r.modifier
  });
  const v = typeof r.content == "string" ? ka({
    text: r.content,
    ownerName: c,
    modifier: r.modifier,
    hostId: f,
    tapped: l
  }) : r.content;
  return /* @__PURE__ */ D.jsx(Rn, { theme: g.box, children: /* @__PURE__ */ D.jsxs(Gre, { $background: r.background, $baseFontSize: a, $boxBlur: d, $boxOpacity: h, $elementIndex: t, $filterColors: o, $fonts: u, $isInFlexBox: i, $modifier: r.modifier, $onePercentHeight: s.onePercentHeight, $onePercentWidth: s.onePercentWidth, $pageSize: s, $isInPortrait: !s.landscape, $tapped: l, "aria-hidden": !r.tapped, "aria-label": r.altText, className: `${pe.css.pageElement}  box`, "data-atom-id": r.id, ref: m, role: "img", children: [
    /* @__PURE__ */ D.jsx("blockquote", { "aria-hidden": !r.tapped, className: "content", children: v }),
    p && /* @__PURE__ */ D.jsxs(Rn, { theme: g.caption, children: [
      /* @__PURE__ */ D.jsx(v2, { atomId: t, pageIndex: e, type: "blank:" }),
      /* @__PURE__ */ D.jsx(O3, { $absolutePosition: !1, $baseFontSize: a, $elementIndex: t, $filterColors: o, $isInFlexBox: i, $pageSize: s, $isInPortrait: !s.landscape, $tapped: l, className: "box-caption", $onePercentHeight: s.onePercentHeight, $onePercentWidth: s.onePercentWidth, $parentFontSizeMultiplier: g.box.fontSize, children: p })
    ] })
  ] }) });
}, Yre = Hr(Wre);
function lf({
  isPreviewer: t,
  type: e,
  atomId: n,
  position: r
}) {
  return `${t ? "previewer:" : ""}${e}${n}-${r}`;
}
const Xre = (t) => t.button, D3 = rt.button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-1tlhed1-0"
})`
 display: flex;
 visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  flex-wrap: wrap;
  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  cursor: pointer;
  opacity: ${(t) => t.$disabled ? 0.5 : 1};
  z-index: 101; //clickable things have to be above the scroll trigger
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`};
  ${(t) => `${zr("button:", t)}`} 
  .inline-link {
    color: inherit !important;
    text-decoration: none !important;
  }
`, Kre = ({
  atomId: t,
  pageIndex: e,
  type: n
}) => {
  const r = Xt(e, t), i = L(fn(r)).data, o = kt(tr), s = Xe(null), a = L(pr), l = L(gr), u = L(zn), c = L(Fs), f = i.modifier?.["toPage:"], d = L(jt), h = i.tapped, p = L(Lo), g = kt(mi), m = L(Fi);
  Bo({
    elRef: s,
    tapped: h,
    atomId: t
  }), Ls({
    elRef: s,
    modifier: i.modifier
  });
  const v = typeof i.content == "string" ? ka({
    text: i.content,
    ownerName: c,
    modifier: i.modifier,
    hostId: m,
    tapped: h
  }) : i.content, S = d.baseFontSize, _ = i.modifier?.["backlink:"], b = i.modifier?.["url:"];
  let y;
  _ && (y = `/${c}/${_}`), b && (y = `http://${b}`);
  let w = null;
  lt(() => (w = new BroadcastChannel(pe.broadcastChannel.viewer), () => {
    w?.close();
  }));
  const E = (x, k, C) => {
    x.preventDefault(), x.stopPropagation(), k && (FQ({
      entry: p,
      goingTo: k
    }), window.open(k, "_self")), C && typeof C == "string" && w && w.postMessage({
      action: pe.messages.goToPage,
      payload: Number.parseInt(C)
    });
  };
  return /* @__PURE__ */ D.jsx(Rn, { theme: Xre, children: /* @__PURE__ */ D.jsx(D3, { $baseFontSize: S, $disabled: !1, $elementIndex: t, $filterColors: a, $fonts: l, $isInFlexBox: o, $modifier: i.modifier, $onePercentHeight: d.onePercentHeight, $onePercentWidth: d.onePercentWidth, $pageSize: d, $isInPortrait: !d.landscape, $tapped: h, "aria-hidden": !i.tapped, className: `${pe.css.pageElement}  Button`, "data-atom-id": t, "data-testid": lf({
    atomId: t,
    position: g,
    type: n,
    isPreviewer: u
  }), onClick: (x) => E(x, y, f), ref: s, children: v }) });
}, Qre = Hr(Kre), Jre = rt.div.withConfig({
  displayName: "Cell__StyledCell",
  componentId: "sc-jddyv1-0"
})``, Zre = () => /* @__PURE__ */ D.jsx(Jre, { className: "cell" }), eie = Hr(Zre), I3 = ({
  event: t,
  imageElement: e
  // Make imageElement optional
}) => {
  if (!e)
    return console.warn("Image element not found, cannot animate."), null;
  const {
    clientX: n,
    clientY: r
  } = t, i = e.getBoundingClientRect(), o = document.documentElement.clientWidth, a = Math.max(i.width, o * 0.3), l = document.createElement("div");
  Pe.set(l, {
    position: "fixed",
    left: n,
    top: r,
    width: a,
    height: a,
    backgroundColor: "#0F0",
    borderRadius: "50%",
    xPercent: -50,
    yPercent: -50,
    opacity: 0,
    scale: 1,
    zIndex: 9999,
    pointerEvents: "none"
  }), document.body.appendChild(l);
  const u = Pe.timeline({
    onComplete: () => l.remove()
  });
  return u.to(l, {
    opacity: 1,
    duration: 0.1,
    ease: "power1.out"
  }).to(l, {
    scale: 0.5,
    duration: 0.2,
    ease: "power1.out"
  }).to(l, {
    scale: 0.8,
    duration: 0.1,
    opacity: 0,
    ease: "power1.in"
  }), u.play(), u;
}, tie = ({
  target: t,
  options: e,
  scrollTrigger: n,
  direction: r
}) => {
  if (r === "back") return {
    tween: void 0,
    position: "0"
  };
  const i = e?.duration ? e.duration : 0.75, o = e?.ease ? e.ease : "expo.out", s = Pe.fromTo(
    t,
    {
      y: "-700%"
    },
    // Start above the viewport
    {
      y: "0",
      duration: i,
      ease: o
    }
    // Drop down quickly
  );
  return n?.trigger && gt.create({
    animation: s,
    ...n
  }), {
    tween: s,
    position: ">"
  };
}, nie = ({
  target: t,
  options: e,
  scrollTrigger: n,
  direction: r
}) => {
  if (r === "back") return {
    tween: void 0,
    position: "0"
  };
  const i = e?.duration ? e.duration : 1, o = e?.ease ? e.ease : "expo.out", s = Pe.fromTo(
    t,
    {
      y: "450%"
    },
    // Start above the viewport, small
    {
      y: "0%",
      duration: i,
      ease: o
    }
  );
  return n?.trigger && gt.create({
    animation: s,
    ...n
  }), {
    tween: s,
    position: "<"
  };
}, rie = ({
  target: t,
  options: e,
  scrollTrigger: n,
  direction: r
}) => {
  if (r === "back") return {
    tween: void 0,
    position: "0"
  };
  const i = e?.duration ? e.duration : 1, o = e?.ease ? e.ease : "expo.in", s = Pe.timeline();
  return s.to(t, {
    y: "450%",
    duration: i,
    ease: o
  }), s.to(t, {
    autoAlpha: 0,
    duration: 0.2,
    ease: "power1.out"
  }, ">"), n?.trigger && gt.create({
    animation: s,
    ...n
  }), {
    tween: s,
    position: "<"
  };
}, iie = ({
  target: t,
  options: e,
  elementsTimeline: n,
  position: r,
  direction: i,
  duration: o
  // Allow duration override via props
}) => {
  if (i === "back") return {
    tween: void 0,
    position: "0"
  };
  const s = o ?? e?.duration ?? 1.5, a = e?.ease ?? "power1.out", l = Pe.fromTo(t, {
    autoAlpha: 0
  }, {
    autoAlpha: 1,
    duration: s,
    ease: a,
    ...e
    // Spread remaining options
  });
  return n ? (n.add(l, r), {
    tween: void 0,
    position: "<60%"
  }) : {
    tween: l,
    position: "<"
  };
}, oie = ({
  target: t,
  options: e,
  scrollTrigger: n
}) => {
  const r = e?.duration ? e.duration : 0.65, i = e?.ease ? e.ease : "power1.out", o = Pe.fromTo(
    t,
    {
      autoAlpha: 0
    },
    // Start above the viewport, small
    {
      autoAlpha: 1,
      duration: r,
      ease: i
    }
    // Drop down quickly
  );
  return n?.trigger && gt.create({
    animation: o,
    ...n
  }), {
    tween: o,
    position: "<60%"
  };
}, sie = ({
  target: t,
  options: e,
  elementsTimeline: n,
  position: r,
  direction: i,
  duration: o
  // Allow duration override via props
}) => {
  if (i === "back") return {
    tween: void 0,
    position: "0"
  };
  const s = o ?? e?.duration ?? 1.5, a = e?.ease ?? "power1.in", l = Pe.to(t, {
    autoAlpha: 0,
    duration: s,
    ease: a,
    ...e
    // Spread remaining options
  });
  return n ? (n.add(l, r), {
    tween: void 0,
    position: "<60%"
  }) : {
    tween: l,
    position: "<"
  };
}, aie = ({
  imageElement: t,
  clonedImageRef: e,
  setIsFullScreen: n
}) => {
  if (!t)
    return console.warn("Image element not found, cannot animate."), null;
  const r = t.cloneNode(!0);
  e.current = r, Pe.set(r, {
    position: "fixed",
    top: "50%",
    left: "50%",
    xPercent: -50,
    yPercent: -50,
    width: "100vw",
    height: "100vh",
    objectFit: "contain",
    zIndex: 1e3,
    opacity: 0,
    scale: 0.33,
    pointerEvents: "none"
  }), document.body.appendChild(r);
  const i = (s) => {
    if (!e.current) return;
    const a = e.current;
    a.removeEventListener("click", i);
    const l = I3({
      event: s,
      imageElement: e.current
    });
    if (l)
      l.eventCallback("onComplete", () => {
        const u = t.getBoundingClientRect(), c = window.innerWidth, f = u.left + u.width / 2 < c / 2 ? `-${c}px` : `${c}px`;
        Pe.to(a, {
          x: f,
          opacity: 1,
          duration: 0.3,
          ease: "power1.in",
          onComplete: () => {
            a.remove(), e.current === a && (e.current = null, n(!1));
          }
        });
      });
    else {
      const u = t.getBoundingClientRect(), c = window.innerWidth, f = u.left + u.width / 2 < c / 2 ? `-${c}px` : `${c}px`;
      Pe.to(a, {
        x: f,
        opacity: 1,
        duration: 0.3,
        ease: "power1.in",
        onComplete: () => {
          a.remove(), e.current === a && (e.current = null, n(!1));
        }
      });
    }
  };
  r.style.pointerEvents = "auto", r.addEventListener("click", (s) => i(s));
  const o = Pe.timeline();
  return o.to(r, {
    opacity: 1,
    scale: 1,
    duration: 0.5,
    ease: "power2.out",
    onComplete: () => n(!0)
  }), o;
}, lie = ({
  target: t
}) => ({
  tween: Pe.set(t, {
    // autoAlpha: 1,
    onComplete: () => {
      const n = document.getElementById("safari-wrapper");
      n && (n.style.overflow = "visible");
      const r = document.getElementById("styled-display");
      r && (r.style.overflow = "hidden");
    }
  }),
  position: 0
}), uie = ({
  target: t,
  options: e,
  scrollTrigger: n,
  direction: r
}) => {
  if (r === "back") return {
    tween: void 0,
    position: "0"
  };
  const i = e?.duration ?? 0.5, o = e?.scale ?? 1.05, s = e?.ease ?? "power1.inOut", a = Pe.timeline({
    repeat: 2,
    yoyo: !0
  });
  return a.to(t, {
    duration: i / 2,
    // Half duration for scale up
    ease: s,
    scale: o
  }), n?.trigger && gt.create({
    animation: a,
    ...n
  }), {
    tween: a,
    position: "<"
  };
}, cie = ({
  target: t,
  scrollTimeline: e,
  direction: n,
  top: r,
  pageIndex: i,
  numberOfPages: o,
  duration: s,
  insertTweenAt: a,
  containersToTap: l
}) => {
  if (!e || typeof i > "u" || typeof o > "u" || typeof s > "u" || typeof a > "u") return;
  const u = typeof t == "string" ? document.querySelector(t) : t;
  if (!u) return;
  const c = u.scrollHeight + window.innerHeight / 2;
  if (n === "forward" || n === "init")
    if (r) {
      if (i < o) {
        Pe.set(t, {
          y: 0,
          autoAlpha: 1
        });
        const f = Pe.to(t, {
          y: `-${c}px`,
          ease: "none",
          duration: s
        });
        e.add(f, n === "init" ? 0 : a);
      }
    } else {
      Pe.set(t, {
        y: `${c}px`,
        autoAlpha: 1
      });
      const f = Pe.to(t, {
        y: 0,
        ease: "none",
        duration: s
      });
      e.add(f, "<");
    }
  if (n === "back") {
    const f = l ? 50 : 100, d = l ? 50 : 0;
    if (r) {
      Pe.set(t, {
        autoAlpha: 1
      });
      const h = Pe.to(t, {
        y: `-${c}px`,
        ease: "power2.inOut",
        duration: f
      });
      e.add(h, d);
    } else {
      Pe.set(t, {
        y: `${c}px`,
        autoAlpha: 1
      });
      const h = Pe.to(t, {
        y: 0,
        ease: "power2.inOut",
        duration: f
      });
      e.add(h, "<");
    }
  }
}, fie = ({
  target: t,
  scrollTimeline: e,
  direction: n,
  top: r,
  pageIndex: i,
  numberOfPages: o,
  duration: s,
  insertTweenAt: a,
  containersToTap: l
}) => {
  if (!(!e || typeof i > "u" || typeof o > "u" || typeof s > "u" || typeof a > "u") && !(i > o)) {
    if (n === "forward" || n === "init")
      if (r) {
        if (i < o) {
          const u = Pe.to(t, {
            y: "-20%",
            ease: "none",
            scale: 0.7,
            autoAlpha: 0,
            duration: s
          });
          e.add(u, a);
        }
      } else {
        Pe.set(t, {
          y: "120%",
          autoAlpha: 1
        });
        const u = Pe.to(t, {
          scale: 1,
          y: 0,
          autoAlpha: 1,
          ease: "none",
          duration: s
        });
        e.add(u, "<");
      }
    if (n === "back") {
      const u = l ? 50 : 100, c = l ? 50 : 0;
      if (r) {
        Pe.set(t, {
          y: "0%",
          scale: 1,
          autoAlpha: 1
        });
        const f = Pe.to(t, {
          y: "-20%",
          autoAlpha: 0,
          scale: 0.7,
          duration: u,
          ease: "none"
        });
        e.add(f, c);
      } else {
        Pe.set(t, {
          y: "120%",
          scale: 1,
          autoAlpha: 0
        });
        const f = Pe.to(t, {
          y: "0%",
          autoAlpha: 1,
          duration: u,
          ease: "none"
        });
        e.add(f, "<");
      }
    }
  }
}, die = ({
  target: t,
  scrollTimeline: e,
  direction: n,
  top: r,
  pageIndex: i,
  numberOfPages: o,
  duration: s,
  insertTweenAt: a,
  containersToTap: l
}) => {
  if (!(!e || typeof i > "u" || typeof o > "u" || typeof s > "u" || typeof a > "u")) {
    if (s = 5, n === "forward" || n === "init")
      if (r) {
        if (i < o) {
          Pe.set(t, {
            autoAlpha: 1
          });
          const u = Pe.to(t, {
            y: "-100%",
            ease: "none",
            duration: s
          });
          e.add(u, a);
        }
      } else {
        Pe.set(t, {
          y: "100%",
          autoAlpha: 1
        });
        const u = Pe.to(t, {
          y: "0%",
          ease: "none",
          duration: s
        });
        e.add(u, "<");
      }
    if (n === "back") {
      const u = l ? 50 : 100, c = l ? 50 : 0;
      if (r) {
        Pe.set(t, {
          autoAlpha: 1
        });
        const f = Pe.to(t, {
          y: "-100%",
          ease: "none",
          duration: u
        });
        e.add(f, c);
      } else {
        Pe.set(t, {
          y: "100%",
          autoAlpha: 1
        });
        const f = Pe.to(t, {
          y: 0,
          ease: "none",
          duration: u
        });
        e.add(f, "<");
      }
    }
  }
}, hie = ({
  target: t
}) => {
  const e = t.querySelector("img");
  return e ? {
    tween: Pe.set(e, {
      objectFit: "cover",
      width: "100%",
      // Ensure image tries to fill the figure width
      height: "100%"
      // Ensure image tries to fill the figure height
    }),
    position: 0
  } : (console.warn("setImageToCover: No <img> element found within the target:", t), {
    tween: void 0
  });
}, pie = () => {
  const t = Pe.utils.interpolate("#000", "#0F0");
  let e = 0;
  return {
    tween: Pe.to({
      progress: 0
    }, {
      progress: 1,
      // Animate from 0 to 1
      duration: 0.84,
      onUpdate: function() {
        e = this.progress();
        const r = t(e);
        uc(r);
      }
    }),
    position: ">"
  };
}, kr = {
  scroll: {},
  element: {},
  click: {}
};
kr.element.destroyFirstPage = () => ({
  tween: void 0
});
kr.element.dropFromTop = tie;
kr.element.enterFromBottom = nie;
kr.element.exitToBottom = rie;
kr.element.fadeIn = iie;
kr.element.fadeOut = sie;
kr.element.fadeInDot = oie;
kr.element.makeBordersTransparent = lie;
kr.element.pulse = uie;
kr.scroll.scroll = cie;
kr.scroll.scrollCards = fie;
kr.scroll.scrollContinuous = die;
kr.element.setImageToCover = hie;
kr.element.setMetaToM23Green = pie;
kr.click.dotClick = I3;
kr.click.fullscreenClick = aie;
Pe.registerPlugin(gt);
const b2 = ({
  ref: t,
  tweenName: e,
  options: n,
  scrollTrigger: r,
  onePercent: i,
  direction: o,
  position: s
}) => {
  const a = L(Lo), l = L(er), u = kt(q3), c = un(_l(a)), f = Xe({
    tweenName: e,
    options: n,
    scrollTrigger: r,
    onePercent: i,
    direction: o,
    position: s,
    stackCfKey: a,
    isInAuthor: l,
    elementsTimeline: u,
    rawCodeSetter: c
  });
  f.current = {
    tweenName: e,
    options: n,
    scrollTrigger: r,
    onePercent: i,
    direction: o,
    position: s,
    stackCfKey: a,
    isInAuthor: l,
    elementsTimeline: u,
    rawCodeSetter: c
  };
  const d = Xe({
    timeline: null,
    scrollTrigger: null
  }), h = () => {
    d.current.scrollTrigger && (d.current.scrollTrigger.kill(), d.current.scrollTrigger = null), d.current.timeline && (d.current.timeline.kill(), d.current.timeline = null);
  };
  lt(() => {
    const p = f.current;
    if (p.isInAuthor) return;
    if (!t.current) {
      console.warn("Target element not found. Ensure the ref is correctly attached.");
      return;
    }
    if (p.position === "bottom" && !p.tweenName?.includes("setImageToCover"))
      return;
    const g = t.current, m = typeof p.tweenName == "string" ? p.tweenName.split(" ").filter((b) => b) : [];
    if (m.length === 0)
      return;
    h();
    const v = Pe.timeline();
    d.current.timeline = v;
    let S = ">";
    for (const b of m) {
      const y = kr.element[b];
      if (y) {
        const w = y({
          target: g,
          options: p.options,
          onePercent: p.onePercent,
          direction: p.direction
        });
        w.tween && (v.add(w.tween, w.position ?? S), S = w.position ?? S);
      } else
        console.warn(`Tween named "${b}" not found in tweenLibrary.element.`);
    }
    if (m[m.length - 1] === "destroyFirstPage" && !p.isInAuthor && v.eventCallback("onComplete", () => {
      p.rawCodeSetter((b) => {
        const y = Cu(b);
        if (b.code) {
          const w = b.code.indexOf("===");
          if (w !== -1) {
            const E = b.code.indexOf("===", w + 3);
            E !== -1 && (y.code = b.code.substring(E + 3));
          }
        }
        return y;
      });
    }), p.scrollTrigger)
      d.current.scrollTrigger = gt.create({
        animation: v,
        ...p.scrollTrigger
      });
    else if (p.elementsTimeline)
      try {
        const b = p.options?.position ?? S;
        p.elementsTimeline.add(v, b);
      } catch (b) {
        console.error("Failed to append to elementsTimeline:", b), v.play();
      }
    else
      v.play();
    return h;
  }, [
    // Only dependencies that REQUIRE full recreation
    e,
    // Different animation
    l,
    // Editor state change
    s
    // Position change
    // Note: options, onePercent, direction are accessed via ref
  ]), lt(() => {
    d.current.timeline;
  }, [o, i]);
}, gie = (t) => t.columnTitle, mie = rt.div.withConfig({
  displayName: "ColumnTitle__StyledColumnTitle",
  componentId: "sc-187fqk6-0"
})`
  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`};
  ${(t) => `${zr("columnTitle:", t)}`};
  text-align: start;
`, yie = ({
  atomId: t,
  pageIndex: e,
  type: n
}) => {
  const r = Xt(e, t), i = L(fn(r)).data, o = i.modifier?.["animate:"], s = L(gi), a = kt(tr), l = Xe(null), u = L(pr), c = L(gr), f = L(zn), d = L(Fs), h = L(jt), p = i.tapped, g = kt(mi), m = L(Fi);
  Bo({
    elRef: l,
    tapped: p,
    atomId: t
  }), Ls({
    elRef: l,
    modifier: i.modifier
  }), b2({
    ref: l,
    tweenName: o,
    onePercent: {
      width: h.onePercentWidth,
      height: h.onePercentHeight
    },
    options: {
      position: i.modifier?.["animateStart:"] ? i.modifier?.["animateStart:"] : void 0
    },
    position: g,
    direction: s
  });
  const v = h.baseFontSize, S = typeof i.content == "string" ? ka({
    text: i.content,
    ownerName: d,
    modifier: i.modifier,
    hostId: m,
    tapped: p
  }) : i.content;
  return i.content ? /* @__PURE__ */ D.jsx(Rn, { theme: gie, children: /* @__PURE__ */ D.jsx(mie, { $baseFontSize: v, $elementIndex: t, $filterColors: u, $fonts: c, $isInFlexBox: a, $modifier: i.modifier, $onePercentHeight: h.onePercentHeight, $onePercentWidth: h.onePercentWidth, $pageSize: h, $isInPortrait: !h.landscape, $tapped: p, "aria-hidden": !i.tapped, className: `${pe.css.pageElement}  column-title`, "data-atom-id": t, "data-testid": lf({
    atomId: t,
    position: g,
    type: n,
    isPreviewer: f
  }), ref: l, role: "columnheader", children: S }) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, vie = Hr(yie);
function bie({
  figureRef: t,
  imageRef: e,
  tweenName: n,
  options: r,
  navigation: i
}) {
  const [o, s] = Cn(!1), a = Xe(null), l = Xe(null), {
    contextSafe: u
  } = so({
    scope: t
  });
  lt(() => () => {
    l.current && (l.current.kill(), l.current = null), a.current && (Pe.killTweensOf(a.current), a.current.remove(), a.current = null), s(!1);
  }, []), lt(() => {
    const c = t.current, f = e.current, d = typeof n == "string" ? n.split(" ").filter((v) => v in kr.click) : [], h = d.length > 0, p = typeof i == "function", g = h || p, m = u((v) => {
      if (!c || (g && (v.preventDefault(), v.stopPropagation()), h && (o || l.current?.isActive())))
        return;
      const S = Pe.timeline();
      let _ = !1;
      if (h)
        for (const b of d) {
          b === "dotThenFullscreen" && (_ = !0);
          const y = kr.click[b];
          if (y) {
            if (_ && !f) {
              console.warn(`Image element ref not found, required for '${b}' tween. Skipping tween.`);
              continue;
            }
            try {
              const w = y({
                event: v,
                figureElement: c,
                imageElement: f || void 0,
                clonedImageRef: a,
                setIsFullScreen: s,
                options: r
              });
              w ? S.add(w, ">") : console.warn(`Click tween "${b}" did not return a timeline or tween.`);
            } catch (w) {
              console.error(`Error executing click tween "${b}":`, w);
            }
          } else
            console.warn(`Click tween "${b}" definition not found.`);
        }
      p && (h ? S.call(() => i(v), [], ">") : i(v)), h && S.duration() > 0 ? (l.current = S, S.play()) : h && (l.current = null);
    });
    return g && c?.addEventListener("click", m), () => {
      g && c?.removeEventListener("click", m), l.current && (l.current.kill(), l.current = null);
    };
  }, [
    t,
    e,
    n,
    // Now a string
    r,
    i,
    // Added navigation callback
    u,
    o
    // Re-run if fullscreen state changes to prevent re-triggering
  ]);
}
const qO = (t) => /* @__PURE__ */ D.jsxs("svg", { style: {
  color: "#FFBCB5"
}, width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  /* @__PURE__ */ D.jsxs("g", { opacity: 0.2, children: [
    /* @__PURE__ */ D.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 3C3.67157 3 3 3.67157 3 4.5V18.5C3 19.3284 3.67157 20 4.5 20H18.5C19.3284 20 20 19.3284 20 18.5V4.5C20 3.67157 19.3284 3 18.5 3H4.5ZM9 9C10.1046 9 11 8.10457 11 7C11 5.89543 10.1046 5 9 5C7.89543 5 7 5.89543 7 7C7 8.10457 7.89543 9 9 9ZM13.0059 10.1229C12.6071 9.66241 11.8928 9.66241 11.4941 10.1229L9.93098 11.9278L9.30294 11.0817C8.90313 10.5431 8.09685 10.5431 7.69703 11.0817L5.78763 13.654C5.29782 14.3138 5.76881 15.25 6.59058 15.25H9.24274H10.4094H15.2572C16.114 15.25 16.574 14.243 16.0132 13.5953L13.0059 10.1229Z", fill: "#FFBCB5" }),
    /* @__PURE__ */ D.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5V7V11.3595L6.09112 9.88962C6.11131 9.86243 6.13183 9.8357 6.1527 9.80943C5.43994 9.08712 5 8.09494 5 7C5 6.27143 5.19479 5.58835 5.53513 5H5ZM4.5 3C3.67157 3 3 3.67157 3 4.5V18.5C3 19.3284 3.67157 20 4.5 20H18.5C19.3284 20 20 19.3284 20 18.5V4.5C20 3.67157 19.3284 3 18.5 3H4.5ZM12.4649 5H18V13.0213C17.8832 12.7655 17.726 12.5181 17.525 12.286L14.5178 8.81357C14.0782 8.30595 13.5107 7.98487 12.9094 7.85032C12.9688 7.57629 13 7.29179 13 7C13 6.27143 12.8052 5.58835 12.4649 5ZM11.7322 9.9215C12.136 9.67686 12.6778 9.74399 13.0059 10.1229L16.0132 13.5953C16.574 14.243 16.114 15.25 15.2572 15.25H6.59058C5.76881 15.25 5.29782 14.3138 5.78763 13.654L7.69703 11.0817C7.76442 10.9909 7.84335 10.9154 7.92994 10.8553C8.09672 10.7394 8.2919 10.6802 8.48767 10.6778C8.66484 10.6757 8.84249 10.72 9 10.8108C9.08313 10.8588 9.16065 10.9197 9.22953 10.9935C9.25526 11.0211 9.27978 11.0505 9.30294 11.0817L9.93098 11.9278L11.4941 10.1229C11.5647 10.0413 11.6453 9.97417 11.7322 9.9215ZM10.1439 8.64082C10.2562 8.56237 10.3601 8.47269 10.4539 8.3734C10.7924 8.01514 11 7.53181 11 7C11 5.89543 10.1046 5 9 5C7.89543 5 7 5.89543 7 7C7 7.73303 7.39435 8.37395 7.98248 8.72218C8.28058 8.89869 8.62846 9 9 9C9.22116 9 9.43394 8.9641 9.63282 8.89781C9.81646 8.83661 9.98825 8.7495 10.1439 8.64082ZM18 15.4654C17.5505 16.479 16.5557 17.25 15.2572 17.25H6.59058C5.98881 17.25 5.44975 17.0827 5 16.8009V18H18V15.4654Z", fill: "#FFBCB5" })
  ] }),
  /* @__PURE__ */ D.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 8C8.55228 8 9 7.55228 9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7C7 7.55228 7.44772 8 8 8ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z", fill: "#FFBCB5" }),
  /* @__PURE__ */ D.jsx("path", { d: "M7.49999 10.6777L5.59058 13.25L7.49999 13.25L9.40939 14.25H5.59058C4.76881 14.25 4.29782 13.3138 4.78763 12.654L6.69703 10.0817C7.09685 9.54308 7.90313 9.54308 8.30294 10.0817L9.25765 11.3678L8.45469 11.9639L7.49999 10.6777Z", fill: "#FFBCB5" }),
  /* @__PURE__ */ D.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2573 13.25L11.25 9.77753L8.24275 13.25L14.2573 13.25ZM12.0059 9.12287C11.6072 8.66241 10.8928 8.66241 10.4941 9.12287L7.48682 12.5953C6.92595 13.243 7.386 14.25 8.24275 14.25H14.2573C15.114 14.25 15.5741 13.243 15.0132 12.5953L12.0059 9.12287Z", fill: "#FFBCB5" }),
  /* @__PURE__ */ D.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V17C2.5 17.2761 2.72386 17.5 3 17.5H17C17.2761 17.5 17.5 17.2761 17.5 17V3C17.5 2.72386 17.2761 2.5 17 2.5ZM3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V17C1.5 17.8284 2.17157 18.5 3 18.5H17C17.8284 18.5 18.5 17.8284 18.5 17V3C18.5 2.17157 17.8284 1.5 17 1.5H3Z", fill: "#FFBCB5" }),
  /* @__PURE__ */ D.jsx("path", { d: "M1.15063 1.87794C0.94979 1.6771 0.94979 1.35147 1.15063 1.15063C1.35147 0.949789 1.6771 0.949789 1.87794 1.15063L18.8494 18.1221C19.0502 18.3229 19.0502 18.6485 18.8494 18.8494C18.6485 19.0502 18.3229 19.0502 18.1221 18.8494L1.15063 1.87794Z", fill: "#FFBCB5" })
] }), wie = rt.img.withConfig({
  displayName: "Image__StyledImage",
  componentId: "sc-1p18gfm-0"
})`

object-fit: contain;
width: ${(t) => t.$singleColumnInPortrait ? "auto" : "100%"};
max-width: 100%;
/* height: ${(t) => t.$isInFlexBox || !t.$isInLandscape ? "auto" : "100%"}; // seems to fix safari */
height: inherit; // seems to fix safari
min-height: 0;
border-radius: inherit;
border-width:  ${(t) => t.$imageWidth && t.$modifier && t.$modifier[Ya["border-thickness:"].keyword] ? `${t.$imageWidth / 400 * Number.parseInt(t.$modifier[Ya["border-thickness:"].keyword] || "0")}px` : "unset"};



`, Sie = R5(({
  atomId: t,
  pageIndex: e,
  imageWidth: n,
  altText: r
}, i) => {
  const o = Xt(e, t), s = L(fn(o)).data, a = kt(tr), l = L(jt), u = l.baseFontSize, c = L(pr), f = L(o3), [d, h] = Cn(!1), p = s.url ? s.url : s.content, g = Es(({
    set: v
  }) => () => {
    v(tu(Xt(e, t)), !0);
  }, [e, t]), m = Es(({
    set: v
  }) => () => {
    v(tu(Xt(e, t)), !1);
  }, [e, t]);
  return lt(() => {
    m();
  }, [p, m]), Bn(() => {
    h(!1), s.url;
  }, [s.url]), p ? d && p ? /* @__PURE__ */ D.jsx(qO, { style: {
    width: "100%",
    height: "100%"
  } }) : /* @__PURE__ */ D.jsx(wie, { alt: r, $baseFontSize: u, $filterColors: c, $imageWidth: n, $isInFlexBox: a, $isInLandscape: l.landscape, $modifier: s.modifier, $onePercentHeight: l.onePercentHeight, $onePercentWidth: l.onePercentWidth, $pageSize: l, $singleColumnInPortrait: f, ref: i, src: typeof p == "string" ? p : "unset", onError: () => {
    h(!0);
  }, onLoad: () => g() }) : /* @__PURE__ */ D.jsx(qO, { style: {
    width: "100%",
    height: "100%"
  } });
}), _ie = Hr(Sie), Eie = rt.figure.withConfig({
  displayName: "Figure__StyledFigure",
  componentId: "sc-16mc3ye-0"
})`
  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
  align-items: center;
  display: flex;
  width: 100%;
  max-width: 100%;
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  flex-direction: column;
  flex-shrink: 1;
  height: ${(t) => t.$isInFlexBox || !t.$isInLandscape ? "auto" : "100%"}; // seems to fix safari
  ${(t) => t.$isInFlexBox ? "min-height: 0;" : ""} // min height 0 when in a cell?
  ${(t) => t.$isInFlexBox ? "height: auto;" : t.$isInLandscape ? "min-height: 0;" : ""}
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  position: relative;
  ${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  theme: t.theme
})}`}
  
  ${(t) => `${zr("image:", t)}`}
  border: 0;
`, kie = ({
  atomId: t,
  pageIndex: e,
  type: n
}) => {
  const r = Xt(e, t), i = L(fn(r)).data, o = Xe(null), s = Xe(null), a = i.modifier?.["animate:"], l = L(Mi), u = L(pr), c = `imageComponent-${i.id}`, f = kt(tr), d = L(jt), h = i.tapped, [p, g] = Cn(0), m = d.baseFontSize, v = i.modifier ? i.modifier["caption:"] : void 0, S = L(gi), _ = L(Sa), b = L(Fi), y = L(Fs), w = kt(mi), E = i.modifier?.["toPage:"], x = i.modifier?.["url:"], k = i.modifier?.["backlink:"];
  Bo({
    elRef: o,
    tapped: h,
    atomId: t
  }), Ls({
    elRef: o,
    modifier: i.modifier
  }), b2({
    ref: o,
    tweenName: a,
    onePercent: {
      width: d.onePercentWidth,
      height: d.onePercentHeight
    },
    options: {
      position: i.modifier?.["animateStart:"] ? i.modifier?.["animateStart:"] : void 0
    },
    position: w,
    direction: S
  });
  const C = fs(() => {
    let M = null;
    try {
      if (x) {
        const F = x.startsWith("http://") || x.startsWith("https://") ? x : `https://${x}`;
        window.open(F, "_blank", "noopener,noreferrer");
      } else if (k)
        window.location.href = `/${y}/${k}`;
      else if (E) {
        M = new BroadcastChannel(pe.broadcastChannel.viewer);
        const F = Number.parseInt(E, 10);
        if (Number.isNaN(F))
          console.warn(`Invalid page number for toPage: ${E}`);
        else {
          const U = {
            hostId: b,
            type: "QP",
            action: pe.messages.goToPage,
            payload: F
          };
          M.postMessage(U);
        }
      }
    } catch (F) {
      console.error("Error during navigation click:", F);
    } finally {
      M && M.close();
    }
  }, [x, k, E, y, b]);
  return bie({
    figureRef: o,
    imageRef: s,
    tweenName: i.modifier?.["animate:"],
    navigation: x || E || k ? C : void 0
  }), Bn(() => {
    s.current && g(s.current.width);
  }, [_]), /* @__PURE__ */ D.jsx(Rn, { theme: l.image, children: /* @__PURE__ */ D.jsxs(Eie, { $baseFontSize: m, $elementIndex: t, $filterColors: u, $imageWidth: o.current?.width, $isInFlexBox: f, $isInLandscape: d.landscape, $modifier: i.modifier, $onePercentHeight: d.onePercentHeight, $onePercentWidth: d.onePercentWidth, $pageSize: d, $isInPortrait: !d.landscape, $tapped: h, "aria-hidden": !i.tapped, className: `${pe.css.pageElement} animate-entry ${pe.css.dynamicResize} image`, "data-atom-id": t, "data-testid": `${n}${t}`, id: c, ref: o, children: [
    /* @__PURE__ */ D.jsx(_ie, { atomId: t, pageIndex: e, type: n, ref: s, imageWidth: p, altText: i.altText }),
    v && /* @__PURE__ */ D.jsx(Rn, { theme: l.caption, children: /* @__PURE__ */ D.jsx(O3, { $absolutePosition: !0, $baseFontSize: m, $elementIndex: t, $filterColors: u, $isInFlexBox: f, $onePercentHeight: d.onePercentHeight, $onePercentWidth: d.onePercentWidth, $pageSize: d, $isInPortrait: !d.landscape, $tapped: h, $width: p, $parentFontSizeMultiplier: l.box.fontSize, children: /* @__PURE__ */ D.jsx("div", { children: v }) }) })
  ] }, t) });
}, Tie = Hr(kie), xie = () => /* @__PURE__ */ D.jsx(D.Fragment, {}), Cie = rt.div.withConfig({
  displayName: "GridEnd__StyledGridEnd",
  componentId: "sc-dt3jjm-0"
})``, Aie = function() {
  return /* @__PURE__ */ D.jsx(Cie, { className: "page-divider" });
}, Rie = (t) => t.line, Oie = rt.div.withConfig({
  displayName: "Line__StyledLine",
  componentId: "sc-12cwfxb-0"
})`
  ${(t) => _r(t.$tapped, t.theme.opacity)};
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  font-family: ${(t) => p2(t.theme, t.$fonts)};
  font-size: ${(t) => wa(t.theme, t.$baseFontSize)};
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  position: relative;
  width: 100%;
  
  .hr-plain {
    border: 0;
    height: ${(t) => `${t.$hrHeight * (t.$baseFontSize / 5)}px`};
    background-color: ${(t) => t.theme.color ?? "unset"};
  }
  .hr-text {
    border: 0;
    color: ${(t) => t.theme.color ?? "unset"};
    height: ${(t) => wa(t.theme, t.$baseFontSize)};
    line-height: ${(t) => `${t.$baseFontSize}px`};
    opacity: 0.9;
    outline: 0;
    position: relative;
    text-align: center;

   
    &:before {
      content: "";
      /* use the linear-gradient for the fading effect */
      /* use a solid background color for a solid bar */
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: ${(t) => `${t.$baseFontSize / 7}px`};
      background: ${(t) => `linear-gradient(to right, transparent, ${t.theme.color} ${t.$contentLocation.left - t.$baseFontSize}px, transparent ${t.$contentLocation.left - t.$baseFontSize}px, transparent ${t.$contentLocation.left + t.$contentLocation.width + t.$baseFontSize}px, ${t.theme.color}   ${t.$contentLocation.left + t.$contentLocation.width + t.$baseFontSize}px , transparent)`}}
    
  }
  ${(t) => `${zr("line:", t)}`}
`, Die = rt.div.withConfig({
  displayName: "Line__StyledContent",
  componentId: "sc-12cwfxb-1"
})`
  position: absolute;
  color: ${(t) => t.theme.color};
  top: ${(t) => `${t.$contentLocation.top}px`};
  left: ${(t) => `${t.$contentLocation.left}px`};
`, Iie = ({
  atomId: t,
  pageIndex: e
}) => {
  const n = L(Fi), r = Xt(e, t), i = L(fn(r)).data, o = kt(tr), s = L(pr), a = L(jt), [l, u] = Cn({
    top: 0,
    left: 0,
    width: 0
  }), c = L(gr), f = a.baseFontSize, d = i.tapped, h = L(Fs), p = Xe(null), g = Xe(null);
  Bo({
    elRef: p,
    tapped: d,
    atomId: t
  });
  let m = !1, v = 1;
  typeof i.content == "string" && (v = parseInt(i.content), Number.isNaN(v) && (v = 1, m = !0));
  const S = typeof i.content == "string" ? ka({
    text: i.content,
    ownerName: h,
    modifier: i.modifier,
    hostId: n,
    tapped: d
  }) : i.content, _ = i.modifier?.["background:"] ? i.modifier?.["background:"] : "unset";
  return Bn(() => {
    if (p.current && m && g.current) {
      const b = p.current, y = g.current, w = b.offsetWidth, E = y.offsetWidth, x = b.offsetHeight, k = y.offsetHeight, C = w / 2 - E / 2, M = x / 2 - k / 2;
      u({
        top: M,
        left: C,
        width: E
      });
    }
  }, [S, m, a]), /* @__PURE__ */ D.jsx(Rn, { theme: Rie, children: /* @__PURE__ */ D.jsxs(Oie, { $baseFontSize: f, $backgroundColor: _, $elementIndex: t, $isInFlexBox: o, $filterColors: s, $contentLocation: l, $fonts: c, $pageSize: a, $isInPortrait: !a.landscape, $onePercentHeight: a.onePercentHeight, $onePercentWidth: a.onePercentWidth, $hrHeight: v, $modifier: i.modifier, $tapped: d, "aria-hidden": !i.tapped, className: `${pe.css.pageElement}  line`, "data-atom-id": i.id, ref: p, children: [
    !m && /* @__PURE__ */ D.jsx("hr", { className: "hr-plain" }),
    m && i.content && /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
      /* @__PURE__ */ D.jsx("hr", { className: "hr-text" }),
      /* @__PURE__ */ D.jsx(Die, { $contentLocation: l, ref: g, children: S })
    ] })
  ] }) });
}, Nie = Hr(Iie);
function zO(t) {
  const e = Array.from(t.querySelectorAll(`${pe.css.gridClass}  ${pe.css.pageElementClass}`)), n = Array.from(t.querySelectorAll(`:not(.backdrop):not(.background)${pe.css.pageElementClass}`));
  return e.filter((i) => !n.includes(i)).concat(n.filter((i) => !e.includes(i)));
}
function HO(t) {
  var e = window.getComputedStyle(t), n = parseFloat(e.marginTop) + parseFloat(e.marginBottom);
  return Math.ceil(t.offsetHeight + n);
}
function Pie(t, e, n, r) {
  const o = t.current?.closest(pe.css.styledGridCellClass);
  let s = 0, a = 0;
  const l = o ? o.querySelectorAll(pe.css.dynamicResizeClass).length : 0, u = o ? o.querySelectorAll(":not(.image):not(.video):not(.backdrop):not(.background).page-element") : [];
  return u.length > 0 && u.forEach((c) => {
    s = +HO(c);
  }), zO(r).length > 0 && zO(r).forEach((c) => {
    a += HO(c);
  }), [(n.height - a) / e - s, l];
}
function $ie(t, e, n, r) {
  const i = document.getElementById(r);
  if (!i)
    throw "Container element does not exist";
  if (i.querySelectorAll(pe.css.gridClass).length > 0)
    return Pie(t, e, n, i);
  const s = i.getElementsByClassName(pe.css.pageElement)[0];
  if (!s || s === null) return [0, 0];
  const a = i.querySelectorAll(pe.css.dynamicResizeClass).length;
  let l = i.querySelectorAll(`:not(.image):not(.video):not(.backdrop):not(.background)${pe.css.pageElementClass}`), u = 0;
  return l.length > 0 && l.forEach((c) => {
    var f = window.getComputedStyle(c), d = parseFloat(f.marginTop) + parseFloat(f.marginBottom);
    u += Math.ceil(c.offsetHeight + d);
  }), [n.height / e - u, a];
}
const Mie = (t) => t.image, Fie = ["paddingTop", "paddingBottom", "marginTop", "marginBottom", "paddingBlockStart", "paddingBlockEnd", "marginBlockStart", "marginBlockEnd"], Lie = ["paddingLeft", "paddingRight", "marginLeft", "marginRight", "paddingInlineStart", "paddingInlineEnd", "marginInlineStart", "marginInlineEnd"], Bie = (t) => {
  const e = window.getComputedStyle(t);
  let n = 0, r = 0;
  for (const i of Fie) {
    const o = e[i];
    if (o) {
      const s = parseInt(o.replace("px", ""));
      n = n + s;
    }
  }
  for (const i of Lie) {
    const o = e[i];
    if (o) {
      const s = parseInt(o.replace("px", ""));
      r = r + s;
    }
  }
  return {
    width: r,
    height: n
  };
}, jie = rt.div.withConfig({
  displayName: "Map__StyledGMap",
  componentId: "sc-zv48r2-0"
})`
  display: flex;
  min-height: 0;
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  flex-shrink: 1;
  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
   
  justify-content: ${(t) => t.theme.align ? t.theme.align : "center"};
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  theme: t.theme
})}`}
  ${(t) => `${zr("image:", t)}`}
  border-width:  ${(t) => t.$imageWidth && t.$modifier && t.$modifier[Ya["border-thickness:"].keyword] ? `${t.$imageWidth / 400 * parseInt(t.$modifier[Ya["border-thickness:"].keyword] || "0")}px` : "unset"};
  max-width: 100%;
`, Vie = ({
  atomId: t,
  pageIndex: e,
  type: n
}) => {
  const r = L(d2), [i, o] = Cn(""), s = L(r2), a = Xt(e, t), l = L(fn(a)).data, u = kt(tr), c = L(pr), f = L(jt), d = `gMapComponent-${l.id}`, [h, p] = Cn(0), g = Xe(null), m = f.baseFontSize, v = l.tapped, S = L(i2);
  return Bo({
    elRef: g,
    tapped: v,
    atomId: t
  }), Bn(() => {
    if (g.current) {
      let _ = 0, b = 0;
      const [y, w] = $ie(g, S, f, r), E = Bie(g.current);
      _ = Math.round(y / w - E.height), b = Math.round(f.width / s - E.width), _ > f.height && (_ = f.height), b > f.width && (b = f.width), p(b), o(`<iframe src=${l.content} width=${b} height=${_} style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`);
    }
  }, [s, r, l.content, f, S]), /* @__PURE__ */ D.jsx(Rn, { theme: Mie, children: /* @__PURE__ */ D.jsx(jie, { $baseFontSize: m, $elementIndex: t, $filterColors: c, $imageWidth: h, $isInFlexBox: u, $isInLandscape: f.landscape, $modifier: l.modifier, $onePercentHeight: f.onePercentHeight, $pageSize: f, $isInPortrait: !f.landscape, $tapped: v, "aria-hidden": !l.tapped, className: `${pe.css.pageElement}  ${pe.css.dynamicResize} gMap`, "data-atom-id": t, "data-testid": `${n}${t}`, id: d, ref: g, $onePercentWidth: f.onePercentWidth, children: /* @__PURE__ */ D.jsx("div", { dangerouslySetInnerHTML: {
    __html: i
  } }) }) });
}, Uie = ({
  pageIndex: t,
  atomId: e
}) => {
  const n = Xt(t, e), r = L(fn(n)).data, i = Es(({
    set: o
  }) => (s) => {
    o(vi, s);
  });
  return lt(() => {
    if (typeof r.content != "string") return;
    const o = r.content.trim();
    (o === "scroll" || o === "tap" || o === "scrollCards" || o === "scrollContinuous") && i(o);
  }), /* @__PURE__ */ D.jsx(D.Fragment, {});
}, qie = rt.div.withConfig({
  displayName: "PageDivider__StyledPageDivider",
  componentId: "sc-138dc11-0"
})``, zie = function() {
  return /* @__PURE__ */ D.jsx(qie, { className: "page-divider" });
}, Hie = (t) => t.paragraph, Gie = rt.div.withConfig({
  displayName: "Paragraph__StyledParagraph",
  componentId: "sc-1pbfnss-0"
})`
  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`};
  ${(t) => `${zr("paragraph:", t)}`};
  text-align: start;
`, Wie = ({
  atomId: t,
  pageIndex: e,
  type: n
}) => {
  const r = Xt(e, t), i = L(fn(r)).data, o = i.modifier?.["animate:"], s = L(gi), a = kt(tr), l = Xe(null), u = L(pr), c = L(gr), f = L(zn), d = L(Fs), h = L(jt), p = i.tapped, g = kt(mi), m = L(Fi);
  Bo({
    elRef: l,
    tapped: p,
    atomId: t
  }), Ls({
    elRef: l,
    modifier: i.modifier
  }), b2({
    ref: l,
    tweenName: o,
    onePercent: {
      width: h.onePercentWidth,
      height: h.onePercentHeight
    },
    options: {
      position: i.modifier?.["animateStart:"] ? i.modifier?.["animateStart:"] : void 0
    },
    position: g,
    direction: s
  });
  const v = h.baseFontSize, S = typeof i.content == "string" ? ka({
    text: i.content,
    ownerName: d,
    modifier: i.modifier,
    hostId: m,
    tapped: p
  }) : i.content;
  return i.content ? /* @__PURE__ */ D.jsx(Rn, { theme: Hie, children: /* @__PURE__ */ D.jsx(
    Gie,
    {
      $baseFontSize: v,
      $elementIndex: t,
      $filterColors: u,
      $fonts: c,
      $isInFlexBox: a,
      $modifier: i.modifier,
      $onePercentHeight: h.onePercentHeight,
      $onePercentWidth: h.onePercentWidth,
      $pageSize: h,
      $isInPortrait: !h.landscape,
      $tapped: p,
      "aria-hidden": !i.tapped,
      className: `${pe.css.pageElement}  paragraph`,
      "data-atom-id": t,
      "data-testid": lf({
        atomId: t,
        position: g,
        type: n,
        isPreviewer: f
      }),
      ref: l,
      children: S
    }
  ) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, Yie = Hr(Wie), Xie = function() {
  return /* @__PURE__ */ D.jsx(D.Fragment, {});
};
Pe.registerPlugin(so);
const Kie = (t) => t.read, Qie = rt.section.withConfig({
  displayName: "Read__StyledRead",
  componentId: "sc-1in6ojn-0"
})`
  overflow: hidden;
  max-height: 50svh;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`}
  display: ${(t) => t.$readMode ? "flex" : "none"};
  align-items: center;
  height: auto;
  border-end-start-radius : 0;
  border-end-end-radius: 0;
  width: ${(t) => `${t.$pageSize.width}px`};
  z-index:60;
  position: absolute; // important to keep this here.  
  top: ${(t) => t.$top};
  visibility: hidden;
  background: linear-gradient(180deg, #fdf4fc, #fff 60%);
`, Jie = rt.div.withConfig({
  displayName: "Read__StyledDagger",
  componentId: "sc-1in6ojn-1"
})`
  display: flex;
  align-items: center;
  justify-self: end;
  visibility: visible;
  padding:  ${(t) => `${t.$pageWidth / 200}px`};
  margin:  ${(t) => `${t.$pageWidth / 200}px`};
  color: ${(t) => t.$daggerColor ? t.$daggerColor : Ot.tufte.black};
  cursor: pointer;

`, Zie = ({
  atomId: t,
  pageIndex: e,
  type: n
}) => {
  const [r, i] = Cn(!1), o = L(op), s = Xt(e, t), a = o.baseFontSize, l = Xe(null), u = L(fn(s)).data, c = L(pr), f = L(gr), d = L(Fi), h = L(dy), p = kt(tr), g = L(Sf), m = L(zn), v = L(Fs), S = Xe(null), _ = kt(mi), b = L(dy), y = u.tapped, w = u.modifier?.["color:"] ? (
    // @ts-expect-error
    c[u.modifier?.["color:"]]
  ) : Ot.tufte.black;
  so(() => {
    if (S.current && r) {
      const M = S.current.offsetHeight;
      g ? Pe.set(S.current, {
        top: o.height - M,
        height: "auto",
        autoAlpha: 1
      }) : (Pe.set(S.current, {
        top: o.height - M
      }), Pe.to(S.current, {
        height: "auto",
        autoAlpha: 1
      }));
    }
  }, {
    dependencies: [r, o.x0, o.documentHeight, o.height]
  });
  const E = () => {
    i(!r);
  };
  so(() => {
    l.current && (r ? Pe.to(l.current, {
      rotate: 90
    }) : Pe.to(l.current, {
      rotate: 0
    }));
  }, {
    dependencies: [r]
  });
  const x = typeof u.content == "string" ? ka({
    text: u.content,
    ownerName: v,
    modifier: u.modifier,
    hostId: d,
    tapped: y
  }) : u.content, k = (M) => {
    M.stopPropagation(), E();
  };
  if (!u.content) return /* @__PURE__ */ D.jsx(D.Fragment, {});
  const C = () => /* @__PURE__ */ D.jsx(Rn, { theme: Kie, children: /* @__PURE__ */ D.jsx(Qie, { $baseFontSize: a, $elementIndex: t, $filterColors: c, $fonts: f, $isInFlexBox: p, $left: o.x0, $modifier: u.modifier, $onePercentHeight: o.onePercentHeight, $onePercentWidth: o.onePercentWidth, $pageSize: o, $isInPortrait: !o.landscape, $readMode: b, $show: r, $tapped: y, $top: o.height, "aria-hidden": !u.tapped, className: `${pe.css.pageElement} read`, "data-atom-id": t, "data-testid": lf({
    atomId: t,
    position: _,
    type: n,
    isPreviewer: m
  }), onClick: k, ref: S, children: /* @__PURE__ */ D.jsx("div", { className: "content", "aria-hidden": !r, children: x }) }) });
  return h ? /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsx(Jie, { className: "read-dagger", $pageWidth: o.width, ref: l, $daggerColor: w, "data-testid": `dagger-${lf({
      atomId: t,
      position: _,
      type: n,
      isPreviewer: m
    })}`, onClick: k, children: "†" }),
    /* @__PURE__ */ D.jsx(C, {})
  ] }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, eoe = function() {
  return /* @__PURE__ */ D.jsx(D.Fragment, {});
}, toe = rt.div.withConfig({
  displayName: "StackDivider__StyledStackDivider",
  componentId: "sc-1rd6ft8-0"
})``, noe = function() {
  return /* @__PURE__ */ D.jsx(toe, { className: "stack-divider" });
}, roe = rt.header.withConfig({
  displayName: "StickyHeader__StyledStickyHeader",
  componentId: "sc-1x51fja-0"
})``, ioe = () => /* @__PURE__ */ D.jsx(roe, { className: "sticky-menu" });
function ooe({
  atomId: t,
  pageIndex: e
}) {
  return /* @__PURE__ */ D.jsx("div", { "data-testid": `sticky-footer-${e}-${t}` });
}
const soe = function({}) {
  return /* @__PURE__ */ D.jsx(D.Fragment, {});
}, aoe = (t) => t.subtitle, loe = rt.div.withConfig({
  displayName: "SubTitle__StyledSubTitle",
  componentId: "sc-d3fkpg-0"
})`
  text-wrap: auto;
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`};
  ${(t) => `${zr("subtitle:", t)}`}
`, uoe = ({
  atomId: t,
  pageIndex: e
}) => {
  const n = Xt(e, t), r = L(fn(n)).data, i = kt(tr), o = Xe(null), s = L(pr), a = L(jt), l = L(gr), u = a.baseFontSize, c = r.tapped, f = L(Fs), d = L(Fi);
  Bo({
    elRef: o,
    tapped: c,
    atomId: t
  }), Ls({
    elRef: o,
    modifier: r.modifier
  });
  const h = typeof r.content == "string" ? ka({
    text: r.content,
    ownerName: f,
    modifier: r.modifier,
    hostId: d,
    tapped: c
  }) : r.content;
  return r.content ? /* @__PURE__ */ D.jsx(Rn, { theme: aoe, children: /* @__PURE__ */ D.jsx(loe, { $baseFontSize: u, $elementIndex: t, $filterColors: s, $fonts: l, $isInFlexBox: i, $modifier: r.modifier, $onePercentHeight: a.onePercentHeight, $onePercentWidth: a.onePercentWidth, $pageSize: a, $isInPortrait: !a.landscape, $tapped: c, className: `${pe.css.pageElement}  subtitle`, "data-atom-id": t, ref: o, children: h }) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, coe = Hr(uoe), foe = rt.div.withConfig({
  displayName: "SuperTitle__StyledSuperTitle",
  componentId: "sc-157jtkq-0"
})`
  flex-wrap: wrap;
  text-wrap: auto;
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  ${(t) => _r(t.$tapped, t.theme.opacity)};
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`};
  ${(t) => `${zr("supertitle:", t)}`}
`, doe = (t) => t.supertitle, hoe = ({
  atomId: t,
  pageIndex: e
}) => {
  const n = Xt(e, t), r = L(fn(n)).data, i = kt(tr), o = Xe(null), s = L(pr), a = L(gr), l = L(Fi), u = L(Fs), c = L(jt), f = r.tapped, d = c.baseFontSize;
  Bo({
    elRef: o,
    tapped: f,
    atomId: t
  }), Ls({
    elRef: o,
    modifier: r.modifier
  });
  const h = typeof r.content == "string" ? ka({
    text: r.content,
    ownerName: u,
    modifier: r.modifier,
    hostId: l,
    tapped: f
  }) : r.content;
  return r.content ? /* @__PURE__ */ D.jsx(Rn, { theme: doe, children: /* @__PURE__ */ D.jsx(foe, { $baseFontSize: d, $elementIndex: t, $filterColors: s, $fonts: a, $isInFlexBox: i, $modifier: r.modifier, $onePercentHeight: c.onePercentHeight, $onePercentWidth: c.onePercentWidth, $pageSize: c, $isInPortrait: !c.landscape, $tapped: f, className: `${pe.css.pageElement}  supertitle`, "data-atom-id": t, ref: o, children: /* @__PURE__ */ D.jsx("span", { children: h }) }) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, poe = Hr(hoe), goe = rt.div.withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-wb207j-0"
})`
  text-wrap: auto;
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`}
  ${(t) => `${zr("title:", t)}`};
  
`, moe = ({
  atomId: t,
  pageIndex: e,
  type: n
}) => {
  const r = Xt(e, t), i = L(fn(r)).data, o = kt(tr), s = Xe(null), a = L(pr), l = L(zn), u = L(jt), c = u.baseFontSize, f = i.tapped, d = L(gr), h = L(Fs), p = kt(mi), g = L(Fi);
  Bo({
    elRef: s,
    tapped: f,
    atomId: t
  }), Ls({
    elRef: s,
    modifier: i.modifier
  });
  const m = typeof i.content == "string" ? ka({
    text: i.content,
    ownerName: h,
    modifier: i.modifier,
    hostId: g,
    tapped: f
  }) : i.content, v = (S) => S.title;
  return i.content ? /* @__PURE__ */ D.jsx(Rn, { theme: v, children: /* @__PURE__ */ D.jsx(goe, { $baseFontSize: c, $elementIndex: t, $filterColors: a, $fonts: d, $isInFlexBox: o, $modifier: i.modifier, $onePercentHeight: u.onePercentHeight, $onePercentWidth: u.onePercentWidth, $pageSize: u, $isInPortrait: !u.landscape, $tapped: f, className: `${pe.css.pageElement}  title`, "data-atom-id": i.id, "data-testid": lf({
    atomId: t,
    position: p,
    type: n,
    isPreviewer: l
  }), ref: s, children: m }) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, yoe = Hr(moe), voe = (t) => /* @__PURE__ */ D.jsxs("svg", { width: "30px", height: "29px", viewBox: "0 0 30 29", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...t, children: [
  /* @__PURE__ */ D.jsx("title", { children: "clapperboard" }),
  /* @__PURE__ */ D.jsx("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ D.jsxs("g", { id: "clapperboard", children: [
    /* @__PURE__ */ D.jsxs("g", { id: "Group", opacity: 0.2, transform: "translate(2, 2)", fill: "#000000", children: [
      /* @__PURE__ */ D.jsx("polygon", { id: "Path", fillRule: "nonzero", points: "1.65582727 6.59998378 24.5285926 1.64001565 25.5303326 6.17071462 2.65743483 11.1306828" }),
      /* @__PURE__ */ D.jsx("path", { d: "M0.0386570205,6.95063312 C-0.156890044,6.06604122 0.408610479,5.1919429 1.30176656,4.99827088 L24.1746478,0.0382863506 C25.0677873,-0.155385675 25.9503317,0.404692443 26.1458456,1.28928434 L27.1474201,5.81998331 C27.3429341,6.70455881 26.777417,7.57867352 25.8842774,7.77234555 L3.01152865,12.7323301 C2.11838912,12.9260021 1.23581165,12.3659076 1.04026458,11.4813321 L0.0386570205,6.95063312 Z M3.6271079,7.85093258 L3.92054438,9.17827132 L23.5589692,4.91968384 L23.2656155,3.59232871 L3.6271079,7.85093258 Z", id: "Shape" }),
      /* @__PURE__ */ D.jsx("polygon", { id: "Path", fillRule: "nonzero", points: "2.92986308 11.4462442 26.344505 11.4462442 26.344505 25.3603791 2.92986308 25.3603791" }),
      /* @__PURE__ */ D.jsx("path", { d: "M1.27436812,11.4462442 C1.27436812,10.5406979 2.01556633,9.80662326 2.92986308,9.80662326 L26.344505,9.80662326 C27.2588349,9.80662326 28,10.5406979 28,11.4462442 L28,25.3603791 C28,26.2659417 27.2588349,27 26.344505,27 L2.92986308,27 C2.01556633,27 1.27436812,26.2659417 1.27436812,25.3603791 L1.27436812,11.4462442 Z M4.58535804,13.0858487 L4.58535804,23.7207581 L24.6890101,23.7207581 L24.6890101,13.0858487 L4.58535804,13.0858487 Z", id: "Shape" })
    ] }),
    /* @__PURE__ */ D.jsx("path", { d: "M0.0193472959,6.41313132 C-0.0785186714,5.95969162 0.204489498,5.5116476 0.65146703,5.41235681 L24.9310023,0.0196247391 C25.3778887,-0.0796492417 25.8196384,0.207448556 25.9174,0.660871453 L26.9806815,5.58688471 C27.078443,6.0403076 26.7955972,6.48836843 26.3485451,6.58764241 L2.06905962,11.9803745 C1.62209037,12.0796485 1.18040688,11.7925675 1.08254588,11.3391278 L0.0193472959,6.41313132 Z M1.81517777,6.87460573 L2.52398235,10.1586146 L25.184851,5.12539349 L24.4759967,1.84138465 L1.81517777,6.87460573 Z", id: "Shape", fill: "#000000" }),
    /* @__PURE__ */ D.jsx("polygon", { id: "Path", fill: "#000000", points: "14.9449428 8 11 4.11682073 12.055118 3 16 6.88317927" }),
    /* @__PURE__ */ D.jsx("polygon", { id: "Path", fill: "#000000", points: "8.94490686 10 5 6.11682073 6.05509314 5 10 8.88317927" }),
    /* @__PURE__ */ D.jsx("polygon", { id: "Path", fill: "#000000", points: "21.9448244 7 18 3.11682073 19.0550236 2 23 5.88317927" }),
    /* @__PURE__ */ D.jsx("polygon", { id: "Path", fill: "#000000", points: "13.4689889 17 17 11.936271 15.5309228 11 12 16.063729" }),
    /* @__PURE__ */ D.jsx("polygon", { id: "Path", fill: "#000000", points: "20.4690512 17 24 11.936271 22.5309488 11 19 16.063729" }),
    /* @__PURE__ */ D.jsx("polygon", { id: "Path", fill: "#000000", points: "7.46898889 17 11 11.936271 9.53101111 11 6 16.063729" }),
    /* @__PURE__ */ D.jsx("path", { d: "M1,10.85 C1,10.380562 1.37776328,10 1.84374895,10 L27.1562511,10 C27.6221692,10 28,10.380562 28,10.85 L28,26.15 C28,26.61937 27.6221692,27 27.1562511,27 L1.84374895,27 C1.37776328,27 1,26.61937 1,26.15 L1,10.85 Z M2.68749789,11.7 L2.68749789,25.3 L26.3125021,25.3 L26.3125021,11.7 L2.68749789,11.7 Z", id: "Shape", fill: "#000000" }),
    /* @__PURE__ */ D.jsx("polygon", { id: "Path", fill: "#000000", points: "28 17 1 17 1 15 28 15" }),
    /* @__PURE__ */ D.jsx("circle", { id: "Oval", fillOpacity: 0.54, fill: "#D8D8D8", cx: 15, cy: 16, r: 6 }),
    /* @__PURE__ */ D.jsx("polygon", { id: "Triangle", fillOpacity: 0.74, fill: "#FFFFFF", transform: "translate(15.813, 16.1485) rotate(-269) translate(-15.813, -16.1485)", points: "15.8130353 13.6517102 18.3098303 18.6453003 13.3162402 18.6453003" })
  ] }) })
] });
var t1, GO;
function boe() {
  if (GO) return t1;
  GO = 1, t1 = function(i, o, s) {
    var a = document.head || document.getElementsByTagName("head")[0], l = document.createElement("script");
    typeof o == "function" && (s = o, o = {}), o = o || {}, s = s || function() {
    }, l.type = o.type || "text/javascript", l.charset = o.charset || "utf8", l.async = "async" in o ? !!o.async : !0, l.src = i, o.attrs && t(l, o.attrs), o.text && (l.text = "" + o.text);
    var u = "onload" in l ? e : n;
    u(l, s), l.onload || e(l, s), a.appendChild(l);
  };
  function t(r, i) {
    for (var o in i)
      r.setAttribute(o, i[o]);
  }
  function e(r, i) {
    r.onload = function() {
      this.onerror = this.onload = null, i(null, r);
    }, r.onerror = function() {
      this.onerror = this.onload = null, i(new Error("Failed to load " + this.src), r);
    };
  }
  function n(r, i) {
    r.onreadystatechange = function() {
      this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, i(null, r));
    };
  }
  return t1;
}
var n1, WO;
function N3() {
  if (WO) return n1;
  WO = 1;
  var t = function(S) {
    return e(S) && !n(S);
  };
  function e(v) {
    return !!v && typeof v == "object";
  }
  function n(v) {
    var S = Object.prototype.toString.call(v);
    return S === "[object RegExp]" || S === "[object Date]" || o(v);
  }
  var r = typeof Symbol == "function" && Symbol.for, i = r ? Symbol.for("react.element") : 60103;
  function o(v) {
    return v.$$typeof === i;
  }
  function s(v) {
    return Array.isArray(v) ? [] : {};
  }
  function a(v, S) {
    return S.clone !== !1 && S.isMergeableObject(v) ? g(s(v), v, S) : v;
  }
  function l(v, S, _) {
    return v.concat(S).map(function(b) {
      return a(b, _);
    });
  }
  function u(v, S) {
    if (!S.customMerge)
      return g;
    var _ = S.customMerge(v);
    return typeof _ == "function" ? _ : g;
  }
  function c(v) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(v).filter(function(S) {
      return Object.propertyIsEnumerable.call(v, S);
    }) : [];
  }
  function f(v) {
    return Object.keys(v).concat(c(v));
  }
  function d(v, S) {
    try {
      return S in v;
    } catch {
      return !1;
    }
  }
  function h(v, S) {
    return d(v, S) && !(Object.hasOwnProperty.call(v, S) && Object.propertyIsEnumerable.call(v, S));
  }
  function p(v, S, _) {
    var b = {};
    return _.isMergeableObject(v) && f(v).forEach(function(y) {
      b[y] = a(v[y], _);
    }), f(S).forEach(function(y) {
      h(v, y) || (d(v, y) && _.isMergeableObject(S[y]) ? b[y] = u(y, _)(v[y], S[y], _) : b[y] = a(S[y], _));
    }), b;
  }
  function g(v, S, _) {
    _ = _ || {}, _.arrayMerge = _.arrayMerge || l, _.isMergeableObject = _.isMergeableObject || t, _.cloneUnlessOtherwiseSpecified = a;
    var b = Array.isArray(S), y = Array.isArray(v), w = b === y;
    return w ? b ? _.arrayMerge(v, S, _) : p(v, S, _) : a(S, _);
  }
  g.all = function(S, _) {
    if (!Array.isArray(S))
      throw new Error("first argument should be an array");
    return S.reduce(function(b, y) {
      return g(b, y, _);
    }, {});
  };
  var m = g;
  return n1 = m, n1;
}
var r1, YO;
function k0() {
  if (YO) return r1;
  YO = 1;
  var t = Object.create, e = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, o = Object.prototype.hasOwnProperty, s = (X, O) => {
    for (var W in O)
      e(X, W, { get: O[W], enumerable: !0 });
  }, a = (X, O, W, T) => {
    if (O && typeof O == "object" || typeof O == "function")
      for (let $ of r(O))
        !o.call(X, $) && $ !== W && e(X, $, { get: () => O[$], enumerable: !(T = n(O, $)) || T.enumerable });
    return X;
  }, l = (X, O, W) => (W = X != null ? t(i(X)) : {}, a(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !X || !X.__esModule ? e(W, "default", { value: X, enumerable: !0 }) : W,
    X
  )), u = (X) => a(e({}, "__esModule", { value: !0 }), X), c = {};
  s(c, {
    callPlayer: () => B,
    getConfig: () => F,
    getSDK: () => M,
    isBlobUrl: () => q,
    isMediaStream: () => N,
    lazy: () => p,
    omit: () => U,
    parseEndTime: () => w,
    parseStartTime: () => y,
    queryString: () => x,
    randomString: () => E,
    supportsWebKitPresentationMode: () => Q
  }), r1 = u(c);
  var f = l(nt), d = l(boe()), h = l(N3());
  const p = (X) => f.default.lazy(async () => {
    const O = await X();
    return typeof O.default == "function" ? O : O.default;
  }), g = /[?&#](?:start|t)=([0-9hms]+)/, m = /[?&#]end=([0-9hms]+)/, v = /(\d+)(h|m|s)/g, S = /^\d+$/;
  function _(X, O) {
    if (X instanceof Array)
      return;
    const W = X.match(O);
    if (W) {
      const T = W[1];
      if (T.match(v))
        return b(T);
      if (S.test(T))
        return parseInt(T);
    }
  }
  function b(X) {
    let O = 0, W = v.exec(X);
    for (; W !== null; ) {
      const [, T, $] = W;
      $ === "h" && (O += parseInt(T, 10) * 60 * 60), $ === "m" && (O += parseInt(T, 10) * 60), $ === "s" && (O += parseInt(T, 10)), W = v.exec(X);
    }
    return O;
  }
  function y(X) {
    return _(X, g);
  }
  function w(X) {
    return _(X, m);
  }
  function E() {
    return Math.random().toString(36).substr(2, 5);
  }
  function x(X) {
    return Object.keys(X).map((O) => `${O}=${X[O]}`).join("&");
  }
  function k(X) {
    return window[X] ? window[X] : window.exports && window.exports[X] ? window.exports[X] : window.module && window.module.exports && window.module.exports[X] ? window.module.exports[X] : null;
  }
  const C = {}, M = function(O, W, T = null, $ = () => !0, P = d.default) {
    const H = k(W);
    return H && $(H) ? Promise.resolve(H) : new Promise((Z, le) => {
      if (C[O]) {
        C[O].push({ resolve: Z, reject: le });
        return;
      }
      C[O] = [{ resolve: Z, reject: le }];
      const J = (ue) => {
        C[O].forEach((he) => he.resolve(ue));
      };
      if (T) {
        const ue = window[T];
        window[T] = function() {
          ue && ue(), J(k(W));
        };
      }
      P(O, (ue) => {
        ue ? (C[O].forEach((he) => he.reject(ue)), C[O] = null) : T || J(k(W));
      });
    });
  };
  function F(X, O) {
    return (0, h.default)(O.config, X.config);
  }
  function U(X, ...O) {
    const W = [].concat(...O), T = {}, $ = Object.keys(X);
    for (const P of $)
      W.indexOf(P) === -1 && (T[P] = X[P]);
    return T;
  }
  function B(X, ...O) {
    if (!this.player || !this.player[X]) {
      let W = `ReactPlayer: ${this.constructor.displayName} player could not call %c${X}%c – `;
      return this.player ? this.player[X] || (W += "The method was not available") : W += "The player was not available", console.warn(W, "font-weight: bold", ""), null;
    }
    return this.player[X](...O);
  }
  function N(X) {
    return typeof window < "u" && typeof window.MediaStream < "u" && X instanceof window.MediaStream;
  }
  function q(X) {
    return /^blob:/.test(X);
  }
  function Q(X = document.createElement("video")) {
    const O = /iPhone|iPod/.test(navigator.userAgent) === !1;
    return X.webkitSupportsPresentationMode && typeof X.webkitSetPresentationMode == "function" && O;
  }
  function ne(X) {
    return X;
  }
  return r1;
}
var i1, XO;
function woe() {
  if (XO) return i1;
  XO = 1;
  var t = Object.defineProperty, e = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, r = Object.prototype.hasOwnProperty, i = (B, N) => {
    for (var q in N)
      t(B, q, { get: N[q], enumerable: !0 });
  }, o = (B, N, q, Q) => {
    if (N && typeof N == "object" || typeof N == "function")
      for (let ne of n(N))
        !r.call(B, ne) && ne !== q && t(B, ne, { get: () => N[ne], enumerable: !(Q = e(N, ne)) || Q.enumerable });
    return B;
  }, s = (B) => o(t({}, "__esModule", { value: !0 }), B), a = {};
  i(a, {
    AUDIO_EXTENSIONS: () => E,
    DASH_EXTENSIONS: () => C,
    FLV_EXTENSIONS: () => M,
    HLS_EXTENSIONS: () => k,
    MATCH_URL_DAILYMOTION: () => _,
    MATCH_URL_FACEBOOK: () => h,
    MATCH_URL_FACEBOOK_WATCH: () => p,
    MATCH_URL_KALTURA: () => w,
    MATCH_URL_MIXCLOUD: () => b,
    MATCH_URL_MUX: () => d,
    MATCH_URL_SOUNDCLOUD: () => c,
    MATCH_URL_STREAMABLE: () => g,
    MATCH_URL_TWITCH_CHANNEL: () => S,
    MATCH_URL_TWITCH_VIDEO: () => v,
    MATCH_URL_VIDYARD: () => y,
    MATCH_URL_VIMEO: () => f,
    MATCH_URL_WISTIA: () => m,
    MATCH_URL_YOUTUBE: () => u,
    VIDEO_EXTENSIONS: () => x,
    canPlay: () => U
  }), i1 = s(a);
  var l = /* @__PURE__ */ k0();
  const u = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//, c = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/, f = /vimeo\.com\/(?!progressive_redirect).+/, d = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/, h = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/, p = /^https?:\/\/fb\.watch\/.+$/, g = /streamable\.com\/([a-z0-9]+)$/, m = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/, v = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/, S = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/, _ = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/, b = /mixcloud\.com\/([^/]+\/[^/]+)/, y = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/, w = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/, E = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i, x = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, k = /\.(m3u8)($|\?)/i, C = /\.(mpd)($|\?)/i, M = /\.(flv)($|\?)/i, F = (B) => {
    if (B instanceof Array) {
      for (const N of B)
        if (typeof N == "string" && F(N) || F(N.src))
          return !0;
      return !1;
    }
    return (0, l.isMediaStream)(B) || (0, l.isBlobUrl)(B) ? !0 : E.test(B) || x.test(B) || k.test(B) || C.test(B) || M.test(B);
  }, U = {
    youtube: (B) => B instanceof Array ? B.every((N) => u.test(N)) : u.test(B),
    soundcloud: (B) => c.test(B) && !E.test(B),
    vimeo: (B) => f.test(B) && !x.test(B) && !k.test(B),
    mux: (B) => d.test(B),
    facebook: (B) => h.test(B) || p.test(B),
    streamable: (B) => g.test(B),
    wistia: (B) => m.test(B),
    twitch: (B) => v.test(B) || S.test(B),
    dailymotion: (B) => _.test(B),
    mixcloud: (B) => b.test(B),
    vidyard: (B) => y.test(B),
    kaltura: (B) => w.test(B),
    file: F
  };
  return i1;
}
var o1, KO;
function Soe() {
  if (KO) return o1;
  KO = 1;
  var t = Object.defineProperty, e = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, r = Object.prototype.hasOwnProperty, i = (f, d) => {
    for (var h in d)
      t(f, h, { get: d[h], enumerable: !0 });
  }, o = (f, d, h, p) => {
    if (d && typeof d == "object" || typeof d == "function")
      for (let g of n(d))
        !r.call(f, g) && g !== h && t(f, g, { get: () => d[g], enumerable: !(p = e(d, g)) || p.enumerable });
    return f;
  }, s = (f) => o(t({}, "__esModule", { value: !0 }), f), a = {};
  i(a, {
    default: () => c
  }), o1 = s(a);
  var l = /* @__PURE__ */ k0(), u = /* @__PURE__ */ woe(), c = [
    {
      key: "youtube",
      name: "YouTube",
      canPlay: u.canPlay.youtube,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerYouTube' */
        "./YouTube-9xsnMnuq.js"
      ).then((f) => f.Y))
    },
    {
      key: "soundcloud",
      name: "SoundCloud",
      canPlay: u.canPlay.soundcloud,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerSoundCloud' */
        "./SoundCloud-ChL9SHZE.js"
      ).then((f) => f.S))
    },
    {
      key: "vimeo",
      name: "Vimeo",
      canPlay: u.canPlay.vimeo,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerVimeo' */
        "./Vimeo-CCik_o35.js"
      ).then((f) => f.V))
    },
    {
      key: "mux",
      name: "Mux",
      canPlay: u.canPlay.mux,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerMux' */
        "./Mux-0keWfqPv.js"
      ).then((f) => f.M))
    },
    {
      key: "facebook",
      name: "Facebook",
      canPlay: u.canPlay.facebook,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerFacebook' */
        "./Facebook-B2XJAABX.js"
      ).then((f) => f.F))
    },
    {
      key: "streamable",
      name: "Streamable",
      canPlay: u.canPlay.streamable,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerStreamable' */
        "./Streamable-Mgp4Qjen.js"
      ).then((f) => f.S))
    },
    {
      key: "wistia",
      name: "Wistia",
      canPlay: u.canPlay.wistia,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerWistia' */
        "./Wistia-OfUhm9u6.js"
      ).then((f) => f.W))
    },
    {
      key: "twitch",
      name: "Twitch",
      canPlay: u.canPlay.twitch,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerTwitch' */
        "./Twitch--KbksoB3.js"
      ).then((f) => f.T))
    },
    {
      key: "dailymotion",
      name: "DailyMotion",
      canPlay: u.canPlay.dailymotion,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerDailyMotion' */
        "./DailyMotion-DtOO447I.js"
      ).then((f) => f.D))
    },
    {
      key: "mixcloud",
      name: "Mixcloud",
      canPlay: u.canPlay.mixcloud,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerMixcloud' */
        "./Mixcloud-DY1HecKQ.js"
      ).then((f) => f.M))
    },
    {
      key: "vidyard",
      name: "Vidyard",
      canPlay: u.canPlay.vidyard,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerVidyard' */
        "./Vidyard-D-j7LrW7.js"
      ).then((f) => f.V))
    },
    {
      key: "kaltura",
      name: "Kaltura",
      canPlay: u.canPlay.kaltura,
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerKaltura' */
        "./Kaltura-CSs2zOKp.js"
      ).then((f) => f.K))
    },
    {
      key: "file",
      name: "FilePlayer",
      canPlay: u.canPlay.file,
      canEnablePIP: (f) => u.canPlay.file(f) && (document.pictureInPictureEnabled || (0, l.supportsWebKitPresentationMode)()) && !u.AUDIO_EXTENSIONS.test(f),
      lazyPlayer: (0, l.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerFilePlayer' */
        "./FilePlayer-Ch9hzFlf.js"
      ).then((f) => f.F))
    }
  ];
  return o1;
}
var QO = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function _oe(t, e) {
  return !!(t === e || QO(t) && QO(e));
}
function Eoe(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!_oe(t[n], e[n]))
      return !1;
  return !0;
}
function koe(t, e) {
  e === void 0 && (e = Eoe);
  var n, r = [], i, o = !1;
  function s() {
    for (var a = [], l = 0; l < arguments.length; l++)
      a[l] = arguments[l];
    return o && n === this && e(a, r) || (i = t.apply(this, a), o = !0, n = this, r = a), i;
  }
  return s;
}
const Toe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: koe
}, Symbol.toStringTag, { value: "Module" })), xoe = /* @__PURE__ */ OS(Toe);
var s1, JO;
function P3() {
  if (JO) return s1;
  JO = 1;
  var t = typeof Element < "u", e = typeof Map == "function", n = typeof Set == "function", r = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function i(o, s) {
    if (o === s) return !0;
    if (o && s && typeof o == "object" && typeof s == "object") {
      if (o.constructor !== s.constructor) return !1;
      var a, l, u;
      if (Array.isArray(o)) {
        if (a = o.length, a != s.length) return !1;
        for (l = a; l-- !== 0; )
          if (!i(o[l], s[l])) return !1;
        return !0;
      }
      var c;
      if (e && o instanceof Map && s instanceof Map) {
        if (o.size !== s.size) return !1;
        for (c = o.entries(); !(l = c.next()).done; )
          if (!s.has(l.value[0])) return !1;
        for (c = o.entries(); !(l = c.next()).done; )
          if (!i(l.value[1], s.get(l.value[0]))) return !1;
        return !0;
      }
      if (n && o instanceof Set && s instanceof Set) {
        if (o.size !== s.size) return !1;
        for (c = o.entries(); !(l = c.next()).done; )
          if (!s.has(l.value[0])) return !1;
        return !0;
      }
      if (r && ArrayBuffer.isView(o) && ArrayBuffer.isView(s)) {
        if (a = o.length, a != s.length) return !1;
        for (l = a; l-- !== 0; )
          if (o[l] !== s[l]) return !1;
        return !0;
      }
      if (o.constructor === RegExp) return o.source === s.source && o.flags === s.flags;
      if (o.valueOf !== Object.prototype.valueOf && typeof o.valueOf == "function" && typeof s.valueOf == "function") return o.valueOf() === s.valueOf();
      if (o.toString !== Object.prototype.toString && typeof o.toString == "function" && typeof s.toString == "function") return o.toString() === s.toString();
      if (u = Object.keys(o), a = u.length, a !== Object.keys(s).length) return !1;
      for (l = a; l-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(s, u[l])) return !1;
      if (t && o instanceof Element) return !1;
      for (l = a; l-- !== 0; )
        if (!((u[l] === "_owner" || u[l] === "__v" || u[l] === "__o") && o.$$typeof) && !i(o[u[l]], s[u[l]]))
          return !1;
      return !0;
    }
    return o !== o && s !== s;
  }
  return s1 = function(s, a) {
    try {
      return i(s, a);
    } catch (l) {
      if ((l.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw l;
    }
  }, s1;
}
var Tg = { exports: {} }, xg = { exports: {} }, nn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ZO;
function Coe() {
  if (ZO) return nn;
  ZO = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, d = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, S = t ? Symbol.for("react.scope") : 60119;
  function _(y) {
    if (typeof y == "object" && y !== null) {
      var w = y.$$typeof;
      switch (w) {
        case e:
          switch (y = y.type, y) {
            case l:
            case u:
            case r:
            case o:
            case i:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case c:
                case p:
                case h:
                case s:
                  return y;
                default:
                  return w;
              }
          }
        case n:
          return w;
      }
    }
  }
  function b(y) {
    return _(y) === u;
  }
  return nn.AsyncMode = l, nn.ConcurrentMode = u, nn.ContextConsumer = a, nn.ContextProvider = s, nn.Element = e, nn.ForwardRef = c, nn.Fragment = r, nn.Lazy = p, nn.Memo = h, nn.Portal = n, nn.Profiler = o, nn.StrictMode = i, nn.Suspense = f, nn.isAsyncMode = function(y) {
    return b(y) || _(y) === l;
  }, nn.isConcurrentMode = b, nn.isContextConsumer = function(y) {
    return _(y) === a;
  }, nn.isContextProvider = function(y) {
    return _(y) === s;
  }, nn.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, nn.isForwardRef = function(y) {
    return _(y) === c;
  }, nn.isFragment = function(y) {
    return _(y) === r;
  }, nn.isLazy = function(y) {
    return _(y) === p;
  }, nn.isMemo = function(y) {
    return _(y) === h;
  }, nn.isPortal = function(y) {
    return _(y) === n;
  }, nn.isProfiler = function(y) {
    return _(y) === o;
  }, nn.isStrictMode = function(y) {
    return _(y) === i;
  }, nn.isSuspense = function(y) {
    return _(y) === f;
  }, nn.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === u || y === o || y === i || y === f || y === d || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === h || y.$$typeof === s || y.$$typeof === a || y.$$typeof === c || y.$$typeof === m || y.$$typeof === v || y.$$typeof === S || y.$$typeof === g);
  }, nn.typeOf = _, nn;
}
var rn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eD;
function Aoe() {
  return eD || (eD = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, d = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, S = t ? Symbol.for("react.scope") : 60119;
    function _(oe) {
      return typeof oe == "string" || typeof oe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      oe === r || oe === u || oe === o || oe === i || oe === f || oe === d || typeof oe == "object" && oe !== null && (oe.$$typeof === p || oe.$$typeof === h || oe.$$typeof === s || oe.$$typeof === a || oe.$$typeof === c || oe.$$typeof === m || oe.$$typeof === v || oe.$$typeof === S || oe.$$typeof === g);
    }
    function b(oe) {
      if (typeof oe == "object" && oe !== null) {
        var re = oe.$$typeof;
        switch (re) {
          case e:
            var se = oe.type;
            switch (se) {
              case l:
              case u:
              case r:
              case o:
              case i:
              case f:
                return se;
              default:
                var ae = se && se.$$typeof;
                switch (ae) {
                  case a:
                  case c:
                  case p:
                  case h:
                  case s:
                    return ae;
                  default:
                    return re;
                }
            }
          case n:
            return re;
        }
      }
    }
    var y = l, w = u, E = a, x = s, k = e, C = c, M = r, F = p, U = h, B = n, N = o, q = i, Q = f, ne = !1;
    function X(oe) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(oe) || b(oe) === l;
    }
    function O(oe) {
      return b(oe) === u;
    }
    function W(oe) {
      return b(oe) === a;
    }
    function T(oe) {
      return b(oe) === s;
    }
    function $(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === e;
    }
    function P(oe) {
      return b(oe) === c;
    }
    function H(oe) {
      return b(oe) === r;
    }
    function Z(oe) {
      return b(oe) === p;
    }
    function le(oe) {
      return b(oe) === h;
    }
    function J(oe) {
      return b(oe) === n;
    }
    function ue(oe) {
      return b(oe) === o;
    }
    function he(oe) {
      return b(oe) === i;
    }
    function me(oe) {
      return b(oe) === f;
    }
    rn.AsyncMode = y, rn.ConcurrentMode = w, rn.ContextConsumer = E, rn.ContextProvider = x, rn.Element = k, rn.ForwardRef = C, rn.Fragment = M, rn.Lazy = F, rn.Memo = U, rn.Portal = B, rn.Profiler = N, rn.StrictMode = q, rn.Suspense = Q, rn.isAsyncMode = X, rn.isConcurrentMode = O, rn.isContextConsumer = W, rn.isContextProvider = T, rn.isElement = $, rn.isForwardRef = P, rn.isFragment = H, rn.isLazy = Z, rn.isMemo = le, rn.isPortal = J, rn.isProfiler = ue, rn.isStrictMode = he, rn.isSuspense = me, rn.isValidElementType = _, rn.typeOf = b;
  }()), rn;
}
var tD;
function $3() {
  return tD || (tD = 1, process.env.NODE_ENV === "production" ? xg.exports = Coe() : xg.exports = Aoe()), xg.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var a1, nD;
function Roe() {
  if (nD) return a1;
  nD = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(c) {
        return s[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return a1 = i() ? Object.assign : function(o, s) {
    for (var a, l = r(o), u, c = 1; c < arguments.length; c++) {
      a = Object(arguments[c]);
      for (var f in a)
        e.call(a, f) && (l[f] = a[f]);
      if (t) {
        u = t(a);
        for (var d = 0; d < u.length; d++)
          n.call(a, u[d]) && (l[u[d]] = a[u[d]]);
      }
    }
    return l;
  }, a1;
}
var l1, rD;
function w2() {
  if (rD) return l1;
  rD = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return l1 = t, l1;
}
var u1, iD;
function M3() {
  return iD || (iD = 1, u1 = Function.call.bind(Object.prototype.hasOwnProperty)), u1;
}
var c1, oD;
function Ooe() {
  if (oD) return c1;
  oD = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ w2(), n = {}, r = /* @__PURE__ */ M3();
    t = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var f;
          try {
            if (typeof o[c] != "function") {
              var d = Error(
                (l || "React class") + ": " + a + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[c](s, c, l, a, null, e);
          } catch (p) {
            f = p;
          }
          if (f && !(f instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var h = u ? u() : "";
            t(
              "Failed " + a + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, c1 = i, c1;
}
var f1, sD;
function Doe() {
  if (sD) return f1;
  sD = 1;
  var t = $3(), e = Roe(), n = /* @__PURE__ */ w2(), r = /* @__PURE__ */ M3(), i = /* @__PURE__ */ Ooe(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return f1 = function(a, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(O) {
      var W = O && (u && O[u] || O[c]);
      if (typeof W == "function")
        return W;
    }
    var d = "<<anonymous>>", h = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: S(),
      arrayOf: _,
      element: b(),
      elementType: y(),
      instanceOf: w,
      node: C(),
      objectOf: x,
      oneOf: E,
      oneOfType: k,
      shape: F,
      exact: U
    };
    function p(O, W) {
      return O === W ? O !== 0 || 1 / O === 1 / W : O !== O && W !== W;
    }
    function g(O, W) {
      this.message = O, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(O) {
      if (process.env.NODE_ENV !== "production")
        var W = {}, T = 0;
      function $(H, Z, le, J, ue, he, me) {
        if (J = J || d, he = he || le, me !== n) {
          if (l) {
            var oe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw oe.name = "Invariant Violation", oe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var re = J + ":" + le;
            !W[re] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + he + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), W[re] = !0, T++);
          }
        }
        return Z[le] == null ? H ? Z[le] === null ? new g("The " + ue + " `" + he + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new g("The " + ue + " `" + he + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : O(Z, le, J, ue, he);
      }
      var P = $.bind(null, !1);
      return P.isRequired = $.bind(null, !0), P;
    }
    function v(O) {
      function W(T, $, P, H, Z, le) {
        var J = T[$], ue = q(J);
        if (ue !== O) {
          var he = Q(J);
          return new g(
            "Invalid " + H + " `" + Z + "` of type " + ("`" + he + "` supplied to `" + P + "`, expected ") + ("`" + O + "`."),
            { expectedType: O }
          );
        }
        return null;
      }
      return m(W);
    }
    function S() {
      return m(s);
    }
    function _(O) {
      function W(T, $, P, H, Z) {
        if (typeof O != "function")
          return new g("Property `" + Z + "` of component `" + P + "` has invalid PropType notation inside arrayOf.");
        var le = T[$];
        if (!Array.isArray(le)) {
          var J = q(le);
          return new g("Invalid " + H + " `" + Z + "` of type " + ("`" + J + "` supplied to `" + P + "`, expected an array."));
        }
        for (var ue = 0; ue < le.length; ue++) {
          var he = O(le, ue, P, H, Z + "[" + ue + "]", n);
          if (he instanceof Error)
            return he;
        }
        return null;
      }
      return m(W);
    }
    function b() {
      function O(W, T, $, P, H) {
        var Z = W[T];
        if (!a(Z)) {
          var le = q(Z);
          return new g("Invalid " + P + " `" + H + "` of type " + ("`" + le + "` supplied to `" + $ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(O);
    }
    function y() {
      function O(W, T, $, P, H) {
        var Z = W[T];
        if (!t.isValidElementType(Z)) {
          var le = q(Z);
          return new g("Invalid " + P + " `" + H + "` of type " + ("`" + le + "` supplied to `" + $ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(O);
    }
    function w(O) {
      function W(T, $, P, H, Z) {
        if (!(T[$] instanceof O)) {
          var le = O.name || d, J = X(T[$]);
          return new g("Invalid " + H + " `" + Z + "` of type " + ("`" + J + "` supplied to `" + P + "`, expected ") + ("instance of `" + le + "`."));
        }
        return null;
      }
      return m(W);
    }
    function E(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function W(T, $, P, H, Z) {
        for (var le = T[$], J = 0; J < O.length; J++)
          if (p(le, O[J]))
            return null;
        var ue = JSON.stringify(O, function(me, oe) {
          var re = Q(oe);
          return re === "symbol" ? String(oe) : oe;
        });
        return new g("Invalid " + H + " `" + Z + "` of value `" + String(le) + "` " + ("supplied to `" + P + "`, expected one of " + ue + "."));
      }
      return m(W);
    }
    function x(O) {
      function W(T, $, P, H, Z) {
        if (typeof O != "function")
          return new g("Property `" + Z + "` of component `" + P + "` has invalid PropType notation inside objectOf.");
        var le = T[$], J = q(le);
        if (J !== "object")
          return new g("Invalid " + H + " `" + Z + "` of type " + ("`" + J + "` supplied to `" + P + "`, expected an object."));
        for (var ue in le)
          if (r(le, ue)) {
            var he = O(le, ue, P, H, Z + "." + ue, n);
            if (he instanceof Error)
              return he;
          }
        return null;
      }
      return m(W);
    }
    function k(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var W = 0; W < O.length; W++) {
        var T = O[W];
        if (typeof T != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(T) + " at index " + W + "."
          ), s;
      }
      function $(P, H, Z, le, J) {
        for (var ue = [], he = 0; he < O.length; he++) {
          var me = O[he], oe = me(P, H, Z, le, J, n);
          if (oe == null)
            return null;
          oe.data && r(oe.data, "expectedType") && ue.push(oe.data.expectedType);
        }
        var re = ue.length > 0 ? ", expected one of type [" + ue.join(", ") + "]" : "";
        return new g("Invalid " + le + " `" + J + "` supplied to " + ("`" + Z + "`" + re + "."));
      }
      return m($);
    }
    function C() {
      function O(W, T, $, P, H) {
        return B(W[T]) ? null : new g("Invalid " + P + " `" + H + "` supplied to " + ("`" + $ + "`, expected a ReactNode."));
      }
      return m(O);
    }
    function M(O, W, T, $, P) {
      return new g(
        (O || "React class") + ": " + W + " type `" + T + "." + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + P + "`."
      );
    }
    function F(O) {
      function W(T, $, P, H, Z) {
        var le = T[$], J = q(le);
        if (J !== "object")
          return new g("Invalid " + H + " `" + Z + "` of type `" + J + "` " + ("supplied to `" + P + "`, expected `object`."));
        for (var ue in O) {
          var he = O[ue];
          if (typeof he != "function")
            return M(P, H, Z, ue, Q(he));
          var me = he(le, ue, P, H, Z + "." + ue, n);
          if (me)
            return me;
        }
        return null;
      }
      return m(W);
    }
    function U(O) {
      function W(T, $, P, H, Z) {
        var le = T[$], J = q(le);
        if (J !== "object")
          return new g("Invalid " + H + " `" + Z + "` of type `" + J + "` " + ("supplied to `" + P + "`, expected `object`."));
        var ue = e({}, T[$], O);
        for (var he in ue) {
          var me = O[he];
          if (r(O, he) && typeof me != "function")
            return M(P, H, Z, he, Q(me));
          if (!me)
            return new g(
              "Invalid " + H + " `" + Z + "` key `" + he + "` supplied to `" + P + "`.\nBad object: " + JSON.stringify(T[$], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
            );
          var oe = me(le, he, P, H, Z + "." + he, n);
          if (oe)
            return oe;
        }
        return null;
      }
      return m(W);
    }
    function B(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O))
            return O.every(B);
          if (O === null || a(O))
            return !0;
          var W = f(O);
          if (W) {
            var T = W.call(O), $;
            if (W !== O.entries) {
              for (; !($ = T.next()).done; )
                if (!B($.value))
                  return !1;
            } else
              for (; !($ = T.next()).done; ) {
                var P = $.value;
                if (P && !B(P[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function N(O, W) {
      return O === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
    }
    function q(O) {
      var W = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : N(W, O) ? "symbol" : W;
    }
    function Q(O) {
      if (typeof O > "u" || O === null)
        return "" + O;
      var W = q(O);
      if (W === "object") {
        if (O instanceof Date)
          return "date";
        if (O instanceof RegExp)
          return "regexp";
      }
      return W;
    }
    function ne(O) {
      var W = Q(O);
      switch (W) {
        case "array":
        case "object":
          return "an " + W;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + W;
        default:
          return W;
      }
    }
    function X(O) {
      return !O.constructor || !O.constructor.name ? d : O.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, f1;
}
var d1, aD;
function Ioe() {
  if (aD) return d1;
  aD = 1;
  var t = /* @__PURE__ */ w2();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, d1 = function() {
    function r(s, a, l, u, c, f) {
      if (f !== t) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, d1;
}
var lD;
function F3() {
  if (lD) return Tg.exports;
  if (lD = 1, process.env.NODE_ENV !== "production") {
    var t = $3(), e = !0;
    Tg.exports = /* @__PURE__ */ Doe()(t.isElement, e);
  } else
    Tg.exports = /* @__PURE__ */ Ioe()();
  return Tg.exports;
}
var h1, uD;
function L3() {
  if (uD) return h1;
  uD = 1;
  var t = Object.create, e = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, o = Object.prototype.hasOwnProperty, s = (x, k) => {
    for (var C in k)
      e(x, C, { get: k[C], enumerable: !0 });
  }, a = (x, k, C, M) => {
    if (k && typeof k == "object" || typeof k == "function")
      for (let F of r(k))
        !o.call(x, F) && F !== C && e(x, F, { get: () => k[F], enumerable: !(M = n(k, F)) || M.enumerable });
    return x;
  }, l = (x, k, C) => (C = x != null ? t(i(x)) : {}, a(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !x || !x.__esModule ? e(C, "default", { value: x, enumerable: !0 }) : C,
    x
  )), u = (x) => a(e({}, "__esModule", { value: !0 }), x), c = {};
  s(c, {
    defaultProps: () => E,
    propTypes: () => y
  }), h1 = u(c);
  var f = l(/* @__PURE__ */ F3());
  const { string: d, bool: h, number: p, array: g, oneOfType: m, shape: v, object: S, func: _, node: b } = f.default, y = {
    url: m([d, g, S]),
    playing: h,
    loop: h,
    controls: h,
    volume: p,
    muted: h,
    playbackRate: p,
    width: m([d, p]),
    height: m([d, p]),
    style: S,
    progressInterval: p,
    playsinline: h,
    pip: h,
    stopOnUnmount: h,
    light: m([h, d, S]),
    playIcon: b,
    previewTabIndex: p,
    previewAriaLabel: d,
    fallback: b,
    oEmbedUrl: d,
    wrapper: m([
      d,
      _,
      v({ render: _.isRequired })
    ]),
    config: v({
      soundcloud: v({
        options: S
      }),
      youtube: v({
        playerVars: S,
        embedOptions: S,
        onUnstarted: _
      }),
      facebook: v({
        appId: d,
        version: d,
        playerId: d,
        attributes: S
      }),
      dailymotion: v({
        params: S
      }),
      vimeo: v({
        playerOptions: S,
        title: d
      }),
      mux: v({
        attributes: S,
        version: d
      }),
      file: v({
        attributes: S,
        tracks: g,
        forceVideo: h,
        forceAudio: h,
        forceHLS: h,
        forceSafariHLS: h,
        forceDisableHls: h,
        forceDASH: h,
        forceFLV: h,
        hlsOptions: S,
        hlsVersion: d,
        dashVersion: d,
        flvVersion: d
      }),
      wistia: v({
        options: S,
        playerId: d,
        customControls: g
      }),
      mixcloud: v({
        options: S
      }),
      twitch: v({
        options: S,
        playerId: d
      }),
      vidyard: v({
        options: S
      })
    }),
    onReady: _,
    onStart: _,
    onPlay: _,
    onPause: _,
    onBuffer: _,
    onBufferEnd: _,
    onEnded: _,
    onError: _,
    onDuration: _,
    onSeek: _,
    onPlaybackRateChange: _,
    onPlaybackQualityChange: _,
    onProgress: _,
    onClickPreview: _,
    onEnablePIP: _,
    onDisablePIP: _
  }, w = () => {
  }, E = {
    playing: !1,
    loop: !1,
    controls: !1,
    volume: null,
    muted: !1,
    playbackRate: 1,
    width: "640px",
    height: "360px",
    style: {},
    progressInterval: 1e3,
    playsinline: !1,
    pip: !1,
    stopOnUnmount: !0,
    light: !1,
    fallback: null,
    wrapper: "div",
    previewTabIndex: 0,
    previewAriaLabel: "",
    oEmbedUrl: "https://noembed.com/embed?url={url}",
    config: {
      soundcloud: {
        options: {
          visual: !0,
          // Undocumented, but makes player fill container and look better
          buying: !1,
          liking: !1,
          download: !1,
          sharing: !1,
          show_comments: !1,
          show_playcount: !1
        }
      },
      youtube: {
        playerVars: {
          playsinline: 1,
          showinfo: 0,
          rel: 0,
          iv_load_policy: 3,
          modestbranding: 1
        },
        embedOptions: {},
        onUnstarted: w
      },
      facebook: {
        appId: "1309697205772819",
        version: "v3.3",
        playerId: null,
        attributes: {}
      },
      dailymotion: {
        params: {
          api: 1,
          "endscreen-enable": !1
        }
      },
      vimeo: {
        playerOptions: {
          autopause: !1,
          byline: !1,
          portrait: !1,
          title: !1
        },
        title: null
      },
      mux: {
        attributes: {},
        version: "2"
      },
      file: {
        attributes: {},
        tracks: [],
        forceVideo: !1,
        forceAudio: !1,
        forceHLS: !1,
        forceDASH: !1,
        forceFLV: !1,
        hlsOptions: {},
        hlsVersion: "1.1.4",
        dashVersion: "3.1.3",
        flvVersion: "1.5.0",
        forceDisableHls: !1
      },
      wistia: {
        options: {},
        playerId: null,
        customControls: null
      },
      mixcloud: {
        options: {
          hide_cover: 1
        }
      },
      twitch: {
        options: {},
        playerId: null
      },
      vidyard: {
        options: {}
      }
    },
    onReady: w,
    onStart: w,
    onPlay: w,
    onPause: w,
    onBuffer: w,
    onBufferEnd: w,
    onEnded: w,
    onError: w,
    onDuration: w,
    onSeek: w,
    onPlaybackRateChange: w,
    onPlaybackQualityChange: w,
    onProgress: w,
    onClickPreview: w,
    onEnablePIP: w,
    onDisablePIP: w
  };
  return h1;
}
var p1, cD;
function Noe() {
  if (cD) return p1;
  cD = 1;
  var t = Object.create, e = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, o = Object.prototype.hasOwnProperty, s = (_, b, y) => b in _ ? e(_, b, { enumerable: !0, configurable: !0, writable: !0, value: y }) : _[b] = y, a = (_, b) => {
    for (var y in b)
      e(_, y, { get: b[y], enumerable: !0 });
  }, l = (_, b, y, w) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let E of r(b))
        !o.call(_, E) && E !== y && e(_, E, { get: () => b[E], enumerable: !(w = n(b, E)) || w.enumerable });
    return _;
  }, u = (_, b, y) => (y = _ != null ? t(i(_)) : {}, l(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !_ || !_.__esModule ? e(y, "default", { value: _, enumerable: !0 }) : y,
    _
  )), c = (_) => l(e({}, "__esModule", { value: !0 }), _), f = (_, b, y) => (s(_, typeof b != "symbol" ? b + "" : b, y), y), d = {};
  a(d, {
    default: () => S
  }), p1 = c(d);
  var h = u(nt), p = u(P3()), g = /* @__PURE__ */ L3(), m = /* @__PURE__ */ k0();
  const v = 5e3;
  class S extends h.Component {
    constructor() {
      super(...arguments), f(this, "mounted", !1), f(this, "isReady", !1), f(this, "isPlaying", !1), f(this, "isLoading", !0), f(this, "loadOnReady", null), f(this, "startOnPlay", !0), f(this, "seekOnPlay", null), f(this, "onDurationCalled", !1), f(this, "handlePlayerMount", (b) => {
        if (this.player) {
          this.progress();
          return;
        }
        this.player = b, this.player.load(this.props.url), this.progress();
      }), f(this, "getInternalPlayer", (b) => this.player ? this.player[b] : null), f(this, "progress", () => {
        if (this.props.url && this.player && this.isReady) {
          const b = this.getCurrentTime() || 0, y = this.getSecondsLoaded(), w = this.getDuration();
          if (w) {
            const E = {
              playedSeconds: b,
              played: b / w
            };
            y !== null && (E.loadedSeconds = y, E.loaded = y / w), (E.playedSeconds !== this.prevPlayed || E.loadedSeconds !== this.prevLoaded) && this.props.onProgress(E), this.prevPlayed = E.playedSeconds, this.prevLoaded = E.loadedSeconds;
          }
        }
        this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
      }), f(this, "handleReady", () => {
        if (!this.mounted)
          return;
        this.isReady = !0, this.isLoading = !1;
        const { onReady: b, playing: y, volume: w, muted: E } = this.props;
        b(), !E && w !== null && this.player.setVolume(w), this.loadOnReady ? (this.player.load(this.loadOnReady, !0), this.loadOnReady = null) : y && this.player.play(), this.handleDurationCheck();
      }), f(this, "handlePlay", () => {
        this.isPlaying = !0, this.isLoading = !1;
        const { onStart: b, onPlay: y, playbackRate: w } = this.props;
        this.startOnPlay && (this.player.setPlaybackRate && w !== 1 && this.player.setPlaybackRate(w), b(), this.startOnPlay = !1), y(), this.seekOnPlay && (this.seekTo(this.seekOnPlay), this.seekOnPlay = null), this.handleDurationCheck();
      }), f(this, "handlePause", (b) => {
        this.isPlaying = !1, this.isLoading || this.props.onPause(b);
      }), f(this, "handleEnded", () => {
        const { activePlayer: b, loop: y, onEnded: w } = this.props;
        b.loopOnEnded && y && this.seekTo(0), y || (this.isPlaying = !1, w());
      }), f(this, "handleError", (...b) => {
        this.isLoading = !1, this.props.onError(...b);
      }), f(this, "handleDurationCheck", () => {
        clearTimeout(this.durationCheckTimeout);
        const b = this.getDuration();
        b ? this.onDurationCalled || (this.props.onDuration(b), this.onDurationCalled = !0) : this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
      }), f(this, "handleLoaded", () => {
        this.isLoading = !1;
      });
    }
    componentDidMount() {
      this.mounted = !0;
    }
    componentWillUnmount() {
      clearTimeout(this.progressTimeout), clearTimeout(this.durationCheckTimeout), this.isReady && this.props.stopOnUnmount && (this.player.stop(), this.player.disablePIP && this.player.disablePIP()), this.mounted = !1;
    }
    componentDidUpdate(b) {
      if (!this.player)
        return;
      const { url: y, playing: w, volume: E, muted: x, playbackRate: k, pip: C, loop: M, activePlayer: F, disableDeferredLoading: U } = this.props;
      if (!(0, p.default)(b.url, y)) {
        if (this.isLoading && !F.forceLoad && !U && !(0, m.isMediaStream)(y)) {
          console.warn(`ReactPlayer: the attempt to load ${y} is being deferred until the player has loaded`), this.loadOnReady = y;
          return;
        }
        this.isLoading = !0, this.startOnPlay = !0, this.onDurationCalled = !1, this.player.load(y, this.isReady);
      }
      !b.playing && w && !this.isPlaying && this.player.play(), b.playing && !w && this.isPlaying && this.player.pause(), !b.pip && C && this.player.enablePIP && this.player.enablePIP(), b.pip && !C && this.player.disablePIP && this.player.disablePIP(), b.volume !== E && E !== null && this.player.setVolume(E), b.muted !== x && (x ? this.player.mute() : (this.player.unmute(), E !== null && setTimeout(() => this.player.setVolume(E)))), b.playbackRate !== k && this.player.setPlaybackRate && this.player.setPlaybackRate(k), b.loop !== M && this.player.setLoop && this.player.setLoop(M);
    }
    getDuration() {
      return this.isReady ? this.player.getDuration() : null;
    }
    getCurrentTime() {
      return this.isReady ? this.player.getCurrentTime() : null;
    }
    getSecondsLoaded() {
      return this.isReady ? this.player.getSecondsLoaded() : null;
    }
    seekTo(b, y, w) {
      if (!this.isReady) {
        b !== 0 && (this.seekOnPlay = b, setTimeout(() => {
          this.seekOnPlay = null;
        }, v));
        return;
      }
      if (y ? y === "fraction" : b > 0 && b < 1) {
        const x = this.player.getDuration();
        if (!x) {
          console.warn("ReactPlayer: could not seek using fraction – duration not yet available");
          return;
        }
        this.player.seekTo(x * b, w);
        return;
      }
      this.player.seekTo(b, w);
    }
    render() {
      const b = this.props.activePlayer;
      return b ? /* @__PURE__ */ h.default.createElement(
        b,
        {
          ...this.props,
          onMount: this.handlePlayerMount,
          onReady: this.handleReady,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onEnded: this.handleEnded,
          onLoaded: this.handleLoaded,
          onError: this.handleError
        }
      ) : null;
    }
  }
  return f(S, "displayName", "Player"), f(S, "propTypes", g.propTypes), f(S, "defaultProps", g.defaultProps), p1;
}
var g1, fD;
function Poe() {
  if (fD) return g1;
  fD = 1;
  var t = Object.create, e = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, o = Object.prototype.hasOwnProperty, s = (M, F, U) => F in M ? e(M, F, { enumerable: !0, configurable: !0, writable: !0, value: U }) : M[F] = U, a = (M, F) => {
    for (var U in F)
      e(M, U, { get: F[U], enumerable: !0 });
  }, l = (M, F, U, B) => {
    if (F && typeof F == "object" || typeof F == "function")
      for (let N of r(F))
        !o.call(M, N) && N !== U && e(M, N, { get: () => F[N], enumerable: !(B = n(F, N)) || B.enumerable });
    return M;
  }, u = (M, F, U) => (U = M != null ? t(i(M)) : {}, l(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !M || !M.__esModule ? e(U, "default", { value: M, enumerable: !0 }) : U,
    M
  )), c = (M) => l(e({}, "__esModule", { value: !0 }), M), f = (M, F, U) => (s(M, typeof F != "symbol" ? F + "" : F, U), U), d = {};
  a(d, {
    createReactPlayer: () => C
  }), g1 = c(d);
  var h = u(nt), p = u(N3()), g = u(xoe), m = u(P3()), v = /* @__PURE__ */ L3(), S = /* @__PURE__ */ k0(), _ = u(/* @__PURE__ */ Noe());
  const b = (0, S.lazy)(() => import(
    /* webpackChunkName: 'reactPlayerPreview' */
    "./Preview-D58VVSew.js"
  ).then((M) => M.P)), y = typeof window < "u" && window.document && typeof document < "u", w = typeof zo < "u" && zo.window && zo.window.document, E = Object.keys(v.propTypes), x = y || w ? h.Suspense : () => null, k = [], C = (M, F) => {
    var U;
    return U = class extends h.Component {
      constructor() {
        super(...arguments), f(this, "state", {
          showPreview: !!this.props.light
        }), f(this, "references", {
          wrapper: (B) => {
            this.wrapper = B;
          },
          player: (B) => {
            this.player = B;
          }
        }), f(this, "handleClickPreview", (B) => {
          this.setState({ showPreview: !1 }), this.props.onClickPreview(B);
        }), f(this, "showPreview", () => {
          this.setState({ showPreview: !0 });
        }), f(this, "getDuration", () => this.player ? this.player.getDuration() : null), f(this, "getCurrentTime", () => this.player ? this.player.getCurrentTime() : null), f(this, "getSecondsLoaded", () => this.player ? this.player.getSecondsLoaded() : null), f(this, "getInternalPlayer", (B = "player") => this.player ? this.player.getInternalPlayer(B) : null), f(this, "seekTo", (B, N, q) => {
          if (!this.player)
            return null;
          this.player.seekTo(B, N, q);
        }), f(this, "handleReady", () => {
          this.props.onReady(this);
        }), f(this, "getActivePlayer", (0, g.default)((B) => {
          for (const N of [...k, ...M])
            if (N.canPlay(B))
              return N;
          return F || null;
        })), f(this, "getConfig", (0, g.default)((B, N) => {
          const { config: q } = this.props;
          return p.default.all([
            v.defaultProps.config,
            v.defaultProps.config[N] || {},
            q,
            q[N] || {}
          ]);
        })), f(this, "getAttributes", (0, g.default)((B) => (0, S.omit)(this.props, E))), f(this, "renderActivePlayer", (B) => {
          if (!B)
            return null;
          const N = this.getActivePlayer(B);
          if (!N)
            return null;
          const q = this.getConfig(B, N.key);
          return /* @__PURE__ */ h.default.createElement(
            _.default,
            {
              ...this.props,
              key: N.key,
              ref: this.references.player,
              config: q,
              activePlayer: N.lazyPlayer || N,
              onReady: this.handleReady
            }
          );
        });
      }
      shouldComponentUpdate(B, N) {
        return !(0, m.default)(this.props, B) || !(0, m.default)(this.state, N);
      }
      componentDidUpdate(B) {
        const { light: N } = this.props;
        !B.light && N && this.setState({ showPreview: !0 }), B.light && !N && this.setState({ showPreview: !1 });
      }
      renderPreview(B) {
        if (!B)
          return null;
        const { light: N, playIcon: q, previewTabIndex: Q, oEmbedUrl: ne, previewAriaLabel: X } = this.props;
        return /* @__PURE__ */ h.default.createElement(
          b,
          {
            url: B,
            light: N,
            playIcon: q,
            previewTabIndex: Q,
            previewAriaLabel: X,
            oEmbedUrl: ne,
            onClick: this.handleClickPreview
          }
        );
      }
      render() {
        const { url: B, style: N, width: q, height: Q, fallback: ne, wrapper: X } = this.props, { showPreview: O } = this.state, W = this.getAttributes(B), T = typeof X == "string" ? this.references.wrapper : void 0;
        return /* @__PURE__ */ h.default.createElement(X, { ref: T, style: { ...N, width: q, height: Q }, ...W }, /* @__PURE__ */ h.default.createElement(x, { fallback: ne }, O ? this.renderPreview(B) : this.renderActivePlayer(B)));
      }
    }, f(U, "displayName", "ReactPlayer"), f(U, "propTypes", v.propTypes), f(U, "defaultProps", v.defaultProps), f(U, "addCustomPlayer", (B) => {
      k.push(B);
    }), f(U, "removeCustomPlayers", () => {
      k.length = 0;
    }), f(U, "canPlay", (B) => {
      for (const N of [...k, ...M])
        if (N.canPlay(B))
          return !0;
      return !1;
    }), f(U, "canEnablePIP", (B) => {
      for (const N of [...k, ...M])
        if (N.canEnablePIP && N.canEnablePIP(B))
          return !0;
      return !1;
    }), U;
  };
  return g1;
}
var m1, dD;
function $oe() {
  if (dD) return m1;
  dD = 1;
  var t = Object.create, e = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, o = Object.prototype.hasOwnProperty, s = (g, m) => {
    for (var v in m)
      e(g, v, { get: m[v], enumerable: !0 });
  }, a = (g, m, v, S) => {
    if (m && typeof m == "object" || typeof m == "function")
      for (let _ of r(m))
        !o.call(g, _) && _ !== v && e(g, _, { get: () => m[_], enumerable: !(S = n(m, _)) || S.enumerable });
    return g;
  }, l = (g, m, v) => (v = g != null ? t(i(g)) : {}, a(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !g || !g.__esModule ? e(v, "default", { value: g, enumerable: !0 }) : v,
    g
  )), u = (g) => a(e({}, "__esModule", { value: !0 }), g), c = {};
  s(c, {
    default: () => p
  }), m1 = u(c);
  var f = l(/* @__PURE__ */ Soe()), d = /* @__PURE__ */ Poe();
  const h = f.default[f.default.length - 1];
  var p = (0, d.createReactPlayer)(f.default, h);
  return m1;
}
var Moe = /* @__PURE__ */ $oe();
const Foe = /* @__PURE__ */ gy(Moe);
function Loe(t) {
  switch (t?.toLowerCase()) {
    case "on":
    case "yes":
      return !0;
    case "off":
    case "no":
      return !1;
    default:
      return !1;
  }
}
const Boe = rt.div.withConfig({
  displayName: "Video__StyledVideoWrapper",
  componentId: "sc-1pql380-0"
})`
	width: 100%;
	height: 100%;
	aspect-ratio: 16/9;
	${({
  $widescreen: t
}) => t && `
    width: 100vw;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  `}
`;
function joe({
  atomId: t,
  pageIndex: e
}) {
  const n = Xt(e, t), r = L(fn(n)).data, i = L(Ea), o = r.tapped, s = Xe(null), a = r.modifier?.["widescreen:"] ? Loe(r.modifier["widescreen:"]) : !1, l = un(t2(e)), [u, c] = Cn(!1);
  return lt(() => {
    const f = new IntersectionObserver(([d]) => {
      c(d.isIntersecting);
    }, {
      threshold: 0.5
    });
    return s.current && f.observe(s.current), () => {
      s.current && f.unobserve(s.current);
    };
  }, []), lt(() => (a && l(!0), () => {
    a && l(!1);
  }), [a, l]), Bo({
    elRef: s,
    tapped: o,
    atomId: t
  }), Ls({
    elRef: s,
    modifier: r.modifier
  }), typeof r.content != "string" ? /* @__PURE__ */ D.jsx(D.Fragment, {}) : i ? /* @__PURE__ */ D.jsx(voe, { style: {
    width: "100%",
    visibility: "visible",
    aspectRatio: "16/9"
  } }) : /* @__PURE__ */ D.jsx(Boe, { ref: s, $widescreen: a, children: /* @__PURE__ */ D.jsx(Foe, { controls: !1, loop: !0, muted: !0, playing: u, playsinline: !0, url: r.content, width: "100%", height: "100%" }) });
}
const Voe = Hr(joe), Uoe = (t) => /* @__PURE__ */ D.jsx("svg", { width: 10, height: 16, viewBox: "0 0 10 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: /* @__PURE__ */ D.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 0.125C1.73206 0.125 1.95462 0.217187 2.11872 0.381282C2.28281 0.545376 2.375 0.767936 2.375 1V15C2.375 15.2321 2.28281 15.4546 2.11872 15.6187C1.95462 15.7828 1.73206 15.875 1.5 15.875C1.26794 15.875 1.04538 15.7828 0.881282 15.6187C0.717187 15.4546 0.625 15.2321 0.625 15V1C0.625 0.767936 0.717187 0.545376 0.881282 0.381282C1.04538 0.217187 1.26794 0.125 1.5 0.125V0.125ZM8.5 0.125C8.73206 0.125 8.95462 0.217187 9.11872 0.381282C9.28281 0.545376 9.375 0.767936 9.375 1V15C9.375 15.2321 9.28281 15.4546 9.11872 15.6187C8.95462 15.7828 8.73206 15.875 8.5 15.875C8.26794 15.875 8.04538 15.7828 7.88128 15.6187C7.71719 15.4546 7.625 15.2321 7.625 15V1C7.625 0.767936 7.71719 0.545376 7.88128 0.381282C8.04538 0.217187 8.26794 0.125 8.5 0.125V0.125Z", fill: "black" }) }), qoe = (t) => /* @__PURE__ */ D.jsx("svg", { width: 14, height: 16, viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: /* @__PURE__ */ D.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.907 7.99997L1.75 2.10772V13.8922L11.907 7.99997ZM13.293 6.78197C13.5076 6.90481 13.6858 7.08214 13.8098 7.29602C13.9339 7.5099 13.9992 7.75275 13.9992 7.99997C13.9992 8.2472 13.9339 8.49004 13.8098 8.70392C13.6858 8.9178 13.5076 9.09514 13.293 9.21797L2.15775 15.679C1.24775 16.2075 0 15.6037 0 14.461V1.53897C0 0.396223 1.24775 -0.207528 2.15775 0.320972L13.293 6.78197Z", fill: "black" }) }), zoe = ({
  isPlaying: t,
  onPlayPauseClick: e
}) => {
  const n = (r) => {
    r.preventDefault(), r.stopPropagation(), e(!t);
  };
  return /* @__PURE__ */ D.jsx("div", { className: "audio-controls", children: t ? /* @__PURE__ */ D.jsx("button", { type: "button", className: "pause", onClick: n, "aria-label": "Pause", children: /* @__PURE__ */ D.jsx(Uoe, {}) }) : /* @__PURE__ */ D.jsx("button", { type: "button", className: "play", onClick: n, "aria-label": "Play", children: /* @__PURE__ */ D.jsx(qoe, {}) }) });
}, Hoe = rt.div.withConfig({
  displayName: "StyledAudioPlayer",
  componentId: "sc-atfzze-0"
})`
 width: ${(t) => t.$pageSize.landscape ? "50%" : "80%"};
 button {
    border: none;
    cursor: pointer;
    background-color: unset;
  }


 
  input[type="range"] {
    height: 5px;
    -webkit-appearance: none;
    border-radius: 8px;
    background: #3b7677;
    transition: background 0.2s ease;
    cursor: pointer;
    accent-color: ${(t) => t.$filterColors.third};
  }
  
  .audio-player {
    color: inherit;
  }
  
  .audio-controls {
    display: flex;
    justify-content: center;
    margin: .5rem;
  }
  
  .audio-controls .play svg,
  .audio-controls .pause svg {
    height: ${(t) => wa(t.theme, t.$baseFontSize)};
    width:  ${(t) => wa(t.theme, t.$baseFontSize)};
    path {
      fill: ${(t) => t.$filterColors.third};
    }
  }
  
  .audio-controls path {
    fill: ${(t) => t.theme.color};
  }

  .progress {
    width: ${(t) => t.$pageSize.landscape ? "50%" : "80%"};
  }
  .track-info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
 
  ${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`};
  ${(t) => `${zr("audio:", t)}`};
  z-index: 1;
  `, Goe = ({
  title: t,
  audioSrc: e,
  modifier: n,
  tapped: r,
  elementIndex: i,
  pageIndex: o,
  isInAuthor: s,
  isEmbedded: a
}) => {
  const [l, u] = Cn(0), c = L(Ut), f = n?.["mute:"] === "no" && !s && !a || !1, [d, h] = Cn(f), p = Xe(new Audio(e)), g = Xe(), m = L(gr), v = L(jt), S = kt(tr), _ = L(pr), {
    duration: b
  } = p.current, y = b ? `${l / b * 100}%` : "0%", w = `
    -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(${y}, ${_.fourth}), color-stop(${y}, ${_.third}))
  `, E = () => {
    clearInterval(g.current), g.current = setInterval(() => {
      u(p.current.currentTime);
    }, 1e3);
  }, x = (C) => {
    clearInterval(g.current), p.current.currentTime = Number.parseInt(C), u(p.current.currentTime);
  }, k = () => {
    d || h(!0), E();
  };
  return lt(() => {
    d ? (p.current.play(), E()) : p.current.pause();
  }, [d]), lt(() => {
    c !== o && (h(!1), p.current.pause(), E()), c === o && (E(), h(f));
  }, [c, o, f]), lt(() => () => {
    p.current.pause(), clearInterval(g.current);
  }, []), /* @__PURE__ */ D.jsx(Hoe, { $baseFontSize: v.baseFontSize, $elementIndex: i, $filterColors: _, $fonts: m, $isInFlexBox: S, $modifier: n, $onePercentHeight: v.onePercentHeight, $onePercentWidth: v.onePercentWidth, $pageSize: v, $isInPortrait: !v.landscape, $tapped: r, children: /* @__PURE__ */ D.jsx("div", { className: "audio-player color-backdrop", children: /* @__PURE__ */ D.jsxs("div", { className: "track-info", children: [
    /* @__PURE__ */ D.jsx("div", { className: "title", children: t }),
    /* @__PURE__ */ D.jsx("input", { className: "progress", max: b || `${b}`, min: "0", onChange: (C) => x(C.target.value), onKeyUp: k, onMouseUp: k, step: "1", style: {
      background: w
    }, type: "range", value: l }),
    /* @__PURE__ */ D.jsx(zoe, { isPlaying: d, onPlayPauseClick: h })
  ] }) }) });
}, Woe = (t) => t.audioPlayer, Yoe = ({
  atomId: t,
  pageIndex: e
}) => {
  const n = Xt(e, t), r = L(fn(n)).data, i = r.tapped, o = Xe(null), s = L(er), a = L(sp);
  Bo({
    elRef: o,
    tapped: i,
    atomId: t
  }), Ls({
    elRef: o,
    modifier: r.modifier
  });
  const l = r.content && typeof r.content == "string" ? r.content : "untitled";
  return r.url ? /* @__PURE__ */ D.jsx(Rn, { theme: Woe, children: /* @__PURE__ */ D.jsx(Goe, { audioSrc: r.url, elementIndex: t, modifier: r.modifier, tapped: i, title: l, pageIndex: e, isInAuthor: s, isEmbedded: a }) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, Xoe = Hr(Yoe), Koe = rt.div.withConfig({
  displayName: "Bullet__StyledBullet",
  componentId: "sc-15u4amm-0"
})`
  width: 66%; // this aligns the bullets
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  display: inline-flex;
  li span {
    position: relative;
    left: ${(t) => `${(t.theme.space ? t.theme.space / 10 : 0) * t.$baseFontSize}px`} 
  }

   ul {
    margin-block-end: 0;
    margin-block-start: 0;
    text-align: start;
    ${(t) => t.theme.align !== "start" ? "padding-inline-start: 0;" : ""}
    li::marker {
      color: ${(t) => t.theme.markerColor};
    }
    li {
      span {
        text-wrap:  auto ;
      }
    }
  } 

  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`}
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  ${(t) => `${zr("*:", t)}`} 
`, Qoe = ({
  atomId: t,
  pageIndex: e
}) => {
  const n = Xt(e, t), r = L(fn(n)).data, i = kt(tr), o = L(pr), s = L(gr), a = L(jt), l = r.tapped;
  let u = L(Mi).bullet;
  const c = a.baseFontSize;
  return !a.landscape && u.align !== dn.End && (u = Cu(u), u.align = dn.Start), r.content ? /* @__PURE__ */ D.jsx(Rn, { theme: u, children: /* @__PURE__ */ D.jsx(Koe, { $baseFontSize: c, $elementIndex: t, $filterColors: o, $fonts: s, $isInFlexBox: i, $modifier: r.modifier, $onePercentHeight: a.onePercentHeight, $onePercentWidth: a.onePercentWidth, $pageSize: a, $isInPortrait: !a.landscape, $tapped: l, className: `${pe.css.pageElement}  bullet`, "data-atom-id": r.id, children: /* @__PURE__ */ D.jsx("ul", { children: /* @__PURE__ */ D.jsx("li", { children: /* @__PURE__ */ D.jsx("span", { children: r.content }) }) }) }) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}, hD = Hr(Qoe), Joe = rt.div.withConfig({
  displayName: "IndentedBullet__StyledIndentedBullet",
  componentId: "sc-1k1nysz-0"
})`
  width: 50%; // this aligns the bullets
  padding-left: 16%;
  display: inline-flex;
  visibility: ${(t) => t.$tapped ? "visible" : "hidden"};
  margin-inline-start: ${(t) => (t.theme.space ? t.theme.space : 3) * t.$baseFontSize}px;
  li span {
    position: relative;
    left: ${(t) => `${(t.theme.space ? t.theme.space / 10 : 0) * t.$baseFontSize}px`} 
  }

   ul {
    margin-block-end: 0;
    margin-block-start: 0;
    ${(t) => t.theme.align !== "start" ? "padding-inline-start: 0;" : ""}
    list-style: circle;
    li::marker {
      color: ${(t) => t.theme.markerColor};
      
    }
    li {
      span {
        text-wrap: auto ;
      }
    }
  }

  ${(t) => ts(t.theme.align, t.$isInFlexBox)};
  position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`}
  opacity: ${(t) => _r(t.$tapped, t.theme.opacity)};
  ${(t) => `${zr("*:", t)}`}

`, pD = ({
  atomId: t,
  pageIndex: e
}) => {
  const n = Xt(e, t), r = L(fn(n)).data, i = kt(tr), o = L(pr), s = L(gr), a = L(jt), l = r.tapped;
  let u = L(Mi).bullet;
  !a.landscape && u.align !== dn.End && (u = Cu(u), u.align = dn.Start);
  const c = a.baseFontSize;
  return r.content ? /* @__PURE__ */ D.jsx(Rn, { theme: u, children: /* @__PURE__ */ D.jsx(Joe, { $baseFontSize: c, $elementIndex: t, $filterColors: o, $fonts: s, $isInFlexBox: i, $modifier: r.modifier, $onePercentHeight: a.onePercentHeight, $onePercentWidth: a.onePercentWidth, $pageSize: a, $isInPortrait: !a.landscape, $tapped: l, className: `${pe.css.pageElement}  bullet`, "data-atom-id": r.id, children: /* @__PURE__ */ D.jsx("ul", { className: "pseudo", children: /* @__PURE__ */ D.jsx("li", { children: /* @__PURE__ */ D.jsx("span", { children: r.content }) }) }) }) }) : /* @__PURE__ */ D.jsx(D.Fragment, {});
};
function Zoe({
  atomId: t,
  submitted: e,
  $disabled: n,
  pageIndex: r
}) {
  const i = Xt(r, t), o = L(fn(i)).data, s = kt(tr), a = L(pr), l = L(gr), u = L(zn), c = L(jt), f = o.tapped, d = kt(jc), h = c.baseFontSize;
  return /* @__PURE__ */ D.jsx(Rn, { theme: d ? d.button : {}, children: /* @__PURE__ */ D.jsx(D3, { $baseFontSize: h, $disabled: n, $elementIndex: t, $filterColors: a, $fonts: l, $isInFlexBox: s, $modifier: o.modifier, $onePercentHeight: c.onePercentHeight, $onePercentWidth: c.onePercentWidth, $pageSize: c, $isInPortrait: !c.landscape, $tapped: f, "aria-hidden": !o.tapped, className: `${pe.css.pageElement}  Button`, "data-atom-id": t, "data-testid": `${u ? "previewer:" : ""} form-button ${t}`, children: e ? "Signed Up!" : "Sign Up Here" }) });
}
var y1 = {}, gD;
function ese() {
  if (gD) return y1;
  gD = 1;
  var t = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  return y1.validate = function(e) {
    if (!e || e.length > 254)
      return !1;
    var n = t.test(e);
    if (!n)
      return !1;
    var r = e.split("@");
    if (r[0].length > 64)
      return !1;
    var i = r[1].split(".");
    return !i.some(function(o) {
      return o.length > 63;
    });
  }, y1;
}
var tse = ese();
const nse = rt.div.withConfig({
  displayName: "Form__StyledForm",
  componentId: "sc-n6lsp4-0"
})`
  .invalid {
    color: red
  }
  ${(t) => _r(t.$tapped, t.theme.opacity)};
  ${(t) => `${zr("paragraph:", t)}`};
  /*  keep this here otherwise the text will become transparent */
  opacity: 1 !important;
  
  background-color: transparent !important;
  /* this required to prevent the backdrop from breaking out of the box */
  /* any modifiers will override it. */
  backdrop-filter: opacity(0);
  width: 100%;

  .email-message {
    margin-block: .5rem;
    font-size: ${(t) => t.$baseFontSize * 2}px;
  }

  .input-box-as-line {
    background: transparent !important;
    color: ${(t) => t.$filterColors.third} !important;
    outline-style: none !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: solid ${(t) => t.$filterColors.first} 1px;
    font-size: ${(t) => t.$baseFontSize * 3}px;
    box-shadow: 0 0 0 !important;
    -webkit-box-shadow: 0 0 0 !important;
    width: 100%;
    }
 
  .content {
    font-family: inherit;
    text-align: center;
    position: relative;
    margin: auto;
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .sign-up-email-input {
      margin-block-start: .5rem;
    }  
  }

position: relative;
${(t) => `${mr({
  baseFontSize: t.$baseFontSize,
  fonts: t.$fonts,
  theme: t.theme
})}`};
  ${(t) => `${zr("paragraph:", t)}`} 
`, rse = ({
  atomId: t,
  pageIndex: e
}) => {
  const [n, r] = Cn(""), [i, o] = Cn(!1), [s, a] = Cn(!1), l = Xt(e, t), u = L(fn(l)).data, c = kt(tr), f = L(pr), d = L(gr), h = L(jt), p = L(MQ), g = L(Lo), m = u.tapped, v = h.baseFontSize, S = Xe(null), _ = fs((w) => {
    w.currentTarget.value && (o(tse.validate(w.currentTarget.value)), r(w.currentTarget.value));
  }, []), b = () => {
    !i || s || y(n);
  }, y = async (w) => {
    if (!i) return;
    const E = {
      created: Date.now(),
      id: y2(26),
      stackId: p,
      recordType: "email",
      stack: g,
      value: w
    }, x = new XE(Yc.gqlWriteUserRecord());
    await gE(x).WriteUserRecord(E), a(!0);
  };
  return /* @__PURE__ */ D.jsx(nse, { $background: u.background, $baseFontSize: v, $elementIndex: t, $isInFlexBox: c, $filterColors: f, $fonts: d, $pageSize: h, $isInPortrait: !h.landscape, $modifier: u.modifier, $tapped: m, $onePercentHeight: h.onePercentHeight, $onePercentWidth: h.onePercentWidth, className: `${pe.css.pageElement}  box`, "data-atom-id": u.id, ref: S, children: /* @__PURE__ */ D.jsxs("div", { className: "content", children: [
    /* @__PURE__ */ D.jsx("span", { className: "form-content", children: u.content }),
    /* @__PURE__ */ D.jsx("input", { placeholder: "Your E-mail", autoComplete: "email", className: `sign-up-email-input input-box-as-line ${i ? "" : "invalid"}`, id: "sign-up-email", type: "email", onInput: _ }),
    i ? /* @__PURE__ */ D.jsx("div", { className: "email-message", children: "👍" }) : /* @__PURE__ */ D.jsx("div", { className: "email-message", children: "Please enter a valid email" }),
    /* @__PURE__ */ D.jsx("div", { onClick: b, onKeyDown: (w) => w.key === "Enter" && b(), role: "button", tabIndex: 0, children: /* @__PURE__ */ D.jsx(Zoe, { $disabled: !i, atomId: t, submitted: s, pageIndex: e }) })
  ] }) });
}, ise = RS(() => import("./CodeBlock-Duulrmae.js")), ose = RS(() => import("./Chart-Brck_9KV.js")), sse = {
  "*:": hD,
  "**:": pD,
  "#:": hD,
  "##:": pD,
  "---": zie,
  "===": noe,
  "|": eoe,
  "-->": Aie,
  "[]": eie,
  "^^^": ioe,
  vvv: ooe,
  "```": ise,
  "audio:": Xoe,
  "autoplay:": ire,
  "autospace:": ore,
  "background:": yre,
  "blank:": v2,
  "box:": Yre,
  "button:": Qre,
  "chart:": ose,
  "columnTitle:": vie,
  "filter:": xie,
  "form:": rse,
  "image:": Tie,
  // watch me now..
  "line:": Nie,
  "map:": Vie,
  "moveBy:": Uie,
  "paragraph:": Yie,
  "read:": Zie,
  "storyName:": soe,
  "subtitle:": coe,
  "supertitle:": poe,
  "pause:": Xie,
  "title:": yoe,
  "video:": Voe
}, S2 = ({
  audioFileMaps: t,
  pageCode: e,
  currentFilter: n,
  dataFileMaps: r,
  editMode: i,
  pageIndex: o,
  imageMaps: s,
  neueroDivergentReader: a,
  showAllTapElements: l
}) => {
  let u = [], c = [], f = !0, d = 0;
  const h = [{
    containerTapped: !1,
    ids: []
  }], p = [], g = e.reduce((b, y, w) => {
    if (y && nS(y.type) || y && hh(y.type) || y && y.type === Ym) {
      const E = y.type;
      let x = y.content;
      a && !hh(y.type) && y.type in Tu && Tu[y.type].allowNdr && typeof y.content == "string" && (x = /* @__PURE__ */ D.jsx(rre, { text: y.content }));
      const k = y.modifier;
      let C = "unset", M = "", F = "";
      if (!i && E === "pause:" && !l && (f = !1, (w !== 0 || !Qh.includes(E)) && (d++, h[d] = {
        containerTapped: f,
        ids: []
      })), h[d].containerTapped = l ? !0 : f, h[d].ids.push(w), E === "image:" && s) {
        const N = s.find((q) => q ? q.userDefinedName === y.content : void 0);
        N && (M = kS(N), N.altText !== null && (F = N.altText));
      }
      if (E === "chart:" && r) {
        const N = r.find((q) => q ? q.userDefinedName === y.content : void 0);
        N && (M = N.url, N.altText !== null && (F = N.altText));
      }
      if (E === "audio:" && t) {
        const N = t.find((q) => q ? q.userDefinedName === y.content : void 0);
        N && (M = N.url, N.altText !== null && (F = N.altText));
      }
      if (E === "box:" && k && s) {
        C = k["background:"] ? k["background:"] : "unset";
        const N = s.find((q) => q ? q.userDefinedName === C : void 0);
        N && (C = `url(${kS(N)})`, N.altText !== null && (F = N.altText)), n && C in n.colors && (C = n.colors[C]);
      }
      const U = {
        altText: F,
        background: C,
        content: x,
        firstElement: !1,
        id: w,
        lastElement: !1,
        modifier: k,
        tapped: f,
        type: y.type,
        url: M
      };
      p[w] = U;
      const B = sse[E];
      b.push(/* @__PURE__ */ D.jsx(v2, { isAutospaceElement: !0, atomId: w, type: "blank:", pageIndex: o }, `blank-autospace-element-${w}-${o}`)), b.push(/* @__PURE__ */ D.jsx(B, { atomId: w, type: E, pageIndex: o }, `element-${w}-${o}`));
    }
    return b;
  }, []), m = [], v = [];
  g.forEach((b, y) => {
    b.props.type === _t["^^^"].controlChar && m.push(y), b.props.type === _t.vvv.controlChar && v.push(y);
  }), v.length === 2 && (c = g.splice(v[0], v[1] - v[0] + 1), c = c.filter((b) => !b.props.isAutospaceElement && b.props.type !== _t.vvv.controlChar)), m.length === 2 && (u = g.splice(m[0], m[1] - m[0] + 1), u = u.filter((b) => !b.props.isAutospaceElement && b.props.type !== _t["^^^"].controlChar));
  const S = p.find((b) => !Hx.includes(b.type)), _ = p.findLast((b) => !Hx.includes(b.type));
  return S && (S.firstElement = !0), _ && (_.lastElement = !0), {
    pageElements: p,
    pageReactElements: g,
    tapIdContainer: h,
    stickyHeaderReactElements: u,
    stickyFooterReactElements: c
  };
};
function _2({
  preRenderForAnimation: t,
  index: e
}) {
  const n = L(JE), r = L(Mi), i = L(ZE), o = L(Ea), s = L(ip);
  let a = L(Ut) + (t ? 1 : 0);
  if (e && (a = e), !a)
    return console.error("pageIndex is undefined"), /* @__PURE__ */ D.jsx(D.Fragment, {});
  const l = L(Zo)[a - 1], u = L(m0), c = L(Oh(a)), f = LV(({
    set: S
  }) => (_) => {
    for (const b of _) {
      const y = Xt(a, b.id);
      S(fn(y), {
        pageIndex: a,
        atomId: b.id,
        data: b,
        key: y
      });
    }
  }), d = Es(({
    set: S
  }) => (_) => {
    _ && S(wl(a), _);
  }), h = Es(({
    set: S
  }) => (_, b) => {
    S(_h(b), _);
  }, []), p = Es(({
    set: S
  }) => (_) => {
    for (const b of _) {
      const y = Xt(a, b.id);
      if (hh(b.type)) {
        S(tu(y), !0);
        continue;
      }
      if (b.type in Tu) {
        const w = Tu[b.type];
        w && w.type === "loadable" ? S(tu(y), !1) : S(tu(y), !0);
      } else
        S(tu(y), !0);
    }
  }), {
    pageElements: g,
    pageReactElements: m,
    tapIdContainer: v
  } = la(() => l ? S2({
    pageCode: l,
    showAllTapElements: c,
    editMode: o,
    imageMaps: s,
    audioFileMaps: n,
    dataFileMaps: i,
    currentFilter: r,
    neueroDivergentReader: u,
    pageIndex: a
  }) : {
    pageElements: void 0,
    pageReactElements: void 0,
    tapIdContainer: void 0
  }, [l, c, o, s, n, i, r, u, a]);
  return lt(() => {
    l && g && m && v && (h(v, a), f(g), d(m), p(g));
  }, [g, m, v, a, l]), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
const ase = rt.div.withConfig({
  displayName: "ScrollPageWrapper__PageWrapper",
  componentId: "sc-vuzqns-0"
})`
	width: 100%;
	overflow: hidden;
	position: relative;
	display: grid;
	grid-template-rows:auto;
	justify-content: center; /* Horizontally center the content */
	align-items: center; /* Vertically center the content */
	min-height: 100%; 
`, lse = Hr(({
  pageIndex: t,
  scrollerRef: e
}) => {
  _2({
    index: t
  });
  const n = L(wl(t));
  return /* @__PURE__ */ D.jsx(ase, { id: `scroll-page-${t}`, children: /* @__PURE__ */ D.jsx(hy, { pageElementsToDisplay: n, pageIndex: t, scrollerRef: e }, `scroll-page-children-${t}`) });
}), use = rt.div.withConfig({
  displayName: "ScrollElements__StyledScrollContainer",
  componentId: "sc-1fycc5w-0"
})`
	height: 100%;
	overflow-y: auto;
	width: 100%;
	position: relative;
`;
function cse() {
  const e = L(Zo).length, n = Xe(null);
  return /* @__PURE__ */ D.jsxs(use, { id: "scroll-elements-container", ref: n, children: [
    /* @__PURE__ */ D.jsx(nre, {}),
    Array.from({
      length: e
    }, (r, i) => i + 1).map((r) => /* @__PURE__ */ D.jsx(lse, { pageIndex: r, scrollerRef: n }, `scroll-page-wrapper-${r}`))
  ] });
}
function fse() {
  const t = L(nJ), e = L(wi), n = L($L), r = L(tJ), i = L(PL);
  return /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsx(mi.Provider, { value: "left", children: /* @__PURE__ */ D.jsx(hy, { pageElementsToDisplay: t, pageIndex: n }, `left-${n}}`) }),
    !e && i > 1 && /* @__PURE__ */ D.jsx(mi.Provider, { value: "right", children: /* @__PURE__ */ D.jsx(hy, { pageElementsToDisplay: r, pageIndex: i, "aria-hidden": !0 }, `right-${i}`) })
  ] });
}
Pe.registerPlugin(so);
const E2 = Qo(!1), mi = Qo("left"), k2 = Qo(void 0), T2 = Qo(void 0);
function dse() {
  const t = L(vi), e = L(zn), n = L(Sf), r = L(er), {
    contextSafe: i
  } = so(), o = i(Pe.timeline);
  return e || n || r ? /* @__PURE__ */ D.jsx(tre, {}) : t === "scroll" || t === "scrollCards" || t === "scrollContinuous" ? /* @__PURE__ */ D.jsx(k2.Provider, { value: o(), children: /* @__PURE__ */ D.jsx(cse, {}) }) : t === "tap" ? /* @__PURE__ */ D.jsx(fse, {}) : /* @__PURE__ */ D.jsx(D.Fragment, {});
}
const hse = rt.div.withConfig({
  displayName: "InfoBar__InformationBar",
  componentId: "sc-1bv0lv0-0"
})`
  display: flex;
  opacity: .7;
  position: ${(t) => t.$constrainDimensions ? "absolute" : "fixed"};
  bottom: 2px;
  left: 0;
  width: 100%;
  height: auto;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Gill Sans;
  background: ${Ot.tufte.white}; 
  font-size: ${(t) => t.$baseFontSize * 2.4}px;
  justify-content: space-between;
  
`, pse = rt.div.withConfig({
  displayName: "InfoBar__StyledProgessBar",
  componentId: "sc-1bv0lv0-1"
})`
background-color: ${Ot.brand.purple};
width: ${(t) => t.$percentComplete}%;
position: ${(t) => t.$constrainDimensions ? "absolute" : "fixed"};
height: ${(t) => t.$isInLandscape ? "4px" : "2px"};
bottom: 0;
`, gse = rt.span.withConfig({
  displayName: "InfoBar__StoryName",
  componentId: "sc-1bv0lv0-2"
})`
margin-inline-start: .2rem;
text-wrap: no-wrap;
`, mse = rt.span.withConfig({
  displayName: "InfoBar__PageNumber",
  componentId: "sc-1bv0lv0-3"
})`
margin-inline-end: .2rem;
text-wrap: no-wrap;
    
`, yse = () => {
  const t = L(Lo), e = L(Ut), n = L($u), r = L(wi), i = (e / n * 100).toFixed(2), o = L(jt).baseFontSize, s = L(jt).landscape;
  return /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsxs(hse, { $constrainDimensions: r, $baseFontSize: o, children: [
      /* @__PURE__ */ D.jsx(gse, { children: t }),
      /* @__PURE__ */ D.jsxs(mse, { children: [
        e,
        "/",
        n
      ] })
    ] }),
    /* @__PURE__ */ D.jsx(pse, { $percentComplete: i, $constrainDimensions: r, $isInLandscape: s })
  ] });
};
function T0() {
  return (T0 = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }).apply(this, arguments);
}
function B3(t, e) {
  if (t == null) return {};
  var n, r, i = {}, o = Object.keys(t);
  for (r = 0; r < o.length; r++) e.indexOf(n = o[r]) >= 0 || (i[n] = t[n]);
  return i;
}
function TS(t) {
  var e = Xe(t), n = Xe(function(r) {
    e.current && e.current(r);
  });
  return e.current = t, n.current;
}
var Dh = function(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = 1), t > n ? n : t < e ? e : t;
}, Jd = function(t) {
  return "touches" in t;
}, xS = function(t) {
  return t && t.ownerDocument.defaultView || self;
}, mD = function(t, e, n) {
  var r = t.getBoundingClientRect(), i = Jd(e) ? function(o, s) {
    for (var a = 0; a < o.length; a++) if (o[a].identifier === s) return o[a];
    return o[0];
  }(e.touches, n) : e;
  return { left: Dh((i.pageX - (r.left + xS(t).pageXOffset)) / r.width), top: Dh((i.pageY - (r.top + xS(t).pageYOffset)) / r.height) };
}, yD = function(t) {
  !Jd(t) && t.preventDefault();
}, j3 = nt.memo(function(t) {
  var e = t.onMove, n = t.onKey, r = B3(t, ["onMove", "onKey"]), i = Xe(null), o = TS(e), s = TS(n), a = Xe(null), l = Xe(!1), u = la(function() {
    var h = function(m) {
      yD(m), (Jd(m) ? m.touches.length > 0 : m.buttons > 0) && i.current ? o(mD(i.current, m, a.current)) : g(!1);
    }, p = function() {
      return g(!1);
    };
    function g(m) {
      var v = l.current, S = xS(i.current), _ = m ? S.addEventListener : S.removeEventListener;
      _(v ? "touchmove" : "mousemove", h), _(v ? "touchend" : "mouseup", p);
    }
    return [function(m) {
      var v = m.nativeEvent, S = i.current;
      if (S && (yD(v), !function(b, y) {
        return y && !Jd(b);
      }(v, l.current) && S)) {
        if (Jd(v)) {
          l.current = !0;
          var _ = v.changedTouches || [];
          _.length && (a.current = _[0].identifier);
        }
        S.focus(), o(mD(S, v, a.current)), g(!0);
      }
    }, function(m) {
      var v = m.which || m.keyCode;
      v < 37 || v > 40 || (m.preventDefault(), s({ left: v === 39 ? 0.05 : v === 37 ? -0.05 : 0, top: v === 40 ? 0.05 : v === 38 ? -0.05 : 0 }));
    }, g];
  }, [s, o]), c = u[0], f = u[1], d = u[2];
  return lt(function() {
    return d;
  }, [d]), nt.createElement("div", T0({}, r, { onTouchStart: c, onMouseDown: c, className: "react-colorful__interactive", ref: i, onKeyDown: f, tabIndex: 0, role: "slider" }));
}), x2 = function(t) {
  return t.filter(Boolean).join(" ");
}, V3 = function(t) {
  var e = t.color, n = t.left, r = t.top, i = r === void 0 ? 0.5 : r, o = x2(["react-colorful__pointer", t.className]);
  return nt.createElement("div", { className: o, style: { top: 100 * i + "%", left: 100 * n + "%" } }, nt.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: e } }));
}, Ur = function(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = Math.pow(10, e)), Math.round(n * t) / n;
}, vse = function(t) {
  return Ese(CS(t));
}, CS = function(t) {
  return t[0] === "#" && (t = t.substring(1)), t.length < 6 ? { r: parseInt(t[0] + t[0], 16), g: parseInt(t[1] + t[1], 16), b: parseInt(t[2] + t[2], 16), a: t.length === 4 ? Ur(parseInt(t[3] + t[3], 16) / 255, 2) : 1 } : { r: parseInt(t.substring(0, 2), 16), g: parseInt(t.substring(2, 4), 16), b: parseInt(t.substring(4, 6), 16), a: t.length === 8 ? Ur(parseInt(t.substring(6, 8), 16) / 255, 2) : 1 };
}, bse = function(t) {
  return _se(Sse(t));
}, wse = function(t) {
  var e = t.s, n = t.v, r = t.a, i = (200 - e) * n / 100;
  return { h: Ur(t.h), s: Ur(i > 0 && i < 200 ? e * n / 100 / (i <= 100 ? i : 200 - i) * 100 : 0), l: Ur(i / 2), a: Ur(r, 2) };
}, AS = function(t) {
  var e = wse(t);
  return "hsl(" + e.h + ", " + e.s + "%, " + e.l + "%)";
}, Sse = function(t) {
  var e = t.h, n = t.s, r = t.v, i = t.a;
  e = e / 360 * 6, n /= 100, r /= 100;
  var o = Math.floor(e), s = r * (1 - n), a = r * (1 - (e - o) * n), l = r * (1 - (1 - e + o) * n), u = o % 6;
  return { r: Ur(255 * [r, a, s, s, l, r][u]), g: Ur(255 * [l, r, r, a, s, s][u]), b: Ur(255 * [s, s, l, r, r, a][u]), a: Ur(i, 2) };
}, Cg = function(t) {
  var e = t.toString(16);
  return e.length < 2 ? "0" + e : e;
}, _se = function(t) {
  var e = t.r, n = t.g, r = t.b, i = t.a, o = i < 1 ? Cg(Ur(255 * i)) : "";
  return "#" + Cg(e) + Cg(n) + Cg(r) + o;
}, Ese = function(t) {
  var e = t.r, n = t.g, r = t.b, i = t.a, o = Math.max(e, n, r), s = o - Math.min(e, n, r), a = s ? o === e ? (n - r) / s : o === n ? 2 + (r - e) / s : 4 + (e - n) / s : 0;
  return { h: Ur(60 * (a < 0 ? a + 6 : a)), s: Ur(o ? s / o * 100 : 0), v: Ur(o / 255 * 100), a: i };
}, kse = nt.memo(function(t) {
  var e = t.hue, n = t.onChange, r = x2(["react-colorful__hue", t.className]);
  return nt.createElement("div", { className: r }, nt.createElement(j3, { onMove: function(i) {
    n({ h: 360 * i.left });
  }, onKey: function(i) {
    n({ h: Dh(e + 360 * i.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": Ur(e), "aria-valuemax": "360", "aria-valuemin": "0" }, nt.createElement(V3, { className: "react-colorful__hue-pointer", left: e / 360, color: AS({ h: e, s: 100, v: 100, a: 1 }) })));
}), Tse = nt.memo(function(t) {
  var e = t.hsva, n = t.onChange, r = { backgroundColor: AS({ h: e.h, s: 100, v: 100, a: 1 }) };
  return nt.createElement("div", { className: "react-colorful__saturation", style: r }, nt.createElement(j3, { onMove: function(i) {
    n({ s: 100 * i.left, v: 100 - 100 * i.top });
  }, onKey: function(i) {
    n({ s: Dh(e.s + 100 * i.left, 0, 100), v: Dh(e.v - 100 * i.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + Ur(e.s) + "%, Brightness " + Ur(e.v) + "%" }, nt.createElement(V3, { className: "react-colorful__saturation-pointer", top: 1 - e.v / 100, left: e.s / 100, color: AS(e) })));
}), U3 = function(t, e) {
  if (t === e) return !0;
  for (var n in t) if (t[n] !== e[n]) return !1;
  return !0;
}, xse = function(t, e) {
  return t.toLowerCase() === e.toLowerCase() || U3(CS(t), CS(e));
};
function Cse(t, e, n) {
  var r = TS(n), i = Cn(function() {
    return t.toHsva(e);
  }), o = i[0], s = i[1], a = Xe({ color: e, hsva: o });
  lt(function() {
    if (!t.equal(e, a.current.color)) {
      var u = t.toHsva(e);
      a.current = { hsva: u, color: e }, s(u);
    }
  }, [e, t]), lt(function() {
    var u;
    U3(o, a.current.hsva) || t.equal(u = t.fromHsva(o), a.current.color) || (a.current = { hsva: o, color: u }, r(u));
  }, [o, t, r]);
  var l = fs(function(u) {
    s(function(c) {
      return Object.assign({}, c, u);
    });
  }, []);
  return [o, l];
}
var Ase = typeof window < "u" ? Bn : lt, Rse = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, vD = /* @__PURE__ */ new Map(), Ose = function(t) {
  Ase(function() {
    var e = t.current ? t.current.ownerDocument : document;
    if (e !== void 0 && !vD.has(e)) {
      var n = e.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, vD.set(e, n);
      var r = Rse();
      r && n.setAttribute("nonce", r), e.head.appendChild(n);
    }
  }, []);
}, Dse = function(t) {
  var e = t.className, n = t.colorModel, r = t.color, i = r === void 0 ? n.defaultColor : r, o = t.onChange, s = B3(t, ["className", "colorModel", "color", "onChange"]), a = Xe(null);
  Ose(a);
  var l = Cse(n, i, o), u = l[0], c = l[1], f = x2(["react-colorful", e]);
  return nt.createElement("div", T0({}, s, { ref: a, className: f }), nt.createElement(Tse, { hsva: u, onChange: c }), nt.createElement(kse, { hue: u.h, onChange: c, className: "react-colorful__last-control" }));
}, Ise = { defaultColor: "000", toHsva: vse, fromHsva: function(t) {
  return bse({ h: t.h, s: t.s, v: t.v, a: 1 });
}, equal: xse }, bD = function(t) {
  return nt.createElement(Dse, T0({}, t, { colorModel: Ise }));
}, Ag = {}, v1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var wD;
function Nse() {
  return wD || (wD = 1, function(t) {
    (function() {
      var e = {}.hasOwnProperty;
      function n() {
        for (var o = "", s = 0; s < arguments.length; s++) {
          var a = arguments[s];
          a && (o = i(o, r(a)));
        }
        return o;
      }
      function r(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return n.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var s = "";
        for (var a in o)
          e.call(o, a) && o[a] && (s = i(s, a));
        return s;
      }
      function i(o, s) {
        return s ? o ? o + " " + s : o + s : o;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(v1)), v1.exports;
}
var Rg = {}, SD;
function Pse() {
  if (SD) return Rg;
  SD = 1, Object.defineProperty(Rg, "__esModule", {
    value: !0
  });
  var t = nt, e = n(t);
  function n(r) {
    return r && r.__esModule ? r : { default: r };
  }
  return Rg.default = function() {
    return e.default.createElement(
      "svg",
      { width: "14", height: "11", viewBox: "0 0 14 11" },
      e.default.createElement("path", { d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0", fill: "#fff", fillRule: "evenodd" })
    );
  }, Rg;
}
var Og = {}, _D;
function $se() {
  if (_D) return Og;
  _D = 1, Object.defineProperty(Og, "__esModule", {
    value: !0
  });
  var t = nt, e = n(t);
  function n(r) {
    return r && r.__esModule ? r : { default: r };
  }
  return Og.default = function() {
    return e.default.createElement(
      "svg",
      { width: "10", height: "10", viewBox: "0 0 10 10" },
      e.default.createElement("path", { d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12", fill: "#fff", fillRule: "evenodd" })
    );
  }, Og;
}
var Dg = {}, ED;
function Mse() {
  if (ED) return Dg;
  ED = 1, Object.defineProperty(Dg, "__esModule", {
    value: !0
  }), Dg.pointerCoord = t;
  function t(e) {
    if (e) {
      var n = e.changedTouches;
      if (n && n.length > 0) {
        var r = n[0];
        return { x: r.clientX, y: r.clientY };
      }
      var i = e.pageX;
      if (i !== void 0)
        return { x: i, y: e.pageY };
    }
    return { x: 0, y: 0 };
  }
  return Dg;
}
var kD;
function Fse() {
  if (kD) return Ag;
  kD = 1, Object.defineProperty(Ag, "__esModule", {
    value: !0
  });
  var t = Object.assign || function(_) {
    for (var b = 1; b < arguments.length; b++) {
      var y = arguments[b];
      for (var w in y)
        Object.prototype.hasOwnProperty.call(y, w) && (_[w] = y[w]);
    }
    return _;
  }, e = /* @__PURE__ */ function() {
    function _(b, y) {
      for (var w = 0; w < y.length; w++) {
        var E = y[w];
        E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(b, E.key, E);
      }
    }
    return function(b, y, w) {
      return y && _(b.prototype, y), w && _(b, w), b;
    };
  }(), n = nt, r = h(n), i = Nse(), o = h(i), s = /* @__PURE__ */ F3(), a = h(s), l = Pse(), u = h(l), c = $se(), f = h(c), d = Mse();
  function h(_) {
    return _ && _.__esModule ? _ : { default: _ };
  }
  function p(_, b) {
    var y = {};
    for (var w in _)
      b.indexOf(w) >= 0 || Object.prototype.hasOwnProperty.call(_, w) && (y[w] = _[w]);
    return y;
  }
  function g(_, b) {
    if (!(_ instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function m(_, b) {
    if (!_)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return b && (typeof b == "object" || typeof b == "function") ? b : _;
  }
  function v(_, b) {
    if (typeof b != "function" && b !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof b);
    _.prototype = Object.create(b && b.prototype, { constructor: { value: _, enumerable: !1, writable: !0, configurable: !0 } }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(_, b) : _.__proto__ = b);
  }
  var S = function(_) {
    v(b, _);
    function b(y) {
      g(this, b);
      var w = m(this, (b.__proto__ || Object.getPrototypeOf(b)).call(this, y));
      return w.handleClick = w.handleClick.bind(w), w.handleTouchStart = w.handleTouchStart.bind(w), w.handleTouchMove = w.handleTouchMove.bind(w), w.handleTouchEnd = w.handleTouchEnd.bind(w), w.handleFocus = w.handleFocus.bind(w), w.handleBlur = w.handleBlur.bind(w), w.previouslyChecked = !!(y.checked || y.defaultChecked), w.state = {
        checked: !!(y.checked || y.defaultChecked),
        hasFocus: !1
      }, w;
    }
    return e(b, [{
      key: "componentDidUpdate",
      value: function(w) {
        w.checked !== this.props.checked && this.setState({ checked: !!this.props.checked });
      }
    }, {
      key: "handleClick",
      value: function(w) {
        if (!this.props.disabled) {
          var E = this.input;
          if (w.target !== E && !this.moved) {
            this.previouslyChecked = E.checked, w.preventDefault(), E.focus(), E.click();
            return;
          }
          var x = this.props.hasOwnProperty("checked") ? this.props.checked : E.checked;
          this.setState({ checked: x });
        }
      }
    }, {
      key: "handleTouchStart",
      value: function(w) {
        this.props.disabled || (this.startX = (0, d.pointerCoord)(w).x, this.activated = !0);
      }
    }, {
      key: "handleTouchMove",
      value: function(w) {
        if (this.activated && (this.moved = !0, this.startX)) {
          var E = (0, d.pointerCoord)(w).x;
          this.state.checked && E + 15 < this.startX ? (this.setState({ checked: !1 }), this.startX = E, this.activated = !0) : E - 15 > this.startX && (this.setState({ checked: !0 }), this.startX = E, this.activated = E < this.startX + 5);
        }
      }
    }, {
      key: "handleTouchEnd",
      value: function(w) {
        if (this.moved) {
          var E = this.input;
          if (w.preventDefault(), this.startX) {
            var x = (0, d.pointerCoord)(w).x;
            this.previouslyChecked === !0 && this.startX + 4 > x ? this.previouslyChecked !== this.state.checked && (this.setState({ checked: !1 }), this.previouslyChecked = this.state.checked, E.click()) : this.startX - 4 < x && this.previouslyChecked !== this.state.checked && (this.setState({ checked: !0 }), this.previouslyChecked = this.state.checked, E.click()), this.activated = !1, this.startX = null, this.moved = !1;
          }
        }
      }
    }, {
      key: "handleFocus",
      value: function(w) {
        var E = this.props.onFocus;
        E && E(w), this.setState({ hasFocus: !0 });
      }
    }, {
      key: "handleBlur",
      value: function(w) {
        var E = this.props.onBlur;
        E && E(w), this.setState({ hasFocus: !1 });
      }
    }, {
      key: "getIcon",
      value: function(w) {
        var E = this.props.icons;
        return E ? E[w] === void 0 ? b.defaultProps.icons[w] : E[w] : null;
      }
    }, {
      key: "render",
      value: function() {
        var w = this, E = this.props, x = E.className;
        E.icons;
        var k = p(E, ["className", "icons"]), C = (0, o.default)("react-toggle", {
          "react-toggle--checked": this.state.checked,
          "react-toggle--focus": this.state.hasFocus,
          "react-toggle--disabled": this.props.disabled
        }, x);
        return r.default.createElement(
          "div",
          {
            className: C,
            onClick: this.handleClick,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd
          },
          r.default.createElement(
            "div",
            { className: "react-toggle-track" },
            r.default.createElement(
              "div",
              { className: "react-toggle-track-check" },
              this.getIcon("checked")
            ),
            r.default.createElement(
              "div",
              { className: "react-toggle-track-x" },
              this.getIcon("unchecked")
            )
          ),
          r.default.createElement("div", { className: "react-toggle-thumb" }),
          r.default.createElement("input", t({}, k, {
            ref: function(F) {
              w.input = F;
            },
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            className: "react-toggle-screenreader-only",
            type: "checkbox"
          }))
        );
      }
    }]), b;
  }(n.PureComponent);
  return Ag.default = S, S.displayName = "Toggle", S.defaultProps = {
    icons: {
      checked: r.default.createElement(u.default, null),
      unchecked: r.default.createElement(f.default, null)
    }
  }, S.propTypes = {
    checked: a.default.bool,
    disabled: a.default.bool,
    defaultChecked: a.default.bool,
    onChange: a.default.func,
    onFocus: a.default.func,
    onBlur: a.default.func,
    className: a.default.string,
    name: a.default.string,
    value: a.default.string,
    id: a.default.string,
    "aria-labelledby": a.default.string,
    "aria-label": a.default.string,
    icons: a.default.oneOfType([a.default.bool, a.default.shape({
      checked: a.default.node,
      unchecked: a.default.node
    })])
  }, Ag;
}
var Lse = Fse();
const Ig = /* @__PURE__ */ gy(Lse), Bse = (t) => /* @__PURE__ */ D.jsxs("svg", { width: 116, height: 38, viewBox: "0 0 116 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  /* @__PURE__ */ D.jsx("rect", { x: 0.5, y: 0.5, width: 115, height: 37, rx: 5.5, fill: "#8265FD" }),
  /* @__PURE__ */ D.jsx("rect", { x: 0.5, y: 0.5, width: 115, height: 37, rx: 5.5, stroke: "#8265FD" }),
  /* @__PURE__ */ D.jsx("path", { d: "M44.4148 24.5H41.1186V14.3182H44.5192C45.5168 14.3182 46.3736 14.522 47.0895 14.9297C47.8054 15.334 48.3539 15.9157 48.7351 16.6747C49.1196 17.4304 49.3118 18.3369 49.3118 19.3942C49.3118 20.4548 49.1179 21.3662 48.7301 22.1286C48.3456 22.8909 47.7888 23.4775 47.0597 23.8885C46.3305 24.2962 45.4489 24.5 44.4148 24.5ZM42.6548 23.1577H44.3303C45.1058 23.1577 45.7505 23.0118 46.2642 22.7202C46.7779 22.4252 47.1624 21.9993 47.4176 21.4425C47.6728 20.8823 47.8004 20.1996 47.8004 19.3942C47.8004 18.5954 47.6728 17.9176 47.4176 17.3608C47.1657 16.804 46.7895 16.3814 46.2891 16.093C45.7886 15.8047 45.1671 15.6605 44.4247 15.6605H42.6548V23.1577ZM54.3194 24.6541C53.6035 24.6541 52.9788 24.4901 52.4451 24.1619C51.9115 23.8338 51.4972 23.3748 51.2022 22.7848C50.9073 22.1948 50.7598 21.5054 50.7598 20.7166C50.7598 19.9245 50.9073 19.2318 51.2022 18.6385C51.4972 18.0452 51.9115 17.5845 52.4451 17.2564C52.9788 16.9283 53.6035 16.7642 54.3194 16.7642C55.0353 16.7642 55.6601 16.9283 56.1937 17.2564C56.7273 17.5845 57.1416 18.0452 57.4366 18.6385C57.7316 19.2318 57.8791 19.9245 57.8791 20.7166C57.8791 21.5054 57.7316 22.1948 57.4366 22.7848C57.1416 23.3748 56.7273 23.8338 56.1937 24.1619C55.6601 24.4901 55.0353 24.6541 54.3194 24.6541ZM54.3244 23.4062C54.7884 23.4062 55.1729 23.2836 55.4778 23.0384C55.7827 22.7931 56.0081 22.4666 56.1539 22.0589C56.3031 21.6513 56.3777 21.2022 56.3777 20.7116C56.3777 20.2244 56.3031 19.777 56.1539 19.3693C56.0081 18.9583 55.7827 18.6286 55.4778 18.38C55.1729 18.1314 54.7884 18.0071 54.3244 18.0071C53.8571 18.0071 53.4693 18.1314 53.161 18.38C52.8561 18.6286 52.6291 18.9583 52.4799 19.3693C52.3341 19.777 52.2612 20.2244 52.2612 20.7116C52.2612 21.2022 52.3341 21.6513 52.4799 22.0589C52.6291 22.4666 52.8561 22.7931 53.161 23.0384C53.4693 23.2836 53.8571 23.4062 54.3244 23.4062ZM61.0249 19.9659V24.5H59.5384V16.8636H60.9652V18.1065H61.0597C61.2353 17.7022 61.5104 17.3774 61.8849 17.1321C62.2628 16.8868 62.7384 16.7642 63.3118 16.7642C63.8321 16.7642 64.2879 16.8736 64.679 17.0923C65.0701 17.3078 65.3733 17.6293 65.5888 18.0568C65.8042 18.4844 65.9119 19.013 65.9119 19.6428V24.5H64.4254V19.8217C64.4254 19.2682 64.2813 18.8357 63.9929 18.5241C63.7045 18.2093 63.3085 18.0518 62.8047 18.0518C62.46 18.0518 62.1534 18.1264 61.8849 18.2756C61.6198 18.4247 61.4093 18.6435 61.2536 18.9318C61.1011 19.2169 61.0249 19.5616 61.0249 19.9659ZM71.1967 24.6541C70.4444 24.6541 69.7964 24.4934 69.2528 24.1719C68.7126 23.8471 68.295 23.3913 68 22.8047C67.7083 22.2147 67.5625 21.5237 67.5625 20.7315C67.5625 19.9493 67.7083 19.2599 68 18.6634C68.295 18.0668 68.706 17.6011 69.233 17.2663C69.7633 16.9316 70.383 16.7642 71.0923 16.7642C71.5232 16.7642 71.9408 16.8355 72.3452 16.978C72.7495 17.1205 73.1125 17.3442 73.4339 17.6491C73.7554 17.9541 74.009 18.3501 74.1946 18.8374C74.3802 19.3213 74.473 19.9096 74.473 20.6023V21.1293H68.4027V20.0156H73.0163C73.0163 19.6245 72.9368 19.2782 72.7777 18.9766C72.6186 18.6716 72.3949 18.4313 72.1065 18.2557C71.8215 18.08 71.4867 17.9922 71.1023 17.9922C70.6847 17.9922 70.3201 18.0949 70.0085 18.3004C69.7003 18.5026 69.4616 18.7678 69.2926 19.0959C69.1269 19.4207 69.044 19.7737 69.044 20.1548V21.0249C69.044 21.5353 69.1335 21.9695 69.3125 22.3274C69.4948 22.6854 69.7483 22.9588 70.0732 23.1477C70.398 23.3333 70.7775 23.4261 71.2116 23.4261C71.4934 23.4261 71.7502 23.3864 71.9822 23.3068C72.2143 23.224 72.4148 23.1013 72.5838 22.9389C72.7528 22.7765 72.8821 22.576 72.9716 22.3374L74.3786 22.5909C74.2659 23.0052 74.0637 23.3681 73.772 23.6797C73.4837 23.9879 73.1207 24.2282 72.6832 24.4006C72.2491 24.5696 71.7536 24.6541 71.1967 24.6541Z", fill: "white" })
] }), jse = RS(() => import("./SourceCodeViewer-D8OINRzF.js")), Vse = `
       "font-size font-size"
			 "dropdown dropdown"
      "text-controls background-controls";
`, Use = `
"font-size"
"dropdown"
"text-controls"
"background-controls";
`, qse = rt.div.withConfig({
  displayName: "Settings__StyledSettings",
  componentId: "sc-1aens6z-0"
})`
  position: absolute;
  z-index: 102;
  font-size: 1.5rem;
  top: 0;
  left: 0;
  background: ${(t) => t.$useNdrColors ? t.$sliderHasMoved ? `${t.$background}F2` : t.$background : t.$sliderHasMoved ? "rgba(255, 255, 255, 0.9)" : "#fff"};
  color: ${(t) => t.$useNdrColors ? t.$text : "#000"};
  height: 100svh;
  font-family: Arial, sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  .toggle-container {
    width: 100%;
    padding: 16px;
    background-color: ${(t) => t.$useNdrColors ? t.$background : "#E5E1F828"};
    border-block-end: 1px solid ${(t) => t.$useNdrColors ? t.$text : "#8265FD0F"};
    
    display: flex;
    flex-direction: ${(t) => t.$isInPortrait ? "column" : "row"};
    align-items: center;
    justify-content: space-around;

    label {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }
    .react-toggle {
        margin-inline-end: ${(t) => t.$isInPortrait ? "8px" : ".6svw"};
        
    }
    .react-toggle--checked .react-toggle-track{
      background-color: ${Ot.brand.purple}
    }
    .button-container {
      button {
        background: none;
        border: none;
        cursor: pointer;
      }
    }
   
  };


  .control-container {
      display: grid;
      grid-column-gap: 8%;
      grid-template: ${(t) => t.$isInPortrait ? Use : Vse};
      padding-block-start: 8%;
      max-width: 90%;

      .button-container{
        display: flex;
        justify-content: end;
        margin-block-start: 8%;
				button {
					background: none;
					border: none;
					cursor: pointer;
				}
      }


      .dropdown {
        grid-area: dropdown;
        label {
          width: 100%;
          padding-block: 8px;
          line-height: 2.5;
        }

        select{
          width: 100%;
          background-color: white;
          margin-inline-end:${(t) => t.$isInPortrait ? "8px" : ".6svw"};
          border-radius: 8px;
          border: 0; 
          padding: 5px; /* If you want space between the border and the text */
          border: 1px solid ${(t) => t.$useNdrColors ? t.$text : "#E5E1F8"};
        }
        padding-block-end: 8%;
      }
     
      .text-controls {
        grid-area: text-controls;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .background-controls {
        grid-area: background-controls;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .picker {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${(t) => t.$useNdrColors ? t.$text : "#E5E1F8"};
        border-radius: 8px;
        margin-block-start: 8px;
        padding: 8px;
      }
      .color-result {
        align-items: center;
        border: 1px solid ${(t) => t.$useNdrColors ? t.$text : "#8265FD0F"};
        border-radius: 8px;
        display: flex;
        justify-content: center;
        padding-block: 8px;
        text-align: center;
        width: 100%;
      }
      .react-colorful {
        width: 100%;
        max-width: 200px;
        aspect-ratio: 1/1;
      }
      .text-color{
        color: ${(t) => t.$text};
        .color-result {
          background-color: ${(t) => t.$background};
        }
      };
			.font-size-container {
				grid-area: font-size;
				label {
					width: 100%;
					padding-block: 8px;
					line-height: 2.5;
				}
				input {
					width: 100%;
				}
			}
    }


 
`;
function zse() {
  const [t, e] = cs(s3), [n, r] = cs(m0), [i, o] = cs(g0), s = un(h2), [a, l] = cs(bne), [u, c] = cs(KE), [f, d] = cs(IL), h = L(NQ), p = L(bi), g = FV(Fo(p)), [m, v] = cs(jt), [S, _] = Cn(!1), b = (x) => {
    if (S || _(!0), !f || f === 0) return;
    const C = m.baseFontSize / f * x;
    v({
      ...m,
      baseFontSize: C
    }), d(x);
  }, y = (x) => {
    c({
      text: x,
      background: u.background
    });
  }, w = (x) => {
    c({
      text: u.text,
      background: x
    });
  }, E = (x) => {
    if (x.target.value === "choose") return;
    const k = h.find((C) => C.name === x.target.value);
    k && c({
      text: k.value.text,
      background: k.value.background
    });
  };
  return /* @__PURE__ */ D.jsx(Rn, { theme: Zh.button, children: /* @__PURE__ */ D.jsxs(qse, { $useNdrColors: i, $background: u.background, $text: u.text, $isInPortrait: !m.landscape, role: "dialog", "aria-modal": "true", "aria-labelledby": "settings-title", $sliderHasMoved: S, children: [
    /* @__PURE__ */ D.jsx("h2", { id: "settings-title", style: {
      position: "absolute",
      left: -1e4
    }, children: "Accessibility Settings" }),
    /* @__PURE__ */ D.jsxs("div", { className: "toggle-container", children: [
      /* @__PURE__ */ D.jsxs("label", { htmlFor: "showInfoBar-toggle", children: [
        /* @__PURE__ */ D.jsx(Ig, { id: "showInfoBar-toggle", className: "qp-react-toggle", defaultChecked: t, onChange: () => e(!t) }),
        /* @__PURE__ */ D.jsx("span", { children: "Show Page Numbers" })
      ] }),
      /* @__PURE__ */ D.jsxs("label", { htmlFor: "showAssistiveTech-toggle", children: [
        /* @__PURE__ */ D.jsx(Ig, { id: "showAssistiveTech-toggle", className: "qp-react-toggle", defaultChecked: n, onChange: () => r(!n) }),
        /* @__PURE__ */ D.jsx("span", { children: "Use Neuro Divergent Font" })
      ] }),
      /* @__PURE__ */ D.jsxs("label", { htmlFor: "useNDRColors-toggle", children: [
        /* @__PURE__ */ D.jsx(Ig, { id: "useNDRColors-toggle", className: "qp-react-toggle", defaultChecked: i, onChange: () => {
          o(!i), g();
        } }),
        /* @__PURE__ */ D.jsx("span", { children: "Use NDR Colors" })
      ] }),
      /* @__PURE__ */ D.jsxs("label", { htmlFor: "showSourceCode-toggle", children: [
        /* @__PURE__ */ D.jsx(Ig, { id: "showSourceCode-toggle", className: "qp-react-toggle", defaultChecked: a, onChange: () => l(!a) }),
        /* @__PURE__ */ D.jsx("span", { children: "Show Source Code" })
      ] }),
      /* @__PURE__ */ D.jsx("div", { className: "button-container", children: /* @__PURE__ */ D.jsx("button", { type: "button", onClick: () => s(!1), children: /* @__PURE__ */ D.jsx(Bse, { children: "Done" }) }) })
    ] }),
    a ? /* @__PURE__ */ D.jsx(OD, { fallback: /* @__PURE__ */ D.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ D.jsx(jse, {}) }) : /* @__PURE__ */ D.jsxs("div", { className: "control-container", children: [
      /* @__PURE__ */ D.jsxs("div", { className: "font-size-container", children: [
        /* @__PURE__ */ D.jsxs("label", { htmlFor: "font-size-slider", "aria-live": "polite", children: [
          "Font Size Multiplier:",
          " ",
          Math.round(f * 100),
          "%"
        ] }),
        /* @__PURE__ */ D.jsx("input", { id: "font-size-slider", type: "range", min: "1", max: "2", step: "0.1", value: f, onChange: (x) => b(Number.parseFloat(x.target.value)), "aria-valuetext": `${Math.round(f * 100)}%` })
      ] }),
      i && /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
        /* @__PURE__ */ D.jsxs("div", { className: "dropdown", children: [
          /* @__PURE__ */ D.jsx("label", { className: "label-text", htmlFor: "preset-color-scheme-select", children: "Choose a Preset Color Scheme:" }),
          /* @__PURE__ */ D.jsxs("select", { id: "preset-color-scheme-select", onChange: E, defaultValue: "choose", children: [
            /* @__PURE__ */ D.jsx("option", { value: "choose", disabled: !0, children: "Choose a Preset" }),
            h.map((x) => /* @__PURE__ */ D.jsx("option", { value: x.name, children: x.name }, x.name))
          ] })
        ] }),
        /* @__PURE__ */ D.jsxs("div", { className: "text-controls", children: [
          /* @__PURE__ */ D.jsxs("div", { className: "text-color", children: [
            /* @__PURE__ */ D.jsx("label", { className: "label-text", htmlFor: "text-color-picker", children: "Text Color:" }),
            /* @__PURE__ */ D.jsx("div", { className: "color-result", "aria-live": "polite", children: u.text })
          ] }),
          /* @__PURE__ */ D.jsx("div", { className: "picker", children: /* @__PURE__ */ D.jsx(bD, { id: "text-color-picker", color: u.text, onChange: y }) })
        ] }),
        /* @__PURE__ */ D.jsxs("div", { className: "background-controls", children: [
          /* @__PURE__ */ D.jsxs("div", { className: "background-color", children: [
            /* @__PURE__ */ D.jsx("label", { className: "label-text", htmlFor: "background-color-picker", children: "Background Color:" }),
            /* @__PURE__ */ D.jsx("div", { className: "color-result", "aria-live": "polite", children: u.background })
          ] }),
          /* @__PURE__ */ D.jsx("div", { className: "picker", children: /* @__PURE__ */ D.jsx(bD, { id: "background-color-picker", color: u.background, onChange: w }) })
        ] })
      ] })
    ] })
  ] }) });
}
const Hse = rt.div.withConfig({
  displayName: "FilterBackGround__StyledFilterBackGround",
  componentId: "sc-w1ml8x-0"
})`
  min-width: ${(t) => t.$constrainDimensions ? `${t.$width}px` : "100vw"};
  min-width: ${(t) => t.$constrainDimensions ? `${t.$width}px` : "100svw"};
   min-height: ${(t) => t.$isInPresentationMode ? "100vh" : t.$constrainDimensions ? `${t.$height}px` : "100vh"};
  position: ${(t) => t.$constrainDimensions ? "absolute" : "fixed"};
  top: 0;
  background-color: ${(t) => t.theme.background ?? "unset"};
  overflow:hidden;
`;
function Gse() {
  const t = L(wi), e = L(jt), n = L(vi), r = L(ap);
  return /* @__PURE__ */ D.jsx(Hse, { "data-testid": "filter-background", role: "none", $constrainDimensions: t, $isInPresentationMode: r, $height: e.height, $navigationType: n, $width: e.width, className: "filter-background" });
}
const Wse = rt.div.withConfig({
  displayName: "StoryBackGround__StyledStoryBackGround",
  componentId: "sc-2htvcl-0"
})`
  display: grid;
  grid-auto-flow: ${(t) => t.$pageSize.landscape ? "column" : "row"};
  min-height: ${(t) => t.$isInPresentationMode ? "100vh" : t.$constrainDimensions ? `${t.$height}px` : "100vh"};
  min-width: ${(t) => t.$constrainDimensions ? `${t.$width}px` : "100vw"};
  min-width: ${(t) => t.$constrainDimensions ? `${t.$width}px` : "100svw"};


  position: ${(t) => t.$constrainDimensions ? "absolute" : "fixed"};
  top:0;
  overflow:hidden;
`;
function Yse(t, e) {
  return e === "tap" ? t ? pe.navigation.storyBackgroundLeft : pe.navigation.storyBackgroundRight : t ? pe.navigation.storyBackgroundTop : pe.navigation.storyBackgroundBottom;
}
function TD({
  leftOrTop: t
}) {
  const e = L(wi), n = L(jt), r = L(_0), i = L(vi), o = Yse(t, i), s = L(ap);
  return (
    // biome-ignore lint/a11y/useValidAriaRole: <explanation>
    /* @__PURE__ */ D.jsx(Wse, { role: "none", $constrainDimensions: e, $isInPopOut: r, $isInPresentationMode: s, $navigationType: i, $pageSize: n, $isInPortrait: !n.landscape, $height: n.height, $width: n.width, id: o })
  );
}
function Xse(t) {
  const e = L(vi), n = L(Ut);
  lt(() => {
    e === "tap" && t.current && t.current.scrollTo({
      top: 0
    });
  }, [n, t, e]);
  const r = Es(({
    set: i
  }) => (o) => {
    o.code === "ArrowRight" && (i(Rh, "forward"), i(gi, "forward")), o.code === "ArrowLeft" && (i(Rh, "back"), i(gi, "back")), i(Ah, {
      autoPlay: !1,
      loop: "once"
    });
  });
  lt(() => (e === "tap" && t.current && window.addEventListener("keyup", r), () => {
    window.removeEventListener("keyup", r);
  }), [r, e, t, n]);
}
function Kse() {
  const [t, e] = cs(h2), n = L(er);
  lt(() => {
    if (n) return;
    const r = (i) => {
      i.touches.length === 3 && e(!t);
    };
    document.addEventListener("touchstart", r);
  }, [t, e, n]), lt(() => {
    if (n) return;
    const r = {
      s: !1,
      e: !1,
      t: !1
    }, i = (o) => {
      o.key !== "s" && o.key !== "e" && o.key !== "t" && (r.s = !1, r.e = !1, r.t = !1), o.key === "s" && (r.s = !0), o.key === "e" && (r.e = !0), o.key === "t" && (r.t = !0), r.s && r.e && r.t && (e(!t), r.s = !1, r.e = !1, r.t = !1);
    };
    return window.addEventListener("keydown", i), () => window.removeEventListener("keydown", i);
  }, [t, e, n]);
}
const q3 = Qo(void 0), z3 = rt.button.withConfig({
  displayName: "Display__NavButton",
  componentId: "sc-1pwmjbn-0"
})`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  height: 100%;
  z-index: 1; /* Ensure buttons are on top of other content */
  /* Visually hide the button but keep it accessible */
  background: transparent;
  border: none;
  color: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;

  &:focus-visible {
    /* Show a clear focus indicator when the button is focused */
    outline: 2px solid blue;
    outline-offset: -2px;
  }
`, Qse = rt(z3).withConfig({
  displayName: "Display__LeftNavButton",
  componentId: "sc-1pwmjbn-1"
})`
  left: 0;
`, Jse = rt(z3).withConfig({
  displayName: "Display__RightNavButton",
  componentId: "sc-1pwmjbn-2"
})`
  right: 0;
`;
function Zse({
  container: t
}) {
  const e = L(Fi), n = L(wi), r = L(gr), i = L(zn), o = L(er), s = L(jt), a = s.baseFontSize, l = L(h2), u = L(s3), c = L(Mi), f = Xe(null), d = L(vi), h = L(i3), p = Xe(null), g = Xe(null);
  h && console.info("debugMode", h), Kse(), Xse(f), lt(() => {
    const S = (() => {
      try {
        return new BroadcastChannel(pe.broadcastChannel.author);
      } catch {
        return !1;
      }
    })();
    if (t && S && o) {
      const _ = {
        hostId: e,
        type: i ? "preview" : "QP",
        action: pe.messages.requestStack
      };
      S.postMessage(_);
    }
    return () => {
      S && S.close();
    };
  }, [o, i, e, t]);
  const m = Es(({
    set: S,
    snapshot: _
  }) => () => {
    const b = _.getLoadable(Ut).getValue();
    d !== "tap" || b <= 1 || (S(Rh, "back"), S(gi, "back"), S(Ah, {
      autoPlay: !1,
      loop: "once"
    }));
  }), v = Es(({
    set: S
  }) => () => {
    d === "tap" && (S(Rh, "forward"), S(gi, "forward"), S(Ah, {
      autoPlay: !1,
      loop: "once"
    }));
  });
  return /* @__PURE__ */ D.jsxs(Rn, { theme: c, children: [
    /* @__PURE__ */ D.jsxs(kne, { "data-testid": "styled-display", id: "styled-display", className: pe.css.viewerContainer, $fonts: r, $constrainDimensions: n, $isPreviewer: i, $baseFontSize: a, $isInLandscape: s.landscape, $height: s.height, $width: s.width, $navigationType: d, ref: f, children: [
      /* @__PURE__ */ D.jsx(Gse, {}),
      /* @__PURE__ */ D.jsx(TD, { leftOrTop: !0 }),
      /* @__PURE__ */ D.jsx(TD, { leftOrTop: !1 }),
      /* @__PURE__ */ D.jsx(dse, {}),
      d === "tap" && /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
        /* @__PURE__ */ D.jsx(Qse, { ref: p, onClick: m, "aria-label": "Previous Page" }),
        /* @__PURE__ */ D.jsx(Jse, { ref: g, onClick: v, "aria-label": "Next Page" })
      ] })
    ] }),
    l && /* @__PURE__ */ D.jsx(zse, {}),
    u && /* @__PURE__ */ D.jsx(yse, {})
  ] });
}
const eae = (t) => /* @__PURE__ */ D.jsxs("svg", { style: {
  color: "rgb(95,168,238)"
}, width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  /* @__PURE__ */ D.jsxs("g", { opacity: 0.8, children: [
    /* @__PURE__ */ D.jsx("path", { d: "M14 10.5C14 12.433 12.433 14 10.5 14C8.567 14 7 12.433 7 10.5C7 8.567 8.567 7 10.5 7C12.433 7 14 8.567 14 10.5Z", fill: "currentColor" }),
    /* @__PURE__ */ D.jsx("path", { d: "M1 10.5C1 9.94772 1.44772 9.5 2 9.5H4C4.55228 9.5 5 9.94772 5 10.5C5 11.0523 4.55228 11.5 4 11.5H2C1.44772 11.5 1 11.0523 1 10.5Z", fill: "currentColor" }),
    /* @__PURE__ */ D.jsx("path", { d: "M16 10.5C16 9.94772 16.4477 9.5 17 9.5H19C19.5523 9.5 20 9.94772 20 10.5C20 11.0523 19.5523 11.5 19 11.5H17C16.4477 11.5 16 11.0523 16 10.5Z", fill: "currentColor" }),
    /* @__PURE__ */ D.jsx("path", { d: "M14.5 14.5C14.8905 14.1095 15.5237 14.1095 15.9142 14.5L17.3284 15.9142C17.719 16.3047 17.719 16.9379 17.3284 17.3284C16.9379 17.7189 16.3048 17.7189 15.9142 17.3284L14.5 15.9142C14.1095 15.5237 14.1095 14.8905 14.5 14.5Z", fill: "currentColor" }),
    /* @__PURE__ */ D.jsx("path", { d: "M3.50001 3.49999C3.89054 3.10946 4.5237 3.10946 4.91423 3.49999L6.32844 4.9142C6.71897 5.30472 6.71897 5.93789 6.32844 6.32841C5.93792 6.71894 5.30475 6.71894 4.91423 6.32841L3.50001 4.9142C3.10949 4.52367 3.10949 3.89051 3.50001 3.49999Z", fill: "currentColor" }),
    /* @__PURE__ */ D.jsx("path", { d: "M10.5 16C11.0523 16 11.5 16.4477 11.5 17V19C11.5 19.5523 11.0523 20 10.5 20C9.94772 20 9.5 19.5523 9.5 19V17C9.5 16.4477 9.94772 16 10.5 16Z", fill: "currentColor" }),
    /* @__PURE__ */ D.jsx("path", { d: "M10.5 1C11.0523 1 11.5 1.44772 11.5 2V4C11.5 4.55228 11.0523 5 10.5 5C9.94772 5 9.5 4.55228 9.5 4V2C9.5 1.44772 9.94772 1 10.5 1Z", fill: "currentColor" }),
    /* @__PURE__ */ D.jsx("path", { d: "M17.3284 3.50001C17.7189 3.89054 17.7189 4.5237 17.3284 4.91423L15.9142 6.32844C15.5237 6.71897 14.8905 6.71897 14.5 6.32844C14.1095 5.93792 14.1095 5.30475 14.5 4.91423L15.9142 3.50001C16.3047 3.10949 16.9379 3.10949 17.3284 3.50001Z", fill: "currentColor" }),
    /* @__PURE__ */ D.jsx("path", { d: "M6.32841 14.5C6.71894 14.8905 6.71894 15.5237 6.32841 15.9142L4.9142 17.3284C4.52368 17.719 3.89051 17.719 3.49999 17.3284C3.10946 16.9379 3.10946 16.3048 3.49999 15.9142L4.9142 14.5C5.30472 14.1095 5.93789 14.1095 6.32841 14.5Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ D.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 8.067 11.933 6.5 10 6.5C8.067 6.5 6.5 8.067 6.5 10C6.5 11.933 8.067 13.5 10 13.5ZM10 7.5C11.3807 7.5 12.5 8.61929 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5Z", fill: "black" }),
  /* @__PURE__ */ D.jsx("rect", { x: 1, y: 10.5, width: 1, height: 3, rx: 0.5, transform: "rotate(-90 1 10.5)", fill: "black" }),
  /* @__PURE__ */ D.jsx("rect", { x: 16, y: 10.5, width: 1, height: 3, rx: 0.5, transform: "rotate(-90 16 10.5)", fill: "black" }),
  /* @__PURE__ */ D.jsx("rect", { x: 14, y: 14.7071, width: 1, height: 3, rx: 0.5, transform: "rotate(-45 14 14.7071)", fill: "black" }),
  /* @__PURE__ */ D.jsx("rect", { x: 3, y: 3.70709, width: 1, height: 3, rx: 0.5, transform: "rotate(-45 3 3.70709)", fill: "black" }),
  /* @__PURE__ */ D.jsx("rect", { x: 9.5, y: 16, width: 1, height: 3, rx: 0.5, fill: "black" }),
  /* @__PURE__ */ D.jsx("rect", { x: 9.5, y: 1, width: 1, height: 3, rx: 0.5, fill: "black" }),
  /* @__PURE__ */ D.jsx("rect", { x: 16.1213, y: 3, width: 1, height: 3, rx: 0.5, transform: "rotate(45 16.1213 3)", fill: "black" }),
  /* @__PURE__ */ D.jsx("rect", { x: 5.12131, y: 14, width: 1, height: 3, rx: 0.5, transform: "rotate(45 5.12131 14)", fill: "black" })
] }), tae = A_`
 
    0% {
        transform : rotate(0deg);
    }
    100% {
        transform : rotate(360deg);
    }

`, nae = rt.div.withConfig({
  displayName: "Refresh__StyledRefresh",
  componentId: "sc-zvf0gi-0"
})`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: ${(t) => t.$absolutePositioning ? "absolute" : "unset"};
  align-items: center;
  background-color: aliceblue;
  svg {
    width: 5rem;
    height: 5rem;
    animation : ${tae} 1s linear infinite reverse;
   
  }
`;
function rae({
  $absolutePositioning: t
}) {
  return /* @__PURE__ */ D.jsx(nae, { $absolutePositioning: t, children: /* @__PURE__ */ D.jsx(eae, { "aria-hidden": "true", className: "refresh", "data-testid": "refresh-spinner" }) });
}
const xD = rt.div.withConfig({
  displayName: "DisplaySticky__StyledStickyElements",
  componentId: "sc-qxbzxa-0"
})`
  ${(t) => ts(t.theme.align, !1)};
  position: ${(t) => t.$constrainDimensions ? "absolute" : "fixed"};
  ${(t) => t.$position}: 0;
  display: flex;
  flex-direction: column;
  height: fit-content; // safari needs this
  justify-content: ${(t) => Ru(t.theme.startingPoint, !1, t.$isInLandscape)};
  width: 100%;
  z-index: 2;
  pointer-events: none;
`;
function H3({
  position: t
}) {
  const e = L(wi), n = L(zn), r = L(jt), i = un(n2), o = un(KQ), s = Xe(null), a = r.baseFontSize;
  return Bn(() => {
    const l = s.current;
    if (!l) return;
    const u = new ResizeObserver((c) => {
      for (const f of c)
        t === "top" ? i(f.target.clientHeight) : o(f.target.clientHeight);
    });
    return u.observe(l), () => u.disconnect();
  }, [i, o, t]), lt(() => {
    const l = document.getElementsByClassName(xD.styledComponentId);
    for (const u of Array.from(l))
      E0(u);
  }), // biome-ignore lint/a11y/useValidAriaRole: <explanation>
  /* @__PURE__ */ D.jsx(xD, { ref: s, role: "none", $baseFontSize: a, "data-testid": `DisplaySticky-${t}`, className: "display-sticky-menu", $isPreviewer: n, $constrainDimensions: e, $isInLandscape: r.landscape, $position: t, children: /* @__PURE__ */ D.jsx(Wne, { position: t }) });
}
function iae() {
  return /* @__PURE__ */ D.jsx(H3, { position: "bottom" });
}
function oae() {
  return /* @__PURE__ */ D.jsx(H3, { position: "top" });
}
function sae() {
  const t = L(Ut), e = L(Zo), n = Es(({
    set: r
  }) => (i) => {
    r(vi, i);
  });
  return lt(() => {
    for (const [r, i] of e.entries())
      for (const o of i)
        o.type === Tu["moveBy:"].keyword && r < t && (o.content === "scroll" || o.content === "tap") && n(o.content);
  }), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
function aae() {
  const t = L(Mi), e = L(Ea), n = L(Ut), r = L(Zo), i = L(ip), o = L(ZE), s = L(JE), a = L(m0), l = L(Oh(n)), u = un(dS), c = gP(dS);
  return Bn(() => {
    let f = [];
    for (let m = 0; m < r.length; m++) {
      const v = r[m];
      for (const S of v)
        S.type === _t.vvv.controlChar && f.push(m + 1);
    }
    const d = new Set(f);
    if (f = Array.from(d).sort((m, v) => m - v), f.length === 0) {
      c();
      return;
    }
    if (n < f[0]) {
      c();
      return;
    }
    let h = f.filter((m) => m <= n).pop() ?? f[0];
    const p = {
      pageCode: r[h - 1],
      // parsed code is base 0
      showAllTapElements: l,
      editMode: e,
      imageMaps: i,
      dataFileMaps: o,
      audioFileMaps: s,
      currentFilter: t,
      neueroDivergentReader: a,
      pageIndex: h
    }, {
      stickyFooterReactElements: g
    } = S2(p);
    return u(g), c;
  }, [n, t, e, r, i, o, s, a, l, u, c]), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
function lae() {
  const t = L(Mi), e = L(Ea), n = L(Ut), r = L(Zo), i = L(ip), o = L(ZE), s = L(JE), a = L(m0), l = L(Oh(n)), u = un(cy), c = gP(cy);
  return Bn(() => {
    let f = [];
    for (let m = 0; m < r.length; m++) {
      const v = r[m];
      for (const S of v)
        S.type === _t["^^^"].controlChar && f.push(m + 1);
    }
    const d = new Set(f);
    if (f = Array.from(d).sort((m, v) => m - v), f.length === 0) {
      c();
      return;
    }
    if (n < f[0]) {
      c();
      return;
    }
    let h = f.filter((m) => m <= n).pop() ?? f[0];
    const p = {
      pageCode: r[h - 1],
      // parsed code is base 0
      showAllTapElements: l,
      editMode: e,
      imageMaps: i,
      dataFileMaps: o,
      audioFileMaps: s,
      currentFilter: t,
      neueroDivergentReader: a,
      pageIndex: h
    }, {
      stickyHeaderReactElements: g
    } = S2(p);
    return u(g), c;
  }, [n, t, e, r, i, o, s, a, l, u, c]), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
const uae = ({
  containerSelector: t
}) => {
  const e = un(jt), n = L(IL), r = un(DQ), i = Xe(null), o = fs((s) => {
    let a = !0;
    const l = s.offsetHeight, u = s.offsetWidth, c = s.offsetLeft, f = s.offsetTop;
    if (l > u && (a = !1), u === 0 || l === 0)
      return;
    const d = a ? 1.68 : 1.7778, h = a ? 1 : d, p = l, g = a ? d : 1, m = u, v = p / h, S = m / g, _ = Math.min(S, v), b = Math.round(h * _), y = Math.round(g * _), w = (l - b) / 2, E = (u - y) / 2;
    i.current === null && (i.current = window.devicePixelRatio || 1);
    const k = (window.devicePixelRatio || 1) / i.current;
    r(k);
    const C = a ? 100 : 60, M = {
      baseFontSize: Math.min(y, b) / C * n * k,
      onePercentHeight: b / 100,
      onePercentWidth: y / 100,
      containerX: c,
      containerY: f,
      documentHeight: l,
      documentWidth: u,
      gridXWidth: y / 100,
      gridYHeight: b / 100,
      height: b,
      landscape: a,
      width: y,
      x0: E,
      y0: w
    };
    e(M);
  }, [n, e, r]);
  return lt(() => {
    const s = document.getElementById(t);
    if (!s || Xte(s)) {
      process.env.NODE_ENV !== "test" && console.error("Incorrect container passed");
      return;
    }
    const a = () => {
      o(s);
    }, l = new ResizeObserver(a);
    return l.observe(s), window.addEventListener("resize", a), a(), () => {
      l.disconnect(), window.removeEventListener("resize", a);
    };
  }, [t, o]), /* @__PURE__ */ D.jsx(D.Fragment, {});
};
function cae() {
  return /* @__PURE__ */ D.jsx(_2, { preRenderForAnimation: !0 });
}
const fae = 4;
let b1 = 0;
const CD = [];
function dae(t) {
  return new Promise((e, n) => {
    const r = () => {
      b1++, t().then(e).catch(n).finally(() => {
        b1--;
        const i = CD.shift();
        i && i();
      });
    };
    b1 < fae ? r() : CD.push(r);
  });
}
const hae = async (t) => dae(async () => {
  const e = new Image();
  return e.src = t, await e.decode(), !0;
}), AD = lo({
  key: "VS_ImageStatuses",
  effects: ({
    userDefinedName: t,
    url: e
  }) => [({
    setSelf: n
  }) => n(hae(e).then(() => ({
    userDefinedName: t,
    url: e,
    loaded: !0
  })).catch((r) => (console.error(r), {
    userDefinedName: t,
    url: e,
    loaded: !1
  })))]
}), pae = Qt({
  key: "VS_ImagePreloader",
  get: ({
    get: t
  }) => {
    const e = t(Zo), n = t(Ut), r = t(ip), i = n - 3 > 0 ? n - 3 : 0, o = n + 3 > e.length - 1 ? e.length - 1 : n + 3, s = [];
    for (let a = i; a <= o; a++) {
      const l = e[a];
      for (const u of l)
        if (u && (u.type === "image:" || u.type === "background:")) {
          const c = r.find((f) => f.userDefinedName === u.content);
          c && (t(AD({
            userDefinedName: c.userDefinedName,
            url: c.url,
            loaded: !0
          })), t(AD({
            userDefinedName: c.userDefinedName,
            url: c.url,
            loaded: !1
          })), s.push(c.userDefinedName));
        }
    }
    return s;
  }
});
function gae() {
  return MV(pae), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
function mae(t, e, n) {
  var r = this, i = Xe(null), o = Xe(0), s = Xe(null), a = Xe([]), l = Xe(), u = Xe(), c = Xe(t), f = Xe(!0);
  c.current = t;
  var d = typeof window < "u", h = !e && e !== 0 && d;
  if (typeof t != "function") throw new TypeError("Expected a function");
  e = +e || 0;
  var p = !!(n = n || {}).leading, g = !("trailing" in n) || !!n.trailing, m = "maxWait" in n, v = "debounceOnServer" in n && !!n.debounceOnServer, S = m ? Math.max(+n.maxWait || 0, e) : null;
  lt(function() {
    return f.current = !0, function() {
      f.current = !1;
    };
  }, []);
  var _ = la(function() {
    var b = function(C) {
      var M = a.current, F = l.current;
      return a.current = l.current = null, o.current = C, u.current = c.current.apply(F, M);
    }, y = function(C, M) {
      h && cancelAnimationFrame(s.current), s.current = h ? requestAnimationFrame(C) : setTimeout(C, M);
    }, w = function(C) {
      if (!f.current) return !1;
      var M = C - i.current;
      return !i.current || M >= e || M < 0 || m && C - o.current >= S;
    }, E = function(C) {
      return s.current = null, g && a.current ? b(C) : (a.current = l.current = null, u.current);
    }, x = function C() {
      var M = Date.now();
      if (w(M)) return E(M);
      if (f.current) {
        var F = e - (M - i.current), U = m ? Math.min(F, S - (M - o.current)) : F;
        y(C, U);
      }
    }, k = function() {
      if (d || v) {
        var C = Date.now(), M = w(C);
        if (a.current = [].slice.call(arguments), l.current = r, i.current = C, M) {
          if (!s.current && f.current) return o.current = i.current, y(x, e), p ? b(i.current) : u.current;
          if (m) return y(x, e), b(i.current);
        }
        return s.current || y(x, e), u.current;
      }
    };
    return k.cancel = function() {
      s.current && (h ? cancelAnimationFrame(s.current) : clearTimeout(s.current)), o.current = 0, a.current = i.current = l.current = s.current = null;
    }, k.isPending = function() {
      return !!s.current;
    }, k.flush = function() {
      return s.current ? E(Date.now()) : u.current;
    }, k;
  }, [p, m, e, S, g, h, d, v]);
  return _;
}
function yae() {
  const t = L(Fi), [e, n, r, i, o] = L($V([Sa, Ut, zn, _l(pe.utility.inAuthor), n3])), s = L(Mi), a = Xe(s.filterName), l = mae((u) => {
    hl(u);
  }, 1e3, {
    leading: !0
  });
  return Bn(() => {
    if (r) {
      const u = {
        hostId: t,
        type: "preview",
        action: pe.messages.restartPreview
      };
      hl(u);
    }
    a.current = s.filterName;
  }, [r, s.filterName, t]), Bn(() => {
    if (r && e && o && i.code) {
      const u = {
        hostId: t,
        type: "preview",
        action: pe.messages.requestPreviewSnap,
        payload: n
      };
      l(u);
    }
  }, [o, e, r, i.code, n, l, t, s.filterName]), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
function vae() {
  const t = L(zn), e = L(er);
  return lt(() => {
    e && aJ(t ? "preview" : "QP");
  }, [e, t]), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
function bae() {
  const t = L(Sa);
  return lt(() => {
    if (!t) return;
    console.log("All page elements are loaded, fire analytics event", t);
    const e = setTimeout(() => {
      typeof _paq < "u" && (_paq.push(["HeatmapSessionRecording::enable"]), _paq.push(["HeatmapSessionRecording::captureInitialDom", 3]));
    }, 1200);
    return () => clearTimeout(e);
  }, [t]), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
const wae = 5e3, Sae = 100, _ae = 100, Eae = !1, Ng = (t) => Math.max(0, Math.min(1, t)), RD = (t, e, n, r, i, o, s) => {
  if (n.clientX !== void 0) {
    if (i && o) {
      if (n.clientX < o.left || n.clientX > o.right)
        return null;
    } else if (n.clientX < e.left || n.clientX > e.right)
      return null;
  }
  const l = {
    viewport: {
      safariX: 0,
      safariY: e.top / t.height,
      safariWidth: 1,
      safariHeight: e.height / t.height
    }
  };
  if (n.clientX !== void 0)
    if (i && o) {
      const u = (n.clientX - o.left) / o.width;
      l.normalizedX = Ng(u);
    } else {
      const u = (n.clientX - e.left) / e.width;
      l.normalizedX = u;
    }
  if (n.clientY !== void 0) {
    if (i && o && s) {
      let u;
      s === "top" ? u = (n.clientY - o.top) / o.height : u = (o.bottom - n.clientY) / o.height, l.normalizedY = Ng(u);
    } else if (r !== void 0) {
      const c = document.querySelector("#scroll-elements-container")?.getBoundingClientRect();
      if (c && n.scrollTop !== void 0 && r > 0) {
        const d = n.clientY - c.top + n.scrollTop;
        l.normalizedY = Ng(d / r);
      }
    }
  }
  if (n.scrollTop !== void 0) {
    const u = document.querySelector("#scroll-elements-container");
    if (u) {
      const c = u.scrollHeight - u.clientHeight;
      l.normalizedScrollY = c > 0 ? Ng(n.scrollTop / c) : 0;
    }
  }
  return l;
};
function kae() {
  const [t, e] = Cn(null), n = Xe([]), r = Xe([]), i = Xe(null), o = Xe(null), s = L(Sa), a = L(bi), l = L(Lo), {
    landscape: u
  } = L(jt), c = Xe(null), f = Xe(!1), d = fs((y) => {
    if (!l || !c.current) {
      console.warn("Cannot send client log, essential data (stackCfKey, sessionId) is missing.");
      return;
    }
    const w = o.current, E = i.current, x = {
      safariX: 0,
      safariY: w && E ? w.top / E.height : 0,
      safariWidth: 1,
      safariHeight: w && E ? w.height / E.height : 1
    }, k = {
      type: "client_log",
      path: l,
      timestamp: Date.now(),
      isLandscape: u,
      message: `[${c.current}] ${y}`,
      viewport: x
    };
    try {
      navigator.sendBeacon(Yc.heatmapCollector(), JSON.stringify([k]));
    } catch (C) {
      console.error("Error sending client log:", C);
    }
  }, [l, u]);
  lt(() => {
    c.current || (c.current = y2(10), d("HeatmapTracker mounted"));
  }, [d]);
  const h = fs(() => {
    if (n.current.length !== 0) {
      try {
        navigator.sendBeacon(Yc.heatmapCollector(), JSON.stringify(n.current));
      } catch (y) {
        console.error("Error sending heatmap data:", y);
      }
      n.current = [];
    }
  }, []), p = la(() => fm(h, wae, {
    leading: !1,
    trailing: !0
  }), [h]), g = fs((y, w) => {
    f.current || (d("Heatmap event recording started"), f.current = !0);
    const E = i.current, x = o.current;
    if (!E || !x || E.width === 0 || x.width === 0) {
      y.type !== "scroll" && d("Missing or zero-dimension viewerati or safari rects, cannot record event.");
      return;
    }
    const C = w?.target?.closest("[data-sticky-position='top'], [data-sticky-position='bottom']"), M = C?.querySelector(".sticky-menu"), F = !!M, U = C?.getAttribute("data-sticky-position"), B = M?.getBoundingClientRect(), N = document.querySelector("#scroll-elements-container");
    if (!N && (y.type === "scroll" || !F)) {
      d(`Missing scroll container for ${y.type} event, cannot record.`);
      return;
    }
    const q = N?.scrollTop, Q = N?.scrollHeight, ne = F ? `sticky_${y.type}` : y.type, X = RD(E, x, {
      clientX: w?.clientX,
      clientY: w?.clientY,
      scrollTop: q
    }, Q, F, B, U);
    if (X === null)
      return;
    const O = {
      type: ne,
      path: l,
      timestamp: Date.now(),
      isLandscape: u,
      ...X
    };
    n.current.push(O), p();
  }, [p, l, u, d]), m = fs((y) => {
    const x = Date.now();
    r.current = [...r.current, x].filter((k) => x - k <= 750), r.current.length >= 3 ? (g({
      type: "frustration_click"
    }, y), r.current = []) : g({
      type: "click"
    }, y);
  }, [g]), v = fs((y) => {
    g({
      type: "scroll"
    }, y);
  }, [g]), S = fs((y) => {
    const w = document.querySelector("#scroll-elements-container"), E = w?.scrollTop ?? 0, x = w?.scrollHeight ?? 0;
    if (i.current && o.current) {
      const C = y.target?.closest("[data-sticky-position='top'], [data-sticky-position='bottom']"), M = C?.querySelector(".sticky-menu"), F = !!M, U = C?.getAttribute("data-sticky-position"), B = M?.getBoundingClientRect();
      if (RD(i.current, o.current, {
        clientX: y.clientX,
        clientY: y.clientY,
        scrollTop: E
      }, x, F, B, U) === null)
        return;
    }
    g({
      type: "move"
    }, y);
  }, [g]), _ = la(() => fm(S, Sae), [S]), b = la(() => fm((y) => {
    v(y);
    const w = y.target;
    if (w) {
      const E = new BroadcastChannel(pe.broadcastChannel.viewer);
      E.postMessage({
        type: "scrollSync",
        scrollTop: w.scrollTop
      }), E.close();
    }
  }, _ae), [v]);
  return lt(() => {
    if (s) {
      const y = document.querySelector("#scroll-elements-container"), w = y ? y.scrollHeight : document.body.scrollHeight, E = new BroadcastChannel(pe.broadcastChannel.viewer);
      E.postMessage({
        type: "contentHeight",
        height: w
      }), E.close();
    }
  }, [s, a]), lt(() => {
    if (!l.startsWith("quickpoint/") && !l.startsWith("tkn/"))
      return;
    const y = document.getElementById("viewerati"), w = document.getElementById("safari-wrapper"), E = document.querySelector("#scroll-elements-container");
    (!y || !w || !E) && d("Could not find all required elements on mount.");
    const x = new ResizeObserver(() => {
      const M = document.getElementById("viewerati"), F = document.getElementById("safari-wrapper");
      if (M && F) {
        const U = M.getBoundingClientRect(), B = F.getBoundingClientRect();
        U.width > 0 && B.width > 0 && (i.current = U, o.current = B);
      }
    }), k = new MutationObserver(() => {
      C();
    }), C = () => {
      const M = document.getElementById("viewerati"), F = document.getElementById("safari-wrapper"), U = document.querySelector("#scroll-elements-container");
      if (M && F && U) {
        const B = M.getBoundingClientRect(), N = F.getBoundingClientRect();
        B.width > 0 && N.width > 0 && (i.current = B, o.current = N), x.observe(M), x.observe(F), U.addEventListener("scroll", b, {
          passive: !0
        }), k.disconnect();
      }
    };
    return C(), k.observe(document.body, {
      childList: !0,
      subtree: !0
    }), document.addEventListener("click", m), document.addEventListener("mousemove", _), window.addEventListener("beforeunload", h), () => {
      x.disconnect(), k.disconnect(), document.removeEventListener("click", m), document.removeEventListener("mousemove", _);
      const M = document.querySelector("#scroll-elements-container");
      M && M.removeEventListener("scroll", b), window.removeEventListener("beforeunload", h), p.cancel(), _.cancel(), b.cancel();
    };
  }, [m, _, b, h, p, l, d]), /* @__PURE__ */ D.jsx(D.Fragment, { children: Eae });
}
const Tae = 100;
function xae() {
  const t = L(Sa), e = L(n3), n = L(bi);
  return Bn(() => {
    if (t && e) {
      const r = setTimeout(() => {
        const i = document.querySelector("#scroll-elements-container"), o = i ? i.scrollHeight : document.body.scrollHeight, s = new BroadcastChannel(pe.broadcastChannel.viewer);
        s.postMessage({
          type: "contentHeight",
          height: o
        }), s.close();
      }, 100);
      return () => clearTimeout(r);
    }
  }, [e, n, t]), lt(() => {
    const r = document.querySelector("#scroll-elements-container");
    if (!r) return;
    const o = fm((s) => {
      const a = s.target, l = new BroadcastChannel(pe.broadcastChannel.viewer);
      l.postMessage({
        type: "scrollSync",
        scrollTop: a.scrollTop
      }), l.close();
    }, Tae);
    return r.addEventListener("scroll", o), () => {
      r.removeEventListener("scroll", o), o.cancel();
    };
  }, [t, n]), null;
}
function Cae() {
  const t = L(Ah), e = L($u), n = un(Rh), r = L(er), i = L(zn), o = L(Ea), [s, a] = cs(Ut);
  return lt(() => {
    if (t.autoPlay === -1 || i || r && o || !t.autoPlay) return;
    const l = setInterval(() => {
      s === e && t.loop === "forever" ? a(1) : n("forward");
    }, t.autoPlay * 1e3);
    return () => {
      clearInterval(l);
    };
  }, [t, a, e, n, o, r, i, s]), /* @__PURE__ */ D.jsx(D.Fragment, {});
}
Pe.registerPlugin(gt);
IV.RECOIL_GKS_ENABLED.delete("recoil_memory_managament_2020");
const Aae = {
  analyticsHost: "https://app.rybbit.io/api",
  siteId: "1161"
}, Rae = ({
  isInAuthor: t,
  isEmbedded: e
}) => !t && !e ? /* @__PURE__ */ D.jsx(kae, {}) : null, ple = ({
  isEmbedded: t = !1,
  containerSelector: e,
  hostId: n,
  isInAuthor: r = !1,
  isInPopOut: i = !1,
  isPreviewer: o = !1,
  onReady: s,
  stackCfKey: a
}) => {
  !r && !t && !o && (rk.init(Aae), rk.pageview());
  const l = window.location.host === "localhost:3000", u = ({
    set: c
  }) => {
    a && c(a3, a);
    const f = !!new URLSearchParams(document.location.search).get("isEmbedded"), d = !!new URLSearchParams(document.location.search).get("isInAuthor"), h = !!new URLSearchParams(document.location.search).get("pop"), p = new URLSearchParams(document.location.search).get("hostId");
    if (c(d2, e), n)
      c(Fi, p || n);
    else
      throw Error("HostId must be defined");
    l && (c(yne, l), window.IsPopOutInDev = !0), t && c(sp, f || t), r && c(er, d || r), i && c(_0, h || i), o && c(zn, o);
  };
  return lt(() => {
    r || o ? gt.disable(!0) : gt.enable();
  }, [r, o]), lt(() => {
    if (s) {
      s();
      return;
    }
    const c = new BroadcastChannel(pe.broadcastChannel.author), f = {
      hostId: n,
      type: "preview",
      action: pe.messages.ready
    };
    return c.postMessage(f), () => {
      c.close();
    };
  }, [n, s]), !r && !t && !o && console.info("Viewer Build Date: ", "2025-11-27T10:07:12.310Z"), /* @__PURE__ */ D.jsx(NV, { initializeState: u, children: /* @__PURE__ */ D.jsxs(OD, { fallback: /* @__PURE__ */ D.jsx(rae, {}), children: [
    /* @__PURE__ */ D.jsxs(O5, { children: [
      /* @__PURE__ */ D.jsx(MX, {}),
      /* @__PURE__ */ D.jsx(bae, {}),
      /* @__PURE__ */ D.jsx(oae, {}),
      /* @__PURE__ */ D.jsx(iae, {}),
      o && /* @__PURE__ */ D.jsx(yae, {}),
      /* @__PURE__ */ D.jsx(uJ, {}),
      /* @__PURE__ */ D.jsx(vae, {}),
      /* @__PURE__ */ D.jsx(Cae, {}),
      /* @__PURE__ */ D.jsx(gae, {}),
      /* @__PURE__ */ D.jsx(lae, {}),
      /* @__PURE__ */ D.jsx(aae, {}),
      /* @__PURE__ */ D.jsx(sae, {}),
      /* @__PURE__ */ D.jsx(Zse, { container: null }),
      /* @__PURE__ */ D.jsx(uae, { containerSelector: e }),
      /* @__PURE__ */ D.jsx(_2, {}),
      !r && /* @__PURE__ */ D.jsx(cae, {}),
      /* @__PURE__ */ D.jsx(Rae, { isInAuthor: r, isEmbedded: t }),
      t && /* @__PURE__ */ D.jsx(xae, {})
    ] }),
    /* @__PURE__ */ D.jsx(YQ, {})
  ] }) });
};
export {
  jt as A,
  Bo as B,
  Mi as C,
  Ls as D,
  hn as E,
  Rn as F,
  TY as G,
  wa as H,
  PV as I,
  k0 as J,
  woe as K,
  ly as L,
  gy as M,
  fn as P,
  rle as Q,
  L as R,
  Lo as S,
  ple as V,
  fX as a,
  oy as b,
  sle as c,
  lle as d,
  _l as e,
  ale as f,
  i0 as g,
  Jae as h,
  ole as i,
  ele as j,
  tle as k,
  nle as l,
  Qae as m,
  ule as n,
  Ht as o,
  Zae as p,
  D as q,
  dle as r,
  nL as s,
  Ne as t,
  fle as u,
  cle as v,
  Uo as w,
  Ot as x,
  rt as y,
  Xt as z
};
//# sourceMappingURL=Viewerati-BBkza6Yl.js.map
